[
  {
    "id": "org-cdc-842",
    "externalIds": {
      "cdcClinicId": "842",
      "googlePlaceId": "ChIJYUaWt3MywVYRDQon2Dm6Zyk"
    },
    "type": "fertility-clinic",
    "name": "Katie Ostrom MD, LLC",
    "phone": "(907) 235-0555",
    "address": {
      "line1": "205 W. Fairview Ave",
      "city": "Homer",
      "state": "AK",
      "zip": "99603",
      "country": "US"
    },
    "location": {
      "lat": 59.6494,
      "lng": -151.5475
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 53.333333333333336,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "8/15"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 25,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27842%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27842%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.katieostrommd.com/about.html",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Katie+Ostrom+MD,+4129+Bartlett+St,+Homer,+AK+99603/@59.6500124,-151.5505739,2016a,13.1y/data=!4m2!3m1!1s0x56c13273b7964661:0x2967ba39d8270a0d",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.katieostrommd.com/contact-us.html",
            "fetchedAt": "2026-06-13"
          }
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.katieostrommd.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-842-katie-ostrom-md",
        "name": "Katie Ostrom, MD",
        "role": "Medical Director",
        "imageUrl": "https://static.royacdn.com/Site-39ee15a8-d7a0-4f4e-ab75-046d6bc2a7d9/inside_pages/katie_ostrom.png",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://www.katieostrommd.com/about.html",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.katieostrommd.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk7sJihsw7g0BPx80ahoWjskXW44rufgzLpzj-9-yJfZalJgaqbKoziS4VS8nE9t0qaRFgWa5s3NxW9EEZP8GG8ICL-YT7X-OuDTAIp9v9IJNmUOqwge7yFHrptv1N-fZcsf8Gj3A=w943-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Katie+Ostrom+MD,+4129+Bartlett+St,+Homer,+AK+99603/@59.6500124,-151.5505739,2016a,13.1y/data=!4m2!3m1!1s0x56c13273b7964661:0x2967ba39d8270a0d",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmq1OnmsttqyAgs-j-r8evd_mporobWHkQ9i2-B_4WIayclgXNYdBdO4LVD3tUHT5U85eCvwpUB7EJ5qEMmZRJrWBkOz558FVXYJ85uUaoh8AlSNzWUURvIqHDQAMrthEIeiq3v7Q=w408-h544-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Katie+Ostrom+MD,+4129+Bartlett+St,+Homer,+AK+99603/@59.6500124,-151.5505739,2016a,13.1y/data=!4m2!3m1!1s0x56c13273b7964661:0x2967ba39d8270a0d",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Alaska (AK) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-325",
    "externalIds": {
      "cdcClinicId": "325",
      "googlePlaceId": "ChIJi_-bL6kZiYgR5HOCn_sldO4"
    },
    "type": "fertility-clinic",
    "name": "Alabama Fertility Specialists - Birmingham",
    "phone": "(205) 874-0000",
    "address": {
      "line1": "3490 Independence Drive",
      "city": "Birmingham",
      "state": "AL",
      "zip": "35209",
      "country": "US"
    },
    "location": {
      "lat": 33.471871,
      "lng": -86.783448
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art",
        "_source": {
          "url": "https://alabamafertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Donor programs",
        "category": "art",
        "_source": {
          "url": "https://alabamafertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://alabamafertility.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 52.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 47.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 38.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 301,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27325%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://alabamafertility.com/contact/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://alabamafertility.com/contact/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://alabamafertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27325%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://alabamafertility.com/our-team/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Alabama+Fertility+Specialists,+3490+Independence+Dr,+Birmingham,+AL+35209/@33.471323,-86.7826586,3328a,13.1y/data=!4m2!3m1!1s0x888919a92f9bff8b:0xee7425fb9f8273e4",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-325-beth-a-malizia-md",
        "name": "Beth A. Malizia, MD",
        "role": "Fertility Physician",
        "credentials": ["MD"],
        "specialty": "Fertility Physician",
        "imageUrl": "https://alabamafertility.com/wp-content/uploads/2024/09/AFS_DrMalizia_web-400x400.jpg",
        "_source": {
          "url": "https://alabamafertility.com/our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-325-janet-mclaren-bouknight-md-msce",
        "name": "Janet McLaren Bouknight, MD, MSCE",
        "role": "Fertility Physician",
        "credentials": ["MD", "MSCE"],
        "specialty": "Fertility Physician",
        "imageUrl": "https://alabamafertility.com/wp-content/uploads/2024/09/AFS_DrBouknight_web-400x400.jpg",
        "_source": {
          "url": "https://alabamafertility.com/our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-325-mamie-mclean-md",
        "name": "Mamie McLean, MD",
        "role": "Fertility Physician",
        "credentials": ["MD"],
        "specialty": "Fertility Physician",
        "imageUrl": "https://alabamafertility.com/wp-content/uploads/2024/09/AFS_DrMcLean_web_v2-400x400.jpg",
        "_source": {
          "url": "https://alabamafertility.com/our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-325-michael-c-allemand-md",
        "name": "Michael C. Allemand, MD",
        "role": "Fertility Physician",
        "credentials": ["MD"],
        "specialty": "Fertility Physician",
        "imageUrl": "https://alabamafertility.com/wp-content/uploads/2024/09/AFS_DrAllemand_web_v2-400x400.jpg",
        "_source": {
          "url": "https://alabamafertility.com/our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-325-emily-spurlin-md",
        "name": "Emily Spurlin, MD",
        "role": "Fertility Physician",
        "credentials": ["MD"],
        "specialty": "Fertility Physician",
        "imageUrl": "https://alabamafertility.com/wp-content/uploads/2024/09/AFS_DrSpurlin_web-400x400.jpg",
        "_source": {
          "url": "https://alabamafertility.com/our-team/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://alabamafertility.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmBFkJGcTErCxI251EwjUmKFzaVfZvNK1ZVy_JGMqB4HCPJRAuscDWEBqzSumZoxa9Q-U1fIUMI9hXI99dag_xmuflYgSzMmrky1PuL-agfzq_lwBRNwFIxm5hPJ8ALzuPw11Gw=w480-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Alabama+Fertility+Specialists,+3490+Independence+Dr,+Birmingham,+AL+35209/@33.471323,-86.7826586,3328a,13.1y/data=!4m2!3m1!1s0x888919a92f9bff8b:0xee7425fb9f8273e4",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "boutique",
    "network": {
      "name": "Alabama Fertility Specialists"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Alabama (AL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-212",
    "externalIds": {
      "cdcClinicId": "212",
      "googlePlaceId": "ChIJwe06ax1OmogRSc95QdO_7cM"
    },
    "type": "fertility-clinic",
    "name": "The Center for Reproductive Medicine",
    "phone": "(251) 438-4200",
    "address": {
      "line1": "3 Mobile Infirmary Circle, Suite 401",
      "city": "Mobile",
      "state": "AL",
      "zip": "36607",
      "country": "US"
    },
    "location": {
      "lat": 30.6955007,
      "lng": -88.0798008
    },
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.infertilityalabama.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.infertilityalabama.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.infertilityalabama.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.infertilityalabama.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Reproductive Surgery",
        "category": "surgical",
        "_source": {
          "url": "https://www.infertilityalabama.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 45,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 33.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 35.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 218,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27212%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.infertilityalabama.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.infertilityalabama.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.infertilityalabama.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27212%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.infertilityalabama.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/The+Center+for+Reproductive+Medicine,+50+N+Florida+St,+Mobile,+AL+36607/@30.689736,-88.0998651,3431a,13.1y/data=!4m2!3m1!1s0x889a4e1d6b3aedc1:0xc3edbfd34179cf49",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-212-george-t-koulianos-md-facog",
        "name": "George T. Koulianos, MD, FACOG",
        "role": "Fertility Specialist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Fertility Specialist",
        "imageUrl": "https://www.infertilityalabama.com/wp-content/uploads/2024/01/crm-dr-koulianos.jpg",
        "_source": {
          "url": "https://www.infertilityalabama.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-212-george-b-inge-md-facog",
        "name": "George B. Inge, MD, FACOG",
        "role": "Fertility Specialist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Fertility Specialist",
        "imageUrl": "https://www.infertilityalabama.com/wp-content/uploads/2024/01/crm-dr-inge.jpg",
        "_source": {
          "url": "https://www.infertilityalabama.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-212-adelina-emmi-md-facog",
        "name": "Adelina Emmi, MD, FACOG",
        "role": "Fertility Specialist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Fertility Specialist",
        "imageUrl": "https://www.infertilityalabama.com/wp-content/uploads/2024/01/crm-dr-emmi.jpg",
        "_source": {
          "url": "https://www.infertilityalabama.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-212-suzanne-degelos-phd",
        "name": "Suzanne Degelos, PhD",
        "role": "Clinical Psychologist",
        "credentials": ["PhD"],
        "specialty": "Clinical Psychologist",
        "imageUrl": "https://www.infertilityalabama.com/wp-content/uploads/2024/01/crm-suzanne-degelos.jpg",
        "_source": {
          "url": "https://www.infertilityalabama.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-212-david-hickman-ms-ts-abb-mt-ascp",
        "name": "David Hickman, MS, TS (ABB), MT (ASCP)",
        "role": "Laboratory Specialist",
        "credentials": ["MS", "TS (ABB)", "MT (ASCP)"],
        "specialty": "Laboratory Specialist",
        "imageUrl": "https://www.infertilityalabama.com/wp-content/uploads/2025/01/David-Hickman.png",
        "_source": {
          "url": "https://www.infertilityalabama.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.infertilityalabama.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmFNeXYDjLtrp0OogEuX7P3hMLyO8qCcFyoI0_KSigRnGcGOPmdAytTizLeThKQLTXOScHmjJvMHgI-L2c7-p2b9rlTBsLVfcZutNh6WC7WstLAbJiv_KUklyjGS-n_7W7eSk7E0I76DOKJ=w408-h544-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/The+Center+for+Reproductive+Medicine,+50+N+Florida+St,+Mobile,+AL+36607/@30.689736,-88.0998651,3431a,13.1y/data=!4m2!3m1!1s0x889a4e1d6b3aedc1:0xc3edbfd34179cf49",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlW9f1oTgB_Qaobig7ahc2axKJdnBF-ydJPC0TEYiL5n10g1Yk33dce_YUoEf89DTqVIsmaQ-cGijzFqPucJ0X9srdmciKtCJyQtOdJmTYJo1vTxHcqGyc_qKumQve4Ja6WczJ3vVB_FWS_=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/The+Center+for+Reproductive+Medicine,+50+N+Florida+St,+Mobile,+AL+36607/@30.689736,-88.0998651,3431a,13.1y/data=!4m2!3m1!1s0x889a4e1d6b3aedc1:0xc3edbfd34179cf49",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Alabama (AL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-830",
    "externalIds": {
      "cdcClinicId": "830",
      "googlePlaceId": "ChIJXbX9hqpsYogRP18ucQraWVE"
    },
    "type": "fertility-clinic",
    "name": "Fertility Institute of North Alabama",
    "phone": "(256) 217-9613",
    "address": {
      "line1": "808 Turner St SW",
      "city": "Huntsville",
      "state": "AL",
      "zip": "35801",
      "country": "US"
    },
    "location": {
      "lat": 34.7215366,
      "lng": -86.584289
    },
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://fertilityalabama.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://fertilityalabama.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://fertilityalabama.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://fertilityalabama.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Reproductive Surgery",
        "category": "surgical",
        "_source": {
          "url": "https://fertilityalabama.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 41.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 45.45454545454545,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/11"
        },
        {
          "ageBand": "38-40",
          "rate": 60,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/10"
        }
      ],
      "cyclesPerYear": 98,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27830%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://fertilityalabama.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://fertilityalabama.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://fertilityalabama.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27830%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://fertilityalabama.com/about-fina/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Institute+of+North+Alabama,+808+Turner+St+SW,+Huntsville,+AL+35801/@34.7208783,-86.5845839,3279a,13.1y/data=!4m2!3m1!1s0x88626caa86fdb55d:0x5159da0a712e5f3f",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-830-brett-davenport-md",
        "name": "Brett Davenport, MD",
        "role": "Reproductive Endocrinology and Infertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility Specialist",
        "imageUrl": "https://fertilityalabama.com/wp-content/uploads/2025/05/brett-professional-photo.jpg",
        "_source": {
          "url": "https://fertilityalabama.com/about-fina/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://fertilityalabama.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person"],
    "setting": "boutique",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Alabama (AL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-881",
    "externalIds": {
      "cdcClinicId": "881",
      "googlePlaceId": "ChIJH9w_O-8XiYgRX2-IO_wCJ3s"
    },
    "type": "fertility-clinic",
    "name": "Innovative Fertility Specialists",
    "phone": "(205) 509-0700",
    "address": {
      "line1": "1 Inverness Center Parkway, Suite 210",
      "city": "Birmingham",
      "state": "AL",
      "zip": "35242",
      "country": "US"
    },
    "location": {
      "lat": 33.4235,
      "lng": -86.7028
    },
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.ifsinvo.health/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.ifsinvo.health/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.ifsinvo.health/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 26.31578947368421,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/19"
        }
      ],
      "cyclesPerYear": 42,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27881%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.ifsinvo.health/find-us",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.ifsinvo.health/find-us",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.ifsinvo.health/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27881%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ifsinvo.health/team-4",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Innovative+Fertility+Specialists,+1+Inverness+Center+Pkwy,+Birmingham,+AL+35242/@33.4235435,-86.7027978,3330a,13.1y/data=!4m2!3m1!1s0x888917ef3b3fdc1f:0x7b2702fc3b886f5f",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-881-nicholas-a-cataldo-md-mph",
        "name": "Nicholas A. Cataldo, MD, MPH",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MPH"],
        "specialty": "Reproductive Endocrinologist",
        "imageUrl": "https://static.wixstatic.com/media/0bb657_a82c48f7665a43df808057766f378c54~mv2.jpg/v1/crop/x_0,y_182,w_611,h_450/fill/w_733,h_540,al_c,lg_1,q_85,enc_avif,quality_auto/Nicholas%20Cataldo%20phote.jpg",
        "_source": {
          "url": "https://www.ifsinvo.health/team-4",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-881-karen-r-hammond-dnp-whnp-bc",
        "name": "Karen R. Hammond, DNP, WHNP-BC",
        "role": "Women’s Health Nurse Practitioner",
        "credentials": ["DNP", "WHNP-BC"],
        "specialty": "Women’s Health Nurse Practitioner",
        "imageUrl": "https://static.wixstatic.com/media/0bb657_1e4f1d716e744b46af6a49ea3afdd8d2~mv2.jpg/v1/crop/x_0,y_576,w_1932,h_1424/fill/w_912,h_672,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/INVOcell%20KRH_JPG.jpg",
        "_source": {
          "url": "https://www.ifsinvo.health/team-4",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-881-lisa-j-ray-ms-eld",
        "name": "Lisa J. Ray, MS, ELD",
        "role": "Embryology Lab Director",
        "credentials": ["MS", "ELD"],
        "specialty": "Embryology Lab Director",
        "imageUrl": "https://static.wixstatic.com/media/0bb657_3d687242976e4ff88b55d04367a4475d~mv2.jpg/v1/crop/x_0,y_151,w_554,h_408/fill/w_664,h_490,al_c,lg_1,q_80,enc_avif,quality_auto/Lisa%20Ray%20Photo.jpg",
        "_source": {
          "url": "https://www.ifsinvo.health/team-4",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.ifsinvo.health/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmJgLHfvjeprTX8V_Ru3npdDpfLkszEiSdwh4BArB9zGj08h66HjtsKDkZvnZWVHUTRgmOAZKyw9rDkuibxAc7_8hG5gsRx0yrnmm7FlpdSJwYnLoDvFvtjbHEu52aXM0d3KIvSWQ=w408-h240-k-no-pi-10-ya348-ro-0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Innovative+Fertility+Specialists,+1+Inverness+Center+Pkwy,+Birmingham,+AL+35242/@33.4235435,-86.7027978,3330a,13.1y/data=!4m2!3m1!1s0x888917ef3b3fdc1f:0x7b2702fc3b886f5f",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Alabama (AL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-151",
    "externalIds": {
      "cdcClinicId": "151"
    },
    "type": "fertility-clinic",
    "name": "UAB Reproductive Endocrinology & Infertility Clinic at Women & Infants Center",
    "phone": "(205) 996-3130",
    "address": {
      "line1": "1700 6th Avenue South, Floor 9",
      "city": "Birmingham",
      "state": "AL",
      "zip": "35233",
      "country": "US"
    },
    "location": {
      "lat": 33.5060077,
      "lng": -86.8047315
    },
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.uabmedicine.org/specialties/women-and-infants/reproductive-endocrinology-infertility-services/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.uabmedicine.org/specialties/women-and-infants/reproductive-endocrinology-infertility-services/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Preservation",
        "category": "preservation",
        "_source": {
          "url": "https://www.uabmedicine.org/specialties/women-and-infants/reproductive-endocrinology-infertility-services/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Male Infertility",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.uabmedicine.org/specialties/women-and-infants/reproductive-endocrinology-infertility-services/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 60,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/14"
        }
      ],
      "cyclesPerYear": 86,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27151%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.uabmedicine.org/specialties/women-and-infants/reproductive-endocrinology-infertility-services/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://providerdirectory.uabmedicine.org/specialty/Reproductive%20Endocrinology%20and%20Infertility?page=1",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.uabmedicine.org/specialties/women-and-infants/reproductive-endocrinology-infertility-services/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27151%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://providerdirectory.uabmedicine.org/specialty/Reproductive%20Endocrinology%20and%20Infertility?page=1",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.uabmedicine.org/locations/uab-women-infants-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-151-caitlin-hutchins-pa-c",
        "name": "Caitlin Hutchins, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "specialty": "Obstetrics and Gynecology, Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/uab/photos/200/hutchins-caitlin-1811434707.jpg",
        "_source": {
          "url": "https://providerdirectory.uabmedicine.org/specialty/Reproductive%20Endocrinology%20and%20Infertility?page=1",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-151-richard-burney-md",
        "name": "Richard Burney, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/uab/photos/200/burney-richard-1003958083.jpg",
        "_source": {
          "url": "https://providerdirectory.uabmedicine.org/specialty/Reproductive%20Endocrinology%20and%20Infertility?page=1",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-151-courtney-gregory-crnp",
        "name": "Courtney Gregory, CRNP",
        "role": "Nurse Practitioner",
        "credentials": ["CRNP"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/uab/photos/200/gregory-courtney-1356659262.jpg",
        "_source": {
          "url": "https://providerdirectory.uabmedicine.org/specialty/Reproductive%20Endocrinology%20and%20Infertility?page=1",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-151-jared-robins-md",
        "name": "Jared Robins, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://providerdirectory.uabmedicine.org/specialty/Reproductive%20Endocrinology%20and%20Infertility?page=1",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-151-ricardo-azziz-md",
        "name": "Ricardo Azziz, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility, Gynecology, Endocrinology",
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/uab/photos/200/azziz-ricardo-1447237375.jpg",
        "_source": {
          "url": "https://providerdirectory.uabmedicine.org/specialty/Reproductive%20Endocrinology%20and%20Infertility?page=1",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-151-sukhkamal-campbell-md",
        "name": "Sukhkamal Campbell, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/uab/photos/200/campbell-sukhkamal-1922442342.jpg",
        "_source": {
          "url": "https://providerdirectory.uabmedicine.org/specialty/Reproductive%20Endocrinology%20and%20Infertility?page=1",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-151-peter-kolettis-md",
        "name": "Peter Kolettis, MD",
        "role": "Male Infertility Urologist",
        "credentials": ["MD"],
        "specialty": "Urology, Male Infertility",
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/uab/photos/orig/kolettis-peter-1336177450.jpg",
        "_source": {
          "url": "https://providerdirectory.uabmedicine.org/provider/peter-kolettis/570146",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.uabmedicine.org/specialties/women-and-infants/reproductive-endocrinology-infertility-services/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "images": [
      {
        "url": "https://www.uabmedicine.org/wp-content/uploads/sites/3/2022/07/WIC-Location-Banner.png",
        "type": "exterior",
        "caption": "UAB Women & Infants Center exterior",
        "_source": {
          "url": "https://www.uabmedicine.org/locations/uab-women-infants-center/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "setting": "hospital-based",
    "network": {
      "name": "UAB Medicine"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Alabama (AL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-497",
    "externalIds": {
      "cdcClinicId": "497",
      "googlePlaceId": "ChIJ3ZV-qQSk0ocR-S9XqVpleTc"
    },
    "type": "fertility-clinic",
    "name": "Arkansas Fertility Center",
    "phone": "(501) 534-3764",
    "address": {
      "line1": "9101 Kanis Rd, Suite 300",
      "city": "Little Rock",
      "state": "AR",
      "zip": "72205",
      "country": "US"
    },
    "location": {
      "lat": 34.7407,
      "lng": -92.3763
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 34.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 28.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 214,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27497%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27497%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.arkansasfertility.com/our-staff.html",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Arkansas+Fertility+%26+Gynecology+Associates,+9101+Kanis+Rd+%23300,+Little+Rock,+AR+72205/@34.7406751,-92.3762727,3279a,13.1y/data=!4m2!3m1!1s0x87d2a404a97e95dd:0x3779655aa9572ff9",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-497-dean-m-moutos-md",
        "name": "Dean M. Moutos, MD",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "role": "Medical Director",
        "imageUrl": "https://www.arkansasfertility.com/images/staff_mout-430.jpg",
        "_source": {
          "url": "https://www.arkansasfertility.com/staff_moutos.html",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-497-christopher-moutos-md",
        "name": "Christopher Moutos, MD",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://www.arkansasfertility.com/images/staff_chris430.jpg",
        "_source": {
          "url": "https://www.arkansasfertility.com/staff_christopher.html",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-497-sarah-humphries-apn",
        "name": "Sarah Humphries, APN",
        "credentials": ["APN"],
        "specialty": "Assisted Reproductive Technology Nursing",
        "role": "Advanced Practice Nurse",
        "imageUrl": "https://www.arkansasfertility.com/images/staff_sarah430.jpg",
        "_source": {
          "url": "https://www.arkansasfertility.com/staff_humphries.html",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-497-mahlon-maris-ba",
        "name": "Mahlon Maris, BA",
        "credentials": ["BA"],
        "specialty": "Embryology and Andrology",
        "role": "Embryology and Andrology Laboratory Supervisor",
        "imageUrl": "https://www.arkansasfertility.com/images/staff_mahlon430.jpg",
        "_source": {
          "url": "https://www.arkansasfertility.com/staff_maris.html",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-497-patsy-caudle-rn-bsn",
        "name": "Patsy Caudle, RN, BSN",
        "credentials": ["RN", "BSN"],
        "specialty": "Fertility Nursing",
        "role": "Operating Room Nurse",
        "imageUrl": "https://www.arkansasfertility.com/images/staff_patsy430.jpg",
        "_source": {
          "url": "https://www.arkansasfertility.com/staff_caudle.html",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.arkansasfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "specialties": [
      "andrology",
      "embryology",
      "fertility-nursing",
      "reproductive-endocrinology"
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Arkansas (AR) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnu01Vkz4SkKLINGOwbJH3Wedh-qGvWFFYaMk2Fr93PnuDFJcUjHpBY5-x-LJ2-Z-k_N4kYACmTqwpKsaRsgwTC4oV1nb_-jZNDaZXxZT9TG3GkQu9nHr6OZsfPp7ZHSKh7RjAw=w156-h156-n-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Arkansas+Fertility+%26+Gynecology+Associates,+9101+Kanis+Rd+%23300,+Little+Rock,+AR+72205/@34.7406751,-92.3762727,3279a,13.1y/data=!4m2!3m1!1s0x87d2a404a97e95dd:0x3779655aa9572ff9",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-32",
    "externalIds": {
      "cdcClinicId": "32"
    },
    "type": "fertility-clinic",
    "name": "ACFS Fertility, Arizona Associates for Reproductive Health",
    "phone": "(480) 860-4792",
    "address": {
      "line1": "8426 E. Shea Blvd",
      "city": "Scottsdale",
      "state": "AZ",
      "zip": "85260",
      "country": "US"
    },
    "location": {
      "lat": 33.6454,
      "lng": -111.894
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 69.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 51.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 54.54545454545454,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/11"
        }
      ],
      "cyclesPerYear": 179,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2732%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2732%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/arizona/scottsdale/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-32-ketan-s-patel-md",
        "name": "Ketan S. Patel, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Ketan_Patel_600x600_2x.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/ketan-s-patel/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Nicole Kummer, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Nicole_Kummer_600x600_2x.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/arizona/scottsdale/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-32-nicole-kummer-md"
      },
      {
        "name": "Shane Lipskind, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Shane_Lipskind_600x600_2x.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/arizona/scottsdale/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-32-shane-lipskind-md"
      },
      {
        "name": "Evan Reshef, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Evan_Reshef_600x600_2x.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/arizona/scottsdale/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-32-evan-reshef-md"
      },
      {
        "name": "Madeline (Maddie) Giancola, DNP, FNP-C",
        "role": "Nurse Practitioner",
        "credentials": ["DNP", "FNP-C"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Madeline_Giancola_600x600_2x-rbxquai0ohthhtrwfkg45tjfo04nydjm5l1fbr4bds.png",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/arizona/scottsdale/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-32-madeline-maddie-giancola-dnp-fnp-c"
      }
    ],
    "website": "https://www.acfs2000.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "images": [],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Arizona (AZ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-312",
    "externalIds": {
      "cdcClinicId": "312"
    },
    "type": "fertility-clinic",
    "name": "Advanced Fertility Care, PLLC",
    "phone": "(480) 874-2229",
    "address": {
      "line1": "9819 N. 95th St, Suite 105",
      "city": "Scottsdale",
      "state": "AZ",
      "zip": "85258",
      "country": "US"
    },
    "location": {
      "lat": 33.5756,
      "lng": -111.875
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 53.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 53.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 54.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 66.66666666666666,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "8/12"
        }
      ],
      "cyclesPerYear": 361,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27312%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27312%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/scottsdale-az/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-312-frederick-larsen",
        "name": "Frederick Larsen",
        "role": "Medical Director",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/03/Dr.-Fred-Larsen_AZ-1024x1024.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-frederick-larsen/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Kurt Peterson",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO", "FACOOG"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/03/Dr.-Kurt-Peterson_AZ-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-kurt-peterson/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-312-kurt-peterson"
      },
      {
        "name": "Allison Abbey",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/02/Allison-Abbey-AZ-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/allison-abbey-pa-c/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-312-allison-abbey"
      },
      {
        "name": "Kelly Soares",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/02/Kelly-Soares-AZ-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/kelly-soares-pa-c/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-312-kelly-soares"
      }
    ],
    "website": "https://www.advancedfertilitycare.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "images": [
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/IMG_7189-1-768x1024.jpg",
        "type": "exterior",
        "caption": "Building exterior of Advanced Fertility Care, Suite 105, with the clinic's signage (matches the 9819 N. 95th St, Suite 105 address).",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/scottsdale-az/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/IMG_7183-768x1024.jpg",
        "type": "interior",
        "caption": "Reception lobby with the Advanced Fertility Care logo on the wall and the stone-clad front desk.",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/scottsdale-az/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/IMG_7155-1-768x1024.jpg",
        "type": "interior",
        "caption": "Exam/procedure room with ultrasound equipment and procedure table.",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/scottsdale-az/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/IMG_7174-768x1024.jpg",
        "type": "interior",
        "caption": "Front desk / patient check-out area inside the clinic.",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/scottsdale-az/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "setting": "network-group",
    "network": {
      "name": "Pinnacle Fertility"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Arizona (AZ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-160",
    "externalIds": {
      "cdcClinicId": "160",
      "googlePlaceId": "ChIJj9TNEzdu1oYR5ZhocdECglM"
    },
    "type": "fertility-clinic",
    "name": "Arizona Center for Reproductive Endocrinology and Infertility",
    "phone": "(520) 326-0001",
    "address": {
      "line1": "5190 E. Farness Dr, Suite 114",
      "city": "Tucson",
      "state": "AZ",
      "zip": "85712",
      "country": "US"
    },
    "location": {
      "lat": 32.2475,
      "lng": -110.883
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 27,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 16.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 17.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 163,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27160%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27160%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilityclinicarizona.com/our-team/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Arizona+Center+for+Reproductive+Endocrinology+%26+Infertility,+STE+114,+E+Farness+Dr,+Tucson,+AZ+85712/@32.2473476,-110.8821978,3374a,13.1y/data=!4m2!3m1!1s0x86d66e3713cdd48f:0x538202d1716898e5",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-160-timothy-j-gelety-md",
        "name": "Timothy J. Gelety, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.fertilityclinicarizona.com/wp-content/uploads/2023/02/Dr.-Gelety_auto_x2.jpg",
        "credentials": [
          "MD",
          "Board Certified in Reproductive Endocrinology and Infertility",
          "Board Certified in Obstetrics and Gynecology"
        ],
        "_source": {
          "url": "https://www.fertilityclinicarizona.com/our-team/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Bin Wu, PhD, HCLD",
        "role": "Director of Assisted Reproductive Bio-Technology Laboratories (IVF Laboratory Director)",
        "credentials": ["PhD", "HCLD"],
        "imageUrl": "https://www.fertilityclinicarizona.com/wp-content/uploads/2023/02/Bin-Wu_edit.jpg",
        "_source": {
          "url": "https://www.fertilityclinicarizona.com/our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-160-bin-wu-phd-hcld"
      },
      {
        "name": "Suzhen Lu",
        "role": "Embryologist / Andrologist",
        "credentials": [],
        "imageUrl": "https://www.fertilityclinicarizona.com/wp-content/uploads/2023/02/Su-edit.jpg",
        "_source": {
          "url": "https://www.fertilityclinicarizona.com/our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-160-suzhen-lu"
      }
    ],
    "website": "https://www.acreivf.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Arizona (AZ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-454",
    "externalIds": {
      "cdcClinicId": "454",
      "googlePlaceId": "ChIJizqiZ4gNK4cRZpmZLcoMLt8"
    },
    "type": "fertility-clinic",
    "name": "Arizona Reproductive Medicine Specialists, LLC",
    "phone": "(602) 343-2767",
    "address": {
      "line1": "1701 E. Thomas Rd, Bldg 1, Suite 101",
      "city": "Phoenix",
      "state": "AZ",
      "zip": "85016",
      "country": "US"
    },
    "location": {
      "lat": 33.4799,
      "lng": -112.045
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 62.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 35.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 60.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 144,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27454%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27454%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://arizonafertility.com/our-team/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Arizona+Reproductive+Medicine+Specialists,+1701+E+Thomas+Rd+Bldg+1+Suite+101,+Phoenix,+AZ+85016/@33.4799284,-112.0445287,3328a,13.1y/data=!4m2!3m1!1s0x872b0d8867a23a8b:0xdf2e0cca2d999966",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-454-drew-v-moffitt-md",
        "name": "Drew V. Moffitt, MD",
        "role": "Medical Director",
        "imageUrl": "https://arizonafertility.com/wp-content/uploads/photo-dr-drew-moffitt.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://arizonafertility.com/our-team/infertility-specialists/drew-moffitt/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Linda R. Nelson, MD, PhD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "PhD", "FACOG"],
        "imageUrl": "https://arizonafertility.com/wp-content/uploads/photo-ARMS_Dr.Nelson_Linda.png",
        "_source": {
          "url": "https://arizonafertility.com/our-team/infertility-specialists/linda-nelson/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-454-linda-r-nelson-md-phd-facog"
      },
      {
        "name": "Carlos A. Guerrero, PhD, HCLD, ELD",
        "role": "Laboratory Director",
        "credentials": ["PhD", "HCLD", "ELD"],
        "imageUrl": "https://arizonafertility.com/wp-content/uploads/photo-carlos-guerrero-square.jpg",
        "_source": {
          "url": "https://arizonafertility.com/our-team/embryologyandrology/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-454-carlos-a-guerrero-phd-hcld-eld"
      },
      {
        "name": "Amber Brewer, MS, TS (ABB)",
        "role": "Senior Embryologist / Laboratory Supervisor",
        "credentials": ["MS", "TS (ABB)"],
        "imageUrl": "https://arizonafertility.com/wp-content/uploads/arms-photo-amber-brewer-square-300x300.jpg",
        "_source": {
          "url": "https://arizonafertility.com/our-team/embryologyandrology/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-454-amber-brewer-ms-ts-abb"
      },
      {
        "name": "Chelsea Tanner, MS, TS",
        "role": "Senior Embryologist",
        "credentials": ["MS", "TS"],
        "imageUrl": "https://arizonafertility.com/wp-content/uploads/ARMS-Chelsea-Embryologist-150x150.png",
        "_source": {
          "url": "https://arizonafertility.com/our-team/embryologyandrology/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-454-chelsea-tanner-ms-ts"
      },
      {
        "name": "Rylee Anderson",
        "role": "Andrologist",
        "credentials": [],
        "imageUrl": "https://arizonafertility.com/wp-content/uploads/PXL_20240717_150820882.PORTRAIT-1-scaled-1-150x150.jpg",
        "_source": {
          "url": "https://arizonafertility.com/our-team/embryologyandrology/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-454-rylee-anderson"
      },
      {
        "name": "Ching-Mei Lin, MSN",
        "role": "IVF Nurse Coordinator",
        "credentials": ["MSN"],
        "imageUrl": "https://arizonafertility.com/wp-content/uploads/photo-arms-Ching-Mei-Lin-300x300.jpg",
        "_source": {
          "url": "https://arizonafertility.com/our-team/embryologyandrology/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-454-ching-mei-lin-msn"
      }
    ],
    "website": "https://www.azmedicine.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "images": [],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Arizona (AZ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-712",
    "externalIds": {
      "cdcClinicId": "712",
      "googlePlaceId": "ChIJUy0sd84KK4cRV7cWYdGZkT8"
    },
    "type": "fertility-clinic",
    "name": "Bloom Reproductive Institute",
    "phone": "(480) 434-6565",
    "address": {
      "line1": "8415 N. Pima Rd, Suite 290",
      "city": "Scottsdale",
      "state": "AZ",
      "zip": "85258",
      "country": "US"
    },
    "location": {
      "lat": 33.5573,
      "lng": -111.891
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 53.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 41.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 42.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 31.25,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/16"
        }
      ],
      "cyclesPerYear": 336,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27712%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27712%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitybloom.com/about-us/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Bloom+Reproductive+Institute,+PLLC,+8415+N+Pima+Rd+Ste+290,+Scottsdale,+AZ+85258/@33.5572757,-111.890765,3325a,13.1y/data=!4m2!3m1!1s0x872b0ace772c2d53:0x3f9199d16116b757",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-712-millie-behera-md-facog-frcsc",
        "name": "Millie Behera, MD, FACOG, FRCSC",
        "role": "Medical Director",
        "imageUrl": "https://www.fertilitybloom.com/wp-content/uploads/2020/06/millie.jpg",
        "credentials": ["MD", "FACOG", "FRCSC"],
        "_source": {
          "url": "https://www.fertilitybloom.com/about-us/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Lauren Reschke, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.fertilitybloom.com/wp-content/uploads/2020/06/Reschke-Website-e1661368908457-890x1024.jpg",
        "_source": {
          "url": "https://www.fertilitybloom.com/about-us/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-712-lauren-reschke-md-facog"
      },
      {
        "name": "Catherine Gordon, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.fertilitybloom.com/wp-content/uploads/2022/10/IMG_2432-2-e1739393416126-799x1024.jpg",
        "_source": {
          "url": "https://www.fertilitybloom.com/about-us/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-712-catherine-gordon-md-facog"
      },
      {
        "name": "Barry Behr, PhD, HCLD",
        "role": "Laboratory Director (IVF/Embryology)",
        "credentials": ["PhD", "HCLD"],
        "imageUrl": "https://www.fertilitybloom.com/wp-content/uploads/2022/10/thumbnail_Behr-Barry-PhD7892x-1.jpg",
        "_source": {
          "url": "https://www.fertilitybloom.com/about-us/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-712-barry-behr-phd-hcld"
      }
    ],
    "website": "https://www.bloomreproductive.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Arizona (AZ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk4evbaiJpuEoVCbAVYohaDMgcqjrlgLP35ds-wrbToZK97BgdSh96Qk2XT2MzVsOZ5ohfVdZep9D-KRJqOXblEe68qZP2RU6iFgnwWrG8m01_fLzS00qv8y1YQzl2u8DOwUSS3=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Bloom+Reproductive+Institute,+PLLC,+8415+N+Pima+Rd+Ste+290,+Scottsdale,+AZ+85258/@33.5572757,-111.890765,3325a,13.1y/data=!4m2!3m1!1s0x872b0ace772c2d53:0x3f9199d16116b757",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-246",
    "externalIds": {
      "cdcClinicId": "246",
      "googlePlaceId": "ChIJeV0dxQUHK4cRymaJIEEIOQQ"
    },
    "type": "fertility-clinic",
    "name": "Fertility Treatment Center, PC",
    "phone": "(480) 831-2445",
    "address": {
      "line1": "2155 E. Conference Dr, Suite 115",
      "city": "Tempe",
      "state": "AZ",
      "zip": "85284",
      "country": "US"
    },
    "location": {
      "lat": 33.3424,
      "lng": -111.895
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 51.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 51.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 20.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 12.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 290,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27246%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27246%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitytreatmentcenter.com",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Treatment+Center,+2155+E+Conference+Dr+Ste+115,+Tempe,+AZ+85284/@33.3425105,-111.89478,3333a,13.1y/data=!4m2!3m1!1s0x872b0705c51d5d79:0x4390841208966ca",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-246-h-randall-craig-md",
        "name": "H. Randall Craig, MD",
        "role": "Medical Director",
        "imageUrl": "https://fertilitytreatmentcenter.com/wp-content/uploads/2024/09/H-Randall-Craig-MD-1x1-1-1024x1024.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://fertilitytreatmentcenter.com/dr-craig-bio/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Kristina Bauer",
        "role": "Clinical Director",
        "credentials": ["PA-C"],
        "imageUrl": "https://fertilitytreatmentcenter.com/wp-content/uploads/2024/08/Kristina-Bauer-PA-C-400.jpg",
        "_source": {
          "url": "https://fertilitytreatmentcenter.com/meet-our-staff/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-246-kristina-bauer"
      },
      {
        "name": "Kristen Branche",
        "role": "Clinical / Medical Staff",
        "credentials": ["WHNP-C"],
        "imageUrl": "https://fertilitytreatmentcenter.com/wp-content/uploads/2024/08/Kristen-Branche.png",
        "_source": {
          "url": "https://fertilitytreatmentcenter.com/meet-our-staff/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-246-kristen-branche"
      },
      {
        "name": "Jun Tao",
        "role": "Embryologist / Laboratory",
        "credentials": ["PhD", "HCLD"],
        "imageUrl": "https://fertilitytreatmentcenter.com/wp-content/uploads/2024/08/Jun-Tao.jpg",
        "_source": {
          "url": "https://fertilitytreatmentcenter.com/meet-our-staff/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-246-jun-tao"
      },
      {
        "name": "Brenda Williams",
        "role": "Lab Director",
        "credentials": [],
        "imageUrl": "https://fertilitytreatmentcenter.com/wp-content/uploads/2024/08/Brenda-Williams-400.jpg",
        "_source": {
          "url": "https://fertilitytreatmentcenter.com/meet-our-staff/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-246-brenda-williams"
      },
      {
        "name": "Alyssa Rodriguez",
        "role": "Embryologist",
        "credentials": [],
        "imageUrl": "https://fertilitytreatmentcenter.com/wp-content/uploads/2024/08/Alyssa-Rodriguez.jpg",
        "_source": {
          "url": "https://fertilitytreatmentcenter.com/meet-our-staff/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-246-alyssa-rodriguez"
      },
      {
        "name": "Evelyn Kunimura",
        "role": "Laboratory Staff",
        "credentials": [],
        "imageUrl": "https://fertilitytreatmentcenter.com/wp-content/uploads/2024/08/Evelyn-Kunimura-400.jpg",
        "_source": {
          "url": "https://fertilitytreatmentcenter.com/meet-our-staff/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-246-evelyn-kunimura"
      },
      {
        "name": "Daina Green",
        "role": "Clinical Staff",
        "credentials": [],
        "imageUrl": "https://fertilitytreatmentcenter.com/wp-content/uploads/2024/08/Daina-Green-400.jpg",
        "_source": {
          "url": "https://fertilitytreatmentcenter.com/meet-our-staff/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-246-daina-green"
      },
      {
        "name": "Clarissa Lucas",
        "role": "Clinical Staff",
        "credentials": [],
        "imageUrl": "https://fertilitytreatmentcenter.com/wp-content/uploads/2024/09/Clarissa-Lucas-1x1-1.jpg",
        "_source": {
          "url": "https://fertilitytreatmentcenter.com/meet-our-staff/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-246-clarissa-lucas"
      }
    ],
    "website": "https://www.fertilitytreatmentcenter.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm5iczs777b6wl73eyx_rPF2DFDQxgir4EdMwWV7twuqmxUCcDoaoFSzTXQhkOcKChycHEWXrsH1URAtmWga66RATJvW1JLKVJIbjiUh9R4UQ2xNB5nm6dnEzE6UAHPBWdz4DE=w224-h298-k-no-pi-10-ya9.999997-ro-0-fo100",
        "type": "exterior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Treatment+Center,+2155+E+Conference+Dr+Ste+115,+Tempe,+AZ+85284/@33.3425105,-111.89478,3333a,13.1y/data=!4m2!3m1!1s0x872b0705c51d5d79:0x4390841208966ca",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Arizona (AZ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-384",
    "externalIds": {
      "cdcClinicId": "384"
    },
    "type": "fertility-clinic",
    "name": "IVF Phoenix",
    "phone": "(602) 765-2229",
    "address": {
      "line1": "9817 N. 95th St, Bldg I, Suite 107",
      "city": "Scottsdale",
      "state": "AZ",
      "zip": "85258",
      "country": "US"
    },
    "location": {
      "lat": 33.5756,
      "lng": -111.876
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 45.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 110,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27384%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27384%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfphoenix.com/about-us/about/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-384-john-l-couvaras-md",
        "name": "John L. Couvaras, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.ivfphoenix.com/wp-content/uploads/2022/10/Untitled-design-1.png",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.ivfphoenix.com/about-us/about/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Andrea",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://www.ivfphoenix.com/wp-content/uploads/2025/12/B4B52916-A7B6-41EE-BB12-A3642F7C71B7-1.jpeg",
        "_source": {
          "url": "https://www.ivfphoenix.com/about-us/about/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-384-andrea"
      }
    ],
    "website": "https://www.ivfphoenix.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "images": [],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Arizona (AZ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-629",
    "externalIds": {
      "cdcClinicId": "629",
      "googlePlaceId": "ChIJu9UEjB2vK4cR56C6zaztRXs"
    },
    "type": "fertility-clinic",
    "name": "New Direction Fertility Centers",
    "phone": "(480) 351-8222",
    "address": {
      "line1": "1760 E. Pecos Rd, Suite 532",
      "city": "Gilbert",
      "state": "AZ",
      "zip": "85295",
      "country": "US"
    },
    "location": {
      "lat": 33.2964,
      "lng": -111.752
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 58.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 58.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 53.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 42.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 709,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27629%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27629%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.newdirectionfertility.com/#team",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/New+Direction+Fertility+Centers,+1760+E+Pecos+Rd+%23532,+Gilbert,+AZ+85295/@33.2963504,-111.7521001,3335a,13.1y/data=!4m2!3m1!1s0x872baf1d8c04d5bb:0x7b45edaccdbaa0e7",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-629-mark-amols-md",
        "name": "Mark Amols, MD",
        "role": "Medical Director",
        "imageUrl": "https://newdirectionfertility.com/wp-content/uploads/2020/12/dr-amols.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://www.newdirectionfertility.com/#team",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Seth Derman, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://newdirectionfertility.com/wp-content/uploads/2020/12/sethderman-headshot.jpg",
        "_source": {
          "url": "https://www.newdirectionfertility.com/#team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-629-seth-derman-md"
      },
      {
        "name": "Mark Johnson, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://newdirectionfertility.com/wp-content/uploads/2023/06/dr-mark-johnson.jpg",
        "_source": {
          "url": "https://www.newdirectionfertility.com/#team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-629-mark-johnson-md"
      },
      {
        "name": "Wael Salem, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://newdirectionfertility.com/wp-content/uploads/2023/09/wael-salem-physician.jpeg",
        "_source": {
          "url": "https://www.newdirectionfertility.com/#team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-629-wael-salem-md"
      },
      {
        "name": "Diane Woodford, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://newdirectionfertility.com/wp-content/uploads/2026/04/D_Woodford-2.jpeg",
        "_source": {
          "url": "https://www.newdirectionfertility.com/#team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-629-diane-woodford-md"
      },
      {
        "name": "Michelle Murphy, CNP",
        "role": "Nurse Practitioner",
        "credentials": ["CNP"],
        "imageUrl": "https://newdirectionfertility.com/wp-content/uploads/2022/03/headshot-michelle.jpg",
        "_source": {
          "url": "https://www.newdirectionfertility.com/#team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-629-michelle-murphy-cnp"
      },
      {
        "name": "Gigi Arora, CNP",
        "role": "Certified Nurse Practitioner",
        "credentials": ["CNP"],
        "imageUrl": "https://newdirectionfertility.com/wp-content/uploads/2022/03/headshot-gigi.jpg",
        "_source": {
          "url": "https://www.newdirectionfertility.com/#team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-629-gigi-arora-cnp"
      }
    ],
    "website": "https://www.newdirectionfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWktsyfKiz7nTOUB_An-0kKuI06Rb5yngvkib7xH5XmdoIV8668BW02PybifYSzRmdkc3yVeU-9QSJJVB_de83O_5KMW4I-5od0hMFzZpyWDlOeJHmpzYqumI4HLGOGXCgj4Wgs7=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/New+Direction+Fertility+Centers,+1760+E+Pecos+Rd+%23532,+Gilbert,+AZ+85295/@33.2963504,-111.7521001,3335a,13.1y/data=!4m2!3m1!1s0x872baf1d8c04d5bb:0x7b45edaccdbaa0e7",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkMceuKyaWGPdUrsAZmil5EbRjyIB1qzO-vThQN0U_weG3mTZrfniKcl73-y4VfV0swRIvURG7zfQD6AidCQ0SkuUQx8wfkONvQvaUS1A_XlniDspAhIo_vIjRih2UFOm8eEl7q=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/New+Direction+Fertility+Centers,+1760+E+Pecos+Rd+%23532,+Gilbert,+AZ+85295/@33.2963504,-111.7521001,3335a,13.1y/data=!4m2!3m1!1s0x872baf1d8c04d5bb:0x7b45edaccdbaa0e7",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnFqR8bkk1zejZUv3uQYVbVX-fZ-uczNdNG0wPvi1_h7mwKXzPwUHlU0brLLydEHZWqLjLa1emTh7gDwolMjwi_IToq75qUW86fPRlvtQAfGJvWvNSUw2PuU4fnav3tBCrkNV8=w224-h298-k-no-pi0-ya280.47635-ro-0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/New+Direction+Fertility+Centers,+1760+E+Pecos+Rd+%23532,+Gilbert,+AZ+85295/@33.2963504,-111.7521001,3335a,13.1y/data=!4m2!3m1!1s0x872baf1d8c04d5bb:0x7b45edaccdbaa0e7",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Arizona (AZ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-378",
    "externalIds": {
      "cdcClinicId": "378"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Health Center",
    "phone": "(520) 733-0083",
    "address": {
      "line1": "4518 E. Camp Lowell Dr",
      "city": "Tucson",
      "state": "AZ",
      "zip": "85712",
      "country": "US"
    },
    "location": {
      "lat": 32.2646,
      "lng": -110.896
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 36.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 34.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 30.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 199,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27378%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27378%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/tucson-az/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-378-scot-m-hutchison-md",
        "name": "Scot M. Hutchison, MD",
        "role": "Medical Director",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Scot-Hutchison_AZ_Square-1024x1024.png",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-scot-hutchison/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Nathaniel Zoneraich",
        "role": "Medical Director, Reproductive Endocrinology and Infertility Specialist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Nate-Zoneraich_AZ-NY_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-nathaniel-zoneraich/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-378-nathaniel-zoneraich"
      },
      {
        "name": "Frederick Larsen",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/03/Dr.-Fred-Larsen_AZ-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-frederick-larsen/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-378-frederick-larsen"
      },
      {
        "name": "Kurt Peterson",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["DO", "FACOOG"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/03/Dr.-Kurt-Peterson_AZ-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-kurt-peterson/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-378-kurt-peterson"
      },
      {
        "name": "Lili Jordan",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/03/Dr.-Lili-Jordan_-AZ-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-lili-jordan/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-378-lili-jordan"
      }
    ],
    "website": "https://www.reproductivehealthcenter.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "network": {
      "name": "Pinnacle Fertility"
    },
    "images": [
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/AFC_Tucson1-1.jpg",
        "type": "exterior",
        "caption": "Building exterior of the Tucson clinic (Reproductive Health Center / Pinnacle Fertility) at 4518 E. Camp Lowell Dr, with signage and provider names on the entrance windows.",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/tucson-az/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/AFC_Tucson3-1.jpg",
        "type": "lab",
        "caption": "On-site embryology/IVF laboratory showing microscopes, a laminar-flow biosafety hood, and incubators.",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/tucson-az/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Arizona (AZ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-120",
    "externalIds": {
      "cdcClinicId": "120",
      "googlePlaceId": "ChIJ8frikLoNK4cR8vJ71-xPBjM"
    },
    "type": "fertility-clinic",
    "name": "Southwest Fertility Center",
    "phone": "(602) 956-7481",
    "address": {
      "line1": "3125 N. 32nd St, Suite 200",
      "city": "Phoenix",
      "state": "AZ",
      "zip": "85018",
      "country": "US"
    },
    "location": {
      "lat": 33.4852,
      "lng": -112.013
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 41.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 33.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 30.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 173,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27120%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27120%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://southwestfertilitycenter.com/intertility-treatment-phoenix/meet-team-infertility-treatment/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Southwest+Fertility+Center,+3125+N+32nd+St+%23200,+Phoenix,+AZ+85018/@33.4852012,-112.0126081,3328a,13.1y/data=!4m2!3m1!1s0x872b0dba90e2faf1:0x33064fecd77bf2f2",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-120-sujatha-gunnala-md",
        "name": "Sujatha Gunnala, MD",
        "role": "Medical Director",
        "imageUrl": "https://southwestfertilitycenter.com/wp-content/uploads/2018/09/SW-Dr-G-200x300.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://southwestfertilitycenter.com/intertility-treatment-phoenix/meet-team-infertility-treatment/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Vinay Gunnala",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://southwestfertilitycenter.com/wp-content/uploads/2018/09/SW-Vaney-200x300.jpg",
        "_source": {
          "url": "https://southwestfertilitycenter.com/intertility-treatment-phoenix/meet-team-infertility-treatment/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-120-vinay-gunnala"
      },
      {
        "name": "Shelley Rosander",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "WHCNP"],
        "imageUrl": "https://southwestfertilitycenter.com/wp-content/uploads/2018/09/SR2-200x300.jpg",
        "_source": {
          "url": "https://southwestfertilitycenter.com/intertility-treatment-phoenix/meet-team-infertility-treatment/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-120-shelley-rosander"
      },
      {
        "name": "Charles E. Cornwell",
        "role": "Embryology Laboratory Director",
        "credentials": ["MSC", "TS", "ELD (ABB)"],
        "imageUrl": "https://southwestfertilitycenter.com/wp-content/uploads/2018/09/SW-Charles-200x300.jpg",
        "_source": {
          "url": "https://southwestfertilitycenter.com/intertility-treatment-phoenix/meet-team-infertility-treatment/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-120-charles-e-cornwell"
      }
    ],
    "website": "https://www.southwestfertilitycenter.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "images": [],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Arizona (AZ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-481",
    "externalIds": {
      "cdcClinicId": "481",
      "googlePlaceId": "ChIJs8JcPgpIhIARrIIRAUnQJ34"
    },
    "type": "fertility-clinic",
    "name": "Advanced Fertility Associates Medical Group, Inc.",
    "phone": "(707) 575-5831",
    "address": {
      "line1": "4690 Hoen Ave",
      "city": "Santa Rosa",
      "state": "CA",
      "zip": "95405",
      "country": "US"
    },
    "location": {
      "lat": 38.442,
      "lng": -122.7
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 72,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 63.1578947368421,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "12/19"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "0/9"
        }
      ],
      "cyclesPerYear": 79,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27481%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27481%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://afamd.com/our-team-santa-rosa-fertility-center",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Advanced+Fertility+Associates,+4690+Hoen+Ave,+Santa+Rosa,+CA+95405/@38.4416172,-122.6649678,3125a,13.1y/data=!4m2!3m1!1s0x8084480a3e5cc2b3:0x7e27d049011182ac",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://afamd.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-481-jennifer-ratcliffe",
        "name": "Jennifer Ratcliffe",
        "role": "Medical Director",
        "imageUrl": "https://res2.yourwebsite.life/res/68d6b78324e550e0b234f4be/696fccfc550439c022705288_optimized_1024_c812x1072-48x111",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://afamd.com/our-team-santa-rosa-fertility-center",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-481-jana-hajnovicova",
        "name": "Jana Hajnovicova",
        "credentials": ["MS", "ELD"],
        "role": "Embryology Laboratory Director",
        "imageUrl": "https://res2.yourwebsite.life/res/68d6b78324e550e0b234f4be/68dc2d2d04f07ee7b986cf83_optimized_200_c200x272-0x0",
        "_source": {
          "url": "https://afamd.com/our-team-santa-rosa-fertility-center",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-481-bonnie-day",
        "name": "Bonnie Day",
        "credentials": ["ANP", "MSN"],
        "role": "Nurse Coordinator",
        "imageUrl": "https://res2.yourwebsite.life/res/68d6b78324e550e0b234f4be/696fcd02550439c0227052a2_optimized_1024_c875x1118-117x68",
        "_source": {
          "url": "https://afamd.com/our-team-santa-rosa-fertility-center",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-481-christine-dearmore",
        "name": "Christine Dearmore",
        "role": "Business Manager",
        "imageUrl": "https://res2.yourwebsite.life/res/68d6b78324e550e0b234f4be/696fcd05d27791310886c06e_optimized_1024_c764x955-150x120",
        "_source": {
          "url": "https://afamd.com/our-team-santa-rosa-fertility-center",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://afamd.com",
    "description": "Have questions about your fertility? Need info on available treatments or just general advice on how to begin? Don’t hesitate to call or email us today\\",
    "insurance": {
      "accepted": true,
      "carriers": ["Kaiser"],
      "_source": {
        "url": "https://afamd.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "images": [
      {
        "url": "https://res2.yourwebsite.life/res/68d6b78324e550e0b234f4be/68d6e39e949677d00592d32d_optimized_1024_c1024x758-0x0",
        "type": "lab",
        "caption": "AFAMD laboratory",
        "_source": {
          "url": "https://afamd.com/",
          "fetchedAt": "2026-06-11"
        }
      },
      {
        "url": "https://res2.yourwebsite.life/res/68d6b78324e550e0b234f4be/68efbe172e683f8e225dd1de_optimized_1362_c1362x953-0x0",
        "type": "interior",
        "caption": "AFAMD patient consultation room",
        "_source": {
          "url": "https://afamd.com/",
          "fetchedAt": "2026-06-11"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWleeYDopowsBwlQV6-UrKnvbbllzYGU5UF50_mofYfAf8FZ-fZTNoAeXIPUfwklPOKYqcFxb_eUlFSh-uZzbfwttB6B5Y-o0fVT69gmk4sQyjEhF7q8gCxVRdsXcAQtWLefotuW0g=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Advanced+Fertility+Associates,+4690+Hoen+Ave,+Santa+Rosa,+CA+95405/@38.4416172,-122.6649678,3125a,13.1y/data=!4m2!3m1!1s0x8084480a3e5cc2b3:0x7e27d049011182ac",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Kaiser",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://afamd.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-301",
    "externalIds": {
      "cdcClinicId": "301",
      "googlePlaceId": "ChIJVefELa3x7IARfAPXPMYnB-E"
    },
    "type": "fertility-clinic",
    "name": "Alex Steinleitner, MD, Inc.",
    "phone": "(805) 543-2228",
    "address": {
      "line1": "127 Casa St",
      "city": "San Luis Obispo",
      "state": "CA",
      "zip": "93405",
      "country": "US"
    },
    "location": {
      "lat": 35.2919,
      "lng": -120.665
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 55.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 35.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 36.84210526315789,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/19"
        }
      ],
      "cyclesPerYear": 174,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27301%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27301%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://ccfertility.com/our-mission.html",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Alex+Steinleitner+MD+Inc,+127+Casa+St,+San+Luis+Obispo,+CA+93405/@35.2919759,-120.6649258,3257a,13.1y/data=!4m2!3m1!1s0x80ecf1ad2dc4e755:0xe10727c63cd7037c",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://ccfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-301-alex-steinleitner",
        "name": "Alex Steinleitner",
        "role": "Medical Director",
        "imageUrl": "https://ccfertility.com/img/dr-alex-steinleitner-md-san-luis-obispo-fertility-center.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive endocrinologist and infertility specialist",
        "_source": {
          "url": "https://ccfertility.com/our-mission.html",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://ccfertility.com",
    "description": "At Simple IVF Centers, we believe that high quality fertility care should be accessible to all families. It is our mission of social justice and equality to help you bring home a baby.",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk0JeKFQbGKm9-R9HACRqpp1gEtOtrBK6L7JsLvnBhVSpEI3Lt5EcSIEIVA-6pr04cb5m85UtdGcShEJY7a45HzG4F0J7QgYsbka-b3Rct8MHdPBhYsWgKAqo6u_wD9hmomvspf=w408-h544-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Alex+Steinleitner+MD+Inc,+127+Casa+St,+San+Luis+Obispo,+CA+93405/@35.2919759,-120.6649258,3257a,13.1y/data=!4m2!3m1!1s0x80ecf1ad2dc4e755:0xe10727c63cd7037c",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-839",
    "externalIds": {
      "cdcClinicId": "839",
      "googlePlaceId": "ChIJJ2Moausrw4ARsnj72RB9IQ4"
    },
    "type": "fertility-clinic",
    "name": "American Fertility Medical Center Corporation",
    "phone": "(909) 777-8888",
    "address": {
      "line1": "1370 Valley Vista Dr, Suite 135",
      "city": "Diamond Bar",
      "state": "CA",
      "zip": "91765",
      "country": "US"
    },
    "location": {
      "lat": 34.0286,
      "lng": -117.81
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 62.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/8"
        },
        {
          "ageBand": "35-37",
          "rate": 62.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/8"
        }
      ],
      "cyclesPerYear": 34,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27839%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27839%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://afmc.com",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/AFMC+Fertility+Medical+Center+IVF,+1370+Valley+Vista+Dr+Ste+135,+Diamond+Bar,+CA+91765/@33.9968448,-117.8380328,3308a,13.1y/data=!4m2!3m1!1s0x80c32beb6a286327:0xe217d10d9fb78b2",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://npiprofile.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-839-thomas-lee-md",
        "name": "Thomas Lee, MD",
        "role": "OBGYN Doctor",
        "imageUrl": "https://afmc.com/wp-content/uploads/2024/06/IMG_1690-copy-1.jpg",
        "credentials": ["MD", "PhD"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://afmc.com/team/dr-thomas-lee/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-839-rafif-z-moussa",
        "name": "Rafif Z. Moussa",
        "credentials": ["MD", "MSc"],
        "role": "Medical Director",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://afmc.com/wp-content/uploads/2024/07/IMG_1680-copy.jpg",
        "_source": {
          "url": "https://afmc.com/team/dr-rafif-z-moussa/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-839-seungwook-hong",
        "name": "Seungwook Hong",
        "credentials": ["PhD"],
        "role": "Lab Director",
        "imageUrl": "https://afmc.com/wp-content/uploads/2021/11/IMG_1428-copy.jpg",
        "_source": {
          "url": "https://afmc.com/team/dr-seungwook-hong/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-839-mohammed-naji",
        "name": "Mohammed Naji",
        "role": "Anesthesiologist",
        "specialty": "Anesthesiology",
        "imageUrl": "https://afmc.com/wp-content/uploads/2024/03/IMG_1677-copy.jpg",
        "_source": {
          "url": "https://afmc.com/team/dr-mohammed-naji/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-839-justin-houman",
        "name": "Justin Houman",
        "credentials": ["MD"],
        "role": "Cedars-Sinai Urologist",
        "specialty": "Urology",
        "imageUrl": "https://afmc.com/wp-content/uploads/2024/03/IMG_1691-copy.jpg",
        "_source": {
          "url": "https://afmc.com/team/dr-justin-houman/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-839-mart-john-magat",
        "name": "Mart John Magat",
        "role": "Junior Embryologist",
        "imageUrl": "https://afmc.com/wp-content/uploads/2024/07/IMG_1429-copy.jpg",
        "_source": {
          "url": "https://afmc.com/team/mj/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-839-dilshat-kahire",
        "name": "Dilshat Kahire",
        "role": "Registered Diagnostic Medical Sonographer",
        "imageUrl": "https://afmc.com/wp-content/uploads/2024/07/IMG_1744-copy.jpg",
        "_source": {
          "url": "https://afmc.com/team/kahire-dilshat/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://afmc.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "images": [
      {
        "url": "https://afmc.com/wp-content/uploads/2024/07/IMG_9003.jpg",
        "type": "interior"
      },
      {
        "url": "https://afmc.com/wp-content/uploads/2024/07/DSC_0784-copy.jpg",
        "type": "interior"
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn_6LDnazNkBms3FKMck6AcSDrlKhLUppHfZwYd4TsYB3XX57PknIrWNRWuiuym3SD3KUfu8y-CPhhpbzmKxe0-EEUg4iLmYsGpGKE1V05YiX7I1ecAJcgTlHcqiNCwtGqAN9_NvNKxLuk=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/AFMC+Fertility+Medical+Center+IVF,+1370+Valley+Vista+Dr+Ste+135,+Diamond+Bar,+CA+91765/@33.9968448,-117.8380328,3308a,13.1y/data=!4m2!3m1!1s0x80c32beb6a286327:0xe217d10d9fb78b2",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmhrYRtBjrXr2mFPnfGCJMcJEQ2drnMWR1RpmsHcrA9sIu2axZNH9bbhir8vPf-stBwTbHxnzNasHjbQAKc3Q_CMF2tfh_4PQvAPgCF06xi0MJy8TXU5XXCknNV2qpu-aOlo7AheRgKuZnX=w224-h398-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/AFMC+Fertility+Medical+Center+IVF,+1370+Valley+Vista+Dr+Ste+135,+Diamond+Bar,+CA+91765/@33.9968448,-117.8380328,3308a,13.1y/data=!4m2!3m1!1s0x80c32beb6a286327:0xe217d10d9fb78b2",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "description": "American Fertility Medical Center (AFMC) is a fertility clinic in Diamond Bar, California offering IUI, IVF, egg freezing, egg and sperm donation, and gestational surrogacy, and welcomes singles and LGBTQIA+ couples on their paths to parenthood. Led by Dr. Moussa and Dr. Lee, the center develops personalized fertility treatment plans and runs an in-house PGS/PGD genetic testing center. Its team offers multi-language support, with medical coordinators and interpreters proficient in English, Arabic, Spanish, Mandarin, Cantonese, and Korean.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-138",
    "externalIds": {
      "cdcClinicId": "138",
      "googlePlaceId": "ChIJ-fC1H4392oARduz8FBuSJpU"
    },
    "type": "fertility-clinic",
    "name": "American Reproductive Centers",
    "phone": "(760) 346-4334",
    "address": {
      "line1": "1180 N Indian Canyon Dr, Suites 301/303",
      "city": "Palm Springs",
      "state": "CA",
      "zip": "92262",
      "country": "US"
    },
    "location": {
      "lat": 33.8392,
      "lng": -116.546
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 36.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 33.33333333333333,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/15"
        },
        {
          "ageBand": "38-40",
          "rate": 33.33333333333333,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/18"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "0/8"
        }
      ],
      "cyclesPerYear": 94,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27138%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27138%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://arcbabies.com/meet-our-team/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/American+Reproductive+Centers,+1180+N+Indian+Canyon+Dr+Ste+301,+302,+303,+Palm+Springs,+CA+92262/@33.8395082,-116.5448884,3314a,13.1y/data=!4m2!3m1!1s0x80dafd8d1fb5f0f9:0x9526921b14fcec76",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://arcbabies.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-138-maher-abdallah",
        "name": "Maher Abdallah",
        "role": "Medical Director",
        "imageUrl": "https://arcbabies.com/wp-content/uploads/2022/07/dr-maher-abdallah2.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://arcbabies.com/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://arcbabies.com",
    "description": "American Reproductive Centers is the supportive partner you’ve been looking for to navigate your fertility journey. By blending world\\-class IVF and IUI protocols with a focused, one\\-on\\-one approach, we provide a sophisticated alternative to big\\-box medicine. With our state\\-of\\-the\\-art laboratory in Palm Springs and locations in San Diego and Redlands, we bring elite reproductive science directly to your neighborhood.",
    "insurance": {
      "accepted": true,
      "carriers": ["Empire"],
      "_source": {
        "url": "https://arcbabies.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish", "Chinese", "Arabic"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Empire",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://arcbabies.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkKondwjB_YmqYTN0Y6g1gIHLx-HDy-gtbOGwf2RicJXs7g24rC9XozL7wDuUfeFYRZwIGKoBDojP1ALwOmSeAXqVyvXaKm6_p0gFfBeeZRezSe-0PHcGxCasDW91PCDKWkAmAF=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/American+Reproductive+Centers,+1180+N+Indian+Canyon+Dr+Ste+301,+302,+303,+Palm+Springs,+CA+92262/@33.8395082,-116.5448884,3314a,13.1y/data=!4m2!3m1!1s0x80dafd8d1fb5f0f9:0x9526921b14fcec76",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-921",
    "externalIds": {
      "cdcClinicId": "921",
      "googlePlaceId": "ChIJzU-TXuPv3IARHu73byPtEdw"
    },
    "type": "fertility-clinic",
    "name": "South Coast Fertility Specialists",
    "phone": "(949) 516-0150",
    "address": {
      "line1": "24541 Pacific Park Drive, Suite 109",
      "city": "Aliso Viejo",
      "state": "CA",
      "zip": "92656",
      "country": "US"
    },
    "location": {
      "lat": 33.6263,
      "lng": -117.7319
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/14"
        },
        {
          "ageBand": "35-37",
          "rate": 60,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/10"
        },
        {
          "ageBand": "38-40",
          "rate": 55.55555555555556,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/9"
        }
      ],
      "cyclesPerYear": 45,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27921%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27921%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.banakashanimd.com/dr-banafsheh-kashani-md",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/South+Coast+Fertility+Specialists,+24541+Pacific+Park+Dr+%23109,+Aliso+Viejo,+CA+92656/@33.5723656,-117.7018622,3324a,13.1y/data=!4m2!3m1!1s0x80dcefe35e934fcd:0xdc11ed236ff7ee1e",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.banakashanimd.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-921-banafsheh-kashani-md",
        "name": "Banafsheh Kashani, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.banakashanimd.com/images/meet-dr-bana-kashani.jpg",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.banakashanimd.com/dr-banafsheh-kashani-md",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://southcoastfertility.com",
    "description": "Dr. Kashani is now part of South Coast Fertility Specialists.  Click here to learn more",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Anthem",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Medicare",
        "Medicaid"
      ],
      "_source": {
        "url": "https://www.banakashanimd.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Farsi", "Spanish"],
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Cigna, United Healthcare, Humana, Medicare, Medicaid",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.banakashanimd.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-423",
    "externalIds": {
      "cdcClinicId": "423",
      "googlePlaceId": "ChIJK5_4Kt66j4ARsBL05Qf4hi4"
    },
    "type": "fertility-clinic",
    "name": "Bay IVF Center",
    "phone": "(650) 322-0500",
    "address": {
      "line1": "1681 El Camino Real",
      "city": "Palo Alto",
      "state": "CA",
      "zip": "94306",
      "country": "US"
    },
    "location": {
      "lat": 37.4307,
      "lng": -122.152
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 30.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 31.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 23.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 101,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27423%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "scraped-retry",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://bayivf.com",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Bay+IVF+Fertility+Treatment+Clinic,+1681+El+Camino+Real,+Palo+Alto,+CA+94306/@37.4306988,-122.1518305,3168a,13.1y/data=!4m2!3m1!1s0x808fbade2af89f2b:0x2e86f807e5f412b0",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27423%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-423-frank-polansky",
        "name": "Frank Polansky",
        "role": "Medical Director",
        "imageUrl": "https://bayivf.com/wp-content/uploads/2023/05/doctor.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://bayivf.com/best-ivf-clinic/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://bayivf.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkJwIwPckN4MEoACygQXD5pr6vFjhNMsu9WLosjtTI6DdwneMzlolDAAkXe0CgedbCEcKWTrqHe6N-pL-DiWMRovQZuZu3u4Nu0IYLnk8JnYSQo83iQwneLyfV_pVToBH-nTYZb=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Bay+IVF+Fertility+Treatment+Clinic,+1681+El+Camino+Real,+Palo+Alto,+CA+94306/@37.4306988,-122.1518305,3168a,13.1y/data=!4m2!3m1!1s0x808fbade2af89f2b:0x2e86f807e5f412b0",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-902",
    "externalIds": {
      "cdcClinicId": "902"
    },
    "type": "fertility-clinic",
    "name": "Beverly Hills Fertility",
    "phone": "(310) 855-3688",
    "address": {
      "line1": "10390 Santa Monica Blvd, Suite 340",
      "city": "Los Angeles",
      "state": "CA",
      "zip": "90025",
      "country": "US"
    },
    "location": {
      "lat": 34.0624,
      "lng": -118.4147
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 5,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27902%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27902%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://bhfertility.com",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.bhfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-902-ellen-goldstein-md",
        "name": "Ellen Goldstein, MD",
        "role": "Medical Director",
        "imageUrl": "https://img1.wsimg.com/isteam/ip/6f213e23-c7b8-4613-8100-3c58dba1e38b/EllenGoldstein-46.jpg/:/cr=t:0%25,l:0%25,w:100%25,h:100%25/rs=w:900,m",
        "credentials": ["MD"],
        "_source": {
          "url": "https://bhfertility.com/about-dr-goldstein",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.bhfertility.com",
    "description": "Ellen Goldstein, MD Fertility SpecialistEllen Goldstein, MD Fertility SpecialistEllen Goldstein, MD Fertility Specialist",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-426",
    "externalIds": {
      "cdcClinicId": "426",
      "googlePlaceId": "ChIJZYbdQf67woARLvQc9PwRHfg"
    },
    "type": "fertility-clinic",
    "name": "California Center for Reproductive Health, Reproductive Fertility Center",
    "phone": "(818) 907-1571",
    "address": {
      "line1": "9201 W. Sunset Blvd, Suite 202",
      "city": "West Hollywood",
      "state": "CA",
      "zip": "90069",
      "country": "US"
    },
    "location": {
      "lat": 34.091,
      "lng": -118.393
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 56.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 46,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 42,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 11.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 643,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27426%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27426%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.center4reproduction.com",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Reproductive+Fertility+Center,+9201+Sunset+Blvd+Suite+500,+Los+Angeles,+CA+90069/@34.0910841,-118.3926678,3304a,13.1y/data=!4m2!3m1!1s0x80c2bbfe41dd8665:0xf81d11fcf41cf42e",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.center4reproduction.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-426-peyman-saadat-md",
        "name": "Peyman Saadat, MD",
        "role": "Medical Director"
      },
      {
        "practitionerId": "pr-org-cdc-426-eliran-mor",
        "name": "Eliran Mor",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinologist",
        "imageUrl": "https://www.center4reproduction.com/wp-content/uploads/2023/05/2131307-1.png",
        "_source": {
          "url": "https://www.center4reproduction.com/doctors/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-426-tina-koopersmith",
        "name": "Tina Koopersmith",
        "credentials": ["MD"],
        "specialty": "OB/GYN and Reproductive Endocrinologist",
        "imageUrl": "https://www.center4reproduction.com/wp-content/uploads/2023/09/Tina-Koopersmith-New.jpg",
        "_source": {
          "url": "https://www.center4reproduction.com/doctors/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-426-maria-zapata",
        "name": "Maria Zapata",
        "credentials": ["NP"],
        "imageUrl": "https://www.center4reproduction.com/wp-content/uploads/2023/10/Maria.jpg",
        "_source": {
          "url": "https://www.center4reproduction.com/doctors/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.center4reproduction.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "description": "The California Center for Reproductive Health is a global pioneer in fertility treatment and research, with proven high success rates year after year. Building families one patient at a time, the practice offers services including IVF and embryo transfer, egg freezing, egg donation, gestational surrogacy, tubal reversal, and LGBTQ fertility care from offices in Encino, West Hollywood, and Valencia, CA.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-135",
    "externalIds": {
      "cdcClinicId": "135",
      "googlePlaceId": "ChIJ35ki44UL3IARXLAzU_Glcrk"
    },
    "type": "fertility-clinic",
    "name": "California Center for Reproductive Medicine",
    "phone": "(760) 274-2000",
    "address": {
      "line1": "477 N. El Camino Real, Suite C310",
      "city": "Encinitas",
      "state": "CA",
      "zip": "92024",
      "country": "US"
    },
    "location": {
      "lat": 33.0571,
      "lng": -117.261
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 71.42857142857143,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/7"
        }
      ],
      "cyclesPerYear": 44,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27135%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27135%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://cacrm.com/about-us-fertility-center/team/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/California+Center+For+Reproductive+Medicine+(CACRM),+477+N+El+Camino+Real+c310,+Encinitas,+CA+92024/@33.0573016,-117.2613655,3344a,13.1y/data=!4m2!3m1!1s0x80dc0b85e32299df:0xb972a5f15333b05c",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://cacrm.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-135-lori-l-arnold-md",
        "name": "Lori L. Arnold, MD",
        "role": "Medical Director",
        "imageUrl": "https://cacrm.com/wp-content/uploads/2018/08/DR-Photo-min.png",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://cacrm.com/about-us-fertility-center/team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-135-eva-ulehova",
        "name": "Eva Ulehova",
        "role": "Embryologist | Lab Director",
        "imageUrl": "https://cacrm.com/wp-content/uploads/2015/07/eva200.png",
        "_source": {
          "url": "https://cacrm.com/about-us-fertility-center/team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-135-gail-overby",
        "name": "Gail Overby",
        "role": "Embryologist | Lab Supervisor",
        "imageUrl": "https://cacrm.com/wp-content/uploads/2015/07/gail200.png",
        "_source": {
          "url": "https://cacrm.com/about-us-fertility-center/team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-135-jannell-terry",
        "name": "Jannell Terry",
        "credentials": ["RN"],
        "role": "Nursing Supervisor",
        "imageUrl": "https://cacrm.com/wp-content/uploads/2015/07/janelle200.png",
        "_source": {
          "url": "https://cacrm.com/about-us-fertility-center/team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-135-marlena-lansford",
        "name": "Marlena Lansford",
        "role": "IVF Coordinator",
        "imageUrl": "https://cacrm.com/wp-content/uploads/2015/07/marlena200.png",
        "_source": {
          "url": "https://cacrm.com/about-us-fertility-center/team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-135-melissa-buchanan",
        "name": "Melissa Buchanan",
        "role": "Surrogate Intake Specialist",
        "imageUrl": "https://cacrm.com/wp-content/uploads/2015/07/melissa200.png",
        "_source": {
          "url": "https://cacrm.com/about-us-fertility-center/team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-135-maggie-rodriguez",
        "name": "Maggie Rodriguez",
        "role": "Director of Finance",
        "imageUrl": "https://cacrm.com/wp-content/uploads/2015/07/maggie200.png",
        "_source": {
          "url": "https://cacrm.com/about-us-fertility-center/team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-135-kari-reynoso",
        "name": "Kari Reynoso",
        "role": "Financial Assistant",
        "imageUrl": "https://cacrm.com/wp-content/uploads/2015/07/kerri200.png",
        "_source": {
          "url": "https://cacrm.com/about-us-fertility-center/team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-135-fei-yu",
        "name": "Fei Yu",
        "role": "Medical Assistant",
        "imageUrl": "https://cacrm.com/wp-content/uploads/2015/07/fei200.png",
        "_source": {
          "url": "https://cacrm.com/about-us-fertility-center/team/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://cacrm.com",
    "description": "At the California Center for Reproductive Medicine \\CACRM\\, we’ve been helping individuals and couples worldwide for nearly 25 years to overcome their fertility challenges and make their dreams of having a child come true. Our personal approach, medical expertise, and state\\-of\\-the\\-art facility have made us one of the most recognized and successful fertility clinics in California.",
    "languages": ["Russian", "French", "German", "Thai", "English"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmjcT_kXy7CVHgLrAnMHSdg505DwWcQgvIhlhw0saMC_3Zc3d-WZYx7wW23AonHN4BspKh-eFnBxvq5V8Xt7QF3PnIhpZP3dTeP6L0QZj9zUFmHprSIBLdHYQKV3Id74nDt7FCB=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/California+Center+For+Reproductive+Medicine+(CACRM),+477+N+El+Camino+Real+c310,+Encinitas,+CA+92024/@33.0573016,-117.2613655,3344a,13.1y/data=!4m2!3m1!1s0x80dc0b85e32299df:0xb972a5f15333b05c",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-889",
    "externalIds": {
      "cdcClinicId": "889",
      "googlePlaceId": "ChIJhZgpf9bh3IARY4lPMpEJ16s"
    },
    "type": "fertility-clinic",
    "name": "California Dream Fertility Center",
    "phone": "(949) 336-4956",
    "address": {
      "line1": "24541 Pacific Park Dr, Suite 109",
      "city": "Aliso Viejo",
      "state": "CA",
      "zip": "92656",
      "country": "US"
    },
    "location": {
      "lat": 33.6655,
      "lng": -117.7633
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 7,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27889%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27889%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ocdrmeng.com",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/California+Dream+Fertility+Center-Fangyin+Meng+MD,+24541+Pacific+Park+Dr+%23109,+Aliso+Viejo,+CA+92656/@33.5723656,-117.7018622,3324a,13.1y/data=!4m2!3m1!1s0x80dce1d67f299885:0xabd70991324f8963",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.ocdrmeng.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-889-fangyin-meng-md-phd",
        "name": "Fangyin Meng, MD, PHD",
        "role": "Medical Director",
        "imageUrl": "https://www.ocdrmeng.com/wp-content/uploads/2025/08/265808-scaled-1.jpg",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive endocrinology and infertility",
        "_source": {
          "url": "https://www.ocdrmeng.com/meet-dr-meng/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.ocdrmeng.com",
    "description": "We invite you contact us today to discuss your reproductive care. Please don't hesitate to call us at \\949\\ 848\\-4500",
    "insurance": {
      "accepted": true,
      "carriers": ["Aetna", "Anthem", "Cigna", "UnitedHealthcare", "HealthNet"],
      "_source": {
        "url": "https://www.ocdrmeng.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["Chinese", "English"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Cigna, UnitedHealthcare, HealthNet",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.ocdrmeng.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmfljU9rw6KACX5oK-nr8mTgahVwF2oWbFx4KR1r06WXhEI9MunRzsUI0zUELzbY03l8dExGl3rozBOQYbYesnIHF_0zndbixcfuH36kXbyiC0dRBIdBU2KtPdS52Z_c0eaMq8Y=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/California+Dream+Fertility+Center-Fangyin+Meng+MD,+24541+Pacific+Park+Dr+%23109,+Aliso+Viejo,+CA+92656/@33.5723656,-117.7018622,3324a,13.1y/data=!4m2!3m1!1s0x80dce1d67f299885:0xabd70991324f8963",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-220",
    "externalIds": {
      "cdcClinicId": "220",
      "googlePlaceId": "ChIJ4aXjYWe7woARQSRSbEHfv00"
    },
    "type": "fertility-clinic",
    "name": "Pinnacle Fertility Los Angeles (formerly California Fertility Partners)",
    "phone": "(310) 828-4008",
    "address": {
      "line1": "11818 Wilshire Blvd, Suite 300",
      "city": "Los Angeles",
      "state": "CA",
      "zip": "90025",
      "country": "US"
    },
    "location": {
      "lat": 34.0473,
      "lng": -118.463
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 65.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 68.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 47.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 45.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 563,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27220%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27220%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/los-angeles-ca/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Pinnacle+Fertility+California+-+Los+Angeles,+11818+Wilshire+Blvd+Ste+300,+Los+Angeles,+CA+90025/@34.0473083,-118.4629784,3306a,13.1y/data=!4m2!3m1!1s0x80c2bb6761e3a5e1:0x4dbfdf416c522441",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-220-karine-chung",
        "name": "Karine Chung",
        "credentials": ["MD", "FACOG"],
        "role": "Medical Director, Reproductive Endocrinologist and Infertility Specialist",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Karine-Chung_CA_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-karine-chung/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-220-guy-ringler",
        "name": "Guy Ringler",
        "credentials": ["MD", "FACOG"],
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Guy-Ringler_CA-NY_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-guy-ringler/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-220-kristin-bendikson",
        "name": "Kristin Bendikson",
        "credentials": ["MD", "FACOG"],
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Kristin-Bendikson_CA_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-kristin-bendikson/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-220-nina-vyas",
        "name": "Nina Vyas",
        "credentials": ["MD", "FACOG"],
        "role": "OBGYN, Reproductive Endocrinology and Infertility Specialist",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-nina-vyas/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-220-kelly-baek",
        "name": "Kelly Baek",
        "credentials": ["MD", "FACOG"],
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/kelly-retired-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-kelly-baek/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-220-meredith-sheehan",
        "name": "Meredith Sheehan",
        "credentials": ["MSN", "FNP-C"],
        "role": "Nurse Practitioner",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/02/meredeth-sheehan-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/meredith-sheehan-msn-fnp-c/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.pinnaclefertility.com/location/los-angeles-ca/",
    "languages": [
      "English",
      "Spanish",
      "Chinese",
      "Korean",
      "Japanese",
      "Arabic",
      "Russian",
      "French",
      "Portuguese",
      "Italian",
      "German",
      "Polish"
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "description": "California Fertility Partners, now a Pinnacle Fertility clinic in Los Angeles, has proudly served the community since 1982, helping individuals and families achieve their dreams of parenthood. From initial consultation to personalized care, the clinic offers a full range of fertility services, including IVF, advanced egg freezing, comprehensive genetic testing, IUI, and leading LGBTQ+ family-building programs.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkfMGM_Gpi8kVgNhkttqfXg0ldgexTxVWX_yvH54SjvKG7E_bb3RsWO6XPmRBVoZFB1IYoJ8ePeT5Zl8OxD72MfMHXo8ZdfuyXShYGsq_ziP2M4WCocUH-6OQGiKaogiIBBjQOEmJGHhDXY=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Pinnacle+Fertility+California+-+Los+Angeles,+11818+Wilshire+Blvd+Ste+300,+Los+Angeles,+CA+90025/@34.0473083,-118.4629784,3306a,13.1y/data=!4m2!3m1!1s0x80c2bb6761e3a5e1:0x4dbfdf416c522441",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn4FU4BpzkSHikoZPmiWbPAzEBBrLMrtO25HdEwifK9jT8GEtW3Qnf7gB-ve3ZGxu1PpEliQAx-WIM7s6xfuOnqEJgmS--yiyfEmRTSapGwwcRHtYHx_MNJxpxB6jZN9BxsoDphzLrzj2Wm=w238-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Pinnacle+Fertility+California+-+Los+Angeles,+11818+Wilshire+Blvd+Ste+300,+Los+Angeles,+CA+90025/@34.0473083,-118.4629784,3306a,13.1y/data=!4m2!3m1!1s0x80c2bb6761e3a5e1:0x4dbfdf416c522441",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-40",
    "externalIds": {
      "cdcClinicId": "40",
      "googlePlaceId": "ChIJuwMOYGQphYARppV2k6m2dtk"
    },
    "type": "fertility-clinic",
    "name": "California IVF Fertility Center",
    "phone": "(916) 979-5599",
    "address": {
      "line1": "2590 Venture Oaks Way, Suite 103",
      "city": "Sacramento",
      "state": "CA",
      "zip": "95833",
      "country": "US"
    },
    "location": {
      "lat": 38.6123,
      "lng": -121.516
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 52.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 38.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 53.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 61.53846153846154,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "8/13"
        }
      ],
      "cyclesPerYear": 318,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2740%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2740%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.californiaivf.com/about-us/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/California+IVF+Fertility+Center+Sacramento,+2590+Venture+Oaks+Way+%23102,+Sacramento,+CA+95833/@38.6123384,-121.5159535,3118a,13.1y/data=!4m2!3m1!1s0x80852964600e03bb:0xd976b6a9937695a6",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.californiaivf.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-40-ernest-zeringue",
        "name": "Ernest Zeringue",
        "role": "Medical Director",
        "imageUrl": "https://www.californiaivf.com/wp-content/uploads/2025/12/Dr-Zeringue.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://www.californiaivf.com/staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-40-gary-gross",
        "name": "Gary Gross",
        "credentials": ["MD"],
        "role": "Physician",
        "imageUrl": "https://www.californiaivf.com/wp-content/uploads/2025/12/Dr-Gary-Gross.jpg",
        "_source": {
          "url": "https://www.californiaivf.com/staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-40-harry-hatasaka",
        "name": "Harry Hatasaka",
        "credentials": ["MD"],
        "role": "Physician",
        "imageUrl": "https://www.californiaivf.com/wp-content/uploads/2026/01/Team-California-IVF-Fertility-Center-Sacramento-CA-Harry.jpg",
        "_source": {
          "url": "https://www.californiaivf.com/staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-40-linda-zeringue",
        "name": "Linda Zeringue",
        "credentials": ["FNP-BC"],
        "role": "Nurse Practitioner",
        "imageUrl": "https://www.californiaivf.com/wp-content/uploads/2025/12/Linda-Zeringue-FNP-BC.jpg",
        "_source": {
          "url": "https://www.californiaivf.com/staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-40-ashley-cook",
        "name": "Ashley Cook",
        "credentials": ["FNP-C"],
        "role": "Nurse Practitioner",
        "imageUrl": "https://www.californiaivf.com/wp-content/uploads/2025/12/Ashley-Cook-FNP-C.jpg",
        "_source": {
          "url": "https://www.californiaivf.com/staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-40-lindsey-debruler",
        "name": "Lindsey DeBruler",
        "credentials": ["FNP-BC"],
        "role": "Nurse Practitioner",
        "imageUrl": "https://www.californiaivf.com/wp-content/uploads/2025/12/Lindsey-DeBruler-FNP-BC.jpg",
        "_source": {
          "url": "https://www.californiaivf.com/staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-40-teresa-barbour",
        "name": "Teresa Barbour",
        "credentials": ["RN"],
        "role": "Nurse",
        "imageUrl": "https://www.californiaivf.com/wp-content/uploads/2025/12/Teresa-Barbour-RN.jpg",
        "_source": {
          "url": "https://www.californiaivf.com/staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-40-iman-khatib-zanjani",
        "name": "Iman Khatib Zanjani",
        "credentials": ["RN"],
        "role": "Nurse",
        "imageUrl": "https://www.californiaivf.com/wp-content/uploads/2025/12/Iman-Khatib-Zanjani-RN.jpg",
        "_source": {
          "url": "https://www.californiaivf.com/staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-40-maritza-olmos",
        "name": "Maritza Olmos",
        "credentials": ["RN"],
        "role": "Nurse",
        "imageUrl": "https://www.californiaivf.com/wp-content/uploads/2025/12/Maritza-Olmos-RN.jpg",
        "_source": {
          "url": "https://www.californiaivf.com/staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-40-isabella-bandy",
        "name": "Isabella Bandy",
        "credentials": ["RN"],
        "role": "Nurse",
        "imageUrl": "https://www.californiaivf.com/wp-content/uploads/2026/01/Team-California-IVF-Fertility-Center-Sacramento-CA-Isabella.jpg",
        "_source": {
          "url": "https://www.californiaivf.com/staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-40-brittany-salazar",
        "name": "Brittany Salazar",
        "credentials": ["RN"],
        "role": "Nurse",
        "imageUrl": "https://www.californiaivf.com/wp-content/uploads/2026/01/Team-California-IVF-Fertility-Center-Sacramento-CA-Brittany.jpg",
        "_source": {
          "url": "https://www.californiaivf.com/staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-40-li-meng",
        "name": "Li Meng",
        "credentials": ["PhD"],
        "role": "Embryology Lab Director",
        "imageUrl": "https://www.californiaivf.com/wp-content/uploads/2025/12/Li-Meng-Ph.D.jpg",
        "_source": {
          "url": "https://www.californiaivf.com/staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-40-anna-streltsov",
        "name": "Anna Streltsov",
        "credentials": [],
        "role": "Embryology Lab Supervisor",
        "imageUrl": "https://www.californiaivf.com/wp-content/uploads/2025/12/Anna-Streltsov.jpg",
        "_source": {
          "url": "https://www.californiaivf.com/staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-40-megan-mills-mitchell",
        "name": "Megan Mills Mitchell",
        "credentials": [],
        "role": "Practice Administrator",
        "imageUrl": "https://www.californiaivf.com/wp-content/uploads/2025/12/Megan-Mills-Mitchell.jpg",
        "_source": {
          "url": "https://www.californiaivf.com/staff/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.californiaivf.com",
    "insurance": {
      "accepted": true,
      "carriers": ["Health Net", "Kaiser", "Tricare"],
      "_source": {
        "url": "https://www.californiaivf.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "description": "California IVF Fertility Center provides the full spectrum of advanced fertility care, combining expert physicians, a highly credentialed embryology team, and personalized guidance every step of the way to help patients grow their families. Founded in 2004 and now located in a modern Sacramento facility, the private practice formed a collaborative partnership with the UC Davis Health System in 2011 and features an in-house research lab, operating room, and state-of-the-art air filtration, making it one of the most advanced embryology laboratories in Northern California.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Health Net, Kaiser, Tricare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.californiaivf.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm1ortdEC0naaGVr-VBzNzamuXIy2by1HT6GBIYKIpGli87rdnQQ85SFd5zkmUe3t_z0aFLrANNeg5hs1GAOSguH8pqkW3uzcRCOsKOVsMb_i7Ewsra7ZLfVljLF9tgVyiROyAi=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/California+IVF+Fertility+Center+Sacramento,+2590+Venture+Oaks+Way+%23102,+Sacramento,+CA+95833/@38.6123384,-121.5159535,3118a,13.1y/data=!4m2!3m1!1s0x80852964600e03bb:0xd976b6a9937695a6",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-244",
    "externalIds": {
      "cdcClinicId": "244",
      "googlePlaceId": "ChIJt25IigrBwoARaxZx6-9iTDQ"
    },
    "type": "fertility-clinic",
    "name": "CARE Fertility",
    "phone": "(818) 230-7778",
    "address": {
      "line1": "500 E. Colorado St, Suite 400",
      "city": "Glendale",
      "state": "CA",
      "zip": "91206",
      "country": "US"
    },
    "location": {
      "lat": 34.1517,
      "lng": -118.232
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 39,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 41.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 35.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 16.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 236,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27244%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27244%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://carefertility.net/about/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Care+Fertility,+500+E+Colorado+St+Ste+400,+Glendale,+CA+91205/@34.1423811,-118.2500222,3302a,13.1y/data=!4m2!3m1!1s0x80c2c10a8a486eb7:0x344c62efeb71166b",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://carefertility.net",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-244-rudy-quintero",
        "name": "Rudy Quintero",
        "role": "Medical Director",
        "imageUrl": "https://carefertility.net/wp-content/uploads/2025/04/quintero-1-1-1.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://carefertility.net/dr-rudy-quintero/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-244-antoine-la",
        "name": "Antoine La",
        "credentials": ["ELD"],
        "role": "Embryology Laboratory Director",
        "imageUrl": "https://carefertility.net/wp-content/uploads/2024/11/antoine-la.png",
        "_source": {
          "url": "https://carefertility.net/antoine-la/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://carefertility.net",
    "description": "Whether you’re having trouble getting pregnant, want to optimize your chances for a future pregnancy, or need a donor and/or surrogate to help you build a family, we have a solution. Schedule a  Free Consultation with our Board Certified fertility specialists today to discuss the best solution for you.",
    "languages": ["English", "Spanish", "Mandarin", "Cantonese"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://carefertility.net/wp-content/uploads/2025/05/FOTO-ENTRANCE_BABYDUST-BOOTH-scaled.jpg",
        "type": "exterior",
        "caption": "CARE Fertility entrance and reception",
        "_source": {
          "url": "https://carefertility.net/about/",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkHb3SQ1lKf_Y-Aqi5OIEHCx_31HB4SJz65Pylka2Y1EFG8P9CSeagPiAYNuBc7tzr-AO2KU4nF6BREGpmfXQaigAL05WbHsEQ7P91dCXvBee0EH51lz3nGdQsMlNj7PRQbR9fCRHylNEJw=w530-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Care+Fertility,+500+E+Colorado+St+Ste+400,+Glendale,+CA+91205/@34.1423811,-118.2500222,3302a,13.1y/data=!4m2!3m1!1s0x80c2c10a8a486eb7:0x344c62efeb71166b",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-280",
    "externalIds": {
      "cdcClinicId": "280"
    },
    "type": "fertility-clinic",
    "name": "CARE for the Bay Area",
    "phone": "(408) 628-0783",
    "address": {
      "line1": "555 Knowles Dr, Suite 212",
      "city": "Los Gatos",
      "state": "CA",
      "zip": "95032",
      "country": "US"
    },
    "location": {
      "lat": 37.262,
      "lng": -121.966
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "miniIVF",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 68.42105263157895,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "13/19"
        },
        {
          "ageBand": "35-37",
          "rate": 55.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 75,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/8"
        }
      ],
      "cyclesPerYear": 167,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27280%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27280%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://care4ba.com/care-team",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://care4ba.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-280-karen-j-purcell-md-phd",
        "name": "Karen J. Purcell, MD, PHD",
        "role": "Medical Director",
        "imageUrl": "https://img1.wsimg.com/isteam/ip/f02dfddd-459b-4fa6-a70d-963f790ef29f/5dac8ff9-31e9-4dc3-9429-2cf52f74634a.jpg/:/cr=t:0%25,l:0%25,w:100%25,h:100%25/rs=w:400,cg:true",
        "credentials": ["MD", "PhD"],
        "_source": {
          "url": "https://care4ba.com/dr-karen-j-purcell",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-280-vanessa-julaton",
        "name": "Vanessa Julaton",
        "credentials": ["PhD", "HCLD (ABB)"],
        "role": "IVF Laboratory Director",
        "imageUrl": "https://img1.wsimg.com/isteam/ip/f02dfddd-459b-4fa6-a70d-963f790ef29f/VJ%20headshot%202022.jpg/:/rs=w:400,cg:true,m",
        "_source": {
          "url": "https://care4ba.com/dr-vanessa-julaton",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-280-iqbal-mirza",
        "name": "Iqbal Mirza",
        "credentials": ["MD"],
        "_source": {
          "url": "https://care4ba.com/care-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-280-yinzhong-bing",
        "name": "Yinzhong Bing",
        "credentials": ["PhD"],
        "_source": {
          "url": "https://care4ba.com/care-team",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://care4ba.com",
    "description": "At C.A.R.E. for the Bay Area, our mission is to provide families with personalized care from an experienced and compassionate team of medical professionals.  We care deeply about our patients and their families, and we understand the physical and emotional toll that comes with infertility.  We are committed to helping our patients reach their dreams of having a healthy family.",
    "insurance": {
      "accepted": true,
      "carriers": ["Medicare", "Medicaid"],
      "_source": {
        "url": "https://care4ba.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Medicare, Medicaid",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://care4ba.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-804",
    "externalIds": {
      "cdcClinicId": "804",
      "googlePlaceId": "ChIJJc750Emjj4ARiy4t7RdEq2Q"
    },
    "type": "fertility-clinic",
    "name": "CCRM San Francisco, Bay Area Center for Reproductive Medicine, LLC (BACRM)",
    "phone": "(650) 646-7500",
    "address": {
      "line1": "1060 Marsh Rd, 1st Floor",
      "city": "Menlo Park",
      "state": "CA",
      "zip": "94025",
      "country": "US"
    },
    "location": {
      "lat": 37.4809,
      "lng": -122.183
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 62.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 65.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 83,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 463,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27804%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27804%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/california/menlo-park/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+San+Francisco,+1060+Marsh+Rd+1st+Floor,+Menlo+Park,+CA+94025/@37.4809156,-122.1825457,3166a,13.1y/data=!4m2!3m1!1s0x808fa349d0f9ce25:0x64ab4417ed2d2e8b",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-804-salli-tazuke-md",
        "name": "Salli Tazuke, MD",
        "role": "Co-founding Physician & Co-Medical Director",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Salli_Tazuke_600x600_2x.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/salli-tazuke/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-804-sunny-jun",
        "name": "Sunny Jun",
        "credentials": ["MD"],
        "role": "Co-founding Physician & Co-Medical Director",
        "specialty": "IVF, PCOS, recurrent pregnancy loss, endometriosis, egg/embryo cryopreservation, third-party reproduction, reproductive surgery, LGBTQIA+ family building",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Sunny_Jun_600x600_2x-2.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/sunny-jun/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-804-angela-liu",
        "name": "Angela Liu",
        "credentials": ["MD"],
        "role": "Reproductive Endocrinologist",
        "specialty": "Third-party reproduction, LGBTQIA+ family building, access to care",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Angelia_Liu_600x600_2x.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/angela-liu/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.ccrmivf.com",
    "languages": [
      "English",
      "Spanish",
      "Chinese",
      "Arabic",
      "Russian",
      "French",
      "Portuguese",
      "Italian",
      "German"
    ],
    "images": [
      {
        "url": "https://www.ccrmivf.com/wp-content/uploads/2025/07/CCRM-San-Francisco-Reception-Desk.jpg",
        "type": "interior"
      },
      {
        "url": "https://www.ccrmivf.com/wp-content/uploads/2025/07/CCRM-San-Francisco-Waiting-Area.jpg",
        "type": "interior"
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkyNRDMiryDMMeSG0Xpcr67itJobNkTmAyCJpSfrcT-UZ91TeOxgrhGx1YNXwbu-F0OAZeX7qyHqxCfaYkddoU2AtqzDxMUCjc0tNs6bZveHS4Z2iGMiMIucYwgmlUcgivuYCFp=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+San+Francisco,+1060+Marsh+Rd+1st+Floor,+Menlo+Park,+CA+94025/@37.4809156,-122.1825457,3166a,13.1y/data=!4m2!3m1!1s0x808fa349d0f9ce25:0x64ab4417ed2d2e8b",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "description": "CCRM Fertility of San Francisco, located at 1060 Marsh Road in Menlo Park, helps individuals and couples realize their dreams of parenthood. The clinic offers a full range of fertility services, including IUI, IVF, ICSI, PGT, egg freezing, LGBTQIA+ family building, egg and sperm donor options, and gestational carrier support, and counts over 2,000 five-star reviews. It was co-founded by Dr. Salli Tazuke and Dr. Sunny Jun, who serve as co-medical directors.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-316",
    "externalIds": {
      "cdcClinicId": "316",
      "googlePlaceId": "ChIJgfzJZ5u5woARjQQEK5KrmPk"
    },
    "type": "fertility-clinic",
    "name": "Cedars Sinai Medical Center, Center for Fertility and Reproductive Medicine",
    "phone": "(310) 423-9964",
    "address": {
      "line1": "444 S. San Vicente Blvd, Suite 1002",
      "city": "Los Angeles",
      "state": "CA",
      "zip": "90048",
      "country": "US"
    },
    "location": {
      "lat": 34.0701,
      "lng": -118.375
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 61.53846153846154,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "8/13"
        },
        {
          "ageBand": "35-37",
          "rate": 46.666666666666664,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/15"
        },
        {
          "ageBand": "38-40",
          "rate": 38.46153846153847,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/13"
        }
      ],
      "cyclesPerYear": 101,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27316%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27316%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.cedars-sinai.org/locations/fertility-reproductive-medicine-center-25.html",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Cedars-Sinai+Fertility+%26+Reproductive+Medicine,+Mark+Goodson+Building,+444+S+San+Vicente+Blvd+%231002,+Los+Angeles,+CA+90048/@34.0701384,-118.3752833,3305a,13.1y/data=!4m2!3m1!1s0x80c2b99b67c9fc81:0xf998ab922b04048d",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.cedars-sinai.org",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-316-margareta-d-pisarska-md",
        "name": "Margareta D. Pisarska, MD",
        "role": "Medical Director",
        "imageUrl": "https://a.mktgcdn.com/p/dNhv-7xk3R-3eenPWOlin2MrGEdNWsmkcjHQcI6u-Go/174x243.jpg",
        "credentials": ["MD"],
        "specialty": "Ob/Gyn-Reproductive Endocrinology",
        "_source": {
          "url": "https://www.cedars-sinai.org/provider/margareta-pisarska-2153126.html",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-316-erica-t-wang",
        "name": "Erica T. Wang",
        "credentials": ["MD", "MAS"],
        "role": "Assistant Professor, Obstetrics and Gynecology",
        "specialty": "Ob/Gyn-Reproductive Endocrinology",
        "imageUrl": "https://a.mktgcdn.com/p/VJ-57mfG4cwAtZiEpxWFmOblwpJeYccoxvuqVEdi1ks/1.0000/243x243.jpg",
        "_source": {
          "url": "https://www.cedars-sinai.org/provider/erica-wang-3639471.html",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-316-jessica-l-chan",
        "name": "Jessica L. Chan",
        "credentials": ["MD"],
        "role": "Assistant Professor, Obstetrics and Gynecology",
        "specialty": "Ob/Gyn-Reproductive Endocrinology",
        "imageUrl": "https://a.mktgcdn.com/p/jcyESX1gDuuXUnrxLfTOodJi0SQIFW847I_t5j-btU8/1.0000/258x258.jpg",
        "_source": {
          "url": "https://www.cedars-sinai.org/provider/jessica-chan-2988261.html",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-316-zoe-a-scannell",
        "name": "Zoe A. Scannell",
        "credentials": ["NP"],
        "specialty": "Ob/Gyn-Reproductive Endocrinology",
        "imageUrl": "https://a.mktgcdn.com/p/WKoaBf1Nnup3ykyKptM3E6r3Qy487d7bwb9jpusCP04/1.0000/243x243.jpg",
        "_source": {
          "url": "https://www.cedars-sinai.org/provider/zoe-scannell-1637546.html",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.cedars-sinai.org",
    "insurance": {
      "accepted": true,
      "carriers": ["Medicare"],
      "_source": {
        "url": "https://www.cedars-sinai.org",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "description": "Cedars-Sinai Fertility & Reproductive Medicine provides care for women who are trying to conceive and those with hormonal disorders. The center offers diagnostic, treatment and management services for patients with the full range of fertility and reproductive health concerns.",
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Medicare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.cedars-sinai.org",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmX0z2dFzwRB3eDoauaGjAnK8msiGbXyoswVRNr02j0v5HBngTPVD7ioICNZ3EKY_esF4whRphZRkKJ2NY2jvaEFkFZ7krvwSC9FBHtv7GqES3BBx-2nyYQ1f-OEo8GgsldZXZkPF2DhK4L=w576-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Cedars-Sinai+Fertility+%26+Reproductive+Medicine,+Mark+Goodson+Building,+444+S+San+Vicente+Blvd+%231002,+Los+Angeles,+CA+90048/@34.0701384,-118.3752833,3305a,13.1y/data=!4m2!3m1!1s0x80c2b99b67c9fc81:0xf998ab922b04048d",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-482",
    "externalIds": {
      "cdcClinicId": "482"
    },
    "type": "fertility-clinic",
    "name": "Center for Reproductive Health & Gynecology, (CRH&G)",
    "phone": "(310) 360-7584",
    "address": {
      "line1": "351 S. Beverly Dr, Suite 230",
      "city": "Beverly Hills",
      "state": "CA",
      "zip": "90212",
      "country": "US"
    },
    "location": {
      "lat": 34.0673,
      "lng": -118.377
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "35-37",
          "rate": 72.72727272727273,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "8/11"
        },
        {
          "ageBand": "38-40",
          "rate": 60,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/10"
        }
      ],
      "cyclesPerYear": 69,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27482%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27482%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.reproductive.org",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.reproductive.org",
            "fetchedAt": "2026-06-11"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.reproductive.org",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-482-sam-najmabadi-md",
        "name": "Sam Najmabadi, MD",
        "role": "Medical Director",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66cc9c75423d440dd28b504f/68ae193f-a44d-4f90-8f43-e88c471b222e/DrNaj_Social.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://www.reproductive.org/dr-sam-najmabadi",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-482-jennifer",
        "name": "Jennifer",
        "role": "Office Manager",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66cc9c75423d440dd28b504f/951c61bb-2532-4a77-9fc0-04f2a395ea0a/Jennifer+Alas-167.jpg",
        "_source": {
          "url": "https://www.reproductive.org/dr-sam-najmabadi",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-482-thelma",
        "name": "Thelma",
        "role": "Senior Embryologist",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66cc9c75423d440dd28b504f/5d44f91f-0cfc-47c3-ac54-50388e8242b5/Thelma+Macaso-143.jpg",
        "_source": {
          "url": "https://www.reproductive.org/dr-sam-najmabadi",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-482-patricia",
        "name": "Patricia",
        "role": "Senior Administrative Assistant & Office Outreach Representative",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66cc9c75423d440dd28b504f/deff141b-7db1-4cce-b933-7c1920de9541/Patricia+Morris-013.jpg",
        "_source": {
          "url": "https://www.reproductive.org/dr-sam-najmabadi",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-482-karla",
        "name": "Karla",
        "role": "Clinical Coordinator",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66cc9c75423d440dd28b504f/62b27ef8-67d9-4db0-a027-82152c301355/Karla.jpeg",
        "_source": {
          "url": "https://www.reproductive.org/dr-sam-najmabadi",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-482-edmond",
        "name": "Edmond",
        "role": "Surgical Technician",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66cc9c75423d440dd28b504f/e04e0c1d-2b64-4218-b88e-6ce8d89989ac/Edmond-159.jpg",
        "_source": {
          "url": "https://www.reproductive.org/dr-sam-najmabadi",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-482-andrea",
        "name": "Andrea",
        "role": "Ultrasound Technician",
        "_source": {
          "url": "https://www.reproductive.org/dr-sam-najmabadi",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-482-alice",
        "name": "Alice",
        "role": "Ultrasound Technician",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66cc9c75423d440dd28b504f/a67b3199-84b7-4eb4-93a4-412563e51136/Alice+Sandoval_Ultrasound+Tech.png",
        "_source": {
          "url": "https://www.reproductive.org/dr-sam-najmabadi",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-482-yadira",
        "name": "Yadira",
        "role": "IV Nurse",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66cc9c75423d440dd28b504f/58bb73bf-09d5-4d51-b815-9b1520355fda/Yadira+Moreno-179.jpg",
        "_source": {
          "url": "https://www.reproductive.org/dr-sam-najmabadi",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-482-ashly",
        "name": "Ashly",
        "role": "Nurse Practitioner",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66cc9c75423d440dd28b504f/11c30b3f-64e9-4a76-8235-2c08cf5c1445/Ashly+2.jpg",
        "_source": {
          "url": "https://www.reproductive.org/dr-sam-najmabadi",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-482-jessica",
        "name": "Jessica",
        "role": "Front Office Staff",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66cc9c75423d440dd28b504f/0101f115-d2c5-41ee-9b00-7584677c7317/Jessica+Godinez-159.jpg",
        "_source": {
          "url": "https://www.reproductive.org/dr-sam-najmabadi",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-482-cindy",
        "name": "Cindy",
        "role": "Front Office Staff",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66cc9c75423d440dd28b504f/112aaf50-a490-49fb-9ec2-709475cb0385/Cindy-222.jpg",
        "_source": {
          "url": "https://www.reproductive.org/dr-sam-najmabadi",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-482-ana",
        "name": "Ana",
        "role": "Billing Coordinator, Practice & Surgical Center",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66cc9c75423d440dd28b504f/ce6e2191-c400-496b-989e-34f5ccfb62a1/Ana+Castaneda-104.jpg",
        "_source": {
          "url": "https://www.reproductive.org/dr-sam-najmabadi",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-482-diane",
        "name": "Diane",
        "role": "Back Office Manager & IVF nurse",
        "_source": {
          "url": "https://www.reproductive.org/dr-sam-najmabadi",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-482-jess",
        "name": "Jess",
        "role": "Lab Assistant",
        "_source": {
          "url": "https://www.reproductive.org/dr-sam-najmabadi",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-482-ashley",
        "name": "Ashley",
        "role": "Lab Assistant",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66cc9c75423d440dd28b504f/c873596c-62ac-4db4-97f3-1433c3568f21/Ashley+Yeung_Lab+Assistant.png",
        "_source": {
          "url": "https://www.reproductive.org/dr-sam-najmabadi",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-482-august",
        "name": "August",
        "role": "Lab Assistant",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66cc9c75423d440dd28b504f/6ace1ae1-3c88-464d-9b4f-d2505b4671a4/August+Roberts_Lab+Assistant.png",
        "_source": {
          "url": "https://www.reproductive.org/dr-sam-najmabadi",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.reproductive.org",
    "insurance": {
      "accepted": true,
      "carriers": ["Aetna", "Cigna", "Health Net"],
      "employeeBenefits": ["WINFertility"],
      "_source": {
        "url": "https://www.reproductive.org",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "images": [],
    "description": "The Center for Reproductive Health & Gynecology (CRHG) in Beverly Hills (CA) and Punta Mita (Mexico) offers comprehensive fertility treatments, including IVF, egg freezing, and surrogacy. With an onsite lab, CRHG provides advanced and low-tech options. Committed to patient education, the clinic ensures a comfortable experience by making complex procedures understandable and tailored to individual needs.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Cigna, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.reproductive.org",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-178",
    "externalIds": {
      "cdcClinicId": "178"
    },
    "type": "fertility-clinic",
    "name": "Central California IVF Program, Women's Specialty and Fertility Center",
    "phone": "(559) 299-7700",
    "address": {
      "line1": "729 N. Medical Center Dr West, Suite 205",
      "city": "Clovis",
      "state": "CA",
      "zip": "93611",
      "country": "US"
    },
    "location": {
      "lat": 36.8418,
      "lng": -119.661
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 52.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 29.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 20.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 223,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27178%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27178%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.wsfcclovis.com/team-1",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.wsfcclovis.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-178-carolina-m-sueldo",
        "name": "Carolina M. Sueldo",
        "role": "Co-Director",
        "imageUrl": "https://static.wixstatic.com/media/25b325_7be4802d12ab4a64b9fe2d93b007f56d~mv2.jpg/v1/fill/w_414,h_478,al_c,q_80/Dr_edited.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://www.wsfcclovis.com/team-1/carolina-m.-sueldo%2C-m.d.",
          "fetchedAt": "2026-06-10"
        },
        "specialty": "Reproductive Endocrinology and Infertility"
      },
      {
        "practitionerId": "pr-org-cdc-178-michael-synn",
        "name": "Michael Synn",
        "credentials": ["MD"],
        "role": "Medical Director",
        "imageUrl": "https://static.wixstatic.com/media/25b325_045d77265443485f88b3547a76951478~mv2.jpg/v1/fill/w_320,h_320,al_c,q_80/Dr_edited.jpg",
        "_source": {
          "url": "https://www.wsfcclovis.com/team-1/michael-synn%2C-m.d.",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.wsfcclovis.com",
    "description": "In need of fertility care? Women's Specialty & Fertility Center is here to help. With over 30 years of experience in your local community, we provide local and international expertise. We have helped thousands of couples achieve their dreams of having a child and starting a family, and look forward to helping many more.",
    "insurance": {
      "accepted": true,
      "carriers": ["Medicare", "Medicaid"],
      "_source": {
        "url": "https://www.wsfcclovis.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Medicare, Medicaid",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.wsfcclovis.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-388",
    "externalIds": {
      "cdcClinicId": "388",
      "googlePlaceId": "ChIJ59Xn2K_d3IARnfI-VQOjHzk"
    },
    "type": "fertility-clinic",
    "name": "Coastal Fertility Medical Center, Inc.",
    "phone": "(949) 726-0600",
    "address": {
      "line1": "15500 Sand Canyon Ave, Suite 100",
      "city": "Irvine",
      "state": "CA",
      "zip": "92618",
      "country": "US"
    },
    "location": {
      "lat": 33.6684,
      "lng": -117.766
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 39.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 27.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 31.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 147,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27388%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27388%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://coastalfertility.com/about/thecenter/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Coastal+Fertility+Medical+Center,+15500+Sand+Canyon+Ave+%23100,+Irvine,+CA+92618/@33.6683965,-117.7655985,3321a,13.1y/data=!4m2!3m1!1s0x80dcddafd8e7d5e7:0x391fa303553ef29d",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://coastalfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-388-minh-n-ho",
        "name": "Minh N. Ho",
        "role": "Medical Director",
        "imageUrl": "https://coastalfertility.com/wp-content/uploads/2019/05/Dr.Ho_-252x300.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://coastalfertility.com/about/fertility-doctors-free-consultation-near-me/dr-minh-n-ho/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-388-david-harari",
        "name": "David Harari",
        "credentials": ["MD"],
        "specialty": "Infertility and gynecology-related disorders, such as fibroids, endometriosis and perimenopause",
        "imageUrl": "https://coastalfertility.com/wp-content/uploads/2019/08/Dr.Harari-252x300.jpg",
        "_source": {
          "url": "https://coastalfertility.com/about/fertility-doctors-free-consultation-near-me/dr-david-harari/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-388-kenna-schnarr",
        "name": "Kenna Schnarr",
        "credentials": ["DO", "MS"],
        "imageUrl": "https://coastalfertility.com/wp-content/uploads/2025/05/Dr.kenna_-252x300-1.webp",
        "_source": {
          "url": "https://coastalfertility.com/about/fertility-doctors-free-consultation-near-me/dr-kenna-schnarr-do-ms/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-388-kenneth-k-c-vu",
        "name": "Kenneth K.C. Vu",
        "credentials": ["MD", "CC/HCLD", "FACOG"],
        "role": "Reproductive Endocrinologist at Coastal Fertility Medical Center",
        "imageUrl": "https://coastalfertility.com/wp-content/uploads/2024/10/Dr.-Vu_3-1024x1024.webp",
        "_source": {
          "url": "https://coastalfertility.com/about/fertility-doctors-free-consultation-near-me/dr-kenneth-vu/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-388-kevin-oum",
        "name": "Kevin Oum",
        "credentials": ["PhD", "HCLD/CC", "EMB"],
        "role": "Laboratory Director",
        "specialty": "Intracytoplasmic Sperm Injection (ICSI), Embryo Biopsy, Surgical Sperm Retrieval, and Cryopreservation",
        "imageUrl": "https://coastalfertility.com/wp-content/uploads/2019/09/doctor.jpg",
        "_source": {
          "url": "https://coastalfertility.com/about/fertility-doctors-free-consultation-near-me/dr-kevin-oum/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-388-karen-zhen",
        "name": "Karen Zhen",
        "role": "Practice Director",
        "_source": {
          "url": "https://coastalfertility.com/about/fertility-doctors-free-consultation-near-me/staff/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://coastalfertility.com",
    "languages": ["English"],
    "images": [
      {
        "url": "https://coastalfertility.com/wp-content/uploads/2024/08/IVF-Lab-Director.webp",
        "type": "lab",
        "caption": "Coastal Fertility IVF lab",
        "_source": {
          "url": "https://coastalfertility.com",
          "fetchedAt": "2026-06-11"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk5mwc8PwfvSUDNRhpGGnJXwt2LoeBC2OF1xfHQtJxj3AA75-oB2JgPEmXYkNNk8Qd1f9MSQRBxn_xfGIajPY2YlH_fM1FhDsYbUY1HxyIbihL5DrpTgD-2bmxHYkOPfL-Ly8nL=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Coastal+Fertility+Medical+Center,+15500+Sand+Canyon+Ave+%23100,+Irvine,+CA+92618/@33.6683965,-117.7655985,3321a,13.1y/data=!4m2!3m1!1s0x80dcddafd8e7d5e7:0x391fa303553ef29d",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "description": "Coastal Fertility Medical Center has been one of Orange County’s leading providers of reproductive care to infertility patients since 1982, and its staff are widely recognized for their compassion and special attention to the individual needs of their patients. Its state-of-the-art medical offices, IVF laboratory, and ambulatory surgery center house the newest, most sophisticated equipment available today. Services range from basic infertility testing, ovulation induction, and inseminations to IVF, ICSI, blastocyst transfer, preimplantation genetic diagnosis (PGD), and donor eggs.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-901",
    "externalIds": {
      "cdcClinicId": "901",
      "googlePlaceId": "ChIJBdvBJenp3IAR2P73Q0x5pSk"
    },
    "type": "fertility-clinic",
    "name": "Ember Fertility Center (formerly Envita)",
    "phone": "(949) 666-2229",
    "address": {
      "line1": "23521 Paseo De Valencia, Suite 100",
      "city": "Laguna Hills",
      "state": "CA",
      "zip": "92653",
      "country": "US"
    },
    "location": {
      "lat": 33.6131,
      "lng": -117.7138
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 0,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27901%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27901%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://emberfertility.com/about",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Ember+Fertility+Center,+23521+Paseo+De+Valencia+Ste+100,+Laguna+Hills,+CA+92653/@33.6113733,-117.7116333,3323a,13.1y/data=!4m2!3m1!1s0x80dce9e925c1db05:0x29a5794c43f7fed8",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.bestprosintown.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-901-william-freije",
        "name": "William Freije",
        "role": "Medical Director",
        "imageUrl": "https://emberfertility.com/wp-content/uploads/photo-envita-William-Freije-400x400.jpg",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive endocrinologist",
        "_source": {
          "url": "https://emberfertility.com/about/dr-william-freije",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-901-avisa-asemi",
        "name": "Avisa Asemi",
        "credentials": ["PhD", "HCLD"],
        "role": "Lab & scientific director, senior embryologist",
        "imageUrl": "https://emberfertility.com/wp-content/uploads/envita-photo-Dr-Avisa-Asemi-400x400.jpg",
        "_source": {
          "url": "https://emberfertility.com/about/avisa-asemi",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-901-vivian-wei-janio",
        "name": "Vivian Wei Janio",
        "credentials": ["MSN", "RN", "FNP-C"],
        "role": "Nurse Practitioner",
        "imageUrl": "https://emberfertility.com/wp-content/uploads/photo-envita-Vivian-Wei-Janio-400x400.jpg",
        "_source": {
          "url": "https://emberfertility.com/about/medical-staff",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-901-christie-sieve",
        "name": "Christie Sieve",
        "credentials": ["LVN"],
        "role": "Nurse",
        "imageUrl": "https://emberfertility.com/wp-content/uploads/photo-EFC-nurse-Christie-Sieve-400x400.jpg",
        "_source": {
          "url": "https://emberfertility.com/about/medical-staff",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-901-yasemin-beyler",
        "name": "Yasemin Beyler",
        "credentials": ["CCM", "LNC"],
        "role": "Nurse",
        "imageUrl": "https://emberfertility.com/wp-content/uploads/photo-efc-Yasemin-Beyler-400x400.jpg",
        "_source": {
          "url": "https://emberfertility.com/about/medical-staff",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-901-julie-ha",
        "name": "Julie Ha",
        "role": "Andrologist/Clinical Laboratory Scientist (CLS)",
        "imageUrl": "https://emberfertility.com/wp-content/uploads/photo-envita-Julie-Ha-1-400x400.jpg",
        "_source": {
          "url": "https://emberfertility.com/about/medical-staff",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-901-priscilla-gonzalez",
        "name": "Priscilla Gonzalez",
        "credentials": ["MS"],
        "role": "Lab Assistant",
        "imageUrl": "https://emberfertility.com/wp-content/uploads/photo-efc-Priscilla-Gonzalez-400x400.jpg",
        "_source": {
          "url": "https://emberfertility.com/about/medical-staff",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-901-nikki-mashayekhi",
        "name": "Nikki Mashayekhi",
        "credentials": ["PharmD"],
        "role": "Pharmacist",
        "imageUrl": "https://emberfertility.com/wp-content/uploads/photo-envita-Nikki-Mashayekhi-400x400.jpg",
        "_source": {
          "url": "https://emberfertility.com/about/medical-staff",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-901-genevieve-colette",
        "name": "Genevieve Colette",
        "role": "Medical Assistant",
        "imageUrl": "https://emberfertility.com/wp-content/uploads/photo-envita-Genevieve-Colette.jpg",
        "_source": {
          "url": "https://emberfertility.com/about/medical-staff",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-901-samantha-yu",
        "name": "Samantha Yu",
        "role": "Medical Assistant",
        "imageUrl": "https://emberfertility.com/wp-content/uploads/photo-ERC-Samantha-Yu.jpg",
        "_source": {
          "url": "https://emberfertility.com/about/medical-staff",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-901-simone-contreras",
        "name": "Simone Contreras",
        "role": "Surgical Technician",
        "imageUrl": "https://emberfertility.com/wp-content/uploads/photo-envita-Simone-Contreras-400x400.jpg",
        "_source": {
          "url": "https://emberfertility.com/about/medical-staff",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-901-linda-zheng",
        "name": "Linda Zheng",
        "credentials": ["MBA", "MS"],
        "role": "Administrator",
        "imageUrl": "https://emberfertility.com/wp-content/uploads/photo-envita-Linda-Zheng-400x400.jpg",
        "_source": {
          "url": "https://emberfertility.com/about/medical-staff",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-901-sherrie-bement",
        "name": "Sherrie Bement",
        "credentials": ["MBA", "MS"],
        "role": "Patient Coordinator",
        "imageUrl": "https://emberfertility.com/wp-content/uploads/photo-envita-Sherrie-Bement-400x400.jpg",
        "_source": {
          "url": "https://emberfertility.com/about/medical-staff",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-901-becky-yin",
        "name": "Becky Yin",
        "role": "Patient Coordinator",
        "imageUrl": "https://emberfertility.com/wp-content/uploads/photo-envita-Becky-Yin-1-400x400.jpg",
        "_source": {
          "url": "https://emberfertility.com/about/medical-staff",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-901-tsan-acosta",
        "name": "Tsan Acosta",
        "credentials": ["MA"],
        "role": "Patient Coordinator",
        "imageUrl": "https://emberfertility.com/wp-content/uploads/photo-efc-Tsan-Acosta-400x400.jpg",
        "_source": {
          "url": "https://emberfertility.com/about/medical-staff",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-901-joyce-he",
        "name": "Joyce He",
        "credentials": ["MA"],
        "role": "Patient Coordinator",
        "imageUrl": "https://emberfertility.com/wp-content/uploads/photo-EFC-Joyce-He-400x400.jpg",
        "_source": {
          "url": "https://emberfertility.com/about/medical-staff",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-901-savaaih-chang",
        "name": "Savaaih Chang",
        "role": "Patient Coordinator",
        "imageUrl": "https://emberfertility.com/wp-content/uploads/photo-efc-Savaaih-Chang-400x400.jpg",
        "_source": {
          "url": "https://emberfertility.com/about/medical-staff",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://emberfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": ["Horizon"],
      "_source": {
        "url": "https://www.bestprosintown.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["Polish", "English"],
    "images": [
      {
        "url": "https://emberfertility.com/wp-content/uploads/Photo-envita-reception-area-400x267.jpg",
        "type": "interior",
        "caption": "Ember Fertility reception area",
        "_source": {
          "url": "https://emberfertility.com/about/fertility-clinic",
          "fetchedAt": "2026-06-11"
        }
      },
      {
        "url": "https://emberfertility.com/wp-content/uploads/photo-envita-lab-400x267.jpg",
        "type": "lab",
        "caption": "Ember Fertility lab",
        "_source": {
          "url": "https://emberfertility.com/about/fertility-clinic",
          "fetchedAt": "2026-06-11"
        }
      },
      {
        "url": "https://emberfertility.com/wp-content/uploads/photo-envita-beds-400x267.jpg",
        "type": "interior",
        "caption": "Ember Fertility surgical beds",
        "_source": {
          "url": "https://emberfertility.com/about/fertility-clinic",
          "fetchedAt": "2026-06-11"
        }
      },
      {
        "url": "https://emberfertility.com/wp-content/uploads/Photo-envita-lab-equipment-400x267.jpg",
        "type": "lab",
        "caption": "Ember Fertility lab equipment",
        "_source": {
          "url": "https://emberfertility.com/about/fertility-clinic",
          "fetchedAt": "2026-06-11"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmQwVLEuobXUjNAPtYyEXyyzoUeMQH0oofAQdTZTaz_wP8SULtzs06SmF60uA6DGzMA4sR3irYB37DQW-lhf0-NWIAgRbfQES1wxblJFbcADuKMoF_q_sblnMT0k8Fzdh5HPQm4=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Ember+Fertility+Center,+23521+Paseo+De+Valencia+Ste+100,+Laguna+Hills,+CA+92653/@33.6113733,-117.7116333,3323a,13.1y/data=!4m2!3m1!1s0x80dce9e925c1db05:0x29a5794c43f7fed8",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk_EsPpAVKdXRPtvje3KcqpXPnJHQHsZjQN5YWUuAtwhHA2SieYNvLGvAmgFcEMslkZX-0Bobxv5_XQ_fYtVKJtSH5PIwv625fa_tblGC9JCOJUiyyp3T1MUCkw92kokqp3MZ1uGrvx2Rdp=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Ember+Fertility+Center,+23521+Paseo+De+Valencia+Ste+100,+Laguna+Hills,+CA+92653/@33.6113733,-117.7116333,3323a,13.1y/data=!4m2!3m1!1s0x80dce9e925c1db05:0x29a5794c43f7fed8",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "description": "Ember Fertility Center is a state-of-the-art fertility clinic in Laguna Hills, California, that offers patients a boutique VIP experience while delivering high-tech, evidence-based care. Its specialists develop individualized treatment plans, supported by state-of-the-art in vitro fertilization (IVF) and andrology labs, an in-house surgery center, and an AI-assisted time-lapse embryo incubator. The clinic serves all couples and individuals with infertility, those in the LGBTQ+ community, and others who require reproductive assistance to become parents.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Horizon",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.bestprosintown.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-270",
    "externalIds": {
      "cdcClinicId": "270",
      "googlePlaceId": "ChIJlbz-_sc66IARFamYYriIKpY"
    },
    "type": "fertility-clinic",
    "name": "Fertility and Surgical Associates of California",
    "phone": "(805) 778-1122",
    "address": {
      "line1": "225 W. Hillcrest Drive, Suite 201",
      "city": "Thousand Oaks",
      "state": "CA",
      "zip": "91361",
      "country": "US"
    },
    "location": {
      "lat": 34.1748,
      "lng": -118.872
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 52.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 54,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 56.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 71.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 617,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27270%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27270%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilityassociates.com/about/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+%26+Surgical+Associates+of+California+Thousand+Oaks,+225+W+Hillcrest+Dr+Ste+201,+Thousand+Oaks,+CA+91360/@34.1829469,-118.8826213,3301a,13.1y/data=!4m2!3m1!1s0x80e83ac7fefebc95:0x962a88b86298a915",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilityassociates.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-270-gary-hubert-md",
        "name": "Gary Hubert, MD",
        "role": "Co-director for FSAC",
        "imageUrl": "https://www.fertilityassociates.com/wp-content/uploads/2023/10/Dr.-Hubert-lab-coat-scaled-e1710953938115-733x1024.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinologist",
        "_source": {
          "url": "https://www.fertilityassociates.com/about/gary-hubert-md/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-270-amy-dhesi",
        "name": "Amy Dhesi",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinologist",
        "imageUrl": "https://www.fertilityassociates.com/wp-content/uploads/2025/01/FSAC-Amy_Dhesi.png",
        "_source": {
          "url": "https://www.fertilityassociates.com/about/amy-dhesi-md-facog/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-270-holly-mehr",
        "name": "Holly Mehr",
        "credentials": ["MD", "MSEd", "FACOG"],
        "specialty": "Reproductive Endocrinologist",
        "imageUrl": "https://www.fertilityassociates.com/wp-content/uploads/2024/03/FSACHeadshot-DrMehr-1-e1733410674399.jpg",
        "_source": {
          "url": "https://www.fertilityassociates.com/about/holly-mehr-md/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-270-mousa-shamonki",
        "name": "Mousa Shamonki",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinologist",
        "imageUrl": "https://www.fertilityassociates.com/wp-content/uploads/2024/03/DrShamonkiFull-backgroundT-copped-1-726x1024.jpg",
        "_source": {
          "url": "https://www.fertilityassociates.com/about/mousa-shamonki-md/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-270-richard-buyalos",
        "name": "Richard Buyalos",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.fertilityassociates.com/wp-content/uploads/2024/03/Dr.-B.-lab-coat-scaled-e1710954134949-737x1024.jpg",
        "_source": {
          "url": "https://www.fertilityassociates.com/about/richard-buyalos-md/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.fertilityassociates.com",
    "description": "To ensure the highest levels of safety, monitoring, and care, FSAC is partnering with CryoFuture—a trusted leader in long\\-term reproductive tissue storage. Your specimens will be securely maintained in a purpose\\-built facility in El Segundo, CA, under continuous professional oversight. Learn More »",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://www.fertilityassociates.com/wp-content/uploads/2026/06/039-1365-V2-1024x683.jpg",
        "type": "lab",
        "caption": "FSAC embryology laboratory",
        "_source": {
          "url": "https://www.fertilityassociates.com/about/",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://www.fertilityassociates.com/wp-content/uploads/2026/02/Copy-of-003-0823-V2-scaled.jpg",
        "type": "interior",
        "caption": "FSAC Thousand Oaks reception and waiting area",
        "_source": {
          "url": "https://www.fertilityassociates.com/clinic/thousand-oaks-fertility-center/",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://www.fertilityassociates.com/wp-content/uploads/2026/02/Copy-of-030-1064-V3-scaled.jpg",
        "type": "interior",
        "caption": "FSAC Thousand Oaks clinical treatment area",
        "_source": {
          "url": "https://www.fertilityassociates.com/clinic/thousand-oaks-fertility-center/",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://www.fertilityassociates.com/wp-content/uploads/2026/02/thousand-oaks-fc.png",
        "type": "exterior",
        "caption": "FSAC Thousand Oaks facility exterior",
        "_source": {
          "url": "https://www.fertilityassociates.com/clinic/thousand-oaks-fertility-center/",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkFydlThtWnPPfyOXrY5FoZFDi4shEaQR590eCVIZVa3WnvXkqSLXiKn-lru3jW3rfmznYdLyRShdfUca8q5WD41iM9SnXhTEhjksuEpr6vy8VdEI1jLxDSZ23Zgxe7O5iJVF27tgnnZNs=w536-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+%26+Surgical+Associates+of+California+Thousand+Oaks,+225+W+Hillcrest+Dr+Ste+201,+Thousand+Oaks,+CA+91360/@34.1829469,-118.8826213,3301a,13.1y/data=!4m2!3m1!1s0x80e83ac7fefebc95:0x962a88b86298a915",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlrCDMW8ve1QwDe68XELavVHyrmjReoShY5ZPCh_sot4Ibrjtzmv5KJpV315aINv8YPry1BxAphCIwx9FPmM7H_huqbxO1-TH2taRt5BZeFxi88vKv86usLpO0FSkkGKVFW7Q26uOnXnGLU=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+%26+Surgical+Associates+of+California+Thousand+Oaks,+225+W+Hillcrest+Dr+Ste+201,+Thousand+Oaks,+CA+91360/@34.1829469,-118.8826213,3301a,13.1y/data=!4m2!3m1!1s0x80e83ac7fefebc95:0x962a88b86298a915",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-148",
    "externalIds": {
      "cdcClinicId": "148"
    },
    "type": "fertility-clinic",
    "name": "Fertility Care of Orange County",
    "phone": "(714) 256-0777",
    "address": {
      "line1": "203 N. Brea Blvd, Suite 100",
      "city": "Brea",
      "state": "CA",
      "zip": "92821",
      "country": "US"
    },
    "location": {
      "lat": 33.9219,
      "lng": -117.898
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 53.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 44,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 36.84210526315789,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/19"
        }
      ],
      "cyclesPerYear": 145,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27148%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "scraped-retry",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fcare.com",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.fcare.com",
            "fetchedAt": "2026-06-10"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27148%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-148-c-terence-lee",
        "name": "C. Terence Lee",
        "role": "Medical Director",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.fcare.com/who-we-are/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.fcare.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "images": [],
    "description": "Fertility Care of Orange County is a family-owned, single-doctor fertility practice in Brea, California headed by C. Terence Lee, MD, FACOG, and a member of the Ovation Fertility network. The practice has been continuously open since 1997 and has helped in the conception of over 2,900 healthy babies. Dr. Lee completed a fellowship in reproductive endocrinology and infertility at UCLA and Cedars Sinai Medical Center and is the primary lecturer on infertility to medical students at UC Irvine College of Medicine.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-211",
    "externalIds": {
      "cdcClinicId": "211"
    },
    "type": "fertility-clinic",
    "name": "Fertility Center of Southern California",
    "phone": "(949) 955-0072",
    "address": {
      "line1": "4980 Barranca Pkwy, Suite 200",
      "city": "Irvine",
      "state": "CA",
      "zip": "92604",
      "country": "US"
    },
    "location": {
      "lat": 33.6757,
      "lng": -117.794
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 52.94117647058824,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "9/17"
        },
        {
          "ageBand": "35-37",
          "rate": 47.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 52.94117647058824,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "9/17"
        },
        {
          "ageBand": ">40",
          "rate": 39.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 128,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27211%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27211%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitycentersocal.com/our-top-fertility-providers",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfauthority.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-211-ilene-hatch",
        "name": "Ilene Hatch",
        "role": "Medical Director",
        "imageUrl": "https://cdn.prod.website-files.com/652f2fd32d451a42f031dae7/6530a2af153c23a5d5d6fe67_Dr.-Hatch.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.fertilitycentersocal.com/providers/dr-hatch",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-211-julie-gordon",
        "name": "Julie Gordon",
        "credentials": ["PA-C", "MPAS"],
        "role": "Physician Assistant",
        "imageUrl": "https://cdn.prod.website-files.com/652f2fd32d451a42f031dae7/67a4605f8870c3a3caa41a0c_Julie%201024x576.jpg",
        "_source": {
          "url": "https://www.fertilitycentersocal.com/providers/dr-gordon",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-211-andrea-shandling",
        "name": "Andrea Shandling",
        "credentials": ["PA-C", "MPH", "CPH"],
        "imageUrl": "https://cdn.prod.website-files.com/652f2fd32d451a42f031dae7/6530a32d7ad8a49184c2f1bc_Andrea-Shandling.jpg",
        "_source": {
          "url": "https://www.fertilitycentersocal.com/providers/andrea-shandling",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.fertilitycentersocal.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross",
        "Blue Shield",
        "Cigna",
        "United Healthcare",
        "EmblemHealth",
        "BCBS",
        "Medicaid"
      ],
      "_source": {
        "url": "https://www.ivfauthority.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "description": "At Fertility Center of Southern California, the team strives to treat every person as an individual and takes a holistic approach to the art and science of fertility treatments, educating patients about their diagnosis, treatment, and finances as they navigate the fertility process. The practice is open 7 days a week and individually tailors the treatment process to each patient to maximize the chances of a successful pregnancy.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross, Blue Shield, Cigna, United Healthcare, EmblemHealth, BCBS, Medicaid",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.ivfauthority.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-271",
    "externalIds": {
      "cdcClinicId": "271",
      "googlePlaceId": "ChIJVXw8p57e3IAR1Qr7IKq2hZA"
    },
    "type": "fertility-clinic",
    "name": "Fertility Centers of Orange County",
    "phone": "(949) 387-3888",
    "address": {
      "line1": "17875 Von Karman Ave, Suite 480",
      "city": "Irvine",
      "state": "CA",
      "zip": "92614",
      "country": "US"
    },
    "location": {
      "lat": 40.7637,
      "lng": -73.9735
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 53.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 51.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 61.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 41.66666666666667,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/12"
        }
      ],
      "cyclesPerYear": 364,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27271%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27271%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://fertilitycentersoc.com",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+Orange+County,+17875+Von+Karman+Ave+%23480,+Irvine,+CA+92614/@33.686282,-117.8472948,3320a,13.1y/data=!4m2!3m1!1s0x80dcde9ea73c7c55:0x9085b6aa20fb0ad5",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfcenter.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-271-wayne-lin-md",
        "name": "Wayne Lin, MD",
        "role": "Medical Director",
        "imageUrl": "https://a.storyblok.com/f/290132/600x898/1299a7d72b/dr-wayne-lin.jpg",
        "credentials": ["MD", "MPH"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://fertilitycentersoc.com/doctors/dr-wayne-lin",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-271-amy-kaing",
        "name": "Amy Kaing",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/600x898/27375acb30/dr-amy-kaing-1.jpg",
        "_source": {
          "url": "https://fertilitycentersoc.com/doctors/dr-amy-kaing",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-271-bill-yee",
        "name": "Bill Yee",
        "role": "Lab Director",
        "_source": {
          "url": "https://fertilitycentersoc.com/about",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-271-denise-cassidenti",
        "name": "Denise Cassidenti",
        "role": "Program Director",
        "specialty": "Reproductive Endocrinology",
        "_source": {
          "url": "https://fertilitycentersoc.com/about",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://fertilitycentersoc.com",
    "languages": ["English"],
    "network": {
      "name": "Ivy Fertility"
    },
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "description": "Fertility Centers of Orange County is a full-service fertility center in Irvine, California that has been creating families for more than 35 years, offering IVF, IUI, egg freezing, genetic testing, egg donor services, and surrogacy. The clinic is affiliated with Reproductive Partners Medical Group, with monitoring-only offices in Beverly Hills, South Bay, and Long Beach, and joined the Ivy Fertility network in 2021. Its lab is accredited by the College of American Pathologists and has been for over 30 years.",
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmf1PPLPRckDnnmXlTFsEFusAjhq2kfHS7MIWJTxlNXZusM5A2O_9veZZuTmcSpw5yj2bhrJAMbmBj9ZH6hBTkKIeLbOLpRF6WTlIAe88_xwjw_yzPUFR82Xd91z5wRud_UFxIFrfwr7S0m=w360-h480-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+Orange+County,+17875+Von+Karman+Ave+%23480,+Irvine,+CA+92614/@33.686282,-117.8472948,3320a,13.1y/data=!4m2!3m1!1s0x80dcde9ea73c7c55:0x9085b6aa20fb0ad5",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-13",
    "externalIds": {
      "cdcClinicId": "13",
      "googlePlaceId": "ChIJW3fgOOD_24AR7Yv8Bp43dF4"
    },
    "type": "fertility-clinic",
    "name": "Fertility Specialists Medical Group",
    "phone": "(858) 505-5500",
    "address": {
      "line1": "8010 Frost St, Suite P",
      "city": "San Diego",
      "state": "CA",
      "zip": "92123",
      "country": "US"
    },
    "location": {
      "lat": 32.8015,
      "lng": -117.152
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 45.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 31.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 29.411764705882355,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/17"
        }
      ],
      "cyclesPerYear": 174,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2713%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2713%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://ivfspecialists.com",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Specialists+Medical+Group,+8010+Frost+St+Ste+p,+San+Diego,+CA+92123/@32.801522,-117.151935,3354a,13.1y/data=!4m2!3m1!1s0x80dbffe038e0775b:0x5e74379e06fc8bed",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.fsmg.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-13-wendy-b-shelly-md",
        "name": "Wendy B. Shelly, MD",
        "role": "Medical Director",
        "imageUrl": "https://ivfspecialists.com/wp-content/uploads/2023/10/Dr-Shelly.jpg",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology, Obstetrics & Gynecology",
        "_source": {
          "url": "https://ivfspecialists.com/about-fertility-specialists-medical-group/fertility-doctors/wendy-shelly/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-13-arlene-j-morales",
        "name": "Arlene J. Morales",
        "credentials": ["MD", "FACOG"],
        "role": "Founder",
        "specialty": "Reproductive Endocrinology, Obstetrics & Gynecology",
        "imageUrl": "https://ivfspecialists.com/wp-content/uploads/2023/10/Dr.-Morales.jpg",
        "_source": {
          "url": "https://ivfspecialists.com/about-fertility-specialists-medical-group/fertility-doctors/arlene-morales/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-13-alexa-medica",
        "name": "Alexa Medica",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology, Obstetrics & Gynecology",
        "imageUrl": "https://ivfspecialists.com/wp-content/uploads/2023/10/Dr-Medika.jpg",
        "_source": {
          "url": "https://ivfspecialists.com/about-fertility-specialists-medical-group/fertility-doctors/alexa-medica-md-facog/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-13-colleen-p-mcnally",
        "name": "Colleen P. McNally",
        "credentials": ["MD", "FACOG"],
        "specialty": "Obstetrics & Gynecology",
        "imageUrl": "https://ivfspecialists.com/wp-content/uploads/2021/06/Screen_Shot_2021-05-19_at_8.18.58_AM-374x374.png",
        "_source": {
          "url": "https://ivfspecialists.com/about-fertility-specialists-medical-group/fertility-doctors/colleen-mcnally/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-13-joe-conaghan",
        "name": "Joe Conaghan",
        "credentials": ["PhD"],
        "role": "Lab Director",
        "_source": {
          "url": "https://ivfspecialists.com/about-fertility-specialists-medical-group/fertility-support-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-13-kathryn-pache",
        "name": "Kathryn Pache",
        "credentials": ["MSc"],
        "role": "Lab Supervisor",
        "_source": {
          "url": "https://ivfspecialists.com/about-fertility-specialists-medical-group/fertility-support-team/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://ivfspecialists.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "images": [
      {
        "url": "https://ivfspecialists.com/wp-content/uploads/2020/05/Untitled-design-8.jpg",
        "type": "exterior"
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmAtPnsJu7O-pJZMH800ll11XZzI1WJlNcawu7DhpSwiRJyqjlzUC5U6IRDr5PGtthgTVzU-0ZlDT8y3qGlEJcCmS8Ld5gcoz6Mb-v79z4PWKBv_4Bswzs6EMbxyloannKpy5B-BA=w224-h298-k-no-pi-0-ya132.4132-ro0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Specialists+Medical+Group,+8010+Frost+St+Ste+p,+San+Diego,+CA+92123/@32.801522,-117.151935,3354a,13.1y/data=!4m2!3m1!1s0x80dbffe038e0775b:0x5e74379e06fc8bed",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmqZlKQUXPVEw6gNLD83v8E9vBn9LKZm3LPFeN97N99H6Easb8yRpyXGF0ORWqybJWcpENXcUpv0rvAxMJM-9GUozXeaqFPXfTzignHzaP-I1edTEoEMGkUJk3lrHXPPzsXrSZdfw=w253-h120-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Specialists+Medical+Group,+8010+Frost+St+Ste+p,+San+Diego,+CA+92123/@32.801522,-117.151935,3354a,13.1y/data=!4m2!3m1!1s0x80dbffe038e0775b:0x5e74379e06fc8bed",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "description": "Fertility Specialists Medical Group (FSMG) is a San Diego fertility practice founded in 2000 by Arlene J. Morales, MD, with clinic locations in San Diego and Carlsbad, a fully accredited in-house surgery center, and a state-of-the-art IVF and andrology lab. Its all-female physician team provides individualized care spanning IVF, IUI, fertility preservation, donation and surrogacy, and LGBTQIA+ and single-parent family building. The practice has been named a Top Doc practice by San Diego Magazine five years in a row and an Optum Healthcare Center of Excellence for six consecutive years.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-832",
    "externalIds": {
      "cdcClinicId": "832",
      "googlePlaceId": "ChIJ6zi00isH3IARrstArZhMqBs"
    },
    "type": "fertility-clinic",
    "name": "Gen 5 Fertility Center",
    "phone": "(858) 267-4365",
    "address": {
      "line1": "3420 Carmel Mountain Rd, Suite 200",
      "city": "San Diego",
      "state": "CA",
      "zip": "92121",
      "country": "US"
    },
    "location": {
      "lat": 32.9195,
      "lng": -117.238
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      },
      {
        "name": "miniIVF",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [],
      "cyclesPerYear": 310,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27832%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27832%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://gen5fertility.com/providers-team/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Gen+5+Fertility+Center,+3420+Carmel+Mountain+Rd+Ste+200,+San+Diego,+CA+92121/@32.9195489,-117.2382864,3349a,13.1y/data=!4m2!3m1!1s0x80dc072bd2b438eb:0x1ba84c98ad40cbae",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://gen5fertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-832-samuel-wood",
        "name": "Samuel Wood",
        "role": "Medical Director",
        "imageUrl": "https://gen5fertility.com/wp-content/uploads/2025/12/Samuel_Wood-1024x1024.webp",
        "credentials": ["MD", "PhD", "MA", "MBA", "HCLD/CC(ABB)", "FACOG"],
        "_source": {
          "url": "https://gen5fertility.com/providers-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-832-benito-villanueva",
        "name": "Benito Villanueva",
        "credentials": ["MD", "FACOG"],
        "role": "Fertility Specialist",
        "imageUrl": "https://gen5fertility.com/wp-content/uploads/2025/12/Benito_Villanueva.webp",
        "_source": {
          "url": "https://gen5fertility.com/providers-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-832-martin-bastuba",
        "name": "Martin Bastuba",
        "credentials": ["MD", "FACS"],
        "role": "Director of Male Fertility Services",
        "specialty": "Male fertility specialist",
        "imageUrl": "https://gen5fertility.com/wp-content/uploads/2025/12/Martin_Bastuba.webp",
        "_source": {
          "url": "https://gen5fertility.com/martin-bastuba/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-832-catharine-adams",
        "name": "Catharine Adams",
        "credentials": ["PhD", "HCLD(ABB)"],
        "role": "IVF Laboratory Director",
        "imageUrl": "https://gen5fertility.com/wp-content/uploads/2025/12/Catharine_Adams.webp",
        "_source": {
          "url": "https://gen5fertility.com/providers-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-832-molly-chen-chu",
        "name": "Molly Chen-Chu",
        "credentials": ["MS", "MHA", "TS (ABB)"],
        "role": "Assistant IVF Laboratory Director",
        "imageUrl": "https://gen5fertility.com/wp-content/uploads/2025/12/Molly_Chen-Chu.webp",
        "_source": {
          "url": "https://gen5fertility.com/providers-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-832-khadija-damji",
        "name": "Khadija Damji",
        "credentials": ["BScN", "RN", "MSN", "FNP-C"],
        "role": "Nurse Practitioner",
        "imageUrl": "https://gen5fertility.com/wp-content/uploads/2025/12/Khadija_Damji.webp",
        "_source": {
          "url": "https://gen5fertility.com/khadija-damji/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://gen5fertility.com",
    "description": "We started Gen 5 Fertility because we wanted to address the problems we had seen in infertility care over many years. There were too many fertility processes that were more difficult than they should be. We saw too many practices that reduced a patient’s chance of becoming pregnant. The goal of the clinical, laboratory, and fertility specialists at the Gen 5 San Diego Fertility Center is simple:",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl7lLcbHpBZZ_xvJXl72E-zgsNfXOCJYY78GKjZyYFuBAlCDsX_hfZbntJe9YRwcNRAfNrZIe_j7cT9xXwZ__NrmLL4nZj3yhLQr3c7sFLN0yV8mmNmJQgPnxDhYTCHMaWVoRgH-A=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Gen+5+Fertility+Center,+3420+Carmel+Mountain+Rd+Ste+200,+San+Diego,+CA+92121/@32.9195489,-117.2382864,3349a,13.1y/data=!4m2!3m1!1s0x80dc072bd2b438eb:0x1ba84c98ad40cbae",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-616",
    "externalIds": {
      "cdcClinicId": "616",
      "googlePlaceId": "ChIJibVWcxkH3IARwnECih-q5Zs"
    },
    "type": "fertility-clinic",
    "name": "Hanabusa IVF",
    "phone": "(858) 480-5400",
    "address": {
      "line1": "4910 Directors Pl, Suite 150",
      "city": "San Diego",
      "state": "CA",
      "zip": "92121",
      "country": "US"
    },
    "location": {
      "lat": 32.8946,
      "lng": -117.212
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      },
      {
        "name": "miniIVF",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 49,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27616%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27616%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.hanabusaivf.com/about",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Hanabusa+IVF,+4910+Directors+Pl+Unit+150,+San+Diego,+CA+92121/@32.8945715,-117.212072,3350a,13.1y/data=!4m2!3m1!1s0x80dc07197356b589:0x9be5aa1f8a0271c2",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.hanabusaivf.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-616-lyndon-chang-md",
        "name": "Lyndon Chang, MD",
        "role": "Medical Director",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/695ff01b0e8b2f2d71be0de8_Dr%20Lyndon%20Chang.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.hanabusaivf.com/team-members/lyndon-chang-md-facog",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-diana-leblanc",
        "name": "Diana LeBlanc",
        "credentials": ["MD", "FACOG"],
        "role": "Physician and Fertility Specialist",
        "specialty": "Endometriosis & Ovarian Rejuvenation",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/699b51e12aea09bf1ade882b_JPEG%20image.jpeg",
        "_source": {
          "url": "https://www.hanabusaivf.com/team-members/diana-leblanc-md-facog",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-disha-mistri",
        "name": "Disha Mistri",
        "credentials": ["MSN", "NP"],
        "role": "Nurse Practitioner",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/69692d73fe14f0915c5432a8_Disha%20Mistri%2C%20MSN%2C%20NP.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-care-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-diana-duguet",
        "name": "Diana Duguet",
        "role": "Patient Experience Coordinator",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/696932ffc0a25bf8183a1180_Diana-AEBHanabusa-543.jpg.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-care-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-kayla-aceves",
        "name": "Kayla Aceves",
        "role": "Patient Experience Coordinator",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/69e91b4ba4c2d9a765b76746_Kayla%20Aceves%20%20Zdralo%20%20Registered%20Nurse.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-care-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-macie-jenkins",
        "name": "Macie Jenkins",
        "role": "Client Services Coordinator",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/696932b3cfcc50e06c126be7_Macie-AEBHanabusa-681.jpg.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-care-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-cristina-torres",
        "name": "Cristina Torres",
        "role": "Client Services Coordinator",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/69b1bc1961ceb1aef29add0a_IMG_2128.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-care-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-ai",
        "name": "Ai",
        "credentials": ["RN"],
        "role": "Registered Nurse",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/6969327726fc3fd6da4464d5_Ai-AEBHanabusa-926.png.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-care-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-heizl-irwin",
        "name": "Heizl Irwin",
        "credentials": ["RN"],
        "role": "Registered Nurse",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/696933d4ab02a50b0b86dc53_Heizl.png.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-care-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-suzy-stulir",
        "name": "Suzy Stulir",
        "credentials": ["RN"],
        "role": "Registered Nurse",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/696933b9d004c3e8644fb86e_Suzy-AEBHanabusa-746.jpg.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-care-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-andrea",
        "name": "Andrea",
        "credentials": ["RN"],
        "role": "Registered Nurse",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/69693290fd465dd9685a2b4d_Andrea%20W-AEBHanabusa-487.jpg.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-care-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-elizabeth-zdralo",
        "name": "Elizabeth Zdralo",
        "role": "Registered Nurse",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/69a08bed792b3c137dfc7a55_Elizabeth%20Zdralo%20-2.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-care-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-daphne-z",
        "name": "Daphne Z.",
        "credentials": ["RN"],
        "role": "3rd Party Lead",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-care-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-savannah",
        "name": "Savannah",
        "credentials": ["LVN"],
        "role": "IVF Coordinator",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/696933414846fc03945e7ddc_Savannah-AEBHanabusa-960.jpg.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-care-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-kayla-meeks",
        "name": "Kayla Meeks",
        "role": "IVF Coordinator",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/69693328e8ff8cfc16f9c775_Kayla-AEBHanabusa-813.jpg.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-care-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-kat-calver",
        "name": "Kat Calver",
        "role": "IVF Coordinator",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/6980eb67245cb949b43c5fab_Kat%20Calver%20IVF%20Coordinator.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-care-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-chenwen-qian",
        "name": "Chenwen Qian",
        "role": "International Coordinator",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/69834b573cf36cbd9b9ca526_Chenwen%20Qian%20International%20Coordinator%20.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-care-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-katelin-tan",
        "name": "Katelin Tan",
        "role": "Third Party Coordinator",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/69b1baf7f7c820b009ceb4ae_IMG_2101.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-care-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-qi-veal",
        "name": "Qi Veal",
        "role": "3rd Party Coordinator",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/69e91c8ce1aae36304c6c2fc_Qi%20Veal%20Zdralo%20%20Registered%20Nurse.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-care-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-kelly-rong",
        "name": "Kelly Rong",
        "role": "Third Party Coordinator",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/69eff019eb187ed5bf88154b_Kelly%20Rong%20Third%20party%20Coordinator%20.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-care-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-yukiko-makiuchi",
        "name": "Yukiko Makiuchi",
        "credentials": ["MA"],
        "role": "Medical Assistant",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/696941c15adb2d5819bf3232_YUKIKIAEBHanabusa-572.jpeg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-care-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-tiffany-hooper",
        "name": "Tiffany Hooper",
        "role": "OR Coordinator",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/6969339d38b3cc06df3e9567_Tiffany-AEBHanabusa-869.jpg.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-care-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-linda-orozco",
        "name": "Linda Orozco",
        "role": "Medical Assistant",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/696e8122d1904d4994de0161_Linda.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-care-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-jacey-hu",
        "name": "Jacey Hu",
        "role": "Medical Assistant",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/6980ec98094b7846c3d1184b_Jacey%20Hu-%20Medical%20Assistant.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-care-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-malally-f",
        "name": "Malally F.",
        "role": "Sonographer",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-care-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-lisa-nelson",
        "name": "Lisa Nelson",
        "credentials": ["M.Sc.", "ELD (ABB)", "EMB (ACE)", "CRB (CDPH)"],
        "role": "Embryology Laboratory Director",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/69693fc14288233a171224a2_Lisa%20Nelson.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-laboratory-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-monica-velasco",
        "name": "Monica Velasco",
        "credentials": ["TS (ABB)", "CLS (RB)"],
        "role": "Senior Embryologist & Lab Supervisor",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/6969343a0118d6cb225af31b_Monica-AEBHanabusa-608.png.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-laboratory-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-jade-yoho",
        "name": "Jade Yoho",
        "credentials": ["MS"],
        "role": "Embryologist",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/6969413f0beaa217b33c5f29_JADEAEBHanabusa-814%20copy.jpeg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-laboratory-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-francia-salas",
        "name": "Francia Salas",
        "role": "Senior Embryologist",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/6969340ab7d37d0e16382309_Francia-AEBHanabusa-971.png.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-laboratory-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-a-k",
        "name": "A.K.",
        "role": "Senior Embryologist",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/69693fa387bd334aaee1a962_A.K.%20Nelson.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-laboratory-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-adiana-dominguez",
        "name": "Adiana Dominguez",
        "role": "Laboratory Assistant",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/6980eb44ad33e2aababac36a_adiana.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/our-laboratory-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-peter-fuzesi",
        "name": "Peter Fuzesi",
        "role": "Chief Executive Officer",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/6a2866cf5b7eda8cd16a07d4_Peter-Fuzesi.jpeg",
        "_source": {
          "url": "https://www.hanabusaivf.com/management-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-effie-zhang",
        "name": "Effie Zhang",
        "role": "Financial Director",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/6969667731a3710d55f5ce6b_Effie%20Zhang.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/management-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-karen-lopez",
        "name": "Karen Lopez",
        "role": "Practice Manager",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/6969630492443f75edcc9e90_Karen-AEBHanabusa-520.jpg.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/management-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-616-brandie-umar",
        "name": "Brandie Umar",
        "role": "Marketing Director",
        "imageUrl": "https://cdn.prod.website-files.com/6931a8a2fa24f2b8887bfc00/69696325fa6f7ba585ed219c_Brandie.jpg",
        "_source": {
          "url": "https://www.hanabusaivf.com/management-team",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.hanabusaivf.com",
    "insurance": {
      "accepted": true,
      "carriers": ["Aetna", "UnitedHealthcare", "Horizon"],
      "_source": {
        "url": "https://www.hanabusaivf.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["Japanese", "English"],
    "description": "Hanabusa IVF is a private fertility clinic in San Diego, California, known for success with both complex fertility cases and patients who are just getting started. The clinic does not use a one-protocol approach; each plan is built around the patient's biology and goals, using Japanese-inspired mild and gentle stimulation IVF that focuses on egg quality over egg quantity. With more than ten years of vitrification focus, Hanabusa IVF is the dedicated lab for Asian Egg Bank and a trusted global shipper of eggs and embryos.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, UnitedHealthcare, Horizon",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.hanabusaivf.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn3DFeTYn4yAKfNXHkNS4EmrpklJJomuq2cU6VtWTa8MwYT8d3SLg3fJKFU7mA9MbWBt2I4Q3IHoQsgk68HAjtTxK8fenaaH3Iu3FikBnLqFHF0n7sHSmB4HYgLxVfN1uIF_uA=w360-h251-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Hanabusa+IVF,+4910+Directors+Pl+Unit+150,+San+Diego,+CA+92121/@32.8945715,-117.212072,3350a,13.1y/data=!4m2!3m1!1s0x80dc07197356b589:0x9be5aa1f8a0271c2",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-847",
    "externalIds": {
      "cdcClinicId": "847",
      "googlePlaceId": "ChIJM-KbGTXbwoARX2wKRu8NjBo"
    },
    "type": "fertility-clinic",
    "name": "Harvest Fertility",
    "phone": "(626) 538-4838",
    "address": {
      "line1": "125 W. Huntington Dr, Bldg B, 3rd Floor",
      "city": "Arcadia",
      "state": "CA",
      "zip": "91006",
      "country": "US"
    },
    "location": {
      "lat": 34.139,
      "lng": -118.0385
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 0,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27847%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27847%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://harvestfertility.com/about-us-best-fertility",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Harvest+Fertility+(Harvest+IVF),+Third+floor,+125+W+Huntington+Dr+Bldg+B,+Arcadia,+CA+91007/@34.1410047,-118.0378202,3302a,13.1y/data=!4m2!3m1!1s0x80c2db35199be233:0x1a8c0def460a6c5f",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://harvestfertility.setmore.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-847-kathleen-kornafel-md-phd",
        "name": "Kathleen Kornafel, MD, PHD",
        "role": "Medical Director",
        "imageUrl": "https://harvestfertility.com/wp-content/uploads/2025/03/1-1-Frame.png",
        "_source": {
          "url": "https://harvestfertility.com/top-fertility-specialists-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-847-ping-xia",
        "name": "Ping Xia",
        "role": "Scientific Lab Director",
        "imageUrl": "https://harvestfertility.com/wp-content/uploads/2025/03/123.png",
        "_source": {
          "url": "https://harvestfertility.com/top-fertility-specialists-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-847-tuong-vando-pham",
        "name": "Tuong VanDo Pham",
        "role": "Senior Embryologist",
        "imageUrl": "https://harvestfertility.com/wp-content/uploads/2025/03/12.png",
        "_source": {
          "url": "https://harvestfertility.com/top-fertility-specialists-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-847-emi-sakamoto",
        "name": "Emi Sakamoto",
        "credentials": ["RN"],
        "role": "Patient Care Coordinator",
        "imageUrl": "https://harvestfertility.com/wp-content/uploads/2025/03/1234.png",
        "_source": {
          "url": "https://harvestfertility.com/top-fertility-specialists-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-847-jane-almazar",
        "name": "Jane Almazar",
        "role": "Business Office Coordinator",
        "imageUrl": "https://harvestfertility.com/wp-content/uploads/2025/03/12345.png",
        "_source": {
          "url": "https://harvestfertility.com/top-fertility-specialists-team",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://harvestfertility.com",
    "languages": ["English"],
    "images": [
      {
        "url": "https://harvestfertility.com/wp-content/uploads/2023/06/DSC06840-Edit-1536x1024-1.jpg",
        "type": "interior",
        "_source": {
          "url": "https://harvestfertility.com/about-us-best-fertility",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "url": "https://harvestfertility.com/wp-content/uploads/2023/06/DSC06861-Edit-1536x1025-1-e1743055379279.jpg",
        "type": "interior",
        "_source": {
          "url": "https://harvestfertility.com/about-us-best-fertility",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkBxDtQPA4U_xOsi0p6hLDp3a5oaFtSdbgFho8_onFasAUpdTk2WRTs3UDdtlOGhAZDh88NAgTz6LWfCmDYI5MYEC29dWeAbPtkeA6W5Sa62MQJZzjsAuEG9Cv7FE10Wc-jZm-R5w=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Harvest+Fertility+(Harvest+IVF),+Third+floor,+125+W+Huntington+Dr+Bldg+B,+Arcadia,+CA+91007/@34.1410047,-118.0378202,3302a,13.1y/data=!4m2!3m1!1s0x80c2db35199be233:0x1a8c0def460a6c5f",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "description": "Harvest Fertility believes healthcare begins with providing the highest, best fertility care to patients along with ensuring the utmost safety. All of its first-rate IVF and assisted reproductive technology (ART) medical services are specially customized for each individual patient. Its state-of-the-art, all-in-one fertility institute is located across from the Santa Anita race track in Arcadia, surrounded by views of the San Gabriel Mountains.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-477",
    "externalIds": {
      "cdcClinicId": "477",
      "googlePlaceId": "ChIJna65NXvDwoARz9-CQ-xxXB4"
    },
    "type": "fertility-clinic",
    "name": "HRC Fertility-Pasadena",
    "description": "Southern California's pioneering fertility network since 1988, part of Jinxin Fertility Group, offering comprehensive IVF, third-party reproduction, and oncofertility services.",
    "website": "https://www.havingbabies.com/locations/pasadena/",
    "phone": "(626) 440-9161",
    "email": "publicrelations@havingbabies.com",
    "bookingUrl": "https://www.havingbabies.com/appointments/",
    "address": {
      "line1": "55 S. Lake Ave, 9th Floor",
      "city": "Pasadena",
      "state": "CA",
      "zip": "91101",
      "country": "US"
    },
    "location": {
      "lat": 34.1449,
      "lng": -118.133
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "financingOptions": [
        "Payment plans",
        "Loans",
        "Package pricing",
        "CapexMD",
        "Future Family",
        "PatientFi"
      ],
      "carriers": [
        "Aetna",
        "Anthem Blue Cross",
        "Blue Cross",
        "Blue Shield of California",
        "Cigna Healthcare",
        "United Healthcare",
        "Humana",
        "Health Net",
        "Kaiser Permanente",
        "Multiplan",
        "Tricare",
        "Optum"
      ],
      "employeeBenefits": [
        "Progyny",
        "Carrot",
        "Maven",
        "WINFertility",
        "Future Family"
      ],
      "_source": {
        "url": "https://www.havingbabies.com/locations/pasadena/",
        "fetchedAt": "2026-03-11"
      }
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 52.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 52,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 51.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 36.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 2279,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27477%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "languages": ["English", "es", "zh", "ru"],
    "consultationTypes": ["in-person", "telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27477%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "scraped"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/locations/pasadena/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/HRC+Fertility,+55+S+Lake+Ave+9th+Floor,+Pasadena,+CA+91101/@34.1450314,-118.1326483,3302a,13.1y/data=!4m2!3m1!1s0x80c2c37b35b9ae9d:0x1e5c71ec4382dfcf",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/locations/pasadena/",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-477-john-g-wilcox-md",
        "name": "John G. Wilcox, MD",
        "role": "Medical Director",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/07/Dr-Wilcox-2024-360X480.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.havingbabies.com/locations/pasadena/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-477-mabel-lee",
        "name": "Mabel Lee",
        "credentials": ["MD", "FACOG"],
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2025/01/Dr-Lee-Headshot-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/pasadena/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-477-bradford-a-kolb",
        "name": "Bradford A. Kolb",
        "credentials": ["MD", "FACOG"],
        "role": "Board Certified Reproductive Endocrinologist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/07/Dr-Kolb-2024-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/pasadena/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-477-sharron-l-manuel",
        "name": "Sharrón L. Manuel",
        "credentials": ["MD", "PhD", "FACOG"],
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2025/06/Dr-Manuel-11-25-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/pasadena/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-477-botros-rizk",
        "name": "Botros Rizk",
        "credentials": ["MD", "FACOG"],
        "role": "Board Certified Reproductive Endocrinologist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2025/06/dr-rizk-headshot-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/pasadena/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-477-katherine-e-mcdaniel",
        "name": "Katherine E. McDaniel",
        "credentials": ["MD", "FACOG"],
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/07/Dr-McDaniel-2024-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/pasadena/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-477-john-m-norian",
        "name": "John M. Norian",
        "credentials": ["MD", "FACOG"],
        "role": "Board Certified Reproductive Endocrinologist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/07/Dr-Norian-2024-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/pasadena/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-477-richard-j-paulson",
        "name": "Richard J. Paulson",
        "credentials": ["MD", "FACOG"],
        "role": "Board Certified Reproductive Endocrinologist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2021/06/Dr-Richard-Paulson-2024-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/pasadena/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-477-molly-quinn",
        "name": "Molly Quinn",
        "credentials": ["MD", "FACOG"],
        "role": "Board Certified Reproductive Endocrinologist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/07/Dr-Quinn-2024-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/pasadena/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-477-natalia-c-llarena",
        "name": "Natalia C. Llarena",
        "credentials": ["MD", "FACOG"],
        "role": "Board Certified OB/GYN and Reproductive Endocrinologist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/07/Dr-llarena-2024-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/pasadena/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-477-jacqueline-carla-yano-maher",
        "name": "Jacqueline Carla Yano Maher",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2026/04/dr-jacqueline-yano-maher-360X480.webp",
        "_source": {
          "url": "https://www.havingbabies.com/locations/pasadena/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [
      {
        "url": "https://www.havingbabies.com/wp-content/uploads/2020/10/55Lake-ext-300x188.png",
        "type": "exterior",
        "_source": {
          "url": "https://www.havingbabies.com/locations/pasadena/",
          "fetchedAt": "2026-03-11"
        },
        "caption": "HRC Fertility Pasadena exterior"
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmnSCOC2Hj_47bRPFI0Czyn1r4efJmjj7e0NWnEYW9zTd72mFjM9qGwmgkRmUC7LBgjB7MSo52FQhGZW_R6T6ceBZl-VdL-W3uxPKofHUsH9jrLROADAwS6jfiuA5FypLmZTSUy=w525-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/HRC+Fertility,+55+S+Lake+Ave+9th+Floor,+Pasadena,+CA+91101/@34.1450314,-118.1326483,3302a,13.1y/data=!4m2!3m1!1s0x80c2c37b35b9ae9d:0x1e5c71ec4382dfcf",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkJ2TFGZ3F_Uv2SgwAw4LtNELBJvrK_TkP-GfiJ0lbt0fPHovKxTPOVOXqMc82i6lBCKlwVssQd2y9L8yAxQv9QVlB1xf396BeajJaB7EbzSmU0p7gnVnSxhWUUq0-A6_S_tF3aZg=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/HRC+Fertility,+55+S+Lake+Ave+9th+Floor,+Pasadena,+CA+91101/@34.1450314,-118.1326483,3302a,13.1y/data=!4m2!3m1!1s0x80c2c37b35b9ae9d:0x1e5c71ec4382dfcf",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk24J5UO17SIHVBbmr01Dgi6gI6Pv2LNSMRyxBwtbt-CLNyUNHf503sa27o8UMmEtpvLgHHazWL28DkqUnt2KMGhaaVT0Bsbx5HrHhPHSpzL-16OpRrY34QPsD2Qn8RXkPbhR9Y=w224-h298-k-no-pi0-ya272.44678-ro-0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/HRC+Fertility,+55+S+Lake+Ave+9th+Floor,+Pasadena,+CA+91101/@34.1450314,-118.1326483,3302a,13.1y/data=!4m2!3m1!1s0x80c2c37b35b9ae9d:0x1e5c71ec4382dfcf",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross, Blue Cross, Blue Shield of California, Cigna Healthcare, United Healthcare, Humana, Health Net",
              "detail": "4 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.havingbabies.com/locations/pasadena/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-942",
    "externalIds": {
      "cdcClinicId": "942",
      "googlePlaceId": "ChIJ1Q0R9s5L3YAR2LG-vpRTpiE"
    },
    "type": "fertility-clinic",
    "name": "Incinta Fertility Center",
    "phone": "(424) 212-4087",
    "address": {
      "line1": "21545 Hawthorne Blvd",
      "city": "Torrance",
      "state": "CA",
      "zip": "90503",
      "country": "US"
    },
    "location": {
      "lat": 33.8284,
      "lng": -118.3489
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 26,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27942%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27942%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://incintafertility.com/fertility-team/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Incinta+Fertility+Center,+21545+Hawthorne+Blvd+Pavilion+B,+Torrance,+CA+90503/@33.8324084,-118.3530858,3314a,13.1y/data=!4m2!3m1!1s0x80dd4bcef6110dd5:0x21a65394bebeb1d8",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://incintafertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-942-james-lin-md",
        "name": "James Lin, MD",
        "role": "Medical Director",
        "imageUrl": "https://incintafertility.com/wordpress/wp-content/uploads/2023/03/lin.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://incintafertility.com/fertility-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-942-zitao-liu",
        "name": "Zitao Liu",
        "credentials": ["MD", "PhD", "FACOG"],
        "role": "Associate Chief Medical Officer",
        "imageUrl": "https://incintafertility.com/wordpress/wp-content/uploads/2026/03/Dr.-Liu-Circle.png",
        "_source": {
          "url": "https://incintafertility.com/fertility-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-942-yufen-xie",
        "name": "Yufen Xie",
        "credentials": ["PhD", "ELD (ABB)", "HCLD (ABB)"],
        "role": "IVF Laboratory Director",
        "imageUrl": "https://incintafertility.com/wordpress/wp-content/uploads/2024/10/Dr.-Xie-Web-1024-.png",
        "_source": {
          "url": "https://incintafertility.com/fertility-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-942-hyang-hailey-park",
        "name": "Hyang (Hailey) Park",
        "credentials": ["MS"],
        "role": "IVF Laboratory Supervisor",
        "imageUrl": "https://incintafertility.com/wordpress/wp-content/uploads/2024/10/Hailey-1024.png",
        "_source": {
          "url": "https://incintafertility.com/fertility-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-942-lily-hao",
        "name": "Lily Hao",
        "credentials": ["MSN", "WHNP"],
        "role": "Nurse Manager",
        "imageUrl": "https://incintafertility.com/wordpress/wp-content/uploads/2024/10/Lily-1024.png",
        "_source": {
          "url": "https://incintafertility.com/fertility-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-942-kelly-zhao",
        "name": "Kelly Zhao",
        "credentials": ["LVN"],
        "role": "Third Party Coordinator",
        "imageUrl": "https://incintafertility.com/wordpress/wp-content/uploads/2023/03/kelly-zhao-1.jpg",
        "_source": {
          "url": "https://incintafertility.com/fertility-team/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://incintafertility.com",
    "description": "With a Patient\\-First approach, your needs as a person and as a patient are foremost in our service to you. For your journey to parenthood, our fertility clinic is with you every step of the way.",
    "languages": [
      "English",
      "Spanish",
      "Chinese",
      "Korean",
      "Japanese",
      "French",
      "German",
      "Thai"
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmcFR9f3S37Vmf3QBBYZV3DIpcCofHP6dUpBmbBqcoUmMsJmKEr4LmnJ_W9OV-KLKFz4_N0c99jipeZrgQKfooTNazkPrggT3kKiYH59vXtF7knMNSeKigVXocktVTxiHLjZ7_KYg=w224-h298-k-no-pi0-ya320-ro0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Incinta+Fertility+Center,+21545+Hawthorne+Blvd+Pavilion+B,+Torrance,+CA+90503/@33.8324084,-118.3530858,3314a,13.1y/data=!4m2!3m1!1s0x80dd4bcef6110dd5:0x21a65394bebeb1d8",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-512",
    "externalIds": {
      "cdcClinicId": "512",
      "googlePlaceId": "ChIJTSw64_izwoARDTunT0qpG1M"
    },
    "type": "fertility-clinic",
    "name": "Innovative Fertility Center",
    "phone": "(310) 648-2229",
    "address": {
      "line1": "3500 N. Sepulveda Blvd",
      "city": "Manhattan Beach",
      "state": "CA",
      "zip": "90266",
      "country": "US"
    },
    "location": {
      "lat": 33.9001,
      "lng": -118.396
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 58.333333333333336,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/12"
        },
        {
          "ageBand": "35-37",
          "rate": 41.66666666666667,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/12"
        }
      ],
      "cyclesPerYear": 114,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27512%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27512%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://innovativefertility.com/about/meet-our-fertility-center-team/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Innovative+Fertility+Center,+3500+N+Sepulveda+Blvd+%23130,+Manhattan+Beach,+CA+90266/@33.9000539,-118.395726,3312a,13.1y/data=!4m2!3m1!1s0x80c2b3f8e33a2c4d:0x531ba94a4fa73b0d",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://innovativefertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-512-joshua-j-berger-md-phd",
        "name": "Joshua J. Berger, MD, PHD",
        "role": "Medical Director",
        "imageUrl": "https://innovativefertility.com/wp-content/uploads/2023/07/Dr.-Berger-High-Resolution-Headshot-Suit-1.png",
        "credentials": ["MD", "PhD"],
        "_source": {
          "url": "https://innovativefertility.com/about/joshua-j-berger-md-phd/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-512-jacqueline",
        "name": "Jacqueline",
        "role": "Project Manager Surgery Center",
        "imageUrl": "https://innovativefertility.com/wp-content/uploads/2023/07/Jacqueline-e1429548024642-150x150-1.jpg",
        "_source": {
          "url": "https://innovativefertility.com/about/meet-our-fertility-center-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-512-greg",
        "name": "Greg",
        "credentials": ["CRNA"],
        "imageUrl": "https://innovativefertility.com/wp-content/uploads/2023/07/greg1-e1429545728442-139x150-1.jpg",
        "_source": {
          "url": "https://innovativefertility.com/about/meet-our-fertility-center-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-512-beth-theodore",
        "name": "Beth Theodore",
        "credentials": ["LAc"],
        "role": "Acupuncturist",
        "imageUrl": "https://innovativefertility.com/wp-content/uploads/2025/02/Headshotbeth.png",
        "_source": {
          "url": "https://innovativefertility.com/about/meet-our-fertility-center-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-512-virginia-prior",
        "name": "Virginia Prior",
        "role": "Acupuncturist",
        "imageUrl": "https://innovativefertility.com/wp-content/uploads/2025/02/Ginnyspractice-11.jpg",
        "_source": {
          "url": "https://innovativefertility.com/about/meet-our-fertility-center-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-512-lisa-pedersen",
        "name": "Lisa Pedersen",
        "role": "Yoga Therapist",
        "imageUrl": "https://innovativefertility.com/wp-content/uploads/2023/07/lisa-pedersen.jpg",
        "_source": {
          "url": "https://innovativefertility.com/about/meet-our-fertility-center-team/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://innovativefertility.com",
    "description": "Innovative Fertility Accepting Insurance   Finance Partners Available   Preferred Provider Groups \\PPO\\",
    "insurance": {
      "accepted": true,
      "carriers": ["Aetna", "Anthem", "Cigna"],
      "employeeBenefits": ["Progyny"],
      "_source": {
        "url": "https://innovativefertility.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Cigna",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://innovativefertility.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-869",
    "externalIds": {
      "cdcClinicId": "869"
    },
    "type": "fertility-clinic",
    "name": "Kaiser Permanente Center for Reproductive Health",
    "phone": "(628) 242-7300",
    "address": {
      "line1": "1700 California St, Suite 400",
      "city": "San Francisco",
      "state": "CA",
      "zip": "94109",
      "country": "US"
    },
    "location": {
      "lat": 37.7905,
      "lng": -122.4231
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 44.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 64.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 62.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 172,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27869%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://nass.cdc.gov",
            "fetchedAt": "2024-01-01"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27869%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.kpivf.com/about-us/meet-our-team/",
            "fetchedAt": "2026-03-11"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://www.kpivf.com/about-us/meet-our-team/",
            "fetchedAt": "2026-03-11"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://www.kpivf.com/about-us/meet-our-team/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.kpivf.com",
            "fetchedAt": "2026-06-10"
          }
        },
        "insurance": {
          "status": "scraped",
          "source": {
            "url": "https://www.kpivf.com/about-us/meet-our-team/",
            "fetchedAt": "2026-03-11"
          }
        },
        "consultationTypes": {
          "status": "scraped",
          "source": {
            "url": "https://www.kpivf.com/about-us/meet-our-team/",
            "fetchedAt": "2026-03-11"
          }
        },
        "images": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-869-jacob-christ",
        "name": "Jacob Christ",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Reproductive Endocrinologist",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-10"
        },
        "imageUrl": "https://www.kpivf.com/content/uploads/2026/01/Dr.-Jacob-Christ.png"
      },
      {
        "practitionerId": "pr-org-cdc-869-mandana-ghahremani",
        "name": "Mandana Ghahremani",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Reproductive Endocrinologist",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-10"
        },
        "imageUrl": "https://www.kpivf.com/content/uploads/2026/01/Mandana-Ghahremani.jpg"
      },
      {
        "practitionerId": "pr-org-cdc-869-irene-moy",
        "name": "Irene Moy",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Reproductive Endocrinologist",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-10"
        },
        "imageUrl": "https://www.kpivf.com/content/uploads/2019/11/9420049_portrait.png"
      },
      {
        "practitionerId": "pr-org-cdc-869-andy-miller",
        "name": "Andy Miller",
        "credentials": ["MS", "TS"],
        "specialty": "Embryology",
        "role": "Embryology Lab Director",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-10"
        },
        "imageUrl": "https://www.kpivf.com/content/uploads/2021/04/Andy-Miller-e1619562502530.jpg"
      },
      {
        "practitionerId": "pr-org-cdc-869-nora-al-jumah",
        "name": "Nora AL-Jumah",
        "credentials": ["MSc", "CLSp", "TS", "ELS", "ALS"],
        "specialty": "Embryology Services",
        "role": "Senior Embryologist",
        "imageUrl": "https://www.kpivf.com/content/uploads/2026/01/Nora-AL-Jumah.jpeg",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/nora-al-jumah/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-869-sharon-anderson",
        "name": "Sharon Anderson",
        "credentials": ["MS", "PhD", "HCLD/CC(ABB)"],
        "specialty": "Embryology Services",
        "imageUrl": "https://www.kpivf.com/content/uploads/2025/02/Sharon-Anderson-PhD-HCLD-Kaiser-2025.jpg",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-869-rhea-chattopadhyay",
        "name": "Rhea Chattopadhyay",
        "credentials": ["MD"],
        "specialty": "In Vitro Fertilization, Fertility Preservation for patients without a FB benefit (fee for service), Fertility Preservation Services",
        "imageUrl": "https://www.kpivf.com/content/uploads/2023/01/Rhea-Chattopadhyay-Headshot-2022.jpg",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-869-danny-dasig",
        "name": "Danny Dasig",
        "credentials": ["MS", "TS", "EMB"],
        "specialty": "Embryology Services",
        "imageUrl": "https://www.kpivf.com/content/uploads/2019/11/Danny-Dasig.jpg",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-869-anthony-deangelis",
        "name": "Anthony Deangelis",
        "credentials": ["MD"],
        "specialty": "In Vitro Fertilization, Fertility Preservation Services, Fertility Preservation for patients without a FB benefit (fee for service)",
        "imageUrl": "https://www.kpivf.com/content/uploads/2021/09/AMDPhoto200-1.jpg",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-869-lisa-farah-eways",
        "name": "Lisa Farah-Eways",
        "credentials": ["MD"],
        "specialty": "In Vitro Fertilization, Fertility Preservation for patients without a FB benefit (fee for service), Fertility Preservation Services",
        "imageUrl": "https://www.kpivf.com/content/uploads/2019/11/lisa-farah.jpg",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-869-sara-gilbert",
        "name": "Sara Gilbert",
        "credentials": ["MD"],
        "specialty": "In Vitro Fertilization, Fertility Preservation Services, Fertility Preservation for patients without a FB benefit (fee for service)",
        "imageUrl": "https://www.kpivf.com/content/uploads/2023/06/Sara-Gilbert-002.jpg",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-869-david-guo",
        "name": "David Guo",
        "credentials": ["MD"],
        "specialty": "Male Infertility Services",
        "imageUrl": "https://www.kpivf.com/content/uploads/2026/03/David-Guo.png",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-869-wayland-hsiao",
        "name": "Wayland Hsiao",
        "credentials": ["MD"],
        "specialty": "Male Infertility Services",
        "role": "Male Reproductive Urologist",
        "imageUrl": "https://www.kpivf.com/content/uploads/2019/11/wayland-hsiao.jpg",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/wayland-hsiao-md/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-869-nikhil-joshi",
        "name": "Nikhil Joshi",
        "credentials": ["MD"],
        "specialty": "Fertility Preservation for patients without a FB benefit (fee for service), In Vitro Fertilization, Fertility Preservation Services",
        "imageUrl": "https://www.kpivf.com/content/uploads/2019/11/Nikhil-Joshi-crop.jpg",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-869-vicky-moy",
        "name": "Vicky Moy",
        "credentials": ["MD"],
        "specialty": "Fertility Preservation for patients without a FB benefit (fee for service), In Vitro Fertilization, Fertility Preservation Services",
        "imageUrl": "https://www.kpivf.com/content/uploads/2019/11/Vicky-Moy-crop.jpg",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-869-jon-proctor",
        "name": "Jon Proctor",
        "credentials": ["MD"],
        "specialty": "In Vitro Fertilization, Fertility Preservation for patients without a FB benefit (fee for service), Fertility Preservation Services",
        "imageUrl": "https://www.kpivf.com/content/uploads/2019/11/jon-proctor-1.jpg",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-869-vaishnavi-purusothaman",
        "name": "Vaishnavi Purusothaman",
        "credentials": ["MD"],
        "specialty": "In Vitro Fertilization, Fertility Preservation Services, Fertility Preservation for patients without a FB benefit (fee for service)",
        "imageUrl": "https://www.kpivf.com/content/uploads/2023/01/0915871_Purusothaman_Vaishnavi_cpm_9-26-2022_IMG_0185-002-002.jpg",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-869-james-stinson",
        "name": "James Stinson",
        "credentials": ["MD"],
        "specialty": "Male Infertility Services",
        "role": "Urologist",
        "imageUrl": "https://www.kpivf.com/content/uploads/2026/03/james-Stinson.png",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/james-stinson-md/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-869-orkun-tan",
        "name": "Orkun Tan",
        "credentials": ["MD"],
        "specialty": "Fertility Preservation Services, Fertility Preservation for patients without a FB benefit (fee for service), In Vitro Fertilization",
        "imageUrl": "https://www.kpivf.com/content/uploads/2019/11/orkun-tan.jpg",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-869-tracey-telles",
        "name": "Tracey Telles",
        "credentials": ["MD"],
        "specialty": "Fertility Preservation for patients without a FB benefit (fee for service), In Vitro Fertilization, Fertility Preservation Services",
        "imageUrl": "https://www.kpivf.com/content/uploads/2019/11/tracey-telles.jpg",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.kpivf.com",
    "description": "Kaiser Permanente Centers for Reproductive Health offers state-of-the-art fertility treatments including IVF at their San Francisco clinic, part of the Kaiser Permanente health system.",
    "bookingUrl": "https://www.kpivf.com/location/san-francisco/",
    "schedule": {
      "mon": {
        "open": "07:30",
        "close": "16:00"
      },
      "tue": {
        "open": "07:30",
        "close": "16:00"
      },
      "wed": {
        "open": "07:30",
        "close": "16:00"
      },
      "thu": {
        "open": "07:30",
        "close": "16:00"
      },
      "fri": {
        "open": "07:30",
        "close": "16:00"
      },
      "sat": null,
      "sun": null
    },
    "consultationTypes": ["in-person"],
    "network": {
      "name": "Kaiser Permanente"
    },
    "insurance": {
      "accepted": true,
      "carriers": ["Kaiser Permanente"],
      "_source": {
        "url": "https://www.kpivf.com/about-us/meet-our-team/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Kaiser Permanente",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kpivf.com/about-us/meet-our-team/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-467",
    "externalIds": {
      "cdcClinicId": "467",
      "googlePlaceId": "ChIJ21I3EY7Aj4ARwQMnoiGQo_U"
    },
    "type": "fertility-clinic",
    "name": "Kaiser Permanente Center for Reproductive Health-Fremont",
    "phone": "(510) 248-6900",
    "address": {
      "line1": "39141 Civic Center Dr, Suite 350",
      "city": "Fremont",
      "state": "CA",
      "zip": "94538",
      "country": "US"
    },
    "location": {
      "lat": 37.554,
      "lng": -121.977
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 50.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 54.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 41.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 34.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 719,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27467%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27467%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.kpivf.com/about-us/meet-our-team/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fremont+Center+for+Reproductive+Health:+Reproductive+Endocrinology+and+Infertility+Clinic+and+Embryology+Lab,+39141+Civic+Center+Dr+%23350,+Fremont,+CA+94538/@37.5540761,-121.9767535,3163a,13.1y/data=!4m2!3m1!1s0x808fc08e113752db:0xf5a39021a22703c1",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.kpivf.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-467-jon-proctor",
        "name": "Jon Proctor",
        "credentials": ["MD"],
        "role": "Reproductive Endocrinology and In Vitro Fertilization Specialist",
        "specialty": "In Vitro Fertilization Services, Fertility Preservation Services",
        "imageUrl": "https://www.kpivf.com/content/uploads/2019/11/jon-proctor-1.jpg",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/jon-proctor-md/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-467-orkun-tan",
        "name": "Orkun Tan",
        "credentials": ["MD"],
        "role": "Reproductive Endocrinology and In Vitro Fertilization Specialist",
        "specialty": "Fertility Preservation Services, In Vitro Fertilization Services",
        "imageUrl": "https://www.kpivf.com/content/uploads/2019/11/orkun-tan.jpg",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/orkun-tan-md/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-467-danny-dasig",
        "name": "Danny Dasig",
        "credentials": ["MS", "TS", "EMB"],
        "role": "IVF Laboratory Manager",
        "specialty": "Embryology Services",
        "imageUrl": "https://www.kpivf.com/content/uploads/2019/11/Danny-Dasig.jpg",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/danny-dasig-ms-ts-emb/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.kpivf.com",
    "description": "You want to grow your family, but it hasn’t been easy. At the Kaiser Permanente Centers for Reproductive Health, our team of dedicated professionals is here to provide you with compassionate, high\\-quality, and personalized care through your journey.",
    "insurance": {
      "accepted": true,
      "carriers": ["Kaiser Permanente"],
      "_source": {
        "url": "https://www.kpivf.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "network": {
      "name": "IVI RMA"
    },
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Kaiser Permanente",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kpivf.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn1xnuPInJblg22F7vPSjjg4E0x3FQg7n3xZJ5x-3077moK0dCM3KD8oAPHVg1YDM0tsFtIyZAQX0gV4eMbMBYaJnRNXjWJgMWy80rVLsa4CBwK4ndJethoj8mXb-tDoCcwGoM=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fremont+Center+for+Reproductive+Health:+Reproductive+Endocrinology+and+Infertility+Clinic+and+Embryology+Lab,+39141+Civic+Center+Dr+%23350,+Fremont,+CA+94538/@37.5540761,-121.9767535,3163a,13.1y/data=!4m2!3m1!1s0x808fc08e113752db:0xf5a39021a22703c1",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-515",
    "externalIds": {
      "cdcClinicId": "515"
    },
    "type": "fertility-clinic",
    "name": "Kaiser Permanente Center for Reproductive Health-Sacramento",
    "phone": "(916) 614-5083",
    "address": {
      "line1": "1650 Response Rd, Suite 1A",
      "city": "Sacramento",
      "state": "CA",
      "zip": "95815",
      "country": "US"
    },
    "location": {
      "lat": 38.5964,
      "lng": -121.43
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 47.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 48.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 55,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 286,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27515%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27515%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.kpivf.com/about-us/meet-our-team/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.kpivf.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-515-anthony-m-deangelis",
        "name": "Anthony M Deangelis",
        "credentials": ["MD"],
        "role": "Reproductive Endocrinology and In Vitro Fertilization Specialist",
        "imageUrl": "https://www.kpivf.com/content/uploads/2021/09/AMDPhoto200-1.jpg",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/anthony-m-deangelis-md/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-515-sara-babcock-gilbert",
        "name": "Sara Babcock Gilbert",
        "credentials": ["MD"],
        "role": "Reproductive Endocrinology and In Vitro Fertilization Specialist",
        "imageUrl": "https://www.kpivf.com/content/uploads/2023/06/Sara-Gilbert-002.jpg",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/sara-babcock-gilbert-md/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-515-vicky-moy",
        "name": "Vicky Moy",
        "credentials": ["MD"],
        "role": "Reproductive Endocrinology and In Vitro Fertilization Specialist",
        "imageUrl": "https://www.kpivf.com/content/uploads/2019/11/Vicky-Moy-crop.jpg",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/vicky-moy-md/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-515-nora-al-jumah",
        "name": "Nora AL-Jumah",
        "credentials": ["MSc", "CLSp", "TS", "ELS", "ALS"],
        "role": "IVF Laboratory Manager",
        "imageUrl": "https://www.kpivf.com/content/uploads/2026/01/Nora-AL-Jumah.jpeg",
        "_source": {
          "url": "https://www.kpivf.com/about-us/meet-our-team/nora-al-jumah/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.kpivf.com",
    "description": "You want to grow your family, but it hasn’t been easy. At the Kaiser Permanente Centers for Reproductive Health, our team of dedicated professionals is here to provide you with compassionate, high\\-quality, and personalized care through your journey.",
    "insurance": {
      "accepted": true,
      "carriers": ["Kaiser Permanente"],
      "_source": {
        "url": "https://www.kpivf.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "network": {
      "name": "IVI RMA"
    },
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Kaiser Permanente",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kpivf.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-870",
    "externalIds": {
      "cdcClinicId": "870",
      "googlePlaceId": "ChIJeYMmACa3j4ARnhegx5v0uiE"
    },
    "type": "fertility-clinic",
    "name": "Kindbody Silicon Valley",
    "phone": "(650) 445-4724",
    "address": {
      "line1": "4756 El Camino Real",
      "city": "Los Altos",
      "state": "CA",
      "zip": "94022",
      "country": "US"
    },
    "location": {
      "lat": 37.3997,
      "lng": -122.1113
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 16,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27870%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27870%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/kindbody-silicon-valley/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+Los+Altos,+4756+El+Camino+Real,+Los+Altos,+CA+94022/@37.3996706,-122.1113035,3170a,13.1y/data=!4m2!3m1!1s0x808fb72600268379:0x21baf49bc7a0179e",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-870-lynn-marie-westphal",
        "name": "Lynn Marie Westphal",
        "role": "Lead CMO, Medicine + Research & REI",
        "imageUrl": "https://kindbody.com/wp-content/uploads/2019/12/WestphalWeb2-683x1024.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://kindbody.com/team/dr-lynn-westphal/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-870-ramya-sethuram",
        "name": "Ramya Sethuram",
        "credentials": ["MD"],
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://kindbody.com/wp-content/uploads/2023/11/My-head-shot-779x1024.jpeg",
        "_source": {
          "url": "https://kindbody.com/team/dr-ramya-sethuram/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://kindbody.com",
    "description": "Make fertility care an Act of Love\\ Save up to 20% on your first fertility cycle, ends 3/13",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Anthem",
        "Blue Cross",
        "Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Health Net",
        "Multiplan",
        "Tricare",
        "Oxford",
        "Oscar",
        "Emblem Health",
        "Empire",
        "Horizon",
        "Optum",
        "First Health",
        "Medicare",
        "Medicaid"
      ],
      "employeeBenefits": ["Kindbody"],
      "_source": {
        "url": "https://kindbody.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlSx5kB6Rg8Q5D3gu7GguhLWdoNuWfbEZrDlf4LiXeIQUy8xDj9bm99j-3nG0K4oymrdiVBjNHAQCPCOTwCBaI-wXEAP56PhXLYaiNi5efqYf6d-sAJYxyYlkyUwUiLTl3csfFbew=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Los+Altos,+4756+El+Camino+Real,+Los+Altos,+CA+94022/@37.3996706,-122.1113035,3170a,13.1y/data=!4m2!3m1!1s0x808fb72600268379:0x21baf49bc7a0179e",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlUDGtm8n8gwr0A7wdAIY6_qKAHi0ekXZqgF5J3O7SDlRdh9aH_jbaMF2BhBGMJJtvr-_Igo0oSsORdJC-FP7jABqF6N4XhEDbBSFrU9-fwfm2Vl0R5Al1ObAJhPd4TpsZaHaIJ--jsy30=w408-h307-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Los+Altos,+4756+El+Camino+Real,+Los+Altos,+CA+94022/@37.3996706,-122.1113035,3170a,13.1y/data=!4m2!3m1!1s0x808fb72600268379:0x21baf49bc7a0179e",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "network": {
      "name": "Kindbody"
    },
    "pricing": {
      "packages": [
        {
          "name": "Pulse Assessment",
          "description": "Quick fertility check — not covered by insurance",
          "price": 9900,
          "currency": "USD",
          "includes": [
            "AMH blood test",
            "Transvaginal ultrasound for follicle count",
            "15-minute reproductive consultation"
          ],
          "notes": "Not covered by insurance"
        },
        {
          "name": "Fertility Consultation",
          "description": "Specialist consultation on fertility fundamentals",
          "price": 30000,
          "currency": "USD",
          "notes": "Billable to most insurance plans"
        },
        {
          "name": "Male Consultation + Semen Analysis",
          "price": 52500,
          "currency": "USD",
          "includes": ["Consultation", "Venipuncture", "Semen analysis"]
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Single egg freezing cycle",
          "price": 690000,
          "priceMax": 966000,
          "currency": "USD",
          "includes": [
            "Stimulation visits",
            "Ultrasounds",
            "Blood draws",
            "Retrieval",
            "Cryopreservation",
            "3 months storage",
            "Coordination"
          ],
          "excludes": ["Medications ($4,000 - $6,000)", "Anesthesia"]
        },
        {
          "name": "Annual Egg Storage",
          "price": 92000,
          "currency": "USD",
          "notes": "Per year"
        },
        {
          "name": "IVF Freeze All (Self Pay)",
          "description": "IVF cycle with all embryos frozen",
          "price": 1160000,
          "priceMax": 1850000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Cryopreservation",
            "3 months storage"
          ],
          "excludes": [
            "Medications (~$4,000 - $6,000)",
            "Embryo biopsy/genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Donor services",
            "Anesthesia"
          ]
        },
        {
          "name": "IVF Fresh Transfer (Self Pay)",
          "description": "IVF cycle with fresh embryo transfer",
          "price": 1380000,
          "priceMax": 1875000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$5,000 - $9,000)",
            "Genetic testing",
            "Surplus embryo storage",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Freeze All",
          "price": 910000,
          "priceMax": 1332000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Cryopreservation",
            "3-month storage"
          ],
          "excludes": [
            "Genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Fresh Transfer",
          "price": 990000,
          "priceMax": 1428000,
          "currency": "USD",
          "includes": [
            "Ultrasounds",
            "Thaw",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Surplus storage",
            "Frozen transfers",
            "Anesthesia"
          ]
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 400000,
          "priceMax": 550000,
          "currency": "USD",
          "includes": ["Ultrasounds", "Thaw", "Assisted hatching", "Transfer"],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "PGT Package",
          "description": "Preimplantation genetic testing",
          "price": 160000,
          "priceMax": 300000,
          "currency": "USD",
          "includes": ["Embryo biopsy", "Lab management"],
          "excludes": ["Storage", "Shipping", "Per-embryo testing costs"]
        },
        {
          "name": "Nutrition Coaching",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Counseling & Support",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Guided Meditation",
          "description": "Virtual wellness — 30-minute session",
          "price": 9000,
          "currency": "USD"
        }
      ],
      "financingOptions": [
        {
          "name": "PatientFi monthly payments",
          "description": "PatientFi monthly payments"
        }
      ],
      "disclaimer": "Prices vary by location. Medications and anesthesia are not included in procedure costs. 3 months of storage included with freeze procedures; annual storage is $920.",
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Blue Cross, Blue Shield, Cigna, United Healthcare, Humana, Health Net",
              "detail": "11 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://kindbody.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "14 public price package(s) and 1 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-834",
    "externalIds": {
      "cdcClinicId": "834",
      "googlePlaceId": "ChIJg997m4ylwoAR3KwudMc0HWM"
    },
    "type": "fertility-clinic",
    "name": "Kindbody-Los Angeles",
    "phone": "(855) 563-2639",
    "address": {
      "line1": "500 Broadway, Suite 7",
      "city": "Santa Monica",
      "state": "CA",
      "zip": "90404",
      "country": "US"
    },
    "location": {
      "lat": 34.0263,
      "lng": -118.487
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 46.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 45.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 52.63157894736842,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "10/19"
        },
        {
          "ageBand": ">40",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/10"
        }
      ],
      "cyclesPerYear": 145,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27834%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27834%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/los-angeles-location/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+Santa+Monica,+500+Broadway+%237,+Santa+Monica,+CA+90401/@34.0153209,-118.4918477,3307a,13.1y/data=!4m2!3m1!1s0x80c2a58c9b7bdf83:0x631d34c7742eacdc",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-834-anupama-kathiresan",
        "name": "Anupama Kathiresan",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://kindbody.com/wp-content/uploads/2021/11/KindbodyCenturyCity143-1024x683.jpg",
        "_source": {
          "url": "https://kindbody.com/team/dr-anupama-kathiresan/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://kindbody.com",
    "description": "Make fertility care an Act of Love\\ Save up to 20% on your first fertility cycle, ends 3/13",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Anthem",
        "Blue Cross",
        "Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Health Net",
        "Multiplan",
        "Tricare",
        "Oxford",
        "Oscar",
        "Emblem Health",
        "Empire",
        "Horizon",
        "Optum",
        "First Health",
        "Medicare",
        "Medicaid"
      ],
      "employeeBenefits": ["Kindbody"],
      "_source": {
        "url": "https://kindbody.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlQMn9WqUuDE4W7wc_epsXsm7MUL5QS6aiWO4NIKDA_uYFJdTtqxEIdepcKNR19n_llsJG5kK_tZX9vYYIvXTIMtOR5dg7W2Ed9TYAjPu2F-OJ8UtDUn9ECLaazdErjvN1Y20Q9Og=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Santa+Monica,+500+Broadway+%237,+Santa+Monica,+CA+90401/@34.0153209,-118.4918477,3307a,13.1y/data=!4m2!3m1!1s0x80c2a58c9b7bdf83:0x631d34c7742eacdc",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkWmnyyG8LcYmn7BwO1fiUSvATzLhP9w5Ln6_HnlzqdsYq9f16joXmuAAxyFMA8qBsy8GhXRIFQA3f4LjRPA6vOtfJRJUfyJ61S4sU71zRdmcOWr9gmm9VWcfDZcBuzRZ2w0H7VrA=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Santa+Monica,+500+Broadway+%237,+Santa+Monica,+CA+90401/@34.0153209,-118.4918477,3307a,13.1y/data=!4m2!3m1!1s0x80c2a58c9b7bdf83:0x631d34c7742eacdc",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "network": {
      "name": "Kindbody"
    },
    "pricing": {
      "packages": [
        {
          "name": "Pulse Assessment",
          "description": "Quick fertility check — not covered by insurance",
          "price": 9900,
          "currency": "USD",
          "includes": [
            "AMH blood test",
            "Transvaginal ultrasound for follicle count",
            "15-minute reproductive consultation"
          ],
          "notes": "Not covered by insurance"
        },
        {
          "name": "Fertility Consultation",
          "description": "Specialist consultation on fertility fundamentals",
          "price": 30000,
          "currency": "USD",
          "notes": "Billable to most insurance plans"
        },
        {
          "name": "Male Consultation + Semen Analysis",
          "price": 52500,
          "currency": "USD",
          "includes": ["Consultation", "Venipuncture", "Semen analysis"]
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Single egg freezing cycle",
          "price": 690000,
          "priceMax": 966000,
          "currency": "USD",
          "includes": [
            "Stimulation visits",
            "Ultrasounds",
            "Blood draws",
            "Retrieval",
            "Cryopreservation",
            "3 months storage",
            "Coordination"
          ],
          "excludes": ["Medications ($4,000 - $6,000)", "Anesthesia"]
        },
        {
          "name": "Annual Egg Storage",
          "price": 92000,
          "currency": "USD",
          "notes": "Per year"
        },
        {
          "name": "IVF Freeze All (Self Pay)",
          "description": "IVF cycle with all embryos frozen",
          "price": 1160000,
          "priceMax": 1850000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Cryopreservation",
            "3 months storage"
          ],
          "excludes": [
            "Medications (~$4,000 - $6,000)",
            "Embryo biopsy/genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Donor services",
            "Anesthesia"
          ]
        },
        {
          "name": "IVF Fresh Transfer (Self Pay)",
          "description": "IVF cycle with fresh embryo transfer",
          "price": 1380000,
          "priceMax": 1875000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$5,000 - $9,000)",
            "Genetic testing",
            "Surplus embryo storage",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Freeze All",
          "price": 910000,
          "priceMax": 1332000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Cryopreservation",
            "3-month storage"
          ],
          "excludes": [
            "Genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Fresh Transfer",
          "price": 990000,
          "priceMax": 1428000,
          "currency": "USD",
          "includes": [
            "Ultrasounds",
            "Thaw",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Surplus storage",
            "Frozen transfers",
            "Anesthesia"
          ]
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 400000,
          "priceMax": 550000,
          "currency": "USD",
          "includes": ["Ultrasounds", "Thaw", "Assisted hatching", "Transfer"],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "PGT Package",
          "description": "Preimplantation genetic testing",
          "price": 160000,
          "priceMax": 300000,
          "currency": "USD",
          "includes": ["Embryo biopsy", "Lab management"],
          "excludes": ["Storage", "Shipping", "Per-embryo testing costs"]
        },
        {
          "name": "Nutrition Coaching",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Counseling & Support",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Guided Meditation",
          "description": "Virtual wellness — 30-minute session",
          "price": 9000,
          "currency": "USD"
        }
      ],
      "financingOptions": [
        {
          "name": "PatientFi monthly payments",
          "description": "PatientFi monthly payments"
        }
      ],
      "disclaimer": "Prices vary by location. Medications and anesthesia are not included in procedure costs. 3 months of storage included with freeze procedures; annual storage is $920.",
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Blue Cross, Blue Shield, Cigna, United Healthcare, Humana, Health Net",
              "detail": "11 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://kindbody.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "14 public price package(s) and 1 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-829",
    "externalIds": {
      "cdcClinicId": "829",
      "googlePlaceId": "ChIJjcN25vSBhYARyz8fQP3o-CQ"
    },
    "type": "fertility-clinic",
    "name": "Kindbody-San Francisco",
    "phone": "(628) 777-7064",
    "address": {
      "line1": "88 Sutter St",
      "city": "San Francisco",
      "state": "CA",
      "zip": "94104",
      "country": "US"
    },
    "location": {
      "lat": 37.7902,
      "lng": -122.402
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 56.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 68.75,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "11/16"
        },
        {
          "ageBand": "38-40",
          "rate": 53.333333333333336,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "8/15"
        }
      ],
      "cyclesPerYear": 98,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27829%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://nass.cdc.gov",
            "fetchedAt": "2024-01-01"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27829%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/san-francisco-location/",
            "fetchedAt": "2026-03-11"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/san-francisco-location/",
            "fetchedAt": "2026-03-11"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/san-francisco-location/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/san-francisco-location/",
            "fetchedAt": "2026-06-10"
          }
        },
        "insurance": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/san-francisco-location/",
            "fetchedAt": "2026-03-11"
          }
        },
        "consultationTypes": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/san-francisco-location/",
            "fetchedAt": "2026-03-11"
          }
        },
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+San+Francisco,+88+Sutter+St,+San+Francisco,+CA+94104/@37.7901907,-122.4019492,3153a,13.1y/data=!4m2!3m1!1s0x808581f4e676c38d:0x24f8e8fd401f3fcb",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-829-geraldine-ekpo",
        "name": "Geraldine Ekpo",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://kindbody.com/wp-content/uploads/2022/01/Ekpo_Web2-683x1024.jpg",
        "_source": {
          "url": "https://kindbody.com/san-francisco-location/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-829-jasmine-pedroso",
        "name": "Jasmine Pedroso",
        "credentials": ["MD"],
        "specialty": "Ob/Gyn Minimally Invasive Gynecologic Surgery",
        "role": "Ob/Gyn Surgeon",
        "_source": {
          "url": "https://kindbody.com/san-francisco-location/",
          "fetchedAt": "2026-06-10"
        },
        "imageUrl": "https://kindbody.com/wp-content/uploads/2020/12/JasminePedroso-2025-857x1024.jpg"
      },
      {
        "practitionerId": "pr-org-cdc-829-erica-keller",
        "name": "Erica Keller",
        "credentials": ["PA"],
        "specialty": "Reproductive Medicine",
        "role": "Physician Assistant",
        "_source": {
          "url": "https://kindbody.com/san-francisco-location/",
          "fetchedAt": "2026-06-10"
        },
        "imageUrl": "https://kindbody.com/wp-content/uploads/2021/11/4D293947-8ABA-482D-938C-C78120CC9024-768x1024.jpg"
      }
    ],
    "website": "https://kindbody.com",
    "description": "Full-suite of fertility services, including conception care, egg freezing, fertility testing and virtual wellness and coaching services.",
    "email": "navigator@kindbody.com",
    "bookingUrl": "https://kindbody.com/scheduling/location-confirmed/service-type-select/san-francisco/",
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "17:00"
      },
      "tue": {
        "open": "07:00",
        "close": "17:00"
      },
      "wed": {
        "open": "07:00",
        "close": "17:00"
      },
      "thu": {
        "open": "07:00",
        "close": "17:00"
      },
      "fri": {
        "open": "07:00",
        "close": "17:00"
      },
      "sat": null,
      "sun": null
    },
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "Kindbody"
    },
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross (Anthem)",
        "Blue Shield of CA",
        "Cigna",
        "Multiplan/PHCS",
        "Sana",
        "United Healthcare"
      ],
      "_source": {
        "url": "https://kindbody.com/san-francisco-location/",
        "fetchedAt": "2026-03-11"
      }
    },
    "images": [
      {
        "url": "https://kindbody.com/wp-content/uploads/2020/03/0J0A5246-1.jpg",
        "type": "interior",
        "caption": "Kindbody San Francisco lounge",
        "_source": {
          "url": "https://kindbody.com/san-francisco-location/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmtGfhTlQf0SgDPyGbMm9Y-OesaNIYd48INg-94-vm7ZSqm18HE2Xw3tQbp1oEMV1sH1WnR1rU84sXT_dz0a1PHYA2zyKtZ-FMLfs45Qi9krU_5TI23Qvqh0p7LfrrmzxWuCmFWHA=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+San+Francisco,+88+Sutter+St,+San+Francisco,+CA+94104/@37.7901907,-122.4019492,3153a,13.1y/data=!4m2!3m1!1s0x808581f4e676c38d:0x24f8e8fd401f3fcb",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnuBgeoawIQvI9UQq3NGNBpglPUROmv_sdMbfMA_FIhhMevH84pN6jEq7RuvCYVg-OaG-YuJlwDo89FaulJoz79wvWG_Z4O8w11FR4Bt-3jv-gN4HUUjssceV7m8AiFbDWESKpyAg=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+San+Francisco,+88+Sutter+St,+San+Francisco,+CA+94104/@37.7901907,-122.4019492,3153a,13.1y/data=!4m2!3m1!1s0x808581f4e676c38d:0x24f8e8fd401f3fcb",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "languages": ["English"],
    "pricing": {
      "packages": [
        {
          "name": "Pulse Assessment",
          "description": "Quick fertility check — not covered by insurance",
          "price": 9900,
          "currency": "USD",
          "includes": [
            "AMH blood test",
            "Transvaginal ultrasound for follicle count",
            "15-minute reproductive consultation"
          ],
          "notes": "Not covered by insurance"
        },
        {
          "name": "Fertility Consultation",
          "description": "Specialist consultation on fertility fundamentals",
          "price": 30000,
          "currency": "USD",
          "notes": "Billable to most insurance plans"
        },
        {
          "name": "Male Consultation + Semen Analysis",
          "price": 52500,
          "currency": "USD",
          "includes": ["Consultation", "Venipuncture", "Semen analysis"]
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Single egg freezing cycle",
          "price": 690000,
          "priceMax": 966000,
          "currency": "USD",
          "includes": [
            "Stimulation visits",
            "Ultrasounds",
            "Blood draws",
            "Retrieval",
            "Cryopreservation",
            "3 months storage",
            "Coordination"
          ],
          "excludes": ["Medications ($4,000 - $6,000)", "Anesthesia"]
        },
        {
          "name": "Annual Egg Storage",
          "price": 92000,
          "currency": "USD",
          "notes": "Per year"
        },
        {
          "name": "IVF Freeze All (Self Pay)",
          "description": "IVF cycle with all embryos frozen",
          "price": 1160000,
          "priceMax": 1850000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Cryopreservation",
            "3 months storage"
          ],
          "excludes": [
            "Medications (~$4,000 - $6,000)",
            "Embryo biopsy/genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Donor services",
            "Anesthesia"
          ]
        },
        {
          "name": "IVF Fresh Transfer (Self Pay)",
          "description": "IVF cycle with fresh embryo transfer",
          "price": 1380000,
          "priceMax": 1875000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$5,000 - $9,000)",
            "Genetic testing",
            "Surplus embryo storage",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Freeze All",
          "price": 910000,
          "priceMax": 1332000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Cryopreservation",
            "3-month storage"
          ],
          "excludes": [
            "Genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Fresh Transfer",
          "price": 990000,
          "priceMax": 1428000,
          "currency": "USD",
          "includes": [
            "Ultrasounds",
            "Thaw",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Surplus storage",
            "Frozen transfers",
            "Anesthesia"
          ]
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 400000,
          "priceMax": 550000,
          "currency": "USD",
          "includes": ["Ultrasounds", "Thaw", "Assisted hatching", "Transfer"],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "PGT Package",
          "description": "Preimplantation genetic testing",
          "price": 160000,
          "priceMax": 300000,
          "currency": "USD",
          "includes": ["Embryo biopsy", "Lab management"],
          "excludes": ["Storage", "Shipping", "Per-embryo testing costs"]
        },
        {
          "name": "Nutrition Coaching",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Counseling & Support",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Guided Meditation",
          "description": "Virtual wellness — 30-minute session",
          "price": 9000,
          "currency": "USD"
        }
      ],
      "financingOptions": [
        {
          "name": "PatientFi monthly payments",
          "description": "PatientFi monthly payments"
        }
      ],
      "disclaimer": "Prices vary by location. Medications and anesthesia are not included in procedure costs. 3 months of storage included with freeze procedures; annual storage is $920.",
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross (Anthem), Blue Shield of CA, Cigna, Multiplan/PHCS, Sana, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://kindbody.com/san-francisco-location/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "14 public price package(s) and 1 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-615",
    "externalIds": {
      "cdcClinicId": "615",
      "googlePlaceId": "ChIJFXo9_4u7woARvg2FUp7Gqec"
    },
    "type": "fertility-clinic",
    "name": "LA IVF Clinic",
    "phone": "(310) 286-2800",
    "address": {
      "line1": "2080 Century Park East, Suite 400",
      "city": "Los Angeles",
      "state": "CA",
      "zip": "90067",
      "country": "US"
    },
    "location": {
      "lat": 34.0601,
      "lng": -118.4119
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      },
      {
        "name": "miniIVF",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 6,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27615%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27615%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://laivfclinic.com/about-la-ivf-clinic/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/LA+IVF+Clinic,+2080+Century+Pk+E+%23400,+Los+Angeles,+CA+90067/@34.059218,-118.4113041,3305a,13.1y/data=!4m2!3m1!1s0x80c2bb8bff3d7a15:0xe7a9c69e52850dbe",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://laivfclinic.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-615-aykut-bayrak-md",
        "name": "Aykut Bayrak, MD",
        "role": "Medical Director",
        "imageUrl": "https://laivfclinic.com/wp-content/uploads/2025/12/Dr_AykutBayrak.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://laivfclinic.com/team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-615-geoffrey-sher",
        "name": "Geoffrey Sher",
        "credentials": ["MD"],
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://laivfclinic.com/wp-content/uploads/2026/05/Screenshot-2026-05-07-at-42654-PM.png",
        "_source": {
          "url": "https://laivfclinic.com/team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-615-steven-a-brody",
        "name": "Steven A. Brody",
        "credentials": ["MD", "PhD"],
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://laivfclinic.com/wp-content/uploads/2026/05/Screenshot-2026-05-07-at-42412-PM.png",
        "_source": {
          "url": "https://laivfclinic.com/team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-615-gozde-gokozan",
        "name": "Gozde Gokozan",
        "credentials": ["LMFT", "LPCC"],
        "role": "Licensed Psychotherapist",
        "imageUrl": "https://laivfclinic.com/wp-content/uploads/2020/10/Gozde-Gokozan-2798-R-WEB.jpg",
        "_source": {
          "url": "https://laivfclinic.com/team/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://laivfclinic.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Anthem",
        "Blue Cross",
        "Blue Shield",
        "Cigna",
        "UnitedHealthcare",
        "Empire",
        "Optum",
        "BCBS"
      ],
      "employeeBenefits": ["Carrot", "WINFertility", "Future Family"],
      "_source": {
        "url": "https://laivfclinic.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnd2CWlbd21tnXX_CFleVBqCTn2WuQrsqeRejfZvRrC_QDV9r_WMHrTh-_10rwLMf55xRh_DW_LkI0ilHpDmsJgbmhS06MNASLErxYBHPxLPKjcSm40wtFB9qp4iiw0gzJTP4YC=w473-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/LA+IVF+Clinic,+2080+Century+Pk+E+%23400,+Los+Angeles,+CA+90067/@34.059218,-118.4113041,3305a,13.1y/data=!4m2!3m1!1s0x80c2bb8bff3d7a15:0xe7a9c69e52850dbe",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "description": "LA IVF Clinic is a Los Angeles fertility clinic dedicated to providing professional, ethical, and individualized reproductive care, combining advanced medical and surgical expertise with a compassionate, patient-centered approach. Treatment decisions are guided by comprehensive diagnostic evaluation using advanced fertility testing before any treatment is initiated, with plans designed around the patient rather than a preset formula. Care is led by Dr. Aykut Bayrak, a double board-certified fertility specialist, and patients are followed by the same physician and clinical team throughout treatment.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Blue Cross, Blue Shield, Cigna, UnitedHealthcare, Empire, Optum",
              "detail": "1 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://laivfclinic.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-874",
    "externalIds": {
      "cdcClinicId": "874"
    },
    "type": "fertility-clinic",
    "name": "LA/OC Fertility, Inc.",
    "phone": "(714) 988-4272",
    "address": {
      "line1": "510 N. Prospect Ave, Suite 205",
      "city": "Redondo Beach",
      "state": "CA",
      "zip": "90277",
      "country": "US"
    },
    "location": {
      "lat": 33.8525,
      "lng": -118.3789
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 48.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 45.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 47.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 14.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1021,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27874%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27874%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.reproductivepartners.com/doctors/gayane-ambartsumyan",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.bloomingeve.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-874-gayane-ambartsumyan-md-phd",
        "name": "Gayane Ambartsumyan, MD, PHD",
        "role": "Medical Director",
        "imageUrl": "https://a.storyblok.com/f/290132/982x982/940854826c/gayane-ambartsumyan.png",
        "credentials": ["MD", "Ph.D."],
        "specialty": "fertility treatments and IVF",
        "_source": {
          "url": "https://www.reproductivepartners.com/doctors/gayane-ambartsumyan",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "",
    "description": "All fertility clinics in the US for egg freezing and infertility treatment \\IVF or IUI\\ in one place.",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-923",
    "externalIds": {
      "cdcClinicId": "923",
      "googlePlaceId": "ChIJkf0Y4H7f3IAR_SYKQJOCJ5E"
    },
    "type": "fertility-clinic",
    "name": "Labryo Fertility Center",
    "phone": "(949) 891-1531",
    "address": {
      "line1": "2001 Westcliff Dr, Suite 300",
      "city": "Newport Beach",
      "state": "CA",
      "zip": "92660",
      "country": "US"
    },
    "location": {
      "lat": 33.6274,
      "lng": -117.9039
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 9,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27923%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27923%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.labryofertility.com/about/whoweare",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Labryo+Fertility+Center,+2001+Westcliff+Dr+Ste+300,+Newport+Beach,+CA+92660/@33.6274142,-117.9079786,3322a,13.1y/data=!4m2!3m1!1s0x80dcdf7ee018fd91:0x91278293400a26fd",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.labryofertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-923-benito-villanueva-md",
        "name": "Benito Villanueva, MD",
        "role": "Medical Director",
        "imageUrl": "https://usa-api.labryofertility.com/uploads/line/834de99a09c34c3d850a5c3a600dc3c6.png",
        "credentials": ["M.D.", "FACOG"],
        "_source": {
          "url": "https://www.labryofertility.com/about/meetourexperts",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-923-samuel-wood",
        "name": "Samuel Wood",
        "credentials": [
          "M.D.",
          "PH.D.",
          "M.A.",
          "M.B.A.",
          "HCLD/CC (ABB)",
          "FACOG"
        ],
        "role": "Clinical Medical Advisor",
        "imageUrl": "https://usa-api.labryofertility.com/uploads/line/677a68b3026043cd838acbfa13f4d53b.png",
        "_source": {
          "url": "https://www.labryofertility.com/about/meetourexperts",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-923-molly-chu-chen",
        "name": "Molly Chu-Chen",
        "credentials": ["M.S.", "M.H.A.", "TS (ABB)"],
        "role": "Founder & Chief Embryologist",
        "imageUrl": "https://usa-api.labryofertility.com/uploads/line/38839913a6bc4cffa55f8da08249e415.png",
        "_source": {
          "url": "https://www.labryofertility.com/about/meetourexperts",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-923-jeremy-a-king",
        "name": "Jeremy A. King",
        "credentials": ["M.D."],
        "role": "Director of IVF",
        "imageUrl": "https://usa-api.labryofertility.com/uploads/line/9fe5225b7efd4b428566b90312512447.png",
        "_source": {
          "url": "https://www.labryofertility.com/about/meetourexperts",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.labryofertility.com",
    "description": "The ONLY fertility center that has a package that refunds based on performance success. Learn more about our Performance Value Package.",
    "languages": [
      "English",
      "Spanish",
      "Cantonese",
      "Mandarin Chinese",
      "Vietnamese"
    ],
    "images": [
      {
        "url": "https://usa-api.labryofertility.com/uploads/vars/445c012e13cf4b378799404390c33b01.jpg",
        "type": "interior",
        "_source": {
          "url": "https://www.labryofertility.com",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "url": "https://usa-api.labryofertility.com/uploads/line/4d016eff8fca4870b3cb73d1ddaf9e9d.jpg",
        "type": "interior",
        "_source": {
          "url": "https://www.labryofertility.com",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "url": "https://usa-api.labryofertility.com/uploads/line/b5529e191ade4cf89d4602093634d357.jpg",
        "type": "interior",
        "_source": {
          "url": "https://www.labryofertility.com",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "url": "https://usa-api.labryofertility.com/uploads/line/acf0220bfc4241c0a4dc16c7ac25ccd9.jpg",
        "type": "interior",
        "_source": {
          "url": "https://www.labryofertility.com",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "url": "https://usa-api.labryofertility.com/uploads/line/a1be7a0910ef407189362597c7952043.jpg",
        "type": "interior",
        "_source": {
          "url": "https://www.labryofertility.com",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkTgUki7voplfbEigyzxYxF4fJ9Q7kU8V6FagNpZTAAeF_NND3NsKFJUoiJaVqzKrBe8mYPz7HYCifMqFFJntDkeQ2tVY4EkPLkAvSgrciSnPGzNtpMlHIri3iDIEfsQ1Eqmv6J=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Labryo+Fertility+Center,+2001+Westcliff+Dr+Ste+300,+Newport+Beach,+CA+92660/@33.6274142,-117.9079786,3322a,13.1y/data=!4m2!3m1!1s0x80dcdf7ee018fd91:0x91278293400a26fd",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmGCAM4Gm250DhGQigfwcitSYpjV9uczFcCBm0yFpfLf_WcnhyXY2QYA-dc8ntdJaDDIJVYPe2r48ZuPkeSULzV_pONu9mNANfXgSzO9-X-a-AUKiwc2Hdw0LGlWKft0PPRvGR8dQ=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Labryo+Fertility+Center,+2001+Westcliff+Dr+Ste+300,+Newport+Beach,+CA+92660/@33.6274142,-117.9079786,3322a,13.1y/data=!4m2!3m1!1s0x80dcdf7ee018fd91:0x91278293400a26fd",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-200",
    "externalIds": {
      "cdcClinicId": "200",
      "googlePlaceId": "ChIJEWKK15e8hYARP80P1MwKPMM"
    },
    "type": "fertility-clinic",
    "name": "Lane Fertility Institute",
    "phone": "(415) 893-0391",
    "address": {
      "line1": "101 Rowland Way, Suite 305",
      "city": "Novato",
      "state": "CA",
      "zip": "94945",
      "country": "US"
    },
    "location": {
      "lat": 38.0973,
      "lng": -122.56
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      }
    ],
    "outcomes": {
      "successRates": [],
      "cyclesPerYear": 43,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27200%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27200%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://lanefertilityinstitute.com/fertility-team/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Lane+Fertility+Institute,+101+Rowland+Way+Unit+305,+Novato,+CA+94945/@38.0973907,-122.559478,3140a,13.1y/data=!4m2!3m1!1s0x8085bc97d78a6211:0xc33c0accd40fcd3f",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://lanefertilityinstitute.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-200-danielle-lane",
        "name": "Danielle Lane",
        "role": "Medical Director",
        "imageUrl": "https://lanefertilityinstitute.com/wp-content/uploads/2024/03/UpdatedDrLaneSquare-500x500.png",
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://lanefertilityinstitute.com/fertility-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-200-sheela-ali",
        "name": "Sheela Ali",
        "credentials": ["PhD", "HCLD/TS/CC (ABB)"],
        "role": "Scientific Director",
        "imageUrl": "https://lanefertilityinstitute.com/wp-content/uploads/2022/10/Dr.-Sheela-Ali-HCLD-Scientific-Director.jpg",
        "_source": {
          "url": "https://lanefertilityinstitute.com/fertility-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-200-nika-vizcarra",
        "name": "Nika Vizcarra",
        "credentials": ["MD", "MS", "FACOG"],
        "role": "Staff Physician",
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://lanefertilityinstitute.com/wp-content/uploads/2024/01/DrNikaVizcarraHeadshotCropped-500x500.jpg",
        "_source": {
          "url": "https://lanefertilityinstitute.com/fertility-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-200-li-mei-che",
        "name": "Li Mei Che",
        "credentials": ["BS", "MS"],
        "role": "Senior Embryologist",
        "imageUrl": "https://lanefertilityinstitute.com/wp-content/uploads/2022/10/Li-Mei-Che-BS-MS-1.jpg",
        "_source": {
          "url": "https://lanefertilityinstitute.com/fertility-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-200-mary-jane-lopez",
        "name": "Mary Jane Lopez",
        "role": "Junior Embryologist",
        "imageUrl": "https://lanefertilityinstitute.com/wp-content/uploads/2022/10/Mary-Jane-Lopez.jpg",
        "_source": {
          "url": "https://lanefertilityinstitute.com/fertility-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-200-allison-chamberlaine",
        "name": "Allison Chamberlaine",
        "credentials": ["RN"],
        "role": "Director of Gestational Surrogacy",
        "imageUrl": "https://lanefertilityinstitute.com/wp-content/uploads/2022/10/Allison-Chamberlaine-RN.jpg",
        "_source": {
          "url": "https://lanefertilityinstitute.com/fertility-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-200-michelle-dang",
        "name": "Michelle Dang",
        "role": "Egg Donor Coordinator",
        "imageUrl": "https://lanefertilityinstitute.com/wp-content/uploads/2024/10/MDang_headshot-500x500.jpeg",
        "_source": {
          "url": "https://lanefertilityinstitute.com/fertility-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-200-marina-hallin",
        "name": "Marina Hallin",
        "role": "Egg Donor Coordinator",
        "imageUrl": "https://lanefertilityinstitute.com/wp-content/uploads/2024/12/Marina_Hallin_2024_01-500x500.jpeg",
        "_source": {
          "url": "https://lanefertilityinstitute.com/fertility-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-200-ann-deguire",
        "name": "Ann Deguire",
        "role": "Intake Coordinator",
        "imageUrl": "https://lanefertilityinstitute.com/wp-content/uploads/2024/10/IMG_1712-500x500.jpg",
        "_source": {
          "url": "https://lanefertilityinstitute.com/fertility-team/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://lanefertilityinstitute.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Anthem Blue Cross",
        "Blue Cross",
        "Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "HealthNet",
        "Multiplan",
        "Horizon",
        "SutterSelect",
        "BCBS",
        "Medicare"
      ],
      "employeeBenefits": ["Kindbody"],
      "_source": {
        "url": "https://lanefertilityinstitute.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": [
      "English",
      "Mandarin",
      "Chinese",
      "French",
      "Portuguese",
      "Italian",
      "German"
    ],
    "description": "Lane Fertility Institute is a boutique fertility practice founded in 2009 by Dr. Danielle Lane to make fertility treatments available to all aspiring parents, serving patients throughout Northern California and beyond. The team offers a full scope of fertility treatments including IUI, IVF, fertility preservation, alternative family planning, and PGD/PGS, and is one of the few fertility clinics in the country with its own in-house egg bank. Dr. Lane and her fertility team pride themselves on high-touch, compassionate care.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross, Blue Cross, Blue Shield, Cigna, United Healthcare, Humana, HealthNet",
              "detail": "5 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://lanefertilityinstitute.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-19",
    "externalIds": {
      "cdcClinicId": "19",
      "googlePlaceId": "ChIJSVPJsOqAhYARJQOLk_q-83c"
    },
    "type": "fertility-clinic",
    "name": "Laurel Fertility Care",
    "phone": "(415) 673-9199",
    "address": {
      "line1": "1700 California St, Suite 570",
      "city": "San Francisco",
      "state": "CA",
      "zip": "94109",
      "country": "US"
    },
    "location": {
      "lat": 37.7905,
      "lng": -122.423
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 37.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 32.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 32.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 265,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2719%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://nass.cdc.gov",
            "fetchedAt": "2024-01-01"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2719%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://laurelfertility.com/locations/san-francisco/",
            "fetchedAt": "2026-03-11"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://laurelfertility.com/locations/san-francisco/",
            "fetchedAt": "2026-03-11"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://laurelfertility.com/locations/san-francisco/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://laurelfertility.com/locations/san-francisco/",
            "fetchedAt": "2026-06-10"
          }
        },
        "insurance": {
          "status": "scraped",
          "source": {
            "url": "https://laurelfertility.com/locations/san-francisco/",
            "fetchedAt": "2026-03-11"
          }
        },
        "consultationTypes": {
          "status": "scraped",
          "source": {
            "url": "https://laurelfertility.com/locations/san-francisco/",
            "fetchedAt": "2026-03-11"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Laurel+Fertility+Care-+San+Francisco,+1700+California+St+%23570,+San+Francisco,+CA+94109/@37.790523,-122.4230564,3153a,13.1y/data=!4m2!3m1!1s0x808580eab0c95349:0x77f3befa938b0325",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-19-collin-smikle",
        "name": "Collin Smikle",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Founder & Medical Director",
        "imageUrl": "https://laurelfertility.com/wp-content/uploads/2025/07/meet-dr-smikle.png",
        "_source": {
          "url": "https://laurelfertility.com/locations/san-francisco/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-19-leslie-barahona",
        "name": "Leslie Barahona",
        "credentials": ["MSN", "APRN", "FNP-BC"],
        "role": "Nurse Practitioner",
        "imageUrl": "https://laurelfertility.com/wp-content/uploads/2025/07/meet-leslie.png",
        "_source": {
          "url": "https://laurelfertility.com/locations/modesto/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://laurelfertility.com",
    "description": "Fertility care that sees you — personalized, compassionate treatment for IVF, egg freezing, LGBTQ+ family building, and more.",
    "bookingUrl": "https://laurelfertility.com/contact-us/",
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "17:00"
      },
      "tue": {
        "open": "08:00",
        "close": "17:00"
      },
      "wed": {
        "open": "08:00",
        "close": "17:00"
      },
      "thu": {
        "open": "08:00",
        "close": "17:00"
      },
      "fri": {
        "open": "08:00",
        "close": "17:00"
      },
      "sat": null,
      "sun": null
    },
    "consultationTypes": ["in-person"],
    "patientGroups": ["LGBTQ+ friendly"],
    "languages": ["English", "Spanish", "Punjabi", "Farsi", "Chinese"],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://laurelfertility.com/locations/san-francisco/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Anthem Blue Cross",
        "Blue Shield of California",
        "Brown & Toland HMO",
        "Cigna Healthcare",
        "First Health Network",
        "Great West Healthcare",
        "Health Net",
        "Hill Physicians Medical Group",
        "Sutter Select",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "WINFertility"]
    },
    "images": [
      {
        "url": "https://laurelfertility.com/wp-content/uploads/2025/07/locations-sf-clinic.png",
        "type": "exterior"
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnNZdgbahH-GG_D2xJPAIDbTEsAHN4dFH3bSKoaD7b0Xx9wi7j_LyNnlOKfGr_2eizcNDVrprRK6pXL79lXYiZdSo_18XYgqOpsckrYgxGY3ezfjJGrJvus_NUjsaYu-Ei67Euu=w408-h334-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Laurel+Fertility+Care-+San+Francisco,+1700+California+St+%23570,+San+Francisco,+CA+94109/@37.790523,-122.4230564,3153a,13.1y/data=!4m2!3m1!1s0x808580eab0c95349:0x77f3befa938b0325",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkgjyKALoW1QodqbhGvcpIS2llC6zIqdfxpukmwOhYk_vTEjv3HSJO4-Iw0UOTdY2ZuIZv0pfcL5wSDja3GHa3_CoKBbAszpuB5r_Uu3-00TZ-unbR8YymWKXCyl2EUDlJ07J-okg=w448-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Laurel+Fertility+Care-+San+Francisco,+1700+California+St+%23570,+San+Francisco,+CA+94109/@37.790523,-122.4230564,3153a,13.1y/data=!4m2!3m1!1s0x808580eab0c95349:0x77f3befa938b0325",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross, Blue Shield of California, Brown & Toland HMO, Cigna Healthcare, First Health Network, Great West Healthcare, Health Net",
              "detail": "4 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://laurelfertility.com/locations/san-francisco/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-7",
    "externalIds": {
      "cdcClinicId": "7",
      "googlePlaceId": "ChIJY7UsaDHc3IARLAa7gX9tUOQ"
    },
    "type": "fertility-clinic",
    "name": "Life IVF Center",
    "description": "Boutique fertility center specializing in Natural Cycle and Minimal Stimulation IVF with transparent flat-fee pricing, welcoming patients regardless of age, AMH, or FSH levels.",
    "website": "https://lifeivfcenter.com/",
    "phone": "(949) 788-1133",
    "email": "info@lifeivfcenter.com",
    "bookingUrl": "https://lifeivfcenter.com/home/book-consultation/",
    "address": {
      "line1": "3500 Barranca Pkwy, Suite 300",
      "city": "Irvine",
      "state": "CA",
      "zip": "92606",
      "country": "US"
    },
    "location": {
      "lat": 33.6863,
      "lng": -117.815
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "miniIVF"
      }
    ],
    "insurance": {
      "accepted": true,
      "financingOptions": ["Package pricing", "Discount pricing"]
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 59,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 55,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 55.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 18.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 2030,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%277%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "languages": ["English", "es", "zh", "ko", "ja", "vi"],
    "consultationTypes": ["in-person", "telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents"],
    "isFirstConsultationFree": true,
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%277%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "scraped"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://lifeivfcenter.com/about-us/team/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Life+IVF+Center,+3500+Barranca+Pkwy+%23300,+Irvine,+CA+92606/@33.6864396,-117.815138,3320a,13.1y/data=!4m2!3m1!1s0x80dcdc31682cb563:0xe4506d7f81bb062c",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://lifeivfcenter.com/",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-7-frank-yelian",
        "name": "Frank Yelian",
        "role": "Medical Director",
        "imageUrl": "https://lifeivfcenter.com/wp-content/uploads/2023/01/Group-1261152299.png",
        "credentials": ["MD", "PhD"],
        "specialty": "Fertility Specialist",
        "_source": {
          "url": "https://lifeivfcenter.com/about-us/team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-7-tsung-chieh-jackson-wu",
        "name": "Tsung-Chieh Jackson Wu",
        "credentials": ["MD"],
        "role": "Fertility Specialist",
        "imageUrl": "https://lifeivfcenter.com/wp-content/uploads/2023/07/Rectangle-26575.png",
        "_source": {
          "url": "https://lifeivfcenter.com/about-us/team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-7-salman-okour",
        "name": "Salman Okour",
        "credentials": ["MD"],
        "role": "Fertility Specialist",
        "imageUrl": "https://lifeivfcenter.com/wp-content/uploads/2026/05/Dr.-Okour.png",
        "_source": {
          "url": "https://lifeivfcenter.com/about-us/team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-7-vivian-duong",
        "name": "Vivian Duong",
        "credentials": ["MSN", "FNP-BC"],
        "role": "Nurse Practitioner",
        "imageUrl": "https://lifeivfcenter.com/wp-content/uploads/2026/05/Vivian.png",
        "_source": {
          "url": "https://lifeivfcenter.com/about-us/team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-7-michelle-yu",
        "name": "Michelle Yu",
        "credentials": ["MD", "FACOG"],
        "role": "Fertility Specialist",
        "imageUrl": "https://lifeivfcenter.com/wp-content/uploads/2026/05/Dr.-Yu.png",
        "_source": {
          "url": "https://lifeivfcenter.com/about-us/team/dr-michelle-yu/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-7-samira-shir",
        "name": "Samira Shir",
        "credentials": ["MSN", "FNP-BC"],
        "role": "Nurse Practitioner",
        "imageUrl": "https://lifeivfcenter.com/wp-content/uploads/2026/05/Samira.png",
        "_source": {
          "url": "https://lifeivfcenter.com/about-us/team/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlf1KUCfuLcclv4w-xogYmN411zIBgVy1PS2J24SQUykwR-dBwUb1Tn6mt3GGfUba8Y3iOjwzA4FW8_AI46UjXEPAfL8sbyNXJFifPiQkxLV5lXQcY2e2LW9hQGFF1qjWSgyY_cAfhBviaD=w530-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Life+IVF+Center,+3500+Barranca+Pkwy+%23300,+Irvine,+CA+92606/@33.6864396,-117.815138,3320a,13.1y/data=!4m2!3m1!1s0x80dcdc31682cb563:0xe4506d7f81bb062c",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmLzrFk2jwuA_Uf8DquHQgrBZ-vShXxlVW7jb5MlAFMGF2Ebax6EanJkKA7OtlYyoUid9AjJxtmJ6US7EW7Nyrg9ev_lX6nDHGsmZGiivawUjb4_uqooPRVkxQ8MQq1Cz-sPRVfhg=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Life+IVF+Center,+3500+Barranca+Pkwy+%23300,+Irvine,+CA+92606/@33.6864396,-117.815138,3320a,13.1y/data=!4m2!3m1!1s0x80dcdc31682cb563:0xe4506d7f81bb062c",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-207",
    "externalIds": {
      "cdcClinicId": "207",
      "googlePlaceId": "ChIJfddVbgIk6IARZDUslvNfl3E"
    },
    "type": "fertility-clinic",
    "name": "LifeStart Fertility Center",
    "phone": "(818) 889-4532",
    "address": {
      "line1": "29525 Canwood St, Suite 210",
      "city": "Agoura Hills",
      "state": "CA",
      "zip": "91301",
      "country": "US"
    },
    "location": {
      "lat": 34.148,
      "lng": -118.767
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 6,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27207%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27207%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.lifestartfertility.com/about-us",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Lifestart+Fertility+Center:+Anita+Singh,+MD,+29525+Canwood+St+Unit+210,+Agoura+Hills,+CA+91301/@34.1480175,-118.7672994,3302a,13.1y/data=!4m2!3m1!1s0x80e824026e55d77d:0x71975ff3962c3564",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.lifestartfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-207-anita-p-singh-md",
        "name": "Anita P. Singh, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.lifestartfertility.com/images/Dr_Singh3.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.lifestartfertility.com/dr-anita-singh",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.lifestartfertility.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "description": "LifeStart Fertility Center is an infertility and IVF practice in Agoura Hills, in the greater Los Angeles area, opened by Dr. Anita Singh in 2005. Dr. Singh, a board certified Reproductive Endocrinologist and Infertility Specialist who formerly chaired the Division of Reproductive Endocrinology & Infertility at the Mayo Clinic in Scottsdale, leads a staff of highly trained professionals providing personalized fertility care. The center has provided IVF and infertility services to patients locally and from around the world and is currently accepting new patients at its Agoura Hills location.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlTNfnTJNzzXT9Y7NtBy5Uo00pCREigyE80ooC0ivX8wnDLEj8YowgCGa4SYC5IubPCVF2KFfqykHe-HtEZPwz-rkpc45bUIzv59bsNmLV00G1Wo-6JEwwrd1OJa3Vbc4W3C_A=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Lifestart+Fertility+Center:+Anita+Singh,+MD,+29525+Canwood+St+Unit+210,+Agoura+Hills,+CA+91301/@34.1480175,-118.7672994,3302a,13.1y/data=!4m2!3m1!1s0x80e824026e55d77d:0x71975ff3962c3564",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-199",
    "externalIds": {
      "cdcClinicId": "199",
      "googlePlaceId": "ChIJL572MImr3IARZs6SJXm0XG8"
    },
    "type": "fertility-clinic",
    "name": "Loma Linda University Center for Fertility and IVF",
    "phone": "(440) 212-3625",
    "address": {
      "line1": "Department of Gynecology and Obstetrics, 11370 Anderson St, Suite 3950",
      "city": "Loma Linda",
      "state": "CA",
      "zip": "92354",
      "country": "US"
    },
    "location": {
      "lat": 34.0472,
      "lng": -117.262
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 57.89473684210527,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "11/19"
        },
        {
          "ageBand": "38-40",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/10"
        }
      ],
      "cyclesPerYear": 86,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27199%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27199%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Loma+Linda+University+Center+for+Fertility+%26+IVF,+11370+Anderson+St+%233950,+Loma+Linda,+CA+92354/@34.04717,-117.262044,3306a,13.1y/data=!4m2!3m1!1s0x80dcab8930f69e2f:0x6f5cb4792592ce66",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://lomalindafertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [],
    "website": "https://lomalindafertility.com",
    "insurance": {
      "accepted": true,
      "carriers": ["Kaiser Permanente", "Tricare", "Empire"],
      "_source": {
        "url": "https://lomalindafertility.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "description": "Loma Linda University Center for Fertility & IVF has provided personalized fertility care in the Inland Empire area for more than 30 years and is one of the longest standing fertility centers in Southern California. As part of the Loma Linda University Health system, it offers university-level care with on-site services including infertility testing, reproductive surgery, egg retrievals, embryo transfers, and IVF, and is a top referral fertility center in Southern California for complex infertility cases. The center welcomes privately insured and managed care patients as well as veterans.",
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Kaiser Permanente, Tricare, Empire",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://lomalindafertility.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmR0JoYcwth8y_UtyQHeLlD8CXSgmNo9pl0cqA7tLXL45Fizl5TD2XW70S0LXRE7Taz6m4u0xvpQkbUT_jB1P2Itsp9L51T-biqzodAyhg4JatrQjxxyFvUI6qLGWEuKgFP_tFE=w856-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Loma+Linda+University+Center+for+Fertility+%26+IVF,+11370+Anderson+St+%233950,+Loma+Linda,+CA+92354/@34.04717,-117.262044,3306a,13.1y/data=!4m2!3m1!1s0x80dcab8930f69e2f:0x6f5cb4792592ce66",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-710",
    "externalIds": {
      "cdcClinicId": "710"
    },
    "type": "fertility-clinic",
    "name": "Los Angeles Reproductive Center (LARC)",
    "phone": "(818) 946-8051",
    "address": {
      "line1": "16055 Ventura Blvd, Suite 1127",
      "city": "Encino",
      "state": "CA",
      "zip": "91436",
      "country": "US"
    },
    "location": {
      "lat": 34.1568,
      "lng": -118.483
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 54.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 56.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "9/18"
        },
        {
          "ageBand": ">40",
          "rate": 47.368421052631575,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "9/19"
        }
      ],
      "cyclesPerYear": 235,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27710%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27710%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.losangelesreproductivecenter.com/meet-the-team",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.losangelesreproductivecenter.com/meet-the-team",
            "fetchedAt": "2026-06-10"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.losangelesreproductivecenter.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-710-nurit-winkler",
        "name": "Nurit Winkler",
        "role": "co-founder and co-owner",
        "imageUrl": "https://a.storyblok.com/f/290132/851x851/0d0c810719/nurit-winkler.jpg",
        "specialty": "Double Board-Certified Fertility Specialist & International Reproductive Expert",
        "_source": {
          "url": "https://www.losangelesreproductivecenter.com/doctors/dr-nurit-winkler",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-710-marc-kalan",
        "name": "Marc Kalan",
        "role": "co-founder",
        "specialty": "Double Board-Certified Reproductive Endocrinologist & Fertility Specialist",
        "imageUrl": "https://a.storyblok.com/f/290132/918x918/2353df0280/marc-kalan.png",
        "_source": {
          "url": "https://www.losangelesreproductivecenter.com/doctors/dr-marc-kalan",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.losangelesreproductivecenter.com",
    "description": "\"I am trying to change the conversation away from 'I hope you never have to go through IVF' to 'it's incredibly empowering and an amazing option.'",
    "languages": ["Mandarin", "Italian", "Hebrew", "English"],
    "images": [
      {
        "url": "https://a.storyblok.com/f/290132/5184x3456/422562fb28/larc-lobby-uncropped.jpg",
        "type": "interior",
        "_source": {
          "url": "https://www.losangelesreproductivecenter.com/locations/our-encino-clinic",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "network": {
      "name": "Ivy Fertility"
    },
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-65",
    "externalIds": {
      "cdcClinicId": "65"
    },
    "type": "fertility-clinic",
    "name": "Marin Fertility Center",
    "phone": "(415) 925-9404",
    "address": {
      "line1": "1100 S. Eliseo Dr, Suite 107",
      "city": "Greenbrae",
      "state": "CA",
      "zip": "94904",
      "country": "US"
    },
    "location": {
      "lat": 37.9439,
      "lng": -122.534
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 48,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 52.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 47.05882352941176,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "8/17"
        }
      ],
      "cyclesPerYear": 176,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2765%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2765%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://marinfertilitycenter.com",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://marinfertilitycenter.com",
            "fetchedAt": "2026-06-10"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://marinfertilitycenter.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-65-peter-uzelac",
        "name": "Peter Uzelac",
        "role": "Medical Director",
        "imageUrl": "https://marinfertilitycenter.com/wp-content/uploads/2023/12/image-155.png",
        "credentials": ["MD", "HCLD"],
        "_source": {
          "url": "https://marinfertilitycenter.com/providers",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-65-joy-brotherton",
        "name": "Joy Brotherton",
        "credentials": ["MD"],
        "role": "Director of Egg Freezing and Fertility Surgery",
        "imageUrl": "https://marinfertilitycenter.com/wp-content/uploads/2024/10/Skype_Picture_2024_10_23T14_53_51_316Z.jpeg",
        "_source": {
          "url": "https://marinfertilitycenter.com/providers",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-65-kirsten-eckert",
        "name": "Kirsten Eckert",
        "credentials": ["WHNP"],
        "role": "Third-Party Reproduction & Genetic Carrier Program Lead",
        "imageUrl": "https://marinfertilitycenter.com/wp-content/uploads/2023/12/image-154.jpg",
        "_source": {
          "url": "https://marinfertilitycenter.com/providers",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://marinfertilitycenter.com",
    "description": "MFC was founded on a commitment to offering the very latest assisted reproductive technology and has a long track record of many regional “firsts”. Learn more here about specific IVF variations here",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross",
        "Blue Shield",
        "Cigna",
        "Health Net",
        "Kaiser Permanente",
        "Brown & Toland"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Future Family"],
      "_source": {
        "url": "https://marinfertilitycenter.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "images": [],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross, Blue Shield, Cigna, Health Net, Kaiser Permanente, Brown & Toland",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://marinfertilitycenter.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-210",
    "externalIds": {
      "cdcClinicId": "210"
    },
    "type": "fertility-clinic",
    "name": "Newport Fertility Center",
    "phone": "(949) 222-1290",
    "address": {
      "line1": "3501 Jamboree Rd, Suite 1100",
      "city": "Newport Beach",
      "state": "CA",
      "zip": "92660",
      "country": "US"
    },
    "location": {
      "lat": 33.6549,
      "lng": -117.866
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 71.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 55.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 44.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/10"
        }
      ],
      "cyclesPerYear": 254,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27210%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "scraped-retry",
      "date": "2026-03-11",
      "sections": {
        "images": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27210%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-210-sina-abhari-md",
        "name": "Sina Abhari, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.ccrmivf.com/location/us/california/newport-beach/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "languages": ["English"],
    "setting": "network-group",
    "bookingUrl": "https://www.ccrmivf.com/location/us/california/newport-beach/",
    "consultationTypes": ["in-person", "telehealth"],
    "description": "CCRM Fertility of Newport Beach serves Orange County with world-class fertility care. Part of the nationally recognized CCRM network known for pioneering fertility research.",
    "network": {
      "name": "CCRM Fertility"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-424",
    "externalIds": {
      "cdcClinicId": "424",
      "googlePlaceId": "ChIJ41CdZxAgm4ARe-cD-7_ks8M"
    },
    "type": "fertility-clinic",
    "name": "Northern California Fertility Medical Center",
    "phone": "(916) 773-2229",
    "address": {
      "line1": "4320 Auburn Blvd",
      "city": "Sacramento",
      "state": "CA",
      "zip": "95841",
      "country": "US"
    },
    "location": {
      "lat": 38.6447,
      "lng": -121.363
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 64.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 57.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 59.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 31.25,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/16"
        }
      ],
      "cyclesPerYear": 679,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27424%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27424%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://ncfmc.com/meet-the-team",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Northern+California+Fertility+Medical+Center,+4320+Auburn+Blvd,+Sacramento,+CA+95841/@38.6446994,-121.3632219,3116a,13.1y/data=!4m2!3m1!1s0x809b2010679d50e3:0xc3b3e4bffb03e77b",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://ncfmc.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-424-michael-j-murray",
        "name": "Michael J. Murray",
        "role": "Medical Director",
        "imageUrl": "https://a.storyblok.com/f/290132/1500x2100/82e2f497ff/michael-murray-m-d.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://ncfmc.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-424-manuel-a-doblado",
        "name": "Manuel A. Doblado",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/1500x2100/2545ddf4c6/manuel-doblado-m-d.jpg",
        "_source": {
          "url": "https://ncfmc.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-424-sahar-m-stephens",
        "name": "Sahar M. Stephens",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/1500x2100/0bc0dcfbdc/sahar-stephens-m-d.jpg",
        "_source": {
          "url": "https://ncfmc.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-424-philip-chenette",
        "name": "Philip Chenette",
        "credentials": ["M.D."],
        "imageUrl": "https://a.storyblok.com/f/290132/2466x2612/d9b28ee768/philip-chenette-m-d.jpg",
        "_source": {
          "url": "https://ncfmc.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-424-suzanne-e-generao",
        "name": "Suzanne E. Generao",
        "credentials": ["MD"],
        "specialty": "urologist and male fertility specialist",
        "imageUrl": "https://a.storyblok.com/f/290132/2418x2925/600b88d457/dr-genereao.jpg",
        "_source": {
          "url": "https://ncfmc.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-424-angela-brooks",
        "name": "Angela Brooks",
        "credentials": ["FNP-C"],
        "role": "Fertility Specialist Nurse Practitioner",
        "imageUrl": "https://a.storyblok.com/f/290132/1995x2360/cf7ea8358c/angela-brooks.png",
        "_source": {
          "url": "https://ncfmc.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-424-celeste-hill",
        "name": "Celeste Hill",
        "credentials": ["PA-C"],
        "role": "Physician Assistant",
        "specialty": "fertility",
        "imageUrl": "https://a.storyblok.com/f/290132/3072x4080/efc58da9a0/celeste-hill-pa-2024.jpg",
        "_source": {
          "url": "https://ncfmc.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-424-maria-tuite",
        "name": "Maria Tuite",
        "credentials": ["WHNP-C"],
        "role": "women's health nurse practitioner",
        "imageUrl": "https://a.storyblok.com/f/290132/2537x2547/6baf26b625/maria-tuite.jpg",
        "_source": {
          "url": "https://ncfmc.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-424-fiona-wang",
        "name": "Fiona Wang",
        "credentials": ["PA-C"],
        "role": "physician assistant",
        "specialty": "comprehensive care of patients undergoing fertility evaluation and treatments",
        "imageUrl": "https://a.storyblok.com/f/290132/3072x4080/5e4bae627e/fiona-wang-pa-c.jpg",
        "_source": {
          "url": "https://ncfmc.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://ncfmc.com",
    "description": "Parenthood knows no borders; patients come to Northern California Fertility Medical Center from all over the globe to experience our next\\-level standards of care. With easy access to Sacramento International Airport and at the gateway of everything Northern California has to offer, we'll help you feel at home while building your family.",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross",
        "Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Optum",
        "Sutter Select"
      ],
      "employeeBenefits": ["Progyny", "Maven", "Future Family"],
      "_source": {
        "url": "https://ncfmc.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "network": {
      "name": "Ivy Fertility"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross, Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Optum, Sutter Select",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://ncfmc.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-460",
    "externalIds": {
      "cdcClinicId": "460",
      "googlePlaceId": "ChIJAQAAAPC5j4ARSJ90Sc56y-o"
    },
    "type": "fertility-clinic",
    "name": "Nova In Vitro Fertilization",
    "phone": "(650) 325-6682",
    "address": {
      "line1": "2500 Hospital Dr, Bldg 7",
      "city": "Mountain View",
      "state": "CA",
      "zip": "94040",
      "country": "US"
    },
    "location": {
      "lat": 37.3683,
      "lng": -122.082
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 48.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 63.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 42.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 167,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27460%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27460%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.novaivf.com/about",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/NOVA+IVF,+2500+Hospital+Dr+Bldg+7,+Mountain+View,+CA+94040/@37.3682728,-122.0824633,3171a,13.1y/data=!4m2!3m1!1s0x808fb9f000000001:0xeacb7ace49749f48",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.novaivf.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-460-richard-j-schmidt",
        "name": "Richard J. Schmidt",
        "role": "medical director and laboratory program director",
        "imageUrl": "https://a.storyblok.com/f/290132/664x664/6247a29c36/richard-schmidt.jpg",
        "credentials": ["MD", "FACOG"],
        "specialty": "reproductive endocrinology and fertility specialist",
        "_source": {
          "url": "https://www.novaivf.com/doctors/richard-schmidt-md",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-460-meera-shah",
        "name": "Meera Shah",
        "credentials": ["MD", "FACOG"],
        "specialty": "reproductive endocrinology and fertility specialist",
        "imageUrl": "https://a.storyblok.com/f/290132/680x680/1f858b7c3e/meera-shah.png",
        "_source": {
          "url": "https://www.novaivf.com/doctors/meera-shah-md-facog",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-460-anna-sokalska",
        "name": "Anna Sokalska",
        "credentials": ["M.D.", "Ph.D."],
        "specialty": "board-certified reproductive endocrinologist and infertility specialist",
        "imageUrl": "https://a.storyblok.com/f/290132/952x904/b2111cc206/anna-sokalska.jpg",
        "_source": {
          "url": "https://www.novaivf.com/doctors/anna-sokalska-m-d-ph-d",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.novaivf.com",
    "description": "Innovative, world\\-class care with a supportive team of experts who are committed to your success.",
    "languages": ["English"],
    "network": {
      "name": "Ivy Fertility"
    },
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm2eZa5IE77zHsRZXUfcBAsk1UXeP7xHbi6OTWiTHDKnWC-0g2kSFs8IEIG8iEfyEfALSTEmAuvyTYbQM8zR7lc3ACHngwIvNkhoH-sayhUJfN95bko3L8tO3wrXSlwdi8snek9=w408-h271-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/NOVA+IVF,+2500+Hospital+Dr+Bldg+7,+Mountain+View,+CA+94040/@37.3682728,-122.0824633,3171a,13.1y/data=!4m2!3m1!1s0x808fb9f000000001:0xeacb7ace49749f48",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-317",
    "externalIds": {
      "cdcClinicId": "317",
      "googlePlaceId": "ChIJIyoe4I7g3IARxj2kwiqOHcY"
    },
    "type": "fertility-clinic",
    "name": "OC Fertility",
    "phone": "(949) 706-2229",
    "address": {
      "line1": "1401 Avocado Ave, Suite 403",
      "city": "Newport Beach",
      "state": "CA",
      "zip": "92660",
      "country": "US"
    },
    "location": {
      "lat": 33.6125,
      "lng": -117.871
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 62.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 65,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 53.84615384615385,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/13"
        }
      ],
      "cyclesPerYear": 166,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27317%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "scraped-retry",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ocfertility.com/about-us/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/OC+Fertility%C2%AE+%2B+OC+Biogenix%C2%AE,+1401+Avocado+Ave+%23403,+Newport+Beach,+CA+92660/@33.612523,-117.8707,3323a,13.1y/data=!4m2!3m1!1s0x80dce08ee01e2a23:0xc61d8e2ac2a43dc6",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27317%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-317-sharon-e-moayeri-md",
        "name": "Sharon E. Moayeri, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.ocfertility.com/wp-content/uploads/2026/01/DSC04745-scaled.jpg",
        "credentials": ["MD", "MPH", "MS", "FACOG"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "_source": {
          "url": "https://www.ocfertility.com/provider/sharon-e-moayeri-md/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-317-jamie-hainlen",
        "name": "Jamie Hainlen",
        "credentials": ["MSN", "APRN", "FNP-C"],
        "role": "Family Nurse Practitioner • Reproductive Health Specialist",
        "imageUrl": "https://www.ocfertility.com/wp-content/uploads/2025/09/Jamie-Hainlen-Bio-Pic-scaled.jpg",
        "_source": {
          "url": "https://www.ocfertility.com/provider/jamie-hainlen/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-317-antoine-la",
        "name": "Antoine La",
        "credentials": ["ELD"],
        "role": "Board-Certified Embryology Laboratory Director",
        "imageUrl": "https://www.ocfertility.com/wp-content/uploads/2026/04/Antoine-Website-Bio-Pic-1-1-scaled.png",
        "_source": {
          "url": "https://www.ocfertility.com/provider/antoine-la/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.ocfertility.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "images": [
      {
        "url": "https://www.ocfertility.com/wp-content/uploads/2025/09/image-scaled.png",
        "type": "interior"
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkmjdI6gQuqlTsB1Uat0XslOOtutMkML3wnf78-oKE_C-t_6-HeJekQlAZq57UwgSLEyPUoxLQIktBuWbTIkPIbvoxjaNTlRnBJXmHPVPr0Os94RXL_RMnJc6gr9FfNcBzAKOzYAA=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/OC+Fertility%C2%AE+%2B+OC+Biogenix%C2%AE,+1401+Avocado+Ave+%23403,+Newport+Beach,+CA+92660/@33.612523,-117.8707,3323a,13.1y/data=!4m2!3m1!1s0x80dce08ee01e2a23:0xc61d8e2ac2a43dc6",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmhrnuO_unwPJ4kItB6wXOrxsU6lMe0u0BYDIpCEBrz4oo4keLIVVA_z0XickaoYcU80w18uwKWpFlxLRNbJBpllSH0e-jPep-kF931k7TjIVujPffRzW_2v4dKwHv7iYyukF35=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/OC+Fertility%C2%AE+%2B+OC+Biogenix%C2%AE,+1401+Avocado+Ave+%23403,+Newport+Beach,+CA+92660/@33.612523,-117.8707,3323a,13.1y/data=!4m2!3m1!1s0x80dce08ee01e2a23:0xc61d8e2ac2a43dc6",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "description": "OC Fertility + OC Biogenix in Newport Beach, California, is an independent, women-owned fertility practice offering fertility care and advanced laboratory services. The practice combines a fertility clinic, laboratory, and surgery center in one location, with a team fellowship-trained in reproductive endocrinology, infertility, embryology, and anesthesiology. Telehealth consults are available beyond regular business hours.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-214",
    "externalIds": {
      "cdcClinicId": "214"
    },
    "type": "fertility-clinic",
    "name": "Pacific Fertility Center",
    "phone": "(415) 834-3000",
    "address": {
      "line1": "55 Francisco St, Suite 500",
      "city": "San Francisco",
      "state": "CA",
      "zip": "94133",
      "country": "US"
    },
    "location": {
      "lat": 37.8054,
      "lng": -122.406
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 48.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 52.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 49.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 39.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 487,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27214%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://nass.cdc.gov",
            "fetchedAt": "2024-01-01"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27214%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.pacificfertilitycenter.com/fertility-specialists",
            "fetchedAt": "2026-03-11"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://www.pacificfertilitycenter.com/fertility-specialists",
            "fetchedAt": "2026-03-11"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://www.pacificfertilitycenter.com/fertility-specialists",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pacificfertilitycenter.com/our-fertility-clinics/san-francisco-fertility-center",
            "fetchedAt": "2026-06-10"
          }
        },
        "insurance": {
          "status": "scraped",
          "source": {
            "url": "https://www.pacificfertilitycenter.com/fertility-specialists",
            "fetchedAt": "2026-03-11"
          }
        },
        "consultationTypes": {
          "status": "scraped",
          "source": {
            "url": "https://www.pacificfertilitycenter.com/fertility-specialists",
            "fetchedAt": "2026-03-11"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.pacificfertilitycenter.com/our-fertility-clinics/san-francisco-fertility-center",
            "fetchedAt": "2026-06-10"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-214-jennifer-agard",
        "name": "Jennifer Agard",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Fertility Specialist",
        "imageUrl": "https://cdn.buttercms.com/tDqpFyofSsGsLMjIRZC1",
        "_source": {
          "url": "https://www.pacificfertilitycenter.com/fertility-specialists",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-cdc-214-liyun-li",
        "name": "Liyun Li",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Fertility Specialist",
        "imageUrl": "https://cdn.buttercms.com/RH1YmrkmQwqX1va6oONl",
        "_source": {
          "url": "https://www.pacificfertilitycenter.com/fertility-specialists",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-cdc-214-isabelle-p-ryan",
        "name": "Isabelle P. Ryan",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Fertility Specialist",
        "imageUrl": "https://cdn.buttercms.com/Ts9z9tNXRVisxnibVcyF",
        "_source": {
          "url": "https://www.pacificfertilitycenter.com/fertility-specialists",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-cdc-214-michael-strug",
        "name": "Michael Strug",
        "credentials": ["DO", "PhD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Fertility Specialist",
        "imageUrl": "https://cdn.buttercms.com/zkTDCNybR7mtXNDcvAJP",
        "_source": {
          "url": "https://www.pacificfertilitycenter.com/fertility-specialists",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-cdc-214-brent-monseur",
        "name": "Brent Monseur",
        "credentials": ["MD", "ScM", "FACOG"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Fertility Specialist",
        "imageUrl": "https://cdn.buttercms.com/2SACBfvTxuFgeDrsN45X",
        "_source": {
          "url": "https://www.pacificfertilitycenter.com/fertility-specialists",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-cdc-214-michael-baker",
        "name": "Michael Baker",
        "credentials": ["PhD", "HCLD"],
        "specialty": "Embryology",
        "role": "Clinical Laboratory Director",
        "_source": {
          "url": "https://www.pacificfertilitycenter.com/fertility-specialists/michael-baker-phd-hcld",
          "fetchedAt": "2026-06-10"
        },
        "imageUrl": "https://cdn.buttercms.com/EGIcUrGJQcWpQRyRrBI3"
      },
      {
        "practitionerId": "pr-org-cdc-214-angela-benirschke",
        "name": "Angela Benirschke",
        "credentials": ["WHNP"],
        "specialty": "Women's Health",
        "role": "Nurse Practitioner",
        "_source": {
          "url": "https://www.pacificfertilitycenter.com/fertility-specialists/angela-benirschke-whnp",
          "fetchedAt": "2026-06-10"
        },
        "imageUrl": "https://cdn.buttercms.com/DDad77nQRRKqEPnJB24G"
      },
      {
        "practitionerId": "pr-org-cdc-214-rebecca-rich",
        "name": "Rebecca Rich",
        "credentials": ["WHNP"],
        "specialty": "Women's Health",
        "role": "Nurse Practitioner",
        "_source": {
          "url": "https://www.pacificfertilitycenter.com/fertility-specialists/rebecca-rich-whnp",
          "fetchedAt": "2026-06-10"
        },
        "imageUrl": "https://cdn.buttercms.com/1NNsVlVwSYeVjyxHJimV"
      }
    ],
    "website": "https://www.pacificfertilitycenter.com",
    "description": "Award-winning San Francisco Bay Area fertility clinic that has built all kinds of families for over 40 years, providing comprehensive reproductive care including IVF, egg freezing, genetic testing, and LGBTQ+ services.",
    "bookingUrl": "https://book.pacificfertilitycenter.com/",
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "17:00"
      },
      "tue": {
        "open": "08:00",
        "close": "17:00"
      },
      "wed": {
        "open": "08:00",
        "close": "17:00"
      },
      "thu": {
        "open": "08:00",
        "close": "17:00"
      },
      "fri": {
        "open": "08:00",
        "close": "17:00"
      },
      "sat": null,
      "sun": null
    },
    "consultationTypes": ["in-person", "telehealth"],
    "languages": ["English", "Mandarin Chinese"],
    "patientGroups": ["LGBTQ+ friendly"],
    "network": {
      "name": "Prelude Network"
    },
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.pacificfertilitycenter.com/fertility-specialists",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "United Healthcare",
        "Aetna",
        "Blue Shield of California",
        "Cigna",
        "Humana",
        "Health Net",
        "Multiplan",
        "Brown & Toland HMO",
        "SutterSelect"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven"]
    },
    "images": [
      {
        "url": "https://cdn.buttercms.com/KCQTyTUKfRTIo0H1NAgz",
        "type": "exterior",
        "caption": "Pacific Fertility Center building, San Francisco",
        "_source": {
          "url": "https://www.pacificfertilitycenter.com/fertility-specialists",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "url": "https://cdn.buttercms.com/xBdlc5QcSeM0yAR0m6NX",
        "type": "interior",
        "caption": "Pacific Fertility Center waiting area",
        "_source": {
          "url": "https://www.pacificfertilitycenter.com/fertility-specialists",
          "fetchedAt": "2026-03-11"
        }
      }
    ],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "United Healthcare, Aetna, Blue Shield of California, Cigna, Humana, Health Net, Multiplan, Brown & Toland HMO",
              "detail": "1 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.pacificfertilitycenter.com/fertility-specialists",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-99",
    "externalIds": {
      "cdcClinicId": "99"
    },
    "type": "fertility-clinic",
    "name": "Pacific Fertility Center-Los Angeles",
    "phone": "(310) 209-7700",
    "address": {
      "line1": "10880 Wilshire Blvd, Suite 300",
      "city": "Los Angeles",
      "state": "CA",
      "zip": "90024",
      "country": "US"
    },
    "location": {
      "lat": 34.0591,
      "lng": -118.445
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 53.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 53.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 42.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 247,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2799%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2799%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pfcla.com/our-physicians",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.pfcla.com/our-physicians",
            "fetchedAt": "2026-06-10"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.pacificfertilitycenter.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-99-vicken-sahakian-md",
        "name": "Vicken Sahakian, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.pfcla.com/hubfs/Style%20Assets/Doctors/Resized/Vicken-Sahakian-2.jpg",
        "_source": {
          "url": "https://www.pfcla.com/our-physicians",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-99-vicken-sepilian",
        "name": "Vicken Sepilian",
        "role": "Infertility Specialist and Reproductive Endocrinologist",
        "imageUrl": "https://www.pfcla.com/hubfs/Style%20Assets/Doctors/Resized/Vicken%20Sepilian.jpg",
        "_source": {
          "url": "https://www.pfcla.com/our-physicians",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-99-ingrid-rodi",
        "name": "Ingrid Rodi",
        "role": "Infertility Specialist and Reproductive Endocrinologist",
        "imageUrl": "https://www.pfcla.com/hubfs/Style%20Assets/Doctors/Resized/Ingrid%20Rodi.jpg",
        "_source": {
          "url": "https://www.pfcla.com/our-physicians",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-99-catherine-deugarte",
        "name": "Catherine DeUgarte",
        "credentials": ["MD"],
        "role": "Infertility Specialist and Reproductive Endocrinologist",
        "imageUrl": "https://www.pfcla.com/hubfs/Style%20Assets/Doctors/Catherine-DeUgarte-1.jpg",
        "_source": {
          "url": "https://www.pfcla.com/our-physicians",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-99-michele-evans",
        "name": "Michele Evans",
        "role": "Infertility Specialist and Reproductive Endocrinologist",
        "imageUrl": "https://www.pfcla.com/hubfs/Style%20Assets/Doctors/Michele%20Evans-desk.jpg",
        "_source": {
          "url": "https://www.pfcla.com/our-physicians",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-99-gerard-celia",
        "name": "Gerard Celia",
        "credentials": ["MBA", "PhD", "HCLD", "CC"],
        "role": "Executive Lab Director",
        "imageUrl": "https://www.pfcla.com/hubfs/Style%20Assets/Doctors/Resized/Gerry%20Celia.jpg",
        "_source": {
          "url": "https://www.pfcla.com/our-physicians",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.pfcla.com",
    "description": "Pacific Fertility Center Los Angeles (PFCLA) has been setting the standard for fertility services since 1991, with success rates among the best in the nation and over 13,500 babies delivered across more than 20,000 IVF procedures. The clinic welcomes everyone, from heterosexual couples to single parents and all members of the LGBTQ+ community, and supports intended parents, surrogates, and egg donors from over 75 countries. PFCLA operates clinics in Westwood (Los Angeles) and Glendale.",
    "languages": ["Mandarin", "English"],
    "network": {
      "name": "Prelude Network"
    },
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "images": [
      {
        "url": "https://www.pfcla.com/hubfs/Images/Background%20Images/clinic-lobby-bg.jpg",
        "type": "interior"
      },
      {
        "url": "https://www.pfcla.com/hubfs/Images/Background%20Images/PFCLA%20Lobby.jpg",
        "type": "interior"
      }
    ],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-188",
    "externalIds": {
      "cdcClinicId": "188",
      "googlePlaceId": "ChIJUeVOUdW0woAROy4A9uGzoJI"
    },
    "type": "fertility-clinic",
    "name": "Pacific Reproductive Center",
    "phone": "(310) 376-7000",
    "address": {
      "line1": "3720 Lomita Blvd, Suite 200",
      "city": "Torrance",
      "state": "CA",
      "zip": "90505",
      "country": "US"
    },
    "location": {
      "lat": 33.8149,
      "lng": -118.35
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 64.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 55.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 55.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 41.66666666666667,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/12"
        }
      ],
      "cyclesPerYear": 163,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27188%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27188%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pacificreproductivecenter.com/about/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Pacific+Reproductive+Center+%7C+Torrance,+CA+%7C+Fertility+Clinic,+3720+Lomita+Blvd+%23200,+Torrance,+CA+90505/@33.8149405,-118.3497208,3315a,13.1y/data=!4m2!3m1!1s0x80c2b4d5514ee551:0x92a0b3e1f6002e3b",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://pacificreproductivecenter.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-188-rifaat-d-salem",
        "name": "Rifaat D. Salem",
        "role": "Medical Director",
        "imageUrl": "https://www.pacificreproductivecenter.com/wp-content/uploads/2023/04/RDS.jpg",
        "credentials": ["MD", "PhD"],
        "_source": {
          "url": "https://www.pacificreproductivecenter.com/meet-the-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-188-shala-a-salem",
        "name": "Shala A. Salem",
        "credentials": ["MD"],
        "role": "Fertility Specialist",
        "imageUrl": "https://www.pacificreproductivecenter.com/wp-content/uploads/2023/04/ssalem-scaled-2.jpg",
        "_source": {
          "url": "https://www.pacificreproductivecenter.com/meet-the-team/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://pacificreproductivecenter.com",
    "languages": ["English"],
    "images": [
      {
        "url": "https://www.pacificreproductivecenter.com/wp-content/uploads/2023/04/reward2023-217x300.jpg",
        "type": "interior",
        "_source": {
          "url": "https://pacificreproductivecenter.com",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlTbo9sBx28EB2RV-F46nMDcO7IRK1C6Qcxzfwkw6ywQX4G_-qMAIExXvcFkYL7ItA6OAAkOHyTJiS99RU5MjDVn_mm1bE6pNqwqYsEikKGoajIERe5826PZYIlEzDXHg80sBtQ=w408-h544-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Pacific+Reproductive+Center+%7C+Torrance,+CA+%7C+Fertility+Clinic,+3720+Lomita+Blvd+%23200,+Torrance,+CA+90505/@33.8149405,-118.3497208,3315a,13.1y/data=!4m2!3m1!1s0x80c2b4d5514ee551:0x92a0b3e1f6002e3b",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnPNxrGwG9sGkZbd5JAFVCXw6glfTpqC8IQvoTRmM4T9gAbasqwmjpLjkczanpVq2WAqnT5pgv2KvFE6LAVEhD6uf1Oa6QcJ5zds8uOyWFlWB-XbAbvDL-o8EqbOtvKWG43QKZPsQ=w224-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Pacific+Reproductive+Center+%7C+Torrance,+CA+%7C+Fertility+Clinic,+3720+Lomita+Blvd+%23200,+Torrance,+CA+90505/@33.8149405,-118.3497208,3315a,13.1y/data=!4m2!3m1!1s0x80c2b4d5514ee551:0x92a0b3e1f6002e3b",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "description": "Pacific Reproductive Center has been successfully aiding conception for over two decades, delivering customized, evidence-based fertility care at clinics across Southern California. The practice operates fully licensed, state-of-the-art surgical centers with in-house IVF labs staffed by experienced physicians, embryologists, and geneticists, and was the first IVF center to offer in-house Array Comparative Genomic Hybridization (aCGH) alongside its in-house preimplantation genetic (PGD) lab.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-101",
    "externalIds": {
      "cdcClinicId": "101"
    },
    "type": "fertility-clinic",
    "name": "Palo Alto Medical Foundation",
    "phone": "(800) 597-2234",
    "address": {
      "line1": "2581 Samaritan Dr, Suite 302",
      "city": "San Jose",
      "state": "CA",
      "zip": "95124",
      "country": "US"
    },
    "location": {
      "lat": 37.2531,
      "lng": -121.949
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 52.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 42.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 46.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 24.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 479,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27101%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "scraped-retry",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.sutterhealth.org/services/fertility",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.sutterhealth.org/services/fertility",
            "fetchedAt": "2026-06-10"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27101%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-101-m-max-ezzati",
        "name": "M. Max Ezzati",
        "role": "Medical Director",
        "imageUrl": "https://a.mktgcdn.com/p/QEWOmYtZPFoKPESiXRh9t62YT2cqLiLAyinnQ_BzVV4/1.0000/191x191.jpg",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility (REI)",
        "_source": {
          "url": "https://www.sutterhealth.org/find-provider/dr-m-max-ezzati-1046239690",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-101-mary-abusief",
        "name": "Mary Abusief",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility (REI)",
        "imageUrl": "https://a.mktgcdn.com/p/vIpKN-F-qkaLJTty4pEsxDaDl0ukpkV08qGZTwBQD4U/480x480.jpg",
        "_source": {
          "url": "https://www.sutterhealth.org/find-provider/dr-mary-abusief-1046239946",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-101-anthony-dobson",
        "name": "Anthony Dobson",
        "credentials": ["MD", "PhD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility (REI)",
        "imageUrl": "https://a.mktgcdn.com/p/a5T3ZvLlGylf_yO0DD_GowUTlWaABlfBXzBOUxrBOME/1.0000/192x192.jpg",
        "_source": {
          "url": "https://www.sutterhealth.org/find-provider/dr-anthony-dobson-1046231943",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-101-jasmyn-k-johal",
        "name": "Jasmyn K Johal",
        "credentials": ["MD", "FACOG", "MS"],
        "specialty": "Reproductive Endocrinology and Infertility (REI)",
        "imageUrl": "https://a.mktgcdn.com/p/Rx2C8qzye6YNsbTvDrZjsniMB7EjOBcwtSEvRoKtR7M/480x480.png",
        "_source": {
          "url": "https://www.sutterhealth.org/find-provider/dr-jasmyn-k-johal-1089981595",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-101-alexis-alex-kim",
        "name": "Alexis (Alex) Kim",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility (REI)",
        "imageUrl": "https://a.mktgcdn.com/p/YJf6d58y74L0i8m66XXIhOOqs7Dq_1x8gcaZb1WihWo/480x480.jpg",
        "_source": {
          "url": "https://www.sutterhealth.org/find-provider/dr-alexis-alex-kim-1046232173",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-101-sanaz-keyhan",
        "name": "Sanaz Keyhan",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology",
        "imageUrl": "https://a.mktgcdn.com/p/XIieeSePJCuVNhxLTGezNMtSAo4b2sT1BcvkkNwBpww/480x480.jpg",
        "_source": {
          "url": "https://www.sutterhealth.org/find-provider/dr-sanaz-keyhan-1046245707",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.sutterhealth.org/pamf",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "images": [],
    "description": "Palo Alto Medical Foundation's fertility program at Sutter Health provides comprehensive fertility care, from less invasive options like ovulation induction and artificial insemination to advanced treatments like in vitro fertilization and fertility preservation methods such as egg freezing. Its embryology laboratory opened in 1984 in Palo Alto and earns the top accreditation from the College of American Pathologists, and more than 10,000 babies have been born to parents who sought treatment with the program. Care is delivered by a team of reproductive endocrinology and infertility specialists.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-446",
    "externalIds": {
      "cdcClinicId": "446"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Fertility Center, LinFertility Family Foundation",
    "phone": "(949) 453-8600",
    "address": {
      "line1": "16300 Sand Canyon Ave, Suite 911",
      "city": "Irvine",
      "state": "CA",
      "zip": "92618",
      "country": "US"
    },
    "location": {
      "lat": 33.6604,
      "lng": -117.773
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 65,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 48,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 54.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 61.111111111111114,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "11/18"
        }
      ],
      "cyclesPerYear": 217,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27446%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27446%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rfcfamily.com/about/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.reproductivefertilitycenter.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-446-james-p-lin-md",
        "name": "James P. Lin, MD",
        "role": "Medical Director",
        "imageUrl": "https://rfcfamily.com/wp-content/uploads/2024/12/Doctor-Lin-Circle.png",
        "credentials": ["MD"],
        "_source": {
          "url": "https://rfcfamily.com/about/meet-our-experts/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-446-zitao-liu",
        "name": "Zitao Liu",
        "credentials": ["MD"],
        "role": "Associate Chief Medical Officer",
        "imageUrl": "https://rfcfamily.com/wp-content/uploads/2026/03/Dr.-Liu-Circle-1024x1024.png",
        "_source": {
          "url": "https://rfcfamily.com/about/meet-our-experts/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-446-shirley-fong",
        "name": "Shirley Fong",
        "credentials": ["MD"],
        "role": "Kaiser Permanente REI Specialist",
        "imageUrl": "https://rfcfamily.com/wp-content/uploads/2025/01/Dr.-Shirley-Fong-Circle.png",
        "_source": {
          "url": "https://rfcfamily.com/about/meet-our-experts/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-446-kenneth-wong",
        "name": "Kenneth Wong",
        "credentials": ["MD"],
        "role": "Kaiser Permanente REI Specialist",
        "imageUrl": "https://rfcfamily.com/wp-content/uploads/2025/01/Dr.-Kenneth-Wong-Circle-2.png",
        "_source": {
          "url": "https://rfcfamily.com/about/meet-our-experts/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-446-ivan-huang",
        "name": "Ivan Huang",
        "credentials": ["MD"],
        "role": "Kaiser Permanente REI Specialist",
        "imageUrl": "https://rfcfamily.com/wp-content/uploads/2025/01/Dr-Ivan-Huang-Circle.png",
        "_source": {
          "url": "https://rfcfamily.com/about/meet-our-experts/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-446-alice-park",
        "name": "Alice Park",
        "credentials": ["MD"],
        "role": "REI Specialist",
        "imageUrl": "https://rfcfamily.com/wp-content/uploads/2020/05/Dr-Park-Circle.png",
        "_source": {
          "url": "https://rfcfamily.com/about/meet-our-experts/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-446-melissa-yates",
        "name": "Melissa Yates",
        "credentials": ["MD"],
        "role": "Kaiser Permanente REI Specialist",
        "imageUrl": "https://rfcfamily.com/wp-content/uploads/2021/03/Melissa-Yates-Tinified.png",
        "_source": {
          "url": "https://rfcfamily.com/about/meet-our-experts/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-446-jianming-li",
        "name": "Jianming Li",
        "role": "Scientific Director",
        "imageUrl": "https://rfcfamily.com/wp-content/uploads/2020/07/Dr-Li-2.png",
        "_source": {
          "url": "https://rfcfamily.com/about/meet-our-experts/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.rfcfamily.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "description": "Reproductive Fertility Center (RFC) was conceived to become an extension of your family, providing personalized support and guidance throughout your fertility journey, with a team of compassionate and skilled professionals by your side. Its facilities include professionally accredited surgery centers and on-site CAP-certified laboratories, and RFC is designated a Center of Excellence servicing Kaiser Permanente across Southern California.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-888",
    "externalIds": {
      "cdcClinicId": "888"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Health and Wellness Center",
    "phone": "(949) 516-0606",
    "address": {
      "line1": "23141 Moulton Pkwy, Suite 204",
      "city": "Laguna Hills",
      "state": "CA",
      "zip": "92653",
      "country": "US"
    },
    "location": {
      "lat": 33.6263,
      "lng": -117.7321
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 63.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 39,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 60.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 172,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27888%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27888%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/reproductive-health-wellness-center/laguna-hills-ca/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/reproductive-health-wellness-center/laguna-hills-ca/",
            "fetchedAt": "2026-06-11"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.rhwcenter.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-888-marcus-rosencrantz",
        "name": "Marcus Rosencrantz",
        "role": "Medical Director",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/05/Doctor-Mobile-website-headshot-264-x-264-px.png",
        "credentials": ["MD"],
        "_source": {
          "url": "https://rmanetwork.com/reproductive-health-wellness-center/laguna-hills-ca/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-888-cindy-anderson",
        "name": "Cindy Anderson",
        "credentials": ["NP"],
        "role": "NURSE PRACTITIONER",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/05/Doctor-Mobile-website-headshot-264-x-264-px-1.png",
        "_source": {
          "url": "https://rmanetwork.com/reproductive-health-wellness-center/laguna-hills-ca/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://rmanetwork.com/reproductive-health-wellness-center/laguna-hills-ca/",
    "languages": ["Chinese", "English"],
    "images": [],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "description": "Reproductive Health and Wellness Center (RHWC) is a fertility clinic in Laguna Hills, CA, now part of RMA Southern California | Orange County, offering a comprehensive range of fertility services from advanced In Vitro Fertilization (IVF) to personalized fertility consultations. The practice integrates technologies like IVF, inseminations, and egg freezing with therapies like acupuncture, therapy, nutrition, and spiritual direction in a boutique setting where Dr. Rosencrantz intends to see you at every visit.",
    "setting": "network-group",
    "bookingUrl": "https://rmanetwork.com/our-locations/rma-orange-county-california/",
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-820",
    "externalIds": {
      "cdcClinicId": "820",
      "googlePlaceId": "ChIJv2IZebSBhYARMD1VpEJl4tA"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Medicine Associates of Northern California",
    "phone": "(415) 603-6999",
    "address": {
      "line1": "150 Spear St, Suite 500",
      "city": "San Francisco",
      "state": "CA",
      "zip": "94105",
      "country": "US"
    },
    "location": {
      "lat": 37.7918,
      "lng": -122.394
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 66.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 54.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 56.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 46.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1047,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27820%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://nass.cdc.gov",
            "fetchedAt": "2024-01-01"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27820%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-northern-california/san-francisco-ca/",
            "fetchedAt": "2026-03-11"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-northern-california/san-francisco-ca/",
            "fetchedAt": "2026-03-11"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-northern-california/san-francisco-ca/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-northern-california/san-francisco-ca/",
            "fetchedAt": "2026-06-10"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "consultationTypes": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-northern-california/san-francisco-ca/",
            "fetchedAt": "2026-03-11"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+Northern+California+-+San+Francisco,+150+Spear+St+Ste+500,+San+Francisco,+CA+94105/@37.7917666,-122.3935863,3153a,13.1y/data=!4m2!3m1!1s0x808581b4791962bf:0xd0e26542a4553d30",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-820-jonathan-d-kort",
        "name": "Jonathan D. Kort",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Reproductive Endocrinologist",
        "_source": {
          "url": "https://rmanetwork.com/staff/jonathan-d-kort/",
          "fetchedAt": "2026-06-10"
        },
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2021/02/Untitled-design-89-1.jpg"
      },
      {
        "practitionerId": "pr-org-cdc-820-scott-j-morin",
        "name": "Scott J. Morin",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2021/02/Untitled-design-2021-07-07T113836.128.jpg",
        "_source": {
          "url": "https://rmanetwork.com/staff/scott-morin/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-820-daniel-j-kaser",
        "name": "Daniel J. Kaser",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2021/02/Untitled-design-88-1.jpg",
        "_source": {
          "url": "https://rmanetwork.com/staff/daniel-j-kaser/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-820-dana-mcqueen",
        "name": "Dana McQueen",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2022/08/Untitled-design.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-northern-california/san-francisco-ca/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-cdc-820-meredith-fisher",
        "name": "Meredith Fisher",
        "credentials": ["WHNP"],
        "specialty": "Reproductive Medicine",
        "role": "Nurse Practitioner",
        "_source": {
          "url": "https://rmanetwork.com/staff/meredith-fisher/",
          "fetchedAt": "2026-06-10"
        },
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2021/08/Copy-of-Untitled-8.jpg"
      },
      {
        "practitionerId": "pr-org-cdc-820-brent-m-hanson",
        "name": "Brent M. Hanson",
        "credentials": ["MD"],
        "role": "REPRODUCTIVE ENDOCRINOLOGIST",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2026/03/Doctor-Page-Mobile-Image-264-x-264-px-7.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/brent-hanson/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-820-martha-noel",
        "name": "Martha Noel",
        "credentials": ["MD"],
        "role": "REPRODUCTIVE ENDOCRINOLOGIST",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2022/09/Untitled-design-39.jpg",
        "_source": {
          "url": "https://rmanetwork.com/staff/martha-noel/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-820-alice-shapiro",
        "name": "Alice Shapiro",
        "credentials": ["MD", "FACOG"],
        "role": "REPRODUCTIVE ENDOCRINOLOGIST",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2022/10/Untitled-design-40.jpg",
        "_source": {
          "url": "https://rmanetwork.com/staff/alice-shapiro-md/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-820-puneet-masson",
        "name": "Puneet Masson",
        "credentials": ["MD"],
        "role": "UROLOGIST",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/09/Doctor-Page-Mobile-Image-264-x-264-px-8.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/puneet-masson-md/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-820-doris-cheung",
        "name": "Doris Cheung",
        "credentials": ["PA-C", "MPA"],
        "role": "PHYSICIAN ASSISTANT",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2024/02/Untitled-design-2.jpg",
        "_source": {
          "url": "https://rmanetwork.com/staff/doris-cheung/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-820-nancy-poon",
        "name": "Nancy Poon",
        "credentials": ["MSN", "NP-C"],
        "role": "NURSE PRACTITIONER",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2021/11/Untitled-design-29.jpg",
        "_source": {
          "url": "https://rmanetwork.com/staff/nancy-poon-np/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://rmanetwork.com/our-locations/rma-northern-california/",
    "description": "Top fertility clinic in San Francisco offering IVF, IUI, egg freezing and genetic testing with personalized reproductive care in the SoMa district.",
    "bookingUrl": "https://rmanetwork.com/our-locations/rma-northern-california/san-francisco-ca/",
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "16:00"
      },
      "tue": {
        "open": "07:00",
        "close": "16:00"
      },
      "wed": {
        "open": "07:00",
        "close": "16:00"
      },
      "thu": {
        "open": "07:00",
        "close": "16:00"
      },
      "fri": {
        "open": "07:00",
        "close": "16:00"
      },
      "sat": {
        "open": "07:00",
        "close": "12:00"
      },
      "sun": {
        "open": "07:00",
        "close": "12:00"
      }
    },
    "consultationTypes": ["in-person"],
    "network": {
      "name": "RMA Network"
    },
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "images": [
      {
        "url": "https://rmanetwork.com/wp-content/uploads/2025/05/website-image-4.jpg",
        "type": "exterior"
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkr5CAt7cyXOsZA-Rn4HGh6j_W5ZqPPiHHGGkhM_xYYOCT3tc5ACMJI9POoYVq4FA0yQEfkzVOH28g7D0s-D5Gh7CUaMIucfhaNmTAsSli9r9MJrX1nVWaqGz_dJ9mAlqm-9ovCajGe5mot=w408-h397-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+Northern+California+-+San+Francisco,+150+Spear+St+Ste+500,+San+Francisco,+CA+94105/@37.7917666,-122.3935863,3153a,13.1y/data=!4m2!3m1!1s0x808581b4791962bf:0xd0e26542a4553d30",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-825",
    "externalIds": {
      "cdcClinicId": "825",
      "googlePlaceId": "ChIJAQBQdQu7woARqCa6pl4AZUw"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Medicine Associates of Southern California",
    "phone": "(424) 293-8841",
    "address": {
      "line1": "11500 W. Olympic Blvd, Suite 150",
      "city": "Los Angeles",
      "state": "CA",
      "zip": "90064",
      "country": "US"
    },
    "location": {
      "lat": 34.0358,
      "lng": -118.444
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 72.22222222222221,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "13/18"
        },
        {
          "ageBand": "35-37",
          "rate": 55.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 57.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 66.66666666666666,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/9"
        }
      ],
      "cyclesPerYear": 115,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27825%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27825%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-southern-california/los-angeles-ca/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+Southern+California+%7C+Los+Angeles,+11500+W+Olympic+Blvd+%23150,+Los+Angeles,+CA+90064/@34.0357522,-118.4441018,3306a,13.1y/data=!4m2!3m1!1s0x80c2bb0b75500001:0x4c65005ea6ba26a8",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.rmasocal.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-825-thomas-j-kim",
        "name": "Thomas J. Kim",
        "role": "Medical Director",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2021/02/Untitled-design-21-1.jpg",
        "credentials": ["MD", "FACOG", "HCLD(ABB)", "MT(AAB)"],
        "specialty": "Reproductive Endocrinologist",
        "_source": {
          "url": "https://rmanetwork.com/staff/thomas-j-kim/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-825-melanie-f-landay",
        "name": "Melanie F. Landay",
        "credentials": ["MD", "FACOG"],
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2021/12/Untitled-design.jpg",
        "_source": {
          "url": "https://rmanetwork.com/staff/melanie-f-landay-md/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-825-keri-bergin",
        "name": "Keri Bergin",
        "credentials": ["MD"],
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/keri-bergin-md/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-825-deena-dubrow",
        "name": "Deena Dubrow",
        "credentials": [],
        "role": "Associate Genetic Counselor",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2026/03/Deena-Dubrow_Genetic_Counselor.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/deena-dubrow/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-825-amber-kaplun",
        "name": "Amber Kaplun",
        "credentials": [],
        "role": "Genetic Counselor",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2023/04/Untitled-design-4.jpg",
        "_source": {
          "url": "https://rmanetwork.com/staff/amber-kaplun/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-825-allison-alleigh-boyd",
        "name": "Allison “Alleigh” Boyd",
        "credentials": [],
        "role": "Genetic Counselor",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2023/04/Untitled-design-3.jpg",
        "_source": {
          "url": "https://rmanetwork.com/staff/allison-alleigh-boyd/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://rmanetwork.com/our-locations/rma-southern-california/los-angeles-ca/",
    "languages": ["English"],
    "network": {
      "name": "IVI RMA"
    },
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "description": "Reproductive Medicine Associates of Southern California offers a full range of fertility services to hopeful parents in Los Angeles and surrounding areas, including in vitro fertilization (IVF), intrauterine insemination (IUI), and third-party reproductive services (egg donor, sperm donor, and gestational surrogacy). The team of reproductive endocrinologists is led by Dr. Thomas J. Kim, who for over 20 years has helped thousands of couples and individuals achieve their dreams of parenthood. The practice is located in the heart of West Los Angeles, close to Beverly Hills, Santa Monica, Culver City, and Brentwood.",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmmctifL4Um8jzskLitYuRSO_JAZrSEsHxxJCf0i_dGJZkPPdwOBny77ekEs7REaacWa7g5XGIY6K3DvgAK-YF9ZPZRThheuG85GzX47mkf-phfWySqVElIlHft9DmMF4XwCfeu=w224-h298-k-no-pi-0-ya259.9-ro0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+Southern+California+%7C+Los+Angeles,+11500+W+Olympic+Blvd+%23150,+Los+Angeles,+CA+90064/@34.0357522,-118.4441018,3306a,13.1y/data=!4m2!3m1!1s0x80c2bb0b75500001:0x4c65005ea6ba26a8",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-339",
    "externalIds": {
      "cdcClinicId": "339"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Partners Fertility Center-San Diego",
    "phone": "(858) 552-9177",
    "address": {
      "line1": "9850 Genesee Ave, Suite 800",
      "city": "La Jolla",
      "state": "CA",
      "zip": "92037",
      "country": "US"
    },
    "location": {
      "lat": 32.8833,
      "lng": -117.226
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 55.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 58.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 54.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 33.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 439,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27339%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27339%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilityclinicsandiego.com/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.repropartners.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-339-v-gabriel-garzo-md",
        "name": "V. Gabriel Garzo, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.fertilityclinicsandiego.com/wp-content/uploads/2023/03/meet-our-team-img-one.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://www.fertilityclinicsandiego.com/our-center/meet-our-team/v-gabriel-garzo-m-d/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-339-li-shei-lin",
        "name": "Li-Shei Lin",
        "credentials": ["MD", "PhD"],
        "imageUrl": "https://www.fertilityclinicsandiego.com/wp-content/uploads/2025/01/Dr.LinBioPicture-768x512.jpeg",
        "_source": {
          "url": "https://www.fertilityclinicsandiego.com/our-center/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-339-irene-su",
        "name": "Irene Su",
        "credentials": ["MD", "MSCE"],
        "imageUrl": "https://www.fertilityclinicsandiego.com/wp-content/uploads/2023/03/meet-our-team-img-five.jpg",
        "_source": {
          "url": "https://www.fertilityclinicsandiego.com/our-center/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-339-antoni-duleba",
        "name": "Antoni Duleba",
        "credentials": ["MD"],
        "imageUrl": "https://www.fertilityclinicsandiego.com/wp-content/uploads/2023/03/meet-our-team-img-four.jpg",
        "_source": {
          "url": "https://www.fertilityclinicsandiego.com/our-center/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-339-sanjay-agarwal",
        "name": "Sanjay Agarwal",
        "credentials": ["MD"],
        "imageUrl": "https://www.fertilityclinicsandiego.com/wp-content/uploads/2023/03/meet-our-team-img-six.jpg",
        "_source": {
          "url": "https://www.fertilityclinicsandiego.com/our-center/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-339-rachel-whynott",
        "name": "Rachel Whynott",
        "credentials": ["MD"],
        "imageUrl": "https://www.fertilityclinicsandiego.com/wp-content/uploads/2025/06/Dr.-Whynott.jpg",
        "_source": {
          "url": "https://www.fertilityclinicsandiego.com/our-center/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-339-jamie-stanhiser",
        "name": "Jamie Stanhiser",
        "credentials": ["MD", "MSCR"],
        "imageUrl": "https://www.fertilityclinicsandiego.com/wp-content/uploads/2023/03/Jamie-Stanhiser_MD_Blue_Barn_Creative_Photos_L7778-1-e1704851397327-768x1051.jpg",
        "_source": {
          "url": "https://www.fertilityclinicsandiego.com/our-center/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-339-ana-lisa-yeo",
        "name": "Ana Lisa Yeo",
        "credentials": ["CLS", "TS/ELD (ABB)"],
        "role": "Laboratory Co-Director/Senior Embryologist",
        "imageUrl": "https://www.fertilityclinicsandiego.com/wp-content/uploads/2023/04/meet-our-team-ana-lisa-yeo.jpg",
        "_source": {
          "url": "https://www.fertilityclinicsandiego.com/our-center/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-339-wei-zhang",
        "name": "Wei Zhang",
        "credentials": ["MSc", "TS(ABB)"],
        "role": "Embryology Lab Supervisor/Senior Embryologist",
        "imageUrl": "https://www.fertilityclinicsandiego.com/wp-content/uploads/2023/10/Unknown-scaled-e1697137083668-768x386.jpeg",
        "_source": {
          "url": "https://www.fertilityclinicsandiego.com/our-center/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-339-t-mike-hsieh",
        "name": "T. Mike Hsieh",
        "credentials": ["MD"],
        "role": "Urologist - Male Fertility Specialist",
        "imageUrl": "https://www.fertilityclinicsandiego.com/wp-content/uploads/2023/04/Hsieh-Photo-Edit.jpg",
        "_source": {
          "url": "https://www.fertilityclinicsandiego.com/our-center/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.fertilityclinicsandiego.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "description": "Reproductive Partners Fertility Center San Diego (RPSD) is a physician-founded and physician-owned fertility practice whose double board-certified physicians personally perform every procedure, and whose team has been successfully treating patients for over 25 years with more than 10,000 IVF cycles. Pioneers in elective single embryo transfer, RPSD achieved San Diego County's first successful PGT-M (2000) and oocyte freezing (2012) pregnancies, operates a fully accredited state-of-the-art on-site lab, and as UC San Diego faculty is the only academic affiliated fertility center in San Diego.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-385",
    "externalIds": {
      "cdcClinicId": "385",
      "googlePlaceId": "ChIJbYcWqJe0woARlzRj4niBHho"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Partners Medical Group - South Bay",
    "phone": "(310) 318-3010",
    "address": {
      "line1": "23440 Hawthorne Blvd",
      "line2": "Suite 230",
      "city": "Torrance",
      "state": "CA",
      "zip": "90505",
      "country": "US"
    },
    "location": {
      "lat": 33.8525,
      "lng": -118.379
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 65.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 51.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 51.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 37.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1080,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27385%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://www.reproductivepartners.com/locations/our-torrance-clinic",
            "fetchedAt": "2026-06-10"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27385%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.reproductivepartners.com/about",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Reproductive+Partners+Medical+Group,+23440+Hawthorne+Blvd+Ste+230,+Torrance,+CA+90505/@33.8127718,-118.3500967,3315a,13.1y/data=!4m2!3m1!1s0x80c2b497a816876d:0x1a1e8178e2633497",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.repropartners.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-385-gayane-ambartsumyan-md-phd",
        "name": "Gayane Ambartsumyan, MD, PHD",
        "role": "Medical Director",
        "imageUrl": "https://a.storyblok.com/f/290132/1080x1080/a820b624e5/dr-a-headshot.png",
        "credentials": ["MD", "PhD"],
        "_source": {
          "url": "https://www.reproductivepartners.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-385-andy-huang",
        "name": "Andy Huang",
        "credentials": ["MD", "MBA"],
        "imageUrl": "https://a.storyblok.com/f/290132/400x500/66f07913bf/huang.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-385-marli-amin",
        "name": "Marli Amin",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/400x500/844aa26871/amin.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-385-carrie-wambach",
        "name": "Carrie Wambach",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/400x500/67d643b342/carrie-melissa-wambach-m-d.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-385-jackie-ho",
        "name": "Jackie Ho",
        "credentials": ["MD", "MS"],
        "imageUrl": "https://a.storyblok.com/f/290132/400x500/e9e1cf1eae/jackie-ho-m-d.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-385-wendy-chang",
        "name": "Wendy Chang",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/400x500/afd38fd276/dr-wendy-chang-m-d-facog.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-385-meredith-brower",
        "name": "Meredith Brower",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/400x500/0ba4bb69c8/meredith-brower-m-d.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-385-eric-han",
        "name": "Eric Han",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/400x500/42b09dc8a6/dr-eric-han-m-d.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-385-amy-kaing",
        "name": "Amy Kaing",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/600x600/d77c1c3424/amy-kaing.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/doctors/dr-amy-kaing",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-385-wayne-lin",
        "name": "Wayne Lin",
        "credentials": ["MD", "MPH"],
        "imageUrl": "https://a.storyblok.com/f/290132/600x600/188219d053/wayne-lin.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/doctors/dr-wayne-lin",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.reproductivepartners.com/locations/our-torrance-clinic",
    "languages": ["English"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnLCK55M7HQ__CTc59P7OQi1a0sX3HofZw7dY0kXtOePATRQc6k9xvOXNIGEpofEOYBijT8EySuyMI-aXa3INAbpH2iiO3EADH7qtPwTeeByKKDK0ebIgeKIc4pKLxV_IVOeUSz=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Reproductive+Partners+Medical+Group,+23440+Hawthorne+Blvd+Ste+230,+Torrance,+CA+90505/@33.8127718,-118.3500967,3315a,13.1y/data=!4m2!3m1!1s0x80c2b497a816876d:0x1a1e8178e2633497",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "description": "Reproductive Partners Medical Group lists its South Bay clinic in Torrance on Hawthorne Boulevard as one of its Southern California locations. The live site notes that the practice now operates Beverly Hills, South Bay/Torrance, Long Beach, and Irvine locations, with Irvine used for monitoring.",
    "schedule": {
      "mon": {
        "open": "07:30",
        "close": "16:00"
      },
      "tue": {
        "open": "07:30",
        "close": "16:00"
      },
      "wed": {
        "open": "07:30",
        "close": "16:00"
      },
      "thu": {
        "open": "07:30",
        "close": "16:00"
      },
      "fri": {
        "open": "07:30",
        "close": "16:00"
      },
      "sat": {
        "open": "07:30",
        "close": "12:00"
      },
      "sun": {
        "open": "07:30",
        "close": "12:00"
      }
    },
    "network": {
      "name": "Ivy Fertility"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-18",
    "externalIds": {
      "cdcClinicId": "18",
      "googlePlaceId": "ChIJydMtpMvyj4ARL-76uRQSbv4"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Science Center of the San Francisco Bay Area",
    "description": "Pioneering fertility center with over 40 years of experience, part of the US Fertility network, offering free emotional health programs and bundled multi-cycle savings.",
    "website": "https://rscbayarea.com",
    "phone": "(925) 867-1800",
    "bookingUrl": "https://rscbayarea.com/contact.html",
    "address": {
      "line1": "100 Park Pl, Suite 200",
      "city": "San Ramon",
      "state": "CA",
      "zip": "94583",
      "country": "US"
    },
    "location": {
      "lat": 37.7725,
      "lng": -121.99
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "financingOptions": ["Discount pricing", "Package pricing", "CapexMD"]
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 65.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 65.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 62.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 50.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1305,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2718%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "consultationTypes": ["in-person"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2718%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "scraped"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rscbayarea.com/locations/san-ramon-fertility-center/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Reproductive+Science+Center+in+San+Ramon,+100+Park+Pl+%23200,+San+Ramon,+CA+94583/@37.7727217,-121.9896017,3154a,13.1y/data=!4m2!3m1!1s0x808ff2cba42dd3c9:0xfe6e1214b9faee2f",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://rscbayarea.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-18-mary-hinckley",
        "name": "Mary Hinckley",
        "role": "Medical Director",
        "imageUrl": "https://rscbayarea.com/wp-content/uploads/2025/03/Hinckley-850x850-1.png",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology and Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://rscbayarea.com/doctors/hinckley/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-18-ravi-agarwal",
        "name": "Ravi Agarwal",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology and Reproductive Endocrinology and Infertility",
        "imageUrl": "https://rscbayarea.com/wp-content/uploads/2025/03/Agarwal-850x850-1.png",
        "_source": {
          "url": "https://rscbayarea.com/doctors/agarwal/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-18-laura-eisman",
        "name": "Laura Eisman",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology and Reproductive Endocrinology and Infertility",
        "imageUrl": "https://rscbayarea.com/wp-content/uploads/2025/03/Eisman850x850.png",
        "_source": {
          "url": "https://rscbayarea.com/doctors/eisman/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-18-eduardo-hariton",
        "name": "Eduardo Hariton",
        "credentials": ["MD", "MBA"],
        "specialty": "Obstetrics and Gynecology and Reproductive Endocrinology and Infertility",
        "imageUrl": "https://rscbayarea.com/wp-content/uploads/2025/03/Hariton-850x850-1.png",
        "_source": {
          "url": "https://rscbayarea.com/doctors/hariton/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-18-evan-rosenbluth",
        "name": "Evan Rosenbluth",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology and Reproductive Endocrinology and Infertility",
        "imageUrl": "https://rscbayarea.com/wp-content/uploads/2025/03/Rosenbluth-850x850-1.png",
        "_source": {
          "url": "https://rscbayarea.com/doctors/rosenbluth/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "languages": ["Chinese", "English"],
    "images": [
      {
        "url": "https://rscbayarea.com/wp-content/uploads/2025/03/San-Ramon.jpg",
        "type": "exterior"
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmLNpDnGjaGQSk5Jfn0WNgRfweh4XfpK7stCcULe90N3qlZCOUEZ6kWXAC4xxqse6jKeuHJOPYL3O2l-cH4Rl3X_fnb8GIe5u9EiprcT_ew_in1T-aHwMcmuUT3F-uO8SE4KEXrZFawgs0x=w445-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Reproductive+Science+Center+in+San+Ramon,+100+Park+Pl+%23200,+San+Ramon,+CA+94583/@37.7727217,-121.9896017,3154a,13.1y/data=!4m2!3m1!1s0x808ff2cba42dd3c9:0xfe6e1214b9faee2f",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmTKTEkazSVdbMw6hA5bpqGoPXsvYyl-j7b8wr4ZxrwAtSTebGjRJ6-aEa23HaCGhXzvrnawdRuMaShPAtkLnHiER2hoxS1F_WLSg3fTVUUewxAUcaV5wuNLqEiUbaKV3bg4iw1=w224-h398-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Reproductive+Science+Center+in+San+Ramon,+100+Park+Pl+%23200,+San+Ramon,+CA+94583/@37.7727217,-121.9896017,3154a,13.1y/data=!4m2!3m1!1s0x808ff2cba42dd3c9:0xfe6e1214b9faee2f",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "network": {
      "name": "US Fertility"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-602",
    "externalIds": {
      "cdcClinicId": "602",
      "googlePlaceId": "ChIJUVw_6joG3IARuuMchGqAWAU"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Sciences Medical Center",
    "phone": "(858) 436-7186",
    "address": {
      "line1": "3661 Valley Centre Dr, Suite 100",
      "city": "San Diego",
      "state": "CA",
      "zip": "92130",
      "country": "US"
    },
    "location": {
      "lat": 32.9364,
      "lng": -117.234
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 69.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 75,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "9/12"
        },
        {
          "ageBand": "38-40",
          "rate": 56.25,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "9/16"
        }
      ],
      "cyclesPerYear": 142,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27602%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27602%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://fertile.com/about-rsmc/why-rsmc/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Reproductive+Sciences+Medical+Center,+3661+Valley+Centre+Dr+%23100,+San+Diego,+CA+92130/@32.9363628,-117.2342049,3349a,13.1y/data=!4m2!3m1!1s0x80dc063aea3f5c51:0x558806a841ce3ba",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://fertile.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-602-minh-n-ho-md",
        "name": "Minh N. Ho, MD",
        "role": "Medical Director",
        "imageUrl": "https://fertile.com/wp-content/uploads/Dr.Ho_.webp",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://fertile.com/about-rsmc/expert-medical-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-602-david-harari",
        "name": "David Harari",
        "credentials": ["MD"],
        "role": "President, Chief Medical Officer",
        "imageUrl": "https://fertile.com/wp-content/uploads/Dr.Harari-1.webp",
        "_source": {
          "url": "https://fertile.com/about-rsmc/expert-medical-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-602-kevin-k-oum",
        "name": "Kevin K. Oum",
        "credentials": ["PhD", "HCLD/CC", "EMB"],
        "role": "Laboratory Director",
        "imageUrl": "https://fertile.com/wp-content/uploads/DR.Oum_-e1548268277147-1.webp",
        "_source": {
          "url": "https://fertile.com/about-rsmc/expert-medical-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-602-kenneth-k-c-vu",
        "name": "Kenneth K.C. Vu",
        "credentials": ["MD", "HCLD/CC (ABB)"],
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://fertile.com/wp-content/uploads/Dr.-Vu_3.webp",
        "_source": {
          "url": "https://fertile.com/about-rsmc/expert-medical-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-602-kelly-miller",
        "name": "Kelly Miller",
        "credentials": ["MD"],
        "role": "Obstetrician and Gynecologist (ABOG Diplomat, 2023)",
        "imageUrl": "https://fertile.com/wp-content/uploads/RSMC-DrMiller-_01-1.webp",
        "_source": {
          "url": "https://fertile.com/about-rsmc/expert-medical-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-602-kenna-schnarr",
        "name": "Kenna Schnarr",
        "credentials": ["DO", "MS"],
        "specialty": "Family medicine and obstetrics/gynecology (OB/GYN)",
        "imageUrl": "https://fertile.com/wp-content/uploads/Dr.-Kenna-Schnarr_11-scaled.webp",
        "_source": {
          "url": "https://fertile.com/about-rsmc/expert-medical-team/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://fertile.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Anthem",
        "Blue Cross",
        "Blue Shield",
        "Cigna",
        "United Healthcare",
        "Tricare"
      ],
      "_source": {
        "url": "https://fertile.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["Chinese", "English"],
    "description": "Reproductive Sciences Medical Center (RSMC) is a San Diego fertility center whose 'One-Stop Service Model' integrates all treatment and services into one location. Its doctors and embryologists have more than 150 years of combined experience, and the center runs in-house egg donation and surrogacy programs alongside its fertility treatments.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Blue Cross, Blue Shield, Cigna, United Healthcare, Tricare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://fertile.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnNaHffyqiPtMqP_miTJl6jk9FBFRhNFzBidu_eYlFhvOq1KKBLXQNm49KWgFbK8CHkj4p3SLQNLsJMRBnS2bfkAU_6keoWPWzUARKssnM-xV6bOMLoLhxLgkp6-0Em9vHmTTVI=w224-h298-k-no-pi-20-ya140-ro0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Reproductive+Sciences+Medical+Center,+3661+Valley+Centre+Dr+%23100,+San+Diego,+CA+92130/@32.9363628,-117.2342049,3349a,13.1y/data=!4m2!3m1!1s0x80dc063aea3f5c51:0x558806a841ce3ba",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-866",
    "externalIds": {
      "cdcClinicId": "866",
      "googlePlaceId": "ChIJoe5Rk2UH3IARcjdwi9ttPuk"
    },
    "type": "fertility-clinic",
    "name": "RMA San Diego (formerly Pearl Mini-IVF)",
    "phone": "(858) 614-6161",
    "address": {
      "line1": "4510 Executive Dr, Suite 150",
      "city": "San Diego",
      "state": "CA",
      "zip": "92121",
      "country": "US"
    },
    "location": {
      "lat": 32.8762,
      "lng": -117.2109
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      }
    ],
    "outcomes": {
      "successRates": [],
      "cyclesPerYear": 56,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27866%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27866%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-san-diego-fertility-clinic-pearl-mini-ivf/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+San+Diego+%7C+Formerly+Pearl+Mini-IVF,+4510+Executive+Dr+Ste+150,+San+Diego,+CA+92121/@32.8760722,-117.2110221,3351a,13.1y/data=!4m2!3m1!1s0x80dc07659351eea1:0xe93e6ddb8b703772",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-866-haley-g-genovese",
        "name": "Haley G. Genovese",
        "credentials": ["MD"],
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2023/04/Doctor-Page-Mobile-Image-264-x-264-px-10.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/haley-glatthorn-genovese/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-866-jamie-stanhiser",
        "name": "Jamie Stanhiser",
        "credentials": ["MD"],
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2026/06/Doctor-Page-Mobile-Image-264-x-264-px-12.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/jamie-stanhiser/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-866-anastasiya-y-kosina",
        "name": "Anastasiya Y. Kosina",
        "credentials": ["PA-C", "MCMSc"],
        "role": "Physician Assistant",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/06/Doctor-Mobile-website-headshot-264-x-264-px-3.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/anastasiya-y-kosina/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-866-diana-tatsumi",
        "name": "Diana Tatsumi",
        "credentials": ["PA-C", "MPAS"],
        "role": "Physician Assistant",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/06/Diana-Tatsumi-headshot.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/diana-tatsumi-pa-c/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-866-deena-dubrow",
        "name": "Deena Dubrow",
        "credentials": [],
        "role": "Associate Genetic Counselor",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2026/03/Deena-Dubrow_Genetic_Counselor.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/deena-dubrow/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-866-amber-kaplun",
        "name": "Amber Kaplun",
        "credentials": [],
        "role": "Genetic Counselor",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2023/04/Untitled-design-4.jpg",
        "_source": {
          "url": "https://rmanetwork.com/staff/amber-kaplun/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-866-allison-alleigh-boyd",
        "name": "Allison “Alleigh” Boyd",
        "credentials": [],
        "role": "Genetic Counselor",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2023/04/Untitled-design-3.jpg",
        "_source": {
          "url": "https://rmanetwork.com/staff/allison-alleigh-boyd/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://rmanetwork.com/our-locations/rma-san-diego-fertility-clinic-pearl-mini-ivf/",
    "languages": ["English"],
    "images": [
      {
        "url": "https://rmanetwork.com/wp-content/uploads/2026/04/Website-Updates-Part-2.jpeg",
        "type": "interior"
      },
      {
        "url": "https://rmanetwork.com/wp-content/uploads/2025/06/Untitled-design-31.png",
        "type": "exterior"
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn-_z3yG7mLZLnH3nRW3WqI-nZo4HLwAaAksEjoKx7TBhWvFABpCCtPgh3j3oO11jlc6VzcZ3dZc30hd1bpXzLkAkFpR53sfsRWn55wT9pbEsuj9z5l_fDmGsF5McILZ6dDsasCP5Tz9sFh=w398-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+San+Diego+%7C+Formerly+Pearl+Mini-IVF,+4510+Executive+Dr+Ste+150,+San+Diego,+CA+92121/@32.8760722,-117.2110221,3351a,13.1y/data=!4m2!3m1!1s0x80dc07659351eea1:0xe93e6ddb8b703772",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "network": {
      "name": "IVI RMA"
    },
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "description": "RMA San Diego, formerly the Pearl Mini-IVF fertility clinic, specializes in personalized, compassionate fertility care and offers a full range of advanced treatment options including IVF, mini-IVF, IUI, egg freezing, ICSI, and genetic testing. The San Diego clinic has a cutting-edge IVF laboratory, surgical center, and a comprehensive suite of services under one roof. Telehealth fertility consultations are available for all San Diego patients.",
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-705",
    "externalIds": {
      "cdcClinicId": "705"
    },
    "type": "fertility-clinic",
    "name": "San Diego Fertility Center",
    "phone": "(858) 794-6363",
    "address": {
      "line1": "11425 El Camino Real",
      "city": "San Diego",
      "state": "CA",
      "zip": "92130",
      "country": "US"
    },
    "location": {
      "lat": 32.9276,
      "lng": -117.237
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 61.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 58.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 49.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 46.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 684,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27705%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27705%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.sdfertility.com/about",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/San+Diego+Fertility+Center,+11425+El+Camino+Real,+San+Diego,+CA+92130/@32.9276203,-117.2373007,3349a,13.1y/data=!4m2!3m1!1s0x80dc0638c85ce03f:0x1acbc4b1a7528554",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.sdfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-705-sandy-chuan-md",
        "name": "Sandy Chuan, MD",
        "role": "Medical Director",
        "imageUrl": "https://a.storyblok.com/f/290132/849x849/91254bcfeb/sandy-chuan.png",
        "_source": {
          "url": "https://www.sdfertility.com/doctors/dr-sandy-chuan",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-705-susanna-j-park",
        "name": "Susanna J. Park",
        "imageUrl": "https://a.storyblok.com/f/290132/822x822/0d7f31fb46/susanna-park.png",
        "_source": {
          "url": "https://www.sdfertility.com/doctors/dr-susanna-j-park",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-705-brooke-friedman",
        "name": "Brooke Friedman",
        "imageUrl": "https://a.storyblok.com/f/290132/720x720/f4ff854f6f/brooke-friedman.jpeg",
        "_source": {
          "url": "https://www.sdfertility.com/doctors/dr-brooke-friedman",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-705-said-daneshmand",
        "name": "Said Daneshmand",
        "imageUrl": "https://a.storyblok.com/f/290132/718x718/1f2054d624/said-daneshmand.png",
        "_source": {
          "url": "https://www.sdfertility.com/doctors/dr-said-daneshmand",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-705-valerie-flores",
        "name": "Valerie Flores",
        "imageUrl": "https://a.storyblok.com/f/290132/842x842/9b4950e105/valerie-flores.png",
        "_source": {
          "url": "https://www.sdfertility.com/doctors/dr-valerie-flores",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-705-bryn-willson",
        "name": "Bryn Willson",
        "imageUrl": "https://a.storyblok.com/f/290132/772x772/149d62c39c/bryn-willson.png",
        "_source": {
          "url": "https://www.sdfertility.com/doctors/dr-bryn-willson",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.sdfertility.com",
    "languages": ["Chinese", "Korean", "English"],
    "network": {
      "name": "Ivy Fertility"
    },
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "description": "San Diego Fertility Center is recognized internationally as a pioneer in fertility treatment, having opened its doors in 1989 and helped bring more than 20,000 babies into the world since then. Its embryology lab was the first in San Diego to offer preimplantation genetic testing and is nationally accredited by the College of American Pathologists. SDFC has three locations across Southern California plus an additional location in New York City.",
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-12",
    "externalIds": {
      "cdcClinicId": "12",
      "googlePlaceId": "ChIJ_VtqkIQU6YARAXBFLeR0QO4"
    },
    "type": "fertility-clinic",
    "name": "Santa Barbara Fertility Center",
    "phone": "(805) 965-3400",
    "address": {
      "line1": "536 E. Arrellaga St, Suite 201",
      "city": "Santa Barbara",
      "state": "CA",
      "zip": "93103",
      "country": "US"
    },
    "location": {
      "lat": 34.4331,
      "lng": -119.703
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 37.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 25.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 38.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 135,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2712%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "minimal",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.santabarbarafertility.com/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Santa+Barbara+Fertility+Center,+536+E+Arrellaga+St+Ste+201,+Santa+Barbara,+CA+93101/@34.4331204,-119.7026809,3291a,13.1y/data=!4m2!3m1!1s0x80e91484906a5bfd:0xee4074e42d457001",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2712%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-12-rene-b-allen-md",
        "name": "René B. Allen, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.santabarbarafertility.com/wp-content/uploads/2025/03/Rene-Allen-Head-Shot-Dr-818x1024.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.santabarbarafertility.com/about-us/dr-rene-b-allen-md-f-a-c-o-g/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.santabarbarafertility.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "images": [
      {
        "url": "https://www.santabarbarafertility.com/wp-content/uploads/2025/04/SBFC-Services-Surgical-1024x683.jpg",
        "type": "interior"
      }
    ],
    "description": "Santa Barbara Fertility Center is a private fertility practice located near downtown Santa Barbara, opened in 2008 by Santa Barbara native Dr. René B. Allen, who completed his fellowship in Reproductive Endocrinology and Infertility at the University of Southern California. The center offers initial testing, IUI, IVF, egg and sperm freezing, egg donation and surrogacy, laboratory procedures, and surgical procedures, serving the Central Coast community as well as patients from around the world. The practice emphasizes a calming atmosphere paired with state-of-the-art fertility technology.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-491",
    "externalIds": {
      "cdcClinicId": "491",
      "googlePlaceId": "ChIJu9pzika7woAR6e7xQC4ayQ0"
    },
    "type": "fertility-clinic",
    "name": "Santa Monica Fertility",
    "phone": "(310) 566-1470",
    "address": {
      "line1": "2825 Santa Monica Blvd, Suite 100",
      "city": "Santa Monica",
      "state": "CA",
      "zip": "90404",
      "country": "US"
    },
    "location": {
      "lat": 34.0357,
      "lng": -118.472
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 236,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27491%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27491%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Santa+Monica+Fertility,+2825+Santa+Monica+Blvd+%23100,+Santa+Monica,+CA+90404/@34.0354519,-118.4721233,3306a,13.1y/data=!4m2!3m1!1s0x80c2bb468a73dabb:0xdc91a2e40f1eee9",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.santamonicafertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-491-guy-e-ringler-md",
        "name": "Guy E. Ringler, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.santamonicafertility.com",
    "languages": [
      "English",
      "Spanish",
      "Chinese",
      "Korean",
      "Japanese",
      "Arabic",
      "Russian",
      "French",
      "Portuguese",
      "Italian",
      "German",
      "Polish"
    ],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWld3IRf4h5azLPcBnXj8Lpz0CxS6a0Mz1ixkUniS9366WzoC6AC7tXM5o5FRRkN64htQBRbPkOrW61auSRqPIWdEYzsaH-MjZPeDBBG4-oagNoFwDvtmcNjYdEpqxHkk4ftTX9jJw=w417-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Santa+Monica+Fertility,+2825+Santa+Monica+Blvd+%23100,+Santa+Monica,+CA+90404/@34.0354519,-118.4721233,3306a,13.1y/data=!4m2!3m1!1s0x80c2bb468a73dabb:0xdc91a2e40f1eee9",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-124",
    "externalIds": {
      "cdcClinicId": "124"
    },
    "type": "fertility-clinic",
    "name": "Southern California Center for Reproductive Medicine",
    "phone": "(949) 642-8727",
    "address": {
      "line1": "361 Hospital Rd, Suite 333",
      "city": "Newport Beach",
      "state": "CA",
      "zip": "92663",
      "country": "US"
    },
    "location": {
      "lat": 33.6262,
      "lng": -117.93
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 47.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 61.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 57.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 71.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 448,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27124%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27124%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.socalfertility.com/about/about-sccrm",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.socalfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-124-robert-e-anderson-md",
        "name": "Robert E. Anderson, MD",
        "role": "Medical Director",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66621324f353f94c4ade0824/5ff1fe10-e420-4d90-8a4e-eb318ccc4588/4_Anderson_31_Hi_Res_2017_IMAGES-200x300.jpg",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology, Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.socalfertility.com/about/fertility-care-team/robert-anderson-md",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-124-don-royster",
        "name": "Don Royster",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology, Reproductive Endocrinology and Infertility",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66621324f353f94c4ade0824/d4d47ea6-ab36-4f8e-abd1-3b6dacd70365/Royster-38-Hi-Resolution-219x300.jpg",
        "_source": {
          "url": "https://www.socalfertility.com/about/fertility-care-team/don-royster-md",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-124-michael-j-tucker",
        "name": "Michael J. Tucker",
        "credentials": ["PhD", "HCLD"],
        "role": "Lab Director",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66621324f353f94c4ade0824/09525271-820d-4eaa-b962-141de34f1de0/SCCRM+Business+Card+Options+%281%29.png",
        "_source": {
          "url": "https://www.socalfertility.com/about/fertility-care-team/michael-j-tucker-phd-hcld",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-124-deisy-cerceda-ramirez",
        "name": "Deisy Cerceda-Ramirez",
        "credentials": ["MA"],
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66621324f353f94c4ade0824/ee880860-3f3c-4792-95f4-254219e3721b/Deisy%252BCerceda_compressed_compressed.jpg",
        "_source": {
          "url": "https://www.socalfertility.com/about/fertility-specialists",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-124-julia-chastain",
        "name": "Julia Chastain",
        "credentials": ["MA"],
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66621324f353f94c4ade0824/a198e845-964b-44e6-a9dd-a1e003ac9f0e/Julia%252BChastain_compressed_compressed.jpg",
        "_source": {
          "url": "https://www.socalfertility.com/about/fertility-specialists",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-124-crista-hill",
        "name": "Crista Hill",
        "credentials": ["RN"],
        "role": "Nurse Manager",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66621324f353f94c4ade0824/6de130ea-2633-42e1-a2b2-fd44353ae2a7/Crista%252BHill_compressed_compressed.jpg",
        "_source": {
          "url": "https://www.socalfertility.com/about/fertility-specialists",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-124-joyce-lin",
        "name": "Joyce Lin",
        "credentials": ["RN"],
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66621324f353f94c4ade0824/def2e9f1-a4a3-4fce-baa4-5430379672cf/55-Hi-Res_150x225_acf_cropped.jpg",
        "_source": {
          "url": "https://www.socalfertility.com/about/fertility-specialists",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-124-joan-moody",
        "name": "Joan Moody",
        "credentials": ["CNP"],
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66621324f353f94c4ade0824/f85f1998-517e-4e0b-a59f-16705547d4ff/Joan%252BMoody_compressed%2B%25281%2529_compressed.jpg",
        "_source": {
          "url": "https://www.socalfertility.com/about/fertility-specialists",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-124-tiffany-tran",
        "name": "Tiffany Tran",
        "credentials": ["MA"],
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66621324f353f94c4ade0824/b689648b-8910-4886-9185-ac7bc4c8ed4f/Tiffany%252BTran_compressed_compressed.jpg",
        "_source": {
          "url": "https://www.socalfertility.com/about/fertility-specialists",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-124-treena-rapaport",
        "name": "Treena Rapaport",
        "credentials": ["MSN"],
        "role": "Third Party Coordinator",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66621324f353f94c4ade0824/2aa082ac-9891-4eef-a95c-b47590b524d2/Treena+Rapaport.png",
        "_source": {
          "url": "https://www.socalfertility.com/about/fertility-specialists",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-124-michelle-sun",
        "name": "Michelle Sun",
        "role": "Mandarin-Speaking New Patient Coordinator",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66621324f353f94c4ade0824/b4c2a494-8a4c-42bd-8cd8-c09e8683994e/Michelle+Sun.png",
        "_source": {
          "url": "https://www.socalfertility.com/about/fertility-specialists",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-124-doris-wang",
        "name": "Doris Wang",
        "credentials": ["LVN"],
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/66621324f353f94c4ade0824/5fd6842b-d906-4613-b6cf-c6eb5c9474a9/Doris+Wang.png",
        "_source": {
          "url": "https://www.socalfertility.com/about/fertility-specialists",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.socalfertility.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "description": "The Southern California Center for Reproductive Medicine (SCCRM) is a Newport Beach fertility center founded in 1992 by Dr. Robert Anderson as Orange County's first independent IVF center, helping individuals and couples achieve parenthood for over 30 years. The practice offers a full range of fertility treatments and minimally invasive reproductive surgeries, including IVF, IUI, egg donation, egg freezing, and care for conditions like endometriosis and PCOS, complemented by counseling and wellness services. Its 'one embryo, one baby' philosophy reflects a commitment to safe, successful outcomes through single embryo transfers, with flexible scheduling seven days per week.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-107",
    "externalIds": {
      "cdcClinicId": "107"
    },
    "type": "fertility-clinic",
    "name": "Southern California Reproductive Center",
    "phone": "(310) 277-2393",
    "address": {
      "line1": "450 N. Roxbury Dr, Suite 500",
      "city": "Beverly Hills",
      "state": "CA",
      "zip": "90210",
      "country": "US"
    },
    "location": {
      "lat": 34.0683,
      "lng": -118.407
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 59.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 56.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 54.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 43.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 854,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27107%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27107%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.scrcivf.com/locations/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.scrcivf.com/locations/",
            "fetchedAt": "2026-06-10"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.scrcivf.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-107-mark-surrey",
        "name": "Mark Surrey",
        "role": "Medical Director",
        "imageUrl": "https://www.scrcivf.com/wp-content/uploads/2025/07/dr-mark-surrey.webp",
        "credentials": ["MD", "FACOG", "FACS"],
        "specialty": "fertility and reproductive medicine",
        "_source": {
          "url": "https://www.scrcivf.com/about-our-center/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-107-hal-c-danzer",
        "name": "Hal C. Danzer",
        "credentials": ["MD"],
        "role": "co-founder and partner",
        "imageUrl": "https://www.scrcivf.com/wp-content/uploads/2025/07/dr-hal-c-danzer.webp",
        "_source": {
          "url": "https://www.scrcivf.com/about-our-center/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-107-carolyn-alexander",
        "name": "Carolyn Alexander",
        "credentials": ["MD", "FACOG"],
        "role": "SCRC Reproductive Endocrinologist and Infertility Specialist",
        "imageUrl": "https://www.scrcivf.com/wp-content/uploads/2025/07/dr-carolyn-alexander.webp",
        "_source": {
          "url": "https://www.scrcivf.com/about-our-center/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-107-susan-m-maxwell",
        "name": "Susan M. Maxwell",
        "credentials": ["MD", "FACOG"],
        "role": "Reproductive Endocrinologist and fertility specialist at SCRC",
        "imageUrl": "https://www.scrcivf.com/wp-content/uploads/2025/07/dr-susan-m-maxwell.webp",
        "_source": {
          "url": "https://www.scrcivf.com/about-our-center/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-107-diana-e-chavkin",
        "name": "Diana E. Chavkin",
        "credentials": ["MD", "FACOG"],
        "role": "double board-certified Reproductive Endocrinologist and Infertility Specialist",
        "imageUrl": "https://www.scrcivf.com/wp-content/uploads/2025/07/dr-diana-e-chavkin.webp",
        "_source": {
          "url": "https://www.scrcivf.com/about-our-center/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.scrcivf.com",
    "description": "At Southern California Reproductive Center, we stand at the forefront of fertility care, blending modern science with personalized compassion. Our dedicated team of fertility experts are committed to guiding you through every step  of your unique fertility journey.",
    "languages": ["English"],
    "images": [
      {
        "url": "https://www.scrcivf.com/wp-content/uploads/2025/08/location-beberly-hills.webp",
        "type": "exterior"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-876",
    "externalIds": {
      "cdcClinicId": "876",
      "googlePlaceId": "ChIJmcwod1GBj4AR3e39s8n2Le8"
    },
    "type": "fertility-clinic",
    "name": "Spring Fertility-East Bay",
    "phone": "(415) 964-5618",
    "address": {
      "line1": "80 Grand Ave, 3rd Floor",
      "city": "Oakland",
      "state": "CA",
      "zip": "94612",
      "country": "US"
    },
    "location": {
      "lat": 37.8117,
      "lng": -122.2662
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 65,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 53.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 62.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 52.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 235,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27876%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27876%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://springfertility.com/east-bay/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Spring+Fertility,+80+Grand+Ave+3rd+Floor,+Oakland,+CA+94612/@37.8116649,-122.2662306,3152a,13.1y/data=!4m2!3m1!1s0x808f81517728cc99:0xef2df6c9b3fdeddd",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://springfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-876-debra-minjarez",
        "name": "Debra Minjarez",
        "credentials": ["MD"],
        "role": "Director of Provider Quality Assurance",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2026/02/SpringFertility_DrMinjarez-01.png",
        "_source": {
          "url": "https://springfertility.com/team/dr-debra-minjarez/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-876-serena-dovey",
        "name": "Serena Dovey",
        "role": "Fertility Specialist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2023/03/Our-Providers_Serena.png",
        "_source": {
          "url": "https://springfertility.com/team/dr-serena-dovey/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-876-srini-reddy",
        "name": "Srini Reddy",
        "credentials": ["MD"],
        "role": "Fertility Specialist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2023/11/Our-Providers_Srini111323.png",
        "_source": {
          "url": "https://springfertility.com/team/dr-srini-reddy/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-876-brett-stark",
        "name": "Brett Stark",
        "role": "Fertility Specialist",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2025/09/MD-Fertility-Specialist_Dr.-Brett-Stark-09.webp",
        "_source": {
          "url": "https://springfertility.com/team/dr-brett-stark/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-876-erin-o-connor",
        "name": "Erin O'Connor",
        "credentials": ["MS", "FNP-C"],
        "imageUrl": "https://springfertility.com/wp-content/uploads/2026/01/ErinOconner_Spring-740x751.png",
        "_source": {
          "url": "https://springfertility.com/east-bay/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-876-nina-metsovaara",
        "name": "Nina Metsovaara",
        "credentials": ["MSN", "FNP-C"],
        "role": "Family Nurse Practitioner",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2026/05/SpringFertility_NINA-METSOVAARA-01.png",
        "_source": {
          "url": "https://springfertility.com/team/nina-metsovaara-fnp-bc/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://springfertility.com",
    "languages": ["English"],
    "images": [
      {
        "url": "https://springfertility.com/wp-content/uploads/2024/09/Office.png",
        "type": "interior",
        "_source": {
          "url": "https://springfertility.com",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "url": "https://springfertility.com/wp-content/uploads/2025/03/SpringFertility_Lab1-1480x768-1.jpg",
        "type": "interior",
        "_source": {
          "url": "https://springfertility.com",
          "fetchedAt": "2026-03-11"
        }
      }
    ],
    "network": {
      "name": "Spring Fertility"
    },
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "pricing": {
      "packages": [
        {
          "name": "Initial Consultation",
          "description": "First visit to assess fertility and create a plan",
          "price": 25000,
          "priceMax": 54500,
          "currency": "USD",
          "includes": ["Ultrasound", "Physical exam", "Physician consultation"],
          "notes": "Bloodwork billed through insurance if applicable, otherwise ~$200 out-of-pocket"
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Complete egg freezing cycle including anesthesia",
          "price": 896400,
          "priceMax": 996000,
          "locationPrices": [
            {
              "location": "San Francisco",
              "price": 996000
            },
            {
              "location": "New York",
              "price": 996000
            },
            {
              "location": "Oregon",
              "price": 896400
            }
          ],
          "currency": "USD",
          "includes": [
            "Monitoring appointments",
            "Anesthesia",
            "Retrieval",
            "Cryopreservation"
          ],
          "notes": "$9,960 for SF & NY locations; $8,964 for Oregon. Anesthesia is included (unlike most clinics)."
        },
        {
          "name": "Medication Package",
          "description": "Pre-negotiated pharmacy rates tailored to your protocol",
          "price": 390000,
          "priceMax": 510000,
          "currency": "USD",
          "includes": [
            "All medications for cycle",
            "Refills if protocol changes"
          ],
          "notes": "Patients save ~$1,500 on average. Federal assistance may reduce cost by $500 - $750/cycle."
        },
        {
          "name": "Future IVF (using frozen eggs)",
          "description": "Complete path from thaw to transfer when you're ready",
          "price": 2300000,
          "priceMax": 2500000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Blastocyst development",
            "Genetic testing",
            "FET medication",
            "Transfer"
          ]
        }
      ],
      "financingOptions": [
        {
          "name": "Internal Payment Plan",
          "description": "Low monthly payments with no down payment",
          "details": [
            "Under $300/month",
            "No down payment required",
            "Covers cycle cost only"
          ],
          "exclusions": "Does not cover consultation, medications, or storage fees",
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "PatientFi Financing",
          "description": "Healthcare financing with flexible repayment terms",
          "details": [
            "Third-party healthcare financing",
            "Flexible repayment options",
            "Quick approval process"
          ],
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "Multi-Cycle Discount",
          "description": "10% off for self-pay patients doing multiple cycles",
          "details": [
            "10% discount on additional cycles",
            "Available to self-pay patients only"
          ],
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "Spring Promise (Shared Risk)",
          "description": "Full refund if pregnancy is not achieved for qualifying patients",
          "details": [
            "Full refund guarantee if pregnancy not achieved",
            "Designed for qualifying egg freezing patients"
          ],
          "eligibility": "20 eggs by age 35, or 30 eggs by age 38",
          "exclusions": "IVF, anesthesia, and medications are excluded from the refund",
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        }
      ],
      "_source": {
        "url": "https://springfertility.com/pricing/",
        "fetchedAt": "2026-03-11"
      }
    },
    "description": "Spring Fertility's Oakland clinic, on-site embryology lab, and surgery center is located near downtown Oakland, one block from Lake Merritt and three blocks from the 19th Street Oakland BART station. The clinic provides egg freezing, embryo freezing, IVF, genetic testing, gestational carrier services, LGBTQ+ care, sperm freezing, and on-site tissue storage. Spring offers virtual and in-person initial consults, dedicated monitoring appointment times, the opportunity to see your doctor at every visit, and a committed care team to support patients every step of the way.",
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "4 public price package(s) and 4 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://springfertility.com/pricing/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-723",
    "externalIds": {
      "cdcClinicId": "723"
    },
    "type": "fertility-clinic",
    "name": "Spring Fertility-San Francisco",
    "description": "At our San Francisco clinic, on-site embryology lab, and surgery center we have reimagined fertility care to put patients first with compassionate, personalized treatment and consistent provider continuity.",
    "website": "https://springfertility.com",
    "phone": "(415) 964-5618",
    "email": "info@springfertility.com",
    "bookingUrl": "https://springfertility.com/book-a-consult/",
    "address": {
      "line1": "1 Daniel Burnham Ct, Suite 110C",
      "city": "San Francisco",
      "state": "CA",
      "zip": "94109",
      "country": "US"
    },
    "location": {
      "lat": 37.7867,
      "lng": -122.422
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "miniIVF"
      }
    ],
    "insurance": {
      "accepted": true,
      "financingOptions": ["Package pricing"],
      "carriers": ["Cigna", "United Healthcare"],
      "employeeBenefits": ["Progyny", "Carrot", "Win", "Maven"],
      "_source": {
        "url": "https://springfertility.com/san-francisco/",
        "fetchedAt": "2026-03-11"
      }
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 62.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 58.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 52.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 40.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1374,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27723%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://nass.cdc.gov",
            "fetchedAt": "2024-01-01"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27723%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://springfertility.com/san-francisco/",
            "fetchedAt": "2026-03-11"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://springfertility.com/san-francisco/",
            "fetchedAt": "2026-03-11"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://springfertility.com/san-francisco/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://springfertility.com/san-francisco/",
            "fetchedAt": "2026-06-10"
          }
        },
        "insurance": {
          "status": "scraped",
          "source": {
            "url": "https://springfertility.com/san-francisco/",
            "fetchedAt": "2026-03-11"
          }
        },
        "consultationTypes": {
          "status": "scraped",
          "source": {
            "url": "https://springfertility.com/san-francisco/",
            "fetchedAt": "2026-03-11"
          }
        },
        "pricing": {
          "status": "verified"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://springfertility.com/san-francisco/",
            "fetchedAt": "2026-06-10"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-723-nam-tran",
        "name": "Nam Tran",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Fertility Specialist",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2018/01/SpringFertilityDrNamTran1.png",
        "_source": {
          "url": "https://springfertility.com/san-francisco/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-cdc-723-monica-pasternak",
        "name": "Monica Pasternak",
        "credentials": ["MD", "MBA"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Fertility Specialist",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2018/02/Spring_Doctors_Circle_Monica-Square-scaled.png",
        "_source": {
          "url": "https://springfertility.com/san-francisco/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-cdc-723-temeka-zore",
        "name": "Temeka Zore",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Fertility Specialist",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2020/06/SpringFertilityDrTemekaZore1.png",
        "_source": {
          "url": "https://springfertility.com/san-francisco/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-cdc-723-angie-wang",
        "name": "Angie Wang",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Fertility Specialist",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2023/10/Dr.-Wang_Alt.png",
        "_source": {
          "url": "https://springfertility.com/san-francisco/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-cdc-723-julia-kim",
        "name": "Julia Kim",
        "credentials": ["MD", "MPH"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Fertility Specialist",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2021/03/MD-Fertility-Specialist__Dr.-Kim.png",
        "_source": {
          "url": "https://springfertility.com/san-francisco/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-cdc-723-ursula-dean",
        "name": "Ursula Dean",
        "credentials": ["NP"],
        "specialty": "Reproductive Medicine",
        "role": "Nurse Practitioner",
        "_source": {
          "url": "https://springfertility.com/san-francisco/",
          "fetchedAt": "2026-06-10"
        },
        "imageUrl": "https://springfertility.com/wp-content/uploads/2024/01/Our-Providers_UD.png"
      },
      {
        "practitionerId": "pr-org-cdc-723-audrey-krall",
        "name": "Audrey Krall",
        "credentials": ["NP"],
        "specialty": "Reproductive Medicine",
        "role": "Nurse Practitioner",
        "_source": {
          "url": "https://springfertility.com/san-francisco/",
          "fetchedAt": "2026-06-10"
        },
        "imageUrl": "https://springfertility.com/wp-content/uploads/2023/03/Our-Providers_Audrey.png"
      }
    ],
    "schedule": {
      "mon": {
        "open": "07:30",
        "close": "16:00"
      },
      "tue": {
        "open": "07:30",
        "close": "16:00"
      },
      "wed": {
        "open": "07:30",
        "close": "16:00"
      },
      "thu": {
        "open": "07:30",
        "close": "16:00"
      },
      "fri": {
        "open": "07:30",
        "close": "16:00"
      },
      "sat": null,
      "sun": null
    },
    "images": [
      {
        "url": "https://springfertility.com/wp-content/uploads/2026/01/Nest_SF_014-scaled-1.jpg",
        "type": "interior",
        "caption": "Spring Fertility San Francisco reception",
        "_source": {
          "url": "https://springfertility.com/san-francisco/",
          "fetchedAt": "2026-07-27"
        }
      },
      {
        "url": "https://springfertility.com/wp-content/uploads/2019/06/loc_sf-header.png",
        "type": "interior",
        "caption": "Spring Fertility San Francisco waiting area",
        "_source": {
          "url": "https://springfertility.com/san-francisco/",
          "fetchedAt": "2026-07-27"
        }
      },
      {
        "url": "https://springfertility.com/wp-content/uploads/2021/07/SF_Locations_SanFransisco.png",
        "type": "interior",
        "caption": "Spring Fertility San Francisco clinic interior",
        "_source": {
          "url": "https://springfertility.com/san-francisco/",
          "fetchedAt": "2026-07-27"
        }
      }
    ],
    "network": {
      "name": "Spring Fertility"
    },
    "pricing": {
      "packages": [
        {
          "name": "Initial Consultation",
          "description": "First visit to assess fertility and create a plan",
          "price": 25000,
          "priceMax": 54500,
          "currency": "USD",
          "includes": ["Ultrasound", "Physical exam", "Physician consultation"],
          "notes": "Bloodwork billed through insurance if applicable, otherwise ~$200 out-of-pocket"
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Complete egg freezing cycle including anesthesia",
          "price": 896400,
          "priceMax": 996000,
          "locationPrices": [
            {
              "location": "San Francisco",
              "price": 996000
            },
            {
              "location": "New York",
              "price": 996000
            },
            {
              "location": "Oregon",
              "price": 896400
            }
          ],
          "currency": "USD",
          "includes": [
            "Monitoring appointments",
            "Anesthesia",
            "Retrieval",
            "Cryopreservation"
          ],
          "notes": "$9,960 for SF & NY locations; $8,964 for Oregon. Anesthesia is included (unlike most clinics)."
        },
        {
          "name": "Medication Package",
          "description": "Pre-negotiated pharmacy rates tailored to your protocol",
          "price": 390000,
          "priceMax": 510000,
          "currency": "USD",
          "includes": [
            "All medications for cycle",
            "Refills if protocol changes"
          ],
          "notes": "Patients save ~$1,500 on average. Federal assistance may reduce cost by $500 - $750/cycle."
        },
        {
          "name": "Future IVF (using frozen eggs)",
          "description": "Complete path from thaw to transfer when you're ready",
          "price": 2300000,
          "priceMax": 2500000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Blastocyst development",
            "Genetic testing",
            "FET medication",
            "Transfer"
          ]
        }
      ],
      "financingOptions": [
        {
          "name": "Internal Payment Plan",
          "description": "Low monthly payments with no down payment",
          "details": [
            "Under $300/month",
            "No down payment required",
            "Covers cycle cost only"
          ],
          "exclusions": "Does not cover consultation, medications, or storage fees",
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "PatientFi Financing",
          "description": "Healthcare financing with flexible repayment terms",
          "details": [
            "Third-party healthcare financing",
            "Flexible repayment options",
            "Quick approval process"
          ],
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "Multi-Cycle Discount",
          "description": "10% off for self-pay patients doing multiple cycles",
          "details": [
            "10% discount on additional cycles",
            "Available to self-pay patients only"
          ],
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "Spring Promise (Shared Risk)",
          "description": "Full refund if pregnancy is not achieved for qualifying patients",
          "details": [
            "Full refund guarantee if pregnancy not achieved",
            "Designed for qualifying egg freezing patients"
          ],
          "eligibility": "20 eggs by age 35, or 30 eggs by age 38",
          "exclusions": "IVF, anesthesia, and medications are excluded from the refund",
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        }
      ],
      "_source": {
        "url": "https://springfertility.com/pricing/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://springfertility.com/san-francisco/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "4 public price package(s) and 4 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://springfertility.com/pricing/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-875",
    "externalIds": {
      "cdcClinicId": "875",
      "googlePlaceId": "ChIJv0UaaA-3j4AR78kSvLWb8Cs"
    },
    "type": "fertility-clinic",
    "name": "Spring Fertility-Silicon Valley",
    "phone": "(415) 964-5618",
    "address": {
      "line1": "550 Lakeside Dr",
      "city": "Sunnyvale",
      "state": "CA",
      "zip": "94085",
      "country": "US"
    },
    "location": {
      "lat": 37.3858,
      "lng": -121.9928
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 56.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 60.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 57.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 46.15384615384615,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/13"
        }
      ],
      "cyclesPerYear": 283,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27875%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27875%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://springfertility.com/silicon-valley/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Spring+Fertility,+550+Lakeside+Dr,+Sunnyvale,+CA+94085/@37.3858116,-121.9930663,3170a,13.1y/data=!4m2!3m1!1s0x808fb70f681a45bf:0x2bf09bb5bc12c9ef",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://springfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-875-nam-d-tran-md-phd",
        "name": "Nam D. Tran, MD, PHD",
        "role": "Medical Director",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2023/03/Our-Providers_Nam.png",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://springfertility.com/team/nam-d-tran/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-875-gaya-murugappan",
        "name": "Gaya Murugappan",
        "credentials": ["MD"],
        "role": "Fertility Specialist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2023/03/Our-Providers_Gaya.png",
        "_source": {
          "url": "https://springfertility.com/team/demo-dr-gaya-murugappan/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-875-joseph-chervenak",
        "name": "Joseph Chervenak",
        "credentials": ["MD", "MBA"],
        "role": "Fertility Specialist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2024/08/Our-Providers_Dr.Chervenak.png",
        "_source": {
          "url": "https://springfertility.com/team/dr-joseph-chervenak/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-875-angie-wang",
        "name": "Angie Wang",
        "credentials": ["MD"],
        "role": "Fertility Specialist",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2023/11/Our-Providers_Ange.png",
        "_source": {
          "url": "https://springfertility.com/team/dr-angie-wang/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-875-ursula-dean",
        "name": "Ursula Dean",
        "credentials": ["RN", "BSN", "MSN", "CNP"],
        "role": "Nurse Practitioner",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2024/01/Our-Providers_UD.png",
        "_source": {
          "url": "https://springfertility.com/silicon-valley/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://springfertility.com",
    "languages": ["English"],
    "images": [
      {
        "url": "https://springfertility.com/wp-content/uploads/2024/09/Office.png",
        "type": "interior",
        "_source": {
          "url": "https://springfertility.com",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "url": "https://springfertility.com/wp-content/uploads/2025/03/SpringFertility_Lab1-1480x768-1.jpg",
        "type": "interior",
        "_source": {
          "url": "https://springfertility.com",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnIXQfWRU7k3g3jD-ToAO19tPGnCEWnK-R5O8wrDe9oOCURI9EJb3uFxtLdAiMi20nSmlq-s4C_ufpgjNLKW5NkNbkgemrenT8y1toTF7S_Tjf_xoXlNxaUNXmf5_FrGR5LTMiv=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Spring+Fertility,+550+Lakeside+Dr,+Sunnyvale,+CA+94085/@37.3858116,-121.9930663,3170a,13.1y/data=!4m2!3m1!1s0x808fb70f681a45bf:0x2bf09bb5bc12c9ef",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "network": {
      "name": "Spring Fertility"
    },
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "pricing": {
      "packages": [
        {
          "name": "Initial Consultation",
          "description": "First visit to assess fertility and create a plan",
          "price": 25000,
          "priceMax": 54500,
          "currency": "USD",
          "includes": ["Ultrasound", "Physical exam", "Physician consultation"],
          "notes": "Bloodwork billed through insurance if applicable, otherwise ~$200 out-of-pocket"
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Complete egg freezing cycle including anesthesia",
          "price": 896400,
          "priceMax": 996000,
          "locationPrices": [
            {
              "location": "San Francisco",
              "price": 996000
            },
            {
              "location": "New York",
              "price": 996000
            },
            {
              "location": "Oregon",
              "price": 896400
            }
          ],
          "currency": "USD",
          "includes": [
            "Monitoring appointments",
            "Anesthesia",
            "Retrieval",
            "Cryopreservation"
          ],
          "notes": "$9,960 for SF & NY locations; $8,964 for Oregon. Anesthesia is included (unlike most clinics)."
        },
        {
          "name": "Medication Package",
          "description": "Pre-negotiated pharmacy rates tailored to your protocol",
          "price": 390000,
          "priceMax": 510000,
          "currency": "USD",
          "includes": [
            "All medications for cycle",
            "Refills if protocol changes"
          ],
          "notes": "Patients save ~$1,500 on average. Federal assistance may reduce cost by $500 - $750/cycle."
        },
        {
          "name": "Future IVF (using frozen eggs)",
          "description": "Complete path from thaw to transfer when you're ready",
          "price": 2300000,
          "priceMax": 2500000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Blastocyst development",
            "Genetic testing",
            "FET medication",
            "Transfer"
          ]
        }
      ],
      "financingOptions": [
        {
          "name": "Internal Payment Plan",
          "description": "Low monthly payments with no down payment",
          "details": [
            "Under $300/month",
            "No down payment required",
            "Covers cycle cost only"
          ],
          "exclusions": "Does not cover consultation, medications, or storage fees",
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "PatientFi Financing",
          "description": "Healthcare financing with flexible repayment terms",
          "details": [
            "Third-party healthcare financing",
            "Flexible repayment options",
            "Quick approval process"
          ],
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "Multi-Cycle Discount",
          "description": "10% off for self-pay patients doing multiple cycles",
          "details": [
            "10% discount on additional cycles",
            "Available to self-pay patients only"
          ],
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "Spring Promise (Shared Risk)",
          "description": "Full refund if pregnancy is not achieved for qualifying patients",
          "details": [
            "Full refund guarantee if pregnancy not achieved",
            "Designed for qualifying egg freezing patients"
          ],
          "eligibility": "20 eggs by age 35, or 30 eggs by age 38",
          "exclusions": "IVF, anesthesia, and medications are excluded from the refund",
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        }
      ],
      "_source": {
        "url": "https://springfertility.com/pricing/",
        "fetchedAt": "2026-03-11"
      }
    },
    "description": "Spring Fertility's Sunnyvale clinic has become a trusted destination in Silicon Valley for comprehensive fertility services for people of all genders, providing egg freezing, embryo freezing, IVF, genetic testing, gestational carrier services, LGBTQ+ care, sperm freezing, on-site tissue storage, and a state-of-the-art lab. Spring has reimagined fertility care to put patients first, offering virtual and in-person initial consults, dedicated monitoring appointment times, and a committed care team to support patients every step of the way.",
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "4 public price package(s) and 4 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://springfertility.com/pricing/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-621",
    "externalIds": {
      "cdcClinicId": "621"
    },
    "type": "fertility-clinic",
    "name": "Stanford Medicine Fertility & Reproductive Health",
    "phone": "(650) 498-7911",
    "address": {
      "line1": "1195 W. Fremont Ave",
      "city": "Sunnyvale",
      "state": "CA",
      "zip": "94087",
      "country": "US"
    },
    "location": {
      "lat": 37.3527,
      "lng": -122.062
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 54.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 51.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 41.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 28.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 737,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27621%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27621%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.stanfordchildrens.org/en/services/fertility-and-reproductive-health/careteam.html",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.stanfordchildrens.org/en/services/fertility-and-reproductive-health/careteam.html",
            "fetchedAt": "2026-06-10"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://stanfordhealthcare.org/medical-clinics/fertility-and-reproductive-health-center.html",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-621-ruth-lathi",
        "name": "Ruth Lathi",
        "credentials": ["MD"],
        "role": "Division Chief, Reproductive Endocrinology and Infertility (REI) at Stanford Medicine's Department of Obstetrics and Gynecology; Director, Recurrent Pregnancy Loss Program",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://images.stanfordchildrens.org/is/image/stanfordchildrens/ruth-b-lathi?$Doctor_Profile$",
        "_source": {
          "url": "https://www.stanfordchildrens.org/en/doctor/ruth-b-lathi.html",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-621-steven-nakajima",
        "name": "Steven Nakajima",
        "credentials": ["MD"],
        "role": "Director of IVF Outreach Program",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://images.stanfordchildrens.org/is/image/stanfordchildrens/steven-t-nakajima?$Doctor_Profile$",
        "_source": {
          "url": "https://www.stanfordchildrens.org/en/doctor/steven-t-nakajima.html",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-621-lusine-aghajanova",
        "name": "Lusine Aghajanova",
        "credentials": ["MD"],
        "role": "Clinical Associate Professor",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://images.stanfordchildrens.org/is/image/stanfordchildrens/lusine-aghajanova?$Doctor_Profile$",
        "_source": {
          "url": "https://www.stanfordchildrens.org/en/doctor/lusine-aghajanova.html",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-621-brindha-saravanabavanandhan",
        "name": "Brindha Saravanabavanandhan",
        "credentials": ["MD"],
        "role": "Clinical Assistant Professor",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://images.stanfordchildrens.org/is/image/stanfordchildrens/brindha-bavan?$Doctor_Profile$",
        "_source": {
          "url": "https://www.stanfordchildrens.org/en/doctor/brindha-saravanabavanandhan.html",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-621-amin-milki",
        "name": "Amin Milki",
        "credentials": ["MD"],
        "role": "Professor",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://images.stanfordchildrens.org/is/image/stanfordchildrens/amin-a-milki?$Doctor_Profile$",
        "_source": {
          "url": "https://www.stanfordchildrens.org/en/doctor/amin-a-milki.html",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-621-bo-yu",
        "name": "Bo Yu",
        "credentials": ["MD"],
        "role": "Associate Professor",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://images.stanfordchildrens.org/is/image/stanfordchildrens/bo-yu-1?$Doctor_Profile$",
        "_source": {
          "url": "https://www.stanfordchildrens.org/en/doctor/bo-yu.html",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-621-michael-eisenberg",
        "name": "Michael Eisenberg",
        "credentials": ["MD"],
        "role": "Director, Male Reproductive Medicine & Surgery",
        "specialty": "Urology",
        "imageUrl": "https://images.stanfordchildrens.org/is/image/stanfordchildrens/michael-l-eisenberg?$Doctor_Profile$",
        "_source": {
          "url": "https://www.stanfordchildrens.org/en/doctor/michael-l-eisenberg.html",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-621-christina-christy-tise",
        "name": "Christina (Christy) Tise",
        "credentials": ["MD", "PhD"],
        "role": "Director, Reproductive Genetics Clinic",
        "specialty": "Medical Genetics",
        "imageUrl": "https://images.stanfordchildrens.org/is/image/stanfordchildrens/christina-g-tise?$Doctor_Profile$",
        "_source": {
          "url": "https://www.stanfordchildrens.org/en/doctor/christina-g-tise.html",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-621-stephanie-cizek",
        "name": "Stephanie Cizek",
        "credentials": ["MD"],
        "role": "Clinical Associate Professor",
        "specialty": "Pediatric and Adolescent Gynecology",
        "imageUrl": "https://images.stanfordchildrens.org/is/image/stanfordchildrens/stephanie-marie-cizek?$Doctor_Profile$",
        "_source": {
          "url": "https://www.stanfordchildrens.org/en/doctor/stephanie-marie-cizek.html",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.stanfordchildrens.org/en/services/fertility-and-reproductive-health",
    "description": "Stanford Medicine's Fertility and Reproductive Health Services offers one of the most comprehensive and progressive fertility treatment programs in the country, integrating innovative technology with a wide array of on-site services including reproductive surgery. The team includes American Board of Obstetrics and Gynecology certified specialists, leading embryologists, research leaders, and Stanford School of Medicine faculty, and the center is one of the specialty services of the Johnson Center for Pregnancy and Newborn Services at Lucile Packard Children's Hospital Stanford. The clinic is located at 1195 West Fremont Avenue in Sunnyvale.",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "images": [
      {
        "url": "https://www.stanfordchildrens.org/content/dam/sch/content-public/images/hero/location/fertility-and-reproductive-health-sunnyvale.jpg",
        "type": "exterior"
      }
    ],
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-458",
    "externalIds": {
      "cdcClinicId": "458",
      "googlePlaceId": "ChIJ6XF686eZwoARq9i6vU_ZgTk"
    },
    "type": "fertility-clinic",
    "name": "The Center for Fertility and Gynecology, Vermesh Center for Fertility",
    "phone": "(818) 881-9800",
    "address": {
      "line1": "18370 Burbank Blvd, Suite 301",
      "city": "Tarzana",
      "state": "CA",
      "zip": "91356",
      "country": "US"
    },
    "location": {
      "lat": 34.1704,
      "lng": -118.533
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 72.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 61.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 69.23076923076923,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "9/13"
        },
        {
          "ageBand": ">40",
          "rate": 13.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 163,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27458%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27458%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.center4fertility.com/about-the-practice/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/The+Center+for+Fertility+and+Gynecology,+18370+Burbank+Blvd+Ste+301,+Tarzana,+CA+91356/@34.1704372,-118.5329397,3301a,13.1y/data=!4m2!3m1!1s0x80c299a7f37a71e9:0x3981d94fbdbad8ab",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.centerforhumanreprod.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-458-michael-vermesh-md",
        "name": "Michael Vermesh, MD",
        "role": "Medical Director",
        "imageUrl": "https://einstein-clients.imgix.net/2060/496764/original_Michael-Vermesh-MD-FACOG.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.center4fertility.com/doctors/michael-vermesh-md-facog/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-458-tannaz-toloubeydokhti",
        "name": "Tannaz Toloubeydokhti",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://einstein-clients.imgix.net/2060/242875/original.jpg",
        "_source": {
          "url": "https://www.center4fertility.com/doctors/tannaz-toloubeydokhti-md-facog/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-458-melissa-burton",
        "name": "Melissa Burton",
        "role": "Embryology Lab Manager/Clinical Senior Embryologist",
        "imageUrl": "https://s3.amazonaws.com/eii-lucid/assets/2060/386057/original_Melissa.jpg",
        "_source": {
          "url": "https://www.center4fertility.com/ivf-lab/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-458-michael-eagle",
        "name": "Michael Eagle",
        "role": "Clinical Senior Embryologist",
        "imageUrl": "https://s3.amazonaws.com/eii-lucid/assets/2060/339557/original_Michael.jpg",
        "_source": {
          "url": "https://www.center4fertility.com/ivf-lab/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-458-allyse-alex",
        "name": "Allyse Alex",
        "role": "Clinical Senior Embryologist",
        "imageUrl": "https://s3.amazonaws.com/eii-lucid/assets/2060/339559/original_Allyse.jpg",
        "_source": {
          "url": "https://www.center4fertility.com/ivf-lab/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-458-veronica-oceguerra",
        "name": "Veronica Oceguerra",
        "credentials": ["LVN"],
        "imageUrl": "https://s3.amazonaws.com/eii-lucid/assets/2060/339563/original_Vero.jpg",
        "_source": {
          "url": "https://www.center4fertility.com/ivf-lab/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-458-katya-clark",
        "name": "Katya Clark",
        "role": "Front Office Coordinator",
        "imageUrl": "https://s3.amazonaws.com/eii-lucid/assets/2060/339565/original_Katya.jpg",
        "_source": {
          "url": "https://www.center4fertility.com/ivf-lab/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-458-paula-hovell",
        "name": "Paula Hovell",
        "role": "Administrator and New Patient Coordinator",
        "_source": {
          "url": "https://www.center4fertility.com/about-the-staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-458-connie-rodriguez",
        "name": "Connie Rodriguez",
        "role": "Financial Coordinator",
        "_source": {
          "url": "https://www.center4fertility.com/about-the-staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-458-giselle-martinez",
        "name": "Giselle Martinez",
        "role": "Lead Nurse and Third Party Coordinator",
        "_source": {
          "url": "https://www.center4fertility.com/about-the-staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-458-zenia-quintanilla",
        "name": "Zenia Quintanilla",
        "role": "Certified Medical Assistant",
        "_source": {
          "url": "https://www.center4fertility.com/about-the-staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-458-tiffany-acosta",
        "name": "Tiffany Acosta",
        "role": "Certified Medical Assistant",
        "_source": {
          "url": "https://www.center4fertility.com/about-the-staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-458-juliana-ramos",
        "name": "Juliana Ramos",
        "role": "Certified Medical Assistant",
        "imageUrl": "https://s3.amazonaws.com/eii-lucid/assets/2060/386063/original_Juliana.jpg",
        "_source": {
          "url": "https://www.center4fertility.com/about-the-staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-458-ashley-carmona",
        "name": "Ashley Carmona",
        "role": "Front Office Coordinator",
        "_source": {
          "url": "https://www.center4fertility.com/about-the-staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-458-nicole-duarte",
        "name": "Nicole Duarte",
        "role": "Front Office Coordinator",
        "imageUrl": "https://s3.amazonaws.com/eii-lucid/assets/2060/386141/original_Nikki.jpg",
        "_source": {
          "url": "https://www.center4fertility.com/about-the-staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-458-nicole-procopio",
        "name": "Nicole Procopio",
        "role": "Financial and Billing Coordinator",
        "imageUrl": "https://einstein-clients.imgix.net/2060/396303/original_Nicole_P,_new_pic.jpg",
        "_source": {
          "url": "https://www.center4fertility.com/about-the-staff/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.center4fertility.com",
    "languages": [
      "English",
      "Spanish",
      "Chinese",
      "Arabic",
      "French",
      "Hebrew"
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "images": [
      {
        "url": "https://einstein-clients.imgix.net/2060/413083/original.jpg",
        "type": "interior"
      },
      {
        "url": "https://einstein-clients.imgix.net/2060/381283/original.jpg",
        "type": "interior"
      },
      {
        "url": "https://einstein-clients.imgix.net/2060/460298/original_lab-gigapixel-.jpg",
        "type": "interior"
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWngZtAms6vun-tqtP5aG-eJfBMhGzmVZlDXDVytVYeSQVaxsekDZm55q0fH1oab5eYrU7qrDr1bGLh1oLWvLhbUuDDP9nUeeA4FTTJP0lNCfE9YNbYpV_JPAgG2QW4yQbhwcE7j=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/The+Center+for+Fertility+and+Gynecology,+18370+Burbank+Blvd+Ste+301,+Tarzana,+CA+91356/@34.1704372,-118.5329397,3301a,13.1y/data=!4m2!3m1!1s0x80c299a7f37a71e9:0x3981d94fbdbad8ab",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnCLCpzMKtciGFcM4BoaZQ3ua-r5tbZRfxSW_JJ_f5KMWGr_jOoxJU3knKNmQBmPhOLaVL-bR5TxswrOiHTuTUeQ6mLtn8fmgmRSOS9vV6WjIU-0RjeqZPj156FN_U5fjOa8XYDPA=w360-h203-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/The+Center+for+Fertility+and+Gynecology,+18370+Burbank+Blvd+Ste+301,+Tarzana,+CA+91356/@34.1704372,-118.5329397,3301a,13.1y/data=!4m2!3m1!1s0x80c299a7f37a71e9:0x3981d94fbdbad8ab",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "description": "The Center for Fertility and Gynecology was established in Los Angeles in 1987 by Dr. Michael Vermesh and has been located at 18370 Burbank Blvd in Tarzana since 1996, growing into the largest fertility center in the San Fernando Valley. The practice offers evaluation, diagnosis, and treatment of both female and male infertility in a patient-oriented, supportive setting, welcomes non-traditional families, and provides a full range of services including an egg donation program and egg freezing. Its embryology/andrology laboratory, built from the ground up in 2002, holds a certification with distinction from the College of American Pathologists.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-356",
    "externalIds": {
      "cdcClinicId": "356"
    },
    "type": "fertility-clinic",
    "name": "The Fertility and Gynecology Center, Monterey Bay IVF",
    "phone": "(831) 649-4483",
    "address": {
      "line1": "9833 Blue Larkspur Ln",
      "city": "Monterey",
      "state": "CA",
      "zip": "93940",
      "country": "US"
    },
    "location": {
      "lat": 36.5714,
      "lng": -121.802
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 38.88888888888889,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/18"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "0/7"
        }
      ],
      "cyclesPerYear": 65,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27356%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27356%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.montereybayivf.com/about",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.montereybayivf.com",
            "fetchedAt": "2026-06-11"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.montereybayivf.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-356-edward-j-ramirez-md",
        "name": "Edward J. Ramirez, MD",
        "role": "Medical Director",
        "imageUrl": "https://sa1s3optim.patientpop.com/assets/docs/188200.jpg",
        "credentials": ["MD", "FACOG"],
        "specialty": "Infertility & Fertility Preservation Specialist & General Gynecology & Minimally Invasive Surgery",
        "_source": {
          "url": "https://www.montereybayivf.com/about",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-356-jeong-hee-moon",
        "name": "Jeong Hee Moon",
        "credentials": [
          "MS",
          "PhD",
          "ALS(ABOR)",
          "ELS(ABOR)",
          "TS(ABB)",
          "HCLD(ABB)"
        ],
        "role": "Embryologist, Director of Laboratories",
        "imageUrl": "https://sa1s3optim.patientpop.com/assets/docs/328681.png",
        "_source": {
          "url": "https://www.montereybayivf.com/contents/about/additional-about/our-staff",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-356-elvira-garcia",
        "name": "Elvira Garcia",
        "role": "Clinical Patient Administrator, Patient Support Staff",
        "imageUrl": "https://sa1s3optim.patientpop.com/assets/docs/188199.jpg",
        "_source": {
          "url": "https://www.montereybayivf.com/contents/about/additional-about/our-staff",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-356-erika-nieto",
        "name": "Erika Nieto",
        "role": "IVF Coordinator",
        "imageUrl": "https://sa1s3optim.patientpop.com/assets/docs/440329.jpg",
        "_source": {
          "url": "https://www.montereybayivf.com/contents/about/additional-about/our-staff",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.montereybayivf.com",
    "languages": ["Spanish", "Japanese", "English"],
    "images": [
      {
        "url": "https://sa1s3optim.patientpop.com/assets/images/provider/photos/2233043.jpg",
        "type": "interior",
        "caption": "Monterey Bay IVF clinic interior",
        "_source": {
          "url": "https://www.montereybayivf.com",
          "fetchedAt": "2026-06-11"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "description": "The Fertility & Gynecology Center - Monterey Bay IVF is the only full-service IVF center on the California coast between San Jose and Santa Barbara, led by Edward J. Ramirez, MD, FACOG, a board-certified OB/GYN and infertility and fertility preservation specialist who is fluent in Spanish and Japanese. The Monterey practice offers a smaller setting with one-on-one care while housing an on-site IVF laboratory and a new Access Ambulatory Surgery Center with some of the most sophisticated equipment available. Dr. Ramirez and his staff make themselves available on weekends for patients whose cycles cause them to ovulate on Saturday or Sunday.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-171",
    "externalIds": {
      "cdcClinicId": "171",
      "googlePlaceId": "ChIJmVJAgKeZwoARcPhQO3YUaqc"
    },
    "type": "fertility-clinic",
    "name": "Tree of Life Center for Fertility, California Fertility Clinics",
    "phone": "(818) 344-8522",
    "address": {
      "line1": "18370 Burbank Blvd, Suite 511",
      "city": "Tarzana",
      "state": "CA",
      "zip": "91356",
      "country": "US"
    },
    "location": {
      "lat": 34.1705,
      "lng": -118.533
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "miniIVF",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 52,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 33.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 35,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 31.25,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/16"
        }
      ],
      "cyclesPerYear": 135,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27171%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27171%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.tlcfertility.com/our-team",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Tree+of+Life+Center+-+TLC+Fertility,+18370+Burbank+Blvd+%23511,+Tarzana,+CA+91356/@34.1705408,-118.5330723,3301a,13.1y/data=!4m2!3m1!1s0x80c299a780405299:0xa76a14763b50f870",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.treeoflifecenter.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-171-vuk-jovanovic-md",
        "name": "Vuk Jovanovic, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.tlcfertility.com/images/Vuk%20Jovanovic.webp",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-s-samuel-kim",
        "name": "S. Samuel Kim",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.tlcfertility.com/images/SSamuel%20Kim.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-snunit-ben-ozer",
        "name": "Snunit Ben-Ozer",
        "credentials": ["MD", "FACOG"],
        "role": "Tree of Life Center, Founder",
        "imageUrl": "https://www.tlcfertility.com/images/Snunit%20Ben-Ozer.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-caroline-kim",
        "name": "Caroline Kim",
        "credentials": ["PA-C"],
        "role": "Certified Physician Associate",
        "imageUrl": "https://www.tlcfertility.com/images/Caroline%20Kim.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-man-li",
        "name": "Man Li",
        "credentials": ["PHD", "HCLD (ABB)"],
        "role": "Tree of Life Center, IVF Lab director",
        "imageUrl": "https://www.tlcfertility.com/images/Man%20Li.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-honey-tavanasefat",
        "name": "Honey Tavanasefat",
        "role": "Embryologist",
        "imageUrl": "https://www.tlcfertility.com/images/Honey-Tavanasefat.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-maria-reica-magcaleng",
        "name": "Maria Reica Magcaleng",
        "role": "BS Endocrinology and Andrologist Technician",
        "imageUrl": "https://www.tlcfertility.com/images/Maria%20Reica%20Magcaleng.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-porscha-parker",
        "name": "Porscha Parker",
        "role": "Andrologist",
        "imageUrl": "https://www.tlcfertility.com/images/Porscha%20Parker.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-aja-pivaral",
        "name": "Aja Pivaral",
        "credentials": ["MA"],
        "role": "Third Party IVF Coordinator / Clinical Team Leader",
        "imageUrl": "https://www.tlcfertility.com/images/Aja%20Pivaral.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-suleima-hernandez",
        "name": "Suleima Hernandez",
        "credentials": ["MA"],
        "role": "Senior IVF Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/suleima%20hernandez.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-roshanda-james",
        "name": "Roshanda James",
        "credentials": ["MA"],
        "role": "Third Party IVF Coordinator / Egg Donor Manager-Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/Roshanda%20James.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-yang-jiao",
        "name": "Yang Jiao",
        "credentials": ["MPH"],
        "role": "Third-party Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/Yang%20Jiao.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-ercy-iglesias",
        "name": "Ercy Iglesias",
        "credentials": ["MA"],
        "role": "Senior Third-Party IVF Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/Ercy-Iglesias.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-julie-zhao",
        "name": "Julie Zhao",
        "role": "Third Party Coordinator & Chinese translator",
        "imageUrl": "https://www.tlcfertility.com/images/Julie%20Zhao.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-dulce-grajeda",
        "name": "Dulce Grajeda",
        "credentials": ["MA"],
        "role": "IVF Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/Dulce-Grajeda.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-kristina-leeds",
        "name": "Kristina Leeds",
        "credentials": ["BSHM"],
        "role": "Third Party IVF Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/Kristina%20Leeds.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-perla-villa",
        "name": "Perla Villa",
        "credentials": ["MA"],
        "role": "Medical Assistant, Assistant IVF Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/Perla%20Villa.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-valentina-mennesson",
        "name": "Valentina Mennesson",
        "credentials": ["MSM"],
        "role": "International Third Party Coordinator / Liaison",
        "imageUrl": "https://www.tlcfertility.com/images/Valentina%20Mennesson.webp",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-tetiana-kovalchuk",
        "name": "Tetiana Kovalchuk",
        "credentials": ["RN"],
        "role": "Registered Nurse",
        "imageUrl": "https://www.tlcfertility.com/images/Tetiana%20Kovalchuk.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-rachel-benavides",
        "name": "Rachel Benavides",
        "credentials": ["MA"],
        "role": "Medical Assistant and Front Desk Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/rachel%20benavides.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-john-genesi",
        "name": "John Genesi",
        "role": "Chief Financial Officer",
        "imageUrl": "https://www.tlcfertility.com/images/John-Genesi.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-jocelyn-hernandez",
        "name": "Jocelyn Hernandez",
        "role": "Financial Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/Jocelyn-Hernandez.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-eileen-jovanovic",
        "name": "Eileen Jovanovic",
        "role": "Billing and Accounting",
        "imageUrl": "https://www.tlcfertility.com/images/Eileen-Jovanovic.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-dave-petersen",
        "name": "Dave Petersen",
        "role": "Front Desk Administrator",
        "imageUrl": "https://www.tlcfertility.com/images/Dave-Petersen.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-dejan-stosic",
        "name": "Dejan Stosic",
        "role": "Digital Marketing and Brand Strategy Specialist",
        "imageUrl": "https://www.tlcfertility.com/images/Dejan-Stosic.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-171-christian-bair",
        "name": "Christian Bair",
        "role": "German Representative",
        "imageUrl": "https://www.tlcfertility.com/images/Christian-Bair.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.tlcfertility.com",
    "languages": ["English"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlbviz3P_2Q0LYY9ekyxvQ6uHWe9TRuFxlANGEl8VJpTAHXHNxo0TwzHz04Kpv6DKogSj9bAM-bufA_H2l2FRQPBsbpE1AYaKA6m1pu4rnkye5fugz6lUjeqiVLJSJBTIrv4S9LeA=w429-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Tree+of+Life+Center+-+TLC+Fertility,+18370+Burbank+Blvd+%23511,+Tarzana,+CA+91356/@34.1705408,-118.5330723,3301a,13.1y/data=!4m2!3m1!1s0x80c299a780405299:0xa76a14763b50f870",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "description": "Tree of Life Fertility Center, located in the heart of the San Fernando Valley in Tarzana, combines cutting-edge fertility treatments with a personalized approach, treating patients as more than a number at every step of their journey to parenthood. Its team of fertility specialists is led by Medical Director Dr. Vuk Jovanovic and founder Dr. Snunit Ben-Ozer. A second location, California Fertility Clinic, brings the same tailored fertility care to the heart of Los Angeles.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-361",
    "externalIds": {
      "cdcClinicId": "361",
      "googlePlaceId": "ChIJ6SHU6ly7woARsa897OlG43A"
    },
    "type": "fertility-clinic",
    "name": "UCLA Fertility Center",
    "phone": "(310) 825-9500",
    "address": {
      "line1": "Department of Obstetrics and Gynecology, 1245 16th St, Suite 202",
      "city": "Santa Monica",
      "state": "CA",
      "zip": "90404",
      "country": "US"
    },
    "location": {
      "lat": 34.0648,
      "lng": -118.447
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 56.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 49.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 58.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 64.70588235294117,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "11/17"
        }
      ],
      "cyclesPerYear": 304,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27361%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27361%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.uclahealth.org/medical-services/obgyn/fertility",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/UCLA+Health+Santa+Monica+OB%2FGYN,+1245+16th+St+%23202,+Santa+Monica,+CA+90404/@34.0274898,-118.48538,3307a,13.1y/data=!4m2!3m1!1s0x80c2bb5cead421e9:0x70e346e9ec3dafb1",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.uclahealth.org/departments/obgyn/reproductive-endocrinology-infertility",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-361-kathleen-m-brennan-md",
        "name": "Kathleen M. Brennan, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.uclahealth.org/sites/default/files/styles/portrait_3x4_010000_300x400/public/images/brennan-kathleen-1306033741.jpg?h=89e245dc&f=b6d625cc&itok=VyMj4IH8",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.uclahealth.org/medical-services/obgyn/fertility",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-361-zain-a-al-safi",
        "name": "Zain A. Al-Safi",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.uclahealth.org/sites/default/files/styles/portrait_3x4_010000_300x400/public/images/alsafi-zain-1578728317.jpg?h=8a019425&f=97a791b3&itok=59tA2Fln",
        "_source": {
          "url": "https://www.uclahealth.org/medical-services/obgyn/fertility",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-361-lindsay-l-kroener",
        "name": "Lindsay L. Kroener",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.uclahealth.org/sites/default/files/styles/portrait_3x4_010000_300x400/public/images/kroener-lindsay-1427285766.jpg?h=27d9f331&f=4627a3a5&itok=kj6zce7i",
        "_source": {
          "url": "https://www.uclahealth.org/medical-services/obgyn/fertility",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-361-robert-roman",
        "name": "Robert Roman",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology, Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.uclahealth.org/sites/default/files/styles/portrait_3x4_010000_300x400/public/images/roman-robert-1811375538.jpg?h=5e2ca3ec&f=f8b412bb&itok=2wGKJWml",
        "_source": {
          "url": "https://www.uclahealth.org/medical-services/obgyn/fertility",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.uclahealth.org/medical-services/obgyn/fertility",
    "languages": ["English", "Italian"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "images": [
      {
        "url": "https://www.uclahealth.org/sites/default/files/styles/portrait_3x4_024000_720x960/public/images/LOC0000053102-57850.jpg?h=7922499f&f=994094eb&itok=iAV7Nd7Z",
        "type": "exterior"
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlHKvXO_6KYUKtRVaew-DcpwsbWQcbRSLB3DGW4NZBdX3WMYqWPF21RgiZpp6luVKGYuutw4287Ba1qI6l3DXmfKza5HPfQPVkEQL2qZYv8lw74HD4hTZLkVOOAfaoUmFIUYKfJ=w408-h725-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/UCLA+Health+Santa+Monica+OB%2FGYN,+1245+16th+St+%23202,+Santa+Monica,+CA+90404/@34.0274898,-118.48538,3307a,13.1y/data=!4m2!3m1!1s0x80c2bb5cead421e9:0x70e346e9ec3dafb1",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "description": "The UCLA Fertility and Reproductive Health Center provides comprehensive fertility services using a collaborative approach based on each person's needs and preferences, and all of its physicians are reproductive endocrinologists. The center has been recognized in Newsweek's annual America's Best Fertility Clinics survey. Services include fertility evaluations, IUI, IVF and ICSI, egg, sperm and embryo freezing, genetic counseling, LGBTQ+ family planning, oncofertility, and reproductive surgery.",
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-362",
    "externalIds": {
      "cdcClinicId": "362"
    },
    "type": "fertility-clinic",
    "name": "UCSF Center for Reproductive Health",
    "description": "Trusted fertility and IVF care offering a comprehensive array of infertility evaluation and treatment options for both men and women. Ranked #1 fertility clinic in California and #5 nationally, with 6,000+ live births over the past decade.",
    "website": "https://crh.ucsf.edu",
    "phone": "(415) 353-3040",
    "bookingUrl": "https://crh.ucsf.edu/appointments",
    "address": {
      "line1": "499 Illinois St, 6th Floor",
      "city": "San Francisco",
      "state": "CA",
      "zip": "94158",
      "country": "US"
    },
    "location": {
      "lat": 37.7658,
      "lng": -122.388
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "financingOptions": [
        "Payment plans",
        "Discount pricing",
        "Future Family"
      ],
      "carriers": [
        "Anthem Blue Cross Blue Shield",
        "Health Net",
        "Canopy Health",
        "Aetna",
        "Cigna",
        "United Healthcare"
      ],
      "_source": {
        "url": "https://crh.ucsf.edu/fertility-team/specialists/",
        "fetchedAt": "2026-03-11"
      }
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 45.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 42.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 44.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 23.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1429,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27362%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "languages": ["English", "Chinese", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://nass.cdc.gov",
            "fetchedAt": "2024-01-01"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27362%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://crh.ucsf.edu/fertility-team/specialists/",
            "fetchedAt": "2026-03-11"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://crh.ucsf.edu/fertility-team/specialists/",
            "fetchedAt": "2026-03-11"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://crh.ucsf.edu/fertility-team/specialists/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://crh.ucsf.edu/the-center/location/",
            "fetchedAt": "2026-06-10"
          }
        },
        "insurance": {
          "status": "scraped",
          "source": {
            "url": "https://crh.ucsf.edu/fertility-team/specialists/",
            "fetchedAt": "2026-03-11"
          }
        },
        "consultationTypes": {
          "status": "scraped",
          "source": {
            "url": "https://crh.ucsf.edu/fertility-team/specialists/",
            "fetchedAt": "2026-03-11"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://crh.ucsf.edu/the-center/location/",
            "fetchedAt": "2026-06-10"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-362-marcelle-cedars",
        "name": "Marcelle Cedars",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Director, Division of Reproductive Endocrinology",
        "imageUrl": "https://providers.ucsfhealth.org/sparkle-assets/images/cedars-marcelle-1427095090-2edf6f6444937791fa4132347eb83009.jpg",
        "_source": {
          "url": "https://crh.ucsf.edu/fertility-team/specialists/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-cdc-362-mitchell-rosen",
        "name": "Mitchell Rosen",
        "credentials": ["MD", "HCLD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Embryology Lab Director",
        "imageUrl": "https://providers.ucsfhealth.org/sparkle-assets/images/rosen-mitchell-1730123662-81310192abed391ff20c5cd634cb76b7.jpg",
        "_source": {
          "url": "https://crh.ucsf.edu/fertility-team/specialists/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-cdc-362-evelyn-mok-lin",
        "name": "Evelyn Mok-Lin",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Clinical Medical Director",
        "imageUrl": "https://providers.ucsfhealth.org/sparkle-assets/images/moklin-evelyn-1255470746-663437f14093887ff658072174b0c4ec.jpg",
        "_source": {
          "url": "https://crh.ucsf.edu/fertility-team/specialists/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-cdc-362-yanett-anaya",
        "name": "Yanett Anaya",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://providers.ucsfhealth.org/sparkle-assets/images/anaya-yanett-1215299102-e0bf59a0f9d70cc33b13850743286b36.jpg",
        "_source": {
          "url": "https://crh.ucsf.edu/fertility-team/specialists/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-cdc-362-hakan-cakmak",
        "name": "Hakan Cakmak",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://providers.ucsfhealth.org/sparkle-assets/images/cakmak-hakan-1861676827-128f98be475b95af866c32f40ab03d51.jpg",
        "_source": {
          "url": "https://crh.ucsf.edu/fertility-team/specialists/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-cdc-362-victor-fujimoto",
        "name": "Victor Fujimoto",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://providers.ucsfhealth.org/sparkle-assets/images/fujimoto-victor-1598704140-7a6e12506cfcba4779f69969756044ae.jpg",
        "_source": {
          "url": "https://crh.ucsf.edu/fertility-team/specialists/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-cdc-362-linda-giudice",
        "name": "Linda Giudice",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://providers.ucsfhealth.org/sparkle-assets/images/giudice-linda-1356387021-a6da0916f5688ec8a8bd2e1e10862fc4.jpg",
        "_source": {
          "url": "https://crh.ucsf.edu/fertility-team/specialists/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-cdc-362-eleni-jaswa",
        "name": "Eleni Jaswa",
        "credentials": ["MD", "MSc", "MAS"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://providers.ucsfhealth.org/sparkle-assets/images/jaswa-eleni-1962768374-4efa2e4a67066b66a8ffa87823a86d98.jpg",
        "_source": {
          "url": "https://crh.ucsf.edu/fertility-team/specialists/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-cdc-362-joie-guner",
        "name": "Joie Guner",
        "credentials": ["MD", "MSc"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Reproductive Endocrinologist",
        "_source": {
          "url": "https://crh.ucsf.edu/fertility-team/specialists/",
          "fetchedAt": "2026-06-10"
        },
        "imageUrl": "https://crh.ucsf.edu/media/2024/01/ucsf-headshot-Guner-1.jpg"
      },
      {
        "practitionerId": "pr-org-cdc-362-david-huang",
        "name": "David Huang",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Reproductive Endocrinologist",
        "_source": {
          "url": "https://crh.ucsf.edu/fertility-team/specialists/",
          "fetchedAt": "2026-06-10"
        },
        "imageUrl": "https://crh.ucsf.edu/media/2024/10/ucsf-Huang-thumbnail-1.png"
      },
      {
        "practitionerId": "pr-org-cdc-362-heather-huddleston",
        "name": "Heather Huddleston",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://providers.ucsfhealth.org/sparkle-assets/images/huddleston-heather-1053358598-826fa2d2688d21d97157e1954ee7e5f8.jpg",
        "_source": {
          "url": "https://crh.ucsf.edu/fertility-team/specialists/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-cdc-362-john-lindsey-ii",
        "name": "John Lindsey II",
        "credentials": ["MD"],
        "specialty": "Urology / Male Reproductive Medicine",
        "role": "Reproductive Urologist",
        "imageUrl": "https://providers.ucsfhealth.org/sparkle-assets/images/lindsey-john-1295196111-1b247d077bc07a2427b4011c33400451.jpg",
        "_source": {
          "url": "https://crh.ucsf.edu/fertility-team/specialists/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-cdc-362-paolo-rinaudo",
        "name": "Paolo Rinaudo",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://providers.ucsfhealth.org/sparkle-assets/images/rinaudo-paolo-1396789228-e09b0de515e46dec3ca7a5d936cdb390.jpg",
        "_source": {
          "url": "https://crh.ucsf.edu/fertility-team/specialists/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-cdc-362-maren-shapiro",
        "name": "Maren Shapiro",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Reproductive Endocrinologist",
        "_source": {
          "url": "https://crh.ucsf.edu/fertility-team/specialists/",
          "fetchedAt": "2026-06-10"
        },
        "imageUrl": "https://crh.ucsf.edu/media/2023/09/ucsf-headshot-Shapiro-1.jpg"
      },
      {
        "practitionerId": "pr-org-cdc-362-alan-shindel",
        "name": "Alan Shindel",
        "credentials": ["MD", "MAS"],
        "specialty": "Urology / Male Reproductive Medicine",
        "role": "Reproductive Urologist",
        "imageUrl": "https://providers.ucsfhealth.org/sparkle-assets/images/shindel-alan-1740375039-71feb29ebfff5c0d55d57cdfa8b9303d.jpg",
        "_source": {
          "url": "https://crh.ucsf.edu/fertility-team/specialists/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-cdc-362-james-smith",
        "name": "James Smith",
        "credentials": ["MD", "MS"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://providers.ucsfhealth.org/sparkle-assets/images/smith-james-1659400984-b444d6bc51d7b6fd514e1e1e99e2d4ce.jpg",
        "_source": {
          "url": "https://crh.ucsf.edu/fertility-team/specialists/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-cdc-362-alisha-tolani",
        "name": "Alisha Tolani",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Reproductive Endocrinologist",
        "_source": {
          "url": "https://crh.ucsf.edu/fertility-team/specialists/",
          "fetchedAt": "2026-06-10"
        },
        "imageUrl": "https://crh.ucsf.edu/media/2024/09/ucsf-Tolani.jpg"
      }
    ],
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "16:45"
      },
      "tue": {
        "open": "08:00",
        "close": "16:45"
      },
      "wed": {
        "open": "08:00",
        "close": "16:45"
      },
      "thu": {
        "open": "08:00",
        "close": "16:45"
      },
      "fri": {
        "open": "08:00",
        "close": "16:45"
      },
      "sat": null,
      "sun": null
    },
    "network": {
      "name": "UCSF Health"
    },
    "images": [
      {
        "url": "https://crh.ucsf.edu/media/2023/09/gallery-n3-1.jpg",
        "type": "interior",
        "caption": "UCSF Center for Reproductive Health entrance",
        "_source": {
          "url": "https://crh.ucsf.edu/fertility-team/specialists/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "url": "https://crh.ucsf.edu/media/2023/09/gallery-n2.jpg",
        "type": "interior",
        "caption": "UCSF CRH waiting area with waterfront view",
        "_source": {
          "url": "https://crh.ucsf.edu/fertility-team/specialists/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "url": "https://crh.ucsf.edu/media/2021/08/gallery-01-1.jpg",
        "type": "interior",
        "caption": "UCSF CRH main lobby",
        "_source": {
          "url": "https://crh.ucsf.edu/fertility-team/specialists/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "url": "https://crh.ucsf.edu/media/2021/08/gallery-06.jpg",
        "type": "interior",
        "_source": {
          "url": "https://crh.ucsf.edu/fertility-team/specialists/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "url": "https://crh.ucsf.edu/media/2021/08/gallery-05-1.jpg",
        "type": "interior",
        "_source": {
          "url": "https://crh.ucsf.edu/fertility-team/specialists/",
          "fetchedAt": "2026-03-11"
        }
      }
    ],
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Anthem Blue Cross Blue Shield, Health Net, Canopy Health, Aetna, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://crh.ucsf.edu/fertility-team/specialists/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-810",
    "externalIds": {
      "cdcClinicId": "810",
      "googlePlaceId": "ChIJL-aCrlrDwoAR_OqI2GgTvN4"
    },
    "type": "fertility-clinic",
    "name": "Unity Fertility Center, LLC",
    "phone": "(626) 588-1555",
    "address": {
      "line1": "625 S. Fair Oaks Ave, Suite 330",
      "city": "Pasadena",
      "state": "CA",
      "zip": "91105",
      "country": "US"
    },
    "location": {
      "lat": 34.135,
      "lng": -118.151
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      }
    ],
    "outcomes": {
      "successRates": [],
      "cyclesPerYear": 29,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27810%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27810%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.unity-fertility.com/about",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Unity+Fertility+Center,+625+S+Fair+Oaks+Ave+Ste+330,+Pasadena,+CA+91105/@34.134987,-118.150714,3302a,13.1y/data=!4m2!3m1!1s0x80c2c35aae82e62f:0xdebc1368d888eafc",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.unityfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-810-chun-yeh-wang-md-phd",
        "name": "Chun-Yeh Wang, MD, PHD",
        "role": "Medical Director",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/6557beb789af580a3379af6a/64a274a9-ce56-4f9a-8103-d033e725275c/chun-yeh+wang+image+1.jpg",
        "_source": {
          "url": "https://www.unity-fertility.com/about",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.unity-fertility.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "description": "Unity Fertility Center is a Pasadena, California fertility clinic led by Dr. Chun-Yeh Wang, with a second location in San Gabriel. Since its opening in 2003, Dr. Wang and her team have developed techniques for IVF, intracytoplasmic sperm injection, blastocyst culture and implantation, and embryo freezing and thawing. The center provides personalized care with individualized treatment plans tailored to each patient's specific needs.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk7Qcq-W6nQ7NrINx3t303w68o5LJOKrmFDp0kllbglvhYfxGwlz9X9f9I1EJKFtfn3F19L7g7NwgWdfE0019Yw-2sEveZKp5t61HNrN0zST-HLqZvviFH8c0zlnTRak-4Mjhs=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Unity+Fertility+Center,+625+S+Fair+Oaks+Ave+Ste+330,+Pasadena,+CA+91105/@34.134987,-118.150714,3302a,13.1y/data=!4m2!3m1!1s0x80c2c35aae82e62f:0xdebc1368d888eafc",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-27",
    "externalIds": {
      "cdcClinicId": "27",
      "googlePlaceId": "ChIJ_z9Hxx5L3YARacsn3mDDk_w"
    },
    "type": "fertility-clinic",
    "name": "University Fertility Center",
    "phone": "(310) 378-7445",
    "address": {
      "line1": "23550 Hawthorne Blvd, Suite 210",
      "city": "Torrance",
      "state": "CA",
      "zip": "90505",
      "country": "US"
    },
    "location": {
      "lat": 33.8119,
      "lng": -118.35
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 30,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 44.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 41.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 118,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2727%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2727%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://universityfertilitycenter.com",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/University+Fertility+Center,+23550+Hawthorne+Blvd+%23210,+Torrance,+CA+90505/@33.8119369,-118.3499451,3315a,13.1y/data=!4m2!3m1!1s0x80dd4b1ec7473fff:0xfc93c360de27cb69",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.universityfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-27-omid-khorram",
        "name": "Omid Khorram",
        "role": "Medical Director",
        "imageUrl": "https://universityfertilitycenter.com/wp-content/uploads/2025/01/dKhorram-1.png",
        "credentials": ["MD", "PhD"],
        "_source": {
          "url": "https://universityfertilitycenter.com/wp-json/wp/v2/pages/9",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-27-hak-nam-kim",
        "name": "Hak-Nam Kim",
        "credentials": ["DVM", "PhD", "HCLD"],
        "role": "Laboratory Director",
        "imageUrl": "https://universityfertilitycenter.com/wp-content/uploads/2025/01/drKim-1.png",
        "_source": {
          "url": "https://universityfertilitycenter.com/wp-json/wp/v2/pages/9",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://universityfertilitycenter.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "description": "University Fertility Center is an academically affiliated fertility clinic in Torrance, California, founded in 2006 by Dr. Omid Khorram, Medical Director and Professor of Obstetrics and Gynecology at UCLA. The free-standing center and its on-site University Fertility Laboratory provide comprehensive fertility services including artificial insemination, IVF, ICSI, donor egg IVF, surrogacy, donor embryos, egg and embryo freezing, and pre-implantation genetic testing. The practice emphasizes accessible, personalized care and has partnered with ARC Fertility Financing to offer flexible IVF packages and financing.",
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-937",
    "externalIds": {
      "cdcClinicId": "937"
    },
    "type": "fertility-clinic",
    "name": "USC Fertility",
    "phone": "(626) 440-9161",
    "address": {
      "line1": "55 S. Lake Ave., 9th Floor",
      "city": "Pasadena",
      "state": "CA",
      "zip": "91101",
      "country": "US"
    },
    "location": {
      "lat": 34.1446,
      "lng": -118.1325
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 12,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27937%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27937%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://uscfertility.org/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://uscfertility.org/",
            "fetchedAt": "2026-06-10"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://uscfertility.org",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-937-richard-j-paulson-md",
        "name": "Richard J. Paulson, MD",
        "role": "Medical Director",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2021/06/Dr-Richard-Paulson-2024-360X480.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://havingbabies.com/locations/pasadena/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://uscfertility.org",
    "description": "USC Fertility is proud to have joined the HRC Fertility family, bringing you world\\-class expertise and inclusive, compassionate care. Your trusted USC physicians are now seeing patients at HRC Fertility – Pasadena a state\\-of\\-the\\-art facility designed to support your journey. To request a consultation, call 866\\-HRC\\-4IVF or click below to visit HRC Fertility’s website.",
    "languages": ["English"],
    "images": [
      {
        "url": "https://havingbabies.com/wp-content/uploads/2020/10/55Lake-ext.png",
        "type": "exterior"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-392",
    "externalIds": {
      "cdcClinicId": "392"
    },
    "type": "fertility-clinic",
    "name": "Valley Center for Reproductive Health, Inc., West Coast Women's Reproductive Center",
    "phone": "(818) 986-1648",
    "address": {
      "line1": "4835 Van Nuys Blvd, Suite 200",
      "city": "Sherman Oaks",
      "state": "CA",
      "zip": "91403",
      "country": "US"
    },
    "location": {
      "lat": 34.1585,
      "lng": -118.449
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 17,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27392%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "minimal",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://womensreproduction.com",
            "fetchedAt": "2026-06-10"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27392%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-392-tina-koopersmith",
        "name": "Tina Koopersmith",
        "role": "Medical Director",
        "imageUrl": "https://womensreproduction.com/wp-content/uploads/2019/07/Dr.jpg",
        "specialty": "Reproductive endocrinologist",
        "_source": {
          "url": "https://womensreproduction.com/our-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-392-lori-lichterman",
        "name": "Lori Lichterman",
        "role": "Dietitian",
        "_source": {
          "url": "https://womensreproduction.com/our-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-392-krista-rauschenberg",
        "name": "Krista Rauschenberg",
        "role": "Breathworks Instructor",
        "_source": {
          "url": "https://womensreproduction.com/our-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-392-leah",
        "name": "Leah",
        "role": "Nutritionist",
        "imageUrl": "https://womensreproduction.com/wp-content/uploads/2024/08/leah.jpeg",
        "_source": {
          "url": "https://womensreproduction.com/our-team/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "description": "West Coast Women's Reproductive Center is an intimate fertility clinic in Sherman Oaks, California, founded by fertility doctor Dr. Tina Koopersmith to deliver personalized care built around learning each patient's medical needs and personal wishes. The practice pairs its boutique setting with hand-picked partner IVF laboratories, hospitals, and surgery centers across the Los Angeles area, and offers treatments spanning IVF, egg donation, fertility preservation, intrauterine insemination, and surgical treatments for infertility. Dr. Koopersmith is board certified in OB/GYN, reproductive endocrinology and infertility, and integrative medicine, and the center emphasizes a whole-person, integrative approach to fertility care.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-84",
    "externalIds": {
      "cdcClinicId": "84",
      "googlePlaceId": "ChIJn6TsWWYn3YARP_BOBObFieQ"
    },
    "type": "fertility-clinic",
    "name": "West Coast Fertility Center",
    "phone": "(714) 513-1399",
    "address": {
      "line1": "11160 Warner Ave, Suite 411",
      "city": "Fountain Valley",
      "state": "CA",
      "zip": "92708",
      "country": "US"
    },
    "location": {
      "lat": 33.7155,
      "lng": -117.934
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      },
      {
        "name": "miniIVF",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 52.94117647058824,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "9/17"
        },
        {
          "ageBand": "35-37",
          "rate": 36.84210526315789,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/19"
        },
        {
          "ageBand": "38-40",
          "rate": 22.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 66,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2784%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2784%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.westcoastfertility.com/about-us",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/West+Coast+Fertility+Centers,+11160+Warner+Ave+%23411,+Fountain+Valley,+CA+92708/@33.7154973,-117.9342854,3319a,13.1y/data=!4m2!3m1!1s0x80dd276659eca49f:0xe489c5e6044ef03f",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.westcoastfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-84-vitaly-a-kushnir-md",
        "name": "Vitaly A. Kushnir, MD",
        "role": "Medical Director",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/61403a538702d35e8818a293/1632338360079-9WFKH1GAQH5QOA2CN3AP/image.png",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.westcoastfertility.com/about-us",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-84-kendra-l-perkins",
        "name": "Kendra L. Perkins",
        "credentials": ["DO", "FACOG"],
        "specialty": "Gynecology and Fertility",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/61403a538702d35e8818a293/4726e931-77cf-46dd-8520-77e1f930e202/Dr.+Perkins.png",
        "_source": {
          "url": "https://www.westcoastfertility.com/about-us",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-84-jeanie-kim",
        "name": "Jeanie Kim",
        "credentials": ["MSN", "WHNP-BC"],
        "role": "Women's Health Nurse Practitioner",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/61403a538702d35e8818a293/412cf501-125c-49ec-83d7-6d0fcf6c2fb1/JKim.jpg",
        "_source": {
          "url": "https://www.westcoastfertility.com/about-us",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.westcoastfertility.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "description": "West Coast Fertility Centers provides comprehensive fertility treatment with a patient-centered approach, tailoring the treatment plan to meet every patient's unique needs. Its laboratories and surgery centers are located in Downtown Los Angeles and Fountain Valley, California, with modern facilities that include the latest in embryology technology. The onsite surgery centers are AAAHC accredited, and the embryology and andrology laboratories are licensed by the California Department of Public Health and CLIA accredited.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-706",
    "externalIds": {
      "cdcClinicId": "706",
      "googlePlaceId": "ChIJZ-kMayeYwoARUsijXF9Jt00"
    },
    "type": "fertility-clinic",
    "name": "Western Fertility Institute",
    "phone": "(818) 292-2242",
    "address": {
      "line1": "16260 Ventura Blvd, Suite 210",
      "city": "Encino",
      "state": "CA",
      "zip": "91436",
      "country": "US"
    },
    "location": {
      "lat": 34.1567,
      "lng": -118.488
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 57.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 52.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 38.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/12"
        }
      ],
      "cyclesPerYear": 192,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27706%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27706%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.westernfertility.com/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Western+Fertility+Institute+-+Encino,+16260+Ventura+Blvd+%23210,+Encino,+CA+91436/@34.1567272,-118.4877641,3302a,13.1y/data=!4m2!3m1!1s0x80c298276b0ce967:0x4db7495f5ca3c852",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.westernfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-706-ashim-kumar",
        "name": "Ashim Kumar",
        "role": "Medical Director",
        "imageUrl": "https://www.westernfertility.com/wp-content/uploads/2016/01/Dr_Kumar_photo-tight.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.westernfertility.com/our-physicians/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.westernfertility.com",
    "languages": ["Italian", "English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "description": "Western Fertility Institute provides personalized fertility care from offices in Encino and Arcadia, California, with services including in vitro fertilization, artificial insemination, surrogacy, egg donation, and egg freezing. For over two decades the practice has helped intended parents from close to home and across the globe build their families, and it believes any person who wishes to have a family has the right to pursue that dream regardless of marital status or sexual orientation.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk0PqwkPV5n4gM8-X9rhEJQyIDiGc7RojNHEnBz9TCsMK_yKCY7pPMstqJY1dUX3Yv5J1L64F9S-DDH5YlvwlLbFZmuRyp_zzvM32SY7ge-o01d7CQ49n3L5GW6XxtguoqERlhA=w460-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Western+Fertility+Institute+-+Encino,+16260+Ventura+Blvd+%23210,+Encino,+CA+91436/@34.1567272,-118.4877641,3302a,13.1y/data=!4m2!3m1!1s0x80c298276b0ce967:0x4db7495f5ca3c852",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnHMPw-hLj5OqDNmCSpdiWUK6EbauNhTu2nT6G4DjJ5u-T6ex0gpUKD7GhMBj2vDWZG5gyVvIekC9kWU4hWA99T3RVUTSvFxduHK_I2LuF8NdYX7Td6giy7QSRKkHjl9JqXfds=w408-h308-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Western+Fertility+Institute+-+Encino,+16260+Ventura+Blvd+%23210,+Encino,+CA+91436/@34.1567272,-118.4877641,3302a,13.1y/data=!4m2!3m1!1s0x80c298276b0ce967:0x4db7495f5ca3c852",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-359",
    "externalIds": {
      "cdcClinicId": "359",
      "googlePlaceId": "ChIJk0exAsuej4ARnvLyYCDg5u8"
    },
    "type": "fertility-clinic",
    "name": "HRC Fertility - Foster City (formerly Zouves Fertility Center)",
    "phone": "(650) 378-1000",
    "address": {
      "line1": "1241 E. Hillsdale Blvd, Suite 100",
      "city": "Foster City",
      "state": "CA",
      "zip": "94404",
      "country": "US"
    },
    "location": {
      "lat": 37.5679,
      "lng": -122.268
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 44,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 48.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 51.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 202,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27359%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27359%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/locations/foster-city/",
            "fetchedAt": "2026-06-10"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/HRC+Fertility+-+Silicon+Valley+Area,+1241+E+Hillsdale+Blvd+%23100,+Foster+City,+CA+94404/@37.567891,-122.2676373,3162a,13.1y/data=!4m2!3m1!1s0x808f9ecb02b14793:0xefe6e02060f2f29e",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.goivf.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-359-christo-g-zouves-md",
        "name": "Christo G. Zouves, MD",
        "role": "Medical Director",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2025/07/Dr-Zouves-7-30-2025-360X480.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://www.havingbabies.com/locations/foster-city/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-cdc-359-arian-khorshid",
        "name": "Arian Khorshid",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2025/11/dr-arian-khorshid-2025-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/foster-city/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "website": "https://www.havingbabies.com/locations/foster-city/",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ]
    },
    "network": {
      "name": "HRC Fertility"
    },
    "description": "HRC Fertility has been at the forefront of fertility care for over three decades, offering individualized, science-backed treatments to help aspiring parents grow their families. The Foster City fertility clinic is led by the renowned Dr. Christo Zouves, MD. Patients have access to a full spectrum of fertility treatments, from initial testing and diagnosis to advanced procedures like IVF, egg freezing, and third-party reproduction medical evaluations, serving individuals, couples, and LGBTQ+ families.",
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnaa54fbO8EIgSxHjclVBhOBX3Qc16BqL7hupjePC-FBJM1apMCToz2QRPxq5n9cmh2MYT7DED5G3jtc3Yo5AH45-Q2nBuTkH_WbipoRl3Xqq1zNk0zkS25mKsTp1IHhId9JwtZ=w448-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/HRC+Fertility+-+Silicon+Valley+Area,+1241+E+Hillsdale+Blvd+%23100,+Foster+City,+CA+94404/@37.567891,-122.2676373,3162a,13.1y/data=!4m2!3m1!1s0x808f9ecb02b14793:0xefe6e02060f2f29e",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnwJ1CUPpvQEWEUSO8EaaoGCbkk-m69_j_hgrSBi3Ep9Vj6tFeV3BKe0WcXylIyAQAOyN8pz92R0YWAtHOeMt_UK6V0cNZWPy10kUJmCL5GfWsxmYu1sS9njcvWBrH1nuPX67cJ=w448-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/HRC+Fertility+-+Silicon+Valley+Area,+1241+E+Hillsdale+Blvd+%23100,+Foster+City,+CA+94404/@37.567891,-122.2676373,3162a,13.1y/data=!4m2!3m1!1s0x808f9ecb02b14793:0xefe6e02060f2f29e",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-153",
    "externalIds": {
      "cdcClinicId": "153",
      "googlePlaceId": "ChIJxUzV6VJEE4cR-88z-cpBfAM"
    },
    "type": "fertility-clinic",
    "name": "CNY Fertility Colorado",
    "description": "Known for making fertility treatment affordable at a fraction of the national average, with in-house payment plans and a holistic wellness approach including acupuncture and yoga.",
    "website": "https://www.cnyfertility.com/location/colorado-springs/",
    "phone": "(719) 475-2229",
    "email": "submissions@cnyfertility.com",
    "bookingUrl": "https://schedule.cnyfertility.com/",
    "address": {
      "line1": "265 S. Parkside Dr, Suite 200",
      "city": "Colorado Springs",
      "state": "CO",
      "zip": "80910",
      "country": "US"
    },
    "location": {
      "lat": 38.8283,
      "lng": -104.789
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "miniIVF"
      },
      {
        "name": "PRP",
        "category": "wellness"
      }
    ],
    "insurance": {
      "accepted": false,
      "financingOptions": [
        "Payment plans",
        "Loans",
        "Discount pricing",
        "Future Family",
        "CapexMD"
      ]
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 21.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 19,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 11,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 7.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1389,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27153%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "consultationTypes": ["in-person", "telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27153%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "scraped"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.cnyfertility.com/location/colorado-springs/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CNY+Fertility+Colorado+Springs,+265+S+Parkside+Dr+%23200,+Colorado+Springs,+CO+80910/@38.8282624,-104.7891611,3108a,13.1y/data=!4m2!3m1!1s0x87134452e9d54cc5:0x37c41caf933cffb",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped"
        },
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-153-robert-j-kiltz-md",
        "name": "Robert J. Kiltz, MD",
        "role": "Medical Director"
      },
      {
        "name": "Fernando L. Gomez, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": [
          "MD",
          "Board-certified OB/GYN",
          "Board-certified Reproductive Endocrinology/Infertility"
        ],
        "imageUrl": "https://www.cnyfertility.com/wp-content/uploads/Dr.-Gomez-CNY-Fertility.png",
        "_source": {
          "url": "https://www.cnyfertility.com/our-team-members/fernando-l-gomez-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-153-fernando-l-gomez-md"
      },
      {
        "name": "Maria Gondra, MD",
        "role": "Physician (Obstetrics & Gynecology / Fertility and Reproductive Medicine)",
        "credentials": ["MD", "Board-certified OB/GYN"],
        "imageUrl": "https://www.cnyfertility.com/wp-content/uploads/Gondra-2.jpg",
        "_source": {
          "url": "https://www.cnyfertility.com/our-team-members/maria-gondra-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-153-maria-gondra-md"
      },
      {
        "name": "Brandis Montez, FNP-BC",
        "role": "Fertility Nurse Practitioner",
        "credentials": ["FNP-BC", "AGACNP-BC"],
        "imageUrl": "https://www.cnyfertility.com/wp-content/uploads/C49A3811.jpg",
        "_source": {
          "url": "https://www.cnyfertility.com/our-team-members/brandis-montez/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-153-brandis-montez-fnp-bc"
      }
    ],
    "network": {
      "name": "CNY Fertility"
    },
    "languages": ["English", "Spanish"],
    "pricing": {
      "packages": [
        {
          "name": "Virtual Consultation",
          "price": 5000,
          "currency": "USD"
        },
        {
          "name": "IUI",
          "description": "Intrauterine insemination",
          "price": 65000,
          "currency": "USD",
          "notes": "Excludes medications"
        },
        {
          "name": "IVF",
          "description": "In vitro fertilization — clinic fee only",
          "price": 390000,
          "currency": "USD",
          "notes": "Clinic fee only; excludes medications, monitoring, and add-ons"
        },
        {
          "name": "IVF Full Cycle",
          "description": "Complete IVF cycle with core add-ons included",
          "price": 729500,
          "priceMax": 1200000,
          "currency": "USD",
          "includes": [
            "Retrieval",
            "ICSI",
            "Assisted hatching",
            "Cryopreservation"
          ],
          "excludes": ["Medications ($1,500 - $6,000)"],
          "notes": "Range depends on medications and protocol add-ons"
        },
        {
          "name": "Egg Freezing",
          "description": "Oocyte cryopreservation procedure",
          "price": 299900,
          "priceMax": 449000,
          "currency": "USD",
          "notes": "Procedure fee; approximately 1/3 national average ($11,500)"
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 99500,
          "priceMax": 194000,
          "currency": "USD",
          "includes": ["Monitoring (at higher end)"]
        },
        {
          "name": "Donor Egg IVF",
          "description": "In-house donor egg package",
          "price": 1129500,
          "currency": "USD",
          "includes": ["4 fresh donor eggs"]
        }
      ],
      "financingOptions": [
        {
          "name": "In-house payment plans (~100% approval rate)",
          "description": "In-house payment plans (~100% approval rate)"
        },
        {
          "name": "Fertile Guarantee shared-risk program (up to 75% refund if no live birth after 6 cycles)",
          "description": "Fertile Guarantee shared-risk program (up to 75% refund if no live birth after 6 cycles)"
        }
      ],
      "disclaimer": "Medications are additional ($1,500 - $6,000 depending on protocol). Most patients need approximately 2 IVF cycles for a live birth. Storage costs approximately $650/year.",
      "_source": {
        "url": "https://www.cnyfertility.com/costs/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "7 public price package(s) and 2 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.cnyfertility.com/costs/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Colorado (CO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmL8ZmfzokuttID6jIS6cH_O-HGBRpEMF9-aBpyTLqujMKXwCof32QSeJlPdeltlhui3jd4b1_l2LgZhJ2kxKqilvpqiiCYQlNq79XtoDqBbhGe-v1oBvJ4x0G_FPHjfmaVp_jcuYxi2nJY=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CNY+Fertility+Colorado+Springs,+265+S+Parkside+Dr+%23200,+Colorado+Springs,+CO+80910/@38.8282624,-104.7891611,3108a,13.1y/data=!4m2!3m1!1s0x87134452e9d54cc5:0x37c41caf933cffb",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmR0Dyw9wCV75wLFkcA2I-yyPLCsbO0-RoKXfawWvfKaGRA8tTs6pah_glCchALXWbfRiadanpyZ0Esb_f7kfKVmA-hSFowKAtrKHUUmcacX9vkSwA_gKoL-JhGx31B92J4ddBpCA=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CNY+Fertility+Colorado+Springs,+265+S+Parkside+Dr+%23200,+Colorado+Springs,+CO+80910/@38.8282624,-104.7891611,3108a,13.1y/data=!4m2!3m1!1s0x87134452e9d54cc5:0x37c41caf933cffb",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-49",
    "externalIds": {
      "cdcClinicId": "49"
    },
    "type": "fertility-clinic",
    "name": "Colorado Center for Reproductive Medicine",
    "description": "A nationally recognized fertility network with an all-inclusive Lone Tree facility housing an on-site clinic, surgery center, IVF lab, and genetics lab.",
    "website": "https://www.ccrmivf.com",
    "phone": "(303) 788-8300",
    "bookingUrl": "https://www.ccrmivf.com/schedule-appointment/",
    "address": {
      "line1": "10290 RidgeGate Cir",
      "city": "Lone Tree",
      "state": "CO",
      "zip": "80124",
      "country": "US"
    },
    "location": {
      "lat": 39.5293,
      "lng": -104.875
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "financingOptions": [
        "Payment plans",
        "Package pricing",
        "Discount pricing",
        "Future Family",
        "CapexMD"
      ]
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 62.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 60.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 54.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 47.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1830,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2749%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "languages": ["es"],
    "consultationTypes": ["in-person", "telehealth"],
    "patientGroups": ["LGBTQIA+", "Same sex couples"],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2749%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "scraped"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/colorado/lone-tree/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "scraped"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-49-william-b-schoolcraft-md",
        "name": "William B. Schoolcraft, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/08/Bill-Schoolcraft-1000x1000.png",
        "credentials": ["MD", "HCLD"],
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/william-schoolcraft/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Sara Barton, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Sara_Barton_600x600_2x-r9yqls6nfv7ch4iaxgu93vup557x56mgmjznxgry5c.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/colorado/lone-tree/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-49-sara-barton-md"
      },
      {
        "name": "Lauren Ehrhart, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Lauren_Ross_Ehrhart_600x600_2x-r9yqlabpu0iwcj88tr4caicxutny2xnk83lft7iffk.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/colorado/lone-tree/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-49-lauren-ehrhart-md"
      },
      {
        "name": "Laxmi Kondapalli, MD, MSCE",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MSCE"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Laxmi_Kondapalli_600x600_2x-r9yqma1l1pvslpsd16k5x9cgfgrw7fld10dw1q1gv4.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/colorado/lone-tree/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-49-laxmi-kondapalli-md-msce"
      },
      {
        "name": "Robert Gustofson, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Robert_Gustafson_600x600_2x-r9yqmsucuelj1x11zeopb4lob678hdnzrlfln99leo.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/colorado/lone-tree/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-49-robert-gustofson-md"
      },
      {
        "name": "Eric Surrey, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Eric_Surrey_600x600_2x-r9yqn6xxox4tw2gkp2s3uj1l7y9qou7ytj7vueootc.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/colorado/lone-tree/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-49-eric-surrey-md"
      },
      {
        "name": "Tiffany Von Wald, MD, MPH",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MPH"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Tiffany_Von_Wald_600x600_2x-r9yqkopfgtpaxi3nbzrx75tc6ymi5w9qh4l9rueheo.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/colorado/lone-tree/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-49-tiffany-von-wald-md-mph"
      },
      {
        "name": "Sarah Gallegos, CNM",
        "role": "Certified Nurse Midwife",
        "credentials": ["CNM"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/APP-Sarah-Gallegos-rfq9inpfwtexv5g81bt102a8v0q9ppwajozdxvo04g.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/colorado/lone-tree/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-49-sarah-gallegos-cnm"
      },
      {
        "name": "Kate Odenwald, ACNP-BC",
        "role": "Acute Care Nurse Practitioner",
        "credentials": ["ACNP-BC"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Kate-Odenwald-rmgnpqn805m04h3i2winsnfr73gryb5ljl2u7ql6e8.png",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/colorado/lone-tree/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-49-kate-odenwald-acnp-bc"
      },
      {
        "name": "Alisia (Lisa) Ortiz, WHNP-BC",
        "role": "Women's Health Nurse Practitioner",
        "credentials": ["WHNP-BC"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Alisia_Lisa_Ortiz_600x600_2x-rbxvo8iterxq013ypr8okxc94yrydy3eqj66h57jxc.png",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/colorado/lone-tree/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-49-alisia-lisa-ortiz-whnp-bc"
      }
    ],
    "images": [
      {
        "url": "https://www.ccrmivf.com/wp-content/uploads/2025/08/labresearchhero_d.png",
        "type": "lab",
        "caption": "Embryologist working at a micromanipulation microscope in the CCRM IVF/embryology laboratory, with an embryo displayed on the monitor",
        "_source": {
          "url": "https://www.ccrmivf.com/lab-research/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.ccrmivf.com/wp-content/uploads/2025/08/CCRM-Research-Group-Photo-1-800x534@2x.jpg",
        "type": "exterior",
        "caption": "CCRM team outside the main entrance of the Lone Tree clinic building at 10290 RidgeGate Circle",
        "_source": {
          "url": "https://www.ccrmivf.com/lab-research/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Colorado (CO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-91",
    "externalIds": {
      "cdcClinicId": "91",
      "googlePlaceId": "ChIJhUVODYCBbIcRYu6ihjxxKdA"
    },
    "type": "fertility-clinic",
    "name": "Conceptions Reproductive Associates of Colorado",
    "phone": "(303) 794-0045",
    "address": {
      "line1": "271 W. County Line Rd",
      "city": "Littleton",
      "state": "CO",
      "zip": "80129",
      "country": "US"
    },
    "location": {
      "lat": 39.5673,
      "lng": -104.993
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 70.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 67,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 69.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 61.53846153846154,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "8/13"
        }
      ],
      "cyclesPerYear": 1153,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2791%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2791%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.conceptionsrepro.com/providers/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Conceptions+Reproductive+Associates+of+Colorado+%7C+RMA,+271+W+County+Line+Rd,+Littleton,+CO+80129/@39.5673397,-104.9929664,3076a,13.1y/data=!4m2!3m1!1s0x876c81800d4e4585:0xd029713c86a2ee62",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-91-robert-a-greene-md-facog",
        "name": "Robert A. Greene, MD, FACOG",
        "role": "Medical Director",
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2022/01/2.png",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.conceptionsrepro.com/staff/robert-greene/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Mark Bush, MD, FACOG, FACS",
        "role": "Reproductive Endocrinologist (Physician Partner)",
        "credentials": ["MD", "FACOG", "FACS"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2022/01/1.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/staff/mark-bush/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-91-mark-bush-md-facog-facs"
      },
      {
        "name": "Althea O'Shaughnessy, MD, FACOG",
        "role": "Reproductive Endocrinologist (Physician Partner)",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2022/01/4.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/staff/althea-oshaughnessy/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-91-althea-o-shaughnessy-md-facog"
      },
      {
        "name": "Jasmine Chiang, MD, FACOG",
        "role": "Reproductive Endocrinologist (Physician Partner)",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2022/01/6.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/staff/jasmine-chiang/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-91-jasmine-chiang-md-facog"
      },
      {
        "name": "Aimee Ferrandino, MD, FACOG",
        "role": "Obstetrician-Gynecologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2024/10/Untitled-design-47.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/staff/aimee-ferrandino/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-91-aimee-ferrandino-md-facog"
      },
      {
        "name": "Malgorzata E. Skaznik-Wikiel, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2023/05/gosia-square.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/staff/malgorzata-e-skaznik-wikiel/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-91-malgorzata-e-skaznik-wikiel-md-facog"
      },
      {
        "name": "Simone Elder, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2025/08/Doctor-Mobile-website-headshot-264-x-264-px-400-x-400-px-1.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/staff/simone-elder-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-91-simone-elder-md-facog"
      }
    ],
    "website": "https://www.conceptionscenter.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "images": [
      {
        "url": "https://www.conceptionsrepro.com/wp-content/uploads/2022/10/image002.jpg",
        "type": "exterior",
        "caption": "Exterior of the Conceptions Reproductive Associates Littleton building (271 W. County Line Rd), the practice's primary location, with the Colorado Front Range in the background.",
        "_source": {
          "url": "https://www.conceptionsrepro.com/littleton-colorado/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "setting": "network-group",
    "bookingUrl": "https://rmanetwork.com/our-locations/conceptions-reproductive-associates-of-colorado-rma/",
    "description": "Conceptions RMA fertility clinic in Littleton, CO. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "network": {
      "name": "IVI RMA"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Colorado (CO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-36",
    "externalIds": {
      "cdcClinicId": "36",
      "googlePlaceId": "ChIJKUrmV2yFbIcRCn8QGX-JQLs"
    },
    "type": "fertility-clinic",
    "name": "Denver Fertility-Albrecht Women's Care",
    "phone": "(720) 420-1570",
    "address": {
      "line1": "9780 Pyramid Ct, Suite 260",
      "city": "Englewood",
      "state": "CO",
      "zip": "80112",
      "country": "US"
    },
    "location": {
      "lat": 39.5387,
      "lng": -104.865
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 56.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 59.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 35.294117647058826,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/17"
        }
      ],
      "cyclesPerYear": 143,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2736%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2736%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.denverfertilitycare.com/locations/englewood-office/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Denver+Fertility+Care,+9780+Mount+Pyramid+Ct+%23260,+Englewood,+CO+80112/@39.5386423,-104.8652529,3077a,13.1y/data=!4m2!3m1!1s0x876c856c57e64a29:0xbb40897f19107f0a",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-36-bruce-h-albrecht-md",
        "name": "Bruce H. Albrecht, MD",
        "role": "Medical Director",
        "imageUrl": "https://einstein-clients.imgix.net/7595/427012/original.jpg?1679521906=&auto=format&fit=max&w=600",
        "credentials": ["MD"],
        "_source": {
          "url": "https://www.denverfertilitycare.com/doctors/bruce-albrecht-md/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Dana Ambler, DO",
        "role": "Reproductive Endocrinologist, OB/GYN, and Fertility Specialist",
        "credentials": ["DO"],
        "imageUrl": "https://einstein-clients.imgix.net/7595/427013/original.jpg?1679521906=&auto=format&fit=max&w=600",
        "_source": {
          "url": "https://www.denverfertilitycare.com/doctors/dana-ambler-do/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-36-dana-ambler-do"
      },
      {
        "name": "Bryan T. Kloos, PhD, HCLD",
        "role": "Embryology Laboratory Director",
        "credentials": ["PhD", "HCLD"],
        "imageUrl": "https://einstein-clients.imgix.net/7595/433004/original_Bryan_Kloos.JPG?1686353611=&auto=format&fit=max&w=1020",
        "_source": {
          "url": "https://www.denverfertilitycare.com/doctors/bryan-t-kloos-phd-hcld/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-36-bryan-t-kloos-phd-hcld"
      },
      {
        "name": "Ellen DiSesa, WHNP-BC",
        "role": "Women's Health Nurse Practitioner",
        "credentials": ["NP", "WHNP-BC"],
        "imageUrl": "https://einstein-clients.imgix.net/7595/460787/original_Ellen.jpeg?1720555762",
        "_source": {
          "url": "https://www.denverfertilitycare.com/doctors/ellen-disesa/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-36-ellen-disesa-whnp-bc"
      }
    ],
    "website": "https://www.denverfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "images": [
      {
        "url": "https://einstein-clients.imgix.net/7595/383795/original.jpg?fit=crop&w=1000&auto=format",
        "type": "lab",
        "caption": "Embryology / IVF lab micromanipulation station with inverted microscope and embryo imaging monitor at the Englewood clinic",
        "_source": {
          "url": "https://www.denverfertilitycare.com/locations/englewood-office/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlHcEwvnZGgunS2i_wiQkGASGMJZpLE0_nxyTDcayl4CbPNzZlzq01cBTUf9tEc2RihVu9s5siJ6tS6Cn_WMRRKkNpEsCABszW0hPnIOXUERL8PJYZ39gbV_hjsaOF5MSkpRpUY=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Denver+Fertility+Care,+9780+Mount+Pyramid+Ct+%23260,+Englewood,+CO+80112/@39.5386423,-104.8652529,3077a,13.1y/data=!4m2!3m1!1s0x876c856c57e64a29:0xbb40897f19107f0a",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Colorado (CO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-897",
    "externalIds": {
      "cdcClinicId": "897",
      "googlePlaceId": "ChIJL2eJOT1_bIcRTLq2GgqDx_A"
    },
    "type": "fertility-clinic",
    "name": "Kindbody - Denver",
    "phone": "(720) 370-5671",
    "address": {
      "line1": "220 Josephine St",
      "city": "Denver",
      "state": "CO",
      "zip": "80206",
      "country": "US"
    },
    "location": {
      "lat": 39.7191,
      "lng": -104.9569
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 0,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27897%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27897%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.kindbody.com/ivf-cost/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/location/denver-mobile-clinic/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+Denver,+220+Josephine+St,+Denver,+CO+80206/@39.7200018,-104.9579866,3069a,13.1y/data=!4m2!3m1!1s0x876c7f3d3989672f:0xf0c7830a1ab6ba4c",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-897-natalia-grob-md",
        "name": "Natalia Grob, MD",
        "role": "Medical Director",
        "imageUrl": "https://nataliagrob.com/wp-content/uploads/2021/12/conceptions-reproductive-associates-2021-web-13nmg.jpg",
        "credentials": ["MD", "FACOG", "REI"],
        "_source": {
          "url": "https://nataliagrob.com/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "network": {
      "name": "Kindbody"
    },
    "website": "https://www.kindbody.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Anthem",
        "Blue Cross Blue Shield",
        "Cigna",
        "Emblem Health",
        "Empire Blue Cross Blue Shield",
        "First Health",
        "Health Net",
        "Horizon",
        "Humana",
        "Maven",
        "Medicare",
        "Medicaid",
        "MultiPlan",
        "Optum",
        "Oscar",
        "Oxford",
        "Progyny",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven"],
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "pricing": {
      "packages": [
        {
          "name": "Pulse Assessment",
          "description": "Quick fertility check — not covered by insurance",
          "price": 9900,
          "currency": "USD",
          "includes": [
            "AMH blood test",
            "Transvaginal ultrasound for follicle count",
            "15-minute reproductive consultation"
          ],
          "notes": "Not covered by insurance"
        },
        {
          "name": "Fertility Consultation",
          "description": "Specialist consultation on fertility fundamentals",
          "price": 30000,
          "currency": "USD",
          "notes": "Billable to most insurance plans"
        },
        {
          "name": "Male Consultation + Semen Analysis",
          "price": 52500,
          "currency": "USD",
          "includes": ["Consultation", "Venipuncture", "Semen analysis"]
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Single egg freezing cycle",
          "price": 690000,
          "priceMax": 966000,
          "currency": "USD",
          "includes": [
            "Stimulation visits",
            "Ultrasounds",
            "Blood draws",
            "Retrieval",
            "Cryopreservation",
            "3 months storage",
            "Coordination"
          ],
          "excludes": ["Medications ($4,000 - $6,000)", "Anesthesia"]
        },
        {
          "name": "Annual Egg Storage",
          "price": 92000,
          "currency": "USD",
          "notes": "Per year"
        },
        {
          "name": "IVF Freeze All (Self Pay)",
          "description": "IVF cycle with all embryos frozen",
          "price": 1160000,
          "priceMax": 1850000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Cryopreservation",
            "3 months storage"
          ],
          "excludes": [
            "Medications (~$4,000 - $6,000)",
            "Embryo biopsy/genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Donor services",
            "Anesthesia"
          ]
        },
        {
          "name": "IVF Fresh Transfer (Self Pay)",
          "description": "IVF cycle with fresh embryo transfer",
          "price": 1380000,
          "priceMax": 1875000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$5,000 - $9,000)",
            "Genetic testing",
            "Surplus embryo storage",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Freeze All",
          "price": 910000,
          "priceMax": 1332000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Cryopreservation",
            "3-month storage"
          ],
          "excludes": [
            "Genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Fresh Transfer",
          "price": 990000,
          "priceMax": 1428000,
          "currency": "USD",
          "includes": [
            "Ultrasounds",
            "Thaw",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Surplus storage",
            "Frozen transfers",
            "Anesthesia"
          ]
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 400000,
          "priceMax": 550000,
          "currency": "USD",
          "includes": ["Ultrasounds", "Thaw", "Assisted hatching", "Transfer"],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "PGT Package",
          "description": "Preimplantation genetic testing",
          "price": 160000,
          "priceMax": 300000,
          "currency": "USD",
          "includes": ["Embryo biopsy", "Lab management"],
          "excludes": ["Storage", "Shipping", "Per-embryo testing costs"]
        },
        {
          "name": "Nutrition Coaching",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Counseling & Support",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Guided Meditation",
          "description": "Virtual wellness — 30-minute session",
          "price": 9000,
          "currency": "USD"
        }
      ],
      "financingOptions": [
        {
          "name": "PatientFi monthly payments",
          "description": "PatientFi monthly payments"
        }
      ],
      "disclaimer": "Prices vary by location. Medications and anesthesia are not included in procedure costs. 3 months of storage included with freeze procedures; annual storage is $920.",
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "images": [
      {
        "url": "https://kindbody.com/wp-content/uploads/2022/04/IMG_8131-scaled.jpg",
        "type": "interior",
        "caption": "Interior of Kindbody Denver clinic featuring the signature flower wall with the message 'Health and fertility care reimagined' and the Kindbody logo, with pendant lighting in the reception area.",
        "_source": {
          "url": "https://kindbody.com/denver-opening-blog/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Blue Cross Blue Shield, Cigna, Emblem Health, Empire Blue Cross Blue Shield, First Health, Health Net",
              "detail": "12 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "14 public price package(s) and 1 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Colorado (CO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-110",
    "externalIds": {
      "cdcClinicId": "110"
    },
    "type": "fertility-clinic",
    "name": "Rocky Mountain Center for Reproductive Medicine",
    "phone": "(970) 493-6353",
    "address": {
      "line1": "1080 E. Elizabeth St",
      "city": "Fort Collins",
      "state": "CO",
      "zip": "80524",
      "country": "US"
    },
    "location": {
      "lat": 40.5745,
      "lng": -105.059
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 51.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 45.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 58,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27110%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27110%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://drbachus.com/about-us/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-110-kevin-e-bachus-md",
        "name": "Kevin E. Bachus, MD",
        "role": "Medical Director",
        "imageUrl": "https://drbachus.com/wp-content/uploads/2023/12/Dr.-Bachus-Rocky-Mountain-Center-For-Reproductive-Medicine-e1701977479538.webp",
        "credentials": [
          "MD",
          "Board Certified in Obstetrics and Gynecology",
          "Board Certified in Reproductive Endocrinology and Infertility"
        ],
        "_source": {
          "url": "https://drbachus.com/about-us/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Kate Odenwald",
        "role": "Acute Care Nurse Practitioner",
        "credentials": [
          "ACNP-BC",
          "MSN",
          "BSN",
          "Board Certified in Reproductive Endocrinology and Infertility"
        ],
        "imageUrl": "https://drbachus.com/wp-content/uploads/2023/12/Kate-Odenwald-ACNP-BC-e1701977644229.webp",
        "_source": {
          "url": "https://drbachus.com/about-us/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-110-kate-odenwald"
      },
      {
        "name": "Hayley M. Benham",
        "role": "IVF/Embryology Laboratory Director",
        "credentials": [
          "PhD",
          "HCLD(ABB)",
          "Board-Certified High Complexity Laboratory Director"
        ],
        "imageUrl": "https://drbachus.com/wp-content/uploads/2023/12/Hayley-Benham-e1701977745881.webp",
        "_source": {
          "url": "https://drbachus.com/about-us/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-110-hayley-m-benham"
      },
      {
        "name": "Alyssa Patton",
        "role": "Laboratory Supervisor / Embryologist",
        "credentials": ["BSc", "TS"],
        "imageUrl": "https://drbachus.com/wp-content/uploads/2023/12/Alyssa-Patton-Embryologist-e1701977723332.webp",
        "_source": {
          "url": "https://drbachus.com/about-us/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-110-alyssa-patton"
      }
    ],
    "website": "https://www.rockymountainfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "images": [],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Colorado (CO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-299",
    "externalIds": {
      "cdcClinicId": "299"
    },
    "type": "fertility-clinic",
    "name": "Rocky Mountain Fertility Center",
    "phone": "(303) 999-3877",
    "address": {
      "line1": "12770 Lynnfield Dr",
      "city": "Englewood",
      "state": "CO",
      "zip": "80112",
      "country": "US"
    },
    "location": {
      "lat": 39.5367,
      "lng": -104.842
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 75,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 43,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27299%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27299%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://onto.health/colorado/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-299-deborah-l-smith-md",
        "name": "Deborah L. Smith, MD",
        "role": "Medical Director"
      },
      {
        "name": "Roohi Jeelani, MD, FACOG",
        "role": "Reproductive Endocrinology & Infertility, OB/GYN (Founder/CEO)",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://onto.health/wp-content/smush-webp/roohi-jeelani-1.jpg.webp",
        "_source": {
          "url": "https://onto.health/colorado/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-299-roohi-jeelani-md-facog"
      },
      {
        "name": "Staci Gorson",
        "role": "Vice President of Provider Operations | Nurse Practitioner",
        "credentials": ["NP"],
        "imageUrl": "https://onto.health/wp-content/smush-webp/Staci-Gorson.jpg.webp",
        "_source": {
          "url": "https://onto.health/colorado/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-299-staci-gorson"
      },
      {
        "name": "Karla Waggener",
        "role": "Lab Supervisor, Senior Embryologist",
        "credentials": [],
        "imageUrl": "https://onto.health/wp-content/smush-webp/unnamed-4.jpg.webp",
        "_source": {
          "url": "https://onto.health/colorado/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-299-karla-waggener"
      },
      {
        "name": "Tana Milner",
        "role": "Embryologist/Lab Manager",
        "credentials": [],
        "imageUrl": "https://onto.health/wp-content/smush-webp/Tana-Milner.jpg.webp",
        "_source": {
          "url": "https://onto.health/colorado/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-299-tana-milner"
      },
      {
        "name": "Matthew Hammerquist",
        "role": "Lead Andrologist/Junior Embryologist",
        "credentials": [],
        "imageUrl": "https://onto.health/wp-content/smush-webp/Matthew-Hammerquist.jpg.webp",
        "_source": {
          "url": "https://onto.health/colorado/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-299-matthew-hammerquist"
      },
      {
        "name": "Kathy Wisniewski, BA, RDMS",
        "role": "Sonographer",
        "credentials": ["BA", "RDMS"],
        "imageUrl": "https://onto.health/wp-content/smush-webp/unnamed-1.jpg.webp",
        "_source": {
          "url": "https://onto.health/colorado/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-299-kathy-wisniewski-ba-rdms"
      },
      {
        "name": "Claire McCarthy, RN",
        "role": "IVF Nurse Coordinator",
        "credentials": ["RN"],
        "imageUrl": "https://onto.health/wp-content/smush-webp/Claire-McCarthy.jpg.webp",
        "_source": {
          "url": "https://onto.health/colorado/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-299-claire-mccarthy-rn"
      },
      {
        "name": "Daniela Gonzalez",
        "role": "Vice President of Clinical Operations",
        "credentials": [],
        "imageUrl": "https://onto.health/wp-content/smush-webp/Daniela-Gonzalez.jpg.webp",
        "_source": {
          "url": "https://onto.health/colorado/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-299-daniela-gonzalez"
      },
      {
        "name": "Brinna Leach",
        "role": "Clinical Coordinator",
        "credentials": [],
        "imageUrl": "https://onto.health/wp-content/smush-webp/Brinna-Leach.jpg.webp",
        "_source": {
          "url": "https://onto.health/colorado/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-299-brinna-leach"
      },
      {
        "name": "Noelle Lawrence",
        "role": "Care Advocate",
        "credentials": [],
        "imageUrl": "https://onto.health/wp-content/smush-webp/unnamed-3-1.jpg.webp",
        "_source": {
          "url": "https://onto.health/colorado/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-299-noelle-lawrence"
      }
    ],
    "website": "https://www.rockymountainfertilitycenter.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Colorado (CO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-719",
    "externalIds": {
      "cdcClinicId": "719",
      "googlePlaceId": "ChIJdaIqlRWHbIcRoqi_Kb6YtQA"
    },
    "type": "fertility-clinic",
    "name": "Shady Grove Fertility Colorado",
    "phone": "(720) 704-8221",
    "address": {
      "line1": "8200 E. Belleview Ave, Suite 615-E",
      "city": "Greenwood Village",
      "state": "CO",
      "zip": "80111",
      "country": "US"
    },
    "location": {
      "lat": 39.7604,
      "lng": -104.901
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 58.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 45.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 47.05882352941176,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "8/17"
        }
      ],
      "cyclesPerYear": 191,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27719%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27719%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/colorado/denver-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Denver,+8200+E+Belleview+Ave+%23615e,+Greenwood+Village,+CO+80111/@39.6236361,-104.8931144,3073a,13.1y/data=!4m2!3m1!1s0x876c8715952aa275:0xb598be29bfa8a2",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-719-alex-j-polotsky-md",
        "name": "Alex J. Polotsky, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Alex-Polotsky-hero.jpg",
        "credentials": ["MD", "MSc", "FACOG"],
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/polotsky/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Cassandra Roeca, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Cassandra-Roeca-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/roeca/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-719-cassandra-roeca-md"
      },
      {
        "name": "Elizabeth Clain, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/08/E.-Clain-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/clain/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-719-elizabeth-clain-md"
      },
      {
        "name": "Ivy L. Lersten, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2023/09/Ivy-Lersten-NEW-preferred_850-x-850.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/lersten/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-719-ivy-l-lersten-md"
      },
      {
        "name": "Pat McShane, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/10/Pat-McShane-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/mcshane/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-719-pat-mcshane-md"
      }
    ],
    "network": {
      "name": "US Fertility"
    },
    "website": "https://www.shadygrovefertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlKBGN8HeAI_tz_ga6kM9m34-tQuuM703NWu2NkqACYDNDJEL0Yrw9FStFmvd_ASxtuSpuycLuuBpwi3gEHZa-Jnec-sR_t-zel4m_-qu1FMeP6XiJn04JNEI0FPIMonBP4YCx-PQ=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Denver,+8200+E+Belleview+Ave+%23615e,+Greenwood+Village,+CO+80111/@39.6236361,-104.8931144,3073a,13.1y/data=!4m2!3m1!1s0x876c8715952aa275:0xb598be29bfa8a2",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Colorado (CO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-235",
    "externalIds": {
      "cdcClinicId": "235",
      "googlePlaceId": "ChIJma6b_dyt54kR1wSQwFT_OLc"
    },
    "type": "fertility-clinic",
    "name": "Center for Advanced Reproductive Services",
    "phone": "(844) 467-3483",
    "address": {
      "line1": "2 Batterson Park Road",
      "city": "Farmington",
      "state": "CT",
      "zip": "06032",
      "country": "US"
    },
    "location": {
      "lat": 41.7069,
      "lng": -72.8001
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 51.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 55.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 44.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 24,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1154,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27235%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27235%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://uconnfertility.com/why-choose-us/about-cars/our-providers/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Center+for+Advanced+Reproductive+Services+Farmington,+2+Batterson+Park+Rd,+Farmington,+CT+06032/@41.7066965,-72.8002312,2979a,13.1y/data=!4m2!3m1!1s0x89e7addcfd9bae99:0xb738ff54c09004d7",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://uconnfertility.com/why-choose-us/about-cars/our-providers/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-235-claudio-benadiva-md",
        "name": "Claudio Benadiva, MD",
        "role": "Director and Lead Physician",
        "credentials": ["MD", "HCLD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-ilamefd.nitrocdn.com/SaTldlPYKUFpfzzDffXJHGRWtltBRwCo/assets/images/optimized/rev-76a6d3b/uconnfertility.com/wp-content/uploads/elementor/thumbs/Claudio-Benadiva-ql7mh8jq5kmzix19xnsq73yxy11w6bn6d4lgo18mkg.jpg",
        "_source": {
          "url": "https://uconnfertility.com/why-choose-us/about-cars/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-235-david-schmidt-md",
        "name": "David Schmidt, MD",
        "role": "Lead Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-ilamefd.nitrocdn.com/SaTldlPYKUFpfzzDffXJHGRWtltBRwCo/assets/images/optimized/rev-76a6d3b/uconnfertility.com/wp-content/uploads/elementor/thumbs/Dr.Schmidt_web-ql7mwenygbekwd00cpuyxs5r2wa5egv847mkhsqw5c.jpg",
        "_source": {
          "url": "https://uconnfertility.com/why-choose-us/about-cars/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-235-lawrence-engmann-md-mrcog",
        "name": "Lawrence Engmann, MD, MRCOG",
        "role": "Lead Physician",
        "credentials": ["MD", "MRCOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-ilamefd.nitrocdn.com/SaTldlPYKUFpfzzDffXJHGRWtltBRwCo/assets/images/optimized/rev-76a6d3b/uconnfertility.com/wp-content/uploads/elementor/thumbs/engmann_new_web-ql7mswpl0im5om2ys7eynnxzh9iyr0z6yw7i6pxnb4.jpg",
        "_source": {
          "url": "https://uconnfertility.com/why-choose-us/about-cars/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-235-andrea-j-diluigi-md",
        "name": "Andrea J. DiLuigi, MD",
        "role": "Lead Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-ilamefd.nitrocdn.com/SaTldlPYKUFpfzzDffXJHGRWtltBRwCo/assets/images/optimized/rev-76a6d3b/uconnfertility.com/wp-content/uploads/elementor/thumbs/diluigi_new_web-ql7mq6yd9qwc560yn15rgcm1p6wsii73xgd09xyla8.jpg",
        "_source": {
          "url": "https://uconnfertility.com/why-choose-us/about-cars/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-235-daniel-grow-md-mhcm",
        "name": "Daniel Grow, MD, MHCM",
        "role": "Lead Physician",
        "credentials": ["MD", "MHCM"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-ilamefd.nitrocdn.com/SaTldlPYKUFpfzzDffXJHGRWtltBRwCo/assets/images/optimized/rev-76a6d3b/uconnfertility.com/wp-content/uploads/elementor/thumbs/grow_retouchedbkg_rev-ql7mr117cg1igot9re5to50spisjctiipl8jmspzr4.jpg",
        "_source": {
          "url": "https://uconnfertility.com/why-choose-us/about-cars/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-235-reeva-makhijani-md",
        "name": "Reeva Makhijani, MD",
        "role": "Lead Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-ilamefd.nitrocdn.com/SaTldlPYKUFpfzzDffXJHGRWtltBRwCo/assets/images/optimized/rev-76a6d3b/uconnfertility.com/wp-content/uploads/elementor/thumbs/ReevaMakhijani-ql7msdwt7twf8eu9tzaf9sorlk3mh2wk8b5sl6pirk.jpg",
        "_source": {
          "url": "https://uconnfertility.com/why-choose-us/about-cars/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-235-prachi-godiwala-md",
        "name": "Prachi Godiwala, MD",
        "role": "Lead Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-ilamefd.nitrocdn.com/SaTldlPYKUFpfzzDffXJHGRWtltBRwCo/assets/images/optimized/rev-76a6d3b/uconnfertility.com/wp-content/uploads/elementor/thumbs/PrachiGodiwala300dpi-ql7mo8gh167tyevd2ooqrceh5ak9h7f8nrfla6v48w.jpg",
        "_source": {
          "url": "https://uconnfertility.com/why-choose-us/about-cars/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-235-kelly-lynch-md",
        "name": "Kelly Lynch, MD",
        "role": "Lead Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-ilamefd.nitrocdn.com/SaTldlPYKUFpfzzDffXJHGRWtltBRwCo/assets/images/optimized/rev-76a6d3b/uconnfertility.com/wp-content/uploads/elementor/thumbs/KellyLynch_5x7-ql7mt48aj6wg9hs1kanz7m1o8chwglt1nxfe0xmhxc.jpg",
        "_source": {
          "url": "https://uconnfertility.com/why-choose-us/about-cars/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-235-maya-barsky-md-msci",
        "name": "Maya Barsky, MD, MSCI",
        "role": "Lead Physician",
        "credentials": ["MD", "MSCI"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-ilamefd.nitrocdn.com/SaTldlPYKUFpfzzDffXJHGRWtltBRwCo/assets/images/optimized/rev-76a6d3b/uconnfertility.com/wp-content/uploads/elementor/thumbs/Maya_5x7_300dpi-ql7mwpy0qbu0rojmiuqhrpba7iqjyu405rge94a62o.jpg",
        "_source": {
          "url": "https://uconnfertility.com/why-choose-us/about-cars/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-235-kim-crone-phd",
        "name": "Kim Crone, PhD",
        "role": "Psychologist",
        "credentials": ["PhD"],
        "specialty": "Psychology",
        "imageUrl": "https://cdn-ilamefd.nitrocdn.com/SaTldlPYKUFpfzzDffXJHGRWtltBRwCo/assets/images/optimized/rev-76a6d3b/uconnfertility.com/wp-content/uploads/elementor/thumbs/KimCrone2018-ql7mt48aj6wg9hs1kanz7m1o8chwglt1nxfe0xmhxc.jpg",
        "_source": {
          "url": "https://uconnfertility.com/why-choose-us/about-cars/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-235-stephanie-hallisey-md",
        "name": "Stephanie Hallisey, MD",
        "role": "Fellow",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-ilamefd.nitrocdn.com/SaTldlPYKUFpfzzDffXJHGRWtltBRwCo/assets/images/optimized/rev-76a6d3b/uconnfertility.com/wp-content/uploads/elementor/thumbs/stephanie-hallisey-ql7mkea74iyojqg2hiyl2t9ptnhb1p6p4rj7qijznk.jpg",
        "_source": {
          "url": "https://uconnfertility.com/why-choose-us/about-cars/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-235-louisa-drake-do",
        "name": "Louisa Drake, DO",
        "role": "Fellow",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-ilamefd.nitrocdn.com/SaTldlPYKUFpfzzDffXJHGRWtltBRwCo/assets/images/optimized/rev-76a6d3b/uconnfertility.com/wp-content/uploads/elementor/thumbs/processed-DDB19203-2736-4276-B4BA-FD19746ED472-qtvbb0js31fj71g0y6aoesh0r00ilq9eaw8bfsvl8g.jpg",
        "_source": {
          "url": "https://uconnfertility.com/why-choose-us/about-cars/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-235-molly-montano-msn-aprn-np-c",
        "name": "Molly Montano, MSN, APRN, NP-C",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "APRN", "NP-C"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-ilamefd.nitrocdn.com/SaTldlPYKUFpfzzDffXJHGRWtltBRwCo/assets/images/optimized/rev-76a6d3b/uconnfertility.com/wp-content/uploads/elementor/thumbs/Molly-Montano-headshot-2v4-ql7mkdccxoxe84hfn0jyibi989lxu02ysmvq98ldts.jpg",
        "_source": {
          "url": "https://uconnfertility.com/why-choose-us/about-cars/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-235-ami-chokshi-mba-nbc-hwc",
        "name": "Ami Chokshi, MBA, NBC-HWC",
        "role": "Health and Wellness Coach",
        "credentials": ["MBA", "NBC-HWC"],
        "specialty": "Health and Wellness Coaching",
        "imageUrl": "https://cdn-ilamefd.nitrocdn.com/SaTldlPYKUFpfzzDffXJHGRWtltBRwCo/assets/images/optimized/rev-76a6d3b/uconnfertility.com/wp-content/uploads/elementor/thumbs/Headshot_Ami-ql7mq6yd9qwc560yn15rgcm1p6wsii73xgd09xyla8.jpg",
        "_source": {
          "url": "https://uconnfertility.com/why-choose-us/about-cars/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-235-donald-b-maier-md",
        "name": "Donald B. Maier, MD",
        "role": "Founding Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-ilamefd.nitrocdn.com/SaTldlPYKUFpfzzDffXJHGRWtltBRwCo/assets/images/optimized/rev-76a6d3b/uconnfertility.com/wp-content/uploads/elementor/thumbs/DM-ql7mwenygbekwd00cpuyxs5r2wa5egv847mkhsqw5c.jpg",
        "_source": {
          "url": "https://uconnfertility.com/why-choose-us/about-cars/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-235-john-c-nulsen-md",
        "name": "John C. Nulsen, MD",
        "role": "Founding Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-ilamefd.nitrocdn.com/SaTldlPYKUFpfzzDffXJHGRWtltBRwCo/assets/images/optimized/rev-76a6d3b/uconnfertility.com/wp-content/uploads/elementor/thumbs/Nulsen_lores-1-ql7mr4sk3s6nr4nt5fsby42n32a07lxg23uhjwkf28.jpg",
        "_source": {
          "url": "https://uconnfertility.com/why-choose-us/about-cars/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.uconnfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "ConnectiCare",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnGiQAIREKxLVvJB6-KQsNBHlYllnoCGOQ9ODgUDeujtMq6b9AK9QG-FChHDv0vXPtShkE8rQx8cSnesaySkWsihWfyRy8kzSctH3EbzptgHRu8jGuoTofUQbS2ZRF71R54SUQ4seINhv3C=w494-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Center+for+Advanced+Reproductive+Services+Farmington,+2+Batterson+Park+Rd,+Farmington,+CT+06032/@41.7066965,-72.8002312,2979a,13.1y/data=!4m2!3m1!1s0x89e7addcfd9bae99:0xb738ff54c09004d7",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, ConnectiCare, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Connecticut (CT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-313",
    "externalIds": {
      "cdcClinicId": "313",
      "googlePlaceId": "ChIJHV8ORtGZwokRAbImJDVzv8w"
    },
    "type": "fertility-clinic",
    "name": "Greenwich Fertility and IVF Center, PC",
    "phone": "(203) 863-2990",
    "address": {
      "line1": "55 Holly Hill Ln, Suite 270",
      "city": "Greenwich",
      "state": "CT",
      "zip": "06830",
      "country": "US"
    },
    "location": {
      "lat": 41.0163,
      "lng": -73.6467
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 47.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 63.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 53.84615384615385,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/13"
        }
      ],
      "cyclesPerYear": 241,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27313%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27313%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.greenwichhospital.org/physicians/barry-r-witt",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Greenwich+Fertility+%26+Ivf+Center,+55+Holly+Hill+Ln+%23270,+Greenwich,+CT+06830/@41.0163435,-73.6466902,3010a,13.1y/data=!4m2!3m1!1s0x89c299d1460e5f1d:0xccbf73352426b201",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.greenwichhospital.org/physicians/barry-r-witt",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-313-barry-r-witt-md",
        "name": "Barry R. Witt, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/DrWitt_whitebackground_circle.png?width=1200&height=1200&name=DrWitt_whitebackground_circle.png",
        "_source": {
          "url": "https://www.illumefertility.com/about-us/fertility-care-team/dr-barry-witt",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.greenwichfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "ConnectiCare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, ConnectiCare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Connecticut (CT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-273",
    "externalIds": {
      "cdcClinicId": "273",
      "googlePlaceId": "ChIJLSyj46gd6IkR4il1zwQ1RVc"
    },
    "type": "fertility-clinic",
    "name": "Illume Fertility",
    "description": "Award-winning fertility clinic and first U.S. practice in The Fertility Partners network, recognized as an LGBTQ Healthcare Equality Leader seven years running.",
    "website": "https://www.illumefertility.com/locations/norwalk-ct",
    "phone": "(203) 750-7400",
    "email": "care@illumefertility.com",
    "bookingUrl": "https://www.illumefertility.com/schedule-your-consultation",
    "address": {
      "line1": "761 Main Avenue, Suite 200",
      "city": "Norwalk",
      "state": "CT",
      "zip": "06851",
      "country": "US"
    },
    "location": {
      "lat": 41.1597,
      "lng": -73.4209
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "financingOptions": ["Payment plans", "Future Family"]
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 53.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 56.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 54.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 42,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1511,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27273%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "consultationTypes": ["in-person", "telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27273%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "scraped"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Illume+Fertility+-+Norwalk,+CT,+761+Main+Ave+%23200,+Norwalk,+CT+06851/@41.1595443,-73.4211798,3004a,13.1y/data=!4m2!3m1!1s0x89e81da8e3a32c2d:0x57453504cf7529e2",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.illumefertility.com/locations/norwalk-ct",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-273-mark-p-leondires-md",
        "name": "Mark P. Leondires, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/Illume%20Fertility/In-House%20Image%20Library%20-%20Illume%20Fertility/Illume%20Team%20Headshots/Light%20Green%20Circle%20Headshots/MPL_circle_lightgreen.jpg?width=600&height=600&name=MPL_circle_lightgreen.jpg",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-273-spencer-richlin-md",
        "name": "Spencer Richlin, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/Illume%20Fertility/In-House%20Image%20Library%20-%20Illume%20Fertility/Illume%20Team%20Headshots/Light%20Green%20Circle%20Headshots/SSR_circle_lightgreen.jpg?width=600&height=600&name=SSR_circle_lightgreen.jpg",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-273-joshua-hurwitz-md",
        "name": "Joshua Hurwitz, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/Illume%20Fertility/In-House%20Image%20Library%20-%20Illume%20Fertility/Illume%20Team%20Headshots/Light%20Green%20Circle%20Headshots/JMH_circle_lightgreen.jpg?width=600&height=600&name=JMH_circle_lightgreen.jpg",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-273-cynthia-murdock-md",
        "name": "Cynthia Murdock, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/Illume%20Fertility/In-House%20Image%20Library%20-%20Illume%20Fertility/Illume%20Team%20Headshots/Light%20Green%20Circle%20Headshots/CMM_circle_lightgreen.jpg?width=600&height=600&name=CMM_circle_lightgreen.jpg",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-273-shaun-williams-md",
        "name": "Shaun Williams, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/Illume%20Fertility/In-House%20Image%20Library%20-%20Illume%20Fertility/Illume%20Team%20Headshots/Light%20Green%20Circle%20Headshots/SCW_circle_lightgreen.jpg?width=600&height=600&name=SCW_circle_lightgreen.jpg",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-273-ilana-ressler-md",
        "name": "Ilana Ressler, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/Illume%20Fertility/In-House%20Image%20Library%20-%20Illume%20Fertility/Illume%20Team%20Headshots/Light%20Green%20Circle%20Headshots/IBR_circle_lightgreen.jpg?width=600&height=600&name=IBR_circle_lightgreen.jpg",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-273-laura-meyer-md",
        "name": "Laura Meyer, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/Illume%20Fertility/In-House%20Image%20Library%20-%20Illume%20Fertility/Illume%20Team%20Headshots/Light%20Green%20Circle%20Headshots/LJM_circle_lightgreen.jpg?width=600&height=600&name=LJM_circle_lightgreen.jpg",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-273-alexander-m-kucherov-md",
        "name": "Alexander M. Kucherov, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/Illume%20Fertility/In-House%20Image%20Library%20-%20Illume%20Fertility/Illume%20Team%20Headshots/Light%20Green%20Circle%20Headshots/AMK_circle_lightgreen.jpg?width=600&height=600&name=AMK_circle_lightgreen.jpg",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-273-barry-r-witt-md",
        "name": "Barry R. Witt, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/DrWitt_whitebackground_circle.png?width=1200&height=1200&name=DrWitt_whitebackground_circle.png",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "languages": ["English", "Spanish"],
    "images": [
      {
        "url": "https://www.illumefertility.com/hubfs/Norwalk_Hero-Image2%20(1).jpg",
        "type": "interior",
        "caption": "Illume Fertility Norwalk reception area",
        "_source": {
          "url": "https://www.illumefertility.com/locations/norwalk-ct",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://www.illumefertility.com/hs-fs/hubfs/Hallway_Norwalk_JCG49-1.jpg?width=1400&height=1026&name=Hallway_Norwalk_JCG49-1.jpg",
        "type": "interior",
        "caption": "Illume Fertility Norwalk hallway",
        "_source": {
          "url": "https://www.illumefertility.com/locations/norwalk-ct",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm1zKtstaYDAd8iFAoHfKe_y4jl3CF-JHaGzeXRaHwJHoINQXuXaBeWJ8QFRJJJQ0ccHIgLbDzRAXDOPaGeG8zoyQyTD57bs9nI3vQ2QZ9UNrbPvf3PG6p25c6beFZka9qep8i3=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Illume+Fertility+-+Norwalk,+CT,+761+Main+Ave+%23200,+Norwalk,+CT+06851/@41.1595443,-73.4211798,3004a,13.1y/data=!4m2!3m1!1s0x89e81da8e3a32c2d:0x57453504cf7529e2",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Connecticut (CT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-315",
    "externalIds": {
      "cdcClinicId": "315",
      "googlePlaceId": "ChIJrVt7fOyhwokRSAFAIw_gg74"
    },
    "type": "fertility-clinic",
    "name": "New England Fertility Institute",
    "phone": "(203) 325-3200",
    "address": {
      "line1": "1275 Summer St, Suite 201",
      "city": "Stamford",
      "state": "CT",
      "zip": "06905",
      "country": "US"
    },
    "location": {
      "lat": 41.062,
      "lng": -73.5415
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [],
      "cyclesPerYear": 194,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27315%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27315%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.nefertility.com/our-fertility-clinic/our-team",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/New+England+Fertility+Institute,+1275+Summer+St+%23201,+Stamford,+CT+06905/@41.0619905,-73.541461,3008a,13.1y/data=!4m2!3m1!1s0x89c2a1ec7c7b5bad:0xbe83e00f23400148",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.nefertility.com",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-315-gad-lavy-md",
        "name": "Gad Lavy, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.nefertility.com/content/1-our-fertility-clinic/1-our-team/1-gad-lavy-md-facog/nef-lavy.jpg",
        "_source": {
          "url": "https://www.nefertility.com/our-fertility-clinic/our-team/gad-lavy-md-facog",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-315-michael-m-guarnaccia-md-mph",
        "name": "Michael M. Guarnaccia, MD, MPH",
        "role": "Fertility Specialist",
        "credentials": ["MD", "MPH"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.nefertility.com/content/1-our-fertility-clinic/1-our-team/2-michael-m-guarnaccia-md-mph/nef-guarnaccia.jpg",
        "_source": {
          "url": "https://www.nefertility.com/our-fertility-clinic/our-team/michael-m-guarnaccia-md-mph",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.nefertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "ConnectiCare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, ConnectiCare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Connecticut (CT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-414",
    "externalIds": {
      "cdcClinicId": "414"
    },
    "type": "fertility-clinic",
    "name": "Park Avenue Fertility and Reproductive Medicine",
    "phone": "(203) 372-6700",
    "address": {
      "line1": "5520 Park Ave, Suite WPG-250",
      "city": "Trumbull",
      "state": "CT",
      "zip": "06611",
      "country": "US"
    },
    "location": {
      "lat": 41.2274,
      "lng": -73.2432
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 84.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 72.72727272727273,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "8/11"
        },
        {
          "ageBand": "38-40",
          "rate": 33.33333333333333,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/15"
        }
      ],
      "cyclesPerYear": 179,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27414%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27414%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://parkavefertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://parkavefertility.com/starting-your-fertility-journey/first-visit/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://parkavefertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-414-andrew-j-levi-md",
        "name": "Andrew J. Levi, MD",
        "role": "Founder and Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://parkavefertility.com/wp-content/uploads/2025/06/Dr-Levi-429x600.webp",
        "_source": {
          "url": "https://parkavefertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-414-tyl-h-taylor-phd-hcld",
        "name": "Tyl H. Taylor, PhD, HCLD",
        "role": "Laboratory Director",
        "credentials": ["PhD", "HCLD"],
        "specialty": "High-complexity IVF Laboratory",
        "imageUrl": "https://parkavefertility.com/wp-content/uploads/2025/06/Tyl-429x600.webp",
        "_source": {
          "url": "https://parkavefertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-414-michelle-falzarano-rn",
        "name": "Michelle Falzarano, RN",
        "role": "IVF Coordinator",
        "credentials": ["RN"],
        "specialty": "IVF Coordination",
        "imageUrl": "https://parkavefertility.com/wp-content/uploads/2025/06/Michelle-429x600.webp",
        "_source": {
          "url": "https://parkavefertility.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://parkavefertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "ConnectiCare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "images": [
      {
        "url": "https://parkavefertility.com/wp-content/uploads/2020/04/167.jpg",
        "type": "interior",
        "caption": "Dr. Andrew Levi at Park Avenue Fertility office",
        "_source": {
          "url": "https://parkavefertility.com/starting-your-fertility-journey/first-visit/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, ConnectiCare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Connecticut (CT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-868",
    "externalIds": {
      "cdcClinicId": "868",
      "googlePlaceId": "ChIJk2NabJMb6IkRd4xJONKSftY"
    },
    "type": "fertility-clinic",
    "name": "Rejuvenating Fertility Center",
    "phone": "(203) 557-9696",
    "address": {
      "line1": "225 Main St, Suite 101",
      "city": "Westport",
      "state": "CT",
      "zip": "06880",
      "country": "US"
    },
    "location": {
      "lat": 41.1446,
      "lng": -73.3625
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 4,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27868%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27868%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.rejuvenatingfertility.com/our-doctors",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Rejuvenating+Fertility+Center,+225+Main+St+%23101,+Westport,+CT+06880/@41.145471,-73.3615211,3004a,13.1y/data=!4m2!3m1!1s0x89e81b936c5a6393:0xd67e92d238498c77",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.rejuvenatingfertility.com/contact-us",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-868-zaher-o-merhi-md-facog-hcld",
        "name": "Zaher O. Merhi, MD, FACOG, HCLD",
        "role": "Medical Director and Founder",
        "credentials": ["MD", "FACOG", "HCLD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://static.wixstatic.com/media/ca2223_aba16047550149dbbd1b6f7bde88f801~mv2.jpg/v1/fill/w_360,h_522,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Merhi-photo-png_edited.jpg",
        "_source": {
          "url": "https://www.rejuvenatingfertility.com/our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-868-hyacinth-nicole-browne-md",
        "name": "Hyacinth Nicole Browne, MD",
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Fertility Medicine",
        "imageUrl": "https://static.wixstatic.com/media/ca2223_91b33847f29a4195b7aeb01008753b28~mv2.jpeg/v1/fill/w_338,h_508,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Dr-Browne-photo.jpeg",
        "_source": {
          "url": "https://www.rejuvenatingfertility.com/our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-868-maab-ezz-aldeen-md",
        "name": "Maab Ezz Aldeen, MD",
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Fertility Medicine",
        "imageUrl": "https://static.wixstatic.com/media/ca2223_4c3e53e1cc27456293360e26b638887d~mv2.png/v1/fill/w_750,h_920,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/Dr-Aldeen-3.png",
        "_source": {
          "url": "https://www.rejuvenatingfertility.com/our-doctors",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.rejuvenatingfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "ConnectiCare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "images": [],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, ConnectiCare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Connecticut (CT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-431",
    "externalIds": {
      "cdcClinicId": "431",
      "googlePlaceId": "ChIJeXqZmzjY54kRFWf7i7VTqa8"
    },
    "type": "fertility-clinic",
    "name": "Yale Fertility Center",
    "phone": "(877) 925-3637",
    "address": {
      "line1": "200 West Campus Drive",
      "city": "Orange",
      "state": "CT",
      "zip": "06477",
      "country": "US"
    },
    "location": {
      "lat": 41.2538,
      "lng": -72.997
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 48.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 34.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 49.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 14,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 435,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27431%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27431%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.yalemedicine.org/search/specialists?departmentId=109729",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Yale+Medicine+Fertility+Center,+200+West+Campus+Drive,+Orange,+CT+06477/@41.2537803,-72.9970282,3000a,13.1y/data=!4m2!3m1!1s0x89e7d8389b997a79:0xafa953b58bfb6715",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.yalemedicine.org/departments/fertility-center",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-431-aydin-arici-md",
        "name": "Aydin Arici, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://ysm-res.cloudinary.com/image/upload/ar_3:4,c_fill,dpr_auto,f_auto,g_faces:auto,q_auto:eco,w_0.5/v1/yms/prod/f40d90b2-c5e6-45a0-8e8c-42c79d5242b9",
        "_source": {
          "url": "https://www.yalemedicine.org/search/specialists?departmentId=109729",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-431-david-frankfurter-md",
        "name": "David Frankfurter, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://ysm-res.cloudinary.com/image/upload/ar_3:4,c_fill,dpr_auto,f_auto,g_faces:auto,q_auto:eco,w_0.5/v1/yms/prod/e713d810-4c34-497d-8b07-2e440c4ef5c4",
        "_source": {
          "url": "https://www.yalemedicine.org/search/specialists?departmentId=109729",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-431-harvey-kliman-md-phd",
        "name": "Harvey Kliman, MD, PhD",
        "role": "Reproductive Scientist",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://ysm-res.cloudinary.com/image/upload/ar_3:4,c_fill,dpr_auto,f_auto,g_faces:auto,q_auto:eco,w_0.5/v1/yms/prod/e29fcc7d-0d92-44a3-b9b5-c2254e854bc5",
        "_source": {
          "url": "https://www.yalemedicine.org/search/specialists?departmentId=109729",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-431-lubna-pal-mbbs-md-ms-msc",
        "name": "Lubna Pal, MBBS, MD, MS, MSc",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MBBS", "MD", "MS", "MSc"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://ysm-res.cloudinary.com/image/upload/ar_3:4,c_fill,dpr_auto,f_auto,g_faces:auto,q_auto:eco,w_0.5/v1/yms/prod/14e9a2b4-503e-48e4-a174-83ee7e133349",
        "_source": {
          "url": "https://www.yalemedicine.org/search/specialists?departmentId=109729",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-431-david-seifer-md",
        "name": "David Seifer, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://ysm-res.cloudinary.com/image/upload/ar_3:4,c_fill,dpr_auto,f_auto,g_faces:auto,q_auto:eco,w_0.5/v1/yms/prod/76ddf44c-2b2b-4599-a791-7def3e4d9e0b",
        "_source": {
          "url": "https://www.yalemedicine.org/search/specialists?departmentId=109729",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-431-emre-seli-md",
        "name": "Emre Seli, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://ysm-res.cloudinary.com/image/upload/ar_3:4,c_fill,dpr_auto,f_auto,g_faces:auto,q_auto:eco,w_0.5/v1/yms/prod/3bc6c84d-12e2-4e9b-812d-aa4c29611a8a",
        "_source": {
          "url": "https://www.yalemedicine.org/search/specialists?departmentId=109729",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-431-reshef-tal-md-phd",
        "name": "Reshef Tal, MD, PhD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://ysm-res.cloudinary.com/image/upload/ar_3:4,c_fill,dpr_auto,f_auto,g_faces:auto,q_auto:eco,w_0.5/v1/yms/prod/498dbae3-82f6-4c1b-ad34-7d0aa1444798",
        "_source": {
          "url": "https://www.yalemedicine.org/search/specialists?departmentId=109729",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-431-hugh-taylor-md",
        "name": "Hugh Taylor, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://ysm-res.cloudinary.com/image/upload/ar_3:4,c_fill,dpr_auto,f_auto,g_faces:auto,q_auto:eco,w_0.5/v1/yms/prod/36b4bbd1-4a77-4ae4-b7ac-c6f52f4b42f3",
        "_source": {
          "url": "https://www.yalemedicine.org/search/specialists?departmentId=109729",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-431-liubin-yang-md-phd",
        "name": "Liubin Yang, MD, PhD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://ysm-res.cloudinary.com/image/upload/ar_3:4,c_fill,dpr_auto,f_auto,g_faces:auto,q_auto:eco,w_0.5/v1/yms/prod/b0a55207-f91b-488a-a748-6fa656a118b1",
        "_source": {
          "url": "https://www.yalemedicine.org/search/specialists?departmentId=109729",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.yalemedicine.org/departments/fertility-center",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "ConnectiCare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlCHW4rU-818mQX_S7Ks-JjkU6ltHQXcoOge0SdUISLKQepSTNrAqL8SV5PF4uzJxV4owB1Zx8-hiSIRMsTwXnrqw0jT3PiLzNntye6wbA_fcIbH-aKBMZibemJH_udxH3OICU=w408-h339-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Yale+Medicine+Fertility+Center,+200+West+Campus+Drive,+Orange,+CT+06477/@41.2537803,-72.9970282,3000a,13.1y/data=!4m2!3m1!1s0x89e7d8389b997a79:0xafa953b58bfb6715",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnAAwSI8sCgkCwDeVPFJXMp64dWKa8Ryfy2ceCFlV2bYm7WyjMAA1WJsec2_vrYhECNjI-5QivOyTvTwcElOnCmR1r6wcqvyKa68Q8mFOMdIvNGK98gMVyg0MZiSMhHS8vfFwqk=w361-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Yale+Medicine+Fertility+Center,+200+West+Campus+Drive,+Orange,+CT+06477/@41.2537803,-72.9970282,3000a,13.1y/data=!4m2!3m1!1s0x89e7d8389b997a79:0xafa953b58bfb6715",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnEFswCMPTvYHnb0_ouEAzYaO9lziUAkSfCtLoMPLe378259um1i45CraGwJLZ8TMqJgwiwTUEseTZz82IrT8JKjcx7BXDDNCd6_Oa850bSBm56bQ7gS4ydAdUtKQRSB5T_VEzZ=w224-h298-k-no-pi-10-ya233.99998-ro-0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Yale+Medicine+Fertility+Center,+200+West+Campus+Drive,+Orange,+CT+06477/@41.2537803,-72.9970282,3000a,13.1y/data=!4m2!3m1!1s0x89e7d8389b997a79:0xafa953b58bfb6715",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, ConnectiCare, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Connecticut (CT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-370",
    "externalIds": {
      "cdcClinicId": "370",
      "googlePlaceId": "ChIJO7BERbS3t4kRzzx77ZjOxzs"
    },
    "type": "fertility-clinic",
    "name": "Columbia Fertility Associates",
    "phone": "(202) 293-6567",
    "address": {
      "line1": "2440 M St N.W., Suite 401",
      "city": "Washington",
      "state": "DC",
      "zip": "20037",
      "country": "US"
    },
    "location": {
      "lat": 38.9049,
      "lng": -77.053
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 40.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 44.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 38.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 16.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 488,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27370%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27370%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.columbiafertility.com/our-providers/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Columbia+Fertility+Associates,+2440+M+St+NW+%23401,+Washington,+DC+20037/@38.9051172,-77.0530562,3105a,13.1y/data=!4m2!3m1!1s0x89b7b7b44544b03b:0x3bc7ce98ed7b3ccf",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.columbiafertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-370-preston-sacks-md-facog",
        "name": "Preston Sacks, MD, FACOG",
        "role": "Medical Director",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.columbiafertility.com/wp-content/uploads/2021/12/1847716.png",
        "_source": {
          "url": "https://www.columbiafertility.com/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-370-rafat-a-abbasi-md-facog",
        "name": "Rafat A. Abbasi, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.columbiafertility.com/wp-content/uploads/2021/12/1847718.png",
        "_source": {
          "url": "https://www.columbiafertility.com/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.columbiafertility.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "CareFirst"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, CareFirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check District of Columbia (DC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-900",
    "externalIds": {
      "cdcClinicId": "900",
      "googlePlaceId": "ChIJWf0bOo-3t4kRyJoKzEKKmkI"
    },
    "type": "fertility-clinic",
    "name": "Kindbody - Washington DC",
    "phone": "(202) 301-3595",
    "address": {
      "line1": "1111 19th Street NW",
      "city": "Washington",
      "state": "DC",
      "zip": "20036",
      "country": "US"
    },
    "location": {
      "lat": 38.9048,
      "lng": -77.0432
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 2,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27900%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27900%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.kindbody.com/ivf-cost/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/book-appointment-dc/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+Washington+D.C.,+1111+19th+St+NW,+Washington,+DC+20036/@38.9043989,-77.0428637,3105a,13.1y/data=!4m2!3m1!1s0x89b7b78f3a1bfd59:0x429a8a42cc0a9ac8",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://kindbody.com/book-appointment-dc/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-900-xiaohong-liu-md",
        "name": "Xiaohong Liu, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://kindbody.com/book-appointment-dc/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "network": {
      "name": "Kindbody"
    },
    "website": "https://kindbody.com/book-appointment-dc/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Anthem",
        "Blue Cross Blue Shield",
        "Cigna",
        "Emblem Health",
        "Empire Blue Cross Blue Shield",
        "First Health",
        "Health Net",
        "Horizon",
        "Humana",
        "Maven",
        "Medicare",
        "Medicaid",
        "MultiPlan",
        "Optum",
        "Oscar",
        "Oxford",
        "Progyny",
        "Tricare",
        "United Healthcare"
      ],
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "pricing": {
      "packages": [
        {
          "name": "Pulse Assessment",
          "description": "Quick fertility check — not covered by insurance",
          "price": 9900,
          "currency": "USD",
          "includes": [
            "AMH blood test",
            "Transvaginal ultrasound for follicle count",
            "15-minute reproductive consultation"
          ],
          "notes": "Not covered by insurance"
        },
        {
          "name": "Fertility Consultation",
          "description": "Specialist consultation on fertility fundamentals",
          "price": 30000,
          "currency": "USD",
          "notes": "Billable to most insurance plans"
        },
        {
          "name": "Male Consultation + Semen Analysis",
          "price": 52500,
          "currency": "USD",
          "includes": ["Consultation", "Venipuncture", "Semen analysis"]
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Single egg freezing cycle",
          "price": 690000,
          "priceMax": 966000,
          "currency": "USD",
          "includes": [
            "Stimulation visits",
            "Ultrasounds",
            "Blood draws",
            "Retrieval",
            "Cryopreservation",
            "3 months storage",
            "Coordination"
          ],
          "excludes": ["Medications ($4,000 - $6,000)", "Anesthesia"]
        },
        {
          "name": "Annual Egg Storage",
          "price": 92000,
          "currency": "USD",
          "notes": "Per year"
        },
        {
          "name": "IVF Freeze All (Self Pay)",
          "description": "IVF cycle with all embryos frozen",
          "price": 1160000,
          "priceMax": 1850000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Cryopreservation",
            "3 months storage"
          ],
          "excludes": [
            "Medications (~$4,000 - $6,000)",
            "Embryo biopsy/genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Donor services",
            "Anesthesia"
          ]
        },
        {
          "name": "IVF Fresh Transfer (Self Pay)",
          "description": "IVF cycle with fresh embryo transfer",
          "price": 1380000,
          "priceMax": 1875000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$5,000 - $9,000)",
            "Genetic testing",
            "Surplus embryo storage",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Freeze All",
          "price": 910000,
          "priceMax": 1332000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Cryopreservation",
            "3-month storage"
          ],
          "excludes": [
            "Genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Fresh Transfer",
          "price": 990000,
          "priceMax": 1428000,
          "currency": "USD",
          "includes": [
            "Ultrasounds",
            "Thaw",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Surplus storage",
            "Frozen transfers",
            "Anesthesia"
          ]
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 400000,
          "priceMax": 550000,
          "currency": "USD",
          "includes": ["Ultrasounds", "Thaw", "Assisted hatching", "Transfer"],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "PGT Package",
          "description": "Preimplantation genetic testing",
          "price": 160000,
          "priceMax": 300000,
          "currency": "USD",
          "includes": ["Embryo biopsy", "Lab management"],
          "excludes": ["Storage", "Shipping", "Per-embryo testing costs"]
        },
        {
          "name": "Nutrition Coaching",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Counseling & Support",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Guided Meditation",
          "description": "Virtual wellness — 30-minute session",
          "price": 9000,
          "currency": "USD"
        }
      ],
      "financingOptions": [
        {
          "name": "PatientFi monthly payments",
          "description": "PatientFi monthly payments"
        }
      ],
      "disclaimer": "Prices vary by location. Medications and anesthesia are not included in procedure costs. 3 months of storage included with freeze procedures; annual storage is $920.",
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Blue Cross Blue Shield, Cigna, Emblem Health, Empire Blue Cross Blue Shield, First Health, Health Net",
              "detail": "12 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "14 public price package(s) and 1 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check District of Columbia (DC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl9Of4C1hW8PIG_ivcLrPaH06uHbgwgWS8aD38eQU_ukYpCYg-rIarAG58rQ8_D5K2BaLkkuewOEJjT2zmdLgew70vr4pVaIXhE-bOzGlHuFUADBLbva1c4xxy6vuk2DGUGUhLfyNv1z2hz=w532-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Washington+D.C.,+1111+19th+St+NW,+Washington,+DC+20036/@38.9043989,-77.0428637,3105a,13.1y/data=!4m2!3m1!1s0x89b7b78f3a1bfd59:0x429a8a42cc0a9ac8",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-20",
    "externalIds": {
      "cdcClinicId": "20",
      "googlePlaceId": "ChIJqxA_Jv0Ax4kRCwxunuunIFI"
    },
    "type": "fertility-clinic",
    "name": "Delaware Institute for Reproductive Medicine - Newark",
    "phone": "(302) 738-4600",
    "address": {
      "line1": "620 Churchmans Rd, Third Floor",
      "city": "Newark",
      "state": "DE",
      "zip": "19702",
      "country": "US"
    },
    "location": {
      "lat": 39.6513,
      "lng": -75.6927
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "LGBTQIA+ family building",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 31.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 34.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 203,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2720%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://ivf-success.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2720%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://ivf-success.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://ivf-success.com/your-care-team/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Delaware+Institute+for+Reproductive+Medicine+(DIRM),+620+Churchmans+Rd+Ste+300,+Newark,+DE+19702/@39.6862907,-75.6341761,3070a,13.1y/data=!4m2!3m1!1s0x89c700fd263f10ab:0x5220a7eb9e6e0c0b",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://ivf-success.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-20-george-kovalevsky-md",
        "name": "George Kovalevsky, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://ivf-success.com/wp-content/uploads/2026/02/Untitled-design-7.png",
        "_source": {
          "url": "https://ivf-success.com/your-care-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-20-adrienne-neithardt-md",
        "name": "Adrienne Neithardt, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://ivf-success.com/wp-content/uploads/2026/02/plain-bg.png",
        "_source": {
          "url": "https://ivf-success.com/your-care-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-20-emelia-a-bachman-md",
        "name": "Emelia A. Bachman, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://ivf-success.com/wp-content/uploads/2026/02/plain-bg-2-2.png",
        "_source": {
          "url": "https://ivf-success.com/your-care-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-20-puneet-masson-md",
        "name": "Puneet Masson, MD",
        "role": "Male Infertility and Urology",
        "credentials": ["MD"],
        "specialty": "Male Infertility and Urology",
        "imageUrl": "https://ivf-success.com/wp-content/uploads/2026/03/Untitled-design-59.png",
        "_source": {
          "url": "https://ivf-success.com/your-care-team/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://ivf-success.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "description": "DIRM fertility clinic in Newark, DE, part of the IVI RMA network.",
    "bookingUrl": "https://ivf-success.com/",
    "network": {
      "name": "IVI RMA"
    },
    "images": [
      {
        "url": "https://ivf-success.com/wp-content/uploads/2024/07/DIRM-New-Location.v2-min.png",
        "type": "exterior",
        "caption": "DIRM Newark fertility center exterior at 620 Churchmans Rd.",
        "_source": {
          "url": "https://ivf-success.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Delaware (DE) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-488",
    "externalIds": {
      "cdcClinicId": "488",
      "googlePlaceId": "ChIJJ8Y7KP0Ax4kRwutzhN-9CoY"
    },
    "type": "fertility-clinic",
    "name": "CCRM Fertility of Delaware - Main Center",
    "phone": "(302) 602-8822",
    "address": {
      "line1": "4735 Ogletown-Stanton Road, MAP 2, Suite 3217",
      "city": "Newark",
      "state": "DE",
      "zip": "19713",
      "country": "US"
    },
    "location": {
      "lat": 39.6856,
      "lng": -75.6731
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "LGBTQIA+ family building",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 56.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 61,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 48.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 31.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 500,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27488%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/delaware/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27488%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/delaware/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/delaware/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Newark,+4735+Ogletown-Stanton+Road+MAP+2,+%233217,+Newark,+DE+19713/@39.6858569,-75.6732094,3070a,13.1y/data=!4m2!3m1!1s0x89c700fd283bc627:0x860abddf8473ebc2",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/delaware/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-488-anne-hutchinson-md",
        "name": "Anne Hutchinson, MD",
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Fertility Specialist",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Anne-Hutchinson-rmgnn7gvl856uarxvb3uksg1kpy67o3mv1sqnwcd5s.png",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/delaware/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-488-maureen-kelly-md",
        "name": "Maureen Kelly, MD",
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Fertility Specialist",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Maureen-Kelly-rfyqzi0yeh9gtxx979ugjjr0zwozmnljh0c7egjesg.png",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/delaware/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-488-wendy-schillings-md",
        "name": "Wendy Schillings, MD",
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Fertility Specialist",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Wendy_Schillings_600x600_2x-r9yqj74mn9nyjq9h0um6r1c2bzykz5d19relf2lx9c.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/delaware/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.ccrmivf.com/location/us/delaware/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "description": "CCRM Fertility of Delaware main fertility center in Newark, DE, formerly RADfertility.",
    "bookingUrl": "https://www.ccrmivf.com/location/us/delaware/",
    "network": {
      "name": "CCRM Fertility"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Delaware (DE) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-4",
    "externalIds": {
      "cdcClinicId": "4",
      "googlePlaceId": "ChIJKWQjGQ_K5YgRKZlPy-Aw0qQ"
    },
    "type": "fertility-clinic",
    "name": "Advanced Reproductive Specialists, Jacksonville Center for Reproductive Medicine",
    "phone": "(904) 493-2229",
    "address": {
      "line1": "7051 Southpoint Pkwy, Suite 200",
      "city": "Jacksonville",
      "state": "FL",
      "zip": "32216",
      "country": "US"
    },
    "location": {
      "lat": 30.2577,
      "lng": -81.5907
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 53.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 44.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 203,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%274%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "minimal",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://jcrm.org/michael-fox/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Jacksonville+Center+for+Reproductive+Medicine,+7051+Southpoint+Pkwy+STE+200,+Jacksonville,+FL+32216/@30.254503,-81.5845634,3446a,13.1y/data=!4m2!3m1!1s0x88e5ca0f19236429:0xa4d230e0cb4f9929",
            "fetchedAt": "2026-08-16"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%274%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-4-michael-d-fox-md",
        "name": "Michael D. Fox, MD",
        "role": "Medical Director",
        "imageUrl": "https://jcrm.org/wp-content/uploads/2020/07/JCRM-Fox-600.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://jcrm.org/michael-fox/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.arsjax.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnBgl_cOntxwQBUUigJ300Q1JPr-79Pc9Y7M1MDv_0nFNzpHaH7l3OGEBGESsJhlzBHWmNu42Nz4NF8YQqiNa_kGwShPpb5rDjyX8Xfh0kqdz1BSJ3Shr-MjJdg7Op_g1xoW8E=w986-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Jacksonville+Center+for+Reproductive+Medicine,+7051+Southpoint+Pkwy+STE+200,+Jacksonville,+FL+32216/@30.254503,-81.5845634,3446a,13.1y/data=!4m2!3m1!1s0x88e5ca0f19236429:0xa4d230e0cb4f9929",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-190",
    "externalIds": {
      "cdcClinicId": "190",
      "googlePlaceId": "ChIJW5_11ti15YgRyYxgFqinzXE"
    },
    "type": "fertility-clinic",
    "name": "Assisted Fertility Program",
    "phone": "(904) 398-1473",
    "address": {
      "line1": "3627 University Blvd South, Suite 450",
      "city": "Jacksonville",
      "state": "FL",
      "zip": "32216",
      "country": "US"
    },
    "location": {
      "lat": 30.2873,
      "lng": -81.601
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 37.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 24,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 102,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27190%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27190%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://assistedfertility.org/about-us/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Assisted+Fertility+Program,+3627+University+Blvd+S+%23450,+Jacksonville,+FL+32216/@30.2873088,-81.6010292,3445a,13.1y/data=!4m2!3m1!1s0x88e5b5d8d6f59f5b:0x71cda7a816608cc9",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.assistedfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-190-marwan-m-shaykh-md",
        "name": "Marwan M. Shaykh, MD",
        "role": "Medical Director",
        "imageUrl": "https://assistedfertility.org/wp-content/uploads/2024/01/Marwan-Shaykh-M.D.-AssistedFertilityProgram-Administrator.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://assistedfertility.org/about-us/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.assistedfertility.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnbrF9JJ26BDXGvJIKG-9dWc1mVskvN3JURhpt1w57s_ETSk8ah5q1sOLQDMP3QUFywOOtJqeOaJRebKFUFfn2grAIPOPl9ZDp4JSn3Ql1-F9eZSONm542Q0QjkDIhv9kKyK3iEZQ=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Assisted+Fertility+Program,+3627+University+Blvd+S+%23450,+Jacksonville,+FL+32216/@30.2873088,-81.6010292,3445a,13.1y/data=!4m2!3m1!1s0x88e5b5d8d6f59f5b:0x71cda7a816608cc9",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-462",
    "externalIds": {
      "cdcClinicId": "462",
      "googlePlaceId": "ChIJPU9n_P0d2YgR037bNwmbo1I"
    },
    "type": "fertility-clinic",
    "name": "Boca Fertility",
    "phone": "(561) 368-5500",
    "address": {
      "line1": "875 Meadows Rd, Suite 334",
      "city": "Boca Raton",
      "state": "FL",
      "zip": "33486",
      "country": "US"
    },
    "location": {
      "lat": 26.3596,
      "lng": -80.1043
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 38.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 45,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 38.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 26.31578947368421,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/19"
        }
      ],
      "cyclesPerYear": 182,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27462%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27462%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Boca+Fertility+IVF+Center,+875+Meadows+Rd,+Boca+Raton,+FL+33486/@26.3596643,-80.1039882,3575a,13.1y/data=!4m2!3m1!1s0x88d91dfdfc674f3d:0x52a39b0937db7ed3",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.bocafertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-462-moshe-maurice-r-peress-md",
        "name": "Moshe (Maurice) R. Peress, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.bocafertility.com",
    "languages": ["English"],
    "images": [
      {
        "url": "https://bocafertility.com/wp-content/uploads/2023/09/BocaFertilityBuilding-1-e1694115395298-768x428.jpeg",
        "type": "exterior",
        "_source": {
          "url": "https://www.bocafertility.com",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl08WTrqVlEJDElnDJpoug5YRbSf33Dh-2OOLPxjYER-Cf4inUgDz8kHc0FJOj5AgHfQjeOjTZ43BOu4R9tsH_QH5CHhYUw9B6gijiOMl3TJh_tMp9HUJWNmmsNiwJ0-eHtoNtW=w408-h612-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Boca+Fertility+IVF+Center,+875+Meadows+Rd,+Boca+Raton,+FL+33486/@26.3596643,-80.1039882,3575a,13.1y/data=!4m2!3m1!1s0x88d91dfdfc674f3d:0x52a39b0937db7ed3",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-329",
    "externalIds": {
      "cdcClinicId": "329"
    },
    "type": "fertility-clinic",
    "name": "Brown Fertility",
    "phone": "(877) 260-0352",
    "address": {
      "line1": "14540 Old Saint Augustine Rd, Bldg 2, Suite 2497",
      "city": "Jacksonville",
      "state": "FL",
      "zip": "32258",
      "country": "US"
    },
    "location": {
      "lat": 30.1392,
      "lng": -81.5354
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 37.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 37,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 16.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 14.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 513,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27329%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27329%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.brownfertility.com/doctors/samuel-brown",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.brownfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "socialLinks": {
          "status": "searched-absent"
        },
        "logo": {
          "status": "searched-absent"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-329-samuel-e-brown-md",
        "name": "Samuel E. Brown, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2021/08/DrBrown-2.png",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/samuel-brown",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Erica Lobel, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2025/12/erica_lobel_1-1920x2965.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/erica-lobel",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-329-erica-lobel-md"
      },
      {
        "name": "Angeline N. Beltsos, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/04/20260319-KKphotography_Studio_114868_Z_8_1-Edit-1-1920x1280.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/angeline-n-beltsos-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-329-angeline-n-beltsos-md"
      },
      {
        "name": "Maria Crespo-Smith, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/02/crespo_lab_coat_2-1920x2965.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/maria-crespo-smith-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-329-maria-crespo-smith-md"
      },
      {
        "name": "Peter Casella, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/05/0050_PeterCasella_BrownFertility_26LauraEvans-002-1920x2878.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/peter-casella-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-329-peter-casella-md"
      },
      {
        "name": "Hannah Ballester, PA-C",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2025/10/Hannah-Ballester-PA-C-Employee-Headshot-1920x2880.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/hannah-ballester",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "practitionerId": "pr-org-cdc-329-hannah-ballester-pa-c"
      },
      {
        "name": "Lauren Hilado",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/06/Brown-Fertility-Headshot.jpeg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/lauren-hilado",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "practitionerId": "pr-org-cdc-329-lauren-hilado"
      }
    ],
    "website": "https://www.brownfertility.com",
    "languages": ["English"],
    "images": [],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "network": {
      "name": "Brown Fertility"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-899",
    "externalIds": {
      "cdcClinicId": "899",
      "googlePlaceId": "ChIJwTapjLx53YgR9nai_hiesL4"
    },
    "type": "fertility-clinic",
    "name": "Center for Living Well, Gaea Center",
    "phone": "(407) 934-4100",
    "address": {
      "line1": "1530 Celebration Blvd, Suite 200",
      "city": "Celebration",
      "state": "FL",
      "zip": "34747",
      "country": "US"
    },
    "location": {
      "lat": 28.3099,
      "lng": -81.5648
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 4,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27899%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "minimal",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Center+for+Living+Well+-+Celebration,+1530+Celebration+Blvd+Ste+200,+Kissimmee,+FL+34747/@28.3097135,-81.5646059,3513a,13.1y/data=!4m2!3m1!1s0x88dd79bc8ca936c1:0xbeb09e18fea276f6",
            "fetchedAt": "2026-08-16"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27899%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-899-nanette-rollene-md",
        "name": "Nanette Rollene, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.gaeacenter.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlip5uLvTjJZ6ZaKqj3zPV3mJCspdWVXzqOJzUzpil-52SnhmPROcPFU85nd2YUvOHQ77k2_1Nsex6Ao7ec2bU13sa1ryysW9DTI_vn-j_0wmLqJfH-GQ0uuqZnGQxmch1LtI4r=w408-h255-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Center+for+Living+Well+-+Celebration,+1530+Celebration+Blvd+Ste+200,+Kissimmee,+FL+34747/@28.3097135,-81.5646059,3513a,13.1y/data=!4m2!3m1!1s0x88dd79bc8ca936c1:0xbeb09e18fea276f6",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-109",
    "externalIds": {
      "cdcClinicId": "109",
      "googlePlaceId": "ChIJrRHu50Zw54gR0CVFPBXCGgI"
    },
    "type": "fertility-clinic",
    "name": "Center for Reproductive Medicine, PA",
    "phone": "(407) 740-0909",
    "address": {
      "line1": "1500 S. Orlando Ave, Suite 200",
      "city": "Winter Park",
      "state": "FL",
      "zip": "32789",
      "country": "US"
    },
    "location": {
      "lat": 28.5836,
      "lng": -81.3646
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 49.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 54,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 42.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 26.31578947368421,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/19"
        }
      ],
      "cyclesPerYear": 596,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27109%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27109%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivforlando.com/our-fertility-clinics/winter-park-fl",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Center+for+Reproductive+Medicine,+1500+S+Orlando+Ave,+Winter+Park,+FL+32789/@28.5835429,-81.3646498,3504a,13.1y/data=!4m2!3m1!1s0x88e77046e7ee11ad:0x21ac2153c4525d0",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivforlando.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-109-randall-a-loy-md",
        "name": "Randall A. Loy, MD",
        "role": "Medical Director",
        "imageUrl": "https://cdn.buttercms.com/KWGtQAdsSUqB5S3srymJ",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.ivforlando.com/fertility-specialists/randall-loy-md",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.ivforlando.com",
    "description": "CRM Orlando is proud to offer fertility preservation discounts to healthcare workers. Learn More",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "setting": "boutique",
    "images": [
      {
        "url": "https://cdn.buttercms.com/XaQc9tzVTSIiEuBcOxHe",
        "type": "exterior",
        "caption": "Center for Reproductive Medicine Winter Park clinic",
        "_source": {
          "url": "https://www.ivforlando.com/our-fertility-clinics/winter-park-fl",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlbmqNgJWH4dGYhoTOVvwb4ZwBeLZbhpx9gx0JzrkIKd-aqH_oGxszFPVr-sWmI_BQN57ctTXpMROjHzODikuwcypOhnHlYPcUhOpzWsiiZER_dodAGe4RcfcJganE6U7L1f_Tv=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Center+for+Reproductive+Medicine,+1500+S+Orlando+Ave,+Winter+Park,+FL+32789/@28.5835429,-81.3646498,3504a,13.1y/data=!4m2!3m1!1s0x88e77046e7ee11ad:0x21ac2153c4525d0",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-450",
    "externalIds": {
      "cdcClinicId": "450",
      "googlePlaceId": "ChIJpUEGb-m32YgRyT6JHgZCEm0"
    },
    "type": "fertility-clinic",
    "name": "Conceptions Florida: Center for Fertility and Genetics",
    "phone": "(305) 446-4673",
    "address": {
      "line1": "4425 Ponce de Leon Blvd, Suite 110",
      "city": "Coral Gables",
      "state": "FL",
      "zip": "33146",
      "country": "US"
    },
    "location": {
      "lat": 25.7312,
      "lng": -80.2577
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 55.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 57.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 40,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 38.46153846153847,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/13"
        }
      ],
      "cyclesPerYear": 231,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27450%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27450%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://conceptionsflorida.com/dr-armando-hernandez-rey/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Conceptions+Florida,+4425+Ponce+de+Leon+Blvd+Ste+110,+Coral+Gables,+FL+33146/@25.7307922,-80.2581713,3594a,13.1y/data=!4m2!3m1!1s0x88d9b7e96f0641a5:0x6d1242061e893ec9",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.conceptionsflorida.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-450-armando-e-hernandez-rey-md",
        "name": "Armando E. Hernandez-Rey, MD",
        "role": "Medical Director",
        "imageUrl": "https://conceptionsflorida.com/wp-content/uploads/2020/06/drhmback2xzc.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://conceptionsflorida.com/dr-armando-hernandez-rey/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.conceptionsflorida.com",
    "languages": ["English"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWklkPmuIwuxaVRZ4KSkbty9k0Y2uA0u63E2ou7m2Up7gLxpSB3JnQo9D6HbpwjwTnkUipLbrJAQz6Gi01eI4xtyXtr3LPG4U2W1j6AA26HksF8mw6AmDBJLLmHDAbXfPzvEgOkj=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Conceptions+Florida,+4425+Ponce+de+Leon+Blvd+Ste+110,+Coral+Gables,+FL+33146/@25.7307922,-80.2581713,3594a,13.1y/data=!4m2!3m1!1s0x88d9b7e96f0641a5:0x6d1242061e893ec9",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmRQlW_uf5rIhdoo1q0UDn2ChzPMkJzY-jcL5X9DCizQ4WE0fY6wBFDHqgT5mrB9LtvEAmt3KfqgTDS0ydWYkg08C2bbasdLI4GR3_o4JCs1uScLEqfooEwvFzbYUkmiWU9_e_cng=w224-h398-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Conceptions+Florida,+4425+Ponce+de+Leon+Blvd+Ste+110,+Coral+Gables,+FL+33146/@25.7307922,-80.2581713,3594a,13.1y/data=!4m2!3m1!1s0x88d9b7e96f0641a5:0x6d1242061e893ec9",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-216",
    "externalIds": {
      "cdcClinicId": "216"
    },
    "type": "fertility-clinic",
    "name": "F.I.R.S.T., Florida Institute for Reproductive Sciences and Technologies",
    "phone": "(954) 217-3456",
    "address": {
      "line1": "2300 N. Commerce Pkwy, Suite 319",
      "city": "Weston",
      "state": "FL",
      "zip": "33326",
      "country": "US"
    },
    "location": {
      "lat": 26.092,
      "lng": -80.3674
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "35-37",
          "rate": 53.333333333333336,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "8/15"
        }
      ],
      "cyclesPerYear": 85,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27216%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "scraped-retry",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27216%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-216-minna-r-selub-md",
        "name": "Minna R. Selub, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.fertilityfirst.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-241",
    "externalIds": {
      "cdcClinicId": "241",
      "googlePlaceId": "ChIJC7Zd5BnH2YgRZwMPU4oJt8k"
    },
    "type": "fertility-clinic",
    "name": "Fertility & IVF Center of Miami, Inc., Fertility Center of Miami",
    "phone": "(305) 596-4013",
    "address": {
      "line1": "8950 N. Kendall Dr, Suite 103",
      "city": "Miami",
      "state": "FL",
      "zip": "33176",
      "country": "US"
    },
    "location": {
      "lat": 25.683,
      "lng": -80.3407
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 54.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 41.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 43.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 35,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 358,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27241%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "scraped-retry",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://fertility-miami.com/about-us/medical-team/fernando-m-akerman-m-d-2/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Center+of+Miami,+8950+N+Kendall+Dr+%23103,+Miami,+FL+33176/@25.6849281,-80.3411571,3596a,13.1y/data=!4m2!3m1!1s0x88d9c719e45db60b:0xc9b7098a530f0367",
            "fetchedAt": "2026-08-16"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27241%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-241-fernando-akerman-md",
        "name": "Fernando Akerman, MD",
        "role": "Medical Director",
        "imageUrl": "https://fertility-miami.com/wp-content/uploads/2024/05/bios-consolidadas-560x700px-fernando-1.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://fertility-miami.com/about-us/medical-team/fernando-m-akerman-m-d-2/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.fertilitycentermiami.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm2lH7CBEYAIaR5bqschM2Z80Q2n2QPoZcum6-_hvKvJdwS-v_nNtozium8O6XiPTf6-wpPhMCk6619Zf5msH4glWp68yXPlnE4_dWylUwvWXQSwEax7vUWi2XT6bwNH5PqyAcWGwMGHac=w224-h398-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Center+of+Miami,+8950+N+Kendall+Dr+%23103,+Miami,+FL+33176/@25.6849281,-80.3411571,3596a,13.1y/data=!4m2!3m1!1s0x88d9c719e45db60b:0xc9b7098a530f0367",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-149",
    "externalIds": {
      "cdcClinicId": "149",
      "googlePlaceId": "ChIJp0_hcN9Gw4gRIHAoNpa_sKo"
    },
    "type": "fertility-clinic",
    "name": "Fertility Center & Applied Genetics of Florida",
    "phone": "(941) 342-1568",
    "address": {
      "line1": "5100 Station Way",
      "city": "Sarasota",
      "state": "FL",
      "zip": "34233",
      "country": "US"
    },
    "location": {
      "lat": 27.2724,
      "lng": -82.4663
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 41.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 55.55555555555556,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "10/18"
        },
        {
          "ageBand": "38-40",
          "rate": 66.66666666666666,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "8/12"
        }
      ],
      "cyclesPerYear": 129,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27149%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "scraped-retry",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://geneticsandfertility.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Center+and+Applied+Genetics+of+Florida,+5100+Station+Way+Ste+A,+Sarasota,+FL+34233/@27.2724139,-82.4663415,3546a,13.1y/data=!4m2!3m1!1s0x88c346df70e14fa7:0xaab0bf9636287020",
            "fetchedAt": "2026-08-16"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27149%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-149-julio-e-pabon-md",
        "name": "Julio E. Pabon, MD",
        "role": "Medical Director",
        "imageUrl": "https://geneticsandfertility.com/wp-content/uploads/2019/10/doctor.png",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://geneticsandfertility.com/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.sarasotafertility.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "setting": "boutique",
    "specialties": ["reproductive-endocrinology", "genetics", "IVF"],
    "consultationTypes": ["in-person"],
    "description": "An extremely unique private practice where patients receive personal care from one Reproductive Endocrinologist and Infertility Specialist. Dr. Pabon offers IVF, genetic testing, and comprehensive fertility treatments across two Florida locations.",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlZQ4T4TjFR3zPCQPjqFgt5iLZFrspQepuX5xcvDxbQaa7JovpEOlQi6R1XQNJybd--vCdxVbsaKgV6bbGFp_5_zdfyeOw3V2h5JmO1LSM4-6XZae8ohZU9zXA7UXrUAKewjyEYCA=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Center+and+Applied+Genetics+of+Florida,+5100+Station+Way+Ste+A,+Sarasota,+FL+34233/@27.2724139,-82.4663415,3546a,13.1y/data=!4m2!3m1!1s0x88c346df70e14fa7:0xaab0bf9636287020",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-624",
    "externalIds": {
      "cdcClinicId": "624"
    },
    "type": "fertility-clinic",
    "name": "Fertility Center of Orlando",
    "phone": "(407) 345-9006",
    "address": {
      "line1": "1912 Boothe Circle, Suite 200",
      "city": "Longwood",
      "state": "FL",
      "zip": "32750",
      "country": "US"
    },
    "location": {
      "lat": 28.6361,
      "lng": -81.3653
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 24,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27624%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "minimal",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://fertilitycenterorlando.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27624%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-624-milton-mcnichol-md",
        "name": "Milton McNichol, MD",
        "role": "Medical Director",
        "imageUrl": "https://fertilitycenterorlando.com/wp-content/uploads/2025/03/2774055.webp",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://fertilitycenterorlando.com/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.fertilityorlando.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-383",
    "externalIds": {
      "cdcClinicId": "383",
      "googlePlaceId": "ChIJsxaCynXuwogRJ7Y7PllmFWU"
    },
    "type": "fertility-clinic",
    "name": "Florida Fertility Institute",
    "phone": "(727) 669-3414",
    "address": {
      "line1": "2454 N. McMullen Booth Rd, Suite 601",
      "city": "Clearwater",
      "state": "FL",
      "zip": "33759",
      "country": "US"
    },
    "location": {
      "lat": 28.0104,
      "lng": -82.7075
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 47.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 37.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 35.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 282,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27383%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "minimal",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Florida+Fertility+Institute,+2454+McMullen+Booth+Rd+Ste+601,+Clearwater,+FL+33759/@28.0105249,-82.7077356,3522a,13.1y/data=!4m2!3m1!1s0x88c2ee75ca8216b3:0x651566593e3bb627",
            "fetchedAt": "2026-08-16"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27383%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-383-mark-d-sanchez-md",
        "name": "Mark D. Sanchez, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.floridafertilityinstitute.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlqYXCIcmzWdOCLTz9djY5EOeqpy-pxj3BnyY2c9BIUYyr1nc07g8iBHniDjGQjgGJDnpYH65yWFhsi9ksWHSo11dD6CU9bBpC_4HAP--X19qmrLwq5ST1m6NxsQ-_wbajx8M3I=w792-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Florida+Fertility+Institute,+2454+McMullen+Booth+Rd+Ste+601,+Clearwater,+FL+33759/@28.0105249,-82.7077356,3522a,13.1y/data=!4m2!3m1!1s0x88c2ee75ca8216b3:0x651566593e3bb627",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-231",
    "externalIds": {
      "cdcClinicId": "231",
      "googlePlaceId": "ChIJ511Ykg635YgRfCEE7u9j2jg"
    },
    "type": "fertility-clinic",
    "name": "Florida Institute for Reproductive Medicine",
    "phone": "(904) 399-5620",
    "address": {
      "line1": "836 Prudential Dr, Suite 902",
      "city": "Jacksonville",
      "state": "FL",
      "zip": "32207",
      "country": "US"
    },
    "location": {
      "lat": 30.316,
      "lng": -81.6628
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 40.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 48.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 30.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 16.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 555,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27231%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27231%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilityjacksonville.com/our-team/doctors/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Florida+Institute+for+Reproductive+Medicine,+841+Prudential+Dr+Ste+260,+Jacksonville,+FL+32207/@30.317889,-81.6628958,3444a,13.1y/data=!4m2!3m1!1s0x88e5b70e92585de7:0x38da63efee04217c",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilityjacksonville.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-231-kevin-l-winslow-md",
        "name": "Kevin L. Winslow, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.fertilityjacksonville.com/wp-content/uploads/2025/09/firm-team-dr-kevin-winslow.webp",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.fertilityjacksonville.com/our-team/doctors/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Teresa Erb, MD",
        "imageUrl": "https://www.fertilityjacksonville.com/wp-content/uploads/2025/09/firm-team-dr-teresa-erb.webp",
        "_source": {
          "url": "https://www.fertilityjacksonville.com/our-team/doctors/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-231-teresa-erb-md"
      },
      {
        "name": "Adrienne Gentry, MD",
        "imageUrl": "https://www.fertilityjacksonville.com/wp-content/uploads/2025/09/firm-team-dr-adrienne-gentry.webp",
        "_source": {
          "url": "https://www.fertilityjacksonville.com/our-team/doctors/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-231-adrienne-gentry-md"
      },
      {
        "name": "Viji Sundaram, MD",
        "imageUrl": "https://www.fertilityjacksonville.com/wp-content/uploads/2025/09/firm-team-dr-viji-sundaram.webp",
        "_source": {
          "url": "https://www.fertilityjacksonville.com/our-team/doctors/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-231-viji-sundaram-md"
      }
    ],
    "website": "https://www.fertilityjacksonville.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross",
        "Blue Shield",
        "Cigna",
        "Humana",
        "Tricare"
      ],
      "_source": {
        "url": "https://www.fertilityjacksonville.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": [
      "English",
      "Spanish",
      "Chinese",
      "Arabic",
      "Russian",
      "French",
      "Portuguese",
      "Italian",
      "German"
    ],
    "images": [
      {
        "url": "https://www.fertilityjacksonville.com/wp-content/uploads/2025/09/FIRM.-jacksonville-south-1024x546.jpg",
        "type": "exterior",
        "caption": "FIRM Jacksonville South fertility clinic",
        "_source": {
          "url": "https://www.fertilityjacksonville.com/about-us/locations/jacksonville-south-infertility-doctor/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnfFHy09T-5v2TaZwnFlS88ApyP3ra8-kvRJVnDuqCR_KsXC55pUHOwsrvQuTDhtUnKz6g1D-_q_JuMrRCLhC1v_S52G0BYlDkD7RsxslR2cFB2DkrkuLrcZZfTZdA3HvJUDMKZB4WqGPc=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Florida+Institute+for+Reproductive+Medicine,+841+Prudential+Dr+Ste+260,+Jacksonville,+FL+32207/@30.317889,-81.6628958,3444a,13.1y/data=!4m2!3m1!1s0x88e5b70e92585de7:0x38da63efee04217c",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross, Blue Shield, Cigna, Humana, Tricare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.fertilityjacksonville.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-192",
    "externalIds": {
      "cdcClinicId": "192",
      "googlePlaceId": "ChIJrSWJsbEE2YgRioMAYTvrvgo"
    },
    "type": "fertility-clinic",
    "name": "IVF Florida Reproductive Associates",
    "phone": "(954) 247-6235",
    "address": {
      "line1": "3251 N. State Rd 7, Suite 200",
      "city": "Margate",
      "state": "FL",
      "zip": "33063",
      "country": "US"
    },
    "location": {
      "lat": 26.2642,
      "lng": -80.2008
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 50.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 61.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 45.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 35.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1123,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27192%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27192%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfflorida.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/IVF+Florida+Reproductive+Associates+in+Margate,+3251+N+State+Rd+7+Ste+200,+Margate,+FL+33063/@26.27055,-80.2023354,3578a,13.1y/data=!4m2!3m1!1s0x88d904b1b18925ad:0xabeeb3b6100838a",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfflorida.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-192-david-i-hoffman-md",
        "name": "David I. Hoffman, MD",
        "role": "Medical Director",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/hoffman92425.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Marcelo Barrionuevo, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/07/barrionuevo-marcelo_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-192-marcelo-barrionuevo-md"
      },
      {
        "name": "Daniel Christie, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/christie-daniel_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-192-daniel-christie-md"
      },
      {
        "name": "Marc Gualtieri, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/marc-gualtieri_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-192-marc-gualtieri-md"
      },
      {
        "name": "Luis Hoyos, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/hoyos-luis_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-192-luis-hoyos-md"
      },
      {
        "name": "Laurice Bou Nemer, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/bou-nemer-laurice_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-192-laurice-bou-nemer-md"
      },
      {
        "name": "Vanessa Weitzman, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/weitzman-vanessa_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-192-vanessa-weitzman-md"
      }
    ],
    "website": "https://www.ivfflorida.com",
    "languages": ["English"],
    "images": [
      {
        "url": "https://ivfflorida.com/wp-content/uploads/2025/08/margate.png",
        "type": "exterior",
        "caption": "IVF Florida Margate fertility center",
        "_source": {
          "url": "https://ivfflorida.com/locations/margate-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnw-B-QZSTyKsSxApIpjdJln243TTsayD99y5RacfSqndPP18SKsT9PSWGSL_T_-fOqe8wb1umbsS4da_8-bTuLwpWa9sndg6yJSkg4iOGzmTHgqlXezh_zr4DNriHXsmMsRdWlLg=w528-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/IVF+Florida+Reproductive+Associates+in+Margate,+3251+N+State+Rd+7+Ste+200,+Margate,+FL+33063/@26.27055,-80.2023354,3578a,13.1y/data=!4m2!3m1!1s0x88d904b1b18925ad:0xabeeb3b6100838a",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnv5-KO0WpqqHVUGXIRCycKFel7TDlUYNbMkESa80hqjVBNsm_Vtz_Iu9MxgTU16jjYxDfM-69DQsjC_FDL63l291Q41fbi295w8wCLnh2p8i5pz1scOjQJprg_rWbH5vnqCqxXjQ2egcNP=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/IVF+Florida+Reproductive+Associates+in+Margate,+3251+N+State+Rd+7+Ste+200,+Margate,+FL+33063/@26.27055,-80.2023354,3578a,13.1y/data=!4m2!3m1!1s0x88d904b1b18925ad:0xabeeb3b6100838a",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "network": {
      "name": "US Fertility"
    },
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-45",
    "externalIds": {
      "cdcClinicId": "45",
      "googlePlaceId": "ChIJm4-cuO3H2YgRLnmmTsEg-ME"
    },
    "type": "fertility-clinic",
    "name": "IVFMD/South Florida Institute for Reproductive Medicine",
    "description": "Premier South Florida fertility network with six locations, over 10,000 families created since 1991, part of the Prelude Network.",
    "website": "https://www.ivfmd.com",
    "phone": "(305) 662-7901",
    "bookingUrl": "https://book.ivfmd.com/",
    "address": {
      "line1": "7300 S.W. 62nd Pl, 4th Floor",
      "city": "South Miami",
      "state": "FL",
      "zip": "33143",
      "country": "US"
    },
    "location": {
      "lat": 25.7028,
      "lng": -80.2952
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "financingOptions": [
        "Loans",
        "Package pricing",
        "Discount pricing",
        "CapexMD"
      ]
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 54.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 48.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 46.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 32.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1274,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2745%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "languages": ["English", "es", "fr", "de"],
    "consultationTypes": ["in-person", "telehealth"],
    "patientGroups": ["LGBTQIA+"],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2745%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "scraped"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfmd.com/fertility-clinics/miami",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/IVFMD,+7300+SW+62nd+Pl+4th+floor,+South+Miami,+FL+33143/@25.702874,-80.295158,3595a,13.1y/data=!4m2!3m1!1s0x88d9c7edb89c8f9b:0xc1f820c14ea6792e",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfmd.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-45-juergen-eisermann-md",
        "name": "Juergen Eisermann, MD",
        "role": "Medical Director",
        "imageUrl": "https://cdn.buttercms.com/0SWb3FFpTDebSmxy8Ag3",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.ivfmd.com/fertility-specialist/juergen-eisermann",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "network": {
      "name": "Prelude Network"
    },
    "setting": "network-group",
    "images": [
      {
        "url": "https://cdn.buttercms.com/ybDci780QnuC93luNVX2",
        "type": "exterior",
        "caption": "IVFMD Miami fertility clinic",
        "_source": {
          "url": "https://www.ivfmd.com/fertility-clinics/miami",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-55",
    "externalIds": {
      "cdcClinicId": "55",
      "googlePlaceId": "ChIJy77XUGjAkIgRLBa460kVxZc"
    },
    "type": "fertility-clinic",
    "name": "New Leaders in Fertility & Endocrinology, LLC",
    "phone": "(850) 857-0033",
    "address": {
      "line1": "4400 Bayou Blvd, Suite 36",
      "city": "Pensacola",
      "state": "FL",
      "zip": "32503",
      "country": "US"
    },
    "location": {
      "lat": 30.4674,
      "lng": -87.204
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 41.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 42.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 28.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "0/10"
        }
      ],
      "cyclesPerYear": 201,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2755%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "minimal",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/NewLIFE+Fertility%2FNew+Leaders+In+Fertility+%26+Endocrinology+LLC,+4400+Bayou+Blvd+Ste+36,+Pensacola,+FL+32503/@30.4674727,-87.2040908,3439a,13.1y/data=!4m2!3m1!1s0x8890c06850d7becb:0x97c51549ebb8162c",
            "fetchedAt": "2026-08-16"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2755%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-55-barry-a-ripps-md",
        "name": "Barry A. Ripps, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.newleadersinfertility.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlkmWuOkRxvuSG56l5bqNKsgj-rKPSLvyNhWUCW2jqQHQqbVA687LFcYfIh3edm1i7RgwqKSu-rVQfH3zNDgdfiqmTcvr7nKXFvgZ-IYnWAEB87vsEsFwQuTwufZHSEB_yiZ8GWWg=w638-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/NewLIFE+Fertility%2FNew+Leaders+In+Fertility+%26+Endocrinology+LLC,+4400+Bayou+Blvd+Ste+36,+Pensacola,+FL+32503/@30.4674727,-87.2040908,3439a,13.1y/data=!4m2!3m1!1s0x8890c06850d7becb:0x97c51549ebb8162c",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmD8AM9HGmigAudZxY4aU9caWFTbq46aJ05LQGkGi_B6jH46shNYlvvhWDEm9Czd7bp9NBmyvorFMkLASQUBqqW2_GeyVfKJbMooEP6hgy8kVLhwnj8CzHy_au9g7L6Fnsj6CVV=w514-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/NewLIFE+Fertility%2FNew+Leaders+In+Fertility+%26+Endocrinology+LLC,+4400+Bayou+Blvd+Ste+36,+Pensacola,+FL+32503/@30.4674727,-87.2040908,3439a,13.1y/data=!4m2!3m1!1s0x8890c06850d7becb:0x97c51549ebb8162c",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-257",
    "externalIds": {
      "cdcClinicId": "257",
      "googlePlaceId": "ChIJQZDMF2sh2YgRtukEB-BPTNw"
    },
    "type": "fertility-clinic",
    "name": "Polcz Fertility Center",
    "phone": "(561) 736-6006",
    "address": {
      "line1": "9868 S. State Rd 7, Suite 320",
      "city": "Boynton Beach",
      "state": "FL",
      "zip": "33472",
      "country": "US"
    },
    "location": {
      "lat": 26.541,
      "lng": -80.1987
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [],
      "cyclesPerYear": 20,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27257%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27257%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.polczfertility.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Polcz+Fertility+Center:+Tibor+Polcz+MD,+9868+FL-7+%23320,+Boynton+Beach,+FL+33472/@26.529941,-80.204369,3570a,13.1y/data=!4m2!3m1!1s0x88d9216b17cc9041:0xdc4c4fe00704e9b6",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.polczfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-257-tibor-e-polcz-md",
        "name": "Tibor E. Polcz, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.polczfertility.com/wp-content/uploads/2023/10/Dr_PHomepage.png",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.polczfertility.com/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.polczfertility.com",
    "description": "At Polcz Fertility Center, we are committed to providing the highest level of individualized care, support, and success to each of our patients throughout every step of their fertility journey.",
    "languages": ["English"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlxHo5zxmqYq2Zowh40Cc2KT4z0TOgA5zfej9oZFx6xpjbraVlJc0Dum-GamKk0GQkzKyaiu2EGM83wySo3VJoPMrYq180DuhRnyD2kDQ11vo8eESK28FIz8T19oOroI-uEDB3un3KjV0Me=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Polcz+Fertility+Center:+Tibor+Polcz+MD,+9868+FL-7+%23320,+Boynton+Beach,+FL+33472/@26.529941,-80.204369,3570a,13.1y/data=!4m2!3m1!1s0x88d9216b17cc9041:0xdc4c4fe00704e9b6",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-815",
    "externalIds": {
      "cdcClinicId": "815",
      "googlePlaceId": "ChIJ0cafg_IN54gRVk5XK_mThXc"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Medicine Associates of Florida, LLC",
    "phone": "(407) 804-9670",
    "address": {
      "line1": "400 Colonial Center Pkwy, Suite 150",
      "city": "Lake Mary",
      "state": "FL",
      "zip": "32746",
      "country": "US"
    },
    "location": {
      "lat": 28.7911,
      "lng": -81.3532
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 66.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 67.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 41.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 174,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27815%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "scraped-retry",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/florida/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+Florida+%7C+Lake+Mary,+400+Colonial+Center+Pkwy+%23150,+Lake+Mary,+FL+32746/@28.7911396,-81.352918,3497a,13.1y/data=!4m2!3m1!1s0x88e70df2839fc6d1:0x778593f92b574e56",
            "fetchedAt": "2026-08-16"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27815%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-815-george-patounakis-md-phd",
        "name": "George Patounakis, MD, PHD",
        "role": "Medical Director",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/12/G.-Patounakis-Website.png",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.rmaflorida.com",
    "languages": ["English"],
    "network": {
      "name": "IVI RMA"
    },
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "setting": "network-group",
    "images": [
      {
        "url": "https://rmanetwork.com/wp-content/uploads/2024/06/New-IMG-1.jpg",
        "type": "exterior",
        "caption": "RMA Florida Lake Mary clinic exterior",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-florida/lake-mary-fl/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-823",
    "externalIds": {
      "cdcClinicId": "823",
      "googlePlaceId": "ChIJ-y4XfELDwogRvSbx_eg_0YY"
    },
    "type": "fertility-clinic",
    "name": "Shady Grove Fertility Tampa Bay",
    "phone": "(813) 906-2285",
    "address": {
      "line1": "5016 W. Cypress St, Suite 302",
      "city": "Tampa",
      "state": "FL",
      "zip": "33607",
      "country": "US"
    },
    "location": {
      "lat": 27.9518,
      "lng": -82.5295
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 48.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 45.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 44.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 29.411764705882355,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/17"
        }
      ],
      "cyclesPerYear": 600,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27823%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27823%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/florida/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Tampa,+5016+W+Cypress+St+Ste+302,+Tampa,+FL+33607/@27.9518926,-82.5294947,3524a,13.1y/data=!4m2!3m1!1s0x88c2c3427c172efb:0x86d13fe8fdf126bd",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-823-shayne-plosker-md",
        "name": "Shayne Plosker, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Shayne_Plosker-hero.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Anthony N. Imudia, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/11/Anthony-Imudia-profile-e1647611307797.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-823-anthony-n-imudia-md"
      },
      {
        "name": "L. Kendall Rauchfuss, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/09/L.-Kendall-Rauchfuss-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-823-l-kendall-rauchfuss-md"
      },
      {
        "name": "George Patounakis, MD, PhD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/12/G.-Patounakis-Website.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-823-george-patounakis-md-phd"
      },
      {
        "name": "Papri Sarkar, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/08/Sarkar-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-823-papri-sarkar-md"
      },
      {
        "name": "Celso Silva, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/02/Celso-Silva-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-823-celso-silva-md"
      },
      {
        "name": "Rachel Sprague",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/10/Rachel-Sprague-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": [],
        "practitionerId": "pr-org-cdc-823-rachel-sprague"
      },
      {
        "name": "Saioa Torrealday, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/10/Torrealday-850x850-2.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-823-saioa-torrealday-md"
      },
      {
        "name": "Christine Kincaid, WHNP-BC",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/05/Christine-Kincaid-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "credentials": ["WHNP-BC"],
        "practitionerId": "pr-org-cdc-823-christine-kincaid-whnp-bc"
      },
      {
        "name": "Susana Soto-Rodriguez, NP",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/01/Susie-Rodriguez.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "credentials": ["NP"],
        "practitionerId": "pr-org-cdc-823-susana-soto-rodriguez-np"
      },
      {
        "name": "Cortney White, MSN, CNM, WHNP-BC",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2023/02/Cortney-White-profile.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "credentials": ["MSN", "CNM", "WHNP-BC"],
        "practitionerId": "pr-org-cdc-823-cortney-white-msn-cnm-whnp-bc"
      }
    ],
    "website": "https://www.shadygrovefertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": [
        "Progyny",
        "Carrot",
        "Maven",
        "WINFertility",
        "Stork Club"
      ],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2021/02/NewWestshoreOffice_Dec2021_850x850.jpg",
        "type": "exterior",
        "caption": "Shady Grove Fertility Tampa-Westshore clinic",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/florida/tampa-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn-sfwEvyuekFNDmgk-SHwzBxqGuJz0UtWeZp8OKK6ORWyzgXiVzL5z4GuOUUpIZabRC1KHv2w9P3vg1R6St0Y71CJRHgi58o8jh-_F6sjMfdiHaR4c0lNUWe-VaPEE9JNzR2_04CYugdmp=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Tampa,+5016+W+Cypress+St+Ste+302,+Tampa,+FL+33607/@27.9518926,-82.5294947,3524a,13.1y/data=!4m2!3m1!1s0x88c2c3427c172efb:0x86d13fe8fdf126bd",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkjeu4ebaetTcDn2oE-KMjwXiDFZRI1lOYbDgsj6gxLRouMDyCVdpXYPn1_gb5l7p5C8mjY-sLch6fUDMmWUn4hhpZb3XkBWGQ839dLPPgMhw7-cx3rB6_iDpdQexIeu9tEaU85=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Tampa,+5016+W+Cypress+St+Ste+302,+Tampa,+FL+33607/@27.9518926,-82.5294947,3524a,13.1y/data=!4m2!3m1!1s0x88c2c3427c172efb:0x86d13fe8fdf126bd",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "network": {
      "name": "US Fertility"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-284",
    "externalIds": {
      "cdcClinicId": "284"
    },
    "type": "fertility-clinic",
    "name": "Southwest Florida Fertility Center, PA",
    "phone": "(239) 561-3430",
    "address": {
      "line1": "15730 New Hampshire Ct, Suite 101",
      "city": "Fort Myers",
      "state": "FL",
      "zip": "33908",
      "country": "US"
    },
    "location": {
      "lat": 26.5151,
      "lng": -81.8972
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 65.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 58.333333333333336,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/12"
        }
      ],
      "cyclesPerYear": 82,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27284%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "scraped-retry",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.swflfertility.com/about.php",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27284%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-284-jacob-l-glock-md",
        "name": "Jacob L. Glock, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.swflfertility.com/images/dr_glock.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.swflfertility.com/about.php",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.bestfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "languages": ["English"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-87",
    "externalIds": {
      "cdcClinicId": "87"
    },
    "type": "fertility-clinic",
    "name": "Specialists in Reproductive Medicine & Surgery, PA, Embryo Donation International, PL",
    "phone": "(239) 275-8118",
    "address": {
      "line1": "12611 World Plaza Ln, Bldg 53",
      "city": "Fort Myers",
      "state": "FL",
      "zip": "33907",
      "country": "US"
    },
    "location": {
      "lat": 26.5597,
      "lng": -81.8778
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 29,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 59,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2787%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "minimal",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.embryodonation.com/staff.php",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2787%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-87-craig-r-sweet-md",
        "name": "Craig R. Sweet, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.embryodonation.com/images/staff/sweet.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.embryodonation.com/staff.php",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.ivfandinfertility.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-295",
    "externalIds": {
      "cdcClinicId": "295",
      "googlePlaceId": "ChIJZ_11uxdv54gRyG5EUf_of1E"
    },
    "type": "fertility-clinic",
    "name": "The IVF Center",
    "phone": "(407) 672-1106",
    "address": {
      "line1": "5901 Brick Ct",
      "city": "Winter Park",
      "state": "FL",
      "zip": "32792",
      "country": "US"
    },
    "location": {
      "lat": 28.6119,
      "lng": -81.2757
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 28.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 37.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 26.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 198,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27295%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27295%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://theivfcenter.com/contact-us/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/The+IVF+Center,+5971+Brick+Ct+Ste+1001,+Winter+Park,+FL+32792/@28.6114787,-81.2766362,3503a,13.1y/data=!4m2!3m1!1s0x88e76f17bb75fd67:0x517fe8ff51446ec8",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.theivfcenter.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-295-mark-p-trolice-md",
        "name": "Mark P. Trolice, MD",
        "role": "Medical Director",
        "imageUrl": "https://theivfcenter.com/wp-content/uploads/2024/08/Trolice-2024-1080.png",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://theivfcenter.com/mark-trolice-md/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.theivfcenter.com",
    "description": "For the safety of you, your families and the community, your IVF Center team is 100% vaccinated.",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross",
        "Blue Shield",
        "Cigna",
        "Tricare",
        "Oscar",
        "Optum"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven"],
      "_source": {
        "url": "https://www.theivfcenter.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["Chinese", "English"],
    "images": [
      {
        "url": "https://theivfcenter.com/wp-content/uploads/2024/05/5971-Brick-Court.png",
        "type": "exterior",
        "caption": "The IVF Center Winter Park location",
        "_source": {
          "url": "https://theivfcenter.com/contact-us/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmIw-aAvkzA5TSXtTXkrdTprICE-Igc2IGxD2ziJRjpIIG1uP0MMcZ-5HD2yw12MmWr0qQyfuzbarB8PGbPz55Xo-asSzJccRs64E0twcNbzinqnIRFv2HQy_c9u6benCctkjFOVvaEejCX=w224-h398-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/The+IVF+Center,+5971+Brick+Ct+Ste+1001,+Winter+Park,+FL+32792/@28.6114787,-81.2766362,3503a,13.1y/data=!4m2!3m1!1s0x88e76f17bb75fd67:0x517fe8ff51446ec8",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "boutique",
    "specialties": ["IVF", "reproductive-endocrinology"],
    "consultationTypes": ["in-person", "telehealth"],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross, Blue Shield, Cigna, Tricare, Oscar, Optum",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.theivfcenter.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-267",
    "externalIds": {
      "cdcClinicId": "267",
      "googlePlaceId": "ChIJYRrcAufHwogRwmEIrddMDhw"
    },
    "type": "fertility-clinic",
    "name": "The Reproductive Medicine Group",
    "phone": "(813) 676-8844",
    "address": {
      "line1": "5245 E. Fletcher Ave, Suite 1",
      "city": "Tampa",
      "state": "FL",
      "zip": "33617",
      "country": "US"
    },
    "location": {
      "lat": 28.0686,
      "lng": -82.3963
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 49.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 49,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 38.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 58.82352941176471,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "10/17"
        }
      ],
      "cyclesPerYear": 546,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27267%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27267%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.floridafertility.com/fertility-specialists/dr-timothy-yeko",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/The+Reproductive+Medicine+Group,+5245+E+Fletcher+Ave+Ste+1,+Tampa,+FL+33617/@28.0686337,-82.3962872,3521a,13.1y/data=!4m2!3m1!1s0x88c2c7e702dc1a61:0x1c0e4cd7ad0861c2",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.reproductivemedicinegroup.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-267-timothy-r-yeko-md",
        "name": "Timothy R. Yeko, MD",
        "role": "Medical Director",
        "imageUrl": "https://cdn.buttercms.com/oS9smygHRDmnOFXdGEyj",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.floridafertility.com/fertility-specialists/dr-timothy-yeko",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.reproductivemedicinegroup.com",
    "languages": ["English"],
    "network": {
      "name": "Prelude Network"
    },
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "setting": "network-group",
    "images": [
      {
        "url": "https://cdn.buttercms.com/e5ReQgiwRaKxnagwCHu2",
        "type": "exterior",
        "caption": "The Reproductive Medicine Group North Tampa clinic",
        "_source": {
          "url": "https://www.floridafertility.com/our-fertility-clinics/north-tampa",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlGfgTHWw2NgRGfcFMPAo-PjuKdSjc1dBSCx_xVfi7H2uiC_MALmIaFnHHHsH1T5znqTPBOYaRFytkiy6mUOdGXe17eUsHDDUDR6GhQp_I4FDl1btvcd_MBMXEFlLZIKbJF4Rpy-r5uYoOb=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/The+Reproductive+Medicine+Group,+5245+E+Fletcher+Ave+Ste+1,+Tampa,+FL+33617/@28.0686337,-82.3962872,3521a,13.1y/data=!4m2!3m1!1s0x88c2c7e702dc1a61:0x1c0e4cd7ad0861c2",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-434",
    "externalIds": {
      "cdcClinicId": "434",
      "googlePlaceId": "ChIJ54bSI6mj6IgR0wO93UPBufk"
    },
    "type": "fertility-clinic",
    "name": "UF Health Reproductive Medicine at Springhill",
    "phone": "(352) 265-2229",
    "address": {
      "line1": "4037 N.W. 86th Terrace, 1st Floor",
      "city": "Gainesville",
      "state": "FL",
      "zip": "32606",
      "country": "US"
    },
    "location": {
      "lat": 29.6903,
      "lng": -82.4338
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 22.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 31.25,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/16"
        },
        {
          "ageBand": "38-40",
          "rate": 29.411764705882355,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/17"
        }
      ],
      "cyclesPerYear": 68,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27434%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27434%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://obgyn.ufl.edu/profile/rhoton-vlasak-alice/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/UF+Health+Reproductive+Medicine+-+Springhill,+4037+NW+86th+Terrace,+Gainesville,+FL+32606/@29.6902863,-82.4338208,3466a,13.1y/data=!4m2!3m1!1s0x88e8a3a923d286e7:0xf9b9c143ddbd03d3",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://ufhealth.org",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-434-alice-s-rhoton-vlasak-md",
        "name": "Alice S. Rhoton-Vlasak, MD",
        "role": "Medical Director",
        "imageUrl": "https://directory.ufhealth.org/rhoton-vlasak-alice/files/profile-photo",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://obgyn.ufl.edu/profile/rhoton-vlasak-alice/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://ufhealth.org",
    "description": "MyUFHealth is a secure application that lets you manage your health at home and on the go.",
    "insurance": {
      "accepted": true,
      "carriers": ["United Healthcare", "Medicare", "Medicaid"],
      "_source": {
        "url": "https://ufhealth.org",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "images": [],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "United Healthcare, Medicare, Medicaid",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://ufhealth.org",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-215",
    "externalIds": {
      "cdcClinicId": "215"
    },
    "type": "fertility-clinic",
    "name": "University of Miami Infertility Center",
    "phone": "(305) 243-1622",
    "address": {
      "line1": "1400 N.W. 12th Ave, Suite 5",
      "city": "Miami",
      "state": "FL",
      "zip": "33136",
      "country": "US"
    },
    "location": {
      "lat": 25.7887,
      "lng": -80.2158
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 47.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 44,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 26.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 8.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 193,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27215%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "minimal",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://med.miami.edu/departments/obgyn/divisions/reproductive-endocrinology-and-infertility",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27215%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-215-george-r-attia-md",
        "name": "George R. Attia, MD",
        "role": "Medical Director",
        "imageUrl": "https://med.miami.edu/-/media/millerschool/faculty/obgyn/50060903-george-attia.ashx?h=250&iar=0&mh=250&mw=200&w=200&rev=37ccaba89829497cbeec5cc7dc6d952e&hash=9124A3D124932EB2F2138ECA9904D960",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://med.miami.edu/departments/obgyn/divisions/reproductive-endocrinology-and-infertility",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.umiamifertility.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-21",
    "externalIds": {
      "cdcClinicId": "21",
      "googlePlaceId": "ChIJq6qqqjoE3ogRwh0d9nqPy4M"
    },
    "type": "fertility-clinic",
    "name": "Viera Fertility Center",
    "phone": "(321) 751-4673",
    "address": {
      "line1": "3160 Alzante Cir",
      "city": "Melbourne",
      "state": "FL",
      "zip": "32940",
      "country": "US"
    },
    "location": {
      "lat": 28.2091,
      "lng": -80.6735
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 34.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 46.666666666666664,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/15"
        }
      ],
      "cyclesPerYear": 75,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2721%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2721%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.vierafertility.com/dr-diran-chamoun/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Viera+Fertility+Center,+3160+Alzante+Cir,+Melbourne,+FL+32940/@28.2091951,-80.6735722,3516a,13.1y/data=!4m2!3m1!1s0x88de043aaaaaaaab:0x83cb8f7af61d1dc2",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.vierafertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-21-diran-j-chamoun-md",
        "name": "Diran J. Chamoun, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.vierafertility.com/wp-content/uploads/2025/06/edit_chamoun.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.vierafertility.com/dr-diran-chamoun/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.vierafertility.com",
    "description": "Viera Fertility is proud to be the Space Coast’s first and only IVF laboratory offering a legacy of excellence that spans nearly three decades. Since opening our doors in Melbourne, Florida, in 1996, we’ve helped thousands of patients grow their families through evidence\\-based, compassionate fertility care.",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-94",
    "externalIds": {
      "cdcClinicId": "94"
    },
    "type": "fertility-clinic",
    "name": "Atlanta Center for Reproductive Medicine",
    "phone": "(770) 928-2276",
    "address": {
      "line1": "5909 Peachtree Dunwoody Rd, Suite 600",
      "city": "Atlanta",
      "state": "GA",
      "zip": "30328",
      "country": "US"
    },
    "location": {
      "lat": 33.9171,
      "lng": -84.3495
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 66.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 61.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 61,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 48.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1046,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2794%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2794%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.atlantainfertility.com/about-us/locations/atlanta-perimeter/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Atlanta+Center+for+Reproductive+Medicine,+5909+Peachtree+Dunwoody+Rd+NE+%23600,+Atlanta,+GA+30328/@33.9170918,-84.349563,3311a,13.1y/data=!4m2!3m1!1s0x88f5094bbcc6da27:0xedd1a309b113557",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-94-kathryn-c-calhoun-md",
        "name": "Kathryn C. Calhoun, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.atlantainfertility.com/images/system/physicians/Calhoun-0001-Edit-White-Coat-cropped.jpg",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.atlantainfertility.com/doctor-directory/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Robin H. Fogle, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.atlantainfertility.com/images/system/physicians/Fogle-0024-Edit-White-Coat-cropped.jpg",
        "_source": {
          "url": "https://www.atlantainfertility.com/doctor-directory/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-94-robin-h-fogle-md-facog"
      },
      {
        "name": "Bonnie G. Patel, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.atlantainfertility.com/images/system/physicians/Patel-Edit-White-Coat-cropped.jpg",
        "_source": {
          "url": "https://www.atlantainfertility.com/doctor-directory/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-94-bonnie-g-patel-md"
      },
      {
        "name": "Stephanie L. Smeltzer, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.atlantainfertility.com/images/system/physicians/Smeltzer-0040-Edit-White-Coat-cropped.jpg",
        "_source": {
          "url": "https://www.atlantainfertility.com/doctor-directory/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-94-stephanie-l-smeltzer-md"
      },
      {
        "name": "Ashley W. Tiegs, MD, FACOG, TS (ABB)",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG", "TS (ABB)"],
        "imageUrl": "https://www.atlantainfertility.com/images/system/physicians/Tiegs-0058-Edit-White-Coat-cropped.jpg",
        "_source": {
          "url": "https://www.atlantainfertility.com/doctor-directory/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-94-ashley-w-tiegs-md-facog-ts-abb"
      }
    ],
    "website": "https://www.acrm.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://www.atlantainfertility.com/images/locations/Perimeter-Office.jpg",
        "type": "exterior",
        "caption": "Atlanta Center for Reproductive Medicine Perimeter office exterior",
        "_source": {
          "url": "https://www.atlantainfertility.com/about-us/locations/atlanta-perimeter/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-118",
    "externalIds": {
      "cdcClinicId": "118",
      "googlePlaceId": "ChIJ9Q5B-kLLjIgRs0fi-Im6PTY"
    },
    "type": "fertility-clinic",
    "name": "Columbus Center for Reproductive Endocrinology & Infertility, LLC",
    "phone": "(706) 653-6344",
    "address": {
      "line1": "2323 Whittlesey Rd",
      "city": "Columbus",
      "state": "GA",
      "zip": "31909",
      "country": "US"
    },
    "location": {
      "lat": 32.5408,
      "lng": -84.959
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 37.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 33.33333333333333,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/15"
        }
      ],
      "cyclesPerYear": 89,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27118%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27118%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://ccrei.com/meet-our-staff/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Columbus+Center+for+Reproductive+Endocrinology+%26+Infertility,+2323+Whittlesey+Rd,+Columbus,+GA+31909/@32.5408207,-84.9589107,3363a,13.1y/data=!4m2!3m1!1s0x888ccb42fa410ef5:0x363dba89f8e247b3",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-118-prakash-j-thiruppathi-md",
        "name": "Prakash J. Thiruppathi, MD",
        "role": "Medical Director",
        "imageUrl": "https://ccrei.com/wp-content/uploads/2025/03/Dr-T.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://ccrei.com/meet-our-staff/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.columbusivf.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkgNt3ybvCR_mvqc2jStnrJps424Kr4UPFeIW_wHWntkZE_aYo64y-Wc4-2KrroDE7dLwof5P7fotkUklRRgzVU0-6cx6t1t_zmDbAIksh4Ey_DgUqi9h5V5jZk3Ve6Gi1PPs1j2g=w408-h725-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Columbus+Center+for+Reproductive+Endocrinology+%26+Infertility,+2323+Whittlesey+Rd,+Columbus,+GA+31909/@32.5408207,-84.9589107,3363a,13.1y/data=!4m2!3m1!1s0x888ccb42fa410ef5:0x363dba89f8e247b3",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-511",
    "externalIds": {
      "cdcClinicId": "511",
      "googlePlaceId": "ChIJsfgWdnAE9YgRpfQDeCL-0CM"
    },
    "type": "fertility-clinic",
    "name": "Emory Reproductive Center",
    "phone": "(404) 778-3401",
    "address": {
      "line1": "550 Peachtree St N.E., Suite 1800",
      "city": "Atlanta",
      "state": "GA",
      "zip": "30308",
      "country": "US"
    },
    "location": {
      "lat": 33.7848,
      "lng": -84.382
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 54.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 51.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 46,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 45.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 570,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27511%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27511%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Emory+Reproductive+Center,+Medical+Office+Tower,+550+Peachtree+St+NE+Fl+18,+Atlanta,+GA+30308/@33.7684962,-84.3860644,3317a,13.1y/data=!4m2!3m1!1s0x88f504707616f8b1:0x23d0fe227803f4a5",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-511-jennifer-f-kawwass-md",
        "name": "Jennifer F. Kawwass, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.emoryhealthcare.org/reproductive-center",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnvsJLzU6fKrvSmcofQaUs6k2kh5Hi7FZMYpvAOUhQmm8XO_UVQx-R_HdGlTyXZr6wmb4acKk__of4nFMCMycgWr6QB4Yr61z49w9bmqz3BxH0Ph4_fBT5nKlCLh8CdKT1Y2OiYplCi-tvl=w408-h272-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Emory+Reproductive+Center,+Medical+Office+Tower,+550+Peachtree+St+NE+Fl+18,+Atlanta,+GA+30308/@33.7684962,-84.3860644,3317a,13.1y/data=!4m2!3m1!1s0x88f504707616f8b1:0x23d0fe227803f4a5",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-865",
    "externalIds": {
      "cdcClinicId": "865",
      "googlePlaceId": "ChIJs9pCYol19YgRmRZkp9Due-I"
    },
    "type": "fertility-clinic",
    "name": "Hope Fertility",
    "phone": "(404) 410-5055",
    "address": {
      "line1": "3005 Royal Boulevard South, Suite 220",
      "city": "Alpharetta",
      "state": "GA",
      "zip": "30022",
      "country": "US"
    },
    "location": {
      "lat": 34.0542,
      "lng": -84.2725
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 54.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 54.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 35.714285714285715,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/14"
        }
      ],
      "cyclesPerYear": 135,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27865%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27865%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://hope-fertility.com/about-us/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Hope+Fertility,+11375+Southbridge+Pkwy,+Alpharetta,+GA+30022/@34.0574764,-84.2367261,3305a,13.1y/data=!4m2!3m1!1s0x88f575896242dab3:0xe27beed0a7641699",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-865-obehi-a-asemota-md",
        "name": "Obehi A. Asemota, MD",
        "role": "Medical Director",
        "imageUrl": "https://hope-fertility.com/wp-content/uploads/2020/06/DrObehi-web2.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Medicine",
        "_source": {
          "url": "https://hope-fertility.com/about-us/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.hopefertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkXzXzGdTLb3RRYgIkIuwYmZ9E0vQB5v4tLEF5tTF-JjGcay48-pGjfEXFZOx1f1sO3uiYUxU7SJXnOlk5xIn4aMXnKbylzphTKrTnVYL6rRu0cbYldFGD44ureQxNztu1gKbg8xw=w408-h540-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Hope+Fertility,+11375+Southbridge+Pkwy,+Alpharetta,+GA+30022/@34.0574764,-84.2367261,3305a,13.1y/data=!4m2!3m1!1s0x88f575896242dab3:0xe27beed0a7641699",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm66jw2dl9SEdFG3W-GgKYLIKpg1NyOJZII2Ae3_6YFPh05oDJP8WiZYcHptbStfhYGV466M_fveLDPMfUGTaXme4GBWSpm_eiF5RzCWqLdNjaXGO-sq7PN2l72ZFNzMjolqTWad-rXWJVR=w224-h398-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Hope+Fertility,+11375+Southbridge+Pkwy,+Alpharetta,+GA+30022/@34.0574764,-84.2367261,3305a,13.1y/data=!4m2!3m1!1s0x88f575896242dab3:0xe27beed0a7641699",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkmzwiy3nWZlZuWdN_DUEAQX9St-PchrB6RrBdgkdLMSS0G-V0f0CTclaqXTrWpeOidQjvbCk_ym0DbpQjsdntoGZmMbsSQqe3rty3FEZy2t16US4bm4d7cZKAUE7BW2BPKyRLP=w298-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Hope+Fertility,+11375+Southbridge+Pkwy,+Alpharetta,+GA+30022/@34.0574764,-84.2367261,3305a,13.1y/data=!4m2!3m1!1s0x88f575896242dab3:0xe27beed0a7641699",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-878",
    "externalIds": {
      "cdcClinicId": "878"
    },
    "type": "fertility-clinic",
    "name": "Kindbody Atlanta",
    "phone": "(470) 765-6347",
    "address": {
      "line1": "3005 Peachtree Rd N.E., Suite 100",
      "city": "Atlanta",
      "state": "GA",
      "zip": "30305",
      "country": "US"
    },
    "location": {
      "lat": 33.8367,
      "lng": -84.3811
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 25,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27878%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27878%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.kindbody.com/ivf-cost/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-878-kristen-cain-md",
        "name": "Kristen Cain, MD",
        "role": "Medical Director"
      }
    ],
    "network": {
      "name": "Kindbody"
    },
    "website": "https://www.kindbody.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Anthem",
        "Blue Cross Blue Shield",
        "Cigna",
        "Emblem Health",
        "Empire Blue Cross Blue Shield",
        "First Health",
        "Health Net",
        "Horizon",
        "Humana",
        "Maven",
        "Medicare",
        "Medicaid",
        "MultiPlan",
        "Optum",
        "Oscar",
        "Oxford",
        "Progyny",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven"],
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "pricing": {
      "packages": [
        {
          "name": "Pulse Assessment",
          "description": "Quick fertility check — not covered by insurance",
          "price": 9900,
          "currency": "USD",
          "includes": [
            "AMH blood test",
            "Transvaginal ultrasound for follicle count",
            "15-minute reproductive consultation"
          ],
          "notes": "Not covered by insurance"
        },
        {
          "name": "Fertility Consultation",
          "description": "Specialist consultation on fertility fundamentals",
          "price": 30000,
          "currency": "USD",
          "notes": "Billable to most insurance plans"
        },
        {
          "name": "Male Consultation + Semen Analysis",
          "price": 52500,
          "currency": "USD",
          "includes": ["Consultation", "Venipuncture", "Semen analysis"]
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Single egg freezing cycle",
          "price": 690000,
          "priceMax": 966000,
          "currency": "USD",
          "includes": [
            "Stimulation visits",
            "Ultrasounds",
            "Blood draws",
            "Retrieval",
            "Cryopreservation",
            "3 months storage",
            "Coordination"
          ],
          "excludes": ["Medications ($4,000 - $6,000)", "Anesthesia"]
        },
        {
          "name": "Annual Egg Storage",
          "price": 92000,
          "currency": "USD",
          "notes": "Per year"
        },
        {
          "name": "IVF Freeze All (Self Pay)",
          "description": "IVF cycle with all embryos frozen",
          "price": 1160000,
          "priceMax": 1850000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Cryopreservation",
            "3 months storage"
          ],
          "excludes": [
            "Medications (~$4,000 - $6,000)",
            "Embryo biopsy/genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Donor services",
            "Anesthesia"
          ]
        },
        {
          "name": "IVF Fresh Transfer (Self Pay)",
          "description": "IVF cycle with fresh embryo transfer",
          "price": 1380000,
          "priceMax": 1875000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$5,000 - $9,000)",
            "Genetic testing",
            "Surplus embryo storage",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Freeze All",
          "price": 910000,
          "priceMax": 1332000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Cryopreservation",
            "3-month storage"
          ],
          "excludes": [
            "Genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Fresh Transfer",
          "price": 990000,
          "priceMax": 1428000,
          "currency": "USD",
          "includes": [
            "Ultrasounds",
            "Thaw",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Surplus storage",
            "Frozen transfers",
            "Anesthesia"
          ]
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 400000,
          "priceMax": 550000,
          "currency": "USD",
          "includes": ["Ultrasounds", "Thaw", "Assisted hatching", "Transfer"],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "PGT Package",
          "description": "Preimplantation genetic testing",
          "price": 160000,
          "priceMax": 300000,
          "currency": "USD",
          "includes": ["Embryo biopsy", "Lab management"],
          "excludes": ["Storage", "Shipping", "Per-embryo testing costs"]
        },
        {
          "name": "Nutrition Coaching",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Counseling & Support",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Guided Meditation",
          "description": "Virtual wellness — 30-minute session",
          "price": 9000,
          "currency": "USD"
        }
      ],
      "financingOptions": [
        {
          "name": "PatientFi monthly payments",
          "description": "PatientFi monthly payments"
        }
      ],
      "disclaimer": "Prices vary by location. Medications and anesthesia are not included in procedure costs. 3 months of storage included with freeze procedures; annual storage is $920.",
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Blue Cross Blue Shield, Cigna, Emblem Health, Empire Blue Cross Blue Shield, First Health, Health Net",
              "detail": "12 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "14 public price package(s) and 1 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-837",
    "externalIds": {
      "cdcClinicId": "837"
    },
    "type": "fertility-clinic",
    "name": "Massey Fertility Services",
    "phone": "(404) 228-7199",
    "address": {
      "line1": "371 E. Paces Ferry Rd, Suite 400",
      "city": "Atlanta",
      "state": "GA",
      "zip": "30305",
      "country": "US"
    },
    "location": {
      "lat": 33.749,
      "lng": -84.388
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 38.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 43.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 43.75,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/16"
        }
      ],
      "cyclesPerYear": 208,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27837%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27837%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-837-nestor-e-dourron-md",
        "name": "Nestor E. Dourron, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.masseyfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-196",
    "externalIds": {
      "cdcClinicId": "196",
      "googlePlaceId": "ChIJ8RuC9TUJ9YgRQQ7bojoB_Sk"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Biology Associates",
    "phone": "(404) 257-1900",
    "address": {
      "line1": "1100 Johnson Ferry Rd N.E., Suite 200",
      "city": "Atlanta",
      "state": "GA",
      "zip": "30342",
      "country": "US"
    },
    "location": {
      "lat": 33.907,
      "lng": -84.3495
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 55.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 56.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 37.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 23,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1022,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27196%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27196%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.rbafertility.com/rba-fertility-clinics/atlanta",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Reproductive+Biology+Associates,+1100+Johnson+Ferry+Rd+NE+Bldg+2,+Suite+200,+Atlanta,+GA+30342/@33.9071389,-84.3493417,3311a,13.1y/data=!4m2!3m1!1s0x88f50935f5821bf1:0x29fd013aa2db0e41",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-196-daniel-b-shapiro-md",
        "name": "Daniel B. Shapiro, MD",
        "role": "Medical Director",
        "imageUrl": "https://cdn.buttercms.com/0vARSRRL6KjKvh15ti6w",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.rbafertility.com/atlanta-fertility-specialists/dr-daniel-shapiro",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.rba-online.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://cdn.buttercms.com/MbSSFnXSKS5Y7Rq6Gi8z",
        "type": "exterior",
        "caption": "RBA Fertility Atlanta clinic exterior",
        "_source": {
          "url": "https://www.rbafertility.com/rba-fertility-clinics/atlanta",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-286",
    "externalIds": {
      "cdcClinicId": "286",
      "googlePlaceId": "ChIJFw0QQEnM-YgR1DD1jjPfhUs"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Medicine and Infertility Associates",
    "phone": "(706) 722-4434",
    "address": {
      "line1": "810 Chafee Ave",
      "city": "Augusta",
      "state": "GA",
      "zip": "30904",
      "country": "US"
    },
    "location": {
      "lat": 33.4747,
      "lng": -81.9903
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 51.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 75,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "12/16"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "0/6"
        }
      ],
      "cyclesPerYear": 97,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27286%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27286%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.augusta.edu/mcg/obgyn/reig/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Wellstar+Reproductive+Medicine+Infertility,+810+Chafee+Ave,+Augusta,+GA+30904/@33.4746781,-81.9902298,3328a,13.1y/data=!4m2!3m1!1s0x88f9cc4940100d17:0x4b85df338ef530d4",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-286-larisa-gavrilova-jordan-md",
        "name": "Larisa Gavrilova-Jordan, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.augusta.edu/colleges/medicine/obgyn/images/gavrilovajordan.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.augusta.edu/mcg/obgyn/reig/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.rmia.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://www.augusta.edu/colleges/medicine/obgyn/images/reproductive-medicine-and-infertility-associates-promo-2.jpg",
        "type": "exterior",
        "caption": "Augusta University Reproductive Medicine and Infertility Associates exterior",
        "_source": {
          "url": "https://www.augusta.edu/mcg/obgyn/reig/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-394",
    "externalIds": {
      "cdcClinicId": "394",
      "googlePlaceId": "ChIJx6DrzTIJ9YgRYL9YXWkXfZA"
    },
    "type": "fertility-clinic",
    "name": "Shady Grove Fertility-Atlanta",
    "phone": "(404) 843-2229",
    "address": {
      "line1": "1100 Lake Hearn Dr, Suite 400",
      "city": "Atlanta",
      "state": "GA",
      "zip": "30342",
      "country": "US"
    },
    "location": {
      "lat": 33.9036,
      "lng": -84.354
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 39.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 28.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 39,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 25,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 650,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27394%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27394%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/georgia/atlanta-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Atlanta,+1100+Lake+Hearn+Dr+NE+Ste+400,+Atlanta,+GA+30342/@33.913106,-84.3500194,3311a,13.1y/data=!4m2!3m1!1s0x88f50932cdeba0c7:0x907d17695d58bf60",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-394-desiree-mccarthy-keith-md",
        "name": "Desireé McCarthy-Keith, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/09/McCarthy-Keith-850x850-1.png",
        "credentials": ["MD", "MPH"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/georgia/atlanta-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Pavna Brahma, MD",
        "role": "IVF Director, Atlanta",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/09/Brahma-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/georgia/atlanta-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-394-pavna-brahma-md"
      },
      {
        "name": "Valerie Libby, MD, MPH",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MPH"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Valerie-Libby-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/georgia/atlanta-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-394-valerie-libby-md-mph"
      },
      {
        "name": "Jessica R. Kanter, MD, MTR",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MTR"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/10/Jessica-Kanter-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/georgia/atlanta-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-394-jessica-r-kanter-md-mtr"
      },
      {
        "name": "Mary Claire Connelly, NP",
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/06/Connelly-85x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/georgia/atlanta-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-394-mary-claire-connelly-np"
      },
      {
        "name": "Paula Morton, TS, ELD",
        "role": "Lab Director, SGF Atlanta",
        "credentials": ["TS", "ELD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/06/Morton-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/georgia/atlanta-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Embryology",
        "practitionerId": "pr-org-cdc-394-paula-morton-ts-eld"
      }
    ],
    "network": {
      "name": "US Fertility"
    },
    "website": "https://www.shadygrovefertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2021/02/sandy-springs.png",
        "type": "exterior",
        "caption": "Shady Grove Fertility Atlanta/Sandy Springs clinic exterior",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/georgia/atlanta-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2024/05/KatieBrickerPhotography_eh4_ShadyGrove-SandySprings-GA_20240121_009_door-closed_v1_webuse-1024x684.jpg",
        "type": "exterior",
        "caption": "Shady Grove Fertility Atlanta/Sandy Springs clinic entrance",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/georgia/atlanta-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2024/05/KatieBrickerPhotography_eh4_ShadyGrove-SandySprings-GA_20240121_102_v1_webuse-1024x683.jpg",
        "type": "interior",
        "caption": "Shady Grove Fertility Atlanta/Sandy Springs clinic interior",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/georgia/atlanta-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlzREdeliFvK3guj4Wo2CFM1s-187JiMiiHwoJeliDxRTBqLmlS_7igO5p4eJDywghDTlQmm_LpHdyMO0uqvh9N9IepwTMx8VcD_xW8d0J4lZrY47HuWsNxnTOgfptPQflTjSPrWA=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Atlanta,+1100+Lake+Hearn+Dr+NE+Ste+400,+Atlanta,+GA+30342/@33.913106,-84.3500194,3311a,13.1y/data=!4m2!3m1!1s0x88f50932cdeba0c7:0x907d17695d58bf60",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl0TT1yngn-p2bcrJb4GaLOA6GcddKm62kU45cey3FpJZ2TfmUtRrhNh3M4wWMhHi89AdPnILj3ct6E_7T4IXvjXWhdNetqO-lppFPx0iIZuaGccjjCzEL2ti-zmwHLBtHhw5qODbZ4Vd3L=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Atlanta,+1100+Lake+Hearn+Dr+NE+Ste+400,+Atlanta,+GA+30342/@33.913106,-84.3500194,3311a,13.1y/data=!4m2!3m1!1s0x88f50932cdeba0c7:0x907d17695d58bf60",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-144",
    "externalIds": {
      "cdcClinicId": "144"
    },
    "type": "fertility-clinic",
    "name": "The Georgia Center for Reproductive Medicine",
    "phone": "(912) 352-8588",
    "address": {
      "line1": "5354 Reynolds St, Suite 510",
      "city": "Savannah",
      "state": "GA",
      "zip": "31405",
      "country": "US"
    },
    "location": {
      "lat": 32.0276,
      "lng": -81.0996
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 66.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 35,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 45.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 178,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27144%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27144%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-144-patrick-l-blohm-md",
        "name": "Patrick L. Blohm, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.ivf.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-277",
    "externalIds": {
      "cdcClinicId": "277",
      "googlePlaceId": "ChIJ6RwtKettAHwRP7d8efaytVA"
    },
    "type": "fertility-clinic",
    "name": "Advanced Reproductive Center of Hawaii",
    "phone": "(808) 949-6611",
    "address": {
      "line1": "1319 Punahou St, Suite 1180",
      "city": "Honolulu",
      "state": "HI",
      "zip": "96826",
      "country": "US"
    },
    "location": {
      "lat": 21.2999,
      "lng": -157.834
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 69.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 76.92307692307693,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "10/13"
        },
        {
          "ageBand": "38-40",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/12"
        }
      ],
      "cyclesPerYear": 98,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27277%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://archawaii.com/connect-with-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27277%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://archawaii.com/about-us/meet-our-team/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Advanced+Reproductive+Center+of+Hawaii,+1319+Punahou+St+%231180,+Honolulu,+HI+96826/@21.2999671,-157.8339239,3717a,13.1y/data=!4m2!3m1!1s0x7c006deb292d1ce9:0x50b5b2f6797cb73f",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://archawaii.com/connect-with-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-277-christopher-t-huang-md",
        "name": "Christopher T. Huang, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://archawaii.com/wp-content/uploads/2018/06/Dr-Huang.jpg",
        "_source": {
          "url": "https://archawaii.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-277-christina-arnett-md",
        "name": "Christina Arnett, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://archawaii.com/wp-content/uploads/2018/06/Dr-Arnett.jpg",
        "_source": {
          "url": "https://archawaii.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://archawaii.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "HMSA",
        "Kaiser Permanente Hawaii"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, HMSA, Kaiser Permanente Hawaii",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Hawaii (HI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-219",
    "externalIds": {
      "cdcClinicId": "219",
      "googlePlaceId": "ChIJndOJXultAHwRHVxyqDO-XuY"
    },
    "type": "fertility-clinic",
    "name": "Fertility Institute of Hawaii",
    "phone": "(808) 545-2800",
    "address": {
      "line1": "1585 Kapiolani Blvd, Suite 1800",
      "city": "Honolulu",
      "state": "HI",
      "zip": "96814",
      "country": "US"
    },
    "location": {
      "lat": 21.2915925,
      "lng": -157.8404769
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 61.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 63.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 43.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 17.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 337,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27219%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.ivfcenterhawaii.com/contact-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27219%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/john-frattarelli-md/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Institute+of+Hawaii,+1585+Kapiolani+Blvd+%231800,+Honolulu,+HI+96814/@21.2915836,-157.8404661,3717a,13.1y/data=!4m2!3m1!1s0x7c006de95e89d39d:0xe65ebe33a8725c1d",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.ivfcenterhawaii.com/contact-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-219-john-l-frattarelli-md-hcld",
        "name": "John L. Frattarelli, MD, HCLD",
        "role": "Medical, Practice and Laboratory Director",
        "credentials": ["MD", "HCLD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2021/01/John-Frattarelli-MD.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/john-frattarelli-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-219-anatte-karmon-md-facog",
        "name": "Anatte Karmon, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2021/01/Anatte-Karmon-MD.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/anatte-karmon-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-219-emily-goulet-md-facog",
        "name": "Emily Goulet, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2021/01/EG_web.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/emily-goulet-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-219-kaitlin-corbett-pa-c",
        "name": "Kaitlin Corbett, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "specialty": "Physician Assistant",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2022/10/PXL_20220922_001157193.PORTRAIT-scaled-e1665018923419-300x223.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/kaitlin-corbett-pa-c/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-219-chandra-marsh-pa-c",
        "name": "Chandra Marsh, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "specialty": "Physician Assistant",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2023/01/Chandra-PA_C-300x200.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/chandra-marsh-pa-c/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-219-lyndsey-smith-aprn",
        "name": "Lyndsey Smith, APRN",
        "role": "Nurse Practitioner",
        "credentials": ["APRN"],
        "specialty": "Nurse Practitioner",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2022/02/Lyndsey-Smith-APRN-300x200.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/lyndsey-smith-aprn/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-219-pauline-garrison-ba-ms-ts",
        "name": "Pauline Garrison, BA, MS, TS",
        "role": "Laboratory Team",
        "credentials": ["BA", "MS", "TS"],
        "specialty": "Embryology",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2020/06/pauline.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/pauline-garrison-ba-ms-ts/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-219-egle-a-ortega-ba-ms-phd",
        "name": "Egle A. Ortega, BA, MS, PhD",
        "role": "Laboratory Team",
        "credentials": ["BA", "MS", "PhD"],
        "specialty": "Embryology",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2022/10/PXL_20221011_010121254.PORTRAIT31-300x240.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/egle-a-ortega-ba-ms-ph-d/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-219-erina-kudo-ms",
        "name": "Erina Kudo, MS",
        "role": "Laboratory Team",
        "credentials": ["MS"],
        "specialty": "Embryology",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2022/02/Erina-Kudo-300x200.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/erina-kudo/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-219-linda-coelho-bs-grad-dip-ms",
        "name": "Linda Coelho, BS, Grad Dip, MS",
        "role": "Laboratory Team",
        "credentials": ["BS", "Grad Dip", "MS"],
        "specialty": "Embryology",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2023/01/Linda-Coelho-BS-MS-Grad-Dip-300x200.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/linda-coelho-bs-grad-dip-ms/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.ivfcenterhawaii.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "HMSA",
        "Kaiser Permanente Hawaii"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://www.fertilityshare.com/wp-content/uploads/2025/01/2024-08e-30.jpg",
        "type": "interior",
        "caption": "Fertility Institute of Hawaii waiting area.",
        "_source": {
          "url": "https://www.fertilityshare.com/clinic/fertility-institute-of-hawaii/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://www.fertilityshare.com/wp-content/uploads/2025/01/202o2-11-19.jpg",
        "type": "interior",
        "caption": "Fertility Institute of Hawaii front desk.",
        "_source": {
          "url": "https://www.fertilityshare.com/clinic/fertility-institute-of-hawaii/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmSFo72fhBe7RNx6BN-hxWpIo9VE-SiDZV4jmr3psNcNZo89T0-AhPABfP6cquJ6BO-GVLJTqvOn_j5b9PHxKENFEnBAyKibHz038Q3h2PQNk9QpwY75I2oCt9DNhhzvCudQ1H5tg=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Institute+of+Hawaii,+1585+Kapiolani+Blvd+%231800,+Honolulu,+HI+96814/@21.2915836,-157.8404661,3717a,13.1y/data=!4m2!3m1!1s0x7c006de95e89d39d:0xe65ebe33a8725c1d",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlOV-oYhZagjKx0Eipk7eBjKysSjSFOcngJvijN77qYbGUoZDOh5eJJXkPD2f1uJrE7E_e3o5NhmE8wCcRxMQSx8VFt2SH31lnMojkmIkGIUhrY7FasiY27syJaUjNV1YUagpdTaBbR3ah5=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Institute+of+Hawaii,+1585+Kapiolani+Blvd+%231800,+Honolulu,+HI+96814/@21.2915836,-157.8404661,3717a,13.1y/data=!4m2!3m1!1s0x7c006de95e89d39d:0xe65ebe33a8725c1d",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, HMSA, Kaiser Permanente Hawaii",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Hawaii (HI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-23",
    "externalIds": {
      "cdcClinicId": "23"
    },
    "type": "fertility-clinic",
    "name": "IVF Hawaii",
    "phone": "(808) 538-6655",
    "address": {
      "line1": "1329 Lusitana St, Suite 607",
      "city": "Honolulu",
      "state": "HI",
      "zip": "96813",
      "country": "US"
    },
    "location": {
      "lat": 21.3076,
      "lng": -157.852
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 57.89473684210527,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "11/19"
        },
        {
          "ageBand": "35-37",
          "rate": 28.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 74,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2723%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.ivfhawaii.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2723%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfhawaii.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfhawaii.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.ivfhawaii.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-23-benton-h-chun-md",
        "name": "Benton H. Chun, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.ivfhawaii.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.ivfhawaii.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "HMSA",
        "Kaiser Permanente Hawaii"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, HMSA, Kaiser Permanente Hawaii",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Hawaii (HI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-115",
    "externalIds": {
      "cdcClinicId": "115"
    },
    "type": "fertility-clinic",
    "name": "Pacific In Vitro Fertilization Institute",
    "phone": "(808) 946-2226",
    "address": {
      "line1": "Kapi`olani Medical Center, 1319 Punahou St, Suite 980",
      "city": "Honolulu",
      "state": "HI",
      "zip": "96826",
      "country": "US"
    },
    "location": {
      "lat": 21.2998,
      "lng": -157.833
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 39.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 37.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 22.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 7.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 181,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27115%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.pacificinvitro.com/about/doctors",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27115%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pacificinvitro.com/about/doctors",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Pacific+In+Vitro+Fertilization+Institute,+1319+Punahou+St+%23980,+Honolulu,+HI+96826/@21.3004056,-157.8338857,3717a,13.1y/data=!4m2!3m1!1s0x7c006deb22f366ff:0xe391dcc7fda49c61",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.pacificinvitro.com/about/doctors",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-115-thomas-s-kosasa-md",
        "name": "Thomas S. Kosasa, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.pacificinvitro.com/img/about/dr_kosasa.1658193516.jpg",
        "_source": {
          "url": "https://www.pacificinvitro.com/about/doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-115-celia-dominguez-md",
        "name": "Celia Dominguez, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.pacificinvitro.com/img/about/dr_dominguez.1658193516.jpg",
        "_source": {
          "url": "https://www.pacificinvitro.com/about/doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-115-thomas-huang-phd-hcld-eld",
        "name": "Thomas Huang, PhD, HCLD, ELD",
        "role": "Laboratory Director",
        "credentials": ["PhD", "HCLD", "ELD"],
        "specialty": "Embryology",
        "imageUrl": "https://www.pacificinvitro.com/img/about/dr_huang.1658193516.jpg",
        "_source": {
          "url": "https://www.pacificinvitro.com/about/doctors",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.pacificinvitro.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "HMSA",
        "Kaiser Permanente Hawaii"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, HMSA, Kaiser Permanente Hawaii",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Hawaii (HI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-474",
    "externalIds": {
      "cdcClinicId": "474"
    },
    "type": "fertility-clinic",
    "name": "Tripler Army Medical Center IVF Institute",
    "phone": "(808) 433-5925",
    "address": {
      "line1": "Department of Obstetrics and Gynecology, 1 Jarrett White Rd",
      "city": "Tripler Amc",
      "state": "HI",
      "zip": "96859",
      "country": "US"
    },
    "location": {
      "lat": 21.359736,
      "lng": -157.8901012
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 31.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 30,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "0/16"
        }
      ],
      "cyclesPerYear": 115,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27474%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://tripler.tricare.mil/Health-Services/Womens-Health-Pregnancy/Reproductive-Endocrinology-Infertility-REI-Center",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27474%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "verified-none",
          "source": {
            "url": "https://tripler.tricare.mil/Health-Services/Womens-Health-Pregnancy/Reproductive-Endocrinology-Infertility-REI-Center",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://tripler.tricare.mil/Health-Services/Womens-Health-Pregnancy/Reproductive-Endocrinology-Infertility-REI-Center",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://tripler.tricare.mil/Health-Services/Womens-Health-Pregnancy/Reproductive-Endocrinology-Infertility-REI-Center",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [],
    "website": "https://tripler.tricare.mil/Health-Services/Womens-Health-Pregnancy/Reproductive-Endocrinology-Infertility-REI-Center",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "HMSA",
        "Kaiser Permanente Hawaii"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, HMSA, Kaiser Permanente Hawaii",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Hawaii (HI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-37",
    "externalIds": {
      "cdcClinicId": "37",
      "googlePlaceId": "ChIJfSeImyAh7IcRvsI9Mdm6Iew"
    },
    "type": "fertility-clinic",
    "name": "Mid-Iowa Fertility, PC",
    "phone": "(515) 420-1669",
    "address": {
      "line1": "1371 NW 121st St",
      "city": "Clive",
      "state": "IA",
      "zip": "50325",
      "country": "US"
    },
    "location": {
      "lat": 41.6024,
      "lng": -93.784
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 47.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 36.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 44.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 554,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2737%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://midiowafertility.com/about-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2737%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://midiowafertility.com/about-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Mid-Iowa+Fertility,+1371+NW+121st+St,+Clive,+IA+50325/@41.6024251,-93.7840276,2983a,13.1y/data=!4m2!3m1!1s0x87ec21209b88277d:0xec21bad9313dc2be",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://midiowafertility.com/about-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-37-donald-c-young-do-facog",
        "name": "Donald C. Young, DO, FACOG",
        "role": "Medical Director",
        "credentials": ["DO", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://midiowafertility.com/wp-content/uploads/2023/09/mid-iowa-fertility-clinic-dr-donald-young.jpg",
        "_source": {
          "url": "https://midiowafertility.com/our-fertility-doctors/donald-c-young/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-37-brian-c-cooper-md-facog",
        "name": "Brian C. Cooper, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://midiowafertility.com/wp-content/uploads/2023/10/mid-iowa-fertility-clinic-dr-brian-cooper.jpg",
        "_source": {
          "url": "https://midiowafertility.com/our-fertility-doctors/brian-c-cooper/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-37-trenton-place-do-phd",
        "name": "Trenton Place, DO, PhD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO", "PhD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://midiowafertility.com/wp-content/uploads/2023/10/mid-iowa-fertility-clinic-dr-trenton-place-1.jpg",
        "_source": {
          "url": "https://midiowafertility.com/our-fertility-doctors/trenton-place/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://midiowafertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://midiowafertility.com/wp-content/uploads/2016/07/Mid_Iowa_Fertility_170221_1355-1-300x200.jpg",
        "type": "interior",
        "caption": "Mid-Iowa Fertility waiting area.",
        "_source": {
          "url": "https://midiowafertility.com/about-us/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn4KZWYKXL2hlI1pPMuYpzzyPHY-4xGkAI8wu6-vMsLhCgCs8cQ4-xz6qilA3yQxT3Shb0X2R7AsO9RoRNo9D0GxBx55Pc17I6u6x8xpxVS-keIipfc4HHjhwMuFhby9FOsKqr5ow=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Mid-Iowa+Fertility,+1371+NW+121st+St,+Clive,+IA+50325/@41.6024251,-93.7840276,2983a,13.1y/data=!4m2!3m1!1s0x87ec21209b88277d:0xec21bad9313dc2be",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Iowa (IA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-255",
    "externalIds": {
      "cdcClinicId": "255"
    },
    "type": "fertility-clinic",
    "name": "University of Iowa Hospitals and Clinics, Center for Advanced Reproductive Care",
    "phone": "1-319-356-8483",
    "address": {
      "line1": "1360 N Dodge St, Suite 2000",
      "city": "Iowa City",
      "state": "IA",
      "zip": "52245",
      "country": "US"
    },
    "location": {
      "lat": 41.67784075,
      "lng": -91.5159454
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 47.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 50.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 41,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 31.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 650,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27255%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://uihc.org/locations/iowa-city-north-dodge/ui-health-care-center-advanced-reproductive-care",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27255%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://obgyn.medicine.uiowa.edu/faculty?cohort=421683",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://uihc.org/locations/iowa-city-north-dodge/ui-health-care-center-advanced-reproductive-care",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://uihc.org/locations/iowa-city-north-dodge/ui-health-care-center-advanced-reproductive-care",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-255-eyup-h-duran-md-facog",
        "name": "Eyup H. Duran, MD, FACOG",
        "role": "Director, Division of Reproductive Endocrinology and Infertility",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://profiles.uiowa.edu/api/people/hakan-duran/image",
        "_source": {
          "url": "https://obgyn.medicine.uiowa.edu/faculty?cohort=421683",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-255-abey-eapen-mbbs-drcog-phd-fcri",
        "name": "Abey Eapen, MBBS, DRCOG, PhD, FCRI",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MBBS", "DRCOG", "PhD", "FCRI"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://profiles.uiowa.edu/api/people/abey-eapen/image",
        "_source": {
          "url": "https://obgyn.medicine.uiowa.edu/faculty?cohort=421683",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-255-jessica-d-kresowik-md",
        "name": "Jessica D. Kresowik, MD",
        "role": "Director, In Vitro Fertilization Program",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://profiles.uiowa.edu/api/people/jessica-kresowik/image",
        "_source": {
          "url": "https://obgyn.medicine.uiowa.edu/faculty?cohort=421683",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-255-abigail-mancuso-md",
        "name": "Abigail Mancuso, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://profiles.uiowa.edu/api/people/abigail-mancuso/image",
        "_source": {
          "url": "https://obgyn.medicine.uiowa.edu/faculty?cohort=421683",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-255-amy-e-sparks-phd-hcld",
        "name": "Amy E. Sparks, PhD, HCLD",
        "role": "Director, IVF and Reproductive Testing Laboratories",
        "credentials": ["PhD", "HCLD"],
        "specialty": "Embryology",
        "imageUrl": "https://profiles.uiowa.edu/api/people/amy-sparks/image",
        "_source": {
          "url": "https://obgyn.medicine.uiowa.edu/faculty?cohort=421683",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://uihc.org/locations/iowa-city-north-dodge/ui-health-care-center-advanced-reproductive-care",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "images": [
      {
        "url": "https://uihc.org/sites/default/files/styles/scale_to_1200px/public/2023-03/20230301_North_Dodge_08-edit.jpg.webp?itok=FCAUd5R0",
        "type": "interior",
        "caption": "UI Health Care Center for Advanced Reproductive Care check-in desk.",
        "_source": {
          "url": "https://uihc.org/locations/iowa-city-north-dodge/ui-health-care-center-advanced-reproductive-care",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Iowa (IA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-35",
    "externalIds": {
      "cdcClinicId": "35",
      "googlePlaceId": "ChIJD3b2Gvz4rlQR1OiqGpza-OA"
    },
    "type": "fertility-clinic",
    "name": "Idaho Center for Reproductive Medicine",
    "phone": "(208) 342-5900",
    "address": {
      "line1": "1000 E. Park Blvd, Suite 110",
      "city": "Boise",
      "state": "ID",
      "zip": "83712",
      "country": "US"
    },
    "location": {
      "lat": 43.6032,
      "lng": -116.188
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 64.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 49.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 340,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2735%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2735%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://idahoreproductive.com/about/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Idaho+Center+for+Reproductive+Medicine,+1000+E+Park+Blvd+Ste+110,+Boise,+ID+83712/@43.6032309,-116.1875906,2889a,13.1y/data=!4m2!3m1!1s0x54aef8fc1af6760f:0xe0f8da9c1aaae8d4",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://idahoreproductive.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-35-kevin-h-maas-md-phd",
        "name": "Kevin H. Maas, MD, PhD",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "role": "Medical Director",
        "imageUrl": "https://idahoreproductive.com/wp-content/uploads/2025/05/Dr.-Kevin-H-1.jpg",
        "_source": {
          "url": "https://idahoreproductive.com/about/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-35-cristin-c-slater-md",
        "name": "Cristin C. Slater, MD",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://idahoreproductive.com/wp-content/uploads/2025/05/Cristin-C.jpg",
        "_source": {
          "url": "https://idahoreproductive.com/about/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-35-kyle-tobler-md",
        "name": "Kyle Tobler, MD",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://idahoreproductive.com/wp-content/uploads/2025/06/Dr.-Kyle-Tobler.-Kyle-Tobler.-Kyle-Tobler.jpg",
        "_source": {
          "url": "https://idahoreproductive.com/about/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-35-kara-hill-rnc-msn",
        "name": "Kara Hill, RNC, MSN",
        "credentials": ["RNC", "MSN"],
        "specialty": "Nurse Practitioner",
        "role": "IVF Coordinator and Clinical Manager",
        "imageUrl": "https://idahoreproductive.com/wp-content/uploads/2025/05/Kara-Hill.jpg",
        "_source": {
          "url": "https://idahoreproductive.com/about/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-35-kelsey-evans-whnp-bc",
        "name": "Kelsey Evans, WHNP-BC",
        "credentials": ["WHNP-BC"],
        "specialty": "Women's Health Nurse Practitioner",
        "role": "Nurse Practitioner",
        "imageUrl": "https://idahoreproductive.com/wp-content/uploads/2025/05/Kelsey-Evans.jpg",
        "_source": {
          "url": "https://idahoreproductive.com/about/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://idahoreproductive.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlJxRoO1ncbHPnIrlYNxkN02YANtovIJaGksV-kWiK6D8oZx0Ktu293fTTT_zq5v9HHei_a-8cWaQEH6O72QaeSktQE0O-gS1vg3IaLtN_SKGjhAVgYqW0r0NCbbo5VND7XbS5nSA=w408-h544-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Idaho+Center+for+Reproductive+Medicine,+1000+E+Park+Blvd+Ste+110,+Boise,+ID+83712/@43.6032309,-116.1875906,2889a,13.1y/data=!4m2!3m1!1s0x54aef8fc1af6760f:0xe0f8da9c1aaae8d4",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnGQm8-D2dtGSmGL9jnz60-QqmQKUP7C4j7QL0L9hBa0GTNf6wp1Ncn_dTtElSAvk4JPgN0Bc-k1ML7lcQ0Pxwv6Sf6S07p_PE23yn7rYbma6h1hfhiovKBf_N9HOp95cCw-1c=w360-h451-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Idaho+Center+for+Reproductive+Medicine,+1000+E+Park+Blvd+Ste+110,+Boise,+ID+83712/@43.6032309,-116.1875906,2889a,13.1y/data=!4m2!3m1!1s0x54aef8fc1af6760f:0xe0f8da9c1aaae8d4",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "specialties": ["fertility-nursing", "reproductive-endocrinology"],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Idaho (ID) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-300",
    "externalIds": {
      "cdcClinicId": "300",
      "googlePlaceId": "ChIJFX8KLmGSD4gRujC2hYfEtIA"
    },
    "type": "fertility-clinic",
    "name": "Advanced Fertility Center of Chicago",
    "phone": "(847) 662-1818",
    "address": {
      "line1": "30 Tower Ct, Suite F",
      "city": "Gurnee",
      "state": "IL",
      "zip": "60031",
      "country": "US"
    },
    "location": {
      "lat": 42.3574,
      "lng": -87.8993
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 53.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 45.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 46.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 15.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 848,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27300%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27300%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.advancedfertility.com/fertility-clinics/gurnee",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Advanced+Fertility+Center+of+Chicago,+30+Tower+Ct+Ste+F,+Gurnee,+IL+60031/@42.3573566,-87.8993706,2948a,13.1y/data=!4m2!3m1!1s0x880f92612e0a7f15:0x80b4c48785b630ba",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-300-michelle-catenacci-md",
        "name": "Michelle Catenacci, MD",
        "role": "Medical Director",
        "imageUrl": "https://cdn.buttercms.com/6iBSp5QOTP21ZpHlyn1V",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.advancedfertility.com/fertility-specialists/michelle-catenacci-md",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.advancedfertility.com",
    "description": "Advanced Fertility Center of Chicago offers IVF, egg freezing, and fertility testing at multiple Chicago-area locations with over 25 years of experience.",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://cdn.buttercms.com/eF9O5AORZqgZQKXTcx1w",
        "type": "exterior",
        "caption": "Advanced Fertility Center of Chicago Gurnee clinic",
        "_source": {
          "url": "https://www.advancedfertility.com/fertility-clinics/gurnee",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWktpU1dic8w2AYYwvbjeJ8Ts_Xs6danTM9HUSpVW7fd3qrN2xes89WtChGs0wqyr27ahPP82_TOVm1ZzDSfad_sJBfxUh0tVQ_R3lsCqOTaxdtiNGSlh5VF-Yy4PaiJLUHy8XE=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Advanced+Fertility+Center+of+Chicago,+30+Tower+Ct+Ste+F,+Gurnee,+IL+60031/@42.3573566,-87.8993706,2948a,13.1y/data=!4m2!3m1!1s0x880f92612e0a7f15:0x80b4c48785b630ba",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnxEl-1V5---vVEsky1LNnG-3CvRCG8FGs4ozBD3FmzcB1Lre3dIVR8iBMsRRmE5BleR4Q12ufr4grQGrWuOFbzJ9MR6wBLsGftXrkCHQen3xzj-DjaeaC1a2VeX1KKU7ncELfdvQ=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Advanced+Fertility+Center+of+Chicago,+30+Tower+Ct+Ste+F,+Gurnee,+IL+60031/@42.3573566,-87.8993706,2948a,13.1y/data=!4m2!3m1!1s0x880f92612e0a7f15:0x80b4c48785b630ba",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-100",
    "externalIds": {
      "cdcClinicId": "100"
    },
    "type": "fertility-clinic",
    "name": "Chicago Infertility Associates, LTD",
    "phone": "(630) 759-2966",
    "address": {
      "line1": "396 Remington Blvd, Suite 250",
      "city": "Bolingbrook",
      "state": "IL",
      "zip": "60440",
      "country": "US"
    },
    "location": {
      "lat": 42.0047,
      "lng": -88.0164
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [],
      "cyclesPerYear": 16,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27100%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27100%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.chicagoinfertility.org/about",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-100-ketan-n-jobanputra-md",
        "name": "Ketan N. Jobanputra, MD",
        "role": "Medical Director",
        "imageUrl": "https://le-cdn.hibuwebsites.com/e61bb726b6b04e4bb45450c09467786b/dms3rep/multi/opt/chicago-infertility-associates-ketan-jobanputra-384h.png",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.chicagoinfertility.org/about",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.chicagoinfertility.com",
    "description": "Chicago Infertility Associates provides comprehensive fertility care including IVF, IUI, and reproductive surgery in the greater Chicago area.",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-323",
    "externalIds": {
      "cdcClinicId": "323"
    },
    "type": "fertility-clinic",
    "name": "Chicago IVF",
    "phone": "(847) 213-5064",
    "address": {
      "line1": "5225 Old Orchard Rd, Suite 21",
      "city": "Skokie",
      "state": "IL",
      "zip": "60077",
      "country": "US"
    },
    "location": {
      "lat": 42.0619,
      "lng": -87.7584
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 32.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 41.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 30.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 13.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 389,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27323%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27323%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.chicagoivf.com/about/fertility-specialists/dr-joel-brasch",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-323-joel-g-brasch-md",
        "name": "Joel G. Brasch, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.chicagoivf.com/content/1-about/1-fertility-specialists/dr-joel-brasch/civf-joel-brasch.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.chicagoivf.com/about/fertility-specialists/dr-joel-brasch",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.chicagoivf.com",
    "description": "Chicago IVF is a fertility center offering IVF, egg freezing, and reproductive endocrinology services across multiple locations in the Chicago suburbs.",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-444",
    "externalIds": {
      "cdcClinicId": "444",
      "googlePlaceId": "ChIJOWm_0bRNDogRWZ3bdfB1eE4"
    },
    "type": "fertility-clinic",
    "name": "Daniel Rostein, MD, SC",
    "phone": "(630) 472-9100",
    "address": {
      "line1": "2208 Midwest Rd, Suite 102",
      "city": "Oak Brook",
      "state": "IL",
      "zip": "60523",
      "country": "US"
    },
    "location": {
      "lat": 41.8452,
      "lng": -87.9729
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 20,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27444%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27444%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.lifewomenshealthcenter.org/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Daniel+Rostein,+MD+SC,+2208+Midwest+Rd+%23102,+Oak+Brook,+IL+60523/@41.845202,-87.972876,2972a,13.1y/data=!4m2!3m1!1s0x880e4db4d1bf6939:0x4e7875f075db9d59",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-444-daniel-a-rostein-md",
        "name": "Daniel A. Rostein, MD",
        "role": "Medical Director",
        "imageUrl": "https://sa1s3optim.patientpop.com/assets/docs/74201.png",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.lifewomenshealthcenter.org/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.ivf-illinois.com",
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Blue Cross Blue Shield of Illinois"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Blue Cross Blue Shield of Illinois",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmLr8WdzQUdK3KzX38wFcURIvDEKbp6hw1LKq2TgAATNAtqBPLNm8N0WWyHSiWgvmhLlpCr-0QulgYN1spfYlr2o9RaQA0sx9G5BSlAsnSS7DYtpI4cHIYD4ckSjfKMCCANZ2eP=w224-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Daniel+Rostein,+MD+SC,+2208+Midwest+Rd+%23102,+Oak+Brook,+IL+60523/@41.845202,-87.972876,2972a,13.1y/data=!4m2!3m1!1s0x880e4db4d1bf6939:0x4e7875f075db9d59",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-518",
    "externalIds": {
      "cdcClinicId": "518"
    },
    "type": "fertility-clinic",
    "name": "Davies Fertility & IVF Specialists, SC",
    "phone": "(847) 972-0300",
    "address": {
      "line1": "2640 Patriot Blvd, Suite 260",
      "city": "Glenview",
      "state": "IL",
      "zip": "60026",
      "country": "US"
    },
    "location": {
      "lat": 42.1029,
      "lng": -87.8242
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 57.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 65.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 52,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 292,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27518%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27518%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.endeavorhealth.org/providers/susan-davies",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-518-susan-a-davies-md",
        "name": "Susan A. Davies, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.endeavorhealth.org/sites/default/files/styles/profile_hero_325x340/public/2024-02/susandavies1225128200.jpg?h=6c83441f&itok=jDJInOzO",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.endeavorhealth.org/providers/susan-davies",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.daviesfertility.com",
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Blue Cross Blue Shield of Illinois"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Blue Cross Blue Shield of Illinois",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-63",
    "externalIds": {
      "cdcClinicId": "63"
    },
    "type": "fertility-clinic",
    "name": "Fertility Centers of Illinois-Highland Park IVF Center",
    "phone": "(847) 266-3535",
    "address": {
      "line1": "767 Park Ave West, Suite B400",
      "city": "Highland Park",
      "state": "IL",
      "zip": "60035",
      "country": "US"
    },
    "location": {
      "lat": 42.1897,
      "lng": -87.8081
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 55.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 51.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 37.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 11.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 619,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2763%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2763%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-63-brian-r-kaplan-md",
        "name": "Brian R. Kaplan, MD",
        "role": "Medical Director"
      }
    ],
    "network": {
      "name": "US Fertility"
    },
    "website": "https://www.fcionline.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-275",
    "externalIds": {
      "cdcClinicId": "275",
      "googlePlaceId": "ChIJOQ5nkTPTD4gRYC-g2heQmqQ"
    },
    "type": "fertility-clinic",
    "name": "Fertility Centers of Illinois-River North IVF",
    "description": "One of the leading US Fertility Network practices, providing advanced reproductive care in Chicago since 1976 with over 42,000 babies born.",
    "website": "https://www.fcionline.com",
    "phone": "(312) 222-8230",
    "bookingUrl": "https://www.fcionline.com/appointment/",
    "address": {
      "line1": "900 N. Kingsbury St, River Walk 6",
      "city": "Chicago",
      "state": "IL",
      "zip": "60610",
      "country": "US"
    },
    "location": {
      "lat": 41.899,
      "lng": -87.6444
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "financingOptions": [
        "Payment plans",
        "Discount pricing",
        "CapexMD",
        "Future Family"
      ]
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 50.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 43.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 46.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 25.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1904,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27275%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "consultationTypes": ["in-person", "telehealth"],
    "patientGroups": ["LGBTQIA+"],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27275%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "scraped"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+Illinois+in+Kingsbury,+900+N+Kingsbury+St+Ste+RW6,+Chicago,+IL+60610/@41.8987197,-87.6449203,2970a,13.1y/data=!4m2!3m1!1s0x880fd33391670e39:0xa49a9017daa02f60",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-275-jennifer-e-hirshfeld-cytron-md",
        "name": "Jennifer E. Hirshfeld-Cytron, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Hirshfeld_Head_LC.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Channing Burks Chatmon, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/07/Burks-850x850-1.png",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-275-channing-burks-chatmon-md"
      },
      {
        "name": "Christopher Sipe, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Sipe_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-275-christopher-sipe-md"
      },
      {
        "name": "Samuel Ohlander, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Ohlander_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-275-samuel-ohlander-md"
      },
      {
        "name": "Edward Nguyen, MD, PhD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/10/Nguyen_head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-275-edward-nguyen-md-phd"
      },
      {
        "name": "Arlene Go, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/12/Untitled-design-50.png",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-275-arlene-go-md"
      },
      {
        "name": "Allison K. Rodgers, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Rodgers_Head_LC_2025.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-275-allison-k-rodgers-md"
      },
      {
        "name": "Jane Nani, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Nani_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-275-jane-nani-md"
      },
      {
        "name": "Karine Matevossian, DO",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/09/Matovessian_head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-275-karine-matevossian-do"
      },
      {
        "name": "Annie Martini, DO",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2025/09/MARTINI_head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-275-annie-martini-do"
      },
      {
        "name": "Meike Uhler, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Uhler_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-275-meike-uhler-md"
      },
      {
        "name": "Megan Sax, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/09/Sax_headshot.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-275-megan-sax-md"
      },
      {
        "name": "Elie Hobeika, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Hobeika_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-275-elie-hobeika-md"
      }
    ],
    "network": {
      "name": "US Fertility"
    },
    "languages": ["English", "Spanish"],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlhlzesENSm5vHgNK169mp1NweRrh5GEu2zxoPRIC69FELAmJfzeNyMpavvhVD3S00Okx8UW8ES-lYxM_3Cd6hMRq9GddeqP7UiPbNdblfD4Y6JO93tD3b4adMn4DI5YCX9tYx7WKkifeMG=w595-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+Illinois+in+Kingsbury,+900+N+Kingsbury+St+Ste+RW6,+Chicago,+IL+60610/@41.8987197,-87.6449203,2970a,13.1y/data=!4m2!3m1!1s0x880fd33391670e39:0xa49a9017daa02f60",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlfnLv6EiFnjjRzOMePW1Or6K83dMw3WQV4VrBTaoz6fHA6NqLMg-JGCVtaywDY1HQD70LnXR3Wu8-Alw00FkNmvOxh1-JCWVjmxGDSjaBTx70Jq8ASv5CGnEZTLLlq_vP9GGyc=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+Illinois+in+Kingsbury,+900+N+Kingsbury+St+Ste+RW6,+Chicago,+IL+60610/@41.8987197,-87.6449203,2970a,13.1y/data=!4m2!3m1!1s0x880fd33391670e39:0xa49a9017daa02f60",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-1",
    "externalIds": {
      "cdcClinicId": "1"
    },
    "type": "fertility-clinic",
    "name": "Pinnacle Fertility - Chicago",
    "phone": "(312) 288-6420",
    "address": {
      "line1": "680 N. Lake Shore Drive, Suite 100",
      "city": "Chicago",
      "state": "IL",
      "zip": "60611",
      "country": "US"
    },
    "location": {
      "lat": 41.8945,
      "lng": -87.639
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 56.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 50.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 31.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 32.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 634,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%271%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%271%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/chicago-il/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "layer2-il-current-org-cdc-1",
      "date": "2026-06-13",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-1-david-p-cohen-md",
        "name": "David P. Cohen, MD",
        "role": "Medical Director",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/03/Dr.-David-Cohen_IL-1024x1024.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/chicago-il/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.pinnaclefertility.com/location/chicago-il/",
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Blue Cross Blue Shield of Illinois"
      ]
    },
    "setting": "network-group",
    "bookingUrl": "https://www.pinnaclefertility.com/location/chicago-il/",
    "network": {
      "name": "Pinnacle Fertility"
    },
    "images": [
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/Front-reception-2-1024x683.jpg",
        "type": "interior",
        "caption": "Pinnacle Fertility Chicago front reception",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/chicago-il/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Blue Cross Blue Shield of Illinois",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-425",
    "externalIds": {
      "cdcClinicId": "425",
      "googlePlaceId": "ChIJA-OhM3CoD4gRzQGczJcitK4"
    },
    "type": "fertility-clinic",
    "name": "InVia Fertility Specialists",
    "phone": "(847) 884-8884",
    "address": {
      "line1": "1585 N. Barrington Rd, Bldg 2, Suite 406",
      "city": "Hoffman Estates",
      "state": "IL",
      "zip": "60169",
      "country": "US"
    },
    "location": {
      "lat": 42.0542,
      "lng": -88.1412
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 52.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 44.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 34.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 22.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 551,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27425%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27425%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.inviafertility.com/meet-the-staff",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/InVia+Fertility+Specialists+-+Hoffman+Estates,+1585+Barrington+Rd+%23406,+Hoffman+Estates,+IL+60169/@42.0542528,-88.1412748,2962a,13.1y/data=!4m2!3m1!1s0x880fa87033a1e303:0xaeb42297cc9c01cd",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-425-vishvanath-c-karande-md",
        "name": "Vishvanath C. Karande, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Dr.%20Karande%20Headshots-5.jpg?width=700&name=Dr.%20Karande%20Headshots-5.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Sigal Klipstein, MD",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Dr.%20Klipstein%20Headshots-5.jpg?width=295&height=443&name=Dr.%20Klipstein%20Headshots-5.jpg",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-425-sigal-klipstein-md"
      },
      {
        "name": "Elizabeth Puscheck, MD",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Dr.%20Puscheck%20Headshots-12.jpg?width=295&height=443&name=Dr.%20Puscheck%20Headshots-12.jpg",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-425-elizabeth-puscheck-md"
      },
      {
        "name": "Ha Luu, MD",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Dr.%20Luu%20Headshots-2.jpg?width=298&name=Dr.%20Luu%20Headshots-2.jpg",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-425-ha-luu-md"
      },
      {
        "name": "Lisa Shandley, MD",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Shandley.jpg?width=298&name=Shandley.jpg",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-425-lisa-shandley-md"
      }
    ],
    "website": "https://www.inviafertility.com",
    "description": "InVia Fertility Specialists provides IVF, IUI, egg freezing, and fertility testing across the Chicago suburbs with a focus on personalized treatment.",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://www.inviafertility.com/hs-fs/hubfs/IMG_4615.jpg?width=5472&height=3648&name=IMG_4615.jpg",
        "type": "interior",
        "caption": "InVia Fertility Hoffman Estates office",
        "_source": {
          "url": "https://www.inviafertility.com/contact-us/invia-fertility-hoffman-estates-il/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnSwBOKPLu0ML7hvUzZsucC9CH_gGBnheYhJ9Q0u6baC6hR5mgT0XbcNt0bxw0RSTH0G9fs4pqIlXs0SS9YSFEFhpBdKgc0q0yZUDlXTWJukxJ1Hli30n1i9NhVQ-TAHWaizBzkdntJ4n_7=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/InVia+Fertility+Specialists+-+Hoffman+Estates,+1585+Barrington+Rd+%23406,+Hoffman+Estates,+IL+60169/@42.0542528,-88.1412748,2962a,13.1y/data=!4m2!3m1!1s0x880fa87033a1e303:0xaeb42297cc9c01cd",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmYWc3OJsPr0v84KDoKa2rDOOOcA-qyoayNU-SGrqgPTaL3w_RiR9KHXZ02v2N-FpQ-eQbPc0xSdMM60MsKrJfuKzGyEWeD6YMzDrGd2479U5IWvdlxh1e1O_mu1CKNZ--JHFyNYBkBLown=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/InVia+Fertility+Specialists+-+Hoffman+Estates,+1585+Barrington+Rd+%23406,+Hoffman+Estates,+IL+60169/@42.0542528,-88.1412748,2962a,13.1y/data=!4m2!3m1!1s0x880fa87033a1e303:0xaeb42297cc9c01cd",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-17",
    "externalIds": {
      "cdcClinicId": "17",
      "googlePlaceId": "ChIJUQbWG7hXDogRbsv1y8-cEbk"
    },
    "type": "fertility-clinic",
    "name": "Pinnacle Fertility - Naperville",
    "phone": "(630) 357-6540",
    "address": {
      "line1": "3 N. Washington St",
      "city": "Naperville",
      "state": "IL",
      "zip": "60540",
      "country": "US"
    },
    "location": {
      "lat": 41.7754,
      "lng": -88.148
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 50.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 49.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 43.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 46.666666666666664,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/15"
        }
      ],
      "cyclesPerYear": 459,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2717%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2717%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/naperville-il/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Pinnacle+Fertility+IVF1+-+Naperville,+3+N+Washington+St,+Naperville,+IL+60540/@41.7752993,-88.1480983,2975a,13.1y/data=!4m2!3m1!1s0x880e57b81bd60651:0xb9119ccfcbf5cb6e",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "layer2-il-current-org-cdc-17",
      "date": "2026-06-13",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-17-randy-s-morris-md",
        "name": "Randy S. Morris, MD",
        "role": "Medical Director",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Randy-Morris_IVF1_Square-1024x1024.png",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/naperville-il/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.pinnaclefertility.com/location/naperville-il/",
    "description": "IVF1 specializes in affordable IVF and fertility treatments with a mini-IVF program in Naperville, Illinois.",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "bookingUrl": "https://www.pinnaclefertility.com/location/naperville-il/",
    "network": {
      "name": "Pinnacle Fertility"
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlbtmf0buJuFwF3EMN9vC8XHReL_HcuiaJENwjO-m2Zxk_KHXrYfP6AXvD2Eb2zf20vT1FZe7A2QAA3baubi65RKm7p4N1BjPHUIo5Y4XeR4VMKcX9zWCyJ-dtzp5s1z8sbUwFj5A=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Pinnacle+Fertility+IVF1+-+Naperville,+3+N+Washington+St,+Naperville,+IL+60540/@41.7752993,-88.1480983,2975a,13.1y/data=!4m2!3m1!1s0x880e57b81bd60651:0xb9119ccfcbf5cb6e",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm9vPg4bqcJxyNt7P3UqUxM5Cgg0z6AzGTzEJonzOVqsAi9BzdojQa9ZXHU4TZyU2_12vgmGJRmMrcO9K4K0pyizxULeTSEG_5qcNv7qXuKRefGbEE7JyIel70r2A3_5e30kAAO=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Pinnacle+Fertility+IVF1+-+Naperville,+3+N+Washington+St,+Naperville,+IL+60540/@41.7752993,-88.1480983,2975a,13.1y/data=!4m2!3m1!1s0x880e57b81bd60651:0xb9119ccfcbf5cb6e",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn6L4b47egneDF4mOKaKKfXBkLiU4vvHyn8EvUYAHYR_0-xM7qD1cfcAWFn703cT-QNUNmDq60-gAzzxPmE_AhZy_MyAzaqPdJX-S8OZjCcXt2EkP48vJMgobTPRWvRVZI-a4mC=w224-h298-k-no-pi0-ya60-ro0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Pinnacle+Fertility+IVF1+-+Naperville,+3+N+Washington+St,+Naperville,+IL+60540/@41.7752993,-88.1480983,2975a,13.1y/data=!4m2!3m1!1s0x880e57b81bd60651:0xb9119ccfcbf5cb6e",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-807",
    "externalIds": {
      "cdcClinicId": "807",
      "googlePlaceId": "ChIJ3xbAIcIsDogRGhrTVREgUV8"
    },
    "type": "fertility-clinic",
    "name": "Kindbody-Chicago West Loop",
    "description": "Part of Kindbody's 31-clinic national network offering full-spectrum reproductive care with a whole-person approach from fertility through menopause.",
    "website": "https://kindbody.com/location/west-loop-chicago/",
    "phone": "(773) 435-9036",
    "email": "navigator@kindbody.com",
    "bookingUrl": "https://kindbody.com/scheduling/location-select/fertility/",
    "address": {
      "line1": "333 S. Desplaines St, Suite 201",
      "city": "Chicago",
      "state": "IL",
      "zip": "60661",
      "country": "US"
    },
    "location": {
      "lat": 41.877,
      "lng": -87.6436
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "financingOptions": ["Payment plans", "Future Family", "PatientFi"],
      "carriers": [
        "Aetna",
        "Anthem",
        "Blue Cross Blue Shield",
        "Cigna",
        "Emblem Health",
        "Empire Blue Cross Blue Shield",
        "First Health",
        "Health Net",
        "Horizon",
        "Humana",
        "Maven",
        "Medicare",
        "Medicaid",
        "MultiPlan",
        "Optum",
        "Oscar",
        "Oxford",
        "Progyny",
        "Tricare",
        "United Healthcare"
      ],
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 59.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 51.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 35.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 20.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1508,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27807%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "languages": ["es"],
    "consultationTypes": ["in-person", "telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27807%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.kindbody.com/ivf-cost/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+Chicago+West+Loop,+333+S+Desplaines+St,+Chicago,+IL+60661/@41.8770213,-87.643546,2971a,13.1y/data=!4m2!3m1!1s0x880e2cc221c016df:0x5f51201155d31a1a",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped"
        },
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-807-angeline-beltsos-md",
        "name": "Angeline Beltsos, MD",
        "role": "Medical Director"
      }
    ],
    "network": {
      "name": "Kindbody"
    },
    "pricing": {
      "packages": [
        {
          "name": "Pulse Assessment",
          "description": "Quick fertility check — not covered by insurance",
          "price": 9900,
          "currency": "USD",
          "includes": [
            "AMH blood test",
            "Transvaginal ultrasound for follicle count",
            "15-minute reproductive consultation"
          ],
          "notes": "Not covered by insurance"
        },
        {
          "name": "Fertility Consultation",
          "description": "Specialist consultation on fertility fundamentals",
          "price": 30000,
          "currency": "USD",
          "notes": "Billable to most insurance plans"
        },
        {
          "name": "Male Consultation + Semen Analysis",
          "price": 52500,
          "currency": "USD",
          "includes": ["Consultation", "Venipuncture", "Semen analysis"]
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Single egg freezing cycle",
          "price": 690000,
          "priceMax": 966000,
          "currency": "USD",
          "includes": [
            "Stimulation visits",
            "Ultrasounds",
            "Blood draws",
            "Retrieval",
            "Cryopreservation",
            "3 months storage",
            "Coordination"
          ],
          "excludes": ["Medications ($4,000 - $6,000)", "Anesthesia"]
        },
        {
          "name": "Annual Egg Storage",
          "price": 92000,
          "currency": "USD",
          "notes": "Per year"
        },
        {
          "name": "IVF Freeze All (Self Pay)",
          "description": "IVF cycle with all embryos frozen",
          "price": 1160000,
          "priceMax": 1850000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Cryopreservation",
            "3 months storage"
          ],
          "excludes": [
            "Medications (~$4,000 - $6,000)",
            "Embryo biopsy/genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Donor services",
            "Anesthesia"
          ]
        },
        {
          "name": "IVF Fresh Transfer (Self Pay)",
          "description": "IVF cycle with fresh embryo transfer",
          "price": 1380000,
          "priceMax": 1875000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$5,000 - $9,000)",
            "Genetic testing",
            "Surplus embryo storage",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Freeze All",
          "price": 910000,
          "priceMax": 1332000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Cryopreservation",
            "3-month storage"
          ],
          "excludes": [
            "Genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Fresh Transfer",
          "price": 990000,
          "priceMax": 1428000,
          "currency": "USD",
          "includes": [
            "Ultrasounds",
            "Thaw",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Surplus storage",
            "Frozen transfers",
            "Anesthesia"
          ]
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 400000,
          "priceMax": 550000,
          "currency": "USD",
          "includes": ["Ultrasounds", "Thaw", "Assisted hatching", "Transfer"],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "PGT Package",
          "description": "Preimplantation genetic testing",
          "price": 160000,
          "priceMax": 300000,
          "currency": "USD",
          "includes": ["Embryo biopsy", "Lab management"],
          "excludes": ["Storage", "Shipping", "Per-embryo testing costs"]
        },
        {
          "name": "Nutrition Coaching",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Counseling & Support",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Guided Meditation",
          "description": "Virtual wellness — 30-minute session",
          "price": 9000,
          "currency": "USD"
        }
      ],
      "financingOptions": [
        {
          "name": "PatientFi monthly payments",
          "description": "PatientFi monthly payments"
        }
      ],
      "disclaimer": "Prices vary by location. Medications and anesthesia are not included in procedure costs. 3 months of storage included with freeze procedures; annual storage is $920.",
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Blue Cross Blue Shield, Cigna, Emblem Health, Empire Blue Cross Blue Shield, First Health, Health Net",
              "detail": "12 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "14 public price package(s) and 1 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkX6Euyq6CHN4vjIBqSW_l_i8LzxnzM7yFnwcbqSmus8ZNJunbCbimJ5P2ygbPeXWzJM0AZswAZBOoOi1_2eL2hEWf3zi7CJSnADG-4vPg8JXjl6aR0QT-OswrwzFBU87ktNpm-=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Chicago+West+Loop,+333+S+Desplaines+St,+Chicago,+IL+60661/@41.8770213,-87.643546,2971a,13.1y/data=!4m2!3m1!1s0x880e2cc221c016df:0x5f51201155d31a1a",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnDvFQT-xv98vlm9Jn0NPsaOa8CA9ELaBWBs_iWesOjdruXAKKq06lhsBy89iBAco3KG-pdazCJQwir8VCvOHQSZq39Fbtt1UcB-L9HdG2duUMc0calsdeGEiVVFKRyTVYw_jujrw=w224-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Chicago+West+Loop,+333+S+Desplaines+St,+Chicago,+IL+60661/@41.8770213,-87.643546,2971a,13.1y/data=!4m2!3m1!1s0x880e2cc221c016df:0x5f51201155d31a1a",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-261",
    "externalIds": {
      "cdcClinicId": "261",
      "googlePlaceId": "ChIJ_Xw_VvJgDogRTHF_yMdrCYc"
    },
    "type": "fertility-clinic",
    "name": "Kindbody-Crest Hill",
    "phone": "(815) 725-4161",
    "address": {
      "line1": "2246 Weber Rd",
      "city": "Crest Hill",
      "state": "IL",
      "zip": "60403",
      "country": "US"
    },
    "location": {
      "lat": 41.5628,
      "lng": -88.1206
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 39.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 102,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27261%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27261%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.kindbody.com/ivf-cost/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+Crest+Hill,+2246+Weber+Rd,+Crest+Hill,+IL+60403/@41.5628081,-88.1206106,2985a,13.1y/data=!4m2!3m1!1s0x880e60f2563f7cfd:0x87096bc7c87f714c",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-261-angie-beltsos-md",
        "name": "Angie Beltsos, MD",
        "role": "Medical Director"
      }
    ],
    "network": {
      "name": "Kindbody"
    },
    "website": "https://www.kindbody.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Anthem",
        "Blue Cross Blue Shield",
        "Cigna",
        "Emblem Health",
        "Empire Blue Cross Blue Shield",
        "First Health",
        "Health Net",
        "Horizon",
        "Humana",
        "Maven",
        "Medicare",
        "Medicaid",
        "MultiPlan",
        "Optum",
        "Oscar",
        "Oxford",
        "Progyny",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven"],
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "pricing": {
      "packages": [
        {
          "name": "Pulse Assessment",
          "description": "Quick fertility check — not covered by insurance",
          "price": 9900,
          "currency": "USD",
          "includes": [
            "AMH blood test",
            "Transvaginal ultrasound for follicle count",
            "15-minute reproductive consultation"
          ],
          "notes": "Not covered by insurance"
        },
        {
          "name": "Fertility Consultation",
          "description": "Specialist consultation on fertility fundamentals",
          "price": 30000,
          "currency": "USD",
          "notes": "Billable to most insurance plans"
        },
        {
          "name": "Male Consultation + Semen Analysis",
          "price": 52500,
          "currency": "USD",
          "includes": ["Consultation", "Venipuncture", "Semen analysis"]
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Single egg freezing cycle",
          "price": 690000,
          "priceMax": 966000,
          "currency": "USD",
          "includes": [
            "Stimulation visits",
            "Ultrasounds",
            "Blood draws",
            "Retrieval",
            "Cryopreservation",
            "3 months storage",
            "Coordination"
          ],
          "excludes": ["Medications ($4,000 - $6,000)", "Anesthesia"]
        },
        {
          "name": "Annual Egg Storage",
          "price": 92000,
          "currency": "USD",
          "notes": "Per year"
        },
        {
          "name": "IVF Freeze All (Self Pay)",
          "description": "IVF cycle with all embryos frozen",
          "price": 1160000,
          "priceMax": 1850000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Cryopreservation",
            "3 months storage"
          ],
          "excludes": [
            "Medications (~$4,000 - $6,000)",
            "Embryo biopsy/genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Donor services",
            "Anesthesia"
          ]
        },
        {
          "name": "IVF Fresh Transfer (Self Pay)",
          "description": "IVF cycle with fresh embryo transfer",
          "price": 1380000,
          "priceMax": 1875000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$5,000 - $9,000)",
            "Genetic testing",
            "Surplus embryo storage",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Freeze All",
          "price": 910000,
          "priceMax": 1332000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Cryopreservation",
            "3-month storage"
          ],
          "excludes": [
            "Genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Fresh Transfer",
          "price": 990000,
          "priceMax": 1428000,
          "currency": "USD",
          "includes": [
            "Ultrasounds",
            "Thaw",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Surplus storage",
            "Frozen transfers",
            "Anesthesia"
          ]
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 400000,
          "priceMax": 550000,
          "currency": "USD",
          "includes": ["Ultrasounds", "Thaw", "Assisted hatching", "Transfer"],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "PGT Package",
          "description": "Preimplantation genetic testing",
          "price": 160000,
          "priceMax": 300000,
          "currency": "USD",
          "includes": ["Embryo biopsy", "Lab management"],
          "excludes": ["Storage", "Shipping", "Per-embryo testing costs"]
        },
        {
          "name": "Nutrition Coaching",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Counseling & Support",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Guided Meditation",
          "description": "Virtual wellness — 30-minute session",
          "price": 9000,
          "currency": "USD"
        }
      ],
      "financingOptions": [
        {
          "name": "PatientFi monthly payments",
          "description": "PatientFi monthly payments"
        }
      ],
      "disclaimer": "Prices vary by location. Medications and anesthesia are not included in procedure costs. 3 months of storage included with freeze procedures; annual storage is $920.",
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Blue Cross Blue Shield, Cigna, Emblem Health, Empire Blue Cross Blue Shield, First Health, Health Net",
              "detail": "12 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "14 public price package(s) and 1 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlUdbt1acpC69gXZYsGL_uAjOuwoFtCoLGQ7N3SUtafpjUgI5E-YU9i7QsMq9SobuXUI2W1L9-6NfPjZ60VH-XTOz_30TEPfqzTbJv_rvmkj9RbTjtJBR7PyPdecNhIc6L3UzKt5w=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Crest+Hill,+2246+Weber+Rd,+Crest+Hill,+IL+60403/@41.5628081,-88.1206106,2985a,13.1y/data=!4m2!3m1!1s0x880e60f2563f7cfd:0x87096bc7c87f714c",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-391",
    "externalIds": {
      "cdcClinicId": "391"
    },
    "type": "fertility-clinic",
    "name": "Midwest Fertility Center",
    "phone": "(630) 810-0212",
    "address": {
      "line1": "4333 Main St",
      "city": "Downers Grove",
      "state": "IL",
      "zip": "60515",
      "country": "US"
    },
    "location": {
      "lat": 41.8082,
      "lng": -88.0108
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 23.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 28.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 105,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27391%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27391%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://mfcfamily.com/about/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-391-amos-e-madanes-md",
        "name": "Amos E. Madanes, MD",
        "role": "Medical Director",
        "imageUrl": "https://mfcfamily.com/wp-content/uploads/2024/05/dralmos.png",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://mfcfamily.com/meet-dr-amos-madanes/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Carlos Rotman, MD",
        "imageUrl": "https://mfcfamily.com/wp-content/uploads/2024/07/dr-carlos-rotman.jpg",
        "_source": {
          "url": "https://mfcfamily.com/about/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "practitionerId": "pr-org-cdc-391-carlos-rotman-md"
      },
      {
        "name": "Dr. Kansal",
        "imageUrl": "https://mfcfamily.com/wp-content/uploads/2024/08/Screenshot_3.png",
        "_source": {
          "url": "https://mfcfamily.com/about/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "practitionerId": "pr-org-cdc-391-dr-kansal"
      }
    ],
    "website": "https://www.midwestfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-520",
    "externalIds": {
      "cdcClinicId": "520"
    },
    "type": "fertility-clinic",
    "name": "North Shore Fertility",
    "phone": "(847) 763-8850",
    "address": {
      "line1": "5225 Old Orchard Rd, Suite 17",
      "city": "Skokie",
      "state": "IL",
      "zip": "60077",
      "country": "US"
    },
    "location": {
      "lat": 42.041,
      "lng": -87.7349
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 39,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 35.294117647058826,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/17"
        },
        {
          "ageBand": "38-40",
          "rate": 41.66666666666667,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/12"
        }
      ],
      "cyclesPerYear": 104,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27520%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27520%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-520-anne-borkowski-md",
        "name": "Anne Borkowski, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.northshorefertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-390",
    "externalIds": {
      "cdcClinicId": "390",
      "googlePlaceId": "ChIJQ-lk3aosDogRodDZ-QgBFj4"
    },
    "type": "fertility-clinic",
    "name": "Northwestern Fertility and Reproductive Medicine",
    "description": "Part of the #1 hospital in Illinois, with a pioneering oncofertility program and comprehensive fertility preservation services led by the Oncofertility Consortium.",
    "website": "https://fertility.nm.org",
    "phone": "(312) 695-1364",
    "bookingUrl": "https://fertility.nm.org/locations-and-appointments.html",
    "address": {
      "line1": "259 E. Erie St, Suite 2400",
      "city": "Chicago",
      "state": "IL",
      "zip": "60611",
      "country": "US"
    },
    "location": {
      "lat": 41.8939,
      "lng": -87.6208
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "financingOptions": ["Payment plans"]
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 49.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 50.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 42.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 29.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1587,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27390%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "consultationTypes": ["in-person"],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27390%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "scraped"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.nm.org/conditions-and-care-areas/womens-health/fertility-and-reproductive-medicine/meet-the-fertility-and-reproductive-medicine-team",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Northwestern+Medicine+Center+for+Fertility+and+Reproductive+Medicine+Chicago,+259+E+Erie+St+Suite+2400,+Chicago,+IL+60611/@41.893866,-87.620599,2970a,13.1y/data=!4m2!3m1!1s0x880e2caadd64e943:0x3e160108f9d9d0a1",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-390-mary-ellen-pavone-md",
        "name": "Mary Ellen Pavone, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.nm.org/image/doctor/NPI/1326192428.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.nm.org/conditions-and-care-areas/womens-health/fertility-and-reproductive-medicine/meet-the-fertility-and-reproductive-medicine-team",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Elnur Babayev, MD",
        "imageUrl": "https://www.nm.org/image/doctor/NPI/1184012759.jpg",
        "_source": {
          "url": "https://www.nm.org/conditions-and-care-areas/womens-health/fertility-and-reproductive-medicine/meet-the-fertility-and-reproductive-medicine-team",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-390-elnur-babayev-md"
      },
      {
        "name": "Lia Bernardi, MD",
        "imageUrl": "https://www.nm.org/image/doctor/NPI/1467784579.jpg",
        "_source": {
          "url": "https://www.nm.org/conditions-and-care-areas/womens-health/fertility-and-reproductive-medicine/meet-the-fertility-and-reproductive-medicine-team",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-390-lia-bernardi-md"
      },
      {
        "name": "Christina Boots, MD",
        "imageUrl": "https://www.nm.org/image/doctor/NPI/1760712863.jpg",
        "_source": {
          "url": "https://www.nm.org/conditions-and-care-areas/womens-health/fertility-and-reproductive-medicine/meet-the-fertility-and-reproductive-medicine-team",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-390-christina-boots-md"
      },
      {
        "name": "Eve Feinberg, MD",
        "imageUrl": "https://www.nm.org/image/doctor/NPI/1306907423.jpg",
        "_source": {
          "url": "https://www.nm.org/conditions-and-care-areas/womens-health/fertility-and-reproductive-medicine/meet-the-fertility-and-reproductive-medicine-team",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-390-eve-feinberg-md"
      },
      {
        "name": "Kara Goldman, MD",
        "imageUrl": "https://www.nm.org/image/doctor/NPI/1184870818.jpg",
        "_source": {
          "url": "https://www.nm.org/conditions-and-care-areas/womens-health/fertility-and-reproductive-medicine/meet-the-fertility-and-reproductive-medicine-team",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-390-kara-goldman-md"
      },
      {
        "name": "Tarun Jain, MD",
        "imageUrl": "https://www.nm.org/image/doctor/NPI/1932156809.jpg",
        "_source": {
          "url": "https://www.nm.org/conditions-and-care-areas/womens-health/fertility-and-reproductive-medicine/meet-the-fertility-and-reproductive-medicine-team",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-390-tarun-jain-md"
      }
    ],
    "languages": ["English", "Spanish"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnt8pF_a83J7CrmaDTZ0nHInCt0Z1etJnTJSyyplsvERBcNpI4SwLsgETnTpQutjuvNH8qILo4yQqVW9sKMsBs_T8q88Ghq7R43UAiHmSTd-Qd2YsqBUHPHlErP_QR4gwioYA0n_w=w504-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Northwestern+Medicine+Center+for+Fertility+and+Reproductive+Medicine+Chicago,+259+E+Erie+St+Suite+2400,+Chicago,+IL+60611/@41.893866,-87.620599,2970a,13.1y/data=!4m2!3m1!1s0x880e2caadd64e943:0x3e160108f9d9d0a1",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-14",
    "externalIds": {
      "cdcClinicId": "14"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Medicine Institute",
    "phone": "(630) 954-0094",
    "address": {
      "line1": "2425 W. 22nd St, Suite 102",
      "city": "Oak Brook",
      "state": "IL",
      "zip": "60523",
      "country": "US"
    },
    "location": {
      "lat": 41.8454,
      "lng": -87.9783
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 36.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 34.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 27.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 15.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 754,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2714%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2714%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.reproductivemedicineinstitute.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-14-elena-trukhacheva-md",
        "name": "Elena Trukhacheva, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.reproductivemedicineinstitute.com/wp-content/uploads/2024/08/elena-trukhacheva.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.reproductivemedicineinstitute.com/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Shweta Nayak, MD",
        "imageUrl": "https://www.reproductivemedicineinstitute.com/wp-content/uploads/2022/01/Shweta-Nayak-M.D.-FACOG-429x600.jpg",
        "_source": {
          "url": "https://www.reproductivemedicineinstitute.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-14-shweta-nayak-md"
      },
      {
        "name": "Amanda Schwartz, MD",
        "imageUrl": "https://www.reproductivemedicineinstitute.com/wp-content/uploads/2025/04/dr-amanda-schwartz-428x600.jpg",
        "_source": {
          "url": "https://www.reproductivemedicineinstitute.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-14-amanda-schwartz-md"
      },
      {
        "name": "Asima K. Ahmed, MD",
        "imageUrl": "https://www.reproductivemedicineinstitute.com/wp-content/uploads/2025/09/dr-asima-k-ahmed.png",
        "_source": {
          "url": "https://www.reproductivemedicineinstitute.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-14-asima-k-ahmed-md"
      }
    ],
    "website": "https://www.reproductivemedicineinstitute.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-174",
    "externalIds": {
      "cdcClinicId": "174",
      "googlePlaceId": "ChIJNyQvb9E5dYgRswTeDyRrGkg"
    },
    "type": "fertility-clinic",
    "name": "Southern Illinois University School of Medicine Fertility and IVF Center",
    "phone": "(217) 545-8000",
    "address": {
      "line1": "751 N. Rutledge St, Suite 0100",
      "city": "Springfield",
      "state": "IL",
      "zip": "62702",
      "country": "US"
    },
    "location": {
      "lat": 39.8094,
      "lng": -89.6582
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 61.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 58.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 127,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27174%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27174%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.siumed.edu/j-ricardo-loret-de-mola",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/SIU+Medicine+Fertility+and+IVF+Center,+751+N+Rutledge+St+Ste+0100,+Springfield,+IL+62702/@39.8093398,-89.6581226,3065a,13.1y/data=!4m2!3m1!1s0x887539d16f2f2437:0x481a6b240fde04b3",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-174-j-ricardo-loret-de-mola-md",
        "name": "J. Ricardo Loret de Mola, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.siumed.edu/sites/default/files/styles/square_540/public/faculty/loret_de_molar_0026.jpg?h=85eca17e&itok=zWt2OtFM",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.siumed.edu/j-ricardo-loret-de-mola",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Rebecca Wangard",
        "imageUrl": "https://www.siumed.edu/sites/default/files/styles/square_540/public/faculty/wangard_rebecca_web.jpg?h=85eca17e&itok=osixakBr",
        "_source": {
          "url": "https://www.siumed.edu/buildings/moy-outpatient-clinics/fertility-ivf-clinic-springfield",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "practitionerId": "pr-org-cdc-174-rebecca-wangard"
      }
    ],
    "website": "https://www.siumed.edu/ob-gyn/fertility-ivf",
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Blue Cross Blue Shield of Illinois"
      ]
    },
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Blue Cross Blue Shield of Illinois",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWklnn9POqOSiHgt2tWKphsG_SGmcw1urJ4H9E4I1gr9ibBhiysBr9LvHSCzNfW5r322dNmuCTS__l-vitrAhJgEwPu1LCSvmiRo80yw2SyHYbq4OOYeXrxX5_dq8hWNFfc41qkR5_v7W8ob=w426-h240-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/SIU+Medicine+Fertility+and+IVF+Center,+751+N+Rutledge+St+Ste+0100,+Springfield,+IL+62702/@39.8093398,-89.6581226,3065a,13.1y/data=!4m2!3m1!1s0x887539d16f2f2437:0x481a6b240fde04b3",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-173",
    "externalIds": {
      "cdcClinicId": "173",
      "googlePlaceId": "ChIJbS0tpO5XDogRw0-UVPrW7cI"
    },
    "type": "fertility-clinic",
    "name": "CCRM Fertility of Naperville",
    "phone": "(331) 213-7100",
    "address": {
      "line1": "120 Pam Davis Drive, Suite 100",
      "city": "Naperville",
      "state": "IL",
      "zip": "60540",
      "country": "US"
    },
    "location": {
      "lat": 41.7597272,
      "lng": -88.1519252
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 61,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 41.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 35,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 14.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 444,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27173%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27173%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/illinois/chicago/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+%26+Gynecologic+Surgeons+of+Illinois,+120+Pam+Davis+Dr+Ste+100,+Naperville,+IL+60540/@41.7598428,-88.1523944,2976a,13.1y/data=!4m2!3m1!1s0x880e57eea42d2d6d:0xc2edd6fa54944fc3",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "layer2-il-current-org-cdc-173",
      "date": "2026-06-13",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-173-charles-e-miller-md",
        "name": "Charles E. Miller, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Charles_E_Miller_600x600_2x-rdhmuwe9yylkjbdbvglys7cljz0u3ez8dpj44wkiao.png",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/illinois/chicago/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Amanda Adeleye, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Amanda_Adeleye_600x600_2x-r9yqqsnnw22ee985nmumemb774ie72ixbd8w2lccyo.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/illinois/chicago/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-173-amanda-adeleye-md"
      },
      {
        "name": "Victoria Wesevich, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Victoria_Wesevich_600x600_2x-r9yppjbyzh286pci81202isfia5m2zlyiyb08ql5ls.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/illinois/chicago/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-173-victoria-wesevich-md"
      },
      {
        "name": "Laurence Jacobs, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Laurence-Jacobs-rmgnsl3mp3i99yyogmszufkzy3fs9bgc9o6riwd9k0.png",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/illinois/chicago/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-173-laurence-jacobs-md"
      },
      {
        "name": "Mary McKenna, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Mary_McKenna_600x600_2x-rbxsvvb7nmjiaywcsdesc94dnth0hfn7lrfppi0wbk.png",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/illinois/chicago/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-173-mary-mckenna-md"
      },
      {
        "name": "Kelly Ryan, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Kelly_Ryan_600x600_2x-rcv0ekz62pampwrlxlchj30z2r4umbcnvm2e1e3grk.png",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/illinois/chicago/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-173-kelly-ryan-md"
      }
    ],
    "website": "https://www.ccrmivf.com/location/us/illinois/naperville/",
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Blue Cross Blue Shield of Illinois"
      ]
    },
    "setting": "network-group",
    "bookingUrl": "https://www.ccrmivf.com/location/us/illinois/naperville/",
    "network": {
      "name": "CCRM Fertility"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Blue Cross Blue Shield of Illinois",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-119",
    "externalIds": {
      "cdcClinicId": "119"
    },
    "type": "fertility-clinic",
    "name": "University of Chicago Medicine Center for Reproductive Medicine and Fertility",
    "phone": "(773) 702-6642",
    "address": {
      "line1": "1101 S. Canal St, Suite 202A",
      "city": "Chicago",
      "state": "IL",
      "zip": "60607",
      "country": "US"
    },
    "location": {
      "lat": 41.8675,
      "lng": -87.6389
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 51.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 36.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 22.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 188,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27119%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27119%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.uchicagomedicine.org/find-a-physician/physician/a-musa-zamah",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-119-a-musa-zamah-md-phd",
        "name": "A. Musa Zamah, MD, PHD",
        "role": "Medical Director",
        "imageUrl": "https://www.uchicagomedicine.org/_next/image?url=https%3A%2F%2Fedge.sitecorecloud.io%2Funichicagomc-81nbqnb3%2Fmedia%2Fimages%2Fucmc%2Fphysician-photos%2Fv-z%2Fzamah_a_musa_261x347.jpg%3Fsc_lang%3Den&w=3840&q=75",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.uchicagomedicine.org/find-a-physician/physician/a-musa-zamah",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.uchicagomedicine.org/conditions-services/reproductive-endocrinology",
    "description": "The University of Chicago Medicine Center for Reproductive Medicine offers advanced fertility care including IVF, genetic testing, and fertility preservation.",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Humana",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "images": [
      {
        "url": "https://www.uchicagomedicine.org/_next/image?url=https%3A%2F%2Fedge.sitecorecloud.io%2Funichicagomc-81nbqnb3%2Fmedia%2Fimages%2Fucmc%2Flocations%2Fsouth-loop-location-666x412.jpg&w=3840&q=75",
        "type": "exterior",
        "caption": "UChicago Medicine South Loop location",
        "_source": {
          "url": "https://www.uchicagomedicine.org/find-a-location/uchicago-medicine-south-loop",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Humana, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-26",
    "externalIds": {
      "cdcClinicId": "26"
    },
    "type": "fertility-clinic",
    "name": "University of Illinois at Chicago IVF Program",
    "phone": "(312) 355-2634",
    "address": {
      "line1": "1801 W. Taylor St, Suite 4A",
      "city": "Chicago",
      "state": "IL",
      "zip": "60612",
      "country": "US"
    },
    "location": {
      "lat": 41.8695,
      "lng": -87.6718
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "35-37",
          "rate": 26.31578947368421,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/19"
        }
      ],
      "cyclesPerYear": 51,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2726%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2726%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-26-frank-gonzalez-md",
        "name": "Frank Gonzalez, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://hospital.uillinois.edu/primary-and-specialty-care/fertility-and-reproductive-health",
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Blue Cross Blue Shield of Illinois"
      ]
    },
    "setting": "hospital-based",
    "images": [
      {
        "url": "https://hospital.uillinois.edu/images/Locations/Outpatient%20Care%20Center/OCCLocation.jpg",
        "type": "exterior",
        "caption": "UI Health Outpatient Care Center",
        "_source": {
          "url": "https://hospital.uillinois.edu/patients-and-visitors/locations/outpatient-care-center",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Blue Cross Blue Shield of Illinois",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-116",
    "externalIds": {
      "cdcClinicId": "116",
      "googlePlaceId": "ChIJQcPQoLisFIgRT2gZmS_QRyI"
    },
    "type": "fertility-clinic",
    "name": "Advanced Fertility Group",
    "phone": "(317) 817-1300",
    "address": {
      "line1": "7830 McFarland Blvd",
      "city": "Indianapolis",
      "state": "IN",
      "zip": "46237",
      "country": "US"
    },
    "location": {
      "lat": 39.9315,
      "lng": -86.1539
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 57.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "0/8"
        }
      ],
      "cyclesPerYear": 48,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27116%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://advancedfertilitygroup.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27116%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://advancedfertilitygroup.com/our-physician/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://advancedfertilitygroup.com/about/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Advanced+Fertility+Group,+7830+McFarland+Blvd,+Indianapolis,+IN+46237/@39.6534867,-86.0831928,3072a,13.1y/data=!4m2!3m1!1s0x8814acb8a0d0c341:0x2247d02f9919684f",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://advancedfertilitygroup.com/contact/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "searched-absent",
          "source": {
            "url": "https://advancedfertilitygroup.com/new-patients/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-116-william-l-gentry-md-facog",
        "name": "William L. Gentry, MD, FACOG",
        "role": "Owner and Founder",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://advancedfertilitygroup.com/wp-content/uploads/2023/05/Dr-William-Gentry.jpg",
        "_source": {
          "url": "https://advancedfertilitygroup.com/our-physician/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://advancedfertilitygroup.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "description": "Advanced Fertility Group is an Indianapolis fertility practice led by William Gentry, MD, FACOG, offering IVF, donor programs, fertility evaluation, surgery and related fertility services.",
    "images": [
      {
        "url": "https://advancedfertilitygroup.com/wp-content/uploads/2023/05/AFG_Office.jpg",
        "type": "interior",
        "caption": "Advanced Fertility Group exam room",
        "_source": {
          "url": "https://advancedfertilitygroup.com/about/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Indiana (IN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-514",
    "externalIds": {
      "cdcClinicId": "514",
      "googlePlaceId": "ChIJjxZWmpYsbogRVC8DGJJedU8"
    },
    "type": "fertility-clinic",
    "name": "Boston IVF at The Women's Hospital",
    "phone": "(812) 842-4530",
    "address": {
      "line1": "4199 Gateway Blvd, Suite 2600",
      "city": "Newburgh",
      "state": "IN",
      "zip": "47630",
      "country": "US"
    },
    "location": {
      "lat": 37.9739,
      "lng": -87.4475
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 48.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "9/18"
        }
      ],
      "cyclesPerYear": 286,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27514%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.bostonivf.com/locations/boston-ivf-at-the-women-s-hospital/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27514%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.bostonivf.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.deaconess.com/indiana-the-womens-hospital/womens-services/fertility-care/about-us",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/locations/boston-ivf-at-the-women-s-hospital/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Boston+IVF+at+The+Women's+Hospital,+4199+Gateway+Blvd,+Newburgh,+IN+47630/@37.973798,-87.447513,3145a,13.1y/data=!4m2!3m1!1s0x886e2c969a56168f:0x4f755e9218032f54",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.bostonivf.com/locations/boston-ivf-at-the-women-s-hospital/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "searched-absent",
          "source": {
            "url": "https://www.bostonivf.com/locations/boston-ivf-at-the-women-s-hospital/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-514-daniel-w-griffin-md",
        "name": "Daniel W. Griffin, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://deaconess-prd-web.azurewebsites.net/getmedia/206a1754-0230-4abd-80a2-070c6cbdebd8/Griffin_Daniel.jpg?width=690&height=690&ext=.jpg",
        "_source": {
          "url": "https://www.deaconess.com/find-a-doctor/doctor-detail?id=DanielGriffin_MD",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-514-stephanie-green-acnp-bc",
        "name": "Stephanie Green, ACNP-BC",
        "role": "Advanced Practice Nurse",
        "credentials": ["ACNP-BC"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://deaconess-prd-web.azurewebsites.net/getmedia/8f32d985-34f8-4aed-92a5-396f22aa61df/TWH_Green-Stephanie-350x350.jpg?width=350&height=350&ext=.jpg",
        "_source": {
          "url": "https://www.deaconess.com/indiana-the-womens-hospital/womens-services/fertility-care/about-us",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "network": {
      "name": "Boston IVF"
    },
    "website": "https://www.bostonivf.com/locations/boston-ivf-at-the-women-s-hospital/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield of Massachusetts",
        "Blue Cross Blue Shield of Rhode Island",
        "Blue Cross Blue Shield PPO (out-of-state)",
        "Carelink",
        "Carrot",
        "CDPHP",
        "Cigna",
        "Cofertility/EggCo",
        "Emblem Health",
        "Excellus Blue Cross Blue Shield",
        "Empire Blue Cross Blue Shield",
        "GHI",
        "GIC Indemnity",
        "Harvard Pilgrim",
        "Health New England",
        "Highmark Blue Shield of Northeastern NY",
        "Highmark Blue Cross Federal",
        "Maine Community Health Options",
        "Mass General Brigham Health Plan",
        "Maven",
        "NYS Empire Plan",
        "PHCS",
        "Progyny",
        "Stork Club",
        "Tricare",
        "Tufts Health Direct",
        "Unicare",
        "United Healthcare",
        "WellSense Health Plan",
        "WIN Fertility/Premier"
      ],
      "employeeBenefits": ["Progyny"],
      "_source": {
        "url": "https://www.bostonivf.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "description": "Boston IVF at The Women's Hospital is a full-service IVF center in Newburgh offering IVF, IUI, egg freezing, genetic testing, donor programs and fertility monitoring through the Boston IVF and Deaconess partnership.",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm2pFdFOi8MsUF427EezG4uUyokBmCE9Yo0lQMEYZ-UDcAmpABZFePOr7cqVmvvdbPt9gZn-eAymu0uqvcO_8m3-E-1QWRJjd1vkDDvbe2nydF4yclqEbBVmvBelx9rbeX8q9otjQ=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Boston+IVF+at+The+Women's+Hospital,+4199+Gateway+Blvd,+Newburgh,+IN+47630/@37.973798,-87.447513,3145a,13.1y/data=!4m2!3m1!1s0x886e2c969a56168f:0x4f755e9218032f54",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield of Massachusetts, Blue Cross Blue Shield of Rhode Island, Blue Cross Blue Shield PPO (out-of-state), Carelink, Carrot, CDPHP, Cigna",
              "detail": "23 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.bostonivf.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Indiana (IN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-72",
    "externalIds": {
      "cdcClinicId": "72",
      "googlePlaceId": "ChIJm3mzWsRMa4gR4S8wcMzOX4Q"
    },
    "type": "fertility-clinic",
    "name": "Community Fertility Specialty Care",
    "phone": "(317) 621-0600",
    "address": {
      "line1": "7250 Clearvista Dr, Suite 190",
      "city": "Indianapolis",
      "state": "IN",
      "zip": "46256",
      "country": "US"
    },
    "location": {
      "lat": 39.9003,
      "lng": -86.0399
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 42.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 66.66666666666666,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "8/12"
        }
      ],
      "cyclesPerYear": 80,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2772%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.ecommunity.com/locations/community-fertility-specialty-care",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2772%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.elanzawellness.com/fertilitydoctors/david-e.-carnovale%2C-md",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Community+Fertility+Care:+David+E.+Carnovale,+MD,+7250+Clearvista+Dr+%23190,+Indianapolis,+IN+46256/@39.9003186,-86.0399155,3061a,13.1y/data=!4m2!3m1!1s0x886b4cc45ab3799b:0x845fcecc70302fe1",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.fertyguide.com/en/facility/2022/72",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "searched-absent",
          "source": {
            "url": "https://www.ecommunity.com/locations/community-fertility-specialty-care",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-72-david-e-carnovale-md",
        "name": "David E. Carnovale, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.elanzawellness.com/fertilitydoctors/david-e.-carnovale%2C-md",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.ecommunity.com/fertility",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Indiana (IN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-352",
    "externalIds": {
      "cdcClinicId": "352",
      "googlePlaceId": "ChIJ4bhhyM1Ma4gRNvtooLoP6l4"
    },
    "type": "fertility-clinic",
    "name": "Family Beginnings IVF",
    "phone": "(317) 595-3665",
    "address": {
      "line1": "8435 Clearvista Place, Suite 104",
      "city": "Indianapolis",
      "state": "IN",
      "zip": "46256",
      "country": "US"
    },
    "location": {
      "lat": 39.9099,
      "lng": -86.0409
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 34.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 78,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27352%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://ivf-indiana.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27352%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://ivf-indiana.com/the-team/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://ivf-indiana.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://ivf-indiana.com/contact-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Family+Beginnings,+PC,+8435+Clearvista+Pl+%23104,+Indianapolis,+IN+46256/@39.909952,-86.0410169,3060a,13.1y/data=!4m2!3m1!1s0x886b4ccdc861b8e1:0x5eea0fbaa068fb36",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://ivf-indiana.com/contact-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "searched-absent",
          "source": {
            "url": "https://ivf-indiana.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-352-james-g-donahue-md-hcld",
        "name": "James G. Donahue, MD, HCLD",
        "role": "Medical Director",
        "credentials": ["MD", "HCLD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://ivf-indiana.com/wp-content/uploads/2019/08/donahue_3.jpg",
        "_source": {
          "url": "https://ivf-indiana.com/the-team/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://ivf-indiana.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "description": "Family Beginnings IVF is an Indianapolis fertility practice offering fertility evaluation, IVF, INVOcell, IUI, donor services, genetic testing, cryopreservation and counseling.",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkEydOSpEG0Zh9cB-S_dVHcRpHcvjEd1Vk3z6WSLgzL0nz0KcWCO_CYp6zLykxbyrH1DOAzLH8IzCmjiLGFTdqTyZtVt2t8dJaZ_veziYVIKnEHEhQce75HC-vE3gzXlznrgP1Y=w408-h240-k-no-pi-10-ya356.28558-ro-0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Family+Beginnings,+PC,+8435+Clearvista+Pl+%23104,+Indianapolis,+IN+46256/@39.909952,-86.0410169,3060a,13.1y/data=!4m2!3m1!1s0x886b4ccdc861b8e1:0x5eea0fbaa068fb36",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "schedule": {
      "mon": {
        "open": "08:30",
        "close": "16:30"
      },
      "tue": {
        "open": "08:30",
        "close": "16:30"
      },
      "wed": {
        "open": "08:30",
        "close": "16:30"
      },
      "thu": {
        "open": "08:30",
        "close": "16:30"
      },
      "fri": {
        "open": "08:30",
        "close": "16:30"
      }
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Indiana (IN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-464",
    "externalIds": {
      "cdcClinicId": "464",
      "googlePlaceId": "ChIJQcPQoLisFIgRyHr8dHszGNM"
    },
    "type": "fertility-clinic",
    "name": "Henry Fertility",
    "phone": "(317) 817-1800",
    "address": {
      "line1": "201 Pennsylvania Parkway, Suite 205",
      "city": "Carmel",
      "state": "IN",
      "zip": "46280",
      "country": "US"
    },
    "location": {
      "lat": 39.9315,
      "lng": -86.1539
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 58.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "9/18"
        }
      ],
      "cyclesPerYear": 129,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27464%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://henryfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27464%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://henryfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://henryfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://henryfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Henry+Fertility,+201+Pennsylvania+Pkwy+%23205,+Indianapolis,+IN+46280/@39.9315132,-86.1539337,3059a,13.1y/data=!4m2!3m1!1s0x8814acb8a0d0c341:0xd318337b74fc7ac8",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://henryfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "scraped",
          "source": {
            "url": "https://henryfertility.com/wp-content/uploads/2025/05/OM-AGENCY-FORMS.pdf",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-464-michael-a-henry-md",
        "name": "Michael A. Henry, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://henryfertility.com/wp-content/uploads/2025/05/Dr.-H-Grey-light.jpg",
        "_source": {
          "url": "https://henryfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://henryfertility.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "description": "Henry Fertility is a Carmel fertility clinic led by Michael A. Henry, MD, providing reproductive endocrinology and infertility care, IVF lab services and outside monitoring through Reproductive Services of Indiana.",
    "images": [],
    "schedule": {
      "mon": {
        "open": "09:00",
        "close": "16:00"
      },
      "tue": {
        "open": "09:00",
        "close": "16:00"
      },
      "wed": {
        "open": "09:00",
        "close": "12:00"
      },
      "thu": {
        "open": "09:00",
        "close": "16:00"
      },
      "fri": {
        "open": "09:00",
        "close": "12:00"
      }
    },
    "pricing": {
      "packages": [
        {
          "name": "Baseline Ultrasound - CPT 76830",
          "price": 45000,
          "currency": "USD",
          "notes": "Outside monitoring service"
        },
        {
          "name": "Follicle Ultrasound - CPT 76857",
          "price": 37500,
          "currency": "USD",
          "notes": "Outside monitoring service"
        },
        {
          "name": "Viability Ultrasound - CPT 76817",
          "price": 52500,
          "currency": "USD",
          "notes": "Rendered by MD to 10 weeks gestation only"
        },
        {
          "name": "SIS or Sonohystogram - CPT 76831/58340",
          "price": 95000,
          "currency": "USD",
          "notes": "Outside monitoring service"
        },
        {
          "name": "Estradiol Blood Test - CPT 82670",
          "price": 14500,
          "currency": "USD",
          "notes": "Outside monitoring service"
        },
        {
          "name": "Venipuncture Fee - CPT 36415",
          "price": 3000,
          "currency": "USD",
          "notes": "May apply to LabCorp processing"
        },
        {
          "name": "Progesterone - CPT 84144",
          "price": 14500,
          "currency": "USD",
          "notes": "LabCorp processing; venipuncture fee may apply"
        },
        {
          "name": "FSH - CPT 83001",
          "price": 14500,
          "currency": "USD",
          "notes": "LabCorp processing; venipuncture fee may apply"
        },
        {
          "name": "LH - CPT 83002",
          "price": 14500,
          "currency": "USD",
          "notes": "LabCorp processing; venipuncture fee may apply"
        },
        {
          "name": "TSH - CPT 83003",
          "price": 14500,
          "currency": "USD",
          "notes": "LabCorp processing; venipuncture fee may apply"
        },
        {
          "name": "AMH - CPT 82397",
          "price": 14500,
          "currency": "USD",
          "notes": "LabCorp processing; venipuncture fee may apply"
        },
        {
          "name": "QuantBhcg - CPT 84702",
          "price": 14500,
          "currency": "USD",
          "notes": "LabCorp processing; venipuncture fee may apply"
        },
        {
          "name": "Prolactin - CPT 84146",
          "price": 14500,
          "currency": "USD",
          "notes": "LabCorp processing; venipuncture fee may apply"
        }
      ],
      "disclaimer": "Outside monitoring pricing only. Henry Fertility requires 24 hours notice, does not accept walk-ins, and does not accept insurance for outside monitoring patients.",
      "_source": {
        "url": "https://henryfertility.com/wp-content/uploads/2025/05/OM-AGENCY-FORMS.pdf",
        "fetchedAt": "2026-06-13"
      }
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "13 public price package(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://henryfertility.com/wp-content/uploads/2025/05/OM-AGENCY-FORMS.pdf",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Indiana (IN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-704",
    "externalIds": {
      "cdcClinicId": "704",
      "googlePlaceId": "ChIJwQmXlZSsFIgRWpZjUPhApC0"
    },
    "type": "fertility-clinic",
    "name": "Indiana Fertility Institute",
    "phone": "(317) 575-6565",
    "address": {
      "line1": "10610 North Pennsylvania Street, #101",
      "city": "Carmel",
      "state": "IN",
      "zip": "46280",
      "country": "US"
    },
    "location": {
      "lat": 39.9423,
      "lng": -86.1562
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 38.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 34.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 33.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 453,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27704%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.fertilityindy.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27704%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilityindy.com/fertility-specialists",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilityindy.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Indiana+Fertility+Institute,+10610+N+Pennsylvania+St+%23101,+Carmel,+IN+46280/@39.942327,-86.1561784,3059a,13.1y/data=!4m2!3m1!1s0x8814ac94959709c1:0x2da440f85063965a",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.fertilityindy.com/fertility-specialists",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "searched-absent",
          "source": {
            "url": "https://www.fertilityindy.com/fertility-costs",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-704-john-c-jarrett-ii-md",
        "name": "John C. Jarrett II, MD",
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn.buttercms.com/zSXclE0oQiuEmqWgl5bX",
        "_source": {
          "url": "https://www.fertilityindy.com/fertility-specialists/john-jarrett",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-704-meredith-provost-md-phd",
        "name": "Meredith Provost, MD, PhD",
        "role": "Fertility Specialist",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn.buttercms.com/d507Fk5fRcKmjhb8Hjsc",
        "_source": {
          "url": "https://www.fertilityindy.com/fertility-specialists/meredith-provost",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-704-christine-e-hur-md",
        "name": "Christine E. Hur, MD",
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn.buttercms.com/POEh9HkfTuuqQ1ZnjFtw",
        "_source": {
          "url": "https://www.fertilityindy.com/fertility-specialists/christine-e-hur",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.fertilityindy.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "description": "Indiana Fertility Institute is a Carmel fertility clinic offering IVF, IUI, egg and sperm freezing, oncofertility, donor egg, surrogacy, male fertility, PGT, ICSI, reproductive surgery and LGBTQ+ family-building services.",
    "network": {
      "name": "Prelude Network"
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmEEL2t5PjLjGHMhGiWaeEO74MkPatt29HBCLVcZroRZok6bZPrV9ZuggehAvX_2eem2wzCfLbl7VJSw640jY9q8am1KrDdcNzUViJcuhsst2ZU_ODi4QlCec8dqa2FZTnL-uCb=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Indiana+Fertility+Institute,+10610+N+Pennsylvania+St+%23101,+Carmel,+IN+46280/@39.942327,-86.1561784,3059a,13.1y/data=!4m2!3m1!1s0x8814ac94959709c1:0x2da440f85063965a",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Indiana (IN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-373",
    "externalIds": {
      "cdcClinicId": "373",
      "googlePlaceId": "ChIJ40txYWasFIgR4rlqteY9iG4"
    },
    "type": "fertility-clinic",
    "name": "Midwest Fertility - Carmel",
    "phone": "(317) 571-1637",
    "address": {
      "line1": "12188-A N. Meridian St, Suite 250",
      "city": "Carmel",
      "state": "IN",
      "zip": "46032",
      "country": "US"
    },
    "location": {
      "lat": 39.967,
      "lng": -86.1588
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 46.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 39.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 51.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 30.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 717,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27373%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.midwestfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27373%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.midwestfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://www.midwestfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Midwest+Fertility+Specialists,+12188A+N+Meridian+St+Ste+250,+Carmel,+IN+46032/@39.9668093,-86.1587228,3058a,13.1y/data=!4m2!3m1!1s0x8814ac6661714be3:0x6e883de6b56ab9e2",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.midwestfertility.com/contact/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "searched-absent",
          "source": {
            "url": "https://www.midwestfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-373-bradford-bopp-md",
        "name": "Bradford Bopp, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.midwestfertility.com/wp-content/uploads/2023/10/boppsquare.jpg",
        "_source": {
          "url": "https://www.midwestfertility.com/indianapolis-fertility-clinic/bradford-bopp-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-373-matthew-a-will-md",
        "name": "Matthew A. Will, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.midwestfertility.com/wp-content/uploads/2023/10/willsquare2.jpg",
        "_source": {
          "url": "https://www.midwestfertility.com/indianapolis-fertility-clinic/matthew-will-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-373-erica-anspach-will-md",
        "name": "Erica Anspach Will, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.midwestfertility.com/wp-content/uploads/2023/10/ericasquare.jpg",
        "_source": {
          "url": "https://www.midwestfertility.com/indianapolis-fertility-clinic/erica-anspach-will-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-373-kate-o-leary-md",
        "name": "Kate O'Leary, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.midwestfertility.com/wp-content/uploads/2023/10/olearysquare2.jpg",
        "_source": {
          "url": "https://www.midwestfertility.com/indianapolis-fertility-clinic/kate-oleary-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-373-thomas-lorenc-md-facog",
        "name": "Thomas Lorenc, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.midwestfertility.com/wp-content/uploads/2024/10/lorencsquarewhitebckground.png",
        "_source": {
          "url": "https://www.midwestfertility.com/indianapolis-fertility-clinic/thomas-lorenc-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-373-maria-antero-md",
        "name": "Maria Antero, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.midwestfertility.com/wp-content/uploads/2025/07/Untitled-1.png",
        "_source": {
          "url": "https://www.midwestfertility.com/indianapolis-fertility-clinic/maria-antero-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-373-margaret-johns-pa-c",
        "name": "Margaret Johns, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "specialty": "Physician Assistant",
        "imageUrl": "https://www.midwestfertility.com/wp-content/uploads/2023/10/maggiesquare.jpg",
        "_source": {
          "url": "https://www.midwestfertility.com/indianapolis-fertility-clinic/margaret-johns-pa-c/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.midwestfertility.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "description": "Midwest Fertility is an Axia/Ovation fertility practice offering IVF, IUI, egg freezing, donor programs, LGBTQIA+ family building, PGT and third-party reproduction at its Carmel and Fort Wayne locations.",
    "network": {
      "name": "US Fertility"
    },
    "images": [
      {
        "url": "https://cdn.axiawh.com/wp-content/uploads/2023/03/08154547/Midwest-Fertility-Carmel-Exterior.jpg",
        "type": "exterior",
        "caption": "Midwest Fertility Carmel exterior",
        "_source": {
          "url": "https://axiawh.com/locations/midwest-fertility-carmel/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl7slkIMnCvKMFrYHj7iC86ArDa6uGzCjmFwC0tSjRBZ3Vhac6eFwpnpPV1DrWLTHMYgWF97YR7lJ431_4ftYaT7rKai0HpIFx8LBVGNINzE7PfihNLCk-ayxvc-2sonF_UqkcnYA=w510-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Midwest+Fertility+Specialists,+12188A+N+Meridian+St+Ste+250,+Carmel,+IN+46032/@39.9668093,-86.1587228,3058a,13.1y/data=!4m2!3m1!1s0x8814ac6661714be3:0x6e883de6b56ab9e2",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Indiana (IN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-803",
    "externalIds": {
      "cdcClinicId": "803"
    },
    "type": "fertility-clinic",
    "name": "Blue Sky Fertility - Overland Park South",
    "phone": "(913) 218-0162",
    "address": {
      "line1": "14253 Metcalf Ave",
      "city": "Overland Park",
      "state": "KS",
      "zip": "66223",
      "country": "US"
    },
    "location": {
      "lat": 38.8701952,
      "lng": -94.6677265
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art",
        "_source": {
          "url": "https://blueskyfertility.com/about",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://blueskyfertility.com/about",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://blueskyfertility.com/about",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Donor egg and donor sperm",
        "category": "art",
        "_source": {
          "url": "https://blueskyfertility.com/about",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 61.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 51.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 70,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 230,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27803%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://blueskyfertility.com/contact",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27803%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://blueskyfertility.com/about",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://blueskyfertility.com/about",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://blueskyfertility.com/contact",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://blueskyfertility.com/about",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://blueskyfertility.com/contact",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-803-ryan-m-riggs-md",
        "name": "Ryan M. Riggs, MD",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "role": "Medical Director",
        "imageUrl": "https://static.showit.co/800/loLesIXqlodbSPND4VLA4Q/shared/dr-ryan-riggs-medical-director-founder-1.jpg",
        "_source": {
          "url": "https://blueskyfertility.com/about",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-803-kelly-mosher",
        "name": "Kelly Mosher",
        "specialty": "Obstetrics and Gynecology",
        "role": "OB/GYN",
        "imageUrl": "https://static.showit.co/400/pZrpGqLg_JAY6xcFVKcELA/shared/dr-kelly-mosher-ob-gyn-1.jpg",
        "_source": {
          "url": "https://blueskyfertility.com/about",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-803-jennifer-riggs",
        "name": "Jennifer Riggs",
        "specialty": "Nurse Practitioner",
        "role": "Nurse Practitioner",
        "imageUrl": "https://static.showit.co/400/3sqlsDIqlnpTAjQY_oACRQ/shared/jennifer-riggs-nurse-practitioner-1.jpg",
        "_source": {
          "url": "https://blueskyfertility.com/about",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-803-aubrey-fraley-np",
        "name": "Aubrey Fraley, NP",
        "credentials": ["NP"],
        "specialty": "Nurse Practitioner",
        "role": "Nurse Practitioner, Third Party Coordinator",
        "imageUrl": "https://static.showit.co/400/7AWMtOOlcQO3q1ewxvY6gQ/shared/aubrey-fraley-nurse-practitioner-1.jpg",
        "_source": {
          "url": "https://blueskyfertility.com/donor-egg-sperm-family-building/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-803-riley-bailie-np",
        "name": "Riley Bailie, NP",
        "credentials": ["NP"],
        "specialty": "Nurse Practitioner",
        "role": "Nurse Practitioner",
        "imageUrl": "https://static.showit.co/400/y_FCEtH1Sx6lQXdJgYVEYw/298207/riley-nurse-practitioner.jpg",
        "_source": {
          "url": "https://blueskyfertility.com/reciprocal-ivf-a-shared-journey-to-parenthood/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-803-abbie-martin-np",
        "name": "Abbie Martin, NP",
        "credentials": ["NP"],
        "specialty": "Nurse Practitioner",
        "role": "Nurse Practitioner",
        "imageUrl": "https://static.showit.co/400/TiOM9KJahw1EJ0aOIyPB4w/shared/abbie-martin-nurse-practitioner-1.jpg",
        "_source": {
          "url": "https://blueskyfertility.com/supporting-partner-through-fertility-treatment/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://blueskyfertility.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [],
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "16:00"
      },
      "tue": {
        "open": "08:00",
        "close": "16:00"
      },
      "wed": {
        "open": "08:00",
        "close": "16:00"
      },
      "thu": {
        "open": "08:00",
        "close": "16:00"
      },
      "fri": {
        "open": "08:00",
        "close": "16:00"
      }
    },
    "specialties": ["reproductive-endocrinology"],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Kansas (KS) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-blue-sky-overland-park-north",
    "externalIds": {},
    "type": "fertility-clinic",
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://blueskyfertility.com/contact",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://blueskyfertility.com/contact",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://blueskyfertility.com/about",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://blueskyfertility.com/about",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://blueskyfertility.com/about",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://blueskyfertility.com/contact",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "name": "Blue Sky Fertility - Overland Park North",
    "phone": "(913) 218-0162",
    "website": "https://blueskyfertility.com/",
    "address": {
      "line1": "9361 W 75th St",
      "city": "Overland Park",
      "state": "KS",
      "zip": "66204",
      "country": "US"
    },
    "location": {
      "lat": 38.9929737,
      "lng": -94.694455
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art",
        "_source": {
          "url": "https://blueskyfertility.com/about",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://blueskyfertility.com/about",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://blueskyfertility.com/about",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Donor egg and donor sperm",
        "category": "art",
        "_source": {
          "url": "https://blueskyfertility.com/about",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [],
    "team": [
      {
        "practitionerId": "pr-org-satellite-blue-sky-overland-park-north-ryan-m-riggs-md",
        "name": "Ryan M. Riggs, MD",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "role": "Medical Director",
        "imageUrl": "https://static.showit.co/800/loLesIXqlodbSPND4VLA4Q/shared/dr-ryan-riggs-medical-director-founder-1.jpg",
        "_source": {
          "url": "https://blueskyfertility.com/about",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-blue-sky-overland-park-north-kelly-mosher",
        "name": "Kelly Mosher",
        "specialty": "Obstetrics and Gynecology",
        "role": "OB/GYN",
        "imageUrl": "https://static.showit.co/400/pZrpGqLg_JAY6xcFVKcELA/shared/dr-kelly-mosher-ob-gyn-1.jpg",
        "_source": {
          "url": "https://blueskyfertility.com/about",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-blue-sky-overland-park-north-jennifer-riggs",
        "name": "Jennifer Riggs",
        "specialty": "Nurse Practitioner",
        "role": "Nurse Practitioner",
        "imageUrl": "https://static.showit.co/400/3sqlsDIqlnpTAjQY_oACRQ/shared/jennifer-riggs-nurse-practitioner-1.jpg",
        "_source": {
          "url": "https://blueskyfertility.com/about",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-blue-sky-overland-park-north-aubrey-fraley-np",
        "name": "Aubrey Fraley, NP",
        "credentials": ["NP"],
        "specialty": "Nurse Practitioner",
        "role": "Nurse Practitioner, Third Party Coordinator",
        "imageUrl": "https://static.showit.co/400/7AWMtOOlcQO3q1ewxvY6gQ/shared/aubrey-fraley-nurse-practitioner-1.jpg",
        "_source": {
          "url": "https://blueskyfertility.com/donor-egg-sperm-family-building/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-blue-sky-overland-park-north-riley-bailie-np",
        "name": "Riley Bailie, NP",
        "credentials": ["NP"],
        "specialty": "Nurse Practitioner",
        "role": "Nurse Practitioner",
        "imageUrl": "https://static.showit.co/400/y_FCEtH1Sx6lQXdJgYVEYw/298207/riley-nurse-practitioner.jpg",
        "_source": {
          "url": "https://blueskyfertility.com/reciprocal-ivf-a-shared-journey-to-parenthood/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-blue-sky-overland-park-north-abbie-martin-np",
        "name": "Abbie Martin, NP",
        "credentials": ["NP"],
        "specialty": "Nurse Practitioner",
        "role": "Nurse Practitioner",
        "imageUrl": "https://static.showit.co/400/TiOM9KJahw1EJ0aOIyPB4w/shared/abbie-martin-nurse-practitioner-1.jpg",
        "_source": {
          "url": "https://blueskyfertility.com/supporting-partner-through-fertility-treatment/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "16:00"
      },
      "tue": {
        "open": "08:00",
        "close": "16:00"
      },
      "wed": {
        "open": "08:00",
        "close": "16:00"
      },
      "thu": {
        "open": "08:00",
        "close": "16:00"
      },
      "fri": {
        "open": "08:00",
        "close": "16:00"
      }
    },
    "specialties": ["reproductive-endocrinology"],
    "consultationTypes": ["in-person"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Kansas (KS) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-blue-sky-lees-summit",
    "externalIds": {
      "googlePlaceId": "ChIJ0YXAbRnhwIcRpEKMrtbzLV8"
    },
    "type": "fertility-clinic",
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://blueskyfertility.com/contact",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://blueskyfertility.com/contact",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://blueskyfertility.com/about",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://blueskyfertility.com/about",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Blue+Sky+Fertility+-+Lee's+Summit,+455+NW+Murray+Rd,+Lee's+Summit,+MO+64081/@38.9207549,-94.4033508,3104a,13.1y/data=!4m2!3m1!1s0x87c0e1196dc085d1:0x5f2df3d6ae8c42a4",
            "fetchedAt": "2026-08-16"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://blueskyfertility.com/contact",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "name": "Blue Sky Fertility - Lee's Summit",
    "phone": "(816) 600-2100",
    "website": "https://blueskyfertility.com/",
    "address": {
      "line1": "455 NW Murray Rd",
      "city": "Lee's Summit",
      "state": "MO",
      "zip": "64081",
      "country": "US"
    },
    "location": {
      "lat": 38.920684,
      "lng": -94.403568
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art",
        "_source": {
          "url": "https://blueskyfertility.com/about",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://blueskyfertility.com/about",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://blueskyfertility.com/about",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Donor egg and donor sperm",
        "category": "art",
        "_source": {
          "url": "https://blueskyfertility.com/about",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [],
    "team": [
      {
        "practitionerId": "pr-org-satellite-blue-sky-lees-summit-ryan-m-riggs-md",
        "name": "Ryan M. Riggs, MD",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "role": "Medical Director",
        "imageUrl": "https://static.showit.co/800/loLesIXqlodbSPND4VLA4Q/shared/dr-ryan-riggs-medical-director-founder-1.jpg",
        "_source": {
          "url": "https://blueskyfertility.com/about",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-blue-sky-lees-summit-kelly-mosher",
        "name": "Kelly Mosher",
        "specialty": "Obstetrics and Gynecology",
        "role": "OB/GYN",
        "imageUrl": "https://static.showit.co/400/pZrpGqLg_JAY6xcFVKcELA/shared/dr-kelly-mosher-ob-gyn-1.jpg",
        "_source": {
          "url": "https://blueskyfertility.com/about",
          "fetchedAt": "2026-06-14"
        },
        "credentials": ["MD"]
      },
      {
        "practitionerId": "pr-org-satellite-blue-sky-lees-summit-jennifer-riggs",
        "name": "Jennifer Riggs",
        "specialty": "Nurse Practitioner",
        "role": "Nurse Practitioner",
        "imageUrl": "https://static.showit.co/400/3sqlsDIqlnpTAjQY_oACRQ/shared/jennifer-riggs-nurse-practitioner-1.jpg",
        "_source": {
          "url": "https://blueskyfertility.com/about",
          "fetchedAt": "2026-06-14"
        },
        "credentials": ["NP"]
      },
      {
        "practitionerId": "pr-org-satellite-blue-sky-lees-summit-aubrey-fraley-np",
        "name": "Aubrey Fraley, NP",
        "credentials": ["NP"],
        "specialty": "Nurse Practitioner",
        "role": "Nurse Practitioner, Third Party Coordinator",
        "imageUrl": "https://static.showit.co/400/7AWMtOOlcQO3q1ewxvY6gQ/shared/aubrey-fraley-nurse-practitioner-1.jpg",
        "_source": {
          "url": "https://blueskyfertility.com/donor-egg-sperm-family-building/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-blue-sky-lees-summit-riley-bailie-np",
        "name": "Riley Bailie, NP",
        "credentials": ["NP"],
        "specialty": "Nurse Practitioner",
        "role": "Nurse Practitioner",
        "imageUrl": "https://static.showit.co/400/y_FCEtH1Sx6lQXdJgYVEYw/298207/riley-nurse-practitioner.jpg",
        "_source": {
          "url": "https://blueskyfertility.com/reciprocal-ivf-a-shared-journey-to-parenthood/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-blue-sky-lees-summit-abbie-martin-np",
        "name": "Abbie Martin, NP",
        "credentials": ["NP"],
        "specialty": "Nurse Practitioner",
        "role": "Nurse Practitioner",
        "imageUrl": "https://static.showit.co/400/TiOM9KJahw1EJ0aOIyPB4w/shared/abbie-martin-nurse-practitioner-1.jpg",
        "_source": {
          "url": "https://blueskyfertility.com/supporting-partner-through-fertility-treatment/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "16:00"
      },
      "tue": {
        "open": "08:00",
        "close": "16:00"
      },
      "wed": {
        "open": "08:00",
        "close": "16:00"
      },
      "thu": {
        "open": "08:00",
        "close": "16:00"
      },
      "fri": {
        "open": "08:00",
        "close": "16:00"
      }
    },
    "specialties": ["reproductive-endocrinology"],
    "consultationTypes": ["in-person"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Missouri (MO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-508",
    "externalIds": {
      "cdcClinicId": "508",
      "googlePlaceId": "ChIJTaV7tCvqwIcRVDNalpuH44Q"
    },
    "type": "fertility-clinic",
    "name": "The University of Kansas Health System Advanced Reproductive Care",
    "phone": "(913) 588-1227",
    "address": {
      "line1": "10777 Nall Avenue, Suite 200",
      "city": "Overland Park",
      "state": "KS",
      "zip": "66211",
      "country": "US"
    },
    "location": {
      "lat": 38.9331169,
      "lng": -94.6481587
    },
    "treatments": [
      {
        "name": "Fertility evaluation",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.kansashealthsystem.com/care/specialties/advanced-reproductive-care",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.kansashealthsystem.com/care/specialties/advanced-reproductive-care",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.kansashealthsystem.com/care/specialties/advanced-reproductive-care",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg preservation",
        "category": "preservation",
        "_source": {
          "url": "https://www.kansashealthsystem.com/care/specialties/advanced-reproductive-care",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Donor eggs and donor sperm",
        "category": "art",
        "_source": {
          "url": "https://www.kansashealthsystem.com/care/specialties/advanced-reproductive-care",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Preimplantation genetic testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.kansashealthsystem.com/care/specialties/advanced-reproductive-care",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 44.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 39.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 32.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 392,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27508%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.kansashealthsystem.com/care/specialties/advanced-reproductive-care",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27508%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.kansashealthsystem.com/care/specialties/advanced-reproductive-care",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://findadoctor.kansashealthsystem.com/specialty/Reproductive%20Endocrinology%20and%20Infertility/near/Overland%20Park%2C%20KS?page=1",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/University+of+Kansas+Physicians+Advanced+Reproductive+Medicine,+10777+Nall+Ave+%23200,+Leawood,+KS+66211/@38.9330372,-94.6482553,3104a,13.1y/data=!4m2!3m1!1s0x87c0ea2bb47ba54d:0x84e3879b965a3354",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://findadoctor.kansashealthsystem.com/specialty/Reproductive%20Endocrinology%20and%20Infertility/near/Overland%20Park%2C%20KS?page=1",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-508-michael-l-lydic-md",
        "name": "Michael L. Lydic, MD",
        "credentials": ["MD"],
        "specialty": "Gynecology, Reproductive Endocrinology and Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/ukhs/photos/200/lydic-michael-1922035690.jpg",
        "_source": {
          "url": "https://findadoctor.kansashealthsystem.com/specialty/Reproductive%20Endocrinology%20and%20Infertility/near/Overland%20Park%2C%20KS?page=1",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-508-kristin-j-holoch-md",
        "name": "Kristin J. Holoch, MD",
        "credentials": ["MD"],
        "specialty": "Gynecology, Reproductive Endocrinology and Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/ukhs/photos/200/holoch-kristin-1942460910.jpg",
        "_source": {
          "url": "https://findadoctor.kansashealthsystem.com/specialty/Reproductive%20Endocrinology%20and%20Infertility/near/Overland%20Park%2C%20KS?page=1",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-508-courtney-a-marsh-md-mph",
        "name": "Courtney A. Marsh, MD, MPH",
        "credentials": ["MD", "MPH"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/ukhs/photos/200/marsh-courtney-1568648756.jpg",
        "_source": {
          "url": "https://findadoctor.kansashealthsystem.com/specialty/Reproductive%20Endocrinology%20and%20Infertility/near/Overland%20Park%2C%20KS?page=1",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.kansashealthsystem.com/care/specialties/advanced-reproductive-care",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "specialties": ["reproductive-endocrinology"],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Kansas (KS) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmjfILOxTtCVGWcy4Ct3H4odqSZE6voZCMXrCNsSKKx8BmUxTGnW0uk3hHABkMD35A7LelLKYBNuPqIuWCY6PkigXNZvodsR5WH6KltqLTm_V_hp5FB_1Mi31Aj2Jtw98EIZRxG=w585-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/University+of+Kansas+Physicians+Advanced+Reproductive+Medicine,+10777+Nall+Ave+%23200,+Leawood,+KS+66211/@38.9330372,-94.6482553,3104a,13.1y/data=!4m2!3m1!1s0x87c0ea2bb47ba54d:0x84e3879b965a3354",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-243",
    "externalIds": {
      "cdcClinicId": "243",
      "googlePlaceId": "ChIJbarnjc69wIcRhSmJxzsRABE"
    },
    "type": "fertility-clinic",
    "name": "AdventHealth Medical Group Fertility at Shawnee Mission",
    "phone": "(913) 780-4300",
    "address": {
      "line1": "9119 W 74th St, Suite 268",
      "city": "Merriam",
      "state": "KS",
      "zip": "66204",
      "country": "US"
    },
    "location": {
      "lat": 38.9948356,
      "lng": -94.6926344
    },
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.adventhealth.com/locations/practices/adventhealth-medical-group/fertility-shawnee-mission",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.adventhealth.com/locations/practices/adventhealth-medical-group/fertility-shawnee-mission",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.adventhealth.com/locations/practices/adventhealth-medical-group/fertility-shawnee-mission",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Sperm freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.adventhealth.com/locations/practices/adventhealth-medical-group/fertility-shawnee-mission",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Preimplantation genetic testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.adventhealth.com/locations/practices/adventhealth-medical-group/fertility-shawnee-mission",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Donor egg and donor sperm services",
        "category": "art",
        "_source": {
          "url": "https://www.adventhealth.com/locations/practices/adventhealth-medical-group/fertility-shawnee-mission",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Gestational carrier services",
        "category": "art",
        "_source": {
          "url": "https://www.adventhealth.com/locations/practices/adventhealth-medical-group/fertility-shawnee-mission",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 37.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 25,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 21.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 257,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27243%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.adventhealth.com/news/adventhealth-shawnee-mission-opens-fertility-center",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27243%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.adventhealth.com/locations/practices/adventhealth-medical-group/fertility-shawnee-mission",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.adventhealth.com/locations/practices/adventhealth-medical-group/fertility-shawnee-mission",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/AdventHealth+Medical+Group+Fertility+at+Shawnee+Mission,+9119+W+74th+St+%23268,+Merriam,+KS+66204/@38.9948742,-94.6926631,3101a,13.1y/data=!4m2!3m1!1s0x87c0bdce8de7aa6d:0x1100113bc7892985",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.adventhealth.com/locations/practices/adventhealth-medical-group/fertility-shawnee-mission",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-243-dan-gehlbach-md-facog",
        "name": "Dan Gehlbach, MD, FACOG",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://www.adventhealth.com/sites/default/files/styles/fc_800x800/public/physicians/Dan_Gehlbach_1962405654.jpg.webp?h=54145fed&itok=c8kZT6nN",
        "_source": {
          "url": "https://www.adventhealth.com/locations/practices/adventhealth-medical-group/fertility-shawnee-mission",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-243-goldie-bjornstad-aprn-fnp-c",
        "name": "Goldie Bjornstad, APRN, FNP-C",
        "credentials": ["APRN", "FNP-C"],
        "specialty": "Nurse Practitioner",
        "role": "Nurse Practitioner",
        "imageUrl": "https://www.adventhealth.com/sites/default/files/styles/fc_800x800/public/physicians/Goldie_Bjornstad_1245879097.jpg.webp?h=54145fed&itok=RaYJxsVD",
        "_source": {
          "url": "https://www.adventhealth.com/locations/practices/adventhealth-medical-group/fertility-shawnee-mission",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-243-johni-kilton-aprn-whnp-bc",
        "name": "Johni Kilton, APRN, WHNP-BC",
        "credentials": ["APRN", "WHNP-BC"],
        "specialty": "Nurse Practitioner",
        "role": "Women's Health Nurse Practitioner",
        "imageUrl": "https://www.adventhealth.com/sites/default/files/styles/fc_800x800/public/physicians/Johni_Kilton_1194055111.jpg.webp?h=54145fed&itok=o4kEO-kW",
        "_source": {
          "url": "https://www.adventhealth.com/locations/practices/adventhealth-medical-group/fertility-shawnee-mission",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.adventhealth.com/locations/practices/adventhealth-medical-group/fertility-shawnee-mission",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "specialties": ["reproductive-endocrinology"],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Kansas (KS) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmH1_nQ7C2uqyVnFeMgpgv3Z-8m7w6A0_yJw05LhoRHC4FHxMnVKG2-ZuOQqDg3PTDNRrzPyj1C308aa4NnHfvrZ2EAlcigi1cNugQyL_4NoemphfyH3JAcSjxSqscnXQA3SNvl=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/AdventHealth+Medical+Group+Fertility+at+Shawnee+Mission,+9119+W+74th+St+%23268,+Merriam,+KS+66204/@38.9948742,-94.6926631,3101a,13.1y/data=!4m2!3m1!1s0x87c0bdce8de7aa6d:0x1100113bc7892985",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-386",
    "externalIds": {
      "cdcClinicId": "386",
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/reproductive-resource-center",
      "googlePlaceId": "ChIJozy2HSvrwIcRc4_I-vBm210"
    },
    "type": "fertility-clinic",
    "name": "HCRM Fertility - Kansas City",
    "phone": "+1 913-392-6388",
    "address": {
      "line1": "6650 W 110th St, Suite 320",
      "city": "Overland Park",
      "state": "KS",
      "zip": "66211",
      "country": "US"
    },
    "location": {
      "lat": 38.9301901,
      "lng": -94.6620889
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 61.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 33.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 180,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27386%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.hcrmfertility.com/locations/kansas-city-office/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27386%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.hcrmfertility.com/locations/kansas-city-office/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.hcrmfertility.com/locations/kansas-city-office/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://www.hcrmfertility.com/locations/kansas-city-office/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/HCRM+Fertility,+6650+W+110th+St+Suite+320,+Overland+Park,+KS+66211/@38.9300985,-94.661944,3104a,13.1y/data=!4m2!3m1!1s0x87c0eb2b1db63ca3:0x5ddb66f0fac88f73",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.hcrmfertility.com/locations/kansas-city-office/",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-386-stephanie-l-f-gustin-md-facog",
        "name": "Stephanie L.F. Gustin, MD, FACOG",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://einstein-clients.imgix.net/2640/492868/original_stephanie-gustin.jpg?1763660771",
        "_source": {
          "url": "https://www.hcrmfertility.com/locations/kansas-city-office/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-386-elizabeth-constance-md-facog",
        "name": "Elizabeth Constance, MD, FACOG",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://einstein-clients.imgix.net/2640/491462/original_Elizabeth-Constance.jpg?1762215580",
        "_source": {
          "url": "https://www.hcrmfertility.com/locations/kansas-city-office/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-386-elizabeth-weedin-do-ms-facog",
        "name": "Elizabeth Weedin, DO, MS, FACOG",
        "credentials": ["DO", "MS", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://einstein-clients.imgix.net/2640/491442/original.jpg?1762210183",
        "_source": {
          "url": "https://www.hcrmfertility.com/locations/kansas-city-office/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-386-abigail-a-delaney-md-facog",
        "name": "Abigail A. Delaney, MD, FACOG",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://einstein-clients.imgix.net/2640/491461/original_abigail-delaney.jpg?1762215580",
        "_source": {
          "url": "https://www.hcrmfertility.com/locations/kansas-city-office/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-386-meghan-b-oakes-md-facog",
        "name": "Meghan B. Oakes, MD, FACOG",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://einstein-clients.imgix.net/2640/491534/original_meghan-oakes.jpg?1762278514",
        "_source": {
          "url": "https://www.hcrmfertility.com/locations/kansas-city-office/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-386-tiffany-vasa-np",
        "name": "Tiffany Vasa, NP",
        "credentials": ["NP"],
        "specialty": "Nurse Practitioner",
        "role": "Nurse Practitioner",
        "imageUrl": "https://einstein-clients.imgix.net/2640/448535/original_Tiffany_Vasa.jpg?w=600&h=600&fit=crop&crop=faces",
        "_source": {
          "url": "https://www.hcrmfertility.com/locations/kansas-city-office/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-386-barry-r-behr-phd-hcld",
        "name": "Barry R. Behr, PhD, HCLD",
        "credentials": ["PhD", "HCLD"],
        "specialty": "Embryology Laboratory Director",
        "role": "Embryology Laboratory Director",
        "imageUrl": "https://einstein-clients.imgix.net/2640/449169/original_Barry-R-Behr.jpg?1706128646",
        "_source": {
          "url": "https://www.hcrmfertility.com/locations/kansas-city-office/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.hcrmfertility.com/locations/kansas-city-office/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "15:30"
      },
      "tue": {
        "open": "07:00",
        "close": "15:30"
      },
      "wed": {
        "open": "07:00",
        "close": "15:30"
      },
      "thu": {
        "open": "07:00",
        "close": "15:30"
      },
      "fri": {
        "open": "07:00",
        "close": "15:30"
      }
    },
    "specialties": ["reproductive-endocrinology"],
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Kansas (KS) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-846",
    "externalIds": {
      "cdcClinicId": "846",
      "googlePlaceId": "ChIJnQGHBHP9uocRhL8SePyaE-g"
    },
    "type": "fertility-clinic",
    "name": "The Center for Reproductive Medicine - Wichita",
    "phone": "(316) 687-2112",
    "address": {
      "line1": "9300 E. 29th St N, Suite 102",
      "city": "Wichita",
      "state": "KS",
      "zip": "67226",
      "country": "US"
    },
    "location": {
      "lat": 37.7384073,
      "lng": -97.2302056
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 47.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 35.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 160,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27846%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.cfrm.net/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27846%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.cfrm.net/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.cfrm.net/AboutUs/OurDoctors/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/The+Center+for+Reproductive+Medicine,+9300+East+29th+St+N+%23102,+Wichita,+KS+67226/@37.738423,-97.2299846,3155a,13.1y/data=!4m2!3m1!1s0x87bafd730487019d:0xe8139afc7812bf84",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.cfrm.net/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-846-david-grainger-md-mph",
        "name": "David Grainger, MD, MPH",
        "credentials": ["MD", "MPH"],
        "specialty": "Reproductive Medicine",
        "role": "Physician",
        "imageUrl": "https://www.cfrm.net/Grainger-icon.jpg",
        "_source": {
          "url": "https://www.cfrm.net/AboutUs/OurDoctors/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-846-laura-tatpati-md",
        "name": "Laura Tatpati, MD",
        "credentials": ["MD"],
        "specialty": "Reproductive Medicine",
        "role": "Physician",
        "imageUrl": "https://www.cfrm.net/Tatpati-icon.jpg",
        "_source": {
          "url": "https://www.cfrm.net/AboutUs/OurDoctors/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-846-james-gilbaugh-md",
        "name": "James Gilbaugh, MD",
        "credentials": ["MD"],
        "specialty": "Reproductive Medicine",
        "role": "Physician",
        "imageUrl": "https://www.cfrm.net/JamesGilbaugh.png",
        "_source": {
          "url": "https://www.cfrm.net/AboutUs/OurDoctors/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-846-jamie-peregrine-md",
        "name": "Jamie Peregrine, MD",
        "credentials": ["MD"],
        "specialty": "Reproductive Medicine",
        "role": "Physician",
        "imageUrl": "https://www.cfrm.net/JamiePeregrine1.png",
        "_source": {
          "url": "https://www.cfrm.net/AboutUs/OurDoctors/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-846-kara-ehlers-md-facog",
        "name": "Kara Ehlers, MD, FACOG",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Medicine",
        "role": "Physician",
        "imageUrl": "https://www.cfrm.net/drKaraehlers.png",
        "_source": {
          "url": "https://www.cfrm.net/AboutUs/OurDoctors/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.cfrm.net/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "specialties": ["reproductive-endocrinology"],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Kansas (KS) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnr7Fu9uYeMKOtr9KwoZ4CSTbd5LW2x7gjJIPUPNrYIOjhApURycq0ZYsa7JEWq7vuS7lwXTcLAN4-fMiNiLpgY4YgLpwmrRXGsjVA1X4VwNsKSJ_lDP7FiqEXczX7xVZ_C5U1u=w156-h156-n-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/The+Center+for+Reproductive+Medicine,+9300+East+29th+St+N+%23102,+Wichita,+KS+67226/@37.738423,-97.2299846,3155a,13.1y/data=!4m2!3m1!1s0x87bafd730487019d:0xe8139afc7812bf84",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-328",
    "externalIds": {
      "cdcClinicId": "328"
    },
    "type": "fertility-clinic",
    "name": "Bluegrass Fertility Center",
    "phone": "(859) 260-1515",
    "address": {
      "line1": "1760 Nicholasville Rd, Suite 501",
      "city": "Lexington",
      "state": "KY",
      "zip": "40503",
      "country": "US"
    },
    "location": {
      "lat": 38.0182,
      "lng": -84.5137
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 33.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 97,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27328%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27328%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.bluegrassfertilitycenter.com/james-w-akin-md/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.bluegrassfertilitycenter.com/contact-locations/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.bluegrassfertilitycenter.com/contact-locations/",
            "fetchedAt": "2026-06-13"
          }
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.bluegrassfertilitycenter.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-328-james-w-akin-md",
        "name": "James W. Akin, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.bluegrassfertilitycenter.com/wp-content/uploads/2015/07/DrAkinPhoto_2012.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.bluegrassfertilitycenter.com/james-w-akin-md/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.bluegrassfertilitycenter.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://www.bluegrassfertilitycenter.com/wp-content/uploads/2015/07/1760-Building.jpg",
        "type": "exterior",
        "caption": "Bluegrass Fertility Center building at 1760 Nicholasville Road",
        "_source": {
          "url": "https://www.bluegrassfertilitycenter.com/contact-locations/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://www.bluegrassfertilitycenter.com/wp-content/uploads/2015/07/IVF_Lab_BGFC.jpg",
        "type": "lab",
        "caption": "Bluegrass Fertility Center IVF lab exterior signage",
        "_source": {
          "url": "https://www.bluegrassfertilitycenter.com/contact-locations/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Kentucky (KY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-281",
    "externalIds": {
      "cdcClinicId": "281",
      "googlePlaceId": "ChIJnQcmOc0KaYgR2tYB7bpVJD8"
    },
    "type": "fertility-clinic",
    "name": "Fertility & Endocrine Associates, Louisville Reproductive Center",
    "phone": "(502) 897-2144",
    "address": {
      "line1": "4123 Dutchmans Ln, Suite 414",
      "city": "Louisville",
      "state": "KY",
      "zip": "40207",
      "country": "US"
    },
    "location": {
      "lat": 38.2354,
      "lng": -85.6322
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 29.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 34.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 17.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 161,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27281%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27281%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://ivfkentucky.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+%26+Endocrine+Associates,+Medical+Plaza+3,+4123+Dutchmans+Ln+Ste+414,+Louisville,+KY+40207/@38.2354361,-85.6321819,3134a,13.1y/data=!4m2!3m1!1s0x88690acd3926079d:0x3f2455baed01d6da",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://ivfkentucky.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-281-miriam-s-krause-md-facog",
        "name": "Miriam S. Krause, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://ivfkentucky.com/wp-content/uploads/2023/10/Dr.-Krause-edit.jpg",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://ivfkentucky.com/team/dr-krause/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-281-tiffany-d-justice-md-facog",
        "name": "Tiffany D. Justice, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://ivfkentucky.com/wp-content/uploads/2023/10/Dr.-Justice-editv1.jpg",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://ivfkentucky.com/team/dr-justice/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-281-lauren-slone-aprn-whnp-fnp",
        "name": "Lauren Slone, APRN, WHNP/FNP",
        "role": "Nurse Practitioner",
        "imageUrl": "https://ivfkentucky.com/wp-content/uploads/2023/10/Lauren-Slone-edit.jpg",
        "credentials": ["APRN", "WHNP/FNP"],
        "specialty": "Nurse Practitioner",
        "_source": {
          "url": "https://ivfkentucky.com/team/lauren-slone/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://ivfkentucky.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Kentucky (KY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn5f5iK0KnGN41uEPsF_AngynWuUziaCIsYIZWdf6SsK7_UHMmIDTRUcSLPAY99Bzv66WO40fmDJfTzf2KhKmtcUwEWBfmHLrzs_5bgLLL-e9d_DyYvQZUVmz5bO5wulRG1RodVnw=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+%26+Endocrine+Associates,+Medical+Plaza+3,+4123+Dutchmans+Ln+Ste+414,+Louisville,+KY+40207/@38.2354361,-85.6321819,3134a,13.1y/data=!4m2!3m1!1s0x88690acd3926079d:0x3f2455baed01d6da",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmpI_mgeRRzqFPT3JYzMwhbMUWbMU1YT-3Lstbtt_y9STzW6ox1OC7on-viLKgH8shLGC80v5uq72GYDBjUTM8EVe5XaqeBxVOFw_h9axdFido1MUShIndd6UuH555I7UusvLfj=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+%26+Endocrine+Associates,+Medical+Plaza+3,+4123+Dutchmans+Ln+Ste+414,+Louisville,+KY+40207/@38.2354361,-85.6321819,3134a,13.1y/data=!4m2!3m1!1s0x88690acd3926079d:0x3f2455baed01d6da",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-717",
    "externalIds": {
      "cdcClinicId": "717",
      "googlePlaceId": "ChIJ0WWb83ueaYgRC-DX_G9AFrA"
    },
    "type": "fertility-clinic",
    "name": "Kentucky Fertility Institute",
    "phone": "(502) 996-4480",
    "address": {
      "line1": "4612 Chamberlain Ln, Suite 200",
      "city": "Louisville",
      "state": "KY",
      "zip": "40241",
      "country": "US"
    },
    "location": {
      "lat": 38.3105,
      "lng": -85.5672
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 47.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 52,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 220,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27717%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.kentuckyfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27717%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.kentuckyfertility.com/about",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kentucky+Fertility+Institute,+4612+Chamberlain+Ln+%23200,+Louisville,+KY+40241/@38.310603,-85.567058,3131a,13.1y/data=!4m2!3m1!1s0x88699e7bf39b65d1:0xb016406ffcd7e00b",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.kentuckyfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.kentuckyfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-717-robert-k-hunter-ii-md-msc-mba-facog",
        "name": "Robert K. Hunter II, MD, MSc, MBA, FACOG",
        "role": "Practice Director",
        "imageUrl": "https://www.kentuckyfertility.com/media/pages/about/our-providers/dr-robert-hunter/dd6abb0c38-1753877355/robert-k-hunter-ii.jpg",
        "credentials": ["MD", "MSc", "MBA", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.kentuckyfertility.com/about/our-providers/dr-robert-hunter",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-717-yllena-novitsky-aprn-fnp-c-whnp-bc-c-rhi",
        "name": "Yllena Novitsky, APRN, FNP-C, WHNP-BC, C-RHI",
        "role": "Clinical Manager",
        "imageUrl": "https://www.kentuckyfertility.com/media/pages/about/our-providers/yllena-novitsky/682a65a6d5-1753877355/yllena-novitsky.jpg",
        "credentials": ["APRN", "FNP-C", "WHNP-BC", "C-RHI"],
        "specialty": "Nurse Practitioner",
        "_source": {
          "url": "https://www.kentuckyfertility.com/about/our-providers/yllena-novitsky",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-717-paige-hardin-o-brien-ms",
        "name": "Paige Hardin-O'Brien, MS",
        "role": "Embryologist",
        "imageUrl": "https://www.kentuckyfertility.com/media/pages/about/our-providers/paige-hardin-obrien/1819eb16ac-1753877355/paige-hardin-obrien.jpg",
        "credentials": ["MS"],
        "specialty": "Embryology",
        "_source": {
          "url": "https://www.kentuckyfertility.com/about/our-providers/paige-hardin-obrien",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-717-bianca-weaver-aprn-cnm",
        "name": "Bianca Weaver, APRN, CNM",
        "role": "Nurse Practitioner",
        "imageUrl": "https://www.kentuckyfertility.com/media/pages/about/our-providers/bianca-weaver/42ef5abbee-1753877355/bianca-weaver.jpg",
        "credentials": ["APRN", "CNM"],
        "specialty": "Nurse Practitioner",
        "_source": {
          "url": "https://www.kentuckyfertility.com/about/our-providers/bianca-weaver",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.kentuckyfertility.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://www.kentuckyfertility.com/media/pages/about/46a2a4433f-1753797508/kfi-jpg-0038.jpg",
        "type": "interior",
        "caption": "Kentucky Fertility Institute clinic interior",
        "_source": {
          "url": "https://www.kentuckyfertility.com/about",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnoqB2OJfFX4TXlTDSP5nr6gIgN_h76LwghrFYbC4en25e7isxdWnAQ8t3o6N87qe5K7oAmO7kL7senjM1VXheX1kpaqkz5IzrYy300EJIM76U8M2NG1vi74PTP1_DA6GCFZwpzv3TCrfng=w408-h408-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kentucky+Fertility+Institute,+4612+Chamberlain+Ln+%23200,+Louisville,+KY+40241/@38.310603,-85.567058,3131a,13.1y/data=!4m2!3m1!1s0x88699e7bf39b65d1:0xb016406ffcd7e00b",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkzOHVYc6hyv_iv_KTy9HtjVu56eokh-P-QIouBrSM0V0VOcgHyHOVCdtiEdjoHiKkfeRd0r9kEKWpRGSMOgP-fhiGQhUOcVnhZoJ3kIoM8BO00CBPJXwNBBuUiVmNTaXOlxdR7=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kentucky+Fertility+Institute,+4612+Chamberlain+Ln+%23200,+Louisville,+KY+40241/@38.310603,-85.567058,3131a,13.1y/data=!4m2!3m1!1s0x88699e7bf39b65d1:0xb016406ffcd7e00b",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Kentucky (KY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-102",
    "externalIds": {
      "cdcClinicId": "102"
    },
    "type": "fertility-clinic",
    "name": "The Lexington Fertility Center",
    "phone": "(859) 277-5736",
    "address": {
      "line1": "3292 Eagle View Ln, Suite 190",
      "city": "Lexington",
      "state": "KY",
      "zip": "40509",
      "country": "US"
    },
    "location": {
      "lat": 38.0008,
      "lng": -84.439
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 32,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27102%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27102%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://kyfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://kyfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://kyfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://kyfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-102-george-m-veloudis-jr-do-facoog",
        "name": "George M. Veloudis Jr., DO, FACOOG",
        "role": "Medical Director",
        "credentials": ["DO", "FACOOG"],
        "specialty": "Reproductive Medicine and Infertility",
        "_source": {
          "url": "https://kyfertility.com/center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-102-cristina-bastias-md",
        "name": "Cristina Bastias, MD",
        "role": "IVF Lab Director",
        "credentials": ["MD"],
        "specialty": "Assisted Reproductive Technology Laboratory",
        "_source": {
          "url": "https://kyfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://kyfertility.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Kentucky (KY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-129",
    "externalIds": {
      "cdcClinicId": "129",
      "googlePlaceId": "ChIJkQrK93zNNoYRCAtxAJHcOD0"
    },
    "type": "fertility-clinic",
    "name": "ArkLaTex Fertility and Reproductive Medicine",
    "phone": "(318) 841-5800",
    "address": {
      "line1": "2401 Greenwood Rd, Suite A",
      "city": "Shreveport",
      "state": "LA",
      "zip": "71103",
      "country": "US"
    },
    "location": {
      "lat": 32.4845,
      "lng": -93.7765
    },
    "treatments": [
      {
        "name": "Fertility evaluation",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.arklatexfertility.com/about-arklatex-fertility-and-reproductive-medicine/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation induction",
        "category": "art",
        "_source": {
          "url": "https://www.arklatexfertility.com/about-arklatex-fertility-and-reproductive-medicine/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.arklatexfertility.com/about-arklatex-fertility-and-reproductive-medicine/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF & ICSI",
        "category": "art",
        "_source": {
          "url": "https://www.arklatexfertility.com/about-arklatex-fertility-and-reproductive-medicine/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.arklatexfertility.com/about-arklatex-fertility-and-reproductive-medicine/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility surgery",
        "category": "surgical",
        "_source": {
          "url": "https://www.arklatexfertility.com/about-arklatex-fertility-and-reproductive-medicine/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 51.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 35,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 94,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27129%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.arklatexfertility.com/about-arklatex-fertility-and-reproductive-medicine/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27129%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.arklatexfertility.com/about-arklatex-fertility-and-reproductive-medicine/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.arklatexfertility.com/about-arklatex-fertility-and-reproductive-medicine/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://www.arklatexfertility.com/about-arklatex-fertility-and-reproductive-medicine/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/ArkLaTex+Fertility+%26+Reproductive,+2401+Greenwood+Rd+Ste+A,+Shreveport,+LA+71103/@32.4844935,-93.7764833,3366a,13.1y/data=!4m2!3m1!1s0x8636cd7cf7ca0a91:0x3d38dc9100710b08",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.arklatexfertility.com/contact-arklatex-fertility-and-reproductive-medicine/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-129-david-t-vandermolen-md-ms",
        "name": "David T. Vandermolen, MD, MS",
        "role": "Medical Director",
        "credentials": ["MD", "MS"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.arklatexfertility.com/wp-content/uploads/2024/01/dr-david-t-vandermolen.webp",
        "_source": {
          "url": "https://www.arklatexfertility.com/about-arklatex-fertility-and-reproductive-medicine/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.arklatexfertility.com/about-arklatex-fertility-and-reproductive-medicine/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "specialties": ["reproductive-endocrinology"],
    "description": "ArkLaTex Fertility and Reproductive Medicine provides fertility evaluation, ovulation induction, IUI, IVF and ICSI, egg freezing, and fertility surgery from its Shreveport clinic.",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Louisiana (LA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-228",
    "externalIds": {
      "cdcClinicId": "228",
      "googlePlaceId": "ChIJ6cFtJrClIIYRPMD4mC9202c"
    },
    "type": "fertility-clinic",
    "name": "Audubon Fertility",
    "phone": "(504) 475-1458",
    "address": {
      "line1": "4321 Magnolia St",
      "city": "New Orleans",
      "state": "LA",
      "zip": "70115",
      "country": "US"
    },
    "location": {
      "lat": 29.9375,
      "lng": -90.1025
    },
    "treatments": [
      {
        "name": "Ovulation induction",
        "category": "art",
        "_source": {
          "url": "https://www.audubonfertility.com/our-clinic",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.audubonfertility.com/our-clinic",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF & ICSI",
        "category": "art",
        "_source": {
          "url": "https://www.audubonfertility.com/our-clinic",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Reproductive surgery",
        "category": "surgical",
        "_source": {
          "url": "https://www.audubonfertility.com/our-clinic",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Preimplantation genetic testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.audubonfertility.com/our-clinic",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Third-party reproduction",
        "category": "art",
        "_source": {
          "url": "https://www.audubonfertility.com/our-clinic",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg freezing and fertility preservation",
        "category": "preservation",
        "_source": {
          "url": "https://www.audubonfertility.com/our-clinic",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 55.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 57.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 66.66666666666666,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "10/15"
        }
      ],
      "cyclesPerYear": 229,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27228%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.audubonfertility.com/team",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27228%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.audubonfertility.com/our-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.audubonfertility.com/team",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://www.audubonfertility.com/our-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Audubon+Fertility,+4321+Magnolia+St,+New+Orleans,+LA+70115/@29.9374568,-90.1025141,3457a,13.1y/data=!4m2!3m1!1s0x8620a5b0266dc1e9:0x67d3762f98f8c03c",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.audubonfertility.com/team",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-228-lindsay-wells-md",
        "name": "Lindsay Wells, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://static.wixstatic.com/media/44d2b9_3f7d9acae334467ea2b506be5f27e1f8~mv2.webp/v1/fill/w_634,h_520,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Dr.%20Wells%20Headshot.webp",
        "_source": {
          "url": "https://www.audubonfertility.com/dr-lindsay-wells",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-228-keith-isaacson-md",
        "name": "Keith Isaacson, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://static.wixstatic.com/media/44d2b9_41cc02c2575d47e4bfe46f0a06af51cd~mv2.jpg/v1/crop/x_0,y_139,w_3144,h_2580/fill/w_634,h_520,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Audubon%20Fertility%20-%202024%20-%2010%20-%20Dr_%20Isaacson%20Headshot%202.jpg",
        "_source": {
          "url": "https://www.audubonfertility.com/dr-keith-isaacson",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-228-morgan-gremillion-np",
        "name": "Morgan Gremillion, NP",
        "role": "Women's Health Nurse Practitioner",
        "credentials": ["NP"],
        "specialty": "Women's Health Nurse Practitioner",
        "imageUrl": "https://static.wixstatic.com/media/730515_0fd949c22a894102bc6d283298b23398~mv2.jpg/v1/crop/x_28,y_0,w_1622,h_1330/fill/w_634,h_520,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/AF%20-%202023%20-%2010%20-%20Headshots%20-%20Morgan%202_edited.jpg",
        "_source": {
          "url": "https://www.audubonfertility.com/morgan-gremillion-np",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.audubonfertility.com/our-clinic",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "specialties": ["reproductive-endocrinology"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "description": "Audubon Fertility is a New Orleans fertility clinic offering ovulation induction, IUI, IVF and ICSI, reproductive surgery, PGT, third-party reproduction, fertility preservation, and LGBTQ+ fertility care.",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Louisiana (LA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-606",
    "externalIds": {
      "cdcClinicId": "606",
      "googlePlaceId": "ChIJlUrKteG6JoYRtmR79D29ti4"
    },
    "type": "fertility-clinic",
    "name": "Fertility Answers - Baton Rouge",
    "phone": "(225) 926-6886",
    "address": {
      "line1": "500 Rue de la Vie, Suite 510",
      "city": "Baton Rouge",
      "state": "LA",
      "zip": "70817",
      "country": "US"
    },
    "location": {
      "lat": 30.3858,
      "lng": -91.0373
    },
    "treatments": [
      {
        "name": "Fertility testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.fertilityanswers.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation induction",
        "category": "art",
        "_source": {
          "url": "https://www.fertilityanswers.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.fertilityanswers.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.fertilityanswers.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility surgery",
        "category": "surgical",
        "_source": {
          "url": "https://www.fertilityanswers.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.fertilityanswers.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility preservation before cancer treatment",
        "category": "preservation",
        "_source": {
          "url": "https://www.fertilityanswers.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg donation",
        "category": "art",
        "_source": {
          "url": "https://www.fertilityanswers.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Genetic testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.fertilityanswers.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Male infertility care",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.fertilityanswers.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 48.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 43.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 37,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 428,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27606%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.fertilityanswers.com/about-us/louisiana-fertility-centers/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27606%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilityanswers.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilityanswers.com/about-us/louisiana-fertility-centers/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilityanswers.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilityanswers.com/about-us/louisiana-fertility-centers/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Answers+Baton+Rouge,+500+Rue+de+la+Vie+%23510,+Baton+Rouge,+LA+70817/@30.3860298,-91.0378955,3442a,13.1y/data=!4m2!3m1!1s0x8626bae1b5ca4a95:0x2eb6bd3df47b64b6",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.fertilityanswers.com/about-us/louisiana-fertility-centers/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-606-neil-chappell-md-msci",
        "name": "Neil Chappell, MD, MSCI",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MSCI"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.fertilityanswers.com/wp-content/uploads/2018/06/chappell-white-background.jpg",
        "_source": {
          "url": "https://www.fertilityanswers.com/about-us/louisiana-fertility-centers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-606-tolulope-bakare-md",
        "name": "Tolulope Bakare, MD",
        "role": "Reproductive Urologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Urology",
        "imageUrl": "https://www.fertilityanswers.com/wp-content/uploads/2023/10/Bakare-thumbnail-sq.jpg",
        "_source": {
          "url": "https://www.fertilityanswers.com/about-us/louisiana-fertility-centers/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.fertilityanswers.com/about-us/louisiana-fertility-centers/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "description": "Fertility Answers provides Louisiana fertility care including fertility testing, IUI, IVF, egg freezing, fertility surgery, male infertility care, and third-party reproduction from Baton Rouge and Lafayette centers.",
    "specialties": ["reproductive-endocrinology", "male-infertility"],
    "patientGroups": ["LGBTQIA+", "Single Parents"],
    "network": {
      "name": "Ovation Fertility"
    },
    "schedule": {
      "mon": {
        "open": "07:30",
        "close": "16:00"
      },
      "tue": {
        "open": "07:30",
        "close": "16:00"
      },
      "wed": {
        "open": "07:30",
        "close": "16:00"
      },
      "thu": {
        "open": "07:30",
        "close": "16:00"
      },
      "fri": {
        "open": "07:30",
        "close": "12:00"
      }
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Louisiana (LA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmUCgAbCpOrmwMyt5sKYUeGcGMFYI1XLCVm_q710giBd2biwm0aApZISATwhnwu6xUrJIofkhfNcfzRor4IPmW7A_taPJOua-B7GYBnxU3dodIYyZMAvjhJYyeTxEyovM3_KqlH=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Answers+Baton+Rouge,+500+Rue+de+la+Vie+%23510,+Baton+Rouge,+LA+70817/@30.3860298,-91.0378955,3442a,13.1y/data=!4m2!3m1!1s0x8626bae1b5ca4a95:0x2eb6bd3df47b64b6",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-496",
    "externalIds": {
      "cdcClinicId": "496",
      "googlePlaceId": "ChIJA4cQPjhaJ4YRhJlZ28o6iqk"
    },
    "type": "fertility-clinic",
    "name": "Fertility Institute of New Orleans - Mandeville",
    "phone": "(504) 454-2165",
    "address": {
      "line1": "800 N. Causeway Blvd, Suite 2C",
      "city": "Mandeville",
      "state": "LA",
      "zip": "70448",
      "country": "US"
    },
    "location": {
      "lat": 30.377224,
      "lng": -90.0914101
    },
    "treatments": [
      {
        "name": "IVF with donor eggs or sperm",
        "category": "art",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation induction",
        "category": "art",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility surgery",
        "category": "surgical",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Male infertility treatments",
        "category": "diagnostic",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Genetic testing and counseling",
        "category": "diagnostic",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Preimplantation genetic testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg and embryo freezing",
        "category": "preservation",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Oncofertility",
        "category": "preservation",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 43.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 33.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 42.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 17.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 432,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27496%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://fertilityinstitute.com/locations/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27496%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://fertilityinstitute.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://fertilityinstitute.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://fertilityinstitute.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/The+Fertility+Institute+of+New+Orleans+%E2%80%93+Mandeville,+800+N+Causeway+Blvd+%232c,+Mandeville,+LA+70448/@30.3768852,-90.0924287,3442a,13.1y/data=!4m2!3m1!1s0x86275a383e108703:0xa98a3acadb599984",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://fertilityinstitute.com/locations/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-496-warren-jay-huber-md-phd",
        "name": "Warren Jay Huber, MD, PhD",
        "role": "Medical Director",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://fertilityinstitute.com/wp-content/uploads/2023/12/photo-fino-doctor-Warren-Jay-Huber-e1620321937309-1024x1024.jpg",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-496-peter-lu-md",
        "name": "Peter Lu, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://fertilityinstitute.com/wp-content/uploads/2024/03/photo-fino-doctor-Peter-Lu-e1620321677334-1024x1024.jpg",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-496-ronald-clisham-md",
        "name": "Ronald Clisham, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://fertilityinstitute.com/wp-content/uploads/2023/10/doc-pic-5.jpg",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-496-stacey-scheib-md",
        "name": "Stacey Scheib, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://fertilityinstitute.com/wp-content/uploads/2024/04/Stacy-Headshot-Screen-Res-1024x1024.jpg",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-496-nicole-ulrich-md",
        "name": "Nicole Ulrich, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://fertilityinstitute.com/wp-content/uploads/2025/01/Nicole-ulrich-square-1024x1024.jpg",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-496-erin-cheneval-fnp",
        "name": "Erin Cheneval, FNP",
        "role": "Family Nurse Practitioner",
        "credentials": ["FNP"],
        "specialty": "Fertility Nursing",
        "imageUrl": "https://fertilityinstitute.com/wp-content/uploads/2023/12/photo-FINO-Erin-Cheneval-1-e1675285466212-1024x1024.jpg",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://fertilityinstitute.com/locations/mandeville/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "specialties": ["reproductive-endocrinology", "male-infertility"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "network": {
      "name": "Fertility Institute of New Orleans"
    },
    "description": "The Fertility Institute of New Orleans provides fertility testing, IUI, IVF, genetic testing, fertility preservation, male infertility treatments, and reproductive surgery across Metairie, Baton Rouge, and Mandeville.",
    "images": [
      {
        "url": "https://fertilityinstitute.com/wp-content/uploads/2023/10/locations-3.jpg",
        "type": "exterior",
        "caption": "Fertility Institute of New Orleans Mandeville location",
        "_source": {
          "url": "https://fertilityinstitute.com/locations/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Louisiana (LA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-fino-metairie",
    "externalIds": {
      "googlePlaceId": "ChIJ5Zq2SmewIIYRHZOPALJxrBc"
    },
    "type": "fertility-clinic",
    "name": "Fertility Institute of New Orleans - Metairie",
    "phone": "(504) 454-2165",
    "address": {
      "line1": "4770 S I-10 Service Road West, Suite 201",
      "city": "Metairie",
      "state": "LA",
      "zip": "70001",
      "country": "US"
    },
    "location": {
      "lat": 29.9956707,
      "lng": -90.1821817
    },
    "website": "https://fertilityinstitute.com/locations/new-orleans/",
    "treatments": [
      {
        "name": "IVF with donor eggs or sperm",
        "category": "art",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation induction",
        "category": "art",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility surgery",
        "category": "surgical",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Male infertility treatments",
        "category": "diagnostic",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Genetic testing and counseling",
        "category": "diagnostic",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Preimplantation genetic testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg and embryo freezing",
        "category": "preservation",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Oncofertility",
        "category": "preservation",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "specialties": ["reproductive-endocrinology", "male-infertility"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "network": {
      "name": "Fertility Institute of New Orleans"
    },
    "setting": "network-group",
    "description": "The Fertility Institute of New Orleans provides fertility testing, IUI, IVF, genetic testing, fertility preservation, male infertility treatments, and reproductive surgery across Metairie, Baton Rouge, and Mandeville.",
    "team": [
      {
        "practitionerId": "pr-org-satellite-fino-metairie-warren-jay-huber-md-phd",
        "name": "Warren Jay Huber, MD, PhD",
        "role": "Medical Director",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://fertilityinstitute.com/wp-content/uploads/2023/12/photo-fino-doctor-Warren-Jay-Huber-e1620321937309-1024x1024.jpg",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fino-metairie-peter-lu-md",
        "name": "Peter Lu, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://fertilityinstitute.com/wp-content/uploads/2024/03/photo-fino-doctor-Peter-Lu-e1620321677334-1024x1024.jpg",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fino-metairie-ronald-clisham-md",
        "name": "Ronald Clisham, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://fertilityinstitute.com/wp-content/uploads/2023/10/doc-pic-5.jpg",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fino-metairie-stacey-scheib-md",
        "name": "Stacey Scheib, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://fertilityinstitute.com/wp-content/uploads/2024/04/Stacy-Headshot-Screen-Res-1024x1024.jpg",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fino-metairie-nicole-ulrich-md",
        "name": "Nicole Ulrich, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://fertilityinstitute.com/wp-content/uploads/2025/01/Nicole-ulrich-square-1024x1024.jpg",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fino-metairie-erin-cheneval-fnp",
        "name": "Erin Cheneval, FNP",
        "role": "Family Nurse Practitioner",
        "credentials": ["FNP"],
        "specialty": "Fertility Nursing",
        "imageUrl": "https://fertilityinstitute.com/wp-content/uploads/2023/12/photo-FINO-Erin-Cheneval-1-e1675285466212-1024x1024.jpg",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk1cSR43LHvFQby4Fv-ATOYP5HqxQsCI-89ogiG_3KApd7Ac_U2yvr0lhavL8WAuuymXdR_6fdeea1QyGm0LbvFLlKGZaWaJYs6SqFhCDHAZLILHSerSrGvL9spYAASKXc4yP_06-p-bSQ=w140-h248-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/The+Fertility+Institute+of+New+Orleans+%E2%80%93+Metairie,+4770+S+I-10+Service+Rd+W+%23201,+Metairie,+LA+70001/@29.9981513,-90.1875986,3455a,13.1y/data=!4m2!3m1!1s0x8620b0674ab69ae5:0x17ac71b2008f931d",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://fertilityinstitute.com/locations/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://fertilityinstitute.com/locations/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://fertilityinstitute.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://fertilityinstitute.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://fertilityinstitute.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/The+Fertility+Institute+of+New+Orleans+%E2%80%93+Metairie,+4770+S+I-10+Service+Rd+W+%23201,+Metairie,+LA+70001/@29.9981513,-90.1875986,3455a,13.1y/data=!4m2!3m1!1s0x8620b0674ab69ae5:0x17ac71b2008f931d",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Louisiana (LA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-fino-baton-rouge",
    "externalIds": {
      "googlePlaceId": "ChIJe4ZTgVCkJoYR4KpS_DZG8qc"
    },
    "type": "fertility-clinic",
    "name": "Fertility Institute of New Orleans - Baton Rouge",
    "phone": "(504) 454-2165",
    "address": {
      "line1": "5207 Essen Lane, Suite 2",
      "city": "Baton Rouge",
      "state": "LA",
      "zip": "70809",
      "country": "US"
    },
    "location": {
      "lat": 30.4007932,
      "lng": -91.1057775
    },
    "website": "https://fertilityinstitute.com/locations/baton-rouge/",
    "treatments": [
      {
        "name": "IVF with donor eggs or sperm",
        "category": "art",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation induction",
        "category": "art",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility surgery",
        "category": "surgical",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Male infertility treatments",
        "category": "diagnostic",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Genetic testing and counseling",
        "category": "diagnostic",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Preimplantation genetic testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg and embryo freezing",
        "category": "preservation",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Oncofertility",
        "category": "preservation",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "specialties": ["reproductive-endocrinology", "male-infertility"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "network": {
      "name": "Fertility Institute of New Orleans"
    },
    "setting": "network-group",
    "description": "The Fertility Institute of New Orleans provides fertility testing, IUI, IVF, genetic testing, fertility preservation, male infertility treatments, and reproductive surgery across Metairie, Baton Rouge, and Mandeville.",
    "team": [
      {
        "practitionerId": "pr-org-satellite-fino-baton-rouge-warren-jay-huber-md-phd",
        "name": "Warren Jay Huber, MD, PhD",
        "role": "Medical Director",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://fertilityinstitute.com/wp-content/uploads/2023/12/photo-fino-doctor-Warren-Jay-Huber-e1620321937309-1024x1024.jpg",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fino-baton-rouge-peter-lu-md",
        "name": "Peter Lu, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://fertilityinstitute.com/wp-content/uploads/2024/03/photo-fino-doctor-Peter-Lu-e1620321677334-1024x1024.jpg",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fino-baton-rouge-ronald-clisham-md",
        "name": "Ronald Clisham, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://fertilityinstitute.com/wp-content/uploads/2023/10/doc-pic-5.jpg",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fino-baton-rouge-stacey-scheib-md",
        "name": "Stacey Scheib, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://fertilityinstitute.com/wp-content/uploads/2024/04/Stacy-Headshot-Screen-Res-1024x1024.jpg",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fino-baton-rouge-nicole-ulrich-md",
        "name": "Nicole Ulrich, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://fertilityinstitute.com/wp-content/uploads/2025/01/Nicole-ulrich-square-1024x1024.jpg",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fino-baton-rouge-erin-cheneval-fnp",
        "name": "Erin Cheneval, FNP",
        "role": "Family Nurse Practitioner",
        "credentials": ["FNP"],
        "specialty": "Fertility Nursing",
        "imageUrl": "https://fertilityinstitute.com/wp-content/uploads/2023/12/photo-FINO-Erin-Cheneval-1-e1675285466212-1024x1024.jpg",
        "_source": {
          "url": "https://fertilityinstitute.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [
      {
        "url": "https://fertilityinstitute.com/wp-content/uploads/2023/12/baton-rouge-2025.png",
        "type": "exterior",
        "caption": "Fertility Institute of New Orleans Baton Rouge location",
        "_source": {
          "url": "https://fertilityinstitute.com/locations/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnFnpCuvLxmdIl4olMgNY-cDx-9qCzNAvFgusCMFKt1UzXTQrJGX9o7YJLdkSnsCnkewJs8iIxyAy-QLhh78Xej8-kG9V1gNFedqqZL3WqXJcug2MwfSmtEzjYBGq-BRJ04AqhMgSwmCgo=w408-h408-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/The+Fertility+Institute+of+New+Orleans+%E2%80%93+Baton+Rouge,+Essen+Oaks+Complex,+5207+Essen+Ln+%232,+Baton+Rouge,+LA+70809/@30.4003711,-91.1052292,3441a,13.1y/data=!4m2!3m1!1s0x8626a4508153867b:0xa7f24636fc52aae0",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://fertilityinstitute.com/locations/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://fertilityinstitute.com/locations/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://fertilityinstitute.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://fertilityinstitute.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://fertilityinstitute.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/The+Fertility+Institute+of+New+Orleans+%E2%80%93+Baton+Rouge,+Essen+Oaks+Complex,+5207+Essen+Ln+%232,+Baton+Rouge,+LA+70809/@30.4003711,-91.1052292,3441a,13.1y/data=!4m2!3m1!1s0x8626a4508153867b:0xa7f24636fc52aae0",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Louisiana (LA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-154",
    "externalIds": {
      "cdcClinicId": "154"
    },
    "type": "fertility-clinic",
    "name": "Baystate Reproductive Medicine",
    "phone": "(413) 794-1950",
    "address": {
      "line1": "Tolosky Center, 3300 Main St, Suite 4C",
      "city": "Springfield",
      "state": "MA",
      "zip": "1199",
      "country": "US"
    },
    "location": {
      "lat": 42.123,
      "lng": -72.61
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 39.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 35.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 30.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 10.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 386,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27154%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27154%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.baystatehealth.org/locations/tolosky-center",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-154-cynthia-k-sites-md",
        "name": "Cynthia K. Sites, MD",
        "role": "Medical Director",
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/baystate/photos/500/sites-cynthia-1821017450.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://www.baystatehealth.org/providers/cynthia-k-sites",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Kelly A. Lynch, MD",
        "role": "Reproductive Endocrinologist (Reproductive Endocrinology and Infertility)",
        "credentials": ["MD"],
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/baystate/photos/500/lynch-kelly-1790885804.jpg",
        "_source": {
          "url": "https://www.baystatehealth.org/providers/kelly-a-lynch",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-154-kelly-a-lynch-md"
      }
    ],
    "website": "https://www.baystatehealth.org/services/reproductive-medicine",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Harvard Pilgrim",
        "Tufts Health Plan"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://kyruus-app-static.kyruus.com/providermatch/baystate/location-photos/public/LOC0000007675-79893.jpg",
        "type": "exterior",
        "caption": "Exterior of the Tolosky Center at 3300 Main Street, Springfield, MA, the building housing Baystate Reproductive Medicine (Suite 4C)",
        "_source": {
          "url": "https://www.baystatehealth.org/locations/tolosky-center",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Harvard Pilgrim, Tufts Health Plan",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-490",
    "externalIds": {
      "cdcClinicId": "490"
    },
    "type": "fertility-clinic",
    "name": "Boston IVF, LLC",
    "phone": "(781) 434-6500",
    "address": {
      "line1": "130 Second Ave",
      "city": "Waltham",
      "state": "MA",
      "zip": "2451",
      "country": "US"
    },
    "location": {
      "lat": 42.3928,
      "lng": -71.2638
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 46.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 40.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 38,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 19.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 510,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27490%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27490%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.bostonivf.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/locations/the-waltham-ma-fertility-center",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-490-michael-m-alper-md",
        "name": "Michael M. Alper, MD",
        "role": "Medical Director",
        "imageUrl": "https://findadoc.bidmc.org/Custom/Photos/hires/28.jpg",
        "credentials": [
          "MD",
          "Board Certified in Obstetrics and Gynecology",
          "Board Certified in Reproductive Endocrinology and Infertility"
        ],
        "_source": {
          "url": "https://findadoc.bidmc.org/details/28/michael-alper-reproductive_endocrinology_infertility-boston-south_portland-waltham",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "network": {
      "name": "Boston IVF"
    },
    "website": "https://www.bostonivf.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield of Massachusetts",
        "Blue Cross Blue Shield of Rhode Island",
        "Blue Cross Blue Shield PPO (out-of-state)",
        "Carelink",
        "Carrot",
        "CDPHP",
        "Cigna",
        "Cofertility/EggCo",
        "Emblem Health",
        "Excellus Blue Cross Blue Shield",
        "Empire Blue Cross Blue Shield",
        "GHI",
        "GIC Indemnity",
        "Harvard Pilgrim",
        "Health New England",
        "Highmark Blue Shield of Northeastern NY",
        "Highmark Blue Cross Federal",
        "Maine Community Health Options",
        "Mass General Brigham Health Plan",
        "Maven",
        "NYS Empire Plan",
        "PHCS",
        "Progyny",
        "Stork Club",
        "Tricare",
        "Tufts Health Direct",
        "Unicare",
        "United Healthcare",
        "WellSense Health Plan",
        "WIN Fertility/Premier"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.bostonivf.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield of Massachusetts, Blue Cross Blue Shield of Rhode Island, Blue Cross Blue Shield PPO (out-of-state), Carelink, Carrot, CDPHP, Cigna",
              "detail": "23 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.bostonivf.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-473",
    "externalIds": {
      "cdcClinicId": "473"
    },
    "type": "fertility-clinic",
    "name": "Brigham and Women's Hospital Center for Assisted Reproductive Technology",
    "description": "One of the largest academic medical center-based fertility programs in the US, part of Mass General Brigham, with nationally-certified in-house laboratories.",
    "website": "https://www.brighamandwomens.org/obgyn/center-for-infertility-and-reproductive-surgery",
    "phone": "(617) 732-5570",
    "bookingUrl": "https://www.brighamandwomens.org/forms/landing/infertility/contact",
    "address": {
      "line1": "75 Francis St",
      "city": "Boston",
      "state": "MA",
      "zip": "2115",
      "country": "US"
    },
    "location": {
      "lat": 42.3362,
      "lng": -71.1067
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "financingOptions": ["Payment plans"]
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 46.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 41,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 41.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 21.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1270,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27473%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "languages": ["es"],
    "consultationTypes": ["in-person", "telehealth"],
    "patientGroups": ["LGBTQIA+", "Same sex couples"],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27473%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "scraped"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.brighamandwomens.org/obgyn/infertility-reproductive-surgery/our-doctors",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "scraped"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-473-serene-s-srouji-md",
        "name": "Serene S. Srouji, MD",
        "role": "Medical Director",
        "imageUrl": "https://physiciandirectory.brighamandwomens.org/Custom/Photos/hires/1793.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://physiciandirectory.brighamandwomens.org/Details/1793",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Rachel K. Ashby, MD",
        "role": "Director, Donor Egg and Gestational Carrier Program; Reproductive Endocrinologist / OB-GYN",
        "credentials": ["MD"],
        "imageUrl": "https://physiciandirectory.brighamandwomens.org/Custom/Photos/hires/1270.jpg",
        "_source": {
          "url": "https://physiciandirectory.brighamandwomens.org/Details/1270",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-473-rachel-k-ashby-md"
      },
      {
        "name": "Robert L. Barbieri, MD",
        "role": "Chairman Emeritus, Obstetrics and Gynecology and Reproductive Biology; OB-GYN",
        "credentials": ["MD"],
        "imageUrl": "https://physiciandirectory.brighamandwomens.org/Custom/Photos/hires/1430.jpg",
        "_source": {
          "url": "https://physiciandirectory.brighamandwomens.org/Details/1430",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-473-robert-l-barbieri-md"
      },
      {
        "name": "Janis H. Fox, MD",
        "role": "Reproductive Endocrinologist / OB-GYN; Assistant Professor, Harvard Medical School",
        "credentials": ["MD"],
        "imageUrl": "https://physiciandirectory.brighamandwomens.org/Custom/Photos/hires/386.jpg",
        "_source": {
          "url": "https://physiciandirectory.brighamandwomens.org/Details/386",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-473-janis-h-fox-md"
      },
      {
        "name": "Elizabeth S. Ginsburg, MD",
        "role": "Fellowship Director, Reproductive Endocrinology and Infertility Program; Reproductive Endocrinologist / OB-GYN; Professor, Harvard Medical School",
        "credentials": ["MD"],
        "imageUrl": "https://physiciandirectory.brighamandwomens.org/Custom/Photos/hires/773.jpg",
        "_source": {
          "url": "https://physiciandirectory.brighamandwomens.org/Details/773",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-473-elizabeth-s-ginsburg-md"
      },
      {
        "name": "Mark D. Hornstein, MD",
        "role": "Director, Reproductive Endocrinology Division; Reproductive Endocrinologist / OB-GYN; Professor, Harvard Medical School",
        "credentials": ["MD"],
        "imageUrl": "https://physiciandirectory.brighamandwomens.org/Custom/Photos/hires/955.jpg",
        "_source": {
          "url": "https://physiciandirectory.brighamandwomens.org/Details/955",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-473-mark-d-hornstein-md"
      },
      {
        "name": "Marc R. Laufer, MD",
        "role": "Chief, Division of Pediatric and Adolescent Gynecology; OB-GYN; Professor, Harvard Medical School",
        "credentials": ["MD"],
        "imageUrl": "https://physiciandirectory.brighamandwomens.org/Custom/Photos/hires/1064.jpg",
        "_source": {
          "url": "https://physiciandirectory.brighamandwomens.org/Details/1064",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-473-marc-r-laufer-md"
      },
      {
        "name": "Brian W. Walsh, MD",
        "role": "Reproductive Endocrinologist / OB-GYN; Associate Professor, Harvard Medical School",
        "credentials": ["MD"],
        "imageUrl": "https://physiciandirectory.brighamandwomens.org/Custom/Photos/hires/1518.jpg",
        "_source": {
          "url": "https://physiciandirectory.brighamandwomens.org/Details/1518",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-473-brian-w-walsh-md"
      },
      {
        "name": "Elena H. Yanushpolsky, MD",
        "role": "Director, Reproductive Surgery; Reproductive Endocrinologist / OB-GYN; Assistant Professor, Harvard Medical School",
        "credentials": ["MD"],
        "imageUrl": "https://physiciandirectory.brighamandwomens.org/Custom/Photos/hires/1566.jpg",
        "_source": {
          "url": "https://physiciandirectory.brighamandwomens.org/Details/1566",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-473-elena-h-yanushpolsky-md"
      },
      {
        "name": "Kimberly W. Keefe Smith, MD",
        "role": "Reproductive Endocrinologist / OB-GYN",
        "credentials": ["MD"],
        "imageUrl": "https://physiciandirectory.brighamandwomens.org/Custom/Photos/hires/13411.jpg",
        "_source": {
          "url": "https://physiciandirectory.brighamandwomens.org/details/13411/kimberly-keefe_smith-obstetrics_gynecology-boston",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-473-kimberly-w-keefe-smith-md"
      },
      {
        "name": "Zachary W. Walker, MD",
        "role": "Reproductive Endocrinologist / OB-GYN; Instructor, Harvard Medical School",
        "credentials": ["MD"],
        "imageUrl": "https://physiciandirectory.brighamandwomens.org/Custom/Photos/hires/17506.jpg",
        "_source": {
          "url": "https://physiciandirectory.brighamandwomens.org/details/17506/zachary-walker-obstetrics_gynecology-boston",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-473-zachary-w-walker-md"
      }
    ],
    "setting": "hospital-based",
    "images": [
      {
        "url": "https://www.brighamandwomens.org/assets/BWH/images/bwh-exterior-default.png",
        "type": "exterior",
        "caption": "Brigham and Women's Hospital main building exterior at 75 Francis Street, Boston, where the Center for Infertility and Reproductive Surgery is located",
        "_source": {
          "url": "https://www.brighamandwomens.org/obgyn/center-for-infertility-and-reproductive-surgery",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-801",
    "externalIds": {
      "cdcClinicId": "801",
      "googlePlaceId": "ChIJN7Wifpd444kR4P15o4tGiD0"
    },
    "type": "fertility-clinic",
    "name": "CCRM Boston",
    "phone": "(617) 449-9750",
    "address": {
      "line1": "300 Boylston St, Suite 300",
      "city": "Newton",
      "state": "MA",
      "zip": "2459",
      "country": "US"
    },
    "location": {
      "lat": 42.3186,
      "lng": -71.18
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 65.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 57.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 60.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 60,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 869,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27801%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27801%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/massachusetts/boston/fertility-doctors/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Boston,+300+Boylston+St+Suite+300,+Newton,+MA+02459/@42.3187276,-71.1801894,2950a,13.1y/data=!4m2!3m1!1s0x89e378977ea2b537:0x3d88468ba379fde0",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-801-alison-zimon-md",
        "name": "Alison Zimon, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Alison_Zimon_600x600_2x.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/alison-zimon/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Aaron K. Styer, MD",
        "role": "Co-Founding Physician & Co-Medical Director, Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Aaron_Styer_600x600_2x.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/aaron-styer/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-801-aaron-k-styer-md"
      },
      {
        "name": "Katherine Koniares, MD, MSCTR",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MSCTR"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/08/Katherine_Koniares_600x600_2x.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/katherine-koniares/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-801-katherine-koniares-md-msctr"
      },
      {
        "name": "Jessica Ryniec, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Jessica_Ryniec_600x600_2x.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/jessica-ryniec/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-801-jessica-ryniec-md"
      }
    ],
    "website": "https://www.ccrmivf.com/boston",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Harvard Pilgrim",
        "Tufts Health Plan"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Harvard Pilgrim, Tufts Health Plan",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmT2dqXGxyk8kk8oR4oytorrgWYZvvZnxh9HIvd_4CydUon3dmil96NSbaVhM2Ie0v9aZJwDlNbjJE-uKnHLc8CatNroQ8mllsKWytQdaacFrNsej6PRFKpF57gm_3Aerg_wZLZ=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Boston,+300+Boylston+St+Suite+300,+Newton,+MA+02459/@42.3187276,-71.1801894,2950a,13.1y/data=!4m2!3m1!1s0x89e378977ea2b537:0x3d88468ba379fde0",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlGujPCjE9c-9uYw4qGg4EdrHsiXBwgIcrbStl8H9JbxsK_vaQ-Oj7PBbHBYmNui9CViO59-L-Um7aX0kuGqrK5A_hrB2HoUTyidk8lJcpVLNjWF70Y0mD5lUBtg2Bs917pPW7n=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Boston,+300+Boylston+St+Suite+300,+Newton,+MA+02459/@42.3187276,-71.1801894,2950a,13.1y/data=!4m2!3m1!1s0x89e378977ea2b537:0x3d88468ba379fde0",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-720",
    "externalIds": {
      "cdcClinicId": "720",
      "googlePlaceId": "ChIJBb7tIVYL44kRJ5nq2OaxBZM"
    },
    "type": "fertility-clinic",
    "name": "Fertility Centers of New England, Inc., New England Clinics of Reproductive Medicine, Inc.",
    "phone": "(781) 942-7000",
    "address": {
      "line1": "20 Pond Meadow Dr, Suite 101",
      "city": "Reading",
      "state": "MA",
      "zip": "1867",
      "country": "US"
    },
    "location": {
      "lat": 42.5166,
      "lng": -71.0992
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 45.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 44.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 41,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 28.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 833,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27720%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27720%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitycenter.com/locations/the-reading-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+New+England+Reading,+20+Pondmeadow+Dr+Ste+101,+Reading,+MA+01867/@42.5166286,-71.0991794,2941a,13.1y/data=!4m2!3m1!1s0x89e30b5621edbe05:0x9305b1e6d8ea9927",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-720-danielle-vitiello-md-phd",
        "name": "Danielle Vitiello, MD, PHD",
        "role": "Medical Director",
        "imageUrl": "https://www.fertilitycenter.com/wp-content/uploads/2020/02/photo-Vitiello.jpg",
        "credentials": ["MD", "PhD", "FACOG"],
        "_source": {
          "url": "https://www.fertilitycenter.com/about-us/danielle-vitiello-phd-md/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "network": {
      "name": "Fertility Centers of New England"
    },
    "website": "https://www.fertilitycenter.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Harvard Pilgrim",
        "Tufts Health Plan"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "images": [
      {
        "url": "https://www.fertilitycenter.com/wp-content/uploads/2019/06/location-reading.jpg",
        "type": "exterior",
        "caption": "Exterior entrance of the Reading Health Center building, home of Fertility Centers of New England's Reading, MA location",
        "_source": {
          "url": "https://www.fertilitycenter.com/locations/the-reading-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkb2aRLkdtF2PwaZ2hCggYScP50f1lHFhJPnGlw2fYxNDX123XtrZb3wIaK9qwDigaf9E1alMSLvwGU9ZK07uelikglcjmHzz6X91lLuKy40jZX0gZr68PdrBohI_K7Rv30-Gf1=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+New+England+Reading,+20+Pondmeadow+Dr+Ste+101,+Reading,+MA+01867/@42.5166286,-71.0991794,2941a,13.1y/data=!4m2!3m1!1s0x89e30b5621edbe05:0x9305b1e6d8ea9927",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Harvard Pilgrim, Tufts Health Plan",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-341",
    "externalIds": {
      "cdcClinicId": "341"
    },
    "type": "fertility-clinic",
    "name": "Fertility Solutions, PC",
    "phone": "(781) 326-2451",
    "address": {
      "line1": "45 Stergis Way",
      "city": "Dedham",
      "state": "MA",
      "zip": "2026",
      "country": "US"
    },
    "location": {
      "lat": 42.2343,
      "lng": -71.1764
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 37.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 43.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 25.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 11.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 380,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27341%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27341%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://fertilitysolutionsne.com",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-341-ania-kowalik-md",
        "name": "Ania Kowalik, MD",
        "role": "Medical Director",
        "imageUrl": "https://cdn.buttercms.com/l7Fa6GuSEiM85EwVJzGC",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.ivfmd.com/fertility-specialist/ania-kowalik",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Pei-Li Huang, MD",
        "role": "Reproductive Endocrinologist (Reproductive Endocrinology & Infertility)",
        "credentials": ["MD"],
        "imageUrl": "https://www.fertilitycenter.com/wp-content/uploads/2024/02/Pei-Li-Huana-M.D.-Thumbnail.jpeg",
        "_source": {
          "url": "https://www.fertilitycenter.com/about-us/pei-li-huang-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-341-pei-li-huang-md"
      }
    ],
    "website": "https://www.fertilitysolutions.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Harvard Pilgrim",
        "Tufts Health Plan"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Harvard Pilgrim, Tufts Health Plan",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-226",
    "externalIds": {
      "cdcClinicId": "226",
      "googlePlaceId": "ChIJ_4KF7Jlw44kRLCMcKbC11gk"
    },
    "type": "fertility-clinic",
    "name": "Massachusetts General Hospital Fertility Center",
    "phone": "(617) 726-8868",
    "address": {
      "line1": "32 Fruit St, Yawkey 10A",
      "city": "Boston",
      "state": "MA",
      "zip": "2114",
      "country": "US"
    },
    "location": {
      "lat": 42.362,
      "lng": -71.0695
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 42.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 42.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 32,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 16.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 943,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27226%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27226%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.massgeneral.org/obgyn/fertility",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Massachusetts+General+Hospital:+Fertility+Center,+Mass+General+Yawkey+Center+for+Outpatient+Care,+32+Fruit+St+%2310A,+Boston,+MA+02114/@42.3620194,-71.0694942,2948a,13.1y/data=!4m2!3m1!1s0x89e37099ec8582ff:0x9d6b5b0291c232c",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-226-john-c-petrozza-md",
        "name": "John C. Petrozza, MD",
        "role": "Medical Director",
        "imageUrl": "https://advances.massgeneral.org/assets/images/contributors/john_pedrozza_advances_2x.png",
        "credentials": ["MD"],
        "_source": {
          "url": "https://advances.massgeneral.org/contributors/contributor.aspx?id=1247",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Eden Cardozo, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://px.massgeneral.connecthealthcare.com/Custom/Photos/HiRes/6523.jpg",
        "_source": {
          "url": "https://www.massgeneral.org/obgyn/fertility/about/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-226-eden-cardozo-md"
      },
      {
        "name": "Irene Dimitriadis, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://px.massgeneral.connecthealthcare.com/Custom/Photos/HiRes/4583.jpg",
        "_source": {
          "url": "https://www.massgeneral.org/obgyn/fertility/about/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-226-irene-dimitriadis-md"
      },
      {
        "name": "Victoria Fitz, MD, MS",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MS"],
        "imageUrl": "https://px.massgeneral.connecthealthcare.com/Custom/Photos/HiRes/6481.jpg",
        "_source": {
          "url": "https://www.massgeneral.org/obgyn/fertility/about/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-226-victoria-fitz-md-ms"
      },
      {
        "name": "Shruthi Mahalingaiah, MD, MS",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MS"],
        "imageUrl": "https://px.massgeneral.connecthealthcare.com/Custom/Photos/HiRes/3889.jpg",
        "_source": {
          "url": "https://www.massgeneral.org/obgyn/fertility/about/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-226-shruthi-mahalingaiah-md-ms"
      },
      {
        "name": "Evelyn Minis, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://px.massgeneral.connecthealthcare.com/Custom/Photos/HiRes/7690.jpg",
        "_source": {
          "url": "https://www.massgeneral.org/obgyn/fertility/about/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-226-evelyn-minis-md"
      },
      {
        "name": "Mitchell Rein, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://px.massgeneral.connecthealthcare.com/Custom/Photos/HiRes/5111.jpg",
        "_source": {
          "url": "https://www.massgeneral.org/obgyn/fertility/about/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-226-mitchell-rein-md"
      },
      {
        "name": "Jan Shifren, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://px.massgeneral.connecthealthcare.com/Custom/Photos/HiRes/4297.jpg",
        "_source": {
          "url": "https://www.massgeneral.org/obgyn/fertility/about/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-226-jan-shifren-md"
      },
      {
        "name": "Irene Souter, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://px.massgeneral.connecthealthcare.com/Custom/Photos/HiRes/3921.jpg",
        "_source": {
          "url": "https://www.massgeneral.org/obgyn/fertility/about/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-226-irene-souter-md"
      }
    ],
    "website": "https://www.massgeneral.org/fertility",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Harvard Pilgrim",
        "Tufts Health Plan"
      ],
      "employeeBenefits": ["Progyny"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Harvard Pilgrim, Tufts Health Plan",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-856",
    "externalIds": {
      "cdcClinicId": "856"
    },
    "type": "fertility-clinic",
    "name": "UMass Memorial IVF Center",
    "phone": "(508) 334-9849",
    "address": {
      "line1": "33 Kendall St, Levine 2",
      "city": "Worcester",
      "state": "MA",
      "zip": "1605",
      "country": "US"
    },
    "location": {
      "lat": 42.274,
      "lng": -71.7933
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 30.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 40,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/15"
        }
      ],
      "cyclesPerYear": 70,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27856%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27856%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-856-meaghan-delaney-md",
        "name": "Meaghan Delaney, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.umassmemorialhealthcare.org",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Harvard Pilgrim",
        "Tufts Health Plan"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://www.ummhealth.org/sites/default/files/styles/location_teaser/public/2025-04/UMMMC-33-kendall-street-levine-v3.jpg.webp",
        "type": "exterior",
        "caption": "Exterior of the Peter H. Levine Ambulatory Center at 33 Kendall Street, UMass Memorial Medical Center - Memorial Campus, Worcester, MA (the exact clinic address; signage reads '33 Kendall Street' and 'Peter H. Levine Ambulatory Center').",
        "_source": {
          "url": "https://www.ummhealth.org/services-treatments/obstetrics-gynecology/fertility-reproductive-endocrinology-ivf",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.ummhealth.org/sites/default/files/styles/location_teaser/public/2024-12/UMMC_Memorial%20Campus_Entrance_960x465.jpg.webp",
        "type": "exterior",
        "caption": "Main entrance of UMass Memorial Medical Center - Memorial Campus, Worcester, MA, the campus where the IVF / Reproductive Endocrinology and Infertility Center is located.",
        "_source": {
          "url": "https://www.ummhealth.org/services-treatments/obstetrics-gynecology/fertility-reproductive-endocrinology-ivf",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Harvard Pilgrim, Tufts Health Plan",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-58",
    "externalIds": {
      "cdcClinicId": "58",
      "googlePlaceId": "ChIJ-5S21LURyIkRrQWY0HEImWA"
    },
    "type": "fertility-clinic",
    "name": "Johns Hopkins Fertility Center",
    "phone": "(410) 847-3835",
    "address": {
      "line1": "10755 Falls Rd, Pavilion I, Suite 480",
      "city": "Lutherville",
      "state": "MD",
      "zip": "21093",
      "country": "US"
    },
    "location": {
      "lat": 39.4207,
      "lng": -76.6666
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 50.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 58.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 42,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 27.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 565,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2758%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2758%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.hopkinsmedicine.org/gynecology-obstetrics/specialty-areas/fertility-center/our-team",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Johns+Hopkins+Fertility+Center,+10755+Falls+Road+Pavillion+I,+%23403,+Timonium,+MD+21093/@39.421166,-76.6672144,3082a,13.1y/data=!4m2!3m1!1s0x89c811b5d4b694fb:0x60990871d09805ad",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-58-valerie-lynn-baker-md-mpp",
        "name": "Valerie Lynn Baker, MD, MPP",
        "role": "Director, Division of Reproductive Endocrinology and Infertility",
        "credentials": ["MD", "MPP"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/johnshopkins/photos/orig/baker-valerie-1790882603.jpg",
        "_source": {
          "url": "https://www.hopkinsmedicine.org/gynecology-obstetrics/specialty-areas/fertility-center/our-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-58-katie-e-cameron-md-mbe",
        "name": "Katie E. Cameron, MD, MBE",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MBE"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/johnshopkins/photos/orig/cameron-katherine-1770928251.jpg",
        "_source": {
          "url": "https://www.hopkinsmedicine.org/gynecology-obstetrics/specialty-areas/fertility-center/our-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-58-kamaria-c-cayton-vaught-md",
        "name": "Kamaria C. Cayton Vaught, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/johnshopkins/photos/orig/cayton-kamaria-1649569542.jpg",
        "_source": {
          "url": "https://www.hopkinsmedicine.org/gynecology-obstetrics/specialty-areas/fertility-center/our-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-58-endrika-leon-hinton-md",
        "name": "Endrika Leon Hinton, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/johnshopkins/photos/orig/hinton-endrika-1477561579.jpg",
        "_source": {
          "url": "https://www.hopkinsmedicine.org/gynecology-obstetrics/specialty-areas/fertility-center/our-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-58-pardis-hosseinzadeh-md-msc",
        "name": "Pardis Hosseinzadeh, MD, MSc",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MSc"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/johnshopkins/photos/orig/hosseinzadeh-pardis-1669829487.jpg",
        "_source": {
          "url": "https://www.hopkinsmedicine.org/gynecology-obstetrics/specialty-areas/fertility-center/our-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-58-vasiliki-moragianni-md-msc",
        "name": "Vasiliki Moragianni, MD, MSc",
        "role": "Medical Director, Fertility Center",
        "credentials": ["MD", "MSc"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/johnshopkins/photos/orig/moragianni-vasiliki-1255591277.jpg",
        "_source": {
          "url": "https://www.hopkinsmedicine.org/gynecology-obstetrics/specialty-areas/fertility-center/our-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-58-james-segars-md",
        "name": "James Segars, MD",
        "role": "Director, Division of Reproductive Science and Women's Health Research",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/johnshopkins/photos/orig/segars-james-1518036482.jpg",
        "_source": {
          "url": "https://www.hopkinsmedicine.org/gynecology-obstetrics/specialty-areas/fertility-center/our-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-58-howard-a-zacur-md",
        "name": "Howard A. Zacur, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/johnshopkins/photos/orig/zacur-howard-1063458602.jpg",
        "_source": {
          "url": "https://www.hopkinsmedicine.org/gynecology-obstetrics/specialty-areas/fertility-center/our-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-58-dana-gebran-aybout-crnp",
        "name": "Dana Gebran Aybout, CRNP",
        "role": "REI Nurse Practitioner",
        "credentials": ["CRNP"],
        "specialty": "Advanced Practice Provider",
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/johnshopkins/photos/500/aybout-dana-1003286493.jpg",
        "_source": {
          "url": "https://www.hopkinsmedicine.org/gynecology-obstetrics/specialty-areas/fertility-center/our-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-58-julie-luterzo-crnp",
        "name": "Julie Luterzo, CRNP",
        "role": "REI Nurse Practitioner",
        "credentials": ["CRNP"],
        "specialty": "Advanced Practice Provider",
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/johnshopkins/photos/500/luterzo-julie-1225199771.jpg",
        "_source": {
          "url": "https://www.hopkinsmedicine.org/gynecology-obstetrics/specialty-areas/fertility-center/our-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-58-stefanie-tyler-crnp-dnp",
        "name": "Stefanie Tyler, CRNP, DNP",
        "role": "REI Nurse Practitioner",
        "credentials": ["CRNP", "DNP"],
        "specialty": "Advanced Practice Provider",
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/johnshopkins/photos/500/tyler-stefanie-1447271804.jpg",
        "_source": {
          "url": "https://www.hopkinsmedicine.org/gynecology-obstetrics/specialty-areas/fertility-center/our-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-58-mark-paul-david-dow-phd",
        "name": "Mark Paul David Dow, PhD",
        "role": "REI Laboratory Director",
        "credentials": ["PhD"],
        "specialty": "Embryology",
        "_source": {
          "url": "https://www.hopkinsmedicine.org/gynecology-obstetrics/specialty-areas/fertility-center/our-team",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.hopkinsmedicine.org/fertility",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "CareFirst"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, CareFirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Maryland (MD) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmajvdQwCfrRU87KxVuwUYEVgKmbl7Rhh15oViadJf6V7TMse3J5hCCMvrS9V5nkJEpvXc4kR4wBIT-h3QtSBzmjVh3IEOWUzeaxRUiJliUqHjCrUnnnxchRBoLsHLvf1RBzZMn=w433-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Johns+Hopkins+Fertility+Center,+10755+Falls+Road+Pavillion+I,+%23403,+Timonium,+MD+21093/@39.421166,-76.6672144,3082a,13.1y/data=!4m2!3m1!1s0x89c811b5d4b694fb:0x60990871d09805ad",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmvFDP0AysjfRhyHt_MlNzCRzV3tGZQuuJAwzd2qb4tjHo4bifvnUT6j4_qFHJ7BFBwRlMJVlbDF9W-C3-cDxkfVUqkEPZslGITNHqowksbZuEeDcs1XL-teDj0_zGeFAxwraqi=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Johns+Hopkins+Fertility+Center,+10755+Falls+Road+Pavillion+I,+%23403,+Timonium,+MD+21093/@39.421166,-76.6672144,3082a,13.1y/data=!4m2!3m1!1s0x89c811b5d4b694fb:0x60990871d09805ad",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-353",
    "externalIds": {
      "cdcClinicId": "353",
      "googlePlaceId": "ChIJ92uXgh3Pt4kRUtQHbAizbdY"
    },
    "type": "fertility-clinic",
    "name": "Montgomery Fertility Center",
    "phone": "(301) 946-6962",
    "address": {
      "line1": "3202 Tower Oaks Blvd, Suite 370",
      "city": "Rockville",
      "state": "MD",
      "zip": "20852",
      "country": "US"
    },
    "location": {
      "lat": 39.0594,
      "lng": -77.1507
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 41.17647058823529,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/17"
        }
      ],
      "cyclesPerYear": 62,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27353%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27353%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://montgomeryfertilitycenter.com/montgomery-fertility-center-doctors/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Montgomery+Fertility+Center,+Tower+Oaks+Professional+Park,+3202+Tower+Oaks+Blvd+%23370,+Rockville,+MD+20852/@39.0593675,-77.1506823,3098a,13.1y/data=!4m2!3m1!1s0x89b7cf1d82976bf7:0xd66db3086c07d452",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-353-oluyemisi-adesanya-famuyiwa-md",
        "name": "Oluyemisi Adesanya-Famuyiwa, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://montgomeryfertilitycenter.com/dr-yemi-adesanya-famuyiwa/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-353-jinping-liu-md-ms-eld",
        "name": "Jinping Liu, MD, MS, ELD",
        "role": "Laboratory Director",
        "credentials": ["MD", "MS", "ELD"],
        "specialty": "Embryology",
        "_source": {
          "url": "https://montgomeryfertilitycenter.com/dr-jinping-liu/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.montgomeryfertilitycenter.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "CareFirst"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, CareFirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Maryland (MD) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl7tl6ATpM9zqROXou0dOMGrvUskQ0OhqOJbBB48q0F6KxwJZJPF-etGFnpgWTVZL4sTZNXub2oAMX6rqx-uw1cPA79u3FBYLXlyIJsA0vby3AQX1T5Hd4BEoPC6ojCMb0f9s_h=w224-h298-k-no-pi-4.2765274-ya331.65573-ro0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Montgomery+Fertility+Center,+Tower+Oaks+Professional+Park,+3202+Tower+Oaks+Blvd+%23370,+Rockville,+MD+20852/@39.0593675,-77.1506823,3098a,13.1y/data=!4m2!3m1!1s0x89b7cf1d82976bf7:0xd66db3086c07d452",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-179",
    "externalIds": {
      "cdcClinicId": "179",
      "googlePlaceId": "ChIJz8OBlFPNt4kRjv9wTzmiIsY"
    },
    "type": "fertility-clinic",
    "name": "Shady Grove Fertility-Rockville",
    "description": "Flagship location of one of the nation's largest fertility networks with 49 locations, home to their largest IVF and embryology laboratory.",
    "website": "https://www.shadygrovefertility.com/locations/maryland/rockville-fertility-center/",
    "phone": "(301) 340-1188",
    "bookingUrl": "https://www.shadygrovefertility.com/appointment/",
    "address": {
      "line1": "9601 Blackwell Rd, 4th Floor",
      "city": "Rockville",
      "state": "MD",
      "zip": "20850",
      "country": "US"
    },
    "location": {
      "lat": 39.1017,
      "lng": -77.1928
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "financingOptions": [
        "Payment plans",
        "Package pricing",
        "Future Family",
        "CapexMD"
      ],
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 47.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 44.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 41.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 27.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 5717,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27179%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "languages": ["es"],
    "consultationTypes": ["in-person", "telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27179%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/maryland/rockville-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Rockville,+9601+Blackwell+Rd+4th+floor,+Rockville,+MD+20850/@39.1016751,-77.1928177,3096a,13.1y/data=!4m2!3m1!1s0x89b7cd539481c3cf:0xc622a2394f70ff8e",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/maryland/rockville-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-179-joseph-doyle-md",
        "name": "Joseph Doyle, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Doyle-850x850-1-150x150.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/rockville-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-179-kathryn-c-humm-md",
        "name": "Kathryn C. Humm, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/01/Kathryn-Humm-profile-150x150.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/rockville-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-179-jeanne-e-o-brien-md",
        "name": "Jeanne E. O'Brien, MD",
        "role": "Medical Director, Rockville ASC",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Jeanne_E._OBrien-150x150.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/rockville-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-179-james-k-robinson-iii-md-ms",
        "name": "James K. Robinson III, MD, MS",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MS"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/06/Robinson-850x850-1-150x150.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/rockville-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-179-lauren-roth-md",
        "name": "Lauren Roth, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/L.-Roth-website-150x150.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/rockville-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-179-david-s-saffan-md",
        "name": "David S. Saffan, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/04/David_S._Saffan_-_Desktop-150x150.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/rockville-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-179-paul-r-shin-md",
        "name": "Paul R. Shin, MD",
        "role": "Director of Reproductive Urology",
        "credentials": ["MD"],
        "specialty": "Urology / Male Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Paul-Shin-website-150x150.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/rockville-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-179-lorna-s-timmreck-md",
        "name": "Lorna S. Timmreck, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Lorna_Timmereck-150x150.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/rockville-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-179-catherine-clough-cnm",
        "name": "Catherine Clough, CNM",
        "role": "Certified Nurse Midwife",
        "credentials": ["CNM"],
        "specialty": "Advanced Practice Provider",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Katie_Clough_main_image-150x150.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/rockville-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-179-ursula-rocha-crnp",
        "name": "Ursula Rocha, CRNP",
        "role": "Nurse Practitioner",
        "credentials": ["CRNP"],
        "specialty": "Advanced Practice Provider",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2026/06/Rocha-850x850-1-150x150.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/rockville-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-179-james-graham-ms-eld",
        "name": "James Graham, MS, ELD",
        "role": "Senior Director of Laboratory Services",
        "credentials": ["MS", "ELD"],
        "specialty": "Embryology",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/06/SGF_Jim-Graham_850x850-150x150.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/rockville-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-179-micah-j-hill-do",
        "name": "Micah J. Hill, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/06/M.Hill-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/hill/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "network": {
      "name": "US Fertility"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Maryland (MD) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlnXbbryvjCxTe_Tv2oWL2DAYuhpXBGjaEFrQXuxEV0Ec7Y5hCqwm7HIG3Qu_8KcOWm_-IXV8V2KXPJTSfXjwA-Ipml0OlNw6OmeGr8olVsQXOFN42rLMG6NBOgbejU_7D_fbbSoEuqM54=w449-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Rockville,+9601+Blackwell+Rd+4th+floor,+Rockville,+MD+20850/@39.1016751,-77.1928177,3096a,13.1y/data=!4m2!3m1!1s0x89b7cd539481c3cf:0xc622a2394f70ff8e",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlUn76jnnxlEMdajMF0IEPl_eEEvyBCKl5A8KTAefrrX5R_5Yn3LunE-n8KY-zXKwNWuHctp7t0a_2WFZQrJYE81eYyiYrMzh2uU2I7BUrLvAqQzAqQAflr84f1d18167hcRGfrN0pBHQfi=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Rockville,+9601+Blackwell+Rd+4th+floor,+Rockville,+MD+20850/@39.1016751,-77.1928177,3096a,13.1y/data=!4m2!3m1!1s0x89b7cd539481c3cf:0xc622a2394f70ff8e",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnOxB1DDhhGmnNhunf3hmeugnigAp3RmWtt1ZOtdbeXfN6Cn-UVsheweXbJ150bg8Y6hoYK6c_wtnpU_C96WGtPe4X_oUqBtre5VEqcF6refAcD1faCpCUMNkydwVV52BFbU79gFA=w224-h298-k-no-pi-20-ya276.63608-ro0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Rockville,+9601+Blackwell+Rd+4th+floor,+Rockville,+MD+20850/@39.1016751,-77.1928177,3096a,13.1y/data=!4m2!3m1!1s0x89b7cd539481c3cf:0xc622a2394f70ff8e",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-108",
    "externalIds": {
      "cdcClinicId": "108"
    },
    "type": "fertility-clinic",
    "name": "Shady Grove Fertility-Towson",
    "description": "Part of US Fertility, one of the nation's largest physician-led fertility networks, with a dedicated Wellness Center offering holistic support services.",
    "website": "https://www.shadygrovefertility.com/locations/maryland/towson-fertility-center/",
    "phone": "(410) 512-8300",
    "bookingUrl": "https://www.shadygrovefertility.com/appointment/",
    "address": {
      "line1": "901 Dulaney Valley Rd, Suite 616",
      "city": "Towson",
      "state": "MD",
      "zip": "21204",
      "country": "US"
    },
    "location": {
      "lat": 39.4068,
      "lng": -76.6003
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "financingOptions": ["Payment plans", "CapexMD"],
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 44.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 44.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 41.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 27.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1547,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27108%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "consultationTypes": ["in-person", "telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27108%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/maryland/towson-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/maryland/towson-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-108-emily-barnard-do",
        "name": "Emily Barnard, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Emily-Barnard-hero-150x150.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/towson-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-108-stephanie-beall-md-phd",
        "name": "Stephanie Beall, MD, PhD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/MicrosoftTeams-image-31-150x150.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/towson-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-108-shelley-dolitsky-md",
        "name": "Shelley Dolitsky, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/01/S.-Dolitsky-website-150x150.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/towson-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-108-jessica-a-marinaro-md",
        "name": "Jessica A. Marinaro, MD",
        "role": "Reproductive Urologist",
        "credentials": ["MD"],
        "specialty": "Urology / Male Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2023/07/J.-Marinaro-850x850-1-150x150.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/towson-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-108-wende-allen-pa-c",
        "name": "Wende Allen, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "specialty": "Advanced Practice Provider",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Wende_Allen_main_image-150x150.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/towson-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-108-emily-opdycke-crnp",
        "name": "Emily Opdycke, CRNP",
        "role": "Nurse Practitioner",
        "credentials": ["CRNP"],
        "specialty": "Advanced Practice Provider",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Emily-Opdycke-hero-150x150.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/towson-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-108-loretta-trumble-crnp",
        "name": "Loretta Trumble, CRNP",
        "role": "Nurse Practitioner",
        "credentials": ["CRNP"],
        "specialty": "Advanced Practice Provider",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Loretta_Trumble_main_image-150x150.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/towson-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-108-james-graham-ms-eld",
        "name": "James Graham, MS, ELD",
        "role": "Senior Director of Laboratory Services",
        "credentials": ["MS", "ELD"],
        "specialty": "Embryology",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/06/SGF_Jim-Graham_850x850-150x150.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/towson-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-108-jeffrey-l-mckeeby-md",
        "name": "Jeffrey L. McKeeby, MD",
        "role": "Medical Director, Towson ASC",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Jeffrey_L._McKeeby-150x150.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/mckeeby/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "network": {
      "name": "US Fertility"
    },
    "languages": ["English", "Spanish"],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Maryland (MD) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-15",
    "externalIds": {
      "cdcClinicId": "15"
    },
    "type": "fertility-clinic",
    "name": "Shady Grove Fertility-Walter Reed, Walter Reed National Military Medical Center",
    "phone": "(301) 400-2144",
    "address": {
      "line1": "8901 Rockville Pike, Bldg 10, Rm 2104",
      "city": "Bethesda",
      "state": "MD",
      "zip": "20889",
      "country": "US"
    },
    "location": {
      "lat": 39.0018,
      "lng": -77.0935
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 48.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 54.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 30.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 277,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2715%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2715%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "verified-none",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/shady-grove-fertility-at-walter-reed-national-military-medical-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/shady-grove-fertility-at-walter-reed-national-military-medical-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/shady-grove-fertility-at-walter-reed-national-military-medical-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [],
    "network": {
      "name": "US Fertility"
    },
    "website": "https://www.shadygrovefertility.com/locations/shady-grove-fertility-at-walter-reed-national-military-medical-center/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Maryland (MD) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-103",
    "externalIds": {
      "cdcClinicId": "103",
      "googlePlaceId": "ChIJM09WXdOeskwRmCT2Z8gQUC0"
    },
    "type": "fertility-clinic",
    "name": "Boston IVF, LLC The Maine Center",
    "phone": "(207) 358-7600",
    "address": {
      "line1": "778 Main St, Suite 2",
      "city": "South Portland",
      "state": "ME",
      "zip": "4106",
      "country": "US"
    },
    "location": {
      "lat": 43.6166,
      "lng": -70.3087
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 47.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 47.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 51.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 369,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27103%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27103%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.bostonivf.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/locations/the-portland-me-fertility-center",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Boston+IVF,+778+Main+St+%232,+South+Portland,+ME+04106/@43.6165576,-70.3087144,2889a,13.1y/data=!4m2!3m1!1s0x4cb29ed35d564f33:0x2d5010c867f62498",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.bostonivf.com/locations/the-portland-me-fertility-center",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-103-benjamin-m-lannon-md",
        "name": "Benjamin M. Lannon, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.bostonivf.com/thumbs/B-Lannon_thumb-physicians-main.png?v=71d4e",
        "_source": {
          "url": "https://www.bostonivf.com/physicians/ben-lannon",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-103-kristen-adams-pa-c-cm",
        "name": "Kristen Adams, PA-C, CM",
        "role": "Physician Assistant",
        "credentials": ["PA-C", "CM"],
        "specialty": "Physician Assistant",
        "imageUrl": "https://www.bostonivf.com/thumbs/kristen-adams_thumb-physicians-list.png?v=0c677",
        "_source": {
          "url": "https://www.bostonivf.com/locations/the-portland-me-fertility-center",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-103-alexandra-huttler-md",
        "name": "Alexandra Huttler, MD",
        "role": "REI Fellow",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.bostonivf.com/thumbs/AHuttler_thumb-physicians-list.png?v=1f77d",
        "_source": {
          "url": "https://www.bostonivf.com/locations/the-portland-me-fertility-center",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "network": {
      "name": "Boston IVF"
    },
    "website": "https://www.bostonivf.com/locations/the-portland-me-fertility-center",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield of Massachusetts",
        "Blue Cross Blue Shield of Rhode Island",
        "Blue Cross Blue Shield PPO (out-of-state)",
        "Carelink",
        "Carrot",
        "CDPHP",
        "Cigna",
        "Cofertility/EggCo",
        "Emblem Health",
        "Excellus Blue Cross Blue Shield",
        "Empire Blue Cross Blue Shield",
        "GHI",
        "GIC Indemnity",
        "Harvard Pilgrim",
        "Health New England",
        "Highmark Blue Shield of Northeastern NY",
        "Highmark Blue Cross Federal",
        "Maine Community Health Options",
        "Mass General Brigham Health Plan",
        "Maven",
        "NYS Empire Plan",
        "PHCS",
        "Progyny",
        "Stork Club",
        "Tricare",
        "Tufts Health Direct",
        "Unicare",
        "United Healthcare",
        "WellSense Health Plan",
        "WIN Fertility/Premier"
      ],
      "_source": {
        "url": "https://www.bostonivf.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield of Massachusetts, Blue Cross Blue Shield of Rhode Island, Blue Cross Blue Shield PPO (out-of-state), Carelink, Carrot, CDPHP, Cigna",
              "detail": "23 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.bostonivf.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Maine (ME) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl8s6o7lSQQosDEJGAdr6z2LxynYjRRQYcRmh3splyHPmT7okU_QZl7SnICCODKQyxi3Qwd4QYx1sZ8AWGqvYNxZ3OWeGPE6MM0S1f1A-9rzPCIsJMxlpa2fh77fQ_Nr8ot6ZO-=w477-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Boston+IVF,+778+Main+St+%232,+South+Portland,+ME+04106/@43.6165576,-70.3087144,2889a,13.1y/data=!4m2!3m1!1s0x4cb29ed35d564f33:0x2d5010c867f62498",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-59",
    "externalIds": {
      "cdcClinicId": "59"
    },
    "type": "fertility-clinic",
    "name": "Gago Center for Fertility",
    "phone": "(810) 227-3232",
    "address": {
      "line1": "2250 Genoa Business Park Dr, Suite 110",
      "city": "Brighton",
      "state": "MI",
      "zip": "48114",
      "country": "US"
    },
    "location": {
      "lat": 42.5696,
      "lng": -83.8063
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 43.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 36.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 47.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 234,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2759%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.gagofertility.com/location/brighton-mi",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2759%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.gagofertility.com/providers",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://www.gagofertility.com/location/brighton-mi",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.gagofertility.com/location/brighton-mi",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-59-laura-april-gago-md",
        "name": "Laura April Gago, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/d6b5b90cb6ad9f2a012ecb0048d32b823f1233c7/images/2801636.jpg",
        "_source": {
          "url": "https://www.gagofertility.com/providers",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-59-elizabeth-pritts-md",
        "name": "Elizabeth Pritts, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/d6b5b90cb6ad9f2a012ecb0048d32b823f1233c7/images/2801638.jpg",
        "_source": {
          "url": "https://www.gagofertility.com/providers",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-59-shoshana-gruber-msn-np-c",
        "name": "Shoshana Gruber, MSN, NP-C",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "NP-C"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/d6b5b90cb6ad9f2a012ecb0048d32b823f1233c7/images/2801634.jpg",
        "_source": {
          "url": "https://www.gagofertility.com/providers",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-59-gwen-goodrow-md",
        "name": "Gwen Goodrow, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/d6b5b90cb6ad9f2a012ecb0048d32b823f1233c7/images/2797176.png",
        "_source": {
          "url": "https://www.gagofertility.com/providers",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.gagofertility.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Priority Health",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Priority Health, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Michigan (MI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-631",
    "externalIds": {
      "cdcClinicId": "631",
      "googlePlaceId": "ChIJs1Np91HCJIgRxqJzroH_U18"
    },
    "type": "fertility-clinic",
    "name": "Henry Ford Health Center for Reproductive Medicine",
    "phone": "(248) 845-8845",
    "address": {
      "line1": "3950 S. Rochester Rd, Suite 2300",
      "city": "Rochester Hills",
      "state": "MI",
      "zip": "48307",
      "country": "US"
    },
    "location": {
      "lat": 42.6236,
      "lng": -83.1317
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 52.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 47.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 43.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 16,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 323,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27631%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.henryford.com/services/reproductive-medicine",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27631%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.henryford.com/services/reproductive-medicine/team",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Henry+Ford+Reproductive+Medicine+-+Rochester+Hills,+3950+S+Rochester+Rd+%232300,+Rochester+Hills,+MI+48307/@42.62366,-83.131851,2936a,13.1y/data=!4m2!3m1!1s0x8824c251f76953b3:0x5f53ff81ae73a2c6",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.henryford.com/services/reproductive-medicine",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-631-molly-moravek-md",
        "name": "Molly Moravek, MD",
        "role": "Division Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.henryford.com/-/media/project/hfhs/henryford/physician-directory/physicians/m/masse_marisa_23/moravek_molly_24.jpg",
        "_source": {
          "url": "https://www.henryford.com/services/reproductive-medicine/team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-631-ali-a-dabaja-md",
        "name": "Ali A Dabaja, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Male Fertility",
        "imageUrl": "https://www.henryford.com/-/media/project/hfhs/henryford/physician-directory/physicians/a/ali-dabaja-md.jpg?h=343&w=245&hash=7BC27D719006861BFC75FDCE36D796EA",
        "_source": {
          "url": "https://www.henryford.com/services/reproductive-medicine/team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-631-alyssa-a-dennie-np",
        "name": "Alyssa A Dennie, NP",
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://www.henryford.com/-/media/project/hfhs/henryford/physician-directory/physicians/k/karas-english__23/dennie_alyssa_23.jpg?h=245&w=175&hash=FF496F7246DA12B64DD160E57A8B07AD",
        "_source": {
          "url": "https://www.henryford.com/services/reproductive-medicine/team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-631-chelsea-fortin-md",
        "name": "Chelsea Fortin, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://www.henryford.com/-/media/project/hfhs/henryford/physician-directory/physicians/c/chelsea-fortin.jpg",
        "_source": {
          "url": "https://www.henryford.com/services/reproductive-medicine/team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-631-english-karas-pa",
        "name": "English Karas, PA",
        "role": "Physician Assistant",
        "credentials": ["PA"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://www.henryford.com/-/media/project/hfhs/henryford/physician-directory/physicians/k/karas-english__23.jpg",
        "_source": {
          "url": "https://www.henryford.com/services/reproductive-medicine/team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-631-marisa-a-masse-pa",
        "name": "Marisa A Masse, PA",
        "role": "Physician Assistant",
        "credentials": ["PA"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://www.henryford.com/-/media/project/hfhs/henryford/physician-directory/physicians/m/masse_marisa_23.jpg",
        "_source": {
          "url": "https://www.henryford.com/services/reproductive-medicine/team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-631-amarnath-rambhatla-md",
        "name": "Amarnath Rambhatla, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Male Fertility",
        "imageUrl": "https://www.henryford.com/-/media/project/hfhs/henryford/physician-directory/physicians/a/amarnath-rambhatla.jpg?h=343&w=245&hash=784BC206D5E28A33BC46AF0EEEF3BE07",
        "_source": {
          "url": "https://www.henryford.com/services/reproductive-medicine/team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-631-stephanie-venturini-pa",
        "name": "Stephanie Venturini, PA",
        "role": "Physician Assistant",
        "credentials": ["PA"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://www.henryford.com/-/media/project/hfhs/henryford/physician-directory/physicians/s/stephanie-venturini.jpeg",
        "_source": {
          "url": "https://www.henryford.com/services/reproductive-medicine/team",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.henryford.com/services/reproductive-medicine",
    "description": "Henry Ford Health Center for Reproductive Medicine offers IVF, IUI, and fertility evaluation services across southeast Michigan.",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "HAP",
        "Priority Health",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnTWUtuaVoDz_0HOrVaqVyS0gBoJYJfLHXm9FxyZpglvxQPRaMO4__RIzjZlozHoCm9nNSxV3UHIPZLDqnCK_HUW4tn-0w3L5o4vxJ88oMeKWRrcFOqjR7ek1IjLG3A8T9kMJpmvA=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Henry+Ford+Reproductive+Medicine+-+Rochester+Hills,+3950+S+Rochester+Rd+%232300,+Rochester+Hills,+MI+48307/@42.62366,-83.131851,2936a,13.1y/data=!4m2!3m1!1s0x8824c251f76953b3:0x5f53ff81ae73a2c6",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, HAP, Priority Health, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Michigan (MI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-632",
    "externalIds": {
      "cdcClinicId": "632",
      "googlePlaceId": "ChIJh29yX5_GJIgR-GQNjaIu7l4"
    },
    "type": "fertility-clinic",
    "name": "Henry Ford Reproductive Medicine",
    "phone": "(248) 637-4050",
    "address": {
      "line1": "2825 Livernois Rd, Suite A",
      "city": "Troy",
      "state": "MI",
      "zip": "48083",
      "country": "US"
    },
    "location": {
      "lat": 42.5601,
      "lng": -83.1487
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 81,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 70,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/10"
        }
      ],
      "cyclesPerYear": 62,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27632%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.henryford.com/services/reproductive-medicine",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27632%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.henryford.com/services/reproductive-medicine/team",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Henry+Ford+Reproductive+Medicine+-+Troy,+2825+Livernois+Rd+1st+Floor,+Ste+A,+Troy,+MI+48083/@42.5601594,-83.1487341,2939a,13.1y/data=!4m2!3m1!1s0x8824c69f5f726f87:0x5eee2ea28d0d64f8",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.henryford.com/services/reproductive-medicine",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-632-molly-moravek-md",
        "name": "Molly Moravek, MD",
        "role": "Division Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.henryford.com/-/media/project/hfhs/henryford/physician-directory/physicians/m/masse_marisa_23/moravek_molly_24.jpg",
        "_source": {
          "url": "https://www.henryford.com/services/reproductive-medicine/team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-632-ali-a-dabaja-md",
        "name": "Ali A Dabaja, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Male Fertility",
        "imageUrl": "https://www.henryford.com/-/media/project/hfhs/henryford/physician-directory/physicians/a/ali-dabaja-md.jpg?h=343&w=245&hash=7BC27D719006861BFC75FDCE36D796EA",
        "_source": {
          "url": "https://www.henryford.com/services/reproductive-medicine/team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-632-alyssa-a-dennie-np",
        "name": "Alyssa A Dennie, NP",
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://www.henryford.com/-/media/project/hfhs/henryford/physician-directory/physicians/k/karas-english__23/dennie_alyssa_23.jpg?h=245&w=175&hash=FF496F7246DA12B64DD160E57A8B07AD",
        "_source": {
          "url": "https://www.henryford.com/services/reproductive-medicine/team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-632-chelsea-fortin-md",
        "name": "Chelsea Fortin, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://www.henryford.com/-/media/project/hfhs/henryford/physician-directory/physicians/c/chelsea-fortin.jpg",
        "_source": {
          "url": "https://www.henryford.com/services/reproductive-medicine/team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-632-english-karas-pa",
        "name": "English Karas, PA",
        "role": "Physician Assistant",
        "credentials": ["PA"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://www.henryford.com/-/media/project/hfhs/henryford/physician-directory/physicians/k/karas-english__23.jpg",
        "_source": {
          "url": "https://www.henryford.com/services/reproductive-medicine/team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-632-marisa-a-masse-pa",
        "name": "Marisa A Masse, PA",
        "role": "Physician Assistant",
        "credentials": ["PA"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://www.henryford.com/-/media/project/hfhs/henryford/physician-directory/physicians/m/masse_marisa_23.jpg",
        "_source": {
          "url": "https://www.henryford.com/services/reproductive-medicine/team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-632-amarnath-rambhatla-md",
        "name": "Amarnath Rambhatla, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Male Fertility",
        "imageUrl": "https://www.henryford.com/-/media/project/hfhs/henryford/physician-directory/physicians/a/amarnath-rambhatla.jpg?h=343&w=245&hash=784BC206D5E28A33BC46AF0EEEF3BE07",
        "_source": {
          "url": "https://www.henryford.com/services/reproductive-medicine/team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-632-stephanie-venturini-pa",
        "name": "Stephanie Venturini, PA",
        "role": "Physician Assistant",
        "credentials": ["PA"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://www.henryford.com/-/media/project/hfhs/henryford/physician-directory/physicians/s/stephanie-venturini.jpeg",
        "_source": {
          "url": "https://www.henryford.com/services/reproductive-medicine/team",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.henryford.com/services/reproductive-medicine",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "HAP",
        "Priority Health",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, HAP, Priority Health, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Michigan (MI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-633",
    "externalIds": {
      "cdcClinicId": "633",
      "googlePlaceId": "ChIJU6enFNtfUocRUFDvIx53aGw"
    },
    "type": "fertility-clinic",
    "name": "Pinnacle Fertility - Bloomfield Hills",
    "phone": "(248) 952-9600",
    "address": {
      "line1": "37000 Woodward Ave, Suite 350",
      "city": "Bloomfield Hills",
      "state": "MI",
      "zip": "48304",
      "country": "US"
    },
    "location": {
      "lat": 42.5596,
      "lng": -83.2227
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 54.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 45.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 39.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 9.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1001,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27633%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/bloomfield-hills-mi/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27633%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/bloomfield-hills-mi/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/IVF+Michigan+Fertility+Center+-+Bloomfield+Hills,+37000+Woodward+Ave+Ste+350,+Bloomfield+Hills,+MI+48304/@42.5596248,-83.2226653,2939a,13.1y/data=!4m2!3m1!1s0x87525fdb14a7a753:0x6c68771e23ef5050",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/bloomfield-hills-mi/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-633-f-nicholas-shamma-md",
        "name": "F. Nicholas Shamma, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/03/Dr.-F.-Nicholas-Shamma_MI-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/bloomfield-hills-mi/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-633-ahmad-hammoud-md-facog",
        "name": "Ahmad Hammoud, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/03/Dr.-Ahmad-Hammoud_MI-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/bloomfield-hills-mi/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-633-zeinab-hazime-msn-fnp-bc",
        "name": "Zeinab Hazime, MSN, FNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "FNP-BC"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/02/Zeinab-Hazime-MI-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/bloomfield-hills-mi/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-633-lorrie-posegay-msn-whnp",
        "name": "Lorrie Posegay, MSN, WHNP",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "WHNP"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/02/lorrie-posegay-1-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/bloomfield-hills-mi/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.pinnaclefertility.com/location/bloomfield-hills-mi/",
    "description": "IVF Michigan Fertility Centers provides IVF, egg freezing, and advanced reproductive care at multiple locations in the Detroit metro area.",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "HAP",
        "Priority Health",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/05/bloomfield.webp",
        "type": "interior",
        "caption": "Pinnacle Fertility Bloomfield Hills waiting room",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/bloomfield-hills-mi/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWll-KFxS9c_z6oIkNj8wgnzGdQ2vZmxEJL7xtXKXor4N62lld9j3_XRKMiLz7wORJ2J4E05VnNrB2kxtBLCeAJgqu0cUMcwaWceFOLMleEzF5A3XBycAP6BFbWv1137lsUZwhUNMg=w254-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/IVF+Michigan+Fertility+Center+-+Bloomfield+Hills,+37000+Woodward+Ave+Ste+350,+Bloomfield+Hills,+MI+48304/@42.5596248,-83.2226653,2939a,13.1y/data=!4m2!3m1!1s0x87525fdb14a7a753:0x6c68771e23ef5050",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, HAP, Priority Health, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Michigan (MI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-894",
    "externalIds": {
      "cdcClinicId": "894",
      "googlePlaceId": "ChIJPcIfgh23JIgRZXohC7ElDE8"
    },
    "type": "fertility-clinic",
    "name": "Kindbody-Detroit",
    "phone": "(248) 780-2070",
    "address": {
      "line1": "26400 W 12th Mile Rd, Ste 140",
      "city": "Southfield",
      "state": "MI",
      "zip": "48034",
      "country": "US"
    },
    "location": {
      "lat": 42.5019,
      "lng": -83.2839
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 3,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27894%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://kindbody.com/book-appointment-detroit/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27894%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.kindbody.com/ivf-cost/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "verified-none",
          "source": {
            "url": "https://kindbody.com/book-appointment-detroit/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+Detroit,+26400+W+12+Mile+Rd+%23+140+D,+Southfield,+MI+48034/@42.501848,-83.3069473,2942a,13.1y/data=!4m2!3m1!1s0x8824b71d821fc23d:0x4f0c25b10b217a65",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/book-appointment-detroit/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [],
    "network": {
      "name": "Kindbody"
    },
    "website": "https://kindbody.com/book-appointment-detroit/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Anthem",
        "Blue Cross Blue Shield",
        "Cigna",
        "Emblem Health",
        "Empire Blue Cross Blue Shield",
        "First Health",
        "Health Net",
        "Horizon",
        "Humana",
        "Maven",
        "Medicare",
        "Medicaid",
        "MultiPlan",
        "Optum",
        "Oscar",
        "Oxford",
        "Progyny",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven"],
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "pricing": {
      "packages": [
        {
          "name": "Pulse Assessment",
          "description": "Quick fertility check — not covered by insurance",
          "price": 9900,
          "currency": "USD",
          "includes": [
            "AMH blood test",
            "Transvaginal ultrasound for follicle count",
            "15-minute reproductive consultation"
          ],
          "notes": "Not covered by insurance"
        },
        {
          "name": "Fertility Consultation",
          "description": "Specialist consultation on fertility fundamentals",
          "price": 30000,
          "currency": "USD",
          "notes": "Billable to most insurance plans"
        },
        {
          "name": "Male Consultation + Semen Analysis",
          "price": 52500,
          "currency": "USD",
          "includes": ["Consultation", "Venipuncture", "Semen analysis"]
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Single egg freezing cycle",
          "price": 690000,
          "priceMax": 966000,
          "currency": "USD",
          "includes": [
            "Stimulation visits",
            "Ultrasounds",
            "Blood draws",
            "Retrieval",
            "Cryopreservation",
            "3 months storage",
            "Coordination"
          ],
          "excludes": ["Medications ($4,000 - $6,000)", "Anesthesia"]
        },
        {
          "name": "Annual Egg Storage",
          "price": 92000,
          "currency": "USD",
          "notes": "Per year"
        },
        {
          "name": "IVF Freeze All (Self Pay)",
          "description": "IVF cycle with all embryos frozen",
          "price": 1160000,
          "priceMax": 1850000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Cryopreservation",
            "3 months storage"
          ],
          "excludes": [
            "Medications (~$4,000 - $6,000)",
            "Embryo biopsy/genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Donor services",
            "Anesthesia"
          ]
        },
        {
          "name": "IVF Fresh Transfer (Self Pay)",
          "description": "IVF cycle with fresh embryo transfer",
          "price": 1380000,
          "priceMax": 1875000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$5,000 - $9,000)",
            "Genetic testing",
            "Surplus embryo storage",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Freeze All",
          "price": 910000,
          "priceMax": 1332000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Cryopreservation",
            "3-month storage"
          ],
          "excludes": [
            "Genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Fresh Transfer",
          "price": 990000,
          "priceMax": 1428000,
          "currency": "USD",
          "includes": [
            "Ultrasounds",
            "Thaw",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Surplus storage",
            "Frozen transfers",
            "Anesthesia"
          ]
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 400000,
          "priceMax": 550000,
          "currency": "USD",
          "includes": ["Ultrasounds", "Thaw", "Assisted hatching", "Transfer"],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "PGT Package",
          "description": "Preimplantation genetic testing",
          "price": 160000,
          "priceMax": 300000,
          "currency": "USD",
          "includes": ["Embryo biopsy", "Lab management"],
          "excludes": ["Storage", "Shipping", "Per-embryo testing costs"]
        },
        {
          "name": "Nutrition Coaching",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Counseling & Support",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Guided Meditation",
          "description": "Virtual wellness — 30-minute session",
          "price": 9000,
          "currency": "USD"
        }
      ],
      "financingOptions": [
        {
          "name": "PatientFi monthly payments",
          "description": "PatientFi monthly payments"
        }
      ],
      "disclaimer": "Prices vary by location. Medications and anesthesia are not included in procedure costs. 3 months of storage included with freeze procedures; annual storage is $920.",
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnOmH3Hm1AOTkdsmiNJk_jTyt4Fg6t2MzoQtJgIrvzPjNOcopnunZU0Qy-7Wf1g2AKB1xLN8wHExbL-d_K673MOHpr2oPzSp3WZwJ7atG6WqQHYoss_Oh09VSbb2RlFqt_BAOt1=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Detroit,+26400+W+12+Mile+Rd+%23+140+D,+Southfield,+MI+48034/@42.501848,-83.3069473,2942a,13.1y/data=!4m2!3m1!1s0x8824b71d821fc23d:0x4f0c25b10b217a65",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Blue Cross Blue Shield, Cigna, Emblem Health, Empire Blue Cross Blue Shield, First Health, Health Net",
              "detail": "12 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "14 public price package(s) and 1 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Michigan (MI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-318",
    "externalIds": {
      "cdcClinicId": "318",
      "googlePlaceId": "ChIJq6rqB8HaJIgRctC5aZ2O7UQ"
    },
    "type": "fertility-clinic",
    "name": "Michigan Center for Fertility and Women's Health, PLC",
    "phone": "(586) 576-0431",
    "address": {
      "line1": "4700 E. 13 Mile Rd",
      "city": "Warren",
      "state": "MI",
      "zip": "48092",
      "country": "US"
    },
    "location": {
      "lat": 42.5202,
      "lng": -83.0604
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 42.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 39.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 46.15384615384615,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/13"
        }
      ],
      "cyclesPerYear": 242,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27318%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.mifertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27318%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.mifertility.com/our-team",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Michigan+Center+For+Fertility+%26+Women's+Health,+4700+E+Thirteen+Mile+Rd,+Warren,+MI+48092/@42.5202569,-83.060416,2941a,13.1y/data=!4m2!3m1!1s0x8824dac107eaaaab:0x44ed8e9d69b9d072",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.mifertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-318-carole-kowalczyk-md",
        "name": "Carole Kowalczyk, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn.prod.website-files.com/6359a41db845fa3045fd02d1/63d2f2417166060f401fc622_Dr.Kowalczyk-600.jpg",
        "_source": {
          "url": "https://www.mifertility.com/our-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-318-nicole-budrys-md",
        "name": "Nicole Budrys, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn.prod.website-files.com/6359a41db845fa3045fd02d1/63d2f24135189c6f6147a391_Dr.Budrys-600.jpg",
        "_source": {
          "url": "https://www.mifertility.com/our-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-318-alexa-karbowski-pa-c",
        "name": "Alexa Karbowski, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://cdn.prod.website-files.com/6359a41db845fa3045fd02d1/63d2f241cf393e5995a5f82f_Alexa-600.jpg",
        "_source": {
          "url": "https://www.mifertility.com/our-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-318-mandi-johnson-pa-c",
        "name": "Mandi Johnson, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://cdn.prod.website-files.com/6359a41db845fa3045fd02d1/63d2f2411856e4206fbc45dc_Mandi-600.jpg",
        "_source": {
          "url": "https://www.mifertility.com/our-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-318-ronald-strickler-md",
        "name": "Ronald Strickler, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn.prod.website-files.com/6359a41db845fa3045fd02d1/6359a41db845fa7d4dfd0346_Strickler-PHOTO-2005SQ-600-1.jpg",
        "_source": {
          "url": "https://www.mifertility.com/our-team",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.mifertility.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Michigan (MI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-56",
    "externalIds": {
      "cdcClinicId": "56",
      "googlePlaceId": "ChIJceK80TtTGIgRGKYW63rQCLw"
    },
    "type": "fertility-clinic",
    "name": "The Fertility Center",
    "phone": "(616) 988-2229",
    "address": {
      "line1": "3230 Eagle Park Dr N.E., Suite 100",
      "city": "Grand Rapids",
      "state": "MI",
      "zip": "49525",
      "country": "US"
    },
    "location": {
      "lat": 42.9879,
      "lng": -85.5892
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 44.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 34.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 28.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 15.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 645,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2756%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://fertilitycentermi.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2756%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://fertilitycentermi.com/meet-the-staff/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/The+Fertility+Center,+3230+Eagle+Park+Dr+NE+%23100,+Grand+Rapids,+MI+49525/@42.9878421,-85.5890304,2919a,13.1y/data=!4m2!3m1!1s0x8818533bd1bce271:0xbc08d07aeb16a618",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://fertilitycentermi.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-56-valerie-shavell-md",
        "name": "Valerie Shavell, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://fertilitycentermi.com/wp-content/uploads/2022/06/1070-The-Fertility-Center-07222021-tu-480x720.jpg",
        "_source": {
          "url": "https://fertilitycentermi.com/meet-the-staff/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-56-emma-giuliani-md",
        "name": "Emma Giuliani, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://fertilitycentermi.com/wp-content/uploads/2022/06/1133-The-Fertility-Center-07222021-tu-480x720.jpg",
        "_source": {
          "url": "https://fertilitycentermi.com/meet-the-staff/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-56-gary-jones-md",
        "name": "Gary Jones, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://fertilitycentermi.com/wp-content/uploads/2022/06/Dr.-Jones-Photo-480x672.jpg",
        "_source": {
          "url": "https://fertilitycentermi.com/meet-the-staff/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-56-sarah-bjorkman-md",
        "name": "Sarah Bjorkman, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://fertilitycentermi.com/wp-content/uploads/2023/09/Sarah-Bjorkman-MD-480x720.jpg",
        "_source": {
          "url": "https://fertilitycentermi.com/meet-the-staff/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-56-mili-thakur-md",
        "name": "Mili Thakur, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility; Medical Genetics",
        "imageUrl": "https://fertilitycentermi.com/wp-content/uploads/2022/06/1010-The-Fertility-Center-07222021-tu-480x720.jpg",
        "_source": {
          "url": "https://fertilitycentermi.com/meet-the-staff/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://fertilitycentermi.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Priority Health",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "description": "Ovation Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmjwL6NzPghtSS26acJDBztuotV840rR_XsLw4UqajyeThZiHQanLgZBkFNTdiwjEjy94gAstSxyBdrRT9zj3vyHpKjYj4YROhGHoUfnzlqjIHIokKL2vT5a283U-GUTzIAeRzuqA=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/The+Fertility+Center,+3230+Eagle+Park+Dr+NE+%23100,+Grand+Rapids,+MI+49525/@42.9878421,-85.5890304,2919a,13.1y/data=!4m2!3m1!1s0x8818533bd1bce271:0xbc08d07aeb16a618",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Priority Health, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Michigan (MI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-364",
    "externalIds": {
      "cdcClinicId": "364"
    },
    "type": "fertility-clinic",
    "name": "U-M Health Center for Reproductive Medicine at Bloomfield Hills",
    "phone": "(248) 593-6990",
    "address": {
      "line1": "41000 Woodward Avenue, Suite 100 East",
      "city": "Bloomfield Hills",
      "state": "MI",
      "zip": "48304",
      "country": "US"
    },
    "location": {
      "lat": 42.5906,
      "lng": -83.2485
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 38.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 35.714285714285715,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/14"
        },
        {
          "ageBand": "38-40",
          "rate": 20,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "0/9"
        }
      ],
      "cyclesPerYear": 137,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27364%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.uofmhealth.org/locations-list/center-reproductive-medicine-bloomfield-hills",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27364%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.uofmhealth.org/locations-list/center-reproductive-medicine-bloomfield-hills",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.uofmhealth.org/locations-list/center-reproductive-medicine-bloomfield-hills",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.uofmhealth.org/locations-list/center-reproductive-medicine-bloomfield-hills",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-364-michael-scott-mersol-barg-md",
        "name": "Michael Scott Mersol-Barg, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Obstetrics & Gynecology; Reproductive Endocrinology",
        "imageUrl": "https://www.trinityhealthmichigan.org/sites/default/files/styles/max_width_400/public/hg_features/hg_provider/7b135ede022c701f82340fa26c5117c0.jpg?itok=VrEBIvc1",
        "_source": {
          "url": "https://www.uofmhealth.org/locations-list/center-reproductive-medicine-bloomfield-hills",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-364-john-f-randolph-md",
        "name": "John F. Randolph, MD",
        "role": "Professor",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology; Obstetrics & Gynecology",
        "_source": {
          "url": "https://www.uofmhealth.org/locations-list/center-reproductive-medicine-bloomfield-hills",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-364-samantha-beth-schon-md",
        "name": "Samantha Beth Schon, MD",
        "role": "Assistant Professor",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology; Obstetrics & Gynecology",
        "_source": {
          "url": "https://www.uofmhealth.org/locations-list/center-reproductive-medicine-bloomfield-hills",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-364-natalie-clark-stentz-md",
        "name": "Natalie Clark Stentz, MD",
        "role": "Clinical Instructor",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology; Obstetrics & Gynecology",
        "_source": {
          "url": "https://www.uofmhealth.org/locations-list/center-reproductive-medicine-bloomfield-hills",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-364-timesha-young-pa-c",
        "name": "Timesha Young, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "specialty": "Reproductive Medicine",
        "_source": {
          "url": "https://www.uofmhealth.org/locations-list/center-reproductive-medicine-bloomfield-hills",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.uofmhealth.org/locations-list/center-reproductive-medicine-bloomfield-hills",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://documentapi-fargate-documentbucket-15qi4tpdvnhlz.s3.amazonaws.com/193/9717c650-1ece-11f1-8fdc-09d7849d3f03.jpg",
        "type": "exterior",
        "caption": "U-M Health Center for Reproductive Medicine at Bloomfield Hills exterior",
        "_source": {
          "url": "https://www.uofmhealth.org/locations-list/center-reproductive-medicine-bloomfield-hills",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Michigan (MI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-320",
    "externalIds": {
      "cdcClinicId": "320",
      "googlePlaceId": "ChIJ0TG6ERHEJIgRNo1_kRBtogg"
    },
    "type": "fertility-clinic",
    "name": "RMA of Michigan",
    "phone": "(248) 619-3100",
    "address": {
      "line1": "130 Town Center Dr, Suite 106",
      "city": "Troy",
      "state": "MI",
      "zip": "48084",
      "country": "US"
    },
    "location": {
      "lat": 42.5682,
      "lng": -83.1509
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 54.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 53.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 39.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 15.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 442,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27320%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.rmami.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.rmami.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.rmami.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Reproductive+Medicine+Associates+of+Michigan+(RMA+of+Michigan),+130+Town+Center+Dr+%23106,+Troy,+MI+48084/@42.5682712,-83.1508657,2938a,13.1y/data=!4m2!3m1!1s0x8824c41111ba31d1:0x8a26d10917f8d36",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27320%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-320-brad-t-miller-md",
        "name": "Brad T. Miller, MD",
        "role": "Medical Director & REI",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.rmami.com/wp-content/uploads/2024/11/Dr-Miller-Headshot-scaled-e1732638342632.jpg",
        "_source": {
          "url": "https://www.rmami.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-320-lynda-j-wolf-md",
        "name": "Lynda J. Wolf, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.rmami.com/wp-content/uploads/2024/07/michigan-ivf-dr-wolf.jpg",
        "_source": {
          "url": "https://www.rmami.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-320-jenny-s-george-md",
        "name": "Jenny S. George, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.rmami.com/wp-content/uploads/2024/07/michigan-ivf-doctor-george.jpg",
        "_source": {
          "url": "https://www.rmami.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-320-annette-lee-md",
        "name": "Annette Lee, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.rmami.com/wp-content/uploads/2025/01/Annette-Lee-MD.jpeg",
        "_source": {
          "url": "https://www.rmami.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-320-molly-moravek-md",
        "name": "Molly Moravek, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.rmami.com/wp-content/uploads/2026/06/Moravek-sitting-cropped-scaled-square-e1780658859769.jpg",
        "_source": {
          "url": "https://www.rmami.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.rmami.com/",
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "setting": "network-group",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlvydPPOh2vT3agBv8ZUJcYRJmmeRSf-HuRXlzYzgEXUbyNz24CM1gvHYrgzQZKf8vu8VZGdlumF1z8fYXrmj_Z8eCZP5AVoMpXVDTBpNqXyWZJ7wJj43C12v8MYGX3sJwsGDIf=w224-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Reproductive+Medicine+Associates+of+Michigan+(RMA+of+Michigan),+130+Town+Center+Dr+%23106,+Troy,+MI+48084/@42.5682712,-83.1508657,2938a,13.1y/data=!4m2!3m1!1s0x8824c41111ba31d1:0x8a26d10917f8d36",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Michigan (MI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-707",
    "externalIds": {
      "cdcClinicId": "707"
    },
    "type": "fertility-clinic",
    "name": "University of Michigan Center for Reproductive Medicine",
    "phone": "(734) 763-6295",
    "address": {
      "line1": "475 Market Place, Briarwood Building 1",
      "city": "Ann Arbor",
      "state": "MI",
      "zip": "48108",
      "country": "US"
    },
    "location": {
      "lat": 42.2431,
      "lng": -83.7419
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 47.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 44.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 42,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 35.714285714285715,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/14"
        }
      ],
      "cyclesPerYear": 423,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27707%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.uofmhealth.org/locations-list/briarwood-center-reproductive-medicine",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27707%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.uofmhealth.org/our-care/specialties-services/fertility-preservation-program",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.uofmhealth.org/locations-list/briarwood-center-reproductive-medicine",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.uofmhealth.org/locations-list/briarwood-center-reproductive-medicine",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-707-james-michael-dupree-md",
        "name": "James Michael Dupree, MD",
        "role": "Clinical Professor",
        "credentials": ["MD"],
        "specialty": "Urology",
        "_source": {
          "url": "https://www.uofmhealth.org/our-care/specialties-services/fertility-preservation-program",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-707-erica-elizabeth-marsh-md-msci-facog",
        "name": "Erica Elizabeth Marsh, MD, MSCI, FACOG",
        "role": "Professor",
        "credentials": ["MD", "MSCI", "FACOG"],
        "specialty": "Reproductive Endocrinology; Obstetrics & Gynecology",
        "_source": {
          "url": "https://www.uofmhealth.org/our-care/specialties-services/fertility-preservation-program",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-707-marie-menke-md",
        "name": "Marie Menke, MD",
        "role": "Clinical Associate Professor",
        "credentials": ["MD"],
        "specialty": "Obstetrics & Gynecology; Reproductive Endocrinology",
        "_source": {
          "url": "https://www.uofmhealth.org/our-care/specialties-services/fertility-preservation-program",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-707-dana-alan-ohl-md",
        "name": "Dana Alan Ohl, MD",
        "role": "Professor",
        "credentials": ["MD"],
        "specialty": "Urology",
        "_source": {
          "url": "https://www.uofmhealth.org/our-care/specialties-services/fertility-preservation-program",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-707-john-f-randolph-md",
        "name": "John F. Randolph, MD",
        "role": "Professor",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology; Obstetrics & Gynecology",
        "_source": {
          "url": "https://www.uofmhealth.org/our-care/specialties-services/fertility-preservation-program",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-707-samantha-beth-schon-md",
        "name": "Samantha Beth Schon, MD",
        "role": "Assistant Professor",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology; Obstetrics & Gynecology",
        "_source": {
          "url": "https://www.uofmhealth.org/our-care/specialties-services/fertility-preservation-program",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-707-yolanda-r-smith-md",
        "name": "Yolanda R. Smith, MD",
        "role": "Professor",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology; Obstetrics & Gynecology",
        "_source": {
          "url": "https://www.uofmhealth.org/our-care/specialties-services/fertility-preservation-program",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-707-natalie-clark-stentz-md",
        "name": "Natalie Clark Stentz, MD",
        "role": "Clinical Instructor",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology; Obstetrics & Gynecology",
        "_source": {
          "url": "https://www.uofmhealth.org/our-care/specialties-services/fertility-preservation-program",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-707-daphna-stroumsa-md-mph",
        "name": "Daphna Stroumsa, MD, MPH",
        "role": "Assistant Professor",
        "credentials": ["MD", "MPH"],
        "specialty": "Obstetrics & Gynecology",
        "_source": {
          "url": "https://www.uofmhealth.org/our-care/specialties-services/fertility-preservation-program",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-707-lindsay-renee-brennan-lmsw",
        "name": "Lindsay Renee Brennan, LMSW",
        "role": "Social Worker",
        "credentials": ["LMSW"],
        "specialty": "Licensed Clinical Social Work",
        "_source": {
          "url": "https://www.uofmhealth.org/our-care/specialties-services/fertility-preservation-program",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.uofmhealth.org/locations-list/briarwood-center-reproductive-medicine",
    "description": "The University of Michigan Center for Reproductive Medicine offers comprehensive fertility treatment and research-backed care in Ann Arbor.",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Priority Health",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "images": [
      {
        "url": "https://documentapi-fargate-documentbucket-15qi4tpdvnhlz.s3.amazonaws.com/193/44454870-326d-11ef-b635-eb036cda4736.jpg",
        "type": "exterior",
        "caption": "Briarwood Medical Building 1 exterior",
        "_source": {
          "url": "https://www.uofmhealth.org/locations-list/briarwood-center-reproductive-medicine",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Priority Health, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Michigan (MI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-611",
    "externalIds": {
      "cdcClinicId": "611",
      "googlePlaceId": "ChIJz5x_faUm9ocReQJcb4qFFh8"
    },
    "type": "fertility-clinic",
    "name": "CCRM Minneapolis",
    "phone": "(952) 225-1630",
    "address": {
      "line1": "6565 France Ave South, Suite 400",
      "city": "Edina",
      "state": "MN",
      "zip": "55435",
      "country": "US"
    },
    "location": {
      "lat": 44.8841,
      "lng": -93.3272
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 63.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 58.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 57.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 40,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 840,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27611%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27611%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/minnesota/minneapolis/fertility-doctors/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Minneapolis,+6565+France+Ave+S+Ste+400,+Edina,+MN+55435/@44.884172,-93.3270466,2827a,13.1y/data=!4m2!3m1!1s0x87f626a57d7f9ccf:0x1f16858a6f5c0279",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-611-april-e-batcheller-md",
        "name": "April E. Batcheller, MD",
        "role": "Founding Physician & Medical Director",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/April_Batcheller_600x600_2x.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/april-batcheller/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-611-jennifer-m-burgart-md-ms",
        "name": "Jennifer M. Burgart, MD, MS",
        "role": "Reproductive Endocrinologist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Jennifer_Burgart_600x600_2x.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/jennifer-burgart/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-611-amy-kohlmeier-md",
        "name": "Amy Kohlmeier, MD",
        "role": "Reproductive Endocrinologist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Amy_Kohlmeier_600x600_2x.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/amy-kohlmeier/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.ccrmivf.com/location/us/minnesota/minneapolis/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "HealthPartners",
        "Medica",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "network": {
      "name": "CCRM Fertility"
    },
    "images": [
      {
        "url": "https://www.fertilityshare.com/wp-content/uploads/2025/01/2022u-08-09.jpg",
        "type": "interior",
        "caption": "CCRM Minneapolis reception area",
        "_source": {
          "url": "https://www.fertilityshare.com/clinic/ccrm-minneapolis/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://www.fertilityshare.com/wp-content/uploads/2025/01/2022-08-09.jpg",
        "type": "interior",
        "caption": "CCRM Minneapolis treatment room",
        "_source": {
          "url": "https://www.fertilityshare.com/clinic/ccrm-minneapolis/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://www.fertilityshare.com/wp-content/uploads/2025/01/2022-0p8-09.jpg",
        "type": "interior",
        "caption": "CCRM Minneapolis exam room",
        "_source": {
          "url": "https://www.fertilityshare.com/clinic/ccrm-minneapolis/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://www.fertilityshare.com/wp-content/uploads/2025/01/2022-p08-09.jpg",
        "type": "lab",
        "caption": "CCRM Minneapolis procedure room",
        "_source": {
          "url": "https://www.fertilityshare.com/clinic/ccrm-minneapolis/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmORfftBKk91q_GZIEzU0b_C6v8V6aP9t504kuSrwibGnoiqdO8rdCS6NDovYBloeX--i0x6pwB2QiEvqdXrJGHABfagIdcuAoW2TuAWsTlCNJnK1TFvz6IJk4mNEvxxkuLefZ-=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Minneapolis,+6565+France+Ave+S+Ste+400,+Edina,+MN+55435/@44.884172,-93.3270466,2827a,13.1y/data=!4m2!3m1!1s0x87f626a57d7f9ccf:0x1f16858a6f5c0279",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm78K_GrZzyvCnxccmKZERJsSat0XZCxSgTdzBChUugFvl8whW7O-uTyYoakB4kKVmAU6FPuLLE_fPI08Y-EnjfEvvAPZcl9VGqKez43NsPeVZQlGC0AlA38pe0R-KJuZucA-cg=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Minneapolis,+6565+France+Ave+S+Ste+400,+Edina,+MN+55435/@44.884172,-93.3270466,2827a,13.1y/data=!4m2!3m1!1s0x87f626a57d7f9ccf:0x1f16858a6f5c0279",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, HealthPartners, Medica, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Minnesota (MN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-70",
    "externalIds": {
      "cdcClinicId": "70",
      "googlePlaceId": "ChIJZd-4J_8n9ocRAO3cGh3zNkI"
    },
    "type": "fertility-clinic",
    "name": "Center for Reproductive Medicine of Minnesota",
    "phone": "(612) 863-5390",
    "address": {
      "line1": "2828 Chicago Ave South, Suite 400",
      "city": "Minneapolis",
      "state": "MN",
      "zip": "55407",
      "country": "US"
    },
    "location": {
      "lat": 44.951,
      "lng": -93.263
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 46.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 52.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 42.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 598,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2770%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2770%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://ivfminnesota.com/about-us/meet-our-team/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Center+for+Reproductive+Medicine+%26+Advanced+Reproductive+Technologies,+2828+Chicago+Ave+%23400,+Minneapolis,+MN+55407/@44.9509544,-93.2630386,2824a,13.1y/data=!4m2!3m1!1s0x87f627ff27b8df65:0x4236f31d1adced00",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-70-colleen-l-casey-md",
        "name": "Colleen L. Casey, MD",
        "role": "President",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://ivfminnesota.com/wp-content/uploads/2025/12/Dr.-Colleen-Casey-USE_-800x640.jpg",
        "_source": {
          "url": "https://ivfminnesota.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-70-joshua-d-kapfhamer-md-ma",
        "name": "Joshua D. Kapfhamer, MD, MA",
        "role": "Medical Director",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://ivfminnesota.com/wp-content/uploads/2025/12/Dr.-Joshua-Kapfhamer-USE_-800x640.jpg",
        "_source": {
          "url": "https://ivfminnesota.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-70-meg-m-hopeman-md-msce",
        "name": "Meg M. Hopeman, MD, MSCE",
        "role": "Reproductive Endocrinologist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://ivfminnesota.com/wp-content/uploads/2025/12/Dr.-Meg-Hopeman-USE_-800x640.jpg",
        "_source": {
          "url": "https://ivfminnesota.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-70-mark-a-damario-md",
        "name": "Mark A. Damario, MD",
        "role": "Reproductive Endocrinologist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://ivfminnesota.com/wp-content/uploads/2025/12/Dr.-Mark-Damario-USE_-800x640.jpg",
        "_source": {
          "url": "https://ivfminnesota.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-70-rachel-b-mejia-do",
        "name": "Rachel B. Mejia, DO",
        "role": "Reproductive Endocrinologist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://ivfminnesota.com/wp-content/uploads/2025/12/Dr.-Rachel-Mejia-USE-THIS-800x640.jpg",
        "_source": {
          "url": "https://ivfminnesota.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-70-douglas-t-carrell-phd-hcld",
        "name": "Douglas T. Carrell, PhD, HCLD",
        "role": "Laboratory Director",
        "specialty": "Embryology Laboratory Director",
        "imageUrl": "https://ivfminnesota.com/wp-content/uploads/2018/08/20250828-CRM-Team-Block-Portrait-Studios-8-800x640.jpg",
        "_source": {
          "url": "https://ivfminnesota.com/about-us/meet-our-team/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://ivfminnesota.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "HealthPartners",
        "Medica"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkgkUzSFro7S6BXU3m4WWsoJEw6j1ZNQgrSQ8JfDCxJxLlyqm5zD0ooQXcUJwyY_BrBS6sBHCTaKzNKEKlw2slX-TYC1zoxqxhVK2x8TVw64RJsobNa7CFvyfqyAqEZT13EEZ8FoqE5HJVn=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Center+for+Reproductive+Medicine+%26+Advanced+Reproductive+Technologies,+2828+Chicago+Ave+%23400,+Minneapolis,+MN+55407/@44.9509544,-93.2630386,2824a,13.1y/data=!4m2!3m1!1s0x87f627ff27b8df65:0x4236f31d1adced00",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, HealthPartners, Medica",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Minnesota (MN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-898",
    "externalIds": {
      "cdcClinicId": "898",
      "googlePlaceId": "ChIJpSZ0-dEzs1IR0fvKpzLaSsU"
    },
    "type": "fertility-clinic",
    "name": "Kindbody Minneapolis",
    "phone": "(612) 230-4090",
    "address": {
      "line1": "138 N. 2nd St",
      "city": "Minneapolis",
      "state": "MN",
      "zip": "55401",
      "country": "US"
    },
    "location": {
      "lat": 44.9846,
      "lng": -93.27
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 3,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27898%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27898%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.kindbody.com/ivf-cost/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/book-appointment-minneapolis/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+Minneapolis,+138+N+2nd+St,+Minneapolis,+MN+55401/@44.9844436,-93.2697329,2822a,13.1y/data=!4m2!3m1!1s0x52b333d1f97426a5:0xc54ada32a7cafbd1",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-898-ellen-hayes-md",
        "name": "Ellen Hayes, MD",
        "role": "Reproductive Endocrinologist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://kindbody.com/wp-content/uploads/2022/05/Ellen-Hayes-Web-683x1024.jpg",
        "_source": {
          "url": "https://kindbody.com/book-appointment-minneapolis/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-898-laura-henderson-dnp-aprn-whnp-bc",
        "name": "Laura Henderson, DNP, APRN, WHNP-BC",
        "role": "Nurse Practitioner",
        "specialty": "Women's and Reproductive Health",
        "imageUrl": "https://kindbody.com/wp-content/uploads/2024/08/1719509777.046183-1-scaled-e1723127470968-909x1024.jpg",
        "_source": {
          "url": "https://kindbody.com/book-appointment-minneapolis/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-898-gabby-gotlund-whnp",
        "name": "Gabby Gotlund, WHNP",
        "role": "Nurse Practitioner",
        "specialty": "Women's Health Nurse Practitioner",
        "imageUrl": "https://kindbody.com/wp-content/uploads/2026/04/Gabby-Gotlund-683x1024.png",
        "_source": {
          "url": "https://kindbody.com/book-appointment-minneapolis/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "network": {
      "name": "Kindbody"
    },
    "website": "https://kindbody.com/book-appointment-minneapolis/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Anthem",
        "Blue Cross Blue Shield",
        "Cigna",
        "Emblem Health",
        "Empire Blue Cross Blue Shield",
        "First Health",
        "Health Net",
        "Horizon",
        "Humana",
        "Maven",
        "Medicare",
        "Medicaid",
        "MultiPlan",
        "Optum",
        "Oscar",
        "Oxford",
        "Progyny",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven"],
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "pricing": {
      "packages": [
        {
          "name": "Pulse Assessment",
          "description": "Quick fertility check — not covered by insurance",
          "price": 9900,
          "currency": "USD",
          "includes": [
            "AMH blood test",
            "Transvaginal ultrasound for follicle count",
            "15-minute reproductive consultation"
          ],
          "notes": "Not covered by insurance"
        },
        {
          "name": "Fertility Consultation",
          "description": "Specialist consultation on fertility fundamentals",
          "price": 30000,
          "currency": "USD",
          "notes": "Billable to most insurance plans"
        },
        {
          "name": "Male Consultation + Semen Analysis",
          "price": 52500,
          "currency": "USD",
          "includes": ["Consultation", "Venipuncture", "Semen analysis"]
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Single egg freezing cycle",
          "price": 690000,
          "priceMax": 966000,
          "currency": "USD",
          "includes": [
            "Stimulation visits",
            "Ultrasounds",
            "Blood draws",
            "Retrieval",
            "Cryopreservation",
            "3 months storage",
            "Coordination"
          ],
          "excludes": ["Medications ($4,000 - $6,000)", "Anesthesia"]
        },
        {
          "name": "Annual Egg Storage",
          "price": 92000,
          "currency": "USD",
          "notes": "Per year"
        },
        {
          "name": "IVF Freeze All (Self Pay)",
          "description": "IVF cycle with all embryos frozen",
          "price": 1160000,
          "priceMax": 1850000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Cryopreservation",
            "3 months storage"
          ],
          "excludes": [
            "Medications (~$4,000 - $6,000)",
            "Embryo biopsy/genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Donor services",
            "Anesthesia"
          ]
        },
        {
          "name": "IVF Fresh Transfer (Self Pay)",
          "description": "IVF cycle with fresh embryo transfer",
          "price": 1380000,
          "priceMax": 1875000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$5,000 - $9,000)",
            "Genetic testing",
            "Surplus embryo storage",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Freeze All",
          "price": 910000,
          "priceMax": 1332000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Cryopreservation",
            "3-month storage"
          ],
          "excludes": [
            "Genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Fresh Transfer",
          "price": 990000,
          "priceMax": 1428000,
          "currency": "USD",
          "includes": [
            "Ultrasounds",
            "Thaw",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Surplus storage",
            "Frozen transfers",
            "Anesthesia"
          ]
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 400000,
          "priceMax": 550000,
          "currency": "USD",
          "includes": ["Ultrasounds", "Thaw", "Assisted hatching", "Transfer"],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "PGT Package",
          "description": "Preimplantation genetic testing",
          "price": 160000,
          "priceMax": 300000,
          "currency": "USD",
          "includes": ["Embryo biopsy", "Lab management"],
          "excludes": ["Storage", "Shipping", "Per-embryo testing costs"]
        },
        {
          "name": "Nutrition Coaching",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Counseling & Support",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Guided Meditation",
          "description": "Virtual wellness — 30-minute session",
          "price": 9000,
          "currency": "USD"
        }
      ],
      "financingOptions": [
        {
          "name": "PatientFi monthly payments",
          "description": "PatientFi monthly payments"
        }
      ],
      "disclaimer": "Prices vary by location. Medications and anesthesia are not included in procedure costs. 3 months of storage included with freeze procedures; annual storage is $920.",
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmVBsEAW0zOdjNXB7n7ZHFN-t90YfWXJVZ_xz8Rar874c0PSckC2qzUktWZjJmkaFFCeddJu0sQb-YBo3w-TIX1IhlBkywPHNGfCElS2ox_wTDLnS5IzdP1C3KkSSjmY8lpUQeD=w408-h612-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Minneapolis,+138+N+2nd+St,+Minneapolis,+MN+55401/@44.9844436,-93.2697329,2822a,13.1y/data=!4m2!3m1!1s0x52b333d1f97426a5:0xc54ada32a7cafbd1",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk2u236WWcl1nzRuXLgcvYXcx4cVB4hGzA7gPCGnP2oMtMULVVA_2KbmzKgq3Y5TdvYLzsg0lfy53s7DeRRS-HAlUO2Gx7KofN6U5SASsMFW8G2pJemsDo5k1yQh8wcXycq0CTvyw=w224-h336-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Minneapolis,+138+N+2nd+St,+Minneapolis,+MN+55401/@44.9844436,-93.2697329,2822a,13.1y/data=!4m2!3m1!1s0x52b333d1f97426a5:0xc54ada32a7cafbd1",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Blue Cross Blue Shield, Cigna, Emblem Health, Empire Blue Cross Blue Shield, First Health, Health Net",
              "detail": "12 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "14 public price package(s) and 1 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Minnesota (MN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-523",
    "externalIds": {
      "cdcClinicId": "523"
    },
    "type": "fertility-clinic",
    "name": "Mayo Clinic Assisted Reproductive Technologies",
    "phone": "(507) 284-9792",
    "address": {
      "line1": "200 First St S.W., Eisenberg 2A",
      "city": "Rochester",
      "state": "MN",
      "zip": "55905",
      "country": "US"
    },
    "location": {
      "lat": 44.0227,
      "lng": -92.4668
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 55,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 23.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 19.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 10,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 321,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27523%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27523%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.mayoclinic.org/tests-procedures/in-vitro-fertilization/doctors-departments/pdc-20384717",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.mayoclinic.org/patient-visitor-guide/minnesota/campus-buildings-maps/mayo-gonda-buildings",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-523-zaraq-khan-md",
        "name": "Zaraq Khan, MD",
        "role": "Division Chair, Reproductive Endocrinology and Infertility",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://college.mayo.edu/media/mccms/content-assets/academics/residencies-and-fellowships/reproductive-endocrinology-and-infertility-fell-mn/department-and-faculty/zaraq-khan-mbbs.jpg",
        "_source": {
          "url": "https://www.mayoclinic.org/biographies/khan-zaraq-m-d/bio-20206072",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-523-ali-j-ainsworth-md",
        "name": "Ali J. Ainsworth, MD",
        "role": "Reproductive Endocrinologist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://college.mayo.edu/media/mccms/content-assets/academics/residencies-and-fellowships/reproductive-endocrinology-and-infertility-fell-mn/department-and-faculty/ali-ainsworth-md.jpg",
        "_source": {
          "url": "https://college.mayo.edu/academics/residencies-and-fellowships/reproductive-endocrinology-and-infertility-fellowship-minnesota/department-and-faculty/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-523-michael-f-neblett-ii-md",
        "name": "Michael F. Neblett II, MD",
        "role": "Reproductive Endocrinologist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://college.mayo.edu/profile-images/30007037.jpg",
        "_source": {
          "url": "https://college.mayo.edu/academics/residencies-and-fellowships/reproductive-endocrinology-and-infertility-fellowship-minnesota/department-and-faculty/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-523-chandra-c-paff-shenoy-md",
        "name": "Chandra C. Paff Shenoy, MD",
        "role": "Reproductive Endocrinologist; Third-Party Reproduction Medical Director",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://college.mayo.edu/media/mccms/content-assets/academics/residencies-and-fellowships/reproductive-endocrinology-and-infertility-fell-mn/department-and-faculty/chandra-shenoy-md.jpg",
        "_source": {
          "url": "https://www.mayoclinic.org/biographies/paff-shenoy-chandra-c-m-d/bio-20348443",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-523-ebbie-a-stewart-md",
        "name": "Ebbie A. Stewart, MD",
        "role": "Reproductive Endocrinologist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://college.mayo.edu/media/mccms/content-assets/academics/residencies-and-fellowships/reproductive-endocrinology-and-infertility-fell-mn/department-and-faculty/ebbie-stewart-md.jpg",
        "_source": {
          "url": "https://college.mayo.edu/academics/residencies-and-fellowships/reproductive-endocrinology-and-infertility-fellowship-minnesota/department-and-faculty/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.mayoclinic.org/art",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "HealthPartners",
        "Medica",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "images": [
      {
        "url": "https://assets.mayoclinic.org/content/dam/media/global/images/2024/09/24/roch-campus-720x400-3col.jpg",
        "type": "exterior",
        "caption": "Mayo Building and Gonda Building, Rochester campus",
        "_source": {
          "url": "https://www.mayoclinic.org/patient-visitor-guide/minnesota/campus-buildings-maps/mayo-gonda-buildings",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, HealthPartners, Medica, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Minnesota (MN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-140",
    "externalIds": {
      "cdcClinicId": "140"
    },
    "type": "fertility-clinic",
    "name": "Midwest Center for Reproductive Health, PA",
    "phone": "(763) 458-2939",
    "address": {
      "line1": "Arbor Lakes Medical Building, 12000 Elm Creek Blvd North, Suite 350",
      "city": "Maple Grove",
      "state": "MN",
      "zip": "55369",
      "country": "US"
    },
    "location": {
      "lat": 45.0957,
      "lng": -93.4333
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 58.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 52.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 182,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27140%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27140%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "verified-none",
          "source": {
            "url": "https://www.invitra.com/en/midwest-centre-for-reproductive-health/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://www.invitra.com/en/midwest-centre-for-reproductive-health/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.invitra.com/en/midwest-centre-for-reproductive-health/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [],
    "website": "https://www.mfrh.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "HealthPartners",
        "Medica"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "description": "The Midwest Center for Reproductive Health was a Maple Grove fertility clinic founded by Randle Corfman. A 2023 clinic profile reports that the clinic closed on December 31, 2022 and Dr. Corfman retired.",
    "images": [
      {
        "url": "https://www.invitra.com/en/wp-content/uploads/2022/07/midwest-centre-reproducitve-health-facade.jpg",
        "type": "exterior",
        "caption": "Former Midwest Center for Reproductive Health exterior",
        "_source": {
          "url": "https://www.invitra.com/en/midwest-centre-for-reproductive-health/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, HealthPartners, Medica",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Minnesota (MN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-82",
    "externalIds": {
      "cdcClinicId": "82",
      "googlePlaceId": "ChIJR5Oasv3W94cR1XizC_ULgOE"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Medicine & Infertility Associates",
    "phone": "(651) 222-6050",
    "address": {
      "line1": "Woodbury Medical Arts Building, 2101 Woodwinds Dr, Suite 100",
      "city": "Woodbury",
      "state": "MN",
      "zip": "55125",
      "country": "US"
    },
    "location": {
      "lat": 44.9176,
      "lng": -92.9798
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 54,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 42.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 40.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 645,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2782%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2782%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.rmia.com/providers/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Reproductive+Medicine+and+Infertility+Associates,+2101+Woodwinds+Dr.+%23100,+Woodbury,+MN+55125/@44.9177702,-92.9798255,2825a,13.1y/data=!4m2!3m1!1s0x87f7d6fdb29a9347:0xe1800bf50bb378d5",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-82-phoebe-h-leonard-md",
        "name": "Phoebe H. Leonard, MD",
        "role": "Reproductive Endocrinologist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.rmia.com/wp-content/uploads/2024/07/Phoebe-Leonard-MD-RMIA-profile-2024.png",
        "_source": {
          "url": "https://www.rmia.com/providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-82-jani-r-jensen-md",
        "name": "Jani R. Jensen, MD",
        "role": "Reproductive Endocrinologist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.rmia.com/wp-content/uploads/2024/07/Jani-Jensen-MD-RMIA-profile-2024.png",
        "_source": {
          "url": "https://www.rmia.com/providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-82-tana-kim-md",
        "name": "Tana Kim, MD",
        "role": "Reproductive Endocrinologist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.rmia.com/wp-content/uploads/2024/08/Tana-Kim-MD-RMIA-square-2024.jpg",
        "_source": {
          "url": "https://www.rmia.com/providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-82-sarah-baumgarten-md-phd",
        "name": "Sarah Baumgarten, MD, PhD",
        "role": "Reproductive Endocrinologist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.rmia.com/wp-content/uploads/2024/07/Sarah-Baumgarten-MD-PHD-RMIA-profile-2024.png",
        "_source": {
          "url": "https://www.rmia.com/providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-82-g-david-ball-phd",
        "name": "G. David Ball, PhD",
        "role": "Laboratory Director",
        "specialty": "Embryology Laboratory Director",
        "imageUrl": "https://www.rmia.com/wp-content/uploads/2021/03/G-David-Ball-PhD-RMIA-square.jpg",
        "_source": {
          "url": "https://www.rmia.com/providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-82-michelle-valentine-aprn-cnp",
        "name": "Michelle Valentine, APRN, CNP",
        "role": "Nurse Practitioner",
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://www.rmia.com/wp-content/uploads/2024/07/Michelle-Valentine-RMIA-profile-2024.png",
        "_source": {
          "url": "https://www.rmia.com/providers/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.rmia.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "HealthPartners",
        "Medica"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, HealthPartners, Medica",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Minnesota (MN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-187",
    "externalIds": {
      "cdcClinicId": "187",
      "googlePlaceId": "ChIJPeInYa9E34cRnRZj6hh-7XA"
    },
    "type": "fertility-clinic",
    "name": "Center for Reproductive Medicine & Robotic Surgery",
    "phone": "(314) 473-1285",
    "address": {
      "line1": "844 N. New Ballas Ct, Suite 300",
      "city": "St. Louis",
      "state": "MO",
      "zip": "63141",
      "country": "US"
    },
    "location": {
      "lat": 38.6731,
      "lng": -90.4443
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 46.666666666666664,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/15"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "0/5"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 32,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27187%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27187%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://gofertility.com/about-us/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Center+for+Reproductive+Medicine+and+Robotic+Surgery,+844+N+New+Ballas+Ct+Ste+300,+Creve+Coeur,+MO+63141/@38.6731073,-90.4443462,3115a,13.1y/data=!4m2!3m1!1s0x87df44af6127e23d:0x70ed7e18ea63169d",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-187-saji-jacob-md",
        "name": "Saji Jacob, MD",
        "role": "Medical Director",
        "imageUrl": "https://gofertility.com/wp-content/uploads/2024/04/dr-jacobs-standing-with-certificate-background-1-scaled.jpg",
        "credentials": ["MD", "FACOG", "HCLD (ABB)"],
        "_source": {
          "url": "https://gofertility.com/about-us/dr-saji-jacob/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://gofertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://gofertility.com/wp-content/uploads/2024/04/crmrs-building-outside.jpg",
        "type": "exterior",
        "caption": "Exterior of the Center for Reproductive Medicine & Robotic Surgery (CRMRS) building at 844 N. New Ballas Ct, St. Louis, MO, showing the clinic's CRMRS branding on the facade",
        "_source": {
          "url": "https://gofertility.com/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnrGamz3pERskT2rxOXlYVcSkXo3kNKAgcOWj9UBk88zepuncBhp4jTDCb1jATB4eAbjEY30ZDhRc-nphLAvA8DeXCMhk5HkWzKbnfkgpXzeGLlsitXL6hvUtkWpkbe7CWmFgjc=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Center+for+Reproductive+Medicine+and+Robotic+Surgery,+844+N+New+Ballas+Ct+Ste+300,+Creve+Coeur,+MO+63141/@38.6731073,-90.4443462,3115a,13.1y/data=!4m2!3m1!1s0x87df44af6127e23d:0x70ed7e18ea63169d",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Missouri (MO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-389",
    "externalIds": {
      "cdcClinicId": "389",
      "googlePlaceId": "ChIJAzXh_9u02IcR9NcgNggV2jQ"
    },
    "type": "fertility-clinic",
    "name": "Fertility and Reproductive Medicine Center, at Washington University School of Medicine and Barnes-Jewish Hospital",
    "phone": "(314) 286-2400",
    "address": {
      "line1": "4444 Forest Park Ave, Suite 3100",
      "city": "St. Louis",
      "state": "MO",
      "zip": "63108",
      "country": "US"
    },
    "location": {
      "lat": 38.6372,
      "lng": -90.257
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 47.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 49,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 21.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 17.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 503,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27389%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27389%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://fertility.wustl.edu/about-us/our-team/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Washington+University+Fertility+and+Reproductive+Medicine+Center,+4444+Forest+Park+Ave+Ste+3100,+St.+Louis,+MO+63110/@38.6370277,-90.2566909,3117a,13.1y/data=!4m2!3m1!1s0x87d8b4dbffe13503:0x34da15083620d7f4",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-389-kenan-r-omurtag-md",
        "name": "Kenan R. Omurtag, MD",
        "role": "Medical Director",
        "imageUrl": "https://fertility.wustl.edu/app/uploads/2023/01/kenanomurtag22-280x386.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://fertility.wustl.edu/people/kenan-r-omurtag-md/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Valerie S. Ratts, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://fertility.wustl.edu/app/uploads/2023/01/ratts22-280x386.jpg",
        "_source": {
          "url": "https://fertility.wustl.edu/people/valerie-s-ratts-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-389-valerie-s-ratts-md"
      },
      {
        "name": "Dan I. Lebovic, MD, MA",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MA"],
        "imageUrl": "https://fertility.wustl.edu/app/uploads/2022/06/thumbnail_Lebovic-Dan_OBGYN_09_300.jpg",
        "_source": {
          "url": "https://fertility.wustl.edu/people/dan-i-lebovic-md-ma/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-389-dan-i-lebovic-md-ma"
      },
      {
        "name": "Dane Johnson, MD",
        "role": "Urologist and Male Factor Infertility Specialist",
        "credentials": ["MD"],
        "imageUrl": "https://fertility.wustl.edu/app/uploads/2018/03/Dane-280x386.jpg",
        "_source": {
          "url": "https://fertility.wustl.edu/people/dane-johnson-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-389-dane-johnson-md"
      },
      {
        "name": "Patricia Jimenez, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://fertility.wustl.edu/app/uploads/2023/01/jimenez22-280x386.jpg",
        "_source": {
          "url": "https://fertility.wustl.edu/people/patricia-jimenez-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-389-patricia-jimenez-md"
      },
      {
        "name": "Megan Gornet, MD",
        "role": "Reproductive Surgeon",
        "credentials": ["MD"],
        "imageUrl": "https://fertility.wustl.edu/app/uploads/2024/09/Gornet-Megan_Obgyn__04_1400x1930-743x1024-1-280x386.png",
        "_source": {
          "url": "https://fertility.wustl.edu/people/megan-gornet-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-389-megan-gornet-md"
      },
      {
        "name": "Anna Geiger, WHNP-BC",
        "role": "Women's Health Nurse Practitioner",
        "credentials": ["WHNP-BC"],
        "imageUrl": "https://fertility.wustl.edu/app/uploads/2023/01/geiger22-280x386.jpg",
        "_source": {
          "url": "https://fertility.wustl.edu/people/anna-geiger-whnp-bc/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-389-anna-geiger-whnp-bc"
      },
      {
        "name": "Marisa Andrews, MS, CGC",
        "role": "Clinical Genetic Counselor",
        "credentials": ["MS", "CGC"],
        "imageUrl": "https://fertility.wustl.edu/app/uploads/2018/12/marisaandrews-280x386.jpg",
        "_source": {
          "url": "https://fertility.wustl.edu/people/marisa-andrews-ms-cgc/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-389-marisa-andrews-ms-cgc"
      },
      {
        "name": "Ali Ahmady, PhD, HCLD, EMB",
        "role": "Laboratory Director",
        "credentials": ["PhD", "HCLD", "EMB"],
        "imageUrl": "https://fertility.wustl.edu/app/uploads/2023/01/ahmady22-280x386.jpg",
        "_source": {
          "url": "https://fertility.wustl.edu/people/ali-ahmady-phd-hcld/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-389-ali-ahmady-phd-hcld-emb"
      },
      {
        "name": "Aileen Portugal, MD",
        "role": "Clinical Fellow",
        "credentials": ["MD"],
        "imageUrl": "https://fertility.wustl.edu/app/uploads/2023/08/Portugal-1-2-280x386.jpeg",
        "_source": {
          "url": "https://fertility.wustl.edu/people/aileen-portugal-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-389-aileen-portugal-md"
      },
      {
        "name": "Rand Sharaiha, MD",
        "role": "Clinical Fellow",
        "credentials": ["MD"],
        "imageUrl": "https://fertility.wustl.edu/app/uploads/2024/08/RandElSharaiha-1-645x889-1-280x386.jpg",
        "_source": {
          "url": "https://fertility.wustl.edu/people/rand-sharaiha-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-389-rand-sharaiha-md"
      },
      {
        "name": "Mitra Sharifi, MD, MS",
        "role": "Clinical Fellow",
        "credentials": ["MD", "MS"],
        "imageUrl": "https://fertility.wustl.edu/app/uploads/2025/08/Mitra-Sharifi-280x386.jpg",
        "_source": {
          "url": "https://fertility.wustl.edu/people/mitra-sharifi-md-ms/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-389-mitra-sharifi-md-ms"
      }
    ],
    "website": "https://www.fertility.wustl.edu",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkWtWFFAu92oWUDBaG_B0QeLsREA5NN-jvI1cAAwp5dr6Nal9HPm6aOG59saodT1UAIJCpiYHpz5-7TeyqI2OfsBbjnacCNSqlGGvtQQGuNcXOVAkaUsbp1XHCW3SO_ToEaKO-eWA=w140-h248-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Washington+University+Fertility+and+Reproductive+Medicine+Center,+4444+Forest+Park+Ave+Ste+3100,+St.+Louis,+MO+63110/@38.6370277,-90.2566909,3117a,13.1y/data=!4m2!3m1!1s0x87d8b4dbffe13503:0x34da15083620d7f4",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Missouri (MO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-387",
    "externalIds": {
      "cdcClinicId": "387",
      "googlePlaceId": "ChIJefH2ZyIo34cR6jehxizh-64"
    },
    "type": "fertility-clinic",
    "name": "Fertility Partnership",
    "phone": "(636) 441-7770",
    "address": {
      "line1": "5401 Veterans Memorial Pkwy, Suite 201",
      "city": "Saint Peters",
      "state": "MO",
      "zip": "63376",
      "country": "US"
    },
    "location": {
      "lat": 38.7971,
      "lng": -90.595
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 44.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 36.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 28.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 220,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27387%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27387%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://fertilitypartnership.com",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Partnership+St.+Louis+IVF,+5401+Veterans+Memorial+Pkwy+Ste+201,+St+Peters,+MO+63376/@38.797091,-90.595009,3110a,13.1y/data=!4m2!3m1!1s0x87df282267f6f179:0xaefbe12cc6a137ea",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-387-david-elan-simckes-md",
        "name": "David Elan Simckes, MD",
        "role": "Medical Director",
        "imageUrl": "https://fertilitypartnership.com/wp-content/uploads/2024/02/dr-elan-simckes-fertility-doctor-st-louis.webp",
        "credentials": ["MD"],
        "_source": {
          "url": "https://fertilitypartnership.com/meet-the-team/dr-elansimckes/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.fertilitypartnership.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://fertilitypartnership.com/wp-content/uploads/2021/11/fertility-partnership-lobby-copy.webp",
        "type": "interior",
        "caption": "Fertility Partnership waiting room / lobby with seating, baby photo artwork, and reception area at the St. Peters office",
        "_source": {
          "url": "https://fertilitypartnership.com/locations/st-peters/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmzsA_Tm5W4WoggMsNpLfzeudXbyfE8k7x7IBWSVCMxeIrhhG70OF37W8TOjsvrYQHKPyqWBzEgm8lRj9xRT5W-YskB18sDpdzGPAx-chZ8a0rzZjq0jr_3WKUdi3fO0DZyuYo=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Partnership+St.+Louis+IVF,+5401+Veterans+Memorial+Pkwy+Ste+201,+St+Peters,+MO+63376/@38.797091,-90.595009,3110a,13.1y/data=!4m2!3m1!1s0x87df282267f6f179:0xaefbe12cc6a137ea",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Missouri (MO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-420",
    "externalIds": {
      "cdcClinicId": "420",
      "googlePlaceId": "ChIJ8UGQMMss34cRQsyG07vyd2c"
    },
    "type": "fertility-clinic",
    "name": "Infertility Center of St. Louis",
    "phone": "(314) 576-1400",
    "address": {
      "line1": "224 S. Woods Mill Rd, Suite 730",
      "city": "Chesterfield",
      "state": "MO",
      "zip": "63017",
      "country": "US"
    },
    "location": {
      "lat": 38.652,
      "lng": -90.5026
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 38,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27420%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27420%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.infertile.com/about-the-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Infertility+Center+of+St+Louis,+224+S+Woods+Mill+Rd+Ste+730,+Chesterfield,+MO+63017/@38.6518933,-90.5026361,3116a,13.1y/data=!4m2!3m1!1s0x87df2ccb309041f1:0x6777f2bbd386cc42",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-420-sherman-j-silber-md",
        "name": "Sherman J. Silber, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.infertile.com/wp-content/uploads/2020/07/Dr.-Silber-3.png",
        "credentials": ["MD"],
        "_source": {
          "url": "https://www.infertile.com/about-the-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Michael DeRosa, MD",
        "role": "Gynecologist and Fertility Physician",
        "credentials": ["MD"],
        "imageUrl": "https://www.infertile.com/wp-content/uploads/2019/10/derosa-silber.jpg",
        "_source": {
          "url": "https://www.infertile.com/about-the-center/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-420-michael-derosa-md"
      },
      {
        "name": "Yuting \"Fanny\" Fan, MD",
        "role": "Reproductive Physician and Embryologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.infertile.com/wp-content/uploads/2019/08/fanny_yuting_fan.jpg",
        "_source": {
          "url": "https://www.infertile.com/about-the-center/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-420-yuting-fanny-fan-md"
      }
    ],
    "website": "https://www.infertile.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://www.infertile.com/wp-content/uploads/2019/10/lab-facility.jpg",
        "type": "lab",
        "caption": "The center's advanced microsurgery and egg-retrieval treatment room for IVF and microsurgery",
        "_source": {
          "url": "https://www.infertile.com/about-the-center/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Missouri (MO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-702",
    "externalIds": {
      "cdcClinicId": "702"
    },
    "type": "fertility-clinic",
    "name": "Kindbody Fertility Institute-St Louis",
    "phone": "(314) 266-2062",
    "address": {
      "line1": "347 N Lindbergh Blvd",
      "city": "St Louis",
      "state": "MO",
      "zip": "63141",
      "country": "US"
    },
    "location": {
      "lat": 38.5662,
      "lng": -89.9868
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 46.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 36.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 28.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 24.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 790,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27702%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27702%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.kindbody.com/ivf-cost/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/st-louis-location/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-702-amber-cooper-md",
        "name": "Amber Cooper, MD",
        "role": "Medical Director",
        "imageUrl": "https://kindbody.com/wp-content/uploads/2022/05/Dr-Cooper.png",
        "credentials": ["MD", "MS"],
        "_source": {
          "url": "https://kindbody.com/team/dr-amber-cooper/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Kelsey Anderson",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://kindbody.com/wp-content/uploads/2023/09/Dr.-Kelsey-Anderson-edit.jpg",
        "_source": {
          "url": "https://kindbody.com/team/dr-kelsey-anderson/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-702-kelsey-anderson"
      },
      {
        "name": "Caitlin Bley",
        "role": "Advanced Practice Provider / Certified Nurse Midwife",
        "credentials": ["DNP", "CNM", "IBCLC"],
        "imageUrl": "https://kindbody.com/wp-content/uploads/2025/05/Caitlin-Bley-Web2.jpg",
        "_source": {
          "url": "https://kindbody.com/team/caitlin-bley-dnp-cnm-ibclc/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-702-caitlin-bley"
      },
      {
        "name": "Keeley Clanahan",
        "role": "Nurse Practitioner",
        "credentials": ["DNP", "APRN", "FNP-C"],
        "imageUrl": "https://kindbody.com/wp-content/uploads/2025/05/Keeley-Clanahan-Web.jpg",
        "_source": {
          "url": "https://kindbody.com/team/keeley-clanahan-dnp-aprn-fnp-c/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-702-keeley-clanahan"
      }
    ],
    "network": {
      "name": "Kindbody"
    },
    "website": "https://www.kindbody.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Anthem",
        "Blue Cross Blue Shield",
        "Cigna",
        "Emblem Health",
        "Empire Blue Cross Blue Shield",
        "First Health",
        "Health Net",
        "Horizon",
        "Humana",
        "Maven",
        "Medicare",
        "Medicaid",
        "MultiPlan",
        "Optum",
        "Oscar",
        "Oxford",
        "Progyny",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven"],
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "pricing": {
      "packages": [
        {
          "name": "Pulse Assessment",
          "description": "Quick fertility check — not covered by insurance",
          "price": 9900,
          "currency": "USD",
          "includes": [
            "AMH blood test",
            "Transvaginal ultrasound for follicle count",
            "15-minute reproductive consultation"
          ],
          "notes": "Not covered by insurance"
        },
        {
          "name": "Fertility Consultation",
          "description": "Specialist consultation on fertility fundamentals",
          "price": 30000,
          "currency": "USD",
          "notes": "Billable to most insurance plans"
        },
        {
          "name": "Male Consultation + Semen Analysis",
          "price": 52500,
          "currency": "USD",
          "includes": ["Consultation", "Venipuncture", "Semen analysis"]
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Single egg freezing cycle",
          "price": 690000,
          "priceMax": 966000,
          "currency": "USD",
          "includes": [
            "Stimulation visits",
            "Ultrasounds",
            "Blood draws",
            "Retrieval",
            "Cryopreservation",
            "3 months storage",
            "Coordination"
          ],
          "excludes": ["Medications ($4,000 - $6,000)", "Anesthesia"]
        },
        {
          "name": "Annual Egg Storage",
          "price": 92000,
          "currency": "USD",
          "notes": "Per year"
        },
        {
          "name": "IVF Freeze All (Self Pay)",
          "description": "IVF cycle with all embryos frozen",
          "price": 1160000,
          "priceMax": 1850000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Cryopreservation",
            "3 months storage"
          ],
          "excludes": [
            "Medications (~$4,000 - $6,000)",
            "Embryo biopsy/genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Donor services",
            "Anesthesia"
          ]
        },
        {
          "name": "IVF Fresh Transfer (Self Pay)",
          "description": "IVF cycle with fresh embryo transfer",
          "price": 1380000,
          "priceMax": 1875000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$5,000 - $9,000)",
            "Genetic testing",
            "Surplus embryo storage",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Freeze All",
          "price": 910000,
          "priceMax": 1332000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Cryopreservation",
            "3-month storage"
          ],
          "excludes": [
            "Genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Fresh Transfer",
          "price": 990000,
          "priceMax": 1428000,
          "currency": "USD",
          "includes": [
            "Ultrasounds",
            "Thaw",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Surplus storage",
            "Frozen transfers",
            "Anesthesia"
          ]
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 400000,
          "priceMax": 550000,
          "currency": "USD",
          "includes": ["Ultrasounds", "Thaw", "Assisted hatching", "Transfer"],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "PGT Package",
          "description": "Preimplantation genetic testing",
          "price": 160000,
          "priceMax": 300000,
          "currency": "USD",
          "includes": ["Embryo biopsy", "Lab management"],
          "excludes": ["Storage", "Shipping", "Per-embryo testing costs"]
        },
        {
          "name": "Nutrition Coaching",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Counseling & Support",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Guided Meditation",
          "description": "Virtual wellness — 30-minute session",
          "price": 9000,
          "currency": "USD"
        }
      ],
      "financingOptions": [
        {
          "name": "PatientFi monthly payments",
          "description": "PatientFi monthly payments"
        }
      ],
      "disclaimer": "Prices vary by location. Medications and anesthesia are not included in procedure costs. 3 months of storage included with freeze procedures; annual storage is $920.",
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Blue Cross Blue Shield, Cigna, Emblem Health, Empire Blue Cross Blue Shield, First Health, Health Net",
              "detail": "12 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "14 public price package(s) and 1 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Missouri (MO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-609",
    "externalIds": {
      "cdcClinicId": "609",
      "googlePlaceId": "ChIJux78JxC43IcR9y4QkN9VWQc"
    },
    "type": "fertility-clinic",
    "name": "MCRM Fertility",
    "phone": "(636) 778-9899",
    "address": {
      "line1": "17300 N. Outer 40 Rd, Suite 101",
      "city": "Chesterfield",
      "state": "MO",
      "zip": "63005",
      "country": "US"
    },
    "location": {
      "lat": 38.672,
      "lng": -90.6008
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 62.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 50.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 52.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 36.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 661,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27609%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27609%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.mcrmfertility.com/our-practice/our-caregivers/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/MCRM+Fertility,+17300+N+Outer+40+Rd+%23101,+Chesterfield,+MO+63005/@38.6720126,-90.6007656,3115a,13.1y/data=!4m2!3m1!1s0x87dcb81027fc1ebb:0x75955df90102ef7",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-609-mira-aubuchon-md",
        "name": "Mira Aubuchon, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.mcrmfertility.com/wp-content/uploads/2023/05/mira-aubuchon-1024x1024.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.mcrmfertility.com/caregivers/mira-aubuchon-md-facog/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Peter Ahlering",
        "role": "Practice Director, Fertility Doctor",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.mcrmfertility.com/wp-content/uploads/2023/05/peter-ahlering-1024x1024.jpg",
        "_source": {
          "url": "https://www.mcrmfertility.com/caregivers/peter-ahlering-md-facog/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-609-peter-ahlering"
      },
      {
        "name": "Randy Fink",
        "role": "Reproductive Specialist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.mcrmfertility.com/wp-content/uploads/2025/09/Dr.-Randy-Fink-cropped-sq-1024x1024.jpg",
        "_source": {
          "url": "https://www.mcrmfertility.com/caregivers/randy-fink-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-609-randy-fink"
      },
      {
        "name": "Lauren Rackovan",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "APRN", "WHNP-BC"],
        "imageUrl": "https://www.mcrmfertility.com/wp-content/uploads/2025/10/Lauren_Rackovan_1024x1024-1.png",
        "_source": {
          "url": "https://www.mcrmfertility.com/caregivers/lauren-rackovan-msn-aprn-whnp-bc/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-609-lauren-rackovan"
      }
    ],
    "website": "https://www.mcrmfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://www.mcrmfertility.com/wp-content/uploads/2023/09/17300-N-Outer-Forty-Chesterfield-MO-Building-Photo-2-LargeHighDefinition-1.jpg",
        "type": "exterior",
        "caption": "Exterior of the MCRM Fertility building at 17300 N. Outer Forty, Chesterfield, MO",
        "_source": {
          "url": "https://www.mcrmfertility.com/our-practice/locations/st-louis-fertility-clinic/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlrAeBxFfwR2iJfDjOhhrbiuiaxjbUgoLRubGGeYoDBjwUqTEZNRK_jqfI1W0CHCjscDGJtHXaxgODyZDp_zcIHDP73OP3yi_b78BoTLL-53Y5875paC3NQY3jirLhU__44GfONwQ=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/MCRM+Fertility,+17300+N+Outer+40+Rd+%23101,+Chesterfield,+MO+63005/@38.6720126,-90.6007656,3115a,13.1y/data=!4m2!3m1!1s0x87dcb81027fc1ebb:0x75955df90102ef7",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl4G3HpYCHWgjtlJft1MvSPFxcJge_SlObl1m0VFTfZR64DCg7ponM5FP24k7-ErOg4ktxK1xtYTkw_XwGREzS_m6vxNq1vVsMcBQ_OyaWmrbQxsFHdvj6KyYrZGnmYasHK8R4Z1g=w224-h298-k-no-pi-0-ya76.99999-ro-0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/MCRM+Fertility,+17300+N+Outer+40+Rd+%23101,+Chesterfield,+MO+63005/@38.6720126,-90.6007656,3115a,13.1y/data=!4m2!3m1!1s0x87dcb81027fc1ebb:0x75955df90102ef7",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Missouri (MO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-365",
    "externalIds": {
      "cdcClinicId": "365"
    },
    "type": "fertility-clinic",
    "name": "Missouri Fertility",
    "phone": "(573) 443-4511",
    "address": {
      "line1": "1506 E. Broadway, Suite 220",
      "city": "Columbia",
      "state": "MO",
      "zip": "65201",
      "country": "US"
    },
    "location": {
      "lat": 38.9505,
      "lng": -92.3174
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 41,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 52.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 66.66666666666666,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "8/12"
        }
      ],
      "cyclesPerYear": 98,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27365%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27365%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.missourifertility.com/our-team.html",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-365-gilbert-b-wilshire-md",
        "name": "Gilbert B. Wilshire, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.missourifertility.com/uploads/3/8/7/5/38755215/published/untitled-design-2024-11-26t155205-542.png?1732657952",
        "credentials": [
          "MD",
          "FACOG",
          "ABOG (Reproductive Endocrinology & Infertility)"
        ],
        "_source": {
          "url": "https://www.missourifertility.com/our-team.html",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Felicia",
        "role": "Fertility Nurse, Surgical 1st Assist",
        "credentials": ["RN"],
        "imageUrl": "https://www.missourifertility.com/uploads/3/8/7/5/38755215/published/3.png?1780492909",
        "_source": {
          "url": "https://www.missourifertility.com/our-team.html",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-365-felicia"
      },
      {
        "name": "Kalli",
        "role": "OB/GYN Sonographer",
        "credentials": ["RDMS"],
        "imageUrl": "https://www.missourifertility.com/uploads/3/8/7/5/38755215/published/untitled-design-2024-11-26t152301-589.png?1780492924",
        "_source": {
          "url": "https://www.missourifertility.com/our-team.html",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-365-kalli"
      },
      {
        "name": "Jaime Hogerty, PhD",
        "role": "Laboratory Director",
        "credentials": ["PhD", "HCLD"],
        "imageUrl": "https://www.missourifertility.com/uploads/3/8/7/5/38755215/published/untitled-design-98.png?1732655969",
        "_source": {
          "url": "https://www.missourifertility.com/our-team.html",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-365-jaime-hogerty-phd"
      },
      {
        "name": "David Wax, BS",
        "role": "Lab Manager / Embryologist",
        "credentials": [
          "BS",
          "Board Certified Lab Supervisor (American Board of Bioanalysis)"
        ],
        "imageUrl": "https://www.missourifertility.com/uploads/3/8/7/5/38755215/published/untitled-design-99.png?1732655980",
        "_source": {
          "url": "https://www.missourifertility.com/our-team.html",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-365-david-wax-bs"
      },
      {
        "name": "Melissa Fudge",
        "role": "Junior Embryologist",
        "credentials": [],
        "imageUrl": "https://www.missourifertility.com/uploads/3/8/7/5/38755215/published/untitled-design-2024-11-26t153020-806.png?1732656729",
        "_source": {
          "url": "https://www.missourifertility.com/our-team.html",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-365-melissa-fudge"
      },
      {
        "name": "Victoria Schulte",
        "role": "Andrology & Endocrine Lab",
        "credentials": [],
        "imageUrl": "https://www.missourifertility.com/uploads/3/8/7/5/38755215/published/untitled-design-2024-11-26t153033-559.png?1732656738",
        "_source": {
          "url": "https://www.missourifertility.com/our-team.html",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-365-victoria-schulte"
      }
    ],
    "website": "https://www.missourifertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Missouri (MO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-268",
    "externalIds": {
      "cdcClinicId": "268"
    },
    "type": "fertility-clinic",
    "name": "MU Healthcare, Reproductive Health and Fertility Center",
    "phone": "(573) 817-3101",
    "address": {
      "line1": "500 N. Keene St, Suite 203",
      "city": "Columbia",
      "state": "MO",
      "zip": "65201",
      "country": "US"
    },
    "location": {
      "lat": 38.9582,
      "lng": -92.2878
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 42.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "0/7"
        }
      ],
      "cyclesPerYear": 60,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27268%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27268%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.muhealth.org/locations/reproductive-health-and-fertility-center",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-268-albert-l-hsu-md",
        "name": "Albert L. Hsu, MD",
        "role": "Medical Director"
      },
      {
        "name": "Tia Brodeur, MD, PhD",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD", "PhD"],
        "imageUrl": "https://www.muhealth.org/sites/default/files/styles/400x600/public/2025-05/Brodeur_Tia-23-1000x1200.jpg?itok=Zfy3-p68",
        "_source": {
          "url": "https://www.muhealth.org/doctors/tia-brodeur-md",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-268-tia-brodeur-md-phd"
      }
    ],
    "website": "https://www.muhealth.org/fertility",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://www.muhealth.org/sites/default/files/2019-04/KeeneMedicalBuilding015-1400_0-compressor_0_1.jpg",
        "type": "exterior",
        "caption": "Keene Medical Building, home of MU Health Care's Reproductive Health and Fertility Center (500 N. Keene St)",
        "_source": {
          "url": "https://www.muhealth.org/locations/reproductive-health-and-fertility-center",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Missouri (MO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-164",
    "externalIds": {
      "cdcClinicId": "164",
      "googlePlaceId": "ChIJkVS8DwUz34cR9PhrfmFZxlg"
    },
    "type": "fertility-clinic",
    "name": "STL Fertility",
    "phone": "(314) 983-9000",
    "address": {
      "line1": "555 N. New Ballas Rd, Suite 150",
      "city": "St. Louis",
      "state": "MO",
      "zip": "63141",
      "country": "US"
    },
    "location": {
      "lat": 38.6659,
      "lng": -90.4439
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 29.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 52.94117647058824,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "9/17"
        }
      ],
      "cyclesPerYear": 201,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27164%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27164%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.stlfertility.com/about",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/STL+Fertility,+555+N+New+Ballas+Rd+Ste+150,+St.+Louis,+MO+63141/@38.6657185,-90.4438987,3115a,13.1y/data=!4m2!3m1!1s0x87df33050fbc5491:0x58c659617e6bf8f4",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-164-molina-b-dayal-md",
        "name": "Molina B. Dayal, MD",
        "role": "Medical Director",
        "imageUrl": "https://static.wixstatic.com/media/c3b9db_cb333f11c1cf4efeb35c47c4d77fab5a~mv2.jpeg",
        "credentials": [
          "MD",
          "MPH",
          "Board Certified OB/GYN",
          "Board Certified REI"
        ],
        "_source": {
          "url": "https://www.stlfertility.com/about",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Maureen Schulte, MD",
        "role": "Operations Director, Reproductive Endocrinologist",
        "credentials": ["MD", "Board Certified OB/GYN", "Board Certified REI"],
        "imageUrl": "https://static.wixstatic.com/media/c3b9db_c164a5f030734667ad5a365ee553c883~mv2.jpg",
        "_source": {
          "url": "https://www.stlfertility.com/about",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-164-maureen-schulte-md"
      },
      {
        "name": "Violet Klenov, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "Board Certified OB/GYN", "Board Certified REI"],
        "imageUrl": "https://static.wixstatic.com/media/c3b9db_dd30b640d70844b9bf4d23ef1f3680c9~mv2.jpeg",
        "_source": {
          "url": "https://www.stlfertility.com/about",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-164-violet-klenov-md"
      },
      {
        "name": "Melanie Miranda, WHNP-BC",
        "role": "Nurse Practitioner, Women's Health",
        "credentials": ["WHNP-BC"],
        "imageUrl": "https://static.wixstatic.com/media/c3b9db_c29cc4728df644f299b9d493014a8b86~mv2.jpeg",
        "_source": {
          "url": "https://www.stlfertility.com/about",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-164-melanie-miranda-whnp-bc"
      },
      {
        "name": "Ellie Engelhardt, WHNP-BC",
        "role": "Nurse Practitioner, Women's Health",
        "credentials": ["WHNP-BC"],
        "imageUrl": "https://static.wixstatic.com/media/c3b9db_089f15b20db14047a4dd0b11b559fca8~mv2.jpg",
        "_source": {
          "url": "https://www.stlfertility.com/about",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-164-ellie-engelhardt-whnp-bc"
      },
      {
        "name": "Sheela Ali, PhD",
        "role": "Off-Site Laboratory Director",
        "credentials": ["PhD", "HCLD", "CC", "TS"],
        "imageUrl": "https://static.wixstatic.com/media/8c71e2_2f975595f44e494382c1eef260b4d09c~mv2.jpg",
        "_source": {
          "url": "https://www.stlfertility.com/about",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-164-sheela-ali-phd"
      },
      {
        "name": "Jaclyn Lambe-Steinmiller, PhD",
        "role": "On-Site Laboratory Director",
        "credentials": ["PhD", "HCLD"],
        "imageUrl": "https://static.wixstatic.com/media/d192ad_23133e81f4044bc08ca3496dbe6b547c~mv2.jpg",
        "_source": {
          "url": "https://www.stlfertility.com/about",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-164-jaclyn-lambe-steinmiller-phd"
      }
    ],
    "website": "https://www.stlfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Missouri (MO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-410",
    "externalIds": {
      "cdcClinicId": "410",
      "googlePlaceId": "ChIJURd7o-YsKIYRdxkLU3jrZoM"
    },
    "type": "fertility-clinic",
    "name": "Mississippi Reproductive Medicine, PLLC",
    "phone": "(601) 936-3650",
    "address": {
      "line1": "2500 Lakeland Dr",
      "city": "Flowood",
      "state": "MS",
      "zip": "39232",
      "country": "US"
    },
    "location": {
      "lat": 32.3306,
      "lng": -90.1223
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 59.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 66.66666666666666,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "10/15"
        },
        {
          "ageBand": "38-40",
          "rate": 60,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/10"
        }
      ],
      "cyclesPerYear": 115,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27410%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://reproductivemedms.com/locations/flowood-ms/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27410%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://reproductivemedms.com/meet-our-team/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Mississippi+Reproductive+Medicine,+2500+Lakeland+Dr,+Flowood,+MS+39232/@32.3306239,-90.1222775,3371a,13.1y/data=!4m2!3m1!1s0x86282ce6a37b1751:0x8366eb78530b1977",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://reproductivemedms.com/locations/flowood-ms/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-410-randall-s-hines-md",
        "name": "Randall S. Hines, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://reproductivemedms.com/wp-content/uploads/2022/07/Dr.-Hines-2.jpg",
        "_source": {
          "url": "https://reproductivemedms.com/meet-our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-410-marty-gebhart-dnp-np-bc-c-rhi",
        "name": "Marty Gebhart, DNP, NP-BC, C-RHI",
        "role": "Nurse Practitioner",
        "credentials": ["DNP", "NP-BC", "C-RHI"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://reproductivemedms.com/wp-content/uploads/2022/07/Dr.-Gebhart.png",
        "_source": {
          "url": "https://reproductivemedms.com/meet-our-team/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://reproductivemedms.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://reproductivemedms.com/wp-content/uploads/2026/02/image-1-2.png",
        "type": "exterior",
        "caption": "Mississippi Reproductive Medicine Flowood clinic exterior.",
        "_source": {
          "url": "https://reproductivemedms.com/locations/flowood-ms/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Mississippi (MS) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-809",
    "externalIds": {
      "cdcClinicId": "809",
      "googlePlaceId": "ChIJNSUl5t3RKYYRP786Iozw1Js"
    },
    "type": "fertility-clinic",
    "name": "Positive Steps Fertility",
    "phone": "855-441-0226",
    "address": {
      "line1": "149 Fountains Blvd",
      "city": "Madison",
      "state": "MS",
      "zip": "39110",
      "country": "US"
    },
    "location": {
      "lat": 32.4707,
      "lng": -90.1451
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 41.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 25,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 231,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27809%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://positivestepsfertility.com/locations/mississippi/madison-fertility-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27809%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://positivestepsfertility.com/about/staff/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Positive+Steps+Fertility+-+Madison,+149+Fountains+Blvd,+Madison,+MS+39110/@32.4706673,-90.1449267,3366a,13.1y/data=!4m2!3m1!1s0x8629d1dde6252535:0x9bd4f08c223abf3f",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://positivestepsfertility.com/locations/mississippi/madison-fertility-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-809-john-preston-parry-md",
        "name": "John Preston Parry, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://positivestepsfertility.com/wp-content/uploads/2025/04/photo-preston-parry-square-300x300-1.jpg",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/mississippi/madison-fertility-clinic",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-809-brittany-linton-nurse-practitioner",
        "name": "Brittany Linton, Nurse Practitioner",
        "role": "Nurse Practitioner",
        "specialty": "Fertility Nursing",
        "imageUrl": "https://positivestepsfertility.com/wp-content/uploads/2026/05/1.png",
        "_source": {
          "url": "https://positivestepsfertility.com/about/staff/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-809-vicki-butler-rn",
        "name": "Vicki Butler, RN",
        "role": "RN",
        "credentials": ["RN"],
        "specialty": "Fertility Nursing",
        "imageUrl": "https://positivestepsfertility.com/wp-content/uploads/2026/05/19.png",
        "_source": {
          "url": "https://positivestepsfertility.com/about/staff/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-809-holly-farmer-rn",
        "name": "Holly Farmer, RN",
        "role": "RN",
        "credentials": ["RN"],
        "specialty": "Fertility Nursing",
        "imageUrl": "https://positivestepsfertility.com/wp-content/uploads/2026/05/17.png",
        "_source": {
          "url": "https://positivestepsfertility.com/about/staff/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-809-courtney-gregory-rn",
        "name": "Courtney Gregory, RN",
        "role": "RN",
        "credentials": ["RN"],
        "specialty": "Fertility Nursing",
        "imageUrl": "https://positivestepsfertility.com/wp-content/uploads/2026/05/18.png",
        "_source": {
          "url": "https://positivestepsfertility.com/about/staff/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-809-ainsley-betcher-rn",
        "name": "Ainsley Betcher, RN",
        "role": "RN",
        "credentials": ["RN"],
        "specialty": "Fertility Nursing",
        "imageUrl": "https://positivestepsfertility.com/wp-content/uploads/2026/05/16.png",
        "_source": {
          "url": "https://positivestepsfertility.com/about/staff/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-809-lisa-dorman-lab-director",
        "name": "Lisa Dorman, Lab Director",
        "role": "Lab Director",
        "specialty": "Embryology",
        "imageUrl": "https://positivestepsfertility.com/wp-content/uploads/2026/05/3.png",
        "_source": {
          "url": "https://positivestepsfertility.com/about/staff/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-809-mandy-nichols-embryologist",
        "name": "Mandy Nichols, Embryologist",
        "role": "Embryologist",
        "specialty": "Embryology",
        "imageUrl": "https://positivestepsfertility.com/wp-content/uploads/2026/05/4.png",
        "_source": {
          "url": "https://positivestepsfertility.com/about/staff/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-809-amanda-doonan-embryologist",
        "name": "Amanda Doonan, Embryologist",
        "role": "Embryologist",
        "specialty": "Embryology",
        "imageUrl": "https://positivestepsfertility.com/wp-content/uploads/2026/05/20.png",
        "_source": {
          "url": "https://positivestepsfertility.com/about/staff/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-809-jessica-thaxton-communications-director",
        "name": "Jessica Thaxton, Communications Director",
        "role": "Communications Director",
        "specialty": "Fertility Care",
        "imageUrl": "https://positivestepsfertility.com/wp-content/uploads/2026/05/23.png",
        "_source": {
          "url": "https://positivestepsfertility.com/about/staff/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-809-kathryn-jackson-practice-manager",
        "name": "Kathryn Jackson, Practice Manager",
        "role": "Practice Manager",
        "specialty": "Fertility Care",
        "imageUrl": "https://positivestepsfertility.com/wp-content/uploads/2026/05/Headshots-3.png",
        "_source": {
          "url": "https://positivestepsfertility.com/about/staff/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-809-anna-thomas-scheduling-coordinator",
        "name": "Anna Thomas, Scheduling Coordinator",
        "role": "Scheduling Coordinator",
        "specialty": "Fertility Care",
        "imageUrl": "https://positivestepsfertility.com/wp-content/uploads/2026/05/22.png",
        "_source": {
          "url": "https://positivestepsfertility.com/about/staff/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-809-tracy-boone-scheduling-coordinator",
        "name": "Tracy Boone, Scheduling Coordinator",
        "role": "Scheduling Coordinator",
        "specialty": "Fertility Care",
        "imageUrl": "https://positivestepsfertility.com/wp-content/uploads/2026/05/21.png",
        "_source": {
          "url": "https://positivestepsfertility.com/about/staff/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-809-april-haley-scheduling-coordinator",
        "name": "April Haley, Scheduling Coordinator",
        "role": "Scheduling Coordinator",
        "specialty": "Fertility Care",
        "imageUrl": "https://positivestepsfertility.com/wp-content/uploads/2026/05/14.png",
        "_source": {
          "url": "https://positivestepsfertility.com/about/staff/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://positivestepsfertility.com/locations/mississippi/madison-fertility-clinic",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Mississippi (MS) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-114",
    "externalIds": {
      "cdcClinicId": "114"
    },
    "type": "fertility-clinic",
    "name": "University of Mississippi Medical Center",
    "phone": "(601) 984-5330",
    "address": {
      "line1": "2925 Layfair Dr, Room 146",
      "city": "Flowood",
      "state": "MS",
      "zip": "39232",
      "country": "US"
    },
    "location": {
      "lat": 32.3276,
      "lng": -90.1128
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 38.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 32,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27114%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/fertility-services-home.html",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27114%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/About-Us/Meet-Our-Team.html",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/fertility-services-home.html",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/fertility-services-home.html",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-114-john-d-isaacs-jr-md",
        "name": "John D. Isaacs, Jr., MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/images/isaacs-300x400.jpg",
        "_source": {
          "url": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/About-Us/Meet-Our-Team.html",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-114-john-rushing-md",
        "name": "John Rushing, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/images/rushing-300x400.jpg",
        "_source": {
          "url": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/About-Us/Meet-Our-Team.html",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-114-martha-claire-thomas-md",
        "name": "Martha Claire Thomas, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/images/martha-claire-thomas-300x400.jpg",
        "_source": {
          "url": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/About-Us/Meet-Our-Team.html",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-114-karyn-fraser",
        "name": "Karyn Fraser",
        "role": "Senior Embryologist",
        "specialty": "Embryology",
        "imageUrl": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/images/fraser-300x400.jpg",
        "_source": {
          "url": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/About-Us/Meet-Our-Team.html",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-114-charity-turner",
        "name": "Charity Turner",
        "role": "Embryologist",
        "specialty": "Embryology",
        "imageUrl": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/images/Charity-Turner.png",
        "_source": {
          "url": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/About-Us/Meet-Our-Team.html",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-114-lyndsey-ayllon-rn",
        "name": "Lyndsey Ayllon, RN",
        "role": "RN",
        "credentials": ["RN"],
        "specialty": "Fertility Nursing",
        "imageUrl": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/images/LyndseyAyllon.jpg",
        "_source": {
          "url": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/About-Us/Meet-Our-Team.html",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-114-ashley-boyte-rn",
        "name": "Ashley Boyte, RN",
        "role": "RN",
        "credentials": ["RN"],
        "specialty": "Fertility Nursing",
        "imageUrl": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/images/Ashley-Boyte.jpg",
        "_source": {
          "url": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/About-Us/Meet-Our-Team.html",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-114-bailey-smith-rn",
        "name": "Bailey Smith, RN",
        "role": "RN",
        "credentials": ["RN"],
        "specialty": "Fertility Nursing",
        "imageUrl": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/images/Bailey-Smith.jpg",
        "_source": {
          "url": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/About-Us/Meet-Our-Team.html",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-114-meghan-stomps-rn",
        "name": "Meghan Stomps, RN",
        "role": "RN",
        "credentials": ["RN"],
        "specialty": "Fertility Nursing",
        "imageUrl": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/images/Meghan-Stomps.jpg",
        "_source": {
          "url": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/About-Us/Meet-Our-Team.html",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-114-beth-mullins",
        "name": "Beth Mullins",
        "role": "Patient Representative",
        "specialty": "Fertility Care",
        "imageUrl": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/images/Beth-Mullins.jpg",
        "_source": {
          "url": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/About-Us/Meet-Our-Team.html",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-114-tina-papp",
        "name": "Tina Papp",
        "role": "Medical Office Assistant",
        "specialty": "Fertility Care",
        "imageUrl": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/images/Tina-Papp.jpg",
        "_source": {
          "url": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/About-Us/Meet-Our-Team.html",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://umc.edu/Healthcare/Womens%20Health/Fertility%20Services/fertility-services-home.html",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Mississippi (MS) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-614",
    "externalIds": {
      "cdcClinicId": "614"
    },
    "type": "fertility-clinic",
    "name": "Billings Clinic, Reproductive Medicine and Fertility Care",
    "phone": "(406) 545-4655",
    "address": {
      "line1": "3319 Gabel Rd, Suite 101",
      "city": "Billings",
      "state": "MT",
      "zip": "59102",
      "country": "US"
    },
    "location": {
      "lat": 45.7906,
      "lng": -108.517
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 50.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 66.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 57.14285714285714,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "8/14"
        }
      ],
      "cyclesPerYear": 198,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27614%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://fertilitymontana.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27614%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://fertilitymontana.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://fertilitymontana.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://fertilitymontana.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-614-stacy-h-shomento-md-facog",
        "name": "Stacy H. Shomento, MD, FACOG",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://framerusercontent.com/images/4MZk8mrbRVCBb6cF7JFI2YiGw.jpg",
        "_source": {
          "url": "https://fertilitymontana.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-614-melanie-a-schmitz-pa",
        "name": "Melanie A. Schmitz, PA",
        "credentials": ["PA"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "role": "Physician Assistant",
        "imageUrl": "https://framerusercontent.com/images/qw0aOQ01QoG15NOD0mqo0tznE.jpg",
        "_source": {
          "url": "https://fertilitymontana.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-614-stephanie-k-dahl-md",
        "name": "Stephanie K. Dahl, MD",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://framerusercontent.com/images/InV43MUwJYkO3O0phfv0rTJ7m8.jpg",
        "_source": {
          "url": "https://fertilitymontana.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://fertilitymontana.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "specialties": ["iui", "ivf", "reproductive-endocrinology"],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Montana (MT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-155",
    "externalIds": {
      "cdcClinicId": "155",
      "googlePlaceId": "ChIJN7-wO3vwrIkR5XjV-EIUZvA"
    },
    "type": "fertility-clinic",
    "name": "Atlantic Reproductive Medicine Specialists, PA",
    "phone": "(919) 248-8777",
    "address": {
      "line1": "10208 Cerny St, Suite 306",
      "city": "Raleigh",
      "state": "NC",
      "zip": "27617",
      "country": "US"
    },
    "location": {
      "lat": 35.9016,
      "lng": -78.8006
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 53.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 60.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 61.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 168,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27155%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27155%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://atlanticfertility.com/raleigh-fertility-doctors",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Atlantic+Fertility+(formerly+Atlantic+Reproductive+Medicine),+10208+Cerny+St+Ste+306,+Raleigh,+NC+27617/@35.9017063,-78.8005481,3232a,13.1y/data=!4m2!3m1!1s0x89acf07b3bb0bf37:0xf0661442f8d578e5",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-155-susannah-copland",
        "name": "Susannah Copland",
        "role": "Medical Director",
        "imageUrl": "https://framerusercontent.com/images/0vpIugO0ZoFVx3pINrTJXSXTN00.jpg",
        "credentials": ["MD", "MSCR"],
        "_source": {
          "url": "https://atlanticfertility.com/raleigh-fertility-doctors",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Mary Peavey",
        "role": "Reproductive Endocrinologist / Fertility Specialist",
        "credentials": ["MD", "MSCR"],
        "imageUrl": "https://framerusercontent.com/images/o4H8cufueYDgaVSEl8PemU0XDtk.jpg",
        "_source": {
          "url": "https://atlanticfertility.com/raleigh-fertility-doctors",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-155-mary-peavey"
      },
      {
        "name": "Matt Coward",
        "role": "Urologic Microsurgeon (Male Fertility)",
        "credentials": ["MD", "FACS"],
        "imageUrl": "https://framerusercontent.com/images/KzBR84e3WoyPFUYxCnga0hCqMDI.jpg",
        "_source": {
          "url": "https://atlanticfertility.com/raleigh-fertility-doctors",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-155-matt-coward"
      },
      {
        "name": "Jenna S. Hynes",
        "role": "Reproductive Endocrinologist / Fertility Specialist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://framerusercontent.com/images/3hqFNwsaE3RPwQtdL7EORdzQT4.jpg",
        "_source": {
          "url": "https://atlanticfertility.com/raleigh-fertility-doctors",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-155-jenna-s-hynes"
      },
      {
        "name": "Hilary Friedlander",
        "role": "Reproductive Endocrinologist / Fertility Specialist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://framerusercontent.com/images/mL3miJocCJSuI2RKUW7N7fy0No.jpg",
        "_source": {
          "url": "https://atlanticfertility.com/raleigh-fertility-doctors",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-155-hilary-friedlander"
      },
      {
        "name": "David Walmer",
        "role": "Reproductive Endocrinologist / Fertility Specialist, Co-Founder",
        "credentials": ["MD", "PhD"],
        "imageUrl": "https://framerusercontent.com/images/gk1Dv3ouBggf373Xmh452Wcs38.jpg",
        "_source": {
          "url": "https://atlanticfertility.com/raleigh-fertility-doctors/david-walmer",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-155-david-walmer"
      },
      {
        "name": "Rachel Eshel",
        "role": "Licensed Psychologist (Reproductive Psychology)",
        "credentials": ["PsyD"],
        "imageUrl": "https://framerusercontent.com/images/HiCBiXUaQf1vPRQA7T3321VnTO0.jpg",
        "_source": {
          "url": "https://atlanticfertility.com/raleigh-fertility-doctors",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-155-rachel-eshel"
      },
      {
        "name": "Stephanie Bartlett",
        "role": "Director, Third Party Programs (Women's Health Nurse Practitioner)",
        "credentials": ["MSN", "WHNP-BC"],
        "imageUrl": "https://framerusercontent.com/images/WKQV58z6IdwVJhP8bTikoVPswyg.jpg",
        "_source": {
          "url": "https://atlanticfertility.com/raleigh-fertility-doctors",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-155-stephanie-bartlett"
      },
      {
        "name": "Meg Beal",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://framerusercontent.com/images/OpUBzKUtDxE0ScIWOpGsY1TfUeQ.jpg",
        "_source": {
          "url": "https://atlanticfertility.com/raleigh-fertility-doctors",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-155-meg-beal"
      },
      {
        "name": "Kelsey Daly",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "FNP-C"],
        "imageUrl": "https://framerusercontent.com/images/aNJrL9RYtCKVy9QyolcDthJBg.jpg",
        "_source": {
          "url": "https://atlanticfertility.com/raleigh-fertility-doctors",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-155-kelsey-daly"
      },
      {
        "name": "Sushma Singh",
        "role": "Laboratory Director",
        "credentials": ["PhD", "HCLD"],
        "imageUrl": "https://framerusercontent.com/images/4GiUEC21bSvzLGbozcyqgA798Ms.jpg",
        "_source": {
          "url": "https://atlanticfertility.com/raleigh-fertility-doctors",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-155-sushma-singh"
      },
      {
        "name": "Tina Manley",
        "role": "Chief Operating Officer",
        "credentials": ["MSN", "RN"],
        "imageUrl": "https://framerusercontent.com/images/LfZRZYOR7II2JbgqXZhogLYWQ.jpg",
        "_source": {
          "url": "https://atlanticfertility.com/raleigh-fertility-doctors",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-155-tina-manley"
      },
      {
        "name": "Becca Taylor",
        "role": "Fertility Nurse Manager",
        "credentials": ["MSN", "RN"],
        "imageUrl": "https://framerusercontent.com/images/8rFMemGiuJSTZI3DCnWW9t0ngLQ.jpg",
        "_source": {
          "url": "https://atlanticfertility.com/raleigh-fertility-doctors/becca-taylor",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-155-becca-taylor"
      }
    ],
    "website": "https://www.atlanticreproductive.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check North Carolina (NC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl5Hl1CNNxzJB02-sUXRRdO_ja-yvHEX0J6jDM-IdCeXyYEWWv-fIXBsecH1i0Mf--zRLUOhl8uSrOMnC9KjYGMusOanW9PnVFbg7D4JjENDYNoVnxMh40gDDb3e3Nwf1B8-IPEqA=w224-h298-k-no-pi-0.20878863-ya149.0053-ro0.09297887-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Atlantic+Fertility+(formerly+Atlantic+Reproductive+Medicine),+10208+Cerny+St+Ste+306,+Raleigh,+NC+27617/@35.9017063,-78.8005481,3232a,13.1y/data=!4m2!3m1!1s0x89acf07b3bb0bf37:0xf0661442f8d578e5",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-358",
    "externalIds": {
      "cdcClinicId": "358",
      "googlePlaceId": "ChIJC2IDDir0rIkRu_FkH9GEwZg"
    },
    "type": "fertility-clinic",
    "name": "Carolina Conceptions, PA",
    "phone": "(919) 782-5911",
    "address": {
      "line1": "2601 Lake Dr, Suite 301",
      "city": "Raleigh",
      "state": "NC",
      "zip": "27607",
      "country": "US"
    },
    "location": {
      "lat": 35.8162,
      "lng": -78.7071
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 52.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 42.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 57.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 639,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27358%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27358%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://carolinaconceptions.com/doctors-providers/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Carolina+Conceptions+Fertility+%E2%80%93+Raleigh,+2601+Lake+Dr+STE+301,+Raleigh,+NC+27607/@35.8162464,-78.7071458,3235a,13.1y/data=!4m2!3m1!1s0x89acf42a0e03620b:0x98c184d11f64f1bb",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-358-meaghan-bowling-md",
        "name": "Meaghan Bowling, MD",
        "role": "Medical Director",
        "imageUrl": "https://i0.wp.com/carolinaconceptions.com/wp-content/uploads/2025/09/j5-fztjgfcopy-2.jpg?fit=2500%2C2500&ssl=1",
        "credentials": ["MD"],
        "_source": {
          "url": "https://carolinaconceptions.com/doctors-providers/bowling/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "John Park, MD",
        "role": "Reproductive Endocrinologist / Fertility Physician",
        "credentials": ["MD"],
        "imageUrl": "https://i0.wp.com/carolinaconceptions.com/wp-content/uploads/2025/09/lklklklk.jpg?fit=2500%2C2500&ssl=1",
        "_source": {
          "url": "https://carolinaconceptions.com/doctors-providers/park/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-358-john-park-md"
      },
      {
        "name": "Lauren Johnson, MD",
        "role": "Reproductive Endocrinologist / Fertility Physician",
        "credentials": ["MD"],
        "imageUrl": "https://i0.wp.com/carolinaconceptions.com/wp-content/uploads/2025/09/j5-copy-2-e1759156647347.jpg?fit=800%2C814&ssl=1",
        "_source": {
          "url": "https://carolinaconceptions.com/doctors-providers/johnson/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-358-lauren-johnson-md"
      },
      {
        "name": "Monica Schointuch, MD",
        "role": "Reproductive Endocrinologist / Fertility Physician",
        "credentials": ["MD"],
        "imageUrl": "https://i0.wp.com/carolinaconceptions.com/wp-content/uploads/2025/09/llll.jpg?fit=800%2C800&ssl=1",
        "_source": {
          "url": "https://carolinaconceptions.com/doctors-providers/schointuch/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-358-monica-schointuch-md"
      },
      {
        "name": "Bill Meyer, MD",
        "role": "Physician (Retired Founder)",
        "credentials": ["MD"],
        "imageUrl": "https://i0.wp.com/carolinaconceptions.com/wp-content/uploads/2025/08/photo-ccon-dr-meyer-headshot-980x980-1.webp?fit=800%2C800&ssl=1",
        "_source": {
          "url": "https://carolinaconceptions.com/doctors-providers/meyer/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-358-bill-meyer-md"
      },
      {
        "name": "Grace Couchman, MD",
        "role": "Physician (Retired Founder)",
        "credentials": ["MD"],
        "imageUrl": "https://i0.wp.com/carolinaconceptions.com/wp-content/uploads/2025/08/Dr.Couchman-480x480-1.webp?fit=480%2C480&ssl=1",
        "_source": {
          "url": "https://carolinaconceptions.com/doctors-providers/couchman/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-358-grace-couchman-md"
      },
      {
        "name": "Karen Onori, FNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["FNP-BC"],
        "imageUrl": "https://i0.wp.com/carolinaconceptions.com/wp-content/uploads/2025/07/photo-ccon-karen-onori-headshot.webp?fit=400%2C400&ssl=1",
        "_source": {
          "url": "https://carolinaconceptions.com/doctors-providers/karen-onori-fnp-bc/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-358-karen-onori-fnp-bc"
      },
      {
        "name": "Natalie Brantley, WHNP-BC",
        "role": "Women's Health Nurse Practitioner",
        "credentials": ["WHNP-BC"],
        "imageUrl": "https://i0.wp.com/carolinaconceptions.com/wp-content/uploads/2025/07/photo-ccon-natalie-brantley-headshot.webp?fit=400%2C400&ssl=1",
        "_source": {
          "url": "https://carolinaconceptions.com/doctors-providers/natalie-brantley-np/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-358-natalie-brantley-whnp-bc"
      },
      {
        "name": "Sarah Yon, FNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["FNP-BC"],
        "imageUrl": "https://i0.wp.com/carolinaconceptions.com/wp-content/uploads/2025/07/photo-ccon-sarah-yon.webp?fit=400%2C400&ssl=1",
        "_source": {
          "url": "https://carolinaconceptions.com/doctors-providers/sarah-yon-np/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-358-sarah-yon-fnp-bc"
      },
      {
        "name": "Reshawn Jones, FNP-C",
        "role": "Nurse Practitioner",
        "credentials": ["FNP-C"],
        "imageUrl": "https://i0.wp.com/carolinaconceptions.com/wp-content/uploads/2025/09/DSC08090-scaled-e1758907583282.jpg?fit=800%2C838&ssl=1",
        "_source": {
          "url": "https://carolinaconceptions.com/doctors-providers/reshawn-jones-np/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-358-reshawn-jones-fnp-c"
      },
      {
        "name": "Liz Money, DNP, FNP-C",
        "role": "Nurse Practitioner",
        "credentials": ["DNP", "FNP-C"],
        "imageUrl": "https://i0.wp.com/carolinaconceptions.com/wp-content/uploads/2025/09/rrrrrrrrrr-2-e1759160079560.jpg?fit=800%2C800&ssl=1",
        "_source": {
          "url": "https://carolinaconceptions.com/doctors-providers/liz-money-np/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-358-liz-money-dnp-fnp-c"
      },
      {
        "name": "Khalied Kaskar, PhD, HCLD/CC",
        "role": "IVF Lab Director",
        "credentials": ["PhD", "HCLD/CC"],
        "imageUrl": "https://i0.wp.com/carolinaconceptions.com/wp-content/uploads/2026/05/DSC00414-copyggg.jpg?fit=2856%2C2857&ssl=1",
        "_source": {
          "url": "https://carolinaconceptions.com/doctors-providers/billy-taeshin-kim-hcld/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-358-khalied-kaskar-phd-hcld-cc"
      },
      {
        "name": "Meagan Bergeron, MS, TS",
        "role": "Senior Embryologist / Supervisor",
        "credentials": ["MS", "TS"],
        "imageUrl": "https://i0.wp.com/carolinaconceptions.com/wp-content/uploads/2025/08/photo-ccon-meagan-bergeron-headshot-480x480-1.webp?fit=480%2C480&ssl=1",
        "_source": {
          "url": "https://carolinaconceptions.com/doctors-providers/meagan-bergeron-embryologist/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-358-meagan-bergeron-ms-ts"
      },
      {
        "name": "Callie Barnwell Gibson, PhD, TS (ABB)",
        "role": "Senior Embryologist / Supervisor",
        "credentials": ["PhD", "TS (ABB)"],
        "imageUrl": "https://i0.wp.com/carolinaconceptions.com/wp-content/uploads/2025/08/photo-ccon-callie-barnwell-headshot-480x480-1.webp?fit=480%2C480&ssl=1",
        "_source": {
          "url": "https://carolinaconceptions.com/doctors-providers/callie-barnwell-gibson-embryologist/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-358-callie-barnwell-gibson-phd-ts-abb"
      }
    ],
    "website": "https://www.carolinaconceptions.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check North Carolina (NC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlZOYc9Fc0eowMVM5_eRhdhSNscTJEZ4u5yk9ne1-d0RIa5Zcqx7l-FPtCl8mjageLY_f4f1wloQuZe4ojfQqsqEyfvN7_aLcFUzPV2G75TzRsBBUmTlJMWBxLNkWOrqRUcIg51=w511-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Carolina+Conceptions+Fertility+%E2%80%93+Raleigh,+2601+Lake+Dr+STE+301,+Raleigh,+NC+27607/@35.8162464,-78.7071458,3235a,13.1y/data=!4m2!3m1!1s0x89acf42a0e03620b:0x98c184d11f64f1bb",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnB8LGM5RM13JF9QuQHksbUBdM79vCC_ynOAMY52qfMgH1rr-zWKvHV0RRaASDw_riPv30NEcFE05-Ch556Y55ahZKPNILUpvL08weALySCtinlwa8yjEtBaBU2RlFEwY15EXHuLQ=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Carolina+Conceptions+Fertility+%E2%80%93+Raleigh,+2601+Lake+Dr+STE+301,+Raleigh,+NC+27607/@35.8162464,-78.7071458,3235a,13.1y/data=!4m2!3m1!1s0x89acf42a0e03620b:0x98c184d11f64f1bb",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-601",
    "externalIds": {
      "cdcClinicId": "601",
      "googlePlaceId": "ChIJ7V9GyUuwU4gRiUk_JVQ60EY"
    },
    "type": "fertility-clinic",
    "name": "Carolinas Fertility Institute",
    "phone": "(336) 448-9100",
    "address": {
      "line1": "3821 Forrestgate Dr",
      "city": "Winston-salem",
      "state": "NC",
      "zip": "27103",
      "country": "US"
    },
    "location": {
      "lat": 36.0727,
      "lng": -80.3142
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 61.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 60.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 57.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 48.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 790,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27601%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27601%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://carolinasfertilityinstitute.com/our-team/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Carolinas+Fertility+Institute+-+Winston+Salem,+3821+Forrestgate+Dr,+Winston-Salem,+NC+27103/@36.0728168,-80.3142696,3225a,13.1y/data=!4m2!3m1!1s0x8853b04bc9465fed:0x46d03a54253f4989",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-601-tamer-m-yalcinkaya-md",
        "name": "Tamer M. Yalcinkaya, MD",
        "role": "Medical Director",
        "imageUrl": "https://carolinasfertilityinstitute.com/wp-content/uploads/2024/11/dr-y.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://carolinasfertilityinstitute.com/our-team/dr-tamer-yalcinkaya/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Kess Thongteum",
        "role": "Nurse Practitioner",
        "credentials": ["WHNP-BC", "MSN"],
        "imageUrl": "https://carolinasfertilityinstitute.com/wp-content/uploads/2025/03/thongteum-1.jpg",
        "_source": {
          "url": "https://carolinasfertilityinstitute.com/our-team/kess-thongteum/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-601-kess-thongteum"
      }
    ],
    "website": "https://www.carolinasfertilityinstitute.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check North Carolina (NC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl7gZuASV1qwAR5oYWVy0ehxNXbbiGD8nMfCQz0EjAP4CIT-bqkB7Y2zi7iwTwVPBWtLyJPRxdKn7DJcQzvJEealHFCJKR9zxNaP5q-G0mVv1iSptnhCYdTRyGEgx_NtG4ymqw=w408-h544-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Carolinas+Fertility+Institute+-+Winston+Salem,+3821+Forrestgate+Dr,+Winston-Salem,+NC+27103/@36.0728168,-80.3142696,3225a,13.1y/data=!4m2!3m1!1s0x8853b04bc9465fed:0x46d03a54253f4989",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-333",
    "externalIds": {
      "cdcClinicId": "333",
      "googlePlaceId": "ChIJTe-MR1XvrIkRlG9FEO-CpOE"
    },
    "type": "fertility-clinic",
    "name": "Duke Fertility Center, Duke University Medical Center",
    "phone": "(919) 572-4673",
    "address": {
      "line1": "5601 Arringdon Park Dr, Suite 210",
      "city": "Morrisville",
      "state": "NC",
      "zip": "27560",
      "country": "US"
    },
    "location": {
      "lat": 35.9224,
      "lng": -78.9283
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 52.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 41.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 48.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 33.33333333333333,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/15"
        }
      ],
      "cyclesPerYear": 255,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27333%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27333%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.dukehealth.org/hospitals/duke-fertility-center",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Duke+Fertility+Center,+5601+Arringdon+Park+Dr+Suite+210,+Morrisville,+NC+27560/@35.8844201,-78.8301775,3233a,13.1y/data=!4m2!3m1!1s0x89acef55478cef4d:0xe1a482ef10456f94",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-333-shelby-a-neal-md",
        "name": "Shelby A. Neal, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.dukehealth.org/sites/default/files/styles/doctor_profile/public/physician/shelby-neal-md.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://www.dukehealth.org/find-doctors-physicians/shelby-neal-md",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Kelly S. Acharya, MD",
        "role": "Reproductive Endocrinology and Infertility Specialist",
        "credentials": ["MD"],
        "imageUrl": "https://www.dukehealth.org/sites/default/files/styles/doctor_profile/public/physician/kelly-s-acharya-md.jpg",
        "_source": {
          "url": "https://www.dukehealth.org/find-doctors-physicians/kelly-s-acharya-md",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-333-kelly-s-acharya-md"
      },
      {
        "name": "Steven L. Young, MD, PhD",
        "role": "Reproductive Endocrinology and Infertility Specialist (Division Chief)",
        "credentials": ["MD", "PhD"],
        "imageUrl": "https://www.dukehealth.org/sites/default/files/styles/doctor_profile/public/physician/steven-l-young-md-phd.jpg",
        "_source": {
          "url": "https://www.dukehealth.org/find-doctors-physicians/steven-l-young-md-phd",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-333-steven-l-young-md-phd"
      },
      {
        "name": "Karen Baker, MD",
        "role": "Reproductive Endocrinology and Infertility / Reproductive Urology Specialist",
        "credentials": ["MD"],
        "imageUrl": "https://www.dukehealth.org/sites/default/files/styles/doctor_profile/public/physician/karen-baker-md.jpg",
        "_source": {
          "url": "https://www.dukehealth.org/find-doctors-physicians/karen-baker-md",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-333-karen-baker-md"
      },
      {
        "name": "Thomas M. Price, MD",
        "role": "Reproductive Endocrinology and Infertility Specialist",
        "credentials": ["MD"],
        "imageUrl": "https://www.dukehealth.org/sites/default/files/styles/doctor_profile/public/physician/thomas-m-price-md.jpg",
        "_source": {
          "url": "https://www.dukehealth.org/find-doctors-physicians/thomas-m-price-md",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-333-thomas-m-price-md"
      }
    ],
    "website": "https://www.dukefertilitycenter.duke.edu",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "images": [
      {
        "url": "https://www.dukehealth.org/sites/default/files/styles/hospital_slider_images/public/new_arringdon_fertility_lobby.jpg?itok=dCC8T0R5",
        "type": "interior",
        "caption": "Waiting area / lobby at Duke Fertility Center, Arringdon (Morrisville, NC)",
        "_source": {
          "url": "https://www.dukehealth.org/hospitals/duke-fertility-center",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.dukehealth.org/sites/default/files/styles/hospital_slider_images/public/new_arringdon_fertility_consult_room.jpg?itok=BiCzvQe_",
        "type": "interior",
        "caption": "Patient consultation room at Duke Fertility Center, Arringdon (Morrisville, NC)",
        "_source": {
          "url": "https://www.dukehealth.org/hospitals/duke-fertility-center",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.dukehealth.org/sites/default/files/styles/hospital_slider_images/public/new_arringdon_fertility_hallway_with_consult_rooms.jpg?itok=jUumqRLP",
        "type": "interior",
        "caption": "Hallway leading to consultation rooms at Duke Fertility Center, Arringdon (Morrisville, NC)",
        "_source": {
          "url": "https://www.dukehealth.org/hospitals/duke-fertility-center",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.dukehealth.org/sites/default/files/styles/hospital_slider_images/public/new_arringdon_fertility_ultrasound_room.jpg?itok=Km57eb_a",
        "type": "interior",
        "caption": "Ultrasound room at Duke Fertility Center, Arringdon (Morrisville, NC)",
        "_source": {
          "url": "https://www.dukehealth.org/hospitals/duke-fertility-center",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkO_k79B3WUN7UG2kamay77s02WgxltlnvpTcICYx5eZMB568iUdG-Aa10wcjPft4FQIi3u74wJCXVhOOYlvKnL7VRTNXHjeYMehMCt7ZCe0r-t3xygR4V8IKUnXGCVn8m1-4Ct7_0bIC2R=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Duke+Fertility+Center,+5601+Arringdon+Park+Dr+Suite+210,+Morrisville,+NC+27560/@35.8844201,-78.8301775,3233a,13.1y/data=!4m2!3m1!1s0x89acef55478cef4d:0xe1a482ef10456f94",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlNWaA3j04N0sC3muZYP-XcvqgRnFHZD4ZqOKnEXRAzUMvVina4ssJlC1_xgsiqF1SIisM3SdkZZGAuRVHieTIvvgSXt5z9ide-4WFWFpb54S9jeBWHdcCSxuw4SQIZye-gv9jG=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Duke+Fertility+Center,+5601+Arringdon+Park+Dr+Suite+210,+Morrisville,+NC+27560/@35.8844201,-78.8301775,3233a,13.1y/data=!4m2!3m1!1s0x89acef55478cef4d:0xe1a482ef10456f94",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkm1oRjTKrutzenGqjM1Zds6VNGjkD-mPqgMqu8Hdmj1Br1BSw8EtyAeIZfoFQCyeq1p_22wUeqfQ58D3fUQIZECc01FhgTkgdO76aGoGvyalFr3-oYu3-F3oBydOGxB3eNetAt=w360-h202-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Duke+Fertility+Center,+5601+Arringdon+Park+Dr+Suite+210,+Morrisville,+NC+27560/@35.8844201,-78.8301775,3233a,13.1y/data=!4m2!3m1!1s0x89acef55478cef4d:0xe1a482ef10456f94",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check North Carolina (NC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-347",
    "externalIds": {
      "cdcClinicId": "347"
    },
    "type": "fertility-clinic",
    "name": "North Carolina Center for Reproductive Medicine, The Talbert Fertility Institute",
    "phone": "(919) 233-1680",
    "address": {
      "line1": "400 Ashville Ave, Suite 200",
      "city": "Cary",
      "state": "NC",
      "zip": "27518",
      "country": "US"
    },
    "location": {
      "lat": 35.7375,
      "lng": -78.7866
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 54.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 61.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 64.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 176,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27347%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27347%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.nccrm.com/our-team/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-347-sameh-k-toma-md",
        "name": "Sameh K. Toma, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.nccrm.com/wp-content/uploads/2025/08/Sameh-Toma-e1759221911114.webp",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.nccrm.com/team/dr-sameh-toma-md/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Nadia Toma, MD",
        "role": "Obstetrician & Gynecologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.nccrm.com/wp-content/uploads/2025/08/nadia-toma.webp",
        "_source": {
          "url": "https://www.nccrm.com/team/nadia-toma-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-347-nadia-toma-md"
      },
      {
        "name": "Easton M. Rice III, DHSc, MPAS, PA-C",
        "role": "Physician Assistant",
        "credentials": ["DHSc", "MPAS", "PA-C"],
        "imageUrl": "https://www.nccrm.com/wp-content/uploads/2025/08/Easton-Rice-e1759222098284.webp",
        "_source": {
          "url": "https://www.nccrm.com/team/easton-m-rice-iii/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-347-easton-m-rice-iii-dhsc-mpas-pa-c"
      },
      {
        "name": "Spencer Badgley, MSN, APRN, NP-C",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "APRN", "NP-C"],
        "imageUrl": "https://www.nccrm.com/wp-content/uploads/2025/08/Spencer-Badgley-e1759222197820.webp",
        "_source": {
          "url": "https://www.nccrm.com/team/spencer-badgley/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-347-spencer-badgley-msn-aprn-np-c"
      },
      {
        "name": "Henny Liwan, MD, FACOG",
        "role": "Board-Certified Obstetrician-Gynecologist, Specialist in Advanced Female Pelvic Surgery",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.nccrm.com/wp-content/uploads/2025/08/Henny-Liwan-e1759222400478.webp",
        "_source": {
          "url": "https://www.nccrm.com/team/dr-henny-liwan-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-347-henny-liwan-md-facog"
      }
    ],
    "website": "https://www.nccrm.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check North Carolina (NC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-217",
    "externalIds": {
      "cdcClinicId": "217"
    },
    "type": "fertility-clinic",
    "name": "Program for Assisted Reproduction at Atrium Health's Carolinas Medical Center, CMC Women's Institute",
    "phone": "(704) 355-3149",
    "address": {
      "line1": "1025 Morehead Medical Dr, Suite 500",
      "city": "Charlotte",
      "state": "NC",
      "zip": "28204",
      "country": "US"
    },
    "location": {
      "lat": 35.205,
      "lng": -80.8389
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 52.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 51.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 42.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/12"
        }
      ],
      "cyclesPerYear": 385,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27217%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27217%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://atriumhealth.org/locations/detail/atrium-health-fertility-center",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-217-bradley-shawn-hurst-md",
        "name": "Bradley Shawn Hurst, MD",
        "role": "Medical Director",
        "imageUrl": "https://providers.atriumhealth.org/sparkle-assets/preview_thumbnails/physicians/399/doctor_finder-893eb7cebc4096c22ef696556cde0bad.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://atriumhealth.org/provider-profile/bradley-hurst-1144245333",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Michelle Matthews, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://providers.atriumhealth.org/sparkle-assets/preview_thumbnails/physicians/2748/doctor_finder-606a6538cca9010b60d7804dcf1b6ad0.jpg",
        "_source": {
          "url": "https://atriumhealth.org/provider-profile/michelle-matthews-1619992740",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-217-michelle-matthews-md"
      },
      {
        "name": "Rebecca S. Usadi, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://providers.atriumhealth.org/sparkle-assets/preview_thumbnails/physicians/3127/doctor_finder-8fc9d925248ac3c43dc00109b7232382.jpg",
        "_source": {
          "url": "https://atriumhealth.org/provider-profile/rebecca-usadi-1730194481",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-217-rebecca-s-usadi-md"
      },
      {
        "name": "Kathryn Merriam Goldrick, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://providers.atriumhealth.org/sparkle-assets/preview_thumbnails/physicians/9478/doctor_finder-e0653641ef050f486f54c03ff5eb1c78.jpg",
        "_source": {
          "url": "https://atriumhealth.org/provider-profile/kathryn-goldrick-1548656333",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-217-kathryn-merriam-goldrick-md"
      }
    ],
    "website": "https://www.atriumhealth.org",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check North Carolina (NC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-452",
    "externalIds": {
      "cdcClinicId": "452"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Endocrinology Associates of Charlotte",
    "phone": "(704) 343-3400",
    "address": {
      "line1": "1524 E. Morehead St",
      "city": "Charlotte",
      "state": "NC",
      "zip": "28207",
      "country": "US"
    },
    "location": {
      "lat": 35.2041,
      "lng": -80.8352
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 45.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 51,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 42.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 30,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 512,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27452%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27452%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.reachfertility.com/about-reach-fertility/specialists/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-452-seth-e-katz-md",
        "name": "Seth E. Katz, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.reachfertility.com/media/3bxhjn5u/drs_katz-2x.webp",
        "credentials": ["MD"],
        "_source": {
          "url": "https://www.reachfertility.com/about-reach-fertility/specialists/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Richard L. Wing, MD",
        "role": "Reproductive Endocrinologist (Founder)",
        "credentials": ["MD"],
        "imageUrl": "https://www.reachfertility.com/media/rfhnbld3/drs_wing-2x.webp",
        "_source": {
          "url": "https://www.reachfertility.com/about-reach-fertility/specialists/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-452-richard-l-wing-md"
      },
      {
        "name": "Joseph G. Whelan, III, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.reachfertility.com/media/kktldjez/drs_whelan-2x.webp",
        "_source": {
          "url": "https://www.reachfertility.com/about-reach-fertility/specialists/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-452-joseph-g-whelan-iii-md"
      },
      {
        "name": "Deidre Downs, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.reachfertility.com/media/j0wjppl4/drs_downs_l.webp",
        "_source": {
          "url": "https://www.reachfertility.com/about-reach-fertility/specialists/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-452-deidre-downs-md"
      },
      {
        "name": "Jack L. Crain, MD",
        "role": "Reproductive Endocrinologist (Research Director)",
        "credentials": ["MD"],
        "imageUrl": "https://www.reachfertility.com/media/tinbxhqo/drs_crain-2x.webp",
        "_source": {
          "url": "https://www.reachfertility.com/about-reach-fertility/specialists/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-452-jack-l-crain-md"
      },
      {
        "name": "Taylor Holt, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://www.reachfertility.com/media/l1hjahy1/drs_holt-2x.webp",
        "_source": {
          "url": "https://www.reachfertility.com/about-reach-fertility/specialists/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-452-taylor-holt-pa-c"
      },
      {
        "name": "Ann Morris Merline, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://www.reachfertility.com/media/1ykfibcj/drs_merline-2x.webp",
        "_source": {
          "url": "https://www.reachfertility.com/about-reach-fertility/specialists/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-452-ann-morris-merline-pa-c"
      },
      {
        "name": "Grace Perez, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://www.reachfertility.com/media/30manklx/drs_perez-2x.webp",
        "_source": {
          "url": "https://www.reachfertility.com/about-reach-fertility/specialists/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-452-grace-perez-pa-c"
      },
      {
        "name": "Jennifer L. Patrick, PhD, HCLD",
        "role": "IVF Laboratory Director / Embryologist",
        "credentials": ["PhD", "HCLD"],
        "imageUrl": "https://www.reachfertility.com/media/d1tmrfnk/drs_patrick-2x.webp",
        "_source": {
          "url": "https://www.reachfertility.com/about-reach-fertility/specialists/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-452-jennifer-l-patrick-phd-hcld"
      }
    ],
    "website": "https://www.reacharlotte.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check North Carolina (NC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-871",
    "externalIds": {
      "cdcClinicId": "871",
      "googlePlaceId": "ChIJn0ou2qKfVogRH0XZfxSUYpQ"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Specialists of the Carolinas",
    "phone": "(704) 247-2209",
    "address": {
      "line1": "1918 Randolph Rd, Suite 410",
      "city": "Charlotte",
      "state": "NC",
      "zip": "28207",
      "country": "US"
    },
    "location": {
      "lat": 35.2096,
      "lng": -80.8251
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 30,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 66.66666666666666,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/9"
        }
      ],
      "cyclesPerYear": 39,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27871%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27871%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://fertilitycarolinas.com/about-rsc-fertility/our-team",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Reproductive+Specialists+of+the+Carolinas,+1918+Randolph+Rd+%23410,+Charlotte,+NC+28207/@35.2095292,-80.8248897,3260a,13.1y/data=!4m2!3m1!1s0x88569fa2da2e4a9f:0x946294147fd9451f",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-871-matrika-johnson-md",
        "name": "Matrika Johnson, MD",
        "role": "Medical Director",
        "imageUrl": "https://fertilitycarolinas.com/media/pages/about-rsc-fertility/our-team/fa68455665-1709821988/dr-johnson.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://fertilitycarolinas.com/about-rsc-fertility/our-team",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Valerie Millwood",
        "role": "Nurse Practitioner",
        "credentials": ["DNP", "APRN", "FNP-BC", "NP-BC"],
        "imageUrl": "https://fertilitycarolinas.com/media/pages/about-rsc-fertility/our-team/b03dd1425e-1709821988/rsc-valerie_millwood.jpg",
        "_source": {
          "url": "https://fertilitycarolinas.com/about-rsc-fertility/our-team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-871-valerie-millwood"
      },
      {
        "name": "Allison Holcomb Mihalkanin",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://fertilitycarolinas.com/media/pages/about-rsc-fertility/our-team/36d70af2d0-1709821988/rsc-allison_holcomb_mihalkanin.jpg",
        "_source": {
          "url": "https://fertilitycarolinas.com/about-rsc-fertility/our-team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-871-allison-holcomb-mihalkanin"
      },
      {
        "name": "Jessica Crouch",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://fertilitycarolinas.com/media/pages/about-rsc-fertility/our-team/d8f6e595c9-1737740143/screenshot-2025-01-24-at-12.33.59pm.png",
        "_source": {
          "url": "https://fertilitycarolinas.com/about-rsc-fertility/our-team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-871-jessica-crouch"
      },
      {
        "name": "Elaine DeQuadros",
        "role": "Laboratory Director / Embryologist",
        "credentials": ["DHSc", "PhD", "TS (ABB)"],
        "imageUrl": "https://fertilitycarolinas.com/media/pages/about-rsc-fertility/our-team/468dcc3516-1763652404/dr-elaine-de-quadros-rsc-fertility-square.jpg",
        "_source": {
          "url": "https://fertilitycarolinas.com/about-rsc-fertility/our-team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-871-elaine-dequadros"
      }
    ],
    "website": "https://www.reproductivespecialists.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn21rY1ZCOe-_7Eb06TQwk8bRGmL3EbIl0W0ozXd8GNF4gQGiheTTZhtgof9RA_fchxpF3JOHA9R5sFAEizLyB7aZqoXHDKH0b7MHgvSIU9VKDDnJr2tEie7oBXAtDXXVVEIcjjUw=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Reproductive+Specialists+of+the+Carolinas,+1918+Randolph+Rd+%23410,+Charlotte,+NC+28207/@35.2095292,-80.8248897,3260a,13.1y/data=!4m2!3m1!1s0x88569fa2da2e4a9f:0x946294147fd9451f",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmmuUiwYjql-1opXvQihp3kmKmlRrWtAqWkblz6qR86uDmDKwbJqLEZOte_6PfcR_-j4BFN10DPqnEHZlim-biALNVBFkG_hQZD5Y9UH2i6ORCzdVgIgZLY3ClpaSJLQdXu8BMR=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Reproductive+Specialists+of+the+Carolinas,+1918+Randolph+Rd+%23410,+Charlotte,+NC+28207/@35.2095292,-80.8248897,3260a,13.1y/data=!4m2!3m1!1s0x88569fa2da2e4a9f:0x946294147fd9451f",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check North Carolina (NC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-344",
    "externalIds": {
      "cdcClinicId": "344",
      "googlePlaceId": "ChIJc2SeWHD6rIkRGQB2344PnDw"
    },
    "type": "fertility-clinic",
    "name": "UNC Fertility",
    "phone": "(919) 908-0000",
    "address": {
      "line1": "7920 ACC Blvd, Suite 300",
      "city": "Raleigh",
      "state": "NC",
      "zip": "27617",
      "country": "US"
    },
    "location": {
      "lat": 35.9067,
      "lng": -78.7637
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 45.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 37,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 40.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 424,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27344%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27344%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://uncfertility.com/our-center/meet-our-team/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/UNC+Fertility,+7920+ACC+Blvd+Ste+300,+Raleigh,+NC+27617/@35.9177551,-78.7800536,3231a,13.1y/data=!4m2!3m1!1s0x89acfa70589e6473:0x3c9c0f8edf760019",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-344-colleen-milroy-md",
        "name": "Colleen Milroy, MD",
        "role": "Medical Director"
      },
      {
        "name": "Colleen Milroy, MD, MHCM",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MHCM"],
        "imageUrl": "https://uncfertility.com/wp-content/uploads/2023/08/Milroy_560x340.png",
        "_source": {
          "url": "https://uncfertility.com/our-center/meet-our-team/colleen-milroy-md-mhcm/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-344-colleen-milroy-md-mhcm"
      },
      {
        "name": "Genevieve Neal-Perry, MD, PhD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "PhD"],
        "imageUrl": "https://uncfertility.com/wp-content/uploads/2020/11/GNPDesktop2.jpg",
        "_source": {
          "url": "https://uncfertility.com/our-center/meet-our-team/genevieve-neal-perry-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-344-genevieve-neal-perry-md-phd"
      },
      {
        "name": "Anne Z. Steiner, MD, MPH",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MPH"],
        "imageUrl": "https://uncfertility.com/wp-content/uploads/2023/10/Steiner_560x340.png",
        "_source": {
          "url": "https://uncfertility.com/our-center/meet-our-team/anne-z-steiner-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-344-anne-z-steiner-md-mph"
      },
      {
        "name": "Jaime Roura-Monllor, MD",
        "role": "Obstetrician-Gynecologist",
        "credentials": ["MD"],
        "imageUrl": "https://uncfertility.com/wp-content/uploads/2024/07/roura_560x340.png",
        "_source": {
          "url": "https://uncfertility.com/our-center/meet-our-team/jaime-roura-monllor-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-344-jaime-roura-monllor-md"
      },
      {
        "name": "Bruce Pier, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://uncfertility.com/wp-content/uploads/2023/05/Doctor_560x340.png",
        "_source": {
          "url": "https://uncfertility.com/our-center/meet-our-team/bruce-pier-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-344-bruce-pier-md"
      },
      {
        "name": "Anna DeGolier, APRN",
        "role": "Nurse Practitioner",
        "credentials": ["APRN"],
        "imageUrl": "https://uncfertility.com/wp-content/uploads/2024/03/degolier_560x340.png",
        "_source": {
          "url": "https://uncfertility.com/our-center/meet-our-team/anna-degolier-aprn/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-344-anna-degolier-aprn"
      },
      {
        "name": "Meghan Cowles, FNP",
        "role": "Family Nurse Practitioner",
        "credentials": ["FNP"],
        "imageUrl": "https://uncfertility.com/wp-content/uploads/2024/08/cowles_560x340.png",
        "_source": {
          "url": "https://uncfertility.com/our-center/meet-our-team/meghan-cowles-np/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-344-meghan-cowles-fnp"
      },
      {
        "name": "Zainab Razai, NP",
        "role": "Women's Health Nurse Practitioner",
        "credentials": ["NP"],
        "imageUrl": "https://uncfertility.com/wp-content/uploads/2024/11/Nov24_doctor_560x340.png",
        "_source": {
          "url": "https://uncfertility.com/our-center/meet-our-team/zainab-razai-np/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-344-zainab-razai-np"
      },
      {
        "name": "Jordan Lodato Hunt, LCSW",
        "role": "Program Director, Fertility Preservation",
        "credentials": ["LCSW"],
        "imageUrl": "https://uncfertility.com/wp-content/uploads/2025/03/PB-UNCF-S-Jordan-H.png",
        "_source": {
          "url": "https://uncfertility.com/our-center/meet-our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-344-jordan-lodato-hunt-lcsw"
      }
    ],
    "website": "https://www.uncfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://uncfertility.com/wp-content/uploads/2015/05/StateoftheArtFacility-860.jpg",
        "type": "interior",
        "caption": "UNC Fertility lobby and waiting area with seating, reception desk, and floor-to-ceiling windows",
        "_source": {
          "url": "https://uncfertility.com/our-center/clinic-location/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm2x2bqrKtDoyiJvfqlBUntHis2JWi8HLF2mae-nEVvbtf2ZDYNOmSoyywlbmWZg2Hzy3CEZUwN7ooFpN0CDHHp1awjJSztGPg7vDdO6pdlx1TD4g_sx0kdoyqjYEoISxJv8UvoL5OqNR7l=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/UNC+Fertility,+7920+ACC+Blvd+Ste+300,+Raleigh,+NC+27617/@35.9177551,-78.7800536,3231a,13.1y/data=!4m2!3m1!1s0x89acfa70589e6473:0x3c9c0f8edf760019",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkuXZ_NEwvbyUwhRP2Zcgc6K5enzCUO-J-DUaoi_vo3MNnSAJoea7VoMBp_fkUWe6hML4J0mdqz_8xC7c90SbMFfALX7oQzE9lkp9n4u9UGBPisK_9nD2B3eiQTNVXAGiiDPi40FguKGxIb=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/UNC+Fertility,+7920+ACC+Blvd+Ste+300,+Raleigh,+NC+27617/@35.9177551,-78.7800536,3231a,13.1y/data=!4m2!3m1!1s0x89acfa70589e6473:0x3c9c0f8edf760019",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check North Carolina (NC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-605",
    "externalIds": {
      "cdcClinicId": "605"
    },
    "type": "fertility-clinic",
    "name": "Wake Forest University Center for Reproductive Medicine",
    "phone": "(336) 716-6476",
    "address": {
      "line1": "111 Hanestown Ct, Suite 351",
      "city": "Winston-salem",
      "state": "NC",
      "zip": "27103",
      "country": "US"
    },
    "location": {
      "lat": 36.0881,
      "lng": -80.2941
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 70.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 60.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 60.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 174,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27605%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27605%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.wakehealth.edu/locations/clinics/c/center-for-fertility-and-reproductive-surgery",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-605-jeffrey-deaton-md",
        "name": "Jeffrey Deaton, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.wakehealth.edu/-/media/wakeforest/global/system/person-images/j/jeffrey-lynn-deaton.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://www.wakehealth.edu/providers/d/jeffrey-deaton",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Elliott Grant Richards, MD",
        "role": "Reproductive Endocrinology and Infertility",
        "credentials": ["MD"],
        "imageUrl": "https://www.wakehealth.edu/-/media/wakeforest/global/system/person-images/e/elliott-grant-richards.jpg",
        "_source": {
          "url": "https://www.wakehealth.edu/locations/clinics/c/center-for-fertility-and-reproductive-surgery",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-605-elliott-grant-richards-md"
      },
      {
        "name": "Luwam Ghidei, MD",
        "role": "Reproductive Endocrinology and Infertility",
        "credentials": ["MD"],
        "imageUrl": "https://www.wakehealth.edu/-/media/wakeforest/global/system/person-images/l/luwam-ghidei.jpg",
        "_source": {
          "url": "https://www.wakehealth.edu/locations/clinics/c/center-for-fertility-and-reproductive-surgery",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-605-luwam-ghidei-md"
      },
      {
        "name": "Carolyn Susan Huffman, PhD",
        "role": "Reproductive Endocrinology and Infertility",
        "credentials": ["PhD"],
        "imageUrl": "https://www.wakehealth.edu/-/media/wakeforest/global/system/person-images/c/carolyn-susan-huffman.jpg",
        "_source": {
          "url": "https://www.wakehealth.edu/locations/clinics/c/center-for-fertility-and-reproductive-surgery",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-605-carolyn-susan-huffman-phd"
      },
      {
        "name": "Eva Maria Reina, MD",
        "role": "Gynecology (Minimally Invasive Gynecologic Surgery)",
        "credentials": ["MD"],
        "imageUrl": "https://www.wakehealth.edu/-/media/wakeforest/global/system/person-images/e/eva-maria-reina.jpg",
        "_source": {
          "url": "https://www.wakehealth.edu/locations/clinics/c/center-for-fertility-and-reproductive-surgery",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-605-eva-maria-reina-md"
      },
      {
        "name": "Janelle Katie Moulder, MD",
        "role": "Gynecology (Minimally Invasive Gynecologic Surgery)",
        "credentials": ["MD"],
        "imageUrl": "https://www.wakehealth.edu/-/media/wakeforest/global/system/person-images/j/janelle-katie-moulder.jpg",
        "_source": {
          "url": "https://www.wakehealth.edu/locations/clinics/c/center-for-fertility-and-reproductive-surgery",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-605-janelle-katie-moulder-md"
      }
    ],
    "website": "https://www.wakehealth.edu",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "images": [
      {
        "url": "https://cdn.atriumhealth.org/-/media/wakeforest/clinical/images/banners-and-carousels/hanestown-court-1361x494.jpg",
        "type": "exterior",
        "caption": "Exterior of the Wake Forest Baptist Health building at Hanestown Court, Winston-Salem, which houses the Center for Fertility and Reproductive Surgery (111 Hanestown Ct, Suite 351).",
        "_source": {
          "url": "https://www.wakehealth.edu/locations/clinics/c/center-for-fertility-and-reproductive-surgery",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check North Carolina (NC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-209",
    "externalIds": {
      "cdcClinicId": "209",
      "googlePlaceId": "ChIJ6QbtUxlqq4kRQX0fHHXQhgU"
    },
    "type": "fertility-clinic",
    "name": "Womack Army Medical Center",
    "phone": "(910) 907-9270",
    "address": {
      "line1": "WAMC MCXC-OB, 2817 Reilly Rd, Mailstop A",
      "city": "Fort Liberty",
      "state": "NC",
      "zip": "28310",
      "country": "US"
    },
    "location": {
      "lat": 35.1461,
      "lng": -79.0021
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 31,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 21.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 96,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27209%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27209%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://womack.tricare.mil",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Womack+Army+Medical+Ctr,+2817+Rock+Merritt+Ave,+Fort+Bragg,+NC+28310/@35.1457838,-79.0021501,3262a,13.1y/data=!4m2!3m1!1s0x89ab6a1953ed06e9:0x586d0751c1f7d41",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-209-luiz-f-correa-do",
        "name": "Luiz F. Correa, DO",
        "role": "Medical Director",
        "imageUrl": "https://doximity-res.cloudinary.com/images/c_crop,f_auto,h_265,q_auto,t_public_profile_photo_320x320,w_265,x_17,y_-1/cptjeesayrejxy3gpdcy/luiz-correa-do-fort-bragg-nc.jpg",
        "credentials": ["DO", "FACOG"],
        "_source": {
          "url": "https://www.doximity.com/pub/luiz-correa-do",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.womack.tricare.mil",
    "insurance": {
      "accepted": true,
      "carriers": ["Tricare"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Tricare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check North Carolina (NC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkMkPEqaM6BNiKuRBcmbG6_5Ozaqwm3FjYfZfdQKCsUhEzjI6B_Svrg-RimKvx82uGGjtK71ibiypfawimL-rn0mqw6KQWMU-2cUx-EzHHcBa_sm5qXzGX3CyzGm8o63GQzoNAK=w452-h240-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Womack+Army+Medical+Ctr,+2817+Rock+Merritt+Ave,+Fort+Bragg,+NC+28310/@35.1457838,-79.0021501,3262a,13.1y/data=!4m2!3m1!1s0x89ab6a1953ed06e9:0x586d0751c1f7d41",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-360",
    "externalIds": {
      "cdcClinicId": "360",
      "googlePlaceId": "ChIJRUEoqDvMyFIRZt_YQjEPZmY"
    },
    "type": "fertility-clinic",
    "name": "Sanford Health Reproductive Medicine Institute",
    "phone": "(701) 234-2700",
    "address": {
      "line1": "1111 Harwood Dr South",
      "city": "Fargo",
      "state": "ND",
      "zip": "58104",
      "country": "US"
    },
    "location": {
      "lat": 46.8304,
      "lng": -96.7981
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 59.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 51.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 58.333333333333336,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/12"
        }
      ],
      "cyclesPerYear": 178,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27360%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27360%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.sanfordhealth.org/locations/sanford-reproductive-medicine-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Sanford+Reproductive+Medicine+Clinic,+1111+Harwood+Dr+S,+Fargo,+ND+58104/@46.8303851,-96.7980965,2730a,13.1y/data=!4m2!3m1!1s0x52c8cc3ba8284145:0x66660f3142d8df66",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.sanfordhealth.org/locations/sanford-reproductive-medicine-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-360-christina-broadwell-md",
        "name": "Christina Broadwell, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology",
        "imageUrl": "https://www.sanfordhealth.org/-/media/org/images/doctors/providerimages/christina_broadwell.jpg",
        "_source": {
          "url": "https://www.sanfordhealth.org/locations/sanford-reproductive-medicine-clinic",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-360-allison-harrison-aprn-cnp",
        "name": "Allison Harrison, APRN, CNP",
        "role": "Nurse Practitioner",
        "credentials": ["APRN", "CNP"],
        "specialty": "Nurse Practitioner",
        "imageUrl": "https://www.sanfordhealth.org/-/media/org/images/doctors/edith-providers/allison-harrison-obgyn-fargo-north-dakota.jpg",
        "_source": {
          "url": "https://www.sanfordhealth.org/locations/sanford-reproductive-medicine-clinic",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-360-amanda-helmer-aprn-cnp",
        "name": "Amanda Helmer, APRN, CNP",
        "role": "Nurse Practitioner",
        "credentials": ["APRN", "CNP"],
        "specialty": "Reproductive Endocrinology",
        "imageUrl": "https://www.sanfordhealth.org/-/media/org/images/doctors/providerimages/amanda-helmer-reproductive-endocrinology-fargo-north-dakota.jpg",
        "_source": {
          "url": "https://www.sanfordhealth.org/locations/sanford-reproductive-medicine-clinic",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-360-ellen-johnson-cgc",
        "name": "Ellen Johnson, CGC",
        "role": "Genetic Counselor",
        "credentials": ["CGC"],
        "specialty": "Genetic Counseling",
        "imageUrl": "https://www.sanfordhealth.org/-/media/org/images/doctors/edith-providers/ellen_johnson.jpg",
        "_source": {
          "url": "https://www.sanfordhealth.org/locations/sanford-reproductive-medicine-clinic",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-360-caitlin-pandolfo-md",
        "name": "Caitlin Pandolfo, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology",
        "imageUrl": "https://www.sanfordhealth.org/-/media/org/images/doctors/providerimages/caitlin-pandolfo.jpg",
        "_source": {
          "url": "https://www.sanfordhealth.org/locations/sanford-reproductive-medicine-clinic",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.sanfordhealth.org/locations/sanford-reproductive-medicine-clinic",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://www.sanfordhealth.org/-/media/org/images/locations/039073-03170p-reproductive-medicine-04-28-20_690x402.jpg",
        "type": "exterior",
        "caption": "Sanford Reproductive Medicine Clinic in Fargo.",
        "_source": {
          "url": "https://www.sanfordhealth.org/locations/sanford-reproductive-medicine-clinic",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check North Dakota (ND) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-455",
    "externalIds": {
      "cdcClinicId": "455"
    },
    "type": "fertility-clinic",
    "name": "Heartland Center for Reproductive Medicine, PC",
    "phone": "(402) 717-4200",
    "address": {
      "line1": "7308 S. 142nd St",
      "city": "Omaha",
      "state": "NE",
      "zip": "68138",
      "country": "US"
    },
    "location": {
      "lat": 41.188523,
      "lng": -96.1382465
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 43.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 32.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 35.714285714285715,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/14"
        }
      ],
      "cyclesPerYear": 359,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27455%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27455%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.hcrmfertility.com/doctors/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.hcrmfertility.com/locations/omaha-office/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.hcrmfertility.com/locations/omaha-office/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-455-stephanie-l-f-gustin-md-facog",
        "name": "Stephanie L.F. Gustin, MD, FACOG",
        "role": "Medical Director",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://einstein-clients.imgix.net/2640/492868/original_stephanie-gustin.jpg?1763660771",
        "_source": {
          "url": "https://www.hcrmfertility.com/locations/omaha-office/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-455-elizabeth-constance-md-facog",
        "name": "Elizabeth Constance, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://einstein-clients.imgix.net/2640/491462/original_Elizabeth-Constance.jpg?1762215580",
        "_source": {
          "url": "https://www.hcrmfertility.com/locations/omaha-office/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-455-elizabeth-weedin-do-ms-facog",
        "name": "Elizabeth Weedin, DO, MS, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO", "MS", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://einstein-clients.imgix.net/2640/491442/original.jpg?1762210183",
        "_source": {
          "url": "https://www.hcrmfertility.com/locations/omaha-office/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-455-abigail-a-delaney-md-facog",
        "name": "Abigail A. Delaney, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://einstein-clients.imgix.net/2640/491461/original_abigail-delaney.jpg?1762215580",
        "_source": {
          "url": "https://www.hcrmfertility.com/locations/omaha-office/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-455-meghan-b-oakes-md-facog",
        "name": "Meghan B. Oakes, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://einstein-clients.imgix.net/2640/491534/original_meghan-oakes.jpg?1762278514",
        "_source": {
          "url": "https://www.hcrmfertility.com/locations/omaha-office/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-455-tiffany-vasa-np",
        "name": "Tiffany Vasa, NP",
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "specialty": "Nurse Practitioner",
        "imageUrl": "https://einstein-clients.imgix.net/2640/448535/original_Tiffany_Vasa.jpg?1705423310",
        "_source": {
          "url": "https://www.hcrmfertility.com/locations/omaha-office/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Barry R. Behr, PhD, HCLD",
        "role": "Laboratory Director",
        "credentials": ["PhD", "HCLD"],
        "imageUrl": "https://einstein-clients.imgix.net/2640/346271/original_Barry-Behr.jpg?auto=format&fit=max&w=600",
        "_source": {
          "url": "https://www.hcrmfertility.com/about-the-practice/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-455-barry-r-behr-phd-hcld"
      }
    ],
    "website": "https://www.hcrmfertility.com/locations/omaha-office/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Nebraska (NE) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-363",
    "externalIds": {
      "cdcClinicId": "363",
      "googlePlaceId": "ChIJ6QE2OCPwk4cRlljAoHC_QC8"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Health Specialists",
    "phone": "(402) 815-1915",
    "address": {
      "line1": "717 N. 190th Plaza, Suite 2500",
      "city": "Elkhorn",
      "state": "NE",
      "zip": "68022",
      "country": "US"
    },
    "location": {
      "lat": 41.2646,
      "lng": -96.2125
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 49.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 44,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 43.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 438,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27363%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27363%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://bestcare.org/specialties/reproductive-health",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Methodist+Reproductive+Health+Specialists,+717+N+190th+Plaza+%232500,+Elkhorn,+NE+68022/@41.2657312,-96.2115681,2999a,13.1y/data=!4m2!3m1!1s0x8793f023383601e9:0x2f40bf70a0c05896",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://bestcare.org/specialties/reproductive-health",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-363-carolyn-maud-doherty-md",
        "name": "Carolyn Maud Doherty, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://bestcare.org/sites/default/files/styles/portrait/public/2022-09/doherty-carolyn-1427163609.jpg.webp?itok=4v7AQ5_H",
        "_source": {
          "url": "https://bestcare.org/specialties/reproductive-health",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Candice Carter, APRN",
        "role": "Nurse Practitioner, Reproductive Endocrinology and Infertility",
        "credentials": ["APRN", "FNP"],
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/nmhs/photos/500/carter-candice-1023388683.jpg",
        "_source": {
          "url": "https://providers.bestcare.org/provider/candice-carter/2537677",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-363-candice-carter-aprn"
      }
    ],
    "website": "https://bestcare.org/specialties/reproductive-health",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://bestcare.org/sites/default/files/styles/media_highlight/public/2023-10/MWH%20MOB%20webp.webp?h=7aefd044&itok=pcAgWlxA",
        "type": "exterior",
        "caption": "Methodist Women's Hospital Medical Office Building for Reproductive Health Specialists.",
        "_source": {
          "url": "https://bestcare.org/specialties/reproductive-health",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnlWGRur_I1ID0Lr5z1RNnrVKr4rDLXgl3qZGgMc_rnDHQheYhamJvIgABam8-EnQeYM458dx891wuuZbe1SMC2oZho7FzEibngsBY_HZme774Ke4Kxzjxkh69CuqmXq6nbexhbSA=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Methodist+Reproductive+Health+Specialists,+717+N+190th+Plaza+%232500,+Elkhorn,+NE+68022/@41.2657312,-96.2115681,2999a,13.1y/data=!4m2!3m1!1s0x8793f023383601e9:0x2f40bf70a0c05896",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnm7MzquPOuM-RPuOVk8oPKU0IZLCXqMCniena4OdsIvuJyvpDFyzIf-TBHjCvK1_VNahKqy23gJJdP67wzSUYRDhGVDnbzXAW_zlsAibKvr3DFSZGbjW5mq4zOOxDqA1o7BXl2=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Methodist+Reproductive+Health+Specialists,+717+N+190th+Plaza+%232500,+Elkhorn,+NE+68022/@41.2657312,-96.2115681,2999a,13.1y/data=!4m2!3m1!1s0x8793f023383601e9:0x2f40bf70a0c05896",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Nebraska (NE) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-867",
    "externalIds": {
      "cdcClinicId": "867",
      "googlePlaceId": "ChIJrekECd9L4okRKUDnavjsGsY"
    },
    "type": "fertility-clinic",
    "name": "Boston IVF - The NH Center",
    "phone": "(603) 637-9736",
    "address": {
      "line1": "18 Constitution Dr, Suite 9",
      "city": "Bedford",
      "state": "NH",
      "zip": "03110",
      "country": "US"
    },
    "location": {
      "lat": 42.9561,
      "lng": -71.5036
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 50.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 45.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 53.84615384615385,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/13"
        }
      ],
      "cyclesPerYear": 141,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27867%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27867%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.bostonivf.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/locations/the-bedford-nh-fertility-center",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Boston+IVF,+18+Constitution+Dr+Ste+9,+Bedford,+NH+03110/@42.9561034,-71.5036914,2920a,13.1y/data=!4m2!3m1!1s0x89e24bdf0904e9ad:0xc61aecf86ae74029",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.bostonivf.com/locations/the-bedford-nh-fertility-center",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-867-kristen-wright-md",
        "name": "Kristen Wright, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.bostonivf.com/thumbs/K-Wright-Updated_thumb-physicians-list.png?v=b3f3e",
        "_source": {
          "url": "https://www.bostonivf.com/locations/the-bedford-nh-fertility-center",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-867-carleigh-nesbit-do",
        "name": "Carleigh Nesbit, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.bostonivf.com/thumbs/C-nesbit-Updated_thumb-physicians-list.png?v=380b4",
        "_source": {
          "url": "https://www.bostonivf.com/locations/the-bedford-nh-fertility-center",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "network": {
      "name": "Boston IVF"
    },
    "website": "https://www.bostonivf.com/locations/the-bedford-nh-fertility-center",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield of Massachusetts",
        "Blue Cross Blue Shield of Rhode Island",
        "Blue Cross Blue Shield PPO (out-of-state)",
        "Carelink",
        "Carrot",
        "CDPHP",
        "Cigna",
        "Cofertility/EggCo",
        "Emblem Health",
        "Excellus Blue Cross Blue Shield",
        "Empire Blue Cross Blue Shield",
        "GHI",
        "GIC Indemnity",
        "Harvard Pilgrim",
        "Health New England",
        "Highmark Blue Shield of Northeastern NY",
        "Highmark Blue Cross Federal",
        "Maine Community Health Options",
        "Mass General Brigham Health Plan",
        "Maven",
        "NYS Empire Plan",
        "PHCS",
        "Progyny",
        "Stork Club",
        "Tricare",
        "Tufts Health Direct",
        "Unicare",
        "United Healthcare",
        "WellSense Health Plan",
        "WIN Fertility/Premier"
      ],
      "_source": {
        "url": "https://www.bostonivf.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "images": [
      {
        "url": "https://www.bostonivf.com/thumbs/thumbnail48_thumb-resources-main.jpg?v=bc48d",
        "type": "interior",
        "caption": "Waiting room / lobby of Boston IVF's Bedford, NH fertility center, showing lounge seating, fireplace, TV, and coffee station",
        "_source": {
          "url": "https://www.bostonivf.com/resources/blog/introducing-our-new-hampshire-fertility-center",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkMTC9Lg-fAWb-fFkRxHls2qdS_tfFE4Rk2W7bGH8cDxPNaGDjPjQikud7f56yBl8C0NkLNOEfLIV5uvY1QfXnsElEb1olA64Iv9_ET1GIsJZ-ElelqrGFvslTuGKGipG8FKh_a=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Boston+IVF,+18+Constitution+Dr+Ste+9,+Bedford,+NH+03110/@42.9561034,-71.5036914,2920a,13.1y/data=!4m2!3m1!1s0x89e24bdf0904e9ad:0xc61aecf86ae74029",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmqkGQX2xr6-bC5hBw5Zvui_-tz2LkvT5sR-ERT7v-pPIaU340U8b7fZB8rZI9Ya4qLB_-n6PsiqshKr43skCH9nakJomeCM8auY0TcYt96P8uuJ8_8wnghs7QJls2wZ-2RrRks=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Boston+IVF,+18+Constitution+Dr+Ste+9,+Bedford,+NH+03110/@42.9561034,-71.5036914,2920a,13.1y/data=!4m2!3m1!1s0x89e24bdf0904e9ad:0xc61aecf86ae74029",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield of Massachusetts, Blue Cross Blue Shield of Rhode Island, Blue Cross Blue Shield PPO (out-of-state), Carelink, Carrot, CDPHP, Cigna",
              "detail": "23 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.bostonivf.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Hampshire (NH) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-412",
    "externalIds": {
      "cdcClinicId": "412",
      "googlePlaceId": "ChIJNSSIe_u3w4kR0rNVBKX1rGk"
    },
    "type": "fertility-clinic",
    "name": "Center for Advanced Reproductive Medicine & Fertility",
    "phone": "(732) 339-9300",
    "address": {
      "line1": "4 Ethel Rd, Suite 405A",
      "city": "Edison",
      "state": "NJ",
      "zip": "8817",
      "country": "US"
    },
    "location": {
      "lat": 40.5412,
      "lng": -74.396
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 60.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 59.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 42.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 35,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27412%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27412%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.infertilitydocs.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Center+for+Advanced+Reproductive+Medicine+%26+Fertility,+4+Ethel+Rd,+Edison,+NJ+08817/@40.5412084,-74.3961959,3032a,13.1y/data=!4m2!3m1!1s0x89c3b7fb7b882435:0x69acf5a50455b3d2",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-412-suna-m-qasim-md",
        "name": "Suna M. Qasim, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.infertilitydocs.com/z-images/team/qasim.webp",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.infertilitydocs.com/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Rahul Sachdev, MD",
        "imageUrl": "https://www.infertilitydocs.com/z-images/team/rahul.webp",
        "_source": {
          "url": "https://www.infertilitydocs.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-412-rahul-sachdev-md"
      }
    ],
    "website": "https://www.armfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl7rhjEQ2ECEJYXQB-64nCKkJdhWlCebE4Qp6qkzSkr4mr6ikcwmTp06QWHI_rJ54yzPPkEY4m1mQHiMp_9bl-debsLl7W5VswDO-vjw3OOCQFK_T_55MQPSZkSZZOxaowp4ONO=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Center+for+Advanced+Reproductive+Medicine+%26+Fertility,+4+Ethel+Rd,+Edison,+NJ+08817/@40.5412084,-74.3961959,3032a,13.1y/data=!4m2!3m1!1s0x89c3b7fb7b882435:0x69acf5a50455b3d2",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkkvvNeWTuZnEKxzcnaDlGkHN-acfefiptmTWI4Deo_eq075il7cM2B2bMOXyUjbU69YEomzxGDQJuewRqOc7COnmga12vL3TNM0-dI-L1HNJ9fxLrJox-ZtGrHrMv4nJiFyzx0=w381-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Center+for+Advanced+Reproductive+Medicine+%26+Fertility,+4+Ethel+Rd,+Edison,+NJ+08817/@40.5412084,-74.3961959,3032a,13.1y/data=!4m2!3m1!1s0x89c3b7fb7b882435:0x69acf5a50455b3d2",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-485",
    "externalIds": {
      "cdcClinicId": "485",
      "googlePlaceId": "ChIJoenRvvkywYkRbrh108J8mQI"
    },
    "type": "fertility-clinic",
    "name": "Center for Reproductive Medicine and Fertility, Louis R. Manara, DO",
    "phone": "(856) 767-0009",
    "address": {
      "line1": "200 Route 73, Suite A",
      "city": "Voorhees",
      "state": "NJ",
      "zip": "8043",
      "country": "US"
    },
    "location": {
      "lat": 39.8426,
      "lng": -74.9233
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 47.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 37.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 46.15384615384615,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/13"
        }
      ],
      "cyclesPerYear": 140,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27485%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27485%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.crmfertility.com",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Center+for+Reproductive+Medicine+and+Fertility,+200+NJ-73+Ste+A,+Voorhees+Township,+NJ+08043/@39.8427713,-74.9233859,3063a,13.1y/data=!4m2!3m1!1s0x89c132f9bed1e9a1:0x2997cc2d375b86e",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-485-louis-r-manara-do",
        "name": "Louis R. Manara, DO",
        "role": "Medical Director",
        "imageUrl": "https://einstein-clients.imgix.net/1262/2549/original_LRM_Photo.jpg?w=200&h=300&fit=crop&auto=format",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.crmfertility.com",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.crmfertility.com",
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Horizon Blue Cross Blue Shield"
      ]
    },
    "setting": "boutique",
    "images": [
      {
        "url": "https://einstein-clients.imgix.net/1262/274845/original.jpg?1566930555%3Ffit=crop&w=600&auto=format&fit=max",
        "type": "exterior",
        "caption": "Center for Reproductive Medicine and Fertility office exterior",
        "_source": {
          "url": "https://www.crmfertility.com",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Horizon Blue Cross Blue Shield",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-186",
    "externalIds": {
      "cdcClinicId": "186",
      "googlePlaceId": "ChIJu0GzYe00wYkRvJ6EgxdE1Mg"
    },
    "type": "fertility-clinic",
    "name": "Cooper Institute for Reproductive Hormonal Disorders, PC",
    "phone": "(856) 751-5575",
    "address": {
      "line1": "17000 Commerce Pkwy, Suite C",
      "city": "Mount Laurel",
      "state": "NJ",
      "zip": "8054",
      "country": "US"
    },
    "location": {
      "lat": 39.9183,
      "lng": -74.942
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 33,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 29.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 14.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 3.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 445,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27186%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27186%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Cooper+Institute+for+Reproductive+Hormonal+Disorders,+P.C.,+17000+Commerce+Pkwy,+Mt+Laurel+Township,+NJ+08054/@39.9182613,-74.942039,3060a,13.1y/data=!4m2!3m1!1s0x89c134ed61b341bb:0xc8d4441783849ebc",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-186-jerome-h-check-md-phd",
        "name": "Jerome H. Check, MD, PHD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.cooperfertility.com",
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Horizon Blue Cross Blue Shield"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Horizon Blue Cross Blue Shield",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmNmJ-p0-RKQvDrsfek2LpeWVrpbSyzl0_nthkhi61HxTAVuimtGA7AfOVJcL-iAbyRFwQaIkYFTq-4j0LJrBumbIHP5RaYDogm7MyFqF2Va4RjzJ5DB9PoKs33z0frdVzw8WA=w408-h544-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Cooper+Institute+for+Reproductive+Hormonal+Disorders,+P.C.,+17000+Commerce+Pkwy,+Mt+Laurel+Township,+NJ+08054/@39.9182613,-74.942039,3060a,13.1y/data=!4m2!3m1!1s0x89c134ed61b341bb:0xc8d4441783849ebc",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmtzzfRKMJNEvimhG0A3Sgg5T_Q1w32BjhdlPfRAClhPeck8hK7egyEka__68kvLshPm0cgt7o80ZwV9qRHhUe8lklbRfCFBx3QbPNHWCt_MseMPQiX8rhO2VUiSC64eAhAM4yT=w360-h270-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Cooper+Institute+for+Reproductive+Hormonal+Disorders,+P.C.,+17000+Commerce+Pkwy,+Mt+Laurel+Township,+NJ+08054/@39.9182613,-74.942039,3060a,13.1y/data=!4m2!3m1!1s0x89c134ed61b341bb:0xc8d4441783849ebc",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-381",
    "externalIds": {
      "cdcClinicId": "381",
      "googlePlaceId": "ChIJJdcB8h0wwokRbu68_i8xFbo"
    },
    "type": "fertility-clinic",
    "name": "Damien Fertility Partners",
    "phone": "(732) 758-6511",
    "address": {
      "line1": "655 Shrewsbury Ave, Suite 300",
      "city": "Shrewsbury",
      "state": "NJ",
      "zip": "7702",
      "country": "US"
    },
    "location": {
      "lat": 40.3263,
      "lng": -74.0724
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 52.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 50.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 32.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 13,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 329,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27381%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27381%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.damienfertilitypartners.com/why-choose-us/our-staff/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Damien+Fertility+Partners+formerly+East+Coast+IVF,+655+Shrewsbury+Ave+%23300,+Shrewsbury,+NJ+07702/@40.3263305,-74.0724267,3042a,13.1y/data=!4m2!3m1!1s0x89c2301df201d725:0xba15312ffebcee6e",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-381-miguel-damien-md",
        "name": "Miguel Damien, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.damienfertilitypartners.com/wp-content/uploads/2018/12/dr-miguel-damien.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.damienfertilitypartners.com/why-choose-us/our-staff/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Nina Seigelstein, MD",
        "imageUrl": "https://www.damienfertilitypartners.com/wp-content/uploads/2020/01/DrSeigelstein.jpg",
        "_source": {
          "url": "https://www.damienfertilitypartners.com/why-choose-us/our-staff/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-381-nina-seigelstein-md"
      },
      {
        "name": "Barry Perlman, DO",
        "imageUrl": "https://www.damienfertilitypartners.com/wp-content/uploads/2024/08/dr-barry-perlman.jpg",
        "_source": {
          "url": "https://www.damienfertilitypartners.com/why-choose-us/our-staff/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["DO"],
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-cdc-381-barry-perlman-do"
      },
      {
        "name": "Katherine Mendez, NP",
        "imageUrl": "https://www.damienfertilitypartners.com/wp-content/uploads/2024/08/NP-katherine.jpg",
        "_source": {
          "url": "https://www.damienfertilitypartners.com/why-choose-us/our-staff/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "practitionerId": "pr-org-cdc-381-katherine-mendez-np"
      },
      {
        "name": "Liz Piercy, NP",
        "imageUrl": "https://www.damienfertilitypartners.com/wp-content/uploads/2024/08/np-liz.jpg",
        "_source": {
          "url": "https://www.damienfertilitypartners.com/why-choose-us/our-staff/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "practitionerId": "pr-org-cdc-381-liz-piercy-np"
      },
      {
        "name": "Klaus Wiemer, PhD",
        "imageUrl": "https://www.damienfertilitypartners.com/wp-content/uploads/2024/08/dr-klaus-wiemer.jpg",
        "_source": {
          "url": "https://www.damienfertilitypartners.com/why-choose-us/our-staff/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Laboratory Director",
        "credentials": ["PhD"],
        "specialty": "Embryology",
        "practitionerId": "pr-org-cdc-381-klaus-wiemer-phd"
      }
    ],
    "website": "https://www.damienfertilitypartners.com",
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Horizon Blue Cross Blue Shield"
      ]
    },
    "setting": "boutique",
    "images": [
      {
        "url": "https://www.damienfertilitypartners.com/wp-content/uploads/2018/12/sh_02-500x500.jpg",
        "type": "interior",
        "caption": "Damien Fertility Partners Shrewsbury office entryway",
        "_source": {
          "url": "https://www.damienfertilitypartners.com/Locations/shrewsbury/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmU825QO9Nj3IwfgJbhr0vIbF8wtPvi-r02sYpO55b9FMLSeSrHpAOjRGXLjps3vfHHxt06iTYfNWOO1Tq6K6fGSzGHa-1kjzskn8jcc17Q6itziZzj2XVVRFalWKNmFa-aFZU1CA=w224-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Damien+Fertility+Partners+formerly+East+Coast+IVF,+655+Shrewsbury+Ave+%23300,+Shrewsbury,+NJ+07702/@40.3263305,-74.0724267,3042a,13.1y/data=!4m2!3m1!1s0x89c2301df201d725:0xba15312ffebcee6e",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Horizon Blue Cross Blue Shield",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-463",
    "externalIds": {
      "cdcClinicId": "463",
      "googlePlaceId": "ChIJNRwwFEqsw4kR0xrsc7icnxo"
    },
    "type": "fertility-clinic",
    "name": "Diamond Institute for Infertility & Menopause",
    "phone": "(973) 761-5600",
    "address": {
      "line1": "89 Millburn Ave",
      "city": "Millburn",
      "state": "NJ",
      "zip": "7041",
      "country": "US"
    },
    "location": {
      "lat": 40.723,
      "lng": -74.2868
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 42.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 22.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 28.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "0/13"
        }
      ],
      "cyclesPerYear": 188,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27463%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27463%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Diamond+Institute+for+Infertility+%26+Menopause,+89+Millburn+Ave,+Millburn,+NJ+07041/@40.7229744,-74.2868115,3024a,13.1y/data=!4m2!3m1!1s0x89c3ac4a14301c35:0x1a9f9cb873ec1ad3",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-463-matan-yemini-md",
        "name": "Matan Yemini, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.diamondinstitute.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-266",
    "externalIds": {
      "cdcClinicId": "266",
      "googlePlaceId": "ChIJP9VZN5bvwokRvcAz0BS5DOw"
    },
    "type": "fertility-clinic",
    "name": "Fertility Institute of New Jersey and New York",
    "phone": "(201) 666-4200",
    "address": {
      "line1": "680 Kinderkamack Rd, Suite 200",
      "city": "Oradell",
      "state": "NJ",
      "zip": "7649",
      "country": "US"
    },
    "location": {
      "lat": 40.9634,
      "lng": -74.0301
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 62.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 73.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 58.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 38.88888888888889,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/18"
        }
      ],
      "cyclesPerYear": 277,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27266%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27266%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitynjny.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Institute+of+NJ+%26+NY,+680+Kinderkamack+Rd+%23200,+Oradell,+NJ+07649/@40.9634163,-74.0300667,3013a,13.1y/data=!4m2!3m1!1s0x89c2ef963759d53f:0xec0cb914d033c0bd",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-266-zalman-levine-md",
        "name": "Zalman Levine, MD",
        "role": "Medical Director",
        "imageUrl": "https://fertilitynjny.com/wp-content/uploads/2023/03/ZalmineLevine-200x300.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.fertilitynjny.com/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.fertilityivf.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://fertilitynjny.com/wp-content/uploads/2014/10/fertility-center-ny-nj-14.jpg",
        "type": "interior",
        "caption": "Fertility Institute of New Jersey and New York office",
        "_source": {
          "url": "https://www.fertilitynjny.com/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlGUJYDlx40uAUpS9NyKychn34B3uPgn4YARo_DV4nOK-ayWuyse1DNoBa3jobnEvWFAL527ilnb7Ng3tL1mqQ6Wc05CRSumjQrUz51wn3qSGI1POxlzzQ1ZpIoIcLSptiEDFhVGw=w588-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Institute+of+NJ+%26+NY,+680+Kinderkamack+Rd+%23200,+Oradell,+NJ+07649/@40.9634163,-74.0300667,3013a,13.1y/data=!4m2!3m1!1s0x89c2ef963759d53f:0xec0cb914d033c0bd",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnLUr-j4tjBLF3E-URMaLXwQlPHzbeTC9hQiiIR8BcqpQya-HrTQptMySEvZXQikgvC6ArlvTwOzI3s6S9nEx7Y5oxJb4jj8A8q7ecmJR53Serj_VCwbITxB50ds7Q0oP4kQjD4=w442-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Institute+of+NJ+%26+NY,+680+Kinderkamack+Rd+%23200,+Oradell,+NJ+07649/@40.9634163,-74.0300667,3013a,13.1y/data=!4m2!3m1!1s0x89c2ef963759d53f:0xec0cb914d033c0bd",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlQl4KjMYGu2_q1COtLtDnooq4nu69vsuOPazTnLUNKhDdhV69WOYzTCZcdeuzfs7eqB3d4kDg6qKnHmyord6dV9WsUMZGERWi0P4ss5C67cK7ZmYeaZwhfNZiLvnoE_jBS0U9-=w224-h298-k-no-pi0-ya353.32196-ro-0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Institute+of+NJ+%26+NY,+680+Kinderkamack+Rd+%23200,+Oradell,+NJ+07649/@40.9634163,-74.0300667,3013a,13.1y/data=!4m2!3m1!1s0x89c2ef963759d53f:0xec0cb914d033c0bd",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-54",
    "externalIds": {
      "cdcClinicId": "54",
      "googlePlaceId": "ChIJAeub9Pirw4kRm8HEjePkDO8"
    },
    "type": "fertility-clinic",
    "name": "CCRM Fertility of New Jersey - Main Center",
    "description": "Leading New Jersey fertility center at Saint Barnabas Medical Center, part of the CCRM network, with dedicated financial counselors and 24-48 hour oncofertility consults.",
    "website": "https://www.ccrmivf.com/location/us/new-jersey/",
    "phone": "(973) 548-9900",
    "bookingUrl": "https://www.ccrmivf.com/location/us/new-jersey/",
    "address": {
      "line1": "94 Old Short Hills Rd, East Wing, Suite 403",
      "city": "Livingston",
      "state": "NJ",
      "zip": "07039",
      "country": "US"
    },
    "location": {
      "lat": 40.7631,
      "lng": -74.3048
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "financingOptions": ["Loans", "Future Family", "CapexMD"]
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 59,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 55.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 55.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 39.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1248,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2754%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "languages": ["es"],
    "consultationTypes": ["in-person", "telehealth"],
    "patientGroups": ["LGBTQIA+", "Same sex couples"],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2754%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "scraped"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/new-jersey/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Livingston,+East+Wing,+94+Old+Short+Hills+Rd+%23403E,+Livingston,+NJ+07039/@40.7630135,-74.3038332,3022a,13.1y/data=!4m2!3m1!1s0x89c3abf8f49beb01:0xef0ce4e38dc4c19b",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "layer2-ccrm-rebrand",
      "date": "2026-06-13",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-54-debbra-a-keegan-md",
        "name": "Debbra A. Keegan, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Debbra_Keegan_600x600_2x-r9yq8xq21dm9sz61xwxt14jwvkjby3miuz0rtbtn6o.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Serena H. Chen, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Serena_Chen_600x600_2x-r9yq9umeokvb3bu9lt5qye91o216fi94nhurm0gv4w.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-54-serena-h-chen-md"
      },
      {
        "name": "Jessica Salas Mann, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Jessica_Salas_Mann_600x600_2x-r9yq8c3ro6sody1gg5ldxs0b7phw128p400lrypp5s.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-54-jessica-salas-mann-md"
      },
      {
        "name": "Melissa C. Yih, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Melissa_C_Yih_600x600_2x-r9yq75t14n6rvhqwb5b6bkokhdadeokry6nr6igexs.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-54-melissa-c-yih-md"
      }
    ],
    "setting": "network-group",
    "network": {
      "name": "CCRM Fertility"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmPjmnJmEK0dcj98puak8K_w7ni0O6nhNWoTvh9g1Dwnb54oFU_cg-bjY_68nVLcuUyQfnXaqHDq2v8zNu8HG_DFuvoae2qNxH6cqt8IOSq3DKP5UjV5Whd5bYCDpIx9696Nw6zfg=w408-h544-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Livingston,+East+Wing,+94+Old+Short+Hills+Rd+%23403E,+Livingston,+NJ+07039/@40.7630135,-74.3038332,3022a,13.1y/data=!4m2!3m1!1s0x89c3abf8f49beb01:0xef0ce4e38dc4c19b",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-147",
    "externalIds": {
      "cdcClinicId": "147"
    },
    "type": "fertility-clinic",
    "name": "North Hudson IVF, Center for Fertility and Gynecology",
    "phone": "(201) 871-1999",
    "address": {
      "line1": "385 Sylvan Ave",
      "city": "Englewood Cliffs",
      "state": "NJ",
      "zip": "7632",
      "country": "US"
    },
    "location": {
      "lat": 40.8747,
      "lng": -73.9522
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 28,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27147%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27147%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.holyname.org/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-147-jane-e-miller-md",
        "name": "Jane E. Miller, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.holyname.org/physician/images/physicians/00406.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.holyname.org/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.northhudsonivf.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-416",
    "externalIds": {
      "cdcClinicId": "416",
      "googlePlaceId": "ChIJvypKcfq9w4kRFDZdyYnnLm4"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Medicine Associates of New Jersey",
    "description": "Ranked #1 fertility clinic in New Jersey with over 25 years of experience and pioneering research in preimplantation genetic testing.",
    "website": "https://rmanetwork.com/our-locations/rma-new-jersey/",
    "phone": "(973) 971-4600",
    "bookingUrl": "https://rmanetwork.com/contact-us/",
    "address": {
      "line1": "140 Allen Rd",
      "city": "Basking Ridge",
      "state": "NJ",
      "zip": "7920",
      "country": "US"
    },
    "location": {
      "lat": 40.6473,
      "lng": -74.5852
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 59.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 54.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 57.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 46.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 4583,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27416%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "languages": ["es"],
    "consultationTypes": ["in-person", "telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+New+Jersey+%E2%80%93+Basking+Ridge+Fertility+Clinic,+140+Allen+Rd,+Basking+Ridge,+NJ+07920/@40.6473402,-74.5852271,3027a,13.1y/data=!4m2!3m1!1s0x89c3bdfa714a2abf:0x6e2ee789c95d3614",
            "fetchedAt": "2026-08-16"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27416%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-416-michael-r-drews-md",
        "name": "Michael R. Drews, MD",
        "role": "Medical Director",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2021/02/founder-2-michael-e1618857492283.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Amanda Kadesh, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Amanda-Kadesh-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/amanda-kadesh-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-416-amanda-kadesh-md"
      },
      {
        "name": "Joelle Mouhanna, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Joelle-Mouhanna-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/joelle-mouhanna-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-416-joelle-mouhanna-md"
      },
      {
        "name": "Rachel Martel, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Rachel-Martel-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/rachel-martel-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-416-rachel-martel-md"
      }
    ],
    "network": {
      "name": "IVI RMA"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmuxnegeRUCMXH6JmeEG5NlVi_cOz0XGjWOihsk9cIRjdSg-rYN92c8n1VxlIo87tFIRCSrLoSCIMMom0pSx97IgUHS8YZhr_LmQtGH4XP_VW-2ZGqMBDwHQVL9MKZxaT72ZsVZ=w224-h298-k-no-pi0-ya160-ro0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+New+Jersey+%E2%80%93+Basking+Ridge+Fertility+Clinic,+140+Allen+Rd,+Basking+Ridge,+NJ+07920/@40.6473402,-74.5852271,3027a,13.1y/data=!4m2!3m1!1s0x89c3bdfa714a2abf:0x6e2ee789c95d3614",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-239",
    "externalIds": {
      "cdcClinicId": "239",
      "googlePlaceId": "ChIJI50hAhMvwokRF09y8EpCaHY"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Science Center of New Jersey",
    "phone": "(732) 918-2500",
    "address": {
      "line1": "234 Industrial Way West, Suite A104",
      "city": "Eatontown",
      "state": "NJ",
      "zip": "7724",
      "country": "US"
    },
    "location": {
      "lat": 40.2765,
      "lng": -74.0561
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 47.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 35.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 25,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 295,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27239%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27239%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.rscnj.com/fertility-specialists",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/The+Reproductive+Science+Center+of+New+Jersey,+234+Industrial+Wy+W+Ste+A104,+Eatontown,+NJ+07724/@40.2764282,-74.055809,3044a,13.1y/data=!4m2!3m1!1s0x89c22f1302219d23:0x7668424af0724f17",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-239-william-ziegler-do",
        "name": "William Ziegler, DO",
        "role": "Medical Director",
        "imageUrl": "https://cdn.buttercms.com/KpIoPTmeTSe3qvUlO6qy",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.rscnj.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Alan Martinez, MD",
        "imageUrl": "https://cdn.buttercms.com/lRIffrAcTDy2zWbqeIEG",
        "_source": {
          "url": "https://www.rscnj.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-239-alan-martinez-md"
      },
      {
        "name": "Ashley Ulker, MD",
        "imageUrl": "https://cdn.buttercms.com/vZRGpIzTTq3knvljZx56",
        "_source": {
          "url": "https://www.rscnj.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-239-ashley-ulker-md"
      }
    ],
    "website": "https://www.rscnj.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "network": {
      "name": "Prelude Network"
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmFciV9yl-Guz7NoOtbzTo2rLseu-iZaAwOMrbk6J16mM51wMXM4hMQXiMUZL5i_FgpresmnJ0tY1k2GqCDoP3JeQHghpi1UrQ-_yaXfDqaQ3_nqckqUEVsWk4zwZYvCgGJBEhDGg=w408-h544-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/The+Reproductive+Science+Center+of+New+Jersey,+234+Industrial+Wy+W+Ste+A104,+Eatontown,+NJ+07724/@40.2764282,-74.055809,3044a,13.1y/data=!4m2!3m1!1s0x89c22f1302219d23:0x7668424af0724f17",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlpsVZuMIz76A-pJEjgdDiWgRztT26DlI4UmwFwxfUoTNEkG9Vnwei9VohxdMLc0nouPaFnRIXoE09skG5Tb4Hwbqxi_cvAeGdyOBpyEUoYegrm1ZYgfQttnmRte3I2qRJDGrWn7Q=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/The+Reproductive+Science+Center+of+New+Jersey,+234+Industrial+Wy+W+Ste+A104,+Eatontown,+NJ+07724/@40.2764282,-74.055809,3044a,13.1y/data=!4m2!3m1!1s0x89c22f1302219d23:0x7668424af0724f17",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnh06SUzka_1p1L2A_eVsXGaHOwNfKbQrGt2xQ4Rp6XGQ6Zy42IQWASDX_XJT2I9JP7oWov2BxUDkJP9BglMyiU1GVAXtlnR3DLVJL8HGT6KaMWw_jmvdy0XTDvVKMLP7aGaijKLQ=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/The+Reproductive+Science+Center+of+New+Jersey,+234+Industrial+Wy+W+Ste+A104,+Eatontown,+NJ+07724/@40.2764282,-74.055809,3044a,13.1y/data=!4m2!3m1!1s0x89c22f1302219d23:0x7668424af0724f17",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-319",
    "externalIds": {
      "cdcClinicId": "319",
      "googlePlaceId": "ChIJcX7SBZaCwYkRx1uPBfqzHys"
    },
    "type": "fertility-clinic",
    "name": "Shore Institute for Reproductive Medicine dba, Morgan Fertility and Reproductive Medicine",
    "phone": "(732) 363-4777",
    "address": {
      "line1": "475 Route 70 West, Suite 201",
      "city": "Lakewood",
      "state": "NJ",
      "zip": "8701",
      "country": "US"
    },
    "location": {
      "lat": 40.0506,
      "lng": -74.2006
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 41.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 32,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 40.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 20,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 28,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27319%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27319%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://morganfertility.com",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Morgan+Fertility+and+Reproductive+Medicine,+475+NJ-70+Suite+201,+Lakewood,+NJ+08701/@40.0505793,-74.2005611,3054a,13.1y/data=!4m2!3m1!1s0x89c1829605d27e71:0x2b1fb3fa058f5bc7",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-319-allen-morgan-md",
        "name": "Allen Morgan, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.morganfertility.com/dr-allen-morgan-headshot.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://morganfertility.com",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.morganfertility.com",
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Horizon Blue Cross Blue Shield"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Horizon Blue Cross Blue Shield",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-43",
    "externalIds": {
      "cdcClinicId": "43",
      "googlePlaceId": "ChIJifVB7n4zwYkRx5EeKhP9y4s"
    },
    "type": "fertility-clinic",
    "name": "South Jersey Fertility Center",
    "phone": "(856) 596-2233",
    "address": {
      "line1": "400 Lippincott Dr, Suite 130",
      "city": "Marlton",
      "state": "NJ",
      "zip": "8053",
      "country": "US"
    },
    "location": {
      "lat": 39.8847,
      "lng": -74.9247
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 46,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 33.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 35.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 13.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 417,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2743%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2743%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/South+Jersey+Fertility+-+Marlton,+400+Lippincott+Dr+%23130,+Marlton,+NJ+08053/@39.8847344,-74.9248113,3062a,13.1y/data=!4m2!3m1!1s0x89c1337eee41f589:0x8bcbfd132a1e91c7",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-43-peter-g-van-deerlin-md",
        "name": "Peter G. Van Deerlin, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.sjfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-133",
    "externalIds": {
      "cdcClinicId": "133",
      "googlePlaceId": "ChIJZRybUqb5wokRWT4VC24E5ZA"
    },
    "type": "fertility-clinic",
    "name": "University Reproductive Associates, PC",
    "phone": "(201) 288-6330",
    "address": {
      "line1": "214 Terrace Ave",
      "city": "Hasbrouck Heights",
      "state": "NJ",
      "zip": "7604",
      "country": "US"
    },
    "location": {
      "lat": 40.8585,
      "lng": -74.0737
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 40.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 40.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 36.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 30.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 557,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27133%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27133%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.uranj.com/providers",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/University+Reproductive+Associates,+214+Terrace+Ave,+Hasbrouck+Heights,+NJ+07604/@40.858465,-74.0736827,3018a,13.1y/data=!4m2!3m1!1s0x89c2f9a6529b1c65:0x90e5046e0b153e59",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-133-peter-g-mcgovern-md",
        "name": "Peter G. McGovern, MD",
        "role": "Medical Director",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845369.png",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Michael Cho, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845361.png",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-133-michael-cho-md"
      },
      {
        "name": "Adam Fechner, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845363.png",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-133-adam-fechner-md"
      },
      {
        "name": "Rita Gulati, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845367.jpg",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-133-rita-gulati-md"
      },
      {
        "name": "Sara Morelli, MD, PhD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845371.png",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-133-sara-morelli-md-phd"
      },
      {
        "name": "Kavitha Persaud, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845373.jpg",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-133-kavitha-persaud-md"
      },
      {
        "name": "Susan Wolf, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845375.png",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-133-susan-wolf-md"
      },
      {
        "name": "Anat Chemerinski, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845377.jpg",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-133-anat-chemerinski-md"
      },
      {
        "name": "Ndidiamaka Onwubalili, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845379.jpg",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-133-ndidiamaka-onwubalili-md"
      }
    ],
    "website": "https://www.uranj.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlGBcbFC1DP0UBBEcB97slnaPZZgcPug82pEJ6cbpNRw8ZTX4uhBLZ7qxO6t6qQSK5ovK8EnZPRY43QLU8qK_rDVjs_QTe8YQCU6Cc0173kv13YXCoN5hUZ1wdL5BlaEGgC5xrtrSTNQqUC=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/University+Reproductive+Associates,+214+Terrace+Ave,+Hasbrouck+Heights,+NJ+07604/@40.858465,-74.0736827,3018a,13.1y/data=!4m2!3m1!1s0x89c2f9a6529b1c65:0x90e5046e0b153e59",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmDFlqTiSCs9KoCtVgg-haF_-LLqz56DB4NytwlKJ9wnms0tyQjzVyL7T9NPojmUsIp_GkjFX1Hegjw4uou_KRPDiSZYIdJoEK4bBAkmaB5OX9hnnEP80D5gi1f3Yyz8o9ql-wfIk4qxuw=w298-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/University+Reproductive+Associates,+214+Terrace+Ave,+Hasbrouck+Heights,+NJ+07604/@40.858465,-74.0736827,3018a,13.1y/data=!4m2!3m1!1s0x89c2f9a6529b1c65:0x90e5046e0b153e59",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-106",
    "externalIds": {
      "cdcClinicId": "106"
    },
    "type": "fertility-clinic",
    "name": "Valley Hospital Fertility Center",
    "phone": "(201) 634-5534",
    "address": {
      "line1": "140 E. Ridgewood Ave, 5th Floor, Suite 590S",
      "city": "Paramus",
      "state": "NJ",
      "zip": "7652",
      "country": "US"
    },
    "location": {
      "lat": 40.9646,
      "lng": -74.0688
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 53.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 53.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 56.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 60,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "9/15"
        }
      ],
      "cyclesPerYear": 256,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27106%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27106%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.valleyhealth.com/services/fertility-center/meet-fertility-team",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-106-ali-nasseri-md-phd",
        "name": "Ali Nasseri, MD, PHD",
        "role": "Medical Director",
        "imageUrl": "https://www.valleyhealth.com/sites/default/files/styles/small_profile/public/2021-11/Nasseri%2C%20Ali%2C%20M.D.%20074%20suit.jpg?itok=CVQ8EkKq",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.valleyhealth.com/services/fertility-center/meet-fertility-team",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Dehan Chen, MD",
        "imageUrl": "https://www.valleyhealth.com/sites/default/files/styles/small_profile/public/2019-01/chen.jpg?itok=ITLBIuZ1",
        "_source": {
          "url": "https://www.valleyhealth.com/services/fertility-center/meet-fertility-team",
          "fetchedAt": "2026-06-14"
        },
        "role": "Associate Clinical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-106-dehan-chen-md"
      },
      {
        "name": "Keri L. Greenseid, MD",
        "imageUrl": "https://www.valleyhealth.com/sites/default/files/styles/small_profile/public/2024-10/keri%20greenseid.png?itok=R-TWe6Vg",
        "_source": {
          "url": "https://www.valleyhealth.com/services/fertility-center/meet-fertility-team",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-106-keri-l-greenseid-md"
      },
      {
        "name": "Kim Altman Weiss, PhD",
        "imageUrl": "https://www.valleyhealth.com/sites/default/files/styles/small_profile/public/2024-01/kim%20weiss%20phd.png?itok=qHk58p9D",
        "_source": {
          "url": "https://www.valleyhealth.com/services/fertility-center/meet-fertility-team",
          "fetchedAt": "2026-06-14"
        },
        "role": "Psychologist",
        "credentials": ["PhD"],
        "practitionerId": "pr-org-cdc-106-kim-altman-weiss-phd"
      }
    ],
    "website": "https://www.valleyfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-722",
    "externalIds": {
      "cdcClinicId": "722",
      "googlePlaceId": "ChIJrVLleld0IocRnfBCpYLdus4"
    },
    "type": "fertility-clinic",
    "name": "Caperton Fertility Institute, LLC",
    "phone": "(505) 702-8020",
    "address": {
      "line1": "6500 Jefferson St N.E., Suite 250",
      "city": "Albuquerque",
      "state": "NM",
      "zip": "87109",
      "country": "US"
    },
    "location": {
      "lat": 35.1545,
      "lng": -106.593
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 57.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 46.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 57.14285714285714,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "8/14"
        }
      ],
      "cyclesPerYear": 272,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27722%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27722%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.capertonfertility.com/meet-our-fertility-doctors",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Caperton+Fertility+Institute,+6500+Jefferson+St+NE+%23250,+Albuquerque,+NM+87109/@35.1545348,-106.5934919,3262a,13.1y/data=!4m2!3m1!1s0x872274577ae552ad:0xcebadd82a542f09d",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-722-charles-l-caperton-md",
        "name": "Charles L. Caperton, MD",
        "role": "Medical Director",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://lirp.cdn-website.com/2fc103ab/dms3rep/multi/opt/DR+LEE+CAPERTON-2880w.jpg",
        "_source": {
          "url": "https://www.capertonfertility.com/meet-our-fertility-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-722-kelly-caperton-md",
        "name": "Kelly Caperton, MD",
        "role": "Founder and President",
        "credentials": ["MD", "FACOG"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://lirp.cdn-website.com/2fc103ab/dms3rep/multi/opt/Kelly-9c6ab227-2880w.jpg",
        "_source": {
          "url": "https://www.capertonfertility.com/meet-our-fertility-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-722-marika-raff-md",
        "name": "Marika Raff, MD",
        "role": "REI Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://lirp.cdn-website.com/2fc103ab/dms3rep/multi/opt/Marika-Raff-Caperton-Fertility-Clinic-2880w.jpg",
        "_source": {
          "url": "https://www.capertonfertility.com/meet-our-fertility-doctors",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.capertonfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkVX752KhUYIMoAvY2vB9tARXL7l8oPZrRYoU7xmqRelqt0dX9EILj_2j3d3o-nc_FqejkeHgK7GGZ6XwFZGS4Koy6KKKeVx2imcQuGwVSpXv7d6Tm8s8qUuqxtrHWRTXdb=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Caperton+Fertility+Institute,+6500+Jefferson+St+NE+%23250,+Albuquerque,+NM+87109/@35.1545348,-106.5934919,3262a,13.1y/data=!4m2!3m1!1s0x872274577ae552ad:0xcebadd82a542f09d",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmWGyOmo5LTrn6GwEy-GIChM06NUazdO0XajtXibgQvS-Xg2sSlfts88QkVDqyJHz1Ggoeoz35jP96wfu0tww4ONL0X5Pv8_ZzhLDx6bxJepQjynjLSt4Vv5_b6CqrM9lWxnaPxbA=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Caperton+Fertility+Institute,+6500+Jefferson+St+NE+%23250,+Albuquerque,+NM+87109/@35.1545348,-106.5934919,3262a,13.1y/data=!4m2!3m1!1s0x872274577ae552ad:0xcebadd82a542f09d",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Mexico (NM) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-263",
    "externalIds": {
      "cdcClinicId": "263"
    },
    "type": "fertility-clinic",
    "name": "The Fertility Center of New Mexico, LLC",
    "phone": "(505) 248-0000",
    "address": {
      "line1": "201 Cedar St S.E., Suite S1-20",
      "city": "Albuquerque",
      "state": "NM",
      "zip": "87106",
      "country": "US"
    },
    "location": {
      "lat": 35.0808,
      "lng": -106.635
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 43.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 68,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/14"
        }
      ],
      "cyclesPerYear": 136,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27263%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27263%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://nmfertility.com/staff/jim-thompson/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://nmfertility.com/staff/jim-thompson/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-263-douglas-j-thompson-md",
        "name": "Douglas J. Thompson, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://nmfertility.com/wp-content/uploads/2024/11/FCNM_Nov2024_GrouPhotos6.jpg",
        "_source": {
          "url": "https://nmfertility.com/staff/jim-thompson/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.nmfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Mexico (NM) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-233",
    "externalIds": {
      "cdcClinicId": "233",
      "googlePlaceId": "ChIJU-Y2KQHHyIARiLCt2J-w2_Y"
    },
    "type": "fertility-clinic",
    "name": "The Fertility Center of Las Vegas",
    "phone": "(702) 254-1777",
    "address": {
      "line1": "5365 S Durango Dr",
      "city": "Las Vegas",
      "state": "NV",
      "zip": "89113",
      "country": "US"
    },
    "location": {
      "lat": 36.143,
      "lng": -115.29
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art",
        "_source": {
          "url": "https://fertilitycenterlv.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://fertilitycenterlv.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Preimplantation genetic testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://fertilitycenterlv.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg freezing",
        "category": "preservation",
        "_source": {
          "url": "https://fertilitycenterlv.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Sperm freezing",
        "category": "preservation",
        "_source": {
          "url": "https://fertilitycenterlv.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Embryo freezing",
        "category": "preservation",
        "_source": {
          "url": "https://fertilitycenterlv.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Donor egg and sperm programs",
        "category": "art",
        "_source": {
          "url": "https://fertilitycenterlv.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Gestational carrier/surrogacy coordination",
        "category": "art",
        "_source": {
          "url": "https://fertilitycenterlv.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility preservation",
        "category": "preservation",
        "_source": {
          "url": "https://fertilitycenterlv.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 60.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 55.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 53.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 357,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27233%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://fertilitycenterlv.com/about-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27233%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://fertilitycenterlv.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://fertilitycenterlv.com/about-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://fertilitycenterlv.com/about-us/the-fertility-center-of-las-vegas-building/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/The+Fertility+Center+of+Las+Vegas,+5365+S+Durango+Dr+%23100,+Las+Vegas,+NV+89113/@36.091586,-115.2795257,3224a,13.1y/data=!4m2!3m1!1s0x80c8c7012936e653:0xf6dbb09fd8adb088",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://fertilitycenterlv.com/about-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-233-bruce-shapiro-md-phd",
        "name": "Bruce Shapiro, MD, PhD",
        "role": "Founder and Medical Director",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://fertilitycenterlv.com/wp-content/uploads/2025/08/SHAPIRO_DESK_D3_5871-Edit-retouched-max_highres-scaled.webp",
        "_source": {
          "url": "https://fertilitycenterlv.com/about-us/bruce-shapiro/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-233-carrie-bedient-md",
        "name": "Carrie Bedient, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://fertilitycenterlv.com/wp-content/uploads/2025/08/BEDIENT_DESK_D3_5832-Edit-retouched-max_highres-scaled.webp",
        "_source": {
          "url": "https://fertilitycenterlv.com/about-us/carrie-bedient/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-233-leah-kaye-md",
        "name": "Leah Kaye, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://fertilitycenterlv.com/wp-content/uploads/2025/08/KAYE_DESK_D3_5929-Edit-retouched-max_highres-scaled.webp",
        "_source": {
          "url": "https://fertilitycenterlv.com/about-us/leah-kaye/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://fertilitycenterlv.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "description": "The Fertility Center of Las Vegas is a reproductive medicine clinic founded in 1988, with fertility specialists and on-site clinical, andrology, IVF laboratory, and surgical services at its Durango Drive facility.",
    "images": [
      {
        "url": "https://fertilitycenterlv.com/wp-content/uploads/2023/07/Exterior-Front-1-2048x1367.jpg",
        "type": "exterior",
        "caption": "The Fertility Center of Las Vegas Durango Drive exterior",
        "_source": {
          "url": "https://fertilitycenterlv.com/about-us/virtual-tour/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://fertilitycenterlv.com/wp-content/uploads/2023/07/2.-Lobby-2-1-2048x1368.jpg",
        "type": "interior",
        "caption": "The Fertility Center of Las Vegas lobby",
        "_source": {
          "url": "https://fertilitycenterlv.com/about-us/virtual-tour/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://fertilitycenterlv.com/wp-content/uploads/2023/07/Procedure-1-2048x1367.jpg",
        "type": "interior",
        "caption": "The Fertility Center of Las Vegas procedure room",
        "_source": {
          "url": "https://fertilitycenterlv.com/about-us/virtual-tour/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmynI5-P9gpVQBUgiRNqkFR3JbW_TqS7zvMYcvPfAcJMHr_OTzGpjTPmtGNVvQI1be6o1xZkMzNxKLzOj2FkYb_Y6K5T6Cix84SrNKUUDL6vgwNGEdUNgYon_GRfBkbdTP8PUXvrFeeQ9vb=w725-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/The+Fertility+Center+of+Las+Vegas,+5365+S+Durango+Dr+%23100,+Las+Vegas,+NV+89113/@36.091586,-115.2795257,3224a,13.1y/data=!4m2!3m1!1s0x80c8c7012936e653:0xf6dbb09fd8adb088",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkCgReUALuuqBpSAS9BnI0Qp70J7WRWX4OAPw14CQU9sRNogVHIpYOEi-kmwUQW43zX4S3kiIAqN6f4UPBq3TBm4nibnKAjDzZa9fXI266Ah_vJko0H_JoXIyGUH1gE5wHdlw8G5g=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/The+Fertility+Center+of+Las+Vegas,+5365+S+Durango+Dr+%23100,+Las+Vegas,+NV+89113/@36.091586,-115.2795257,3224a,13.1y/data=!4m2!3m1!1s0x80c8c7012936e653:0xf6dbb09fd8adb088",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Nevada (NV) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-501",
    "externalIds": {
      "cdcClinicId": "501",
      "googlePlaceId": "ChIJtztbrCvOyIARShxnxVMYPb8"
    },
    "type": "fertility-clinic",
    "name": "Green Valley Fertility Partners",
    "phone": "(702) 722-2229",
    "address": {
      "line1": "2950 W Horizon Ridge Pkwy",
      "city": "Henderson",
      "state": "NV",
      "zip": "89052",
      "country": "US"
    },
    "location": {
      "lat": 36.0349,
      "lng": -115.098
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art",
        "_source": {
          "url": "https://greenvalleyfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://greenvalleyfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Frozen embryo transfer",
        "category": "art",
        "_source": {
          "url": "https://greenvalleyfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Genetic testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://greenvalleyfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg freezing",
        "category": "preservation",
        "_source": {
          "url": "https://greenvalleyfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "LGBTQ+ family building",
        "category": "art",
        "_source": {
          "url": "https://greenvalleyfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 26.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 44.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 224,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27501%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://greenvalleyfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27501%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://greenvalleyfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://greenvalleyfertility.com/about/meet-dr-fisch/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://greenvalleyfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Green+Valley+Fertility+Partners,+2950+W+Horizon+Ridge+Pkwy,+Henderson,+NV+89052/@35.999951,-115.1160328,3228a,13.1y/data=!4m2!3m1!1s0x80c8ce2bac5b3bb7:0xbf3d1853c5671c4a",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://greenvalleyfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-501-jeffrey-d-fisch-md",
        "name": "Jeffrey D. Fisch, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://greenvalleyfertility.com/wp-content/uploads/2023/01/fisch-jeff-2.jpg",
        "_source": {
          "url": "https://greenvalleyfertility.com/about/meet-dr-fisch/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://greenvalleyfertility.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "description": "Green Valley Fertility Partners is a Henderson fertility clinic offering Concierge-IVF and advanced fertility services under Jeffrey D. Fisch, MD.",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlhkMnHk_sKwTyha0KpuaPDoJi2IT4fIwezsiV8vSNX0JRUrTG4KqY-n9eKGsXpQNW0ifhYQWbL4H0pmaQMl395117VT0t2BRT5PSEVRIrdub0SSMaNyUvC2g5_KR9acGT0b4K6=w408-h305-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Green+Valley+Fertility+Partners,+2950+W+Horizon+Ridge+Pkwy,+Henderson,+NV+89052/@35.999951,-115.1160328,3228a,13.1y/data=!4m2!3m1!1s0x80c8ce2bac5b3bb7:0xbf3d1853c5671c4a",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmbZvNE6golCsMPnULXcXsiao0oN2aRbkmzE8zecUjye54u8E_bfqDIeo1faFSYgb19w_ex9-zVNWyofp8NRGnHND0RC-CmEIgvHGi1IF2OgndgKpgUnAI2kv9h9BYElijqC9Ct2A=w224-h398-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Green+Valley+Fertility+Partners,+2950+W+Horizon+Ridge+Pkwy,+Henderson,+NV+89052/@35.999951,-115.1160328,3228a,13.1y/data=!4m2!3m1!1s0x80c8ce2bac5b3bb7:0xbf3d1853c5671c4a",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Nevada (NV) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-713",
    "externalIds": {
      "cdcClinicId": "713",
      "googlePlaceId": "ChIJz6usUwHHyIARpzdLXaf-Z3U"
    },
    "type": "fertility-clinic",
    "name": "Nevada Fertility Center",
    "phone": "(702) 892-9696",
    "address": {
      "line1": "5320 S Rainbow Blvd, Suite 300",
      "city": "Las Vegas",
      "state": "NV",
      "zip": "89118",
      "country": "US"
    },
    "location": {
      "lat": 36.0918,
      "lng": -115.242
    },
    "treatments": [
      {
        "name": "IVF & Conception",
        "category": "art",
        "_source": {
          "url": "https://www.nvfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.nvfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "LGBTQ+ family-building",
        "category": "art",
        "_source": {
          "url": "https://www.nvfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg donation and surrogacy",
        "category": "art",
        "_source": {
          "url": "https://www.nvfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "International patient coordination",
        "category": "art",
        "_source": {
          "url": "https://www.nvfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 66.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 60.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 47.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 222,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27713%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.nvfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27713%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.nvfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.nvfertility.com/meet-the-team",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://www.nvfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Nevada+Fertility+Center,+5320+S+Rainbow+Blvd+%23300,+Las+Vegas,+NV+89118/@36.0917826,-115.2421456,3224a,13.1y/data=!4m2!3m1!1s0x80c8c70153acabcf:0x7567fea75d4b37a7",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.nvfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-713-gary-levy-md",
        "name": "Gary Levy, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/1384x1730/bc5c1a17c3/levy-v2.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://www.nvfertility.com/meet-the-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-713-khurram-rehman-md",
        "name": "Khurram Rehman, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/1384x1730/9d4c13cd51/rehman-v2.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://www.nvfertility.com/meet-the-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-713-russell-foulk-md",
        "name": "Russell Foulk, MD",
        "role": "Founding Physician",
        "credentials": ["MD", "FACOG", "HCLD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/1384x1730/bcc87fa55a/foulk-v2.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://www.nvfertility.com/meet-the-team",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.nvfertility.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "description": "Nevada Fertility Center is an Ivy Fertility clinic in Las Vegas offering IVF, egg freezing, LGBTQ+ family-building, donor egg, and surrogacy services.",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkJUB7IpK1UFwhWmAfLdw1JKjWdlII_TJ6myXe3F7_QjbUydp8M7Lqb1nOcPEpKnBfdRQNRX9uB0Rmb0Zne1yhshXGkE85qw899c6n7kVULmR3w6YvTudmPVmqL4zfaJAf69uwC6g=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Nevada+Fertility+Center,+5320+S+Rainbow+Blvd+%23300,+Las+Vegas,+NV+89118/@36.0917826,-115.2421456,3224a,13.1y/data=!4m2!3m1!1s0x80c8c70153acabcf:0x7567fea75d4b37a7",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWke2MJ1hWU72CsbgKyYUEXELF29tTq7dcurTrdIoz26wZ2N8ynCDn3jwIrlbGPlY13jkWzpgcrAAOdAkAQJ7uT3JByRfs5Iz8l006xoV7ra6MVxpMQJBrlF89D8-Vf7ABBNVdg8CeXjrCbM=w224-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Nevada+Fertility+Center,+5320+S+Rainbow+Blvd+%23300,+Las+Vegas,+NV+89118/@36.0917826,-115.2421456,3224a,13.1y/data=!4m2!3m1!1s0x80c8c70153acabcf:0x7567fea75d4b37a7",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Nevada (NV) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-831",
    "externalIds": {
      "cdcClinicId": "831",
      "googlePlaceId": "ChIJa25KnPLHyIARPLlpxR9zAnc"
    },
    "type": "fertility-clinic",
    "name": "Nevada Fertility Institute",
    "phone": "(702) 936-8710",
    "address": {
      "line1": "8530 W Sunset Rd, Suite 310",
      "city": "Las Vegas",
      "state": "NV",
      "zip": "89113",
      "country": "US"
    },
    "location": {
      "lat": 36.0714,
      "lng": -115.278
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art",
        "_source": {
          "url": "https://nevadafertilityinstitute.com/blog/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://nevadafertilityinstitute.com/blog/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg donation",
        "category": "art",
        "_source": {
          "url": "https://nevadafertilityinstitute.com/blog/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Surrogacy",
        "category": "art",
        "_source": {
          "url": "https://nevadafertilityinstitute.com/blog/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Embryo banking",
        "category": "preservation",
        "_source": {
          "url": "https://nevadafertilityinstitute.com/blog/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Embryo testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://nevadafertilityinstitute.com/blog/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Semen analysis",
        "category": "diagnostic",
        "_source": {
          "url": "https://nevadafertilityinstitute.com/blog/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Sperm freezing",
        "category": "preservation",
        "_source": {
          "url": "https://nevadafertilityinstitute.com/blog/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 57.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "8/16"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "0/9"
        }
      ],
      "cyclesPerYear": 150,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27831%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://nevadafertilityinstitute.com/building-your-family-exploring-diverse-paths-to-parenthood/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27831%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://nevadafertilityinstitute.com/blog/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://nevadafertilityinstitute.com/building-your-family-exploring-diverse-paths-to-parenthood/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://nevadafertilityinstitute.com/building-your-family-exploring-diverse-paths-to-parenthood/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Nevada+Fertility+Institute,+8530+W+Sunset+Rd+Ste+310,+Las+Vegas,+NV+89113/@36.0713656,-115.2776952,3225a,13.1y/data=!4m2!3m1!1s0x80c8c7f29c4a6e6b:0x7702731fc569b93c",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://nevadafertilityinstitute.com/blog/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-831-cindy-duke-md-phd-facog",
        "name": "Cindy Duke, MD, PhD, FACOG",
        "role": "Founder and Chief Medical Officer",
        "credentials": ["MD", "PhD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://ewscripps.brightspotcdn.com/dims4/default/a191d67/2147483647/strip/true/crop/1280x720+0+0/resize/1280x720!/quality/90/?url=http%3A%2F%2Fewscripps-brightspot.s3.amazonaws.com%2F06%2F05%2Ff255de374e91acbe4dbedcba356b%2Fdr-cindy-duke.jpg",
        "_source": {
          "url": "https://nevadafertilityinstitute.com/building-your-family-exploring-diverse-paths-to-parenthood/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://nevadafertilityinstitute.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "description": "Nevada Fertility Institute is a Las Vegas fertility practice led by Cindy Duke, MD, PhD, FACOG, offering fertility testing, IVF, fertility preservation, donor, surrogacy, and related services.",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlUvxJrLhVcC3mfOKeN5f-nkyg0S5_95TrIxGztaXZ3S8z-RxpTKhCZdl76WBZYIPTcdP7j5xdlVlHH_KNTgxvItt6GxeGkTzGrG5XTL6rnO0u8ZimWvDUPTNl_-bKd8iCY6QGKLQ=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Nevada+Fertility+Institute,+8530+W+Sunset+Rd+Ste+310,+Las+Vegas,+NV+89113/@36.0713656,-115.2776952,3225a,13.1y/data=!4m2!3m1!1s0x80c8c7f29c4a6e6b:0x7702731fc569b93c",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Nevada (NV) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-379",
    "externalIds": {
      "cdcClinicId": "379",
      "googlePlaceId": "ChIJjW9GE3y4yIARfhCVEnUM5nU"
    },
    "type": "fertility-clinic",
    "name": "Red Rock Fertility Center",
    "phone": "(702) 749-4676",
    "address": {
      "line1": "9120 West Russell Road, Suite 200",
      "city": "Las Vegas",
      "state": "NV",
      "zip": "89148",
      "country": "US"
    },
    "location": {
      "lat": 36.086,
      "lng": -115.291
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art",
        "_source": {
          "url": "https://redrockfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://redrockfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Genetic screening",
        "category": "diagnostic",
        "_source": {
          "url": "https://redrockfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg donor services",
        "category": "art",
        "_source": {
          "url": "https://redrockfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Gestational carrier services",
        "category": "art",
        "_source": {
          "url": "https://redrockfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "LGBTQ family planning",
        "category": "art",
        "_source": {
          "url": "https://redrockfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Reproductive preservation",
        "category": "preservation",
        "_source": {
          "url": "https://redrockfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Second opinion",
        "category": "diagnostic",
        "_source": {
          "url": "https://redrockfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 57.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 53.84615384615385,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/13"
        }
      ],
      "cyclesPerYear": 149,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27379%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://redrockfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27379%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://redrockfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://redrockfertility.com/about-us/eva-littman-m-d/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://redrockfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://redrockfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Red+Rock+Fertility+Center,+9120+W+Russell+Rd+%23200,+Las+Vegas,+NV+89148/@36.0860543,-115.2908715,3224a,13.1y/data=!4m2!3m1!1s0x80c8b87c13466f8d:0x75e60c751295107e",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://redrockfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-379-eva-d-littman-md-facog",
        "name": "Eva D. Littman, MD, FACOG",
        "role": "Founder and Practice Director",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://redrockfertility.com/wp-content/uploads/2023/08/RRFC_1100x391_EvaLittman@2x-1-1.png",
        "_source": {
          "url": "https://redrockfertility.com/about-us/eva-littman-m-d/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://redrockfertility.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "description": "Red Rock Fertility Center is a Las Vegas fertility clinic founded and led by Eva Littman, MD, offering IVF, IUI, donor, gestational carrier, fertility preservation, and related services.",
    "schedule": {
      "mon": {
        "open": "07:30",
        "close": "17:00"
      },
      "tue": {
        "open": "07:30",
        "close": "17:00"
      },
      "wed": {
        "open": "07:30",
        "close": "17:00"
      },
      "thu": {
        "open": "07:30",
        "close": "17:00"
      },
      "fri": {
        "open": "07:30",
        "close": "12:00"
      },
      "sat": null,
      "sun": null
    },
    "images": [
      {
        "url": "https://redrockfertility.com/wp-content/uploads/2023/08/rrf_lobby-1.jpg",
        "type": "interior",
        "caption": "Red Rock Fertility lobby",
        "_source": {
          "url": "https://redrockfertility.com/about-us/our-clinic/",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Nevada (NV) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-304",
    "externalIds": {
      "cdcClinicId": "304",
      "googlePlaceId": "ChIJt5LJ13JAmYARpC7xeoly4uk"
    },
    "type": "fertility-clinic",
    "name": "Nevada Center for Reproductive Medicine",
    "phone": "(775) 828-1200",
    "address": {
      "line1": "645 Sierra Rose Drive, Suite 205",
      "city": "Reno",
      "state": "NV",
      "zip": "89511",
      "country": "US"
    },
    "location": {
      "lat": 39.4746,
      "lng": -119.798
    },
    "treatments": [
      {
        "name": "IVF & Conception",
        "category": "art",
        "_source": {
          "url": "https://nevadafertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg freezing",
        "category": "preservation",
        "_source": {
          "url": "https://nevadafertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "LGBTQ+ family-building",
        "category": "art",
        "_source": {
          "url": "https://nevadafertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg donation and surrogacy",
        "category": "art",
        "_source": {
          "url": "https://nevadafertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility diagnostics",
        "category": "diagnostic",
        "_source": {
          "url": "https://nevadafertility.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 62.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 64,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 52.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 54.54545454545454,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/11"
        }
      ],
      "cyclesPerYear": 291,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27304%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://nevadafertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27304%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://nevadafertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://nevadafertility.com/meet-the-team",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://nevadafertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Nevada+Center+for+Reproductive+Medicine,+645+Sierra+Rose+Dr+%23205,+Reno,+NV+89511/@39.4746368,-119.7976984,3080a,13.1y/data=!4m2!3m1!1s0x80994072d7c992b7:0xe9e272897af12ea4",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://nevadafertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-304-scott-j-whitten-md",
        "name": "Scott J. Whitten, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/1024x681/beb58f93ee/dr-scott-whitten-updated-headshot.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://nevadafertility.com/meet-the-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-304-jennifer-lassi-np",
        "name": "Jennifer Lassi, NP",
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "specialty": "Nurse Practitioner",
        "imageUrl": "https://a.storyblok.com/f/290132/1024x1536/14f3ff2a79/jennifer-lassi-np.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://nevadafertility.com/meet-the-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-304-jonna-collins-pa-c",
        "name": "Jonna Collins, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "specialty": "Physician Assistant",
        "imageUrl": "https://a.storyblok.com/f/290132/4024x6048/fb695c1b35/jonna-collins-pa-c.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://nevadafertility.com/meet-the-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-304-gnanaratnam-girtharan-phd-hcld",
        "name": "Gnanaratnam Girtharan, PhD, HCLD",
        "role": "Laboratory Director",
        "credentials": ["PhD", "HCLD"],
        "specialty": "IVF Laboratory Director",
        "imageUrl": "https://a.storyblok.com/f/290132/1024x681/1d57df95b6/gnanaratnam-girtharan-laboratory-director.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://nevadafertility.com/meet-the-team",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://nevadafertility.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "description": "Nevada Center for Reproductive Medicine is an Ivy Fertility clinic in Reno and Northern Nevada's fully accredited fertility clinic, offering IVF, egg freezing, LGBTQ+ family-building, donor egg, and surrogacy services.",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnXaVZvS4BfjaPpGgmExwJN31luln21XmzUzyKrHa3kAxs38zh826lNs10XYsxqKuESUEcuV5nRn3-F9p-G3kbOSFt963lOECh3h8rEFZpWEWvIk0HftlmiY8gKgIzkNTBqgP1nnQ=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Nevada+Center+for+Reproductive+Medicine,+645+Sierra+Rose+Dr+%23205,+Reno,+NV+89511/@39.4746368,-119.7976984,3080a,13.1y/data=!4m2!3m1!1s0x80994072d7c992b7:0xe9e272897af12ea4",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Nevada (NV) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-817",
    "externalIds": {
      "cdcClinicId": "817",
      "googlePlaceId": "ChIJbTDb9qHz2YkRUsT5CYbKzEE"
    },
    "type": "fertility-clinic",
    "name": "Boston IVF-The Syracuse Center",
    "phone": "(315) 703-3050",
    "address": {
      "line1": "5792 Widewaters Pkwy",
      "city": "Syracuse",
      "state": "NY",
      "zip": "13214",
      "country": "US"
    },
    "location": {
      "lat": 43.0494,
      "lng": -76.0591
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 46.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 47.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 124,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27817%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27817%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.bostonivf.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/physicians/jamil-mroueh",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Boston+IVF,+5792+Widewaters+Pkwy,+Syracuse,+NY+13214/@43.049423,-76.059078,2916a,13.1y/data=!4m2!3m1!1s0x89d9f3a1f6db306d:0x41ccca8609f9c452",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-817-maximillian-klein-md",
        "name": "Maximillian Klein, MD",
        "role": "Medical Director"
      },
      {
        "name": "Jamil Mroueh, MD",
        "imageUrl": "https://www.bostonivf.com/thumbs/J-Mroueh_thumb-physicians-main.png?v=c5c4d",
        "_source": {
          "url": "https://www.bostonivf.com/physicians/jamil-mroueh",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-817-jamil-mroueh-md"
      }
    ],
    "website": "https://www.bostonivf.com",
    "description": "Learn what to expect at Boston IVF visits, understand insurance coverage, and more.",
    "languages": ["English"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmXqlqYgHt-q7gtQyxfSAOq_LIoM94wUCaCfKHcT83nlL2njSpkL21YA378W9JIezR7IP85DrU7_CMQ2NhyjcWXMlTxJRyKaac4WS4F_LH360girxfMVQ8wtPm75OkeOG_TXHWXOw=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Boston+IVF,+5792+Widewaters+Pkwy,+Syracuse,+NY+13214/@43.049423,-76.059078,2916a,13.1y/data=!4m2!3m1!1s0x89d9f3a1f6db306d:0x41ccca8609f9c452",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlA04fBLiCR74YA77mNgRAlPXndBjzhoKpm_nI1NrGi8guU_kcsXl-Fxcn_gRsWPucHobA7_Ql7zpGcVxh6Dv2z1HLNJ3zT08oEbvGC1sx4VZIGkHbY-e1rZm2mjNU1umBQR7w=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Boston+IVF,+5792+Widewaters+Pkwy,+Syracuse,+NY+13214/@43.049423,-76.059078,2916a,13.1y/data=!4m2!3m1!1s0x89d9f3a1f6db306d:0x41ccca8609f9c452",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "network": {
      "name": "Boston IVF"
    },
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield of Massachusetts",
        "Blue Cross Blue Shield of Rhode Island",
        "Blue Cross Blue Shield PPO (out-of-state)",
        "Carelink",
        "Carrot",
        "CDPHP",
        "Cigna",
        "Cofertility/EggCo",
        "Emblem Health",
        "Excellus Blue Cross Blue Shield",
        "Empire Blue Cross Blue Shield",
        "GHI",
        "GIC Indemnity",
        "Harvard Pilgrim",
        "Health New England",
        "Highmark Blue Shield of Northeastern NY",
        "Highmark Blue Cross Federal",
        "Maine Community Health Options",
        "Mass General Brigham Health Plan",
        "Maven",
        "NYS Empire Plan",
        "PHCS",
        "Progyny",
        "Stork Club",
        "Tricare",
        "Tufts Health Direct",
        "Unicare",
        "United Healthcare",
        "WellSense Health Plan",
        "WIN Fertility/Premier"
      ],
      "_source": {
        "url": "https://www.bostonivf.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield of Massachusetts, Blue Cross Blue Shield of Rhode Island, Blue Cross Blue Shield PPO (out-of-state), Carelink, Carrot, CDPHP, Cigna",
              "detail": "23 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.bostonivf.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-507",
    "externalIds": {
      "cdcClinicId": "507",
      "googlePlaceId": "ChIJGzEoKtcL3okR-7Gchy3v7dM"
    },
    "type": "fertility-clinic",
    "name": "Boston IVF, The Albany Center",
    "phone": "(518) 434-9759",
    "address": {
      "line1": "399 Albany Shaker Rd",
      "city": "Loudonville",
      "state": "NY",
      "zip": "12211",
      "country": "US"
    },
    "location": {
      "lat": 42.6974,
      "lng": -73.7675
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 39.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 36.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 36.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 37.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/16"
        }
      ],
      "cyclesPerYear": 442,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27507%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27507%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.bostonivf.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/physicians/alan-penzias",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Boston+IVF,+399+Albany+Shaker+Rd,+Albany,+NY+12211/@42.6974584,-73.7676732,2932a,13.1y/data=!4m2!3m1!1s0x89de0bd72a28311b:0xd3edef2d879cb1fb",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-507-alan-penzias-md",
        "name": "Alan Penzias, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.bostonivf.com/thumbs/A-Penzias_thumb-physicians-main.png?v=14a55",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.bostonivf.com/physicians/alan-penzias",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.bostonivf.com",
    "description": "Learn what to expect at Boston IVF visits, understand insurance coverage, and more.",
    "languages": ["English"],
    "images": [],
    "network": {
      "name": "Boston IVF"
    },
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield of Massachusetts",
        "Blue Cross Blue Shield of Rhode Island",
        "Blue Cross Blue Shield PPO (out-of-state)",
        "Carelink",
        "Carrot",
        "CDPHP",
        "Cigna",
        "Cofertility/EggCo",
        "Emblem Health",
        "Excellus Blue Cross Blue Shield",
        "Empire Blue Cross Blue Shield",
        "GHI",
        "GIC Indemnity",
        "Harvard Pilgrim",
        "Health New England",
        "Highmark Blue Shield of Northeastern NY",
        "Highmark Blue Cross Federal",
        "Maine Community Health Options",
        "Mass General Brigham Health Plan",
        "Maven",
        "NYS Empire Plan",
        "PHCS",
        "Progyny",
        "Stork Club",
        "Tricare",
        "Tufts Health Direct",
        "Unicare",
        "United Healthcare",
        "WellSense Health Plan",
        "WIN Fertility/Premier"
      ],
      "_source": {
        "url": "https://www.bostonivf.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield of Massachusetts, Blue Cross Blue Shield of Rhode Island, Blue Cross Blue Shield PPO (out-of-state), Carelink, Carrot, CDPHP, Cigna",
              "detail": "23 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.bostonivf.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-708",
    "externalIds": {
      "cdcClinicId": "708",
      "googlePlaceId": "ChIJtdCme_hYwokRAXsFtIIqnaw"
    },
    "type": "fertility-clinic",
    "name": "CCRM New York",
    "phone": "(212) 290-8100",
    "address": {
      "line1": "810 Seventh Ave, 21st Floor",
      "city": "New York",
      "state": "NY",
      "zip": "10019",
      "country": "US"
    },
    "location": {
      "lat": 40.7628,
      "lng": -73.9823
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 58.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 54.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 65.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 46.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 779,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27708%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27708%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/jaime-knopman/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+New+York,+810+7th+Ave+21st+Floor,+New+York,+NY+10019/@40.7628107,-73.9823263,3022a,13.1y/data=!4m2!3m1!1s0x89c258f87ba6d0b5:0xac9d2a82b4057b01",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-708-jaime-knopman-md",
        "name": "Jaime Knopman, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/08/Jaime-Knopman.png",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/jaime-knopman/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.ccrmivf.com",
    "languages": [
      "English",
      "Spanish",
      "Chinese",
      "Arabic",
      "Russian",
      "French",
      "Portuguese",
      "Italian",
      "German"
    ],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlZm8uRTR7WCZnp5h_63j3ZPTivMjW9JqmWNeQZ05ZVXTSaYPYesd4ri4ijPvca_gnsIbzn5zOs-HXKKBj_PvCocCmDCanqk2boYjQKkBsmX1iDu-MROd2G1REnRjb9SDWkBt8z=w449-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+New+York,+810+7th+Ave+21st+Floor,+New+York,+NY+10019/@40.7628107,-73.9823263,3022a,13.1y/data=!4m2!3m1!1s0x89c258f87ba6d0b5:0xac9d2a82b4057b01",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmk20G01RvT9RlD1r8l5FDQcj33-_Bd5-rfYkAxAVtniJskH9xZCxrsMKMRRA2BuDq5eARgzlWYcBQu_jU-ZOSaIySiqjhaHhcPKv9jVp3NwhTd1g1D1IAOFhkLZJM5SZWdsFN0=w449-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+New+York,+810+7th+Ave+21st+Floor,+New+York,+NY+10019/@40.7628107,-73.9823263,3022a,13.1y/data=!4m2!3m1!1s0x89c258f87ba6d0b5:0xac9d2a82b4057b01",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl6PJqZ1QEf7_n-TGJu0pUDrmKOXz9Z7sWXM_wGpTD6XUHTYiWi4nja71tOrwQ1o-UrtXdW8JN0nUD8bUeXflhrRghmhXeb_EpSFo4XkSMXVUujOZJxvzVH-MO9TYSLEXsjntu8JqdyaZ_x=w224-h398-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+New+York,+810+7th+Ave+21st+Floor,+New+York,+NY+10019/@40.7628107,-73.9823263,3022a,13.1y/data=!4m2!3m1!1s0x89c258f87ba6d0b5:0xac9d2a82b4057b01",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl6PJqZ1QEf7_n-TGJu0pUDrmKOXz9Z7sWXM_wGpTD6XUHTYi4nja71tOrwQ1o-UrtXdW8JN0nUD8bUeXflhrRghmhXeb_EpSFo4XkSMXVUujOZJxvzVH-MO9TYSLEXsjntu8JqdyaZ_x=w224-h398-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+New+York,+810+7th+Ave+21st+Floor,+New+York,+NY+10019/@40.7628107,-73.9823263,3022a,13.1y/data=!4m2!3m1!1s0x89c258f87ba6d0b5:0xac9d2a82b4057b01",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-441",
    "externalIds": {
      "cdcClinicId": "441",
      "googlePlaceId": "ChIJoRdVYuxYwokRe2F_DRk_yRE"
    },
    "type": "fertility-clinic",
    "name": "Center for Human Reproduction (CHR)",
    "phone": "(212) 994-4400",
    "address": {
      "line1": "21 E. 69th St",
      "city": "New York",
      "state": "NY",
      "zip": "10021",
      "country": "US"
    },
    "location": {
      "lat": 40.7698,
      "lng": -73.9663
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 33.33333333333333,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/15"
        },
        {
          "ageBand": "38-40",
          "rate": 9.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 2.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 356,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27441%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27441%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://centerforhumanreprod.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Center+for+Human+Reproduction,+21+E+69th+St,+New+York,+NY+10021/@40.7698181,-73.9663572,3022a,13.1y/data=!4m2!3m1!1s0x89c258ec625517a1:0x11c93f190d7f617b",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.centerforhumanreprod.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-441-norbert-gleicher-md",
        "name": "Norbert Gleicher, MD",
        "role": "Medical Director",
        "imageUrl": "https://assets.centerforhumanreprod.com/Images/Sites/C/CenterForHumanReproduction/Practitioner/1420451.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://centerforhumanreprod.com/dr-norbert-gleicher",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.centerforhumanreprod.com",
    "languages": [
      "English",
      "Spanish",
      "Chinese",
      "Arabic",
      "French",
      "Hebrew"
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "boutique",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlUb5y8_66hbIFdpFsV8uNWpFcnPz4mhgirP1McFnUOfyfE8SHvwJ-4igDUDqBZcW-nSqSvqDMek3Fw0dWjbKwkmRw46bQ0-wLr5W9gCO33WLeIkHp3Oa5Ces852Dbk2TL3POUtGT3mCX_q=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Center+for+Human+Reproduction,+21+E+69th+St,+New+York,+NY+10021/@40.7698181,-73.9663572,3022a,13.1y/data=!4m2!3m1!1s0x89c258ec625517a1:0x11c93f190d7f617b",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-607",
    "externalIds": {
      "cdcClinicId": "607",
      "googlePlaceId": "ChIJI-1qxQZZwokRdfEkBnFinFQ"
    },
    "type": "fertility-clinic",
    "name": "Chelsea Fertility NYC",
    "phone": "(212) 685-2229",
    "address": {
      "line1": "105 E. 37th St, Suite 1",
      "city": "New York",
      "state": "NY",
      "zip": "10016",
      "country": "US"
    },
    "location": {
      "lat": 40.7489,
      "lng": -73.9793
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/12"
        }
      ],
      "cyclesPerYear": 72,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27607%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27607%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.chelseafertilitynyc.com/our-center/paul-gindoff-fertility-doctor",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Chelsea+Fertility+NYC,+105+E+37th+St+Ste+1,+New+York,+NY+10016/@40.748924,-73.979251,3023a,13.1y/data=!4m2!3m1!1s0x89c25906c56aed23:0x549c62710624f175",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.chelseafertilitynyc.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-607-paul-gindoff-md",
        "name": "Paul Gindoff, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.chelseafertilitynyc.com/content/1-our-center/1-paul-gindoff-fertility-doctor/cfnyc-paul-gindoff-fertility-doctor.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.chelseafertilitynyc.com/our-center/paul-gindoff-fertility-doctor",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.chelseafertilitynyc.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmgcllixBybEcKQgjw9oC15pFIxfQFxbple3MVKVxDh6Oazk2nw8QTj11Qa9hBkXATps_nNHYOEBksO4doy11eDgEOVVybZIcW5ZLL7EOSlkTU4y4htbxYeC82G_bQsodd6TJav8mey0Crn=w408-h653-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Chelsea+Fertility+NYC,+105+E+37th+St+Ste+1,+New+York,+NY+10016/@40.748924,-73.979251,3023a,13.1y/data=!4m2!3m1!1s0x89c25906c56aed23:0x549c62710624f175",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-377",
    "externalIds": {
      "cdcClinicId": "377",
      "googlePlaceId": "ChIJpXHuXYv02YkRzDe1ASfnXNc"
    },
    "type": "fertility-clinic",
    "name": "CNY Fertility Center",
    "description": "Known for making fertility treatment affordable with IVF cycles starting at $4,275 and in-house payment plans.",
    "website": "https://www.cnyfertility.com",
    "phone": "(315) 469-8700",
    "email": "hello@cnyfertility.com",
    "bookingUrl": "https://schedule.cnyfertility.com/",
    "address": {
      "line1": "195 Intrepid Ln",
      "city": "Syracuse",
      "state": "NY",
      "zip": "13205",
      "country": "US"
    },
    "location": {
      "lat": 43.0023,
      "lng": -76.1264
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Tubal / vasectomy reversal",
        "category": "surgical"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "financingOptions": [
        "Payment plans",
        "Discount pricing",
        "Package pricing",
        "Future Family",
        "CapexMD"
      ]
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 28.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 20.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 15.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 6.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 5750,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27377%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "consultationTypes": ["in-person", "telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27377%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "scraped"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.cnyfertility.com/locations/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CNY+Fertility+Syracuse,+195+Intrepid+Ln,+Syracuse,+NY+13205/@43.0022974,-76.1264296,2918a,13.1y/data=!4m2!3m1!1s0x89d9f48b5dee71a5:0xd75ce72701b537cc",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.cnyfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-377-robert-j-kiltz-md",
        "name": "Robert J. Kiltz, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.cnyfertility.com/wp-content/uploads/2018/05/doctorkiltz-1.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.cnyfertility.com/our-team-members/dr-robert-kiltz/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "languages": ["English", "Italian"],
    "images": [
      {
        "url": "https://www.cnyfertility.com/wp-content/uploads/2019/10/Syracuse-general-1.png",
        "type": "exterior",
        "caption": "CNY Fertility Syracuse location",
        "_source": {
          "url": "https://www.cnyfertility.com/locations/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlxA3kwceG6WeMqgFfTl-9fsRLv6pxt2buHVRgZhvz6ffCKHCweYDscW6kYHeBDZBtbHJ3bU7hUqvkY2nDq9UqABG8CY314sbSDv-IEvau12UBoyNYyy72Xz4186AHhluQs5cK0Rc8EV0k=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CNY+Fertility+Syracuse,+195+Intrepid+Ln,+Syracuse,+NY+13205/@43.0022974,-76.1264296,2918a,13.1y/data=!4m2!3m1!1s0x89d9f48b5dee71a5:0xd75ce72701b537cc",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "network": {
      "name": "CNY Fertility"
    },
    "pricing": {
      "packages": [
        {
          "name": "Virtual Consultation",
          "price": 5000,
          "currency": "USD"
        },
        {
          "name": "IUI",
          "description": "Intrauterine insemination",
          "price": 65000,
          "currency": "USD",
          "notes": "Excludes medications"
        },
        {
          "name": "IVF",
          "description": "In vitro fertilization — clinic fee only",
          "price": 390000,
          "currency": "USD",
          "notes": "Clinic fee only; excludes medications, monitoring, and add-ons"
        },
        {
          "name": "IVF Full Cycle",
          "description": "Complete IVF cycle with core add-ons included",
          "price": 729500,
          "priceMax": 1200000,
          "currency": "USD",
          "includes": [
            "Retrieval",
            "ICSI",
            "Assisted hatching",
            "Cryopreservation"
          ],
          "excludes": ["Medications ($1,500 - $6,000)"],
          "notes": "Range depends on medications and protocol add-ons"
        },
        {
          "name": "Egg Freezing",
          "description": "Oocyte cryopreservation procedure",
          "price": 299900,
          "priceMax": 449000,
          "currency": "USD",
          "notes": "Procedure fee; approximately 1/3 national average ($11,500)"
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 99500,
          "priceMax": 194000,
          "currency": "USD",
          "includes": ["Monitoring (at higher end)"]
        },
        {
          "name": "Donor Egg IVF",
          "description": "In-house donor egg package",
          "price": 1129500,
          "currency": "USD",
          "includes": ["4 fresh donor eggs"]
        }
      ],
      "financingOptions": [
        {
          "name": "In-house payment plans (~100% approval rate)",
          "description": "In-house payment plans (~100% approval rate)"
        },
        {
          "name": "Fertile Guarantee shared-risk program (up to 75% refund if no live birth after 6 cycles)",
          "description": "Fertile Guarantee shared-risk program (up to 75% refund if no live birth after 6 cycles)"
        }
      ],
      "disclaimer": "Medications are additional ($1,500 - $6,000 depending on protocol). Most patients need approximately 2 IVF cycles for a live birth. Storage costs approximately $650/year.",
      "_source": {
        "url": "https://www.cnyfertility.com/costs/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "7 public price package(s) and 2 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.cnyfertility.com/costs/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-75",
    "externalIds": {
      "cdcClinicId": "75",
      "googlePlaceId": "ChIJB2wGjEBZwokRms7YWD0iJ1g"
    },
    "type": "fertility-clinic",
    "name": "Columbia University Fertility Center",
    "description": "Ranked #1 by Newsweek, offering the personalized care of a boutique practice with the innovations of a leading academic center and over four decades of experience.",
    "website": "https://www.columbiadoctors.org/specialties/obstetrics-gynecology/our-services/columbia-university-fertility-center",
    "phone": "(646) 756-8282",
    "bookingUrl": "https://www.columbiadoctors.org/specialties/obstetrics-gynecology/our-services/columbia-university-fertility-center/patients/make-appointment",
    "address": {
      "line1": "5 Columbus Cir, PH Floor",
      "city": "New York",
      "state": "NY",
      "zip": "10019",
      "country": "US"
    },
    "location": {
      "lat": 40.7668,
      "lng": -73.9815
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "financingOptions": ["Payment plans", "Future Family"],
      "carriers": ["UnitedHealthcare"],
      "_source": {
        "url": "https://www.columbiadoctors.org/specialties/obstetrics-gynecology/our-services/columbia-university-fertility-center",
        "fetchedAt": "2026-03-11"
      }
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 53.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 48.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 28.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1571,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2775%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "languages": ["English", "es"],
    "consultationTypes": ["in-person", "telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents"],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2775%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "scraped"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.columbiadoctors.org/specialties/obstetrics-gynecology/our-services/columbia-university-fertility-center",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Columbia+University+Fertility+Center,+5+Columbus+Cir+Suite+PH+Suite+PH,+New+York,+NY+10019/@40.766668,-73.9814608,3022a,13.1y/data=!4m2!3m1!1s0x89c259408c066c07:0x5827223d58d8ce9a",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.columbiadoctors.org/specialties/obstetrics-gynecology/our-services/columbia-university-fertility-center",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-75-eric-j-forman-md",
        "name": "Eric J. Forman, MD",
        "role": "Medical Director",
        "imageUrl": "https://a.mktgcdn.com/p/mhStDgTPmMtUPFCjv-OeHoSwKTYeo1XvYX840fJHCJE/800x800.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://doctors.columbia.edu/us/ny/new-york/eric-forman-md-hcld-5-columbus-cir",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "setting": "hospital-based",
    "images": [
      {
        "url": "https://www.columbiadoctors.org/sites/default/files/styles/cola_media_1600_3_1/public/media/images/2026-04/fertility-center-2026.jpeg?itok=JBdIz4kb",
        "type": "interior",
        "caption": "Columbia University Fertility Center",
        "_source": {
          "url": "https://www.columbiadoctors.org/specialties/obstetrics-gynecology/our-services/columbia-university-fertility-center",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlxtPfrCJtizOpcWSsHm_xuW-WAdsXFDiCLbd5k3yNTycL7PhTC6thQ5WHl0n6xYnyicIUiYbn3h-C1biDEOKik3NX1DjbU6gEQQUXFClUo514ydDF9Gt3Pv0Pp6JPLNFNrj-HJ=w408-h408-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Columbia+University+Fertility+Center,+5+Columbus+Cir+Suite+PH+Suite+PH,+New+York,+NY+10019/@40.766668,-73.9814608,3022a,13.1y/data=!4m2!3m1!1s0x89c259408c066c07:0x5827223d58d8ce9a",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnxk0HVTP-majBl1wwDMlGqh3HKFYu73EoEE2amHdgyorQDHcZoyDFtCDyVkcfRNVFvfqOweKgsct_RtE7KHhsXkPOovNo-NA-u781D5SeDIKWWjGKfG0af4_TN6KVwtHth2ccP=w224-h398-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Columbia+University+Fertility+Center,+5+Columbus+Cir+Suite+PH+Suite+PH,+New+York,+NY+10019/@40.766668,-73.9814608,3022a,13.1y/data=!4m2!3m1!1s0x89c259408c066c07:0x5827223d58d8ce9a",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "UnitedHealthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.columbiadoctors.org/specialties/obstetrics-gynecology/our-services/columbia-university-fertility-center",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-805",
    "externalIds": {
      "cdcClinicId": "805",
      "googlePlaceId": "ChIJOQHumvdYwokRRz1h9useJFk"
    },
    "type": "fertility-clinic",
    "name": "Extend Fertility",
    "phone": "(212) 810-2828",
    "address": {
      "line1": "200 W. 57th St, Suite 1101",
      "city": "New York",
      "state": "NY",
      "zip": "10019",
      "country": "US"
    },
    "location": {
      "lat": 40.7654,
      "lng": -73.9806
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 46.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 52.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 39.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/10"
        }
      ],
      "cyclesPerYear": 340,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27805%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27805%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://extendfertility.com/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://extendfertility.com/about-extend-fertility/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Extend+Fertility,+200+W+57th+St+%231101,+New+York,+NY+10019/@40.7653794,-73.9806833,3022a,13.1y/data=!4m2!3m1!1s0x89c258f79aee0139:0x59241eebf6613d47",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://extendfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-805-joshua-u-klein-md",
        "name": "Joshua U. Klein, MD",
        "role": "Medical Director",
        "imageUrl": "https://extendfertility.com/wp-content/uploads/2019/08/2022-09-21_Extend_Fertility_Dr_Joshua_Klein-85-scaled.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://extendfertility.com/about-extend-fertility/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://extendfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Cigna",
        "GHI",
        "Progyny",
        "WinFertility",
        "Maven",
        "Carrot"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://extendfertility.com/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["French", "German", "Thai", "English"],
    "images": [
      {
        "url": "https://extendfertility.com/wp-content/uploads/2019/09/2019-09-18_Extend_Fertility_Office-358.jpg",
        "type": "interior",
        "caption": "Extend Fertility office",
        "_source": {
          "url": "https://extendfertility.com/about-extend-fertility/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://extendfertility.com/wp-content/uploads/2019/08/lab-main_image-e1565277804200.jpg",
        "type": "interior",
        "caption": "Extend Fertility lab",
        "_source": {
          "url": "https://extendfertility.com/about-extend-fertility/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlOi988LsYpGelGrETd2US-NDeis-GSUk80YUGSSZCgLkwe8xaXXTyM7eIGa4EFy_734SvMU14K0M7ArjXbMELcRyQ5BUqRtItyzRDWF3cxxEtXIZ40rzdkrOaNE_gvRW5FYu1-=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Extend+Fertility,+200+W+57th+St+%231101,+New+York,+NY+10019/@40.7653794,-73.9806833,3022a,13.1y/data=!4m2!3m1!1s0x89c258f79aee0139:0x59241eebf6613d47",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmmLkN20aPH5BV0R5I1mBFa1GaCsAGbRWk1yIPEnF7BSWy2jkl9ySv5b41jzUbyBiCUG32e6ilOJrIn7EXxwBUpY9dASySdMofd6ff5dMbPwdXmYpIvW18ZBYwTGrIkO6WwTBD4=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Extend+Fertility,+200+W+57th+St+%231101,+New+York,+NY+10019/@40.7653794,-73.9806833,3022a,13.1y/data=!4m2!3m1!1s0x89c258f79aee0139:0x59241eebf6613d47",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlEg0zLQnQmnmIuqmJm9zh0LcWALgkkE_7s_ZRdTM31V2VvTUVATQXADfwkvYXCFcKhzVW-tAWFuADDPaxOVaAlDaI1htGkDWjmPsYGvTGeyArGxIAFaceAiA1C9I7scqf0CfV-_Q=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Extend+Fertility,+200+W+57th+St+%231101,+New+York,+NY+10019/@40.7653794,-73.9806833,3022a,13.1y/data=!4m2!3m1!1s0x89c258f79aee0139:0x59241eebf6613d47",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Cigna, GHI, Progyny, WinFertility, Maven, Carrot",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://extendfertility.com/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-836",
    "externalIds": {
      "cdcClinicId": "836"
    },
    "type": "fertility-clinic",
    "name": "Fertility New York",
    "phone": "(212) 535-5350",
    "address": {
      "line1": "240 Central Park South, Suite 1P",
      "city": "New York",
      "state": "NY",
      "zip": "10019",
      "country": "US"
    },
    "location": {
      "lat": 40.7671,
      "lng": -73.9811
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 25,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27836%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27836%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilityny.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-836-amir-r-radjabi-md",
        "name": "Amir R. Radjabi, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.fertilityny.com",
    "description": "Castle Connolly has recognized six of our New York City fertility specialists as 2026 Top Doctors\\",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "boutique",
    "images": [
      {
        "url": "https://ferny.com/wp-content/uploads/2026/05/Ferny-NYC-Contact-Us-Ferny-Central-Park.jpg",
        "type": "exterior",
        "caption": "Ferny Central Park location",
        "_source": {
          "url": "https://ferny.com/locations/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-802",
    "externalIds": {
      "cdcClinicId": "802",
      "googlePlaceId": "ChIJ4z_6POVYwokRlOcDBMasum8"
    },
    "type": "fertility-clinic",
    "name": "Generation Next Fertility, PLLC",
    "phone": "(212) 641-0906",
    "address": {
      "line1": "115 E. 57th St, 11th Floor",
      "city": "New York",
      "state": "NY",
      "zip": "10022",
      "country": "US"
    },
    "location": {
      "lat": 40.7615,
      "lng": -73.9699
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 37.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 27.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 38.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 8.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 744,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27802%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27802%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.generationnextfertility.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Generation+Next,+115+E+57th+St+FLR+11,+New+York,+NY+10022/@40.7614978,-73.9698881,3022a,13.1y/data=!4m2!3m1!1s0x89c258e53cfa3fe3:0x6fbaacc60403e794",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.generationnextfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-802-janelle-luk-md",
        "name": "Janelle Luk, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.generationnextfertility.com/wp-content/uploads/2025/07/imgi_51_Drs-Headshots-6-1337x1536-1.png",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.generationnextfertility.com/dr-janelle-luk-2-2/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.generationnextfertility.com",
    "languages": ["English"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnKWOaQSiQInS_1Ccjn65cv7fDcJ-uuJZP43es9hksdGJ_ExovL6bFkjEFG7pdlA5OaGAcFOHXp65l5aEy-o-6dyU3Mh00agDw9-g3-Br9nYcg6FlSjKEfewephdbE-EI3YS5A=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Generation+Next,+115+E+57th+St+FLR+11,+New+York,+NY+10022/@40.7614978,-73.9698881,3022a,13.1y/data=!4m2!3m1!1s0x89c258e53cfa3fe3:0x6fbaacc60403e794",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmu8mwlO6zMHR8vEIrPiVyP4HfNdm4TvjIxOK36Mim-oO7-mf1_0ZSAS7vLjHmWdSfkltAfj8ZO4FycIukyZ01s8oziVqpxwwht3t9rEsxJJReILyBr3nxa-jpdarjlFq-n9-s=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Generation+Next,+115+E+57th+St+FLR+11,+New+York,+NY+10022/@40.7614978,-73.9698881,3022a,13.1y/data=!4m2!3m1!1s0x89c258e53cfa3fe3:0x6fbaacc60403e794",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWly4sO2u1XxzdTfX1P0xHesiOVO656bxxtnJBIQeLTDnYe9xgH2gOkodhoxeeUWspmSblsHpyIM_Pxt-iMztZxTKK_RR0mKO5EGDDUPHV2wHte3XLflv24Ladsa89cs3U0qMfQX=w224-h398-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Generation+Next,+115+E+57th+St+FLR+11,+New+York,+NY+10022/@40.7614978,-73.9698881,3022a,13.1y/data=!4m2!3m1!1s0x89c258e53cfa3fe3:0x6fbaacc60403e794",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-81",
    "externalIds": {
      "cdcClinicId": "81",
      "googlePlaceId": "ChIJ08FeJN5EwokRB1tLh0xMTdM"
    },
    "type": "fertility-clinic",
    "name": "Genesis Fertility & Reproductive Medicine",
    "phone": "(718) 436-3747",
    "address": {
      "line1": "6010 Bay Pkwy",
      "city": "Brooklyn",
      "state": "NY",
      "zip": "11204",
      "country": "US"
    },
    "location": {
      "lat": 40.6166,
      "lng": -73.979
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 37.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 31.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 32.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 9.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 618,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2781%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2781%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.genesisfertility.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/GENESIS+Fertility+%26+Reproductive+Medicine,+6010+Bay+Pkwy+ste+501,+Brooklyn,+NY+11204/@40.6165841,-73.9790554,3029a,13.1y/data=!4m2!3m1!1s0x89c244de245ec1d3:0xd34d4c4c874b5b07",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.genesisfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-81-richard-v-grazi-md",
        "name": "Richard V. Grazi, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.genesisfertility.com/wp-content/uploads/2016/06/video-dr-grazi.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.genesisfertility.com/video/dr-richard-grazi/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.genesisfertility.com",
    "languages": [
      "Spanish",
      "Chinese",
      "Russian",
      "Hebrew",
      "Polish",
      "English"
    ],
    "images": [],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-819",
    "externalIds": {
      "cdcClinicId": "819",
      "googlePlaceId": "ChIJ4z_6POVYwokRjApdrq6XwY4"
    },
    "type": "fertility-clinic",
    "name": "Global Fertility & Genetics, NY",
    "phone": "(646) 739-4956",
    "address": {
      "line1": "115 E. 57th St, Suite 420-430",
      "city": "New York",
      "state": "NY",
      "zip": "10022",
      "country": "US"
    },
    "location": {
      "lat": 40.7615,
      "lng": -73.9699
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 48.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 35.714285714285715,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/14"
        }
      ],
      "cyclesPerYear": 119,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27819%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "minimal",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://globalivfny.com/about-us/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Global+Fertility+%26+Genetics,+115+E+57th+St+Ste+420+%26+430,+New+York,+NY+10022/@40.7615203,-73.9698802,3022a,13.1y/data=!4m2!3m1!1s0x89c258e53cfa3fe3:0x8ec197aeae5d0a8c",
            "fetchedAt": "2026-08-16"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27819%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-819-melvin-thornton-md",
        "name": "Melvin Thornton, MD",
        "role": "Medical Director",
        "imageUrl": "https://globalivfny.com/wp-content/uploads/2025/02/GlobalIVF-Staff_0013_Dr.-Melvin-Thornton-Medical-Director.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://globalivfny.com/meet-dr-melvin-thornton/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.globalfertility.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "boutique",
    "images": [
      {
        "url": "https://globalivfny.com/wp-content/themes/yootheme/cache/54/115-east-57th-street-new-york-QhqOI6LZI9pIK91QTxJHvfZLwlXO399Wbku3qa3gVYVsxOKoQyCwWUfvU-54b8d54f.jpeg",
        "type": "exterior",
        "caption": "Global Fertility & Genetics 115 E 57th Street location",
        "_source": {
          "url": "https://globalivfny.com/about-us/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnuIf_btDl1SnR5Hqa2cJgrxxLbqVO-toXhFGcgh6JIjHwzVSvlQ3xDybZD74e6oCi3sySvCu9o3QVuMb-FS5u8mMPRlsESpg_lWh3zkdV05XjC-ULK5gDBJSmivNQsd3BwulbF=w224-h398-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Global+Fertility+%26+Genetics,+115+E+57th+St+Ste+420+%26+430,+New+York,+NY+10022/@40.7615203,-73.9698802,3022a,13.1y/data=!4m2!3m1!1s0x89c258e53cfa3fe3:0x8ec197aeae5d0a8c",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-78",
    "externalIds": {
      "cdcClinicId": "78",
      "googlePlaceId": "ChIJU-KRF32BwokRY-kvAccZpsU"
    },
    "type": "fertility-clinic",
    "name": "Gold Coast IVF, Reproductive Medicine and Surgery Center",
    "phone": "(516) 682-8900",
    "address": {
      "line1": "246 Crossways Park Dr West",
      "city": "Woodbury",
      "state": "NY",
      "zip": "11797",
      "country": "US"
    },
    "location": {
      "lat": 40.8043,
      "lng": -73.4877
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 53.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 56.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 35.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 219,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2778%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2778%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.goldcoastivf.com/who-we-are/steven-palter-m-d/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Gold+Coast+IVF,+246+Crossways+Park+Dr+W,+Woodbury,+NY+11797/@40.8043985,-73.4873949,3020a,13.1y/data=!4m2!3m1!1s0x89c2817d1791e253:0xc5a619c7012fe963",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.goldcoastivf.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-78-steven-f-palter-md",
        "name": "Steven F. Palter, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.goldcoastivf.com/wp-content/uploads/2021/09/steven-palter-md-pichi.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.goldcoastivf.com/who-we-are/steven-palter-m-d/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.goldcoastivf.com",
    "description": "If you need fertility treatment, hang on to your common sense, and don’t give up\\ Get straight answers from Dr. Steven Palter, founder and Medical Director of Gold Coast IVF in the free ebook “Get Pregnant Now\\”, a short, no\\-nonsense guide can help you find the way.",
    "languages": ["English"],
    "images": [
      {
        "url": "https://www.goldcoastivf.com/wp-content/uploads/2021/09/waiting-room-pichi-450x300.jpg",
        "type": "interior",
        "caption": "Gold Coast IVF waiting room",
        "_source": {
          "url": "https://www.goldcoastivf.com/who-we-are/about/",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-259",
    "externalIds": {
      "cdcClinicId": "259",
      "googlePlaceId": "ChIJ_XCh5wctw4kR0fNmfirkiGQ"
    },
    "type": "fertility-clinic",
    "name": "Hudson Valley Fertility, PLLC",
    "phone": "(845) 765-0125",
    "address": {
      "line1": "400 Westage Business Center Dr, Suite 109",
      "city": "Fishkill",
      "state": "NY",
      "zip": "12524",
      "country": "US"
    },
    "location": {
      "lat": 41.5243,
      "lng": -73.8965
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 45.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 40.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 19.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 171,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27259%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "minimal",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.hudsonvalleyfertility.com/our-team",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Hudson+Valley+Fertility,+400+Westage+Business+Center+Dr+Ste+109,+Fishkill,+NY+12524/@41.5243311,-73.8965002,2987a,13.1y/data=!4m2!3m1!1s0x89c32d07e7a170fd:0x6488e42a7e66f3d1",
            "fetchedAt": "2026-08-16"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27259%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-259-daniel-w-levine-md",
        "name": "Daniel W. Levine, MD",
        "role": "Medical Director",
        "imageUrl": "https://irp.cdn-website.com/544ed94d/dms3rep/multi/Dr+Daniel+Levine.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.hudsonvalleyfertility.com/our-team",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.hvfertility.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmVuJYJXag7mLDNI-AH-AmWZy5xWe8akNDmiUUmbDpL8RfkoHqHQV5jgIhkBT1n9DVCLtFihzNLAW368BxPTrrECco1hanwUgg6K2fvVAn9yuU8v2Rc_5LGSgJjgqx6lSEBIjpPzAwHevqK=w408-h544-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Hudson+Valley+Fertility,+400+Westage+Business+Center+Dr+Ste+109,+Fishkill,+NY+12524/@41.5243311,-73.8965002,2987a,13.1y/data=!4m2!3m1!1s0x89c32d07e7a170fd:0x6488e42a7e66f3d1",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-440",
    "externalIds": {
      "cdcClinicId": "440",
      "googlePlaceId": "ChIJjToCDAVz04kRvra2WOB8VJ4"
    },
    "type": "fertility-clinic",
    "name": "Infertility & IVF Medical Associates of Western New York, PLLC dba, Buffalo IVF",
    "phone": "(716) 839-3057",
    "address": {
      "line1": "4510 Main St",
      "city": "Buffalo",
      "state": "NY",
      "zip": "14226",
      "country": "US"
    },
    "location": {
      "lat": 42.9639,
      "lng": -78.7831
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 35.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 30.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 26.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 9.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 491,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27440%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27440%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Buffalo+Infertility+%26+IVF+Associates,+4510+Main+St+%23200,+Buffalo,+NY+14226/@42.9638994,-78.783124,2920a,13.1y/data=!4m2!3m1!1s0x89d373050c023a8d:0x9e547ce058b6b6be",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.buffaloivf.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-440-adam-m-griffin-md",
        "name": "Adam M. Griffin, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.buffaloivf.com",
    "languages": ["English"],
    "images": [],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-835",
    "externalIds": {
      "cdcClinicId": "835",
      "googlePlaceId": "ChIJgYknaxIv6IkRkeS8cFopfEE"
    },
    "type": "fertility-clinic",
    "name": "Island Fertility, Stony Brook Community Medical, PC",
    "phone": "(631) 638-4600",
    "address": {
      "line1": "500 Commack Rd, Suite 202",
      "city": "Commack",
      "state": "NY",
      "zip": "11725",
      "country": "US"
    },
    "location": {
      "lat": 40.8227,
      "lng": -73.2917
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 48,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 46.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 21.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 18.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 650,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27835%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27835%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.stonybrookmedicine.edu/islandfertility/our-practice",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Island+Fertility,+500+Commack+Rd+Suite+202+%26+Suite+204,+Commack,+NY+11725/@40.8228152,-73.2922906,3019a,13.1y/data=!4m2!3m1!1s0x89e82f126b278981:0x417c295a70bce491",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.islandfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-835-james-r-stelling-md",
        "name": "James R. Stelling, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.stonybrookmedicine.edu/sites/default/files/cckimages/page/180711_StelingJames_06_0_0.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.stonybrookmedicine.edu/islandfertility/our-practice",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.islandfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": ["Horizon"],
      "_source": {
        "url": "https://www.islandfertility.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "images": [],
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Horizon",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.islandfertility.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-73",
    "externalIds": {
      "cdcClinicId": "73",
      "googlePlaceId": "ChIJbXYQi1y1w4kRphX1mYsOWe8"
    },
    "type": "fertility-clinic",
    "name": "Island Reproductive Services, PC",
    "phone": "(718) 948-6100",
    "address": {
      "line1": "237 Richmond Valley Rd",
      "city": "Staten Island",
      "state": "NY",
      "zip": "10309",
      "country": "US"
    },
    "location": {
      "lat": 40.5216,
      "lng": -74.2365
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 48,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 35.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 30.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 14.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 412,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2773%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "minimal",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://ivfny.org/specialists/dr-eric-knochenhauer",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Island+Reproductive+Services,+237+Richmond+Valley+Rd,+Staten+Island,+NY+10309/@40.521604,-74.2364498,3033a,13.1y/data=!4m2!3m1!1s0x89c3b55c8b10766d:0xef590e8b99f515a6",
            "fetchedAt": "2026-08-16"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2773%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-73-eric-s-knochenhauer-md",
        "name": "Eric S. Knochenhauer, MD",
        "role": "Medical Director",
        "imageUrl": "https://ivfny.org/wp-content/uploads/2019/11/knochenhauer_3.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://ivfny.org/specialists/dr-eric-knochenhauer",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.islandreproductive.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn0_bXXXMgIT3XkMS-JHRncBmLMxeQ0cUIJJV06UriuLfWTUZTDcSkW-LA3jGAo3dyrCKQCz0B9pDE8uRNd-9a2uWU7jtvEZJ_gNhYi1OzCm9TZH7jt7_vnI466anhF3a5CjR6oo5eF2KXY=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Island+Reproductive+Services,+237+Richmond+Valley+Rd,+Staten+Island,+NY+10309/@40.521604,-74.2364498,3033a,13.1y/data=!4m2!3m1!1s0x89c3b55c8b10766d:0xef590e8b99f515a6",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-814",
    "externalIds": {
      "cdcClinicId": "814",
      "googlePlaceId": "ChIJI-ygAgZZwokR178lLsHJ-_k"
    },
    "type": "fertility-clinic",
    "name": "Kindbody-New York",
    "phone": "(855) 563-2639",
    "address": {
      "line1": "16 E. 40th St, 2nd Floor",
      "city": "New York",
      "state": "NY",
      "zip": "10016",
      "country": "US"
    },
    "location": {
      "lat": 40.737,
      "lng": -73.9931
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 56.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 53.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 63,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 216,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27814%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27814%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/locations/new-york/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+Bryant+Park,+16+E+40th+St+2nd+floor,+New+York,+NY+10016/@40.7515432,-73.9809392,3022a,13.1y/data=!4m2!3m1!1s0x89c2590602a0ec23:0xf9fbc9c12e25bfd7",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-814-aimee-seungdamrong-md",
        "name": "Aimee Seungdamrong, MD",
        "role": "Medical Director",
        "imageUrl": "https://kindbody.com/wp-content/uploads/2019/12/Dr-Aimee-Web-683x1024.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://kindbody.com/team/dr-aimee-seungdamrong/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://kindbody.com",
    "description": "Make fertility care an Act of Love\\ Save up to 20% on your first fertility cycle, ends 3/13",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Anthem",
        "Blue Cross",
        "Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Health Net",
        "Multiplan",
        "Tricare",
        "Oxford",
        "Oscar",
        "Emblem Health",
        "Empire",
        "Horizon",
        "Optum",
        "First Health",
        "Medicare",
        "Medicaid"
      ],
      "employeeBenefits": ["Kindbody"],
      "_source": {
        "url": "https://kindbody.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWme_sYCYnk9-skqV-dU9JY0VhNCzlPV4G7a9sSskTrMaXj3FJOWhOp1zBhrGa0Zydovj7TqIDgOJmS3its12F1PSFzMoNpNVzHw4IM80cCLo0M7hWm1zjPXNMS0h431l1h3lbS9=w440-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Bryant+Park,+16+E+40th+St+2nd+floor,+New+York,+NY+10016/@40.7515432,-73.9809392,3022a,13.1y/data=!4m2!3m1!1s0x89c2590602a0ec23:0xf9fbc9c12e25bfd7",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "network": {
      "name": "Kindbody"
    },
    "pricing": {
      "packages": [
        {
          "name": "Pulse Assessment",
          "description": "Quick fertility check — not covered by insurance",
          "price": 9900,
          "currency": "USD",
          "includes": [
            "AMH blood test",
            "Transvaginal ultrasound for follicle count",
            "15-minute reproductive consultation"
          ],
          "notes": "Not covered by insurance"
        },
        {
          "name": "Fertility Consultation",
          "description": "Specialist consultation on fertility fundamentals",
          "price": 30000,
          "currency": "USD",
          "notes": "Billable to most insurance plans"
        },
        {
          "name": "Male Consultation + Semen Analysis",
          "price": 52500,
          "currency": "USD",
          "includes": ["Consultation", "Venipuncture", "Semen analysis"]
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Single egg freezing cycle",
          "price": 690000,
          "priceMax": 966000,
          "currency": "USD",
          "includes": [
            "Stimulation visits",
            "Ultrasounds",
            "Blood draws",
            "Retrieval",
            "Cryopreservation",
            "3 months storage",
            "Coordination"
          ],
          "excludes": ["Medications ($4,000 - $6,000)", "Anesthesia"]
        },
        {
          "name": "Annual Egg Storage",
          "price": 92000,
          "currency": "USD",
          "notes": "Per year"
        },
        {
          "name": "IVF Freeze All (Self Pay)",
          "description": "IVF cycle with all embryos frozen",
          "price": 1160000,
          "priceMax": 1850000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Cryopreservation",
            "3 months storage"
          ],
          "excludes": [
            "Medications (~$4,000 - $6,000)",
            "Embryo biopsy/genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Donor services",
            "Anesthesia"
          ]
        },
        {
          "name": "IVF Fresh Transfer (Self Pay)",
          "description": "IVF cycle with fresh embryo transfer",
          "price": 1380000,
          "priceMax": 1875000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$5,000 - $9,000)",
            "Genetic testing",
            "Surplus embryo storage",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Freeze All",
          "price": 910000,
          "priceMax": 1332000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Cryopreservation",
            "3-month storage"
          ],
          "excludes": [
            "Genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Fresh Transfer",
          "price": 990000,
          "priceMax": 1428000,
          "currency": "USD",
          "includes": [
            "Ultrasounds",
            "Thaw",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Surplus storage",
            "Frozen transfers",
            "Anesthesia"
          ]
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 400000,
          "priceMax": 550000,
          "currency": "USD",
          "includes": ["Ultrasounds", "Thaw", "Assisted hatching", "Transfer"],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "PGT Package",
          "description": "Preimplantation genetic testing",
          "price": 160000,
          "priceMax": 300000,
          "currency": "USD",
          "includes": ["Embryo biopsy", "Lab management"],
          "excludes": ["Storage", "Shipping", "Per-embryo testing costs"]
        },
        {
          "name": "Nutrition Coaching",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Counseling & Support",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Guided Meditation",
          "description": "Virtual wellness — 30-minute session",
          "price": 9000,
          "currency": "USD"
        }
      ],
      "financingOptions": [
        {
          "name": "PatientFi monthly payments",
          "description": "PatientFi monthly payments"
        }
      ],
      "disclaimer": "Prices vary by location. Medications and anesthesia are not included in procedure costs. 3 months of storage included with freeze procedures; annual storage is $920.",
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Blue Cross, Blue Shield, Cigna, United Healthcare, Humana, Health Net",
              "detail": "11 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://kindbody.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "14 public price package(s) and 1 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-337",
    "externalIds": {
      "cdcClinicId": "337",
      "googlePlaceId": "ChIJh3z-Y7VbwokRkFPTPXA5ZfA"
    },
    "type": "fertility-clinic",
    "name": "Kofinas Fertility Group",
    "phone": "(212) 348-4000",
    "address": {
      "line1": "65 Broadway, 14th Floor",
      "city": "New York",
      "state": "NY",
      "zip": "10006",
      "country": "US"
    },
    "location": {
      "lat": 40.7073,
      "lng": -74.0126
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 68.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 59.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 54.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 45.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 435,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27337%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27337%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.kofinasfertility.com/locations/lower-manhattan/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kofinas+Fertility+Group,+65+Broadway+14th+floor,+New+York,+NY+10006/@40.707344,-74.0125825,3024a,13.1y/data=!4m2!3m1!1s0x89c25bb563fe7c87:0xf06539703dd35390",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.kofinasfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-337-george-d-kofinas-md",
        "name": "George D. Kofinas, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.kofinasfertility.com/wp-content/uploads/2026/03/20240330_Dr.-George-Kofinas_0072.jpeg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.kofinasfertility.com/team/george-d-kofinas-md-facog/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.kofinasfertility.com",
    "languages": ["English"],
    "images": [
      {
        "url": "https://www.kofinasfertility.com/wp-content/uploads/2026/02/65-Broadway-1.webp",
        "type": "exterior",
        "caption": "Kofinas Fertility Lower Manhattan location",
        "_source": {
          "url": "https://www.kofinasfertility.com/locations/lower-manhattan/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkHld2157dV3SkDT_aorDu7F9RInM_3h4TioX57425LqWJuzYRHre1swMQ2TbZPQcZzCAfeJmwspMdXyTETibe4DwtZrp_CaZVNGwytZCyXyLIfICQXtwo1OUvH2vFVPK2RydXRhyu60XQ=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kofinas+Fertility+Group,+65+Broadway+14th+floor,+New+York,+NY+10006/@40.707344,-74.0125825,3024a,13.1y/data=!4m2!3m1!1s0x89c25bb563fe7c87:0xf06539703dd35390",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkSOlijLXFAIYgRVzCnbAyFHXc5AYmrMb9Lee8Ng6UAVKeODTpv5wx3HeOPD0AzW_RhnT96zuDpCx8DjVr-vzUjCRI54ztl0LALarE9YerPhMQRvd4kDnsFihx0QYyDihD8G_C8fgtMDIdO=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kofinas+Fertility+Group,+65+Broadway+14th+floor,+New+York,+NY+10006/@40.707344,-74.0125825,3024a,13.1y/data=!4m2!3m1!1s0x89c25bb563fe7c87:0xf06539703dd35390",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-25",
    "externalIds": {
      "cdcClinicId": "25",
      "googlePlaceId": "ChIJ-TGctOpYwokRaMkgwXckxZw"
    },
    "type": "fertility-clinic",
    "name": "Manhattan Reproductive Medicine",
    "phone": "(212) 794-0080",
    "address": {
      "line1": "159 E. 74th St, Suite C",
      "city": "New York",
      "state": "NY",
      "zip": "10021",
      "country": "US"
    },
    "location": {
      "lat": 40.7717,
      "lng": -73.9605
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 16,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2725%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "minimal",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Manhattan+Reproductive+Medicine,+159+E+74th+St+C,+New+York,+NY+10021/@40.7717117,-73.9605332,3022a,13.1y/data=!4m2!3m1!1s0x89c258eab49c31f9:0x9cc52477c120c968",
            "fetchedAt": "2026-08-16"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2725%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-25-hanna-jesionowska-md",
        "name": "Hanna Jesionowska, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.manhattanreproductivemedicine.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-421",
    "externalIds": {
      "cdcClinicId": "421"
    },
    "type": "fertility-clinic",
    "name": "Metropolitan Reproductive Medicine, PC",
    "phone": "(212) 580-2252",
    "address": {
      "line1": "422 West End Ave",
      "city": "New York",
      "state": "NY",
      "zip": "10024",
      "country": "US"
    },
    "location": {
      "lat": 40.7853,
      "lng": -73.9803
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 17,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27421%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27421%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.metrorepro.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-421-susan-lobel-md",
        "name": "Susan Lobel, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.metrorepro.com",
    "languages": ["English"],
    "images": [],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-824",
    "externalIds": {
      "cdcClinicId": "824",
      "googlePlaceId": "ChIJaStXQkZZwokRdYM9C3qGZT8"
    },
    "type": "fertility-clinic",
    "name": "Mingxue Yang Medical, PC",
    "phone": "(212) 230-5711",
    "address": {
      "line1": "1625 Third Ave",
      "city": "New York",
      "state": "NY",
      "zip": "10128",
      "country": "US"
    },
    "location": {
      "lat": 40.7823,
      "lng": -73.9512
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 77.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 68.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 38.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 484,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27824%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27824%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://allcarefertility.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Mingxue+Yang+MD,+369+Lexington+Ave+Fl+6,+New+York,+NY+10017/@40.750579,-73.9764314,3023a,13.1y/data=!4m2!3m1!1s0x89c2594642572b69:0x3f65867a0b3d8375",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.yangfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-824-mingxue-yang-md-phd",
        "name": "Mingxue Yang, MD, PHD",
        "role": "Medical Director",
        "imageUrl": "https://allcarefertility.com/wp-content/uploads/2023/09/dryang-scaled.jpg",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://allcarefertility.com/dr-yang/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.yangfertility.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "boutique",
    "images": [
      {
        "url": "https://allcarefertility.com/wp-content/uploads/2023/12/LAB2-scaled.jpg",
        "type": "interior",
        "caption": "ALLcare Fertility lab",
        "_source": {
          "url": "https://allcarefertility.com/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmhgHJw62O66d7-F1Z_1pG0XmKtA3hY1PSsLt2lkhgDh6xpRvfHs2UW4hLMTtVcZ4F8sur3P46EIq8AND_XD3DFBqYk9jKy_KgpOTgwVVD6m-oqR0eqJ_K-ZxBZ60wNfO-v-F3UuchYfGI=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Mingxue+Yang+MD,+369+Lexington+Ave+Fl+6,+New+York,+NY+10017/@40.750579,-73.9764314,3023a,13.1y/data=!4m2!3m1!1s0x89c2594642572b69:0x3f65867a0b3d8375",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk3f-y183964xnNk6zDedNBxnYdmM8QWo33qNaTzsysuLXwNsdL9nxsBlBty2F62bXUpdmt-sRxPVzdvgsvsH5dnP_-BPy_lgh6dxuBdIN6bvqPXkoN3-krI7DXsgD3jqNL2cwNmwWD7WeY=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Mingxue+Yang+MD,+369+Lexington+Ave+Fl+6,+New+York,+NY+10017/@40.750579,-73.9764314,3023a,13.1y/data=!4m2!3m1!1s0x89c2594642572b69:0x3f65867a0b3d8375",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-293",
    "externalIds": {
      "cdcClinicId": "293",
      "googlePlaceId": "ChIJ_-faeo-UwokRHffC_fchGqk"
    },
    "type": "fertility-clinic",
    "name": "Montefiore's Institute for Reproductive Medicine and Health",
    "phone": "(914) 997-1060",
    "address": {
      "line1": "141 S. Central Ave, Suite 201",
      "city": "Hartsdale",
      "state": "NY",
      "zip": "10530",
      "country": "US"
    },
    "location": {
      "lat": 41.0158,
      "lng": -73.8029
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 41,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 60.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 27.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 4.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 180,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27293%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27293%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://doctors.montefioreeinstein.org/providers/1275613739/harry-j-lieman",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Montefiore's+Institute+for+Reproductive+Medicine+and+Health,+141+S+Central+Ave+%23201,+Hartsdale,+NY+10530/@41.0158452,-73.8029167,3010a,13.1y/data=!4m2!3m1!1s0x89c2948f7adae7ff:0xa91a21f7fdc2f71d",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.montefiore.org/reproductive-medicine",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-293-harry-j-lieman-md",
        "name": "Harry J. Lieman, MD",
        "role": "Medical Director",
        "imageUrl": "https://documentapi-fargate-documentbucket-15qi4tpdvnhlz.s3.amazonaws.com/218/8e8cd210-c4aa-11eb-925b-439657343c68.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://doctors.montefioreeinstein.org/providers/1275613739/harry-j-lieman",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.montefiore.org/reproductive-medicine",
    "insurance": {
      "accepted": true,
      "carriers": ["Health Net"],
      "_source": {
        "url": "https://www.montefiore.org/reproductive-medicine",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmrX4zEaL3Fz2JMDos-vX2HUxQ-W8B5V5Rqy9btsl-m3UkgdAv2tU2fbhmChX80EJG98WvAqNW-RmpII5i-0g8mG-XhutuzqMxsXQ95O7NDy2OZ370j-6KqL1FqlXRTz7riqS1o=w298-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Montefiore's+Institute+for+Reproductive+Medicine+and+Health,+141+S+Central+Ave+%23201,+Hartsdale,+NY+10530/@41.0158452,-73.8029167,3010a,13.1y/data=!4m2!3m1!1s0x89c2948f7adae7ff:0xa91a21f7fdc2f71d",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.montefiore.org/reproductive-medicine",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-31",
    "externalIds": {
      "cdcClinicId": "31",
      "googlePlaceId": "ChIJuZo_1fdYwokRm0OFDdUx-H8"
    },
    "type": "fertility-clinic",
    "name": "New Hope Fertility Center",
    "description": "Pioneer of Mini-IVF and Natural Cycle IVF, specializing in low-drug fertility solutions with over 15,000 babies born.",
    "website": "https://www.newhopefertility.com",
    "phone": "(212) 517-7676",
    "bookingUrl": "https://www.newhopefertility.com/start-fertility-treatment/",
    "address": {
      "line1": "4 Columbus Cir, 4th Floor",
      "city": "New York",
      "state": "NY",
      "zip": "10019",
      "country": "US"
    },
    "location": {
      "lat": 40.7674,
      "lng": -73.9829
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "miniIVF"
      }
    ],
    "insurance": {
      "accepted": true,
      "financingOptions": ["Payment plans", "Loans", "Future Family", "CapexMD"]
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 31.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 23.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 26.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 11.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 3347,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2731%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "languages": ["English", "es", "fr", "ja", "ko"],
    "consultationTypes": ["in-person", "telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2731%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "scraped"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.newhopefertility.com/about-us/fertility-doctor/john-zhang/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/New+Hope+Fertility+Center,+784+Park+Ave,+New+York,+NY+10021/@40.7723675,-73.9634275,3022a,13.1y/data=!4m2!3m1!1s0x89c258f7d53f9ab9:0x7ff831d50d85439b",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.newhopefertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-31-john-zhang-md-phd",
        "name": "John Zhang, MD, PHD",
        "role": "Medical Director",
        "imageUrl": "https://www.newhopefertility.com/wp-content/uploads/2025/12/Dr.-John-Zhang.png.webp",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.newhopefertility.com/about-us/fertility-doctor/john-zhang/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "images": [
      {
        "url": "https://www.newhopefertility.com/wp-content/uploads/2025/11/New-Hope-Fertility-Clinic-NYC.png.webp",
        "type": "interior",
        "_source": {
          "url": "https://www.newhopefertility.com",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn8qnIhMdM3cYX6GNYj6amyqAsFPbBynvB2eekIbZX8LYrHq3edBhWSA9uKV3s_gyp3M1REdT0BshSAMNQMM80Dc4HJeS--nOM6Z_B_MWQCqQMB2SGjca8Lsj-dzPVPfiKaNgX3=w408-h611-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/New+Hope+Fertility+Center,+784+Park+Ave,+New+York,+NY+10021/@40.7723675,-73.9634275,3022a,13.1y/data=!4m2!3m1!1s0x89c258f7d53f9ab9:0x7ff831d50d85439b",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-838",
    "externalIds": {
      "cdcClinicId": "838",
      "googlePlaceId": "ChIJY_P-w89ZwokR75nEFlbpAZo"
    },
    "type": "fertility-clinic",
    "name": "New York Fertility Medical Practice, PLLC dba, Shady Grove Fertility New York",
    "phone": "(646) 502-5450",
    "address": {
      "line1": "110 E. 60th St, Suite 500",
      "city": "New York",
      "state": "NY",
      "zip": "10022",
      "country": "US"
    },
    "location": {
      "lat": 40.7649,
      "lng": -73.9726
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 62,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 52.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 33.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 35,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 487,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27838%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27838%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.rmany.com/our-team/physicians/dr-anate-brauer",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Uptown+Manhattan,+110+E+60th+St+5th+Floor,+New+York,+NY+10022/@40.7631063,-73.9688336,3022a,13.1y/data=!4m2!3m1!1s0x89c259cfc3fef363:0x9a01e95616c499ef",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-838-anate-brauer-md",
        "name": "Anate Brauer, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.rmany.com/media/pages/our-team/physicians/dr-anate-brauer/40672054cc-1729794594/anate_brauer.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.rmany.com/our-team/physicians/dr-anate-brauer",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.shadygrovefertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": [
        "Progyny",
        "Carrot",
        "Maven",
        "WINFertility",
        "Stork Club"
      ],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWndfpIuIXwBGIKCGiJMSK4wCFjG3G1OoP668OYjCfiwWZ0zAv7jB2VHG_wp_fQ3FZDQNrddorZrzBQEHkOY8s8Q4SVXISUQpTFr5GjS1K9kztnb0kdbOukBYLq_n5-hJIl5CA4w6A=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Uptown+Manhattan,+110+E+60th+St+5th+Floor,+New+York,+NY+10022/@40.7631063,-73.9688336,3022a,13.1y/data=!4m2!3m1!1s0x89c259cfc3fef363:0x9a01e95616c499ef",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn-WQ0UwVH1q5BAjs8_eSjCujzBSmWkb8MCu9En6Qi5R2_BmgUxHDDv-df180zhJt3RTHVTI7JxKxdD-VJQOGk-KTiPBH982ApeqblN6596J1t_yvuQ8w4v-LNjykRtmHzHmfRwTg=w224-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Uptown+Manhattan,+110+E+60th+St+5th+Floor,+New+York,+NY+10022/@40.7631063,-73.9688336,3022a,13.1y/data=!4m2!3m1!1s0x89c259cfc3fef363:0x9a01e95616c499ef",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "network": {
      "name": "US Fertility"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-204",
    "externalIds": {
      "cdcClinicId": "204"
    },
    "type": "fertility-clinic",
    "name": "New York Reproductive Wellness",
    "phone": "(516) 605-2626",
    "address": {
      "line1": "300 S. Oyster Bay Rd",
      "city": "Syosset",
      "state": "NY",
      "zip": "11791",
      "country": "US"
    },
    "location": {
      "lat": 40.7963,
      "lng": -73.5034
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 55.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 48,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 42.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 191,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27204%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27204%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.nyreproductivewellness.com/contact",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.nyreproductivewellness.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-204-gregory-zapantis-md",
        "name": "Gregory Zapantis, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.nyreproductivewellness.com/media/pages/our-fertility-clinic/meet-dr-zapantis/f89ed2f5e7-1598990636/nyrw-dr_zapantis.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.nyreproductivewellness.com/our-fertility-clinic/meet-dr-zapantis",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.nyreproductivewellness.com",
    "description": "From Syosset to Suffolk, Greenpoint to Greenport, and everywhere in between, infertility patients come to us with high hopes and high expectations. We understand. You're treated as person, a patient, and hopeful parent, and not a number at NYRW.",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "boutique",
    "images": [
      {
        "url": "https://www.nyreproductivewellness.com/media/pages/contact/1015a796e8-1747404606/hero-our-location.jpg",
        "type": "interior",
        "caption": "New York Reproductive Wellness location",
        "_source": {
          "url": "https://www.nyreproductivewellness.com/contact",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-619",
    "externalIds": {
      "cdcClinicId": "619",
      "googlePlaceId": "ChIJMSSxPeVYwokR18x9kv3UhRA"
    },
    "type": "fertility-clinic",
    "name": "Neway Medical",
    "phone": "(212) 750-3330",
    "address": {
      "line1": "123 W. 79th St",
      "city": "New York",
      "state": "NY",
      "zip": "10024",
      "country": "US"
    },
    "location": {
      "lat": 40.7825,
      "lng": -73.9761
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 53.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 66.66666666666666,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "12/18"
        },
        {
          "ageBand": "38-40",
          "rate": 44.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 42.857142857142854,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/14"
        }
      ],
      "cyclesPerYear": 202,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27619%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "minimal",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://newayfertility.com/team-member/jeffrey-wang-md/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Neway+Fertility,+123+W+79th+St,+New+York,+NY+10024/@40.7825461,-73.9761367,3021a,13.1y/data=!4m2!3m1!1s0x89c258e53db12431:0x1085d4fd927dccd7",
            "fetchedAt": "2026-08-16"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27619%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-619-jeffrey-wang-md",
        "name": "Jeffrey Wang, MD",
        "role": "Medical Director",
        "imageUrl": "https://newayfertility.com/wp-content/uploads/2025/11/dr-wang.webp",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://newayfertility.com/team-member/jeffrey-wang-md/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://neway.nyc",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmyz-Xpz36hPKA5h5Wl6gsbCi7plco7Cy38Dh9_KK8PigGll0hVX6StmYbBuyPfjRGQk9m5swIetNVvTn_TKlcMRfBnJMYehUHePeR1hQpJVVxue5EZxYK3GMXH7D-OW9HY1QI7=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Neway+Fertility,+123+W+79th+St,+New+York,+NY+10024/@40.7825461,-73.9761367,3021a,13.1y/data=!4m2!3m1!1s0x89c258e53db12431:0x1085d4fd927dccd7",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn6zyEXCvtnH7fRmYpHXKPum_xd0TNIDe0yhed84gbCbUePeGc7fbtsPCoxuTCuD0RJdJ0nqQbVnLj6s5maZBY9-oZWRtPV-3A1VLYCE4s8rLMuRIzo81XrgCCWnXbLaZtBRZaM=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Neway+Fertility,+123+W+79th+St,+New+York,+NY+10024/@40.7825461,-73.9761367,3021a,13.1y/data=!4m2!3m1!1s0x89c258e53db12431:0x1085d4fd927dccd7",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-92",
    "externalIds": {
      "cdcClinicId": "92"
    },
    "type": "fertility-clinic",
    "name": "Northwell Health Fertility",
    "phone": "(516) 562-2229",
    "address": {
      "line1": "300 Community Dr",
      "city": "Manhasset",
      "state": "NY",
      "zip": "11030",
      "country": "US"
    },
    "location": {
      "lat": 40.7753,
      "lng": -73.701
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 56.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 50.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 49,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 21,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 663,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2792%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2792%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.northwell.edu/obstetrics-and-gynecology/fertility/find-care/locations/manhasset",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.northwell.edu/obstetrics-and-gynecology/fertility",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-92-christine-m-mullin-md",
        "name": "Christine M. Mullin, MD",
        "role": "Medical Director",
        "imageUrl": "https://fadapi.northwell.io/images/providers/dr-christine-marie-mullin-md-1447557426.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.northwell.edu/find-care/find-a-doctor/dr-christine-marie-mullin-md-1447557426",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.northwell.edu/obstetrics-and-gynecology/fertility",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Anthem Blue Cross Blue Shield",
        "Blue Cross",
        "Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Health Net",
        "Tricare",
        "Oxford",
        "Oscar",
        "Emblem Health",
        "EmblemHealth",
        "Empire",
        "Horizon",
        "Molina",
        "Optum",
        "BCBS",
        "Medicare",
        "Medicaid"
      ],
      "employeeBenefits": ["Progyny", "WINFertility", "WIN Fertility"],
      "_source": {
        "url": "https://www.northwell.edu/obstetrics-and-gynecology/fertility",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "images": [],
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross Blue Shield, Blue Cross, Blue Shield, Cigna, United Healthcare, Humana, Health Net",
              "detail": "12 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.northwell.edu/obstetrics-and-gynecology/fertility",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-828",
    "externalIds": {
      "cdcClinicId": "828",
      "googlePlaceId": "ChIJcRLyl6RZwokRscLittoG0Kk"
    },
    "type": "fertility-clinic",
    "name": "Northwell Health Fertility-NYC",
    "phone": "(212) 324-2229",
    "address": {
      "line1": "210 E. 64th St, 1st Floor",
      "city": "New York",
      "state": "NY",
      "zip": "10065",
      "country": "US"
    },
    "location": {
      "lat": 40.7641,
      "lng": -73.9633
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 49.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 43.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 36.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 31.57894736842105,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/19"
        }
      ],
      "cyclesPerYear": 208,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27828%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27828%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.northwell.edu/obstetrics-and-gynecology/fertility/news/the-latest/northwell-opens-25m-fertility-center-at-manhattan-eye-ear-and-throat-hospital",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Northwell+Health+Fertility+of+New+York+City,+210+E+64th+St+1st+floor,+New+York,+NY+10065/@40.7640723,-73.9633151,3022a,13.1y/data=!4m2!3m1!1s0x89c259a497f21271:0xa9d006dab6e2c2b1",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.northwell.edu/obstetrics-and-gynecology/fertility",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-828-christine-mullin-md",
        "name": "Christine Mullin, MD",
        "role": "Medical Director",
        "imageUrl": "https://fadapi.northwell.io/images/providers/dr-christine-marie-mullin-md-1447557426.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.northwell.edu/find-care/find-a-doctor/dr-christine-marie-mullin-md-1447557426",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.northwell.edu/obstetrics-and-gynecology/fertility",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Anthem Blue Cross Blue Shield",
        "Blue Cross",
        "Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Health Net",
        "Tricare",
        "Oxford",
        "Oscar",
        "Emblem Health",
        "EmblemHealth",
        "Empire",
        "Horizon",
        "Molina",
        "Optum",
        "BCBS",
        "Medicare",
        "Medicaid"
      ],
      "employeeBenefits": ["Progyny", "WINFertility", "WIN Fertility"],
      "_source": {
        "url": "https://www.northwell.edu/obstetrics-and-gynecology/fertility",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "images": [
      {
        "url": "https://dam.northwell.edu/m/43278ab96214db74/Drupal-NEWS_Northwell-opens-25M-fertility-center-at-Manhattan-Eye-Ear-and-Throat-Hospital-patient-doctor.jpg",
        "type": "interior",
        "caption": "Northwell Health Fertility NYC fertility center",
        "_source": {
          "url": "https://www.northwell.edu/obstetrics-and-gynecology/fertility/news/the-latest/northwell-opens-25m-fertility-center-at-manhattan-eye-ear-and-throat-hospital",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross Blue Shield, Blue Cross, Blue Shield, Cigna, United Healthcare, Humana, Health Net",
              "detail": "12 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.northwell.edu/obstetrics-and-gynecology/fertility",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-822",
    "externalIds": {
      "cdcClinicId": "822",
      "googlePlaceId": "ChIJoVnM0-ZYwokRqbNykb326bk"
    },
    "type": "fertility-clinic",
    "name": "NYC In Vitro Fertilization, PC",
    "phone": "(800) 853-7595",
    "address": {
      "line1": "693 Fifth Ave, 7th Floor",
      "city": "New York",
      "state": "NY",
      "zip": "10022",
      "country": "US"
    },
    "location": {
      "lat": 40.7612,
      "lng": -73.9748
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 46.15384615384615,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/13"
        },
        {
          "ageBand": "35-37",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/12"
        },
        {
          "ageBand": "38-40",
          "rate": 33.33333333333333,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/15"
        }
      ],
      "cyclesPerYear": 63,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27822%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27822%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://nycivf.com/about-us/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/NYC+IVF,+693+5th+Ave+7th+Floor,+New+York,+NY+10022/@40.7611595,-73.9748035,3022a,13.1y/data=!4m2!3m1!1s0x89c258e6d3cc59a1:0xb9e9f6bd9172b3a9",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.nycivf.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-822-alyaa-elassar-md",
        "name": "Alyaa Elassar, MD",
        "role": "Medical Director",
        "imageUrl": "https://nycivf.com/wp-content/uploads/2021/01/Dr.-Elassar-2021.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://nycivf.com/about-us/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.nycivf.com",
    "insurance": {
      "accepted": true,
      "carriers": ["Molina"],
      "_source": {
        "url": "https://www.nycivf.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["Russian", "Italian", "Hebrew", "English"],
    "images": [
      {
        "url": "https://nycivf.com/wp-content/uploads/2021/02/Wellness-and-Accupressure-room.jpg",
        "type": "interior",
        "caption": "NYC IVF wellness and acupressure room",
        "_source": {
          "url": "https://nycivf.com/about-us/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmljM8vybM5KFJoKkBysSk9p5CkJSO0thCVqQN68q6UvLosMVicomwNTUNCqhwWJ6h1-gD6WaQo3W51BXwRGkctW4wN7fn-cZyMbwOOYlQuDC6bp6PKBy3NoyA9XuzH0IGgDSFR=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/NYC+IVF,+693+5th+Ave+7th+Floor,+New+York,+NY+10022/@40.7611595,-73.9748035,3022a,13.1y/data=!4m2!3m1!1s0x89c258e6d3cc59a1:0xb9e9f6bd9172b3a9",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Molina",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.nycivf.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-46",
    "externalIds": {
      "cdcClinicId": "46",
      "googlePlaceId": "ChIJIxsd1gRZwokRCB2AzKRGDdc"
    },
    "type": "fertility-clinic",
    "name": "NYU Langone Fertility Center",
    "description": "A pioneer in preimplantation genetic testing and egg freezing, offering a comprehensive wellness program with acupuncture, yoga, nutrition, and mind-body classes.",
    "website": "https://www.fertilityny.org",
    "phone": "(212) 263-8990",
    "bookingUrl": "https://www.fertilityny.org/appointments",
    "address": {
      "line1": "159 E. 53rd St, 3rd Floor",
      "city": "New York",
      "state": "NY",
      "zip": "10022",
      "country": "US"
    },
    "location": {
      "lat": 40.746,
      "lng": -73.9715
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "financingOptions": ["Payment plans"]
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 58.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 57.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 55.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 52.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1883,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2746%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "languages": ["English", "es"],
    "consultationTypes": ["in-person", "telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2746%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "scraped"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://nyulangone.org/locations/fertility-center",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/NYU+Langone+Fertility+Center,+159+E+53rd+St+3rd+Fl,+New+York,+NY+10022/@40.7580552,-73.9698375,3022a,13.1y/data=!4m2!3m1!1s0x89c25904d61d1b23:0xd70d46a4cc801d08",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilityny.org",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-46-james-a-grifo-md-phd",
        "name": "James A. Grifo, MD, PHD",
        "role": "Medical Director",
        "imageUrl": "https://nyulangone.org/images/doctors/g/grifo/1316994403/james-a-grifo-square.jpg",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://nyulangone.org/doctors/1316994403/james-a-grifo",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "setting": "hospital-based",
    "images": [
      {
        "url": "https://nyulangone.org/files/fertility-center-inline.jpg",
        "type": "interior",
        "caption": "NYU Langone Fertility Center",
        "_source": {
          "url": "https://nyulangone.org/locations/fertility-center",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnZAgbeRDgizx01joSZoOwb72PEVAgmLNtmX6WXMCRO8W840Ip1PYY7MOpNhxOSbgN1nIXnMXtXI8gApMYWSYEbw-VsuBCmvFS8fCDXysbaEnTF7Pt8pCsWQF0t4vwPeuqYRFwYlPxZ-Is=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/NYU+Langone+Fertility+Center,+159+E+53rd+St+3rd+Fl,+New+York,+NY+10022/@40.7580552,-73.9698375,3022a,13.1y/data=!4m2!3m1!1s0x89c25904d61d1b23:0xd70d46a4cc801d08",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlsmpI-kmxcpO2zAv_KJsDbnTXtU8tVXABFclukovDNOVXBrpLNHwDYDl-Dtl8JKYGoaE22it5FTICLD7aFwLlTLPmqG5dWee0TKzF11b_BfXsFz4RwBsgW3GGZt4MWbi0FXjG_=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/NYU+Langone+Fertility+Center,+159+E+53rd+St+3rd+Fl,+New+York,+NY+10022/@40.7580552,-73.9698375,3022a,13.1y/data=!4m2!3m1!1s0x89c25904d61d1b23:0xd70d46a4cc801d08",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlVtzIompAgUjBg9PH5m8G8oHaexnlHxwn6wscEtg_Is2VYuIANwjwHlyhqM5pP8bHSQWSwfPyMSicTzHPN-yLe9y4m8y9fWbp2Fii8AZVU8G0ESQ2VKrfQtaK-_F2WhASoicaSJg=w224-h398-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/NYU+Langone+Fertility+Center,+159+E+53rd+St+3rd+Fl,+New+York,+NY+10022/@40.7580552,-73.9698375,3022a,13.1y/data=!4m2!3m1!1s0x89c25904d61d1b23:0xd70d46a4cc801d08",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-64",
    "externalIds": {
      "cdcClinicId": "64",
      "googlePlaceId": "ChIJtziWylt9wokR5DNecBh9n-M"
    },
    "type": "fertility-clinic",
    "name": "NYU Langone Reproductive Specialists of New York",
    "phone": "(516) 739-2100",
    "address": {
      "line1": "200 Old Country Rd, Suite 350",
      "city": "Mineola",
      "state": "NY",
      "zip": "11501",
      "country": "US"
    },
    "location": {
      "lat": 40.7395,
      "lng": -73.6389
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 50.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 48.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 38.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 26.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 556,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2764%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2764%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://nyulangone.org/doctors/1306822820/maria-saketos",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/NYU+Langone+Reproductive+Specialists+of+New+York,+200+Old+Country+Rd+%23350,+Mineola,+NY+11501/@40.739555,-73.638812,3023a,13.1y/data=!4m2!3m1!1s0x89c27d5bca9638b7:0xe39f7d18705e33e4",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilityny.org",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-64-maria-saketos-md",
        "name": "Maria Saketos, MD",
        "role": "Medical Director",
        "imageUrl": "https://nyulangone.org/images/doctors/s/saketos/1306822820/maria-saketos-square.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://nyulangone.org/doctors/1306822820/maria-saketos",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.fertilityny.org",
    "description": "Castle Connolly has recognized six of our New York City fertility specialists as 2026 Top Doctors\\",
    "languages": ["English"],
    "network": {
      "name": "Prelude Network"
    },
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn19tINpMbvmoIeENeKOpfCsXEcnF2wWB2AIXfi9a94larfFZSjERavs8AQxv7fLp59wImLyhncQ96ImThA_SVLmjs5yJo1c2MPPB2q_0_o7FEyYYh-j6c1ykUY0bnvgo5H974zWA=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/NYU+Langone+Reproductive+Specialists+of+New+York,+200+Old+Country+Rd+%23350,+Mineola,+NY+11501/@40.739555,-73.638812,3023a,13.1y/data=!4m2!3m1!1s0x89c27d5bca9638b7:0xe39f7d18705e33e4",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-877",
    "externalIds": {
      "cdcClinicId": "877",
      "googlePlaceId": "ChIJDTkqHwpZwokRMy1bvjd0FVo"
    },
    "type": "fertility-clinic",
    "name": "Rejuvenating Fertility Center-New York",
    "phone": "(203) 557-9696",
    "address": {
      "line1": "315 W. 57th St, Suite 208",
      "city": "New York",
      "state": "NY",
      "zip": "10019",
      "country": "US"
    },
    "location": {
      "lat": 40.7673,
      "lng": -73.9838
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 8.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 5.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 2.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 952,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27877%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27877%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.rejuvenatingfertility.com/our-doctors",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Rejuvenating+Fertility+Center,+315+W+57th+St+%23208,+New+York,+NY+10019/@40.767447,-73.9838244,3022a,13.1y/data=!4m2!3m1!1s0x89c2590a1f2a390d:0x5a157437be5b2d33",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.rejuvenatingfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-877-zaher-o-merhi-md",
        "name": "Zaher O. Merhi, MD",
        "role": "Medical Director",
        "imageUrl": "https://static.wixstatic.com/media/ca2223_aba16047550149dbbd1b6f7bde88f801~mv2.jpg/v1/fill/w_180,h_261,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Merhi-photo-png_edited.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.rejuvenatingfertility.com/our-doctors",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.rejuvenatingfertility.com",
    "description": "I am so proud to say that I thank God for Dr. Merhi and Dr. Marco and the entire rejuvenating staff. I was 50 years old when I started my fertility treatments and I’m proud to say that my husband and I are now four months pregnant. Glory to God for using this great office to make our dream come true\\ I am now 53 years old and pregnant.",
    "languages": ["English"],
    "images": [],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-130",
    "externalIds": {
      "cdcClinicId": "130",
      "googlePlaceId": "ChIJFTRg--9YwokRfs3eP2tuMfI"
    },
    "type": "fertility-clinic",
    "name": "RMA of New York - Eastside",
    "description": "Division of Reproductive Endocrinology at Mount Sinai, operating 14 offices and 4 IVF labs across the NYC metro area with a dedicated oncofertility and male reproductive health center.",
    "website": "https://www.rmany.com/",
    "phone": "(212) 756-5777",
    "bookingUrl": "https://www.rmany.com/appointments",
    "address": {
      "line1": "635 Madison Ave, 10th Floor",
      "city": "New York",
      "state": "NY",
      "zip": "10022",
      "country": "US"
    },
    "location": {
      "lat": 40.7637,
      "lng": -73.971
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "financingOptions": [
        "Payment plans",
        "Loans",
        "Package pricing",
        "CapexMD",
        "Future Family",
        "PatientFi",
        "Gaia"
      ]
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 50.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 54.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 51.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 38.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 2247,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27130%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "consultationTypes": ["in-person", "telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27130%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "scraped"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.rmany.com/about-rmany/locations/manhattan/rma-eastside",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+of+New+York:+Eastside,+635+Madison+Ave+10th+floor,+New+York,+NY+10022/@40.7637152,-73.9709963,3022a,13.1y/data=!4m2!3m1!1s0x89c258effb603415:0xf2316e6b3fdecd7e",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.rmany.com/",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-130-eric-flisser-md",
        "name": "Eric Flisser, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.rmany.com/media/pages/our-team/physicians/dr-eric-flisser/73c3cc2e5a-1729794594/eric_flisser_new.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.rmany.com/our-team/physicians/dr-eric-flisser",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "languages": ["English"],
    "network": {
      "name": "US Fertility"
    },
    "setting": "network-group",
    "images": [
      {
        "url": "https://www.rmany.com/media/pages/about-rmany/locations/manhattan/rma-eastside/6ab374d042-1729794593/eastside-rma.jpg",
        "type": "interior",
        "caption": "RMA of New York Eastside location",
        "_source": {
          "url": "https://www.rmany.com/about-rmany/locations/manhattan/rma-eastside",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnrRL-2F4a_DFM5iaZqzQNi8bX0fGBVsgFViW7zyiz7sCkswM67UYNfPDBjgUjhZI-3S5Ou6DfaqLq6HRP2iYvYEyDHpBCENitYqpNY_SHVB4BF3yBMus036cprvjxATbpe0X8D8g=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+of+New+York:+Eastside,+635+Madison+Ave+10th+floor,+New+York,+NY+10022/@40.7637152,-73.9709963,3022a,13.1y/data=!4m2!3m1!1s0x89c258effb603415:0xf2316e6b3fdecd7e",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkXw3-2Fu7GtYIpkEDD9JL-F3ZLByFnr19VReRGhAoKEmGxQ_KsKcjd1DLil6XpcxiADcuFsxGdQkhVc6oKl7pXc2U8-IcTEg34e4ugpxYiBV1prXfX8zxp7B5OfM9o2JtpDXnB=w224-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+of+New+York:+Eastside,+635+Madison+Ave+10th+floor,+New+York,+NY+10022/@40.7637152,-73.9709963,3022a,13.1y/data=!4m2!3m1!1s0x89c258effb603415:0xf2316e6b3fdecd7e",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-306",
    "externalIds": {
      "cdcClinicId": "306",
      "googlePlaceId": "ChIJOyfyuMgr6IkRQtKiKSTA0kU"
    },
    "type": "fertility-clinic",
    "name": "RMA Long Island IVF",
    "phone": "(631) 752-0606",
    "address": {
      "line1": "8 Corporate Center Dr, Suite 101",
      "city": "Melville",
      "state": "NY",
      "zip": "11747",
      "country": "US"
    },
    "location": {
      "lat": 40.7748,
      "lng": -73.4075
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 44.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 45.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 38.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 21.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1136,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27306%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27306%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.rmalongislandivf.com/physicians/dr-beth-mcavey",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+of+New+York+-+Long+Island:+Melville,+8+Corporate+Center+Dr+%23101,+Melville,+NY+11747/@40.7747654,-73.4074312,3021a,13.1y/data=!4m2!3m1!1s0x89e82bc8b8f2273b:0x45d2c02429a2d242",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://rmany.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-306-beth-mcavey-md",
        "name": "Beth McAvey, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.rmalongislandivf.com/media/pages/physicians/dr-beth-mcavey/2932ec2afc-1729791156/md-beth_mcavey.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.rmalongislandivf.com/physicians/dr-beth-mcavey",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://rmany.com",
    "description": "Your browser does not support the security verification required by www.rmany.com. This can happen if your browser is either too old to support the latest security features or too new to be fully compatible.",
    "languages": ["English"],
    "network": {
      "name": "US Fertility"
    },
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "network-group",
    "consultationTypes": ["in-person", "telehealth"],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn2whb_ep0SOnYEturNiPh-ZVapv9KJ4WV07liCLxeUb7JiljIHtUMtWs0lH_QW8eN0M3fBj_hCpdggDTgb0FSqi_zpbqNfG-9f47hbZa8PUPvG84OpL8n2tgBbm3kqvR0E2SrJVFKiM7Qc=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+of+New+York+-+Long+Island:+Melville,+8+Corporate+Center+Dr+%23101,+Melville,+NY+11747/@40.7747654,-73.4074312,3021a,13.1y/data=!4m2!3m1!1s0x89e82bc8b8f2273b:0x45d2c02429a2d242",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-127",
    "externalIds": {
      "cdcClinicId": "127"
    },
    "type": "fertility-clinic",
    "name": "Rochester Regional Health Fertility Care",
    "phone": "(585) 453-7760",
    "address": {
      "line1": "1561 Long Pond Rd, Suite 410",
      "city": "Rochester",
      "state": "NY",
      "zip": "14626",
      "country": "US"
    },
    "location": {
      "lat": 43.1921,
      "lng": -77.7047
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 36.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 23.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 97,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27127%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27127%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.rochesterregional.org",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-127-jamil-mroueh-md",
        "name": "Jamil Mroueh, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.rochesterregional.org",
    "languages": ["English"],
    "images": [],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "boutique",
    "bookingUrl": "https://www.bostonivf.com/locations/rochester/",
    "consultationTypes": ["in-person", "telehealth"],
    "description": "Boston IVF - Rochester fertility clinic in Rochester, NY. Part of the Boston IVF network.",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-627",
    "externalIds": {
      "cdcClinicId": "627",
      "googlePlaceId": "ChIJRRXkugBZwokRjgHiGlbStGs"
    },
    "type": "fertility-clinic",
    "name": "Sher Fertility Solutions-New York",
    "phone": "(646) 792-7476",
    "address": {
      "line1": "425 Fifth Ave, 3rd Floor",
      "city": "New York",
      "state": "NY",
      "zip": "10016",
      "country": "US"
    },
    "location": {
      "lat": 40.751,
      "lng": -73.9825
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 20.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 30,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 3.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 298,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27627%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "scraped-retry",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://sherfertilitysolutions.com/our-team/dr-tortoriello/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Sher+Fertility+Solutions,+425+5th+Ave,+New+York,+NY+10016/@40.7510077,-73.982336,3023a,13.1y/data=!4m2!3m1!1s0x89c25900bae41545:0x6bb4d2561ae2018e",
            "fetchedAt": "2026-08-16"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27627%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-627-drew-v-tortoriello-md",
        "name": "Drew V. Tortoriello, MD",
        "role": "Medical Director",
        "imageUrl": "https://sherfertilitysolutions.com/wp-content/uploads/2024/11/dr-tortoriello.webp",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://sherfertilitysolutions.com/our-team/dr-tortoriello/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://haveababy.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm6Ul5HiDz_R0ymPtO79y29p9DdH7kCqKIE1cocPYUP9MLVP-rmR0kUXVFn_QHH6FZrkewkvFIHGDW7WjRBvcU-dtlenogOcY1np6S8dGeRYcDwZ7tlCXNpecWBxcp12FL4w-845A=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Sher+Fertility+Solutions,+425+5th+Ave,+New+York,+NY+10016/@40.7510077,-73.982336,3023a,13.1y/data=!4m2!3m1!1s0x89c25900bae41545:0x6bb4d2561ae2018e",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkGcS2h1h0IJoFQnDgokdLAZphr88D7S80fgYw-SozKX1N3NALOI5arjBRwTnWZ7rbsqJQtJuMIo0YkltBlaQ7fpNhFpnwJOQHCrDzrIExDSBPVJdQduQhthLfQulpUbr3eJoDU=w224-h398-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Sher+Fertility+Solutions,+425+5th+Ave,+New+York,+NY+10016/@40.7510077,-73.982336,3023a,13.1y/data=!4m2!3m1!1s0x89c25900bae41545:0x6bb4d2561ae2018e",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-880",
    "externalIds": {
      "cdcClinicId": "880",
      "googlePlaceId": "ChIJjQ2lb8VZwokRNb4RwKLTu7o"
    },
    "type": "fertility-clinic",
    "name": "Spring Fertility-New York",
    "phone": "(646) 568-5638",
    "address": {
      "line1": "114 W. 41st St, 2nd Floor",
      "city": "New York",
      "state": "NY",
      "zip": "10036",
      "country": "US"
    },
    "location": {
      "lat": 40.7545,
      "lng": -73.9855
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 55.55555555555556,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/9"
        },
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "0/5"
        }
      ],
      "cyclesPerYear": 33,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27880%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27880%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://springfertility.com/newyorkcity/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Spring+Fertility,+114+W+41st+St+2nd+Floor,+New+York,+NY+10036/@40.7544099,-73.9856036,3022a,13.1y/data=!4m2!3m1!1s0x89c259c56fa50d8d:0xbabbd3a2c011be35",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://springfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-880-catha-fischer-md",
        "name": "Catha Fischer, MD",
        "role": "Medical Director",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2021/07/Spring_NY_-Catha.png",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://springfertility.com/team/dr-catha-fischer/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://springfertility.com",
    "languages": ["English"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlho34LKsWniaaYNsfSGY0YmpFBN1Os9UbhEcoRoCawWQKD4O_kutbDlB3pknO1h6QyBRJnWWHHC-Iaisx_RbryerNDYYq2qMzRmYgipVnvZjNeNawsN01wKc44l7j7-W_RzCl7Wg=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Spring+Fertility,+114+W+41st+St+2nd+Floor,+New+York,+NY+10036/@40.7544099,-73.9856036,3022a,13.1y/data=!4m2!3m1!1s0x89c259c56fa50d8d:0xbabbd3a2c011be35",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlZWeMWKOMF4qaMN7c3lqoFQcf5kC0frf8BjV6yMQ-WRD5dDoKOh7AyvbvdrUdS6gY5SazbDeWAdqAdwOPQTpzfLsYIQ9dOGdSvQ2NjU0h4ju6NBFnO1g-9-DF0rMxBH8So0mQl=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Spring+Fertility,+114+W+41st+St+2nd+Floor,+New+York,+NY+10036/@40.7544099,-73.9856036,3022a,13.1y/data=!4m2!3m1!1s0x89c259c56fa50d8d:0xbabbd3a2c011be35",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "network": {
      "name": "Spring Fertility"
    },
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "pricing": {
      "packages": [
        {
          "name": "Initial Consultation",
          "description": "First visit to assess fertility and create a plan",
          "price": 25000,
          "priceMax": 54500,
          "currency": "USD",
          "includes": ["Ultrasound", "Physical exam", "Physician consultation"],
          "notes": "Bloodwork billed through insurance if applicable, otherwise ~$200 out-of-pocket"
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Complete egg freezing cycle including anesthesia",
          "price": 896400,
          "priceMax": 996000,
          "locationPrices": [
            {
              "location": "San Francisco",
              "price": 996000
            },
            {
              "location": "New York",
              "price": 996000
            },
            {
              "location": "Oregon",
              "price": 896400
            }
          ],
          "currency": "USD",
          "includes": [
            "Monitoring appointments",
            "Anesthesia",
            "Retrieval",
            "Cryopreservation"
          ],
          "notes": "$9,960 for SF & NY locations; $8,964 for Oregon. Anesthesia is included (unlike most clinics)."
        },
        {
          "name": "Medication Package",
          "description": "Pre-negotiated pharmacy rates tailored to your protocol",
          "price": 390000,
          "priceMax": 510000,
          "currency": "USD",
          "includes": [
            "All medications for cycle",
            "Refills if protocol changes"
          ],
          "notes": "Patients save ~$1,500 on average. Federal assistance may reduce cost by $500 - $750/cycle."
        },
        {
          "name": "Future IVF (using frozen eggs)",
          "description": "Complete path from thaw to transfer when you're ready",
          "price": 2300000,
          "priceMax": 2500000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Blastocyst development",
            "Genetic testing",
            "FET medication",
            "Transfer"
          ]
        }
      ],
      "financingOptions": [
        {
          "name": "Internal Payment Plan",
          "description": "Low monthly payments with no down payment",
          "details": [
            "Under $300/month",
            "No down payment required",
            "Covers cycle cost only"
          ],
          "exclusions": "Does not cover consultation, medications, or storage fees",
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "PatientFi Financing",
          "description": "Healthcare financing with flexible repayment terms",
          "details": [
            "Third-party healthcare financing",
            "Flexible repayment options",
            "Quick approval process"
          ],
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "Multi-Cycle Discount",
          "description": "10% off for self-pay patients doing multiple cycles",
          "details": [
            "10% discount on additional cycles",
            "Available to self-pay patients only"
          ],
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "Spring Promise (Shared Risk)",
          "description": "Full refund if pregnancy is not achieved for qualifying patients",
          "details": [
            "Full refund guarantee if pregnancy not achieved",
            "Designed for qualifying egg freezing patients"
          ],
          "eligibility": "20 eggs by age 35, or 30 eggs by age 38",
          "exclusions": "IVF, anesthesia, and medications are excluded from the refund",
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        }
      ],
      "_source": {
        "url": "https://springfertility.com/pricing/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "4 public price package(s) and 4 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://springfertility.com/pricing/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-357",
    "externalIds": {
      "cdcClinicId": "357"
    },
    "type": "fertility-clinic",
    "name": "Strong Fertility Center",
    "phone": "(585) 487-3378",
    "address": {
      "line1": "500 Red Creek Dr, Suite 220",
      "city": "Rochester",
      "state": "NY",
      "zip": "14623",
      "country": "US"
    },
    "location": {
      "lat": 43.0645,
      "lng": -77.6303
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 35.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 29.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 29.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 9.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 460,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27357%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "minimal",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.urmc.rochester.edu/strong-fertility-center/our-team",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27357%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-357-erin-m-masaba-md",
        "name": "Erin M. Masaba, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.urmc.rochester.edu/ecv_binary/faculty/generated/profile_web/25147.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.urmc.rochester.edu/strong-fertility-center/our-team",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.urmc.rochester.edu/ob-gyn/fertility.aspx",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-113",
    "externalIds": {
      "cdcClinicId": "113",
      "googlePlaceId": "ChIJIUm_FxNgwokRkkDZcF_pQYM"
    },
    "type": "fertility-clinic",
    "name": "The New York Fertility Center",
    "phone": "(718) 261-9068",
    "address": {
      "line1": "42-31 Colden St, Suite 202",
      "city": "Flushing",
      "state": "NY",
      "zip": "11355",
      "country": "US"
    },
    "location": {
      "lat": 40.7539,
      "lng": -73.8262
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 26,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 20.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 10.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 3.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 332,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27113%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "scraped-retry",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://newyorkfertilitycenter.com/providers",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/The+New+York+Fertility+Center,+42-31+Colden+St+Ste+202,+Flushing,+NY+11355/@40.7539009,-73.8261514,3022a,13.1y/data=!4m2!3m1!1s0x89c2601317bf4921:0x8341e95f70d94092",
            "fetchedAt": "2026-08-16"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27113%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-113-tony-tsai-md",
        "name": "Tony Tsai, MD",
        "role": "Medical Director",
        "imageUrl": "https://img1.wsimg.com/isteam/ip/ee1a8fb2-3763-4950-9266-0f1919b0bce0/tsai.jpg/:/cr=t:0%25,l:10.33%25,w:79.35%25,h:100%25/rs=w:460,h:460,cg:true",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://newyorkfertilitycenter.com/providers",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.nyfertilitycenter.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-437",
    "externalIds": {
      "cdcClinicId": "437",
      "googlePlaceId": "ChIJ63hd5sNYwokRufLoZ4JpqrY"
    },
    "type": "fertility-clinic",
    "name": "Weill Cornell Medicine, Center for Reproductive Medicine",
    "description": "Academic medical center affiliated with NewYork-Presbyterian, with over 21,000 IVF babies born and its own PGT and reproductive endocrinology labs.",
    "website": "https://ivf.org",
    "phone": "(646) 962-2764",
    "bookingUrl": "https://ivf.org/contact-us",
    "address": {
      "line1": "1305 York Ave, 6th Floor",
      "city": "New York",
      "state": "NY",
      "zip": "10021",
      "country": "US"
    },
    "location": {
      "lat": 40.7655,
      "lng": -73.9552
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 46.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 42.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 33.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 15.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 3311,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27437%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "languages": ["English", "es"],
    "consultationTypes": ["in-person", "telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27437%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "scraped"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://ivf.org/about-us/facilities",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Weill+Cornell+Medicine+Center+for+Reproductive+Medicine+and+Infertility,+1305+York+Ave+6th+floor,+New+York,+NY+10021/@40.7656564,-73.9552982,3022a,13.1y/data=!4m2!3m1!1s0x89c258c3e65d78eb:0xb6aa698267e8f2b9",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://ivf.org",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-437-zev-rosenwaks-md",
        "name": "Zev Rosenwaks, MD",
        "role": "Medical Director",
        "imageUrl": "https://ivf.org/sites/default/files/img18.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://ivf.org/about-us/physicians/zev-rosenwaks-md",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "images": [
      {
        "url": "https://ivf.org/sites/default/files/styles/panopoly_image_original/public/weill_greenberg_center.jpg?itok=wYVk5WvV",
        "type": "exterior",
        "caption": "Weill Greenberg Center",
        "_source": {
          "url": "https://ivf.org/about-us/facilities",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlmIeCSPE6F1UJcUeAinNS3J8H2R9BeqoLJOpZJx5clStnkSqsTe4cyCKzbKKChFFejG5QQEE2gAqlKNHVi0HU-zjPBLA_I8nIxdCHEcbVmq-mBRWBZoUl7WH7n3Km-S5KssqzJ=w224-h398-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Weill+Cornell+Medicine+Center+for+Reproductive+Medicine+and+Infertility,+1305+York+Ave+6th+floor,+New+York,+NY+10021/@40.7656564,-73.9552982,3022a,13.1y/data=!4m2!3m1!1s0x89c258c3e65d78eb:0xb6aa698267e8f2b9",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnKXcd9pTdbbl4feS0k348Mk4JR9eeKzNUwWqhjYdWheLlThX8uuXsStBoErVfcM_TlqhxiuRMQW2EQbMP32L3AGUO9qDNRyLSt5KNJffnhCLy5T8quN1qXYqWBnkYA740he8ZwPvH9HzE=w140-h248-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Weill+Cornell+Medicine+Center+for+Reproductive+Medicine+and+Infertility,+1305+York+Ave+6th+floor,+New+York,+NY+10021/@40.7656564,-73.9552982,3022a,13.1y/data=!4m2!3m1!1s0x89c258c3e65d78eb:0xb6aa698267e8f2b9",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-47",
    "externalIds": {
      "cdcClinicId": "47",
      "googlePlaceId": "ChIJd114ZDuUwokRLh7IVUdZsVs"
    },
    "type": "fertility-clinic",
    "name": "Westchester Fertility & Reproductive Endocrinology",
    "phone": "(914) 949-6677",
    "address": {
      "line1": "136 S. Broadway",
      "city": "White Plains",
      "state": "NY",
      "zip": "10605",
      "country": "US"
    },
    "location": {
      "lat": 41.0262,
      "lng": -73.7612
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 23.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 36,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 125,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2747%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2747%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.westchesterfertility.com/about-dr-blotner/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Westchester+Fertility+%26+Reproductive+Endocrinology,+136+S+Broadway+%23100,+White+Plains,+NY+10605/@41.0262308,-73.7611546,3010a,13.1y/data=!4m2!3m1!1s0x89c2943b64785d77:0x5bb1594755c81e2e",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.westchesterfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-47-michael-b-blotner-md",
        "name": "Michael B. Blotner, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.westchesterfertility.com/wp-content/uploads/2017/05/page-image_dr-blotner.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.westchesterfertility.com/about-dr-blotner/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.westchesterfertility.com",
    "description": "- LGBTQ & Same\\-Sex Fertility Services: White Plains, Westchester & Rockland Counties",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Blue Cross",
        "Blue Shield",
        "Cigna",
        "Tricare",
        "Oxford",
        "Oscar",
        "Empire",
        "Horizon",
        "BCBS"
      ],
      "_source": {
        "url": "https://www.westchesterfertility.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "images": [],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Blue Cross, Blue Shield, Cigna, Tricare, Oxford, Oscar, Empire, Horizon",
              "detail": "1 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.westchesterfertility.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-625",
    "externalIds": {
      "cdcClinicId": "625",
      "googlePlaceId": "ChIJj5TAWB-XwokRkiVzG-Zti60"
    },
    "type": "fertility-clinic",
    "name": "Westmed Reproductive Services",
    "phone": "(914) 607-6213",
    "address": {
      "line1": "3030 Westchester Ave",
      "city": "Purchase",
      "state": "NY",
      "zip": "10577",
      "country": "US"
    },
    "location": {
      "lat": 41.0095,
      "lng": -73.6963
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 47.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 52.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 41.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 40.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 299,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27625%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27625%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Summit+Health+-+Purchase+(formerly+Westmed+Medical+Group),+3030+Westchester+Ave,+Purchase,+NY+10577/@41.0094546,-73.6963082,3011a,13.1y/data=!4m2!3m1!1s0x89c2971f58c0948f:0xad8b6de61b732592",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.westmedgroup.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-625-martin-d-keltz-md",
        "name": "Martin D. Keltz, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.westmedgroup.com",
    "description": "Summit Health’s Westmed Medical Group providers and staff provide high\\-quality care for every health condition and throughout every stage of life. Our patients benefit from an expanded network of primary care and multispecialty services, plus top\\-notch urgent care.",
    "languages": ["English"],
    "images": [],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Empire Blue Cross",
        "Healthfirst"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Empire Blue Cross, Healthfirst",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-895",
    "externalIds": {
      "cdcClinicId": "895",
      "googlePlaceId": "ChIJm2MJuPVz04kR6AZ1925pD7o"
    },
    "type": "fertility-clinic",
    "name": "Your Family Fertility",
    "phone": "(716) 243-8377",
    "address": {
      "line1": "630 Frankhauser",
      "city": "Williamsville",
      "state": "NY",
      "zip": "14221",
      "country": "US"
    },
    "location": {
      "lat": 43.0004,
      "lng": -78.8009
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 11,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27895%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27895%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.yourfamilyfertility.com/new-page",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Your+Family+Fertility:+Krystene+DiPaola+MD,+630+Frankhauser+Rd,+Buffalo,+NY+14221/@42.9898681,-78.7886597,2918a,13.1y/data=!4m2!3m1!1s0x89d373f5b809639b:0xba0f696ef77506e8",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.yourfamilyfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-895-krystene-b-dipaola-md",
        "name": "Krystene B. DiPaola, MD",
        "role": "Medical Director",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/5f343d9f4dd3285faba8c1af/1605103304329-AQFB35Z9QMJAEVHEYRY3/Dr.D.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.yourfamilyfertility.com/new-page",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.yourfamilyfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Anthem",
        "Blue Cross",
        "Blue Shield",
        "Empire",
        "Highmark",
        "BCBS"
      ],
      "employeeBenefits": ["WINFertility", "Kindbody"],
      "_source": {
        "url": "https://www.yourfamilyfertility.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkDoiYQ6vKX2D4syHL9ORYI3z83ob4BbpBVD1bawuw59fP_bggqu0BP9QPQ6PkYA9uMyhDiA9qYAKngE6PpM8-3k4g1E4UZeqmG9nNaTAdpJbBf8hvFysqVhtJbFB4Zh4Wv0b7K=w259-h120-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Your+Family+Fertility:+Krystene+DiPaola+MD,+630+Frankhauser+Rd,+Buffalo,+NY+14221/@42.9898681,-78.7886597,2918a,13.1y/data=!4m2!3m1!1s0x89d373f5b809639b:0xba0f696ef77506e8",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Anthem, Blue Cross, Blue Shield, Empire, Highmark, BCBS",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.yourfamilyfertility.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-285",
    "externalIds": {
      "cdcClinicId": "285",
      "googlePlaceId": "ChIJNQQ9exFUQIgRmI4TuYW3Dsw"
    },
    "type": "fertility-clinic",
    "name": "Bethesda Fertility Center",
    "phone": "(513) 865-1675",
    "address": {
      "line1": "10506 Montgomery Rd, Suite 303",
      "city": "Cincinnati",
      "state": "OH",
      "zip": "45242",
      "country": "US"
    },
    "location": {
      "lat": 39.2513,
      "lng": -84.3405
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 43.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 52.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 18.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "0/9"
        }
      ],
      "cyclesPerYear": 192,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27285%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27285%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.bethesdafertility.com",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Bethesda+Fertility+Center,+10506+Montgomery+Rd+Ste+303,+Montgomery,+OH+45242/@39.251234,-84.340475,3090a,13.1y/data=!4m2!3m1!1s0x884054117b3d0435:0xcc0eb785b9138e98",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-285-isela-m-robertshaw-md",
        "name": "Isela M. Robertshaw, MD",
        "role": "Medical Director",
        "imageUrl": "https://b3252928.smushcdn.com/3252928/wp-content/uploads/2025/07/robertshaw-updated-circle.png",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.bethesdafertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Ohio (OH) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnwMJgDnQkzfsEiLeQJjyCFDWiBh8-eKhyld17upJiEjOdPPNyefHJ9SNzHelNvHYOM2bEbuthY7HF1ROIQqdnYXHD1yTSB3pDz4w8MSfuctLfW9CUtWZkRblxbqC_IWxDvtgZ3=w408-h611-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Bethesda+Fertility+Center,+10506+Montgomery+Rd+Ste+303,+Montgomery,+OH+45242/@39.251234,-84.340475,3090a,13.1y/data=!4m2!3m1!1s0x884054117b3d0435:0xcc0eb785b9138e98",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-380",
    "externalIds": {
      "cdcClinicId": "380"
    },
    "type": "fertility-clinic",
    "name": "Cleveland Clinic Fertility Center",
    "phone": "(216) 839-3150",
    "address": {
      "line1": "26900 Cedar Rd, Suite 220S",
      "city": "Beachwood",
      "state": "OH",
      "zip": "44122",
      "country": "US"
    },
    "location": {
      "lat": 41.5005,
      "lng": -81.4892
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 56.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 47.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 45.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 26.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 557,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27380%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27380%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://my.clevelandclinic.org/departments/fertility",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-380-marjan-attaran-md",
        "name": "Marjan Attaran, MD",
        "role": "Medical Director",
        "imageUrl": "https://assets.clevelandclinic.org/transform/db021a00-508e-47ed-a954-ea26a614b2bf/marjan-attaran-md",
        "credentials": ["MD"],
        "_source": {
          "url": "https://providers.clevelandclinic.org/provider/marjan-attaran/4270506",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Mindy Christianson",
        "role": "Chief, Reproductive Endocrinology and Infertility; Practice Director, Cleveland Clinic Fertility Center",
        "credentials": ["MD", "MBA"],
        "imageUrl": "https://assets.clevelandclinic.org/transform/14da8717-bf09-4b08-b6db-300e3c39ba56/mindy-s-christianson-md",
        "_source": {
          "url": "https://providers.clevelandclinic.org/provider/mindy-christianson/4270551",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-380-mindy-christianson"
      },
      {
        "name": "Julierut Tantibhedhyangkul",
        "role": "Reproductive Endocrinologist; Director of Ultrasound Services, Division of Reproductive Endocrinology and Infertility",
        "credentials": ["MD"],
        "imageUrl": "https://assets.clevelandclinic.org/transform/493ff9f0-362b-41e4-aa59-d6af87683ec4/julierut-tantibhedhyangkul-md",
        "_source": {
          "url": "https://providers.clevelandclinic.org/provider/julierut-tantibhedhyangkul/4269525",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-380-julierut-tantibhedhyangkul"
      },
      {
        "name": "Lili Mickey",
        "role": "Nurse Practitioner, Reproductive Endocrinology and Infertility",
        "credentials": ["CNP"],
        "imageUrl": "https://assets.clevelandclinic.org/transform/24e35c95-a5d9-476e-b098-34dbbe76b358/liliana-g-mickey-cnp",
        "_source": {
          "url": "https://providers.clevelandclinic.org/provider/lili-mickey/4266982",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-380-lili-mickey"
      },
      {
        "name": "Katie Donnelly",
        "role": "Nurse Practitioner, Reproductive Endocrinology and Infertility",
        "credentials": ["CNP"],
        "imageUrl": "https://assets.clevelandclinic.org/transform/59557a63-5786-4359-89ed-77fec0cba47b/katie-donnelly-cnp",
        "_source": {
          "url": "https://providers.clevelandclinic.org/specialty/Reproductive%20Endocrinology%20and%20Infertility/near/Beachwood,%20OH?page=1",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-380-katie-donnelly"
      },
      {
        "name": "Lauren Mindzora",
        "role": "Nurse Practitioner, Reproductive Endocrinology and Infertility",
        "credentials": ["CNP"],
        "imageUrl": "https://assets.clevelandclinic.org/transform/f18a150b-1df4-4805-90b1-d90dfe357c8f/lauren-m-mindzora-cnp",
        "_source": {
          "url": "https://providers.clevelandclinic.org/specialty/Reproductive%20Endocrinology%20and%20Infertility/near/Beachwood,%20OH?page=1",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-380-lauren-mindzora"
      }
    ],
    "website": "https://my.clevelandclinic.org/departments/reproductive-endocrinology",
    "description": "Cleveland Clinic Fertility Center provides comprehensive reproductive endocrinology and infertility services with nationally ranked specialists.",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Humana",
        "Medical Mutual",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "images": [
      {
        "url": "https://my.clevelandclinic.org/-/scassets/images/org/fertility/fertility-lab.jpg",
        "type": "lab",
        "caption": "Cleveland Clinic Fertility Center IVF procedure room with surgical lights, exam table and equipment",
        "_source": {
          "url": "https://my.clevelandclinic.org/departments/fertility",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Humana, Medical Mutual, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Ohio (OH) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-143",
    "externalIds": {
      "cdcClinicId": "143",
      "googlePlaceId": "ChIJa5xxuICyQYgRbrr-CzxwscE"
    },
    "type": "fertility-clinic",
    "name": "Institute for Reproductive Health",
    "phone": "(513) 924-5546",
    "address": {
      "line1": "3805 Edwards Rd, Suite 450",
      "city": "Cincinnati",
      "state": "OH",
      "zip": "45209",
      "country": "US"
    },
    "location": {
      "lat": 39.1484,
      "lng": -84.444
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 43.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 37.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 38.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 19.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 869,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27143%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27143%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://cincinnatifertility.com/meet-our-team/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Institute+for+Reproductive+Health+%7C+Cincinnati+Fertility,+3805+Edwards+Rd+4th+Floor+Suite+%23450,+Cincinnati,+OH+45209/@39.1483153,-84.4439324,3094a,13.1y/data=!4m2!3m1!1s0x8841b280b8719c6b:0xc1b1703c0bfeba6e",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-143-michael-d-scheiber-md",
        "name": "Michael D. Scheiber, MD",
        "role": "Medical Director",
        "imageUrl": "https://b3252928.smushcdn.com/3252928/wp-content/uploads/2025/07/scheiber-updated-circle.png",
        "credentials": ["MD", "MPH", "FACOG"],
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Isela Robertshaw, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://b3252928.smushcdn.com/3252928/wp-content/uploads/2025/07/robertshaw-updated-circle.png",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-143-isela-robertshaw-md-facog"
      },
      {
        "name": "Vinita Alexander, MD, MSCI, FACOG",
        "role": "Reproductive Endocrinologist (REI specialist and OB/GYN)",
        "credentials": ["MD", "MSCI", "FACOG"],
        "imageUrl": "https://b3252928.smushcdn.com/3252928/wp-content/uploads/2025/08/alexander-circle-2025.png",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-143-vinita-alexander-md-msci-facog"
      },
      {
        "name": "Michael Awadalla, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://b3252928.smushcdn.com/3252928/wp-content/uploads/2025/07/michal-awadalla-circle-updated.png",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-143-michael-awadalla-md-facog"
      },
      {
        "name": "Marja King, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://b3252928.smushcdn.com/3252928/wp-content/uploads/2025/07/king-updated-circle.png",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-143-marja-king-md-facog"
      },
      {
        "name": "Mercedes Fussnecker, MSN, CNP, WHNP-BC, C-RHI",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "CNP", "WHNP-BC", "C-RHI"],
        "imageUrl": "https://b3252928.smushcdn.com/3252928/wp-content/uploads/2025/07/fussnecker-updated-circle.png",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-143-mercedes-fussnecker-msn-cnp-whnp-bc-c-rhi"
      },
      {
        "name": "Nikki Meyer, MSN, FNP-C",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "FNP-C"],
        "imageUrl": "https://b3252928.smushcdn.com/3252928/wp-content/uploads/2025/07/meyer-updated-circle.png",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-143-nikki-meyer-msn-fnp-c"
      },
      {
        "name": "Melissa Doepker, BSN, RNC-NIC, C-RHI",
        "role": "Registered Nurse",
        "credentials": ["BSN", "RNC-NIC", "C-RHI"],
        "imageUrl": "https://b3252928.smushcdn.com/3252928/wp-content/uploads/2025/07/doepker-updated-circle.png",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-143-melissa-doepker-bsn-rnc-nic-c-rhi"
      }
    ],
    "website": "https://www.infertilityanswer.com",
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Ohio (OH) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-136",
    "externalIds": {
      "cdcClinicId": "136",
      "googlePlaceId": "ChIJAWqkhKqNOIgRpkj60eW0l3c"
    },
    "type": "fertility-clinic",
    "name": "Ohio Reproductive Medicine",
    "phone": "(614) 451-2280",
    "address": {
      "line1": "535 Reach Blvd, Suite 200",
      "city": "Columbus",
      "state": "OH",
      "zip": "43215",
      "country": "US"
    },
    "location": {
      "lat": 40.0585,
      "lng": -83.0381
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 33.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 33.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 20.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 14.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 534,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27136%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27136%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://ohioreproductivemedicine.com/our-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Ohio+Reproductive+Medicine,+535+Reach+Blvd+Ste+200,+Columbus,+OH+43215/@39.9723518,-83.0184026,3058a,13.1y/data=!4m2!3m1!1s0x88388daa84a46a01:0x7797b4e5d1fa48a6",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-136-grant-e-schmidt-md-phd",
        "name": "Grant E. Schmidt, MD, PHD",
        "role": "Medical Director",
        "imageUrl": "https://ohioreproductivemedicine.com/wp-content/uploads/2024/05/Dr.-Grant-Schmidt-Fertility-Specialist-Ohio-e1715512714315.jpg",
        "credentials": ["MD", "PhD", "FACOG"],
        "_source": {
          "url": "https://ohioreproductivemedicine.com/our-team/grant-schmidt-m-d-ph-d/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Brooke Rossi, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://ohioreproductivemedicine.com/wp-content/uploads/2024/05/2-2-1.png",
        "_source": {
          "url": "https://ohioreproductivemedicine.com/our-team/brooke-rossi-m-d/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-136-brooke-rossi-md"
      },
      {
        "name": "Laura Londra, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://ohioreproductivemedicine.com/wp-content/uploads/2024/05/1-2.png",
        "_source": {
          "url": "https://ohioreproductivemedicine.com/our-team/laura-londra-m-d/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-136-laura-londra-md"
      }
    ],
    "website": "https://www.ohioreproductivemedicine.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Medical Mutual",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "bookingUrl": "https://rmanetwork.com/our-locations/ohio-reproductive-medicine-fertility-clinic/",
    "description": "Ohio Reproductive Medicine fertility clinic in Columbus, OH. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "images": [
      {
        "url": "https://ohioreproductivemedicine.com/wp-content/uploads/2024/05/243121802_4795147827173527_8586886985304372147_n.jpg",
        "type": "exterior",
        "caption": "Ohio Reproductive Medicine building exterior with signage at 535 Reach Blvd, Columbus",
        "_source": {
          "url": "https://ohioreproductivemedicine.com/our-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://ohioreproductivemedicine.com/wp-content/uploads/2024/05/IMG_7241-768x576-1.jpg",
        "type": "interior",
        "caption": "Patient waiting room with seating and stone accent wall",
        "_source": {
          "url": "https://ohioreproductivemedicine.com/our-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://ohioreproductivemedicine.com/wp-content/uploads/2024/05/Screen-Shot-2021-12-08-at-2.04.39-PM-768x576-1.png",
        "type": "interior",
        "caption": "Interior lounge/reception seating area",
        "_source": {
          "url": "https://ohioreproductivemedicine.com/our-center/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Medical Mutual, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Ohio (OH) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-382",
    "externalIds": {
      "cdcClinicId": "382"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Gynecology & Infertility-Akron",
    "phone": "(330) 375-7722",
    "address": {
      "line1": "95 Arch St, Suite 250",
      "city": "Akron",
      "state": "OH",
      "zip": "44304",
      "country": "US"
    },
    "location": {
      "lat": 41.0823,
      "lng": -81.4995
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 55,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 49.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 51.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 671,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27382%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27382%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/akron-oh/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-382-david-m-nash-md",
        "name": "David M. Nash, MD",
        "role": "Medical Director",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-David-Nash_OH_Square-1024x1024.png",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-david-m-nash/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Priya B. Maseelall, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Priya-Maseelall_OH_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-priya-b-maseelall/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-382-priya-b-maseelall-md-facog"
      },
      {
        "name": "Jessica R. Zolton, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/03/Dr.-Jessica-Zolton_OH-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-jessica-r-zolton/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-382-jessica-r-zolton-md-facog"
      },
      {
        "name": "Christy MacKay, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/02/Christy-Mckay-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/christy-mackay-pa-c/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-382-christy-mackay-pa-c"
      }
    ],
    "website": "https://www.rfrms.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Medical Mutual",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/Akron-3-768x1024.jpg",
        "type": "interior",
        "caption": "Interior waiting lounge with cushioned seating at the Akron clinic (95 Arch St, Suite 250)",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/akron-oh/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/Akron-4-768x1024.jpg",
        "type": "interior",
        "caption": "Interior reception / front desk area of the Akron clinic",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/akron-oh/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Medical Mutual, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Ohio (OH) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-262",
    "externalIds": {
      "cdcClinicId": "262"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Gynecology & Infertility-Westerville",
    "phone": "(614) 895-3333",
    "address": {
      "line1": "540 N. Cleveland Ave, Suite 100",
      "city": "Westerville",
      "state": "OH",
      "zip": "43082",
      "country": "US"
    },
    "location": {
      "lat": 40.1404,
      "lng": -82.9466
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 59.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 57.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 47.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 31.25,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/16"
        }
      ],
      "cyclesPerYear": 482,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27262%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27262%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/columbus-oh/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-262-david-m-nash-md",
        "name": "David M. Nash, MD",
        "role": "Medical Director",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-David-Nash_OH_Square-1024x1024.png",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-david-m-nash/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Akas Jain, MD",
        "role": "Medical Director, Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Akas-Jain_OH_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/columbus-oh/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-262-akas-jain-md"
      },
      {
        "name": "Rachel E. Warwar, MD",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/03/Dr.-Rachel-Warwar_OH-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-rachel-e-warwar/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-262-rachel-e-warwar-md"
      },
      {
        "name": "Stacia Cheadle, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/02/Stacia-Cheadle-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/stacia-cheadle/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-262-stacia-cheadle-pa-c"
      },
      {
        "name": "Allison Headly, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/02/Allison-Headly-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/allison-headly/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-262-allison-headly-pa-c"
      }
    ],
    "website": "https://www.rfrms.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Medical Mutual",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/Westerville_Columbus1-e1741807306800.jpg",
        "type": "exterior",
        "caption": "Building exterior of the clinic at 540 N. Cleveland Ave, Westerville, OH (street number '540' visible above the entrance).",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/columbus-oh/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/Westerville_Columbus3.jpg",
        "type": "interior",
        "caption": "Waiting room / reception lobby interior.",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/columbus-oh/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/Westerville_Columbus2.jpg",
        "type": "interior",
        "caption": "Exam / procedure room with ultrasound equipment.",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/columbus-oh/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/Westerville_Columbus4.jpg",
        "type": "lab",
        "caption": "Embryology / IVF laboratory with incubators and an embryologist at a microscope.",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/columbus-oh/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Medical Mutual, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Ohio (OH) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-618",
    "externalIds": {
      "cdcClinicId": "618",
      "googlePlaceId": "ChIJkwhDDSaJQIgRdvS1XDAABfw"
    },
    "type": "fertility-clinic",
    "name": "SpringCreek Fertility",
    "phone": "(937) 458-5084",
    "address": {
      "line1": "7095 Clyo Rd",
      "city": "Dayton",
      "state": "OH",
      "zip": "45459",
      "country": "US"
    },
    "location": {
      "lat": 39.6422,
      "lng": -84.1389
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 42.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 28.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 349,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27618%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27618%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.springcreekfertility.com/fertility-specialists/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/SpringCreek+Fertility,+7095+Clyo+Rd,+Dayton,+OH+45459/@39.6422262,-84.1389395,3072a,13.1y/data=!4m2!3m1!1s0x884089260d430893:0xfc0500305cb5f476",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-618-jeremy-m-groll-md",
        "name": "Jeremy M. Groll, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.springcreekfertility.com/wp-content/uploads/2021/08/Dr.-Jeremy-Groll.png",
        "credentials": ["MD", "REI", "OB/GYN"],
        "_source": {
          "url": "https://www.springcreekfertility.com/doctor-jeremy-groll/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Kasey Reynolds Marelić",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD", "REI", "OB/GYN"],
        "imageUrl": "https://www.springcreekfertility.com/wp-content/uploads/2025/05/luxe-3d-cincinnati-real-estate-photographer-03-673x1024.jpg",
        "_source": {
          "url": "https://www.springcreekfertility.com/dr-kasey-marelic/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-618-kasey-reynolds-marelic"
      },
      {
        "name": "Julie Cuy Castellanos",
        "role": "Women's Health Nurse Practitioner",
        "credentials": ["WHNP-BC", "C-RHI"],
        "imageUrl": "https://www.springcreekfertility.com/wp-content/uploads/2021/11/5d977a7067514julie-at-spring-creek-fertility.jpeg",
        "_source": {
          "url": "https://www.springcreekfertility.com/julie-cuy-castellanos-whnp-bc/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-618-julie-cuy-castellanos"
      },
      {
        "name": "Emily McMillan",
        "role": "Women's Health Nurse Practitioner",
        "credentials": ["MSN", "APRN", "FNP-BC"],
        "imageUrl": "https://www.springcreekfertility.com/wp-content/uploads/2023/10/Emily-McMillan-for-web-.jpg",
        "_source": {
          "url": "https://www.springcreekfertility.com/emily-mcmillan-whnp/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-618-emily-mcmillan"
      }
    ],
    "website": "https://www.springcreekfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://www.springcreekfertility.com/wp-content/uploads/2021/10/ExteriorPic3.jpg",
        "type": "exterior",
        "caption": "SpringCreek Fertility building exterior in Dayton, Ohio",
        "_source": {
          "url": "https://www.springcreekfertility.com/tour/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.springcreekfertility.com/wp-content/uploads/2021/10/WaitingRm.jpg",
        "type": "interior",
        "caption": "Patient waiting room",
        "_source": {
          "url": "https://www.springcreekfertility.com/tour/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.springcreekfertility.com/wp-content/uploads/2021/10/PatientRm.jpg",
        "type": "interior",
        "caption": "Patient exam room",
        "_source": {
          "url": "https://www.springcreekfertility.com/tour/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.springcreekfertility.com/wp-content/uploads/2021/10/ProcedureRm.jpg",
        "type": "interior",
        "caption": "Procedure room",
        "_source": {
          "url": "https://www.springcreekfertility.com/tour/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.springcreekfertility.com/wp-content/uploads/2021/10/Recovery.jpg",
        "type": "interior",
        "caption": "Recovery room",
        "_source": {
          "url": "https://www.springcreekfertility.com/tour/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.springcreekfertility.com/wp-content/uploads/2021/10/dayton-ivf-lab.jpg",
        "type": "lab",
        "caption": "On-site IVF embryology laboratory",
        "_source": {
          "url": "https://www.springcreekfertility.com/tour/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.springcreekfertility.com/wp-content/uploads/2021/10/andrology-lab.jpg",
        "type": "lab",
        "caption": "Andrology laboratory",
        "_source": {
          "url": "https://www.springcreekfertility.com/tour/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.springcreekfertility.com/wp-content/uploads/2021/10/IVF_Isolette.jpg",
        "type": "lab",
        "caption": "IVF isolette workstation in the embryology lab",
        "_source": {
          "url": "https://www.springcreekfertility.com/tour/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmKDPmQhyGCwEbwMCE8mr76S8iVnsAdtEEVTZg8j3iLNawsq_pTqj4QqL7a78SW9wYOFJxOP2zpNNPI78Tej4Vh0rk1x29vlvjPEbfROdcdh4XPC8Q67MJ9ccTIzAYsn2RMpR9KsBif0N4v=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/SpringCreek+Fertility,+7095+Clyo+Rd,+Dayton,+OH+45459/@39.6422262,-84.1389395,3072a,13.1y/data=!4m2!3m1!1s0x884089260d430893:0xfc0500305cb5f476",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Ohio (OH) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-528",
    "externalIds": {
      "cdcClinicId": "528",
      "googlePlaceId": "ChIJFayF3N1ZQIgRmD5FFXaFuk8"
    },
    "type": "fertility-clinic",
    "name": "The Fertility Wellness Institute of Ohio",
    "phone": "(513) 326-4300",
    "address": {
      "line1": "7671 Tylers Place Blvd",
      "city": "West Chester",
      "state": "OH",
      "zip": "45069",
      "country": "US"
    },
    "location": {
      "lat": 39.3588,
      "lng": -84.3766
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 42.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 38.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 20.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 231,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27528%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27528%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.chinbaby.com/our-team/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Wellness+Institute+of+Ohio,+7671+Tylers+Pl+Blvd,+West+Chester+Township,+OH+45069/@39.358768,-84.3766636,3085a,13.1y/data=!4m2!3m1!1s0x884059dddc85ac15:0x4fba857615453e98",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-528-neeoo-w-chin-md",
        "name": "Neeoo W. Chin, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.chinbaby.com/media/site/our-team/Dr.%20Chin%20(5).jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://www.chinbaby.com/our-team/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Mark Bidwell, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://www.chinbaby.com/media/site/our-team/DSC05711.jpg",
        "_source": {
          "url": "https://www.chinbaby.com/our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-528-mark-bidwell-md"
      },
      {
        "name": "Hailey",
        "role": "Nurse Practitioner",
        "credentials": ["FNP-BC"],
        "imageUrl": "https://www.chinbaby.com/media/site/our-team/Hailey.jpg",
        "_source": {
          "url": "https://www.chinbaby.com/our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-528-hailey"
      },
      {
        "name": "Jinnuo Han, PhD",
        "role": "Laboratory Director",
        "credentials": ["PhD", "TS", "HCLD"],
        "imageUrl": "https://www.chinbaby.com/media/site/our-team/DSC05692.jpg",
        "_source": {
          "url": "https://www.chinbaby.com/our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-528-jinnuo-han-phd"
      },
      {
        "name": "Hannah",
        "role": "Embryologist",
        "credentials": [],
        "imageUrl": "https://www.chinbaby.com/media/site/our-team/DSC05685.jpg",
        "_source": {
          "url": "https://www.chinbaby.com/our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-528-hannah"
      },
      {
        "name": "Lily",
        "role": "Andrologist",
        "credentials": [],
        "imageUrl": "https://www.chinbaby.com/media/site/our-team/DSC05686.jpg",
        "_source": {
          "url": "https://www.chinbaby.com/our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-528-lily"
      },
      {
        "name": "Elyssa Potts, RN",
        "role": "Director of Operations / Laboratory Manager / Third Party IVF Nurse",
        "credentials": ["RN"],
        "imageUrl": "https://www.chinbaby.com/media/site/our-team/DSC05707.jpg",
        "_source": {
          "url": "https://www.chinbaby.com/our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-528-elyssa-potts-rn"
      }
    ],
    "website": "https://www.fertilitywellnessinstitute.com",
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "images": [
      {
        "url": "https://www.chinbaby.com/media/site/about/Waiting%20Room%20new.jpg",
        "type": "interior",
        "caption": "Waiting room at The Fertility Wellness Institute of Ohio, West Chester",
        "_source": {
          "url": "https://www.chinbaby.com/about/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.chinbaby.com/media/site/about/front%20desk.jpg",
        "type": "interior",
        "caption": "Front desk / reception area at the West Chester clinic",
        "_source": {
          "url": "https://www.chinbaby.com/about/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.chinbaby.com/media/site/about/waiting%20room.jpg",
        "type": "interior",
        "caption": "Patient waiting area at The Fertility Wellness Institute of Ohio",
        "_source": {
          "url": "https://www.chinbaby.com/about/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.chinbaby.com/media/site/services/DSC_0081.jpg",
        "type": "lab",
        "caption": "IVF nurses working in the clinic's laboratory",
        "_source": {
          "url": "https://www.chinbaby.com/services/ivf/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmLn9t3ESm3ZQpJRcXK81QhJorshWjH5sbOD9SWxPXRYX9Ez_49nPshndRXz4ho0Bm6rHjmzMQumJnXXUasuROV9En8L5pF17P-4gzpSetUdSdB_dLkpAfBJqISYIGQBTUv0QZu=w408-h307-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Wellness+Institute+of+Ohio,+7671+Tylers+Pl+Blvd,+West+Chester+Township,+OH+45069/@39.358768,-84.3766636,3085a,13.1y/data=!4m2!3m1!1s0x884059dddc85ac15:0x4fba857615453e98",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmlOQYclmusWUsGpoYbdHkaTPpKJcbgvQjCVXk5lAwH3RXqZVhJQWVAsQegdghHdi_B74JYidvzQZnDlZvx0KyNGBx_EE20HI83YR27w3OmMbcws9lGe7BbN3ffCJl0dcvyiSVp=w394-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Wellness+Institute+of+Ohio,+7671+Tylers+Pl+Blvd,+West+Chester+Township,+OH+45069/@39.358768,-84.3766636,3085a,13.1y/data=!4m2!3m1!1s0x884059dddc85ac15:0x4fba857615453e98",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Ohio (OH) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-355",
    "externalIds": {
      "cdcClinicId": "355",
      "googlePlaceId": "ChIJW-3swA9aQIgRrJCm2csf8no"
    },
    "type": "fertility-clinic",
    "name": "UC Center for Reproductive Health",
    "phone": "(513) 475-7600",
    "address": {
      "line1": "7675 Wellness Way, Suite 315",
      "city": "West Chester",
      "state": "OH",
      "zip": "45069",
      "country": "US"
    },
    "location": {
      "lat": 39.358,
      "lng": -84.368
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 51,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 27.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 44.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 177,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27355%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27355%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.uchealth.com/women/reproductive-endocrinology-infertility/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/UC+Health+Center+for+Reproductive+Health,+7675+Wellness+Way+%23315,+West+Chester+Township,+OH+45069/@39.3580095,-84.3679973,3085a,13.1y/data=!4m2!3m1!1s0x88405a0fc0eced5b:0x7af21fcbd9a690ac",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-355-emily-g-hurley-md",
        "name": "Emily G. Hurley, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.uchealth.com/content/dam/uchealth/provider-photos/hurley-emily-1093151441.png/jcr:content/renditions/cq5dam.web.1024.576.png",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.uchealth.com/en/provider-profiles/hurley-emily-1093151441",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.uchealth.com/services/fertility",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://www.uchealth.com/content/dam/uchealth/images/locations/uc-health-south.png/jcr%3Acontent/renditions/cq5dam.web.767.431.png",
        "type": "exterior",
        "caption": "UC Health South Building exterior at 7675 Wellness Way, West Chester, OH (with the address \"7675\" visible on the facade), the building that houses the UC Center for Reproductive Health in Suite 315",
        "_source": {
          "url": "https://www.uchealth.com/en/locations/south-building",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmLn9t3ESm3ZQpJRcXK81QhJorshWjH5sbOD9SWxPXRYX9Ez_49nPshndRXz4ho0Bm6rHjmzMQumJnXXUasuROV9En8L5pF17P-4gzpSetUdSdB_dLkpAfBJqISYIGQBTUv0QZu=w156-h156-n-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/UC+Health+Center+for+Reproductive+Health,+7675+Wellness+Way+%23315,+West+Chester+Township,+OH+45069/@39.3580095,-84.3679973,3085a,13.1y/data=!4m2!3m1!1s0x88405a0fc0eced5b:0x7af21fcbd9a690ac",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Ohio (OH) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-331",
    "externalIds": {
      "cdcClinicId": "331"
    },
    "type": "fertility-clinic",
    "name": "University Hospitals Fertility Center",
    "phone": "(216) 285-5028",
    "address": {
      "line1": "Kathy Risman Pavilion, 1000 Auburn Dr, Suite 310",
      "city": "Beachwood",
      "state": "OH",
      "zip": "44122",
      "country": "US"
    },
    "location": {
      "lat": 41.4526,
      "lng": -81.495
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 53.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 39.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 42.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 22,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 390,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27331%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27331%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.uhhospitals.org/services/obgyn-womens-health/conditions-and-treatments/fertility-and-reproductive-health/find-a-doctor",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-331-rebecca-flyckt-md",
        "name": "Rebecca Flyckt, MD",
        "role": "Medical Director",
        "imageUrl": "https://cdn.uhhospitals.org/provider-images/1174734461.jpg",
        "credentials": [
          "MD",
          "Board Certified - Reproductive Endocrinology and Infertility",
          "Board Certified - Obstetrics and Gynecology"
        ],
        "_source": {
          "url": "https://www.uhhospitals.org/doctors/Flyckt-Rebecca-1174734461",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Joseph Findley, MD",
        "role": "Reproductive Endocrinologist; OB/GYN-General",
        "credentials": [
          "MD",
          "Board Certified - Reproductive Endocrinology and Infertility",
          "Board Certified - Obstetrics and Gynecology"
        ],
        "imageUrl": "https://cdn.uhhospitals.org/provider-images/1558595843.jpg",
        "_source": {
          "url": "https://www.uhhospitals.org/doctors/Findley-Joseph-1558595843",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-331-joseph-findley-md"
      },
      {
        "name": "Kathryn Coyne, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "Board Certified - Obstetrics and Gynecology"],
        "imageUrl": "https://cdn.uhhospitals.org/provider-images/1447785340.jpg",
        "_source": {
          "url": "https://www.uhhospitals.org/doctors/Coyne-Kathryn-1447785340",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-331-kathryn-coyne-md"
      },
      {
        "name": "Adam Evans, MD",
        "role": "Reproductive Endocrinologist; OB/GYN-Gynecology",
        "credentials": ["MD", "Board Certified - Obstetrics and Gynecology"],
        "imageUrl": "https://cdn.uhhospitals.org/provider-images/1356848709.jpg",
        "_source": {
          "url": "https://www.uhhospitals.org/doctors/Evans-Adam-1356848709",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-331-adam-evans-md"
      },
      {
        "name": "Rachel Weinerman, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": [
          "MD",
          "Board Certified - Reproductive Endocrinology and Infertility",
          "Board Certified - Obstetrics and Gynecology"
        ],
        "imageUrl": "https://cdn.uhhospitals.org/provider-images/1043478068.jpg",
        "_source": {
          "url": "https://www.uhhospitals.org/doctors/Weinerman-Rachel-1043478068",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-331-rachel-weinerman-md"
      },
      {
        "name": "Mary Howard, CNP",
        "role": "Reproductive Endocrinology Nurse Practitioner",
        "credentials": [
          "CNP",
          "NP - Women's Healthcare (National Certification Corporation)"
        ],
        "imageUrl": "https://cdn.uhhospitals.org/provider-images/1104251537.jpg",
        "_source": {
          "url": "https://www.uhhospitals.org/doctors/Howard-Mary-1104251537",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-331-mary-howard-cnp"
      }
    ],
    "website": "https://www.uhhospitals.org/services/reproductive-medicine",
    "description": "University Hospitals Fertility Center offers full-spectrum fertility care including IVF, IUI, genetic testing, and fertility preservation in northeast Ohio.",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Medical Mutual",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "images": [
      {
        "url": "https://www.uhhospitals.org/-/media/images/locations/uh-facilities/medical-centers/ahuja/ahuja-102110-17-hero.jpg",
        "type": "exterior",
        "caption": "Exterior of University Hospitals Ahuja Medical Center, whose Kathy Risman Pavilion houses the UH Fertility Center (Beachwood).",
        "_source": {
          "url": "https://www.uhhospitals.org/locations/uh-ahuja-medical-center",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Medical Mutual, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Ohio (OH) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-892",
    "externalIds": {
      "cdcClinicId": "892",
      "googlePlaceId": "ChIJPV6AgpkbsocRZ8Gd5-u-28I"
    },
    "type": "fertility-clinic",
    "name": "Thrive IVF - Oklahoma City",
    "phone": "(405) 930-3483",
    "address": {
      "line1": "3427 NW 50th Street",
      "city": "Oklahoma City",
      "state": "OK",
      "zip": "73112",
      "country": "US"
    },
    "location": {
      "lat": 35.5225,
      "lng": -97.5781
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/12"
        }
      ],
      "cyclesPerYear": 26,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27892%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://thrivefertilityivf.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27892%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://thrivefertilityivf.com/about/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Thrive+IVF+%7C+Shaurin+Patel,+MD,+3427+NW+50th+St,+Oklahoma+City,+OK+73112/@35.5225216,-97.5780843,3247a,13.1y/data=!4m2!3m1!1s0x87b21b9982805e3d:0xc2dbbeebe79dc167",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://thrivefertilityivf.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://thrivefertilityivf.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-892-shaurin-patel-md-facog",
        "name": "Shaurin Patel, MD, FACOG",
        "role": "Fertility Provider",
        "credentials": ["MD", "FACOG"],
        "specialty": "Fertility Provider",
        "imageUrl": "https://thrivefertilityivf.com/wp-content/uploads/2026/01/dr-shaurin.webp",
        "_source": {
          "url": "https://thrivefertilityivf.com/about/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://thrivefertilityivf.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnnXgcJ6KhxdfzXnVY-9YVVUITxRoSnz9bfmM8atrbD0VjA7z3ZgCkjXlaabNZ5kp7cWh4jyoW5euGkjNHZAAMWzgx5RcFFyDvH_fJsnOKftbOLWRsY2L4-U3A8KyormyvQCzKc1i6SMrM=w238-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Thrive+IVF+%7C+Shaurin+Patel,+MD,+3427+NW+50th+St,+Oklahoma+City,+OK+73112/@35.5225216,-97.5780843,3247a,13.1y/data=!4m2!3m1!1s0x87b21b9982805e3d:0xc2dbbeebe79dc167",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Oklahoma (OK) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-9",
    "externalIds": {
      "cdcClinicId": "9"
    },
    "type": "fertility-clinic",
    "name": "OU Health Reproductive Medicine",
    "phone": "(572) 244-0203",
    "address": {
      "line1": "840 Research Pkwy, Suite 200",
      "city": "Oklahoma City",
      "state": "OK",
      "zip": "73104",
      "country": "US"
    },
    "location": {
      "lat": 35.4775,
      "lng": -97.5009
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 48,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 37,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 29.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 309,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%279%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.ouhealth.com/health-services/fertility-services-reproductive-medicine/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%279%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ouhealth.com/health-services/fertility-services-reproductive-medicine/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.ouhealth.com/find-a-location/ou-health-physicians-reproductive-medicine/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.ouhealth.com/find-a-location/ou-health-physicians-reproductive-medicine/",
            "fetchedAt": "2026-06-13"
          }
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.ouhealth.com/health-services/fertility-services-reproductive-medicine/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-9-latasha-b-craig-md",
        "name": "LaTasha B. Craig, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Fertility",
        "imageUrl": "https://www.ouhealth.com/images/physicians/LaTasha-B.-Craig.jpg",
        "_source": {
          "url": "https://www.ouhealth.com/find-a-doctor/latasha-b-craig-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-9-john-doolittle-md",
        "name": "John Doolittle, MD",
        "role": "Urology, Fertility",
        "credentials": ["MD"],
        "specialty": "Urology, Fertility",
        "imageUrl": "https://www.ouhealth.com/images/physicians/johnathan_dolittle1.jpg",
        "_source": {
          "url": "https://www.ouhealth.com/health-services/fertility-services-reproductive-medicine/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-9-claire-reynolds-md",
        "name": "Claire Reynolds, MD",
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Fertility",
        "imageUrl": "https://www.ouhealth.com/images/Claire-Reynolds-REI.png",
        "_source": {
          "url": "https://www.ouhealth.com/health-services/fertility-services-reproductive-medicine/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-9-karl-hansen-md-phd",
        "name": "Karl Hansen, MD, PhD",
        "role": "Fertility Specialist",
        "credentials": ["MD", "PhD"],
        "specialty": "Fertility",
        "imageUrl": "https://www.ouhealth.com/images/physicians/Karl-Hansen1.jpg",
        "_source": {
          "url": "https://www.ouhealth.com/health-services/fertility-services-reproductive-medicine/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-9-heather-r-burks-md",
        "name": "Heather R. Burks, MD",
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Fertility",
        "imageUrl": "https://www.ouhealth.com/images/physicians/Heather-Burks1.jpg",
        "_source": {
          "url": "https://www.ouhealth.com/health-services/fertility-services-reproductive-medicine/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-9-michael-blake-evans-do",
        "name": "Michael \"Blake\" Evans, DO",
        "role": "Fertility Specialist",
        "credentials": ["DO"],
        "specialty": "Fertility",
        "imageUrl": "https://www.ouhealth.com/images/physicians/Blake-Evans.jpg",
        "_source": {
          "url": "https://www.ouhealth.com/health-services/fertility-services-reproductive-medicine/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-9-andrea-buery-pa-c",
        "name": "Andrea Buery, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://www.ouhealth.com/images/Andrea-Buery.png",
        "_source": {
          "url": "https://www.ouhealth.com/health-services/fertility-services-reproductive-medicine/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-9-taryn-frazier-pa-c-mpas",
        "name": "Taryn Frazier, PA-C, MPAS",
        "role": "Physician Assistant",
        "credentials": ["PA-C", "MPAS"],
        "specialty": "Reproductive Medicine, Obstetrics",
        "imageUrl": "https://www.ouhealth.com/images/physicians/Taryn-Frazier.png",
        "_source": {
          "url": "https://www.ouhealth.com/health-services/fertility-services-reproductive-medicine/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.ouhealth.com/health-services/fertility-services-reproductive-medicine/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://www.ouhealth.com/images/locations/51089953571_bf0eb41d1b_k[1].jpg",
        "type": "exterior",
        "caption": "OU Health Physicians Reproductive Medicine building at 840 Research Parkway",
        "_source": {
          "url": "https://www.ouhealth.com/find-a-location/ou-health-physicians-reproductive-medicine/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Oklahoma (OK) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-111",
    "externalIds": {
      "cdcClinicId": "111"
    },
    "type": "fertility-clinic",
    "name": "Pinnacle Fertility - Tulsa",
    "phone": "(918) 359-2229",
    "address": {
      "line1": "115 E 15th St",
      "city": "Tulsa",
      "state": "OK",
      "zip": "74119",
      "country": "US"
    },
    "location": {
      "lat": 36.1412,
      "lng": -95.9843
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 47.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 32.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 171,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27111%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/tulsa-ok/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27111%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/tulsa-ok/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/tulsa-ok/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/tulsa-ok/",
            "fetchedAt": "2026-06-13"
          }
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/tulsa-ok/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-111-shauna-l-mckinney-md-facog",
        "name": "Shauna L. McKinney, MD, FACOG",
        "role": "Fertility Specialist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Fertility Specialist",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/03/Dr.-Shauna-McKinney_OK-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/tulsa-ok/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.pinnaclefertility.com/location/tulsa-ok/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "network": {
      "name": "Pinnacle Fertility"
    },
    "images": [
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/10/PFO-Lobby-Full-1024x768.jpg",
        "type": "interior",
        "caption": "Pinnacle Fertility Tulsa lobby",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/tulsa-ok/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/10/PFO-Exterior-Left-Full-1024x768.jpg",
        "type": "exterior",
        "caption": "Pinnacle Fertility Tulsa building exterior",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/tulsa-ok/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Oklahoma (OK) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-812",
    "externalIds": {
      "cdcClinicId": "812",
      "googlePlaceId": "ChIJ9zzVB_cMlVQRDFDzlj09sow"
    },
    "type": "fertility-clinic",
    "name": "Oregon Fertility Institute",
    "phone": "(503) 292-7734",
    "address": {
      "line1": "9370 SW Greenburg Rd, Suite 412",
      "city": "Portland",
      "state": "OR",
      "zip": "97223",
      "country": "US"
    },
    "location": {
      "lat": 45.4521,
      "lng": -122.773
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 53.333333333333336,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "8/15"
        }
      ],
      "cyclesPerYear": 61,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27812%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.oregonfertilityinstitute.com/about-us/aimee-s-chang-md/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27812%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.oregonfertilityinstitute.com/about-us/aimee-s-chang-md/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Oregon+Fertility+Institute,+9370+SW+Greenburg+Rd+%23412,+Portland,+OR+97223/@45.4520166,-122.773693,2799a,13.1y/data=!4m2!3m1!1s0x54950cf707d53cf7:0x8cb23d3d96f3500c",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.oregonfertilityinstitute.com/about-us/aimee-s-chang-md/",
            "fetchedAt": "2026-06-13"
          }
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.oregonfertilityinstitute.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-812-aimee-s-chang-md",
        "name": "Aimee S. Chang, MD",
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.oregonfertilityinstitute.com/wp-content/uploads/sites/7367/2014/11/business_portrait.jpg",
        "_source": {
          "url": "https://www.oregonfertilityinstitute.com/about-us/aimee-s-chang-md/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.oregonfertilityinstitute.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWktaYrsqERoEyw0uUKFFjPcJSp7oEhpIrl4W4-PZpwMwdv_OG_IAx5r9rErJL0SWqSuJJCyKymtS6oD-_JAg8K3o0KClNFRoiJWtqTcatgu_3iZfKGeGUYqy0VSbJAOXAyH4k2f=w140-h248-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Oregon+Fertility+Institute,+9370+SW+Greenburg+Rd+%23412,+Portland,+OR+97223/@45.4520166,-122.773693,2799a,13.1y/data=!4m2!3m1!1s0x54950cf707d53cf7:0x8cb23d3d96f3500c",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Oregon (OR) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-272",
    "externalIds": {
      "cdcClinicId": "272",
      "googlePlaceId": "ChIJhbtt6xwKlVQRaLRiuOTmHhg"
    },
    "type": "fertility-clinic",
    "name": "Pinnacle Fertility - Downtown Portland",
    "phone": "(503) 241-2366",
    "address": {
      "line1": "808 SW 15th Ave",
      "city": "Portland",
      "state": "OR",
      "zip": "97205",
      "country": "US"
    },
    "location": {
      "lat": 45.5205029,
      "lng": -122.6875055
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 62.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 54.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 52.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 41.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 720,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27272%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/downtown-portland-or/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27272%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/downtown-portland-or/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Pinnacle+Fertility+Oregon-+Downtown+Portland,+808+SW+15th+Ave,+Portland,+OR+97205/@45.520442,-122.687344,2795a,13.1y/data=!4m2!3m1!1s0x54950a1ceb6dbb85:0x181ee6e4b862b468",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/downtown-portland-or/",
            "fetchedAt": "2026-06-13"
          }
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/downtown-portland-or/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-272-brandon-bankowski-md-mph-facog",
        "name": "Brandon Bankowski, MD, MPH, FACOG",
        "role": "Fertility Specialist",
        "credentials": ["MD", "MPH", "FACOG"],
        "specialty": "Fertility Specialist",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Brandon-Bankowski_OR_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/downtown-portland-or/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-272-elizabeth-barbieri-md-facog",
        "name": "Elizabeth Barbieri, MD, FACOG",
        "role": "Fertility Specialist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Fertility Specialist",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Betsy-Barbieri_OR_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/downtown-portland-or/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-272-john-hesla-md-facog",
        "name": "John Hesla, MD, FACOG",
        "role": "Medical Director",
        "credentials": ["MD", "FACOG"],
        "specialty": "Fertility Specialist",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-John-Hesla_OR_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/downtown-portland-or/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-272-jillian-kurtz-do-facoog",
        "name": "Jillian Kurtz, DO, FACOOG",
        "role": "Fertility Specialist",
        "credentials": ["DO", "FACOOG"],
        "specialty": "Fertility Specialist",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Jillian-Kurtz_OR_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/downtown-portland-or/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-272-marissa-luck-md-facog",
        "name": "Marissa Luck, MD, FACOG",
        "role": "Fertility Specialist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Fertility Specialist",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/03/Dr.-Marissa-Luck_OR-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/downtown-portland-or/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-272-sophia-brett-mspas-pa-c",
        "name": "Sophia Brett, MSPAS, PA-C",
        "role": "Physician Assistant",
        "credentials": ["MSPAS", "PA-C"],
        "specialty": "Physician Assistant",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/02/Sophia-Brett-OR-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/downtown-portland-or/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-272-martha-mcmahon-pa-c",
        "name": "Martha McMahon, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "specialty": "Physician Assistant",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/02/Martha-McMahon-OR-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/downtown-portland-or/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-272-molly-mccluskey-pa-c-mpas",
        "name": "Molly McCluskey, PA-C, MPAS",
        "role": "Physician Assistant",
        "credentials": ["PA-C", "MPAS"],
        "specialty": "Physician Assistant",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/02/molly-mckluskey-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/downtown-portland-or/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-272-shannon-gwartney-whnp-bc",
        "name": "Shannon Gwartney, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["WHNP-BC"],
        "specialty": "Women’s Health Nurse Practitioner",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/04/Shannon-G-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/downtown-portland-or/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.pinnaclefertility.com/location/downtown-portland-or/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "network": {
      "name": "Pinnacle Fertility"
    },
    "images": [
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/Dr.-Barbieri-and-Dr.-Kutz-at-desk-4-1024x576.jpg",
        "type": "interior",
        "caption": "Pinnacle Fertility Downtown Portland consultation room",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/downtown-portland-or/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmniGvf_vDUjJEEBUAiGqGUPFJz3lsYmTrOExW8k_uiVvdObYbkexJq62h63rQl-JkB2rftJpcCjm_8ob3YghJyF-iV73eIRsSMaFxqD7RAQ04fmO731KraaZrtUTzgYaNW1xuKHXDgSZo=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Pinnacle+Fertility+Oregon-+Downtown+Portland,+808+SW+15th+Ave,+Portland,+OR+97205/@45.520442,-122.687344,2795a,13.1y/data=!4m2!3m1!1s0x54950a1ceb6dbb85:0x181ee6e4b862b468",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmzdbaTNUyMtRWoX3nnzvRgnc4KS8bjsPmLwM_DXCdpbZPoSZ31bhja8XabuWiIeIV0846su7Ujq7YBrrjVVP0HSXcZ2Dh5HnEQkAJLUwaK1ijqEyJicxT0WWYuuh4lJ8YsitFI=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Pinnacle+Fertility+Oregon-+Downtown+Portland,+808+SW+15th+Ave,+Portland,+OR+97205/@45.520442,-122.687344,2795a,13.1y/data=!4m2!3m1!1s0x54950a1ceb6dbb85:0x181ee6e4b862b468",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Oregon (OR) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-411",
    "externalIds": {
      "cdcClinicId": "411"
    },
    "type": "fertility-clinic",
    "name": "The Fertility Center of Oregon",
    "phone": "(541) 683-1559",
    "address": {
      "line1": "590 Country Club Pkwy, Suite A",
      "city": "Eugene",
      "state": "OR",
      "zip": "97401",
      "country": "US"
    },
    "location": {
      "lat": 44.0639,
      "lng": -123.092
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 38.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 37.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 42.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 165,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27411%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://fertilitycenteroforegon.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27411%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://fertilitycenteroforegon.com/history/staff/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://fertilitycenteroforegon.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://fertilitycenteroforegon.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://fertilitycenteroforegon.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-411-douglas-j-austin-md",
        "name": "Douglas J. Austin, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://fertilitycenteroforegon.com/wp-content/uploads/2013/10/dr-austin.jpg",
        "_source": {
          "url": "https://fertilitycenteroforegon.com/history/staff/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-411-carolyn-camille-mcgregor-whnp",
        "name": "Carolyn Camille McGregor, WHNP",
        "role": "Nurse Practitioner",
        "credentials": ["WHNP"],
        "specialty": "Women’s Health Nurse Practitioner",
        "imageUrl": "https://fertilitycenteroforegon.com/wp-content/uploads/2021/02/carolyn-camille-mcgregor.jpg",
        "_source": {
          "url": "https://fertilitycenteroforegon.com/history/staff/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-411-laurel-stiedemann-pa-c",
        "name": "Laurel Stiedemann, PA-C",
        "role": "Physician Associate",
        "credentials": ["PA-C"],
        "specialty": "Physician Associate",
        "imageUrl": "https://fertilitycenteroforegon.com/wp-content/uploads/2025/03/people_laurel-stiedemann.jpg",
        "_source": {
          "url": "https://fertilitycenteroforegon.com/history/staff/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-411-matt-gilman",
        "name": "Matt Gilman",
        "role": "Laboratory Director",
        "specialty": "Laboratory Director",
        "imageUrl": "https://fertilitycenteroforegon.com/wp-content/uploads/2013/10/people-matt-gilman.jpg",
        "_source": {
          "url": "https://fertilitycenteroforegon.com/history/staff/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-411-sharon-huff-rn",
        "name": "Sharon Huff, RN",
        "role": "IVF and Infertility Nurse Coordinator",
        "credentials": ["RN"],
        "specialty": "IVF and Infertility Nurse Coordinator",
        "imageUrl": "https://fertilitycenteroforegon.com/wp-content/uploads/2013/10/people-sharon-huff.jpg",
        "_source": {
          "url": "https://fertilitycenteroforegon.com/history/staff/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-411-brittany-adams-rn",
        "name": "Brittany Adams, RN",
        "role": "IVF and Infertility Nurse Coordinator",
        "credentials": ["RN"],
        "specialty": "IVF and Infertility Nurse Coordinator",
        "imageUrl": "https://fertilitycenteroforegon.com/wp-content/uploads/2018/01/b-adams_5039.jpg",
        "_source": {
          "url": "https://fertilitycenteroforegon.com/history/staff/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://fertilitycenteroforegon.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Oregon (OR) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-517",
    "externalIds": {
      "cdcClinicId": "517"
    },
    "type": "fertility-clinic",
    "name": "University Fertility Consultants, Oregon Health & Science University",
    "phone": "(503) 418-3700",
    "address": {
      "line1": "3303 S Bond Ave, 10th Floor",
      "city": "Portland",
      "state": "OR",
      "zip": "97239",
      "country": "US"
    },
    "location": {
      "lat": 45.4988372,
      "lng": -122.6712914
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 44.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 45.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 410,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27517%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.ohsu.edu/womens-health/ohsu-fertility-clinic-south-waterfront",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27517%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ohsu.edu/womens-health/fertility-services-team-ohsu",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.ohsu.edu/womens-health/ohsu-fertility-clinic-south-waterfront",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.ohsu.edu/womens-health/ohsu-fertility-clinic-south-waterfront",
            "fetchedAt": "2026-06-13"
          }
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.ohsu.edu/womens-health/ohsu-fertility-clinic-south-waterfront",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-517-paula-amato-md",
        "name": "Paula Amato, MD",
        "role": "Fertility Doctor",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2024/05/Dr-Paula-Amato.png",
        "_source": {
          "url": "https://www.ohsu.edu/womens-health/fertility-services-team-ohsu",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-517-jessica-k-cheung-md",
        "name": "Jessica K. Cheung, MD",
        "role": "Fertility Doctor",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2025/09/Fertility-Specialist.webp",
        "_source": {
          "url": "https://www.ohsu.edu/womens-health/fertility-services-team-ohsu",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-517-alexa-gilbert-msn-cnm",
        "name": "Alexa Gilbert, MSN, CNM",
        "role": "Certified Nurse Midwife",
        "credentials": ["MSN", "CNM"],
        "specialty": "Reproductive Endocrinology",
        "_source": {
          "url": "https://www.ohsu.edu/womens-health/fertility-services-team-ohsu",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-517-molly-kornfield-md",
        "name": "Molly Kornfield, MD",
        "role": "Fertility Doctor",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2024/06/Dr.-Kornfield.png",
        "_source": {
          "url": "https://www.ohsu.edu/womens-health/fertility-services-team-ohsu",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-517-sacha-ann-krieg-md-phd-facog",
        "name": "Sacha Ann Krieg, MD, PhD, FACOG",
        "role": "Fertility Doctor",
        "credentials": ["MD", "PhD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2024/08/Our-Providers_Krieg_New.png",
        "_source": {
          "url": "https://www.ohsu.edu/womens-health/fertility-services-team-ohsu",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-517-liz-rubin-md",
        "name": "Liz Rubin, MD",
        "role": "Fertility Doctor",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2024/08/Our-Providers_Rubin_New.png",
        "_source": {
          "url": "https://www.ohsu.edu/womens-health/fertility-services-team-ohsu",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-517-diana-h-wu-md",
        "name": "Diana H. Wu, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2024/08/Our-Providers_Wu_New.png",
        "_source": {
          "url": "https://www.ohsu.edu/womens-health/fertility-services-team-ohsu",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.ohsu.edu/womens-health/ohsu-fertility-clinic-south-waterfront",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Oregon (OR) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-628",
    "externalIds": {
      "cdcClinicId": "628",
      "googlePlaceId": "ChIJHcOvZ0z5NIgRivdfiSZouI4"
    },
    "type": "fertility-clinic",
    "name": "AHN Center for Reproductive Medicine",
    "phone": "(412) 847-1166",
    "address": {
      "line1": "200 Quinn Drive, Suite 120",
      "city": "Pittsburgh",
      "state": "PA",
      "zip": "15275",
      "country": "US"
    },
    "location": {
      "lat": 40.5738,
      "lng": -80.0249
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 44.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 26.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 177,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27628%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27628%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ahn.org/services/womens-health/reproductive-medicine/reproductive-medicine-center",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/AHN+Reproductive+Medicine+at+H%2BW+Pavilion+North+Fayette,+200+Quinn+Dr+Ste+120,+Pittsburgh,+PA+15275/@40.4457745,-80.1767826,3036a,13.1y/data=!4m2!3m1!1s0x8834f94c67afc31d:0x8eb86826895ff78a",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-628-lori-homa-md",
        "name": "Lori Homa, MD",
        "role": "Medical Director",
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/ahn/photos/200/homa-lori-1902078637.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.ahn.org/services/womens-health/reproductive-medicine/reproductive-medicine-center",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Terrence D. Lewis, MD, PhD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "PhD"],
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/ahn/photos/200/lewis-terrence-1730474297.jpg",
        "_source": {
          "url": "https://www.ahn.org/services/womens-health/reproductive-medicine/reproductive-medicine-center",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-628-terrence-d-lewis-md-phd"
      },
      {
        "name": "Justin Pilgrim, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/ahn/photos/200/pilgrim-justin-1881841583.jpg",
        "_source": {
          "url": "https://www.ahn.org/services/womens-health/reproductive-medicine/reproductive-medicine-center",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-628-justin-pilgrim-do"
      },
      {
        "name": "Meredith Snook, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/ahn/photos/200/snook-meredith-1033351556.jpg",
        "_source": {
          "url": "https://www.ahn.org/services/womens-health/reproductive-medicine/reproductive-medicine-center",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-cdc-628-meredith-snook-md"
      },
      {
        "name": "Sandra Alway, CRNP",
        "role": "Nurse Practitioner",
        "credentials": ["CRNP"],
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/ahn/photos/200/alway-sandra-1174802102.jpg",
        "_source": {
          "url": "https://www.ahn.org/services/womens-health/reproductive-medicine/reproductive-medicine-center",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Women's Health",
        "practitionerId": "pr-org-cdc-628-sandra-alway-crnp"
      },
      {
        "name": "Katherine Brinton, CRNP",
        "role": "Nurse Practitioner",
        "credentials": ["CRNP"],
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/ahn/photos/200/brinton-katherine-1063131308.jpg",
        "_source": {
          "url": "https://www.ahn.org/services/womens-health/reproductive-medicine/reproductive-medicine-center",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Women's Health",
        "practitionerId": "pr-org-cdc-628-katherine-brinton-crnp"
      }
    ],
    "website": "https://www.ahn.org/services/fertility-reproductive-medicine",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Highmark",
        "UPMC Health Plan",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Highmark, UPMC Health Plan, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWklxkfIKsbsD2HcoMiDxjyqm3yV43u2W4Lxpobrbin-QDYtZxA3N8sCPki-sHF5F-xgjQ3jSYilEJj3DWG0AjSe8AEE_LEx02kjf2zbRAUdMgr1RYu0NJIFUIW4iyjWzXe_OxCgTA=w517-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/AHN+Reproductive+Medicine+at+H%2BW+Pavilion+North+Fayette,+200+Quinn+Dr+Ste+120,+Pittsburgh,+PA+15275/@40.4457745,-80.1767826,3036a,13.1y/data=!4m2!3m1!1s0x8834f94c67afc31d:0x8eb86826895ff78a",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-142",
    "externalIds": {
      "cdcClinicId": "142",
      "googlePlaceId": "ChIJ2dKLm4A_xIkRjAdnb0VY5RA"
    },
    "type": "fertility-clinic",
    "name": "Family Fertility Center",
    "phone": "(610) 868-8600",
    "address": {
      "line1": "95 Highland Ave, Suite 100",
      "city": "Bethlehem",
      "state": "PA",
      "zip": "18017",
      "country": "US"
    },
    "location": {
      "lat": 40.6672,
      "lng": -75.3845
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 58.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 68.42105263157895,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "13/19"
        },
        {
          "ageBand": "38-40",
          "rate": 38.46153846153847,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/13"
        }
      ],
      "cyclesPerYear": 84,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27142%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27142%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://familyfertility.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Family+Fertility+Center,+95+Highland+Ave+%23100,+Bethlehem,+PA+18017/@40.6671945,-75.3844765,3026a,13.1y/data=!4m2!3m1!1s0x89c43f809b8bd2d9:0x10e558456f67078c",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-142-h-christina-lee-md",
        "name": "H. Christina Lee, MD",
        "role": "Medical Director",
        "imageUrl": "https://familyfertility.com/wp-content/uploads/2020/11/dr-h-christina-lee.webp",
        "credentials": ["MD", "JD", "HCLD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://familyfertility.com/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.familyfertilitycenter.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Highmark",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Highmark, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-409",
    "externalIds": {
      "cdcClinicId": "409",
      "googlePlaceId": "ChIJeQvV7i9lz4kRD3rQM20zseE"
    },
    "type": "fertility-clinic",
    "name": "Geisinger Medical Center Fertility Program",
    "phone": "(570) 271-5620",
    "address": {
      "line1": "100 N. Academy Ave",
      "city": "Danville",
      "state": "PA",
      "zip": "17822",
      "country": "US"
    },
    "location": {
      "lat": 40.9678,
      "lng": -76.6053
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 42.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 43.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 30.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 215,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27409%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27409%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://providers.geisinger.org/provider/jennifer-sue-gell/756921",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/The+Fertility+Center+at+Geisinger,+100+N+Academy+Ave,+Danville,+PA+17822/@40.9679873,-76.6058515,3013a,13.1y/data=!4m2!3m1!1s0x89cf652feed50b79:0xe1b1336d33d07a0f",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-409-jennifer-sue-gell-md",
        "name": "Jennifer Sue Gell, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.geisinger.org/-/media/OneGeisinger/Images/providers/gell-j-1275501926.jpg?sc_lang=en&hash=E01388495B2D66A6BF5BF50E01EF1B47",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://providers.geisinger.org/provider/jennifer-sue-gell/756921",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.geisinger.org/patient-care/conditions-treatments-specialties/fertility",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Geisinger",
        "Blue Cross Blue Shield",
        "Cigna",
        "Highmark",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Geisinger, Blue Cross Blue Shield, Cigna, Highmark, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-167",
    "externalIds": {
      "cdcClinicId": "167",
      "googlePlaceId": "ChIJrwY0YQrAxokRtOliQnbA1_k"
    },
    "type": "fertility-clinic",
    "name": "Main Line Fertility & Reproductive Medicine",
    "phone": "(484) 380-4879",
    "address": {
      "line1": "825 Old Lancaster Rd, Suite 170",
      "city": "Bryn Mawr",
      "state": "PA",
      "zip": "19010",
      "country": "US"
    },
    "location": {
      "lat": 40.0205,
      "lng": -75.3214
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 47.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 42,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 37.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 28.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1032,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27167%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27167%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.mainlinefertility.com/fertility-specialists",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Main+Line+Fertility,+825+Old+Lancaster+Rd+Ste+170,+Bryn+Mawr,+PA+19010/@40.020429,-75.321452,3055a,13.1y/data=!4m2!3m1!1s0x89c6c00a613406af:0xf9d7c0764262e9b4",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-167-michael-j-glassner-md",
        "name": "Michael J. Glassner, MD",
        "role": "Medical Director",
        "imageUrl": "https://cdn.buttercms.com/LJcH8BlKRCWDYk7WldTU",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Deanna R. Brasile, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "imageUrl": "https://cdn.buttercms.com/QNWDauTvRtmVmBffRYxC",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-167-deanna-r-brasile-do"
      },
      {
        "name": "Allison Bloom, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "imageUrl": "https://cdn.buttercms.com/pmwj4gofTfmgmKfw2Htt",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-167-allison-bloom-do"
      },
      {
        "name": "Shahab Minassian, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.buttercms.com/Sg6yiMuRGWI0J0hN2dkA",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-167-shahab-minassian-md"
      },
      {
        "name": "Jenna Kahn, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.buttercms.com/6lYzdfGTuEEA8tEmRLQg",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-167-jenna-kahn-md"
      },
      {
        "name": "Shannon Alexa, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "imageUrl": "https://cdn.buttercms.com/srYom1bNTDGa6byClbVY",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-167-shannon-alexa-do"
      },
      {
        "name": "Ben Gocial, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.buttercms.com/K1VJbgdqRaurRrTSYV1e",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-167-ben-gocial-md"
      },
      {
        "name": "Gina Menarde, MSN, CRNP",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "CRNP"],
        "imageUrl": "https://cdn.buttercms.com/AfBIbiPS6GFxuRgac9NR",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-167-gina-menarde-msn-crnp"
      },
      {
        "name": "Allison Tomack, PA-C, MPAS",
        "role": "Physician Assistant",
        "credentials": ["PA-C", "MPAS"],
        "imageUrl": "https://cdn.buttercms.com/c6tKozQPG8sgrstm28gw",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-167-allison-tomack-pa-c-mpas"
      },
      {
        "name": "Rachel Bruner, NP-C",
        "role": "Nurse Practitioner",
        "credentials": ["NP-C"],
        "imageUrl": "https://cdn.buttercms.com/Unu3HVnDQHO12BdSAcPn",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-167-rachel-bruner-np-c"
      },
      {
        "name": "Katie Gavern, MSN, CRNP, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "CRNP", "WHNP-BC"],
        "imageUrl": "https://cdn.buttercms.com/bMD6qLsRQjeoUzxc5068",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-167-katie-gavern-msn-crnp-whnp-bc"
      },
      {
        "name": "Sydney Gocial, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["WHNP-BC"],
        "imageUrl": "https://cdn.buttercms.com/7h9Ld17QQ6SvMxkfjHhw",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-167-sydney-gocial-whnp-bc"
      }
    ],
    "website": "https://www.mainlinefertility.com",
    "description": "Main Line Fertility provides personalized fertility care including IVF, IUI, and genetic testing on Philadelphia's Main Line.",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Independence Blue Cross",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://cdn.buttercms.com/5YXnfTHISvywfT1GxosP",
        "type": "exterior",
        "caption": "Main Line Fertility Bryn Mawr clinic",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-clinics/bryn-mawr",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlaCye1o_MAWYESvZNq_gDPw8PLSBKH6zC3J7I-bKQ6HNvU1HSsrivb2zwuIYC--cmEAxSujoZPEs00VCxDstd-uS1i5qJdWIB5teCuUZlJA9jbzhN740gdTzJfGGP9yyFsX8KPuDRGg8F9=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Main+Line+Fertility,+825+Old+Lancaster+Rd+Ste+170,+Bryn+Mawr,+PA+19010/@40.020429,-75.321452,3055a,13.1y/data=!4m2!3m1!1s0x89c6c00a613406af:0xf9d7c0764262e9b4",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Independence Blue Cross, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-872",
    "externalIds": {
      "cdcClinicId": "872",
      "googlePlaceId": "ChIJvaMMEW8lxokR80PspfDi9nI"
    },
    "type": "fertility-clinic",
    "name": "Penn Fertility Care-Lancaster General Health",
    "phone": "(717) 544-0107",
    "address": {
      "line1": "2112 Harrisburg Pike, Suite 110",
      "city": "Lancaster",
      "state": "PA",
      "zip": "17601",
      "country": "US"
    },
    "location": {
      "lat": 40.0646,
      "lng": -76.3557
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 26,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27872%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27872%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pennmedicine.org/providers/christine-skiadas",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Penn+Fertility+Care+Lancaster+General+Health,+2112+Harrisburg+Pike+Ste+110,+Lancaster,+PA+17601/@40.0646989,-76.3554275,3053a,13.1y/data=!4m2!3m1!1s0x89c6256f110ca3bd:0x72f6e2f0a5ec43f3",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-872-christine-curley-skiadas-md",
        "name": "Christine Curley Skiadas, MD",
        "role": "Medical Director",
        "imageUrl": "https://tupa-q-001.sitecorecontenthub.cloud/api/public/content/4a26fae1831c4644818db11182813f93?fit=scale-down",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.pennmedicine.org/providers/christine-skiadas",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.pennmedicine.org/for-patients-and-visitors/find-a-program-or-service/penn-fertility-care",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Independence Blue Cross",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Independence Blue Cross, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-6",
    "externalIds": {
      "cdcClinicId": "6",
      "googlePlaceId": "ChIJQTpxp167yIkRTPyWv2NBzd0"
    },
    "type": "fertility-clinic",
    "name": "Penn State Milton S. Hershey Medical Center",
    "phone": "(717) 531-6731",
    "address": {
      "line1": "35 Hope Dr, Suite 202",
      "city": "Hershey",
      "state": "PA",
      "zip": "17033",
      "country": "US"
    },
    "location": {
      "lat": 40.2702,
      "lng": -76.6611
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 51.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 45,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 99,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%276%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%276%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pennstatehealth.org/doctors/samantha-f-butts-md",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Penn+State+Health+Obstetrics+and+Gynecology,+35+Hope+Dr+Ste+202204,+Hershey,+PA+17033/@40.2701071,-76.6612277,3044a,13.1y/data=!4m2!3m1!1s0x89c8bb5ea7713a41:0xddcd4163bf96fc4c",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-6-samantha-f-butts-md",
        "name": "Samantha F. Butts, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.pennstatehealth.org/sites/default/files/styles/300x400/public/providers/B2678D5C925B395DE053C90D1DAC32DD.jpg?itok=-_AU_VSE",
        "credentials": ["MD", "MSCE"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.pennstatehealth.org/doctors/samantha-f-butts-md",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.pennstatehealth.org/services-treatments/fertility-reproductive-endocrinology",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Geisinger",
        "Highmark",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://www.pennstatehealth.org/sites/default/files/styles/800x600/public/locations/B0998B286943E77BE053C90D1DAC883E.jpg?itok=jYV6gM7R",
        "type": "exterior",
        "caption": "Penn State Health Obstetrics and Gynecology clinic",
        "_source": {
          "url": "https://www.pennstatehealth.org/doctors/samantha-f-butts-md",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlXYD-jfR5pLuZF0FemOJ86RQRJ9UTIEUVGD1GZsD9CxBTdOZg4PoziO5kkrCtZ1edQ_iCe0b4jeDzUmk2QeXeBDb-odU1icytR73fg9z3vCyKoOfxyNfmcqp4A4sf6w41WnkgQ=w360-h360-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Penn+State+Health+Obstetrics+and+Gynecology,+35+Hope+Dr+Ste+202204,+Hershey,+PA+17033/@40.2701071,-76.6612277,3044a,13.1y/data=!4m2!3m1!1s0x89c8bb5ea7713a41:0xddcd4163bf96fc4c",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlTHy-Wgbf3lpccat3RER5nRdtnVXIf3QJsmZWOYMOnDoiqfLkcnBggyQE-V_UnlwyQJjktCcPyaiKilO8JC-tc3Edd9JvCDWrvqSI9NONfCzh0EX6hbbdjN5-ZHEt9cTwueDn1=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Penn+State+Health+Obstetrics+and+Gynecology,+35+Hope+Dr+Ste+202204,+Hershey,+PA+17033/@40.2701071,-76.6612277,3044a,13.1y/data=!4m2!3m1!1s0x89c8bb5ea7713a41:0xddcd4163bf96fc4c",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Geisinger, Highmark, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-146",
    "externalIds": {
      "cdcClinicId": "146",
      "googlePlaceId": "ChIJw2Z2uzuUxokR434sju_X3lw"
    },
    "type": "fertility-clinic",
    "name": "RMA Philadelphia - Wayne",
    "phone": "(215) 654-1544",
    "address": {
      "line1": "880 E. Swedesford Road",
      "city": "Wayne",
      "state": "PA",
      "zip": "19087",
      "country": "US"
    },
    "location": {
      "lat": 40.0811494,
      "lng": -75.4087575
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 57.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 54.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 46.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 58.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 798,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27146%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "layer2-rma-current-address",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+Philadelphia+%7C+Wayne,+880+Swedesford+Rd,+Wayne,+PA+19087/@40.0815664,-75.404213,3053a,13.1y/data=!4m2!3m1!1s0x89c6943bbb7666c3:0x5cded7ef8e2c7ee3",
            "fetchedAt": "2026-08-16"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27146%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-146-arthur-j-castelbaum-md",
        "name": "Arthur J. Castelbaum, MD",
        "role": "Medical Director"
      },
      {
        "name": "Jeffrey T. Thorne, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2021/02/Copy-of-Untitled-3-3.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-146-jeffrey-t-thorne-md"
      },
      {
        "name": "Jacqueline N. Gutmann, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2021/02/Untitled-design-2-1.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-146-jacqueline-n-gutmann-md"
      },
      {
        "name": "Allison Lange, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2021/02/Doctor-Page-Mobile-Image-264-x-264-px-9.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-146-allison-lange-md"
      },
      {
        "name": "Karen C. Wheeler, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2022/04/Untitled-design-18.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-146-karen-c-wheeler-md"
      },
      {
        "name": "Daniel Miranian, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2025/10/RMA-header-image-doctor-page-mobile-image-264-x-264-px-8.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-146-daniel-miranian-md"
      },
      {
        "name": "Danielle Leotta, NP",
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2022/11/Untitled-design-17-1.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-146-danielle-leotta-np"
      },
      {
        "name": "Alexa Konrad, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2025/05/Doctor-Page-Mobile-Image-264-x-264-px-1.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-146-alexa-konrad-pa-c"
      },
      {
        "name": "Masaya Jimbo, MD",
        "role": "Urologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2025/01/Doctor-Page-Mobile-Image-264-x-264-px-2.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Urology",
        "practitionerId": "pr-org-cdc-146-masaya-jimbo-md"
      },
      {
        "name": "Deena Dubrow",
        "role": "Associate Genetic Counselor",
        "credentials": [],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2026/03/Deena-Dubrow_Genetic_Counselor.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Genetic Counseling",
        "practitionerId": "pr-org-cdc-146-deena-dubrow"
      },
      {
        "name": "Amber Kaplun",
        "role": "Genetic Counselor",
        "credentials": [],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2023/04/Untitled-design-4.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Genetic Counseling",
        "practitionerId": "pr-org-cdc-146-amber-kaplun"
      },
      {
        "name": "Allison Alleigh Boyd",
        "role": "Genetic Counselor",
        "credentials": [],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2023/04/Untitled-design-3.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Genetic Counseling",
        "practitionerId": "pr-org-cdc-146-allison-alleigh-boyd"
      }
    ],
    "website": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-2",
    "externalIds": {
      "cdcClinicId": "2",
      "googlePlaceId": "ChIJ-1WjShKTxokRhQWJ94NH0-o"
    },
    "type": "fertility-clinic",
    "name": "Shady Grove Fertility-Pennsylvania",
    "phone": "(610) 981-6000",
    "address": {
      "line1": "945 Chesterbrook Blvd",
      "city": "Wayne",
      "state": "PA",
      "zip": "19087",
      "country": "US"
    },
    "location": {
      "lat": 40.0681,
      "lng": -75.4619
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 46,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 44.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 43.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 39.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 985,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%272%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%272%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/pennsylvania/chesterbrook/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Chesterbrook,+735+Chesterbrook+Blvd,+Chesterbrook,+PA+19087/@40.0699077,-75.4622307,3053a,13.1y/data=!4m2!3m1!1s0x89c693124aa355fb:0xead34783f7890585",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-2-isaac-e-sasson-md-phd",
        "name": "Isaac E. Sasson, MD, PHD",
        "role": "Medical Director",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Isaac-Sasson-850x850-1-1.png",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/chesterbrook/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Russell Hayden, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/09/R.-Hayden-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/chesterbrook/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-2-russell-hayden-md"
      },
      {
        "name": "Nicole M. Marchetto, MD, MPH",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MPH"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/12/Niole-Marchetto-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/chesterbrook/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-2-nicole-m-marchetto-md-mph"
      },
      {
        "name": "Brianna Schumacher, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Brianna-Schumacher_hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/chesterbrook/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-2-brianna-schumacher-md"
      },
      {
        "name": "London Pino, MSN, RN, FNP-C",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "RN", "FNP-C"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/09/Pino-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/chesterbrook/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-2-london-pino-msn-rn-fnp-c"
      }
    ],
    "network": {
      "name": "US Fertility"
    },
    "website": "https://www.shadygrovefertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2021/02/Chesterbrook-Office_MAIN-IMAGE.jpg",
        "type": "interior",
        "caption": "Shady Grove Fertility Chesterbrook office",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/chesterbrook/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlOwbkERdvOUa8hFxSnrwlRWgB9FEVEzgHTUzYs7QvkfBEvtlHtYA6XTy_4XS2RugpbbW0rqWvw5RcOGfb5qbFhq-ZSC4d9ntuwej8InqL_k1_7zFR0mkmDHZLx1v0pZxA9cBHG=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Chesterbrook,+735+Chesterbrook+Blvd,+Chesterbrook,+PA+19087/@40.0699077,-75.4622307,3053a,13.1y/data=!4m2!3m1!1s0x89c693124aa355fb:0xead34783f7890585",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk8JTTHnn_TBPSm3G7qEFghwuHpoTBTdwoXx1xrOOOg797zCoT1-nbHwg8a6LSqNqxyhe2ZjJUt9d_MfBBDRmmj6Z3Jdoh0kZv2HypoAjCX05yDwTUahv7QIS753V1O6dnJlXzU6uD5zy62=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Chesterbrook,+735+Chesterbrook+Blvd,+Chesterbrook,+PA+19087/@40.0699077,-75.4622307,3053a,13.1y/data=!4m2!3m1!1s0x89c693124aa355fb:0xead34783f7890585",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-8",
    "externalIds": {
      "cdcClinicId": "8",
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/society-hill-reproductive-medicine",
      "googlePlaceId": "ChIJdV61QyfGxokRf68v-2eJkbo"
    },
    "type": "fertility-clinic",
    "name": "CCRM Fertility of Philadelphia",
    "phone": "+1 215-829-8110",
    "address": {
      "line1": "822 Pine St, Suite 4B",
      "city": "Philadelphia",
      "state": "PA",
      "zip": "19107",
      "country": "US"
    },
    "location": {
      "lat": 39.9443,
      "lng": -75.1561
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 44.44444444444444,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "8/18"
        }
      ],
      "cyclesPerYear": 65,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%278%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%278%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/pennsylvania/philadelphia/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/pennsylvania/philadelphia/",
            "fetchedAt": "2026-06-15"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Philadelphia,+822+Pine+St+%234B,+Philadelphia,+PA+19107/@39.94415,-75.156105,3059a,13.1y/data=!4m2!3m1!1s0x89c6c62743b55e75:0xba918967fb2faf7f",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/pennsylvania/philadelphia/",
            "fetchedAt": "2026-06-15"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "layer2-ccrm-rebrand",
      "date": "2026-06-13",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-8-maureen-p-kelly-md",
        "name": "Maureen P. Kelly, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Maureen-Kelly-rfyqzi0yeh9gtxx979ugjjr0zwozmnljh0c7egjesg.png",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/pennsylvania/philadelphia/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Anne Hutchinson, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Anne-Hutchinson-rmgnn7gvl856uarxvb3uksg1kpy67o3mv1sqnwcd5s.png",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/pennsylvania/philadelphia/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-cdc-8-anne-hutchinson-md"
      }
    ],
    "website": "https://www.ccrmivf.com/location/us/pennsylvania/philadelphia/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Independence Blue Cross",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "CCRM Fertility"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Independence Blue Cross, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmooycjuqhDspBQrf880-GiPDrA1iikOrJQxtPdbPtfItztlHLYJcbfJoFohdbMERyk2HvRNm6cH3GJJO4bkk1BwXzsnSsV6Xt__x5jEgNtSY-NIz_qit4_oed14CWVvSXlTjCQ9Jvag98=w408-h543-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Philadelphia,+822+Pine+St+%234B,+Philadelphia,+PA+19107/@39.94415,-75.156105,3059a,13.1y/data=!4m2!3m1!1s0x89c6c62743b55e75:0xba918967fb2faf7f",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnW-9nSct9mxJXQ1R_QOkKcrvU7fneJVb_NwN6OenCyyV84NeG0YKxLV9krlIcwa_gNncIVy0rExXX79rwwRkLVICSsLUEWKOQICvAgkPTtli-tZrVCU8LWp9ANhFkruPFxgPEY=w224-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Philadelphia,+822+Pine+St+%234B,+Philadelphia,+PA+19107/@39.94415,-75.156105,3059a,13.1y/data=!4m2!3m1!1s0x89c6c62743b55e75:0xba918967fb2faf7f",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-398",
    "externalIds": {
      "cdcClinicId": "398"
    },
    "type": "fertility-clinic",
    "name": "University of Pennsylvania, Penn Fertility Care",
    "phone": "(215) 662-6100",
    "address": {
      "line1": "3701 Market St, Suite 800",
      "city": "Philadelphia",
      "state": "PA",
      "zip": "19104",
      "country": "US"
    },
    "location": {
      "lat": 39.9568,
      "lng": -75.1961
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 51.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 43.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 33.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 24,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 831,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27398%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27398%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pennmedicine.org/providers/clarisa-gracia",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-398-clarisa-r-gracia-md",
        "name": "Clarisa R. Gracia, MD",
        "role": "Medical Director",
        "imageUrl": "https://tupa-q-001.sitecorecontenthub.cloud/api/public/content/ea7e24661acd4f4383cbe1ae89474990?fit=scale-down",
        "credentials": ["MD", "MSCE"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.pennmedicine.org/providers/clarisa-gracia",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.pennmedicine.org/for-patients-and-visitors/find-a-program-or-service/penn-fertility-care",
    "description": "Penn Fertility Care at the University of Pennsylvania provides comprehensive fertility treatment including IVF, egg freezing, and reproductive surgery.",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Independence Blue Cross",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Independence Blue Cross, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-168",
    "externalIds": {
      "cdcClinicId": "168"
    },
    "type": "fertility-clinic",
    "name": "University of Pittsburgh Physicians, Center for Fertility and Reproductive Endocrinology",
    "phone": "(412) 731-8000",
    "address": {
      "line1": "Magee Womens Hospital, 300 Halket St, Suite 5150",
      "city": "Pittsburgh",
      "state": "PA",
      "zip": "15213",
      "country": "US"
    },
    "location": {
      "lat": 40.437,
      "lng": -79.9607
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 44.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 47.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 32.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 17.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 381,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27168%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27168%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch1-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-168-julie-m-rios-md",
        "name": "Julie M. Rios, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://upmc.com/services/reproductive-endocrinology",
    "description": "The University of Pittsburgh Center for Fertility and Reproductive Endocrinology offers advanced fertility treatments through UPMC's academic medical center.",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Highmark",
        "UPMC Health Plan",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Highmark, UPMC Health Plan, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-274",
    "externalIds": {
      "cdcClinicId": "274"
    },
    "type": "fertility-clinic",
    "name": "Clinica de Fertilidad Pavia Caguas",
    "phone": "(787) 653-3775",
    "address": {
      "line1": "Ave Muñoz Rivera, A-1, Suite 303",
      "city": "Caguas",
      "state": "PR",
      "zip": "00726",
      "country": "US"
    },
    "location": {
      "lat": 18.2468,
      "lng": -66.0358
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/12"
        }
      ],
      "cyclesPerYear": 54,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27274%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://infertilidadpr.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27274%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://infertilidadpr.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://infertilidadpr.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://infertilidadpr.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://infertilidadpr.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-274-jose-r-cruz-diaz-md",
        "name": "Jose R. Cruz Diaz, MD",
        "role": "Medical and Laboratory Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://infertilidadpr.com/wp-content/uploads/2026/03/CLINICA_DE_FERTILIDAD_NOTICEL_JEBG_11_8198470_ver1.0_640_360.jpg",
        "_source": {
          "url": "https://infertilidadpr.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://infertilidadpr.com/",
    "insurance": {
      "accepted": true,
      "carriers": ["Triple-S", "MCS", "Humana", "Medicare Advantage"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Triple-S, MCS, Humana, Medicare Advantage",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Puerto Rico (PR) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-145",
    "externalIds": {
      "cdcClinicId": "145",
      "googlePlaceId": "ChIJSXRmBUtvA4wRxDeHGjDI-J0"
    },
    "type": "fertility-clinic",
    "name": "GREFI, Gynecology, Reproductive Endocrinology & Fertility Institute",
    "phone": "(787) 984-3008",
    "address": {
      "line1": "First Bank Building, 1519 Ponce de León Ave, Suite 705",
      "city": "San Juan",
      "state": "PR",
      "zip": "00909",
      "country": "US"
    },
    "location": {
      "lat": 18.4418,
      "lng": -66.0706
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 26.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 17.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 12,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "0/16"
        }
      ],
      "cyclesPerYear": 5,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27145%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27145%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.elanzawellness.com/fertilitydoctors/rosa-ileana-cruz%2C-md",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Cl%C3%ADnica+de+Fertilidad+GREFI+(Gynecology+Reproductive+Endocrinology+Fertility+Institute),+1519+Av.+Juan+Ponce+de+Le%C3%B3n+Suite+705,+Santurce,+San+Juan+00909,+Puerto+Rico/@18.4451027,-66.0665408,3785a,13.1y/data=!4m2!3m1!1s0x8c036f4b05667449:0x9df8c8301a8737c4",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-145-rosa-ileana-cruz-md",
        "name": "Rosa Ileana Cruz, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://static.wixstatic.com/media/eb305a_851b221e56cc463086ce466ae980b0b0~mv2.png",
        "_source": {
          "url": "https://www.elanzawellness.com/fertilitydoctors/rosa-ileana-cruz%2C-md",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.grefifertility.com",
    "insurance": {
      "accepted": true,
      "carriers": ["Triple-S", "MCS", "Humana", "Medicare Advantage"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Triple-S, MCS, Humana, Medicare Advantage",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Puerto Rico (PR) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-338",
    "externalIds": {
      "cdcClinicId": "338",
      "googlePlaceId": "ChIJ0x54jihrA4wRJcBqVNCCy4s"
    },
    "type": "fertility-clinic",
    "name": "Puerto Rico Fertility Center",
    "phone": "(787) 798-0100",
    "address": {
      "line1": "Dr. Arturo Cadilla Building, 100 Paseo San Pablo, Suite 503",
      "city": "Bayamón",
      "state": "PR",
      "zip": "00961",
      "country": "US"
    },
    "location": {
      "lat": 18.3989,
      "lng": -66.1481
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 20.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 17.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 12.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 6.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 208,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27338%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27338%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.prfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Puerto+Rico+Fertility+Center,+100+P.%C2%BA+San+Pablo+Ste+101,+Bayam%C3%B3n,+00961,+Puerto+Rico/@18.3981558,-66.1483011,3786a,13.1y/data=!4m2!3m1!1s0x8c036b288e781ed3:0x8bcb82d0546ac025",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.prfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-338-amaury-j-llorens-md",
        "name": "Amaury J. Llorens, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.prfertility.com/img/team/Doc_Llorens.jpg",
        "_source": {
          "url": "https://www.prfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-338-pedro-j-beauchamp-md-facog-facs-rei",
        "name": "Pedro J. Beauchamp, MD, FACOG, FACS, REI",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG", "FACS", "REI"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.prfertility.com/img/team/Doc_Beauchamp.jpg",
        "_source": {
          "url": "https://www.prfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.prfertility.com/",
    "insurance": {
      "accepted": true,
      "carriers": ["Triple-S", "MCS", "Humana", "Medicare Advantage"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Triple-S, MCS, Humana, Medicare Advantage",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Puerto Rico (PR) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-721",
    "externalIds": {
      "cdcClinicId": "721",
      "googlePlaceId": "ChIJ_USns25F5IkRElslPMLvyYw"
    },
    "type": "fertility-clinic",
    "name": "Women & Infants Fertility Center",
    "phone": "(401) 453-7500",
    "address": {
      "line1": "90 Plain St, 5th Floor",
      "city": "Providence",
      "state": "RI",
      "zip": "02903",
      "country": "US"
    },
    "location": {
      "lat": 41.8141,
      "lng": -71.4123
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 40.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 45.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 32.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 18.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 528,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27721%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27721%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.carenewengland.org/provider-finder",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Women+%26+Infants+Fertility+Center,+90+Plain+St,+Providence,+RI+02903/@41.8140558,-71.412253,2974a,13.1y/data=!4m2!3m1!1s0x89e4456eb3a744fd:0x8cc9efc23c255b12",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-721-virginia-a-mensah-md",
        "name": "Virginia A. Mensah, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Infertility and Reproductive Endocrinology",
        "imageUrl": "https://www.carenewengland.org/hubfs/Headshots/Mensah_Virginia.png",
        "_source": {
          "url": "https://www.carenewengland.org/provider-finder",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-721-jennifer-l-eaton-md-msci",
        "name": "Jennifer L. Eaton, MD, MSCI",
        "role": "Director",
        "credentials": ["MD", "MSCI"],
        "specialty": "Infertility and Reproductive Endocrinology",
        "imageUrl": "https://www.carenewengland.org/hubfs/Headshots/Eaton_Jennifer.png",
        "_source": {
          "url": "https://www.carenewengland.org/provider-finder",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-721-andrey-dolinko-md",
        "name": "Andrey Dolinko, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Infertility and Reproductive Endocrinology",
        "imageUrl": "https://www.carenewengland.org/hubfs/Headshots/Andrey_Dolinko.png",
        "_source": {
          "url": "https://www.carenewengland.org/provider-finder",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-721-jen-bakkensen-md",
        "name": "Jen Bakkensen, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Infertility and Reproductive Endocrinology",
        "imageUrl": "https://www.carenewengland.org/hubfs/Headshots/Jen_Bakkensen.png",
        "_source": {
          "url": "https://www.carenewengland.org/provider-finder",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-721-carol-a-wheeler-md",
        "name": "Carol A. Wheeler, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Infertility and Reproductive Endocrinology",
        "imageUrl": "https://www.carenewengland.org/hubfs/Headshots/Carol_A_Wheeler.png",
        "_source": {
          "url": "https://www.carenewengland.org/provider-finder",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.womenandinfants.org/fertility",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Neighborhood Health Plan"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Neighborhood Health Plan",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Rhode Island (RI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkedwhXswW7XtiBq3rDWZtR8doqtX08_sPCo-WlJ2Wb5aVcS5byPrVHlM_WLmug1tAp2B7xh9wUzTvQhK2pYFgbasC6aVJbzwGSNKpbx7Dv6pXTcqQ4ApEQQK6LSz8AVI-PyLkI=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Women+%26+Infants+Fertility+Center,+90+Plain+St,+Providence,+RI+02903/@41.8140558,-71.412253,2974a,13.1y/data=!4m2!3m1!1s0x89e4456eb3a744fd:0x8cc9efc23c255b12",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-891",
    "externalIds": {
      "cdcClinicId": "891"
    },
    "type": "fertility-clinic",
    "name": "Adore Fertility",
    "phone": "(843) 990-4500",
    "address": {
      "line1": "1280 Hospital Drive, Suite 300",
      "city": "Mount Pleasant",
      "state": "SC",
      "zip": "29464",
      "country": "US"
    },
    "location": {
      "lat": 32.7901,
      "lng": -79.8771
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 3,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27891%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://adorefertility.com/contact/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27891%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://adorefertility.com/our-team/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://adorefertility.com/contact/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://adorefertility.com/contact/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-891-jeris-cox-md",
        "name": "Jeris Cox, MD",
        "role": "Physician | Founding Partner",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://adorefertility.com/wp-content/uploads/2024/04/Dr.-Cox-Headshot.jpg",
        "_source": {
          "url": "https://adorefertility.com/our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-891-sadie-west-rn",
        "name": "Sadie West, RN",
        "role": "Practice Manager & REI Nurse",
        "credentials": ["RN"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://adorefertility.com/wp-content/uploads/2024/04/sadie-west.jpg",
        "_source": {
          "url": "https://adorefertility.com/our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-891-lori-moore-rn",
        "name": "Lori Moore, RN",
        "role": "REI Nurse & IVF Coordinator",
        "credentials": ["RN"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://adorefertility.com/wp-content/uploads/2024/11/lori.jpg",
        "_source": {
          "url": "https://adorefertility.com/our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-891-jennifer-baker",
        "name": "Jennifer Baker",
        "role": "Senior Embryologist & Lab Manager",
        "specialty": "Embryology",
        "imageUrl": "https://adorefertility.com/wp-content/uploads/2024/11/jennifer.jpg",
        "_source": {
          "url": "https://adorefertility.com/our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-891-jordyn-mason",
        "name": "Jordyn Mason",
        "role": "Certified Medical Assistant",
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://adorefertility.com/wp-content/uploads/2023/11/Jordyn-Mason.jpg",
        "_source": {
          "url": "https://adorefertility.com/our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-891-kaila-eaddy",
        "name": "Kaila Eaddy",
        "role": "Certified Surgical Technologist",
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://adorefertility.com/wp-content/uploads/2023/11/Kaila-Eaddy.jpg",
        "_source": {
          "url": "https://adorefertility.com/our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-891-sydney-johnson",
        "name": "Sydney Johnson",
        "role": "Administrative Assistant & Front Desk Manager",
        "imageUrl": "https://adorefertility.com/wp-content/uploads/2023/11/Sydney.jpg",
        "_source": {
          "url": "https://adorefertility.com/our-team/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://adorefertility.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check South Carolina (SC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-89",
    "externalIds": {
      "cdcClinicId": "89",
      "googlePlaceId": "ChIJITyOvr1x_ogRcGaNoBfJfgM"
    },
    "type": "fertility-clinic",
    "name": "Coastal Fertility Specialists",
    "phone": "(843) 883-5800",
    "address": {
      "line1": "1375 Hospital Dr",
      "city": "Mount Pleasant",
      "state": "SC",
      "zip": "29464",
      "country": "US"
    },
    "location": {
      "lat": 32.8165,
      "lng": -79.8535
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 65.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 51.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 57.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 45,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 568,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2789%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.coastalfertilityspecialists.com/locations/mt-pleasant/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2789%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.coastalfertilityspecialists.com/team/physicians/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Coastal+Fertility+Specialists,+1375+Hospital+Dr,+Mt+Pleasant,+SC+29464/@32.8164185,-79.8533912,3353a,13.1y/data=!4m2!3m1!1s0x88fe71bdbe8e3c21:0x37ec917a08d6670",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.coastalfertilityspecialists.com/locations/mt-pleasant/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-89-john-a-schnorr-md",
        "name": "John A. Schnorr, MD",
        "role": "Founder and Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.coastalfertilityspecialists.com/wp-content/uploads/2021/09/JAS-Headshot-cropped.jpg",
        "_source": {
          "url": "https://www.coastalfertilityspecialists.com/team/physicians/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-89-heather-cook-md",
        "name": "Heather Cook, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.coastalfertilityspecialists.com/wp-content/uploads/2021/09/dr-cook-new-headshot-2022-crop.jpg",
        "_source": {
          "url": "https://www.coastalfertilityspecialists.com/team/physicians/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-89-jessica-mclaughlin-md",
        "name": "Jessica McLaughlin, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.coastalfertilityspecialists.com/wp-content/uploads/2021/09/20220812-DSC07336-crop.jpg",
        "_source": {
          "url": "https://www.coastalfertilityspecialists.com/team/physicians/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-89-carrie-riestenberg-md",
        "name": "Carrie Riestenberg, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.coastalfertilityspecialists.com/wp-content/uploads/2022/06/20220812-DSC07161.jpg",
        "_source": {
          "url": "https://www.coastalfertilityspecialists.com/team/physicians/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-89-andrea-peterson-md",
        "name": "Andrea Peterson, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.coastalfertilityspecialists.com/wp-content/uploads/2023/06/Peterson_Andrea_MD_Portraits_2021_8_6-6-2.jpg",
        "_source": {
          "url": "https://www.coastalfertilityspecialists.com/team/physicians/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.coastalfertilityspecialists.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://www.coastalfertilityspecialists.com/wp-content/uploads/2021/09/Lab-2.jpg",
        "type": "interior",
        "caption": "Coastal Fertility Specialists embryology laboratory",
        "_source": {
          "url": "https://www.coastalfertilityspecialists.com/team/laboratory/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkhYRdTDCLhB6pzfCKcWlLI1bzB9d3ei4vwRxj3j3b_5TfPPSIQnymIz2oOv38ZwVM2xf17mjdFsbRg5minoPAT2RLOVNYCwAnUyh4TL2XRmKtz9rQgbv1V2tVpCmUDV-mByYmI=w596-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Coastal+Fertility+Specialists,+1375+Hospital+Dr,+Mt+Pleasant,+SC+29464/@32.8164185,-79.8533912,3353a,13.1y/data=!4m2!3m1!1s0x88fe71bdbe8e3c21:0x37ec917a08d6670",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check South Carolina (SC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-41",
    "externalIds": {
      "cdcClinicId": "41",
      "googlePlaceId": "ChIJ-VDHZgIxWIgRB1B4SjgGFT4"
    },
    "type": "fertility-clinic",
    "name": "Prisma Health Fertility Center of the Carolinas - Faris Road",
    "phone": "(864) 455-4673",
    "address": {
      "line1": "890 West Faris Road, Suite 470",
      "city": "Greenville",
      "state": "SC",
      "zip": "29605",
      "country": "US"
    },
    "location": {
      "lat": 34.8175,
      "lng": -82.4105
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 39.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 25.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 42.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 222,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2741%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://prismahealth.org/locations/practices/fertility-center-of-the-carolinas-faris",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2741%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://doctors.prismahealth.org/specialty/Reproductive%20Endocrinology%20and%20Infertility?page=1",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Prisma+Health+Fertility+Center+of+the+Carolinas%E2%80%93Faris+Road,+890+W+Faris+Rd+Ste+470,+Greenville,+SC+29605/@34.8175183,-82.4105188,3276a,13.1y/data=!4m2!3m1!1s0x8858310266c750f9:0x3e1506384a785007",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://prismahealth.org/locations/practices/fertility-center-of-the-carolinas-faris",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-41-paul-bruce-miller-md",
        "name": "Paul Bruce Miller, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://kyruus-app-static.kyruus.com/providermatch/prisma/photos/200/miller-paul-1194772475.jpg?1623177787543",
        "_source": {
          "url": "https://doctors.prismahealth.org/specialty/Reproductive%20Endocrinology%20and%20Infertility?page=1",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-41-johanna-bailey-von-hofe-md",
        "name": "Johanna Bailey Von Hofe, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://kyruus-app-static.kyruus.com/providermatch/prisma/photos/200/vonhofe-johanna-1235496076.jpg?1599742589822",
        "_source": {
          "url": "https://doctors.prismahealth.org/specialty/Reproductive%20Endocrinology%20and%20Infertility?page=1",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-41-chelsea-webb-fox-md",
        "name": "Chelsea Webb Fox, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://kyruus-app-static.kyruus.com/providermatch/prisma/photos/200/fox-chelsea-1437598968.jpg?1646061141085",
        "_source": {
          "url": "https://doctors.prismahealth.org/specialty/Reproductive%20Endocrinology%20and%20Infertility?page=1",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-41-emily-grace-styles-fnp",
        "name": "Emily Grace Styles, FNP",
        "role": "Nurse Practitioner",
        "credentials": ["FNP"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://kyruus-app-static.kyruus.com/providermatch/prisma/photos/200/styles-emily-1013712850.jpg",
        "_source": {
          "url": "https://doctors.prismahealth.org/specialty/Reproductive%20Endocrinology%20and%20Infertility?page=1",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-41-lauren-mckinney-evans-pa",
        "name": "Lauren McKinney Evans, PA",
        "role": "Physician Assistant",
        "credentials": ["PA"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://kyruus-app-static.kyruus.com/providermatch/prisma/photos/200/mckinney-lauren-1912473570.jpg?1643733168203",
        "_source": {
          "url": "https://doctors.prismahealth.org/specialty/Reproductive%20Endocrinology%20and%20Infertility?page=1",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://prismahealth.org/locations/practices/fertility-center-of-the-carolinas-faris",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check South Carolina (SC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-10",
    "externalIds": {
      "cdcClinicId": "10",
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/piedmont-reproductive-endocrinology-group",
      "googlePlaceId": "ChIJvdhCVvMuWIgRIh11aOGdoyo"
    },
    "type": "fertility-clinic",
    "name": "PREG Greenville",
    "phone": "+1 864-385-2250",
    "address": {
      "line1": "17 Caledon Ct, Suite C",
      "city": "Greenville",
      "state": "SC",
      "zip": "29615",
      "country": "US"
    },
    "location": {
      "lat": 34.8634642,
      "lng": -82.337566
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 47.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 47.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 45.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 587,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2710%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://pregonline.com/locations/greenville/",
            "fetchedAt": "2026-06-15"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2710%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://pregonline.com/team/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Piedmont+Reproductive+Endocrinology+Group+-+Greenville,+17+Caledon+Ct+%23+C,+Greenville,+SC+29615/@34.8631254,-82.3396363,3274a,13.1y/data=!4m2!3m1!1s0x88582ef35642d8bd:0x2aa39de168751d22",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://pregonline.com/locations/greenville/",
            "fetchedAt": "2026-06-15"
          }
        },
        "socialLinks": {
          "status": "scraped",
          "source": {
            "url": "https://pregonline.com/locations/",
            "fetchedAt": "2026-06-15"
          }
        },
        "logo": {
          "status": "scraped",
          "source": {
            "url": "https://pregonline.com/locations/",
            "fetchedAt": "2026-06-15"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-10-john-e-nichols-md",
        "name": "John E. Nichols, MD",
        "role": "Founder & Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2023/02/Dr.-Nichols-Headshot.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-10-john-f-payne-md",
        "name": "John F. Payne, MD",
        "role": "Director of Third-Party Reproduction",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2022/01/Dr.-Payne-Headshot-1.png",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-10-travis-w-mccoy-md",
        "name": "Travis W. McCoy, MD",
        "role": "Director of Surgery & Male Infertility",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2021/11/Dr.-Travis-W.-McCoy.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-10-edward-d-tarnawa-md",
        "name": "Edward D. Tarnawa, MD",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2021/11/Dr.-Tarnawa-Headshot.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-10-kathryn-imgrund-md",
        "name": "Kathryn Imgrund, MD",
        "role": "Advanced Gynecologic Surgery and Infertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2021/11/Dr.-Kathryn-Imgrund.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-10-j-graham-theisen-md-mscr",
        "name": "J. Graham Theisen, MD, MSCR",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD", "MSCR"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/01/Dr.-Theisen-Headshot.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-10-lauren-rouleau-md-phd",
        "name": "Lauren Rouleau, MD, PhD",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/09/Lauren-Rouleau-MD-PHD.jpg",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-10-tarek-k-khader-md",
        "name": "Tarek K. Khader, MD",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/09/Dr.-Tarek-K.-Khader.jpg",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-10-ahmad-h-arabi-md",
        "name": "Ahmad H. Arabi, MD",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/09/Dr.-Arabi-PREG.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-10-jing-chen-phd-hcld-eld",
        "name": "Jing Chen, PhD, HCLD/ELD",
        "role": "Lab Director, Embryologist",
        "credentials": ["PhD", "HCLD/ELD"],
        "specialty": "Embryology",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/02/Dr.-Chen-Headshot-1.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-10-haley-pollack-np",
        "name": "Haley Pollack, NP",
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/02/Halley-Pollack.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-10-madison-browning-np",
        "name": "Madison Browning, NP",
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/02/Madison-Browning.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "network": {
      "name": "US Fertility"
    },
    "website": "https://pregonline.com/locations/greenville/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "images": [],
    "logoUrl": "https://pregonline.com/wp-content/uploads/2025/01/PREG_Logo.png",
    "socialLinks": [
      {
        "platform": "facebook",
        "url": "http://www.facebook.com/PREGonline",
        "label": "Facebook",
        "_source": {
          "url": "https://pregonline.com/locations/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "youtube",
        "url": "https://www.youtube.com/c/PiedmontReproductive",
        "label": "YouTube",
        "_source": {
          "url": "https://pregonline.com/locations/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "instagram",
        "url": "https://www.instagram.com/pregonline/",
        "label": "Instagram",
        "_source": {
          "url": "https://pregonline.com/locations/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "linkedin",
        "url": "https://www.linkedin.com/company/piedmont-reproductive-endocrinology-group/",
        "label": "LinkedIn",
        "_source": {
          "url": "https://pregonline.com/locations/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check South Carolina (SC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-269",
    "externalIds": {
      "cdcClinicId": "269",
      "googlePlaceId": "ChIJ2U93Y_O1jocRtIT1jUCjAZc"
    },
    "type": "fertility-clinic",
    "name": "Sanford Women's Health",
    "phone": "(605) 328-8800",
    "address": {
      "line1": "1500 W. 22nd St, MB3, Suite 102",
      "city": "Sioux Falls",
      "state": "SD",
      "zip": "57105",
      "country": "US"
    },
    "location": {
      "lat": 43.5346,
      "lng": -96.7436
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 31.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 32.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 259,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27269%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27269%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.sanfordhealth.org/locations/sanford-fertility-and-reproductive-medicine",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Sanford+Obstetrics+%26+Gynecology+Clinic,+1500+W+22nd+St+Suite+301,+Sioux+Falls,+SD+57105/@43.5345822,-96.7438795,2892a,13.1y/data=!4m2!3m1!1s0x878eb5f363774fd9:0x9701a3408df584b4",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-269-keith-a-hansen-md",
        "name": "Keith A. Hansen, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.sanfordhealth.org/-/media/org/images/doctors/edith-providers/keith_hansen.jpg?sc_lang=en&hash=CBB50B6CFCB88E7FEFA42A1419FD7B30",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology",
        "_source": {
          "url": "https://www.sanfordhealth.org/locations/sanford-fertility-and-reproductive-medicine",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Peyton Bates, APRN, CNP",
        "role": "Reproductive Endocrinology",
        "credentials": ["APRN", "CNP"],
        "specialty": "Reproductive Endocrinology",
        "imageUrl": "https://www.sanfordhealth.org/-/media/org/images/doctors/providerimages/peyton_bates.jpg",
        "_source": {
          "url": "https://www.sanfordhealth.org/locations/sanford-fertility-and-reproductive-medicine",
          "fetchedAt": "2026-06-13"
        },
        "practitionerId": "pr-org-cdc-269-peyton-bates-aprn-cnp"
      },
      {
        "name": "Emily Boysen, APRN, CNP",
        "role": "Reproductive Endocrinology",
        "credentials": ["APRN", "CNP"],
        "specialty": "Reproductive Endocrinology",
        "imageUrl": "https://www.sanfordhealth.org/-/media/org/images/doctors/providerimages/emily_boysen.jpg",
        "_source": {
          "url": "https://www.sanfordhealth.org/locations/sanford-fertility-and-reproductive-medicine",
          "fetchedAt": "2026-06-13"
        },
        "practitionerId": "pr-org-cdc-269-emily-boysen-aprn-cnp"
      },
      {
        "name": "Jason Flanagan, CGC",
        "role": "Genetic Counseling",
        "credentials": ["MS", "CGC"],
        "specialty": "Genetic Counseling",
        "imageUrl": "https://www.sanfordhealth.org/-/media/org/images/doctors/edith-providers/jason_flanagan.jpg?sc_lang=en&hash=587501BE85B8B4897FE4D69D258FCC3E",
        "_source": {
          "url": "https://www.sanfordhealth.org/locations/sanford-fertility-and-reproductive-medicine",
          "fetchedAt": "2026-06-13"
        },
        "practitionerId": "pr-org-cdc-269-jason-flanagan-cgc"
      },
      {
        "name": "Erica Van Surksum, APRN, CNP",
        "role": "Reproductive Endocrinology",
        "credentials": ["APRN", "CNP"],
        "specialty": "Reproductive Endocrinology",
        "imageUrl": "https://www.sanfordhealth.org/-/media/org/images/doctors/providerimages/vansurksum_erica_mug_rgb_erica-van-surksum.jpg",
        "_source": {
          "url": "https://www.sanfordhealth.org/locations/sanford-fertility-and-reproductive-medicine",
          "fetchedAt": "2026-06-13"
        },
        "practitionerId": "pr-org-cdc-269-erica-van-surksum-aprn-cnp"
      }
    ],
    "website": "https://www.sanfordhealth.org/fertility",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check South Dakota (SD) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-132",
    "externalIds": {
      "cdcClinicId": "132",
      "googlePlaceId": "ChIJWdpMI3BkYIgROV7eGvXodNQ"
    },
    "type": "fertility-clinic",
    "name": "Fertility Center, LLC",
    "phone": "(423) 899-0500",
    "address": {
      "line1": "7407 Ziegler Rd",
      "city": "Chattanooga",
      "state": "TN",
      "zip": "37421",
      "country": "US"
    },
    "location": {
      "lat": 35.0203,
      "lng": -85.1596
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 44.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 57.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 46.15384615384615,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/13"
        }
      ],
      "cyclesPerYear": 169,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27132%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27132%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.myfertilitycenter.com/who-we-are/doctors/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/The+Fertility+Center,+7407+Ziegler+Rd,+Chattanooga,+TN+37421/@35.020203,-85.1597244,3267a,13.1y/data=!4m2!3m1!1s0x88606470234cda59:0xd474e8f51ade5e39",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-132-barry-w-donesky-md",
        "name": "Barry W. Donesky, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.myfertilitycenter.com/wp-content/uploads/2024/10/BarryDonesky.ChattandKnox-1-1.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://www.myfertilitycenter.com/who-we-are/doctors/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Joseph S. Bird Jr., MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.myfertilitycenter.com/wp-content/uploads/2024/10/JosephSBirdJr.Chatt_-1.jpg",
        "_source": {
          "url": "https://www.myfertilitycenter.com/who-we-are/doctors/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-132-joseph-s-bird-jr-md"
      },
      {
        "name": "Joseph S. Bird III, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.myfertilitycenter.com/wp-content/uploads/2024/10/JosephSBirdIII.ChattandKnox-1.jpg",
        "_source": {
          "url": "https://www.myfertilitycenter.com/who-we-are/doctors/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-132-joseph-s-bird-iii-md"
      },
      {
        "name": "Katie Murchison",
        "role": "Women's Health Nurse Practitioner",
        "credentials": ["WHNP-BC"],
        "imageUrl": "https://www.myfertilitycenter.com/wp-content/uploads/2024/10/KatieMurchison.NP_.Chatt_.jpg",
        "_source": {
          "url": "https://www.myfertilitycenter.com/who-we-are/doctors/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-132-katie-murchison"
      }
    ],
    "website": "https://www.fertilitycenterchattanooga.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://www.myfertilitycenter.com/wp-content/uploads/2020/10/contact-location1.jpg",
        "type": "exterior",
        "caption": "Exterior of The Fertility Center, Chattanooga (7407 Ziegler Rd), with fertilitycenter signage over the entrance",
        "_source": {
          "url": "https://www.myfertilitycenter.com/contact/chattanooga/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Tennessee (TN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-152",
    "externalIds": {
      "cdcClinicId": "152"
    },
    "type": "fertility-clinic",
    "name": "Kutteh Ke Fertility Associates of Memphis, PLLC",
    "phone": "(901) 747-2229",
    "address": {
      "line1": "80 Humphreys Center, Suite 307",
      "city": "Memphis",
      "state": "TN",
      "zip": "38120",
      "country": "US"
    },
    "location": {
      "lat": 35.1282,
      "lng": -89.8569
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 60.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 52.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 32.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 370,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27152%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27152%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitymemphis.com/meet-the-team",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-152-raymond-ke-md",
        "name": "Raymond Ke, MD",
        "role": "Medical Director",
        "imageUrl": "https://a.storyblok.com/f/290132/1114x1688/5086b12d7a/raymond-ke-md.png/m/0x2000/filters:no_upscale()",
        "credentials": ["MD", "HCLD"],
        "_source": {
          "url": "https://www.fertilitymemphis.com/meet-the-team",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "William Kutteh, MD",
        "role": "Reproductive Endocrinologist; Co-Director of the Center for Recurrent Pregnancy Loss",
        "credentials": ["MD", "PhD", "HCLD"],
        "imageUrl": "https://a.storyblok.com/f/290132/1116x1688/de31614aaf/william-kutteh-md.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://www.fertilitymemphis.com/meet-the-team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-152-william-kutteh-md"
      },
      {
        "name": "Amelia Bailey, MD",
        "role": "Reproductive Endocrinologist; Director of Fertility Preservation",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/1120x1688/4bb87cf8f9/amelia-bailey-md.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://www.fertilitymemphis.com/meet-the-team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-152-amelia-bailey-md"
      },
      {
        "name": "Paul Brezina, MD",
        "role": "Reproductive Endocrinologist; Managing Physician and Director of Reproductive Genetics",
        "credentials": ["MD", "MBA"],
        "imageUrl": "https://a.storyblok.com/f/290132/1122x1688/8057794954/paul-brezina-md.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://www.fertilitymemphis.com/meet-the-team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-152-paul-brezina-md"
      },
      {
        "name": "Todd Chappell, MD",
        "role": "OB/GYN; Director of Minimally Invasive Gynecologic Surgery",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://a.storyblok.com/f/290132/1118x1688/6e2a74dab1/todd-chappell-md.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://www.fertilitymemphis.com/meet-the-team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-152-todd-chappell-md"
      },
      {
        "name": "Sierra Bishop, MD",
        "role": "Physician (Obstetrics, Gynecology, and Reproductive Medicine)",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/1711x2566/7dfd08efd2/dr-sierra-bishop.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://www.fertilitymemphis.com/meet-the-team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-152-sierra-bishop-md"
      }
    ],
    "website": "https://www.kutteh.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Tennessee (TN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-258",
    "externalIds": {
      "cdcClinicId": "258",
      "googlePlaceId": "ChIJmRLUfLhmZIgRj6TZkMsOC-I"
    },
    "type": "fertility-clinic",
    "name": "Nashville Fertility Center",
    "phone": "(615) 321-4740",
    "address": {
      "line1": "345 23rd Ave North, Suite 401",
      "city": "Nashville",
      "state": "TN",
      "zip": "37203",
      "country": "US"
    },
    "location": {
      "lat": 36.155,
      "lng": -86.8096
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 58.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 51.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 61.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 46.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 616,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27258%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27258%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.nashvillefertility.com/about-us/fertility-specialists/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Nashville+Fertility+Center,+345+23rd+Ave+N+%23401,+Nashville,+TN+37203/@36.1550075,-86.8096365,3221a,13.1y/data=!4m2!3m1!1s0x886466b87cd41299:0xe20b0ecb90d9a48f",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-258-george-a-hill-md",
        "name": "George A. Hill, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2021/06/George-Hill-2021-SQ.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/fertility-specialists/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Abby Eblen, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2021/06/Abby-Eblen-2021-SQ-.jpg",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/fertility-specialists/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-258-abby-eblen-md"
      },
      {
        "name": "Kristin Van Heertum, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2021/06/Kristin-Van-Heertum-2021-SQ.jpg",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/fertility-specialists/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-258-kristin-van-heertum-md"
      },
      {
        "name": "Meghan (Meggie) Smith, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2021/06/Meggie-Smith-2021-SQ-e1622567677634.jpg",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/fertility-specialists/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-258-meghan-meggie-smith-md"
      },
      {
        "name": "Meredith A. Humphreys, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2024/01/NFCHumphreys_cropped.jpg",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/fertility-specialists/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-258-meredith-a-humphreys-md"
      },
      {
        "name": "Colleen Miller, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2025/12/NFC_Colleen_Miller_600.png",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/fertility-specialists/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-258-colleen-miller-md"
      },
      {
        "name": "Carly Warfield, APN",
        "role": "Nurse Practitioner / Clinic Manager",
        "credentials": ["APN"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2023/01/carly-warfield-apn-clinic-manager-2-scaled-1-860x1024.jpg",
        "_source": {
          "url": "https://www.nashvillefertility.com/meet-our-clinical-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-258-carly-warfield-apn"
      },
      {
        "name": "Martha Goodyear, APN",
        "role": "Nurse Practitioner",
        "credentials": ["APN"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2023/01/martha-goodyear-apn.jpg",
        "_source": {
          "url": "https://www.nashvillefertility.com/meet-our-clinical-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-258-martha-goodyear-apn"
      },
      {
        "name": "Kelley Whitaker, APN",
        "role": "Nurse Practitioner",
        "credentials": ["APN"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2021/06/NFC-HS-0038-scaled-e1622987072699-822x1024.jpg",
        "_source": {
          "url": "https://www.nashvillefertility.com/meet-our-clinical-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-258-kelley-whitaker-apn"
      },
      {
        "name": "Andrea Yates, APN",
        "role": "Nurse Practitioner",
        "credentials": ["APN"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2023/01/andrea-yates-apn-1.jpg",
        "_source": {
          "url": "https://www.nashvillefertility.com/meet-our-clinical-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-258-andrea-yates-apn"
      },
      {
        "name": "Ellen Rogers, APRN",
        "role": "Nurse Practitioner",
        "credentials": ["APRN"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2023/01/ellen-rogers-aprn.jpg",
        "_source": {
          "url": "https://www.nashvillefertility.com/meet-our-clinical-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-258-ellen-rogers-aprn"
      },
      {
        "name": "Jamie D'Souza, APN",
        "role": "Nurse Practitioner",
        "credentials": ["APN"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2023/01/jamie-dsouza-apn-1.jpg",
        "_source": {
          "url": "https://www.nashvillefertility.com/meet-our-clinical-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-258-jamie-d-souza-apn"
      }
    ],
    "website": "https://www.nashvillefertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://www.nashvillefertility.com/wp-content/uploads/2024/10/mast-int-nashville-fertility-center.webp",
        "type": "exterior",
        "caption": "Nashville Fertility Center building exterior at TriStar Centennial Professional Plaza, 345 23rd Ave North",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/find-a-tennessee-fertility-center/nashville-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Tennessee (TN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-314",
    "externalIds": {
      "cdcClinicId": "314"
    },
    "type": "fertility-clinic",
    "name": "Quillen Fertility & Women's Services",
    "phone": "(423) 439-7246",
    "address": {
      "line1": "1319 Sunset Dr, Suite 103",
      "city": "Johnson City",
      "state": "TN",
      "zip": "37604",
      "country": "US"
    },
    "location": {
      "lat": 36.3274,
      "lng": -82.3925
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 35,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 28,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27314%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27314%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.etsuhealth.org/locations/fertility-urogynecology.php",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-314-mark-x-ransom-md",
        "name": "Mark X. Ransom, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.etsuhealth.org/pictures/provider-images/ranson_mark_wc_web.jpg",
        "credentials": ["MD", "FACOG", "HCLD"],
        "_source": {
          "url": "https://www.etsuhealth.org/find-a-doctor/obgyn/ransom.php",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.quillenfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://www.etsuhealth.org/pictures/locations/fertility-urogynecology.jpg",
        "type": "exterior",
        "caption": "Exterior of ETSU Health Fertility & Urogynecology (Quillen Fertility & Women's Services), Suite 103, 1319 Sunset Dr, Johnson City, TN",
        "_source": {
          "url": "https://www.etsuhealth.org/locations/fertility-urogynecology.php",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.etsuhealth.org/pictures/locations/johnson-city_fertility_uro-gynecology_etsu-health.jpg",
        "type": "exterior",
        "caption": "Building entrance of ETSU Health Fertility & Urogynecology, Suite 103, Johnson City, TN",
        "_source": {
          "url": "https://www.etsuhealth.org/services/obgyn/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Tennessee (TN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-436",
    "externalIds": {
      "cdcClinicId": "436"
    },
    "type": "fertility-clinic",
    "name": "Southeastern Center for Fertility and Reproductive Surgery, PLLC",
    "phone": "(865) 777-0088",
    "address": {
      "line1": "11126 Kingston Pike",
      "city": "Knoxville",
      "state": "TN",
      "zip": "37934",
      "country": "US"
    },
    "location": {
      "lat": 35.8858,
      "lng": -84.1503
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 43.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 16,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 47.368421052631575,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "9/19"
        }
      ],
      "cyclesPerYear": 242,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27436%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27436%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://southeasternfertility.pages.dev/about-us/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-436-john-david-gordon-md",
        "name": "John David Gordon, MD",
        "role": "Medical Director",
        "imageUrl": "https://southeasternfertility.pages.dev/images/gordon.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://southeasternfertility.pages.dev/about-us/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Jeffrey Keenan, MD, HCLD",
        "role": "Founder, Reproductive Endocrinologist",
        "credentials": ["MD", "HCLD"],
        "imageUrl": "https://southeasternfertility.pages.dev/images/keenan.jpg",
        "_source": {
          "url": "https://southeasternfertility.pages.dev/about-us/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-436-jeffrey-keenan-md-hcld"
      },
      {
        "name": "Allyn Ann Simpson, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["WHNP-BC"],
        "imageUrl": "https://southeasternfertility.pages.dev/images/staff/AllynAnnNew.png",
        "_source": {
          "url": "https://southeasternfertility.pages.dev/about-us/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-436-allyn-ann-simpson-whnp-bc"
      }
    ],
    "website": "https://www.sefertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Tennessee (TN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-715",
    "externalIds": {
      "cdcClinicId": "715",
      "googlePlaceId": "ChIJG95nj997ZIgR7CM-Z5_1lfY"
    },
    "type": "fertility-clinic",
    "name": "Tennessee Fertility Institute",
    "phone": "(615) 721-6250",
    "address": {
      "line1": "9160 Carothers Pkwy, Suite 201",
      "city": "Franklin",
      "state": "TN",
      "zip": "37067",
      "country": "US"
    },
    "location": {
      "lat": 35.9602,
      "lng": -86.8002
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 55.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 47.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 44,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 225,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27715%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27715%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.tnfertility.com/our-fertility-clinics/franklin-fertility-clinic",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Tennessee+Fertility+Institute,+9160+Carothers+Pkwy+Ste+201,+Franklin,+TN+37067/@35.9602109,-86.8001736,3229a,13.1y/data=!4m2!3m1!1s0x88647bdf8f67de1b:0xf695f59f673e23ec",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-715-christopher-p-montville-md",
        "name": "Christopher P. Montville, MD",
        "role": "Medical Director"
      },
      {
        "name": "Jane I. Ruman, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.buttercms.com/idzxTAdNQ3uCpfHeT3Tu",
        "_source": {
          "url": "https://www.tnfertility.com/fertility-specialists/dr-jane-ruman",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-715-jane-i-ruman-md"
      },
      {
        "name": "Pinar H. Kodaman, MD, PhD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "PhD"],
        "imageUrl": "https://cdn.buttercms.com/jH9TgXsNSgqNHBdo0Uup",
        "_source": {
          "url": "https://www.tnfertility.com/fertility-specialists/dr-pinar-kodaman",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-715-pinar-h-kodaman-md-phd"
      },
      {
        "name": "Brooke Rittenberry, RN, MSN, WHNP-BC",
        "role": "Women's Health Nurse Practitioner",
        "credentials": ["RN", "MSN", "WHNP-BC"],
        "imageUrl": "https://cdn.buttercms.com/8FycynQET3GwYBWWUBSL",
        "_source": {
          "url": "https://www.tnfertility.com/brooke-rittenberry",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-715-brooke-rittenberry-rn-msn-whnp-bc"
      },
      {
        "name": "Kayleigh Holthaus, CNM, MSN",
        "role": "Certified Nurse Midwife",
        "credentials": ["CNM", "MSN"],
        "imageUrl": "https://cdn.buttercms.com/BbAKGGokRku5wsWkY4nL",
        "_source": {
          "url": "https://www.tnfertility.com/kayleigh-holthaus",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-715-kayleigh-holthaus-cnm-msn"
      }
    ],
    "website": "https://www.tnfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://cdn.buttercms.com/P6KgniHkSiOyAqp0u7nl",
        "type": "exterior",
        "caption": "Exterior of the Tennessee Fertility Institute Franklin clinic at 9160 Carothers Pkwy (the 9160 address is visible on the building tower).",
        "_source": {
          "url": "https://www.tnfertility.com/our-fertility-clinics/franklin-fertility-clinic",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkwkbXOs08zuCFXogFxauYnqvHbq4t0JK8kgx-Ox-OpUs6rWfcPX8-VxGQvRiffOupZRAvq_ti9AE2SLU1Bzws-xQ5Fym5CVMnTg_NPKECSeflcnfq0dZKtIbQsf6npKZ2T4LCIND991QIG=w588-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Tennessee+Fertility+Institute,+9160+Carothers+Pkwy+Ste+201,+Franklin,+TN+37067/@35.9602109,-86.8001736,3229a,13.1y/data=!4m2!3m1!1s0x88647bdf8f67de1b:0xf695f59f673e23ec",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm17xqzsVEbFajQ-gwUqBPA5VFDo09H4HNlpEDFTEbTaMGPwo2W-Ak2djZMwryokwWMKZxb2kFEIBiuB4duPePKR3xvJtIcSwKXdRiZ09xkNj3x81qJv57pEvA9Tsr0xF17E2cxsF7E2uw=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Tennessee+Fertility+Institute,+9160+Carothers+Pkwy+Ste+201,+Franklin,+TN+37067/@35.9602109,-86.8001736,3229a,13.1y/data=!4m2!3m1!1s0x88647bdf8f67de1b:0xf695f59f673e23ec",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Tennessee (TN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-307",
    "externalIds": {
      "cdcClinicId": "307",
      "googlePlaceId": "ChIJA26MYOdjYIgRMUY8ST6Ao6w"
    },
    "type": "fertility-clinic",
    "name": "Tennessee Reproductive Medicine",
    "phone": "(423) 876-2229",
    "address": {
      "line1": "6031 Shallowford Rd, Suite 101",
      "city": "Chattanooga",
      "state": "TN",
      "zip": "37421",
      "country": "US"
    },
    "location": {
      "lat": 35.0539,
      "lng": -85.183
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 48.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 56.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 55.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 230,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27307%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27307%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://trmbaby.com/about-us/doctors/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Tennessee+Reproductive+Medicine,+6031+Shallowford+Rd+%23101,+Chattanooga,+TN+37421/@35.0538787,-85.1831817,3266a,13.1y/data=!4m2!3m1!1s0x886063e7608c6e03:0xaca3803e493c4631",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-307-ringland-s-murray-md",
        "name": "Ringland S. Murray, MD",
        "role": "Medical Director",
        "imageUrl": "https://trmbaby.com/wp-content/uploads/Dr.Murray-web-e1478135007329-2-400x598.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://trmbaby.com/about-us/doctors/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Jessica Scotchie, MD",
        "role": "Reproductive Endocrinologist & OB/GYN",
        "credentials": ["MD"],
        "imageUrl": "https://trmbaby.com/wp-content/uploads/photo-trm-scotchie-headshot-400x600.jpg",
        "_source": {
          "url": "https://trmbaby.com/about-us/doctors/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-307-jessica-scotchie-md"
      },
      {
        "name": "Shelby Wright",
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "imageUrl": "https://trmbaby.com/wp-content/uploads/S.-Wright-2-scaled-1-400x320.jpg",
        "_source": {
          "url": "https://trmbaby.com/about-us/doctors/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-307-shelby-wright"
      }
    ],
    "website": "https://www.tnreproductivemedicine.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://trmbaby.com/wp-content/uploads/medClinic.jpg",
        "type": "exterior",
        "caption": "Tennessee Reproductive Medicine clinic building exterior with entrance and signage",
        "_source": {
          "url": "https://trmbaby.com/about-us/about/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Tennessee (TN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-66",
    "externalIds": {
      "cdcClinicId": "66",
      "googlePlaceId": "ChIJ88LVoLlmZIgRM4GYiGMcXT0"
    },
    "type": "fertility-clinic",
    "name": "The Center for Reproductive Health",
    "phone": "(615) 321-8899",
    "address": {
      "line1": "2410 Patterson St, Suite 401",
      "city": "Nashville",
      "state": "TN",
      "zip": "37203",
      "country": "US"
    },
    "location": {
      "lat": 36.1523,
      "lng": -86.8109
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 20.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 103,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2766%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2766%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://web.archive.org/web/2023/https://www.crhnashville.com/our-providers/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Center+For+Reproductive+Health,+2410+Patterson+St+Ste+401,+Nashville,+TN+37203/@36.1525069,-86.8110094,3222a,13.1y/data=!4m2!3m1!1s0x886466b9a0d5c2f3:0x3d5d1c6388988133",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch3-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-66-jaime-m-vasquez-md",
        "name": "Jaime M. Vasquez, MD",
        "role": "Medical Director",
        "imageUrl": "https://web.archive.org/web/20231111032303if_/https://www.crhnashville.com/uploads/provider/small/1678657244-photo.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://web.archive.org/web/2023/https://www.crhnashville.com/our-providers/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Shannon Maloney, WHNP",
        "role": "Women's Health Nurse Practitioner",
        "credentials": ["WHNP", "RN"],
        "imageUrl": "https://web.archive.org/web/20231111034548if_/https://www.crhnashville.com/uploads/provider/small/1678658445-photo.jpg",
        "_source": {
          "url": "https://web.archive.org/web/2023/https://www.crhnashville.com/our-providers/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-66-shannon-maloney-whnp"
      }
    ],
    "website": "https://www.nashvillefertilitycenter.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Tennessee (TN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlvViZBadaYYS79w-xfEPFQWMAvDzBBPqxki8QHKQ9_1LT6Y0vwxai5qJD2DhOdb9-vR7pzMB4KwXd-pZNvTJfhK8MnjmbWHWWw2jVR06VT9RpBnYhDT2xD938ydx6nilZ_S0g=w539-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Center+For+Reproductive+Health,+2410+Patterson+St+Ste+401,+Nashville,+TN+37203/@36.1525069,-86.8110094,3222a,13.1y/data=!4m2!3m1!1s0x886466b9a0d5c2f3:0x3d5d1c6388988133",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlRhmIJoLbH8BW_4ctPs-W2bjxbGXHIfelQinUVKkT2ky2vlEqBOvSl0Ut2eYhpIOxasdzAzizvbcB_hltYBYhq7LGRSgPOyB9RgsvfGNpC_IJcMnm-D1LYb7L00RQSKuUl6rqRRw=w224-h298-k-no-pi0-ya272-ro-0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Center+For+Reproductive+Health,+2410+Patterson+St+Ste+401,+Nashville,+TN+37203/@36.1525069,-86.8110094,3222a,13.1y/data=!4m2!3m1!1s0x886466b9a0d5c2f3:0x3d5d1c6388988133",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-489",
    "externalIds": {
      "cdcClinicId": "489",
      "googlePlaceId": "ChIJrZle70jbQIYR4WM4Exx588Q"
    },
    "type": "fertility-clinic",
    "name": "Advanced Fertility Center of Texas",
    "phone": "(713) 467-4488",
    "address": {
      "line1": "10901 Katy Freeway",
      "city": "Houston",
      "state": "TX",
      "zip": "77079",
      "country": "US"
    },
    "location": {
      "lat": 29.7837,
      "lng": -95.5702
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 46.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 48.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 58.333333333333336,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/12"
        }
      ],
      "cyclesPerYear": 169,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27489%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "minimal",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.infertilityanswers.com/dr-michael-allon/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Advanced+Fertility+Center+of+Texas,+10901+Katy+Fwy,+Houston,+TX+77079/@29.7837218,-95.5701143,3463a,13.1y/data=!4m2!3m1!1s0x8640db48ef5e99ad:0xc4f3791c133863e1",
            "fetchedAt": "2026-08-16"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27489%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-489-michael-a-allon-md",
        "name": "Michael A. Allon, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.infertilityanswers.com/images/pages/dr-1.png",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.infertilityanswers.com/dr-michael-allon/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.afctexas.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkPEt3TH6M0R_J9_IdA2Y0KURl3brbXXGsNdKhA43OVqV0Y55yJ__dYrAanZ-Tb9Kuk1kKecTMqM7YMLdhfvE7_J4lIgd8bvZa-8QD6wbEobl-GUPQzNNxLpdaFg_5zeM6ThaZ7TrmckAN7=w565-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Advanced+Fertility+Center+of+Texas,+10901+Katy+Fwy,+Houston,+TX+77079/@29.7837218,-95.5701143,3463a,13.1y/data=!4m2!3m1!1s0x8640db48ef5e99ad:0xc4f3791c133863e1",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkKUEOlMDoJ3DaFjpCvLvfMomRpcjbQjG-lTP3xlWVWuk1SxeFPKMv8RutFxwslg0KGOztqM-Zwlma4dbz_BF5fXzyVUY69g5nYmtU8-w0E-_iQhOKa67-Qv-yjYZLHDcvUymUslD8xRDI=w497-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Advanced+Fertility+Center+of+Texas,+10901+Katy+Fwy,+Houston,+TX+77079/@29.7837218,-95.5701143,3463a,13.1y/data=!4m2!3m1!1s0x8640db48ef5e99ad:0xc4f3791c133863e1",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-622",
    "externalIds": {
      "cdcClinicId": "622"
    },
    "type": "fertility-clinic",
    "name": "Advanced Fertility Centers, PLLC",
    "phone": "(432) 614-6376",
    "address": {
      "line1": "420 E. 6th St, Suite 101",
      "city": "Odessa",
      "state": "TX",
      "zip": "79761",
      "country": "US"
    },
    "location": {
      "lat": 31.8511,
      "lng": -102.366
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 66.66666666666666,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "12/18"
        }
      ],
      "cyclesPerYear": 26,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27622%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.afcivf.com/our-team/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27622%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-622-rizwan-malik-md",
        "name": "Rizwan Malik, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.afcivf.com/wp-content/uploads/2019/07/1489876130.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.afcivf.com/our-team/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "description": "Advanced Fertility Centers in Odessa, Texas provides fertility treatment services including IVF, IUI, and reproductive endocrinology.",
    "languages": ["English", "Spanish"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-42",
    "externalIds": {
      "cdcClinicId": "42",
      "googlePlaceId": "ChIJLUiu1pG1RIYR82jOAvMybgk"
    },
    "type": "fertility-clinic",
    "name": "Aspire Fertility-Austin",
    "phone": "(512) 479-7979",
    "address": {
      "line1": "911 W. 38th St, Suite 402",
      "city": "Austin",
      "state": "TX",
      "zip": "78705",
      "country": "US"
    },
    "location": {
      "lat": 30.3046,
      "lng": -97.7432
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 52,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 50.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 61.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 75,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/8"
        }
      ],
      "cyclesPerYear": 275,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2742%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2742%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+Austin,+911+W+38th+St+Bldg+2+Suite+402,+Austin,+TX+78705/@30.3047038,-97.743056,3445a,13.1y/data=!4m2!3m1!1s0x8644b591d6ae482d:0x96e32f302ce68f3",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.aspirefertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-42-christine-mansfield-md",
        "name": "Christine Mansfield, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.aspirefertility.com",
    "description": "Castle Connolly has recognized five of our Texas fertility specialists as 2026 Top Doctors\\",
    "insurance": {
      "accepted": true,
      "carriers": ["Optum"],
      "employeeBenefits": ["Progyny"],
      "_source": {
        "url": "https://www.aspirefertility.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["Spanish", "Chinese", "Vietnamese", "English"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmFowtfODttc4wMyyHg8uT_mF0Yy3hiXQbAh7SSW8YjZ50TX4-epSCTzsWA-Lz_tXdzfylooJdtsYbmsT8JAZYjGJ5_dnS3fm35XxJgJ8URgfIC2iE1mrxEJpQJ7u7hTYbe3OOQxg=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+Austin,+911+W+38th+St+Bldg+2+Suite+402,+Austin,+TX+78705/@30.3047038,-97.743056,3445a,13.1y/data=!4m2!3m1!1s0x8644b591d6ae482d:0x96e32f302ce68f3",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "network": {
      "name": "Prelude Network"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Optum",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.aspirefertility.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-703",
    "externalIds": {
      "cdcClinicId": "703",
      "googlePlaceId": "ChIJ-wAdPlIhTIYRD1nkLMc-q0A"
    },
    "type": "fertility-clinic",
    "name": "Aspire Fertility-Dallas",
    "phone": "(214) 414-3806",
    "address": {
      "line1": "16415 Addison Rd, Suite 900",
      "city": "Addison",
      "state": "TX",
      "zip": "75001",
      "country": "US"
    },
    "location": {
      "lat": 32.9724,
      "lng": -96.8308
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 34.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 32.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 47.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 297,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27703%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27703%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+Addison,+16415+Addison+Rd+Ste+900,+Addison,+TX+75001/@32.9727376,-96.8305909,3347a,13.1y/data=!4m2!3m1!1s0x864c21523e1d00fb:0x40ab3ec72ce4590f",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.aspirefertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-703-christine-mansfield-md",
        "name": "Christine Mansfield, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.aspirefertility.com",
    "description": "Castle Connolly has recognized five of our Texas fertility specialists as 2026 Top Doctors\\",
    "insurance": {
      "accepted": true,
      "carriers": ["Optum"],
      "employeeBenefits": ["Progyny"],
      "_source": {
        "url": "https://www.aspirefertility.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["Spanish", "Chinese", "Vietnamese", "English"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlaVHWQIZmnqx7k-tBU4FS5OIzHLaPmYhCkhhm0tAdurrKMX_ckKySfYlAXQhydDSAKjgNfewyDu7qFCmtlNnouL8RunyienBc7151Awigrm7wDBJcCxnUDN2CTdLn_rdYsPvtb=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+Addison,+16415+Addison+Rd+Ste+900,+Addison,+TX+75001/@32.9727376,-96.8305909,3347a,13.1y/data=!4m2!3m1!1s0x864c21523e1d00fb:0x40ab3ec72ce4590f",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "network": {
      "name": "Prelude Network"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Optum",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.aspirefertility.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-62",
    "externalIds": {
      "cdcClinicId": "62",
      "googlePlaceId": "ChIJBa6BqhJiXIYRCRW3mTZBDyg"
    },
    "type": "fertility-clinic",
    "name": "Aspire Fertility-San Antonio",
    "phone": "(210) 337-8453",
    "address": {
      "line1": "150 E. Sonterra Blvd, Suite 220",
      "city": "San Antonio",
      "state": "TX",
      "zip": "78258",
      "country": "US"
    },
    "location": {
      "lat": 29.6153,
      "lng": -98.4922
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 57.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 54.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 56,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 40,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/15"
        }
      ],
      "cyclesPerYear": 618,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2762%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2762%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+Stone+Oak,+150+E+Sonterra+Blvd+Suite+220,+San+Antonio,+TX+78258/@29.6152703,-98.4922013,3469a,13.1y/data=!4m2!3m1!1s0x865c6212aa81ae05:0x280f413699b71509",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.aspirefertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-62-ursula-balthazar-md",
        "name": "Ursula Balthazar, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.aspirefertility.com",
    "description": "Castle Connolly has recognized five of our Texas fertility specialists as 2026 Top Doctors\\",
    "insurance": {
      "accepted": true,
      "carriers": ["Optum"],
      "employeeBenefits": ["Progyny"],
      "_source": {
        "url": "https://www.aspirefertility.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["Spanish", "Chinese", "Vietnamese", "English"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk0KiT1XBl6ih0pJgN9yfkIVMR_GJW7Z_2PMDBFFAWm_tgU11v9AKVUsYU1WugCOqu3A_FNpx_o03FVq2-bC-_qZMZdV-tUq11JV7ml0HHERGkZ23OPLN-IoYkBgjhUA1PP1OuW=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+Stone+Oak,+150+E+Sonterra+Blvd+Suite+220,+San+Antonio,+TX+78258/@29.6152703,-98.4922013,3469a,13.1y/data=!4m2!3m1!1s0x865c6212aa81ae05:0x280f413699b71509",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "network": {
      "name": "Prelude Network"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Optum",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.aspirefertility.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-442",
    "externalIds": {
      "cdcClinicId": "442"
    },
    "type": "fertility-clinic",
    "name": "Austin Fertility and Reproductive Medicine-Westlake IVF",
    "phone": "(512) 444-1414",
    "address": {
      "line1": "300 Beardsley Ln, Bldg B, Suite 200",
      "city": "Austin",
      "state": "TX",
      "zip": "78746",
      "country": "US"
    },
    "location": {
      "lat": 30.3133,
      "lng": -97.8541
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 48.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 31.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 45,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 176,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27442%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27442%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.austinfertility.com/about/medical-team/shahryar-k-kavoussi-md-mph-facog/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.austinfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-442-shahryar-k-kavoussi-md",
        "name": "Shahryar K. Kavoussi, MD",
        "role": "Medical Director",
        "imageUrl": "https://afrm.wpenginepowered.com/wp-content/uploads/2015/08/Dr-S.jpg",
        "credentials": ["MD", "MPH", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.austinfertility.com/about/medical-team/shahryar-k-kavoussi-md-mph-facog/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.austinfertility.com",
    "languages": ["English"],
    "images": [],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-112",
    "externalIds": {
      "cdcClinicId": "112",
      "googlePlaceId": "ChIJQZbqchzMRIYRP_Dl7AkorS0"
    },
    "type": "fertility-clinic",
    "name": "Austin Fertility Institute, PA",
    "phone": "(512) 339-4234",
    "address": {
      "line1": "2200 Park Bend Dr, Bldg 2, Suite 201",
      "city": "Austin",
      "state": "TX",
      "zip": "78758",
      "country": "US"
    },
    "location": {
      "lat": 30.4095,
      "lng": -97.7031
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 43.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 37.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 48,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 165,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27112%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "scraped-retry",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://austinfertilityinstitute.com/dr-kenneth-moghadam/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Austin+Fertility+Institute,+2200+Park+Bend+Dr+Bldg+2+Suite+201,+Austin,+TX+78758/@30.4094144,-97.7031441,3441a,13.1y/data=!4m2!3m1!1s0x8644cc1c72ea9641:0x2dad2809ece5f03f",
            "fetchedAt": "2026-08-16"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27112%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-112-kenneth-k-moghadam-md",
        "name": "Kenneth K. Moghadam, MD",
        "role": "Medical Director",
        "imageUrl": "https://austinfertilityinstitute.com/wp-content/uploads/Moghadam-2016-3-480x640.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://austinfertilityinstitute.com/dr-kenneth-moghadam/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.austinfertilityinstitute.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-289",
    "externalIds": {
      "cdcClinicId": "289"
    },
    "type": "fertility-clinic",
    "name": "Brooke Army Medical Center",
    "phone": "(210) 916-6305",
    "address": {
      "line1": "Department of Obstetrics & Gynecology, 3551 Roger Brooke Dr",
      "city": "Fort Sam Houston",
      "state": "TX",
      "zip": "78234",
      "country": "US"
    },
    "location": {
      "lat": 37.7018,
      "lng": -97.316
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 44.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 46.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 47.368421052631575,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "9/19"
        }
      ],
      "cyclesPerYear": 121,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27289%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27289%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-289-rhiana-saunders-md",
        "name": "Rhiana Saunders, MD",
        "role": "Medical Director"
      }
    ],
    "description": "Brooke Army Medical Center (BAMC) at Fort Sam Houston provides fertility and reproductive medicine services to active duty military, retirees, and their families.",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-427",
    "externalIds": {
      "cdcClinicId": "427",
      "googlePlaceId": "ChIJEfmxzfI8TIYRplTBVJRuiAQ"
    },
    "type": "fertility-clinic",
    "name": "CCRM Dallas-Fort Worth",
    "phone": "(972) 377-2625",
    "address": {
      "line1": "8380 Warren Pkwy, Suite 201",
      "city": "Frisco",
      "state": "TX",
      "zip": "75034",
      "country": "US"
    },
    "location": {
      "lat": 33.1089,
      "lng": -96.8142
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 61.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 53.84615384615385,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/13"
        },
        {
          "ageBand": "38-40",
          "rate": 41.17647058823529,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/17"
        },
        {
          "ageBand": ">40",
          "rate": 83.33333333333334,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/6"
        }
      ],
      "cyclesPerYear": 163,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27427%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27427%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Dallas-Fort+Worth,+8380+Warren+Pkwy+Ste+201,+Frisco,+TX+75034/@33.1088372,-96.8137967,3342a,13.1y/data=!4m2!3m1!1s0x864c3cf2cdb1f911:0x4886e9454c154a6",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-427-dorette-j-noorhasan-md",
        "name": "Dorette J. Noorhasan, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.ccrmivf.com",
    "languages": [
      "English",
      "Spanish",
      "Chinese",
      "Arabic",
      "Russian",
      "French",
      "Portuguese",
      "Italian",
      "German"
    ],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnISzj2--fLwpxyTZc77AKfwlo_tuthA0CSWVWTz57R9MoBpacqUH18Zce3vGruMwd-9IYY3j5e0TjstBDDuoshb3DS5U8zfbJIOS_IbUGk32lyFuy87Ixe8Md7IWTeVGLE4u-8=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Dallas-Fort+Worth,+8380+Warren+Pkwy+Ste+201,+Frisco,+TX+75034/@33.1088372,-96.8137967,3342a,13.1y/data=!4m2!3m1!1s0x864c3cf2cdb1f911:0x4886e9454c154a6",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmFXOHD-CMBjqglXXf040jqEi5wT3NfM_xvoF5e33zCGtwDF8n78nMvzozkhuB3EK4ZkqkbgvM-EF6AtfEXznWOkg2EdVJhwxLHt94umV_a6CKnSGtn4wZHzQFYeHRO2mq0yys=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Dallas-Fort+Worth,+8380+Warren+Pkwy+Ste+201,+Frisco,+TX+75034/@33.1088372,-96.8137967,3342a,13.1y/data=!4m2!3m1!1s0x864c3cf2cdb1f911:0x4886e9454c154a6",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-249",
    "externalIds": {
      "cdcClinicId": "249"
    },
    "type": "fertility-clinic",
    "name": "Center for Assisted Reproduction",
    "phone": "(817) 540-1157",
    "address": {
      "line1": "1701 Park Place Ave",
      "city": "Bedford",
      "state": "TX",
      "zip": "76022",
      "country": "US"
    },
    "location": {
      "lat": 32.8344,
      "lng": -97.1295
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 44,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 29.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 38.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 22.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 464,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27249%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27249%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.embryo.net/provider/kevin-j-doody-m-d-hcld",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.embryo.net",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-249-kevin-j-doody-md",
        "name": "Kevin J. Doody, MD",
        "role": "Medical Director",
        "imageUrl": "https://sa1s3optim.patientpop.com/assets/production/practices/021d7e70fa771213a45bed3387ead6ca5054df2c/images/2808117.png",
        "credentials": ["MD", "HCLD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.embryo.net/provider/kevin-j-doody-m-d-hcld",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.embryo.net",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross",
        "Blue Shield",
        "Cigna",
        "Humana",
        "Multiplan",
        "Tricare",
        "First Health",
        "BCBS"
      ],
      "_source": {
        "url": "https://www.embryo.net",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["Spanish", "Mandarin Chinese", "English"],
    "images": [],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross, Blue Shield, Cigna, Humana, Multiplan, Tricare, First Health",
              "detail": "1 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.embryo.net",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-334",
    "externalIds": {
      "cdcClinicId": "334",
      "googlePlaceId": "ChIJn6PTDJqcQIYRP5o6X4uVhe8"
    },
    "type": "fertility-clinic",
    "name": "Center of Reproductive Medicine, LLP dba, SGF Houston",
    "phone": "(281) 332-0073",
    "address": {
      "line1": "1015 Medical Center Blvd, Suite 2100",
      "city": "Webster",
      "state": "TX",
      "zip": "77598",
      "country": "US"
    },
    "location": {
      "lat": 29.5351,
      "lng": -95.1332
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 53.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 44.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 42.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 31.57894736842105,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/19"
        }
      ],
      "cyclesPerYear": 492,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27334%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27334%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/our-care-team/doctors/schnell/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Clear+Lake,+1015+W+Medical+Ctr+Blvd+Ste+2100,+Webster,+TX+77598/@29.5351037,-95.1333026,3471a,13.1y/data=!4m2!3m1!1s0x86409c9a0cd3a39f:0xef85958b5f3a9a3f",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-334-vicki-l-schnell-md",
        "name": "Vicki L. Schnell, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/03/Vicki-Schnell-profile.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/schnell/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.shadygrovefertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Anthem Blue Cross Blue Shield",
        "Blue Cross",
        "Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Health Net",
        "Kaiser Permanente",
        "Multiplan",
        "Tricare",
        "Oxford",
        "Highmark",
        "Optum",
        "First Health",
        "BCBS"
      ],
      "employeeBenefits": [
        "Progyny",
        "Carrot",
        "Maven",
        "WINFertility",
        "Stork Club"
      ],
      "_source": {
        "url": "https://www.shadygrovefertility.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmRrrpMZLQMJp79uJat9ipLejkM8MGsUoFSlU9VVm73Y1jWso574FzHMl6N8I6dMbMwJRYsXnYCpriTx2VdETQajQjeW9RqXQAUYXw_39UbUoLB3jvQys6YTbjwOTyYdc1nVAOz3WMu9OsW=w650-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Clear+Lake,+1015+W+Medical+Ctr+Blvd+Ste+2100,+Webster,+TX+77598/@29.5351037,-95.1333026,3471a,13.1y/data=!4m2!3m1!1s0x86409c9a0cd3a39f:0xef85958b5f3a9a3f",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross Blue Shield, Blue Cross, Blue Shield, Cigna, United Healthcare, Humana, Health Net",
              "detail": "8 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-811",
    "externalIds": {
      "cdcClinicId": "811",
      "googlePlaceId": "ChIJwbCG-H0pTIYRUdE4iCgIQfs"
    },
    "type": "fertility-clinic",
    "name": "Conceive Fertility Center",
    "phone": "(214) 224-0778",
    "address": {
      "line1": "7515 Greenville Ave., Suite 1030",
      "city": "Dallas",
      "state": "TX",
      "zip": "75231",
      "country": "US"
    },
    "location": {
      "lat": 32.9012,
      "lng": -96.9572
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 47.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 53.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 185,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27811%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27811%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://conceivefertilitycenter.com/team-member/derek-haas-md/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Conceive+Fertility+Center+-+Dallas,+7515+Greenville+Ave+Ste+1030,+Dallas,+TX+75231/@32.8838512,-96.7602333,3351a,13.1y/data=!4m2!3m1!1s0x864c297df886b0c1:0xfb4108288838d151",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.conceivefertilitycenter.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-811-derek-haas-md",
        "name": "Derek Haas, MD",
        "role": "Medical Director",
        "imageUrl": "https://conceivefertilitycenter.com/wp-content/uploads/2026/05/Dr-Derek-Haas-Fertility-Doctor-Euless-Texas.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://conceivefertilitycenter.com/team-member/derek-haas-md/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.conceivefertilitycenter.com",
    "description": "Conceive Fertility Center \\| Fertility Treatments, Infertility Testing, & IVF Dallas, TX",
    "languages": ["English"],
    "images": [
      {
        "url": "https://conceivefertilitycenter.com/wp-content/uploads/2021/05/Dallas-Banner-01.jpg",
        "type": "exterior",
        "caption": "Conceive Fertility Center Dallas location",
        "_source": {
          "url": "https://conceivefertilitycenter.com/dallas/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://conceivefertilitycenter.com/wp-content/uploads/2023/03/CFC-McKinney-Location-banner-no-text.jpg",
        "type": "exterior",
        "caption": "Conceive Fertility Center McKinney location",
        "_source": {
          "url": "https://conceivefertilitycenter.com/mckinney/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://conceivefertilitycenter.com/wp-content/uploads/2023/06/Euless-Banner-image-01.jpg",
        "type": "exterior",
        "caption": "Conceive Fertility Center Euless-Bedford location",
        "_source": {
          "url": "https://conceivefertilitycenter.com/euless-bedford/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnn_s8IItKXbHt7DdUnREMVg3aPJ5STYQIQ4hXtFrcLPRm-webwZyhTzXtn9ZEI59HJTCzVchspTd8cO6Or3VBFDQ-IJgyyscv0-WDCL7rmnjWPdrluqLXomFMnqZeWg46NcrSF8A=w523-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Conceive+Fertility+Center+-+Dallas,+7515+Greenville+Ave+Ste+1030,+Dallas,+TX+75231/@32.8838512,-96.7602333,3351a,13.1y/data=!4m2!3m1!1s0x864c297df886b0c1:0xfb4108288838d151",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-83",
    "externalIds": {
      "cdcClinicId": "83"
    },
    "type": "fertility-clinic",
    "name": "Cooper Institute for Advanced Reproductive Medicine",
    "phone": "(713) 771-9771",
    "address": {
      "line1": "7500 Beechnut St, Suite 308",
      "city": "Houston",
      "state": "TX",
      "zip": "77074",
      "country": "US"
    },
    "location": {
      "lat": 29.6924,
      "lng": -95.5188
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 27.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 57,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2783%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2783%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.coopersurgical.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "socialLinks": {
          "status": "searched-absent"
        },
        "logo": {
          "status": "searched-absent"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-83-c-james-chuong-md",
        "name": "C. James Chuong, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.coopersurgical.com",
    "description": "CooperSurgical has acquired ZyMōt Fertility, a subsidiary of DxNow, Inc. Read the full announcement her",
    "languages": ["English"],
    "images": [],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-253",
    "externalIds": {
      "cdcClinicId": "253",
      "googlePlaceId": "ChIJByeSf2Q7TIYResIR8Aqq4sY"
    },
    "type": "fertility-clinic",
    "name": "Dallas IVF",
    "phone": "(214) 297-0027",
    "address": {
      "line1": "2840 Legacy Dr, Bldg 1, Suite 100",
      "city": "Frisco",
      "state": "TX",
      "zip": "75034",
      "country": "US"
    },
    "location": {
      "lat": 33.1022,
      "lng": -96.8409
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 54.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 49.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 44.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 40.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 620,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27253%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27253%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://dallasivf.com/locations/frisco-fertility-clinic",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Dallas+IVF+-+Frisco,+2840+Legacy+Dr+Ste+100,+Frisco,+TX+75034/@33.102167,-96.840703,3342a,13.1y/data=!4m2!3m1!1s0x864c3b647f922707:0xc6e2aa0af011c27a",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.dallasivf.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-253-brian-d-barnett-md",
        "name": "Brian D. Barnett, MD",
        "role": "Medical Director",
        "imageUrl": "https://a.storyblok.com/f/290132/266x400/eb7205627d/doctor-photo-4-dallas.png/m/0x2000/filters:no_upscale()",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://dallasivf.com/doctors/dr-brian-barnett",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.dallasivf.com",
    "description": "Parenthood knows no borders; patients come to Dallas IVF from all over the globe to experience our next\\-level standards of care. We’re highly experienced with travel coordination and the unique treatment needs of international patients.",
    "languages": ["English"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlWFrCC0LQXMqxaSVhVJXR7QCWHojmbFPbmqvW7h_58Bqi4JBR6woESVUgqOF-OZSowNLmdDNNnsPYk6sZyYIdSQZ5ONrygTDb5hDaawElh5bW9Hcs4U7nS9N1yA8jNf9-jo2Y=w408-h603-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Dallas+IVF+-+Frisco,+2840+Legacy+Dr+Ste+100,+Frisco,+TX+75034/@33.102167,-96.840703,3342a,13.1y/data=!4m2!3m1!1s0x864c3b647f922707:0xc6e2aa0af011c27a",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn7ZxadHKETzlSIBdcnfQ9vbvRh-_Eqck_FkC2LjnSFqpG206aUIz9Osv6uvaXeVc3byXyI6acDRgkoax0M9PZOfCAU3kV6WSuzGhNGUp_3hz7Grtni5a4x-qC4xXMAuSItjGEE=w224-h398-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Dallas+IVF+-+Frisco,+2840+Legacy+Dr+Ste+100,+Frisco,+TX+75034/@33.102167,-96.840703,3342a,13.1y/data=!4m2!3m1!1s0x864c3b647f922707:0xc6e2aa0af011c27a",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "network": {
      "name": "Ivy Fertility"
    },
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-177",
    "externalIds": {
      "cdcClinicId": "177"
    },
    "type": "fertility-clinic",
    "name": "Dallas-Fort Worth Fertility Associates",
    "phone": "(214) 363-5965",
    "address": {
      "line1": "5477 Glen Lakes Dr, Suite 200",
      "city": "Dallas",
      "state": "TX",
      "zip": "75231",
      "country": "US"
    },
    "location": {
      "lat": 32.8835,
      "lng": -96.7663
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 46.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 47.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 42.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 37,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 987,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27177%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "scraped-retry",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.dallasfertility.com/samuel-j-chantilis-md.html",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27177%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-177-samuel-j-chantilis-md",
        "name": "Samuel J. Chantilis, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.dallasfertility.com/assets/img/sam-chantilis.webp",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.dallasfertility.com/samuel-j-chantilis-md.html",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.dfwfertility.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-626",
    "externalIds": {
      "cdcClinicId": "626",
      "googlePlaceId": "ChIJ162wVCUXTIYRmwtcCbx9kbA"
    },
    "type": "fertility-clinic",
    "name": "DFW Center for Fertility & IVF",
    "phone": "(214) 383-2600",
    "address": {
      "line1": "980 Raintree Cir",
      "city": "Allen",
      "state": "TX",
      "zip": "75013",
      "country": "US"
    },
    "location": {
      "lat": 33.1106,
      "lng": -96.6796
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 70.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/14"
        },
        {
          "ageBand": "38-40",
          "rate": 27.77777777777778,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/18"
        }
      ],
      "cyclesPerYear": 81,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27626%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27626%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.dfwfertility.com/about-us/dr-victor-beshay/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/DFW+Center+for+Fertility+%26+IVF,+980+Raintree+Cir,+Allen,+TX+75013/@33.1106445,-96.6795701,3342a,13.1y/data=!4m2!3m1!1s0x864c172554b0add7:0xb0917dbc095c0b9b",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.dfwivf.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-626-victor-e-beshay-md",
        "name": "Victor E. Beshay, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.dfwfertility.com/wp-content/uploads/2014/04/VictorBeshay-265x300.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.dfwfertility.com/about-us/dr-victor-beshay/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.dfwivf.com",
    "description": "World class fertility testing and treatment conveniently located in Medical City Dallas.",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmbN0pt6PzzLoypCQ32sHgtc6jMrODKoWHmmxz85wJNEbRrd4TR59soFdpDGOyp2MmzZc1CW3rhVJQUv_hCseqBXLhYNZFy9byI16rwDf_Vc0e8DFDQDRQ6w7lQ14tW9xxKoYI9=w449-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/DFW+Center+for+Fertility+%26+IVF,+980+Raintree+Cir,+Allen,+TX+75013/@33.1106445,-96.6795701,3342a,13.1y/data=!4m2!3m1!1s0x864c172554b0add7:0xb0917dbc095c0b9b",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-451",
    "externalIds": {
      "cdcClinicId": "451"
    },
    "type": "fertility-clinic",
    "name": "Family Fertility Center",
    "phone": "(832) 826-7463",
    "address": {
      "line1": "Texas Children's Pavilion for Women, 6651 Main St, Suite E350",
      "city": "Houston",
      "state": "TX",
      "zip": "77030",
      "country": "US"
    },
    "location": {
      "lat": 29.7082,
      "lng": -95.4027
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 46.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 60,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 35.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 300,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27451%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "minimal",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.texaschildrens.org/locations/texas-childrens-pavilion-women",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27451%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-451-laura-detti-md",
        "name": "Laura Detti, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.texaschildrens.org/sites/tc/files/styles/person_pic_mobile/public/2024-01/lauradetti3.png?h=7beaea4b&itok=vPbQfheM",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.texaschildrens.org/find-a-provider/laura-detti-md",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.familyfertilitycenter.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "images": [
      {
        "url": "https://www.texaschildrens.org/sites/tc/files/styles/location_mobile/public/2022-12/PFW%20Main.jpg?h=e0f9d5a9&itok=L5hwOdz8",
        "type": "exterior",
        "caption": "Texas Children's Pavilion for Women",
        "_source": {
          "url": "https://www.texaschildrens.org/locations/texas-childrens-pavilion-women",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-238",
    "externalIds": {
      "cdcClinicId": "238"
    },
    "type": "fertility-clinic",
    "name": "UT Southwestern Advanced Reproductive Medicine and Fertility Clinic",
    "phone": "(214) 645-8300",
    "address": {
      "line1": "5323 Harry Hines Boulevard",
      "city": "Dallas",
      "state": "TX",
      "zip": "75390",
      "country": "US"
    },
    "location": {
      "lat": 32.8129823,
      "lng": -96.8388215
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "8/16"
        }
      ],
      "cyclesPerYear": 149,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27238%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27238%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://utswmed.org/locations/outpatient/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+%26+Advanced+Reproductive+Medicine+Clinic+-+UT+Southwestern,+1801+Inwood+Rd+6th+floor+suite+616,+Dallas,+TX+75390/@32.8163477,-96.8455415,3353a,13.1y/data=!4m2!3m1!1s0x864e9c103d7a8553:0xe2db557d6fc2ff76",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.dallasfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-06-13",
      "source": "layer2-tx-current-org-cdc-238"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-238-orhan-bukulmez-md",
        "name": "Orhan Bukulmez, MD",
        "role": "Medical Director",
        "imageUrl": "https://d38sso7f6qz01j.cloudfront.net/original_images/bukulmez-orhan-67365-200x200.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://utswmed.org/doctors/orhan-bukulmez/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://utswmed.org/locations/outpatient/fertility-clinic/",
    "description": "High quality fertility testing and treatment in a sensitive, caring, and safe environment.",
    "languages": ["English"],
    "images": [
      {
        "url": "https://d38sso7f6qz01j.cloudfront.net/images/outpatie.width-320.height-146.format-jpeg.jpegquality-40_yXLTFlW.jpg",
        "type": "exterior",
        "caption": "UT Southwestern Outpatient Building",
        "_source": {
          "url": "https://utswmed.org/locations/outpatient/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "hospital-based",
    "network": {
      "name": "UT Southwestern Medical Center"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-445",
    "externalIds": {
      "cdcClinicId": "445"
    },
    "type": "fertility-clinic",
    "name": "Fertility Center of Dallas",
    "phone": "(972) 884-5700",
    "address": {
      "line1": "Baylor Medical Pavilion, 3900 Junius St, Suite 610",
      "city": "Dallas",
      "state": "TX",
      "zip": "75246",
      "country": "US"
    },
    "location": {
      "lat": 32.7908,
      "lng": -96.7776
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 47.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 66.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 66.66666666666666,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "10/15"
        }
      ],
      "cyclesPerYear": 136,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27445%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27445%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitydallas.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-445-samuel-chantilis-md",
        "name": "Samuel Chantilis, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.fertilitydallas.com",
    "languages": ["English"],
    "images": [],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-123",
    "externalIds": {
      "cdcClinicId": "123",
      "googlePlaceId": "ChIJyzG6TP5dXIYRB6naSFMD12Y"
    },
    "type": "fertility-clinic",
    "name": "Fertility Center of San Antonio",
    "phone": "(210) 692-0577",
    "address": {
      "line1": "7707 Ewing Halsell Dr, Suite 103",
      "city": "San Antonio",
      "state": "TX",
      "zip": "78229",
      "country": "US"
    },
    "location": {
      "lat": 29.5103,
      "lng": -98.5738
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 47.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 41.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 30.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 20,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 296,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27123%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27123%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://fertilitysa.com/about-us/about-our-providers/dr-neal/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Center+Of+San+Antonio,+7707+Ewing+Halsell+Dr+Ste+103,+San+Antonio,+TX+78229/@29.5097127,-98.5708621,3472a,13.1y/data=!4m2!3m1!1s0x865c5dfe4cba31cb:0x66d7035348daa907",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitysa.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-123-gregory-s-neal-md",
        "name": "Gregory S. Neal, MD",
        "role": "Medical Director",
        "imageUrl": "https://fertilitysa.com/wp-content/uploads/2024/02/thumbnail_Dr-Neal-Headshots-.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://fertilitysa.com/about-us/about-our-providers/dr-neal/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.fertilitysa.com",
    "languages": ["English"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnf_6FYkDMhMs-rhjqjs0uw00NxnPz4MWF0rAHAiaDHJIZf4-URdm95ilXjznmUVdUKNIY_sjfHCfrT49OAyzcVoyHINipxRA2GGc0j4wOTmiv6r7Pu85J15wrwIVGihTnv4o7C=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Center+Of+San+Antonio,+7707+Ewing+Halsell+Dr+Ste+103,+San+Antonio,+TX+78229/@29.5097127,-98.5708621,3472a,13.1y/data=!4m2!3m1!1s0x865c5dfe4cba31cb:0x66d7035348daa907",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-98",
    "externalIds": {
      "cdcClinicId": "98",
      "googlePlaceId": "ChIJa0G-j1Vt_oYRiRfopULYgfo"
    },
    "type": "fertility-clinic",
    "name": "Fertility Specialists of Texas - Lubbock",
    "phone": "(214) 618-2044",
    "address": {
      "line1": "9826 Slide Road, Suite 200",
      "city": "Lubbock",
      "state": "TX",
      "zip": "79424",
      "country": "US"
    },
    "location": {
      "lat": 33.5048861,
      "lng": -101.9224596
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 58.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 45,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2798%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2798%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitytexas.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Specialists+of+Texas+-+Lubbock,+9826+Slide+Rd,+Lubbock,+TX+79424/@33.5020329,-101.9235829,3327a,13.1y/data=!4m2!3m1!1s0x86fe6d558fbe416b:0xfa81d842a5e81789",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitytexas.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "source": "layer2-tx-current-org-cdc-98",
      "date": "2026-06-13"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-98-jerald-s-goldstein-md",
        "name": "Jerald S. Goldstein, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.fertilitytexas.com/wp-content/uploads/2025/01/FST-Jerald-Goldstein-MD.png",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.fertilitytexas.com/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.fertilitytexas.com/",
    "insurance": {
      "accepted": true,
      "carriers": ["Aetna", "Cigna", "Horizon", "Optum", "BCBS"],
      "employeeBenefits": [
        "Progyny",
        "Carrot",
        "Maven",
        "WIN Fertility",
        "Kindbody",
        "Future Family"
      ],
      "_source": {
        "url": "https://www.fertilitytexas.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkuo727nS-Z20klWJyrh4JADsbNBwvck-OxXS-urFX-bej_6U8MvDRzkqj_0Z7uMcjDdwygFszv30KXbuLWIXg9KWt0YqnlkMdTr0uDdnhYtaVOTpVJnXk6il_hK-OHf6EaEDHJ7m2WfP0=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Specialists+of+Texas+-+Lubbock,+9826+Slide+Rd,+Lubbock,+TX+79424/@33.5020329,-101.9235829,3327a,13.1y/data=!4m2!3m1!1s0x86fe6d558fbe416b:0xfa81d842a5e81789",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "network-group",
    "network": {
      "name": "Fertility Specialists of Texas"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Cigna, Horizon, Optum, BCBS",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.fertilitytexas.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-480",
    "externalIds": {
      "cdcClinicId": "480",
      "googlePlaceId": "ChIJB0QnN307TIYRPS7Tik6FTuM"
    },
    "type": "fertility-clinic",
    "name": "Fertility Specialists of Texas, PLLC",
    "phone": "(214) 618-2044",
    "address": {
      "line1": "5736 State Highway 121",
      "city": "Plano",
      "state": "TX",
      "zip": "75024",
      "country": "US"
    },
    "location": {
      "lat": 33.1056,
      "lng": -96.8372
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 54.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 54.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 46.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 41.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 712,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27480%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27480%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitytexas.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Specialists+Of+Texas+-+Plano+%2F+Frisco,+5736+State+Hwy+121,+Plano,+TX+75024/@33.0916717,-96.8163171,3343a,13.1y/data=!4m2!3m1!1s0x864c3b7d37274407:0xe34e854e8ad32e3d",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitytexas.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-480-jerald-s-goldstein-md",
        "name": "Jerald S. Goldstein, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.fertilitytexas.com/wp-content/uploads/2025/01/FST-Jerald-Goldstein-MD.png",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.fertilitytexas.com/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.fertilitytexas.com",
    "insurance": {
      "accepted": true,
      "carriers": ["Aetna", "Cigna", "Horizon", "Optum", "BCBS"],
      "employeeBenefits": [
        "Progyny",
        "Carrot",
        "Maven",
        "WIN Fertility",
        "Kindbody",
        "Future Family"
      ],
      "_source": {
        "url": "https://www.fertilitytexas.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmsKvMkl6FGgW9j-IIimcZ4um6N5gHTugl8KQUxgweHGZb8J55_Mt7jrRFoqegOhIcEjUTDTy2wSscgk2yGp_dQ9RcjjFZ-9vLiTyqTqK9sq4JbEfJcQ9g1PB6oenoSnh7rk4un=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Specialists+Of+Texas+-+Plano+%2F+Frisco,+5736+State+Hwy+121,+Plano,+TX+75024/@33.0916717,-96.8163171,3343a,13.1y/data=!4m2!3m1!1s0x864c3b7d37274407:0xe34e854e8ad32e3d",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkBxVeJtbpQci5dLsjIHEWCG-AQ6aa3qdOsaMuP8fQDr0ZwH40MUQA6SNAvKBJA_ZSrEpFtMz4lGMetRWs6p6di9X_hxMYqDb0Y_rDrwY0X8yMRSpFimrwx5mHUO3z4_o_QypM=w372-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Specialists+Of+Texas+-+Plano+%2F+Frisco,+5736+State+Hwy+121,+Plano,+TX+75024/@33.0916717,-96.8163171,3343a,13.1y/data=!4m2!3m1!1s0x864c3b7d37274407:0xe34e854e8ad32e3d",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Cigna, Horizon, Optum, BCBS",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.fertilitytexas.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-843",
    "externalIds": {
      "cdcClinicId": "843",
      "googlePlaceId": "ChIJL9ShLjHLRIYRca0pMMX_q58"
    },
    "type": "fertility-clinic",
    "name": "Fora Fertility",
    "phone": "(512) 956-5006",
    "address": {
      "line1": "715 W. 34th St",
      "city": "Austin",
      "state": "TX",
      "zip": "78705",
      "country": "US"
    },
    "location": {
      "lat": 30.3015,
      "lng": -97.7427
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 66.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 57.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 37.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 245,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27843%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27843%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.forafertility.com/meet-fora",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fora+Fertility,+4107+Medical+Pkwy+Ste+101,+Austin,+TX+78756/@30.3105436,-97.7420619,3444a,13.1y/data=!4m2!3m1!1s0x8644cb312ea1d42f:0x9fabffc53029ad71",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://forafertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-843-amanda-skillern-md",
        "name": "Amanda Skillern, MD",
        "role": "Medical Director",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/63b71f3d0098a50e89e60525/dace906d-c352-41cc-a969-8bd6d6cd3b91/Amanda+Skillern%2C+M.D-8.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.forafertility.com/meet-fora",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://forafertility.com",
    "description": "PHONE: 512\\-956\\-5006 \\| FAX: 833\\-979\\-0943 \\| EMAIL: info@forafertilityaustin.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "specialties": ["boutique-fertility", "personalized-care"],
    "consultationTypes": ["in-person"],
    "images": [
      {
        "url": "https://images.squarespace-cdn.com/content/v1/63b71f3d0098a50e89e60525/1760192199544-XUKSCJRD4MUJFKTSCA80/Fora+Fertility+%28clinic+photos%29-39.jpg",
        "type": "interior",
        "caption": "Fora Fertility clinic",
        "_source": {
          "url": "https://www.forafertility.com/meet-fora",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlmNrzsPTpCiD78OWhkTCLmqa7PNRHYKo-Ubnyb5_CDXzwchAA-TjY8OgdLxD-PwY6OY76OVOrSVsgYT1W1t6S01iiT5QNXTF-BYz0DX-DAIm3OM_eBjl2q9-XXObVJl84ZL0tkgyonp-Jv=w408-h392-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fora+Fertility,+4107+Medical+Pkwy+Ste+101,+Austin,+TX+78756/@30.3105436,-97.7420619,3444a,13.1y/data=!4m2!3m1!1s0x8644cb312ea1d42f:0x9fabffc53029ad71",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-468",
    "externalIds": {
      "cdcClinicId": "468",
      "googlePlaceId": "ChIJG8fhpxg3R4YRVmguUn9vlqo"
    },
    "type": "fertility-clinic",
    "name": "HART Fertility Clinic",
    "phone": "(281) 444-4784",
    "address": {
      "line1": "111 Vision Park, Suite 110",
      "city": "The Woodlands",
      "state": "TX",
      "zip": "77384",
      "country": "US"
    },
    "location": {
      "lat": 30.1909,
      "lng": -95.4569
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 52.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 39.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 42.857142857142854,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/14"
        }
      ],
      "cyclesPerYear": 148,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27468%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27468%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.hartfertility.com/areas-served/the-woodlands-fertility-clinic",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/HART+Fertility+Clinic+-+The+Woodlands,+111+Vision+Park+Blvd+Ste+110,+The+Woodlands,+TX+77384/@30.1908521,-95.4566239,3449a,13.1y/data=!4m2!3m1!1s0x86473718a7e1c71b:0xaa966f7f522e6856",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.hartfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-468-dorothy-j-roach-md",
        "name": "Dorothy J. Roach, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.hartfertility.com/images/2021/05/17/dr-roach-sq.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.hartfertility.com/areas-served/the-woodlands-fertility-clinic",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.hartfertility.com",
    "description": "Our Houston fertility clinic is here to bring families together. Our practice is proud to deliver our services with the expertise and skills of our trained practitioners.",
    "languages": ["English", "Spanish"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlOuUjleaD5-9b_tKjWnQbtgAMQf1F9EnJoXnGTm2Irq2ZV09HKBBDGxZ_G_SlijByuyfmvM3m2H8J78HGOmed0QyX0x-ofr6hxAjiUEmRRCQQws7akxFCxI1r81EB6EJ9XaXE=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/HART+Fertility+Clinic+-+The+Woodlands,+111+Vision+Park+Blvd+Ste+110,+The+Woodlands,+TX+77384/@30.1908521,-95.4566239,3449a,13.1y/data=!4m2!3m1!1s0x86473718a7e1c71b:0xaa966f7f522e6856",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnGxHQjcLLvJzjm27pcDjiIN1dZZpGWkP9wHdHEvWJ43JXuJ_so6iK-rxliEy80gZ2sTigZt6fOy9UANtBZ4lIhUVd4_ctvEqKyh5VAm4O2-u7ufstVWnyXOFA2Vm4uiuXLp1vajg=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/HART+Fertility+Clinic+-+The+Woodlands,+111+Vision+Park+Blvd+Ste+110,+The+Woodlands,+TX+77384/@30.1908521,-95.4566239,3449a,13.1y/data=!4m2!3m1!1s0x86473718a7e1c71b:0xaa966f7f522e6856",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-104",
    "externalIds": {
      "cdcClinicId": "104"
    },
    "type": "fertility-clinic",
    "name": "Houston Fertility Institute",
    "description": "The largest and most experienced fertility center in Texas, part of the Prelude Network, with 14 locations across Greater Houston and its own donor egg bank.",
    "website": "https://www.aspirehfi.com/",
    "phone": "(713) 730-2229",
    "bookingUrl": "https://www.aspirehfi.com/appointments",
    "address": {
      "line1": "2500 Fondren Rd, Suite 300",
      "city": "Houston",
      "state": "TX",
      "zip": "77063",
      "country": "US"
    },
    "location": {
      "lat": 29.7404,
      "lng": -95.5221
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "financingOptions": [
        "Payment plans",
        "Loans",
        "Future Family",
        "CapexMD",
        "PatientFi"
      ]
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 56.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 48.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 47.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 28.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 2207,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27104%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "languages": ["English", "vi"],
    "consultationTypes": ["in-person"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27104%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "scraped"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://memorialhermann.org/doctors/reproductive-endocrinologists/dr-ghassan-haddad-md-1477627164",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "scraped"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.aspirehfi.com/",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-104-ghassan-f-haddad-md",
        "name": "Ghassan F. Haddad, MD",
        "role": "Medical Director",
        "imageUrl": "https://memorialhermann.org/-/media/memorial-hermann/global/images/physicians/ghassan-haddad-1477627164.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://memorialhermann.org/doctors/reproductive-endocrinologists/dr-ghassan-haddad-md-1477627164",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-3",
    "externalIds": {
      "cdcClinicId": "3"
    },
    "type": "fertility-clinic",
    "name": "Houston Infertility Clinic, Sonja Kristiansen, MD",
    "phone": "(713) 862-6181",
    "address": {
      "line1": "9055 Katy Freeway, Suite 450",
      "city": "Houston",
      "state": "TX",
      "zip": "77024",
      "country": "US"
    },
    "location": {
      "lat": 29.7836,
      "lng": -95.5123
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 20.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 16.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 38.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "0/5"
        }
      ],
      "cyclesPerYear": 220,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%273%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%273%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-3-sonja-b-kristiansen-md",
        "name": "Sonja B. Kristiansen, MD",
        "role": "Medical Director"
      }
    ],
    "description": "Houston Infertility Clinic, led by Dr. Sonja Kristiansen, provides personalized fertility care in Houston, Texas.",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-33",
    "externalIds": {
      "cdcClinicId": "33"
    },
    "type": "fertility-clinic",
    "name": "Houston IVF dba, CCRM Houston",
    "phone": "(713) 465-1211",
    "address": {
      "line1": "929 Gessner Rd, Suite 2300",
      "city": "Houston",
      "state": "TX",
      "zip": "77024",
      "country": "US"
    },
    "location": {
      "lat": 29.782,
      "lng": -95.5455
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 63.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 52.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 54.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 53.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 815,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2733%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2733%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/timothy-hickman/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-33-timothy-n-hickman-md",
        "name": "Timothy N. Hickman, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Timothy_Hickman_600x600_2x-r9yqgyaibilat9iw4vo9slqf8v10l6g4anau59xs4g.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/timothy-hickman/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.ccrmivf.com",
    "languages": [
      "English",
      "Spanish",
      "Chinese",
      "Arabic",
      "Russian",
      "French",
      "Portuguese",
      "Italian",
      "German"
    ],
    "images": [],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-841",
    "externalIds": {
      "cdcClinicId": "841",
      "googlePlaceId": "ChIJD6atf9rBQIYRtgwFccXHMKM"
    },
    "type": "fertility-clinic",
    "name": "Inovi Fertility & Genetics Institute",
    "phone": "(713) 401-9000",
    "address": {
      "line1": "3773 Richmond Ave, Suite 400",
      "city": "Houston",
      "state": "TX",
      "zip": "77046",
      "country": "US"
    },
    "location": {
      "lat": 29.7325,
      "lng": -95.4372
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 52.94117647058824,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "9/17"
        }
      ],
      "cyclesPerYear": 54,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27841%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27841%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.inovifertility.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Inovi+Fertility+%26+Genetics+Institute,+3773+Richmond+Ave+Ste+400,+Houston,+TX+77046/@29.7324208,-95.4372472,3465a,13.1y/data=!4m2!3m1!1s0x8640c1da7fada60f:0xa330c7c571050cb6",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.inovifertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-841-stephan-krotz-md",
        "name": "Stephan Krotz, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.inovifertility.com/wp-content/smush-webp/2023/12/INOVI%C2%A9Al-Torres-Photography-Inc-22-1-682x1024-1.jpg.webp",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.inovifertility.com/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.inovifertility.com",
    "languages": ["Spanish", "English"],
    "images": [
      {
        "url": "https://www.inovifertility.com/wp-content/uploads/2024/04/office.webp",
        "type": "interior",
        "caption": "Inovi Fertility office",
        "_source": {
          "url": "https://www.inovifertility.com/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmektOZB4MQGETVYvolXagz8a4nkpFZYh6TiuP11yqcSYijZoTa1uL-lWCIvzPnhtuA1Xdo0angrhAZA2JVMJipPaaToPwqFIA-_k9OhFc5MDcwbjwts_KcVPWSRKQWZzWRXND4=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Inovi+Fertility+%26+Genetics+Institute,+3773+Richmond+Ave+Ste+400,+Houston,+TX+77046/@29.7324208,-95.4372472,3465a,13.1y/data=!4m2!3m1!1s0x8640c1da7fada60f:0xa330c7c571050cb6",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlQHCTKeJwSiCmiWg2oRnE5Snf2J4UFAOYxJ_p5e1ZpsQo72l3lUP92EHWkrMnQqbkp6vWKAPkIiZoSVDzqHMjePOp9pJ9pzKv6abswMAWLrMY7mwXiSptturWOLO-zUzdQa3MI=w413-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Inovi+Fertility+%26+Genetics+Institute,+3773+Richmond+Ave+Ste+400,+Houston,+TX+77046/@29.7324208,-95.4372472,3465a,13.1y/data=!4m2!3m1!1s0x8640c1da7fada60f:0xa330c7c571050cb6",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-827",
    "externalIds": {
      "cdcClinicId": "827",
      "googlePlaceId": "ChIJO0KhEbZiToYRDM5wRpx9VKQ"
    },
    "type": "fertility-clinic",
    "name": "IVFMD-Arlington",
    "phone": "(817) 701-1290",
    "address": {
      "line1": "600 W. Mayfield Rd",
      "city": "Arlington",
      "state": "TX",
      "zip": "76014",
      "country": "US"
    },
    "location": {
      "lat": 32.6906,
      "lng": -97.1134
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 43.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 38.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 38.88888888888889,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/18"
        }
      ],
      "cyclesPerYear": 167,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27827%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27827%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfmd.net/about/fertility-specialists/renju-raj/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/IVFMD+Fertility+Clinic,+600+W+Mayfield+Rd,+Arlington,+TX+76014/@32.690603,-97.113355,3358a,13.1y/data=!4m2!3m1!1s0x864e62b611a1423b:0xa4547d9c4670ce0c",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfmd.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-827-renju-raj-md",
        "name": "Renju Raj, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.ivfmd.net/wp-content/uploads/2022/10/ivfmd-doctors-renju-raj-780x805.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.ivfmd.net/about/fertility-specialists/renju-raj/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.ivfmd.com",
    "description": "Castle Connolly has recognized four of our fertility specialists as a 2026 Top Doctor\\",
    "languages": ["English"],
    "network": {
      "name": "Prelude Network"
    },
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnlejcKE5kn255IPfLnjXCXpiKkUShfVCSVDV9PlbSTw7RzIOF-b2Nv6NIYGf-2eFtfk4onOcrbscBM55th89qT3iTSh8fIrOQE87IUX0Z_gMYHhLM5MWRf4_K18WrzAHq12DM=w408-h315-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/IVFMD+Fertility+Clinic,+600+W+Mayfield+Rd,+Arlington,+TX+76014/@32.690603,-97.113355,3358a,13.1y/data=!4m2!3m1!1s0x864e62b611a1423b:0xa4547d9c4670ce0c",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnnnIcOcdXZeqCfA2bVCWnOl5W6QfkVYphufL0zD9a9KerdW9bDwLbGSzIH7UN3WuePR9TiXekW244Yp7sN5eNKTtXN6TzkOyWXMJrce6UqCJdSF-2904XO6D56tAU1_p0q5QY=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/IVFMD+Fertility+Clinic,+600+W+Mayfield+Rd,+Arlington,+TX+76014/@32.690603,-97.113355,3358a,13.1y/data=!4m2!3m1!1s0x864e62b611a1423b:0xa4547d9c4670ce0c",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-469",
    "externalIds": {
      "cdcClinicId": "469",
      "googlePlaceId": "ChIJ3eBTSUgoTIYRKI41rMRq3Zo"
    },
    "type": "fertility-clinic",
    "name": "IVFMD-Irving",
    "phone": "(972) 506-9986",
    "address": {
      "line1": "7501 Las Colinas Blvd, Suite 200A",
      "city": "Irving",
      "state": "TX",
      "zip": "75063",
      "country": "US"
    },
    "location": {
      "lat": 32.9098,
      "lng": -96.9555
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 53.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 47.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 25,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 257,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27469%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27469%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfmd.net/about/fertility-specialists/sy-le/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/IVFMD+Fertility+Treatment+Center,+7501+Las+Colinas+Blvd+%23200a,+Irving,+TX+75063/@32.909808,-96.955446,3350a,13.1y/data=!4m2!3m1!1s0x864c28484953e0dd:0x9add6ac4ac358e28",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfmd.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-469-sy-q-le-md",
        "name": "Sy Q. Le, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.ivfmd.net/wp-content/uploads/2022/10/ivfmd-doctors-sy-le-780x805.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.ivfmd.net/about/fertility-specialists/sy-le/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.ivfmd.com",
    "description": "Castle Connolly has recognized four of our fertility specialists as a 2026 Top Doctor\\",
    "languages": ["English"],
    "network": {
      "name": "Prelude Network"
    },
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlJwBGCMuhjqiUaqM8ce1ECEEb-4jE3nU7hYczLRqvdsTCAQ53PcYsDQoycb2BrjU2xklMBRI5QZnMorg0n88KvoejARJNU4YvuRNh63qkgeBCOD_Yqka5EfMWFpLbW7LAVD_EF=w408-h725-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/IVFMD+Fertility+Treatment+Center,+7501+Las+Colinas+Blvd+%23200a,+Irving,+TX+75063/@32.909808,-96.955446,3350a,13.1y/data=!4m2!3m1!1s0x864c28484953e0dd:0x9add6ac4ac358e28",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmpFxZ1rgN5Ne9ximDIgslRAsTCMXpdWrFCvGvtbPSvEmKt5XDAAO_EjGYvc_LMYzBPyyt-73dLopIgzYzzmJDIWkl2y7VVf5zFKSmPqJps5_f3oi9rV5LkiE3HbZK834Vge0Vb=w383-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/IVFMD+Fertility+Treatment+Center,+7501+Las+Colinas+Blvd+%23200a,+Irving,+TX+75063/@32.909808,-96.955446,3350a,13.1y/data=!4m2!3m1!1s0x864c28484953e0dd:0x9add6ac4ac358e28",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-927",
    "externalIds": {
      "cdcClinicId": "927",
      "googlePlaceId": "ChIJm1EQ5_DBQIYRFhjxyKWgXoQ"
    },
    "type": "fertility-clinic",
    "name": "Kindbody - Houston",
    "phone": "(528) 171-9935",
    "address": {
      "line1": "1111 Uptown Park Blvd, Suite 02",
      "city": "Houston",
      "state": "TX",
      "zip": "77056",
      "country": "US"
    },
    "location": {
      "lat": 29.7518,
      "lng": -95.4485
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 0,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27927%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27927%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/team/dr-toral-parikh/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+Houston,+1111+Uptown+Park+Blvd+%2302,+Houston,+TX+77056/@29.7578106,-95.457122,3464a,13.1y/data=!4m2!3m1!1s0x8640c1f0e710519b:0x845ea0a5c8f11816",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-927-toral-parikh-md",
        "name": "Toral  Parikh, MD",
        "role": "Medical Director",
        "imageUrl": "https://kindbody.com/wp-content/uploads/2022/03/Screen-Shot-2022-03-22-at-10.26.16-AM.png",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://kindbody.com/team/dr-toral-parikh/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://kindbody.com",
    "description": "Make fertility care an Act of Love\\ Save up to 20% on your first fertility cycle, ends 3/13",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Anthem",
        "Blue Cross",
        "Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Health Net",
        "Multiplan",
        "Tricare",
        "Oxford",
        "Oscar",
        "Emblem Health",
        "Empire",
        "Horizon",
        "Optum",
        "First Health",
        "Medicare",
        "Medicaid"
      ],
      "employeeBenefits": ["Kindbody"],
      "_source": {
        "url": "https://kindbody.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl9ayRWTWXS2qQMeD1wxy2MjYueyIpTgTqHIj97Jfpn78bDKxHA1BLT0ebgYlOTt7akjpvgS72a-wvMy3sQ2cqOX17DnQ49EZSI0pACJdCc8oW4i69A-TjRKDVOKe10YjkMg_o=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Houston,+1111+Uptown+Park+Blvd+%2302,+Houston,+TX+77056/@29.7578106,-95.457122,3464a,13.1y/data=!4m2!3m1!1s0x8640c1f0e710519b:0x845ea0a5c8f11816",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnMpb_sw5RHNyIoKnQ8sjcaM00HhYdMETeoqyNlPSKqA0p9YfTx7mBc5ncSpadptT_meFJIwCr70XTY6tvXwxH4IwupswQ8-jpHggJOUJQs8BinFhgS9g4_RcXUOix0p7Px3w_f=w224-h336-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Houston,+1111+Uptown+Park+Blvd+%2302,+Houston,+TX+77056/@29.7578106,-95.457122,3464a,13.1y/data=!4m2!3m1!1s0x8640c1f0e710519b:0x845ea0a5c8f11816",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "network": {
      "name": "Kindbody"
    },
    "pricing": {
      "packages": [
        {
          "name": "Pulse Assessment",
          "description": "Quick fertility check — not covered by insurance",
          "price": 9900,
          "currency": "USD",
          "includes": [
            "AMH blood test",
            "Transvaginal ultrasound for follicle count",
            "15-minute reproductive consultation"
          ],
          "notes": "Not covered by insurance"
        },
        {
          "name": "Fertility Consultation",
          "description": "Specialist consultation on fertility fundamentals",
          "price": 30000,
          "currency": "USD",
          "notes": "Billable to most insurance plans"
        },
        {
          "name": "Male Consultation + Semen Analysis",
          "price": 52500,
          "currency": "USD",
          "includes": ["Consultation", "Venipuncture", "Semen analysis"]
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Single egg freezing cycle",
          "price": 690000,
          "priceMax": 966000,
          "currency": "USD",
          "includes": [
            "Stimulation visits",
            "Ultrasounds",
            "Blood draws",
            "Retrieval",
            "Cryopreservation",
            "3 months storage",
            "Coordination"
          ],
          "excludes": ["Medications ($4,000 - $6,000)", "Anesthesia"]
        },
        {
          "name": "Annual Egg Storage",
          "price": 92000,
          "currency": "USD",
          "notes": "Per year"
        },
        {
          "name": "IVF Freeze All (Self Pay)",
          "description": "IVF cycle with all embryos frozen",
          "price": 1160000,
          "priceMax": 1850000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Cryopreservation",
            "3 months storage"
          ],
          "excludes": [
            "Medications (~$4,000 - $6,000)",
            "Embryo biopsy/genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Donor services",
            "Anesthesia"
          ]
        },
        {
          "name": "IVF Fresh Transfer (Self Pay)",
          "description": "IVF cycle with fresh embryo transfer",
          "price": 1380000,
          "priceMax": 1875000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$5,000 - $9,000)",
            "Genetic testing",
            "Surplus embryo storage",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Freeze All",
          "price": 910000,
          "priceMax": 1332000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Cryopreservation",
            "3-month storage"
          ],
          "excludes": [
            "Genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Fresh Transfer",
          "price": 990000,
          "priceMax": 1428000,
          "currency": "USD",
          "includes": [
            "Ultrasounds",
            "Thaw",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Surplus storage",
            "Frozen transfers",
            "Anesthesia"
          ]
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 400000,
          "priceMax": 550000,
          "currency": "USD",
          "includes": ["Ultrasounds", "Thaw", "Assisted hatching", "Transfer"],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "PGT Package",
          "description": "Preimplantation genetic testing",
          "price": 160000,
          "priceMax": 300000,
          "currency": "USD",
          "includes": ["Embryo biopsy", "Lab management"],
          "excludes": ["Storage", "Shipping", "Per-embryo testing costs"]
        },
        {
          "name": "Nutrition Coaching",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Counseling & Support",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Guided Meditation",
          "description": "Virtual wellness — 30-minute session",
          "price": 9000,
          "currency": "USD"
        }
      ],
      "financingOptions": [
        {
          "name": "PatientFi monthly payments",
          "description": "PatientFi monthly payments"
        }
      ],
      "disclaimer": "Prices vary by location. Medications and anesthesia are not included in procedure costs. 3 months of storage included with freeze procedures; annual storage is $920.",
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Blue Cross, Blue Shield, Cigna, United Healthcare, Humana, Health Net",
              "detail": "11 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://kindbody.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "14 public price package(s) and 1 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-879",
    "externalIds": {
      "cdcClinicId": "879"
    },
    "type": "fertility-clinic",
    "name": "Kindbody Austin",
    "phone": "(737) 787-7806",
    "address": {
      "line1": "100 Colorado St",
      "city": "Austin",
      "state": "TX",
      "zip": "78701",
      "country": "US"
    },
    "location": {
      "lat": 30.264,
      "lng": -97.746
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 7,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27879%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27879%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+Austin,+100+Colorado+St,+Austin,+TX+78701/@30.2639914,-97.7460816,3446a,13.1y/data=!4m2!3m1!1s0x8644b51d306a1d05:0x88330512852dbeae",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-879-deborah-e-ikhena-abel-md",
        "name": "Deborah E. Ikhena-Abel, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://kindbody.com",
    "description": "Make fertility care an Act of Love\\ Save up to 20% on your first fertility cycle, ends 3/13",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Anthem",
        "Blue Cross",
        "Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Health Net",
        "Multiplan",
        "Tricare",
        "Oxford",
        "Oscar",
        "Emblem Health",
        "Empire",
        "Horizon",
        "Optum",
        "First Health",
        "Medicare",
        "Medicaid"
      ],
      "employeeBenefits": ["Kindbody"],
      "_source": {
        "url": "https://kindbody.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "images": [],
    "network": {
      "name": "Kindbody"
    },
    "pricing": {
      "packages": [
        {
          "name": "Pulse Assessment",
          "description": "Quick fertility check — not covered by insurance",
          "price": 9900,
          "currency": "USD",
          "includes": [
            "AMH blood test",
            "Transvaginal ultrasound for follicle count",
            "15-minute reproductive consultation"
          ],
          "notes": "Not covered by insurance"
        },
        {
          "name": "Fertility Consultation",
          "description": "Specialist consultation on fertility fundamentals",
          "price": 30000,
          "currency": "USD",
          "notes": "Billable to most insurance plans"
        },
        {
          "name": "Male Consultation + Semen Analysis",
          "price": 52500,
          "currency": "USD",
          "includes": ["Consultation", "Venipuncture", "Semen analysis"]
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Single egg freezing cycle",
          "price": 690000,
          "priceMax": 966000,
          "currency": "USD",
          "includes": [
            "Stimulation visits",
            "Ultrasounds",
            "Blood draws",
            "Retrieval",
            "Cryopreservation",
            "3 months storage",
            "Coordination"
          ],
          "excludes": ["Medications ($4,000 - $6,000)", "Anesthesia"]
        },
        {
          "name": "Annual Egg Storage",
          "price": 92000,
          "currency": "USD",
          "notes": "Per year"
        },
        {
          "name": "IVF Freeze All (Self Pay)",
          "description": "IVF cycle with all embryos frozen",
          "price": 1160000,
          "priceMax": 1850000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Cryopreservation",
            "3 months storage"
          ],
          "excludes": [
            "Medications (~$4,000 - $6,000)",
            "Embryo biopsy/genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Donor services",
            "Anesthesia"
          ]
        },
        {
          "name": "IVF Fresh Transfer (Self Pay)",
          "description": "IVF cycle with fresh embryo transfer",
          "price": 1380000,
          "priceMax": 1875000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$5,000 - $9,000)",
            "Genetic testing",
            "Surplus embryo storage",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Freeze All",
          "price": 910000,
          "priceMax": 1332000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Cryopreservation",
            "3-month storage"
          ],
          "excludes": [
            "Genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Fresh Transfer",
          "price": 990000,
          "priceMax": 1428000,
          "currency": "USD",
          "includes": [
            "Ultrasounds",
            "Thaw",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Surplus storage",
            "Frozen transfers",
            "Anesthesia"
          ]
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 400000,
          "priceMax": 550000,
          "currency": "USD",
          "includes": ["Ultrasounds", "Thaw", "Assisted hatching", "Transfer"],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "PGT Package",
          "description": "Preimplantation genetic testing",
          "price": 160000,
          "priceMax": 300000,
          "currency": "USD",
          "includes": ["Embryo biopsy", "Lab management"],
          "excludes": ["Storage", "Shipping", "Per-embryo testing costs"]
        },
        {
          "name": "Nutrition Coaching",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Counseling & Support",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Guided Meditation",
          "description": "Virtual wellness — 30-minute session",
          "price": 9000,
          "currency": "USD"
        }
      ],
      "financingOptions": [
        {
          "name": "PatientFi monthly payments",
          "description": "PatientFi monthly payments"
        }
      ],
      "disclaimer": "Prices vary by location. Medications and anesthesia are not included in procedure costs. 3 months of storage included with freeze procedures; annual storage is $920.",
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Blue Cross, Blue Shield, Cigna, United Healthcare, Humana, Health Net",
              "detail": "11 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://kindbody.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "14 public price package(s) and 1 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-890",
    "externalIds": {
      "cdcClinicId": "890"
    },
    "type": "fertility-clinic",
    "name": "Origin Fertility, PA",
    "phone": "(817) 840-7700",
    "address": {
      "line1": "1643 Lancaster Dr, Suite 309",
      "city": "Grapevine",
      "state": "TX",
      "zip": "76051",
      "country": "US"
    },
    "location": {
      "lat": 32.938,
      "lng": -97.0754
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 3,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27890%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27890%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.originfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-890-linda-c-elkins-md",
        "name": "Linda C. Elkins, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.originfertility.com",
    "description": "As a board certified Reproductive Endocrinology and Infertility specialist, I have been practicing in the Dallas\\-Fort Worth metropolitan area since finishing fellowship in 2011. After ten years at various types of infertility practices, I am ready to start a new kind of practice with a new kind of focus: the patient and their journey through infertility.",
    "languages": ["English"],
    "images": [],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-896",
    "externalIds": {
      "cdcClinicId": "896",
      "googlePlaceId": "ChIJKQFQiWVhXIYRbB0Es--7Bp8"
    },
    "type": "fertility-clinic",
    "name": "Pozitivf Fertility",
    "phone": "210-404-2229",
    "address": {
      "line1": "4515 N Loop 1604 W, Suite 301",
      "city": "San Antonio",
      "state": "TX",
      "zip": "78249",
      "country": "US"
    },
    "location": {
      "lat": 29.5964,
      "lng": -98.5693
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 0,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27896%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27896%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://pozitivf.com/dr-francisco-arredondo/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Pozitivf+Fertility,+4515+N+Loop+1604+W+Ste+301,+San+Antonio,+TX+78249/@29.596767,-98.5720587,3469a,13.1y/data=!4m2!3m1!1s0x865c616589500129:0x9f06bbefb3041d6c",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.pozitivf.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-896-francisco-arredondo-md",
        "name": "Francisco Arredondo, MD",
        "role": "Medical Director",
        "imageUrl": "https://pozitivf.com/wp-content/uploads/2025/02/DrPaco.png",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://pozitivf.com/dr-francisco-arredondo/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.pozitivf.com",
    "languages": ["English", "Spanish"],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnfPHZllDCNvC5WsIdg7BbnAbUO2e4ERvqyCYZ2Wh5SUaQ2TdCZ6s3Vrh-QA65kE6s0pg8UNuHzflv439TDn7UJsr8J6jkqqjvk_xVMbCbRj3poWfuZAqVdVCTxacnuKSkjysiLZYerhGQj=w408-h417-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Pozitivf+Fertility,+4515+N+Loop+1604+W+Ste+301,+San+Antonio,+TX+78249/@29.596767,-98.5720587,3469a,13.1y/data=!4m2!3m1!1s0x865c616589500129:0x9f06bbefb3041d6c",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "logoUrl": "https://pozitivf.com/wp-content/uploads/2024/11/Header-Logo.png",
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "16:00"
      },
      "tue": {
        "open": "08:00",
        "close": "16:00"
      },
      "wed": {
        "open": "08:00",
        "close": "16:00"
      },
      "thu": {
        "open": "08:00",
        "close": "16:00"
      },
      "fri": {
        "open": "08:00",
        "close": "16:00"
      },
      "sat": null,
      "sun": null
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-205",
    "externalIds": {
      "cdcClinicId": "205"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Institute of South Texas",
    "phone": "(956) 687-2693",
    "address": {
      "line1": "110 E. Savannah Ave, Bldg B, Suite 103",
      "city": "Mcallen",
      "state": "TX",
      "zip": "78503",
      "country": "US"
    },
    "location": {
      "lat": 26.1845,
      "lng": -98.2215
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 37.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 8.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 80,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27205%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27205%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitysa.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-205-esteban-o-brown-md",
        "name": "Esteban O. Brown, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.fertilitysa.com",
    "languages": ["English"],
    "images": [],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-24",
    "externalIds": {
      "cdcClinicId": "24",
      "googlePlaceId": "ChIJy_RHG9GYToYR_ggWFtrLDUg"
    },
    "type": "fertility-clinic",
    "name": "ReproMed Fertility Center",
    "phone": "(214) 827-8777",
    "address": {
      "line1": "3800 San Jacinto St",
      "city": "Dallas",
      "state": "TX",
      "zip": "75204",
      "country": "US"
    },
    "location": {
      "lat": 32.7972,
      "lng": -96.785
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 64.70588235294117,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "11/17"
        },
        {
          "ageBand": "38-40",
          "rate": 53.84615384615385,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/13"
        }
      ],
      "cyclesPerYear": 145,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2724%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "minimal",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/ReproMed+Fertility+Center,+3800+San+Jacinto+St,+Dallas,+TX+75204/@32.7971714,-96.7851183,3354a,13.1y/data=!4m2!3m1!1s0x864e98d11b47f4cb:0x480dcbda161608fe",
            "fetchedAt": "2026-08-16"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2724%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-24-anil-b-pinto-md",
        "name": "Anil B. Pinto, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.repromed.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-234",
    "externalIds": {
      "cdcClinicId": "234"
    },
    "type": "fertility-clinic",
    "name": "Scott & White Clinic-Temple",
    "phone": "(254) 724-3389",
    "address": {
      "line1": "Department of Obstetrics and Gynecology, 2401 S. 31st St",
      "city": "Temple",
      "state": "TX",
      "zip": "76508",
      "country": "US"
    },
    "location": {
      "lat": 31.0776,
      "lng": -97.364
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 41,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 30.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 23.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 160,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27234%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27234%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-234-gordon-w-bates-md",
        "name": "Gordon W. Bates, MD",
        "role": "Medical Director"
      }
    ],
    "description": "Baylor Scott & White in Temple, Texas provides comprehensive fertility and reproductive endocrinology services as part of one of the largest not-for-profit healthcare systems in the country.",
    "languages": ["English", "Spanish"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "images": [
      {
        "url": "https://bswmedia.blob.core.windows.net/locationphotos/bsw-clinic-temple.jpg",
        "type": "exterior",
        "caption": "Baylor Scott & White Clinic - Temple",
        "_source": {
          "url": "https://www.bswhealth.com/physician/gordon-bates",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-201",
    "externalIds": {
      "cdcClinicId": "201"
    },
    "type": "fertility-clinic",
    "name": "Southwest Center for Reproductive Health, PA",
    "phone": "(915) 842-9998",
    "address": {
      "line1": "700 S. Mesa Hills Dr",
      "city": "El Paso",
      "state": "TX",
      "zip": "79912",
      "country": "US"
    },
    "location": {
      "lat": 31.8154,
      "lng": -106.539
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 41.66666666666667,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/12"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "0/9"
        }
      ],
      "cyclesPerYear": 49,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27201%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27201%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-201-luis-s-noble-md",
        "name": "Luis S. Noble, MD",
        "role": "Medical Director"
      }
    ],
    "description": "Southwest Center for Reproductive Health in El Paso, Texas provides IVF, IUI, and other fertility treatments serving the West Texas and Southern New Mexico region.",
    "languages": ["English", "Spanish"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-376",
    "externalIds": {
      "cdcClinicId": "376"
    },
    "type": "fertility-clinic",
    "name": "Texas Center for Reproductive Health",
    "phone": "(214) 821-2274",
    "address": {
      "line1": "Barnett Tower, 3600 Gaston Ave, Suite 504",
      "city": "Dallas",
      "state": "TX",
      "zip": "75246",
      "country": "US"
    },
    "location": {
      "lat": 32.7901,
      "lng": -96.7801
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 45.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 45,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27376%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "scraped-retry",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://ivfandfertility.com/our-experts",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27376%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-376-samuel-p-marynick-md",
        "name": "Samuel P. Marynick, MD",
        "role": "Medical Director",
        "imageUrl": "https://ivfandfertility.com/wp-content/uploads/2025/04/Sam-300x209.png",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://ivfandfertility.com/our-experts",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.texasfertility.com",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-276",
    "externalIds": {
      "cdcClinicId": "276"
    },
    "type": "fertility-clinic",
    "name": "Texas Fertility Center, Vaughn, Silverberg & Associates",
    "phone": "(512) 451-0149",
    "address": {
      "line1": "6500 N. Mopac Expressway, Bldg 1, Suite 1200",
      "city": "Austin",
      "state": "TX",
      "zip": "78731",
      "country": "US"
    },
    "location": {
      "lat": 30.3472,
      "lng": -97.7514
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 51.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 52.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 46.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 35.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1141,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27276%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27276%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://txfertility.com/fertility-specialists/kaylen-silverberg-md/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.txfertility.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-276-kaylen-silverberg-md",
        "name": "Kaylen Silverberg, MD",
        "role": "Medical Director",
        "imageUrl": "https://txfertility.com/wp-content/uploads/2023/03/TFC-Kaylen-Silverberg-Headshot-optimized-819x1024.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://txfertility.com/fertility-specialists/kaylen-silverberg-md/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.txfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": ["Optum"],
      "_source": {
        "url": "https://www.txfertility.com",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English"],
    "images": [],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Optum",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.txfertility.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-48",
    "externalIds": {
      "cdcClinicId": "48"
    },
    "type": "fertility-clinic",
    "name": "Texas IVF",
    "phone": "(972) 981-7800",
    "address": {
      "line1": "6130 W. Parker Rd, Suite 215",
      "city": "Plano",
      "state": "TX",
      "zip": "75093",
      "country": "US"
    },
    "location": {
      "lat": 33.044,
      "lng": -96.8371
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 41.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 41.66666666666667,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/12"
        }
      ],
      "cyclesPerYear": 97,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2748%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2748%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.texasivf.com",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-48-alfred-j-rodriguez-md",
        "name": "Alfred J. Rodriguez, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.texasivf.com",
    "languages": ["English"],
    "images": [],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-519",
    "externalIds": {
      "cdcClinicId": "519",
      "googlePlaceId": "ChIJ1R0z3VcN_oYR9g1akCIQZXM"
    },
    "type": "fertility-clinic",
    "name": "Texas Tech University Health Sciences Center, Center for Fertility and Reproductive Surgery",
    "phone": "(806) 743-4256",
    "address": {
      "line1": "808 Joliet Ave, Suite 230",
      "city": "Lubbock",
      "state": "TX",
      "zip": "79415",
      "country": "US"
    },
    "location": {
      "lat": 33.5877,
      "lng": -101.89
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 31.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/14"
        }
      ],
      "cyclesPerYear": 88,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27519%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Texas+Tech+Physicians:+Center+for+Fertility+and+Reproductive+Surgery,+Medical+Office+Plaza+II,+808+Joliet+Ave+Ste+230,+Lubbock,+TX+79415/@33.58844,-101.890035,3324a,13.1y/data=!4m2!3m1!1s0x86fe0d57dd331dd5:0x73651022905a0df6",
            "fetchedAt": "2026-08-16"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27519%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-519-edward-yeomans-md",
        "name": "Edward\t Yeomans, MD",
        "role": "Medical Director"
      }
    ],
    "description": "Texas Tech University Health Sciences Center's Center for Fertility and Reproductive Surgery in Lubbock provides academic-based fertility care and reproductive surgery.",
    "languages": ["English", "Spanish"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk4JHT9MqqPeyoZScd0BIXTwA5tKqb4WtqbKdlmhM-ddNNPpxMZfyRtdtdu9e4J7rjzo8QqL6kk1lwY3Il8SFJayISaCUDtaoHsYC12ASOoz4hgXQ7ZelULcJ7d60CBtRQ-VLD1WYA-Flw=w426-h240-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Texas+Tech+Physicians:+Center+for+Fertility+and+Reproductive+Surgery,+Medical+Office+Plaza+II,+808+Joliet+Ave+Ste+230,+Lubbock,+TX+79415/@33.58844,-101.890035,3324a,13.1y/data=!4m2!3m1!1s0x86fe0d57dd331dd5:0x73651022905a0df6",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-608",
    "externalIds": {
      "cdcClinicId": "608"
    },
    "type": "fertility-clinic",
    "name": "The Center for Reproductive Endocrinology",
    "phone": "(972) 566-6686",
    "address": {
      "line1": "7777 Forest Ln, Suite C638",
      "city": "Dallas",
      "state": "TX",
      "zip": "75230",
      "country": "US"
    },
    "location": {
      "lat": 32.9127,
      "lng": -96.7744
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 41.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 40.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 201,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27608%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://dallasfertilitycenter.com/our-center/photo-gallery/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27608%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-608-walid-a-saleh-md",
        "name": "Walid A. Saleh, MD",
        "role": "Medical Director",
        "imageUrl": "https://dallasfertilitycenter.com/wp-content/uploads/2023/11/dr-walid-saleh-dallas-fertility-clinic.webp",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://dallasfertilitycenter.com/our-center/meet-the-managers/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "description": "The Center for Reproductive Endocrinology in Dallas, Texas offers fertility treatment services including IVF and reproductive endocrinology.",
    "languages": ["English"],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "images": [
      {
        "url": "https://dallasfertilitycenter.com/wp-content/uploads/2015/05/Andology-Reception.webp",
        "type": "interior",
        "caption": "Dallas Fertility Center andrology reception",
        "_source": {
          "url": "https://dallasfertilitycenter.com/our-center/photo-gallery/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://dallasfertilitycenter.com/wp-content/uploads/2023/11/CRE-Reception.webp",
        "type": "interior",
        "caption": "Dallas Fertility Center reception",
        "_source": {
          "url": "https://dallasfertilitycenter.com/our-center/photo-gallery/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://dallasfertilitycenter.com/wp-content/uploads/2023/11/CRE-Reception-2.webp",
        "type": "interior",
        "caption": "Dallas Fertility Center reception",
        "_source": {
          "url": "https://dallasfertilitycenter.com/our-center/photo-gallery/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://dallasfertilitycenter.com/wp-content/uploads/2023/11/Operating-Room.webp",
        "type": "interior",
        "caption": "Dallas Fertility Center operating room",
        "_source": {
          "url": "https://dallasfertilitycenter.com/our-center/photo-gallery/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-169",
    "externalIds": {
      "cdcClinicId": "169"
    },
    "type": "fertility-clinic",
    "name": "UT Health San Antonio Reproductive Health and Fertility Center",
    "phone": "(210) 450-9500",
    "address": {
      "line1": "Medical Arts & Research Center, 8300 Floyd Curl Dr, 5th Floor",
      "city": "San Antonio",
      "state": "TX",
      "zip": "78229",
      "country": "US"
    },
    "location": {
      "lat": 36.0525,
      "lng": -94.1268
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 38.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 38.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 26.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 33.33333333333333,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/18"
        }
      ],
      "cyclesPerYear": 240,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27169%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27169%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://directory.uthscsa.edu/academics/profile/yauger",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.uthscsa.edu",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z",
      "date": "2026-03-11"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-169-belinda-j-yauger-md",
        "name": "Belinda J. Yauger, MD",
        "role": "Medical Director",
        "imageUrl": "https://directory.uthscsa.edu/sites/directory/files/belindayauger.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://directory.uthscsa.edu/academics/profile/yauger",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.uthscsa.edu",
    "description": "UT Health San Antonio offers a holistic approach to treat neurological disease and support the day\\-to\\-day lives of patients and their families",
    "languages": ["English"],
    "images": [
      {
        "url": "https://uthscsa.edu/sites/default/files/styles/max_325x325/public/2026-03/Center%20for%20Brain%20Health-7.jpg?itok=_Fcha4ul",
        "type": "exterior",
        "_source": {
          "url": "https://www.uthscsa.edu",
          "fetchedAt": "2026-03-11"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-833",
    "externalIds": {
      "cdcClinicId": "833",
      "googlePlaceId": "ChIJzy99Y-GbTYcRwrek0F7GelY"
    },
    "type": "fertility-clinic",
    "name": "Conceptions Fertility Center - Provo",
    "phone": "(801) 430-9612",
    "address": {
      "line1": "1900 N State St, Suite 105",
      "city": "Provo",
      "state": "UT",
      "zip": "84604",
      "country": "US"
    },
    "location": {
      "lat": 40.2603,
      "lng": -111.676
    },
    "treatments": [
      {
        "name": "Reproductive surgery",
        "category": "surgical",
        "_source": {
          "url": "https://conceptionsutah.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg, sperm, and embryo freezing",
        "category": "preservation",
        "_source": {
          "url": "https://conceptionsutah.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF & ICSI",
        "category": "art",
        "_source": {
          "url": "https://conceptionsutah.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Frozen embryo transfer",
        "category": "art",
        "_source": {
          "url": "https://conceptionsutah.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Preimplantation genetic testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://conceptionsutah.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation induction",
        "category": "art",
        "_source": {
          "url": "https://conceptionsutah.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://conceptionsutah.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility diagnostics",
        "category": "diagnostic",
        "_source": {
          "url": "https://conceptionsutah.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Third-party reproduction",
        "category": "art",
        "_source": {
          "url": "https://conceptionsutah.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 48.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 43.75,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/16"
        }
      ],
      "cyclesPerYear": 125,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27833%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://conceptionsutah.com/locations-provo",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27833%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://conceptionsutah.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://conceptionsutah.com/our-team",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://conceptionsutah.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://conceptionsutah.com/locations-provo",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Conceptions+Fertility+Center,+1900+N+State+St+%23105,+Provo,+UT+84604/@40.2602616,-111.6754863,3045a,13.1y/data=!4m2!3m1!1s0x874d9be1637d2fcf:0x567ac65ed0a4b7c2",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://conceptionsutah.com/locations-provo",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-833-andrew-k-moore-md",
        "name": "Andrew K. Moore, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://conceptionsutah.com/wp-content/uploads/2024/06/moore-md-desktop.jpg",
        "_source": {
          "url": "https://conceptionsutah.com/our-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-833-katie-mckinnon-pa-c",
        "name": "Katie McKinnon, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "specialty": "Physician Assistant",
        "imageUrl": "https://conceptionsutah.com/wp-content/uploads/2023/08/katie-mckinnon-pa-c-img-desktop.jpg",
        "_source": {
          "url": "https://conceptionsutah.com/our-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-833-chelsey-cook-fnp-c",
        "name": "Chelsey Cook, FNP-C",
        "role": "Nurse Practitioner",
        "credentials": ["FNP-C"],
        "specialty": "Nurse Practitioner",
        "imageUrl": "https://conceptionsutah.com/wp-content/uploads/2023/12/chelsey-desktop-1.jpg",
        "_source": {
          "url": "https://conceptionsutah.com/our-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-833-claire-escovar-dnp-whnp-bc",
        "name": "Claire Escovar, DNP, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["DNP", "WHNP-BC"],
        "specialty": "Nurse Practitioner",
        "imageUrl": "https://conceptionsutah.com/wp-content/uploads/2025/05/claire-desktop.jpg",
        "_source": {
          "url": "https://conceptionsutah.com/our-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-833-erin-phelps-msn-fnp-c",
        "name": "Erin Phelps, MSN, FNP-C",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "FNP-C"],
        "specialty": "Nurse Practitioner",
        "imageUrl": "https://conceptionsutah.com/wp-content/uploads/2025/09/erin-phelps-img22-desktop.jpg",
        "_source": {
          "url": "https://conceptionsutah.com/our-team",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://conceptionsutah.com/locations-provo",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "specialties": ["reproductive-endocrinology"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "schedule": {
      "mon": {
        "open": "08:30",
        "close": "16:30"
      },
      "tue": {
        "open": "08:30",
        "close": "16:30"
      },
      "wed": {
        "open": "08:30",
        "close": "16:30"
      },
      "thu": {
        "open": "08:30",
        "close": "16:30"
      },
      "fri": {
        "open": "08:30",
        "close": "16:30"
      }
    },
    "description": "Conceptions Fertility Center provides IVF, IUI, fertility diagnostics, reproductive surgery, fertility preservation, PGT, LGBTQ fertility care, and third-party reproduction from Provo and North Logan clinics.",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Utah (UT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWljb-Ue4x-zkaqH7C29O5i1YjQFhJ8MFnmPUMrgQTocV9y9Wrky4-cK0OYY0k2FZ4V8LoUFGXZSU3O1_jYqMMQ__TygVozUm2E_cN4NWhp6v5-jI2yZvK_vN5u_BykruO7_9iY=w360-h240-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Conceptions+Fertility+Center,+1900+N+State+St+%23105,+Provo,+UT+84604/@40.2602616,-111.6754863,3045a,13.1y/data=!4m2!3m1!1s0x874d9be1637d2fcf:0x567ac65ed0a4b7c2",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-conceptions-north-logan",
    "externalIds": {
      "googlePlaceId": "ChIJ--o_ti19VIcRlAEwyP4_9Io"
    },
    "type": "fertility-clinic",
    "name": "Conceptions Fertility Center - North Logan",
    "phone": "(801) 430-9465",
    "address": {
      "line1": "2245 N 400 E, Suite 201",
      "city": "North Logan",
      "state": "UT",
      "zip": "84341",
      "country": "US"
    },
    "location": {
      "lat": 41.7728927,
      "lng": -111.8236975
    },
    "website": "https://conceptionsutah.com/locations-north-logan",
    "treatments": [
      {
        "name": "Reproductive surgery",
        "category": "surgical",
        "_source": {
          "url": "https://conceptionsutah.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg, sperm, and embryo freezing",
        "category": "preservation",
        "_source": {
          "url": "https://conceptionsutah.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF & ICSI",
        "category": "art",
        "_source": {
          "url": "https://conceptionsutah.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Frozen embryo transfer",
        "category": "art",
        "_source": {
          "url": "https://conceptionsutah.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Preimplantation genetic testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://conceptionsutah.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation induction",
        "category": "art",
        "_source": {
          "url": "https://conceptionsutah.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://conceptionsutah.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility diagnostics",
        "category": "diagnostic",
        "_source": {
          "url": "https://conceptionsutah.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Third-party reproduction",
        "category": "art",
        "_source": {
          "url": "https://conceptionsutah.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "specialties": ["reproductive-endocrinology"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "schedule": {
      "mon": {
        "open": "08:30",
        "close": "16:30"
      },
      "tue": {
        "open": "08:30",
        "close": "16:30"
      },
      "wed": {
        "open": "08:30",
        "close": "16:30"
      },
      "thu": {
        "open": "08:30",
        "close": "16:30"
      },
      "fri": {
        "open": "08:30",
        "close": "16:30"
      }
    },
    "description": "Conceptions Fertility Center provides IVF, IUI, fertility diagnostics, reproductive surgery, fertility preservation, PGT, LGBTQ fertility care, and third-party reproduction from Provo and North Logan clinics.",
    "team": [
      {
        "practitionerId": "pr-org-satellite-conceptions-north-logan-cassidy-gonzalez-dmsc-pa-c",
        "name": "Cassidy Gonzalez, DMSc, PA-C",
        "role": "Physician Assistant",
        "credentials": ["DMSc", "PA-C"],
        "specialty": "Physician Assistant",
        "imageUrl": "https://conceptionsutah.com/wp-content/uploads/2023/08/cassidy-gonzalez-img-desktop.jpg",
        "_source": {
          "url": "https://conceptionsutah.com/locations-north-logan",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://conceptionsutah.com/locations-north-logan",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://conceptionsutah.com/locations-north-logan",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://conceptionsutah.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://conceptionsutah.com/locations-north-logan",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://conceptionsutah.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://conceptionsutah.com/locations-north-logan",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Conceptions+Fertility+North+Logan+UT,+2245+N+400+E+Ste+201,+North+Logan,+UT+84341/@41.772912,-111.823802,2976a,13.1y/data=!4m2!3m1!1s0x87547d2db63feafb:0x8af43ffec8300194",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Utah (UT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkhR-IHCORPnE_qPvny0DrReGlO0DqW3kkhyrejWDlheK5dVnQlNJzLtGTazxkNnizQ_0YTyFb8vkpUQJeHpjdPCnLFxo7eznwBa9QvhrDYAkRNOrOXJrUM-T0A7W6uJ_HNSWE=w454-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Conceptions+Fertility+North+Logan+UT,+2245+N+400+E+Ste+201,+North+Logan,+UT+84341/@41.772912,-111.823802,2976a,13.1y/data=!4m2!3m1!1s0x87547d2db63feafb:0x8af43ffec8300194",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-79",
    "externalIds": {
      "cdcClinicId": "79"
    },
    "type": "fertility-clinic",
    "name": "RMA Utah - Sandy",
    "phone": "(866) 762-3140",
    "address": {
      "line1": "10150 Petunia Way",
      "city": "Sandy",
      "state": "UT",
      "zip": "84092",
      "country": "US"
    },
    "location": {
      "lat": 40.5668,
      "lng": -111.851
    },
    "treatments": [
      {
        "name": "Infertility testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation induction",
        "category": "art",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Frozen embryo transfer",
        "category": "art",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "ICSI",
        "category": "art",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Genetic testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg freezing",
        "category": "preservation",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Third-party reproduction",
        "category": "art",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Reproductive surgery",
        "category": "surgical",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 43.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 44.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 27.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 261,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2779%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2779%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://fertilitydr.com/sandy-ut-fertility-clinic/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-79-erica-b-johnstone-md-mhs",
        "name": "Erica B. Johnstone, MD, MHS",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MHS"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2026/03/Erica-Boiman-Johnstone-MD-MHS-mobile-image.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-79-kristi-maas-md",
        "name": "Kristi Maas, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2025/10/Doctor-Mobile-website-headshot-264-x-264-px-1.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-79-joseph-m-letourneau-md",
        "name": "Joseph M. Letourneau, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2026/03/RMA-header-image-doctor-page-mobile-image-264-x-264-px-1.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-79-megan-link-md",
        "name": "Megan Link, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2026/03/Doctor-Page-Mobile-Image-264-x-264-px-10.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-79-ashley-n-shaffer-np",
        "name": "Ashley N. Shaffer, NP",
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "specialty": "Nurse Practitioner",
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2026/03/Ashley-Shaffer-Mobile.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://fertilitydr.com/sandy-ut-fertility-clinic/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "bookingUrl": "https://rmanetwork.com/our-locations/reproductive-care-center-utah-ivf/",
    "description": "RMA Utah, formerly UCRM and Reproductive Care Center, provides infertility testing, IUI, IVF, FET, ICSI, genetic testing, egg freezing, third-party reproduction, LGBTQ fertility care, and reproductive surgery across Clearfield, Salt Lake City, and Sandy.",
    "network": {
      "name": "IVI RMA"
    },
    "specialties": ["reproductive-endocrinology"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Utah (UT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-16",
    "externalIds": {
      "cdcClinicId": "16"
    },
    "type": "fertility-clinic",
    "name": "RMA Utah - Salt Lake City",
    "phone": "(866) 762-3140",
    "address": {
      "line1": "675 Arapeen Drive, Suite 205",
      "city": "Salt Lake City",
      "state": "UT",
      "zip": "84108",
      "country": "US"
    },
    "location": {
      "lat": 40.7552,
      "lng": -111.826
    },
    "treatments": [
      {
        "name": "Infertility testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation induction",
        "category": "art",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Frozen embryo transfer",
        "category": "art",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "ICSI",
        "category": "art",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Genetic testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg freezing",
        "category": "preservation",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Third-party reproduction",
        "category": "art",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Reproductive surgery",
        "category": "surgical",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 61.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 62.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 23.1,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 327,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2716%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2716%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-16-erica-b-johnstone-md-mhs",
        "name": "Erica B. Johnstone, MD, MHS",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MHS"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2026/03/Erica-Boiman-Johnstone-MD-MHS-mobile-image.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-16-kristi-maas-md",
        "name": "Kristi Maas, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2025/10/Doctor-Mobile-website-headshot-264-x-264-px-1.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-16-joseph-m-letourneau-md",
        "name": "Joseph M. Letourneau, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2026/03/RMA-header-image-doctor-page-mobile-image-264-x-264-px-1.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-16-megan-link-md",
        "name": "Megan Link, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2026/03/Doctor-Page-Mobile-Image-264-x-264-px-10.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-16-ashley-n-shaffer-np",
        "name": "Ashley N. Shaffer, NP",
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "specialty": "Nurse Practitioner",
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2026/03/Ashley-Shaffer-Mobile.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "network": {
      "name": "IVI RMA"
    },
    "specialties": ["reproductive-endocrinology"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "description": "RMA Utah, formerly UCRM and Reproductive Care Center, provides infertility testing, IUI, IVF, FET, ICSI, genetic testing, egg freezing, third-party reproduction, LGBTQ fertility care, and reproductive surgery across Clearfield, Salt Lake City, and Sandy.",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Utah (UT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-433",
    "externalIds": {
      "cdcClinicId": "433"
    },
    "type": "fertility-clinic",
    "name": "Utah Fertility Center - Pleasant Grove",
    "phone": "(801) 785-5100",
    "address": {
      "line1": "1446 S. Pleasant Grove Blvd",
      "city": "Pleasant Grove",
      "state": "UT",
      "zip": "84062",
      "country": "US"
    },
    "location": {
      "lat": 40.3605,
      "lng": -111.761
    },
    "treatments": [
      {
        "name": "Gentle IVF",
        "category": "art",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Recurrent pregnancy loss care",
        "category": "diagnostic",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Genetic testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Male infertility care",
        "category": "diagnostic",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg freezing",
        "category": "preservation",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility preservation for cancer patients",
        "category": "preservation",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg donor services",
        "category": "art",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Surrogacy",
        "category": "art",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 48.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 47.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 56,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 39.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1178,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27433%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://utahfertility.com/locations/pleasant-grove-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27433%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://utahfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://utahfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://utahfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://utahfertility.com/locations/pleasant-grove-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://utahfertility.com/locations/pleasant-grove-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://utahfertility.com/locations/pleasant-grove-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-433-shawn-e-gurtcheff-md-ms",
        "name": "Shawn E. Gurtcheff, MD, MS",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MS"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/1452x1932/9489a3d16c/dr-shawn-e-gurtcheff.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-433-deirdre-a-conway-md",
        "name": "Deirdre A. Conway, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/1024x1536/b2bcf0b114/deirdre-a-conway-md.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-433-yetunde-ibrahim-md",
        "name": "Yetunde Ibrahim, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/1452x1932/0b5feadcfe/dr-yetunde-ibrahim.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-433-erica-louden-md-phd-facog",
        "name": "Erica Louden, MD, PhD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "PhD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/533x800/41547658de/erica-louden-md-ph-d-facog.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-433-melinda-henne-md",
        "name": "Melinda Henne, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/3072x4080/79fa1d7c87/melinda-henne-md.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-433-addison-alley-md-msci-facog",
        "name": "Addison Alley, MD, MSCI, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MSCI", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/2520x3149/7dac9de5f0/dr-addison-alley.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://utahfertility.com/locations/pleasant-grove-clinic",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "network": {
      "name": "Utah Fertility Center"
    },
    "specialties": ["reproductive-endocrinology", "male-infertility"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "17:00"
      },
      "tue": {
        "open": "08:00",
        "close": "17:00"
      },
      "wed": {
        "open": "08:00",
        "close": "17:00"
      },
      "thu": {
        "open": "08:00",
        "close": "17:00"
      },
      "fri": {
        "open": "08:00",
        "close": "17:00"
      }
    },
    "description": "Utah Fertility Center provides gentle IVF, IVF, IUI, genetic testing, male infertility care, egg freezing, cancer fertility preservation, LGBTQ family-building, egg donor services, and surrogacy from clinics in Pleasant Grove, Midvale, Ogden, and St. George.",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Utah (UT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-utah-fertility-midvale",
    "externalIds": {
      "googlePlaceId": "ChIJ5WPfQyqKUocR1raPTwGAaNg"
    },
    "type": "fertility-clinic",
    "name": "Utah Fertility Center - Midvale",
    "phone": "(801) 785-5100",
    "address": {
      "line1": "7050 Union Park Ave, Suite 500",
      "city": "Midvale",
      "state": "UT",
      "zip": "84047",
      "country": "US"
    },
    "location": {
      "lat": 40.6229503,
      "lng": -111.8585198
    },
    "website": "https://utahfertility.com/locations/midvale-clinic",
    "treatments": [
      {
        "name": "Gentle IVF",
        "category": "art",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Recurrent pregnancy loss care",
        "category": "diagnostic",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Genetic testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Male infertility care",
        "category": "diagnostic",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg freezing",
        "category": "preservation",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility preservation for cancer patients",
        "category": "preservation",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg donor services",
        "category": "art",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Surrogacy",
        "category": "art",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "Utah Fertility Center"
    },
    "setting": "network-group",
    "specialties": ["reproductive-endocrinology", "male-infertility"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "17:00"
      },
      "tue": {
        "open": "08:00",
        "close": "17:00"
      },
      "wed": {
        "open": "08:00",
        "close": "17:00"
      },
      "thu": {
        "open": "08:00",
        "close": "17:00"
      },
      "fri": {
        "open": "08:00",
        "close": "17:00"
      }
    },
    "description": "Utah Fertility Center provides gentle IVF, IVF, IUI, genetic testing, male infertility care, egg freezing, cancer fertility preservation, LGBTQ family-building, egg donor services, and surrogacy from clinics in Pleasant Grove, Midvale, Ogden, and St. George.",
    "team": [
      {
        "practitionerId": "pr-org-web-utah-fertility-midvale-shawn-e-gurtcheff-md-ms",
        "name": "Shawn E. Gurtcheff, MD, MS",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MS"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/1452x1932/9489a3d16c/dr-shawn-e-gurtcheff.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-utah-fertility-midvale-deirdre-a-conway-md",
        "name": "Deirdre A. Conway, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/1024x1536/b2bcf0b114/deirdre-a-conway-md.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-utah-fertility-midvale-yetunde-ibrahim-md",
        "name": "Yetunde Ibrahim, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/1452x1932/0b5feadcfe/dr-yetunde-ibrahim.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-utah-fertility-midvale-erica-louden-md-phd-facog",
        "name": "Erica Louden, MD, PhD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "PhD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/533x800/41547658de/erica-louden-md-ph-d-facog.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-utah-fertility-midvale-melinda-henne-md",
        "name": "Melinda Henne, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/3072x4080/79fa1d7c87/melinda-henne-md.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-utah-fertility-midvale-addison-alley-md-msci-facog",
        "name": "Addison Alley, MD, MSCI, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MSCI", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/2520x3149/7dac9de5f0/dr-addison-alley.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://utahfertility.com/locations/midvale-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://utahfertility.com/locations/midvale-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://utahfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://utahfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://utahfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://utahfertility.com/locations/midvale-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Utah+Fertility+Center,+7050+Union+Park+Ave+Ste+500,+Midvale,+UT+84047/@40.6229503,-111.8585225,3028a,13.1y/data=!4m2!3m1!1s0x87528a2a43df63e5:0xd86880014f8fb6d6",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Utah (UT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl6JNavzhceEVz11UruEmBrtiMheRF-ENtCUlwdcP5DTP7BxMQ_feYGUhkw3n6dAqAujgcFoTyJgBnkoxaiE9YaY9w74EqRV0uOUMb1-RprXOD2vN7XU08V4Ca1kdnT57WvcC0J=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Utah+Fertility+Center,+7050+Union+Park+Ave+Ste+500,+Midvale,+UT+84047/@40.6229503,-111.8585225,3028a,13.1y/data=!4m2!3m1!1s0x87528a2a43df63e5:0xd86880014f8fb6d6",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnKZCjAXSpZ61pG0BYFvKvXhbhftQkija-nv9DqTjnEg5VG_L4CrUSu2eaL-DlON8Ri3a7KTkHmYev9ag7G_fSaD6vldNB7VRbBpe7JsTRxEeB8THV3edgN3UN7uupMHLdsBFEU=w444-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Utah+Fertility+Center,+7050+Union+Park+Ave+Ste+500,+Midvale,+UT+84047/@40.6229503,-111.8585225,3028a,13.1y/data=!4m2!3m1!1s0x87528a2a43df63e5:0xd86880014f8fb6d6",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-utah-fertility-ogden",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Utah Fertility Center - Ogden",
    "phone": "(801) 785-5100",
    "address": {
      "line1": "1452 E Ridgeline Dr, Suite 100",
      "city": "South Ogden",
      "state": "UT",
      "zip": "84405",
      "country": "US"
    },
    "location": {
      "lat": 41.1544692,
      "lng": -111.9421252
    },
    "website": "https://utahfertility.com/locations/ogden-clinic",
    "treatments": [
      {
        "name": "Gentle IVF",
        "category": "art",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Recurrent pregnancy loss care",
        "category": "diagnostic",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Genetic testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Male infertility care",
        "category": "diagnostic",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg freezing",
        "category": "preservation",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility preservation for cancer patients",
        "category": "preservation",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg donor services",
        "category": "art",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Surrogacy",
        "category": "art",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "Utah Fertility Center"
    },
    "setting": "network-group",
    "specialties": ["reproductive-endocrinology", "male-infertility"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "17:00"
      },
      "tue": {
        "open": "08:00",
        "close": "17:00"
      },
      "wed": {
        "open": "08:00",
        "close": "17:00"
      },
      "thu": {
        "open": "08:00",
        "close": "17:00"
      },
      "fri": {
        "open": "08:00",
        "close": "17:00"
      }
    },
    "description": "Utah Fertility Center provides gentle IVF, IVF, IUI, genetic testing, male infertility care, egg freezing, cancer fertility preservation, LGBTQ family-building, egg donor services, and surrogacy from clinics in Pleasant Grove, Midvale, Ogden, and St. George.",
    "team": [
      {
        "practitionerId": "pr-org-web-utah-fertility-ogden-shawn-e-gurtcheff-md-ms",
        "name": "Shawn E. Gurtcheff, MD, MS",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MS"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/1452x1932/9489a3d16c/dr-shawn-e-gurtcheff.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-utah-fertility-ogden-deirdre-a-conway-md",
        "name": "Deirdre A. Conway, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/1024x1536/b2bcf0b114/deirdre-a-conway-md.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-utah-fertility-ogden-yetunde-ibrahim-md",
        "name": "Yetunde Ibrahim, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/1452x1932/0b5feadcfe/dr-yetunde-ibrahim.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-utah-fertility-ogden-erica-louden-md-phd-facog",
        "name": "Erica Louden, MD, PhD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "PhD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/533x800/41547658de/erica-louden-md-ph-d-facog.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-utah-fertility-ogden-melinda-henne-md",
        "name": "Melinda Henne, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/3072x4080/79fa1d7c87/melinda-henne-md.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-utah-fertility-ogden-addison-alley-md-msci-facog",
        "name": "Addison Alley, MD, MSCI, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MSCI", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/2520x3149/7dac9de5f0/dr-addison-alley.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://utahfertility.com/locations/ogden-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://utahfertility.com/locations/ogden-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://utahfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://utahfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://utahfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://utahfertility.com/locations/ogden-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://utahfertility.com/locations/ogden-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Utah (UT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-806",
    "externalIds": {
      "cdcClinicId": "806",
      "googlePlaceId": "ChIJgSmlVuZKtokR50tdbp1BRLg"
    },
    "type": "fertility-clinic",
    "name": "CCRM Northern Virginia",
    "phone": "(571) 789-2100",
    "address": {
      "line1": "8010 Towers Crescent Dr, 5th Floor",
      "city": "Vienna",
      "state": "VA",
      "zip": "22182",
      "country": "US"
    },
    "location": {
      "lat": 38.9143,
      "lng": -77.2207
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 51.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 57.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 42.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 35.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 721,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27806%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27806%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/virginia/vienna/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Northern+Virginia+-+Vienna,+8010+Towers+Crescent+Dr+5th+Floor,+Vienna,+VA+22182/@38.9146383,-77.2208457,3104a,13.1y/data=!4m2!3m1!1s0x89b64ae656a52981:0xb844419d6e5d4be7",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-806-mark-d-payson-md",
        "name": "Mark D. Payson, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Mark_Payson_600x600_2x.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/mark-payson/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Olivia Carpinello, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Olivia_Carpinello_600x600_2x.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/olivia-carpinello/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-806-olivia-carpinello-md"
      },
      {
        "name": "Chantel Cross, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Chantel_Cross_600x600_2x.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/chantel-cross/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-806-chantel-cross-md"
      },
      {
        "name": "Carter Owen, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Carter_Owen_600x600_2x.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/carter-owen/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-806-carter-owen-md"
      },
      {
        "name": "Abbaa Sarhan, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Abbaa_Sarhanr_600x600_2x.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/abbaa-sarhan/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-806-abbaa-sarhan-md"
      },
      {
        "name": "Ashley Urben, MSN, APRN, FNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "APRN", "FNP-BC"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/09/Urben_600x600_2x.png",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/ashley-urben/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-806-ashley-urben-msn-aprn-fnp-bc"
      },
      {
        "name": "Caroline Yeakle, MSN, WHNP-BC",
        "role": "Women's Health Nurse Practitioner",
        "credentials": ["MSN", "WHNP-BC"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/08/Caroline-Yeakle-1200x1200.png",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/caroline-yeakle/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-806-caroline-yeakle-msn-whnp-bc"
      }
    ],
    "website": "https://www.ccrmivf.com/northern-virginia",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Anthem"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Anthem",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmZ5YdyX3O5uea6tGMn-FZ1R6miuQg7BXXdg6qVykHCPghLoSfLqBwe3ycGdkFVBmGqhWoUk0OKtCjdiF1fgOC8ntNMSb85d4rwzajL50NBW3M2PDiD6v4xsXEBvTsFIPfWfhrg=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Northern+Virginia+-+Vienna,+8010+Towers+Crescent+Dr+5th+Floor,+Vienna,+VA+22182/@38.9146383,-77.2208457,3104a,13.1y/data=!4m2!3m1!1s0x89b64ae656a52981:0xb844419d6e5d4be7",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl8VDpeJbewT8witt4Kxrz1UwfiHK58z0a-2ZGU_l3RuaFl-zJsTL_VCY4j3gdpKFmRojBOapRqtFkcJCK6DxbqbW6VqE8cQRbbb39Syy2OHbv5NuwyqAatyc3-ylwwUGpi1m_kTw=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Northern+Virginia+-+Vienna,+8010+Towers+Crescent+Dr+5th+Floor,+Vienna,+VA+22182/@38.9146383,-77.2208457,3104a,13.1y/data=!4m2!3m1!1s0x89b64ae656a52981:0xb844419d6e5d4be7",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-327",
    "externalIds": {
      "cdcClinicId": "327"
    },
    "type": "fertility-clinic",
    "name": "Dominion Fertility",
    "phone": "(703) 920-3890",
    "address": {
      "line1": "4040 N. Fairfax Dr, Suite 600",
      "city": "Arlington",
      "state": "VA",
      "zip": "22203",
      "country": "US"
    },
    "location": {
      "lat": 38.882,
      "lng": -77.1089
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 51.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 54.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 37.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 22.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 783,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27327%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27327%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.dominionfertility.com/about/team",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-327-michael-dimattina-md",
        "name": "Michael DiMattina, MD",
        "role": "Medical Director",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/03/Dr.-Michael-Dimattina_VA-1024x1024.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.dominionfertility.com/about/team",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "SiWon Lee",
        "role": "Reproductive Endocrinologist & Infertility Specialist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/03/Dr.-Si-Won-Lee_VA-1024x1024.jpg",
        "_source": {
          "url": "https://www.dominionfertility.com/about/team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-327-siwon-lee"
      },
      {
        "name": "Taylor Gardner",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "APRN", "FNP-C"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/02/Taylor-Gardner-VA-1024x1024.jpg",
        "_source": {
          "url": "https://www.dominionfertility.com/about/team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-327-taylor-gardner"
      }
    ],
    "website": "https://www.dominionfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Anthem"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/4040marianna-1024x849.png",
        "type": "interior",
        "caption": "Exam/procedure room at the Arlington clinic with a staff member",
        "_source": {
          "url": "https://www.dominionfertility.com/about/team",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/3620lab-1024x768.png",
        "type": "lab",
        "caption": "Embryology/IVF lab workstation with an embryologist at the microscope",
        "_source": {
          "url": "https://www.dominionfertility.com/about/team",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Anthem",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-461",
    "externalIds": {
      "cdcClinicId": "461"
    },
    "type": "fertility-clinic",
    "name": "Genetics & IVF Institute",
    "phone": "(703) 698-3912",
    "address": {
      "line1": "3015 Williams Dr",
      "city": "Fairfax",
      "state": "VA",
      "zip": "22031",
      "country": "US"
    },
    "location": {
      "lat": 38.8685,
      "lng": -77.2332
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 40,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 46.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 53.84615384615385,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/13"
        }
      ],
      "cyclesPerYear": 97,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27461%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27461%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://givffertility.com/our-team/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-461-laurence-c-udoff-md",
        "name": "Laurence C. Udoff, MD",
        "role": "Medical Director",
        "imageUrl": "https://givffertility.com/wp-content/uploads/2025/03/Fertility-Specialist-Dr.-Laurence-Udoff-e1743612010349.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://givffertility.com/about/fertility-specialist-dr-laurence-udoff/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Ioanna Comstock, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://givffertility.com/wp-content/uploads/2025/03/Dr.-Comstock-e1743466683661.avif",
        "_source": {
          "url": "https://givffertility.com/about/ioanna-comstock-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-461-ioanna-comstock-md"
      }
    ],
    "website": "https://www.givf.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Anthem"
      ],
      "employeeBenefits": ["Progyny"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Anthem",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-845",
    "externalIds": {
      "cdcClinicId": "845",
      "googlePlaceId": "ChIJ__8_jV27uokRmByeikmtMjY"
    },
    "type": "fertility-clinic",
    "name": "Procreate Fertility Center of Virginia",
    "phone": "(757) 977-8500",
    "address": {
      "line1": "700 Oak Grove Rd",
      "city": "Chesapeake",
      "state": "VA",
      "zip": "23320",
      "country": "US"
    },
    "location": {
      "lat": 36.7352,
      "lng": -76.2384
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 41.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 38.88888888888889,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/18"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "0/5"
        }
      ],
      "cyclesPerYear": 126,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27845%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27845%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.procreatefertility.com",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Procreate+Fertility+Center+of+Virginia,+Chesapeake,+700+Oak+Grove+Rd,+Chesapeake,+VA+23320/@36.7476059,-76.2377001,3197a,13.1y/data=!4m2!3m1!1s0x89babb5d8d3fffff:0x3632ad498a9e1c98",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-845-christian-perez-md",
        "name": "Christian Perez, MD",
        "role": "Medical Director",
        "imageUrl": "https://procreatefertility.com/wp-content/uploads/2021/12/Christian-Perez-370x365.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://procreatefertility.com/our-team/christian-perez/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.procreatefertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Anthem"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Anthem",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-105",
    "externalIds": {
      "cdcClinicId": "105",
      "googlePlaceId": "ChIJTSFkVFRtsYkR57l66v6bYRU"
    },
    "type": "fertility-clinic",
    "name": "Shady Grove Fertility-Richmond",
    "phone": "(804) 379-9000",
    "address": {
      "line1": "9030 Stony Point Pkwy, Suite 450",
      "city": "Richmond",
      "state": "VA",
      "zip": "23235",
      "country": "US"
    },
    "location": {
      "lat": 37.5534,
      "lng": -77.5688
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 60.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 51.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 60.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 33.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 527,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27105%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27105%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/virginia/richmond-stony-point-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Richmond,+9030+Stony+Point+Pkwy+%23450,+Richmond,+VA+23235/@37.5533324,-77.5686766,3163a,13.1y/data=!4m2!3m1!1s0x89b16d545464214d:0x15619bfeea7ab9e7",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-105-erika-b-johnston-macananny-m-d",
        "name": "Erika B. Johnston-MacAnanny, M.D.",
        "role": "Medical Director",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Erika-Johnston-hero.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/johnston-macananny/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Michael Edelstein, M.D.",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Michael-Edelstein-hero-min.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/edelstein/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-105-michael-edelstein-m-d"
      },
      {
        "name": "Anish A. Shah, M.D., MHS",
        "role": "Reproductive Endocrinologist / Practice Director, Southern Virginia",
        "credentials": ["MD", "MHS"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/A.-Shah-website-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/virginia/richmond-stony-point-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-105-anish-a-shah-m-d-mhs"
      },
      {
        "name": "Benjamin S. Harris, M.D., MPH",
        "role": "Reproductive Endocrinologist / Medical Director, Southern Virginia",
        "credentials": ["MD", "MPH"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/09/Benjamin-Harris-profile1.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/virginia/richmond-stony-point-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-105-benjamin-s-harris-m-d-mph"
      },
      {
        "name": "Grace W. Graham, D.O.",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2023/08/G.-Graham-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/virginia/richmond-stony-point-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-105-grace-w-graham-d-o"
      },
      {
        "name": "Ray Tsai, Ph.D.",
        "role": "Laboratory Director, SGF Richmond",
        "credentials": ["PhD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/05/Ray-Tsai-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/virginia/richmond-stony-point-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-105-ray-tsai-ph-d"
      },
      {
        "name": "Hannah Moon, M.M.S., P.A.-C",
        "role": "Physician Assistant",
        "credentials": ["MMS", "PA-C"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/05/Hannah-Moon-PA-C-website-crop.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/virginia/richmond-stony-point-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-105-hannah-moon-m-m-s-p-a-c"
      }
    ],
    "network": {
      "name": "US Fertility"
    },
    "website": "https://www.shadygrovefertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2021/02/Stony_Point.jpg",
        "type": "exterior",
        "caption": "Exterior of the Shady Grove Fertility Richmond - Stony Point office building at 9030 Stony Point Pkwy",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/virginia/richmond-stony-point-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWniWIw46xtK-lZYMhwZpIGiFtLXPROoTeceB6jKoJIZo1sMbdHPtmV5hU8Di8VqkOSv-8XLONlD5g7AL4S_-cNI1zAeAoyKXr9A2YtINttUt1kxMIeEiKdGmlLUn1jDAZNJt-Qv0_6Zn6NC=w440-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Richmond,+9030+Stony+Point+Pkwy+%23450,+Richmond,+VA+23235/@37.5533324,-77.5686766,3163a,13.1y/data=!4m2!3m1!1s0x89b16d545464214d:0x15619bfeea7ab9e7",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-202",
    "externalIds": {
      "cdcClinicId": "202",
      "googlePlaceId": "ChIJsZ7FgKPruokRyRFW4HcBESs"
    },
    "type": "fertility-clinic",
    "name": "CCRM Fertility of Virginia Beach",
    "phone": "(757) 496-5370",
    "address": {
      "line1": "448 Viking Dr, Suite 100",
      "city": "Virginia Beach",
      "state": "VA",
      "zip": "23452",
      "country": "US"
    },
    "location": {
      "lat": 36.8269,
      "lng": -76.0727
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 41.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 26.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 16,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 253,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27202%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27202%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/virginia/virginia-beach/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Virginia+Beach,+Oceana+Place,+448+Viking+Dr+%23100,+Virginia+Beach,+VA+23452/@36.8267939,-76.0728216,3194a,13.1y/data=!4m2!3m1!1s0x89baeba380c59eb1:0x2b110177e05611c9",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "layer2-ccrm-rebrand",
      "date": "2026-06-13",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-202-robin-l-poe-zeigler-md",
        "name": "Robin L. Poe-Zeigler, MD",
        "role": "Medical Director"
      },
      {
        "name": "Lucy X. Chen",
        "role": "Reproductive Endocrinologist & Medical Director",
        "credentials": ["MD"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Lucy_Chen_600x600_2x.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/lucy-x-chen/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-202-lucy-x-chen"
      },
      {
        "name": "Sara Meyer",
        "role": "Women's Health Nurse Practitioner",
        "credentials": ["WHNP-BC"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2026/02/Sara-Meyer-1200x1200.png",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/sara-meyer/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-202-sara-meyer"
      }
    ],
    "website": "https://www.ccrmivf.com/location/us/virginia/virginia-beach/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Anthem"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "CCRM Fertility"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Anthem",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlRxFBV3_yl6XNtCvp1ezRzoGJ5cJiwFVAbtwYGKUNpi9C-lrvUEt_NZ9Jpk6Fe8CVKvHZvHLqsQgOGX0dC9f6BSWKF3VlxrJY60U2C7ot7qLcRz0GjR3zv9mJsoomacmmIE9kLHqQ0O8zF=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Virginia+Beach,+Oceana+Place,+448+Viking+Dr+%23100,+Virginia+Beach,+VA+23452/@36.8267939,-76.0728216,3194a,13.1y/data=!4m2!3m1!1s0x89baeba380c59eb1:0x2b110177e05611c9",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmkij20_EOKS4KyWsf9cFLGbTjmsUIUO11ks6j83vdlwqYQQCyJaS2wVf3pwT1pKYbyqE6XCDbDM9kdJX2YV57go8FJ2bFnXAA7QUeBO22CNNcwlYn4kMITYP3d47yEiFimvuJebpxiehg=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Virginia+Beach,+Oceana+Place,+448+Viking+Dr+%23100,+Virginia+Beach,+VA+23452/@36.8267939,-76.0728216,3194a,13.1y/data=!4m2!3m1!1s0x89baeba380c59eb1:0x2b110177e05611c9",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-428",
    "externalIds": {
      "cdcClinicId": "428",
      "googlePlaceId": "ChIJ6cOaRgdtsYkRaA2l-n_4owQ"
    },
    "type": "fertility-clinic",
    "name": "VCU Reproductive Medicine",
    "phone": "(804) 327-8820",
    "address": {
      "line1": "9109 Stony Point Dr",
      "city": "Richmond",
      "state": "VA",
      "zip": "23235",
      "country": "US"
    },
    "location": {
      "lat": 37.5475,
      "lng": -77.5657
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 36.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 38.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 30.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 40,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/15"
        }
      ],
      "cyclesPerYear": 226,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27428%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27428%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://obgyn.vcu.edu/specialties/division-of-reproductive-endocrinology-and-infertility/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/VCU+Health+Reproductive+Medicine:+Stony+Point+9109,+9109+Stony+Point+Dr+3rd+Floor,+Richmond,+VA+23235/@37.5474882,-77.5657656,3163a,13.1y/data=!4m2!3m1!1s0x89b16d07469ac3e9:0x4a3f87ffaa50d68",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-428-richard-s-lucidi-md",
        "name": "Richard S. Lucidi, MD",
        "role": "Medical Director",
        "imageUrl": "https://go.vcuhealth.org/media/PhysicianPhotos/Lucidi_3391.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://www.vcuhealth.org/find-a-provider/profile/richard-lucidi",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Erika New, MD",
        "role": "Reproductive Endocrinologist (Assistant Professor, Reproductive Endocrinology and Infertility)",
        "credentials": ["MD", "MPH"],
        "imageUrl": "https://go.vcuhealth.org/media/PhysicianPhotos/New_4997.jpg",
        "_source": {
          "url": "https://www.vcuhealth.org/find-a-provider/profile/erika-new",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-428-erika-new-md"
      },
      {
        "name": "Samantha Twyman, CNM",
        "role": "Certified Nurse Midwife (Division of Reproductive Endocrinology and Infertility)",
        "credentials": ["CNM"],
        "imageUrl": "https://obgyn.vcu.edu/media/obgyn/faculty/Twyman.jpg",
        "_source": {
          "url": "https://obgyn.vcu.edu/specialties/division-of-reproductive-endocrinology-and-infertility/samantha-twyman-cnm.html",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-428-samantha-twyman-cnm"
      }
    ],
    "website": "https://www.vcuhealth.org",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Anthem"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Anthem",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-278",
    "externalIds": {
      "cdcClinicId": "278",
      "googlePlaceId": "ChIJ8zgdUM1JtokRdCX9u-2LUzQ"
    },
    "type": "fertility-clinic",
    "name": "Virginia Center for Reproductive Medicine",
    "phone": "(703) 437-7722",
    "address": {
      "line1": "11150 Sunset Hills Rd, Suite 100",
      "city": "Reston",
      "state": "VA",
      "zip": "20190",
      "country": "US"
    },
    "location": {
      "lat": 38.9482,
      "lng": -77.3304
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 66.66666666666666,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/9"
        },
        {
          "ageBand": "35-37",
          "rate": 45.45454545454545,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/11"
        }
      ],
      "cyclesPerYear": 81,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27278%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27278%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.vcrmed.com/about-us/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Virginia+Center+for+Reproductive+Medicine,+11150+Sunset+Hills+Rd+%23100,+Reston,+VA+20190/@38.948157,-77.3304134,3103a,13.1y/data=!4m2!3m1!1s0x89b649cd501d38f3:0x34538bedbbfd2574",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-278-fady-i-sharara-md",
        "name": "Fady I. Sharara, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.vcrmed.com/wp-content/uploads/2022/11/dr-sharara-asrm-2022-cropped-261x300.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.vcrmed.com/about-us/dr-fady-sharara/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Chad A. Johnson, PhD, HCLD",
        "role": "IVF Laboratory Director",
        "credentials": ["PhD", "HCLD"],
        "imageUrl": "https://www.vcrmed.com/wp-content/uploads/2018/11/CAJ-lab-e1543246076368-225x300.jpg",
        "_source": {
          "url": "https://www.vcrmed.com/about-us/chad-a-johnson-phd-hcld/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-278-chad-a-johnson-phd-hcld"
      }
    ],
    "website": "https://www.vcrmed.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Anthem"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://www.vcrmed.com/wp-content/uploads/2013/06/vcrm_reception.gif",
        "type": "interior",
        "caption": "Reception desk at Virginia Center for Reproductive Medicine, Reston VA",
        "_source": {
          "url": "https://www.vcrmed.com/about-us/fertility-facility-tour/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.vcrmed.com/wp-content/uploads/2013/06/vcrm_exam.gif",
        "type": "interior",
        "caption": "Examination room with ultrasound equipment",
        "_source": {
          "url": "https://www.vcrmed.com/about-us/fertility-facility-tour/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.vcrmed.com/wp-content/uploads/2013/06/vcrm_recovery.gif",
        "type": "interior",
        "caption": "Recovery room with beds and privacy curtains",
        "_source": {
          "url": "https://www.vcrmed.com/about-us/fertility-facility-tour/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.vcrmed.com/wp-content/uploads/2013/06/vcrm_phleb-150x131.gif",
        "type": "interior",
        "caption": "Phlebotomy / blood draw station",
        "_source": {
          "url": "https://www.vcrmed.com/about-us/fertility-facility-tour/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.vcrmed.com/wp-content/uploads/2013/06/vcrm_embryology.gif",
        "type": "lab",
        "caption": "Embryology laboratory with incubators and microscope",
        "_source": {
          "url": "https://www.vcrmed.com/about-us/fertility-facility-tour/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.vcrmed.com/wp-content/uploads/2013/06/vcrm_icsi.gif",
        "type": "lab",
        "caption": "ICSI micromanipulation station in the IVF lab",
        "_source": {
          "url": "https://www.vcrmed.com/about-us/fertility-facility-tour/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.vcrmed.com/wp-content/uploads/2013/06/vcrm_andrology.gif",
        "type": "lab",
        "caption": "Andrology / semen analysis laboratory station",
        "_source": {
          "url": "https://www.vcrmed.com/about-us/fertility-facility-tour/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.vcrmed.com/wp-content/uploads/2013/06/vcrm_endo_station.gif",
        "type": "lab",
        "caption": "Endocrinology / hormone assay laboratory station",
        "_source": {
          "url": "https://www.vcrmed.com/about-us/fertility-facility-tour/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.vcrmed.com/wp-content/uploads/2013/06/vcrm_k_hood.gif",
        "type": "lab",
        "caption": "K-hood (laminar flow workstation) in the IVF lab",
        "_source": {
          "url": "https://www.vcrmed.com/about-us/fertility-facility-tour/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Anthem",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-52",
    "externalIds": {
      "cdcClinicId": "52",
      "googlePlaceId": "ChIJacVSpR-Js4kRwgnNbhCLzBo"
    },
    "type": "fertility-clinic",
    "name": "Virginia Fertility & IVF",
    "phone": "(434) 220-6620",
    "address": {
      "line1": "4100 Olympia Cir, Suite 201",
      "city": "Charlottesville",
      "state": "VA",
      "zip": "22911",
      "country": "US"
    },
    "location": {
      "lat": 38.0228,
      "lng": -78.4399
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 58.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 67.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 56.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 346,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2752%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2752%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.vafertility.com/meet-the-team",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Virginia+Fertility+%26+IVF,+4100+Olympia+Cir+Ste+201,+Charlottesville,+VA+22911/@38.033537,-78.444996,3143a,13.1y/data=!4m2!3m1!1s0x89b3891fa552c569:0x1acc8b106ecd09c2",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-52-christopher-d-williams-md",
        "name": "Christopher D. Williams, MD",
        "role": "Medical Director",
        "imageUrl": "https://a.storyblok.com/f/290132/1055x704/59d9b9a695/dr-christopher-d-williams.png",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.vafertility.com/meet-the-team",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Linnea R. Goodman, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://a.storyblok.com/f/290132/1249x1362/4e50ae8dbb/cropped-linnea-goodman-md.png",
        "_source": {
          "url": "https://www.vafertility.com/meet-the-team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-52-linnea-r-goodman-md"
      },
      {
        "name": "Laura P. Smith, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://a.storyblok.com/f/290132/300x300/2424f3891a/laura-smith.png",
        "_source": {
          "url": "https://www.vafertility.com/meet-the-team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-52-laura-p-smith-md"
      }
    ],
    "website": "https://www.vafertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Anthem"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "bookingUrl": "https://www.ivyfertility.com/",
    "description": "Virginia Fertility and IVF fertility clinic in Charlottesville, VA. Part of the Ivy Fertility network.",
    "network": {
      "name": "Ivy Fertility"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Anthem",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlLxMegGrTqug3T6BoYJRP-Oo_wRf58xAcFPZyOIZl1FdT_dSP3UTFuENJSwfSknSWK9O3hLC_Y8DmAYOhKcJoGimtQ5mMnkG0yj-i7yOvvEDevH0mXO79vNqJG9G8i_B3-KAY=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Virginia+Fertility+%26+IVF,+4100+Olympia+Cir+Ste+201,+Charlottesville,+VA+22911/@38.033537,-78.444996,3143a,13.1y/data=!4m2!3m1!1s0x89b3891fa552c569:0x1acc8b106ecd09c2",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-884",
    "externalIds": {
      "cdcClinicId": "884",
      "googlePlaceId": "ChIJS10TKmqYuokR9CKCtGlE84A"
    },
    "type": "fertility-clinic",
    "name": "Virginia Fertility Associates, LLC, SGF Jones Institute",
    "phone": "(757) 937-7955",
    "address": {
      "line1": "601 Colley Ave",
      "city": "Norfolk",
      "state": "VA",
      "zip": "23507",
      "country": "US"
    },
    "location": {
      "lat": 36.8581,
      "lng": -76.2994
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 3,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27884%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27884%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/virginia/norfolk-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+Jones+Institute,+601+Colley+Ave,+Norfolk,+VA+23507/@36.8613035,-76.3006968,3192a,13.1y/data=!4m2!3m1!1s0x89ba986a2a135d4b:0x80f34469b48222f4",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-884-erika-b-johnston-macananny-m-d",
        "name": "Erika B. Johnston-MacAnanny, M.D.",
        "role": "Medical Director",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Erika-Johnston-hero.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/johnston-macananny/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Nicole Banks, M.D.",
        "role": "Reproductive Endocrinologist and Fertility Specialist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/09/Nicole-Banks-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/banks/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-884-nicole-banks-m-d"
      },
      {
        "name": "Benjamin S. Harris, M.D., MPH",
        "role": "Reproductive Endocrinologist; Medical Director, Southern Virginia",
        "credentials": ["MD", "MPH"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/09/Benjamin-Harris-profile1.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/benjamin-harris/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-884-benjamin-s-harris-m-d-mph"
      },
      {
        "name": "Kyle Le, M.D.",
        "role": "Reproductive Endocrinology and Infertility Fellow (EVMS-Jones Institute)",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/12/Le-850-x-850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/le/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-884-kyle-le-m-d"
      },
      {
        "name": "Arielle Yeshua, M.D.",
        "role": "Reproductive Endocrinology and Infertility Fellow (SGF Jones Institute / EVMS)",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/02/Yeshua-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/yeshua/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-884-arielle-yeshua-m-d"
      },
      {
        "name": "Ray Tsai, Ph.D.",
        "role": "IVF Lab Director, SGF Richmond and SGF Jones Institute",
        "credentials": ["PhD", "HCLD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/05/Ray-Tsai-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/tsai/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-884-ray-tsai-ph-d"
      }
    ],
    "website": "https://www.jonesinstituteivf.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Anthem"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "network": {
      "name": "US Fertility"
    },
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2021/04/SGF-Jones-Institute_560x523.jpg",
        "type": "exterior",
        "caption": "Exterior of the SGF Jones Institute (Shady Grove Fertility) at 601 Colley Ave, Norfolk, VA - distinctive curved green-glass medical building on the Eastern Virginia Medical campus",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/virginia/norfolk-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnj3UAUuzCq_xnCC0hffflcdKPVOcArPLZ4r9cV01uFi5fJH1JO0TI99nfohRfGJ3Zg7Yn12m1itQyrSqCfnbCIyOI1aieVTqpj1Mm1LFLs-GeM-s_KMYagAZ2AdWumPH9sbAW5e-H7UoWK=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+Jones+Institute,+601+Colley+Ave,+Norfolk,+VA+23507/@36.8613035,-76.3006968,3192a,13.1y/data=!4m2!3m1!1s0x89ba986a2a135d4b:0x80f34469b48222f4",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWktAn45Ksru7MQlV2JdU12pE5RPWt7BJ20sCyXYYM2dQc-OIebD1Ai0hzWO478JuaF51e4vyFkQKLIQgPn3AgNCJIU3XTa9rpjVxTjOALAm32b8inioMPMgG-0m1qbGu3_0-RvBJBF5fsD2=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+Jones+Institute,+601+Colley+Ave,+Norfolk,+VA+23507/@36.8613035,-76.3006968,3192a,13.1y/data=!4m2!3m1!1s0x89ba986a2a135d4b:0x80f34469b48222f4",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Anthem",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-282",
    "externalIds": {
      "cdcClinicId": "282",
      "googlePlaceId": "ChIJ1W8bKC6zt4kR2KPDf54rJII"
    },
    "type": "fertility-clinic",
    "name": "Washington Fertility Center",
    "phone": "(703) 658-3100",
    "address": {
      "line1": "4316 Evergreen Ln",
      "city": "Annandale",
      "state": "VA",
      "zip": "22003",
      "country": "US"
    },
    "location": {
      "lat": 38.8307,
      "lng": -77.1864
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 40,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 45.45454545454545,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/11"
        }
      ],
      "cyclesPerYear": 78,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27282%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27282%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.washingtonfertility.com/fertility-center/fertility-specialists",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Washington+Fertility+Center,+4316+Evergreen+Ln,+Annandale,+VA+22003/@38.830559,-77.186565,3108a,13.1y/data=!4m2!3m1!1s0x89b7b32e281b6fd5:0x82242b9e7fc3a3d8",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-282-pierre-asmar-md",
        "name": "Pierre Asmar, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.washingtonfertility.com/content/1-fertility-center/1-fertility-specialists/1-dr-pierre-asmar/pierre-asmar.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.washingtonfertility.com/fertility-center/fertility-specialists/dr-pierre-asmar",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Sunita Kulshrestha, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.washingtonfertility.com/content/1-fertility-center/1-fertility-specialists/2-sunita-kulshrestha-md/sunita-kulshrestha-md-1.jpg",
        "_source": {
          "url": "https://www.washingtonfertility.com/fertility-center/fertility-specialists/sunita-kulshrestha-md",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-282-sunita-kulshrestha-md"
      }
    ],
    "website": "https://www.washingtonfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Anthem"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Anthem",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-526",
    "externalIds": {
      "cdcClinicId": "526",
      "googlePlaceId": "ChIJr7rH1YdwykwRQisnNXV-BAQ"
    },
    "type": "fertility-clinic",
    "name": "Northeastern Reproductive Medicine",
    "phone": "(802) 655-8888",
    "address": {
      "line1": "105 W. View Rd, Suite 302",
      "city": "Colchester",
      "state": "VT",
      "zip": "05446",
      "country": "US"
    },
    "location": {
      "lat": 44.5096,
      "lng": -73.1868
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 24.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 22.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 298,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27526%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27526%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://nrmvt.com/our-physicians",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Northeastern+Reproductive+Medicine,+105+W+View+Rd+%23302,+Colchester,+VT+05446/@44.5095006,-73.1868027,2845a,13.1y/data=!4m2!3m1!1s0x4cca7087d5c7baaf:0x4047e7535272b42",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://nrmvt.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-526-jennifer-k-brown-md",
        "name": "Jennifer K. Brown, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://nrmvt.com/client_media/crops/Default.a8194e4f.dr_jennifer_brown_at_northeastern_reproductive_medicine.jpg",
        "_source": {
          "url": "https://nrmvt.com/our-physicians",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-526-cate-boniface-md",
        "name": "Cate Boniface, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://nrmvt.com/client_media/crops/Default.adba69be.cate_boniface.jpg",
        "_source": {
          "url": "https://nrmvt.com/our-physicians",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-526-peter-casson-md",
        "name": "Peter Casson, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://nrmvt.com/client_media/crops/Default.aa625aa9.peter_casson_md.jpeg",
        "_source": {
          "url": "https://nrmvt.com/our-physicians",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-526-christine-murray-md",
        "name": "Christine Murray, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://nrmvt.com/client_media/crops/Default.aed6620b.christine_murray_md.jpeg",
        "_source": {
          "url": "https://nrmvt.com/our-physicians",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://nrmvt.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://nrmvt.com/client_media/crops/Default.78b5e89c.northeastern_reproductive_medicine_outside_of_building.jpg",
        "type": "exterior",
        "caption": "Northeastern Reproductive Medicine building exterior.",
        "_source": {
          "url": "https://nrmvt.com/our-facilities",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://nrmvt.com/client_media/crops/Default.a79ffb5f.northeastern_reproductive_medicine_lobby_1.jpg",
        "type": "interior",
        "caption": "Northeastern Reproductive Medicine lobby.",
        "_source": {
          "url": "https://nrmvt.com/our-facilities",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Vermont (VT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-613",
    "externalIds": {
      "cdcClinicId": "613",
      "googlePlaceId": "ChIJo-n5MEN6ykwRXbwiUo9wn1c"
    },
    "type": "fertility-clinic",
    "name": "University of Vermont Medical Center, Vermont Center for Reproductive Medicine",
    "phone": "(802) 847-1248",
    "address": {
      "line1": "111 Colchester Ave, Main Campus, Main Pavilion, Level 4",
      "city": "Burlington",
      "state": "VT",
      "zip": "05401",
      "country": "US"
    },
    "location": {
      "lat": 44.4797,
      "lng": -73.1941
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 32.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 35,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 82,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27613%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27613%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.uvmhealth.org/gme/fellowships/reproductive-endocrinology-and-infertility/our-clinical-faculty",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Reproductive+Health+and+Infertility+Center,+University+of+Vermont+Medical+Center,+Main+Campus,+Main+Pavilion,+111+Colchester+Ave+Level+4,+Burlington,+VT+05401/@44.479695,-73.1941277,2847a,13.1y/data=!4m2!3m1!1s0x4cca7a4330f9e9a3:0x579f708f5222bc5d",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.uvmhealth.org/conditions-specialties/reproductive-endocrinology-infertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-613-elizabeth-mcgee-md",
        "name": "Elizabeth McGee, MD",
        "role": "Director of Reproductive Endocrinology and Infertility",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.uvmhealth.org/sites/default/files/migrated-page-files/assets/2024-01/elizabeth-mcgee-uvmmc-trustee.jpg",
        "_source": {
          "url": "https://www.uvmhealth.org/board-member/elizabeth-lisa-mcgee-md",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-613-amanda-kallen-md",
        "name": "Amanda Kallen, MD",
        "role": "Division Chief and Program Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://d2ubrtwy6ww54e.cloudfront.net/www.uvmhealth.org/assets/styles/portrait/s3/2026-04/amanda-kallen-md.png?VersionId=ygb8pPCFLzx04q9BDRxIIdKzEvkKxtvG&h=ca0958c8&itok=us9IeetH",
        "_source": {
          "url": "https://www.uvmhealth.org/gme/fellowships/reproductive-endocrinology-and-infertility/our-clinical-faculty",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-613-erica-bove-md",
        "name": "Erica Bove, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://d2ubrtwy6ww54e.cloudfront.net/www.uvmhealth.org/assets/styles/portrait/s3/2026-04/erica-bove-md.jpg?VersionId=5lRhF2.MAKzoj0mfzAu.qOC8KXGLPnxs&h=ca0958c8&itok=96v5MA89",
        "_source": {
          "url": "https://www.uvmhealth.org/gme/fellowships/reproductive-endocrinology-and-infertility/our-clinical-faculty",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-613-jennifer-dundee-md",
        "name": "Jennifer Dundee, MD",
        "role": "Medical Director of REI and Clinical Director of IVF",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://d2ubrtwy6ww54e.cloudfront.net/www.uvmhealth.org/assets/styles/portrait/s3/2026-03/jennifer-dundee-md.jpg?VersionId=6jaGCYhfbN5cu5_O6pe6VA_Zd9Nz4lDh&h=99e0c21c&itok=ehhOAqRz",
        "_source": {
          "url": "https://www.uvmhealth.org/gme/fellowships/reproductive-endocrinology-and-infertility/our-clinical-faculty",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-613-julia-johnson-md",
        "name": "Julia Johnson, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://d2ubrtwy6ww54e.cloudfront.net/www.uvmhealth.org/assets/styles/portrait/s3/2026-03/julie-johnson-md.jpg?VersionId=7ssX6WEJM6_LdDlc9IE27Z1suYVWquUi&h=d0dd59e8&itok=rsupqlpT",
        "_source": {
          "url": "https://www.uvmhealth.org/gme/fellowships/reproductive-endocrinology-and-infertility/our-clinical-faculty",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.uvmhealth.org/conditions-specialties/reproductive-endocrinology-infertility",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "images": [
      {
        "url": "https://www.uvmhealth.org/sites/default/files/2025-04/20250326-UVMMC-Repro8.jpg",
        "type": "lab",
        "caption": "UVM reproductive endocrinology laboratory.",
        "_source": {
          "url": "https://www.uvmhealth.org/conditions-specialties/reproductive-endocrinology-infertility",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnCurdJhtFyJ0dN0F0qkreHGpPyDrgZ81IoofIcYncDwG2lsp1fIl8V0YmrZNe65h1mzm7oDnePYn9zaNxNIM5RewKyHupQBnZAhhwD3YgqnMQHsSyRVEAtAJLrhnA-B5pJnmh4h6UIjQ7T=w298-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Reproductive+Health+and+Infertility+Center,+University+of+Vermont+Medical+Center,+Main+Campus,+Main+Pavilion,+111+Colchester+Ave+Level+4,+Burlington,+VT+05401/@44.479695,-73.1941277,2847a,13.1y/data=!4m2!3m1!1s0x4cca7a4330f9e9a3:0x579f708f5222bc5d",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Vermont (VT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-371",
    "externalIds": {
      "cdcClinicId": "371",
      "googlePlaceId": "ChIJOa4RyGQYnlQRen_zhnwPKs0"
    },
    "type": "fertility-clinic",
    "name": "Center for Reproductive Health",
    "phone": "(509) 462-7070",
    "address": {
      "line1": "201 W. North River Dr, Suite 100",
      "city": "Spokane",
      "state": "WA",
      "zip": "99201",
      "country": "US"
    },
    "location": {
      "lat": 47.6635,
      "lng": -117.414
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 50.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 43.75,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "7/16"
        },
        {
          "ageBand": "38-40",
          "rate": 83.33333333333334,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/6"
        }
      ],
      "cyclesPerYear": 151,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27371%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27371%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://fertilitydoctor.net/about-us/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Center+For+Reproductive+Health,+201+W+North+River+Dr+%23100,+Spokane,+WA+99201/@47.6634717,-117.4136438,2687a,13.1y/data=!4m2!3m1!1s0x549e1864c811ae39:0xcd2a0f7c86f37f7a",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-371-edwin-robins-md",
        "name": "Edwin Robins, MD",
        "role": "Medical Director",
        "imageUrl": "https://fertilitydoctor.net/wp-content/uploads/2025/02/Edwin-Robins-MD.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://fertilitydoctor.net/about-us/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Gabriela Byrne, ARNP",
        "role": "Women's Health Provider",
        "credentials": ["ARNP"],
        "imageUrl": "https://fertilitydoctor.net/wp-content/uploads/2025/02/Gabriela-Byrne-ARNP.jpg",
        "_source": {
          "url": "https://fertilitydoctor.net/about-us/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-371-gabriela-byrne-arnp"
      },
      {
        "name": "James R. Broussard, PhD",
        "role": "Director of Embryology and Andrology",
        "credentials": ["PhD", "HCLD"],
        "imageUrl": "https://fertilitydoctor.net/wp-content/uploads/2025/02/James-R.-Broussard-Ph.D.jpg",
        "_source": {
          "url": "https://fertilitydoctor.net/about-us/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-371-james-r-broussard-phd"
      },
      {
        "name": "Nathan Cope, MS",
        "role": "Embryologist & Practice Administrator",
        "credentials": ["MS", "TS"],
        "imageUrl": "https://fertilitydoctor.net/wp-content/uploads/2025/02/Nathan-Cope.jpg",
        "_source": {
          "url": "https://fertilitydoctor.net/about-us/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-371-nathan-cope-ms"
      }
    ],
    "website": "https://www.spokaneivf.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Premera",
        "Regence"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Premera, Regence",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Washington (WA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkukxU9pAhcW4WbGDTaiZVk0iTn6tbegPB5qkKwjt7XvgTzWvspmVJuMJyQg0dZ-9485bWbS6FfSTE-rgqiGq_gH4uYZCFoEjWLUx2ElEEcggRxBE4K7QMctMx0UgmdMgdssC0gAAObIP4x=w408-h544-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Center+For+Reproductive+Health,+201+W+North+River+Dr+%23100,+Spokane,+WA+99201/@47.6634717,-117.4136438,2687a,13.1y/data=!4m2!3m1!1s0x549e1864c811ae39:0xcd2a0f7c86f37f7a",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnKk-O9bN4W-73zgZC06OpA4xrOIqBPfi5IbZRKOpOQ4RXbbp_899MW2HhZQ6qeT_7-Nq6HA-HTo-YVJuLH9rhvkVqeG4oJC5bbZOYlSmjcIWlzQfDty40PTQ7-y-IDxKK-uCQ-SPs0L98=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Center+For+Reproductive+Health,+201+W+North+River+Dr+%23100,+Spokane,+WA+99201/@47.6634717,-117.4136438,2687a,13.1y/data=!4m2!3m1!1s0x549e1864c811ae39:0xcd2a0f7c86f37f7a",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-893",
    "externalIds": {
      "cdcClinicId": "893",
      "googlePlaceId": "ChIJlV9U_ZmtlVQREMyVJWcG5YQ"
    },
    "type": "fertility-clinic",
    "name": "Kindbody - Vancouver (Pacific Northwest)",
    "phone": "(360) 535-7590",
    "address": {
      "line1": "2501 NE 134th St, Ste 100",
      "city": "Vancouver",
      "state": "WA",
      "zip": "98686",
      "country": "US"
    },
    "location": {
      "lat": 45.7195,
      "lng": -122.6427
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27893%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27893%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.kindbody.com/ivf-cost/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/team/haley-a-riggs-gilman-msn-aprn-fnp-c/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+Portland,+2501+NE+134th+St+%23100,+Vancouver,+WA+98686/@45.716428,-122.6456837,2786a,13.1y/data=!4m2!3m1!1s0x5495ad99fd545f95:0x84e506672595cc10",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-893-angie-beltsos-md",
        "name": "Angie Beltsos, MD",
        "role": "Medical Director",
        "imageUrl": "https://mrsimeeting.org/wp-content/uploads/2025/09/Angeline-Beltsos.png",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://mrsimeeting.org/about-us/our-board-of-directors/angeline-beltsos-md/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Haley A. Riggs-Gilman",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "APRN", "FNP-C"],
        "imageUrl": "https://kindbody.com/wp-content/uploads/2024/10/image-24.png",
        "_source": {
          "url": "https://kindbody.com/team/haley-a-riggs-gilman-msn-aprn-fnp-c/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-893-haley-a-riggs-gilman"
      }
    ],
    "network": {
      "name": "Kindbody"
    },
    "website": "https://www.kindbody.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Anthem",
        "Blue Cross Blue Shield",
        "Cigna",
        "Emblem Health",
        "Empire Blue Cross Blue Shield",
        "First Health",
        "Health Net",
        "Horizon",
        "Humana",
        "Maven",
        "Medicare",
        "Medicaid",
        "MultiPlan",
        "Optum",
        "Oscar",
        "Oxford",
        "Progyny",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven"],
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "pricing": {
      "packages": [
        {
          "name": "Pulse Assessment",
          "description": "Quick fertility check — not covered by insurance",
          "price": 9900,
          "currency": "USD",
          "includes": [
            "AMH blood test",
            "Transvaginal ultrasound for follicle count",
            "15-minute reproductive consultation"
          ],
          "notes": "Not covered by insurance"
        },
        {
          "name": "Fertility Consultation",
          "description": "Specialist consultation on fertility fundamentals",
          "price": 30000,
          "currency": "USD",
          "notes": "Billable to most insurance plans"
        },
        {
          "name": "Male Consultation + Semen Analysis",
          "price": 52500,
          "currency": "USD",
          "includes": ["Consultation", "Venipuncture", "Semen analysis"]
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Single egg freezing cycle",
          "price": 690000,
          "priceMax": 966000,
          "currency": "USD",
          "includes": [
            "Stimulation visits",
            "Ultrasounds",
            "Blood draws",
            "Retrieval",
            "Cryopreservation",
            "3 months storage",
            "Coordination"
          ],
          "excludes": ["Medications ($4,000 - $6,000)", "Anesthesia"]
        },
        {
          "name": "Annual Egg Storage",
          "price": 92000,
          "currency": "USD",
          "notes": "Per year"
        },
        {
          "name": "IVF Freeze All (Self Pay)",
          "description": "IVF cycle with all embryos frozen",
          "price": 1160000,
          "priceMax": 1850000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Cryopreservation",
            "3 months storage"
          ],
          "excludes": [
            "Medications (~$4,000 - $6,000)",
            "Embryo biopsy/genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Donor services",
            "Anesthesia"
          ]
        },
        {
          "name": "IVF Fresh Transfer (Self Pay)",
          "description": "IVF cycle with fresh embryo transfer",
          "price": 1380000,
          "priceMax": 1875000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$5,000 - $9,000)",
            "Genetic testing",
            "Surplus embryo storage",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Freeze All",
          "price": 910000,
          "priceMax": 1332000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Cryopreservation",
            "3-month storage"
          ],
          "excludes": [
            "Genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Fresh Transfer",
          "price": 990000,
          "priceMax": 1428000,
          "currency": "USD",
          "includes": [
            "Ultrasounds",
            "Thaw",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Surplus storage",
            "Frozen transfers",
            "Anesthesia"
          ]
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 400000,
          "priceMax": 550000,
          "currency": "USD",
          "includes": ["Ultrasounds", "Thaw", "Assisted hatching", "Transfer"],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "PGT Package",
          "description": "Preimplantation genetic testing",
          "price": 160000,
          "priceMax": 300000,
          "currency": "USD",
          "includes": ["Embryo biopsy", "Lab management"],
          "excludes": ["Storage", "Shipping", "Per-embryo testing costs"]
        },
        {
          "name": "Nutrition Coaching",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Counseling & Support",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Guided Meditation",
          "description": "Virtual wellness — 30-minute session",
          "price": 9000,
          "currency": "USD"
        }
      ],
      "financingOptions": [
        {
          "name": "PatientFi monthly payments",
          "description": "PatientFi monthly payments"
        }
      ],
      "disclaimer": "Prices vary by location. Medications and anesthesia are not included in procedure costs. 3 months of storage included with freeze procedures; annual storage is $920.",
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Blue Cross Blue Shield, Cigna, Emblem Health, Empire Blue Cross Blue Shield, First Health, Health Net",
              "detail": "12 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "14 public price package(s) and 1 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Washington (WA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkLMuc6CWQVucdB2SfGzEIyda8NMSMrIxAQQoDToRqgwcdqba9k5Sv8w-D9T8ZpqHOu3JU-kcDYXalU5SSqkfDfOCsFcnyRJrwz14vEFJxCGC-Oca6LO7IeZxCraoBZaJDrTi6VAg=w408-h725-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Portland,+2501+NE+134th+St+%23100,+Vancouver,+WA+98686/@45.716428,-122.6456837,2786a,13.1y/data=!4m2!3m1!1s0x5495ad99fd545f95:0x84e506672595cc10",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkg7vSaKyZmhsbS1lWmgPaVdkU3CiV0tUxcMtpWOuhb1kmZqnMbhXg4odM2D2nTEGdyeEWyWJ-R2KifnHzqTY6WK_N27hw5ESGsGsNEKc3RH93cSTICp-aOxLY80a7Kpww6MDBq=w224-h398-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Portland,+2501+NE+134th+St+%23100,+Vancouver,+WA+98686/@45.716428,-122.6456837,2786a,13.1y/data=!4m2!3m1!1s0x5495ad99fd545f95:0x84e506672595cc10",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-718",
    "externalIds": {
      "cdcClinicId": "718"
    },
    "type": "fertility-clinic",
    "name": "Madigan Army Medical Center",
    "phone": "(253) 968-3783",
    "address": {
      "line1": "Department of Obstetrics and Gynecology, 9040A Jackson Ave",
      "city": "Tacoma",
      "state": "WA",
      "zip": "98431",
      "country": "US"
    },
    "location": {
      "lat": 47.1098,
      "lng": -122.552
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 55.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "0/11"
        }
      ],
      "cyclesPerYear": 58,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27718%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27718%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-718-bruce-d-pier-md",
        "name": "Bruce D. Pier, MD",
        "role": "Medical Director"
      }
    ],
    "website": "https://www.mamc.health.mil",
    "insurance": {
      "accepted": true,
      "carriers": ["Tricare"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://upload.wikimedia.org/wikipedia/commons/9/9d/MAMC_in_the_fall.jpg",
        "type": "exterior",
        "caption": "Madigan Army Medical Center main hospital tower and reflecting pond on Joint Base Lewis-McChord, Tacoma, WA (official Madigan Public Affairs Office photo, public domain U.S. Army work).",
        "_source": {
          "url": "https://commons.wikimedia.org/wiki/File:MAMC_in_the_fall.jpg",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Tricare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Washington (WA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-415",
    "externalIds": {
      "cdcClinicId": "415"
    },
    "type": "fertility-clinic",
    "name": "Olympia Women's Health, Olympia Fertility",
    "phone": "(360) 786-1515",
    "address": {
      "line1": "403 Black Hills Ln S.W., Suite E",
      "city": "Olympia",
      "state": "WA",
      "zip": "98502",
      "country": "US"
    },
    "location": {
      "lat": 47.0468,
      "lng": -122.95
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 60.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 56.25,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "9/16"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "0/6"
        }
      ],
      "cyclesPerYear": 60,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27415%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27415%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.olympiafertility.com",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-415-james-f-moruzzi-md-phd",
        "name": "James F. Moruzzi, MD, PHD",
        "role": "Medical Director",
        "imageUrl": "https://cdn.providence.org/asset/9qxoDgVb56L7qc88O8EwTQ11368669342/providermatch/phs/photos/orig/moruzzi-james-1841288396/jpg",
        "credentials": ["MD", "PhD"],
        "_source": {
          "url": "https://www.providence.org/doctors/obstetrics-and-gynecology/wa/olympia/james-moruzzi-1841288396",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "website": "https://www.olympiafertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Premera",
        "Regence"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Premera, Regence",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Washington (WA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-826",
    "externalIds": {
      "cdcClinicId": "826",
      "googlePlaceId": "ChIJxWzRffNskFQRjtkEywTK374"
    },
    "type": "fertility-clinic",
    "name": "ORM Fertility Bellevue",
    "phone": "(425) 458-2622",
    "address": {
      "line1": "1370 116th Ave N.E., Suite 100",
      "city": "Bellevue",
      "state": "WA",
      "zip": "98004",
      "country": "US"
    },
    "location": {
      "lat": 47.6219,
      "lng": -122.184
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 39.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 46.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 90,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27826%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27826%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/bellevue-wa/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/ORM+Fertility+-+Bellevue,+1370+116th+Ave+NE+%23100,+Bellevue,+WA+98004/@47.6219281,-122.1835821,2689a,13.1y/data=!4m2!3m1!1s0x54906cf37dd16cc5:0xbedfca04cb04d98e",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-826-elizabeth-a-barbieri-md",
        "name": "Elizabeth A. Barbieri, MD",
        "role": "Medical Director"
      },
      {
        "name": "Amy R. Criniti, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Amy-Criniti_WA_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-amy-criniti/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-826-amy-r-criniti-md"
      },
      {
        "name": "Paul C. Lin, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Paul-Lin_WA_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-paul-c-lin/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-826-paul-c-lin-md"
      },
      {
        "name": "Amanda K. Hurliman, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Amanda-Hurliman_WA_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-amanda-k-hurliman/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-826-amanda-k-hurliman-md"
      },
      {
        "name": "Teagen Tibbot, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/02/Teagan-Tibbot-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/teagen-tibbot-pa-c/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-826-teagen-tibbot-pa-c"
      }
    ],
    "website": "https://www.ormfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Premera",
        "Regence"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/Bellevue-Front-Desk-scaled.jpg",
        "type": "interior",
        "caption": "Front desk / reception area of the Bellevue clinic, with the Seattle Reproductive Medicine (SRM) logo on the wall",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/bellevue-wa/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/Bellevue-Main-Wait-Area.jpg",
        "type": "interior",
        "caption": "Main waiting area of the Bellevue clinic",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/bellevue-wa/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/Bellevue-Second-Wait-Area-scaled.jpg",
        "type": "interior",
        "caption": "Second waiting area of the Bellevue clinic",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/bellevue-wa/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlif-dslX7C_eSKuzCsrVHckmc2vJ-KgOMVXaBh13jD03RbdeaY_4cRRREUcglGYtti83BSLc0SYjunt9J2HY3hehGVRzDV2NwSnGUpRr4T9aL5wOmW4nkvuUJ8bcuWkuslRvfz=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/ORM+Fertility+-+Bellevue,+1370+116th+Ave+NE+%23100,+Bellevue,+WA+98004/@47.6219281,-122.1835821,2689a,13.1y/data=!4m2!3m1!1s0x54906cf37dd16cc5:0xbedfca04cb04d98e",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnaNmZsd_f-Om3CToS07YWwwkEKyyyZpTvCjnNtGlE-632G1wNr9TWW6MY4fvw0nOn8dGIoAzrR-qKUiUlDmatHLhTUz0Taq4DPNqg6fJ8ivqMD0m1XEt-KSrImlYVMGpJ7uTsZEA=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/ORM+Fertility+-+Bellevue,+1370+116th+Ave+NE+%23100,+Bellevue,+WA+98004/@47.6219281,-122.1835821,2689a,13.1y/data=!4m2!3m1!1s0x54906cf37dd16cc5:0xbedfca04cb04d98e",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Premera, Regence",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Washington (WA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-96",
    "externalIds": {
      "cdcClinicId": "96"
    },
    "type": "fertility-clinic",
    "name": "Overlake Reproductive Health, Inc., PS",
    "phone": "(425) 646-4700",
    "address": {
      "line1": "11232 N.E. 15th St, Suite 201",
      "city": "Bellevue",
      "state": "WA",
      "zip": "98004",
      "country": "US"
    },
    "location": {
      "lat": 47.6245,
      "lng": -122.189
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 41.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 59.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/12"
        }
      ],
      "cyclesPerYear": 273,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2796%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2796%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/washington/seattle/fertility-doctors/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-96-kevin-m-johnson-md",
        "name": "Kevin M. Johnson, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Kevin_Johnson_600x600_2x-1.jpg",
        "credentials": ["MD"],
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/kevin-johnson/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "James Nodler, MD",
        "role": "Medical Director / Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2026/02/Dr-Nodler.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/james-nodler/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-96-james-nodler-md"
      },
      {
        "name": "Lindsay Canning, DNP, CNM, ARNP",
        "role": "Nurse Practitioner",
        "credentials": ["DNP", "CNM", "ARNP"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2026/02/Lindsay-Canning-1200x1200.png",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/lindsay-canning/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-96-lindsay-canning-dnp-cnm-arnp"
      },
      {
        "name": "Jo Gray, BSN, ARNP",
        "role": "Advanced Practice Registered Nurse Practitioner",
        "credentials": ["BSN", "ARNP"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/10/Josephine-Gray_600x600_2x.png",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/jo-gray/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-96-jo-gray-bsn-arnp"
      },
      {
        "name": "Julie Mattison, WHCNP, MSN",
        "role": "Women's Health Nurse Practitioner",
        "credentials": ["WHCNP", "MSN"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/10/Julie-Mattison_600x600_2x.png",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/julie-mattison/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-96-julie-mattison-whcnp-msn"
      },
      {
        "name": "Jami Taylor, MSN, APRN, FNP-C",
        "role": "Nurse Practitioner / Advanced Practice Provider",
        "credentials": ["MSN", "APRN", "FNP-C"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/10/Jami-Taylor_600x600_2x.png",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/jami-taylor/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-96-jami-taylor-msn-aprn-fnp-c"
      }
    ],
    "website": "https://www.overlakereproductive.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Premera",
        "Regence"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Premera, Regence",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Washington (WA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-128",
    "externalIds": {
      "cdcClinicId": "128",
      "googlePlaceId": "ChIJZTs13clqkFQRBX8YdWqa7Z8"
    },
    "type": "fertility-clinic",
    "name": "Pacific Northwest Fertility and IVF Specialists",
    "phone": "(206) 515-0000",
    "address": {
      "line1": "1101 Madison St, Suite 1050",
      "city": "Seattle",
      "state": "WA",
      "zip": "98104",
      "country": "US"
    },
    "location": {
      "lat": 47.6092,
      "lng": -122.324
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 58.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 59.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 58.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 53.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 646,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27128%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27128%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pnwfertility.com/meet-the-team",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Pacific+NW+Fertility+-+Seattle,+1101+Madison+St+%231050,+Seattle,+WA+98104/@47.6093764,-122.3246188,2690a,13.1y/data=!4m2!3m1!1s0x54906ac9dd353b65:0x9fed9a6a75187f05",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-128-julie-lamb",
        "name": "Julie Lamb",
        "role": "Medical Director",
        "imageUrl": "https://a.storyblok.com/f/290132/1600x2000/c5d6caa0d4/julie-lamb.png/m/0x2000/filters:no_upscale()",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.pnwfertility.com/doctors/julie-lamb-md-facog",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Lora Shahine",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://a.storyblok.com/f/290132/1600x2000/ea1012b29b/lora-shahine.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://www.pnwfertility.com/doctors/lora-shahine-md-facog",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-128-lora-shahine"
      },
      {
        "name": "Darcy Broughton",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://a.storyblok.com/f/290132/1600x2000/9d0073819e/darcy-broughton.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://www.pnwfertility.com/doctors/darcy-broughton-md-facog",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-128-darcy-broughton"
      },
      {
        "name": "Stephanie Rothenberg",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://a.storyblok.com/f/290132/1600x2000/f479bdbf10/stephanie-rothenberg.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://www.pnwfertility.com/doctors/stephanie-rothenberg-md-facog",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-128-stephanie-rothenberg"
      },
      {
        "name": "Diana Zhou",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://a.storyblok.com/f/290132/1600x2000/b5709cc4f1/diana-zhou.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://www.pnwfertility.com/doctors/diana-zhou-md-facog",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-128-diana-zhou"
      },
      {
        "name": "Jamie Massie",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://a.storyblok.com/f/290132/1600x2000/89c7ed5773/jamie-massie.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://www.pnwfertility.com/doctors/jamie-massie-md-facog",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-128-jamie-massie"
      },
      {
        "name": "Hanh Nguyen Cottrell",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://a.storyblok.com/f/290132/1600x2000/fc33f19e96/hanh-cottrell.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://www.pnwfertility.com/doctors/hanh-nguyen-cottrell-md-facog",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-128-hanh-nguyen-cottrell"
      },
      {
        "name": "Shannel Adams",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://a.storyblok.com/f/290132/1600x2000/f7e4e19b5c/shannel-adams.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://www.pnwfertility.com/doctors/shannel-adams-md-facog",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-128-shannel-adams"
      },
      {
        "name": "Shelun Tsai",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://a.storyblok.com/f/290132/1600x2000/44dbb30537/shelun-tsai.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://www.pnwfertility.com/doctors/shelun-tsai-md-facog",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-128-shelun-tsai"
      },
      {
        "name": "Lauren Verrilli",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/4476x3620/dc154e6edf/lauren-verrilli_003_hp_march-15-2022.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://www.pnwfertility.com/doctors/lauren-verrilli-md",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-128-lauren-verrilli"
      }
    ],
    "website": "https://www.pnwfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Premera",
        "Regence"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Premera, Regence",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Washington (WA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnDn5DCynJXkeZcFENSsBxCdiHJDaJ9M3SMW8vFJxrqP9FGJFoHJgM7oaEmsv_u2CZurCiQRMfktJp5CY6WP-7ke-5EVnDeMM1xDKIw5RZ1S8OGAuf_4nKVPD-mm7pyeGdXpqyHgxh3lzke=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Pacific+NW+Fertility+-+Seattle,+1101+Madison+St+%231050,+Seattle,+WA+98104/@47.6093764,-122.3246188,2690a,13.1y/data=!4m2!3m1!1s0x54906ac9dd353b65:0x9fed9a6a75187f05",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-cdc-457",
    "externalIds": {
      "cdcClinicId": "457",
      "googlePlaceId": "ChIJL0cwqYUNkFQRAWnNnnHBYXo"
    },
    "type": "fertility-clinic",
    "name": "Poma Fertility",
    "phone": "(425) 822-7662",
    "address": {
      "line1": "12039 N.E. 128th St, Suite 110",
      "city": "Kirkland",
      "state": "WA",
      "zip": "98034",
      "country": "US"
    },
    "location": {
      "lat": 47.7145,
      "lng": -122.179
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 54.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 44.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 44.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 37.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 408,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27457%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27457%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pomafertility.com/our-team",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/POMA+Fertility,+12039+NE+128th+St+Ste+110,+Kirkland,+WA+98034/@47.7144649,-122.1794818,2684a,13.1y/data=!4m2!3m1!1s0x54900d85a930472f:0x7a61c1719ecd6901",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-457-ronald-beesley-md",
        "name": "Ronald Beesley, MD",
        "role": "Medical Director",
        "imageUrl": "https://cdn.prod.website-files.com/6408c7175280297ba7c2e0a5/6424001dc7720b1690c84d9b_Ronald%20Beesley-large.webp",
        "credentials": ["MD"],
        "_source": {
          "url": "https://www.pomafertility.com/team-members/dr-ronald-beesley-md",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Michael Opsahl",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.prod.website-files.com/6408c7175280297ba7c2e0a5/6424002bc7720b3324c84dd2_OPSAHL-large.webp",
        "_source": {
          "url": "https://www.pomafertility.com/team-members/dr-michael-opsahl-md",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-457-michael-opsahl"
      },
      {
        "name": "Audrey Messelt",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.prod.website-files.com/6408c7175280297ba7c2e0a5/68f5d43622f4adba68c9be52_Audrey%20Messelt.webp",
        "_source": {
          "url": "https://www.pomafertility.com/team-members/audrey-messelt-md",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-457-audrey-messelt"
      },
      {
        "name": "Anne Judge",
        "role": "Nurse Practitioner",
        "credentials": ["DNP", "WHNP-BC", "ARNP"],
        "imageUrl": "https://cdn.prod.website-files.com/6408c7175280297ba7c2e0a5/686e11ab160f761a66ad6a97_Anne%20Judge%20DNP%20WHNP-BC%20ARNP_POMA%20Fertility_Kirkland%20WA_Nurse%20Practitioner-removebg-preview.jpg",
        "_source": {
          "url": "https://www.pomafertility.com/team-members/anne-judge-dnp-whnp-bc-arnp",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-457-anne-judge"
      },
      {
        "name": "Megan Palazzola",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://cdn.prod.website-files.com/6408c7175280297ba7c2e0a5/642400053901ac692668edec_Megan%20Palazzola-large.webp",
        "_source": {
          "url": "https://www.pomafertility.com/team-members/megan-palazzola-pac",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-457-megan-palazzola"
      },
      {
        "name": "Carol Lynn Curchoe",
        "role": "Laboratory Director",
        "credentials": ["PhD", "HCLD (ABB)"],
        "imageUrl": "https://cdn.prod.website-files.com/6408c7175280297ba7c2e0a5/6880c750856775e245502066_Dr_Carol_Lynn_Curchoe_PhD_HCLD_POMA_Fertility_Kirkland_WA_Laboratory_Director-removebg-preview.png",
        "_source": {
          "url": "https://www.pomafertility.com/team-members/dr-carol-lynn-curchoe-phd-hcld-abb",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-457-carol-lynn-curchoe"
      }
    ],
    "website": "https://www.pomafertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Premera",
        "Regence"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://cdn.prod.website-files.com/64022a7562265580b9f04c73/641d5c452b0f05b1735e63ba_about-us-carousel_01.webp",
        "type": "interior",
        "caption": "Poma Fertility Kirkland reception area",
        "_source": {
          "url": "https://www.pomafertility.com/about-us",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://cdn.prod.website-files.com/64022a7562265580b9f04c73/641d5c454862799057196a71_about-us-carousel_02.webp",
        "type": "interior",
        "caption": "Poma Fertility Kirkland waiting area",
        "_source": {
          "url": "https://www.pomafertility.com/about-us",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://cdn.prod.website-files.com/64022a7562265580b9f04c73/641d5c45f46b497846fff1f0_about-us-carousel_03.webp",
        "type": "interior",
        "caption": "Poma Fertility Kirkland office interior",
        "_source": {
          "url": "https://www.pomafertility.com/about-us",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkgbgkjmIFg6U_hjEfHsadVUk9jpOYIIilS8XkZSuPH3IuLt586Bi95VQNkR0kIQ9mkTMKbpDEfRXNwQori8iXEATg0afg8Hk2MkfVOirj4cg1mfY8OiaHAFSXtoAb0cOA4AfhL8A=w637-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/POMA+Fertility,+12039+NE+128th+St+Ste+110,+Kirkland,+WA+98034/@47.7144649,-122.1794818,2684a,13.1y/data=!4m2!3m1!1s0x54900d85a930472f:0x7a61c1719ecd6901",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmMfTONPDg93nim2cmyO0FVi5WiflP8IvXvTsSu1XMYfTYmEhZlpAklVH1usBUdZWMA9Y6wEhRTQVnHpzlODDG6WjnEhm6h6n_navN2_vQ0CmW6b7f6taJ_mtnMwO_IS5FZE3bo=w224-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/POMA+Fertility,+12039+NE+128th+St+Ste+110,+Kirkland,+WA+98034/@47.7144649,-122.1794818,2684a,13.1y/data=!4m2!3m1!1s0x54900d85a930472f:0x7a61c1719ecd6901",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Premera, Regence",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Washington (WA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-50",
    "externalIds": {
      "cdcClinicId": "50"
    },
    "type": "fertility-clinic",
    "name": "Seattle Reproductive Medicine",
    "description": "Seattle's established fertility practice since 2004, now part of Pinnacle Fertility, offering comprehensive IVF, genetic testing, LGBTQ+ family-building, and oncofertility services.",
    "website": "https://www.seattlefertility.com/",
    "phone": "(206) 301-5000",
    "email": "srminfo@seattlefertility.com",
    "bookingUrl": "https://www.seattlefertility.com/contact-us/",
    "address": {
      "line1": "1505 Westlake Ave North, Suite 400",
      "city": "Seattle",
      "state": "WA",
      "zip": "98109",
      "country": "US"
    },
    "location": {
      "lat": 47.6326,
      "lng": -122.341
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "financingOptions": [
        "Payment plans",
        "Loans",
        "Package pricing",
        "CapexMD",
        "Future Family",
        "PatientFi",
        "Gaia"
      ]
    },
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 51.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 52.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 50.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 32.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 1934,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2750%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "consultationTypes": ["in-person", "telehealth"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%2750%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "scraped"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/seattle-wa/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "scraped"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-50-paul-c-lin-md",
        "name": "Paul C. Lin, MD",
        "role": "Medical Director",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Paul-Lin_WA_Square-1024x1024.png",
        "credentials": ["MD"],
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/seattle-wa/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Nancy A. Klein",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Nancy-Klein_WA_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/seattle-wa/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-50-nancy-a-klein"
      },
      {
        "name": "Anna Vanderhoff",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/03/Dr.-Anna-Vanderhoff_WA-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/seattle-wa/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-50-anna-vanderhoff"
      },
      {
        "name": "Lynn B. Davis",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MS", "FACOG"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Lynn-Davis_WA_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/seattle-wa/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-50-lynn-b-davis"
      },
      {
        "name": "Amanda K. Hurliman",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Amanda-Hurliman_WA_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/seattle-wa/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-50-amanda-k-hurliman"
      },
      {
        "name": "Jeremy Choy",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Jeremy-Choy_WA_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/seattle-wa/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-50-jeremy-choy"
      },
      {
        "name": "Tom Walsh",
        "role": "Physician",
        "credentials": ["MD", "MS"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/tom-walsh-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/seattle-wa/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-50-tom-walsh"
      },
      {
        "name": "Emily Truong",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/02/Emily-WA-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/seattle-wa/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-50-emily-truong"
      },
      {
        "name": "Cindy Wong Sick Hong",
        "role": "Nurse Practitioner",
        "credentials": ["ARNP", "FNP-C"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/02/cindy-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/seattle-wa/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-50-cindy-wong-sick-hong"
      }
    ],
    "languages": ["English", "Spanish"],
    "setting": "network-group",
    "network": {
      "name": "Pinnacle Fertility"
    },
    "images": [
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/DSC_7986.jpg",
        "type": "exterior",
        "caption": "Exterior of the Seattle Reproductive Medicine building at 1505 Westlake Ave N, Seattle, showing the SRM signage on the facade.",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/seattle-wa/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/Seattle-4-daylight.jpg",
        "type": "interior",
        "caption": "Interior patient lounge/waiting area at the Seattle clinic with floor-to-ceiling windows overlooking Lake Union.",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/seattle-wa/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Washington (WA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-610",
    "externalIds": {
      "cdcClinicId": "610",
      "googlePlaceId": "ChIJGdlZNEsVkFQRknGYRz3DKIE"
    },
    "type": "fertility-clinic",
    "name": "RMA Seattle",
    "phone": "(206) 651-4432",
    "address": {
      "line1": "509 Olive Way, Suite 501",
      "city": "Seattle",
      "state": "WA",
      "zip": "98101",
      "country": "US"
    },
    "location": {
      "lat": 47.6127,
      "lng": -122.337
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 37.2,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "8/16"
        },
        {
          "ageBand": "38-40",
          "rate": 53.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 129,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27610%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27610%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-seattle/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Reproductive+Medicine+Associates+%7C+Sound+Fertility+Care,+509+Olive+Wy+%23501,+Seattle,+WA+98101/@47.6127103,-122.3366522,2690a,13.1y/data=!4m2!3m1!1s0x5490154b3459d919:0x8128c33d47987192",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-610-kathleen-lin-md",
        "name": "Kathleen Lin, MD",
        "role": "Medical Director",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2022/09/1.png",
        "credentials": ["MD", "MSCE"],
        "_source": {
          "url": "https://rmanetwork.com/staff/kat-lin/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Sarah Keller",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/04/Doctor-Mobile-website-headshot-264-x-264-px-5.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/sarah-keller/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-610-sarah-keller"
      },
      {
        "name": "Paulinna Huynh",
        "role": "Physician Assistant",
        "credentials": ["PA-C", "MHS"],
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2023/05/2.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/paulinna-huynh/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-610-paulinna-huynh"
      }
    ],
    "website": "https://www.soundfertilitycare.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Premera",
        "Regence"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "bookingUrl": "https://rmanetwork.com/our-locations/rma-seattle/",
    "description": "RMA Seattle fertility clinic in Seattle, WA. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "network": {
      "name": "IVI RMA"
    },
    "images": [
      {
        "url": "https://rmanetwork.com/wp-content/uploads/2025/02/Untitled-design-2.jpg",
        "type": "interior",
        "caption": "RMA Seattle reception and waiting area with the Reproductive Medicine Associates logo wall",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-seattle/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://rmanetwork.com/wp-content/uploads/2025/01/Untitled-design-7.jpg",
        "type": "interior",
        "caption": "Patient consultation seating area at the RMA Seattle (formerly Sound Fertility Care) office",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-seattle/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkiRczbGOnifbi2kEqluNPyo2jQjrmHZoIevdoa5o2r1b-I5hvyAJtuSSABkEwcrB2wxy9P-tbp0RLT2X2vfCQpbdQuADRUKgTtgnCE5vHjS2Pey2tqoxlQR_fl-sJeo12D83St=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Reproductive+Medicine+Associates+%7C+Sound+Fertility+Care,+509+Olive+Wy+%23501,+Seattle,+WA+98101/@47.6127103,-122.3366522,2690a,13.1y/data=!4m2!3m1!1s0x5490154b3459d919:0x8128c33d47987192",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Premera, Regence",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Washington (WA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-513",
    "externalIds": {
      "cdcClinicId": "513"
    },
    "type": "fertility-clinic",
    "name": "SRM Spokane",
    "phone": "(206) 301-5000",
    "address": {
      "line1": "15920 E. Indiana Ave, Suite 200",
      "city": "Spokane Valley",
      "state": "WA",
      "zip": "99216",
      "country": "US"
    },
    "location": {
      "lat": 47.6686,
      "lng": -117.191
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 60.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 41,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 34.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 152,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27513%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27513%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.seattlefertility.com/our-center/clinic-locations/srm-spokane/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-513-brenda-s-houmard-md-phd",
        "name": "Brenda S. Houmard, MD, PHD",
        "role": "Medical Director",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Brenda-Houmard_WA_Square-1024x1024.png",
        "credentials": ["MD", "PhD", "FACOG"],
        "_source": {
          "url": "https://www.seattlefertility.com/our-center/clinic-locations/srm-spokane/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Justine K. Fluharty, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/11/Justine-1024x1024.jpg",
        "_source": {
          "url": "https://www.seattlefertility.com/our-center/clinic-locations/srm-spokane/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-513-justine-k-fluharty-pa-c"
      },
      {
        "name": "Kathleen (Katie) Nave-Perez, CNM",
        "role": "Certified Nurse-Midwife",
        "credentials": ["CNM"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/02/Kathleen-N-1024x1024.jpg",
        "_source": {
          "url": "https://www.seattlefertility.com/our-center/clinic-locations/srm-spokane/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-513-kathleen-katie-nave-perez-cnm"
      }
    ],
    "website": "https://www.seattlereproductivemedicine.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Premera",
        "Regence"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/Spokane-Lab-1.jpg",
        "type": "lab",
        "caption": "Embryology/IVF lab at the SRM Spokane (Spokane Valley) clinic",
        "_source": {
          "url": "https://www.seattlefertility.com/our-center/clinic-locations/srm-spokane/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Premera, Regence",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Washington (WA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-925",
    "externalIds": {
      "cdcClinicId": "925",
      "googlePlaceId": "ChIJH6XIPYxtkFQREJItoBCxErY"
    },
    "type": "fertility-clinic",
    "name": "Think Fertility",
    "phone": "(425) 453-2229",
    "address": {
      "line1": "1600 116th Ave N.E., Suite 104",
      "city": "Bellevue",
      "state": "WA",
      "zip": "98004",
      "country": "US"
    },
    "location": {
      "lat": 47.6252,
      "lng": -122.1825
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": ">40",
          "rate": 0,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 0,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27925%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27925%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://thinkfertilityusa.com/meet-our-providers/",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Think+Fertility+-+Bellevue,+1135+116th+Ave+NE+Ste+630,+Bellevue,+WA+98004/@47.6213305,-122.1868862,2689a,13.1y/data=!4m2!3m1!1s0x54906d8c3dc8a51f:0xb612b110a02d9210",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-925-jie-deng-md-phd",
        "name": "Jie Deng, MD, PHD",
        "role": "Medical Director",
        "imageUrl": "https://thinkfertilityusa.com/wp-content/uploads/brizy/imgs/Potrait_Jie_2_retouched2-scaled-652x836x0x0x603x836x1724947390.jpg",
        "credentials": ["MD", "PhD", "HCLD", "FACOG"],
        "_source": {
          "url": "https://thinkfertilityusa.com/dr-deng-2/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "name": "Allycin Rajasaari",
        "role": "Nurse Practitioner",
        "credentials": ["ARNP"],
        "imageUrl": "https://thinkfertilityusa.com/wp-content/uploads/brizy/imgs/image1-501x744x0x0x501x677x1723567498.jpeg",
        "_source": {
          "url": "https://thinkfertilityusa.com/meet-our-providers/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-925-allycin-rajasaari"
      }
    ],
    "website": "https://www.thinkfertility.com",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Premera",
        "Regence"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Premera, Regence",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Washington (WA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-180",
    "externalIds": {
      "cdcClinicId": "180"
    },
    "type": "fertility-clinic",
    "name": "University Reproductive Care, University of Washington",
    "phone": "(206) 598-4225",
    "address": {
      "line1": "4245 Roosevelt Way N.E., 3rd Floor",
      "city": "Seattle",
      "state": "WA",
      "zip": "98105",
      "country": "US"
    },
    "location": {
      "lat": 47.6588,
      "lng": -122.318
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 64.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 42.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 47.6,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 136,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27180%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27180%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.uwmedicine.org/locations/reproductive-care-uwmc-roosevelt",
            "fetchedAt": "2026-06-14"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "contact": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch2-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-180-ginny-ryan-md",
        "name": "Ginny Ryan, MD",
        "role": "Medical Director"
      },
      {
        "name": "Ginny Ryan, MD, MA",
        "role": "Professor; Division Chief, Reproductive Endocrinology & Infertility",
        "credentials": ["MD", "MA"],
        "imageUrl": "https://obgyn.uw.edu/sites/obgyn.uw.edu/files/2022-05/Ryan_Ginny-2.jpg",
        "_source": {
          "url": "https://obgyn.uw.edu/people/Ryan",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-180-ginny-ryan-md-ma"
      },
      {
        "name": "Rebecca Chung, MD, FACOG",
        "role": "Reproductive Endocrinologist; Assistant Professor",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://obgyn.uw.edu/sites/obgyn.uw.edu/files/2023-12/Chung_Rebecca2.jpg",
        "_source": {
          "url": "https://obgyn.uw.edu/people/Chung",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-180-rebecca-chung-md-facog"
      },
      {
        "name": "Angela Petlow, ARNP",
        "role": "Reproductive Endocrinology & Infertility Nurse Practitioner",
        "credentials": ["ARNP"],
        "imageUrl": "https://obgyn.uw.edu/sites/obgyn.uw.edu/files/2025-07/Petlow_Angela-small.jpg",
        "_source": {
          "url": "https://obgyn.uw.edu/people/petlow",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-180-angela-petlow-arnp"
      },
      {
        "name": "Mary Sienkiewicz, MSN, ARNP",
        "role": "Reproductive Endocrinology & Infertility Nurse Practitioner",
        "credentials": ["MSN", "ARNP"],
        "imageUrl": "https://obgyn.uw.edu/sites/obgyn.uw.edu/files/2022-05/Sienkiewicz_Mary_D.jpg",
        "_source": {
          "url": "https://obgyn.uw.edu/people/Sienkiewicz",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-180-mary-sienkiewicz-msn-arnp"
      },
      {
        "name": "Emalee R. Danforth, CNM, MSN",
        "role": "Certified Nurse-Midwife",
        "credentials": ["CNM", "MSN", "MSCP"],
        "imageUrl": "https://obgyn.uw.edu/sites/obgyn.uw.edu/files/2022-05/Emalee_Danforth.jpg",
        "_source": {
          "url": "https://obgyn.uw.edu/people/Danforth",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-180-emalee-r-danforth-cnm-msn"
      },
      {
        "name": "Austin Johnson, MD",
        "role": "Reproductive Endocrinology & Infertility Fellow",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://obgyn.uw.edu/sites/obgyn.uw.edu/files/inline-images/Johnson%2C%20Austin%20-%205x7%20300dpi.jpg",
        "_source": {
          "url": "https://obgyn.uw.edu/education/fellowships/current-fellows",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-180-austin-johnson-md"
      },
      {
        "name": "Vania Nwokolo, MD",
        "role": "Reproductive Endocrinology & Infertility Fellow",
        "credentials": ["MD"],
        "imageUrl": "https://obgyn.uw.edu/sites/obgyn.uw.edu/files/inline-images/Vania.jpg",
        "_source": {
          "url": "https://obgyn.uw.edu/education/fellowships/current-fellows",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-180-vania-nwokolo-md"
      },
      {
        "name": "Ticara Onyewuenyi, MD, MPH",
        "role": "Reproductive Endocrinology & Infertility Fellow",
        "credentials": ["MD", "MPH"],
        "imageUrl": "https://obgyn.uw.edu/sites/obgyn.uw.edu/files/inline-images/Onyewuenyi_Ticara_small.jpg",
        "_source": {
          "url": "https://obgyn.uw.edu/education/fellowships/current-fellows",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-cdc-180-ticara-onyewuenyi-md-mph"
      }
    ],
    "website": "https://www.uwmedicine.org/services/reproductive-care",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Premera",
        "Regence"
      ],
      "employeeBenefits": ["Progyny"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Premera, Regence",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Washington (WA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-cdc-525",
    "externalIds": {
      "cdcClinicId": "525"
    },
    "type": "fertility-clinic",
    "name": "Aurora Health Care-Aurora Fertility Services, The Women's Center at Aurora BayCare Medical Center",
    "phone": "(920) 288-8500",
    "address": {
      "line1": "2845 Greenbrier Rd, Suite 350",
      "city": "Green Bay",
      "state": "WI",
      "zip": "54311",
      "country": "US"
    },
    "location": {
      "lat": 44.475,
      "lng": -87.9407
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 63.9,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 45.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 75,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "6/8"
        }
      ],
      "cyclesPerYear": 150,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27525%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27525%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.aurorabaycare.com/doctors/katherine-a-green-1558672170",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.aurorahealthcare.org/locations/aurora-fertility-services-green-bay",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.aurorahealthcare.org/locations/aurora-fertility-services-green-bay",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-525-katherine-a-green-md",
        "name": "Katherine A. Green, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology",
        "imageUrl": "https://providers.advocatehealth.com/sparkle-assets/preview_thumbnails/physicians/21557/default-411ed3db9ef91b7d90a62a77facf1d89.jpg",
        "_source": {
          "url": "https://www.aurorabaycare.com/doctors/katherine-a-green-1558672170",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.aurorahealthcare.org/locations/aurora-fertility-services-green-bay",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://providers.advocatehealth.com/sparkle-assets/preview_thumbnails/locations/5449/default-2c467040d23a62bcd6b12fb8e96687c4.jpg",
        "type": "exterior",
        "caption": "Aurora Fertility Services Green Bay exterior",
        "_source": {
          "url": "https://www.aurorahealthcare.org/locations/aurora-fertility-services-green-bay",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Wisconsin (WI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-503",
    "externalIds": {
      "cdcClinicId": "503"
    },
    "type": "fertility-clinic",
    "name": "Aurora Health Care-Aurora Fertility Services, West Allis",
    "phone": "(414) 329-4300",
    "address": {
      "line1": "West Allis Memorial Hospital, 8901 W. Lincoln Ave, 2nd Floor",
      "city": "West Allis",
      "state": "WI",
      "zip": "53227",
      "country": "US"
    },
    "location": {
      "lat": 43.0014,
      "lng": -88.0234
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 63.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 56.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 75,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "9/12"
        }
      ],
      "cyclesPerYear": 200,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27503%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27503%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.aurorabaycare.com/doctors/katherine-a-green-1558672170",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.aurorahealthcare.org/locations/aurora-fertility-services-west-allis",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.aurorahealthcare.org/locations/aurora-fertility-services-west-allis",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-503-katherine-a-green-md",
        "name": "Katherine A. Green, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology",
        "imageUrl": "https://providers.advocatehealth.com/sparkle-assets/preview_thumbnails/physicians/21557/default-411ed3db9ef91b7d90a62a77facf1d89.jpg",
        "_source": {
          "url": "https://www.aurorabaycare.com/doctors/katherine-a-green-1558672170",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.aurorahealthcare.org/locations/aurora-fertility-services-west-allis",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://providers.advocatehealth.com/sparkle-assets/preview_thumbnails/locations/5353/default-f063522beda25848b4491731a323fd04.jpg",
        "type": "exterior",
        "caption": "Aurora Fertility Services West Allis exterior",
        "_source": {
          "url": "https://www.aurorahealthcare.org/locations/aurora-fertility-services-west-allis",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Wisconsin (WI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-183",
    "externalIds": {
      "cdcClinicId": "183"
    },
    "type": "fertility-clinic",
    "name": "Froedtert & Medical College of Wisconsin, Reproductive Medicine Center",
    "phone": "(262) 253-9220",
    "address": {
      "line1": "North Hills Health Center, W129 N7055 Northfield Dr, Bldg B, Suite 500",
      "city": "Menomonee Falls",
      "state": "WI",
      "zip": "53051",
      "country": "US"
    },
    "location": {
      "lat": 43.145,
      "lng": -88.0718
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 47.4,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 35.8,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 35.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 263,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27183%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27183%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.froedtert.com/fertility/doctors",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.froedtert.com/fertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.froedtert.com/fertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-183-jayme-s-bosler-md",
        "name": "Jayme S. Bosler, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.froedtert.com/sites/default/files/styles/provider_image_teaser_large/public/doctors/images/jayme-bosler-1356517122.jpg?itok=BwKoLw5O",
        "_source": {
          "url": "https://www.froedtert.com/fertility/doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-183-peter-n-dietrich-md",
        "name": "Peter N. Dietrich, MD",
        "role": "Reproductive Medicine Urologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Medicine, Urology",
        "imageUrl": "https://www.froedtert.com/sites/default/files/styles/provider_image_teaser_large/public/doctors/images/peter-dietrich-1225484363.jpg?itok=36oXC5_o",
        "_source": {
          "url": "https://www.froedtert.com/fertility/doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-183-stephanie-jean-gunderson-md",
        "name": "Stephanie Jean Gunderson, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.froedtert.com/sites/default/files/styles/provider_image_teaser_large/public/doctors/images/stephanie-gunderson-1366785065.jpg?itok=q4e0HfE2",
        "_source": {
          "url": "https://www.froedtert.com/fertility/doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-183-karli-mcmanaman-apnp",
        "name": "Karli McManaman, APNP",
        "role": "Advanced Practice Nurse Practitioner",
        "credentials": ["APNP"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.froedtert.com/sites/default/files/styles/provider_image_teaser_large/public/doctors/images/karli-mcmanaman-1366182008.jpg?itok=_DIZEDFr",
        "_source": {
          "url": "https://www.froedtert.com/fertility/doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-183-jamie-neary-apnp-aocnp",
        "name": "Jamie Neary, APNP, AOCNP",
        "role": "Advanced Practice Nurse Practitioner",
        "credentials": ["APNP", "AOCNP"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://www.froedtert.com/sites/default/files/styles/provider_image_teaser_large/public/doctors/images/jamie-neary-1477889616.jpg?itok=QyoD8r_-",
        "_source": {
          "url": "https://www.froedtert.com/fertility/doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-183-katherine-schoyer-md",
        "name": "Katherine Schoyer, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.froedtert.com/sites/default/files/styles/provider_image/public/doctors/images/katherine-schoyer-1932140480.jpg?itok=d16j8VGv",
        "_source": {
          "url": "https://www.froedtert.com/fertility/doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-183-jay-i-sandlow-md",
        "name": "Jay I. Sandlow, MD",
        "role": "Reproductive Medicine Urologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Medicine, Urology",
        "imageUrl": "https://www.froedtert.com/sites/default/files/styles/provider_image_teaser_large/public/doctors/images/jay-sandlow-1063465797.jpg?itok=L9vdXFvk",
        "_source": {
          "url": "https://www.froedtert.com/fertility/doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-183-robert-rydze-md-msci",
        "name": "Robert Rydze, MD, MSCI",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MSCI"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.froedtert.com/sites/default/files/styles/provider_image_teaser_large/public/doctors/images/robert-rydze-1750634036.jpg?itok=jMW2dnta",
        "_source": {
          "url": "https://www.froedtert.com/fertility/doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-183-shunping-wang-phd",
        "name": "Shunping Wang, PhD",
        "role": "IVF and Andrology Lab Director",
        "credentials": ["PhD"],
        "specialty": "IVF and Andrology Laboratory",
        "imageUrl": "https://www.froedtert.com/sites/default/files/styles/provider_image_teaser_large/public/doctors/images/shunping-wang.jpg?itok=Ja8tltUa",
        "_source": {
          "url": "https://www.froedtert.com/fertility/doctors",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.froedtert.com/fertility",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "images": [
      {
        "url": "https://www.froedtert.com/sites/default/files/styles/media_bar_medium/public/image/2022-04/fertility-lab-for-web.jpg?itok=VJVIz3Cg",
        "type": "interior",
        "caption": "Froedtert Fertility and Reproductive Medicine lab",
        "_source": {
          "url": "https://www.froedtert.com/fertility",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://www.froedtert.com/sites/default/files/styles/media_bar_medium/public/image/2022-04/fertility-lab-reading.jpg?itok=DiTySldo",
        "type": "interior",
        "caption": "Froedtert fertility lab reading station",
        "_source": {
          "url": "https://www.froedtert.com/fertility",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Wisconsin (WI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-343",
    "externalIds": {
      "cdcClinicId": "343",
      "googlePlaceId": "ChIJXa6itMMYBYgRWf4Gm3IFKxI"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Specialty Center",
    "phone": "(414) 289-9668",
    "address": {
      "line1": "Water Tower Medical Commons Building, 2350 N. Lake Drive, Suite 504",
      "city": "Milwaukee",
      "state": "WI",
      "zip": "53211",
      "country": "US"
    },
    "location": {
      "lat": 43.0613,
      "lng": -87.8787
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [],
      "cyclesPerYear": 26,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27343%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27343%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.milwaukeemag.com/dr-grace-janik-receives-prestigious-society-of-reproductive-surgeons-award/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Reproductive+Specialty+Center,+2350+N+Lake+Dr+%23303,+Milwaukee,+WI+53211/@43.0608143,-87.8786794,2915a,13.1y/data=!4m2!3m1!1s0x880518c3b4a2ae5d:0x122b05729b06fe59",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "http://www.reproductivecenter.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-343-grace-m-janik-md",
        "name": "Grace M. Janik, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility; Minimally Invasive Gynecologic Surgery",
        "imageUrl": "https://www.milwaukeemag.com/wp-content/uploads/2024/06/0524-SAS-MedicalExcellenceProfiles-Janik-683x1024.jpg",
        "_source": {
          "url": "https://www.milwaukeemag.com/dr-grace-janik-receives-prestigious-society-of-reproductive-surgeons-award/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "http://www.reproductivecenter.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Wisconsin (WI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-397",
    "externalIds": {
      "cdcClinicId": "397"
    },
    "type": "fertility-clinic",
    "name": "University of Wisconsin-Generations Fertility Care",
    "phone": "(608) 824-6160",
    "address": {
      "line1": "2365 Deming Way",
      "city": "Middleton",
      "state": "WI",
      "zip": "53562",
      "country": "US"
    },
    "location": {
      "lat": 43.1006,
      "lng": -89.5172
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 48.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 42.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 28,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 180,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27397%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27397%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.uwhealth.org/locations/fertility-care-clinic/reproductive-endocrinology-and-infertility-clinic-828",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.uwhealth.org/locations/fertility-care-clinic/reproductive-endocrinology-and-infertility-clinic-828",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.uwhealth.org/locations/fertility-care-clinic/reproductive-endocrinology-and-infertility-clinic-828",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-397-jasmin-barthel-pa",
        "name": "Jasmin Barthel, PA",
        "role": "Physician Assistant",
        "credentials": ["PA"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://res.cloudinary.com/uwhealth/image/upload/v1685638145/u/1KC6VXGiyUxpr7vrK9rqkT.jpg",
        "_source": {
          "url": "https://www.uwhealth.org/locations/fertility-care-clinic/reproductive-endocrinology-and-infertility-clinic-828",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-397-bala-bhagavath-md",
        "name": "Bala Bhagavath, MD",
        "role": "Infertility Doctor and Reproductive Surgeon",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://res.cloudinary.com/uwhealth/image/upload/v1729180076/u/HIPP11372.jpg",
        "_source": {
          "url": "https://www.uwhealth.org/locations/fertility-care-clinic/reproductive-endocrinology-and-infertility-clinic-828",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-397-laura-g-cooney-md",
        "name": "Laura G. Cooney, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://res.cloudinary.com/uwhealth/image/upload/v1673995874/u/HIPP10605.jpg",
        "_source": {
          "url": "https://www.uwhealth.org/locations/fertility-care-clinic/reproductive-endocrinology-and-infertility-clinic-828",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-397-kiley-c-dehaven-pa",
        "name": "Kiley C. DeHaven, PA",
        "role": "Physician Assistant",
        "credentials": ["PA"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://res.cloudinary.com/uwhealth/image/upload/v1674667361/u/6KAAV7SPASDydEJeyWFqYq.jpg",
        "_source": {
          "url": "https://www.uwhealth.org/locations/fertility-care-clinic/reproductive-endocrinology-and-infertility-clinic-828",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-397-megan-lyght-pa",
        "name": "Megan Lyght, PA",
        "role": "Physician Assistant",
        "credentials": ["PA"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://res.cloudinary.com/uwhealth/image/upload/v1677864920/u/HIPP11103.jpg",
        "_source": {
          "url": "https://www.uwhealth.org/locations/fertility-care-clinic/reproductive-endocrinology-and-infertility-clinic-828",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-397-aleksandar-stanic-kostic-md-phd",
        "name": "Aleksandar Stanic-Kostic, MD, PhD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://res.cloudinary.com/uwhealth/image/upload/v1688056623/u/HIPP9674.jpg",
        "_source": {
          "url": "https://www.uwhealth.org/locations/fertility-care-clinic/reproductive-endocrinology-and-infertility-clinic-828",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-397-kristen-wilkinson-psyd",
        "name": "Kristen Wilkinson, PsyD",
        "role": "Psychologist",
        "credentials": ["PsyD"],
        "specialty": "Health Psychology; Reproductive Endocrinology and Infertility",
        "imageUrl": "https://res.cloudinary.com/uwhealth/image/upload/v1738356572/u/2ctae71g4Jcta1Ncrzvj4H.jpg",
        "_source": {
          "url": "https://www.uwhealth.org/locations/fertility-care-clinic/reproductive-endocrinology-and-infertility-clinic-828",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-397-daniel-h-williams-iv-md",
        "name": "Daniel H. Williams IV, MD",
        "role": "Urologist; Male Fertility",
        "credentials": ["MD"],
        "specialty": "Urology; Reproductive Endocrinology and Infertility",
        "imageUrl": "https://res.cloudinary.com/uwhealth/image/upload/v1708963584/u/HIPP7931.jpg",
        "_source": {
          "url": "https://www.uwhealth.org/locations/fertility-care-clinic/reproductive-endocrinology-and-infertility-clinic-828",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-397-julianne-e-zweifel-phd",
        "name": "Julianne E. Zweifel, PhD",
        "role": "Clinical Psychologist",
        "credentials": ["PhD"],
        "specialty": "Health Psychology; Reproductive Endocrinology and Infertility",
        "imageUrl": "https://res.cloudinary.com/uwhealth/image/upload/v1700002287/u/HIPP8022.jpg",
        "_source": {
          "url": "https://www.uwhealth.org/locations/fertility-care-clinic/reproductive-endocrinology-and-infertility-clinic-828",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.uwhealth.org/services/infertility",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Wisconsin (WI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-470",
    "externalIds": {
      "cdcClinicId": "470",
      "googlePlaceId": "ChIJrSX9AMaoB4gRF6fmWbTAzUA"
    },
    "type": "fertility-clinic",
    "name": "Wisconsin Fertility Institute",
    "phone": "(608) 824-0075",
    "address": {
      "line1": "3146 Deming Way",
      "city": "Middleton",
      "state": "WI",
      "zip": "53562",
      "country": "US"
    },
    "location": {
      "lat": 43.1058,
      "lng": -89.5266
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 34.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 28.3,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "38-40",
          "rate": 20,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        }
      ],
      "cyclesPerYear": 224,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27470%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27470%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://wisconsinfertility.com/who-we-are/our-team/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Wisconsin+Fertility+Institute,+3146+Deming+Way,+Middleton,+WI+53562/@43.1058149,-89.5265519,2913a,13.1y/data=!4m2!3m1!1s0x8807a8c600fd25ad:0x40cdc0b459e6a717",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://wisconsinfertility.com/contact-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch4-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-470-gretchen-collins-md",
        "name": "Gretchen Collins, MD",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://wisconsinfertility.com/wp-content/uploads/2019/07/dr-gretchen-collins-md.jpg",
        "_source": {
          "url": "https://wisconsinfertility.com/who-we-are/our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-470-meghan-ogden-md",
        "name": "Meghan Ogden, MD",
        "role": "Minimally Invasive Gynecologic Surgeon and Infertility Specialist",
        "credentials": ["MD"],
        "specialty": "Minimally Invasive Gynecologic Surgery and Infertility",
        "imageUrl": "https://wisconsinfertility.com/wp-content/uploads/2023/02/Dr-Meghan-Ogden.png",
        "_source": {
          "url": "https://wisconsinfertility.com/who-we-are/our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-470-wael-abdel-megid-md-msc-phd-hcld",
        "name": "Wael Abdel Megid, MD, MSc, PhD, HCLD",
        "role": "Lab Director",
        "credentials": ["MD", "MSc", "PhD", "HCLD"],
        "specialty": "Embryology Laboratory Direction",
        "imageUrl": "https://wisconsinfertility.com/wp-content/uploads/2019/07/dr-wael-megid.jpg",
        "_source": {
          "url": "https://wisconsinfertility.com/who-we-are/our-team/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://wisconsinfertility.com/",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "boutique",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmsbrWh-PHubMD_r3_2fmbPmn8Sj0yjnR4msGhDN5ou_J-Ae9Jg-TbHU7Fw-cXgHQF0DrZ9WdO0eIPgVEpbpo-68fzeIU7IZvWL7JAGieeuGl3iVNx_Q_KrZvI4P8bPTGELKD7F=w408-h240-k-no-pi-0-ya8.013725-ro-0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Wisconsin+Fertility+Institute,+3146+Deming+Way,+Middleton,+WI+53562/@43.1058149,-89.5265519,2913a,13.1y/data=!4m2!3m1!1s0x8807a8c600fd25ad:0x40cdc0b459e6a717",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlwnS62-c0IqinkAwA_8tpqtyCkI1qPKgPofiM9B_teXMelRwNj7vK2-cwGNAblfLufOvfIHo0y4g_r3-1zp0QnYqAItfudAXnSPFNMZ2oZyIZepMSzrJ3k_vNjW8hdZne5AAlYnA=w224-h298-k-no-pi-0-ya167.99582-ro-0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Wisconsin+Fertility+Institute,+3146+Deming+Way,+Middleton,+WI+53562/@43.1058149,-89.5265519,2913a,13.1y/data=!4m2!3m1!1s0x8807a8c600fd25ad:0x40cdc0b459e6a717",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Wisconsin (WI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-493",
    "externalIds": {
      "cdcClinicId": "493"
    },
    "type": "fertility-clinic",
    "name": "Cabell Huntington Hospital, Center for Advanced Reproductive Medicine",
    "phone": "(304) 526-2602",
    "address": {
      "line1": "1600 Medical Center Dr, Suite 4500",
      "city": "Huntington",
      "state": "WV",
      "zip": "25701",
      "country": "US"
    },
    "location": {
      "lat": 38.4091,
      "lng": -82.4269
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 47.368421052631575,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "9/19"
        }
      ],
      "cyclesPerYear": 34,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27493%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27493%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.marshallhealth.org/services/infertility-reproductive-endocrinology/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.marshallhealth.org/services/infertility-reproductive-endocrinology/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://cabellhuntington.org/services/womens-health/center-for-advanced-reproductive-medicine",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-493-william-n-burns-md",
        "name": "William N. Burns, MD",
        "role": "Medical Director",
        "credentials": ["MD", "FACOG"],
        "specialty": "Infertility and Reproductive Health",
        "imageUrl": "https://www.marshallhealth.org/img/providers/burns.jpg",
        "_source": {
          "url": "https://www.marshallhealth.org/services/infertility-reproductive-endocrinology/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://cabellhuntington.org/services/womens-health/center-for-advanced-reproductive-medicine",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "images": [
      {
        "url": "https://www.marshallhealth.org/img/locations/mumedcenter.jpg",
        "type": "exterior",
        "caption": "Marshall University Medical Center, the listed Huntington location.",
        "_source": {
          "url": "https://www.marshallhealth.org/services/infertility-reproductive-endocrinology/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC outcome participation is imported, but this record has no positive success-rate value to chart.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check West Virginia (WV) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-cdc-418",
    "externalIds": {
      "cdcClinicId": "418",
      "googlePlaceId": "ChIJ68hWugR7NYgRv8xFE8rXBY8"
    },
    "type": "fertility-clinic",
    "name": "West Virginia University Center for Reproductive Medicine",
    "phone": "(304) 598-3100",
    "address": {
      "line1": "1322 Pineview Dr, Suite 2",
      "city": "Morgantown",
      "state": "WV",
      "zip": "26505",
      "country": "US"
    },
    "location": {
      "lat": 39.6627,
      "lng": -79.9537
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "outcomes": {
      "successRates": [
        {
          "ageBand": "<35",
          "rate": 45.7,
          "metric": "Live-birth deliveries per embryo transfer using own eggs"
        },
        {
          "ageBand": "35-37",
          "rate": 62.5,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "10/16"
        },
        {
          "ageBand": "38-40",
          "rate": 50,
          "metric": "Live-birth deliveries per embryo transfer using own eggs",
          "denominator": "5/10"
        }
      ],
      "cyclesPerYear": 128,
      "reportedTo": "CDC",
      "reportYear": 2022,
      "sourceType": "national-mandatory-registry",
      "_source": {
        "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27418%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
        "fetchedAt": "2026-10-08"
      }
    },
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "outcomes": {
          "status": "verified",
          "source": {
            "url": "https://data.cdc.gov/resource/cchw-gdwa.json?%24where=year%3D2022+AND+clinicid%3D%27418%27+AND+questionid%3D%27Q019%27+AND+filterid%3D%27F009%27",
            "fetchedAt": "2026-10-08"
          }
        },
        "treatments": {
          "status": "scraped"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://medicine.hsc.wvu.edu/obgyn/research/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/WVU+Medicine+Center+for+Reproductive+Medicine,+1322+Pineview+Dr,+Morgantown,+WV+26505/@39.6627802,-79.9536993,3071a,13.1y/data=!4m2!3m1!1s0x88357b04ba56c8eb:0x8f05d7ca1345ccbf",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://wvumedicine.org/locations/location/?locationId=Department_358",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "source": "batch5-manual",
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11T02:17:06.416Z",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-cdc-418-ryan-j-heitmann-do",
        "name": "Ryan J. Heitmann, DO",
        "role": "Medical Director of CRM",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://medicine.hsc.wvu.edu/obgyn/research/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-418-i-chung-chen-phd",
        "name": "I-Chung Chen, PhD",
        "role": "Embryologist",
        "credentials": ["PhD"],
        "specialty": "Embryology and Andrology",
        "_source": {
          "url": "https://medicine.hsc.wvu.edu/obgyn/research/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-418-melanie-clemmer-phd-hcld",
        "name": "Melanie Clemmer, PhD, HCLD",
        "role": "IVF Laboratory Director",
        "credentials": ["PhD", "HCLD"],
        "specialty": "Reproductive Medicine",
        "_source": {
          "url": "https://medicine.hsc.wvu.edu/obgyn/research/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-cdc-418-shon-rowan-md",
        "name": "Shon Rowan, MD",
        "role": "Reproductive Medicine Physician",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology, Reproductive Medicine, Surgery and Pediatric Gynecology",
        "_source": {
          "url": "https://medicine.hsc.wvu.edu/obgyn/research/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.wvumedicine.org/fertility",
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "hospital-based",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "CDC success-rate values are imported for this record.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check West Virginia (WV) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-manual-hrc-sf",
    "externalIds": {
      "googlePlaceId": "ChIJQ4J63f6BhYARE9lzYtJVGaU"
    },
    "type": "fertility-clinic",
    "name": "HRC Fertility - San Francisco",
    "description": "HRC Fertility is a leading fertility clinic network in California, now serving San Francisco. Known for high success rates and cutting-edge reproductive technology, HRC offers comprehensive fertility services including IVF, egg freezing, and genetic testing.",
    "website": "https://www.havingbabies.com/san-francisco/",
    "phone": "(866) 472-4483",
    "bookingUrl": "https://www.havingbabies.com/san-francisco/",
    "address": {
      "line1": "55 Francisco St, Suite 300",
      "city": "San Francisco",
      "state": "CA",
      "zip": "94133",
      "country": "US"
    },
    "location": {
      "lat": 37.8058,
      "lng": -122.4105
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.havingbabies.com/san-francisco/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Anthem Blue Cross",
        "Blue Shield of California",
        "Cigna Healthcare",
        "Health Net of California",
        "Humana",
        "Kaiser Permanente",
        "Multiplan",
        "Optum Healthcare Solutions",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://nass.cdc.gov",
            "fetchedAt": "2024-01-01"
          }
        },
        "outcomes": {
          "status": "missing"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/san-francisco/",
            "fetchedAt": "2026-03-11"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/san-francisco/",
            "fetchedAt": "2026-03-11"
          }
        },
        "schedule": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/san-francisco/",
            "fetchedAt": "2026-03-11"
          }
        },
        "insurance": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/san-francisco/",
            "fetchedAt": "2026-03-11"
          }
        },
        "consultationTypes": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/san-francisco/",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/HRC+Fertility+-+San+Francisco,+55+Francisco+St+Ste+300,+San+Francisco,+CA+94133/@37.8053252,-122.4057883,3152a,13.1y/data=!4m2!3m1!1s0x808581fedd7a8243:0xa51955d26273d913",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "HRC Fertility"
    },
    "team": [
      {
        "practitionerId": "pr-org-manual-hrc-sf-kay-waud",
        "name": "Kay Waud",
        "credentials": ["MD", "PhD", "FACOG"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://www.havingbabies.com/wp-content/uploads/2024/07/Dr-Waud-2024-360X480b.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/san-francisco/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "practitionerId": "pr-org-manual-hrc-sf-howard-li",
        "name": "Howard Li",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology & Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://www.havingbabies.com/wp-content/uploads/2025/11/dr-howard-li-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/san-francisco/",
          "fetchedAt": "2026-03-11"
        }
      }
    ],
    "images": [
      {
        "url": "https://www.havingbabies.com/wp-content/uploads/2024/08/HRC-Fertility-San-Francisco-2025-500X333-300x200.jpg",
        "type": "exterior",
        "caption": "HRC Fertility San Francisco clinic",
        "_source": {
          "url": "https://www.havingbabies.com/san-francisco/",
          "fetchedAt": "2026-03-11"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkJxt3uUMj55YEIm76RlNoa8gFDOO4onNBgsLlPB3Sjt7kYck4tsaQTNUjKXfDhL4pFGeLkQxrYh5Qfzce3CaWr9951he7Rtf4IzaFOub648Q-p-PpP2QVnGrjnQYpMq7RKbsQ=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/HRC+Fertility+-+San+Francisco,+55+Francisco+St+Ste+300,+San+Francisco,+CA+94133/@37.8053252,-122.4057883,3152a,13.1y/data=!4m2!3m1!1s0x808581fedd7a8243:0xa51955d26273d913",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk4MricF-jYKJ3BR-m-2WCG_6PO9WRfIb1t8dlUOTLPDvNf2BXg37JkPbzfOqbQ48bvkgS80IbT0ElF1HUC4hSa7ALC36OiqGJBHg3oV97WAGc8t_7TeYHqVzWUsbFSRQDthAo=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/HRC+Fertility+-+San+Francisco,+55+Francisco+St+Ste+300,+San+Francisco,+CA+94133/@37.8053252,-122.4057883,3152a,13.1y/data=!4m2!3m1!1s0x808581fedd7a8243:0xa51955d26273d913",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross, Blue Shield of California, Cigna Healthcare, Health Net of California, Humana, Kaiser Permanente, Multiplan",
              "detail": "3 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.havingbabies.com/san-francisco/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-manual-ccrm-miami",
    "externalIds": {
      "googlePlaceId": "ChIJPYdW3jSt2YgRsa-KerSWWUY"
    },
    "type": "fertility-clinic",
    "name": "CCRM Fertility of Miami",
    "description": "CCRM Fertility of Miami is a leading fertility clinic in South Florida offering a full range of fertility services including IVF, IUI, egg freezing, PGT, LGBTQIA+ family building, egg and sperm donor options, and gestational carrier support. Part of the nationally recognized CCRM network known for pioneering fertility research and high success rates.",
    "website": "https://www.ccrmivf.com/location/us/florida/miami/",
    "phone": "(305) 526-4530",
    "bookingUrl": "https://www.ccrmivf.com/location/us/florida/miami/",
    "address": {
      "line1": "19505 Biscayne Blvd, Suite 2230",
      "city": "Aventura",
      "state": "FL",
      "zip": "33180",
      "country": "US"
    },
    "location": {
      "lat": 25.9565,
      "lng": -80.1422
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.ccrmivf.com/location/us/florida/miami/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Humana",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": [
      "English",
      "Spanish",
      "Chinese",
      "Arabic",
      "Russian",
      "French",
      "Portuguese",
      "Italian",
      "German"
    ],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/florida/miami/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Miami,+19505+Biscayne+Blvd+Ste+2230,+Miami,+FL+33180/@25.9559032,-80.1436961,3587a,13.1y/data=!4m2!3m1!1s0x88d9ad34de56873d:0x465996b47a8aafb1",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "CCRM Fertility"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Callum Potts, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Callum_Potts_600x600_2x-r9yqg0gbhhaz7aw1mh1pau9tuznsw2ps5ztcvbbycg.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/florida/miami/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-manual-ccrm-miami-callum-potts-md"
      },
      {
        "name": "Rachel Cain, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Rachel-Cain-600x600-1-rfabnhffyqk9b81y3savfu12e1655ren69vum98asg.png",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/florida/miami/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-manual-ccrm-miami-rachel-cain-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Humana, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.ccrmivf.com/location/us/florida/miami/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnRVbRVzjzLaEpjHZJggxGv_lkIKga2TBYEK1-uX0c4jGnloYTfvaSydWN9KAvWnRmGjk1azp8dRLOZxTO-kte5P-kiDNAPQ3F4AJMxPZjhDFYwJpKvnn_o9EJPQK1F1Zn7Lm0u=w457-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Miami,+19505+Biscayne+Blvd+Ste+2230,+Miami,+FL+33180/@25.9559032,-80.1436961,3587a,13.1y/data=!4m2!3m1!1s0x88d9ad34de56873d:0x465996b47a8aafb1",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn0zQh21CgDTX3q729sL0R9JZAeeaj-XgZv7W36cbY54Ubw17Zc4w_ggPv8VITZuPvNP7w5ADYaB5DSk8GVukW8Pj72y7eQkxzjRqIo_fSYFTUm3uNQcaLMza_5gxdy_qWT0SY=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Miami,+19505+Biscayne+Blvd+Ste+2230,+Miami,+FL+33180/@25.9559032,-80.1436961,3587a,13.1y/data=!4m2!3m1!1s0x88d9ad34de56873d:0x465996b47a8aafb1",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-hrc-encino",
    "externalIds": {
      "googlePlaceId": "ChIJ8yySxIuXwoARaJTqLiS5BqU"
    },
    "type": "fertility-clinic",
    "name": "HRC Fertility - Encino",
    "description": "HRC Fertility's Encino location, serving the San Fernando Valley. Part of one of the largest fertility networks in Southern California with over 35 years of experience and high success rates.",
    "website": "https://www.havingbabies.com/locations/encino/",
    "phone": "(866) 472-4483",
    "bookingUrl": "https://www.havingbabies.com/locations/encino/",
    "address": {
      "line1": "15503 Ventura Blvd, Suite 200",
      "city": "Encino",
      "state": "CA",
      "zip": "91403",
      "country": "US"
    },
    "location": {
      "lat": 34.1561,
      "lng": -118.5006
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.havingbabies.com/locations/encino/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Anthem Blue Cross",
        "Blue Shield of California",
        "Cigna Healthcare",
        "Health Net of California",
        "Humana",
        "Kaiser Permanente",
        "Multiplan",
        "Optum Healthcare Solutions",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish", "Chinese", "Korean", "Farsi"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/locations/encino/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/HRC+Fertility+Encino,+15503+Ventura+Blvd+%23200,+Encino,+CA+91436/@34.1553844,-118.4719816,3302a,13.1y/data=!4m2!3m1!1s0x80c2978bc4922cf3:0xa506b9242eea9468",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "HRC Fertility"
    },
    "parentClinicId": "org-cdc-99000009",
    "team": [
      {
        "practitionerId": "pr-org-satellite-hrc-encino-alison-c-peck",
        "name": "Alison C. Peck",
        "credentials": ["MD", "FACOG"],
        "role": "Board Certified Reproductive Endocrinologist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/07/Dr-Peck-2024-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/encino/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-hrc-encino-robert-boostanfar",
        "name": "Robert Boostanfar",
        "credentials": ["MD", "FACOG"],
        "role": "Board Certified Reproductive Endocrinologist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/07/Dr-Boostanfar-2024-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/encino/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-hrc-encino-roy-handelsman",
        "name": "Roy Handelsman",
        "credentials": ["MD", "FACOG"],
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/08/dr-roy-handelsman-2025-360X480c.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/encino/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-hrc-encino-irene-woo",
        "name": "Irene Woo",
        "credentials": ["MD", "FACOG"],
        "role": "Board Certified Reproductive Endocrinologist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/03/Dr-Woo-2024b-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/encino/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [
      {
        "url": "https://havingbabies.com/wp-content/uploads/2019/04/hrc-encino-exterior.jpg",
        "type": "exterior"
      }
    ],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross, Blue Shield of California, Cigna Healthcare, Health Net of California, Humana, Kaiser Permanente, Multiplan",
              "detail": "3 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.havingbabies.com/locations/encino/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-hrc-newport-beach",
    "externalIds": {
      "googlePlaceId": "ChIJodvjEgsg3YARJqAn51pE4MA"
    },
    "type": "fertility-clinic",
    "name": "HRC Fertility - Newport Beach",
    "description": "HRC Fertility's Newport Beach location in Orange County. Part of one of the largest fertility networks in Southern California known for cutting-edge reproductive technology and compassionate care.",
    "website": "https://www.havingbabies.com/locations/newport-beach/",
    "phone": "(866) 472-4483",
    "bookingUrl": "https://www.havingbabies.com/locations/newport-beach/",
    "address": {
      "line1": "20360 SW Birch St, Suite 200",
      "city": "Newport Beach",
      "state": "CA",
      "zip": "92663",
      "country": "US"
    },
    "location": {
      "lat": 33.6465,
      "lng": -117.8685
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.havingbabies.com/locations/newport-beach/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Anthem Blue Cross",
        "Blue Shield of California",
        "Cigna Healthcare",
        "Health Net of California",
        "Humana",
        "Kaiser Permanente",
        "Multiplan",
        "Optum Healthcare Solutions",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish", "Chinese", "Korean", "Farsi"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/locations/newport-beach/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/HRC+Fertility,+20360+SW+Birch+St,+Newport+Beach,+CA+92660/@33.65587,-117.878029,3321a,13.1y/data=!4m2!3m1!1s0x80dd200b12e3dba1:0xc0e0445ae727a026",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "HRC Fertility"
    },
    "parentClinicId": "org-cdc-99000009",
    "team": [
      {
        "practitionerId": "pr-org-satellite-hrc-newport-beach-melody-rasouli",
        "name": "Melody Rasouli",
        "credentials": ["MD", "MBA", "FACOG"],
        "role": "Arriving in 2026",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2026/04/dr-melody-rasouli-360X480.webp",
        "_source": {
          "url": "https://www.havingbabies.com/locations/newport-beach/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-hrc-newport-beach-lisa-becht",
        "name": "Lisa Becht",
        "credentials": ["MD", "FACOG"],
        "role": "Board Certified Reproductive Endocrinologist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2026/01/dr-lisa-becht-2026-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/newport-beach/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-hrc-newport-beach-lawrence-b-werlin",
        "name": "Lawrence B. Werlin",
        "credentials": ["MD", "FACOG"],
        "role": "Board Certified Reproductive Endocrinologist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2023/01/Dr-Werlin-2024b.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/newport-beach/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-hrc-newport-beach-esther-h-chung",
        "name": "Esther H. Chung",
        "credentials": ["MD", "FACOG"],
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/09/dr-esther-chung-12-25nl-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/newport-beach/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-hrc-newport-beach-daniel-a-potter",
        "name": "Daniel A. Potter",
        "credentials": ["MD", "FACOG"],
        "role": "Board Certified Reproductive Endocrinologist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/07/Dr-Potter-2024-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/newport-beach/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-hrc-newport-beach-atoosa-ghofranian",
        "name": "Atoosa Ghofranian",
        "credentials": ["MD"],
        "role": "Arriving in 2026",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2026/04/dr-atoosa-ghofranian-360X480b.webp",
        "_source": {
          "url": "https://www.havingbabies.com/locations/newport-beach/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-hrc-newport-beach-anupama-rambhatla",
        "name": "Anupama Rambhatla",
        "credentials": ["MD", "FACOG"],
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2025/07/dr-anupama-rambhatla-12-25-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/newport-beach/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [
      {
        "url": "https://havingbabies.com/wp-content/uploads/2016/09/HRC-Fertility-Newport-Beach-Location-2022-600X400.jpg",
        "type": "exterior"
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkuDVbbYQ2paOqi0-dVynISt_f5tbi7RUKAVtZtEt7pFfyTewXA8BtpdwwJRr4ZSQX_HGDpIxZzyur9n4Qpn0YEeLJYhBxTRS9Xi0es6VtRBJGqVbJy5pSfdmPj1dnS-Sr5vUGrug=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/HRC+Fertility,+20360+SW+Birch+St,+Newport+Beach,+CA+92660/@33.65587,-117.878029,3321a,13.1y/data=!4m2!3m1!1s0x80dd200b12e3dba1:0xc0e0445ae727a026",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross, Blue Shield of California, Cigna Healthcare, Health Net of California, Humana, Kaiser Permanente, Multiplan",
              "detail": "3 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.havingbabies.com/locations/newport-beach/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-hrc-fullerton",
    "externalIds": {
      "googlePlaceId": "ChIJLad0-nsq3YARCEUMA2xw2kg"
    },
    "type": "fertility-clinic",
    "name": "HRC Fertility - Fullerton",
    "description": "HRC Fertility's Fullerton location in North Orange County. Part of one of the largest fertility networks in Southern California with over 35 years of experience.",
    "website": "https://www.havingbabies.com/locations/fullerton/",
    "phone": "(866) 472-4483",
    "bookingUrl": "https://www.havingbabies.com/locations/fullerton/",
    "address": {
      "line1": "1950 Sunnycrest Dr, Suite 2400",
      "city": "Fullerton",
      "state": "CA",
      "zip": "92835",
      "country": "US"
    },
    "location": {
      "lat": 33.8959,
      "lng": -117.9076
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.havingbabies.com/locations/fullerton/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Anthem Blue Cross",
        "Blue Shield of California",
        "Cigna Healthcare",
        "Health Net of California",
        "Humana",
        "Kaiser Permanente",
        "Multiplan",
        "Optum Healthcare Solutions",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish", "Chinese", "Korean", "Farsi"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/locations/fullerton/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/HRC+Fertility,+1950+Sunny+Crest+Dr+%232400,+Fullerton,+CA+92835/@33.8935428,-117.9308872,3312a,13.1y/data=!4m2!3m1!1s0x80dd2a7bfa74a72d:0x48da706c030c4508",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "HRC Fertility"
    },
    "parentClinicId": "org-cdc-99000009",
    "team": [
      {
        "practitionerId": "pr-org-satellite-hrc-fullerton-esther-h-chung",
        "name": "Esther H. Chung",
        "credentials": ["MD", "FACOG"],
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/09/dr-esther-chung-12-25nl-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/fullerton/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-hrc-fullerton-daniel-a-potter",
        "name": "Daniel A. Potter",
        "credentials": ["MD", "FACOG"],
        "role": "Board Certified Reproductive Endocrinologist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/07/Dr-Potter-2024-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/fullerton/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross, Blue Shield of California, Cigna Healthcare, Health Net of California, Humana, Kaiser Permanente, Multiplan",
              "detail": "3 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.havingbabies.com/locations/fullerton/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-hrc-west-la",
    "externalIds": {
      "googlePlaceId": "ChIJj4BOcgu7woARaKE_QF9kSlU"
    },
    "type": "fertility-clinic",
    "name": "HRC Fertility - West Los Angeles",
    "description": "HRC Fertility's West Los Angeles location on the Westside. Part of one of the largest fertility networks in Southern California with over 35 years of experience and high success rates.",
    "website": "https://havingbabies.com/locations/west-la/",
    "phone": "(866) 472-4483",
    "bookingUrl": "https://www.havingbabies.com/locations/west-los-angeles/",
    "address": {
      "line1": "11500 Olympic Blvd, Suite 504",
      "city": "Los Angeles",
      "state": "CA",
      "zip": "90064",
      "country": "US"
    },
    "location": {
      "lat": 34.0291,
      "lng": -118.4389
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.havingbabies.com/locations/west-los-angeles/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Anthem Blue Cross",
        "Blue Shield of California",
        "Cigna Healthcare",
        "Health Net of California",
        "Humana",
        "Kaiser Permanente",
        "Multiplan",
        "Optum Healthcare Solutions",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish", "Chinese", "Korean", "Farsi"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://havingbabies.com/locations/west-la/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/HRC+Fertility,+11500+W+Olympic+Blvd+%23504,+Los+Angeles,+CA+90064/@34.0358441,-118.4445706,3306a,13.1y/data=!4m2!3m1!1s0x80c2bb0b724e808f:0x554a645f403fa168",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "HRC Fertility"
    },
    "parentClinicId": "org-cdc-99000009",
    "team": [
      {
        "practitionerId": "pr-org-satellite-hrc-west-la-rachel-mandelbaum",
        "name": "Rachel Mandelbaum",
        "credentials": ["MD", "FACOG"],
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/07/Dr-Mandelbaum-2024-360X480.jpg",
        "_source": {
          "url": "https://havingbabies.com/locations/west-la/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnSiWMYWJE8-9FiwXhsJDvoH2jMfcAjgxUllFU5rRMpTv2ksY5D-YkGNvHyoMELJV0T6KlRn8TamiCnAYtbKYYoRLyk0h7854Ln_4XG7pd_UTiL5GKj7V6eNkaWyMaftSsgqjZl=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/HRC+Fertility,+11500+W+Olympic+Blvd+%23504,+Los+Angeles,+CA+90064/@34.0358441,-118.4445706,3306a,13.1y/data=!4m2!3m1!1s0x80c2bb0b724e808f:0x554a645f403fa168",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross, Blue Shield of California, Cigna Healthcare, Health Net of California, Humana, Kaiser Permanente, Multiplan",
              "detail": "3 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.havingbabies.com/locations/west-los-angeles/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-hrc-laguna-hills",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "HRC Fertility - Laguna Hills",
    "description": "HRC Fertility's Laguna Hills location in South Orange County. Part of one of the largest fertility networks in Southern California.",
    "website": "https://www.havingbabies.com/locations/laguna-hills/",
    "phone": "(866) 472-4483",
    "bookingUrl": "https://www.havingbabies.com/locations/laguna-hills/",
    "address": {
      "line1": "23961 Calle de la Magdalena, Suite 503",
      "city": "Laguna Hills",
      "state": "CA",
      "zip": "92653",
      "country": "US"
    },
    "location": {
      "lat": 33.5969,
      "lng": -117.7064
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.havingbabies.com/locations/laguna-hills/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Anthem Blue Cross",
        "Blue Shield of California",
        "Cigna Healthcare",
        "Health Net of California",
        "Humana",
        "Kaiser Permanente",
        "Multiplan",
        "Optum Healthcare Solutions",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish", "Chinese", "Korean", "Farsi"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "HRC Fertility"
    },
    "parentClinicId": "org-cdc-99000009",
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross, Blue Shield of California, Cigna Healthcare, Health Net of California, Humana, Kaiser Permanente, Multiplan",
              "detail": "3 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.havingbabies.com/locations/laguna-hills/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-satellite-hrc-rancho-cucamonga",
    "externalIds": {
      "googlePlaceId": "ChIJT9Hbyfs1w4ARIldvQrAFqOM"
    },
    "type": "fertility-clinic",
    "name": "HRC Fertility - Rancho Cucamonga",
    "description": "HRC Fertility's Rancho Cucamonga location serving the Inland Empire. Part of one of the largest fertility networks in Southern California.",
    "website": "https://www.havingbabies.com/locations/rancho-cucamonga/",
    "phone": "(866) 472-4483",
    "bookingUrl": "https://www.havingbabies.com/locations/rancho-cucamonga/",
    "address": {
      "line1": "8112 Milliken Ave, Suite 101",
      "city": "Rancho Cucamonga",
      "state": "CA",
      "zip": "91730",
      "country": "US"
    },
    "location": {
      "lat": 34.1095,
      "lng": -117.5714
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.havingbabies.com/locations/rancho-cucamonga/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Anthem Blue Cross",
        "Blue Shield of California",
        "Cigna Healthcare",
        "Health Net of California",
        "Humana",
        "Kaiser Permanente",
        "Multiplan",
        "Optum Healthcare Solutions",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish", "Chinese", "Korean", "Farsi"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/locations/rancho-cucamonga/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/HRC+Fertility,+8112+Milliken+Ave+%23101,+Rancho+Cucamonga,+CA+91730/@34.104765,-117.557479,3304a,13.1y/data=!4m2!3m1!1s0x80c335fbc9dbd14f:0xe3a805b0426f5722",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "HRC Fertility"
    },
    "parentClinicId": "org-cdc-99000009",
    "team": [
      {
        "practitionerId": "pr-org-satellite-hrc-rancho-cucamonga-john-m-norian",
        "name": "John M. Norian",
        "credentials": ["MD", "FACOG"],
        "role": "Board Certified Reproductive Endocrinologist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/07/Dr-Norian-2024-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/rancho-cucamonga/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [
      {
        "url": "https://havingbabies.com/wp-content/uploads/2020/04/hrc-rancho-cucamonga-exterior.jpg",
        "type": "exterior"
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlebzwc8dF-UIZFrigLub5jEtxUY1aSLO8xDN5L5XE2II2Za2QBSBLq4UKlcX6PAylK82Fwbx2mMI5XaaNqwe6jPFJihsJX-8wxorI4MbjbanSNRGOuO_13HgISM7FHjjRpxO49lw=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/HRC+Fertility,+8112+Milliken+Ave+%23101,+Rancho+Cucamonga,+CA+91730/@34.104765,-117.557479,3304a,13.1y/data=!4m2!3m1!1s0x80c335fbc9dbd14f:0xe3a805b0426f5722",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl_g0bTguFxu64QB1mLdC-jwM5Q5G1iaDhaFaow9-4JgN9nRRfNRGDx0cqqvag_BqVWanZuZULuibKitm9dbQC6gpYE-DqgNBiPcwt-45pQDmdRmd8UfurpwzvlXCaG4XmPjmycJQ=w224-h298-k-no-pi-0-ya103.799995-ro-0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/HRC+Fertility,+8112+Milliken+Ave+%23101,+Rancho+Cucamonga,+CA+91730/@34.104765,-117.557479,3304a,13.1y/data=!4m2!3m1!1s0x80c335fbc9dbd14f:0xe3a805b0426f5722",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross, Blue Shield of California, Cigna Healthcare, Health Net of California, Humana, Kaiser Permanente, Multiplan",
              "detail": "3 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.havingbabies.com/locations/rancho-cucamonga/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-hrc-mission-viejo",
    "externalIds": {
      "googlePlaceId": "ChIJr3vyRM_v3IAR1HdxaxItAhc"
    },
    "type": "fertility-clinic",
    "name": "HRC Fertility - Mission Viejo",
    "description": "HRC Fertility's Mission Viejo location in South Orange County. Part of one of the largest fertility networks in Southern California.",
    "website": "https://www.havingbabies.com/locations/mission-viejo/",
    "phone": "(866) 472-4483",
    "bookingUrl": "https://www.havingbabies.com/locations/mission-viejo/",
    "address": {
      "line1": "27800 Medical Center Rd, Bldg 1, Suite 308",
      "city": "Mission Viejo",
      "state": "CA",
      "zip": "92691",
      "country": "US"
    },
    "location": {
      "lat": 33.5537,
      "lng": -117.6672
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.havingbabies.com/locations/mission-viejo/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Anthem Blue Cross",
        "Blue Shield of California",
        "Cigna Healthcare",
        "Health Net of California",
        "Humana",
        "Kaiser Permanente",
        "Multiplan",
        "Optum Healthcare Solutions",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish", "Chinese", "Korean", "Farsi"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/locations/mission-viejo/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/HRC+Fertility+-+Mission+Viejo,+27800+Medical+Center+Rd+Ste+308,+Mission+Viejo,+CA+92691/@33.5599098,-117.6639273,3325a,13.1y/data=!4m2!3m1!1s0x80dcefcf44f27baf:0x17022d126b7177d4",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "HRC Fertility"
    },
    "parentClinicId": "org-cdc-99000009",
    "team": [
      {
        "practitionerId": "pr-org-satellite-hrc-mission-viejo-anupama-rambhatla",
        "name": "Anupama Rambhatla",
        "credentials": ["MD", "FACOG"],
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2025/07/dr-anupama-rambhatla-12-25-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/mission-viejo/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-hrc-mission-viejo-lisa-becht",
        "name": "Lisa Becht",
        "credentials": ["MD", "FACOG"],
        "role": "Board Certified Reproductive Endocrinologist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2026/01/dr-lisa-becht-2026-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/mission-viejo/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [
      {
        "url": "https://havingbabies.com/wp-content/uploads/2023/10/HRC-Fertility-Mission-Viejo-600X400.jpg",
        "type": "exterior"
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnFJFW0zKgJQL0TjHgb-9MoBbpp1dQj5AL0ZVRwRbWYILETsbJF6a7fJrIVGEunEGekdzkPslihh7HOYhr2WjrWJ8ohtlp-Ge44H-tjENJ6-qHewO9GSTUm09a8eB-ayxVFuhwR=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/HRC+Fertility+-+Mission+Viejo,+27800+Medical+Center+Rd+Ste+308,+Mission+Viejo,+CA+92691/@33.5599098,-117.6639273,3325a,13.1y/data=!4m2!3m1!1s0x80dcefcf44f27baf:0x17022d126b7177d4",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnEQ14-XhzIesmNOi347Q6nC-guUAKX93qJWX6J4VWhXjIVK5Cuj3MQzxoRxxE036McpxciP1GY-nOrIMB30_KrNarjgrZnLMCRrVaR19zgPCNUaUG9eap5gB3hyW1U1N0u3rCl=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/HRC+Fertility+-+Mission+Viejo,+27800+Medical+Center+Rd+Ste+308,+Mission+Viejo,+CA+92691/@33.5599098,-117.6639273,3325a,13.1y/data=!4m2!3m1!1s0x80dcefcf44f27baf:0x17022d126b7177d4",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross, Blue Shield of California, Cigna Healthcare, Health Net of California, Humana, Kaiser Permanente, Multiplan",
              "detail": "3 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.havingbabies.com/locations/mission-viejo/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-hrc-oceanside",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "HRC Fertility - Oceanside",
    "description": "HRC Fertility's Oceanside location in North San Diego County. Part of one of the largest fertility networks in Southern California.",
    "website": "https://www.havingbabies.com/locations/oceanside/",
    "phone": "(866) 472-4483",
    "bookingUrl": "https://www.havingbabies.com/locations/oceanside/",
    "address": {
      "line1": "3231 Waring Ct, Suite M",
      "city": "Oceanside",
      "state": "CA",
      "zip": "92056",
      "country": "US"
    },
    "location": {
      "lat": 33.2148,
      "lng": -117.3451
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.havingbabies.com/locations/oceanside/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Anthem Blue Cross",
        "Blue Shield of California",
        "Cigna Healthcare",
        "Health Net of California",
        "Humana",
        "Kaiser Permanente",
        "Multiplan",
        "Optum Healthcare Solutions",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish", "Chinese", "Korean", "Farsi"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "HRC Fertility"
    },
    "parentClinicId": "org-cdc-99000009",
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross, Blue Shield of California, Cigna Healthcare, Health Net of California, Humana, Kaiser Permanente, Multiplan",
              "detail": "3 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.havingbabies.com/locations/oceanside/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-satellite-ccrm-austin",
    "externalIds": {
      "googlePlaceId": "ChIJ9fqkWi9LW4YRGAkAQQ8al-s"
    },
    "type": "fertility-clinic",
    "name": "CCRM Fertility of Austin",
    "description": "CCRM Fertility of Austin brings world-class reproductive medicine to Central Texas. Part of the nationally recognized CCRM network.",
    "website": "https://www.ccrmivf.com/location/us/texas/austin/",
    "phone": "(737) 497-9944",
    "bookingUrl": "https://www.ccrmivf.com/location/us/texas/austin/",
    "address": {
      "line1": "5301 Southwest Pkwy, Bldg 2, Suite 350",
      "city": "Austin",
      "state": "TX",
      "zip": "78735",
      "country": "US"
    },
    "location": {
      "lat": 30.26,
      "lng": -97.8356
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.ccrmivf.com/location/us/texas/austin/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Humana",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Austin,+5301+Southwest+Pkwy+Bldg+2,+Suite+350,+Austin,+TX+78735/@30.2423679,-97.8417505,3447a,13.1y/data=!4m2!3m1!1s0x865b4b2f5aa4faf5:0xeb971a0f41000918",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "CCRM Fertility"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Humana, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.ccrmivf.com/location/us/texas/austin/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkvokINOa4RUaDFehglmM11EfJ9TCW9JXKLcjiIlXZAE89gF0y0ZXzWswnzN7jr5F3oTWEJlfPTfX89_sU7FWBl5JNPOOVg0MMtM9FqqzgmM7SUU9lQHXZqbLoEZ7Ik0QLDYuz-Rg=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Austin,+5301+Southwest+Pkwy+Bldg+2,+Suite+350,+Austin,+TX+78735/@30.2423679,-97.8417505,3447a,13.1y/data=!4m2!3m1!1s0x865b4b2f5aa4faf5:0xeb971a0f41000918",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmk8dlNyzM6-m1YdUtTqrBR2Du3siiIr1coWCrsQl4wsORLW6zR8WXJoaFM80j2XrFZoM7q1pq6Xvfk9pAdj-vbuEtzWVMWwFHkpWwyk_lwvelVgM_GkMy7PC9s0cUlwNTXtATK=w395-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Austin,+5301+Southwest+Pkwy+Bldg+2,+Suite+350,+Austin,+TX+78735/@30.2423679,-97.8417505,3447a,13.1y/data=!4m2!3m1!1s0x865b4b2f5aa4faf5:0xeb971a0f41000918",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-ccrm-houston-sugar-land",
    "externalIds": {
      "googlePlaceId": "ChIJs9aV7jznQIYRxmvXMeH6jcc"
    },
    "type": "fertility-clinic",
    "name": "CCRM Fertility of Houston - Sugar Land",
    "description": "CCRM Fertility's Sugar Land location serves the southwest Houston metro area. Part of the nationally recognized CCRM network.",
    "website": "https://www.ccrmivf.com/houston/ccrm-sugar-land-office/",
    "phone": "(713) 465-1211",
    "bookingUrl": "https://www.ccrmivf.com/houston/ccrm-sugar-land-office/",
    "address": {
      "line1": "16545 SW Fwy, Suite 200",
      "city": "Sugar Land",
      "state": "TX",
      "zip": "77479",
      "country": "US"
    },
    "location": {
      "lat": 29.5977,
      "lng": -95.6349
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.ccrmivf.com/houston/ccrm-sugar-land-office/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Humana",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Sugar+Land,+16545+Southwest+Fwy+Suite+200,+Sugar+Land,+TX+77479/@29.591067,-95.6284628,3469a,13.1y/data=!4m2!3m1!1s0x8640e73cee95d6b3:0xc78dfae131d76bc6",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "CCRM Fertility"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Humana, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.ccrmivf.com/houston/ccrm-sugar-land-office/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlmXNpCHNXifjsEi0UvITy1Dz-F_YRYUbDfnJn-2dfLzK1pmCPYZ2XhnWXShVfZUzVcMbpa-wdJS6KBpD9gBoUeeZtvqDLPd78rCpqMAtLqViRqS5PWnuQSU0yxmWJzDGfeejR4=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Sugar+Land,+16545+Southwest+Fwy+Suite+200,+Sugar+Land,+TX+77479/@29.591067,-95.6284628,3469a,13.1y/data=!4m2!3m1!1s0x8640e73cee95d6b3:0xc78dfae131d76bc6",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkpxQqFUFEI4v4AK62tvo7V-kjnFNRk5ORmaM_jZIMpAjIhdMo3DIw7mPdciPobU20KhJw4i8OarxACmEvpYV92EAtLV1Bf9W1JMt1DnVE6T56Z2dlqbB0PdNex0ThceTFeVwIe=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Sugar+Land,+16545+Southwest+Fwy+Suite+200,+Sugar+Land,+TX+77479/@29.591067,-95.6284628,3469a,13.1y/data=!4m2!3m1!1s0x8640e73cee95d6b3:0xc78dfae131d76bc6",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-ccrm-houston-tmc",
    "externalIds": {
      "googlePlaceId": "ChIJ3YP38Q7AQIYRAFXdevj59-M"
    },
    "type": "fertility-clinic",
    "name": "CCRM Fertility of Houston - Texas Medical Center",
    "description": "CCRM Fertility's Texas Medical Center location in the heart of Houston's renowned medical district. Part of the nationally recognized CCRM network.",
    "website": "https://www.ccrmivf.com/location/us/texas/houston/",
    "phone": "(713) 465-1211",
    "bookingUrl": "https://www.ccrmivf.com/location/us/texas/houston/",
    "address": {
      "line1": "7400 Fannin, Suite 910",
      "city": "Houston",
      "state": "TX",
      "zip": "77054",
      "country": "US"
    },
    "location": {
      "lat": 29.7069,
      "lng": -95.3977
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.ccrmivf.com/location/us/texas/houston/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Humana",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Houston+(Texas+Medical+Center),+7400+Fannin+St+Suite+910,+Houston,+TX+77054/@29.6944293,-95.4010391,3466a,13.1y/data=!4m2!3m1!1s0x8640c00ef1f783dd:0xe3f7f9f87add5500",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "CCRM Fertility"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Humana, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.ccrmivf.com/location/us/texas/houston/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmnyARd8IgOWp_lhUfToXBatGWUiQgEytuJXar10CGwXfq2nCNAG1TFiHvDTTVv6bleETWp0hriNbqWU7kDvX8b2BM_hM11UeQFond-pmVC9Lte7i37aSYWhq_YHQlPGb8Qub6oo5DqWNhj=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Houston+(Texas+Medical+Center),+7400+Fannin+St+Suite+910,+Houston,+TX+77054/@29.6944293,-95.4010391,3466a,13.1y/data=!4m2!3m1!1s0x8640c00ef1f783dd:0xe3f7f9f87add5500",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmDSqKzUN4lfIO87n9YYQ9rBNsEWfEvaP8xeNGfh-eK7QlqJjOMIrnfjCog5k_RMvLqWbRP2tJrj8rDuWVSIp3sVMTlK_IcgAbc8YAGLMY0_QijZlynn7N1bvgW5O1PEYlW6p0=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Houston+(Texas+Medical+Center),+7400+Fannin+St+Suite+910,+Houston,+TX+77054/@29.6944293,-95.4010391,3466a,13.1y/data=!4m2!3m1!1s0x8640c00ef1f783dd:0xe3f7f9f87add5500",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-spring-redwood-city",
    "externalIds": {
      "googlePlaceId": "ChIJQw_02E-ij4AR-84WdudDPJI"
    },
    "type": "fertility-clinic",
    "name": "Spring Fertility - Redwood City",
    "description": "Spring Fertility's Redwood City location on the San Francisco Peninsula. Known for a modern, patient-centered approach to fertility care.",
    "website": "https://springfertility.com/redwood-city/",
    "phone": "(415) 964-5618",
    "bookingUrl": "https://springfertility.com/redwood-city/",
    "address": {
      "line1": "570 Price Ave, Suite 200",
      "city": "Redwood City",
      "state": "CA",
      "zip": "94063",
      "country": "US"
    },
    "location": {
      "lat": 37.4863,
      "lng": -122.218
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://springfertility.com/redwood-city/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Anthem Blue Cross",
        "Blue Shield of California",
        "Cigna",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "sections": {
        "pricing": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://springfertility.com/redwood-city/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Spring+Fertility,+570+Price+Ave+%23200,+Redwood+City,+CA+94063/@37.4936005,-122.2314765,3166a,13.1y/data=!4m2!3m1!1s0x808fa24fd8f40f43:0x923c43e77616cefb",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "Spring Fertility"
    },
    "pricing": {
      "packages": [
        {
          "name": "Initial Consultation",
          "description": "First visit to assess fertility and create a plan",
          "price": 25000,
          "priceMax": 54500,
          "currency": "USD",
          "includes": ["Ultrasound", "Physical exam", "Physician consultation"],
          "notes": "Bloodwork billed through insurance if applicable, otherwise ~$200 out-of-pocket"
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Complete egg freezing cycle including anesthesia",
          "price": 896400,
          "priceMax": 996000,
          "locationPrices": [
            {
              "location": "San Francisco",
              "price": 996000
            },
            {
              "location": "New York",
              "price": 996000
            },
            {
              "location": "Oregon",
              "price": 896400
            }
          ],
          "currency": "USD",
          "includes": [
            "Monitoring appointments",
            "Anesthesia",
            "Retrieval",
            "Cryopreservation"
          ],
          "notes": "$9,960 for SF & NY locations; $8,964 for Oregon. Anesthesia is included (unlike most clinics)."
        },
        {
          "name": "Medication Package",
          "description": "Pre-negotiated pharmacy rates tailored to your protocol",
          "price": 390000,
          "priceMax": 510000,
          "currency": "USD",
          "includes": [
            "All medications for cycle",
            "Refills if protocol changes"
          ],
          "notes": "Patients save ~$1,500 on average. Federal assistance may reduce cost by $500 - $750/cycle."
        },
        {
          "name": "Future IVF (using frozen eggs)",
          "description": "Complete path from thaw to transfer when you're ready",
          "price": 2300000,
          "priceMax": 2500000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Blastocyst development",
            "Genetic testing",
            "FET medication",
            "Transfer"
          ]
        }
      ],
      "financingOptions": [
        {
          "name": "Internal Payment Plan",
          "description": "Low monthly payments with no down payment",
          "details": [
            "Under $300/month",
            "No down payment required",
            "Covers cycle cost only"
          ],
          "exclusions": "Does not cover consultation, medications, or storage fees",
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "PatientFi Financing",
          "description": "Healthcare financing with flexible repayment terms",
          "details": [
            "Third-party healthcare financing",
            "Flexible repayment options",
            "Quick approval process"
          ],
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "Multi-Cycle Discount",
          "description": "10% off for self-pay patients doing multiple cycles",
          "details": [
            "10% discount on additional cycles",
            "Available to self-pay patients only"
          ],
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "Spring Promise (Shared Risk)",
          "description": "Full refund if pregnancy is not achieved for qualifying patients",
          "details": [
            "Full refund guarantee if pregnancy not achieved",
            "Designed for qualifying egg freezing patients"
          ],
          "eligibility": "20 eggs by age 35, or 30 eggs by age 38",
          "exclusions": "IVF, anesthesia, and medications are excluded from the refund",
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        }
      ],
      "_source": {
        "url": "https://springfertility.com/pricing/",
        "fetchedAt": "2026-03-11"
      }
    },
    "team": [
      {
        "practitionerId": "pr-org-satellite-spring-redwood-city-angie-wang",
        "name": "Angie Wang",
        "credentials": ["MD"],
        "role": "Fertility Specialist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2023/11/Our-Providers_Ange.png",
        "_source": {
          "url": "https://springfertility.com/team/dr-angie-wang/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-spring-redwood-city-ursula-dean",
        "name": "Ursula Dean",
        "role": "Nurse Practitioner",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2024/01/Our-Providers_UD.png",
        "_source": {
          "url": "https://springfertility.com/redwood-city/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [
      {
        "url": "https://springfertility.com/wp-content/uploads/2023/05/RWC1-1480x987.jpg",
        "type": "interior"
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmeQKRcqshVC_tH-ofexyAS82bBVQ6BPlMNNLM-iXLpj_mRm1lvEPEaE9kjpklUTff-osMZu8wM5AWJ7a6-Zzf0r2LovyD1JC88A9o5K1Sci6JXqrgkJCAHmjKFHidFQ5nScBo=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Spring+Fertility,+570+Price+Ave+%23200,+Redwood+City,+CA+94063/@37.4936005,-122.2314765,3166a,13.1y/data=!4m2!3m1!1s0x808fa24fd8f40f43:0x923c43e77616cefb",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross, Blue Shield of California, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://springfertility.com/redwood-city/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "4 public price package(s) and 4 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://springfertility.com/pricing/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-spring-danville",
    "externalIds": {
      "googlePlaceId": "ChIJ7ynovb2Nj4ARy9S8Y-B0fgA"
    },
    "type": "fertility-clinic",
    "name": "Spring Fertility - Danville",
    "description": "Spring Fertility's Danville location serving the East Bay and Tri-Valley area. Known for a modern, patient-centered approach to fertility care.",
    "website": "https://springfertility.com/danville/",
    "phone": "(415) 964-5618",
    "bookingUrl": "https://springfertility.com/danville/",
    "address": {
      "line1": "905 San Ramon Valley Blvd, Suite 206",
      "city": "Danville",
      "state": "CA",
      "zip": "94526",
      "country": "US"
    },
    "location": {
      "lat": 37.8204,
      "lng": -121.9967
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://springfertility.com/danville/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Anthem Blue Cross",
        "Blue Shield of California",
        "Cigna",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "sections": {
        "pricing": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://springfertility.com/danville/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Spring+Fertility,+905+San+Ramon+Valley+Blvd+Ste+206,+Danville,+CA+94526/@37.808029,-121.9929085,3152a,13.1y/data=!4m2!3m1!1s0x808f8dbdbde829ef:0x7e74e063bcd4cb",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "Spring Fertility"
    },
    "pricing": {
      "packages": [
        {
          "name": "Initial Consultation",
          "description": "First visit to assess fertility and create a plan",
          "price": 25000,
          "priceMax": 54500,
          "currency": "USD",
          "includes": ["Ultrasound", "Physical exam", "Physician consultation"],
          "notes": "Bloodwork billed through insurance if applicable, otherwise ~$200 out-of-pocket"
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Complete egg freezing cycle including anesthesia",
          "price": 896400,
          "priceMax": 996000,
          "locationPrices": [
            {
              "location": "San Francisco",
              "price": 996000
            },
            {
              "location": "New York",
              "price": 996000
            },
            {
              "location": "Oregon",
              "price": 896400
            }
          ],
          "currency": "USD",
          "includes": [
            "Monitoring appointments",
            "Anesthesia",
            "Retrieval",
            "Cryopreservation"
          ],
          "notes": "$9,960 for SF & NY locations; $8,964 for Oregon. Anesthesia is included (unlike most clinics)."
        },
        {
          "name": "Medication Package",
          "description": "Pre-negotiated pharmacy rates tailored to your protocol",
          "price": 390000,
          "priceMax": 510000,
          "currency": "USD",
          "includes": [
            "All medications for cycle",
            "Refills if protocol changes"
          ],
          "notes": "Patients save ~$1,500 on average. Federal assistance may reduce cost by $500 - $750/cycle."
        },
        {
          "name": "Future IVF (using frozen eggs)",
          "description": "Complete path from thaw to transfer when you're ready",
          "price": 2300000,
          "priceMax": 2500000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Blastocyst development",
            "Genetic testing",
            "FET medication",
            "Transfer"
          ]
        }
      ],
      "financingOptions": [
        {
          "name": "Internal Payment Plan",
          "description": "Low monthly payments with no down payment",
          "details": [
            "Under $300/month",
            "No down payment required",
            "Covers cycle cost only"
          ],
          "exclusions": "Does not cover consultation, medications, or storage fees",
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "PatientFi Financing",
          "description": "Healthcare financing with flexible repayment terms",
          "details": [
            "Third-party healthcare financing",
            "Flexible repayment options",
            "Quick approval process"
          ],
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "Multi-Cycle Discount",
          "description": "10% off for self-pay patients doing multiple cycles",
          "details": [
            "10% discount on additional cycles",
            "Available to self-pay patients only"
          ],
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "Spring Promise (Shared Risk)",
          "description": "Full refund if pregnancy is not achieved for qualifying patients",
          "details": [
            "Full refund guarantee if pregnancy not achieved",
            "Designed for qualifying egg freezing patients"
          ],
          "eligibility": "20 eggs by age 35, or 30 eggs by age 38",
          "exclusions": "IVF, anesthesia, and medications are excluded from the refund",
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        }
      ],
      "_source": {
        "url": "https://springfertility.com/pricing/",
        "fetchedAt": "2026-03-11"
      }
    },
    "team": [
      {
        "practitionerId": "pr-org-satellite-spring-danville-srini-reddy",
        "name": "Srini Reddy",
        "credentials": ["MD"],
        "role": "Fertility Specialist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2023/11/Our-Providers_Srini111323.png",
        "_source": {
          "url": "https://springfertility.com/team/dr-srini-reddy/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmdQY8SEp9b1-XAFuXqiKXAqzGzU119An9pcdHy-Tvj0B1tIy80QuxEy4J7OsYUgN4JdDTAPllcpRS3-IJyMQiPHdmTcdjQuhlbKotSA4gd7tQLB7P1e0-mCHMoa9h1MPsZ3vtBYs3lJHFq=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Spring+Fertility,+905+San+Ramon+Valley+Blvd+Ste+206,+Danville,+CA+94526/@37.808029,-121.9929085,3152a,13.1y/data=!4m2!3m1!1s0x808f8dbdbde829ef:0x7e74e063bcd4cb",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross, Blue Shield of California, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://springfertility.com/danville/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "4 public price package(s) and 4 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://springfertility.com/pricing/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-spring-long-island",
    "externalIds": {
      "googlePlaceId": "ChIJwaXSd419wokRsRGMPqPR2_U"
    },
    "type": "fertility-clinic",
    "name": "Spring Fertility - Long Island",
    "description": "Spring Fertility's Long Island location in Garden City, serving Nassau County and the surrounding area.",
    "website": "https://springfertility.com/long-island/",
    "phone": "(415) 964-5618",
    "bookingUrl": "https://springfertility.com/long-island/",
    "address": {
      "line1": "700 Stewart Ave",
      "city": "Garden City",
      "state": "NY",
      "zip": "11530",
      "country": "US"
    },
    "location": {
      "lat": 40.7268,
      "lng": -73.5852
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://springfertility.com/long-island/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": ["Aetna", "Cigna", "United Healthcare", "Oxford"],
      "employeeBenefits": ["Progyny", "Carrot", "Maven"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "sections": {
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Spring+Fertility,+700+Stewart+Ave+%23200,+Garden+City,+NY+11530/@40.7320608,-73.6078618,3023a,13.1y/data=!4m2!3m1!1s0x89c27d8d77d2a5c1:0xf5dbd1a33e8c11b1",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "Spring Fertility"
    },
    "pricing": {
      "packages": [
        {
          "name": "Initial Consultation",
          "description": "First visit to assess fertility and create a plan",
          "price": 25000,
          "priceMax": 54500,
          "currency": "USD",
          "includes": ["Ultrasound", "Physical exam", "Physician consultation"],
          "notes": "Bloodwork billed through insurance if applicable, otherwise ~$200 out-of-pocket"
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Complete egg freezing cycle including anesthesia",
          "price": 896400,
          "priceMax": 996000,
          "locationPrices": [
            {
              "location": "San Francisco",
              "price": 996000
            },
            {
              "location": "New York",
              "price": 996000
            },
            {
              "location": "Oregon",
              "price": 896400
            }
          ],
          "currency": "USD",
          "includes": [
            "Monitoring appointments",
            "Anesthesia",
            "Retrieval",
            "Cryopreservation"
          ],
          "notes": "$9,960 for SF & NY locations; $8,964 for Oregon. Anesthesia is included (unlike most clinics)."
        },
        {
          "name": "Medication Package",
          "description": "Pre-negotiated pharmacy rates tailored to your protocol",
          "price": 390000,
          "priceMax": 510000,
          "currency": "USD",
          "includes": [
            "All medications for cycle",
            "Refills if protocol changes"
          ],
          "notes": "Patients save ~$1,500 on average. Federal assistance may reduce cost by $500 - $750/cycle."
        },
        {
          "name": "Future IVF (using frozen eggs)",
          "description": "Complete path from thaw to transfer when you're ready",
          "price": 2300000,
          "priceMax": 2500000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Blastocyst development",
            "Genetic testing",
            "FET medication",
            "Transfer"
          ]
        }
      ],
      "financingOptions": [
        {
          "name": "Internal Payment Plan",
          "description": "Low monthly payments with no down payment",
          "details": [
            "Under $300/month",
            "No down payment required",
            "Covers cycle cost only"
          ],
          "exclusions": "Does not cover consultation, medications, or storage fees",
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "PatientFi Financing",
          "description": "Healthcare financing with flexible repayment terms",
          "details": [
            "Third-party healthcare financing",
            "Flexible repayment options",
            "Quick approval process"
          ],
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "Multi-Cycle Discount",
          "description": "10% off for self-pay patients doing multiple cycles",
          "details": [
            "10% discount on additional cycles",
            "Available to self-pay patients only"
          ],
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "Spring Promise (Shared Risk)",
          "description": "Full refund if pregnancy is not achieved for qualifying patients",
          "details": [
            "Full refund guarantee if pregnancy not achieved",
            "Designed for qualifying egg freezing patients"
          ],
          "eligibility": "20 eggs by age 35, or 30 eggs by age 38",
          "exclusions": "IVF, anesthesia, and medications are excluded from the refund",
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        }
      ],
      "_source": {
        "url": "https://springfertility.com/pricing/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlCzQcQju02SVE-tdAy-3N8DKuMEQwXkEozDJhvbNCp9NbV4TPQj3F3yQmYilymLx0U52hxNFF_Z-VodKm3ul_w6bW74chGFcDeirQ4ZVUUNNwuEIGmN-0M6tCoHuSIwHorOPD-B934S7Ye=w426-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Spring+Fertility,+700+Stewart+Ave+%23200,+Garden+City,+NY+11530/@40.7320608,-73.6078618,3023a,13.1y/data=!4m2!3m1!1s0x89c27d8d77d2a5c1:0xf5dbd1a33e8c11b1",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Cigna, United Healthcare, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://springfertility.com/long-island/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "4 public price package(s) and 4 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://springfertility.com/pricing/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-kindbody-newport-beach",
    "externalIds": {
      "googlePlaceId": "ChIJC8uuGPTf3IARKuaNUr_FXuA"
    },
    "type": "fertility-clinic",
    "name": "Kindbody - Newport Beach",
    "description": "Kindbody's Newport Beach location offering comprehensive fertility services including IVF, egg freezing, and employer-sponsored fertility benefits in Orange County.",
    "website": "https://kindbody.com/newport-beach/",
    "phone": "(949) 432-7438",
    "bookingUrl": "https://kindbody.com/location/newport-beach-california/",
    "address": {
      "line1": "4321 Birch St",
      "city": "Newport Beach",
      "state": "CA",
      "zip": "92660",
      "country": "US"
    },
    "location": {
      "lat": 33.6615,
      "lng": -117.868
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Anthem",
        "Blue Cross Blue Shield",
        "Cigna",
        "Emblem Health",
        "Empire Blue Cross Blue Shield",
        "First Health",
        "Health Net",
        "Horizon",
        "Humana",
        "Maven",
        "Medicare",
        "Medicaid",
        "MultiPlan",
        "Optum",
        "Oscar",
        "Oxford",
        "Progyny",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "sections": {
        "pricing": {
          "status": "verified"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.kindbody.com/ivf-cost/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/newport-beach/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+Newport+Beach,+4321+Birch+St,+Newport+Beach,+CA+92660/@33.667858,-117.867381,3321a,13.1y/data=!4m2!3m1!1s0x80dcdff418aecb0b:0xe05ec5bf528de62a",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "Kindbody"
    },
    "pricing": {
      "packages": [
        {
          "name": "Pulse Assessment",
          "description": "Quick fertility check — not covered by insurance",
          "price": 9900,
          "currency": "USD",
          "includes": [
            "AMH blood test",
            "Transvaginal ultrasound for follicle count",
            "15-minute reproductive consultation"
          ],
          "notes": "Not covered by insurance"
        },
        {
          "name": "Fertility Consultation",
          "description": "Specialist consultation on fertility fundamentals",
          "price": 30000,
          "currency": "USD",
          "notes": "Billable to most insurance plans"
        },
        {
          "name": "Male Consultation + Semen Analysis",
          "price": 52500,
          "currency": "USD",
          "includes": ["Consultation", "Venipuncture", "Semen analysis"]
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Single egg freezing cycle",
          "price": 690000,
          "priceMax": 966000,
          "currency": "USD",
          "includes": [
            "Stimulation visits",
            "Ultrasounds",
            "Blood draws",
            "Retrieval",
            "Cryopreservation",
            "3 months storage",
            "Coordination"
          ],
          "excludes": ["Medications ($4,000 - $6,000)", "Anesthesia"]
        },
        {
          "name": "Annual Egg Storage",
          "price": 92000,
          "currency": "USD",
          "notes": "Per year"
        },
        {
          "name": "IVF Freeze All (Self Pay)",
          "description": "IVF cycle with all embryos frozen",
          "price": 1160000,
          "priceMax": 1850000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Cryopreservation",
            "3 months storage"
          ],
          "excludes": [
            "Medications (~$4,000 - $6,000)",
            "Embryo biopsy/genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Donor services",
            "Anesthesia"
          ]
        },
        {
          "name": "IVF Fresh Transfer (Self Pay)",
          "description": "IVF cycle with fresh embryo transfer",
          "price": 1380000,
          "priceMax": 1875000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$5,000 - $9,000)",
            "Genetic testing",
            "Surplus embryo storage",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Freeze All",
          "price": 910000,
          "priceMax": 1332000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Cryopreservation",
            "3-month storage"
          ],
          "excludes": [
            "Genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Fresh Transfer",
          "price": 990000,
          "priceMax": 1428000,
          "currency": "USD",
          "includes": [
            "Ultrasounds",
            "Thaw",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Surplus storage",
            "Frozen transfers",
            "Anesthesia"
          ]
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 400000,
          "priceMax": 550000,
          "currency": "USD",
          "includes": ["Ultrasounds", "Thaw", "Assisted hatching", "Transfer"],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "PGT Package",
          "description": "Preimplantation genetic testing",
          "price": 160000,
          "priceMax": 300000,
          "currency": "USD",
          "includes": ["Embryo biopsy", "Lab management"],
          "excludes": ["Storage", "Shipping", "Per-embryo testing costs"]
        },
        {
          "name": "Nutrition Coaching",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Counseling & Support",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Guided Meditation",
          "description": "Virtual wellness — 30-minute session",
          "price": 9000,
          "currency": "USD"
        }
      ],
      "financingOptions": [
        {
          "name": "PatientFi monthly payments",
          "description": "PatientFi monthly payments"
        }
      ],
      "disclaimer": "Prices vary by location. Medications and anesthesia are not included in procedure costs. 3 months of storage included with freeze procedures; annual storage is $920.",
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "team": [
      {
        "practitionerId": "pr-org-satellite-kindbody-newport-beach-lauren-w-sundheimer",
        "name": "Lauren W. Sundheimer",
        "credentials": ["MD", "MS", "FACOG"],
        "role": "Reproductive Endocrinologist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://kindbody.com/wp-content/uploads/2022/08/Lauren-Sundheimer-MD-EDIT-1024x1024.png",
        "_source": {
          "url": "https://kindbody.com/team/dr-lauren-sundheimer/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-kindbody-newport-beach-natalie-crump",
        "name": "Natalie Crump",
        "role": "Physician Assistant",
        "imageUrl": "https://kindbody.com/wp-content/uploads/2023/02/IMG_5124-768x1024.jpg",
        "_source": {
          "url": "https://kindbody.com/team/natalie-crump/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [
      {
        "url": "https://kindbody.com/wp-content/uploads/2023/10/004-1920x1075.jpg",
        "type": "interior"
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmn3X9KqGSJn6AxuvOMeJRwC5C5WfpHFrh72MBhZGemITNVwZUHGpYbvQFYMdvKTUbyYrd0_YVwG8xs_JIkmpV84lQP8IlO_6jMhowMtoiaysi1AYfGRvdlJagvYBjS6rPYDxk2iQ=w508-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Newport+Beach,+4321+Birch+St,+Newport+Beach,+CA+92660/@33.667858,-117.867381,3321a,13.1y/data=!4m2!3m1!1s0x80dcdff418aecb0b:0xe05ec5bf528de62a",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Blue Cross Blue Shield, Cigna, Emblem Health, Empire Blue Cross Blue Shield, First Health, Health Net",
              "detail": "12 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "14 public price package(s) and 1 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-kindbody-san-diego",
    "externalIds": {
      "googlePlaceId": "ChIJESIe4RkH3IARbOfMErA1zW4"
    },
    "type": "fertility-clinic",
    "name": "Kindbody - San Diego",
    "description": "Kindbody's San Diego location in La Jolla offering comprehensive fertility services including IVF, egg freezing, and employer-sponsored fertility benefits.",
    "website": "https://kindbody.com/san-diego-location-page/",
    "phone": "(619) 673-8658",
    "bookingUrl": "https://kindbody.com/location/san-diego-california/",
    "address": {
      "line1": "4150 Regents Park Row, Suite 321",
      "city": "La Jolla",
      "state": "CA",
      "zip": "92037",
      "country": "US"
    },
    "location": {
      "lat": 32.8711,
      "lng": -117.2268
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Anthem",
        "Blue Cross Blue Shield",
        "Cigna",
        "Emblem Health",
        "Empire Blue Cross Blue Shield",
        "First Health",
        "Health Net",
        "Horizon",
        "Humana",
        "Maven",
        "Medicare",
        "Medicaid",
        "MultiPlan",
        "Optum",
        "Oscar",
        "Oxford",
        "Progyny",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "sections": {
        "pricing": {
          "status": "verified"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.kindbody.com/ivf-cost/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/san-diego-location-page/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+San+Diego,+4150+Regents+Park+Row+Ste+321,+La+Jolla,+CA+92037/@32.8732164,-117.2171209,3351a,13.1y/data=!4m2!3m1!1s0x80dc0719e11e2211:0x6ecd35b012cce76c",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "Kindbody"
    },
    "pricing": {
      "packages": [
        {
          "name": "Pulse Assessment",
          "description": "Quick fertility check — not covered by insurance",
          "price": 9900,
          "currency": "USD",
          "includes": [
            "AMH blood test",
            "Transvaginal ultrasound for follicle count",
            "15-minute reproductive consultation"
          ],
          "notes": "Not covered by insurance"
        },
        {
          "name": "Fertility Consultation",
          "description": "Specialist consultation on fertility fundamentals",
          "price": 30000,
          "currency": "USD",
          "notes": "Billable to most insurance plans"
        },
        {
          "name": "Male Consultation + Semen Analysis",
          "price": 52500,
          "currency": "USD",
          "includes": ["Consultation", "Venipuncture", "Semen analysis"]
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Single egg freezing cycle",
          "price": 690000,
          "priceMax": 966000,
          "currency": "USD",
          "includes": [
            "Stimulation visits",
            "Ultrasounds",
            "Blood draws",
            "Retrieval",
            "Cryopreservation",
            "3 months storage",
            "Coordination"
          ],
          "excludes": ["Medications ($4,000 - $6,000)", "Anesthesia"]
        },
        {
          "name": "Annual Egg Storage",
          "price": 92000,
          "currency": "USD",
          "notes": "Per year"
        },
        {
          "name": "IVF Freeze All (Self Pay)",
          "description": "IVF cycle with all embryos frozen",
          "price": 1160000,
          "priceMax": 1850000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Cryopreservation",
            "3 months storage"
          ],
          "excludes": [
            "Medications (~$4,000 - $6,000)",
            "Embryo biopsy/genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Donor services",
            "Anesthesia"
          ]
        },
        {
          "name": "IVF Fresh Transfer (Self Pay)",
          "description": "IVF cycle with fresh embryo transfer",
          "price": 1380000,
          "priceMax": 1875000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$5,000 - $9,000)",
            "Genetic testing",
            "Surplus embryo storage",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Freeze All",
          "price": 910000,
          "priceMax": 1332000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Cryopreservation",
            "3-month storage"
          ],
          "excludes": [
            "Genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Fresh Transfer",
          "price": 990000,
          "priceMax": 1428000,
          "currency": "USD",
          "includes": [
            "Ultrasounds",
            "Thaw",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Surplus storage",
            "Frozen transfers",
            "Anesthesia"
          ]
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 400000,
          "priceMax": 550000,
          "currency": "USD",
          "includes": ["Ultrasounds", "Thaw", "Assisted hatching", "Transfer"],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "PGT Package",
          "description": "Preimplantation genetic testing",
          "price": 160000,
          "priceMax": 300000,
          "currency": "USD",
          "includes": ["Embryo biopsy", "Lab management"],
          "excludes": ["Storage", "Shipping", "Per-embryo testing costs"]
        },
        {
          "name": "Nutrition Coaching",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Counseling & Support",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Guided Meditation",
          "description": "Virtual wellness — 30-minute session",
          "price": 9000,
          "currency": "USD"
        }
      ],
      "financingOptions": [
        {
          "name": "PatientFi monthly payments",
          "description": "PatientFi monthly payments"
        }
      ],
      "disclaimer": "Prices vary by location. Medications and anesthesia are not included in procedure costs. 3 months of storage included with freeze procedures; annual storage is $920.",
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "team": [
      {
        "practitionerId": "pr-org-satellite-kindbody-san-diego-lauren-w-sundheimer",
        "name": "Lauren W. Sundheimer",
        "credentials": ["MD", "MS", "FACOG"],
        "role": "Reproductive Endocrinologist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://kindbody.com/wp-content/uploads/2022/08/Lauren-Sundheimer-MD-EDIT-1024x1024.png",
        "_source": {
          "url": "https://kindbody.com/team/dr-lauren-sundheimer/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-kindbody-san-diego-abigail-armstrong",
        "name": "Abigail Armstrong",
        "role": "Reproductive Endocrinologist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://kindbody.com/wp-content/uploads/2023/09/IMG_8564-edit-cropped-blur-768x1024.jpg",
        "_source": {
          "url": "https://kindbody.com/team/dr-abigail-armstrong/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Blue Cross Blue Shield, Cigna, Emblem Health, Empire Blue Cross Blue Shield, First Health, Health Net",
              "detail": "12 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "14 public price package(s) and 1 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlu-pumkAbxBN0z53lFDYIx1Eht8fxLdIlCQzHBUjluKlIzyjQ7z0eys_AnXz5cqO_lq8TiedKeXnJywFhtiQ1vDVHXd5pDTGeDKL9iEB_8Pkb-I88fz8kcXQCw8pm0tVkuXYGz=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+San+Diego,+4150+Regents+Park+Row+Ste+321,+La+Jolla,+CA+92037/@32.8732164,-117.2171209,3351a,13.1y/data=!4m2!3m1!1s0x80dc0719e11e2211:0x6ecd35b012cce76c",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-kindbody-walnut-creek",
    "externalIds": {
      "googlePlaceId": "ChIJp2lzAmhhhYAR_N1s1jk1wGk"
    },
    "type": "fertility-clinic",
    "name": "Kindbody - Walnut Creek",
    "description": "Kindbody's Walnut Creek location serving the East Bay and Contra Costa County with comprehensive fertility services.",
    "website": "https://kindbody.com/location/walnut-creek-california/",
    "phone": "(925) 322-2115",
    "bookingUrl": "https://kindbody.com/location/walnut-creek-california/",
    "address": {
      "line1": "1700 N Main St",
      "city": "Walnut Creek",
      "state": "CA",
      "zip": "94596",
      "country": "US"
    },
    "location": {
      "lat": 37.9058,
      "lng": -122.0634
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Anthem",
        "Blue Cross Blue Shield",
        "Cigna",
        "Emblem Health",
        "Empire Blue Cross Blue Shield",
        "First Health",
        "Health Net",
        "Horizon",
        "Humana",
        "Maven",
        "Medicare",
        "Medicaid",
        "MultiPlan",
        "Optum",
        "Oscar",
        "Oxford",
        "Progyny",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "sections": {
        "pricing": {
          "status": "verified"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.kindbody.com/ivf-cost/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/east-bay-location/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+Walnut+Creek,+1700+N+Main+St,+Walnut+Creek,+CA+94596/@37.9022462,-122.0618609,3148a,13.1y/data=!4m2!3m1!1s0x80856168027369a7:0x69c03539d66cddfc",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "Kindbody"
    },
    "pricing": {
      "packages": [
        {
          "name": "Pulse Assessment",
          "description": "Quick fertility check — not covered by insurance",
          "price": 9900,
          "currency": "USD",
          "includes": [
            "AMH blood test",
            "Transvaginal ultrasound for follicle count",
            "15-minute reproductive consultation"
          ],
          "notes": "Not covered by insurance"
        },
        {
          "name": "Fertility Consultation",
          "description": "Specialist consultation on fertility fundamentals",
          "price": 30000,
          "currency": "USD",
          "notes": "Billable to most insurance plans"
        },
        {
          "name": "Male Consultation + Semen Analysis",
          "price": 52500,
          "currency": "USD",
          "includes": ["Consultation", "Venipuncture", "Semen analysis"]
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Single egg freezing cycle",
          "price": 690000,
          "priceMax": 966000,
          "currency": "USD",
          "includes": [
            "Stimulation visits",
            "Ultrasounds",
            "Blood draws",
            "Retrieval",
            "Cryopreservation",
            "3 months storage",
            "Coordination"
          ],
          "excludes": ["Medications ($4,000 - $6,000)", "Anesthesia"]
        },
        {
          "name": "Annual Egg Storage",
          "price": 92000,
          "currency": "USD",
          "notes": "Per year"
        },
        {
          "name": "IVF Freeze All (Self Pay)",
          "description": "IVF cycle with all embryos frozen",
          "price": 1160000,
          "priceMax": 1850000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Cryopreservation",
            "3 months storage"
          ],
          "excludes": [
            "Medications (~$4,000 - $6,000)",
            "Embryo biopsy/genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Donor services",
            "Anesthesia"
          ]
        },
        {
          "name": "IVF Fresh Transfer (Self Pay)",
          "description": "IVF cycle with fresh embryo transfer",
          "price": 1380000,
          "priceMax": 1875000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$5,000 - $9,000)",
            "Genetic testing",
            "Surplus embryo storage",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Freeze All",
          "price": 910000,
          "priceMax": 1332000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Cryopreservation",
            "3-month storage"
          ],
          "excludes": [
            "Genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Fresh Transfer",
          "price": 990000,
          "priceMax": 1428000,
          "currency": "USD",
          "includes": [
            "Ultrasounds",
            "Thaw",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Surplus storage",
            "Frozen transfers",
            "Anesthesia"
          ]
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 400000,
          "priceMax": 550000,
          "currency": "USD",
          "includes": ["Ultrasounds", "Thaw", "Assisted hatching", "Transfer"],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "PGT Package",
          "description": "Preimplantation genetic testing",
          "price": 160000,
          "priceMax": 300000,
          "currency": "USD",
          "includes": ["Embryo biopsy", "Lab management"],
          "excludes": ["Storage", "Shipping", "Per-embryo testing costs"]
        },
        {
          "name": "Nutrition Coaching",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Counseling & Support",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Guided Meditation",
          "description": "Virtual wellness — 30-minute session",
          "price": 9000,
          "currency": "USD"
        }
      ],
      "financingOptions": [
        {
          "name": "PatientFi monthly payments",
          "description": "PatientFi monthly payments"
        }
      ],
      "disclaimer": "Prices vary by location. Medications and anesthesia are not included in procedure costs. 3 months of storage included with freeze procedures; annual storage is $920.",
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "team": [
      {
        "practitionerId": "pr-org-satellite-kindbody-walnut-creek-geraldine-ekpo",
        "name": "Geraldine Ekpo",
        "role": "Reproductive Endocrinologist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://kindbody.com/wp-content/uploads/2022/01/Ekpo_Web2-683x1024.jpg",
        "_source": {
          "url": "https://kindbody.com/team/dr-geraldine-ekpo/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-kindbody-walnut-creek-shawn-breen",
        "name": "Shawn Breen",
        "credentials": ["PhD", "HCLD (ABB)"],
        "role": "Regional Laboratory Director, Clinical Laboratory Program Director",
        "imageUrl": "https://kindbody.com/wp-content/uploads/2023/09/37.png",
        "_source": {
          "url": "https://kindbody.com/team/dr-shawn-breen-phd-hcld-abb/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [
      {
        "url": "https://kindbody.com/wp-content/uploads/2024/01/East-Bay-Exterior.jpg",
        "type": "exterior"
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWktjXhPAA3bm-TynFaxFYx7yB-tuuU61EP3OGIGSmKnmKMAK_wsh9KZ1_9XYKtpy7HRAW47sCa7PpCK7mrssp5DU5CYkj_6UQPk0hFMoenlBaKuIonCY0SQWR_K5T8oDpJkfQPv=w513-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Walnut+Creek,+1700+N+Main+St,+Walnut+Creek,+CA+94596/@37.9022462,-122.0618609,3148a,13.1y/data=!4m2!3m1!1s0x80856168027369a7:0x69c03539d66cddfc",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Blue Cross Blue Shield, Cigna, Emblem Health, Empire Blue Cross Blue Shield, First Health, Health Net",
              "detail": "12 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "14 public price package(s) and 1 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-kindbody-dallas",
    "externalIds": {
      "googlePlaceId": "ChIJRVzakLufToYRxT1GhwL5Z-4"
    },
    "type": "fertility-clinic",
    "name": "Kindbody - Dallas",
    "description": "Kindbody's Dallas location offering comprehensive fertility services including IVF, egg freezing, and employer-sponsored fertility benefits.",
    "website": "https://kindbody.com/location/dallas-texas/",
    "phone": "(214) 239-2743",
    "bookingUrl": "https://kindbody.com/location/dallas-texas/",
    "address": {
      "line1": "8041 Walnut Hill Ln, Unit 870",
      "city": "Dallas",
      "state": "TX",
      "zip": "75231",
      "country": "US"
    },
    "location": {
      "lat": 32.8741,
      "lng": -96.7618
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Anthem",
        "Blue Cross Blue Shield",
        "Cigna",
        "Emblem Health",
        "Empire Blue Cross Blue Shield",
        "First Health",
        "Health Net",
        "Horizon",
        "Humana",
        "Maven",
        "Medicare",
        "Medicaid",
        "MultiPlan",
        "Optum",
        "Oscar",
        "Oxford",
        "Progyny",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual",
      "sections": {
        "pricing": {
          "status": "verified"
        },
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.kindbody.com/ivf-cost/",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+Dallas,+8041+Walnut+Hill+Ln+Unit+870,+Dallas,+TX+75231/@32.8814555,-96.7680529,3351a,13.1y/data=!4m2!3m1!1s0x864e9fbb90da5c45:0xee67f90287463dc5",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "Kindbody"
    },
    "pricing": {
      "packages": [
        {
          "name": "Pulse Assessment",
          "description": "Quick fertility check — not covered by insurance",
          "price": 9900,
          "currency": "USD",
          "includes": [
            "AMH blood test",
            "Transvaginal ultrasound for follicle count",
            "15-minute reproductive consultation"
          ],
          "notes": "Not covered by insurance"
        },
        {
          "name": "Fertility Consultation",
          "description": "Specialist consultation on fertility fundamentals",
          "price": 30000,
          "currency": "USD",
          "notes": "Billable to most insurance plans"
        },
        {
          "name": "Male Consultation + Semen Analysis",
          "price": 52500,
          "currency": "USD",
          "includes": ["Consultation", "Venipuncture", "Semen analysis"]
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Single egg freezing cycle",
          "price": 690000,
          "priceMax": 966000,
          "currency": "USD",
          "includes": [
            "Stimulation visits",
            "Ultrasounds",
            "Blood draws",
            "Retrieval",
            "Cryopreservation",
            "3 months storage",
            "Coordination"
          ],
          "excludes": ["Medications ($4,000 - $6,000)", "Anesthesia"]
        },
        {
          "name": "Annual Egg Storage",
          "price": 92000,
          "currency": "USD",
          "notes": "Per year"
        },
        {
          "name": "IVF Freeze All (Self Pay)",
          "description": "IVF cycle with all embryos frozen",
          "price": 1160000,
          "priceMax": 1850000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Cryopreservation",
            "3 months storage"
          ],
          "excludes": [
            "Medications (~$4,000 - $6,000)",
            "Embryo biopsy/genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Donor services",
            "Anesthesia"
          ]
        },
        {
          "name": "IVF Fresh Transfer (Self Pay)",
          "description": "IVF cycle with fresh embryo transfer",
          "price": 1380000,
          "priceMax": 1875000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$5,000 - $9,000)",
            "Genetic testing",
            "Surplus embryo storage",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Freeze All",
          "price": 910000,
          "priceMax": 1332000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Cryopreservation",
            "3-month storage"
          ],
          "excludes": [
            "Genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Fresh Transfer",
          "price": 990000,
          "priceMax": 1428000,
          "currency": "USD",
          "includes": [
            "Ultrasounds",
            "Thaw",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Surplus storage",
            "Frozen transfers",
            "Anesthesia"
          ]
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 400000,
          "priceMax": 550000,
          "currency": "USD",
          "includes": ["Ultrasounds", "Thaw", "Assisted hatching", "Transfer"],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "PGT Package",
          "description": "Preimplantation genetic testing",
          "price": 160000,
          "priceMax": 300000,
          "currency": "USD",
          "includes": ["Embryo biopsy", "Lab management"],
          "excludes": ["Storage", "Shipping", "Per-embryo testing costs"]
        },
        {
          "name": "Nutrition Coaching",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Counseling & Support",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Guided Meditation",
          "description": "Virtual wellness — 30-minute session",
          "price": 9000,
          "currency": "USD"
        }
      ],
      "financingOptions": [
        {
          "name": "PatientFi monthly payments",
          "description": "PatientFi monthly payments"
        }
      ],
      "disclaimer": "Prices vary by location. Medications and anesthesia are not included in procedure costs. 3 months of storage included with freeze procedures; annual storage is $920.",
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Blue Cross Blue Shield, Cigna, Emblem Health, Empire Blue Cross Blue Shield, First Health, Health Net",
              "detail": "12 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "14 public price package(s) and 1 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlXNtNDjr83XEvkIRlnVNnNLf2a1d7SE2FZ1w9H6jPtDLw_lu5d8piZ84sg4JYR63Ncca7ibOdN4HBIaLKaCQ-Iqu3E6onMij-U2qZrRO6jlX5T-wzZMl-8IJ6hEp5xOA=w408-h307-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Dallas,+8041+Walnut+Hill+Ln+Unit+870,+Dallas,+TX+75231/@32.8814555,-96.7680529,3351a,13.1y/data=!4m2!3m1!1s0x864e9fbb90da5c45:0xee67f90287463dc5",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm6FLoq-fHPBafWGWuXmlNRkvYXbvy4MADUnCoE6ToZi7oP9Jv4obfJk8HE2GgI8xaaVwUXxrd3mMA6CbGddj_UQW59g5kWVxBnxJVzLz3kBlfD4LIOMWP33fUrK-sUPjI1MNcL=w395-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Dallas,+8041+Walnut+Hill+Ln+Unit+870,+Dallas,+TX+75231/@32.8814555,-96.7680529,3351a,13.1y/data=!4m2!3m1!1s0x864e9fbb90da5c45:0xee67f90287463dc5",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-rma-palo-alto",
    "externalIds": {
      "googlePlaceId": "ChIJ6RwjKJW7j4ARlg-MGUAJsmY"
    },
    "type": "fertility-clinic",
    "name": "RMA Northern California - Palo Alto",
    "description": "RMA Northern California fertility clinic in East Palo Alto, CA. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/rma-northern-california/",
    "phone": "(650) 618-6070",
    "bookingUrl": "https://rmanetwork.com/our-locations/rma-northern-california/",
    "address": {
      "line1": "1900 University Ave, Suite 101",
      "city": "East Palo Alto",
      "state": "CA",
      "zip": "94303",
      "country": "US"
    },
    "location": {
      "lat": 37.459,
      "lng": -122.1389
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/rma-northern-california/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-northern-california/palo-alto-ca/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+Northern+California+%7C+Palo+Alto,+1900+University+Ave+101+e,+Palo+Alto,+CA+94303/@37.4590561,-122.1428211,3167a,13.1y/data=!4m2!3m1!1s0x808fbb9528231ce9:0x66b20940198c0f96",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-satellite-rma-palo-alto-brent-m-hanson",
        "name": "Brent M. Hanson",
        "credentials": ["MD"],
        "role": "REPRODUCTIVE ENDOCRINOLOGIST",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2026/03/Doctor-Page-Mobile-Image-264-x-264-px-7.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-northern-california/palo-alto-ca/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-rma-palo-alto-daniel-j-kaser",
        "name": "Daniel J. Kaser",
        "credentials": ["MD", "FACOG"],
        "role": "PHYSICIAN PARTNER, REPRODUCTIVE ENDOCRINOLOGIST",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2021/02/Untitled-design-88-1.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-northern-california/palo-alto-ca/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-rma-palo-alto-scott-j-morin",
        "name": "Scott J. Morin",
        "credentials": ["MD", "FACOG"],
        "role": "PHYSICIAN PARTNER, WEST COAST MEDICAL DIRECTOR, REPRODUCTIVE ENDOCRINOLOGIST",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2021/02/Untitled-design-2021-07-07T113836.128.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-northern-california/palo-alto-ca/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-rma-palo-alto-jonathan-d-kort",
        "name": "Jonathan D. Kort",
        "credentials": ["MD", "FACOG"],
        "role": "PHYSICIAN PARTNER, REPRODUCTIVE ENDOCRINOLOGIST",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2021/02/Untitled-design-89-1.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-northern-california/palo-alto-ca/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-rma-palo-alto-puneet-masson",
        "name": "Puneet Masson",
        "credentials": ["MD"],
        "role": "UROLOGIST",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/09/Doctor-Page-Mobile-Image-264-x-264-px-8.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-northern-california/palo-alto-ca/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [
      {
        "url": "https://rmanetwork.com/wp-content/uploads/2025/05/website-image-6.jpg",
        "type": "exterior"
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmuxDU14jj9VJtVdv_N6EveWmT0X1FjOTbZKWLJuo-pvkUyEyddosbtBR8zgw3GZuINXniuKBIrYddMla6cstogHQVs_7PQ60NZfsULuAO1t18zNmm79rfkNYC5rv_avPjp60hC-Q=w551-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+Northern+California+%7C+Palo+Alto,+1900+University+Ave+101+e,+Palo+Alto,+CA+94303/@37.4590561,-122.1428211,3167a,13.1y/data=!4m2!3m1!1s0x808fbb9528231ce9:0x66b20940198c0f96",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/rma-northern-california/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-rma-danville",
    "externalIds": {
      "googlePlaceId": "ChIJoeBZYHHzj4AR1sT_cPV0V3c"
    },
    "type": "fertility-clinic",
    "name": "RMA Northern California - Danville",
    "description": "RMA Northern California fertility clinic in Danville, CA. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/rma-northern-california/",
    "phone": "(209) 791-6220",
    "bookingUrl": "https://rmanetwork.com/our-locations/rma-northern-california/",
    "address": {
      "line1": "1320 El Capitan Dr, Suite 410",
      "city": "Danville",
      "state": "CA",
      "zip": "94526",
      "country": "US"
    },
    "location": {
      "lat": 37.8204,
      "lng": -121.9558
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/rma-northern-california/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-northern-california/danville-ca/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+Northern+California+-+Danville,+1320+El+Capitan+Dr+Suite+410,+Danville,+CA+94526/@37.7843164,-121.9667245,3153a,13.1y/data=!4m2!3m1!1s0x808ff3716059e0a1:0x775774f570ffc4d6",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-satellite-rma-danville-brent-m-hanson",
        "name": "Brent M. Hanson",
        "credentials": ["MD"],
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2026/03/Doctor-Page-Mobile-Image-264-x-264-px-7.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/brent-hanson/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-rma-danville-scott-j-morin",
        "name": "Scott J. Morin",
        "credentials": ["MD", "FACOG"],
        "role": "Physician Partner, West Coast Medical Director, Reproductive Endocrinologist",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2021/02/Untitled-design-2021-07-07T113836.128.jpg",
        "_source": {
          "url": "https://rmanetwork.com/staff/scott-morin/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-rma-danville-alice-shapiro",
        "name": "Alice Shapiro",
        "credentials": ["MD", "FACOG"],
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2022/10/Untitled-design-40.jpg",
        "_source": {
          "url": "https://rmanetwork.com/staff/alice-shapiro-md/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/rma-northern-california/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-satellite-rma-burbank",
    "externalIds": {
      "googlePlaceId": "ChIJeZTSWsS_woARor4NX5sNlzg"
    },
    "type": "fertility-clinic",
    "name": "RMA Southern California - Burbank",
    "description": "RMA Southern California fertility clinic in Burbank, CA. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/rma-southern-california/",
    "phone": "(818) 237-9388",
    "bookingUrl": "https://rmanetwork.com/our-locations/rma-southern-california/",
    "address": {
      "line1": "2601 W Alameda Ave, Suite 404",
      "city": "Burbank",
      "state": "CA",
      "zip": "91505",
      "country": "US"
    },
    "location": {
      "lat": 34.1536,
      "lng": -118.3326
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/rma-southern-california/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-southern-california/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+Southern+California+%7C+Burbank,+2601+W+Alameda+Ave+Ste+404,+Burbank,+CA+91505/@34.1580026,-118.3294976,3302a,13.1y/data=!4m2!3m1!1s0x80c2bfc45ad29479:0x38970d9b5f0dbea2",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-satellite-rma-burbank-thomas-j-kim",
        "name": "Thomas J. Kim",
        "credentials": ["MD", "FACOG", "HCLD(ABB)", "MT(AAB)"],
        "role": "Reproductive Endocrinologist, Medical/Laboratory Director",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2021/02/Untitled-design-21-1.jpg",
        "_source": {
          "url": "https://rmanetwork.com/staff/thomas-j-kim/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-rma-burbank-melanie-f-landay",
        "name": "Melanie F. Landay",
        "credentials": ["MD", "FACOG"],
        "role": "Reproductive Endocrinologist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2021/12/Untitled-design.jpg",
        "_source": {
          "url": "https://rmanetwork.com/staff/melanie-f-landay-md/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-rma-burbank-keri-bergin",
        "name": "Keri Bergin",
        "credentials": ["MD"],
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/keri-bergin-md/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-rma-burbank-deena-dubrow",
        "name": "Deena Dubrow",
        "role": "Associate Genetic Counselor",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2026/03/Deena-Dubrow_Genetic_Counselor.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-southern-california/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-rma-burbank-amber-kaplun",
        "name": "Amber Kaplun",
        "role": "Genetic Counselor",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2023/04/Untitled-design-4.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-southern-california/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-rma-burbank-allison-boyd",
        "name": "Allison Boyd",
        "role": "Genetic Counselor",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2023/04/Untitled-design-3.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-southern-california/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/rma-southern-california/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-rma-mission-viejo",
    "externalIds": {
      "googlePlaceId": "ChIJg3hRZsfv3IARKPB46JC-7GQ"
    },
    "type": "fertility-clinic",
    "name": "RMA Orange County - Mission Viejo",
    "description": "RMA Orange County fertility clinic in Mission Viejo, CA. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/rma-orange-county-california/",
    "phone": "(877) 747-3483",
    "bookingUrl": "https://rmanetwork.com/our-locations/rma-orange-county-california/",
    "address": {
      "line1": "26800 Crown Valley Pkwy, Suite 455",
      "city": "Mission Viejo",
      "state": "CA",
      "zip": "92691",
      "country": "US"
    },
    "location": {
      "lat": 33.5467,
      "lng": -117.6609
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/rma-orange-county-california/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-orange-county-california/mission-viejo-ca-fertility-clinic/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+Southern+California+-+Mission+Viejo,+CA,+26800+Crown+Valley+Pkwy+%23455,+Mission+Viejo,+CA+92691/@33.5624278,-117.6671728,3325a,13.1y/data=!4m2!3m1!1s0x80dcefc766517883:0x64ecbe90e878f028",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-satellite-rma-mission-viejo-sanaz-ghazal",
        "name": "Sanaz Ghazal",
        "credentials": ["MD", "FACOG"],
        "role": "REPRODUCTIVE ENDOCRINOLOGIST",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/04/Untitled-design-11.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-orange-county-california/mission-viejo-ca-fertility-clinic/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-rma-mission-viejo-marcus-rosencrantz",
        "name": "Marcus Rosencrantz",
        "credentials": ["MD", "FACOG"],
        "role": "REPRODUCTIVE ENDOCRINOLOGIST",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/05/Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-orange-county-california/mission-viejo-ca-fertility-clinic/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-rma-mission-viejo-heidi-ozaeta",
        "name": "Heidi Ozaeta",
        "credentials": ["NP", "RN", "WHNP-BC"],
        "role": "NURSE PRACTITIONER",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2026/05/Untitled-design-28.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-orange-county-california/mission-viejo-ca-fertility-clinic/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-rma-mission-viejo-cindy-anderson",
        "name": "Cindy Anderson",
        "credentials": ["NP"],
        "role": "NURSE PRACTITIONER",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/05/Doctor-Mobile-website-headshot-264-x-264-px-1.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-orange-county-california/mission-viejo-ca-fertility-clinic/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlkDPEHHy8R4N_gcxvbW5O6hL1YVHrfdGbGE64IYUdm1DGcMcGfUm91nQJ-gQIJ8slX47L4397eMXnHnZGxi_0sY6pt5BIXid05HsyL9LHO3G1wB1XCidb4P-jKWKDsfr5drWek=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+Southern+California+-+Mission+Viejo,+CA,+26800+Crown+Valley+Pkwy+%23455,+Mission+Viejo,+CA+92691/@33.5624278,-117.6671728,3325a,13.1y/data=!4m2!3m1!1s0x80dcefc766517883:0x64ecbe90e878f028",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmktlQRn0qbkeODMai4BUW6oKJlWA9rS7MSFAAIyTut5T7FGEC8cmF_MsvqGDxnQTE8hQGVM2cyKJkOHEt8RF-g44vs2TWe64rTPCszm5sT_CeRHb25i1EkWkKh4YnXOloZgXRo=w360-h240-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+Southern+California+-+Mission+Viejo,+CA,+26800+Crown+Valley+Pkwy+%23455,+Mission+Viejo,+CA+92691/@33.5624278,-117.6671728,3325a,13.1y/data=!4m2!3m1!1s0x80dcefc766517883:0x64ecbe90e878f028",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/rma-orange-county-california/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-rma-newport-beach",
    "externalIds": {
      "googlePlaceId": "ChIJqRxiO3gh3YARdOLF_DIsiW8"
    },
    "type": "fertility-clinic",
    "name": "RMA Orange County - Newport Beach",
    "description": "RMA Orange County fertility clinic in Newport Beach, CA. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/rma-orange-county-california/",
    "phone": "(877) 747-3483",
    "bookingUrl": "https://rmanetwork.com/our-locations/rma-orange-county-california/",
    "address": {
      "line1": "3333 W Coast Hwy, Suite 300",
      "city": "Newport Beach",
      "state": "CA",
      "zip": "92663",
      "country": "US"
    },
    "location": {
      "lat": 33.6175,
      "lng": -117.9296
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/rma-orange-county-california/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-orange-county-california/newport-beach-fertility-clinic/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+Southern+California+-+Newport+Beach,+3333+West+Coast+Hwy+%23300,+Newport+Beach,+CA+92663/@33.6208104,-117.9271788,3322a,13.1y/data=!4m2!3m1!1s0x80dd21783b621ca9:0x6f892c32fcc5e274",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-satellite-rma-newport-beach-sanaz-ghazal",
        "name": "Sanaz Ghazal",
        "credentials": ["MD", "FACOG"],
        "role": "REPRODUCTIVE ENDOCRINOLOGIST",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/04/Untitled-design-11.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-orange-county-california/newport-beach-fertility-clinic/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-rma-newport-beach-heidi-ozaeta",
        "name": "Heidi Ozaeta",
        "credentials": ["NP", "RN", "WHNP-BC"],
        "role": "NURSE PRACTITIONER",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2026/05/Untitled-design-28.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-orange-county-california/newport-beach-fertility-clinic/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [
      {
        "url": "https://rmanetwork.com/wp-content/uploads/2025/05/website-image-580-x-330-px.jpg",
        "type": "interior"
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkomz6e1c1mda64_clYO91kQkPfcTnTe1NT-J4368HujVIMLCZrobC06nR4OgYgGc0DGT-Vsd7H_rbblMuEk_dQqwEcDW9TweQx7_rnL8UOKY2mgFFg3H2kIduTicgbvXOXYeE=w224-h298-k-no-pi-0.77099425-ya14.987103-ro-0.25385293-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+Southern+California+-+Newport+Beach,+3333+West+Coast+Hwy+%23300,+Newport+Beach,+CA+92663/@33.6208104,-117.9271788,3322a,13.1y/data=!4m2!3m1!1s0x80dd21783b621ca9:0x6f892c32fcc5e274",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/rma-orange-county-california/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-rma-denver",
    "externalIds": {
      "googlePlaceId": "ChIJyxkYFBx8bIcRRI8yfEq64qw"
    },
    "type": "fertility-clinic",
    "name": "Conceptions RMA - Denver",
    "description": "Conceptions RMA fertility clinic in Denver, CO. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/conceptions-reproductive-associates-of-colorado-rma/",
    "phone": "(303) 720-7887",
    "bookingUrl": "https://rmanetwork.com/our-locations/conceptions-reproductive-associates-of-colorado-rma/",
    "address": {
      "line1": "4500 E 9th Ave, Suite 630",
      "city": "Denver",
      "state": "CO",
      "zip": "80220",
      "country": "US"
    },
    "location": {
      "lat": 39.7322,
      "lng": -104.9435
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/conceptions-reproductive-associates-of-colorado-rma/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.conceptionsrepro.com/providers/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Conceptions+Reproductive+Associates+of+Colorado+%7C+RMA,+4500+E+9th+Ave+%23630,+Denver,+CO+80220/@39.7307544,-104.9342768,3068a,13.1y/data=!4m2!3m1!1s0x876c7c1c141819cb:0xace2ba4a7c328f44",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Mark Bush, MD",
        "role": "Reproductive Endocrinologist (Physician Partner)",
        "credentials": ["MD", "FACOG", "FACS"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2022/01/1.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/staff/mark-bush/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-denver-mark-bush-md"
      },
      {
        "name": "Robert Greene, MD",
        "role": "Reproductive Endocrinologist (Physician Partner)",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2022/01/2.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/staff/robert-greene/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-denver-robert-greene-md"
      },
      {
        "name": "Althea O'Shaughnessy, MD",
        "role": "Reproductive Endocrinologist (Physician Partner)",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2022/01/4.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/staff/althea-oshaughnessy/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-denver-althea-o-shaughnessy-md"
      },
      {
        "name": "Jasmine Chiang, MD",
        "role": "Reproductive Endocrinologist (Physician Partner)",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2022/01/6.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/staff/jasmine-chiang/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-denver-jasmine-chiang-md"
      },
      {
        "name": "Aimee Ferrandino, MD",
        "role": "Obstetrician-Gynecologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2024/10/Untitled-design-47.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/staff/aimee-ferrandino/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-denver-aimee-ferrandino-md"
      },
      {
        "name": "Malgorzata E. Skaznik-Wikiel, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2023/05/gosia-square.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/staff/malgorzata-e-skaznik-wikiel/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-denver-malgorzata-e-skaznik-wikiel-md"
      },
      {
        "name": "Simone Elder, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2025/08/Doctor-Mobile-website-headshot-264-x-264-px-400-x-400-px-1.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/staff/simone-elder-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-denver-simone-elder-md"
      },
      {
        "name": "Elle Barela, PA-C",
        "role": "Physician Assistant (Advanced Practice Provider)",
        "credentials": ["PA-C"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2024/08/Untitled-design-39.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/advanced-practice-provider-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-denver-elle-barela-pa-c"
      },
      {
        "name": "Amanda Bird, PA-C",
        "role": "Physician Assistant (Advanced Practice Provider)",
        "credentials": ["MPAS", "PA-C"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2022/08/Untitled-design-1.jpg",
        "_source": {
          "url": "https://www.conceptionsrepro.com/advanced-practice-provider-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-denver-amanda-bird-pa-c"
      },
      {
        "name": "Stephanie Kagan, WHNP",
        "role": "Women's Health Nurse Practitioner (Advanced Practice Provider)",
        "credentials": ["MSN", "WHNP"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2022/02/10.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/advanced-practice-provider-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-denver-stephanie-kagan-whnp"
      },
      {
        "name": "Chelsea Reed, FNP",
        "role": "Family Nurse Practitioner (Advanced Practice Provider)",
        "credentials": ["MSN", "FNP"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2022/02/9.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/advanced-practice-provider-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-denver-chelsea-reed-fnp"
      },
      {
        "name": "Channing Wells, WHNP-BC",
        "role": "Women's Health Nurse Practitioner (Advanced Practice Provider)",
        "credentials": ["WHNP-BC"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2025/01/Untitled-design-1.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/advanced-practice-provider-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-denver-channing-wells-whnp-bc"
      },
      {
        "name": "Jennifer Weiss, PA-C",
        "role": "Physician Assistant (Advanced Practice Provider)",
        "credentials": ["MPAS", "PA-C"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2022/02/jennifer-weiss-sm.jpg",
        "_source": {
          "url": "https://www.conceptionsrepro.com/staff/jennifer-weiss/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-denver-jennifer-weiss-pa-c"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/conceptions-reproductive-associates-of-colorado-rma/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Colorado (CO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnI1oNZvFfqecH1-HZPZk1XwDp-S6i6wmZ46As7chE8ijbgO6NTfNOCgZXhsRmh9wOd-i61MwQnQbElltTZcZPMWdivEJxY0LGN3QYwvFYBcNuGC8_3n5hPbJV9cE1Xr7WQ58EL=w408-h493-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Conceptions+Reproductive+Associates+of+Colorado+%7C+RMA,+4500+E+9th+Ave+%23630,+Denver,+CO+80220/@39.7307544,-104.9342768,3068a,13.1y/data=!4m2!3m1!1s0x876c7c1c141819cb:0xace2ba4a7c328f44",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-rma-lafayette",
    "externalIds": {
      "googlePlaceId": "ChIJC_roQdP0a4cREqO9gchdUh8"
    },
    "type": "fertility-clinic",
    "name": "Conceptions RMA - Lafayette",
    "description": "Conceptions RMA fertility clinic in Lafayette, CO. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/conceptions-reproductive-associates-of-colorado-rma/",
    "phone": "(303) 449-1084",
    "bookingUrl": "https://rmanetwork.com/our-locations/conceptions-reproductive-associates-of-colorado-rma/",
    "address": {
      "line1": "300 Exempla Cir, Suite 370",
      "city": "Lafayette",
      "state": "CO",
      "zip": "80026",
      "country": "US"
    },
    "location": {
      "lat": 39.9881,
      "lng": -105.1019
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/conceptions-reproductive-associates-of-colorado-rma/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/conceptions-reproductive-associates-of-colorado-rma/lafayette-colorado/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Conceptions+Reproductive+Associates+of+Colorado+%7C+RMA,+300+Exempla+Cir+%23370,+Lafayette,+CO+80026/@39.9692186,-105.0872894,3058a,13.1y/data=!4m2!3m1!1s0x876bf4d341e8fa0b:0x1f525dc881bda312",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Jasmine Chiang",
        "role": "Reproductive Endocrinologist (Physician Partner)",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2022/01/6.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/providers/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-lafayette-jasmine-chiang"
      },
      {
        "name": "Simone Elder",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2025/08/Doctor-Mobile-website-headshot-264-x-264-px-400-x-400-px-1.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/providers/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-lafayette-simone-elder"
      },
      {
        "name": "Robert Greene",
        "role": "Reproductive Endocrinologist (Physician Partner)",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2022/01/2.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/providers/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-lafayette-robert-greene"
      },
      {
        "name": "Amanda Bird",
        "role": "Physician Assistant",
        "credentials": ["MPAS", "PA-C"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2022/02/amanda-beck-sm.jpg",
        "_source": {
          "url": "https://www.conceptionsrepro.com/staff/amanda-bird/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-lafayette-amanda-bird"
      },
      {
        "name": "Deena Dubrow",
        "role": "Associate Genetic Counselor",
        "credentials": [],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2026/03/Deena-Dubrow_Genetic_Counselor.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/deena-dubrow/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-lafayette-deena-dubrow"
      },
      {
        "name": "Allison \"Alleigh\" Boyd",
        "role": "Genetic Counselor",
        "credentials": [],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2023/04/Untitled-design-3.jpg",
        "_source": {
          "url": "https://rmanetwork.com/staff/allison-alleigh-boyd/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-lafayette-allison-alleigh-boyd"
      },
      {
        "name": "Amber Kaplun",
        "role": "Genetic Counselor",
        "credentials": [],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2023/04/Untitled-design-4.jpg",
        "_source": {
          "url": "https://rmanetwork.com/staff/amber-kaplun/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-lafayette-amber-kaplun"
      }
    ],
    "images": [
      {
        "url": "https://www.conceptionsrepro.com/wp-content/uploads/2022/06/Untitled-design-2022-06-23T184142.793.jpg",
        "type": "exterior",
        "caption": "Exterior of the Community Physicians Pavilion at 300 Exempla Circle on the Good Samaritan Medical Center campus, home to Conceptions RMA Lafayette (Suite 370). Building address '300' and 'Community Physicians Pavilion' signage are visible.",
        "_source": {
          "url": "https://www.conceptionsrepro.com/lafayette-colorado/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/conceptions-reproductive-associates-of-colorado-rma/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Colorado (CO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-rma-lone-tree",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Conceptions RMA - Lone Tree",
    "description": "Conceptions RMA fertility clinic in Lone Tree, CO. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/conceptions-reproductive-associates-of-colorado-rma/",
    "phone": "(303) 586-6598",
    "bookingUrl": "https://rmanetwork.com/our-locations/conceptions-reproductive-associates-of-colorado-rma/",
    "address": {
      "line1": "10107 RidgeGate Pkwy, Suite 300",
      "city": "Lone Tree",
      "state": "CO",
      "zip": "80124",
      "country": "US"
    },
    "location": {
      "lat": 39.5371,
      "lng": -104.8744
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/conceptions-reproductive-associates-of-colorado-rma/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.conceptionsrepro.com/lone-tree-colorado/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Mark Bush, MD",
        "role": "Reproductive Endocrinologist (Physician Partner)",
        "credentials": ["MD", "FACOG", "FACS"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2022/01/1.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/staff/mark-bush/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-lone-tree-mark-bush-md"
      },
      {
        "name": "Robert Greene, MD",
        "role": "Reproductive Endocrinologist (Physician Partner)",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2022/01/2.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/staff/robert-greene/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-lone-tree-robert-greene-md"
      },
      {
        "name": "Althea O'Shaughnessy, MD",
        "role": "Reproductive Endocrinologist (Physician Partner)",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2022/01/4.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/staff/althea-oshaughnessy/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-lone-tree-althea-o-shaughnessy-md"
      },
      {
        "name": "Jasmine Chiang, MD",
        "role": "Reproductive Endocrinologist (Physician Partner)",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2022/01/6.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/staff/jasmine-chiang/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-lone-tree-jasmine-chiang-md"
      },
      {
        "name": "Aimee Ferrandino, MD",
        "role": "Obstetrician-Gynecologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2024/10/Untitled-design-47.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/staff/aimee-ferrandino/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-lone-tree-aimee-ferrandino-md"
      },
      {
        "name": "Malgorzata E. Skaznik-Wikiel, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2023/05/gosia-square.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/staff/malgorzata-e-skaznik-wikiel/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-lone-tree-malgorzata-e-skaznik-wikiel-md"
      },
      {
        "name": "Simone Elder, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.conceptionsrepro.com/wp-content/uploads/2025/08/Doctor-Mobile-website-headshot-264-x-264-px-400-x-400-px-1.png",
        "_source": {
          "url": "https://www.conceptionsrepro.com/staff/simone-elder-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-lone-tree-simone-elder-md"
      }
    ],
    "images": [
      {
        "url": "https://www.conceptionsrepro.com/wp-content/uploads/2022/02/Untitled-design-24.jpg",
        "type": "exterior",
        "caption": "Exterior of the Evergreen Building at Sky Ridge Medical Center, home to Conceptions RMA's Lone Tree clinic (10107 RidgeGate Pkwy, Suite 300).",
        "_source": {
          "url": "https://www.conceptionsrepro.com/lone-tree-colorado/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/conceptions-reproductive-associates-of-colorado-rma/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Colorado (CO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-rma-milford-de",
    "externalIds": {
      "googlePlaceId": "ChIJdeM_zAaauIkRAxbDF48adhs"
    },
    "type": "fertility-clinic",
    "name": "Delaware Institute for Reproductive Medicine - Milford",
    "description": "DIRM fertility clinic in Milford, DE, part of the IVI RMA network.",
    "website": "https://ivf-success.com/",
    "phone": "(302) 738-4600",
    "bookingUrl": "https://ivf-success.com/",
    "address": {
      "line1": "909 Lakeview Ave",
      "city": "Milford",
      "state": "DE",
      "zip": "19963",
      "country": "US"
    },
    "location": {
      "lat": 38.9026,
      "lng": -75.4391
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "LGBTQIA+ family building",
        "category": "art"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://ivf-success.com/",
        "fetchedAt": "2026-06-13"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://ivf-success.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://ivf-success.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://ivf-success.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Delaware+Institute+for+Reproductive+Medicine,+909+Lakeview+Ave,+Milford,+DE+19963/@38.9024809,-75.4394116,3105a,13.1y/data=!4m2!3m1!1s0x89b89a06cc3fe375:0x1b761a8f17c31603",
            "fetchedAt": "2026-08-16"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://ivf-success.com/your-care-team/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "practitionerId": "pr-org-satellite-rma-milford-de-george-kovalevsky-md",
        "name": "George Kovalevsky, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://ivf-success.com/wp-content/uploads/2026/02/Untitled-design-7.png",
        "_source": {
          "url": "https://ivf-success.com/your-care-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-rma-milford-de-adrienne-neithardt-md",
        "name": "Adrienne Neithardt, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://ivf-success.com/wp-content/uploads/2026/02/plain-bg.png",
        "_source": {
          "url": "https://ivf-success.com/your-care-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-rma-milford-de-emelia-a-bachman-md",
        "name": "Emelia A. Bachman, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://ivf-success.com/wp-content/uploads/2026/02/plain-bg-2-2.png",
        "_source": {
          "url": "https://ivf-success.com/your-care-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-rma-milford-de-puneet-masson-md",
        "name": "Puneet Masson, MD",
        "role": "Male Infertility and Urology",
        "credentials": ["MD"],
        "specialty": "Male Infertility and Urology",
        "imageUrl": "https://ivf-success.com/wp-content/uploads/2026/03/Untitled-design-59.png",
        "_source": {
          "url": "https://ivf-success.com/your-care-team/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://ivf-success.com/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Delaware (DE) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkCso68xhfja4pV6Iy5uywU1NZ1OAXjIixzeTUK0SbCvZlnoh4bqpWbVateGKxW3XttJI_dtg12HGYnccN4C8u3huehAMQSDY41WsYiJD8pf6vGIS_Q65UiR1ZrBNoPDczLgdJD=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Delaware+Institute+for+Reproductive+Medicine,+909+Lakeview+Ave,+Milford,+DE+19963/@38.9024809,-75.4394116,3105a,13.1y/data=!4m2!3m1!1s0x89b89a06cc3fe375:0x1b761a8f17c31603",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-rma-eatontown",
    "externalIds": {
      "googlePlaceId": "ChIJ_S6PEm4vwokRIUL2y3s7bbM"
    },
    "type": "fertility-clinic",
    "name": "RMA New Jersey - Eatontown",
    "description": "RMA New Jersey fertility clinic in Eatontown, NJ. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/rma-new-jersey/eatontown-nj/",
    "phone": "(732) 935-1002",
    "bookingUrl": "https://rmanetwork.com/our-locations/rma-new-jersey/eatontown-nj/",
    "address": {
      "line1": "2 Industrial Way W, Suite 204",
      "city": "Eatontown",
      "state": "NJ",
      "zip": "07724",
      "country": "US"
    },
    "location": {
      "lat": 40.2871,
      "lng": -74.0632
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/rma-new-jersey/eatontown-nj/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+New+Jersey+%7C+Eatontown,+2+Industrial+Wy+W+Suite+204,+Eatontown,+NJ+07724/@40.277215,-74.0465821,3044a,13.1y/data=!4m2!3m1!1s0x89c22f6e128f2efd:0xb36d3b7bcbf64221",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Michael R. Drews, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2021/02/founder-2-michael-e1618857492283.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-eatontown-michael-r-drews-md"
      },
      {
        "name": "Amanda Kadesh, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Amanda-Kadesh-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/amanda-kadesh-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-eatontown-amanda-kadesh-md"
      },
      {
        "name": "Joelle Mouhanna, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Joelle-Mouhanna-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/joelle-mouhanna-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-eatontown-joelle-mouhanna-md"
      },
      {
        "name": "Rachel Martel, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Rachel-Martel-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/rachel-martel-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-eatontown-rachel-martel-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/rma-new-jersey/eatontown-nj/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl-4AYLctTutaOwQoJzCzZrw66fX6GyYQAHh3uD8KKlUlyBc8fPNDWWVL9a-aD1EunsgYjPC49UUlQUhWQgQSXANnBjkD4ppUGGsLJYI54W4hyNg8gdv1-dsnS_2NU-iuFvCaoW=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+New+Jersey+%7C+Eatontown,+2+Industrial+Wy+W+Suite+204,+Eatontown,+NJ+07724/@40.277215,-74.0465821,3044a,13.1y/data=!4m2!3m1!1s0x89c22f6e128f2efd:0xb36d3b7bcbf64221",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-rma-englewood",
    "externalIds": {
      "googlePlaceId": "ChIJcdnHH9bwwokRhVI20uj4x_Q"
    },
    "type": "fertility-clinic",
    "name": "RMA New Jersey - Englewood",
    "description": "RMA New Jersey fertility clinic in Englewood, NJ. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/rma-new-jersey/",
    "phone": "(201) 569-7773",
    "bookingUrl": "https://rmanetwork.com/our-locations/rma-new-jersey/",
    "address": {
      "line1": "25 Rockwood Pl, Suite 320",
      "city": "Englewood",
      "state": "NJ",
      "zip": "07631",
      "country": "US"
    },
    "location": {
      "lat": 40.8917,
      "lng": -73.9729
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+New+Jersey+%7C+Englewood,+25+Rockwood+Pl+Ste+320,+Englewood,+NJ+07631/@40.8796336,-73.9830948,3017a,13.1y/data=!4m2!3m1!1s0x89c2f0d61fc7d971:0xf4c7f8e8d2365285",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Michael R. Drews, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2021/02/founder-2-michael-e1618857492283.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-englewood-michael-r-drews-md"
      },
      {
        "name": "Amanda Kadesh, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Amanda-Kadesh-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/amanda-kadesh-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-englewood-amanda-kadesh-md"
      },
      {
        "name": "Joelle Mouhanna, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Joelle-Mouhanna-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/joelle-mouhanna-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-englewood-joelle-mouhanna-md"
      },
      {
        "name": "Rachel Martel, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Rachel-Martel-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/rachel-martel-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-englewood-rachel-martel-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnH7c8DkuFRQwMnPd5gKC186TbRUQXuArHafrIiJB0NuLO10EQCaTf80sxjdXZBJz71qxhYt5fZgh-eQSiZMqMfEu8elf0nRooyZZy8siQ15y1o47stMgrLF8H8fO1vqRtiiswA=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+New+Jersey+%7C+Englewood,+25+Rockwood+Pl+Ste+320,+Englewood,+NJ+07631/@40.8796336,-73.9830948,3017a,13.1y/data=!4m2!3m1!1s0x89c2f0d61fc7d971:0xf4c7f8e8d2365285",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-rma-freehold",
    "externalIds": {
      "googlePlaceId": "ChIJE0fcp5XAw4kRumMtux5pwOk"
    },
    "type": "fertility-clinic",
    "name": "RMA New Jersey - Freehold",
    "description": "RMA New Jersey fertility clinic in Freehold, NJ. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/rma-new-jersey/",
    "phone": "(732) 577-6500",
    "bookingUrl": "https://rmanetwork.com/our-locations/rma-new-jersey/",
    "address": {
      "line1": "109 Professional View Dr, Bldg 100",
      "city": "Freehold",
      "state": "NJ",
      "zip": "07728",
      "country": "US"
    },
    "location": {
      "lat": 40.2348,
      "lng": -74.2726
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+New+Jersey+%7C+Freehold,+109+Professional+View+Dr+Bldg+100,+Freehold,+NJ+07728/@40.2332128,-74.3204509,3046a,13.1y/data=!4m2!3m1!1s0x89c3c095a7dc4713:0xe9c0691ebb2d63ba",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Michael R. Drews, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2021/02/founder-2-michael-e1618857492283.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-freehold-michael-r-drews-md"
      },
      {
        "name": "Amanda Kadesh, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Amanda-Kadesh-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/amanda-kadesh-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-freehold-amanda-kadesh-md"
      },
      {
        "name": "Joelle Mouhanna, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Joelle-Mouhanna-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/joelle-mouhanna-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-freehold-joelle-mouhanna-md"
      },
      {
        "name": "Rachel Martel, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Rachel-Martel-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/rachel-martel-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-freehold-rachel-martel-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-satellite-rma-jersey-city",
    "externalIds": {
      "googlePlaceId": "ChIJRwouD0ZXwokR0JONknZ-4MU"
    },
    "type": "fertility-clinic",
    "name": "RMA New Jersey - Jersey City",
    "description": "RMA New Jersey fertility clinic in Jersey City, NJ. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/rma-new-jersey/",
    "phone": "(201) 621-0909",
    "bookingUrl": "https://rmanetwork.com/our-locations/rma-new-jersey/",
    "address": {
      "line1": "100 Town Square Pl, Suite 610",
      "city": "Jersey City",
      "state": "NJ",
      "zip": "07310",
      "country": "US"
    },
    "location": {
      "lat": 40.7178,
      "lng": -74.034
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+New+Jersey+%7C+Jersey+City,+100+Town+Square+Pl+6th+Floor,+Suite+610,+Jersey+City,+NJ+07310/@40.7271095,-74.033409,3024a,13.1y/data=!4m2!3m1!1s0x89c257460f2e0a47:0xc5e07e76928d93d0",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Michael R. Drews, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2021/02/founder-2-michael-e1618857492283.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-jersey-city-michael-r-drews-md"
      },
      {
        "name": "Amanda Kadesh, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Amanda-Kadesh-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/amanda-kadesh-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-jersey-city-amanda-kadesh-md"
      },
      {
        "name": "Joelle Mouhanna, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Joelle-Mouhanna-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/joelle-mouhanna-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-jersey-city-joelle-mouhanna-md"
      },
      {
        "name": "Rachel Martel, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Rachel-Martel-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/rachel-martel-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-jersey-city-rachel-martel-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnxAAYeFtiuynxLyH0kWcMxxOYE6rUJBBkOcAjzNNodjcZsFqoDBRaK9nDwVl3NkpRkL6K3a2mr67Y1Tg6iiIuGa0JGF41TroDSly1LcTPaVxaXlQvgoddcN9y7poVj2_B7jhDU=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+New+Jersey+%7C+Jersey+City,+100+Town+Square+Pl+6th+Floor,+Suite+610,+Jersey+City,+NJ+07310/@40.7271095,-74.033409,3024a,13.1y/data=!4m2!3m1!1s0x89c257460f2e0a47:0xc5e07e76928d93d0",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-rma-marlton",
    "externalIds": {
      "googlePlaceId": "ChIJ3emkrq7Gw4kR59isRs6clBA"
    },
    "type": "fertility-clinic",
    "name": "RMA New Jersey - Marlton",
    "description": "RMA New Jersey fertility clinic in Marlton, NJ. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/rma-new-jersey/",
    "phone": "(856) 267-8100",
    "bookingUrl": "https://rmanetwork.com/our-locations/rma-new-jersey/",
    "address": {
      "line1": "95 Old Marlton Pike West",
      "city": "Marlton",
      "state": "NJ",
      "zip": "08053",
      "country": "US"
    },
    "location": {
      "lat": 39.883,
      "lng": -74.9362
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+New+Jersey+%7C+Marlton,+95+Old+Marlton+Pike,+Evesham,+NJ+08053/@39.892881,-74.9287359,3061a,13.1y/data=!4m2!3m1!1s0x89c3c6aeaea4e9dd:0x10949cce46acd8e7",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Michael R. Drews, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2021/02/founder-2-michael-e1618857492283.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-marlton-michael-r-drews-md"
      },
      {
        "name": "Amanda Kadesh, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Amanda-Kadesh-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/amanda-kadesh-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-marlton-amanda-kadesh-md"
      },
      {
        "name": "Joelle Mouhanna, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Joelle-Mouhanna-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/joelle-mouhanna-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-marlton-joelle-mouhanna-md"
      },
      {
        "name": "Rachel Martel, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Rachel-Martel-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/rachel-martel-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-marlton-rachel-martel-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm4Dz8OMtkyZOb43wW1FTsGXpn3X2GKR5-Sq6kTtKuiixa3p5SzkfhJwoz4VxXHp42hMGSuaQtjKcyjwzpbQpXBeXUvgtkb6h33eOvNergwFDINfnLBahVxiI70ObH3jy8SjaFqiA=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+New+Jersey+%7C+Marlton,+95+Old+Marlton+Pike,+Evesham,+NJ+08053/@39.892881,-74.9287359,3061a,13.1y/data=!4m2!3m1!1s0x89c3c6aeaea4e9dd:0x10949cce46acd8e7",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnY-GXXm3Lyap7JhGvlUo0-AVk_KDCQcCvl_gEtcim1rlkxh9TBCODD0NgPkDy0yJujsQOsOtVgZuMKDGt7RJ5QK6pA62Jd1CmMMwKzp-g1oPEAe1YfxPPJtHUqXG0MlzAP088=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+New+Jersey+%7C+Marlton,+95+Old+Marlton+Pike,+Evesham,+NJ+08053/@39.892881,-74.9287359,3061a,13.1y/data=!4m2!3m1!1s0x89c3c6aeaea4e9dd:0x10949cce46acd8e7",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlWeo3RFjhwLJI1czhWJCZF4JfyxvYmpykXT4i-j6if-SSl_avl3OS49wppDkvbHjZi_NAoy3kL3M-lo8VJWAGmyShy94jbCgyzgPbpyG_VEAkjG08CeOx8K8tOWzq1shP6KFo=w224-h398-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+New+Jersey+%7C+Marlton,+95+Old+Marlton+Pike,+Evesham,+NJ+08053/@39.892881,-74.9287359,3061a,13.1y/data=!4m2!3m1!1s0x89c3c6aeaea4e9dd:0x10949cce46acd8e7",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-rma-morristown",
    "externalIds": {
      "googlePlaceId": "ChIJK8MFpoCnw4kROQ9VezOsRzQ"
    },
    "type": "fertility-clinic",
    "name": "RMA New Jersey - Morristown",
    "description": "RMA New Jersey fertility clinic in Morristown, NJ. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/rma-new-jersey/",
    "phone": "(973) 971-4600",
    "bookingUrl": "https://rmanetwork.com/our-locations/rma-new-jersey/",
    "address": {
      "line1": "60 Columbia Rd, Suite 140, Bldg B",
      "city": "Morristown",
      "state": "NJ",
      "zip": "07960",
      "country": "US"
    },
    "location": {
      "lat": 40.7851,
      "lng": -74.4809
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+New+Jersey+%7C+Morristown,+60+Columbia+Rd+Ste+140,+Building+B,+Morristown,+NJ+07960/@40.7961058,-74.4516337,3020a,13.1y/data=!4m2!3m1!1s0x89c3a780a605c32b:0x3447ac337b550f39",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Michael R. Drews, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2021/02/founder-2-michael-e1618857492283.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-morristown-michael-r-drews-md"
      },
      {
        "name": "Amanda Kadesh, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Amanda-Kadesh-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/amanda-kadesh-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-morristown-amanda-kadesh-md"
      },
      {
        "name": "Joelle Mouhanna, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Joelle-Mouhanna-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/joelle-mouhanna-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-morristown-joelle-mouhanna-md"
      },
      {
        "name": "Rachel Martel, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Rachel-Martel-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/rachel-martel-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-morristown-rachel-martel-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-satellite-rma-princeton",
    "externalIds": {
      "googlePlaceId": "ChIJR7MhcFRfwYkRzwlZW2FyU-M"
    },
    "type": "fertility-clinic",
    "name": "RMA New Jersey - Princeton",
    "description": "RMA New Jersey fertility clinic in Princeton, NJ. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/rma-new-jersey/",
    "phone": "(609) 799-5666",
    "bookingUrl": "https://rmanetwork.com/our-locations/rma-new-jersey/",
    "address": {
      "line1": "731 Alexander Rd",
      "city": "Princeton",
      "state": "NJ",
      "zip": "08540",
      "country": "US"
    },
    "location": {
      "lat": 40.3278,
      "lng": -74.6771
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+New+Jersey+%7C+Princeton,+731+Alexander+Rd+Ste+203,+Princeton,+NJ+08540/@40.322318,-74.6372069,3042a,13.1y/data=!4m2!3m1!1s0x89c15f547021b347:0xe35372615b5909cf",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Michael R. Drews, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2021/02/founder-2-michael-e1618857492283.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-princeton-michael-r-drews-md"
      },
      {
        "name": "Amanda Kadesh, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Amanda-Kadesh-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/amanda-kadesh-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-princeton-amanda-kadesh-md"
      },
      {
        "name": "Joelle Mouhanna, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Joelle-Mouhanna-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/joelle-mouhanna-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-princeton-joelle-mouhanna-md"
      },
      {
        "name": "Rachel Martel, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Rachel-Martel-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/rachel-martel-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-princeton-rachel-martel-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-satellite-rma-somerset",
    "externalIds": {
      "googlePlaceId": "ChIJ3emkrq7Gw4kRQfahq0i07X8"
    },
    "type": "fertility-clinic",
    "name": "RMA New Jersey - Somerset",
    "description": "RMA New Jersey fertility clinic in Somerset, NJ. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/rma-new-jersey/",
    "phone": "(732) 220-9060",
    "bookingUrl": "https://rmanetwork.com/our-locations/rma-new-jersey/",
    "address": {
      "line1": "81 Veronica Ave",
      "city": "Somerset",
      "state": "NJ",
      "zip": "08873",
      "country": "US"
    },
    "location": {
      "lat": 40.5077,
      "lng": -74.4905
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+New+Jersey+%7C+Somerset,+81+Veronica+Ave,+Franklin+Township,+NJ+08873/@40.474726,-74.4931611,3035a,13.1y/data=!4m2!3m1!1s0x89c3c6aeaea4e9dd:0x7fedb448aba1f641",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Michael R. Drews, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2021/02/founder-2-michael-e1618857492283.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-somerset-michael-r-drews-md"
      },
      {
        "name": "Amanda Kadesh, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Amanda-Kadesh-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/amanda-kadesh-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-somerset-amanda-kadesh-md"
      },
      {
        "name": "Joelle Mouhanna, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Joelle-Mouhanna-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/joelle-mouhanna-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-somerset-joelle-mouhanna-md"
      },
      {
        "name": "Rachel Martel, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Rachel-Martel-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/rachel-martel-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-somerset-rachel-martel-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-satellite-rma-springfield",
    "externalIds": {
      "googlePlaceId": "ChIJ2xCfYGSuw4kRQlDdLOfmLlk"
    },
    "type": "fertility-clinic",
    "name": "RMA New Jersey - Springfield",
    "description": "RMA New Jersey fertility clinic in Springfield, NJ. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/rma-new-jersey/",
    "phone": "(973) 258-4081",
    "bookingUrl": "https://rmanetwork.com/our-locations/rma-new-jersey/",
    "address": {
      "line1": "955 S Springfield Ave, Bldg A, Suite 103",
      "city": "Springfield",
      "state": "NJ",
      "zip": "07081",
      "country": "US"
    },
    "location": {
      "lat": 40.6884,
      "lng": -74.326
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+New+Jersey+%7C+Springfield,+955+S+Springfield+Ave+A+103,+Springfield,+NJ+07081/@40.6833736,-74.3293283,3026a,13.1y/data=!4m2!3m1!1s0x89c3ae64609f10db:0x592ee6e72cdd5042",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Michael R. Drews, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2021/02/founder-2-michael-e1618857492283.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-springfield-michael-r-drews-md"
      },
      {
        "name": "Amanda Kadesh, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Amanda-Kadesh-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/amanda-kadesh-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-springfield-amanda-kadesh-md"
      },
      {
        "name": "Joelle Mouhanna, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Joelle-Mouhanna-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/joelle-mouhanna-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-springfield-joelle-mouhanna-md"
      },
      {
        "name": "Rachel Martel, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Rachel-Martel-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/rachel-martel-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-springfield-rachel-martel-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-satellite-rma-west-orange",
    "externalIds": {
      "googlePlaceId": "ChIJg2aDHgOrw4kRHhod45-2IEg"
    },
    "type": "fertility-clinic",
    "name": "RMA New Jersey - West Orange",
    "description": "RMA New Jersey fertility clinic in West Orange, NJ. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/rma-new-jersey/",
    "phone": "(973) 325-2229",
    "bookingUrl": "https://rmanetwork.com/our-locations/rma-new-jersey/",
    "address": {
      "line1": "475 Prospect Ave, Suite 101",
      "city": "West Orange",
      "state": "NJ",
      "zip": "07052",
      "country": "US"
    },
    "location": {
      "lat": 40.7735,
      "lng": -74.2682
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+New+Jersey+%7C+West+Orange,+475+Prospect+Ave+%23101,+West+Orange,+NJ+07052/@40.790805,-74.255825,3021a,13.1y/data=!4m2!3m1!1s0x89c3ab031e836683:0x4820b69fe31d1a1e",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Michael R. Drews, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2021/02/founder-2-michael-e1618857492283.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-west-orange-michael-r-drews-md"
      },
      {
        "name": "Amanda Kadesh, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Amanda-Kadesh-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/amanda-kadesh-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-west-orange-amanda-kadesh-md"
      },
      {
        "name": "Joelle Mouhanna, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Joelle-Mouhanna-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/joelle-mouhanna-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-west-orange-joelle-mouhanna-md"
      },
      {
        "name": "Rachel Martel, MD",
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/08/Rachel-Martel-MD-Doctor-Mobile-website-headshot-264-x-264-px.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/rachel-martel-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-west-orange-rachel-martel-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/rma-new-jersey/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl9TeWBDRRerYQrLe0GHLKQRnnQXmSuQGqJKu7BCoCpuQvhwl_CZ9kZv4yl3vg0FBrEheET9B0eIsZPfa0Ly0AKYPktVDikmjlsWJkiEbwHLem3irOUi5WTa2uag-WjYyABurc=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+New+Jersey+%7C+West+Orange,+475+Prospect+Ave+%23101,+West+Orange,+NJ+07052/@40.790805,-74.255825,3021a,13.1y/data=!4m2!3m1!1s0x89c3ab031e836683:0x4820b69fe31d1a1e",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-rma-wilmington-nc",
    "externalIds": {
      "googlePlaceId": "ChIJfQdqyJf1qYkRjkciW9x4mHo"
    },
    "type": "fertility-clinic",
    "name": "Wilmington Fertility Center",
    "description": "Wilmington Fertility Center fertility clinic in Wilmington, NC. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/wilmington-fertility-center/",
    "phone": "(910) 444-1980",
    "bookingUrl": "https://rmanetwork.com/our-locations/wilmington-fertility-center/",
    "address": {
      "line1": "5815 Oleander Dr, Suite 240",
      "city": "Wilmington",
      "state": "NC",
      "zip": "28403",
      "country": "US"
    },
    "location": {
      "lat": 34.2104,
      "lng": -77.8868
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/wilmington-fertility-center/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/wilmington-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Wilmington+Fertility+Center,+5815+Oleander+Dr+Ste+240,+Wilmington,+NC+28403/@34.2094783,-77.8455913,3300a,13.1y/data=!4m2!3m1!1s0x89a9f597c86a077d:0x7a9878dc5b22478e",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Donna Session, MD",
        "role": "Reproductive Endocrinologist & Medical Director",
        "credentials": ["MD"],
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/05/Doctor-Mobile-website-headshot-264-x-264-px.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/wilmington-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-wilmington-nc-donna-session-md"
      },
      {
        "name": "Tricia Sutherland",
        "role": "Embryology Lab Manager",
        "credentials": ["TS"],
        "imageUrl": "https://wilmingtonfertilitycenter.com/webroot/images/home/TriciaHeadshot.png",
        "_source": {
          "url": "https://wilmingtonfertilitycenter.com/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-wilmington-nc-tricia-sutherland"
      },
      {
        "name": "Courtney Gautreau",
        "role": "Embryologist",
        "credentials": [],
        "imageUrl": "https://wilmingtonfertilitycenter.com/webroot/images/home/courtney.png",
        "_source": {
          "url": "https://wilmingtonfertilitycenter.com/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-wilmington-nc-courtney-gautreau"
      }
    ],
    "images": [
      {
        "url": "https://rmanetwork.com/wp-content/uploads/2025/05/website-image-12.jpg",
        "type": "exterior",
        "caption": "Exterior of Wilmington Fertility Center, located in the Bradley Creek Station building at 5815 Oleander Dr, Wilmington, NC",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/wilmington-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://rmanetwork.com/wp-content/uploads/2025/05/website-image-9.jpg",
        "type": "interior",
        "caption": "Waiting / reception area inside Wilmington Fertility Center",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/wilmington-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmel-u419BpbRDOM3egELi3TysvCL1HVbDVddalYeupFq84bGHNG_eGlkDSifHmS4PTPov-4SVa3g_mmYT50QyOzCZSj-N60zK5GI8y7BSU8mXoa0vH-5OEA9sSVwlsvVbYw1I=w408-h312-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Wilmington+Fertility+Center,+5815+Oleander+Dr+Ste+240,+Wilmington,+NC+28403/@34.2094783,-77.8455913,3300a,13.1y/data=!4m2!3m1!1s0x89a9f597c86a077d:0x7a9878dc5b22478e",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlj57SVCbc9o3au2rgl-zjnahhcp0zJuK7vN9bu7pKgH0lPv028jKb5t3fjYRSrCzHfkIaSvzN5J3_73Ys_djTxLavG-zIZj9dE7IweUGhxWuOWOUx1UVd5BHbBFbmS69oCw8-L=w406-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Wilmington+Fertility+Center,+5815+Oleander+Dr+Ste+240,+Wilmington,+NC+28403/@34.2094783,-77.8455913,3300a,13.1y/data=!4m2!3m1!1s0x89a9f597c86a077d:0x7a9878dc5b22478e",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/wilmington-fertility-center/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check North Carolina (NC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-rma-abington",
    "externalIds": {
      "googlePlaceId": "ChIJqdyTYNGvxokRnjT85pDXMzk"
    },
    "type": "fertility-clinic",
    "name": "RMA Philadelphia - Abington",
    "description": "RMA Philadelphia fertility clinic in Abington, PA. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/rma-philadelphia/abington-pa/",
    "phone": "(215) 938-1515",
    "bookingUrl": "https://rmanetwork.com/our-locations/rma-philadelphia/abington-pa/",
    "address": {
      "line1": "1151 Old York Rd",
      "city": "Abington",
      "state": "PA",
      "zip": "19001",
      "country": "US"
    },
    "location": {
      "lat": 40.124,
      "lng": -75.1176
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/rma-philadelphia/abington-pa/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-philadelphia/abington-pa/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+Philadelphia+%7C+Abington,+1151+Old+York+Rd,+Abington,+PA+19001/@40.1159679,-75.1207254,3051a,13.1y/data=!4m2!3m1!1s0x89c6afd16093dca9:0x3933d790e6fc349e",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Jeffrey T. Thorne, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2021/02/Copy-of-Untitled-3-3.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-abington-jeffrey-t-thorne-md"
      },
      {
        "name": "Annu Mathew, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2024/02/Untitled-design-22-1.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/abington-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-abington-annu-mathew-pa-c"
      },
      {
        "name": "Karen C. Wheeler, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2022/04/Untitled-design-18.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-abington-karen-c-wheeler-md"
      },
      {
        "name": "Deena Dubrow",
        "role": "Associate Genetic Counselor",
        "credentials": [],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2026/03/Deena-Dubrow_Genetic_Counselor.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Genetic Counseling",
        "practitionerId": "pr-org-satellite-rma-abington-deena-dubrow"
      },
      {
        "name": "Amber Kaplun",
        "role": "Genetic Counselor",
        "credentials": [],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2023/04/Untitled-design-4.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Genetic Counseling",
        "practitionerId": "pr-org-satellite-rma-abington-amber-kaplun"
      },
      {
        "name": "Allison Alleigh Boyd",
        "role": "Genetic Counselor",
        "credentials": [],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2023/04/Untitled-design-3.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Genetic Counseling",
        "practitionerId": "pr-org-satellite-rma-abington-allison-alleigh-boyd"
      }
    ],
    "images": [
      {
        "url": "https://rmanetwork.com/wp-content/uploads/2024/02/New-IMG.jpg",
        "type": "exterior",
        "caption": "RMA Philadelphia Abington clinic exterior",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/abington-pa/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/rma-philadelphia/abington-pa/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-rma-langhorne",
    "externalIds": {
      "googlePlaceId": "ChIJt4jObaVTwYkRli8IcfTbLiQ"
    },
    "type": "fertility-clinic",
    "name": "RMA Philadelphia - Langhorne",
    "description": "RMA Philadelphia fertility clinic in Langhorne, PA. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/rma-philadelphia/langhorne-pa/",
    "phone": "(267) 852-0780",
    "bookingUrl": "https://rmanetwork.com/our-locations/rma-philadelphia/langhorne-pa/",
    "address": {
      "line1": "930 Town Center Dr, Suite G-75",
      "city": "Langhorne",
      "state": "PA",
      "zip": "19047",
      "country": "US"
    },
    "location": {
      "lat": 40.1574,
      "lng": -74.8834
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/rma-philadelphia/langhorne-pa/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-philadelphia/langhorne-pa/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+Philadelphia+%7C+Langhorne,+930+Town+Center+Dr+G-75,+Langhorne,+PA+19047/@40.1887763,-74.8782616,3048a,13.1y/data=!4m2!3m1!1s0x89c153a56dce88b7:0x242edbf471082f96",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Jeffrey T. Thorne, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2021/02/Copy-of-Untitled-3-3.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-langhorne-jeffrey-t-thorne-md"
      },
      {
        "name": "Annu Mathew, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2024/02/Untitled-design-22-1.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/abington-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-langhorne-annu-mathew-pa-c"
      },
      {
        "name": "Karen C. Wheeler, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2022/04/Untitled-design-18.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-langhorne-karen-c-wheeler-md"
      },
      {
        "name": "Deena Dubrow",
        "role": "Associate Genetic Counselor",
        "credentials": [],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2026/03/Deena-Dubrow_Genetic_Counselor.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Genetic Counseling",
        "practitionerId": "pr-org-satellite-rma-langhorne-deena-dubrow"
      },
      {
        "name": "Amber Kaplun",
        "role": "Genetic Counselor",
        "credentials": [],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2023/04/Untitled-design-4.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Genetic Counseling",
        "practitionerId": "pr-org-satellite-rma-langhorne-amber-kaplun"
      },
      {
        "name": "Allison Alleigh Boyd",
        "role": "Genetic Counselor",
        "credentials": [],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2023/04/Untitled-design-3.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Genetic Counseling",
        "practitionerId": "pr-org-satellite-rma-langhorne-allison-alleigh-boyd"
      }
    ],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmeD2HnG7mRPIKr3IeVNrASGXItiH4ZB4VNr3ykN4jQZCf4ZFnxxVWwOcyZ_s-3ByYh0AX8f40GspL_vTP_2iO_rMr2oolkL3-cl0w6SO0VrdTwPH7A_ovvmxDViIeXNytpdHei=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+Philadelphia+%7C+Langhorne,+930+Town+Center+Dr+G-75,+Langhorne,+PA+19047/@40.1887763,-74.8782616,3048a,13.1y/data=!4m2!3m1!1s0x89c153a56dce88b7:0x242edbf471082f96",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/rma-philadelphia/langhorne-pa/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-rma-philadelphia-cc",
    "externalIds": {
      "googlePlaceId": "ChIJNzuFJSjGxokRuWxzr4bL0nc"
    },
    "type": "fertility-clinic",
    "name": "RMA Philadelphia - Center City",
    "description": "RMA Philadelphia fertility clinic in Philadelphia, PA. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/rma-philadelphia/philadelphia-pa/",
    "phone": "(215) 922-1556",
    "bookingUrl": "https://rmanetwork.com/our-locations/rma-philadelphia/philadelphia-pa/",
    "address": {
      "line1": "1015 Chestnut St, Floor 8",
      "city": "Philadelphia",
      "state": "PA",
      "zip": "19107",
      "country": "US"
    },
    "location": {
      "lat": 39.9501,
      "lng": -75.158
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/rma-philadelphia/philadelphia-pa/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-philadelphia/philadelphia-pa/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+Philadelphia+%7C+Center+City,+1015+Chestnut+St+8th+floor,+Philadelphia,+PA+19107/@39.9501715,-75.1574491,3059a,13.1y/data=!4m2!3m1!1s0x89c6c62825853b37:0x77d2cb86af736cb9",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Jacqueline N. Gutmann, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2021/02/Untitled-design-2-1.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-philadelphia-cc-jacqueline-n-gutmann-md"
      },
      {
        "name": "Allison Lange, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2021/02/Doctor-Page-Mobile-Image-264-x-264-px-9.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-philadelphia-cc-allison-lange-md"
      },
      {
        "name": "Karen C. Wheeler, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2022/04/Untitled-design-18.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-philadelphia-cc-karen-c-wheeler-md"
      },
      {
        "name": "Daniel Miranian, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2025/10/RMA-header-image-doctor-page-mobile-image-264-x-264-px-8.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-philadelphia-cc-daniel-miranian-md"
      },
      {
        "name": "Danielle Leotta, NP",
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2022/11/Untitled-design-17-1.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-philadelphia-cc-danielle-leotta-np"
      },
      {
        "name": "Alexa Konrad, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2025/05/Doctor-Page-Mobile-Image-264-x-264-px-1.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-philadelphia-cc-alexa-konrad-pa-c"
      },
      {
        "name": "Deena Dubrow",
        "role": "Associate Genetic Counselor",
        "credentials": [],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2026/03/Deena-Dubrow_Genetic_Counselor.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Genetic Counseling",
        "practitionerId": "pr-org-satellite-rma-philadelphia-cc-deena-dubrow"
      },
      {
        "name": "Amber Kaplun",
        "role": "Genetic Counselor",
        "credentials": [],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2023/04/Untitled-design-4.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Genetic Counseling",
        "practitionerId": "pr-org-satellite-rma-philadelphia-cc-amber-kaplun"
      },
      {
        "name": "Allison Alleigh Boyd",
        "role": "Genetic Counselor",
        "credentials": [],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2023/04/Untitled-design-3.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-philadelphia/wayne-pa/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Genetic Counseling",
        "practitionerId": "pr-org-satellite-rma-philadelphia-cc-allison-alleigh-boyd"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/rma-philadelphia/philadelphia-pa/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm4NdodCg6E30KMFP_TipNriWynhNs3hSt1s3BfsFK_1hYW_VPAFwy72qdZLaGIF-VXKZ8jDcEbvCkgsmBj5eNuOqXFX10KAw1hstBjUKrhigwmgZyp941pLsqHb9rkHw-A8L4m=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+Philadelphia+%7C+Center+City,+1015+Chestnut+St+8th+floor,+Philadelphia,+PA+19107/@39.9501715,-75.1574491,3059a,13.1y/data=!4m2!3m1!1s0x89c6c62825853b37:0x77d2cb86af736cb9",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-rma-allentown",
    "externalIds": {
      "googlePlaceId": "ChIJjZneQ1Q3xIkR30WDpAuYBgc"
    },
    "type": "fertility-clinic",
    "name": "RMA Lehigh Valley - Allentown",
    "description": "RMA Lehigh Valley fertility clinic in Allentown, PA. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/rma-lehigh-valley/",
    "phone": "(610) 820-6888",
    "bookingUrl": "https://rmanetwork.com/our-locations/rma-lehigh-valley/",
    "address": {
      "line1": "1401 N Cedar Crest Blvd, Suite 200",
      "city": "Allentown",
      "state": "PA",
      "zip": "18104",
      "country": "US"
    },
    "location": {
      "lat": 40.6125,
      "lng": -75.5032
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/rma-lehigh-valley/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+Lehigh+Valley+%7C+Allentown,+1401+N+Cedar+Crest+Blvd+%23200,+Allentown,+PA+18104/@40.6116998,-75.5308686,3029a,13.1y/data=!4m2!3m1!1s0x89c4375443de998d:0x706980ba48345df",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/rma-lehigh-valley/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkU8KiUwJR2Juyrmu4SvACvZUlP4-J92tTzWXjNGdvbCzzlgkIbnt9rx2-i4lWDn3S2C_HOy-cFNdFMDB6xM9Ok1zcXEtHA-aph46OGG3gGsPl6BVigustI5GNa_P4oip3YEfXp=w290-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+Lehigh+Valley+%7C+Allentown,+1401+N+Cedar+Crest+Blvd+%23200,+Allentown,+PA+18104/@40.6116998,-75.5308686,3029a,13.1y/data=!4m2!3m1!1s0x89c4375443de998d:0x706980ba48345df",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-rma-chadds-ford",
    "externalIds": {
      "googlePlaceId": "ChIJ95HTwFj7xokRihz1FDa1D48"
    },
    "type": "fertility-clinic",
    "name": "DIRM - Chadds Ford",
    "description": "DIRM fertility clinic in Chadds Ford, PA. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/delaware-institute-for-reproductive-medicine-dirm-fertility-clinic/",
    "phone": "(302) 738-4600",
    "bookingUrl": "https://rmanetwork.com/our-locations/delaware-institute-for-reproductive-medicine-dirm-fertility-clinic/",
    "address": {
      "line1": "6 Dickinson Ct",
      "city": "Chadds Ford",
      "state": "PA",
      "zip": "19317",
      "country": "US"
    },
    "location": {
      "lat": 39.8572,
      "lng": -75.589
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/delaware-institute-for-reproductive-medicine-dirm-fertility-clinic/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/delaware-institute-for-reproductive-medicine-dirm-fertility-clinic/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Delaware+Institute+for+Reproductive+Medicine+-+Chadds+Ford+Office,+Concord+Health+Center,+161+Wilmington+West+Chester+Pike+Ste+1030,+Chadds+Ford,+PA+19317/@39.8469389,-75.5368591,3063a,13.1y/data=!4m2!3m1!1s0x89c6fb58c0d391f7:0x8f0fb53614f51c8a",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "George Kovalevsky, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2025/07/Untitled-design-7-e1772025727244.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/delaware-institute-for-reproductive-medicine-dirm-fertility-clinic/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-chadds-ford-george-kovalevsky-md"
      },
      {
        "name": "Adrienne Neithardt, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2025/07/Untitled-design-47.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/delaware-institute-for-reproductive-medicine-dirm-fertility-clinic/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-chadds-ford-adrienne-neithardt-md"
      },
      {
        "name": "Emelia A. Bachman, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2025/07/Doctor-Page-Mobile-Image-264-x-264-px-5.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/delaware-institute-for-reproductive-medicine-dirm-fertility-clinic/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-chadds-ford-emelia-a-bachman-md"
      },
      {
        "name": "Julia Bergeman, MSPAS, PA-C",
        "role": "Physician Assistant",
        "credentials": ["MSPAS", "PA-C"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2025/07/Untitled-design-49.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/delaware-institute-for-reproductive-medicine-dirm-fertility-clinic/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-chadds-ford-julia-bergeman-mspas-pa-c"
      },
      {
        "name": "Samantha Bernard, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2026/03/Samantha-1.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/delaware-institute-for-reproductive-medicine-dirm-fertility-clinic/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-chadds-ford-samantha-bernard-pa-c"
      },
      {
        "name": "Lauren Rainey, NP",
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2026/04/RMA-header-image-doctor-page-mobile-image-264-x-264-px-6.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/delaware-institute-for-reproductive-medicine-dirm-fertility-clinic/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-chadds-ford-lauren-rainey-np"
      },
      {
        "name": "Rhonda Wright, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2026/04/Rhonda-Wright-DIRM.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/delaware-institute-for-reproductive-medicine-dirm-fertility-clinic/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-rma-chadds-ford-rhonda-wright-pa-c"
      },
      {
        "name": "Puneet Masson, MD",
        "role": "Urologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2025/09/Doctor-Page-Mobile-Image-264-x-264-px-8.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/delaware-institute-for-reproductive-medicine-dirm-fertility-clinic/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Urology",
        "practitionerId": "pr-org-satellite-rma-chadds-ford-puneet-masson-md"
      },
      {
        "name": "Deena Dubrow",
        "role": "Associate Genetic Counselor",
        "credentials": [],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2026/03/Deena-Dubrow_Genetic_Counselor.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/delaware-institute-for-reproductive-medicine-dirm-fertility-clinic/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Genetic Counseling",
        "practitionerId": "pr-org-satellite-rma-chadds-ford-deena-dubrow"
      },
      {
        "name": "Amber Kaplun",
        "role": "Genetic Counselor",
        "credentials": [],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2023/04/Untitled-design-4.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/delaware-institute-for-reproductive-medicine-dirm-fertility-clinic/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Genetic Counseling",
        "practitionerId": "pr-org-satellite-rma-chadds-ford-amber-kaplun"
      },
      {
        "name": "Allison Alleigh Boyd",
        "role": "Genetic Counselor",
        "credentials": [],
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2023/04/Untitled-design-3.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/delaware-institute-for-reproductive-medicine-dirm-fertility-clinic/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Genetic Counseling",
        "practitionerId": "pr-org-satellite-rma-chadds-ford-allison-alleigh-boyd"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/delaware-institute-for-reproductive-medicine-dirm-fertility-clinic/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-satellite-rma-houston",
    "externalIds": {
      "googlePlaceId": "ChIJB9GYJFG_QIYRzimy5sOrfVA"
    },
    "type": "fertility-clinic",
    "name": "RMA Houston",
    "description": "RMA Houston fertility clinic in Houston, TX. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/rma-houston-texas/",
    "phone": "(281) 643-7703",
    "bookingUrl": "https://rmanetwork.com/our-locations/rma-houston-texas/",
    "address": {
      "line1": "888 Westheimer Rd, Suite 200",
      "city": "Houston",
      "state": "TX",
      "zip": "77006",
      "country": "US"
    },
    "location": {
      "lat": 29.7421,
      "lng": -95.3931
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/rma-houston-texas/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+Houston,+888+Westheimer+Rd+Ste+200,+Houston,+TX+77006/@29.7450022,-95.3902626,3464a,13.1y/data=!4m2!3m1!1s0x8640bf512498d107:0x507dabc3e6b229ce",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/rma-houston-texas/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-rma-clearfield",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "RMA Utah - Clearfield",
    "description": "RMA Utah, formerly UCRM and Reproductive Care Center, provides infertility testing, IUI, IVF, FET, ICSI, genetic testing, egg freezing, third-party reproduction, LGBTQ fertility care, and reproductive surgery across Clearfield, Salt Lake City, and Sandy.",
    "website": "https://fertilitydr.com/clearfield-ut-fertility-clinic/",
    "phone": "(866) 762-3140",
    "bookingUrl": "https://rmanetwork.com/our-locations/reproductive-care-center-utah-ivf/",
    "address": {
      "line1": "1725 E 1450 S, Suite 300",
      "city": "Clearfield",
      "state": "UT",
      "zip": "84015",
      "country": "US"
    },
    "location": {
      "lat": 41.0948,
      "lng": -111.9828
    },
    "treatments": [
      {
        "name": "Infertility testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation induction",
        "category": "art",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Frozen embryo transfer",
        "category": "art",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "ICSI",
        "category": "art",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Genetic testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg freezing",
        "category": "preservation",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Third-party reproduction",
        "category": "art",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Reproductive surgery",
        "category": "surgical",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/reproductive-care-center-utah-ivf/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
            "fetchedAt": "2026-06-13"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://fertilitydr.com/clearfield-ut-fertility-clinic/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "specialties": ["reproductive-endocrinology"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "team": [
      {
        "practitionerId": "pr-org-satellite-rma-clearfield-erica-b-johnstone-md-mhs",
        "name": "Erica B. Johnstone, MD, MHS",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MHS"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2026/03/Erica-Boiman-Johnstone-MD-MHS-mobile-image.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-rma-clearfield-kristi-maas-md",
        "name": "Kristi Maas, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2025/10/Doctor-Mobile-website-headshot-264-x-264-px-1.jpg",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-rma-clearfield-joseph-m-letourneau-md",
        "name": "Joseph M. Letourneau, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2026/03/RMA-header-image-doctor-page-mobile-image-264-x-264-px-1.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-rma-clearfield-megan-link-md",
        "name": "Megan Link, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2026/03/Doctor-Page-Mobile-Image-264-x-264-px-10.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-rma-clearfield-ashley-n-shaffer-np",
        "name": "Ashley N. Shaffer, NP",
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "specialty": "Nurse Practitioner",
        "imageUrl": "https://cdn-blejn.nitrocdn.com/blwhiFHKcMxPgRTgoiamYPTmPzJjwJrt/assets/images/optimized/rev-d85dfd3/rmanetwork.com/wp-content/uploads/2026/03/Ashley-Shaffer-Mobile.png",
        "_source": {
          "url": "https://rmanetwork.com/our-locations/rma-utah-ucrm/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/reproductive-care-center-utah-ivf/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Utah (UT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-rma-bellevue",
    "externalIds": {
      "googlePlaceId": "ChIJab898jptkFQRWNH8k7oQEQM"
    },
    "type": "fertility-clinic",
    "name": "RMA Seattle - Bellevue",
    "description": "RMA Seattle fertility clinic in Bellevue, WA. Part of the IVI RMA Network, the world's largest fertility network with over 200 clinics globally.",
    "website": "https://rmanetwork.com/our-locations/rma-seattle/bellevue-wa/",
    "phone": "(425) 644-1803",
    "bookingUrl": "https://rmanetwork.com/our-locations/rma-seattle/bellevue-wa/",
    "address": {
      "line1": "1427 116th Ave NE",
      "city": "Bellevue",
      "state": "WA",
      "zip": "98004",
      "country": "US"
    },
    "location": {
      "lat": 47.6188,
      "lng": -122.1855
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://rmanetwork.com/our-locations/rma-seattle/bellevue-wa/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "Horizon BCBS",
        "Oxford",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "IVI RMA"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-rma",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rmanetwork.com/our-locations/rma-seattle/bellevue-wa/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Reproductive+Medicine+Associates+%7C+Bellevue,+1427+116th+Ave+NE,+Bellevue,+WA+98004/@47.6234274,-122.187455,2689a,13.1y/data=!4m2!3m1!1s0x54906d3af23dbf69:0x31110ba93fcd158",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Kathleen Lin",
        "role": "Medical Director, Reproductive Endocrinologist",
        "credentials": ["MD", "MSCE"],
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2022/09/1.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/kat-lin/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-bellevue-kathleen-lin"
      },
      {
        "name": "Sarah Keller",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2025/04/Doctor-Mobile-website-headshot-264-x-264-px-5.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/sarah-keller/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-bellevue-sarah-keller"
      },
      {
        "name": "Paulinna Huynh",
        "role": "Physician Assistant",
        "credentials": ["PA-C", "MHS"],
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2023/05/2.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/paulinna-huynh/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-bellevue-paulinna-huynh"
      },
      {
        "name": "Shani Badnani",
        "role": "Women's Health Nurse Practitioner",
        "credentials": ["MSN", "ARNP", "WHNP-BC"],
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2026/03/RMA-header-image-doctor-page-mobile-image-264-x-264-px-4.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/shani-badnani/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-bellevue-shani-badnani"
      },
      {
        "name": "Deena Dubrow",
        "role": "Genetic Counselor",
        "credentials": [],
        "imageUrl": "https://rmanetwork.com/wp-content/uploads/2026/03/Deena-Dubrow_Genetic_Counselor.png",
        "_source": {
          "url": "https://rmanetwork.com/staff/deena-dubrow/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-rma-bellevue-deena-dubrow"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, Horizon BCBS, Oxford, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rmanetwork.com/our-locations/rma-seattle/bellevue-wa/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Washington (WA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-satellite-spring-portland",
    "externalIds": {
      "googlePlaceId": "ChIJy2-eIkkJlVQRq7gJM4mXTxw"
    },
    "type": "fertility-clinic",
    "name": "Spring Fertility - Portland",
    "description": "Spring Fertility - Portland fertility clinic in Portland, OR. Part of the Spring Fertility network.",
    "website": "https://springfertility.com/portland/",
    "phone": "(971) 429-6000",
    "bookingUrl": "https://springfertility.com/portland/",
    "address": {
      "line1": "2055 NW Savier Street, Suite 150",
      "city": "Portland",
      "state": "OR",
      "zip": "97209",
      "country": "US"
    },
    "location": {
      "lat": 45.5353133,
      "lng": -122.6939636
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://springfertility.com/portland/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "Spring Fertility"
    },
    "_enrichment": {
      "status": "partially-enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-network",
      "sections": {
        "pricing": {
          "status": "verified"
        },
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://springfertility.com/portland/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://springfertility.com/portland/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://springfertility.com/portland/",
            "fetchedAt": "2026-06-13"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://springfertility.com/portland/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Spring+Fertility,+2055+NW+Savier+St+Ste+150,+Portland,+OR+97209/@45.5351604,-122.6939216,2795a,13.1y/data=!4m2!3m1!1s0x54950949229e6fcb:0x1c4f97893309b8ab",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "pricing": {
      "packages": [
        {
          "name": "Initial Consultation",
          "description": "First visit to assess fertility and create a plan",
          "price": 25000,
          "priceMax": 54500,
          "currency": "USD",
          "includes": ["Ultrasound", "Physical exam", "Physician consultation"],
          "notes": "Bloodwork billed through insurance if applicable, otherwise ~$200 out-of-pocket"
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Complete egg freezing cycle including anesthesia",
          "price": 896400,
          "priceMax": 996000,
          "locationPrices": [
            {
              "location": "San Francisco",
              "price": 996000
            },
            {
              "location": "New York",
              "price": 996000
            },
            {
              "location": "Oregon",
              "price": 896400
            }
          ],
          "currency": "USD",
          "includes": [
            "Monitoring appointments",
            "Anesthesia",
            "Retrieval",
            "Cryopreservation"
          ],
          "notes": "$9,960 for SF & NY locations; $8,964 for Oregon. Anesthesia is included (unlike most clinics)."
        },
        {
          "name": "Medication Package",
          "description": "Pre-negotiated pharmacy rates tailored to your protocol",
          "price": 390000,
          "priceMax": 510000,
          "currency": "USD",
          "includes": [
            "All medications for cycle",
            "Refills if protocol changes"
          ],
          "notes": "Patients save ~$1,500 on average. Federal assistance may reduce cost by $500 - $750/cycle."
        },
        {
          "name": "Future IVF (using frozen eggs)",
          "description": "Complete path from thaw to transfer when you're ready",
          "price": 2300000,
          "priceMax": 2500000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Blastocyst development",
            "Genetic testing",
            "FET medication",
            "Transfer"
          ]
        }
      ],
      "financingOptions": [
        {
          "name": "Internal Payment Plan",
          "description": "Low monthly payments with no down payment",
          "details": [
            "Under $300/month",
            "No down payment required",
            "Covers cycle cost only"
          ],
          "exclusions": "Does not cover consultation, medications, or storage fees",
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "PatientFi Financing",
          "description": "Healthcare financing with flexible repayment terms",
          "details": [
            "Third-party healthcare financing",
            "Flexible repayment options",
            "Quick approval process"
          ],
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "Multi-Cycle Discount",
          "description": "10% off for self-pay patients doing multiple cycles",
          "details": [
            "10% discount on additional cycles",
            "Available to self-pay patients only"
          ],
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "Spring Promise (Shared Risk)",
          "description": "Full refund if pregnancy is not achieved for qualifying patients",
          "details": [
            "Full refund guarantee if pregnancy not achieved",
            "Designed for qualifying egg freezing patients"
          ],
          "eligibility": "20 eggs by age 35, or 30 eggs by age 38",
          "exclusions": "IVF, anesthesia, and medications are excluded from the refund",
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        }
      ],
      "_source": {
        "url": "https://springfertility.com/pricing/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "images": [],
    "team": [
      {
        "practitionerId": "pr-org-satellite-spring-portland-thomas-fisher-do",
        "name": "Thomas Fisher, DO",
        "role": "Fertility Specialist",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2024/08/Our-Providers_Fisher_New.png",
        "_source": {
          "url": "https://springfertility.com/portland/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-spring-portland-diana-h-wu-md",
        "name": "Diana H. Wu, MD",
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2024/08/Our-Providers_Wu_New.png",
        "_source": {
          "url": "https://springfertility.com/portland/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-spring-portland-sacha-ann-krieg-md-phd-facog",
        "name": "Sacha Ann Krieg, MD, PhD, FACOG",
        "role": "Fertility Specialist",
        "credentials": ["MD", "PhD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2024/08/Our-Providers_Krieg_New.png",
        "_source": {
          "url": "https://springfertility.com/portland/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-spring-portland-molly-kornfield-md",
        "name": "Molly Kornfield, MD",
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2024/06/Dr.-Kornfield.png",
        "_source": {
          "url": "https://springfertility.com/portland/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-spring-portland-paula-amato-md",
        "name": "Paula Amato, MD",
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2024/05/Dr-Paula-Amato.png",
        "_source": {
          "url": "https://springfertility.com/portland/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-spring-portland-liz-rubin-md",
        "name": "Liz Rubin, MD",
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2024/08/Our-Providers_Rubin_New.png",
        "_source": {
          "url": "https://springfertility.com/portland/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-spring-portland-jessica-k-cheung-md",
        "name": "Jessica K. Cheung, MD",
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2025/09/Fertility-Specialist.webp",
        "_source": {
          "url": "https://springfertility.com/portland/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://springfertility.com/portland/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "4 public price package(s) and 4 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://springfertility.com/pricing/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Oregon (OR) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-spring-sf-soma",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Spring Fertility - San Francisco SOMA",
    "description": "Spring Fertility - San Francisco SOMA fertility clinic in San Francisco, CA. Part of the Spring Fertility network.",
    "website": "https://springfertility.com/san-francisco-soma/",
    "phone": "(415) 964-5618",
    "bookingUrl": "https://springfertility.com/san-francisco-soma/",
    "address": {
      "line1": "200 2nd St",
      "city": "San Francisco",
      "state": "CA",
      "zip": "94105",
      "country": "US"
    },
    "location": {
      "lat": 37.7863,
      "lng": -122.3993
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://springfertility.com/san-francisco-soma/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "Spring Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-network",
      "sections": {
        "pricing": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://springfertility.com/team/?location=san-francisco",
            "fetchedAt": "2026-06-10"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "pricing": {
      "packages": [
        {
          "name": "Initial Consultation",
          "description": "First visit to assess fertility and create a plan",
          "price": 25000,
          "priceMax": 54500,
          "currency": "USD",
          "includes": ["Ultrasound", "Physical exam", "Physician consultation"],
          "notes": "Bloodwork billed through insurance if applicable, otherwise ~$200 out-of-pocket"
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Complete egg freezing cycle including anesthesia",
          "price": 896400,
          "priceMax": 996000,
          "locationPrices": [
            {
              "location": "San Francisco",
              "price": 996000
            },
            {
              "location": "New York",
              "price": 996000
            },
            {
              "location": "Oregon",
              "price": 896400
            }
          ],
          "currency": "USD",
          "includes": [
            "Monitoring appointments",
            "Anesthesia",
            "Retrieval",
            "Cryopreservation"
          ],
          "notes": "$9,960 for SF & NY locations; $8,964 for Oregon. Anesthesia is included (unlike most clinics)."
        },
        {
          "name": "Medication Package",
          "description": "Pre-negotiated pharmacy rates tailored to your protocol",
          "price": 390000,
          "priceMax": 510000,
          "currency": "USD",
          "includes": [
            "All medications for cycle",
            "Refills if protocol changes"
          ],
          "notes": "Patients save ~$1,500 on average. Federal assistance may reduce cost by $500 - $750/cycle."
        },
        {
          "name": "Future IVF (using frozen eggs)",
          "description": "Complete path from thaw to transfer when you're ready",
          "price": 2300000,
          "priceMax": 2500000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Blastocyst development",
            "Genetic testing",
            "FET medication",
            "Transfer"
          ]
        }
      ],
      "financingOptions": [
        {
          "name": "Internal Payment Plan",
          "description": "Low monthly payments with no down payment",
          "details": [
            "Under $300/month",
            "No down payment required",
            "Covers cycle cost only"
          ],
          "exclusions": "Does not cover consultation, medications, or storage fees",
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "PatientFi Financing",
          "description": "Healthcare financing with flexible repayment terms",
          "details": [
            "Third-party healthcare financing",
            "Flexible repayment options",
            "Quick approval process"
          ],
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "Multi-Cycle Discount",
          "description": "10% off for self-pay patients doing multiple cycles",
          "details": [
            "10% discount on additional cycles",
            "Available to self-pay patients only"
          ],
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "Spring Promise (Shared Risk)",
          "description": "Full refund if pregnancy is not achieved for qualifying patients",
          "details": [
            "Full refund guarantee if pregnancy not achieved",
            "Designed for qualifying egg freezing patients"
          ],
          "eligibility": "20 eggs by age 35, or 30 eggs by age 38",
          "exclusions": "IVF, anesthesia, and medications are excluded from the refund",
          "_source": {
            "url": "https://springfertility.com/pricing/",
            "fetchedAt": "2026-03-11"
          }
        }
      ],
      "_source": {
        "url": "https://springfertility.com/pricing/",
        "fetchedAt": "2026-03-11"
      }
    },
    "images": [
      {
        "url": "https://springfertility.com/wp-content/uploads/2025/12/Spring-Fertility-Soma-Fertility-Care-For-Tomorrow.jpg",
        "type": "interior",
        "caption": "Spring Fertility SOMA facility",
        "_source": {
          "url": "https://springfertility.com/soma/",
          "fetchedAt": "2026-03-11"
        }
      }
    ],
    "team": [
      {
        "practitionerId": "pr-org-satellite-spring-sf-soma-temeka-zore",
        "name": "Temeka Zore",
        "role": "Fertility Specialist",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2020/06/SpringFertilityDrTemekaZore1.png",
        "_source": {
          "url": "https://springfertility.com/team/dr-temeka-zore/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-spring-sf-soma-kelly-mccarter",
        "name": "Kelly McCarter",
        "role": "Fertility Specialist",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2025/09/large-Quetrell-Heyward_-MD-Fertility-Specialist_Dr.-Brett-Stark-copy-2.webp",
        "_source": {
          "url": "https://springfertility.com/team/dr-kelly-mccarter/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-spring-sf-soma-brett-stark",
        "name": "Brett Stark",
        "role": "Fertility Specialist",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2025/09/MD-Fertility-Specialist_Dr.-Brett-Stark-08.webp",
        "_source": {
          "url": "https://springfertility.com/team/dr-brett-stark/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-spring-sf-soma-audrey-krall",
        "name": "Audrey Krall",
        "credentials": ["RN", "BSN", "MSN", "CNP"],
        "role": "Nurse Practitioner",
        "imageUrl": "https://springfertility.com/wp-content/uploads/2019/09/SpringFertility_AudreyKrall.png",
        "_source": {
          "url": "https://springfertility.com/team/?location=san-francisco",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://springfertility.com/san-francisco-soma/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "4 public price package(s) and 4 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://springfertility.com/pricing/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-bostonivf-boston",
    "externalIds": {
      "googlePlaceId": "ChIJQfTsFHd644kRaw28aGcDrKA"
    },
    "type": "fertility-clinic",
    "name": "Boston IVF - Downtown Boston",
    "description": "Boston IVF - Downtown Boston fertility clinic in Boston, MA. Part of the Boston IVF network.",
    "website": "https://www.bostonivf.com/locations/The-Downtown-Boston-Fertility-Center/",
    "phone": "(857) 244-6750",
    "bookingUrl": "https://www.bostonivf.com/locations/The-Downtown-Boston-Fertility-Center/",
    "address": {
      "line1": "1 Liberty Square, 9th Floor",
      "city": "Boston",
      "state": "MA",
      "zip": "02109",
      "country": "US"
    },
    "location": {
      "lat": 42.3581,
      "lng": -71.0556
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://www.bostonivf.com/insurance/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield of Massachusetts",
        "Blue Cross Blue Shield of Rhode Island",
        "Blue Cross Blue Shield PPO (out-of-state)",
        "Carelink",
        "Carrot",
        "CDPHP",
        "Cigna",
        "Cofertility/EggCo",
        "Emblem Health",
        "Excellus Blue Cross Blue Shield",
        "Empire Blue Cross Blue Shield",
        "GHI",
        "GIC Indemnity",
        "Harvard Pilgrim",
        "Health New England",
        "Highmark Blue Shield of Northeastern NY",
        "Highmark Blue Cross Federal",
        "Maine Community Health Options",
        "Mass General Brigham Health Plan",
        "Maven",
        "NYS Empire Plan",
        "PHCS",
        "Progyny",
        "Stork Club",
        "Tricare",
        "Tufts Health Direct",
        "Unicare",
        "United Healthcare",
        "WellSense Health Plan",
        "WIN Fertility/Premier"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "Boston IVF"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-network",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.bostonivf.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.bostonivf.com/locations/The-Downtown-Boston-Fertility-Center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/locations/The-Downtown-Boston-Fertility-Center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Boston+IVF,+One+Liberty+Sq+9th+Floor,+Boston,+MA+02109/@42.3576414,-71.0548897,2948a,13.1y/data=!4m2!3m1!1s0x89e37a7714ecf441:0xa0ac036768bc0d6b",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Hadi Ramadan",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.bostonivf.com/thumbs/HRamadan_thumb-physicians-main.jpg?v=22592",
        "_source": {
          "url": "https://www.bostonivf.com/physicians/hadi-ramadan",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-bostonivf-boston-hadi-ramadan"
      },
      {
        "name": "Sandy Li",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.bostonivf.com/thumbs/Sandi-Li_thumb-physicians-main.png?v=c34ee",
        "_source": {
          "url": "https://www.bostonivf.com/physicians/sandy-li",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-bostonivf-boston-sandy-li"
      },
      {
        "name": "Alexandra Huttler",
        "role": "Reproductive Endocrinology and Infertility (REI) Fellow",
        "credentials": ["MD"],
        "imageUrl": "https://www.bostonivf.com/thumbs/AHuttler_thumb-physicians-main.png?v=efb6d",
        "_source": {
          "url": "https://www.bostonivf.com/physicians/alexandra-huttler",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-bostonivf-boston-alexandra-huttler"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield of Massachusetts, Blue Cross Blue Shield of Rhode Island, Blue Cross Blue Shield PPO (out-of-state), Carelink, Carrot, CDPHP, Cigna",
              "detail": "23 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.bostonivf.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm8LWtu6r75WMt7MFrryMMnCvCKiybC7yUdctYEenzw-7UrXhU6auhH5rQcMVOn2GNElRqH1z2NSZlDcA4PHxuy-m649cw2S9T-FrhW0-lefu4fYxJC8zRnE9uqNsJd4Pf8X6UnSw=w501-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Boston+IVF,+One+Liberty+Sq+9th+Floor,+Boston,+MA+02109/@42.3576414,-71.0548897,2948a,13.1y/data=!4m2!3m1!1s0x89e37a7714ecf441:0xa0ac036768bc0d6b",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWllPVG2U0nEL2A5ZDv132wwh1S3A3uhzo_I5gWXjV0xCjslFldSMMzWd05hT3QoBxS67p8N47c10u3CkG25IzlyQhuK4Cu4ImNeKX2LnlBLr3V0DdhJbEg1q0QfnfUOwmiR4EQK=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Boston+IVF,+One+Liberty+Sq+9th+Floor,+Boston,+MA+02109/@42.3576414,-71.0548897,2948a,13.1y/data=!4m2!3m1!1s0x89e37a7714ecf441:0xa0ac036768bc0d6b",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-bostonivf-brookline",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Boston IVF - Brookline",
    "description": "Boston IVF - Brookline fertility clinic in Brookline, MA. Part of the Boston IVF network.",
    "website": "https://www.bostonivf.com/locations/brookline/",
    "phone": "(888) 300-2483",
    "bookingUrl": "https://www.bostonivf.com/locations/brookline/",
    "address": {
      "line1": "1 Brookline Pl, Suite 602",
      "city": "Brookline",
      "state": "MA",
      "zip": "02445",
      "country": "US"
    },
    "location": {
      "lat": 42.3442,
      "lng": -71.1186
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://www.bostonivf.com/insurance/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield of Massachusetts",
        "Blue Cross Blue Shield of Rhode Island",
        "Blue Cross Blue Shield PPO (out-of-state)",
        "Carelink",
        "Carrot",
        "CDPHP",
        "Cigna",
        "Cofertility/EggCo",
        "Emblem Health",
        "Excellus Blue Cross Blue Shield",
        "Empire Blue Cross Blue Shield",
        "GHI",
        "GIC Indemnity",
        "Harvard Pilgrim",
        "Health New England",
        "Highmark Blue Shield of Northeastern NY",
        "Highmark Blue Cross Federal",
        "Maine Community Health Options",
        "Mass General Brigham Health Plan",
        "Maven",
        "NYS Empire Plan",
        "PHCS",
        "Progyny",
        "Stork Club",
        "Tricare",
        "Tufts Health Direct",
        "Unicare",
        "United Healthcare",
        "WellSense Health Plan",
        "WIN Fertility/Premier"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "Boston IVF"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-network",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.bostonivf.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/locations/the-brookline-ma-fertility-center",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Lauren Murphy, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": [
          "MD",
          "FACOG",
          "Board-certified in Obstetrics and Gynecology",
          "Board-certified in Reproductive Endocrinology and Infertility"
        ],
        "imageUrl": "https://www.bostonivf.com/thumbs/L-Murphy_thumb-physicians-main.png?v=199cc",
        "_source": {
          "url": "https://www.bostonivf.com/physicians/lauren-murphy",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-bostonivf-brookline-lauren-murphy-md"
      }
    ],
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield of Massachusetts, Blue Cross Blue Shield of Rhode Island, Blue Cross Blue Shield PPO (out-of-state), Carelink, Carrot, CDPHP, Cigna",
              "detail": "23 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.bostonivf.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-bostonivf-quincy",
    "externalIds": {
      "googlePlaceId": "ChIJd4Qpatl844kR7E_ghRby0OE"
    },
    "type": "fertility-clinic",
    "name": "Boston IVF - Quincy",
    "description": "Boston IVF - Quincy fertility clinic in Quincy, MA. Part of the Boston IVF network.",
    "website": "https://www.bostonivf.com/locations/quincy/",
    "phone": "(888) 300-2483",
    "bookingUrl": "https://www.bostonivf.com/locations/quincy/",
    "address": {
      "line1": "500 Congress St, Suite 1B",
      "city": "Quincy",
      "state": "MA",
      "zip": "02169",
      "country": "US"
    },
    "location": {
      "lat": 42.2471,
      "lng": -70.9981
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://www.bostonivf.com/insurance/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield of Massachusetts",
        "Blue Cross Blue Shield of Rhode Island",
        "Blue Cross Blue Shield PPO (out-of-state)",
        "Carelink",
        "Carrot",
        "CDPHP",
        "Cigna",
        "Cofertility/EggCo",
        "Emblem Health",
        "Excellus Blue Cross Blue Shield",
        "Empire Blue Cross Blue Shield",
        "GHI",
        "GIC Indemnity",
        "Harvard Pilgrim",
        "Health New England",
        "Highmark Blue Shield of Northeastern NY",
        "Highmark Blue Cross Federal",
        "Maine Community Health Options",
        "Mass General Brigham Health Plan",
        "Maven",
        "NYS Empire Plan",
        "PHCS",
        "Progyny",
        "Stork Club",
        "Tricare",
        "Tufts Health Direct",
        "Unicare",
        "United Healthcare",
        "WellSense Health Plan",
        "WIN Fertility/Premier"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "Boston IVF"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-network",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.bostonivf.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/locations/the-quincy-ma-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Boston+IVF,+2300+Crown+Colony+Dr+Ste+104,+Quincy,+MA+02169/@42.2353403,-71.0184362,2954a,13.1y/data=!4m2!3m1!1s0x89e37cd96a298477:0xe1d0f21685e04fec",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Brian M. Berger",
        "role": "Reproductive Endocrinologist; Medical Director, Boston IVF South Shore Center (Quincy)",
        "credentials": ["MD"],
        "imageUrl": "https://www.bostonivf.com/thumbs/B-Berger_thumb-physicians-main.png?v=52a12",
        "_source": {
          "url": "https://www.bostonivf.com/physicians/brian-berger",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-bostonivf-quincy-brian-m-berger"
      },
      {
        "name": "Sara Elizabeth Arian",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG", "MSc"],
        "imageUrl": "https://www.bostonivf.com/thumbs/S-Arian_thumb-physicians-main.png?v=9f7b8",
        "_source": {
          "url": "https://www.bostonivf.com/physicians/sara-arian",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-bostonivf-quincy-sara-elizabeth-arian"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield of Massachusetts, Blue Cross Blue Shield of Rhode Island, Blue Cross Blue Shield PPO (out-of-state), Carelink, Carrot, CDPHP, Cigna",
              "detail": "23 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.bostonivf.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnk7Y9L31wM0BqjqpOWx3v8z5dwM2R0QnuARgce_o3fD397TLI1ugcLh4yeh_CJLuOwl2h1gtoI7QeWpHt3bwcMdLAYZYV-6tzww3flt8Nvn8cgUSQpowp6ILo2wxBT7nXwMw_JTA=w300-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Boston+IVF,+2300+Crown+Colony+Dr+Ste+104,+Quincy,+MA+02169/@42.2353403,-71.0184362,2954a,13.1y/data=!4m2!3m1!1s0x89e37cd96a298477:0xe1d0f21685e04fec",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-bostonivf-stoneham",
    "externalIds": {
      "googlePlaceId": "ChIJmX4TO6Z044kR0hZEQBhwGVo"
    },
    "type": "fertility-clinic",
    "name": "Boston IVF - Stoneham",
    "description": "Boston IVF - Stoneham fertility clinic in Stoneham, MA. Part of the Boston IVF network.",
    "website": "https://www.bostonivf.com/locations/stoneham/",
    "phone": "(888) 300-2483",
    "bookingUrl": "https://www.bostonivf.com/locations/stoneham/",
    "address": {
      "line1": "176 Main St, Suite 201",
      "city": "Stoneham",
      "state": "MA",
      "zip": "02180",
      "country": "US"
    },
    "location": {
      "lat": 42.4753,
      "lng": -71.0967
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://www.bostonivf.com/insurance/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield of Massachusetts",
        "Blue Cross Blue Shield of Rhode Island",
        "Blue Cross Blue Shield PPO (out-of-state)",
        "Carelink",
        "Carrot",
        "CDPHP",
        "Cigna",
        "Cofertility/EggCo",
        "Emblem Health",
        "Excellus Blue Cross Blue Shield",
        "Empire Blue Cross Blue Shield",
        "GHI",
        "GIC Indemnity",
        "Harvard Pilgrim",
        "Health New England",
        "Highmark Blue Shield of Northeastern NY",
        "Highmark Blue Cross Federal",
        "Maine Community Health Options",
        "Mass General Brigham Health Plan",
        "Maven",
        "NYS Empire Plan",
        "PHCS",
        "Progyny",
        "Stork Club",
        "Tricare",
        "Tufts Health Direct",
        "Unicare",
        "United Healthcare",
        "WellSense Health Plan",
        "WIN Fertility/Premier"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "Boston IVF"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-network",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.bostonivf.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/locations/the-stoneham-ma-fertility-center",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Boston+IVF,+2+Main+St+%23150,+Stoneham,+MA+02180/@42.5017944,-71.1003809,2942a,13.1y/data=!4m2!3m1!1s0x89e374a63b137e99:0x5a197018404416d2",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Pietro Bortoletto",
        "role": "Reproductive Endocrinologist, Director of Reproductive Surgery",
        "credentials": ["MD", "MSc"],
        "imageUrl": "https://www.bostonivf.com/thumbs/P-Bortoletto_thumb-physicians-main.png",
        "_source": {
          "url": "https://www.bostonivf.com/physicians/pietro-bortoletto",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-bostonivf-stoneham-pietro-bortoletto"
      },
      {
        "name": "Sandy Li",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.bostonivf.com/thumbs/Sandi-Li_thumb-physicians-main.png?v=c34ee",
        "_source": {
          "url": "https://www.bostonivf.com/physicians/sandy-li",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-bostonivf-stoneham-sandy-li"
      },
      {
        "name": "Mary Morris",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "PhD"],
        "imageUrl": "https://www.bostonivf.com/thumbs/mmorris_thumb-physicians-main.png?v=d8d12",
        "_source": {
          "url": "https://www.bostonivf.com/physicians/mary-morris",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-bostonivf-stoneham-mary-morris"
      },
      {
        "name": "Rita Sneeringer",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.bostonivf.com/thumbs/R-Sneeringer_thumb-physicians-main.png?v=18bc8",
        "_source": {
          "url": "https://www.bostonivf.com/physicians/rita-sneeringer",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-bostonivf-stoneham-rita-sneeringer"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield of Massachusetts, Blue Cross Blue Shield of Rhode Island, Blue Cross Blue Shield PPO (out-of-state), Carelink, Carrot, CDPHP, Cigna",
              "detail": "23 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.bostonivf.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmV1zS2AIxaqAat2BlCe-sC0TkmMKaA7AfbP15b1l6IHMZlnecgD00kglvTTtzj18MustkaSm7etmCqE5QQHIPta75zql8U3gPdJ31FEyzIrDc4UTzg_JQjxFTcQSlVMC5XOYTaSnPN7HDK=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Boston+IVF,+2+Main+St+%23150,+Stoneham,+MA+02180/@42.5017944,-71.1003809,2942a,13.1y/data=!4m2!3m1!1s0x89e374a63b137e99:0x5a197018404416d2",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkvxjldBuWYxQP8m_u7SpLqtFECEoqYzEVgt78qM59ORViRHWglfANVPA1VOrkCT2-Mfwc4gM7TKZHlJF1tdpVsr4Yyy3a6lYt7xTnVu69OlqWAKD_D7NNIbsiWUY45xKmQg_vSbg=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Boston+IVF,+2+Main+St+%23150,+Stoneham,+MA+02180/@42.5017944,-71.1003809,2942a,13.1y/data=!4m2!3m1!1s0x89e374a63b137e99:0x5a197018404416d2",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-bostonivf-westborough",
    "externalIds": {
      "googlePlaceId": "ChIJdYyuc5kK5IkRIptF9A5MQ5M"
    },
    "type": "fertility-clinic",
    "name": "Boston IVF - Westborough",
    "description": "Boston IVF - Westborough fertility clinic in Westborough, MA. Part of the Boston IVF network.",
    "website": "https://www.bostonivf.com/locations/westborough/",
    "phone": "(888) 300-2483",
    "bookingUrl": "https://www.bostonivf.com/locations/westborough/",
    "address": {
      "line1": "2 Catamore Blvd",
      "city": "Westborough",
      "state": "MA",
      "zip": "01581",
      "country": "US"
    },
    "location": {
      "lat": 42.2673,
      "lng": -71.6125
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://www.bostonivf.com/insurance/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield of Massachusetts",
        "Blue Cross Blue Shield of Rhode Island",
        "Blue Cross Blue Shield PPO (out-of-state)",
        "Carelink",
        "Carrot",
        "CDPHP",
        "Cigna",
        "Cofertility/EggCo",
        "Emblem Health",
        "Excellus Blue Cross Blue Shield",
        "Empire Blue Cross Blue Shield",
        "GHI",
        "GIC Indemnity",
        "Harvard Pilgrim",
        "Health New England",
        "Highmark Blue Shield of Northeastern NY",
        "Highmark Blue Cross Federal",
        "Maine Community Health Options",
        "Mass General Brigham Health Plan",
        "Maven",
        "NYS Empire Plan",
        "PHCS",
        "Progyny",
        "Stork Club",
        "Tricare",
        "Tufts Health Direct",
        "Unicare",
        "United Healthcare",
        "WellSense Health Plan",
        "WIN Fertility/Premier"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "Boston IVF"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-network",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.bostonivf.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/locations/the-westborough-ma-fertility-center",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Boston+IVF,+4+Bellows+Rd+B,+Westborough,+MA+01581/@42.2845669,-71.6008152,2952a,13.1y/data=!4m2!3m1!1s0x89e40a9973ae8c75:0x93434c0ef4459b22",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Hadi Ramadan",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.bostonivf.com/thumbs/HRamadan_thumb-physicians-main.jpg?v=22592",
        "_source": {
          "url": "https://www.bostonivf.com/physicians/hadi-ramadan",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-bostonivf-westborough-hadi-ramadan"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield of Massachusetts, Blue Cross Blue Shield of Rhode Island, Blue Cross Blue Shield PPO (out-of-state), Carelink, Carrot, CDPHP, Cigna",
              "detail": "23 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.bostonivf.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlmWk1-yFlJPTNzUN89M1bBZ-JL-Pdl288l1xl7zRsd1mi1OyrrwIbY1nDzyIonvy7YnGRJRaAhH8rcNaJCQCjUj8rk8lq9yDoDkJt-I2eSE5pkZbcP7ohvHPyCBl_M1MRDqnQcWg=w408-h408-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Boston+IVF,+4+Bellows+Rd+B,+Westborough,+MA+01581/@42.2845669,-71.6008152,2952a,13.1y/data=!4m2!3m1!1s0x89e40a9973ae8c75:0x93434c0ef4459b22",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-bostonivf-worcester",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Boston IVF - Worcester",
    "description": "Boston IVF - Worcester fertility clinic in Wellesley Hills, MA. Part of the Boston IVF network.",
    "website": "https://www.bostonivf.com/locations/worcester/",
    "phone": "(888) 300-2483",
    "bookingUrl": "https://www.bostonivf.com/locations/worcester/",
    "address": {
      "line1": "161 Worcester Rd",
      "city": "Wellesley Hills",
      "state": "MA",
      "zip": "02481",
      "country": "US"
    },
    "location": {
      "lat": 42.3094,
      "lng": -71.2779
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://www.bostonivf.com/insurance/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield of Massachusetts",
        "Blue Cross Blue Shield of Rhode Island",
        "Blue Cross Blue Shield PPO (out-of-state)",
        "Carelink",
        "Carrot",
        "CDPHP",
        "Cigna",
        "Cofertility/EggCo",
        "Emblem Health",
        "Excellus Blue Cross Blue Shield",
        "Empire Blue Cross Blue Shield",
        "GHI",
        "GIC Indemnity",
        "Harvard Pilgrim",
        "Health New England",
        "Highmark Blue Shield of Northeastern NY",
        "Highmark Blue Cross Federal",
        "Maine Community Health Options",
        "Mass General Brigham Health Plan",
        "Maven",
        "NYS Empire Plan",
        "PHCS",
        "Progyny",
        "Stork Club",
        "Tricare",
        "Tufts Health Direct",
        "Unicare",
        "United Healthcare",
        "WellSense Health Plan",
        "WIN Fertility/Premier"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "Boston IVF"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-network",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.bostonivf.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/locations/the-worcester-ma-fertility-center",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Kim Thornton, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.bostonivf.com/thumbs/K-Thornton_thumb-physicians-main.png?v=9685f",
        "_source": {
          "url": "https://www.bostonivf.com/physicians/kim-thornton",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-bostonivf-worcester-kim-thornton-md"
      },
      {
        "name": "Ann Korkidakis, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.bostonivf.com/thumbs/A-Korkidakis_thumb-physicians-main.png?v=37cb6",
        "_source": {
          "url": "https://www.bostonivf.com/physicians/ann-korkidakis",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-bostonivf-worcester-ann-korkidakis-md"
      },
      {
        "name": "Samuel Pang, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.bostonivf.com/thumbs/S-Pang_thumb-physicians-main.png?v=0a3f4",
        "_source": {
          "url": "https://www.bostonivf.com/physicians/samuel-pang",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-bostonivf-worcester-samuel-pang-md"
      },
      {
        "name": "Samuel Pauli, MD",
        "role": "Reproductive Endocrinologist, Massachusetts Medical Director",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.bostonivf.com/thumbs/S-Pauli_thumb-physicians-main.png?v=751c9",
        "_source": {
          "url": "https://www.bostonivf.com/physicians/samuel-pauli",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-bostonivf-worcester-samuel-pauli-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield of Massachusetts, Blue Cross Blue Shield of Rhode Island, Blue Cross Blue Shield PPO (out-of-state), Carelink, Carrot, CDPHP, Cigna",
              "detail": "23 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.bostonivf.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-satellite-bostonivf-portsmouth",
    "externalIds": {
      "googlePlaceId": "ChIJx5zn09Gr44kRxsw2ZDC3qK0"
    },
    "type": "fertility-clinic",
    "name": "Boston IVF - Portsmouth",
    "description": "Boston IVF - Portsmouth fertility clinic in Portsmouth, NH. Part of the Boston IVF network.",
    "website": "https://www.bostonivf.com/locations/the-portsmouth-nh-fertility-center",
    "phone": "(888) 300-2483",
    "bookingUrl": "https://www.bostonivf.com/locations/the-portsmouth-nh-fertility-center",
    "address": {
      "line1": "100 Campus Dr, Suite 28",
      "city": "Portsmouth",
      "state": "NH",
      "zip": "03801",
      "country": "US"
    },
    "location": {
      "lat": 43.0389,
      "lng": -70.7787
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://www.bostonivf.com/insurance/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield of Massachusetts",
        "Blue Cross Blue Shield of Rhode Island",
        "Blue Cross Blue Shield PPO (out-of-state)",
        "Carelink",
        "Carrot",
        "CDPHP",
        "Cigna",
        "Cofertility/EggCo",
        "Emblem Health",
        "Excellus Blue Cross Blue Shield",
        "Empire Blue Cross Blue Shield",
        "GHI",
        "GIC Indemnity",
        "Harvard Pilgrim",
        "Health New England",
        "Highmark Blue Shield of Northeastern NY",
        "Highmark Blue Cross Federal",
        "Maine Community Health Options",
        "Mass General Brigham Health Plan",
        "Maven",
        "NYS Empire Plan",
        "PHCS",
        "Progyny",
        "Stork Club",
        "Tricare",
        "Tufts Health Direct",
        "Unicare",
        "United Healthcare",
        "WellSense Health Plan",
        "WIN Fertility/Premier"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "Boston IVF"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-network",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.bostonivf.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/locations/the-portsmouth-nh-fertility-center",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Boston+IVF,+Harbour+Women's+Health,+155+Griffin+Rd,+Portsmouth,+NH+03801/@43.055863,-70.7981487,2915a,13.1y/data=!4m2!3m1!1s0x89e3abd1d3e79cc7:0xada8b7306436ccc6",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.bostonivf.com/locations/the-portsmouth-nh-fertility-center",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "practitionerId": "pr-org-satellite-bostonivf-portsmouth-benjamin-m-lannon-md",
        "name": "Benjamin M. Lannon, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.bostonivf.com/thumbs/B-Lannon_thumb-physicians-list.png?v=00665",
        "_source": {
          "url": "https://www.bostonivf.com/locations/the-portsmouth-nh-fertility-center",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield of Massachusetts, Blue Cross Blue Shield of Rhode Island, Blue Cross Blue Shield PPO (out-of-state), Carelink, Carrot, CDPHP, Cigna",
              "detail": "23 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.bostonivf.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Hampshire (NH) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-satellite-cny-albany",
    "externalIds": {
      "googlePlaceId": "ChIJu74NrMIN3okRLdxWIYjk-z8"
    },
    "type": "fertility-clinic",
    "name": "CNY Fertility - Albany",
    "description": "CNY Fertility - Albany fertility clinic in Latham, NY. Part of the CNY Fertility network.",
    "website": "https://www.cnyfertility.com/locations/",
    "phone": "(518) 690-0700",
    "bookingUrl": "https://www.cnyfertility.com/locations/",
    "address": {
      "line1": "38A Old Sparrowbush Rd",
      "city": "Latham",
      "state": "NY",
      "zip": "12110",
      "country": "US"
    },
    "location": {
      "lat": 42.7461,
      "lng": -73.7601
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://www.cnyfertility.com/locations/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "CNY Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-network",
      "sections": {
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CNY+Fertility+Albany,+38A+Old+Sparrowbush+Rd,+Latham,+NY+12110/@42.7598399,-73.7596451,2929a,13.1y/data=!4m2!3m1!1s0x89de0dc2ac0dbebb:0x3ffbe4882156dc2d",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "pricing": {
      "packages": [
        {
          "name": "Virtual Consultation",
          "price": 5000,
          "currency": "USD"
        },
        {
          "name": "IUI",
          "description": "Intrauterine insemination",
          "price": 65000,
          "currency": "USD",
          "notes": "Excludes medications"
        },
        {
          "name": "IVF",
          "description": "In vitro fertilization — clinic fee only",
          "price": 390000,
          "currency": "USD",
          "notes": "Clinic fee only; excludes medications, monitoring, and add-ons"
        },
        {
          "name": "IVF Full Cycle",
          "description": "Complete IVF cycle with core add-ons included",
          "price": 729500,
          "priceMax": 1200000,
          "currency": "USD",
          "includes": [
            "Retrieval",
            "ICSI",
            "Assisted hatching",
            "Cryopreservation"
          ],
          "excludes": ["Medications ($1,500 - $6,000)"],
          "notes": "Range depends on medications and protocol add-ons"
        },
        {
          "name": "Egg Freezing",
          "description": "Oocyte cryopreservation procedure",
          "price": 299900,
          "priceMax": 449000,
          "currency": "USD",
          "notes": "Procedure fee; approximately 1/3 national average ($11,500)"
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 99500,
          "priceMax": 194000,
          "currency": "USD",
          "includes": ["Monitoring (at higher end)"]
        },
        {
          "name": "Donor Egg IVF",
          "description": "In-house donor egg package",
          "price": 1129500,
          "currency": "USD",
          "includes": ["4 fresh donor eggs"]
        }
      ],
      "financingOptions": [
        {
          "name": "In-house payment plans (~100% approval rate)",
          "description": "In-house payment plans (~100% approval rate)"
        },
        {
          "name": "Fertile Guarantee shared-risk program (up to 75% refund if no live birth after 6 cycles)",
          "description": "Fertile Guarantee shared-risk program (up to 75% refund if no live birth after 6 cycles)"
        }
      ],
      "disclaimer": "Medications are additional ($1,500 - $6,000 depending on protocol). Most patients need approximately 2 IVF cycles for a live birth. Storage costs approximately $650/year.",
      "_source": {
        "url": "https://www.cnyfertility.com/costs/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "images": [
      {
        "url": "https://www.cnyfertility.com/wp-content/uploads/2019/10/Albany-General.png",
        "type": "exterior",
        "caption": "CNY Fertility Albany location",
        "_source": {
          "url": "https://www.cnyfertility.com/locations/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.cnyfertility.com/locations/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "7 public price package(s) and 2 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.cnyfertility.com/costs/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-cny-buffalo",
    "externalIds": {
      "googlePlaceId": "ChIJwQd_CAN004kR7VXx6GLZw2I"
    },
    "type": "fertility-clinic",
    "name": "CNY Fertility - Buffalo",
    "description": "CNY Fertility - Buffalo fertility clinic in Williamsville, NY. Part of the CNY Fertility network.",
    "website": "https://www.cnyfertility.com/locations/",
    "phone": "(844) 315-2229",
    "bookingUrl": "https://www.cnyfertility.com/locations/",
    "address": {
      "line1": "835 Hopkins Rd",
      "city": "Williamsville",
      "state": "NY",
      "zip": "14221",
      "country": "US"
    },
    "location": {
      "lat": 42.9634,
      "lng": -78.7363
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://www.cnyfertility.com/locations/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "CNY Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-network",
      "sections": {
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CNY+Fertility+Buffalo,+835+Hopkins+Rd,+Buffalo,+NY+14221/@43.0017838,-78.7389806,2918a,13.1y/data=!4m2!3m1!1s0x89d37403087f07c1:0x62c3d962e8f155ed",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "pricing": {
      "packages": [
        {
          "name": "Virtual Consultation",
          "price": 5000,
          "currency": "USD"
        },
        {
          "name": "IUI",
          "description": "Intrauterine insemination",
          "price": 65000,
          "currency": "USD",
          "notes": "Excludes medications"
        },
        {
          "name": "IVF",
          "description": "In vitro fertilization — clinic fee only",
          "price": 390000,
          "currency": "USD",
          "notes": "Clinic fee only; excludes medications, monitoring, and add-ons"
        },
        {
          "name": "IVF Full Cycle",
          "description": "Complete IVF cycle with core add-ons included",
          "price": 729500,
          "priceMax": 1200000,
          "currency": "USD",
          "includes": [
            "Retrieval",
            "ICSI",
            "Assisted hatching",
            "Cryopreservation"
          ],
          "excludes": ["Medications ($1,500 - $6,000)"],
          "notes": "Range depends on medications and protocol add-ons"
        },
        {
          "name": "Egg Freezing",
          "description": "Oocyte cryopreservation procedure",
          "price": 299900,
          "priceMax": 449000,
          "currency": "USD",
          "notes": "Procedure fee; approximately 1/3 national average ($11,500)"
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 99500,
          "priceMax": 194000,
          "currency": "USD",
          "includes": ["Monitoring (at higher end)"]
        },
        {
          "name": "Donor Egg IVF",
          "description": "In-house donor egg package",
          "price": 1129500,
          "currency": "USD",
          "includes": ["4 fresh donor eggs"]
        }
      ],
      "financingOptions": [
        {
          "name": "In-house payment plans (~100% approval rate)",
          "description": "In-house payment plans (~100% approval rate)"
        },
        {
          "name": "Fertile Guarantee shared-risk program (up to 75% refund if no live birth after 6 cycles)",
          "description": "Fertile Guarantee shared-risk program (up to 75% refund if no live birth after 6 cycles)"
        }
      ],
      "disclaimer": "Medications are additional ($1,500 - $6,000 depending on protocol). Most patients need approximately 2 IVF cycles for a live birth. Storage costs approximately $650/year.",
      "_source": {
        "url": "https://www.cnyfertility.com/costs/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "images": [
      {
        "url": "https://www.cnyfertility.com/wp-content/uploads/2019/10/buffalo-general.png",
        "type": "exterior",
        "caption": "CNY Fertility Buffalo location",
        "_source": {
          "url": "https://www.cnyfertility.com/locations/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlL501OR1I55SXFgP1jGzLLJ7VL82zH9xJB8WudhhGltf108OJwyU6ZciSsj-eems1mvGs6gYE8lUZSFc0jojInd_GiTC72QjyOPIyHH0shrpCnFS3Z8QWIaPWoUvmf7h-YuaKLLw=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CNY+Fertility+Buffalo,+835+Hopkins+Rd,+Buffalo,+NY+14221/@43.0017838,-78.7389806,2918a,13.1y/data=!4m2!3m1!1s0x89d37403087f07c1:0x62c3d962e8f155ed",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnGADCucTyk2DRFq_h_YGTTFQBCKPaa1L4xq5iw5Sp3duawwePb2P8_dmjpscA-5cHhp1y2GFl3bOohPOooWdmFJNr3mJe6IY7YVqrl2Fdg59hgdPT0MPCKhaE5ddXCLtgjjHvZ=w408-h311-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CNY+Fertility+Buffalo,+835+Hopkins+Rd,+Buffalo,+NY+14221/@43.0017838,-78.7389806,2918a,13.1y/data=!4m2!3m1!1s0x89d37403087f07c1:0x62c3d962e8f155ed",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.cnyfertility.com/locations/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "7 public price package(s) and 2 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.cnyfertility.com/costs/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-cny-rochester",
    "externalIds": {
      "googlePlaceId": "ChIJiVuXm47K1okRNJQypRBhbv0"
    },
    "type": "fertility-clinic",
    "name": "CNY Fertility - Rochester",
    "description": "CNY Fertility - Rochester fertility clinic in Rochester, NY. Part of the CNY Fertility network.",
    "website": "https://www.cnyfertility.com/locations/",
    "phone": "(585) 244-1280",
    "bookingUrl": "https://www.cnyfertility.com/locations/",
    "address": {
      "line1": "2244 East Ave",
      "city": "Rochester",
      "state": "NY",
      "zip": "14610",
      "country": "US"
    },
    "location": {
      "lat": 43.1465,
      "lng": -77.56
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://www.cnyfertility.com/locations/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "CNY Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-network",
      "sections": {
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CNY+Fertility+Rochester,+2244+East+Ave,+Rochester,+NY+14610/@43.1413994,-77.544816,2911a,13.1y/data=!4m2!3m1!1s0x89d6ca8e9b975b89:0xfd6e6110a5329434",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "pricing": {
      "packages": [
        {
          "name": "Virtual Consultation",
          "price": 5000,
          "currency": "USD"
        },
        {
          "name": "IUI",
          "description": "Intrauterine insemination",
          "price": 65000,
          "currency": "USD",
          "notes": "Excludes medications"
        },
        {
          "name": "IVF",
          "description": "In vitro fertilization — clinic fee only",
          "price": 390000,
          "currency": "USD",
          "notes": "Clinic fee only; excludes medications, monitoring, and add-ons"
        },
        {
          "name": "IVF Full Cycle",
          "description": "Complete IVF cycle with core add-ons included",
          "price": 729500,
          "priceMax": 1200000,
          "currency": "USD",
          "includes": [
            "Retrieval",
            "ICSI",
            "Assisted hatching",
            "Cryopreservation"
          ],
          "excludes": ["Medications ($1,500 - $6,000)"],
          "notes": "Range depends on medications and protocol add-ons"
        },
        {
          "name": "Egg Freezing",
          "description": "Oocyte cryopreservation procedure",
          "price": 299900,
          "priceMax": 449000,
          "currency": "USD",
          "notes": "Procedure fee; approximately 1/3 national average ($11,500)"
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 99500,
          "priceMax": 194000,
          "currency": "USD",
          "includes": ["Monitoring (at higher end)"]
        },
        {
          "name": "Donor Egg IVF",
          "description": "In-house donor egg package",
          "price": 1129500,
          "currency": "USD",
          "includes": ["4 fresh donor eggs"]
        }
      ],
      "financingOptions": [
        {
          "name": "In-house payment plans (~100% approval rate)",
          "description": "In-house payment plans (~100% approval rate)"
        },
        {
          "name": "Fertile Guarantee shared-risk program (up to 75% refund if no live birth after 6 cycles)",
          "description": "Fertile Guarantee shared-risk program (up to 75% refund if no live birth after 6 cycles)"
        }
      ],
      "disclaimer": "Medications are additional ($1,500 - $6,000 depending on protocol). Most patients need approximately 2 IVF cycles for a live birth. Storage costs approximately $650/year.",
      "_source": {
        "url": "https://www.cnyfertility.com/costs/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "images": [
      {
        "url": "https://www.cnyfertility.com/wp-content/uploads/2019/10/Rochester-General.png",
        "type": "exterior",
        "caption": "CNY Fertility Rochester location",
        "_source": {
          "url": "https://www.cnyfertility.com/locations/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm7LSoHQ5TcolyfCJhaV21x0xo2f6Ws8Btaw78cxD2zIILxNI1Y0lUNouAjqbvyAtN8X7e_YgHm9ccHt1BUbZ6jcVKOCMj3urpoV2YFhVZ460G9yrjgWFEBHitYB6zz_gmNvkDZhw=w360-h240-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CNY+Fertility+Rochester,+2244+East+Ave,+Rochester,+NY+14610/@43.1413994,-77.544816,2911a,13.1y/data=!4m2!3m1!1s0x89d6ca8e9b975b89:0xfd6e6110a5329434",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.cnyfertility.com/locations/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "7 public price package(s) and 2 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.cnyfertility.com/costs/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-cny-sarasota",
    "externalIds": {
      "googlePlaceId": "ChIJudNXWNFHw4gR8zlxSP7UAhY"
    },
    "type": "fertility-clinic",
    "name": "CNY Fertility - Sarasota",
    "description": "CNY Fertility - Sarasota fertility clinic in Sarasota, FL. Part of the CNY Fertility network.",
    "website": "https://www.cnyfertility.com/locations/",
    "phone": "(844) 315-2229",
    "bookingUrl": "https://www.cnyfertility.com/locations/",
    "address": {
      "line1": "5922 Cattlemen Ln",
      "city": "Sarasota",
      "state": "FL",
      "zip": "34232",
      "country": "US"
    },
    "location": {
      "lat": 27.3364,
      "lng": -82.4736
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://www.cnyfertility.com/locations/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "CNY Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-network",
      "sections": {
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CNY+Fertility+Sarasota,+5922+Cattlemen+Ln,+Sarasota,+FL+34232/@27.3137497,-82.450776,3545a,13.1y/data=!4m2!3m1!1s0x88c347d15857d3b9:0x1602d4fe487139f3",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "pricing": {
      "packages": [
        {
          "name": "Virtual Consultation",
          "price": 5000,
          "currency": "USD"
        },
        {
          "name": "IUI",
          "description": "Intrauterine insemination",
          "price": 65000,
          "currency": "USD",
          "notes": "Excludes medications"
        },
        {
          "name": "IVF",
          "description": "In vitro fertilization — clinic fee only",
          "price": 390000,
          "currency": "USD",
          "notes": "Clinic fee only; excludes medications, monitoring, and add-ons"
        },
        {
          "name": "IVF Full Cycle",
          "description": "Complete IVF cycle with core add-ons included",
          "price": 729500,
          "priceMax": 1200000,
          "currency": "USD",
          "includes": [
            "Retrieval",
            "ICSI",
            "Assisted hatching",
            "Cryopreservation"
          ],
          "excludes": ["Medications ($1,500 - $6,000)"],
          "notes": "Range depends on medications and protocol add-ons"
        },
        {
          "name": "Egg Freezing",
          "description": "Oocyte cryopreservation procedure",
          "price": 299900,
          "priceMax": 449000,
          "currency": "USD",
          "notes": "Procedure fee; approximately 1/3 national average ($11,500)"
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 99500,
          "priceMax": 194000,
          "currency": "USD",
          "includes": ["Monitoring (at higher end)"]
        },
        {
          "name": "Donor Egg IVF",
          "description": "In-house donor egg package",
          "price": 1129500,
          "currency": "USD",
          "includes": ["4 fresh donor eggs"]
        }
      ],
      "financingOptions": [
        {
          "name": "In-house payment plans (~100% approval rate)",
          "description": "In-house payment plans (~100% approval rate)"
        },
        {
          "name": "Fertile Guarantee shared-risk program (up to 75% refund if no live birth after 6 cycles)",
          "description": "Fertile Guarantee shared-risk program (up to 75% refund if no live birth after 6 cycles)"
        }
      ],
      "disclaimer": "Medications are additional ($1,500 - $6,000 depending on protocol). Most patients need approximately 2 IVF cycles for a live birth. Storage costs approximately $650/year.",
      "_source": {
        "url": "https://www.cnyfertility.com/costs/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.cnyfertility.com/locations/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "7 public price package(s) and 2 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.cnyfertility.com/costs/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlBhn5Fj9E0QxfUevUhxVj0c8iLOdXErNhu78Qo6JFG0lKFmiypaqmZ180lOgWmFbIXNYSbbrxts7AZp8KzM9_qFIqvpYnJY_O0COPmkqHniQWr7Jm6wD9tHJ3Xx5QTXxDejCi4Ka8Ailno=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CNY+Fertility+Sarasota,+5922+Cattlemen+Ln,+Sarasota,+FL+34232/@27.3137497,-82.450776,3545a,13.1y/data=!4m2!3m1!1s0x88c347d15857d3b9:0x1602d4fe487139f3",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-cny-atlanta",
    "externalIds": {
      "googlePlaceId": "ChIJP93DdMLR9YgRt_U4iIv73fg"
    },
    "type": "fertility-clinic",
    "name": "CNY Fertility - Atlanta",
    "description": "CNY Fertility - Atlanta fertility clinic in Monroe, GA. Part of the CNY Fertility network.",
    "website": "https://www.cnyfertility.com/locations/",
    "phone": "(844) 315-2229",
    "bookingUrl": "https://www.cnyfertility.com/locations/",
    "address": {
      "line1": "924 W Spring St",
      "city": "Monroe",
      "state": "GA",
      "zip": "30655",
      "country": "US"
    },
    "location": {
      "lat": 33.795,
      "lng": -83.7183
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://www.cnyfertility.com/locations/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "CNY Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-network",
      "sections": {
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CNY+Fertility+Atlanta,+924+W+Spring+St,+Monroe,+GA+30655/@33.7937981,-83.7290866,3316a,13.1y/data=!4m2!3m1!1s0x88f5d1c274c3dd3f:0xf8ddfb8b8838f5b7",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "pricing": {
      "packages": [
        {
          "name": "Virtual Consultation",
          "price": 5000,
          "currency": "USD"
        },
        {
          "name": "IUI",
          "description": "Intrauterine insemination",
          "price": 65000,
          "currency": "USD",
          "notes": "Excludes medications"
        },
        {
          "name": "IVF",
          "description": "In vitro fertilization — clinic fee only",
          "price": 390000,
          "currency": "USD",
          "notes": "Clinic fee only; excludes medications, monitoring, and add-ons"
        },
        {
          "name": "IVF Full Cycle",
          "description": "Complete IVF cycle with core add-ons included",
          "price": 729500,
          "priceMax": 1200000,
          "currency": "USD",
          "includes": [
            "Retrieval",
            "ICSI",
            "Assisted hatching",
            "Cryopreservation"
          ],
          "excludes": ["Medications ($1,500 - $6,000)"],
          "notes": "Range depends on medications and protocol add-ons"
        },
        {
          "name": "Egg Freezing",
          "description": "Oocyte cryopreservation procedure",
          "price": 299900,
          "priceMax": 449000,
          "currency": "USD",
          "notes": "Procedure fee; approximately 1/3 national average ($11,500)"
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 99500,
          "priceMax": 194000,
          "currency": "USD",
          "includes": ["Monitoring (at higher end)"]
        },
        {
          "name": "Donor Egg IVF",
          "description": "In-house donor egg package",
          "price": 1129500,
          "currency": "USD",
          "includes": ["4 fresh donor eggs"]
        }
      ],
      "financingOptions": [
        {
          "name": "In-house payment plans (~100% approval rate)",
          "description": "In-house payment plans (~100% approval rate)"
        },
        {
          "name": "Fertile Guarantee shared-risk program (up to 75% refund if no live birth after 6 cycles)",
          "description": "Fertile Guarantee shared-risk program (up to 75% refund if no live birth after 6 cycles)"
        }
      ],
      "disclaimer": "Medications are additional ($1,500 - $6,000 depending on protocol). Most patients need approximately 2 IVF cycles for a live birth. Storage costs approximately $650/year.",
      "_source": {
        "url": "https://www.cnyfertility.com/costs/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.cnyfertility.com/locations/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "7 public price package(s) and 2 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.cnyfertility.com/costs/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnRW3pcoxekCyLEXzGD8B0sXTpdLXGfCb3eyZJcdBj2ZHMToT0GHsyKnQLRzL1NcTM9DuPk1uJwGogjNMn4eGD_eo6zJnXXUerdA7Ilf81h9dCdERaQ3kyjrPw5GxstLBKGTQuRPA=w408-h544-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CNY+Fertility+Atlanta,+924+W+Spring+St,+Monroe,+GA+30655/@33.7937981,-83.7290866,3316a,13.1y/data=!4m2!3m1!1s0x88f5d1c274c3dd3f:0xf8ddfb8b8838f5b7",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-cny-philadelphia",
    "externalIds": {
      "googlePlaceId": "ChIJI7A6qSytxokRok4UCYzQh7w"
    },
    "type": "fertility-clinic",
    "name": "CNY Fertility - Philadelphia",
    "description": "CNY Fertility - Philadelphia fertility clinic in Feasterville-Trevose, PA. Part of the CNY Fertility network.",
    "website": "https://www.cnyfertility.com/locations/",
    "phone": "(844) 315-2229",
    "bookingUrl": "https://www.cnyfertility.com/locations/",
    "address": {
      "line1": "520 Bustleton Pike",
      "city": "Feasterville-Trevose",
      "state": "PA",
      "zip": "19053",
      "country": "US"
    },
    "location": {
      "lat": 40.1519,
      "lng": -75.0338
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://www.cnyfertility.com/locations/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "CNY Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-network",
      "sections": {
        "pricing": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CNY+Fertility+Philadelphia,+520+Bustleton+Pike+Ground,+Feasterville-Trevose,+PA+19053/@40.1463264,-75.0049735,3050a,13.1y/data=!4m2!3m1!1s0x89c6ad2ca93ab023:0xbc87d08c09144ea2",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "date": "2026-03-11",
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "pricing": {
      "packages": [
        {
          "name": "Virtual Consultation",
          "price": 5000,
          "currency": "USD"
        },
        {
          "name": "IUI",
          "description": "Intrauterine insemination",
          "price": 65000,
          "currency": "USD",
          "notes": "Excludes medications"
        },
        {
          "name": "IVF",
          "description": "In vitro fertilization — clinic fee only",
          "price": 390000,
          "currency": "USD",
          "notes": "Clinic fee only; excludes medications, monitoring, and add-ons"
        },
        {
          "name": "IVF Full Cycle",
          "description": "Complete IVF cycle with core add-ons included",
          "price": 729500,
          "priceMax": 1200000,
          "currency": "USD",
          "includes": [
            "Retrieval",
            "ICSI",
            "Assisted hatching",
            "Cryopreservation"
          ],
          "excludes": ["Medications ($1,500 - $6,000)"],
          "notes": "Range depends on medications and protocol add-ons"
        },
        {
          "name": "Egg Freezing",
          "description": "Oocyte cryopreservation procedure",
          "price": 299900,
          "priceMax": 449000,
          "currency": "USD",
          "notes": "Procedure fee; approximately 1/3 national average ($11,500)"
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 99500,
          "priceMax": 194000,
          "currency": "USD",
          "includes": ["Monitoring (at higher end)"]
        },
        {
          "name": "Donor Egg IVF",
          "description": "In-house donor egg package",
          "price": 1129500,
          "currency": "USD",
          "includes": ["4 fresh donor eggs"]
        }
      ],
      "financingOptions": [
        {
          "name": "In-house payment plans (~100% approval rate)",
          "description": "In-house payment plans (~100% approval rate)"
        },
        {
          "name": "Fertile Guarantee shared-risk program (up to 75% refund if no live birth after 6 cycles)",
          "description": "Fertile Guarantee shared-risk program (up to 75% refund if no live birth after 6 cycles)"
        }
      ],
      "disclaimer": "Medications are additional ($1,500 - $6,000 depending on protocol). Most patients need approximately 2 IVF cycles for a live birth. Storage costs approximately $650/year.",
      "_source": {
        "url": "https://www.cnyfertility.com/costs/",
        "fetchedAt": "2026-03-11"
      }
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.cnyfertility.com/locations/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "7 public price package(s) and 2 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.cnyfertility.com/costs/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-satellite-fcne-boston",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Fertility Centers of New England - Boston",
    "description": "Fertility Centers of New England - Boston fertility clinic in Boston, MA. Part of the Fertility Centers of New England network.",
    "website": "https://www.fertilitycenter.com/locations/",
    "phone": "(781) 942-7000",
    "bookingUrl": "https://www.fertilitycenter.com/locations/",
    "address": {
      "line1": "460 Harrison Ave, Suite 340",
      "city": "Boston",
      "state": "MA",
      "zip": "02118",
      "country": "US"
    },
    "location": {
      "lat": 42.3421,
      "lng": -71.068
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://www.fertilitycenter.com/locations/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "Fertility Centers of New England"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-network",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitycenter.com/locations/the-boston-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Beth Plante, M.D.",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.fertilitycenter.com/wp-content/uploads/2020/02/photo-plante-thumb.jpg",
        "_source": {
          "url": "https://www.fertilitycenter.com/about-us/beth-plante-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-fcne-boston-beth-plante-m-d"
      },
      {
        "name": "Robert M. Weiss, M.D.",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.fertilitycenter.com/wp-content/uploads/2020/02/photo-weiss-thumb.jpg",
        "_source": {
          "url": "https://www.fertilitycenter.com/about-us/robert-m-weiss-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-fcne-boston-robert-m-weiss-m-d"
      }
    ],
    "images": [
      {
        "url": "https://www.fertilitycenter.com/wp-content/uploads/2019/06/location-boston.jpg",
        "type": "exterior",
        "caption": "Exterior of the Fertility Centers of New England Boston Center building",
        "_source": {
          "url": "https://www.fertilitycenter.com/locations/the-boston-center/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.fertilitycenter.com/locations/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-fcne-braintree",
    "externalIds": {
      "googlePlaceId": "ChIJMTrikRh944kRkkwUJna3WxY"
    },
    "type": "fertility-clinic",
    "name": "Fertility Centers of New England - Braintree",
    "description": "Fertility Centers of New England - Braintree fertility clinic in Braintree, MA. Part of the Fertility Centers of New England network.",
    "website": "https://www.fertilitycenter.com/locations/",
    "phone": "(781) 942-7000",
    "bookingUrl": "https://www.fertilitycenter.com/locations/",
    "address": {
      "line1": "20 Guest St",
      "city": "Braintree",
      "state": "MA",
      "zip": "02184",
      "country": "US"
    },
    "location": {
      "lat": 42.2126,
      "lng": -71.0033
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://www.fertilitycenter.com/locations/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "Fertility Centers of New England"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-network",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitycenter.com/locations/the-braintree-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+New+England+Braintree,+30+Braintree+Hill+Park+%23107,+Braintree,+MA+02184/@42.2270328,-71.0288638,2954a,13.1y/data=!4m2!3m1!1s0x89e37d1891e23a31:0x165bb77626144c92",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Beth Plante, M.D.",
        "role": "Reproductive Endocrinologist",
        "credentials": [
          "MD",
          "Board-Certified in Obstetrics and Gynecology",
          "Board-Certified in Reproductive Endocrinology and Infertility"
        ],
        "imageUrl": "https://www.fertilitycenter.com/wp-content/uploads/2020/02/photo-plante-thumb.jpg",
        "_source": {
          "url": "https://www.fertilitycenter.com/about-us/beth-plante-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-fcne-braintree-beth-plante-m-d"
      },
      {
        "name": "Robert M. Weiss, M.D.",
        "role": "Reproductive Endocrinologist",
        "credentials": [
          "MD",
          "Board-Certified in Obstetrics and Gynecology",
          "Board-Certified in Reproductive Endocrinology and Infertility"
        ],
        "imageUrl": "https://www.fertilitycenter.com/wp-content/uploads/2020/02/photo-weiss-thumb.jpg",
        "_source": {
          "url": "https://www.fertilitycenter.com/about-us/robert-m-weiss-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-fcne-braintree-robert-m-weiss-m-d"
      }
    ],
    "images": [
      {
        "url": "https://www.fertilitycenter.com/wp-content/uploads/2019/06/location-braintree.jpg",
        "type": "exterior",
        "caption": "Exterior of the Fertility Centers of New England Braintree Center, located in the Braintree Hill Office Park (Voya building), Braintree, MA",
        "_source": {
          "url": "https://www.fertilitycenter.com/locations/the-braintree-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmlxCmC-wJavDrYh-Aw5fTQWsuze2NCO7PGbH60_cHg3AG80292RhN_gZMbrZs8wmzFg-D7TOZAp-fl-V1_qz2stkLsNU8ZszV_XT08sRmgJoJ0EPoAdrpXFG3mY_JKsibCeQv4vQ=w408-h326-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+New+England+Braintree,+30+Braintree+Hill+Park+%23107,+Braintree,+MA+02184/@42.2270328,-71.0288638,2954a,13.1y/data=!4m2!3m1!1s0x89e37d1891e23a31:0x165bb77626144c92",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.fertilitycenter.com/locations/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-fcne-bedford-nh",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Fertility Centers of New England - Bedford NH",
    "description": "Fertility Centers of New England - Bedford NH fertility clinic in Bedford, NH. Part of the Fertility Centers of New England network.",
    "website": "https://www.fertilitycenter.com/locations/the-bedford-center/",
    "phone": "(877) 326-3483",
    "bookingUrl": "https://www.fertilitycenter.com/locations/the-bedford-center/",
    "address": {
      "line1": "169 South River Road, Suite 11",
      "city": "Bedford",
      "state": "NH",
      "zip": "03110",
      "country": "US"
    },
    "location": {
      "lat": 42.9466,
      "lng": -71.4784
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://www.fertilitycenter.com/locations/the-bedford-center/",
        "fetchedAt": "2026-06-13"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "Fertility Centers of New England"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-network",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitycenter.com/about-us/danielle-vitiello-ph-d-m-d/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitycenter.com/locations/the-bedford-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.fertilitycenter.com/locations/the-bedford-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "images": [
      {
        "url": "https://www.fertilitycenter.com/wp-content/uploads/2019/06/location-bedford.jpg",
        "type": "exterior",
        "caption": "Fertility Centers of New England Bedford location image from the official Bedford page.",
        "_source": {
          "url": "https://www.fertilitycenter.com/locations/the-bedford-center/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "team": [
      {
        "practitionerId": "pr-org-satellite-fcne-bedford-nh-danielle-vitiello-phd-md",
        "name": "Danielle Vitiello, PhD, MD",
        "role": "Medical Director",
        "credentials": ["PhD", "MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.fertilitycenter.com/wp-content/uploads/2020/02/photo-vitiello-thumb.jpg",
        "_source": {
          "url": "https://www.fertilitycenter.com/about-us/danielle-vitiello-ph-d-m-d/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.fertilitycenter.com/locations/the-bedford-center/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Hampshire (NH) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-fcne-providence",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Fertility Centers of New England - Providence",
    "description": "Fertility Centers of New England - Providence fertility clinic in Providence, RI. Part of the Fertility Centers of New England network.",
    "website": "https://www.fertilitycenter.com/locations/the-providence-center/",
    "phone": "(877) 326-3483",
    "bookingUrl": "https://www.fertilitycenter.com/locations/",
    "address": {
      "line1": "134 Thurbers Avenue, 2nd Floor, Suite 209",
      "city": "Providence",
      "state": "RI",
      "zip": "02905",
      "country": "US"
    },
    "location": {
      "lat": 41.79981457113047,
      "lng": -71.40781418816266
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://www.fertilitycenter.com/locations/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "Fertility Centers of New England"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-network",
      "sections": {
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitycenter.com/locations/the-providence-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.fertilitycenter.com/locations/the-providence-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitycenter.com/locations/the-providence-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "team": {
          "status": "verified-none",
          "source": {
            "url": "https://www.fertilitycenter.com/locations/the-providence-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "images": [
      {
        "url": "https://www.fertilitycenter.com/wp-content/uploads/2024/02/location-providence.jpeg",
        "type": "exterior",
        "caption": "Fertility Centers of New England Providence location exterior.",
        "_source": {
          "url": "https://www.fertilitycenter.com/locations/the-providence-center/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "team": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.fertilitycenter.com/locations/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Rhode Island (RI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-fcne-falmouth-me",
    "externalIds": {
      "googlePlaceId": "ChIJdU1bAb6DskwR2qm4Hr4aZME"
    },
    "type": "fertility-clinic",
    "name": "Fertility Centers of New England - Falmouth ME",
    "description": "Fertility Centers of New England - Falmouth ME fertility clinic in Falmouth, ME. Part of the Fertility Centers of New England network.",
    "website": "https://www.fertilitycenter.com/locations/the-falmouth-center/",
    "phone": "(877) 326-3483",
    "bookingUrl": "https://www.fertilitycenter.com/locations/the-falmouth-center/",
    "address": {
      "line1": "202 US Route 1, Suite 202",
      "city": "Falmouth",
      "state": "ME",
      "zip": "04105",
      "country": "US"
    },
    "location": {
      "lat": 43.7187821,
      "lng": -70.2342385
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://www.fertilitycenter.com/locations/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "Fertility Centers of New England"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-network",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.fertilitycenter.com/locations/the-falmouth-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+New+England+Falmouth,+202+US-1+%23202,+Falmouth,+ME+04105/@43.7188265,-70.2342787,2884a,13.1y/data=!4m2!3m1!1s0x4cb283be015b4d75:0xc1641abe1eb8a9da",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitycenter.com/locations/the-falmouth-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitycenter.com/about-us/joseph-a-hill-md/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "images": [
      {
        "url": "https://www.fertilitycenter.com/wp-content/uploads/2022/08/68347400584__CB44C38B-6B5C-45EF-BA24-939F4BB16D46.jpg",
        "type": "exterior",
        "caption": "Fertility Centers of New England Falmouth location exterior.",
        "_source": {
          "url": "https://www.fertilitycenter.com/locations/the-falmouth-center/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "team": [
      {
        "practitionerId": "pr-org-satellite-fcne-falmouth-me-joseph-a-hill-iii-md",
        "name": "Joseph A. Hill III, MD",
        "role": "Primary Fertility Doctor",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.fertilitycenter.com/wp-content/uploads/2020/02/photo-hill.jpg",
        "_source": {
          "url": "https://www.fertilitycenter.com/about-us/joseph-a-hill-md/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.fertilitycenter.com/locations/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Maine (ME) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-ivy-memphis",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Fertility Associates of Memphis",
    "description": "Fertility Associates of Memphis fertility clinic in Cordova, TN. Part of the Ivy Fertility network.",
    "website": "https://www.ivyfertility.com/",
    "phone": "(901) 747-2229",
    "bookingUrl": "https://www.ivyfertility.com/",
    "address": {
      "line1": "81 Timber Creek Dr, Suite 2",
      "city": "Cordova",
      "state": "TN",
      "zip": "38018",
      "country": "US"
    },
    "location": {
      "lat": 35.1563,
      "lng": -89.7577
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "_source": {
        "url": "https://www.ivyfertility.com/",
        "fetchedAt": "2026-03-11"
      },
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot"]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "Ivy Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "enrichedAt": "2026-03-11",
      "source": "manual-network",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitymemphis.com/meet-the-team",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Amelia Bailey, MD",
        "role": "Reproductive Endocrinologist; Director of Fertility Preservation",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/1120x1688/4bb87cf8f9/amelia-bailey-md.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://www.fertilitymemphis.com/meet-the-team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-ivy-memphis-amelia-bailey-md"
      },
      {
        "name": "Paul Brezina, MD",
        "role": "Managing Physician; Director of Reproductive Genetics",
        "credentials": ["MD", "MBA"],
        "imageUrl": "https://a.storyblok.com/f/290132/1122x1688/8057794954/paul-brezina-md.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://www.fertilitymemphis.com/meet-the-team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-ivy-memphis-paul-brezina-md"
      },
      {
        "name": "Todd Chappell, MD",
        "role": "Director of Minimally Invasive Gynecologic Surgery",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://a.storyblok.com/f/290132/1118x1688/6e2a74dab1/todd-chappell-md.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://www.fertilitymemphis.com/meet-the-team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-ivy-memphis-todd-chappell-md"
      },
      {
        "name": "Raymond Ke, MD",
        "role": "Director of Assisted Reproductive Technology",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/1114x1688/5086b12d7a/raymond-ke-md.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://www.fertilitymemphis.com/meet-the-team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-ivy-memphis-raymond-ke-md"
      },
      {
        "name": "William Kutteh, MD",
        "role": "Co-Director of the Center for Recurrent Pregnancy Loss",
        "credentials": ["MD", "PhD"],
        "imageUrl": "https://a.storyblok.com/f/290132/1116x1688/de31614aaf/william-kutteh-md.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://www.fertilitymemphis.com/meet-the-team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-ivy-memphis-william-kutteh-md"
      },
      {
        "name": "Sierra Bishop, MD",
        "role": "Physician, Obstetrics, Gynecology, and Reproductive Medicine",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/1711x2566/7dfd08efd2/dr-sierra-bishop.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://www.fertilitymemphis.com/meet-the-team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-satellite-ivy-memphis-sierra-bishop-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.ivyfertility.com/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Tennessee (TN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-sgf-solana-beach",
    "name": "Shady Grove Fertility Solana Beach",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/california/solana-beach-fertility-center/",
    "phone": "(858) 461-3722",
    "address": {
      "line1": "420 Stevens Avenue",
      "city": "Solana Beach",
      "state": "CA",
      "zip": "92075",
      "country": "US"
    },
    "location": {
      "lat": 32.9912,
      "lng": -117.2712
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/california/solana-beach-fertility-center/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Solana+Beach,+420+Stevens+Ave+Ste+300,+Solana+Beach,+CA+92075/@32.9927723,-117.2610093,3346a,13.1y/data=!4m2!3m1!1s0x80dc0977bac01053:0x3f32424d21c4ef23",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "team": [
      {
        "practitionerId": "pr-org-sgf-solana-beach-anne-davis",
        "name": "Anne Davis",
        "credentials": ["MD", "MS"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/06/A.-Davis-850x850-1-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/anne-davis/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-sgf-solana-beach-alexander-quaas",
        "name": "Alexander Quaas",
        "credentials": ["MD", "PhD"],
        "role": "Medical Director, California",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2023/07/Alexander-Quaas-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/quaas/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2024/01/Screenshot-2025-07-29-115414.jpg",
        "type": "exterior"
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlTUeIf6ZnjsHz36O1SK_Aq61QYpKpDScwtw6cL80Isaq7KYRJi7ZexpiJlzQ3oAMBrCnPPSbPkkk1bM2qLnd8xo1pZUuj5ReEwKsBZwW8iw0kzZ6E4E78V85jAv8KEIV9H37b7iNSuETtc=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Solana+Beach,+420+Stevens+Ave+Ste+300,+Solana+Beach,+CA+92075/@32.9927723,-117.2610093,3346a,13.1y/data=!4m2!3m1!1s0x80dc0977bac01053:0x3f32424d21c4ef23",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkUb0cu6t37FavmnF6zQqVBQZxBwUhhTuB2L2ywdyDwt7NnI9AX73qgJEp5sE8nWD7cnXzb1b10stmHRfcyfgAHcTaraemskTmPIESNRdgqRqGz2cNpiUOnjU4cH_sh4bORxxuUQ8d46YGO=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Solana+Beach,+420+Stevens+Ave+Ste+300,+Solana+Beach,+CA+92075/@32.9927723,-117.2610093,3346a,13.1y/data=!4m2!3m1!1s0x80dc0977bac01053:0x3f32424d21c4ef23",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJUxDAuncJ3IARI-_EIU1CMj8"
    }
  },
  {
    "id": "org-sgf-colorado-springs",
    "name": "Shady Grove Fertility Colorado Springs",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/colorado/colorado-springs-fertility-center/",
    "phone": "(719) 314-3333",
    "address": {
      "line1": "4105 Briargate Pkwy, Suite 255",
      "city": "Colorado Springs",
      "state": "CO",
      "zip": "80920",
      "country": "US"
    },
    "location": {
      "lat": 38.9345,
      "lng": -104.7912
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/colorado/colorado-springs-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Colorado+Springs,+4105+Briargate+Pkwy+%23255,+Colorado+Springs,+CO+80920/@38.9650531,-104.7531064,3102a,13.1y/data=!4m2!3m1!1s0x87134c078d4a7e5f:0x4b01e73d5a0a6397",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Shona Murray, M.D.",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "Board Certified OB/GYN", "REI"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Shona-Murray-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/murray/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-colorado-springs-shona-murray-m-d"
      },
      {
        "name": "Amy Lee Harris, M.D.",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "Board Certified OB/GYN", "Board Certified REI"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/06/Amy-Harris-profile-1.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/harris/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-colorado-springs-amy-lee-harris-m-d"
      }
    ],
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/CO_Colorado_Springs_850x850.jpg",
        "type": "exterior",
        "caption": "Exterior of the Shady Grove Fertility Colorado Springs office building",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/colorado/colorado-springs-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnHIDqfDyl9o7tsC0_22S3_dgPreQ9Nx2zw3gkmdrXVCxGGVrLtbBt9O18mCTyYVtAy0RH-yHsHAS9eH4xrbhfDLvRg7dh4aRcGX9ion8vYlA0N4AeYZHlc7rAOWlS2mZjBtDAr=w718-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Colorado+Springs,+4105+Briargate+Pkwy+%23255,+Colorado+Springs,+CO+80920/@38.9650531,-104.7531064,3102a,13.1y/data=!4m2!3m1!1s0x87134c078d4a7e5f:0x4b01e73d5a0a6397",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn6GxQmwgE1LfCvnieomfnKKBheBzYpAzaQ1VXiS5slsGQCAGFW2NdEJ55dj-CwzKA-yIOx8QVp4BCK24ltN44iAH-laKiKyIqob1HCzBOSDvANYvs7d9q4UpyenAIAxgOtYeyeSOH2mmVs=w454-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Colorado+Springs,+4105+Briargate+Pkwy+%23255,+Colorado+Springs,+CO+80920/@38.9650531,-104.7531064,3102a,13.1y/data=!4m2!3m1!1s0x87134c078d4a7e5f:0x4b01e73d5a0a6397",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Colorado (CO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJX35KjQdME4cRl2MKWj3nAUs"
    }
  },
  {
    "id": "org-sgf-denver-central-park",
    "name": "Shady Grove Fertility Denver Central Park",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/colorado/",
    "phone": "(720) 704-8221",
    "address": {
      "line1": "3401 Quebec St, Suite 4010",
      "city": "Denver",
      "state": "CO",
      "zip": "80207",
      "country": "US"
    },
    "location": {
      "lat": 39.7685,
      "lng": -104.9052
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/colorado/denver-central-park-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Elizabeth Clain, M.D.",
        "role": "Reproductive Endocrinologist / Fertility Physician",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/08/E.-Clain-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/clain/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-denver-central-park-elizabeth-clain-m-d"
      },
      {
        "name": "Ivy L. Lersten, M.D.",
        "role": "Reproductive Endocrinologist / Fertility Physician",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2023/09/Ivy-Lersten-NEW-preferred_850-x-850.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/lersten/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-denver-central-park-ivy-l-lersten-m-d"
      }
    ],
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2024/06/processed-FFB3D481-E2DC-4304-B703-6F2DE27A2214-1-scaled.jpeg",
        "type": "exterior",
        "caption": "Exterior of the Shady Grove Fertility Denver Central Park office building (SGF signage visible), 3401 Quebec St, Denver, CO",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/colorado/denver-central-park-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Colorado (CO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-sgf-wilmington",
    "name": "Shady Grove Fertility Newark",
    "description": "Shady Grove Fertility Newark provides fertility care for the greater Newark, Delaware community as part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/delaware/newark-fertility-center/",
    "phone": "(302) 467-1898",
    "address": {
      "line1": "111 Continental Drive, Suite 114",
      "city": "Newark",
      "state": "DE",
      "zip": "19713",
      "country": "US"
    },
    "location": {
      "lat": 39.6885,
      "lng": -75.6605
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "LGBTQIA+ family building",
        "category": "art"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/delaware/newark-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/delaware/newark-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/delaware/newark-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Newark,+111+Continental+Dr+Ste+114,+Newark,+DE+19713/@39.688549,-75.6604931,3070a,13.1y/data=!4m2!3m1!1s0x89c70142b9cb5b35:0x4633854f890ddd37",
            "fetchedAt": "2026-08-16"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/delaware/newark-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "bookingUrl": "https://www.shadygrovefertility.com/locations/delaware/newark-fertility-center/",
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2022/12/CEC-Pictures-006.jpg",
        "type": "exterior",
        "caption": "Shady Grove Fertility Newark office exterior.",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/delaware/newark-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "team": [
      {
        "practitionerId": "pr-org-sgf-wilmington-nicole-m-marchetto-md-mph",
        "name": "Nicole M. Marchetto, MD, MPH",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MPH"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/12/Niole-Marchetto-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/marchetto/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-sgf-wilmington-brianna-schumacher-md",
        "name": "Brianna Schumacher, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Brianna-Schumacher_hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/schumacher/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-sgf-wilmington-erin-o-brien-mms-pa-c",
        "name": "Erin O’Brien, MMS, PA-C",
        "role": "Physician Assistant",
        "credentials": ["MMS", "PA-C"],
        "specialty": "Physician Assistant",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/erin-obrien/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-sgf-wilmington-amanda-zlupko-crnp-whnp-bc",
        "name": "Amanda Zlupko, CRNP, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["CRNP", "WHNP-BC"],
        "specialty": "Women's Health Nurse Practitioner",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/09/Zlupko-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/zlupko/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Delaware (DE) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJNVvLuUIBx4kRN90NiU-FM0Y"
    }
  },
  {
    "id": "org-sgf-brandon",
    "name": "Shady Grove Fertility Brandon",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/florida/brandon-fertility-center/",
    "phone": "(813) 463-1234",
    "address": {
      "line1": "515 S Kings Ave, Suite 2200",
      "city": "Brandon",
      "state": "FL",
      "zip": "33511",
      "country": "US"
    },
    "location": {
      "lat": 27.9376,
      "lng": -82.2859
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/florida/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Brandon,+515+S+Kings+Ave+Ste+2200,+Brandon,+FL+33511/@27.9313242,-82.293823,3525a,13.1y/data=!4m2!3m1!1s0x88c2cd9f74df45af:0x9fb574e240433ed7",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Anthony N. Imudia, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/11/Anthony-Imudia-profile-e1647611307797.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-brandon-anthony-n-imudia-md"
      },
      {
        "name": "L. Kendall Rauchfuss, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/09/L.-Kendall-Rauchfuss-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-brandon-l-kendall-rauchfuss-md"
      },
      {
        "name": "George Patounakis, MD, PhD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/12/G.-Patounakis-Website.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-brandon-george-patounakis-md-phd"
      },
      {
        "name": "Shayne Plosker, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Shayne_Plosker-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-brandon-shayne-plosker-md"
      },
      {
        "name": "Papri Sarkar, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/08/Sarkar-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-brandon-papri-sarkar-md"
      },
      {
        "name": "Celso Silva, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/02/Celso-Silva-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-brandon-celso-silva-md"
      },
      {
        "name": "Rachel Sprague",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/10/Rachel-Sprague-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": [],
        "practitionerId": "pr-org-sgf-brandon-rachel-sprague"
      },
      {
        "name": "Saioa Torrealday, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/10/Torrealday-850x850-2.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-brandon-saioa-torrealday-md"
      },
      {
        "name": "Christine Kincaid, WHNP-BC",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/05/Christine-Kincaid-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "credentials": ["WHNP-BC"],
        "practitionerId": "pr-org-sgf-brandon-christine-kincaid-whnp-bc"
      },
      {
        "name": "Susana Soto-Rodriguez, NP",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/01/Susie-Rodriguez.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "credentials": ["NP"],
        "practitionerId": "pr-org-sgf-brandon-susana-soto-rodriguez-np"
      },
      {
        "name": "Cortney White, MSN, CNM, WHNP-BC",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2023/02/Cortney-White-profile.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "credentials": ["MSN", "CNM", "WHNP-BC"],
        "practitionerId": "pr-org-sgf-brandon-cortney-white-msn-cnm-whnp-bc"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2021/02/Brandon_Building_Front_with_Oak_hero.jpg",
        "type": "exterior",
        "caption": "Shady Grove Fertility Brandon clinic exterior",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/florida/brandon-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm61lV-CRbaARBvQ85XsgHHO32Ak68_g9mvKBg5aYsKeQQIh8BNpAdRcm5aXsCj1J5Fbm7dlCor_vSxI1diCm7tQGLQJaI_C0ZqdTmeUz9-nUf0S0ZyByqV1ugO6SHMaDOeELdLMQ=w454-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Brandon,+515+S+Kings+Ave+Ste+2200,+Brandon,+FL+33511/@27.9313242,-82.293823,3525a,13.1y/data=!4m2!3m1!1s0x88c2cd9f74df45af:0x9fb574e240433ed7",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJr0XfdJ_NwogR1z5DQOJ0tZ8"
    }
  },
  {
    "id": "org-sgf-orlando",
    "name": "Shady Grove Fertility Orlando",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/florida/orlando-fertility-center/",
    "phone": "(689) 500-4016",
    "address": {
      "line1": "265 E Rollins St",
      "city": "Orlando",
      "state": "FL",
      "zip": "32804",
      "country": "US"
    },
    "location": {
      "lat": 28.5685,
      "lng": -81.3668
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/florida/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Orlando,+265+E+Rollins+St+Ste+10100,+Orlando,+FL+32804/@28.5744143,-81.3748589,3504a,13.1y/data=!4m2!3m1!1s0x88e77f21e111024f:0x30a946a6e80cbb06",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Anthony N. Imudia, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/11/Anthony-Imudia-profile-e1647611307797.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-orlando-anthony-n-imudia-md"
      },
      {
        "name": "L. Kendall Rauchfuss, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/09/L.-Kendall-Rauchfuss-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-orlando-l-kendall-rauchfuss-md"
      },
      {
        "name": "George Patounakis, MD, PhD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/12/G.-Patounakis-Website.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-orlando-george-patounakis-md-phd"
      },
      {
        "name": "Shayne Plosker, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Shayne_Plosker-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-orlando-shayne-plosker-md"
      },
      {
        "name": "Papri Sarkar, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/08/Sarkar-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-orlando-papri-sarkar-md"
      },
      {
        "name": "Celso Silva, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/02/Celso-Silva-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-orlando-celso-silva-md"
      },
      {
        "name": "Rachel Sprague",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/10/Rachel-Sprague-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": [],
        "practitionerId": "pr-org-sgf-orlando-rachel-sprague"
      },
      {
        "name": "Saioa Torrealday, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/10/Torrealday-850x850-2.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-orlando-saioa-torrealday-md"
      },
      {
        "name": "Christine Kincaid, WHNP-BC",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/05/Christine-Kincaid-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "credentials": ["WHNP-BC"],
        "practitionerId": "pr-org-sgf-orlando-christine-kincaid-whnp-bc"
      },
      {
        "name": "Susana Soto-Rodriguez, NP",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/01/Susie-Rodriguez.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "credentials": ["NP"],
        "practitionerId": "pr-org-sgf-orlando-susana-soto-rodriguez-np"
      },
      {
        "name": "Cortney White, MSN, CNM, WHNP-BC",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2023/02/Cortney-White-profile.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "credentials": ["MSN", "CNM", "WHNP-BC"],
        "practitionerId": "pr-org-sgf-orlando-cortney-white-msn-cnm-whnp-bc"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2023/06/Z816268-scaled.jpg",
        "type": "exterior",
        "caption": "Shady Grove Fertility Orlando clinic",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/florida/orlando-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlddCzScbQt0KJAslgWd4vS6WmDsEvXfqazDunW5YUnS9Ac6vu8BJhhFfllXEU3FfebJFZuVryrzhA9PRaGEalcsX9vbz3Tp18Pk5_BySV0O9HjJ0MSrXRe17qrzpa8Y7TfukIIlQ=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Orlando,+265+E+Rollins+St+Ste+10100,+Orlando,+FL+32804/@28.5744143,-81.3748589,3504a,13.1y/data=!4m2!3m1!1s0x88e77f21e111024f:0x30a946a6e80cbb06",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJTwIR4SF_54gRBrsM6KZGqTA"
    }
  },
  {
    "id": "org-sgf-st-petersburg",
    "name": "Shady Grove Fertility St. Petersburg",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/florida/st-petersburg-fertility-center/",
    "phone": "(727) 379-2838",
    "address": {
      "line1": "601 Seventh St S, Suite 475",
      "city": "St. Petersburg",
      "state": "FL",
      "zip": "33701",
      "country": "US"
    },
    "location": {
      "lat": 27.7661,
      "lng": -82.6363
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/florida/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+St.+Petersburg,+570+8th+St+S+Ste+1200,+St.+Petersburg,+FL+33701/@27.764483,-82.6445358,3530a,13.1y/data=!4m2!3m1!1s0x88c2e1dcada3773f:0xacf383153788442b",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Anthony N. Imudia, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/11/Anthony-Imudia-profile-e1647611307797.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-st-petersburg-anthony-n-imudia-md"
      },
      {
        "name": "L. Kendall Rauchfuss, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/09/L.-Kendall-Rauchfuss-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-st-petersburg-l-kendall-rauchfuss-md"
      },
      {
        "name": "George Patounakis, MD, PhD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/12/G.-Patounakis-Website.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-st-petersburg-george-patounakis-md-phd"
      },
      {
        "name": "Shayne Plosker, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Shayne_Plosker-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-st-petersburg-shayne-plosker-md"
      },
      {
        "name": "Papri Sarkar, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/08/Sarkar-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-st-petersburg-papri-sarkar-md"
      },
      {
        "name": "Celso Silva, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/02/Celso-Silva-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-st-petersburg-celso-silva-md"
      },
      {
        "name": "Rachel Sprague",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/10/Rachel-Sprague-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": [],
        "practitionerId": "pr-org-sgf-st-petersburg-rachel-sprague"
      },
      {
        "name": "Saioa Torrealday, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/10/Torrealday-850x850-2.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-st-petersburg-saioa-torrealday-md"
      },
      {
        "name": "Christine Kincaid, WHNP-BC",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/05/Christine-Kincaid-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "credentials": ["WHNP-BC"],
        "practitionerId": "pr-org-sgf-st-petersburg-christine-kincaid-whnp-bc"
      },
      {
        "name": "Susana Soto-Rodriguez, NP",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/01/Susie-Rodriguez.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "credentials": ["NP"],
        "practitionerId": "pr-org-sgf-st-petersburg-susana-soto-rodriguez-np"
      },
      {
        "name": "Cortney White, MSN, CNM, WHNP-BC",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2023/02/Cortney-White-profile.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "credentials": ["MSN", "CNM", "WHNP-BC"],
        "practitionerId": "pr-org-sgf-st-petersburg-cortney-white-msn-cnm-whnp-bc"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2022/09/St.-Pete-Office_Jan2026_EDITED2.jpg",
        "type": "exterior",
        "caption": "Shady Grove Fertility St. Petersburg clinic",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/florida/st-petersburg-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJP3ejrdzhwogRK0SINxWD86w"
    }
  },
  {
    "id": "org-sgf-wesley-chapel",
    "name": "Shady Grove Fertility Wesley Chapel",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/florida/wesley-chapel-fertility-center/",
    "phone": "(813) 463-1234",
    "address": {
      "line1": "2352 Bruce B Downs Blvd, Suite 200",
      "city": "Wesley Chapel",
      "state": "FL",
      "zip": "33544",
      "country": "US"
    },
    "location": {
      "lat": 28.2333,
      "lng": -82.3396
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/florida/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Wesley+Chapel,+2590+Healing+Wy+Ste+160,+Wesley+Chapel,+FL+33544/@28.1945247,-82.351311,3516a,13.1y/data=!4m2!3m1!1s0x88c2b173002e645f:0x9e65c045361f6199",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Anthony N. Imudia, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/11/Anthony-Imudia-profile-e1647611307797.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-wesley-chapel-anthony-n-imudia-md"
      },
      {
        "name": "L. Kendall Rauchfuss, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/09/L.-Kendall-Rauchfuss-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-wesley-chapel-l-kendall-rauchfuss-md"
      },
      {
        "name": "George Patounakis, MD, PhD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/12/G.-Patounakis-Website.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-wesley-chapel-george-patounakis-md-phd"
      },
      {
        "name": "Shayne Plosker, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Shayne_Plosker-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-wesley-chapel-shayne-plosker-md"
      },
      {
        "name": "Papri Sarkar, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/08/Sarkar-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-wesley-chapel-papri-sarkar-md"
      },
      {
        "name": "Celso Silva, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/02/Celso-Silva-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-wesley-chapel-celso-silva-md"
      },
      {
        "name": "Rachel Sprague",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/10/Rachel-Sprague-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": [],
        "practitionerId": "pr-org-sgf-wesley-chapel-rachel-sprague"
      },
      {
        "name": "Saioa Torrealday, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/10/Torrealday-850x850-2.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-wesley-chapel-saioa-torrealday-md"
      },
      {
        "name": "Christine Kincaid, WHNP-BC",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/05/Christine-Kincaid-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "credentials": ["WHNP-BC"],
        "practitionerId": "pr-org-sgf-wesley-chapel-christine-kincaid-whnp-bc"
      },
      {
        "name": "Susana Soto-Rodriguez, NP",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/01/Susie-Rodriguez.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "credentials": ["NP"],
        "practitionerId": "pr-org-sgf-wesley-chapel-susana-soto-rodriguez-np"
      },
      {
        "name": "Cortney White, MSN, CNM, WHNP-BC",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2023/02/Cortney-White-profile.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "credentials": ["MSN", "CNM", "WHNP-BC"],
        "practitionerId": "pr-org-sgf-wesley-chapel-cortney-white-msn-cnm-whnp-bc"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk6f2oD75zuDik4SxSXiL4jtIO0zDJX2V-MCV2fq97Do_xuJPjS2y1C39-pEYJaPffh6uNUvB4FVWMJgoKdnvCf5cPqarcG_YUkU7-a33ksDIKbBIT8G9SzYgXY-BgkQ4hqVbPQxtyk4Ss=w427-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Wesley+Chapel,+2590+Healing+Wy+Ste+160,+Wesley+Chapel,+FL+33544/@28.1945247,-82.351311,3516a,13.1y/data=!4m2!3m1!1s0x88c2b173002e645f:0x9e65c045361f6199",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJX2QuAHOxwogRmWEfNkXAZZ4"
    }
  },
  {
    "id": "org-sgf-westshore",
    "name": "Shady Grove Fertility Westshore",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/florida/",
    "phone": "(813) 463-1234",
    "address": {
      "line1": "4020 W Boy Scout Blvd, Suite 100",
      "city": "Tampa",
      "state": "FL",
      "zip": "33607",
      "country": "US"
    },
    "location": {
      "lat": 27.9527,
      "lng": -82.5278
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/florida/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Tampa,+5016+W+Cypress+St+Ste+302,+Tampa,+FL+33607/@27.9518926,-82.5294947,3524a,13.1y/data=!4m2!3m1!1s0x88c2c3427c172efb:0x86d13fe8fdf126bd",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Anthony N. Imudia, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/11/Anthony-Imudia-profile-e1647611307797.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-westshore-anthony-n-imudia-md"
      },
      {
        "name": "L. Kendall Rauchfuss, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/09/L.-Kendall-Rauchfuss-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-westshore-l-kendall-rauchfuss-md"
      },
      {
        "name": "George Patounakis, MD, PhD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/12/G.-Patounakis-Website.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-westshore-george-patounakis-md-phd"
      },
      {
        "name": "Shayne Plosker, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Shayne_Plosker-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-westshore-shayne-plosker-md"
      },
      {
        "name": "Papri Sarkar, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/08/Sarkar-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-westshore-papri-sarkar-md"
      },
      {
        "name": "Celso Silva, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/02/Celso-Silva-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-westshore-celso-silva-md"
      },
      {
        "name": "Rachel Sprague",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/10/Rachel-Sprague-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": [],
        "practitionerId": "pr-org-sgf-westshore-rachel-sprague"
      },
      {
        "name": "Saioa Torrealday, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/10/Torrealday-850x850-2.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-westshore-saioa-torrealday-md"
      },
      {
        "name": "Christine Kincaid, WHNP-BC",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/05/Christine-Kincaid-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "credentials": ["WHNP-BC"],
        "practitionerId": "pr-org-sgf-westshore-christine-kincaid-whnp-bc"
      },
      {
        "name": "Susana Soto-Rodriguez, NP",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/01/Susie-Rodriguez.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "credentials": ["NP"],
        "practitionerId": "pr-org-sgf-westshore-susana-soto-rodriguez-np"
      },
      {
        "name": "Cortney White, MSN, CNM, WHNP-BC",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2023/02/Cortney-White-profile.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "credentials": ["MSN", "CNM", "WHNP-BC"],
        "practitionerId": "pr-org-sgf-westshore-cortney-white-msn-cnm-whnp-bc"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2021/02/NewWestshoreOffice_Dec2021_850x850.jpg",
        "type": "exterior",
        "caption": "Shady Grove Fertility Westshore clinic",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/florida/tampa-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn-sfwEvyuekFNDmgk-SHwzBxqGuJz0UtWeZp8OKK6ORWyzgXiVzL5z4GuOUUpIZabRC1KHv2w9P3vg1R6St0Y71CJRHgi58o8jh-_F6sjMfdiHaR4c0lNUWe-VaPEE9JNzR2_04CYugdmp=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Tampa,+5016+W+Cypress+St+Ste+302,+Tampa,+FL+33607/@27.9518926,-82.5294947,3524a,13.1y/data=!4m2!3m1!1s0x88c2c3427c172efb:0x86d13fe8fdf126bd",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkjeu4ebaetTcDn2oE-KMjwXiDFZRI1lOYbDgsj6gxLRouMDyCVdpXYPn1_gb5l7p5C8mjY-sLch6fUDMmWUn4hhpZb3XkBWGQ839dLPPgMhw7-cx3rB6_iDpdQexIeu9tEaU85=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Tampa,+5016+W+Cypress+St+Ste+302,+Tampa,+FL+33607/@27.9518926,-82.5294947,3524a,13.1y/data=!4m2!3m1!1s0x88c2c3427c172efb:0x86d13fe8fdf126bd",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJ-y4XfELDwogRvSbx_eg_0YY"
    }
  },
  {
    "id": "org-sgf-annapolis",
    "name": "Shady Grove Fertility Annapolis",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/maryland/annapolis-fertility-center/",
    "phone": "(410) 224-5500",
    "address": {
      "line1": "2000 Medical Pkwy, Suite 308",
      "city": "Annapolis",
      "state": "MD",
      "zip": "21401",
      "country": "US"
    },
    "location": {
      "lat": 38.9784,
      "lng": -76.5243
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/maryland/annapolis-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/maryland/annapolis-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Annapolis,+2000+Medical+Pkwy+%23308,+Annapolis,+MD+21401/@38.9897413,-76.5368134,3101a,13.1y/data=!4m2!3m1!1s0x89b7f6d9c47aec81:0x64e11a8440c35b7b",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-sgf-annapolis-rebecca-j-chason-md",
        "name": "Rebecca J. Chason, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Rebecca-Chason-hero-150x150.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/annapolis-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-sgf-annapolis-jessica-a-marinaro-md",
        "name": "Jessica A. Marinaro, MD",
        "role": "Reproductive Urologist",
        "credentials": ["MD"],
        "specialty": "Urology / Male Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2023/07/J.-Marinaro-850x850-1-150x150.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/annapolis-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-sgf-annapolis-jeffrey-l-mckeeby-md",
        "name": "Jeffrey L. McKeeby, MD",
        "role": "Medical Director, Towson ASC",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Jeffrey_L._McKeeby-150x150.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/mckeeby/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-sgf-annapolis-mae-w-healy-do",
        "name": "Mae W. Healy, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2023/07/M.-Healy850x850-150x150.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/annapolis-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-sgf-annapolis-matthew-t-connell-do",
        "name": "Matthew T. Connell, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Matt-Connell-hero-150x150.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/annapolis-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Maryland (MD) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmOpOXxvj09T7D8sDDz_QxheLHoqI_fKmfW1n50WqiVhUI-eDar7iTSCmvaKyVAdCR6K7JNawsvJLc9Xp-wrseu7NuXn183d-0v9ZJcBJiVNVRJmFJpm7CkkgRRULlN_himIXbf_b42AeIW=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Annapolis,+2000+Medical+Pkwy+%23308,+Annapolis,+MD+21401/@38.9897413,-76.5368134,3101a,13.1y/data=!4m2!3m1!1s0x89b7f6d9c47aec81:0x64e11a8440c35b7b",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "externalIds": {
      "googlePlaceId": "ChIJgex6xNn2t4kRe1vDQIQa4WQ"
    }
  },
  {
    "id": "org-sgf-baltimore",
    "name": "Shady Grove Fertility Baltimore - Harbor East",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/maryland/baltimore-fertility-center/",
    "phone": "(443) 825-3340",
    "address": {
      "line1": "720 Aliceanna St, Suite 300",
      "city": "Baltimore",
      "state": "MD",
      "zip": "21202",
      "country": "US"
    },
    "location": {
      "lat": 39.2823,
      "lng": -76.5928
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/maryland/baltimore-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/maryland/baltimore-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Baltimore+-+Harbor+East,+720+Aliceanna+St+%23300,+Baltimore,+MD+21202/@39.283427,-76.602232,3088a,13.1y/data=!4m2!3m1!1s0x89c8037c37cfe22b:0x77a4eb5f0478ac2a",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-sgf-baltimore-jessica-a-marinaro-md",
        "name": "Jessica A. Marinaro, MD",
        "role": "Reproductive Urologist",
        "credentials": ["MD"],
        "specialty": "Urology / Male Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2023/07/J.-Marinaro-850x850-1-150x150.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/baltimore-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-sgf-baltimore-jerrine-r-morris-md-mph",
        "name": "Jerrine R. Morris, MD, MPH",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MPH"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/09/MicrosoftTeams-image-21-150x150.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/baltimore-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-sgf-baltimore-emily-opdycke-crnp",
        "name": "Emily Opdycke, CRNP",
        "role": "Nurse Practitioner",
        "credentials": ["CRNP"],
        "specialty": "Advanced Practice Provider",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Emily-Opdycke-hero-150x150.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/baltimore-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Maryland (MD) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlZp9aojCclcYBdjNT5k3z-cd_qq8kCB5hVlsSI9xtNSM1F_YPhCJHwFeez6fvcYZzOw7kcTa2qUcQQUia70ewOazvPL0bu3d1QxvGvsqBbTmvu_awQ7w8WMPGI9D-rnQUPu0_BDJTJPbel=w448-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Baltimore+-+Harbor+East,+720+Aliceanna+St+%23300,+Baltimore,+MD+21202/@39.283427,-76.602232,3088a,13.1y/data=!4m2!3m1!1s0x89c8037c37cfe22b:0x77a4eb5f0478ac2a",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlK5uPo9Fdd463u-DXH6EPRKc-fnCl2_85Civqd-Gj0zk0oV_LS85NCc_ED3gzxcQi7_RN3H5XK-4eyFfjKuaKwP7tC4WeDBNYBMX8PUKb0pkiKJ2nC688xFSzJUsnWIFCHO3HIZQ=w298-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Baltimore+-+Harbor+East,+720+Aliceanna+St+%23300,+Baltimore,+MD+21202/@39.283427,-76.602232,3088a,13.1y/data=!4m2!3m1!1s0x89c8037c37cfe22b:0x77a4eb5f0478ac2a",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "externalIds": {
      "googlePlaceId": "ChIJK-LPN3wDyIkRKqx4BF_rpHc"
    }
  },
  {
    "id": "org-sgf-columbia",
    "name": "Shady Grove Fertility Columbia",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/maryland/columbia-fertility-center/",
    "phone": "(410) 997-6999",
    "address": {
      "line1": "10630 Little Patuxent Pkwy, Suite 305",
      "city": "Columbia",
      "state": "MD",
      "zip": "21044",
      "country": "US"
    },
    "location": {
      "lat": 39.2137,
      "lng": -76.8526
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/maryland/columbia-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/maryland/columbia-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Columbia,+10630+Little+Patuxent+Pkwy+%23305,+Columbia,+MD+21044/@39.2144787,-76.8708745,3091a,13.1y/data=!4m2!3m1!1s0x89b7dfa03cfb455d:0xe086c01a721e8dec",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-sgf-columbia-alexis-gadson-md",
        "name": "Alexis Gadson, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2023/08/A.-Gadson-850x850-1-150x150.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/columbia-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-sgf-columbia-jessica-a-marinaro-md",
        "name": "Jessica A. Marinaro, MD",
        "role": "Reproductive Urologist",
        "credentials": ["MD"],
        "specialty": "Urology / Male Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2023/07/J.-Marinaro-850x850-1-150x150.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/columbia-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-sgf-columbia-joseph-e-osheroff-md",
        "name": "Joseph E. Osheroff, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Joseph_E._Osheroff-150x150.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/columbia-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-sgf-columbia-loretta-trumble-crnp",
        "name": "Loretta Trumble, CRNP",
        "role": "Nurse Practitioner",
        "credentials": ["CRNP"],
        "specialty": "Advanced Practice Provider",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Loretta_Trumble_main_image-150x150.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/columbia-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Maryland (MD) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl7N7l3DHGwfIhO3PVgGMEvLeGRDGgLI52dDWjpzkeOs9Pea9qL0NJ4TMJLW9-pJ5CHviFvYej9Pk9HpTg7zoX9VSWzEtdCKRG6rjR6MiLUNUTcyj195s874C4KQwmoqEpez1jYVt63dB7g=w468-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Columbia,+10630+Little+Patuxent+Pkwy+%23305,+Columbia,+MD+21044/@39.2144787,-76.8708745,3091a,13.1y/data=!4m2!3m1!1s0x89b7dfa03cfb455d:0xe086c01a721e8dec",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkWYFvu0RO7UkGka65oSQA7ok2cemWTwQq68ue3nhxIxnbaUE-LPpqHqVgsum-SN000-XlKSA6d6dRBzEHKJsl-DFCIJneV6ZUNOuA66lJ89N5EsowhQz-i5N2Lokn5jfOD7ExqlA=w224-h298-k-no-pi-0-ya19.389053-ro-0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Columbia,+10630+Little+Patuxent+Pkwy+%23305,+Columbia,+MD+21044/@39.2144787,-76.8708745,3091a,13.1y/data=!4m2!3m1!1s0x89b7dfa03cfb455d:0xe086c01a721e8dec",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "externalIds": {
      "googlePlaceId": "ChIJXUX7PKDft4kR7I0echrAhuA"
    }
  },
  {
    "id": "org-sgf-salisbury",
    "name": "Shady Grove Fertility Salisbury",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/maryland/salisbury/",
    "phone": "(410) 546-3700",
    "address": {
      "line1": "1415 S Division St",
      "city": "Salisbury",
      "state": "MD",
      "zip": "21804",
      "country": "US"
    },
    "location": {
      "lat": 38.3514,
      "lng": -75.5996
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "verified-none",
          "source": {
            "url": "https://www.shadygrovefertility.com/maryland/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Salisbury,+MD,+1647+Woodbrooke+Dr,+Salisbury,+MD+21804/@38.3635263,-75.5528705,3128a,13.1y/data=!4m2!3m1!1s0x89b9040d6c853255:0xe6d486474ac3070d",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Maryland (MD) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [],
    "externalIds": {
      "googlePlaceId": "ChIJVTKFbA0EuYkRDQfDSkeG1OY"
    }
  },
  {
    "id": "org-sgf-waldorf",
    "name": "Shady Grove Fertility Waldorf",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/maryland/waldorf-fertility-center/",
    "phone": "(301) 705-9923",
    "address": {
      "line1": "3010 Crain Highway, Suite 201",
      "city": "Waldorf",
      "state": "MD",
      "zip": "20601",
      "country": "US"
    },
    "location": {
      "lat": 38.625925,
      "lng": -76.910476
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/maryland/waldorf-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/maryland/waldorf-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Waldorf,+3010+Crain+Hwy+Ste+201,+Waldorf,+MD+20601/@38.6289386,-76.9060507,3117a,13.1y/data=!4m2!3m1!1s0x89b7a125fe68d6b7:0xc8271b673382f1d7",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-sgf-waldorf-matthew-t-connell-do",
        "name": "Matthew T. Connell, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Matt-Connell-hero-150x150.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/waldorf-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-sgf-waldorf-jessica-a-marinaro-md",
        "name": "Jessica A. Marinaro, MD",
        "role": "Reproductive Urologist",
        "credentials": ["MD"],
        "specialty": "Urology / Male Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2023/07/J.-Marinaro-850x850-1-150x150.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/maryland/waldorf-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Maryland (MD) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlj1Ls4UTkUAfShoWhkt6lUusN8Va5xzpE0fRab5CVVsYLulIF-a9LRcXiqn_IHtibZvPRjWwp9Gis-HnBwBSZHkuyLWSLsYPp-cM0Fb9vniEHftd1WRp3NEMAcU5CfWve73KNNbHkbqitw=w408-h411-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Waldorf,+3010+Crain+Hwy+Ste+201,+Waldorf,+MD+20601/@38.6289386,-76.9060507,3117a,13.1y/data=!4m2!3m1!1s0x89b7a125fe68d6b7:0xc8271b673382f1d7",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmMRs7_mDhnfc5GsxHQXuL9YceDT5egtTIWw7vG8J5hyvCpRjm-l53ODF3h2I4UCsJttDoqsTooBiFU2GK02lVaf8C8VtFEItrIpFZhMrOdp4XIJl45_Nm0OlEM9hKjCibImYEaLA=w298-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Waldorf,+3010+Crain+Hwy+Ste+201,+Waldorf,+MD+20601/@38.6289386,-76.9060507,3117a,13.1y/data=!4m2!3m1!1s0x89b7a125fe68d6b7:0xc8271b673382f1d7",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "externalIds": {
      "googlePlaceId": "ChIJt9Zo_iWht4kR1_GCM2cbJ8g"
    }
  },
  {
    "id": "org-sgf-cary",
    "name": "Shady Grove Fertility Cary",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/north-carolina/cary-fertility-center/",
    "phone": "(984) 464-2244",
    "address": {
      "line1": "6730 McCrimmon Pkwy",
      "city": "Cary",
      "state": "NC",
      "zip": "27519",
      "country": "US"
    },
    "location": {
      "lat": 35.8219,
      "lng": -78.8703
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/north-carolina/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+Cary,+6730+McCrimmon+Pkwy,+Cary,+NC+27519/@35.829927,-78.880544,3235a,13.1y/data=!4m2!3m1!1s0x89acf3e8ded23a09:0x91eaab07ebf1eae4",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Jennifer E. Mersereau",
        "role": "Reproductive Endocrinologist; Medical Director, SGF Carolinas",
        "credentials": ["MD", "MSCI"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/09/Jennifer-Mersereau-profile1.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/mersereau/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-cary-jennifer-e-mersereau"
      },
      {
        "name": "Leah Bressler",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MPH"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/12/Leah-Bressler-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/bressler/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-cary-leah-bressler"
      },
      {
        "name": "Christina N.C. Mitchell",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2023/06/Christina-Mitchell-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/mitchell/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-cary-christina-n-c-mitchell"
      },
      {
        "name": "Ellie Andres",
        "role": "Physician Assistant (Advanced Practice Provider)",
        "credentials": ["PA-C"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/11/Ellie-Andres-profile_850x850.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/andres/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-cary-ellie-andres"
      }
    ],
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2024/08/SGF-2024-076-1024x684.jpg",
        "type": "lab",
        "caption": "Embryologist working at a microscope in the SGF Carolinas IVF/embryology laboratory at the Cary, NC full-service campus.",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/laboratories/ivf-lab-raleigh/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlhAmzubRxsX7imgk09RWyqrRcgJaxPN4Juou4C0lutHE9gaYqlqJHe9pVcgmYSXqRi0qdjBzGa8uqR0Uef2ZFt4UrhxXsNhGn-FoxjVC9dd1lASqrRbboz9sE4eYV5rNbah1I=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+Cary,+6730+McCrimmon+Pkwy,+Cary,+NC+27519/@35.829927,-78.880544,3235a,13.1y/data=!4m2!3m1!1s0x89acf3e8ded23a09:0x91eaab07ebf1eae4",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check North Carolina (NC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJCTrS3ujzrIkR5Orx6wer6pE"
    }
  },
  {
    "id": "org-sgf-chesterbrook",
    "name": "Shady Grove Fertility Chesterbrook",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/pennsylvania/chesterbrook/",
    "phone": "(610) 961-3100",
    "address": {
      "line1": "945 Chesterbrook Blvd, Suite 110",
      "city": "Chesterbrook",
      "state": "PA",
      "zip": "19087",
      "country": "US"
    },
    "location": {
      "lat": 40.0726,
      "lng": -75.4642
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/pennsylvania/chesterbrook/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Chesterbrook,+735+Chesterbrook+Blvd,+Chesterbrook,+PA+19087/@40.0699077,-75.4622307,3053a,13.1y/data=!4m2!3m1!1s0x89c693124aa355fb:0xead34783f7890585",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Russell Hayden, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/09/R.-Hayden-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/chesterbrook/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-chesterbrook-russell-hayden-md"
      },
      {
        "name": "Nicole M. Marchetto, MD, MPH",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MPH"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/12/Niole-Marchetto-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/chesterbrook/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-chesterbrook-nicole-m-marchetto-md-mph"
      },
      {
        "name": "Isaac E. Sasson, MD, PhD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "PhD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Isaac-Sasson-850x850-1-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/chesterbrook/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-chesterbrook-isaac-e-sasson-md-phd"
      },
      {
        "name": "Brianna Schumacher, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Brianna-Schumacher_hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/chesterbrook/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-chesterbrook-brianna-schumacher-md"
      },
      {
        "name": "London Pino, MSN, RN, FNP-C",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "RN", "FNP-C"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/09/Pino-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/chesterbrook/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-chesterbrook-london-pino-msn-rn-fnp-c"
      }
    ],
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2021/02/Chesterbrook-Office_MAIN-IMAGE.jpg",
        "type": "interior",
        "caption": "Shady Grove Fertility Chesterbrook office",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/chesterbrook/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJ-1WjShKTxokRhQWJ94NH0-o"
    }
  },
  {
    "id": "org-sgf-mechanicsburg",
    "name": "Shady Grove Fertility Mechanicsburg",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/pennsylvania/mechanicsburg/",
    "phone": "(717) 763-1036",
    "address": {
      "line1": "2005 Technology Pkwy, Bldg 2, Suite 340",
      "city": "Mechanicsburg",
      "state": "PA",
      "zip": "17025",
      "country": "US"
    },
    "location": {
      "lat": 40.2361,
      "lng": -76.9527
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/pennsylvania/mechanicsburg/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Mechanicsburg,+2005+Technology+Pkwy+Bldg+2+Suite+340,+Mechanicsburg,+PA+17050/@40.2837794,-76.9757515,3044a,13.1y/data=!4m2!3m1!1s0x89c8c3bb6f872979:0xe6f443abf19ed8de",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Kara Khanh-Ha D. Nguyen, MD, MPH",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MPH"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Kara-Nguyen-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/mechanicsburg/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-mechanicsburg-kara-khanh-ha-d-nguyen-md-mph"
      },
      {
        "name": "Russell Hayden, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/09/R.-Hayden-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/chesterbrook/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-mechanicsburg-russell-hayden-md"
      },
      {
        "name": "Caitlin Reeser, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/03/Reeser-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/mechanicsburg/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-mechanicsburg-caitlin-reeser-pa-c"
      }
    ],
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2021/02/Mechanicsburg_Hero.jpg",
        "type": "interior",
        "caption": "Shady Grove Fertility Mechanicsburg office",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/mechanicsburg/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmgfYht5q-matfh-K9WKWmjvbDNdKOZlES-ZzvAr7lRKqFXfE0zt_x7q48D55MnUHYCOTYdBnsmWymCjs4605hKJJzLu2SGM1uX079d50Hwgsl5Hdm9LUYe2eQj4yQNgpH85cJrfQ=w530-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Mechanicsburg,+2005+Technology+Pkwy+Bldg+2+Suite+340,+Mechanicsburg,+PA+17050/@40.2837794,-76.9757515,3044a,13.1y/data=!4m2!3m1!1s0x89c8c3bb6f872979:0xe6f443abf19ed8de",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJeSmHb7vDyIkR3tie8atD9OY"
    }
  },
  {
    "id": "org-sgf-houston-memorial",
    "name": "Shady Grove Fertility Houston Memorial City",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/texas/",
    "phone": "(346) 386-0051",
    "address": {
      "line1": "9230 Katy Freeway, Suite 540",
      "city": "Houston",
      "state": "TX",
      "zip": "77055",
      "country": "US"
    },
    "location": {
      "lat": 29.7821,
      "lng": -95.5483
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-sgf-houston-tmc",
    "name": "Shady Grove Fertility Houston Texas Medical Center",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/texas/",
    "phone": "(346) 386-0051",
    "address": {
      "line1": "7400 Fannin St, Suite 1180",
      "city": "Houston",
      "state": "TX",
      "zip": "77054",
      "country": "US"
    },
    "location": {
      "lat": 29.7076,
      "lng": -95.3968
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Houston+-+Texas+Medical+Center,+7400+Fannin+St+%231180,+Houston,+TX+77054/@29.6945121,-95.401197,3466a,13.1y/data=!4m2!3m1!1s0x8640c00ef1fd54e9:0xd755d33c2189ff89",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnHVSTUMjNHUOgvs-fRwqlasFYXVFQFU68MUnbwUldgGo46LEHiaC9aHUVBrfhlJeUPGp5tJtOFwruPDNIMQr3nra8hP2JvjpAEt6P25TcgRktfkUraK_2zKE1XqK8sp5BZOBVduvEdx_4p=w360-h480-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Houston+-+Texas+Medical+Center,+7400+Fannin+St+%231180,+Houston,+TX+77054/@29.6945121,-95.401197,3466a,13.1y/data=!4m2!3m1!1s0x8640c00ef1fd54e9:0xd755d33c2189ff89",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnfont_lDlDp0u8bbu2evTNJQN_-4jIXzxBAy1-daQiQLidj6UHqQ8Q2l2wt-pw1qRMN83Ir6hl9igWCe5qyhN13S3RdxmCqiyfurwnkU125rKMQ0MNFd1YGgG8GLmj639yEmOWDnBLyNnh=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Houston+-+Texas+Medical+Center,+7400+Fannin+St+%231180,+Houston,+TX+77054/@29.6945121,-95.401197,3466a,13.1y/data=!4m2!3m1!1s0x8640c00ef1fd54e9:0xd755d33c2189ff89",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "externalIds": {
      "googlePlaceId": "ChIJ6VT98Q7AQIYRif-JITzTVdc"
    }
  },
  {
    "id": "org-sgf-houston-clear-lake",
    "name": "Shady Grove Fertility Houston Clear Lake",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/texas/",
    "phone": "(346) 386-0051",
    "address": {
      "line1": "1015 W Medical Center Blvd, Suite 2100",
      "city": "Webster",
      "state": "TX",
      "zip": "77598",
      "country": "US"
    },
    "location": {
      "lat": 29.5437,
      "lng": -95.1289
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Clear+Lake,+1015+W+Medical+Ctr+Blvd+Ste+2100,+Webster,+TX+77598/@29.5351037,-95.1333026,3471a,13.1y/data=!4m2!3m1!1s0x86409c9a0cd3a39f:0xef85958b5f3a9a3f",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmRrrpMZLQMJp79uJat9ipLejkM8MGsUoFSlU9VVm73Y1jWso574FzHMl6N8I6dMbMwJRYsXnYCpriTx2VdETQajQjeW9RqXQAUYXw_39UbUoLB3jvQys6YTbjwOTyYdc1nVAOz3WMu9OsW=w650-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Clear+Lake,+1015+W+Medical+Ctr+Blvd+Ste+2100,+Webster,+TX+77598/@29.5351037,-95.1333026,3471a,13.1y/data=!4m2!3m1!1s0x86409c9a0cd3a39f:0xef85958b5f3a9a3f",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "externalIds": {
      "googlePlaceId": "ChIJn6PTDJqcQIYRP5o6X4uVhe8"
    }
  },
  {
    "id": "org-sgf-spring-woodlands",
    "name": "Shady Grove Fertility Spring-Woodlands",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/texas/spring-woodlands-fertility-center/",
    "phone": "(346) 386-0051",
    "address": {
      "line1": "121 Vision Park Blvd",
      "city": "Shenandoah",
      "state": "TX",
      "zip": "77384",
      "country": "US"
    },
    "location": {
      "lat": 30.1804,
      "lng": -95.4547
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Spring-Woodlands,+121+Vision+Park+Blvd+Ste+215,+Shenandoah,+TX+77384/@30.189512,-95.459767,3449a,13.1y/data=!4m2!3m1!1s0x8647356989d5375d:0xe94a0398b9b0e3f7",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2022/08/Vision-Park-.png",
        "type": "exterior",
        "caption": "Shady Grove Fertility Spring-Woodlands Vision Park facility",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/texas/spring-woodlands-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlsljqL1bq-wEcfTOOw4ZgM9Gkz0K8ySWEaGCVHTYcOXn6ovfk1jc77f3vMNlCWAZd-EHSxOmcywzMCXHd1MB0pF62pSzN5v5l-t9A-9QQWe7bnSINSqdAtv5qU_OmEnpICOD3yVqqchsf7=w408-h315-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Spring-Woodlands,+121+Vision+Park+Blvd+Ste+215,+Shenandoah,+TX+77384/@30.189512,-95.459767,3449a,13.1y/data=!4m2!3m1!1s0x8647356989d5375d:0xe94a0398b9b0e3f7",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJXTfViWk1R4YR9-OwuZgDSuk"
    }
  },
  {
    "id": "org-sgf-beaumont",
    "name": "Shady Grove Fertility Beaumont",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/texas/beaumont-fertility-center/",
    "phone": "(346) 386-0051",
    "address": {
      "line1": "755 N 11th St, Suite 160",
      "city": "Beaumont",
      "state": "TX",
      "zip": "77702",
      "country": "US"
    },
    "location": {
      "lat": 30.0891,
      "lng": -94.102
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-sgf-arlington",
    "name": "Shady Grove Fertility Arlington",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/virginia/arlington-fertility-center/",
    "phone": "(703) 574-3772",
    "address": {
      "line1": "901 N Stuart St, Suite 610",
      "city": "Arlington",
      "state": "VA",
      "zip": "22203",
      "country": "US"
    },
    "location": {
      "lat": 38.8832,
      "lng": -77.0938
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/virginia/arlington-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Arlington,+901+N+Stuart+St+Unit+610,+Arlington,+VA+22203/@38.8815697,-77.1113576,3106a,13.1y/data=!4m2!3m1!1s0x89b7b425016efcb5:0x1c2c9669dc807445",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Shruti Malik, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Shruti_Malik.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/malik/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-arlington-shruti-malik-md-facog"
      },
      {
        "name": "Anitha S. Nair, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Anitha_S._Nair_M.D._DESKTOP.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/nair/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-arlington-anitha-s-nair-md-facog"
      },
      {
        "name": "Andrea E. Reh, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Andrea-Reh-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/reh/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-arlington-andrea-e-reh-md-facog"
      },
      {
        "name": "Cigdem (Cori) Tanrikut, MD, FACS",
        "role": "Reproductive Urologist (male infertility and microsurgery)",
        "credentials": ["MD", "FACS"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/05/Cori-Tanrikut-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/tanrikut/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-arlington-cigdem-cori-tanrikut-md-facs"
      }
    ],
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2021/02/Arlington_Office_.jpg",
        "type": "exterior",
        "caption": "Exterior of the office building at 901 N Stuart St, Arlington, VA, where Shady Grove Fertility Arlington is located (Suite 610). The address \"901 N Stuart St\" is engraved on the building facade.",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/virginia/arlington-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmR4HDo2QoiEmwEzI3jGEgWDeAr5AIMKSLu3UMuqRjEr4jYK1T8gKJmTMnrYZYhoM441YnxJOOpgRY__vc8ahSOrR4ZAnhIYSv-SyZTbhn0hq7JqKbbVnZStqITPvPwyMNg4vdfJcWev0-m=w408-h459-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Arlington,+901+N+Stuart+St+Unit+610,+Arlington,+VA+22203/@38.8815697,-77.1113576,3106a,13.1y/data=!4m2!3m1!1s0x89b7b425016efcb5:0x1c2c9669dc807445",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJtfxuASW0t4kRRXSA3GmWLBw"
    }
  },
  {
    "id": "org-sgf-fair-oaks",
    "name": "Shady Grove Fertility Fair Oaks",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/virginia/fair-oaks-fertility-center/",
    "phone": "(703) 246-0500",
    "address": {
      "line1": "12011 Lee Jackson Memorial Hwy, Suite 302",
      "city": "Fairfax",
      "state": "VA",
      "zip": "22033",
      "country": "US"
    },
    "location": {
      "lat": 38.8631,
      "lng": -77.3644
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/virginia/fair-oaks-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Fair+Oaks,+12011+Lee+Jackson+Mem+Hwy+%23302,+Fairfax,+VA+22033/@38.8661715,-77.3610835,3107a,13.1y/data=!4m2!3m1!1s0x89b64f441cfdcb7d:0xa0beddd2d70eaf3a",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Alexandra Gannon, M.D.",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/09/Ali-Gannon-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/gannon/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-fair-oaks-alexandra-gannon-m-d"
      },
      {
        "name": "Brad B. Swelstad, M.D.",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Brad-Swelstad-hero-min.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/swelstad/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-fair-oaks-brad-b-swelstad-m-d"
      },
      {
        "name": "Cori Tanrikut, M.D.",
        "role": "Reproductive Urologist",
        "credentials": ["MD", "FACS"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/05/Cori-Tanrikut-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/tanrikut/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-fair-oaks-cori-tanrikut-m-d"
      }
    ],
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2021/02/DSC05302-1024x683.jpg",
        "type": "exterior",
        "caption": "Exterior of the medical office building housing Shady Grove Fertility's Fair Oaks center in Fairfax, VA",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/virginia/fair-oaks-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkkQQOemiSzgIwpnGO_QukHXTHSf3KYNmZOgTVOBNc-nPvCXYl8A-uYPpQ5cZU8rit4hxevUScywscCZYzYIf0E6pAwFPAnNnkOE1LEDqTf2cfGqyseEgI3G2GXmjdeLrtOkhlaEVJCXFor=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Fair+Oaks,+12011+Lee+Jackson+Mem+Hwy+%23302,+Fairfax,+VA+22033/@38.8661715,-77.3610835,3107a,13.1y/data=!4m2!3m1!1s0x89b64f441cfdcb7d:0xa0beddd2d70eaf3a",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmuKeiA-Z3WaLm8DS2NIW9Kdn7fhKe_UkmvTdQxwpSWFwLUDBVClOeNIS1hgyF-5Ee4BjORMVi6lPPmiFE2JQjXwKSuysrqq4X3zsjvLtIXRoyYh52fFugbb7QgLN4Bdxoe_sPv=w224-h298-k-no-pi0-ya322.029-ro-0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Fair+Oaks,+12011+Lee+Jackson+Mem+Hwy+%23302,+Fairfax,+VA+22033/@38.8661715,-77.3610835,3107a,13.1y/data=!4m2!3m1!1s0x89b64f441cfdcb7d:0xa0beddd2d70eaf3a",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJfcv9HERPtokROq8O19LdvqA"
    }
  },
  {
    "id": "org-sgf-fairfax",
    "name": "Shady Grove Fertility Fairfax",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/virginia/fairfax-fertility-center/",
    "phone": "(703) 698-7355",
    "address": {
      "line1": "8501 Arlington Blvd, Suite 500",
      "city": "Fairfax",
      "state": "VA",
      "zip": "22031",
      "country": "US"
    },
    "location": {
      "lat": 38.87,
      "lng": -77.2396
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/virginia/fairfax-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Fairfax,+8501+Arlington+Blvd+Ste+500,+Fairfax,+VA+22031/@38.86483,-77.2386287,3107a,13.1y/data=!4m2!3m1!1s0x89b64c8059189e67:0x2dfca9f74484b747",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Eric D. Levens, M.D.",
        "role": "Reproductive Endocrinologist; Medical Director, Northern Virginia",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Eric-Levens-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/levens/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-fairfax-eric-d-levens-m-d"
      },
      {
        "name": "Rachana V. Garde, M.D., MPH",
        "role": "Reproductive Endocrinologist and Fertility Specialist",
        "credentials": ["MD", "MPH"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Rachana_Garde_1.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/garde/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-fairfax-rachana-v-garde-m-d-mph"
      },
      {
        "name": "David S. Saffan, M.D.",
        "role": "Reproductive Endocrinologist and Fertility Specialist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/04/David_S._Saffan_-_Desktop.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/saffan/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-fairfax-david-s-saffan-m-d"
      },
      {
        "name": "Cori Tanrikut, M.D.",
        "role": "Reproductive Urologist",
        "credentials": ["MD", "FACS"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/05/Cori-Tanrikut-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/tanrikut/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-fairfax-cori-tanrikut-m-d"
      },
      {
        "name": "Amy Chang, MSN, FNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "FNP-BC"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/10/Amy-Change-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/amy-chang/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-fairfax-amy-chang-msn-fnp-bc"
      },
      {
        "name": "James Graham, M.S., ELD",
        "role": "Senior Director of Laboratory Services / Embryology Laboratory Director",
        "credentials": ["MS", "ELD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/06/SGF_Jim-Graham_850x850.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/james-graham/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-fairfax-james-graham-m-s-eld"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmxgXY5cQn2PTG9bm_bKQjHAfbyw_RLYju8s-zhXKfPLV-AuSb1w1CwJp35KUOrd5IjiMRrsvrqLSLsOnoS7kT5CxAIkuR7Gb-jXec5PHEm3cSCiAJKjfVHuLbg32X0tL5kQsukzQ=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Fairfax,+8501+Arlington+Blvd+Ste+500,+Fairfax,+VA+22031/@38.86483,-77.2386287,3107a,13.1y/data=!4m2!3m1!1s0x89b64c8059189e67:0x2dfca9f74484b747",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm0OcYhBxHWAU75F36XFA_rKfJqNsqi4JdvWYk6f5Bd0DRux2KXYuVKpIL6khCdA0y_reshMhk911pU7UaUjYE00ruKfCylO9kPA0q7GOKCk8o5UibZnAJTMs6VaPva3KXweTQ8=w224-h298-k-no-pi-0-ya211.981-ro0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Fairfax,+8501+Arlington+Blvd+Ste+500,+Fairfax,+VA+22031/@38.86483,-77.2386287,3107a,13.1y/data=!4m2!3m1!1s0x89b64c8059189e67:0x2dfca9f74484b747",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "externalIds": {
      "googlePlaceId": "ChIJZ54YWYBMtokRR7eERPep_C0"
    }
  },
  {
    "id": "org-sgf-fredericksburg",
    "name": "Shady Grove Fertility Fredericksburg",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/virginia/fredericksburg-fertility-center/",
    "phone": "(540) 654-1900",
    "address": {
      "line1": "200 Executive Center Pkwy, Suite 102",
      "city": "Fredericksburg",
      "state": "VA",
      "zip": "22401",
      "country": "US"
    },
    "location": {
      "lat": 38.2989,
      "lng": -77.5184
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/virginia/fredericksburg-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Fredericksburg,+200+Executive+Center+Pkwy+%23102,+Fredericksburg,+VA+22401/@38.3114587,-77.4794809,3131a,13.1y/data=!4m2!3m1!1s0x89b6c1e49c6b8991:0xbad912fe1c4ed129",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Nancy Durso",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Nancy-Durso-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/durso/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-fredericksburg-nancy-durso"
      },
      {
        "name": "Cori Tanrikut",
        "role": "Reproductive Urologist",
        "credentials": ["MD", "FACS"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/05/Cori-Tanrikut-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/tanrikut/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-fredericksburg-cori-tanrikut"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlJnwsdJ6A8z5rWDHz-mVxzc0JtKeS4eeMIq-C9iLSz2imrpGNsYSoj2xQe3ooFN3xvODp0lMXO18-0xzr7RFwYK4DvGHSLQ3AHDaZTs7MLmQKxGEhO7Hlejcct_Two3YY_lRnKkYz8asOr=w555-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Fredericksburg,+200+Executive+Center+Pkwy+%23102,+Fredericksburg,+VA+22401/@38.3114587,-77.4794809,3131a,13.1y/data=!4m2!3m1!1s0x89b6c1e49c6b8991:0xbad912fe1c4ed129",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkIqy40W2LREWS7GLMtdDIwANHCevHFMuFaC2dcHp0LxKLNj4a2IUUvAqr2Tr0H-WhnTcPg8Env7JjQnRQWkftMhx3c1SEtoc4dCmRsW07ktZSkKnpsakl35afkF31JOSQTEA=w298-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Fredericksburg,+200+Executive+Center+Pkwy+%23102,+Fredericksburg,+VA+22401/@38.3114587,-77.4794809,3131a,13.1y/data=!4m2!3m1!1s0x89b6c1e49c6b8991:0xbad912fe1c4ed129",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "externalIds": {
      "googlePlaceId": "ChIJkYlrnOTBtokRKdFOHP4S2bo"
    }
  },
  {
    "id": "org-sgf-leesburg",
    "name": "Shady Grove Fertility Leesburg",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/virginia/leesburg-fertility-center/",
    "phone": "(703) 858-3180",
    "address": {
      "line1": "19500 Sandridge Way, Suite 280",
      "city": "Leesburg",
      "state": "VA",
      "zip": "20176",
      "country": "US"
    },
    "location": {
      "lat": 39.0924,
      "lng": -77.5189
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/virginia/leesburg-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Leesburg,+19500+Sandridge+Way+Ste+280,+Leesburg,+VA+20176/@39.0761604,-77.4803226,3097a,13.1y/data=!4m2!3m1!1s0x89b63c128f1d0967:0xb09137f02ffacb1e",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Naveed Khan, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Dr._Khan.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/khan/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-leesburg-naveed-khan-md"
      },
      {
        "name": "Cori Tanrikut, MD",
        "role": "Reproductive Urologist",
        "credentials": ["MD", "FACS"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/05/Cori-Tanrikut-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/tanrikut/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-leesburg-cori-tanrikut-md"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlituPAWWMhs8W4YDzPh6Ngu3r9ETeaKqHIW-9J2WKMDG9YroAy8srEzqySLEx4gDZb_fBwzvi0f0gnn3kutsq57eblrYNIyn0F2EXV_W_NB9VH8PnNJ3P669nZSqrbCCnJxjj2WIFtGcNY=w527-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Leesburg,+19500+Sandridge+Way+Ste+280,+Leesburg,+VA+20176/@39.0761604,-77.4803226,3097a,13.1y/data=!4m2!3m1!1s0x89b63c128f1d0967:0xb09137f02ffacb1e",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmRRakuDDYEGouKFYO2FMw_o2SRYHZxX1nrotrUyEbrVSPtPrlxjW7d-Cf1wPj4YQkRRB7zJPDRiinyLU9kw1ya7PVXACXn11kZW1ocdGyfWvmnSPQYXy7ImUFWZJDl6sD4grAt8Q=w298-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Leesburg,+19500+Sandridge+Way+Ste+280,+Leesburg,+VA+20176/@39.0761604,-77.4803226,3097a,13.1y/data=!4m2!3m1!1s0x89b63c128f1d0967:0xb09137f02ffacb1e",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmRrL9crUoY1Wq--cMOhvX0UXpFoAzFUtMX9TKrTpkXVYrqrAWsaTuX0D6r1_FezMNVlJRDtI4abV2dJUMU7yaOfxIh3VdiXjh9wrXHFEc4uspbdW27deoQrQgPA1gx1loTQYEzZQ=w224-h298-k-no-pi0-ya270.4075-ro-0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Leesburg,+19500+Sandridge+Way+Ste+280,+Leesburg,+VA+20176/@39.0761604,-77.4803226,3097a,13.1y/data=!4m2!3m1!1s0x89b63c128f1d0967:0xb09137f02ffacb1e",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "externalIds": {
      "googlePlaceId": "ChIJZwkdjxI8tokRHsv6L_A3kbA"
    }
  },
  {
    "id": "org-sgf-woodbridge",
    "name": "Shady Grove Fertility Woodbridge",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/virginia/woodbridge-fertility-center/",
    "phone": "(703) 680-1770",
    "address": {
      "line1": "13580 Groupe Dr, Suite 105",
      "city": "Woodbridge",
      "state": "VA",
      "zip": "22192",
      "country": "US"
    },
    "location": {
      "lat": 38.6498,
      "lng": -77.2906
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/virginia/woodbridge-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Woodbridge,+13580+Groupe+Dr+Ste+105,+Woodbridge,+VA+22192/@38.6587599,-77.2960709,3116a,13.1y/data=!4m2!3m1!1s0x89b6565367f94677:0xf8e7de2a0237db4d",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Jennifer Y. Hsu",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Jennifer-Hsu-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/hsu/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-woodbridge-jennifer-y-hsu"
      },
      {
        "name": "Cori Tanrikut",
        "role": "Reproductive Urologist",
        "credentials": ["MD", "FACS"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/05/Cori-Tanrikut-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/tanrikut/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-woodbridge-cori-tanrikut"
      }
    ],
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2021/02/Woodbridge.jpg",
        "type": "exterior",
        "caption": "Exterior of the office building housing Shady Grove Fertility Woodbridge, 13580 Groupe Dr, Woodbridge, VA",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/virginia/woodbridge-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkfWjVEoA6fZ2XuCXfkhQ-DmnZuVglzH6RWODEvoIQLxY1oPw1N9spiCxzpLvKg7cGPjh_rpZf_2nHp2uQcvMvAzG9XB09-ayaaAnRiPnKeP_a9-RyJIQshfn2JxY88OyqzQhpy2ShN3oTx=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Woodbridge,+13580+Groupe+Dr+Ste+105,+Woodbridge,+VA+22192/@38.6587599,-77.2960709,3116a,13.1y/data=!4m2!3m1!1s0x89b6565367f94677:0xf8e7de2a0237db4d",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmQvyZcWbHeVabbzsEErIjhTjjHeqZmBw39Sk9rtz8tpDm_DnIru1vH7GQ-MgmjpHiiW4DLeNBl8gaK3Rg1sdNejnhfqryAdzJZ4cQA_o_oT-GSXpkgrVeLPIuc9Vrr5Mvo-i6K=w224-h298-k-no-pi-0-ya26.163834-ro-0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Woodbridge,+13580+Groupe+Dr+Ste+105,+Woodbridge,+VA+22192/@38.6587599,-77.2960709,3116a,13.1y/data=!4m2!3m1!1s0x89b6565367f94677:0xf8e7de2a0237db4d",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJd0b5Z1NWtokRTds3Aire5_g"
    }
  },
  {
    "id": "org-sgf-henrico",
    "name": "Shady Grove Fertility Henrico",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/virginia/henrico-fertility-center/",
    "phone": "(804) 267-9698",
    "address": {
      "line1": "7607 Forest Ave, Suite 310",
      "city": "Richmond",
      "state": "VA",
      "zip": "23229",
      "country": "US"
    },
    "location": {
      "lat": 37.5862,
      "lng": -77.5408
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/virginia/richmond-henrico-doctors-forest-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Erika B. Johnston-MacAnanny",
        "role": "Reproductive Endocrinologist (Medical Director, SGF Richmond)",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Erika-Johnston-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/johnston-macananny/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-henrico-erika-b-johnston-macananny"
      },
      {
        "name": "Anish A. Shah",
        "role": "Reproductive Endocrinologist (Practice Director, SGF Southern Virginia)",
        "credentials": ["MD", "MHS", "FACOG"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/A.-Shah-website-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/shah/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-henrico-anish-a-shah"
      }
    ],
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2021/02/Richmond_exterior_og.jpg",
        "type": "exterior",
        "caption": "Exterior of the Shady Grove Fertility Henrico fertility center, located in the Sarah Cannon Cancer Institute building at 7607 Forest Ave on the Henrico Doctors' Hospital campus (building address number 7607 visible on the facade).",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/virginia/richmond-henrico-doctors-forest-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-sgf-roanoke",
    "name": "Shady Grove Fertility Roanoke",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/virginia/roanoke-fertility-center/",
    "phone": "(540) 985-9580",
    "address": {
      "line1": "1906 Belleview Ave SE",
      "city": "Roanoke",
      "state": "VA",
      "zip": "24014",
      "country": "US"
    },
    "location": {
      "lat": 37.2574,
      "lng": -79.9274
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/virginia/roanoke-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Emily A. Evans-Hoeker, M.D.",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/07/EvansHoekerHeadshot-e1658429857880.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/evans-hoeker/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-roanoke-emily-a-evans-hoeker-m-d"
      },
      {
        "name": "Grace W. Graham, D.O.",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2023/08/G.-Graham-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/graham/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-roanoke-grace-w-graham-d-o"
      },
      {
        "name": "Erika B. Johnston-MacAnanny, M.D.",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Erika-Johnston-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/johnston-macananny/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-roanoke-erika-b-johnston-macananny-m-d"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-sgf-dc-k-street",
    "name": "Shady Grove Fertility Washington DC K Street",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/washington-dc/k-st-fertility-center/",
    "phone": "(202) 296-2595",
    "address": {
      "line1": "1801 K St NW, Suite M-110",
      "city": "Washington",
      "state": "DC",
      "zip": "20006",
      "country": "US"
    },
    "location": {
      "lat": 38.9021,
      "lng": -77.042
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/washington-dc/k-st-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/washington-dc/k-st-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/washington-dc/k-st-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [],
    "team": [
      {
        "practitionerId": "pr-org-sgf-dc-k-street-selma-amrane-md",
        "name": "Selma Amrane, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Selma-Amrane-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/washington-dc/k-st-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-sgf-dc-k-street-john-m-csokmay-md",
        "name": "John M. Csokmay, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/05/John-Csokmay-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/washington-dc/k-st-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-sgf-dc-k-street-kate-devine-md",
        "name": "Kate Devine, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Kate_Devine.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/washington-dc/k-st-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-sgf-dc-k-street-kimberly-s-moon-md",
        "name": "Kimberly S. Moon, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Kimberly_S._Moon.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/washington-dc/k-st-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-sgf-dc-k-street-jessica-selter-md",
        "name": "Jessica Selter, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2023/07/J.-Selter-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/washington-dc/k-st-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-sgf-dc-k-street-paul-shin-md",
        "name": "Paul Shin, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Paul-Shin-website.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/washington-dc/k-st-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check District of Columbia (DC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-sgf-dc-loughboro",
    "name": "Shady Grove Fertility Washington DC Loughboro",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/washington-dc/sibley-fertility-center/",
    "phone": "(202) 296-2595",
    "address": {
      "line1": "5215 Loughboro Rd NW, Suite 410",
      "city": "Washington",
      "state": "DC",
      "zip": "20016",
      "country": "US"
    },
    "location": {
      "lat": 38.9339,
      "lng": -77.0969
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/washington-dc/sibley-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+at+Sibley+Hospital,+5215+Loughboro+Rd+NW+%23410,+Washington,+DC+20016/@38.9370248,-77.1074568,3103a,13.1y/data=!4m2!3m1!1s0x89b7ca00943ecfa9:0x16f580d481075439",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/washington-dc/sibley-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2021/02/Sibely_-_Exterior_-_HERO.jpg",
        "type": "exterior",
        "caption": "Shady Grove Fertility Sibley Hospital Campus office exterior in Washington, DC.",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/washington-dc/sibley-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkE2L3CGdW-EUqfcoN3x5cQyI4GxAq7TFRH0V_txeYpAvTFXgDhrFOmX8sUEd3Ueqc6zhvyuirW0ukMGxkq1Jy5-IERuIS0DU56oviHF1ygymDP5CbPI7bNS42Gaz9Es9bWFfaU=w298-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+at+Sibley+Hospital,+5215+Loughboro+Rd+NW+%23410,+Washington,+DC+20016/@38.9370248,-77.1074568,3103a,13.1y/data=!4m2!3m1!1s0x89b7ca00943ecfa9:0x16f580d481075439",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkw2Om_0xFqGIVJGDqmczsFF4FecJMll2Tt-d3hEXf41oRJpgITjpMdppy_Sufz2xl2B-dZJtrEM4L3a2wU2hBtR2YC4l4gdKeE4Xgdcvq5NweYPWXUykre1AfZ71L0QUQ4ZIOMcA=w224-h298-k-no-pi0-ya297.3928-ro-0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+at+Sibley+Hospital,+5215+Loughboro+Rd+NW+%23410,+Washington,+DC+20016/@38.9370248,-77.1074568,3103a,13.1y/data=!4m2!3m1!1s0x89b7ca00943ecfa9:0x16f580d481075439",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "team": [
      {
        "practitionerId": "pr-org-sgf-dc-loughboro-nicole-p-doyle-md-phd",
        "name": "Nicole P. Doyle, MD, PhD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Nicole-Doyle_hero.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/washington-dc/sibley-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-sgf-dc-loughboro-kathryn-c-humm-md",
        "name": "Kathryn C. Humm, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/01/Kathryn-Humm-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/washington-dc/sibley-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-sgf-dc-loughboro-paul-shin-md",
        "name": "Paul Shin, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Paul-Shin-website.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/washington-dc/sibley-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check District of Columbia (DC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJqc8-lADKt4kROVQHgdSA9RY"
    }
  },
  {
    "id": "org-rmany-brooklyn",
    "name": "RMA of New York Brooklyn",
    "description": "RMA of New York provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.rmany.com/about-rmany/locations/brooklyn",
    "phone": "(718) 532-3003",
    "address": {
      "line1": "430 Albee Square",
      "city": "Brooklyn",
      "state": "NY",
      "zip": "11201",
      "country": "US"
    },
    "location": {
      "lat": 40.690847,
      "lng": -73.9835944
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+of+New+York:+Brooklyn,+430+Albee+Square+W+2nd+Floor,+Brooklyn,+NY+11201/@40.690867,-73.983788,3025a,13.1y/data=!4m2!3m1!1s0x89c25a4917ad2225:0xa0df5d2f3479b309",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "images": [
      {
        "url": "https://www.rmany.com/media/pages/about-rmany/locations/brooklyn/fe85623ba7-1737472030/brooklynoffice_image.webp",
        "type": "interior",
        "caption": "RMA of New York Brooklyn office",
        "_source": {
          "url": "https://www.rmany.com/about-rmany/locations/brooklyn",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJJSKtF0lawokRCbN5NC9d36A"
    }
  },
  {
    "id": "org-rmany-westchester",
    "name": "RMA of New York Westchester",
    "description": "RMA of New York provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.rmany.com/about-rmany/locations",
    "phone": "(914) 997-6200",
    "address": {
      "line1": "333 Westchester Ave, Suite 100",
      "city": "White Plains",
      "state": "NY",
      "zip": "10604",
      "country": "US"
    },
    "location": {
      "lat": 41.0304,
      "lng": -73.7571
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+of+New+York+-+Westchester:+White+Plains,+311+North+St+Ste+310,+White+Plains,+NY+10605/@41.0262506,-73.7473032,3010a,13.1y/data=!4m2!3m1!1s0x89c29433c2d327db:0x1fc068928eef7520",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "images": [
      {
        "url": "https://www.rmany.com/media/pages/about-rmany/locations/westchester/rma-white-plains/8627897598-1729794593/westhero_2.jpg",
        "type": "interior",
        "caption": "RMA of New York Westchester location",
        "_source": {
          "url": "https://www.rmany.com/about-rmany/locations/westchester/rma-white-plains",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmmtd93zgdn3udIq1-l1aYdXeKRHgljqD3_GRZhe0q1YPAdVtjZYyAHYareB9OTxw6F8R8oOXT8gAcIjkRpTYE2jqqzunQtvQZ4OFCZUotecRAAYN7VsxqlhabDDCX5VeMzaJmm=w408-h272-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+of+New+York+-+Westchester:+White+Plains,+311+North+St+Ste+310,+White+Plains,+NY+10605/@41.0262506,-73.7473032,3010a,13.1y/data=!4m2!3m1!1s0x89c29433c2d327db:0x1fc068928eef7520",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJ2yfTwjOUwokRIHXvjpJowB8"
    }
  },
  {
    "id": "org-rmany-mount-kisco",
    "name": "RMA of New York Mount Kisco",
    "description": "RMA of New York provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.rmany.com/about-rmany/locations",
    "phone": "(914) 997-6200",
    "address": {
      "line1": "110 S Bedford Rd, Suite 100",
      "city": "Mount Kisco",
      "state": "NY",
      "zip": "10549",
      "country": "US"
    },
    "location": {
      "lat": 41.2038,
      "lng": -73.7304
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "images": [
      {
        "url": "https://www.rmany.com/media/pages/about-rmany/locations/westchester/rma-mount-kisco-clinic/318ed3ca34-1729794593/wet_mkhero.jpg",
        "type": "interior",
        "caption": "RMA of New York Mount Kisco clinic",
        "_source": {
          "url": "https://www.rmany.com/about-rmany/locations/westchester",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-rmany-garden-city",
    "name": "RMA of New York Long Island Garden City",
    "description": "RMA of New York provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.rmalongislandivf.com/locations",
    "phone": "(877) 838-2229",
    "address": {
      "line1": "877 Stewart Ave, Suite 24",
      "city": "Garden City",
      "state": "NY",
      "zip": "11530",
      "country": "US"
    },
    "location": {
      "lat": 40.7258,
      "lng": -73.6255
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+of+New+York+-+Long+Island:+Garden+City,+877+Stewart+Ave+%2324,+Garden+City,+NY+11530/@40.7342948,-73.6018676,3023a,13.1y/data=!4m2!3m1!1s0x89c27d7b35fbe211:0x5de94a692202161f",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn-hdsLKmPOmHizQrnH4tkPSRpEhy3fctpVpdu22qDM3_F6d-iAYmzuapPVYUE6KGin-foxuDt_t5FeRNuhQcqYYJ07f4HgM87Q8j97hhC0FVGg8nlorc6Z3mlY2cN8acOUe2gpBw=w408-h544-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+of+New+York+-+Long+Island:+Garden+City,+877+Stewart+Ave+%2324,+Garden+City,+NY+11530/@40.7342948,-73.6018676,3023a,13.1y/data=!4m2!3m1!1s0x89c27d7b35fbe211:0x5de94a692202161f",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn60pZOzSvniaSA4hTVfPDp-4odLhjgJIQ1HMgIHBWDXngugQ0xPQOuZdnSELJVlUtXJZlX4d1SJoFPZslcd4jKaNSWXQAy3QbZZgKhec-dvtqlPLiQ6tCg1IMeCW4EsVsslexFBw=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+of+New+York+-+Long+Island:+Garden+City,+877+Stewart+Ave+%2324,+Garden+City,+NY+11530/@40.7342948,-73.6018676,3023a,13.1y/data=!4m2!3m1!1s0x89c27d7b35fbe211:0x5de94a692202161f",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJEeL7NXt9wokRHxYCImlK6V0"
    }
  },
  {
    "id": "org-rmany-lake-success",
    "name": "RMA of New York Long Island Lake Success",
    "description": "RMA of New York provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.rmalongislandivf.com/locations",
    "phone": "(877) 838-2229",
    "address": {
      "line1": "2001 Marcus Ave, Suite N213",
      "city": "New Hyde Park",
      "state": "NY",
      "zip": "11042",
      "country": "US"
    },
    "location": {
      "lat": 40.7538,
      "lng": -73.6978
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+of+New+York+-+Long+Island:+Lake+Success,+2001+Marcus+Ave+n213,+New+Hyde+Park,+NY+11042/@40.7555133,-73.6898575,3022a,13.1y/data=!4m2!3m1!1s0x89c28828973cd0c1:0xb13954927026f228",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn833rTzzKQKeOW7wrdYWSaxhMEmlnroc_uy8e8t2THAzOHlEVI3AivvSDWtEbvzgzQQozmcCTpVebliOFt_K8xu6IxMDPBWpfzgR552PD7lzIdLr8PuLz6emfrJGoM2zQFWgmqAA=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+of+New+York+-+Long+Island:+Lake+Success,+2001+Marcus+Ave+n213,+New+Hyde+Park,+NY+11042/@40.7555133,-73.6898575,3022a,13.1y/data=!4m2!3m1!1s0x89c28828973cd0c1:0xb13954927026f228",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJwdA8lyiIwokRKPImcJJUObE"
    }
  },
  {
    "id": "org-rmany-east-patchogue",
    "name": "RMA of New York Long Island East Patchogue",
    "description": "RMA of New York provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.rmalongislandivf.com/locations",
    "phone": "(877) 838-2229",
    "address": {
      "line1": "285 Sills Rd, Building 15D",
      "city": "East Patchogue",
      "state": "NY",
      "zip": "11772",
      "country": "US"
    },
    "location": {
      "lat": 40.7628,
      "lng": -72.99
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "images": [],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-rmany-west-islip",
    "name": "RMA of New York Long Island West Islip",
    "description": "RMA of New York provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.rmalongislandivf.com/locations",
    "phone": "(877) 838-2229",
    "address": {
      "line1": "500 Montauk Hwy, Suite A",
      "city": "West Islip",
      "state": "NY",
      "zip": "11795",
      "country": "US"
    },
    "location": {
      "lat": 40.7118,
      "lng": -73.3065
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+of+New+York+-+Long+Island:+West+Islip,+500+Montauk+Hwy+a,+West+Islip,+NY+11795/@40.6964637,-73.3092279,3025a,13.1y/data=!4m2!3m1!1s0x89e9d2cd2b4f44a9:0x4f8665c0372795a3",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnivBn1wLdI6AeEuDNIosFGRIw-Q5iLcbGrHZ5HRLRvBR-pDwkj07uBfHhUte0e5MWzmj8R_4MriKKhXReGskh-nlANwaDsnQ7mscrXIRogLQqhLLEZTFPyB3NqBMJQL8pzGAGX=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+of+New+York+-+Long+Island:+West+Islip,+500+Montauk+Hwy+a,+West+Islip,+NY+11795/@40.6964637,-73.3092279,3025a,13.1y/data=!4m2!3m1!1s0x89e9d2cd2b4f44a9:0x4f8665c0372795a3",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJqURPK83S6YkRo5UnN8Blhk8"
    }
  },
  {
    "id": "org-rmany-stony-brook",
    "name": "RMA of New York Long Island Stony Brook",
    "description": "RMA of New York provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.rmalongislandivf.com/locations",
    "phone": "(877) 838-2229",
    "address": {
      "line1": "2500 Nesconset Hwy, Building 19A",
      "city": "Stony Brook",
      "state": "NY",
      "zip": "11790",
      "country": "US"
    },
    "location": {
      "lat": 40.8626,
      "lng": -73.1285
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "hospital-based",
    "images": [],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-rsc-los-gatos",
    "name": "Reproductive Science Center Los Gatos",
    "description": "RSC Bay Area provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://rscbayarea.com/locations/",
    "phone": "(925) 867-1800",
    "address": {
      "line1": "15066 Los Gatos Almaden Rd, Suite 110",
      "city": "Los Gatos",
      "state": "CA",
      "zip": "95032",
      "country": "US"
    },
    "location": {
      "lat": 37.2249,
      "lng": -121.965
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rscbayarea.com/locations/los-gatos-fertility-center/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Reproductive+Science+Center+in+Los+Gatos,+15066+Los+Gatos+Almaden+Rd+%23110,+Los+Gatos,+CA+95032/@37.2431348,-121.9328329,3176a,13.1y/data=!4m2!3m1!1s0x808e343bb440d939:0xc7aa4ddc55ede90b",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "team": [
      {
        "practitionerId": "pr-org-rsc-los-gatos-isiah-harris",
        "name": "Isiah Harris",
        "credentials": ["MD", "MSc"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://rscbayarea.com/wp-content/uploads/2025/03/photo-rscba-dr-harris-headshot-square.jpg",
        "_source": {
          "url": "https://rscbayarea.com/doctors/harris/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rsc-los-gatos-michael-homer",
        "name": "Michael Homer",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://rscbayarea.com/wp-content/uploads/2025/03/Homer850x850.png",
        "_source": {
          "url": "https://rscbayarea.com/doctors/homer/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rsc-los-gatos-deborah-wachs",
        "name": "Deborah Wachs",
        "credentials": ["MD"],
        "role": "IVF Practice Director & Managing Partner",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://rscbayarea.com/wp-content/uploads/2025/03/photo-rscba-dr-deborah-wachs-featured-e1745329312658.jpg",
        "_source": {
          "url": "https://rscbayarea.com/doctors/wachs/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [
      {
        "url": "https://rscbayarea.com/wp-content/uploads/2025/03/Los-Gatos.jpg",
        "type": "exterior"
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmAV1JFBR5SAiyOxtvVuQfNTKYQQxdHTPKHa1EvXmpYxdh5_gElKrYh-dZkrmRmpZSqbdEUbtwS-Yo3byjkvYTKchOzURY01FJFYS29G1dMNcsChlhnmFfjwYF7odfXEkAKBz-t=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Reproductive+Science+Center+in+Los+Gatos,+15066+Los+Gatos+Almaden+Rd+%23110,+Los+Gatos,+CA+95032/@37.2431348,-121.9328329,3176a,13.1y/data=!4m2!3m1!1s0x808e343bb440d939:0xc7aa4ddc55ede90b",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmpvF6JuHCoFQXuIC6_pMmSA5gYU2zFxFw8JusI2oKByJPxvHIRy-ZvcPyRE6RU2fFAFITcBQ77KplusjDXP88aveLnJJU6sM8Y6mBw3LLZws8MVz7vhndVv7UYNYjlfVj-o7xHilAd8PnC=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Reproductive+Science+Center+in+Los+Gatos,+15066+Los+Gatos+Almaden+Rd+%23110,+Los+Gatos,+CA+95032/@37.2431348,-121.9328329,3176a,13.1y/data=!4m2!3m1!1s0x808e343bb440d939:0xc7aa4ddc55ede90b",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJOdlAtDs0joARC-ntVdxNqsc"
    }
  },
  {
    "id": "org-rsc-menlo-park",
    "name": "Reproductive Science Center Menlo Park",
    "description": "RSC Bay Area provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://rscbayarea.com/locations/",
    "phone": "(925) 867-1800",
    "address": {
      "line1": "8 Homewood Pl",
      "city": "Menlo Park",
      "state": "CA",
      "zip": "94025",
      "country": "US"
    },
    "location": {
      "lat": 37.4536,
      "lng": -122.185
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rscbayarea.com/locations/menlo-park-fertility-center/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Reproductive+Science+Center+in+Menlo+Park,+8+Homewood+Pl,+Menlo+Park,+CA+94025/@37.454679,-122.1695611,3167a,13.1y/data=!4m2!3m1!1s0x808fbbbd379e68ed:0xf22922af0054be77",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "team": [
      {
        "practitionerId": "pr-org-rsc-menlo-park-isiah-harris",
        "name": "Isiah Harris",
        "credentials": ["MD", "MSc"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://rscbayarea.com/wp-content/uploads/2025/03/photo-rscba-dr-harris-headshot-square.jpg",
        "_source": {
          "url": "https://rscbayarea.com/doctors/harris/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rsc-menlo-park-michael-homer",
        "name": "Michael Homer",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://rscbayarea.com/wp-content/uploads/2025/03/Homer850x850.png",
        "_source": {
          "url": "https://rscbayarea.com/doctors/homer/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rsc-menlo-park-malinda-lee",
        "name": "Malinda Lee",
        "credentials": ["MD", "MBA"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://rscbayarea.com/wp-content/uploads/2025/03/Lee-850x850-1.png",
        "_source": {
          "url": "https://rscbayarea.com/doctors/lee/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rsc-menlo-park-sara-reid",
        "name": "Sara Reid",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://rscbayarea.com/wp-content/uploads/2025/03/Reid-850x850-1.png",
        "_source": {
          "url": "https://rscbayarea.com/doctors/reid/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rsc-menlo-park-deborah-wachs",
        "name": "Deborah Wachs",
        "credentials": ["MD"],
        "role": "IVF Practice Director & Managing Partner",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://rscbayarea.com/wp-content/uploads/2025/03/photo-rscba-dr-deborah-wachs-featured-e1745329312658.jpg",
        "_source": {
          "url": "https://rscbayarea.com/doctors/wachs/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [
      {
        "url": "https://rscbayarea.com/wp-content/uploads/2025/07/menlo-park-outside.jpeg",
        "type": "exterior"
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmaXWsySBFCSH8x_67NSRo5E2GuFjYFUBJsRgI6PDbLUzJl1N9rLzcNqGhc4RwWx9XCLOAjoEG77N5Y8cCHzhUZDwSdwFwgtNhuaVEDnjTf32nWFFyBnRWCvbTWZeEe-XQ9x_Sk8Fkgeg8=w661-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Reproductive+Science+Center+in+Menlo+Park,+8+Homewood+Pl,+Menlo+Park,+CA+94025/@37.454679,-122.1695611,3167a,13.1y/data=!4m2!3m1!1s0x808fbbbd379e68ed:0xf22922af0054be77",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJ7WieN727j4ARd75UAK8iKfI"
    }
  },
  {
    "id": "org-rsc-oakland",
    "name": "Reproductive Science Center Oakland",
    "description": "RSC Bay Area provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://rscbayarea.com/locations/",
    "phone": "(925) 867-1800",
    "address": {
      "line1": "3300 Webster St, Suite 404",
      "city": "Oakland",
      "state": "CA",
      "zip": "94609",
      "country": "US"
    },
    "location": {
      "lat": 37.8172,
      "lng": -122.2633
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rscbayarea.com/locations/oakland-fertility-center/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Reproductive+Science+Center+in+Oakland,+3300+Webster+St+Ste+404,+Oakland,+CA+94609/@37.8212199,-122.2620832,3152a,13.1y/data=!4m2!3m1!1s0x80857d2965e2c9a3:0x75fd9e47855ac96c",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "team": [
      {
        "practitionerId": "pr-org-rsc-oakland-laura-eisman",
        "name": "Laura Eisman",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://rscbayarea.com/wp-content/uploads/2025/03/Eisman850x850.png",
        "_source": {
          "url": "https://rscbayarea.com/doctors/eisman/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rsc-oakland-eduardo-hariton",
        "name": "Eduardo Hariton",
        "credentials": ["MD", "MBA"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://rscbayarea.com/wp-content/uploads/2025/03/Hariton-850x850-1.png",
        "_source": {
          "url": "https://rscbayarea.com/doctors/hariton/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnzCLlSGCJX7giZjNFoiAHihQfoslTTsAVg5jTtXuEf1ZmT6bNhIortTAvrpnwRXiS-GrfYrUNwck6b4rxWVzzBicz0qNciaM2VBzjVC15gffIDY6DHBslk-5QNLI5yLxOtKI5Pz1R80gUe=w298-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Reproductive+Science+Center+in+Oakland,+3300+Webster+St+Ste+404,+Oakland,+CA+94609/@37.8212199,-122.2620832,3152a,13.1y/data=!4m2!3m1!1s0x80857d2965e2c9a3:0x75fd9e47855ac96c",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "externalIds": {
      "googlePlaceId": "ChIJo8niZSl9hYARbMlahUee_XU"
    }
  },
  {
    "id": "org-rsc-san-mateo",
    "name": "Reproductive Science Center San Mateo",
    "description": "RSC Bay Area provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://rscbayarea.com/locations/",
    "phone": "(925) 867-1800",
    "address": {
      "line1": "1100 Park Pl, Suite 80",
      "city": "San Mateo",
      "state": "CA",
      "zip": "94403",
      "country": "US"
    },
    "location": {
      "lat": 37.5558,
      "lng": -122.2946
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rscbayarea.com/locations/san-mateo-fertility-center/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Reproductive+Science+Center+in+San+Mateo,+1100+Park+Pl+%2380,+San+Mateo,+CA+94403/@37.5451928,-122.2907748,3163a,13.1y/data=!4m2!3m1!1s0x808f98d634850425:0x42f73caf753855b3",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "team": [
      {
        "practitionerId": "pr-org-rsc-san-mateo-isiah-harris",
        "name": "Isiah Harris",
        "credentials": ["MD", "MSc"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://rscbayarea.com/wp-content/uploads/2025/03/photo-rscba-dr-harris-headshot-square.jpg",
        "_source": {
          "url": "https://rscbayarea.com/doctors/harris/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rsc-san-mateo-sara-reid",
        "name": "Sara Reid",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://rscbayarea.com/wp-content/uploads/2025/03/Reid-850x850-1.png",
        "_source": {
          "url": "https://rscbayarea.com/doctors/reid/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rsc-san-mateo-charlene-chang",
        "name": "Charlene Chang",
        "credentials": ["FNP"],
        "imageUrl": "https://rscbayarea.com/wp-content/uploads/2025/03/Chang-850x850-1.png",
        "_source": {
          "url": "https://rscbayarea.com/doctors/chang/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [
      {
        "url": "https://rscbayarea.com/wp-content/uploads/2025/03/San-Mateo-1.jpg",
        "type": "exterior"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJJQSFNNaYj4ARs1U4da8890I"
    }
  },
  {
    "id": "org-preg-asheville",
    "name": "PREG Asheville",
    "description": "PREG provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://pregonline.com/locations/",
    "phone": "+1 828-761-6492",
    "address": {
      "line1": "76 Peachtree Rd, Suite 210",
      "city": "Asheville",
      "state": "NC",
      "zip": "28803",
      "country": "US"
    },
    "location": {
      "lat": 35.51391,
      "lng": -82.522422
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "partially-enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://pregonline.com/fertility-clinic-asheville-nc/",
            "fetchedAt": "2026-06-14"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://pregonline.com/locations/asheville/",
            "fetchedAt": "2026-06-15"
          }
        },
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://pregonline.com/locations/asheville/",
            "fetchedAt": "2026-06-15"
          }
        },
        "socialLinks": {
          "status": "scraped",
          "source": {
            "url": "https://pregonline.com/locations/",
            "fetchedAt": "2026-06-15"
          }
        },
        "logo": {
          "status": "scraped",
          "source": {
            "url": "https://pregonline.com/locations/",
            "fetchedAt": "2026-06-15"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Piedmont+Reproductive+Endocrinology+Group+-+Asheville,+76+Peachtree+Rd+%23210,+Asheville,+NC+28803/@35.5135911,-82.5219661,3248a,13.1y/data=!4m2!3m1!1s0x8859f338d828cc7b:0x1a0a75ed7230434b",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Travis W. McCoy, MD",
        "role": "Reproductive Endocrinologist; Director of Surgery and Male Infertility",
        "credentials": ["MD"],
        "imageUrl": "https://pregonline.com/wp-content/uploads/2021/11/Dr.-Travis-W.-McCoy.webp",
        "_source": {
          "url": "https://pregonline.com/team/travis-w-mccoy/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-preg-asheville-travis-w-mccoy-md"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/piedmont-reproductive-endocrinology-group",
      "googlePlaceId": "ChIJe8wo2DjzWYgRS0Mwcu11Cho"
    },
    "logoUrl": "https://pregonline.com/wp-content/uploads/2025/01/PREG_Logo.png",
    "socialLinks": [
      {
        "platform": "facebook",
        "url": "http://www.facebook.com/PREGonline",
        "label": "Facebook",
        "_source": {
          "url": "https://pregonline.com/locations/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "youtube",
        "url": "https://www.youtube.com/c/PiedmontReproductive",
        "label": "YouTube",
        "_source": {
          "url": "https://pregonline.com/locations/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "instagram",
        "url": "https://www.instagram.com/pregonline/",
        "label": "Instagram",
        "_source": {
          "url": "https://pregonline.com/locations/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "linkedin",
        "url": "https://www.linkedin.com/company/piedmont-reproductive-endocrinology-group/",
        "label": "LinkedIn",
        "_source": {
          "url": "https://pregonline.com/locations/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check North Carolina (NC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm0f3fAH77K2qbPmLHYybeBrmky0MD4qJMTS6XvQWruDs1_aovowUHVoA9PXSrLx91ukqri3IRT_H5lHx-OxpgDkCuVyX58kbXAtC9VFQXOSzvKHWvkE81KXiozl6lIy6FUCNqkwg=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Piedmont+Reproductive+Endocrinology+Group+-+Asheville,+76+Peachtree+Rd+%23210,+Asheville,+NC+28803/@35.5135911,-82.5219661,3248a,13.1y/data=!4m2!3m1!1s0x8859f338d828cc7b:0x1a0a75ed7230434b",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-preg-columbia",
    "name": "PREG Columbia",
    "description": "PREG provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://pregonline.com/locations/columbia/",
    "phone": "+1 803-373-7098",
    "address": {
      "line1": "2324 Sunset Blvd",
      "city": "West Columbia",
      "state": "SC",
      "zip": "29169",
      "country": "US"
    },
    "location": {
      "lat": 34.0020688,
      "lng": -81.104351
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "partially-enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://pregonline.com/locations/columbia/",
            "fetchedAt": "2026-06-15"
          }
        },
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://pregonline.com/locations/columbia/",
            "fetchedAt": "2026-06-15"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://pregonline.com/team/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Piedmont+Reproductive+Endocrinology+Group+-+Columbia,+2324+Sunset+Blvd,+West+Columbia,+SC+29169/@34.0028104,-81.10466,3308a,13.1y/data=!4m2!3m1!1s0x88f8bcd42ff086cb:0x3b855167c8804f76",
            "fetchedAt": "2026-08-16"
          }
        },
        "socialLinks": {
          "status": "scraped",
          "source": {
            "url": "https://pregonline.com/locations/",
            "fetchedAt": "2026-06-15"
          }
        },
        "logo": {
          "status": "scraped",
          "source": {
            "url": "https://pregonline.com/locations/",
            "fetchedAt": "2026-06-15"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-preg-columbia-john-e-nichols-md",
        "name": "John E. Nichols, MD",
        "role": "Founder & Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2023/02/Dr.-Nichols-Headshot.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-columbia-john-f-payne-md",
        "name": "John F. Payne, MD",
        "role": "Director of Third-Party Reproduction",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2022/01/Dr.-Payne-Headshot-1.png",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-columbia-travis-w-mccoy-md",
        "name": "Travis W. McCoy, MD",
        "role": "Director of Surgery & Male Infertility",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2021/11/Dr.-Travis-W.-McCoy.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-columbia-edward-d-tarnawa-md",
        "name": "Edward D. Tarnawa, MD",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2021/11/Dr.-Tarnawa-Headshot.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-columbia-kathryn-imgrund-md",
        "name": "Kathryn Imgrund, MD",
        "role": "Advanced Gynecologic Surgery and Infertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2021/11/Dr.-Kathryn-Imgrund.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-columbia-j-graham-theisen-md-mscr",
        "name": "J. Graham Theisen, MD, MSCR",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD", "MSCR"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/01/Dr.-Theisen-Headshot.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-columbia-lauren-rouleau-md-phd",
        "name": "Lauren Rouleau, MD, PhD",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/09/Lauren-Rouleau-MD-PHD.jpg",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-columbia-tarek-k-khader-md",
        "name": "Tarek K. Khader, MD",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/09/Dr.-Tarek-K.-Khader.jpg",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-columbia-ahmad-h-arabi-md",
        "name": "Ahmad H. Arabi, MD",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/09/Dr.-Arabi-PREG.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-columbia-jing-chen-phd-hcld-eld",
        "name": "Jing Chen, PhD, HCLD/ELD",
        "role": "Lab Director, Embryologist",
        "credentials": ["PhD", "HCLD/ELD"],
        "specialty": "Embryology",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/02/Dr.-Chen-Headshot-1.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-columbia-haley-pollack-np",
        "name": "Haley Pollack, NP",
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/02/Halley-Pollack.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-columbia-madison-browning-np",
        "name": "Madison Browning, NP",
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/02/Madison-Browning.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnuYeA4zViCKe8-mGcMLKx1d2iI51UaPHE2IslbsWdPIghnXBHXr8kaTgW3QgXy4eSbK6F2EluIJf5RtWhIb4haOpJHdjXMsXIukNW7UQQT3RIYL-DQcIVkJAtiPvS80stUBe0cVH4ji0k=w224-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Piedmont+Reproductive+Endocrinology+Group+-+Columbia,+2324+Sunset+Blvd,+West+Columbia,+SC+29169/@34.0028104,-81.10466,3308a,13.1y/data=!4m2!3m1!1s0x88f8bcd42ff086cb:0x3b855167c8804f76",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/piedmont-reproductive-endocrinology-group",
      "googlePlaceId": "ChIJy4bwL9S8-IgRdk-AyGdRhTs"
    },
    "logoUrl": "https://pregonline.com/wp-content/uploads/2025/01/PREG_Logo.png",
    "socialLinks": [
      {
        "platform": "facebook",
        "url": "http://www.facebook.com/PREGonline",
        "label": "Facebook",
        "_source": {
          "url": "https://pregonline.com/locations/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "youtube",
        "url": "https://www.youtube.com/c/PiedmontReproductive",
        "label": "YouTube",
        "_source": {
          "url": "https://pregonline.com/locations/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "instagram",
        "url": "https://www.instagram.com/pregonline/",
        "label": "Instagram",
        "_source": {
          "url": "https://pregonline.com/locations/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "linkedin",
        "url": "https://www.linkedin.com/company/piedmont-reproductive-endocrinology-group/",
        "label": "LinkedIn",
        "_source": {
          "url": "https://pregonline.com/locations/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check South Carolina (SC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-preg-mount-pleasant",
    "name": "PREG Mount Pleasant",
    "description": "PREG provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://pregonline.com/locations/mount-pleasant-charleston/",
    "phone": "+1 843-277-0053",
    "address": {
      "line1": "180 Wingo Way, Suite 103",
      "city": "Mount Pleasant",
      "state": "SC",
      "zip": "29464",
      "country": "US"
    },
    "location": {
      "lat": 32.8026996,
      "lng": -79.8983997
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "partially-enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://pregonline.com/locations/mount-pleasant-charleston/",
            "fetchedAt": "2026-06-15"
          }
        },
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://pregonline.com/locations/mount-pleasant-charleston/",
            "fetchedAt": "2026-06-15"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://pregonline.com/team/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Piedmont+Reproductive+Endocrinology+Group,+180+Wingo+Way+%23103,+Mt+Pleasant,+SC+29464/@32.8027879,-79.8984172,3354a,13.1y/data=!4m2!3m1!1s0x88fe71d84841b677:0x52e4d59f1fb77c5e",
            "fetchedAt": "2026-08-16"
          }
        },
        "socialLinks": {
          "status": "scraped",
          "source": {
            "url": "https://pregonline.com/locations/",
            "fetchedAt": "2026-06-15"
          }
        },
        "logo": {
          "status": "scraped",
          "source": {
            "url": "https://pregonline.com/locations/",
            "fetchedAt": "2026-06-15"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-preg-mount-pleasant-john-e-nichols-md",
        "name": "John E. Nichols, MD",
        "role": "Founder & Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2023/02/Dr.-Nichols-Headshot.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-mount-pleasant-john-f-payne-md",
        "name": "John F. Payne, MD",
        "role": "Director of Third-Party Reproduction",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2022/01/Dr.-Payne-Headshot-1.png",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-mount-pleasant-travis-w-mccoy-md",
        "name": "Travis W. McCoy, MD",
        "role": "Director of Surgery & Male Infertility",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2021/11/Dr.-Travis-W.-McCoy.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-mount-pleasant-edward-d-tarnawa-md",
        "name": "Edward D. Tarnawa, MD",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2021/11/Dr.-Tarnawa-Headshot.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-mount-pleasant-kathryn-imgrund-md",
        "name": "Kathryn Imgrund, MD",
        "role": "Advanced Gynecologic Surgery and Infertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2021/11/Dr.-Kathryn-Imgrund.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-mount-pleasant-j-graham-theisen-md-mscr",
        "name": "J. Graham Theisen, MD, MSCR",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD", "MSCR"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/01/Dr.-Theisen-Headshot.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-mount-pleasant-lauren-rouleau-md-phd",
        "name": "Lauren Rouleau, MD, PhD",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/09/Lauren-Rouleau-MD-PHD.jpg",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-mount-pleasant-tarek-k-khader-md",
        "name": "Tarek K. Khader, MD",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/09/Dr.-Tarek-K.-Khader.jpg",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-mount-pleasant-ahmad-h-arabi-md",
        "name": "Ahmad H. Arabi, MD",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/09/Dr.-Arabi-PREG.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-mount-pleasant-jing-chen-phd-hcld-eld",
        "name": "Jing Chen, PhD, HCLD/ELD",
        "role": "Lab Director, Embryologist",
        "credentials": ["PhD", "HCLD/ELD"],
        "specialty": "Embryology",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/02/Dr.-Chen-Headshot-1.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-mount-pleasant-haley-pollack-np",
        "name": "Haley Pollack, NP",
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/02/Halley-Pollack.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-mount-pleasant-madison-browning-np",
        "name": "Madison Browning, NP",
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/02/Madison-Browning.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [],
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/piedmont-reproductive-endocrinology-group",
      "googlePlaceId": "ChIJd7ZBSNhx_ogRXny3H5_V5FI"
    },
    "logoUrl": "https://pregonline.com/wp-content/uploads/2025/01/PREG_Logo.png",
    "socialLinks": [
      {
        "platform": "facebook",
        "url": "http://www.facebook.com/PREGonline",
        "label": "Facebook",
        "_source": {
          "url": "https://pregonline.com/locations/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "youtube",
        "url": "https://www.youtube.com/c/PiedmontReproductive",
        "label": "YouTube",
        "_source": {
          "url": "https://pregonline.com/locations/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "instagram",
        "url": "https://www.instagram.com/pregonline/",
        "label": "Instagram",
        "_source": {
          "url": "https://pregonline.com/locations/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "linkedin",
        "url": "https://www.linkedin.com/company/piedmont-reproductive-endocrinology-group/",
        "label": "LinkedIn",
        "_source": {
          "url": "https://pregonline.com/locations/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check South Carolina (SC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-preg-spartanburg",
    "name": "PREG Spartanburg",
    "description": "PREG provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://pregonline.com/locations/spartanburg/",
    "phone": "+1 864-732-1594",
    "address": {
      "line1": "1330 Boiling Springs Rd #2200",
      "city": "Spartanburg",
      "state": "SC",
      "zip": "29303",
      "country": "US"
    },
    "location": {
      "lat": 34.9897859,
      "lng": -81.9445906
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "partially-enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://pregonline.com/locations/spartanburg/",
            "fetchedAt": "2026-06-15"
          }
        },
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://pregonline.com/locations/spartanburg/",
            "fetchedAt": "2026-06-15"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://pregonline.com/team/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Piedmont+Reproductive+Endocrinology+Group+-+Spartanburg,+1330+Boiling+Springs+Rd+%232200,+Spartanburg,+SC+29303/@34.9897364,-81.9446322,3269a,13.1y/data=!4m2!3m1!1s0x885775d301566f39:0xd26d40bdc9763ac8",
            "fetchedAt": "2026-08-16"
          }
        },
        "socialLinks": {
          "status": "scraped",
          "source": {
            "url": "https://pregonline.com/locations/",
            "fetchedAt": "2026-06-15"
          }
        },
        "logo": {
          "status": "scraped",
          "source": {
            "url": "https://pregonline.com/locations/",
            "fetchedAt": "2026-06-15"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-preg-spartanburg-john-e-nichols-md",
        "name": "John E. Nichols, MD",
        "role": "Founder & Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2023/02/Dr.-Nichols-Headshot.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-spartanburg-john-f-payne-md",
        "name": "John F. Payne, MD",
        "role": "Director of Third-Party Reproduction",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2022/01/Dr.-Payne-Headshot-1.png",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-spartanburg-travis-w-mccoy-md",
        "name": "Travis W. McCoy, MD",
        "role": "Director of Surgery & Male Infertility",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2021/11/Dr.-Travis-W.-McCoy.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-spartanburg-edward-d-tarnawa-md",
        "name": "Edward D. Tarnawa, MD",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2021/11/Dr.-Tarnawa-Headshot.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-spartanburg-kathryn-imgrund-md",
        "name": "Kathryn Imgrund, MD",
        "role": "Advanced Gynecologic Surgery and Infertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2021/11/Dr.-Kathryn-Imgrund.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-spartanburg-j-graham-theisen-md-mscr",
        "name": "J. Graham Theisen, MD, MSCR",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD", "MSCR"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/01/Dr.-Theisen-Headshot.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-spartanburg-lauren-rouleau-md-phd",
        "name": "Lauren Rouleau, MD, PhD",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/09/Lauren-Rouleau-MD-PHD.jpg",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-spartanburg-tarek-k-khader-md",
        "name": "Tarek K. Khader, MD",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/09/Dr.-Tarek-K.-Khader.jpg",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-spartanburg-ahmad-h-arabi-md",
        "name": "Ahmad H. Arabi, MD",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/09/Dr.-Arabi-PREG.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-spartanburg-jing-chen-phd-hcld-eld",
        "name": "Jing Chen, PhD, HCLD/ELD",
        "role": "Lab Director, Embryologist",
        "credentials": ["PhD", "HCLD/ELD"],
        "specialty": "Embryology",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/02/Dr.-Chen-Headshot-1.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-spartanburg-haley-pollack-np",
        "name": "Haley Pollack, NP",
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/02/Halley-Pollack.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-spartanburg-madison-browning-np",
        "name": "Madison Browning, NP",
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/02/Madison-Browning.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnZ8e6lgwev946TrcYzSStzq0wajlvrlfAgxD5yTZfx9P7va9cPZwg4VlKxjM4UKNAiBuh6n2UCstxGkOP2x4jcpXylFvqk5Bl5B34q4S5t6iFsh0EcS90n8kdTPhbbv_04E7OC=w408-h328-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Piedmont+Reproductive+Endocrinology+Group+-+Spartanburg,+1330+Boiling+Springs+Rd+%232200,+Spartanburg,+SC+29303/@34.9897364,-81.9446322,3269a,13.1y/data=!4m2!3m1!1s0x885775d301566f39:0xd26d40bdc9763ac8",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlaLh-h3Eh5Q4lGD5373cSmrD8-LXzexRPdqQcycLU3mQcHa2MaVfyI7StT3qS6shpM5Xqf4Ze4aw8dfomeFiOdfGxAjl2HoBjhSScLDi5Lo8v2QBlxMesoX8jR9djZHES0kMGpjw=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Piedmont+Reproductive+Endocrinology+Group+-+Spartanburg,+1330+Boiling+Springs+Rd+%232200,+Spartanburg,+SC+29303/@34.9897364,-81.9446322,3269a,13.1y/data=!4m2!3m1!1s0x885775d301566f39:0xd26d40bdc9763ac8",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkkeuIMWyVR5AZEX9PP5Yk2jYbtS2ShP_NDsCuFflUCbzpjmwMSDsbD2LR2G_2SMSj2Hjbo4p_D1McvgPlYepg6jRDqiD7xN15zicrwVZRvaG0SGt2oNzY8xLzM8eGNFPsIyEhzD9T-RlXY=w224-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Piedmont+Reproductive+Endocrinology+Group+-+Spartanburg,+1330+Boiling+Springs+Rd+%232200,+Spartanburg,+SC+29303/@34.9897364,-81.9446322,3269a,13.1y/data=!4m2!3m1!1s0x885775d301566f39:0xd26d40bdc9763ac8",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/piedmont-reproductive-endocrinology-group",
      "googlePlaceId": "ChIJOW9WAdN1V4gRyDp2yb1AbdI"
    },
    "logoUrl": "https://pregonline.com/wp-content/uploads/2025/01/PREG_Logo.png",
    "socialLinks": [
      {
        "platform": "facebook",
        "url": "http://www.facebook.com/PREGonline",
        "label": "Facebook",
        "_source": {
          "url": "https://pregonline.com/locations/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "youtube",
        "url": "https://www.youtube.com/c/PiedmontReproductive",
        "label": "YouTube",
        "_source": {
          "url": "https://pregonline.com/locations/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "instagram",
        "url": "https://www.instagram.com/pregonline/",
        "label": "Instagram",
        "_source": {
          "url": "https://pregonline.com/locations/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "linkedin",
        "url": "https://www.linkedin.com/company/piedmont-reproductive-endocrinology-group/",
        "label": "LinkedIn",
        "_source": {
          "url": "https://pregonline.com/locations/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check South Carolina (SC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-preg-summerville",
    "name": "PREG Summerville",
    "description": "PREG provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://pregonline.com/locations/summerville-charleston/",
    "phone": "+1 843-896-6043",
    "address": {
      "line1": "5500 Front St, Suite 410",
      "city": "Summerville",
      "state": "SC",
      "zip": "29486",
      "country": "US"
    },
    "location": {
      "lat": 33.0437922,
      "lng": -80.146996
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "partially-enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://pregonline.com/locations/summerville-charleston/",
            "fetchedAt": "2026-06-15"
          }
        },
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://pregonline.com/locations/summerville-charleston/",
            "fetchedAt": "2026-06-15"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://pregonline.com/team/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Piedmont+Reproductive+Endocrinology+Group+Charleston,+SC,+5500+Front+St+Ste+410,+Summerville,+SC+29486/@33.0435629,-80.1470817,3344a,13.1y/data=!4m2!3m1!1s0x88fe710ce3f6797f:0xfa1df667d359d709",
            "fetchedAt": "2026-08-16"
          }
        },
        "socialLinks": {
          "status": "scraped",
          "source": {
            "url": "https://pregonline.com/locations/",
            "fetchedAt": "2026-06-15"
          }
        },
        "logo": {
          "status": "scraped",
          "source": {
            "url": "https://pregonline.com/locations/",
            "fetchedAt": "2026-06-15"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-preg-summerville-john-e-nichols-md",
        "name": "John E. Nichols, MD",
        "role": "Founder & Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2023/02/Dr.-Nichols-Headshot.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-summerville-john-f-payne-md",
        "name": "John F. Payne, MD",
        "role": "Director of Third-Party Reproduction",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2022/01/Dr.-Payne-Headshot-1.png",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-summerville-travis-w-mccoy-md",
        "name": "Travis W. McCoy, MD",
        "role": "Director of Surgery & Male Infertility",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2021/11/Dr.-Travis-W.-McCoy.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-summerville-edward-d-tarnawa-md",
        "name": "Edward D. Tarnawa, MD",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2021/11/Dr.-Tarnawa-Headshot.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-summerville-kathryn-imgrund-md",
        "name": "Kathryn Imgrund, MD",
        "role": "Advanced Gynecologic Surgery and Infertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2021/11/Dr.-Kathryn-Imgrund.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-summerville-j-graham-theisen-md-mscr",
        "name": "J. Graham Theisen, MD, MSCR",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD", "MSCR"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/01/Dr.-Theisen-Headshot.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-summerville-lauren-rouleau-md-phd",
        "name": "Lauren Rouleau, MD, PhD",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/09/Lauren-Rouleau-MD-PHD.jpg",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-summerville-tarek-k-khader-md",
        "name": "Tarek K. Khader, MD",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/09/Dr.-Tarek-K.-Khader.jpg",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-summerville-ahmad-h-arabi-md",
        "name": "Ahmad H. Arabi, MD",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/09/Dr.-Arabi-PREG.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-summerville-jing-chen-phd-hcld-eld",
        "name": "Jing Chen, PhD, HCLD/ELD",
        "role": "Lab Director, Embryologist",
        "credentials": ["PhD", "HCLD/ELD"],
        "specialty": "Embryology",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/02/Dr.-Chen-Headshot-1.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-summerville-haley-pollack-np",
        "name": "Haley Pollack, NP",
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/02/Halley-Pollack.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-preg-summerville-madison-browning-np",
        "name": "Madison Browning, NP",
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "specialty": "Reproductive Medicine",
        "imageUrl": "https://pregonline.com/wp-content/uploads/2025/02/Madison-Browning.webp",
        "_source": {
          "url": "https://pregonline.com/team/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlz7TsByIcYdmrb4cWoTYgWw9PT9U0i4AZn-kRpEodk3ygUy8-m4J4x1ctiXhvTHMFPfoBMYMQfnGbkOWRaPPojTl1erDLkNR0nIkVeKs8rYH1kXaoqcIeAMdt4J3r7BXvQs3o=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Piedmont+Reproductive+Endocrinology+Group+Charleston,+SC,+5500+Front+St+Ste+410,+Summerville,+SC+29486/@33.0435629,-80.1470817,3344a,13.1y/data=!4m2!3m1!1s0x88fe710ce3f6797f:0xfa1df667d359d709",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/piedmont-reproductive-endocrinology-group",
      "googlePlaceId": "ChIJf3n24wxx_ogRCddZ02f2Hfo"
    },
    "logoUrl": "https://pregonline.com/wp-content/uploads/2025/01/PREG_Logo.png",
    "socialLinks": [
      {
        "platform": "facebook",
        "url": "http://www.facebook.com/PREGonline",
        "label": "Facebook",
        "_source": {
          "url": "https://pregonline.com/locations/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "youtube",
        "url": "https://www.youtube.com/c/PiedmontReproductive",
        "label": "YouTube",
        "_source": {
          "url": "https://pregonline.com/locations/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "instagram",
        "url": "https://www.instagram.com/pregonline/",
        "label": "Instagram",
        "_source": {
          "url": "https://pregonline.com/locations/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "linkedin",
        "url": "https://www.linkedin.com/company/piedmont-reproductive-endocrinology-group/",
        "label": "LinkedIn",
        "_source": {
          "url": "https://pregonline.com/locations/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check South Carolina (SC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-sgf-alpharetta",
    "name": "Shady Grove Fertility Alpharetta",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/georgia/",
    "phone": "(678) 597-1700",
    "address": {
      "line1": "3400-A Old Milton Pkwy, Suite 390",
      "city": "Alpharetta",
      "state": "GA",
      "zip": "30005",
      "country": "US"
    },
    "location": {
      "lat": 34.0704,
      "lng": -84.2758
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/georgia/alpharetta-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Alpharetta,+3905+Brookside+Pkwy+Ste+100,+Alpharetta,+GA+30022/@34.0599584,-84.2491005,3305a,13.1y/data=!4m2!3m1!1s0x88f59e2c1bff7915:0xf89bc000806bd4ba",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Steven Gay, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/09/Gay-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/georgia/alpharetta-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-alpharetta-steven-gay-md"
      },
      {
        "name": "Quinton Katler, MD, MSc",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MSc"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/08/Katler-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/georgia/alpharetta-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-alpharetta-quinton-katler-md-msc"
      },
      {
        "name": "Suzy Schneider, WHNP, MSN",
        "role": "Nurse Practitioner",
        "credentials": ["WHNP", "MSN"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2023/02/Suzy-Schneider-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/georgia/alpharetta-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-alpharetta-suzy-schneider-whnp-msn"
      }
    ],
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2021/02/Alpha-2-002.webp",
        "type": "exterior",
        "caption": "Shady Grove Fertility Alpharetta clinic exterior",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/georgia/alpharetta-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlpbJ4quai77V8MXaVYUC4dNqPpZkKSKBLT5ayj_PjaxBUdsUcm6C2Sjvr7s6G3cWUoJUQNBJYFGaxeKy2TwfqdVxm3pbh6hIDQxAk_ulRLWZEoRJtrbjiy70AeqrmJ7HekCA3r=w360-h480-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Alpharetta,+3905+Brookside+Pkwy+Ste+100,+Alpharetta,+GA+30022/@34.0599584,-84.2491005,3305a,13.1y/data=!4m2!3m1!1s0x88f59e2c1bff7915:0xf89bc000806bd4ba",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkHoiZm7kGBQ_lLgcldjRGInfgdaVhvq98fV4YWeYAZpicbGpp0Kkgij4aDHxBuohiGfNZNoSn-PkteDEpsgAP8pTic_p9v9akqFwUqhxU8bKNGg-ctMYTwjOdAtJ-l4Qv5wqF4dnTL3dM=w574-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Alpharetta,+3905+Brookside+Pkwy+Ste+100,+Alpharetta,+GA+30022/@34.0599584,-84.2491005,3305a,13.1y/data=!4m2!3m1!1s0x88f59e2c1bff7915:0xf89bc000806bd4ba",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJFXn_Gyye9YgRutRrgADAm_g"
    }
  },
  {
    "id": "org-sgf-marietta",
    "name": "Shady Grove Fertility Marietta",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/georgia/marietta-fertility-center/",
    "phone": "(678) 597-1700",
    "address": {
      "line1": "61 Whitcher St, Suite 4140",
      "city": "Marietta",
      "state": "GA",
      "zip": "30060",
      "country": "US"
    },
    "location": {
      "lat": 33.9525,
      "lng": -84.5491
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/georgia/marietta-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Marietta,+61+Whitcher+St+%234140,+Marietta,+GA+30060/@33.9672528,-84.5516821,3309a,13.1y/data=!4m2!3m1!1s0x88f515d8c2d9eea5:0x7fb600c37285f73a",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Victoria S. Jiang, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/10/Jiang-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/georgia/marietta-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-marietta-victoria-s-jiang-md"
      },
      {
        "name": "Jessica R. Kanter, MD, MTR",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MTR"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/10/Jessica-Kanter-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/georgia/marietta-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-marietta-jessica-r-kanter-md-mtr"
      },
      {
        "name": "Erika Rubant, MSN, RN, WHNP",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "RN", "WHNP"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2023/02/Erika-Rubant-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/georgia/marietta-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-marietta-erika-rubant-msn-rn-whnp"
      }
    ],
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2021/02/Marietta_Hero_Image.jpg",
        "type": "exterior",
        "caption": "Shady Grove Fertility Marietta clinic exterior",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/georgia/marietta-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnEEg6B1OykMyuuoK5HSRaQWJ7Xum8V_DShyNiPVL814cZh-P8YITW33Oc1ZDg6KJlO02p6be2kLgaJzHhVD-ajzOHU7l6I94fbPS6TnyK5v8fBVLRwvvjXLRMHXLQRfW5F9--usa2YLUQL=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Marietta,+61+Whitcher+St+%234140,+Marietta,+GA+30060/@33.9672528,-84.5516821,3309a,13.1y/data=!4m2!3m1!1s0x88f515d8c2d9eea5:0x7fb600c37285f73a",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJpe7ZwtgV9YgROveFcsMAtn8"
    }
  },
  {
    "id": "org-sgf-buckhead",
    "name": "Shady Grove Fertility Buckhead",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/georgia/",
    "phone": "(678) 597-1700",
    "address": {
      "line1": "2061 Peachtree Rd NW, Suite 350",
      "city": "Atlanta",
      "state": "GA",
      "zip": "30309",
      "country": "US"
    },
    "location": {
      "lat": 33.8091,
      "lng": -84.3854
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-sgf-allentown",
    "name": "Shady Grove Fertility Allentown",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/pennsylvania/",
    "phone": "(610) 961-3100",
    "address": {
      "line1": "1251 S Cedar Crest Blvd, Suite 220",
      "city": "Allentown",
      "state": "PA",
      "zip": "18103",
      "country": "US"
    },
    "location": {
      "lat": 40.5816,
      "lng": -75.5051
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-sgf-lancaster",
    "name": "Shady Grove Fertility Lancaster",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/pennsylvania/lancaster-fertility-center/",
    "phone": "(717) 763-1036",
    "address": {
      "line1": "205 Granite Run Dr",
      "city": "Lancaster",
      "state": "PA",
      "zip": "17601",
      "country": "US"
    },
    "location": {
      "lat": 40.0746,
      "lng": -76.3414
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/pennsylvania/lancaster-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Lancaster,+205+Granite+Run+Dr+%23350,+Lancaster,+PA+17601/@40.0770225,-76.3354034,3053a,13.1y/data=!4m2!3m1!1s0x89c623e1be73685d:0xbef35858468d5071",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Russell Hayden, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/09/R.-Hayden-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/chesterbrook/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-lancaster-russell-hayden-md"
      },
      {
        "name": "Nicole M. Marchetto, MD, MPH",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MPH"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/12/Niole-Marchetto-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/chesterbrook/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-lancaster-nicole-m-marchetto-md-mph"
      },
      {
        "name": "Kara Khanh-Ha D. Nguyen, MD, MPH",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MPH"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Kara-Nguyen-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/mechanicsburg/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-lancaster-kara-khanh-ha-d-nguyen-md-mph"
      },
      {
        "name": "Melanie Ochalski, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Melanie-Ochalski-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/lancaster-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-lancaster-melanie-ochalski-md"
      },
      {
        "name": "Elyse Whiting, CRNP",
        "role": "Nurse Practitioner",
        "credentials": ["CRNP"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Elyse-Whiting-hero.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/lancaster-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-lancaster-elyse-whiting-crnp"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmOQZbM4PYwCUIZszxnuMj4bv8quijqviOiZf2jqZ2dLM9p5nm3ol27s_-_dqC--cywPxqu8KM6GUhoA7yCBOJYcPfsfEDkuWdVrDCIvIbMWkj3IUI1YhBNCpYGC3DX6D1YZODFFMl93h0=w526-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Lancaster,+205+Granite+Run+Dr+%23350,+Lancaster,+PA+17601/@40.0770225,-76.3354034,3053a,13.1y/data=!4m2!3m1!1s0x89c623e1be73685d:0xbef35858468d5071",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnr3Wnzw4KrzkmlxOaHVBFniq0pbU6Rokjiah-zB6rERBKkI4joAW6TXOOaRhOtxWaN1UWWyH1RR8CfVSflcuZcaSgXSzH3iPHGIDqiBw-cCT22cjLs-yIM5ph64QVxcI8POMJ78I56JHQ=w469-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Lancaster,+205+Granite+Run+Dr+%23350,+Lancaster,+PA+17601/@40.0770225,-76.3354034,3053a,13.1y/data=!4m2!3m1!1s0x89c623e1be73685d:0xbef35858468d5071",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "externalIds": {
      "googlePlaceId": "ChIJXWhzvuEjxokRcVCNRlhY874"
    }
  },
  {
    "id": "org-sgf-philadelphia",
    "name": "Shady Grove Fertility Philadelphia",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/pennsylvania/center-city-fertility-center/",
    "phone": "(215) 554-2880",
    "address": {
      "line1": "1515 Market St, Suite 1030",
      "city": "Philadelphia",
      "state": "PA",
      "zip": "19102",
      "country": "US"
    },
    "location": {
      "lat": 39.9527,
      "lng": -75.1675
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/pennsylvania/center-city-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Philadelphia,+1515+Market+St+Ste.+1030,+Philadelphia,+PA+19102/@39.9528556,-75.1661466,3058a,13.1y/data=!4m2!3m1!1s0x89c6c75d8c53c8e3:0xe829f7eadeaf9b10",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Caleb Kallen, MD, PhD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "PhD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Caleb-Kallen-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/center-city-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-philadelphia-caleb-kallen-md-phd"
      },
      {
        "name": "Russell Hayden, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/09/R.-Hayden-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/chesterbrook/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-philadelphia-russell-hayden-md"
      },
      {
        "name": "Amanda Zlupko, CRNP, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["CRNP", "WHNP-BC"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/09/Zlupko-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/center-city-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-philadelphia-amanda-zlupko-crnp-whnp-bc"
      }
    ],
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2021/02/CenterCity_Thumbnail.jpg",
        "type": "exterior",
        "caption": "Shady Grove Fertility Center City office",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/center-city-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnFvTDyPS7Zgtp_lTz1Yx5cjkupWmq6ydr4hEQs_8ISdlPcgerHbi2YdxVqA_Disv5hH_G-0fIHOO-tm0Ev3yMGEHoNeqK7ib3tEcwi9sidEcdzMaqo8jGEDFwRpMAS4AY879yx=w224-h336-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Philadelphia,+1515+Market+St+Ste.+1030,+Philadelphia,+PA+19102/@39.9528556,-75.1661466,3058a,13.1y/data=!4m2!3m1!1s0x89c6c75d8c53c8e3:0xe829f7eadeaf9b10",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmu6Gs6fiXupGsrbLcZhsY8UsgrdQFFyo1jThJKVXr0ztwLwd9zp_vJxljnLYKU1WVC--8bllfyoPul49iA8IpHSw5gwCh_5zFpI3AAsVFWkFxnxH5W8SnXZoTafXDv4mur1n9Sww=w140-h248-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Philadelphia,+1515+Market+St+Ste.+1030,+Philadelphia,+PA+19102/@39.9528556,-75.1661466,3058a,13.1y/data=!4m2!3m1!1s0x89c6c75d8c53c8e3:0xe829f7eadeaf9b10",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJ48hTjF3HxokREJuv3ur3Keg"
    }
  },
  {
    "id": "org-sgf-warrington",
    "name": "Shady Grove Fertility Warrington",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/pennsylvania/warrington-fertility-center/",
    "phone": "(215) 554-2880",
    "address": {
      "line1": "865 Easton Rd, Suite 290",
      "city": "Warrington",
      "state": "PA",
      "zip": "18976",
      "country": "US"
    },
    "location": {
      "lat": 40.2476,
      "lng": -75.1427
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/pennsylvania/warrington-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Warrington,+865+Easton+Rd+Ste+290,+Warrington,+PA+18976/@40.2388355,-75.134753,3046a,13.1y/data=!4m2!3m1!1s0x89c6a8b45798e8c3:0xeef8b314801838c0",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "J. Ryan Martin, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Ryan-Martin-850-x-850.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/warrington-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-warrington-j-ryan-martin-md"
      },
      {
        "name": "Russell Hayden, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/09/R.-Hayden-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/chesterbrook/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-warrington-russell-hayden-md"
      }
    ],
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2021/02/warrington-hero.jpg",
        "type": "exterior",
        "caption": "Shady Grove Fertility Warrington office",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/warrington-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnUFYn06sGmjjwSErcXN9ZHssElGe3YFvLg8XDv7VUEi3zU59-O9txpppMqaUB37fHXSnqDFcBx5Cu0_ECFEQHVXLz0rKTHAYG_yD23NNRCEhoj4WBFDJvd-BJFTjYc2qjYqxzAzX71FBz8=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Warrington,+865+Easton+Rd+Ste+290,+Warrington,+PA+18976/@40.2388355,-75.134753,3046a,13.1y/data=!4m2!3m1!1s0x89c6a8b45798e8c3:0xeef8b314801838c0",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJw-iYV7SoxokRwDgYgBSz-O4"
    }
  },
  {
    "id": "org-sgf-wexford",
    "name": "Shady Grove Fertility Wexford",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/pennsylvania/wexford-fertility-center/",
    "phone": "(412) 785-1057",
    "address": {
      "line1": "6400 Brooktree Ct, Suite 100",
      "city": "Wexford",
      "state": "PA",
      "zip": "15090",
      "country": "US"
    },
    "location": {
      "lat": 40.6229,
      "lng": -80.0603
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/pennsylvania/wexford-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Wexford,+6400+Brooktree+Ct+%23100,+Wexford,+PA+15090/@40.6134816,-80.0617855,3029a,13.1y/data=!4m2!3m1!1s0x883489b2be3e82df:0xfeab2f9ad0244e18",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "John M. Csokmay, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/05/John-Csokmay-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/wexford-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-wexford-john-m-csokmay-md"
      },
      {
        "name": "Lisa Green, MD, MPH",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MPH"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/06/Green-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/wexford-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-wexford-lisa-green-md-mph"
      },
      {
        "name": "Lauren Roth, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/L.-Roth-website.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/wexford-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-wexford-lauren-roth-md"
      },
      {
        "name": "Susan Strellec, MPAS, PA-C",
        "role": "Physician Assistant",
        "credentials": ["MPAS", "PA-C"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2023/02/Susan-Strellec-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/wexford-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-wexford-susan-strellec-mpas-pa-c"
      }
    ],
    "images": [
      {
        "url": "https://www.shadygrovefertility.com/wp-content/uploads/2021/10/MicrosoftTeams-image-7.jpg",
        "type": "exterior",
        "caption": "Shady Grove Fertility Wexford office",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/wexford-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl4NboPcNHZDkkJUD1mX7w0hIZQGVPhG6foCfAoPb2Umpc_yrYgh8U7DFL5ABYr75462wkRYK7BNevlwuSAlCbINtW7ai0k84HLpCVlVaC_4_NXk-bacfWaOrhUoMGKmyfgZkzh8w1eqNw4=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Wexford,+6400+Brooktree+Ct+%23100,+Wexford,+PA+15090/@40.6134816,-80.0617855,3029a,13.1y/data=!4m2!3m1!1s0x883489b2be3e82df:0xfeab2f9ad0244e18",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJ34I-vrKJNIgRGE4k0Jovq_4"
    }
  },
  {
    "id": "org-sgf-york",
    "name": "Shady Grove Fertility York",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/pennsylvania/york-fertility-center/",
    "phone": "(717) 763-1036",
    "address": {
      "line1": "2200 S George St",
      "city": "York",
      "state": "PA",
      "zip": "17403",
      "country": "US"
    },
    "location": {
      "lat": 39.942,
      "lng": -76.7327
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/pennsylvania/york-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+York,+2200+S+George+St+%231,+York,+PA+17403/@39.9263405,-76.7137653,3060a,13.1y/data=!4m2!3m1!1s0x89c88937608d33b9:0x87531e252ebb92b8",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Melanie Ochalski, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Melanie-Ochalski-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/lancaster-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-york-melanie-ochalski-md"
      },
      {
        "name": "Russell Hayden, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/09/R.-Hayden-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/chesterbrook/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-york-russell-hayden-md"
      },
      {
        "name": "Emily Rochester, CRNP, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["CRNP", "WHNP-BC"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/03/Rochester-850x850-2.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/pennsylvania/york-fertility-center/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-sgf-york-emily-rochester-crnp-whnp-bc"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl5yaAAc531NFTP1IGds_eNK8SnnDcsj68NpGa6sFkJq3JySAYh7BYqNTSTBXr2tOZjL3uOCxjNlzYa2wRBwQJIFa5r5b6uBpPd4_UffD6OVpJQh8tlSddn8xUFHqcX_nBaOZx337s6UehL=w298-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+York,+2200+S+George+St+%231,+York,+PA+17403/@39.9263405,-76.7137653,3060a,13.1y/data=!4m2!3m1!1s0x89c88937608d33b9:0x87531e252ebb92b8",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "externalIds": {
      "googlePlaceId": "ChIJuTONYDeJyIkRuJK7LiUeU4c"
    }
  },
  {
    "id": "org-sgf-annandale",
    "name": "Shady Grove Fertility Annandale",
    "description": "Shady Grove Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.shadygrovefertility.com/locations/virginia/",
    "phone": "(703) 698-7355",
    "address": {
      "line1": "7023 Little River Tpke, Suite 300",
      "city": "Annandale",
      "state": "VA",
      "zip": "22003",
      "country": "US"
    },
    "location": {
      "lat": 38.83,
      "lng": -77.1987
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Adventist Healthnet",
        "Aetna",
        "Amerihealth HMO",
        "Anthem",
        "Berkshire Health Plan",
        "Capital Blue Cross Blue Shield",
        "CareFirst Blue Cross Blue Shield of Maryland",
        "CareFirst Blue Choice",
        "CareFirst National Capital Area",
        "Choice Care Network",
        "CHP/Informed",
        "Cigna",
        "Coventry Healthcare National Network",
        "GreatWest Healthcare",
        "Health America",
        "Highmark Blue Cross Blue Shield",
        "Highmark Blue Cross Blue Shield Premier",
        "Health Keepers",
        "Independence Blue Cross Blue Shield",
        "Intergroup",
        "Kaiser",
        "Keystone Health Plan East",
        "Keystone Health Plan Central",
        "MAMSI Life & Health",
        "MDIPA/Optimum Choice",
        "MultiPlan Network",
        "OneNet PPO",
        "Parent Steps",
        "Private Healthcare Systems",
        "Tricare",
        "United Healthcare",
        "United Resource Network"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"],
      "_source": {
        "url": "https://www.shadygrovefertility.com/insurance/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/insurance/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/virginia/fairfax-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Eric D. Levens, M.D.",
        "role": "Reproductive Endocrinologist; Medical Director, Northern Virginia",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Eric-Levens-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/levens/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-annandale-eric-d-levens-m-d"
      },
      {
        "name": "David S. Saffan, M.D.",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/04/David_S._Saffan_-_Desktop.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/saffan/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-annandale-david-s-saffan-m-d"
      },
      {
        "name": "Rachana V. Garde, M.D., MPH",
        "role": "Reproductive Endocrinologist / Fertility Specialist",
        "credentials": ["MD", "MPH"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Rachana_Garde_1.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/garde/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-annandale-rachana-v-garde-m-d-mph"
      },
      {
        "name": "Cigdem (Cori) Tanrikut, M.D.",
        "role": "Reproductive Urologist (Male Fertility)",
        "credentials": ["MD", "FACS"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/05/Cori-Tanrikut-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/tanrikut/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-annandale-cigdem-cori-tanrikut-m-d"
      },
      {
        "name": "Amy Chang, MSN, FNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "FNP-BC"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/10/Amy-Change-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/amy-chang/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-annandale-amy-chang-msn-fnp-bc"
      },
      {
        "name": "James Graham, M.S., ELD",
        "role": "Senior Director of Laboratory Services / Lab Director (Maryland and Virginia)",
        "credentials": ["MS", "ELD"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/06/SGF_Jim-Graham_850x850.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/james-graham/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-sgf-annandale-james-graham-m-s-eld"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Adventist Healthnet, Aetna, Amerihealth HMO, Anthem, Berkshire Health Plan, Capital Blue Cross Blue Shield, CareFirst Blue Cross Blue Shield of Maryland, CareFirst Blue Choice",
              "detail": "24 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.shadygrovefertility.com/insurance/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-fci-chestnut",
    "name": "Fertility Centers of Illinois Chicago Chestnut",
    "description": "Fertility Centers of Illinois provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.fcionline.com/locations/",
    "phone": "(312) 222-8230",
    "address": {
      "line1": "361 W Chestnut, Suite 100",
      "city": "Chicago",
      "state": "IL",
      "zip": "60610",
      "country": "US"
    },
    "location": {
      "lat": 41.8984,
      "lng": -87.6383
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-fci-glenview",
    "name": "Fertility Centers of Illinois Glenview",
    "description": "Fertility Centers of Illinois provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.fcionline.com/locations/",
    "phone": "(847) 729-3344",
    "address": {
      "line1": "2555 Patriot Blvd",
      "city": "Glenview",
      "state": "IL",
      "zip": "60026",
      "country": "US"
    },
    "location": {
      "lat": 42.0862,
      "lng": -87.8168
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+Illinois+in+Glenview,+2555+Patriot+Blvd,+Glenview,+IL+60026/@42.1005733,-87.8219948,2960a,13.1y/data=!4m2!3m1!1s0x880fc78f42966ae3:0xd083539c318b29b",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Jennifer E. Hirshfeld-Cytron, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Hirshfeld_Head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-glenview-jennifer-e-hirshfeld-cytron-md"
      },
      {
        "name": "Channing Burks Chatmon, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/07/Burks-850x850-1.png",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-glenview-channing-burks-chatmon-md"
      },
      {
        "name": "Christopher Sipe, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Sipe_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-glenview-christopher-sipe-md"
      },
      {
        "name": "Samuel Ohlander, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Ohlander_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-glenview-samuel-ohlander-md"
      },
      {
        "name": "Edward Nguyen, MD, PhD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/10/Nguyen_head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-glenview-edward-nguyen-md-phd"
      },
      {
        "name": "Arlene Go, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/12/Untitled-design-50.png",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-glenview-arlene-go-md"
      },
      {
        "name": "Allison K. Rodgers, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Rodgers_Head_LC_2025.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-glenview-allison-k-rodgers-md"
      },
      {
        "name": "Jane Nani, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Nani_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-glenview-jane-nani-md"
      },
      {
        "name": "Karine Matevossian, DO",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/09/Matovessian_head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-glenview-karine-matevossian-do"
      },
      {
        "name": "Annie Martini, DO",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2025/09/MARTINI_head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-glenview-annie-martini-do"
      },
      {
        "name": "Meike Uhler, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Uhler_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-glenview-meike-uhler-md"
      },
      {
        "name": "Megan Sax, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/09/Sax_headshot.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-glenview-megan-sax-md"
      },
      {
        "name": "Elie Hobeika, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Hobeika_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-glenview-elie-hobeika-md"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn--Pl_kIg-uT3ihrw9xHpITMPqREEUyEM5M9vhkNsunC5MMbY_vcqhp7vVzGnQ8AwiSosDVgPZttCx8TyjJGKFLGTQEUfn82Nl87c_040okM5wKxOwZL4svFWdKHCgTHHKT-00WH7IMrLN=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+Illinois+in+Glenview,+2555+Patriot+Blvd,+Glenview,+IL+60026/@42.1005733,-87.8219948,2960a,13.1y/data=!4m2!3m1!1s0x880fc78f42966ae3:0xd083539c318b29b",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl-EX8gixK282t7_0WOtVPCUMfJcfZVp7g1ZLPg8W5h1wA4yKXluQURdBOqkSxQRR8tbjzSDVz9gsxW0AGeHH_EQtKJl1031VGEX43AlgshHITXiOmBvcUdoi_-UFkUL8pgKeNv2eHsnps=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+Illinois+in+Glenview,+2555+Patriot+Blvd,+Glenview,+IL+60026/@42.1005733,-87.8219948,2960a,13.1y/data=!4m2!3m1!1s0x880fc78f42966ae3:0xd083539c318b29b",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "externalIds": {
      "googlePlaceId": "ChIJ42qWQo_HD4gRm7IYwzk1CA0"
    }
  },
  {
    "id": "org-fci-hinsdale",
    "name": "Fertility Centers of Illinois Hinsdale",
    "description": "Fertility Centers of Illinois provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.fcionline.com/locations/",
    "phone": "(630) 366-4575",
    "address": {
      "line1": "907 N Elm St, Suite 200",
      "city": "Hinsdale",
      "state": "IL",
      "zip": "60521",
      "country": "US"
    },
    "location": {
      "lat": 41.8041,
      "lng": -87.9331
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Jennifer E. Hirshfeld-Cytron, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Hirshfeld_Head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hinsdale-jennifer-e-hirshfeld-cytron-md"
      },
      {
        "name": "Channing Burks Chatmon, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/07/Burks-850x850-1.png",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hinsdale-channing-burks-chatmon-md"
      },
      {
        "name": "Christopher Sipe, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Sipe_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hinsdale-christopher-sipe-md"
      },
      {
        "name": "Samuel Ohlander, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Ohlander_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hinsdale-samuel-ohlander-md"
      },
      {
        "name": "Edward Nguyen, MD, PhD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/10/Nguyen_head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hinsdale-edward-nguyen-md-phd"
      },
      {
        "name": "Arlene Go, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/12/Untitled-design-50.png",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hinsdale-arlene-go-md"
      },
      {
        "name": "Allison K. Rodgers, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Rodgers_Head_LC_2025.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hinsdale-allison-k-rodgers-md"
      },
      {
        "name": "Jane Nani, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Nani_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hinsdale-jane-nani-md"
      },
      {
        "name": "Karine Matevossian, DO",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/09/Matovessian_head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hinsdale-karine-matevossian-do"
      },
      {
        "name": "Annie Martini, DO",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2025/09/MARTINI_head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hinsdale-annie-martini-do"
      },
      {
        "name": "Meike Uhler, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Uhler_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hinsdale-meike-uhler-md"
      },
      {
        "name": "Megan Sax, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/09/Sax_headshot.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hinsdale-megan-sax-md"
      },
      {
        "name": "Elie Hobeika, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Hobeika_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hinsdale-elie-hobeika-md"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-fci-hoffman-estates",
    "name": "Fertility Centers of Illinois Hoffman Estates",
    "description": "Fertility Centers of Illinois provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.fcionline.com/locations/",
    "phone": "(847) 884-8884",
    "address": {
      "line1": "2260 W Higgins Rd, Suite 200",
      "city": "Hoffman Estates",
      "state": "IL",
      "zip": "60169",
      "country": "US"
    },
    "location": {
      "lat": 42.0395,
      "lng": -88.1157
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+Illinois+in+Hoffman+Estates,+2260+W+Higgins+Rd+%23200,+Hoffman+Estates,+IL+60169/@42.0574778,-88.1351247,2962a,13.1y/data=!4m2!3m1!1s0x880fa8723cdf2d85:0x4d84670f75aa0a4c",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Jennifer E. Hirshfeld-Cytron, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Hirshfeld_Head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hoffman-estates-jennifer-e-hirshfeld-cytron-md"
      },
      {
        "name": "Channing Burks Chatmon, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/07/Burks-850x850-1.png",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hoffman-estates-channing-burks-chatmon-md"
      },
      {
        "name": "Christopher Sipe, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Sipe_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hoffman-estates-christopher-sipe-md"
      },
      {
        "name": "Samuel Ohlander, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Ohlander_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hoffman-estates-samuel-ohlander-md"
      },
      {
        "name": "Edward Nguyen, MD, PhD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/10/Nguyen_head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hoffman-estates-edward-nguyen-md-phd"
      },
      {
        "name": "Arlene Go, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/12/Untitled-design-50.png",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hoffman-estates-arlene-go-md"
      },
      {
        "name": "Allison K. Rodgers, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Rodgers_Head_LC_2025.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hoffman-estates-allison-k-rodgers-md"
      },
      {
        "name": "Jane Nani, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Nani_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hoffman-estates-jane-nani-md"
      },
      {
        "name": "Karine Matevossian, DO",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/09/Matovessian_head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hoffman-estates-karine-matevossian-do"
      },
      {
        "name": "Annie Martini, DO",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2025/09/MARTINI_head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hoffman-estates-annie-martini-do"
      },
      {
        "name": "Meike Uhler, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Uhler_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hoffman-estates-meike-uhler-md"
      },
      {
        "name": "Megan Sax, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/09/Sax_headshot.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hoffman-estates-megan-sax-md"
      },
      {
        "name": "Elie Hobeika, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Hobeika_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-hoffman-estates-elie-hobeika-md"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWncVH-7zQLZQcPknIv-oKTVACE0kLVlQOoMq-u6hVYCVITQl7yzo6qrf-6I6nUEOaoeO1EIYOCeQ1QPT5otxcqxLp5fOE_zWtcLRME7QcqkhuGu0zro8rpPDHzPXuXQoK-azsN_3bUsr_Jg=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+Illinois+in+Hoffman+Estates,+2260+W+Higgins+Rd+%23200,+Hoffman+Estates,+IL+60169/@42.0574778,-88.1351247,2962a,13.1y/data=!4m2!3m1!1s0x880fa8723cdf2d85:0x4d84670f75aa0a4c",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkekmaS-dnxICTiHh_GiVdt88zdePQEFuuUQaQ8WmrE3uMlJRXxhwymleiV2i2jLLhG7HmBjC-3WAyr5Y-jyJMnl8A5FL95mgh726iMzKzy_1pxurzPOWNdtOOcIq3NEcsAcCg=w224-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+Illinois+in+Hoffman+Estates,+2260+W+Higgins+Rd+%23200,+Hoffman+Estates,+IL+60169/@42.0574778,-88.1351247,2962a,13.1y/data=!4m2!3m1!1s0x880fa8723cdf2d85:0x4d84670f75aa0a4c",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "externalIds": {
      "googlePlaceId": "ChIJhS3fPHKoD4gRTAqqdQ9nhE0"
    }
  },
  {
    "id": "org-fci-mokena",
    "name": "Fertility Centers of Illinois Mokena",
    "description": "Fertility Centers of Illinois provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.fcionline.com/locations/",
    "phone": "(708) 342-3900",
    "address": {
      "line1": "19065 Hickory Creek Dr, Suite 115",
      "city": "Mokena",
      "state": "IL",
      "zip": "60448",
      "country": "US"
    },
    "location": {
      "lat": 41.5365,
      "lng": -87.8738
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+Illinois+in+Mokena,+19065+Hickory+Creek+Dr+Ste+115,+Mokena,+IL+60448/@41.54442,-87.8424168,2986a,13.1y/data=!4m2!3m1!1s0x880e15b690e9bcb9:0xa9a225ed40eb6f87",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Jennifer E. Hirshfeld-Cytron, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Hirshfeld_Head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-mokena-jennifer-e-hirshfeld-cytron-md"
      },
      {
        "name": "Channing Burks Chatmon, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/07/Burks-850x850-1.png",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-mokena-channing-burks-chatmon-md"
      },
      {
        "name": "Christopher Sipe, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Sipe_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-mokena-christopher-sipe-md"
      },
      {
        "name": "Samuel Ohlander, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Ohlander_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-mokena-samuel-ohlander-md"
      },
      {
        "name": "Edward Nguyen, MD, PhD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/10/Nguyen_head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-mokena-edward-nguyen-md-phd"
      },
      {
        "name": "Arlene Go, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/12/Untitled-design-50.png",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-mokena-arlene-go-md"
      },
      {
        "name": "Allison K. Rodgers, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Rodgers_Head_LC_2025.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-mokena-allison-k-rodgers-md"
      },
      {
        "name": "Jane Nani, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Nani_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-mokena-jane-nani-md"
      },
      {
        "name": "Karine Matevossian, DO",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/09/Matovessian_head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-mokena-karine-matevossian-do"
      },
      {
        "name": "Annie Martini, DO",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2025/09/MARTINI_head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-mokena-annie-martini-do"
      },
      {
        "name": "Meike Uhler, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Uhler_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-mokena-meike-uhler-md"
      },
      {
        "name": "Megan Sax, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/09/Sax_headshot.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-mokena-megan-sax-md"
      },
      {
        "name": "Elie Hobeika, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Hobeika_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-mokena-elie-hobeika-md"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlKrmzD3ayl3IwDDTy0GkHQFVN2oma8vP9lwKrou1nxD16STTzUZDlJxFOidRy2DIFfCCVfWxnDDFHL54_JuyJZQI6P0kKUUhZraOeH0IkJYIksV1mSMpilbfHv_AILg0NwrEk6istHlYZw=w596-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+Illinois+in+Mokena,+19065+Hickory+Creek+Dr+Ste+115,+Mokena,+IL+60448/@41.54442,-87.8424168,2986a,13.1y/data=!4m2!3m1!1s0x880e15b690e9bcb9:0xa9a225ed40eb6f87",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "externalIds": {
      "googlePlaceId": "ChIJubzpkLYVDogRh2_rQO0loqk"
    }
  },
  {
    "id": "org-fci-vernon-hills",
    "name": "Fertility Centers of Illinois Vernon Hills",
    "description": "Fertility Centers of Illinois provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.fcionline.com/locations/",
    "phone": "(847) 729-3344",
    "address": {
      "line1": "175 E Hawthorn Pkwy, Suite 102",
      "city": "Vernon Hills",
      "state": "IL",
      "zip": "60061",
      "country": "US"
    },
    "location": {
      "lat": 42.2283,
      "lng": -87.9596
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+Illinois+-+Vernon+Hills,+175+E+Hawthorn+Pkwy+Ste+102,+Vernon+Hills,+IL+60061/@42.2409874,-87.9612755,2954a,13.1y/data=!4m2!3m1!1s0x880fbc9244308af5:0x4aa3119f0018c0e9",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Jennifer E. Hirshfeld-Cytron, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Hirshfeld_Head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-vernon-hills-jennifer-e-hirshfeld-cytron-md"
      },
      {
        "name": "Channing Burks Chatmon, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/07/Burks-850x850-1.png",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-vernon-hills-channing-burks-chatmon-md"
      },
      {
        "name": "Christopher Sipe, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Sipe_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-vernon-hills-christopher-sipe-md"
      },
      {
        "name": "Samuel Ohlander, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Ohlander_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-vernon-hills-samuel-ohlander-md"
      },
      {
        "name": "Edward Nguyen, MD, PhD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/10/Nguyen_head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-vernon-hills-edward-nguyen-md-phd"
      },
      {
        "name": "Arlene Go, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/12/Untitled-design-50.png",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-vernon-hills-arlene-go-md"
      },
      {
        "name": "Allison K. Rodgers, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Rodgers_Head_LC_2025.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-vernon-hills-allison-k-rodgers-md"
      },
      {
        "name": "Jane Nani, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Nani_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-vernon-hills-jane-nani-md"
      },
      {
        "name": "Karine Matevossian, DO",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/09/Matovessian_head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-vernon-hills-karine-matevossian-do"
      },
      {
        "name": "Annie Martini, DO",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2025/09/MARTINI_head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-vernon-hills-annie-martini-do"
      },
      {
        "name": "Meike Uhler, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Uhler_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-vernon-hills-meike-uhler-md"
      },
      {
        "name": "Megan Sax, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/09/Sax_headshot.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-vernon-hills-megan-sax-md"
      },
      {
        "name": "Elie Hobeika, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Hobeika_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-vernon-hills-elie-hobeika-md"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlPAj7FfFrX9zJxbRzbdf9tAKZ0qZfzS_NKZQUM3EYK-y_PKRwD3-QHUNDSRG1EthPu25RkkCMa2f53te9qaydJRjbcv-OyogBmJkoZB1xHLRpqTLOSCEpJH_p3yf1cigNmhv4Es0JrR3dI=w408-h329-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+Illinois+-+Vernon+Hills,+175+E+Hawthorn+Pkwy+Ste+102,+Vernon+Hills,+IL+60061/@42.2409874,-87.9612755,2954a,13.1y/data=!4m2!3m1!1s0x880fbc9244308af5:0x4aa3119f0018c0e9",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "externalIds": {
      "googlePlaceId": "ChIJ9YowRJK8D4gR6cAYAJ8Ro0o"
    }
  },
  {
    "id": "org-fci-warrenville",
    "name": "Fertility Centers of Illinois Warrenville",
    "description": "Fertility Centers of Illinois provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.fcionline.com/locations/",
    "phone": "(630) 366-4575",
    "address": {
      "line1": "28373 Davis Pkwy, Suite 502",
      "city": "Warrenville",
      "state": "IL",
      "zip": "60555",
      "country": "US"
    },
    "location": {
      "lat": 41.8136,
      "lng": -88.1768
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+Illinois+in+Warrenville,+28373+Davis+Pkwy+%23502,+Warrenville,+IL+60555/@41.8003532,-88.1764345,2974a,13.1y/data=!4m2!3m1!1s0x880ef89a29fa34b7:0xe67decbbd66b5b47",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Jennifer E. Hirshfeld-Cytron, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Hirshfeld_Head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-warrenville-jennifer-e-hirshfeld-cytron-md"
      },
      {
        "name": "Channing Burks Chatmon, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/07/Burks-850x850-1.png",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-warrenville-channing-burks-chatmon-md"
      },
      {
        "name": "Christopher Sipe, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Sipe_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-warrenville-christopher-sipe-md"
      },
      {
        "name": "Samuel Ohlander, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Ohlander_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-warrenville-samuel-ohlander-md"
      },
      {
        "name": "Edward Nguyen, MD, PhD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/10/Nguyen_head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-warrenville-edward-nguyen-md-phd"
      },
      {
        "name": "Arlene Go, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/12/Untitled-design-50.png",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-warrenville-arlene-go-md"
      },
      {
        "name": "Allison K. Rodgers, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Rodgers_Head_LC_2025.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-warrenville-allison-k-rodgers-md"
      },
      {
        "name": "Jane Nani, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Nani_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-warrenville-jane-nani-md"
      },
      {
        "name": "Karine Matevossian, DO",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/09/Matovessian_head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-warrenville-karine-matevossian-do"
      },
      {
        "name": "Annie Martini, DO",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2025/09/MARTINI_head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-warrenville-annie-martini-do"
      },
      {
        "name": "Meike Uhler, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Uhler_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-warrenville-meike-uhler-md"
      },
      {
        "name": "Megan Sax, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2024/09/Sax_headshot.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-warrenville-megan-sax-md"
      },
      {
        "name": "Elie Hobeika, MD",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2023/05/Hobeika_profile.jpg",
        "_source": {
          "url": "https://www.fcionline.com/doctors/jennifer-hirshfeld-cytron/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-fci-warrenville-elie-hobeika-md"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl7eScX5mCeyJoTBpnNkb_huv_IJ17T3zdX_DKJB1GXjQuRzgbaFVbC_9U9r4bKEdBQMi1oXwJmRYN2-5d4fhunGqAzJ2HpQHPQioHEwuO1QnJC1PNHQmdrQnk9NbonVqzz-beO1lF_ugg=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+Illinois+in+Warrenville,+28373+Davis+Pkwy+%23502,+Warrenville,+IL+60555/@41.8003532,-88.1764345,2974a,13.1y/data=!4m2!3m1!1s0x880ef89a29fa34b7:0xe67decbbd66b5b47",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnyuM0dc2U5EGqjBbU5YmvP5kyY4NUeWSalZKwYGZ1xC6lNyCxVEux7bg8oxWIWAHozmriAj1S2_3IViy2IBxB4VRP88nvX99Z8BpavZwq5j0FTOCBy-MkebLCouRyz9skohgL17IoR7nVx=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+Illinois+in+Warrenville,+28373+Davis+Pkwy+%23502,+Warrenville,+IL+60555/@41.8003532,-88.1764345,2974a,13.1y/data=!4m2!3m1!1s0x880ef89a29fa34b7:0xe67decbbd66b5b47",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "externalIds": {
      "googlePlaceId": "ChIJtzT6KZr4DogRR1tr1rvsfeY"
    }
  },
  {
    "id": "org-fci-milwaukee",
    "name": "Fertility Centers of Illinois Milwaukee",
    "description": "Fertility Centers of Illinois provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.fcionline.com/locations/milwaukee-wisconsin-fertility-center/",
    "phone": "(414) 939-3600",
    "address": {
      "line1": "239 E Chicago St, Suite 101",
      "city": "Milwaukee",
      "state": "WI",
      "zip": "53202",
      "country": "US"
    },
    "location": {
      "lat": 43.0352,
      "lng": -87.9061
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "identity": {
          "status": "missing"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.fcionline.com/locations/milwaukee-wisconsin-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fcionline.com/locations/milwaukee-wisconsin-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+Illinois+in+Milwaukee,+239+E+Chicago+St+Suite+101,+Milwaukee,+WI+53202/@43.032255,-87.907963,2916a,13.1y/data=!4m2!3m1!1s0x880519680c9e5da1:0xe9cc9648ac59ec0d",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-fci-milwaukee-annie-martini-do",
        "name": "Annie Martini, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.fcionline.com/wp-content/uploads/2025/09/MARTINI_head_LC.jpg",
        "_source": {
          "url": "https://www.fcionline.com/locations/milwaukee-wisconsin-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWndMDJ7YqLiMGtWwxdUdWUSWQchsb2lJtfQVYWplSP-Nf4zJvCWbW0o8fJZrgAsy-4-rbaDgu1D9Z63nBLkWrjHN4Mp0XjFadTCvV74IgvQ6w81RjAXCj1mwNOXuahGqw7Diy5kNcw7werf=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+Illinois+in+Milwaukee,+239+E+Chicago+St+Suite+101,+Milwaukee,+WI+53202/@43.032255,-87.907963,2916a,13.1y/data=!4m2!3m1!1s0x880519680c9e5da1:0xe9cc9648ac59ec0d",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Wisconsin (WI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJoV2eDGgZBYgRDexZrEiWzOk"
    }
  },
  {
    "id": "org-ivffl-boca-raton",
    "name": "IVF Florida Boca Raton",
    "description": "IVF Florida provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://ivfflorida.com/locations/boca-raton-fertility-center/",
    "phone": "(954) 247-6200",
    "address": {
      "line1": "2500 N Military Trail, Suite 150",
      "city": "Boca Raton",
      "state": "FL",
      "zip": "33431",
      "country": "US"
    },
    "location": {
      "lat": 26.3733,
      "lng": -80.1168
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfflorida.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Marcelo Barrionuevo, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/07/barrionuevo-marcelo_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-boca-raton-marcelo-barrionuevo-md"
      },
      {
        "name": "Daniel Christie, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/christie-daniel_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-boca-raton-daniel-christie-md"
      },
      {
        "name": "Marc Gualtieri, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/marc-gualtieri_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-boca-raton-marc-gualtieri-md"
      },
      {
        "name": "David I. Hoffman, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/hoffman92425.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-boca-raton-david-i-hoffman-md"
      },
      {
        "name": "Luis Hoyos, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/hoyos-luis_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-boca-raton-luis-hoyos-md"
      },
      {
        "name": "Laurice Bou Nemer, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/bou-nemer-laurice_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-boca-raton-laurice-bou-nemer-md"
      },
      {
        "name": "Vanessa Weitzman, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/weitzman-vanessa_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-boca-raton-vanessa-weitzman-md"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://ivfflorida.com/wp-content/uploads/2025/08/bocaraton.png",
        "type": "exterior",
        "caption": "IVF Florida Boca Raton fertility center",
        "_source": {
          "url": "https://ivfflorida.com/locations/boca-raton-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-ivffl-coral-gables",
    "name": "IVF Florida Coral Gables",
    "description": "IVF Florida provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://ivfflorida.com/locations/coral-gables-fertility-center/",
    "phone": "(954) 247-6200",
    "address": {
      "line1": "126 Aragon Ave, Suite 126",
      "city": "Coral Gables",
      "state": "FL",
      "zip": "33134",
      "country": "US"
    },
    "location": {
      "lat": 25.7496,
      "lng": -80.2583
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfflorida.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/IVF+Florida+Reproductive+Associates+in+Coral+Gables,+126+Aragon+Ave+%23126,+Coral+Gables,+FL+33134/@25.7504484,-80.2574638,3594a,13.1y/data=!4m2!3m1!1s0x88d9b799cdb0da9d:0x9f5fc2441e2a9fe5",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Marcelo Barrionuevo, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/07/barrionuevo-marcelo_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-coral-gables-marcelo-barrionuevo-md"
      },
      {
        "name": "Daniel Christie, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/christie-daniel_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-coral-gables-daniel-christie-md"
      },
      {
        "name": "Marc Gualtieri, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/marc-gualtieri_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-coral-gables-marc-gualtieri-md"
      },
      {
        "name": "David I. Hoffman, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/hoffman92425.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-coral-gables-david-i-hoffman-md"
      },
      {
        "name": "Luis Hoyos, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/hoyos-luis_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-coral-gables-luis-hoyos-md"
      },
      {
        "name": "Laurice Bou Nemer, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/bou-nemer-laurice_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-coral-gables-laurice-bou-nemer-md"
      },
      {
        "name": "Vanessa Weitzman, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/weitzman-vanessa_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-coral-gables-vanessa-weitzman-md"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://ivfflorida.com/wp-content/uploads/2025/08/cg-building.png",
        "type": "exterior",
        "caption": "IVF Florida Coral Gables fertility center",
        "_source": {
          "url": "https://ivfflorida.com/locations/coral-gables-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkal9ozmsiC8psZ5uDO5gToeAgw4r7oNBzJU8qwWTzfEN-g3na71qJNg3Rs3ncR6GGM6ets_uIIleRjGBaCfZFEc2lnAyI-sNT-apPGrAkXE6D1lkSwS6D8BVJoIGsH5kFiMYH0aw=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/IVF+Florida+Reproductive+Associates+in+Coral+Gables,+126+Aragon+Ave+%23126,+Coral+Gables,+FL+33134/@25.7504484,-80.2574638,3594a,13.1y/data=!4m2!3m1!1s0x88d9b799cdb0da9d:0x9f5fc2441e2a9fe5",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJndqwzZm32YgR5Z8qHkTCX58"
    }
  },
  {
    "id": "org-ivffl-jensen-beach",
    "name": "IVF Florida Jensen Beach",
    "description": "IVF Florida provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://ivfflorida.com/locations/jensen-beach-fertility-center/",
    "phone": "(954) 247-6200",
    "address": {
      "line1": "3498 NW Federal Hwy",
      "city": "Jensen Beach",
      "state": "FL",
      "zip": "34957",
      "country": "US"
    },
    "location": {
      "lat": 27.2658,
      "lng": -80.2496
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfflorida.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/IVF+Florida+Reproductive+Associates+in+Jensen+Beach,+3498+NW+Federal+Hwy,+Jensen+Beach,+FL+34957/@27.245428,-80.2769069,3547a,13.1y/data=!4m2!3m1!1s0x88dee9eed24dc5fb:0x3b415ce1c5f2ade5",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Marcelo Barrionuevo, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/07/barrionuevo-marcelo_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-jensen-beach-marcelo-barrionuevo-md"
      },
      {
        "name": "Daniel Christie, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/christie-daniel_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-jensen-beach-daniel-christie-md"
      },
      {
        "name": "Marc Gualtieri, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/marc-gualtieri_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-jensen-beach-marc-gualtieri-md"
      },
      {
        "name": "David I. Hoffman, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/hoffman92425.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-jensen-beach-david-i-hoffman-md"
      },
      {
        "name": "Luis Hoyos, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/hoyos-luis_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-jensen-beach-luis-hoyos-md"
      },
      {
        "name": "Laurice Bou Nemer, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/bou-nemer-laurice_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-jensen-beach-laurice-bou-nemer-md"
      },
      {
        "name": "Vanessa Weitzman, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/weitzman-vanessa_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-jensen-beach-vanessa-weitzman-md"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://ivfflorida.com/wp-content/uploads/2025/08/jensenbeach.png",
        "type": "exterior",
        "caption": "IVF Florida Jensen Beach fertility center",
        "_source": {
          "url": "https://ivfflorida.com/locations/jensen-beach-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJ-8VN0u7p3ogR5a3yxeFcQTs"
    }
  },
  {
    "id": "org-ivffl-jupiter",
    "name": "IVF Florida Jupiter",
    "description": "IVF Florida provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://ivfflorida.com/locations/jupiter-fertility-center/",
    "phone": "(954) 247-6200",
    "address": {
      "line1": "600 Heritage Dr, Suite 200",
      "city": "Jupiter",
      "state": "FL",
      "zip": "33458",
      "country": "US"
    },
    "location": {
      "lat": 26.9311,
      "lng": -80.1086
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfflorida.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Marcelo Barrionuevo, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/07/barrionuevo-marcelo_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-jupiter-marcelo-barrionuevo-md"
      },
      {
        "name": "Daniel Christie, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/christie-daniel_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-jupiter-daniel-christie-md"
      },
      {
        "name": "Marc Gualtieri, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/marc-gualtieri_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-jupiter-marc-gualtieri-md"
      },
      {
        "name": "David I. Hoffman, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/hoffman92425.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-jupiter-david-i-hoffman-md"
      },
      {
        "name": "Luis Hoyos, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/hoyos-luis_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-jupiter-luis-hoyos-md"
      },
      {
        "name": "Laurice Bou Nemer, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/bou-nemer-laurice_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-jupiter-laurice-bou-nemer-md"
      },
      {
        "name": "Vanessa Weitzman, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/weitzman-vanessa_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-jupiter-vanessa-weitzman-md"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://ivfflorida.com/wp-content/uploads/2025/08/jup-building.png",
        "type": "exterior",
        "caption": "IVF Florida Jupiter fertility center",
        "_source": {
          "url": "https://ivfflorida.com/locations/jupiter-palm-beach-gardens-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-ivffl-pembroke-pines",
    "name": "IVF Florida Pembroke Pines",
    "description": "IVF Florida provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://ivfflorida.com/locations/pembroke-pines-fertility-center/",
    "phone": "(954) 247-6200",
    "address": {
      "line1": "400 N Hiatus Rd, Suite 205",
      "city": "Pembroke Pines",
      "state": "FL",
      "zip": "33026",
      "country": "US"
    },
    "location": {
      "lat": 26.0176,
      "lng": -80.2981
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfflorida.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Marcelo Barrionuevo, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/07/barrionuevo-marcelo_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-pembroke-pines-marcelo-barrionuevo-md"
      },
      {
        "name": "Daniel Christie, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/christie-daniel_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-pembroke-pines-daniel-christie-md"
      },
      {
        "name": "Marc Gualtieri, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/marc-gualtieri_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-pembroke-pines-marc-gualtieri-md"
      },
      {
        "name": "David I. Hoffman, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/hoffman92425.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-pembroke-pines-david-i-hoffman-md"
      },
      {
        "name": "Luis Hoyos, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/hoyos-luis_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-pembroke-pines-luis-hoyos-md"
      },
      {
        "name": "Laurice Bou Nemer, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/bou-nemer-laurice_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-pembroke-pines-laurice-bou-nemer-md"
      },
      {
        "name": "Vanessa Weitzman, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/weitzman-vanessa_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-pembroke-pines-vanessa-weitzman-md"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://ivfflorida.com/wp-content/uploads/2025/08/pembrokepines.png",
        "type": "exterior",
        "caption": "IVF Florida Pembroke Pines fertility center",
        "_source": {
          "url": "https://ivfflorida.com/locations/pembroke-pines-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-ivffl-jacksonville",
    "name": "IVF Florida Jacksonville",
    "description": "IVF Florida provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://ivfflorida.com/locations/jacksonville-fertility-center/",
    "phone": "(954) 247-6200",
    "address": {
      "line1": "9084 RG Skinner Pkwy",
      "city": "Jacksonville",
      "state": "FL",
      "zip": "32256",
      "country": "US"
    },
    "location": {
      "lat": 30.2225,
      "lng": -81.5401
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfflorida.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/IVF+Florida+Reproductive+Associates+in+Jacksonville,+9084+R+G+Skinner+Pkwy,+Jacksonville,+FL+32256/@30.214687,-81.511529,3448a,13.1y/data=!4m2!3m1!1s0x88e5b5431cc943cf:0x7b5cc0b1f3e22a2e",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Marcelo Barrionuevo, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/07/barrionuevo-marcelo_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-jacksonville-marcelo-barrionuevo-md"
      },
      {
        "name": "Daniel Christie, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/christie-daniel_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-jacksonville-daniel-christie-md"
      },
      {
        "name": "Marc Gualtieri, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/marc-gualtieri_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-jacksonville-marc-gualtieri-md"
      },
      {
        "name": "David I. Hoffman, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/hoffman92425.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-jacksonville-david-i-hoffman-md"
      },
      {
        "name": "Luis Hoyos, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/hoyos-luis_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-jacksonville-luis-hoyos-md"
      },
      {
        "name": "Laurice Bou Nemer, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/bou-nemer-laurice_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-jacksonville-laurice-bou-nemer-md"
      },
      {
        "name": "Vanessa Weitzman, MD",
        "imageUrl": "https://ivfflorida.com/wp-content/uploads/2025/08/weitzman-vanessa_450x600.jpg",
        "_source": {
          "url": "https://www.ivfflorida.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-ivffl-jacksonville-vanessa-weitzman-md"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://ivfflorida.com/wp-content/uploads/2025/08/jacksonville.png",
        "type": "exterior",
        "caption": "IVF Florida Jacksonville fertility center",
        "_source": {
          "url": "https://ivfflorida.com/locations/jacksonville-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlcU4A0rgdPdRTtnv5BM4mkbMuqm2b5xDv0tuYf3mY7h7pumqJJizKynnMHWJ8PF72uXC6iZhxYdhOtp6ZK4PH6Q-XjCi_oxprdBghDKn1YiOSyoP7FXURjE9YG7R316ksh4ZPh4-J93bUO=w428-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/IVF+Florida+Reproductive+Associates+in+Jacksonville,+9084+R+G+Skinner+Pkwy,+Jacksonville,+FL+32256/@30.214687,-81.511529,3448a,13.1y/data=!4m2!3m1!1s0x88e5b5431cc943cf:0x7b5cc0b1f3e22a2e",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJz0PJHEO15YgRLiri87HAXHs"
    }
  },
  {
    "id": "org-ovation-newport-beach",
    "name": "Ovation Fertility Newport Beach",
    "description": "Ovation Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.ovationfertility.com/locations",
    "phone": "(949) 642-5954",
    "address": {
      "line1": "361 Hospital Rd, Suite 433",
      "city": "Newport Beach",
      "state": "CA",
      "zip": "92663",
      "country": "US"
    },
    "location": {
      "lat": 33.6282,
      "lng": -117.9295
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Ovation+Fertility+Newport+Beach,+361+Hospital+Rd+%23433,+Newport+Beach,+CA+92663/@33.6262376,-117.9294699,3322a,13.1y/data=!4m2!3m1!1s0x80dd20095e58c167:0x3ea22a8fb55554f9",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [],
    "externalIds": {
      "googlePlaceId": "ChIJZ8FYXgkg3YAR-VRVtY8qoj4"
    }
  },
  {
    "id": "org-ovation-fort-wayne",
    "name": "Midwest Fertility - Fort Wayne",
    "description": "Midwest Fertility Fort Wayne is an Axia/Ovation location offering fertility care, including IVF, IUI, egg freezing, donor programs, LGBTQIA+ family building, PGT and third-party reproduction.",
    "website": "https://www.midwestfertility.com/fort-wayne-fertility-center-location/",
    "phone": "(260) 490-3456",
    "address": {
      "line1": "7920 W. Jefferson Blvd, Suite 260",
      "city": "Fort Wayne",
      "state": "IN",
      "zip": "46804",
      "country": "US"
    },
    "location": {
      "lat": 41.0693,
      "lng": -85.2155
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "partially-enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.midwestfertility.com/fort-wayne-fertility-center-location/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.midwestfertility.com/fort-wayne-fertility-center-location/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://www.midwestfertility.com/fort-wayne-fertility-center-location/",
            "fetchedAt": "2026-06-13"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.midwestfertility.com/fort-wayne-fertility-center-location/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Midwest+Fertility+Specialists,+7920+W+Jefferson+Blvd+%23260,+Fort+Wayne,+IN+46804/@41.0411516,-85.2509129,3009a,13.1y/data=!4m2!3m1!1s0x8815e2aaea759e35:0x37f63f679bec617a",
            "fetchedAt": "2026-08-16"
          }
        },
        "pricing": {
          "status": "searched-absent",
          "source": {
            "url": "https://www.midwestfertility.com/fort-wayne-fertility-center-location/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "practitionerId": "pr-org-ovation-fort-wayne-bradford-bopp-md",
        "name": "Bradford Bopp, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.midwestfertility.com/wp-content/uploads/2023/10/boppsquare.jpg",
        "_source": {
          "url": "https://www.midwestfertility.com/indianapolis-fertility-clinic/bradford-bopp-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-ovation-fort-wayne-matthew-a-will-md",
        "name": "Matthew A. Will, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.midwestfertility.com/wp-content/uploads/2023/10/willsquare2.jpg",
        "_source": {
          "url": "https://www.midwestfertility.com/indianapolis-fertility-clinic/matthew-will-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-ovation-fort-wayne-erica-anspach-will-md",
        "name": "Erica Anspach Will, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.midwestfertility.com/wp-content/uploads/2023/10/ericasquare.jpg",
        "_source": {
          "url": "https://www.midwestfertility.com/indianapolis-fertility-clinic/erica-anspach-will-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-ovation-fort-wayne-kate-o-leary-md",
        "name": "Kate O'Leary, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.midwestfertility.com/wp-content/uploads/2023/10/olearysquare2.jpg",
        "_source": {
          "url": "https://www.midwestfertility.com/indianapolis-fertility-clinic/kate-oleary-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-ovation-fort-wayne-thomas-lorenc-md-facog",
        "name": "Thomas Lorenc, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.midwestfertility.com/wp-content/uploads/2024/10/lorencsquarewhitebckground.png",
        "_source": {
          "url": "https://www.midwestfertility.com/indianapolis-fertility-clinic/thomas-lorenc-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-ovation-fort-wayne-maria-antero-md",
        "name": "Maria Antero, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.midwestfertility.com/wp-content/uploads/2025/07/Untitled-1.png",
        "_source": {
          "url": "https://www.midwestfertility.com/indianapolis-fertility-clinic/maria-antero-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-ovation-fort-wayne-margaret-johns-pa-c",
        "name": "Margaret Johns, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "specialty": "Physician Assistant",
        "imageUrl": "https://www.midwestfertility.com/wp-content/uploads/2023/10/maggiesquare.jpg",
        "_source": {
          "url": "https://www.midwestfertility.com/indianapolis-fertility-clinic/margaret-johns-pa-c/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Indiana (IN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "externalIds": {
      "googlePlaceId": "ChIJNZ516qriFYgRemHsm2c_9jc"
    }
  },
  {
    "id": "org-ovation-florence",
    "name": "Institute for Reproductive Health - Florence",
    "description": "Institute for Reproductive Health provides fertility care in Greater Cincinnati, Florence, and Louisville, with IVF laboratory services through Ovation Fertility.",
    "website": "https://cincinnatifertility.com/contact-us/locations/",
    "phone": "(513) 924-5550",
    "address": {
      "line1": "6900 Houston Rd, Building 600, #15",
      "city": "Florence",
      "state": "KY",
      "zip": "41042",
      "country": "US"
    },
    "location": {
      "lat": 38.9893,
      "lng": -84.6438
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "partially-enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://cincinnatifertility.com/contact-us/locations/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://cincinnatifertility.com/contact-us/locations/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://cincinnatifertility.com/louisville-ky-location/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "scraped",
          "source": {
            "url": "https://cincinnatifertility.com/contact-us/locations/",
            "fetchedAt": "2026-06-13"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://cincinnatifertility.com/meet-our-team/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Institute+for+Reproductive+Health+%7C+Cincinnati+Fertility,+6900+Houston+Rd+Ste+15,+Florence,+KY+41042/@39.0086761,-84.6476637,3100a,13.1y/data=!4m2!3m1!1s0x8841c7b530f760db:0x201ac3dcd8a4ec97",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "practitionerId": "pr-org-ovation-florence-sherif-g-awadalla-md",
        "name": "Sherif G. Awadalla, MD",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://b3252928.smushcdn.com/3252928/wp-content/uploads/2022/12/Sherif-G-Awadalla-2022.png?lossy=0&strip=1&webp=1",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-ovation-florence-michael-d-scheiber-md",
        "name": "Michael D. Scheiber, MD",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://b3252928.smushcdn.com/3252928/wp-content/uploads/2022/12/Michael-Scheiber-2022.png?lossy=0&strip=1&webp=1",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-ovation-florence-thomas-burwinkel-md",
        "name": "Thomas Burwinkel, MD",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://b3252928.smushcdn.com/3252928/wp-content/uploads/2022/12/Thomas-Burwinkel-2022.png?lossy=0&strip=1&webp=1",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-ovation-florence-michael-g-awadalla-md",
        "name": "Michael G. Awadalla, MD",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://b3252928.smushcdn.com/3252928/wp-content/uploads/2022/12/Michael-Awadalla-2022.png?lossy=0&strip=1&webp=1",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmZ1-_MehpJUDHJJ6Uwp0I_vIU05Iy40_3AuADsjHRwuOb9_3dyx-A8WH60bVdqYiNTGp1K9IvixNYI2awpy1TWdFMTA45MSuWh3U3zdTO_Fda7zrocFpYqSuInPQdUJsd_2PPAlA=w516-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Institute+for+Reproductive+Health+%7C+Cincinnati+Fertility,+6900+Houston+Rd+Ste+15,+Florence,+KY+41042/@39.0086761,-84.6476637,3100a,13.1y/data=!4m2!3m1!1s0x8841c7b530f760db:0x201ac3dcd8a4ec97",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Kentucky (KY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJ22D3MLXHQYgRl-yk2NzDGiA"
    }
  },
  {
    "id": "org-ovation-louisville",
    "name": "Institute for Reproductive Health - Louisville",
    "description": "Institute for Reproductive Health Louisville is a full-service fertility center offering IVF, ICSI, donor egg, fertility preservation, tubal reversal, vasectomy reversal, surrogacy, and genetic testing support.",
    "website": "https://cincinnatifertility.com/louisville-ky-location/",
    "phone": "(513) 924-5550",
    "address": {
      "line1": "2401 Terra Crossing Blvd, Suite 325",
      "city": "Louisville",
      "state": "KY",
      "zip": "40245",
      "country": "US"
    },
    "location": {
      "lat": 38.232,
      "lng": -85.5267
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "partially-enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://cincinnatifertility.com/louisville-ky-location/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://cincinnatifertility.com/louisville-ky-location/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://cincinnatifertility.com/louisville-ky-location/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "scraped",
          "source": {
            "url": "https://cincinnatifertility.com/louisville-ky-location/",
            "fetchedAt": "2026-06-13"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://cincinnatifertility.com/meet-our-team/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Institute+for+Reproductive+Health,+2401+Terra+Crossing+Blvd+%23325,+Louisville,+KY+40245/@38.2738905,-85.4954744,3132a,13.1y/data=!4m2!3m1!1s0x8869995ada173761:0x6602b2e89edbdbdb",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "practitionerId": "pr-org-ovation-louisville-sherif-g-awadalla-md",
        "name": "Sherif G. Awadalla, MD",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://b3252928.smushcdn.com/3252928/wp-content/uploads/2022/12/Sherif-G-Awadalla-2022.png?lossy=0&strip=1&webp=1",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-ovation-louisville-michael-d-scheiber-md",
        "name": "Michael D. Scheiber, MD",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://b3252928.smushcdn.com/3252928/wp-content/uploads/2022/12/Michael-Scheiber-2022.png?lossy=0&strip=1&webp=1",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-ovation-louisville-thomas-burwinkel-md",
        "name": "Thomas Burwinkel, MD",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://b3252928.smushcdn.com/3252928/wp-content/uploads/2022/12/Thomas-Burwinkel-2022.png?lossy=0&strip=1&webp=1",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-ovation-louisville-michael-g-awadalla-md",
        "name": "Michael G. Awadalla, MD",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://b3252928.smushcdn.com/3252928/wp-content/uploads/2022/12/Michael-Awadalla-2022.png?lossy=0&strip=1&webp=1",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkZGS2ATRDp3UAkid94XCbRLJk42FTVye28X_FPo-tV3ujn3gWxwwnKyXecqKcF9wGgHjBhLgOuO1zF04fjIYL8Fd2jinyhk4AAQZI8yVoMXvwy02Z64Gjq4m0gB01_XBc904HN=w395-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Institute+for+Reproductive+Health,+2401+Terra+Crossing+Blvd+%23325,+Louisville,+KY+40245/@38.2738905,-85.4954744,3132a,13.1y/data=!4m2!3m1!1s0x8869995ada173761:0x6602b2e89edbdbdb",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Kentucky (KY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJYTcX2lqZaYgR29vbnuiyAmY"
    }
  },
  {
    "id": "org-ovation-lafayette",
    "name": "Fertility Answers - Lafayette",
    "description": "Fertility Answers Lafayette provides fertility testing, IUI, IVF, egg freezing, fertility surgery, male infertility care, and third-party reproduction services with an Ovation Fertility IVF lab partnership.",
    "website": "https://www.fertilityanswers.com/about-us/louisiana-fertility-centers/",
    "phone": "(337) 989-8795",
    "address": {
      "line1": "206 E Farrel Rd",
      "city": "Lafayette",
      "state": "LA",
      "zip": "70508",
      "country": "US"
    },
    "location": {
      "lat": 30.1520334,
      "lng": -92.0471395
    },
    "treatments": [
      {
        "name": "Fertility testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.fertilityanswers.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation induction",
        "category": "art",
        "_source": {
          "url": "https://www.fertilityanswers.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.fertilityanswers.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.fertilityanswers.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility surgery",
        "category": "surgical",
        "_source": {
          "url": "https://www.fertilityanswers.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.fertilityanswers.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility preservation before cancer treatment",
        "category": "preservation",
        "_source": {
          "url": "https://www.fertilityanswers.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg donation",
        "category": "art",
        "_source": {
          "url": "https://www.fertilityanswers.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Genetic testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.fertilityanswers.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Male infertility care",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.fertilityanswers.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "Ovation Fertility"
    },
    "_enrichment": {
      "status": "partially-enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.fertilityanswers.com/about-us/louisiana-fertility-centers/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.fertilityanswers.com/about-us/louisiana-fertility-centers/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilityanswers.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilityanswers.com/about-us/louisiana-fertility-centers/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilityanswers.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilityanswers.com/about-us/louisiana-fertility-centers/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Answers+Lafayette,+206+E+Farrel+Rd,+Lafayette,+LA+70508/@30.1522554,-92.0481526,3450a,13.1y/data=!4m2!3m1!1s0x86249df2e146ed39:0xc7a6b5c597083cc7",
            "fetchedAt": "2026-08-16"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "specialties": ["reproductive-endocrinology", "male-infertility"],
    "patientGroups": ["LGBTQIA+", "Single Parents"],
    "schedule": {
      "mon": {
        "open": "07:30",
        "close": "16:00"
      },
      "tue": {
        "open": "07:30",
        "close": "16:00"
      },
      "wed": {
        "open": "07:30",
        "close": "16:00"
      },
      "thu": {
        "open": "07:30",
        "close": "16:00"
      },
      "fri": {
        "open": "07:30",
        "close": "12:00"
      }
    },
    "team": [
      {
        "practitionerId": "pr-org-ovation-lafayette-john-m-storment-md",
        "name": "John M. Storment, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.fertilityanswers.com/wp-content/uploads/2024/01/storment-2024-gray-sm.png",
        "_source": {
          "url": "https://www.fertilityanswers.com/about-us/louisiana-fertility-centers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-ovation-lafayette-tolulope-bakare-md",
        "name": "Tolulope Bakare, MD",
        "role": "Reproductive Urologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Urology",
        "imageUrl": "https://www.fertilityanswers.com/wp-content/uploads/2023/10/Bakare-thumbnail-sq.jpg",
        "_source": {
          "url": "https://www.fertilityanswers.com/about-us/louisiana-fertility-centers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-ovation-lafayette-susan-conway-md",
        "name": "Susan Conway, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.fertilityanswers.com/wp-content/uploads/2016/04/FWHC-Dr-Susan-Conway1-scaled.jpg",
        "_source": {
          "url": "https://www.fertilityanswers.com/about-us/louisiana-fertility-centers/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Louisiana (LA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl7F904LOKdrMJWGBm3NmbnVWjgxSLrYRjcIPxiPDPRcdc8--0DDu4y8Awuf4o07Z2136MV9E6hJv4cEr2zGInmD5fbMXKa8Nt-_Djicr8hsrwl00UEKZp44WVFl69BfG6ZpqGBFw=w224-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Answers+Lafayette,+206+E+Farrel+Rd,+Lafayette,+LA+70508/@30.1522554,-92.0481526,3450a,13.1y/data=!4m2!3m1!1s0x86249df2e146ed39:0xc7a6b5c597083cc7",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "externalIds": {
      "googlePlaceId": "ChIJOe1G4fKdJIYRxzwIl8W1psc"
    }
  },
  {
    "id": "org-ovation-las-vegas",
    "name": "Ovation Fertility Las Vegas",
    "description": "Ovation Fertility Las Vegas is the on-site IVF and andrology laboratory partner for The Fertility Center of Las Vegas at the Durango Drive facility.",
    "website": "https://www.ovationfertility.com/locations",
    "phone": "(702) 558-4733",
    "address": {
      "line1": "5365 S Durango Dr, Suite 110",
      "city": "Las Vegas",
      "state": "NV",
      "zip": "89113",
      "country": "US"
    },
    "location": {
      "lat": 36.0962,
      "lng": -115.2793
    },
    "treatments": [
      {
        "name": "IVF laboratory services",
        "category": "art",
        "_source": {
          "url": "https://www.ovationfertility.com/newsroom/on-the-move-the-fertility-center-of-las-vegas-relocates-to-new-state-of-the-art-facility",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Andrology laboratory services",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.ovationfertility.com/newsroom/on-the-move-the-fertility-center-of-las-vegas-relocates-to-new-state-of-the-art-facility",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Preimplantation genetic testing support",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.ovationfertility.com/locations",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Embryo cryopreservation support",
        "category": "preservation",
        "_source": {
          "url": "https://www.ovationfertility.com/locations",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.ovationfertility.com/locations",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.ovationfertility.com/newsroom/on-the-move-the-fertility-center-of-las-vegas-relocates-to-new-state-of-the-art-facility",
            "fetchedAt": "2026-06-13"
          }
        },
        "team": {
          "status": "verified-none",
          "source": {
            "url": "https://www.ovationfertility.com/locations",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://www.ovationfertility.com/newsroom/on-the-move-the-fertility-center-of-las-vegas-relocates-to-new-state-of-the-art-facility",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Ovation+Fertility+Las+Vegas,+5365+S+Durango+Dr+%23110,+Las+Vegas,+NV+89113/@36.091586,-115.2795257,3224a,13.1y/data=!4m2!3m1!1s0x80c8bf84b569bf45:0x5ba75e0e892a9eac",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.ovationfertility.com/locations",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "verified"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [],
    "images": [
      {
        "url": "https://fertilitycenterlv.com/wp-content/uploads/2023/07/Exterior-Front-1-2048x1367.jpg",
        "type": "exterior",
        "caption": "Shared FCLV/Ovation Durango Drive facility exterior",
        "_source": {
          "url": "https://fertilitycenterlv.com/about-us/virtual-tour/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkxwz9Mi8JTwKKFrcvV4Ojx3Wn_AgcZUX5ZTxR2WSdxfjLUTaGRBd7b5Ip_3WvKfnfkzJQi9brfK3cjayF0BptpNT9ILcw-VC4dLthlGcwi35A14E8foQWF4maXhXMo9gK_rnm2=w442-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Ovation+Fertility+Las+Vegas,+5365+S+Durango+Dr+%23110,+Las+Vegas,+NV+89113/@36.091586,-115.2795257,3224a,13.1y/data=!4m2!3m1!1s0x80c8bf84b569bf45:0x5ba75e0e892a9eac",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Nevada (NV) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {
      "googlePlaceId": "ChIJRb9ptYS_yIARrJ4qiQ5ep1s"
    }
  },
  {
    "id": "org-ovation-cincinnati",
    "name": "Ovation Fertility Cincinnati",
    "description": "Ovation Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.ovationfertility.com/locations",
    "phone": "(513) 924-5550",
    "address": {
      "line1": "3805 Edwards Rd, Suite 455",
      "city": "Cincinnati",
      "state": "OH",
      "zip": "45209",
      "country": "US"
    },
    "location": {
      "lat": 39.154,
      "lng": -84.4326
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ovationfertility.com/locations",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Ovation+Fertility+Cincinnati,+3805+Edwards+Rd+Ste+455,+Cincinnati,+OH+45209/@39.1483153,-84.4439324,3094a,13.1y/data=!4m2!3m1!1s0x8841b3bee0a0f55d:0xcf5deb3f93ce7715",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Pradeep Warikoo, PhD, HCLD, ELD, CC (ABB)",
        "role": "Laboratory Director, Ovation Fertility Cincinnati",
        "credentials": ["PhD", "HCLD", "ELD", "CC (ABB)"],
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/6661b708a35ef750e78b50d2/c7cfbdba-1aec-4d1a-b00a-df7abd7c55aa/Pradeep-Warikoo-SQ-450x430.jpg",
        "_source": {
          "url": "https://www.ovationfertility.com/newsroom/ovation-fertility-welcomes-pradeep-warikoo-phd-hcld-eld-cc-abb-as-cincinnati-lab-director",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-cincinnati-pradeep-warikoo-phd-hcld-eld-cc-abb"
      },
      {
        "name": "Dr. Michael D. Scheiber, MD, MPH, FACOG",
        "role": "Reproductive Endocrinologist; Director of Reproductive Research; Director of the IVF Program",
        "credentials": ["MD", "MPH", "FACOG"],
        "imageUrl": "https://files.elfsightcdn.com/eafe4a4d-3436-495d-b748-5bdce62d911d/070f16d4-4771-4d30-b3c0-226f011dd9f6/scheiber-updated-circle.png",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-cincinnati-dr-michael-d-scheiber-md-mph-facog"
      },
      {
        "name": "Dr. Thomas Burwinkel, MD, FACOG",
        "role": "Reproductive Endocrinologist; Medical Director",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://files.elfsightcdn.com/eafe4a4d-3436-495d-b748-5bdce62d911d/3ab96804-48c6-4f52-b22c-20c5ac081373/burwinkel-updated-circle.png",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-cincinnati-dr-thomas-burwinkel-md-facog"
      },
      {
        "name": "Dr. Sherif G. Awadalla, MD, FABOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FABOG"],
        "imageUrl": "https://files.elfsightcdn.com/eafe4a4d-3436-495d-b748-5bdce62d911d/ba8e1ef8-73df-4384-8d17-038cda80726b/Sherif-G-Awadalla-2022.png",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-cincinnati-dr-sherif-g-awadalla-md-fabog"
      },
      {
        "name": "Dr. Isela Robertshaw, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://files.elfsightcdn.com/eafe4a4d-3436-495d-b748-5bdce62d911d/21b13f69-6993-4308-8204-f7e33d809389/robertshaw-updated-circle.png",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-cincinnati-dr-isela-robertshaw-md-facog"
      },
      {
        "name": "Dr. Vinita Alexander, MD, MSCI, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MSCI", "FACOG"],
        "imageUrl": "https://files.elfsightcdn.com/eafe4a4d-3436-495d-b748-5bdce62d911d/851e8c59-cba5-4559-9363-e293a273c49c/alexander-circle-2025.png",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-cincinnati-dr-vinita-alexander-md-msci-facog"
      },
      {
        "name": "Dr. Michael Awadalla, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://files.elfsightcdn.com/28780741-9490-4abf-82ec-100f7b99e126/0fb51d92-bf3d-4e80-97f8-32bbd2e3951c/Michael-Awadalla-2022.png",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-cincinnati-dr-michael-awadalla-md-facog"
      },
      {
        "name": "Dr. Marja King, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://files.elfsightcdn.com/eafe4a4d-3436-495d-b748-5bdce62d911d/b7b4e81d-ade4-47c9-824c-589c6caef7d1/m-king-2023.png",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-cincinnati-dr-marja-king-md-facog"
      },
      {
        "name": "Mercedes Fussnecker, MSN, CNP, WHNP-BC, C-RHI",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "CNP", "WHNP-BC", "C-RHI"],
        "imageUrl": "https://files.elfsightcdn.com/eafe4a4d-3436-495d-b748-5bdce62d911d/53adab46-3a80-4bcd-8b12-997e22c64c93/m-fussneker.png",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-cincinnati-mercedes-fussnecker-msn-cnp-whnp-bc-c-rhi"
      },
      {
        "name": "Nikki Meyer, MSN, FNP-C",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "FNP-C"],
        "imageUrl": "https://files.elfsightcdn.com/eafe4a4d-3436-495d-b748-5bdce62d911d/21e4dd10-23cc-4cfa-9d4a-ed1498f261c2/Nikki-Meyer-headshot.png",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-cincinnati-nikki-meyer-msn-fnp-c"
      },
      {
        "name": "Melissa Doepker, BSN, RNC-NIC, C-RHI",
        "role": "Charge Nurse",
        "credentials": ["BSN", "RNC-NIC", "C-RHI"],
        "imageUrl": "https://files.elfsightcdn.com/eafe4a4d-3436-495d-b748-5bdce62d911d/8a6ed6a0-fb18-4db0-b14b-d329cdfa7674/Melissa2.png",
        "_source": {
          "url": "https://cincinnatifertility.com/meet-our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-cincinnati-melissa-doepker-bsn-rnc-nic-c-rhi"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Ohio (OH) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [],
    "externalIds": {
      "googlePlaceId": "ChIJXfWg4L6zQYgRFXfOkz_rXc8"
    }
  },
  {
    "id": "org-ovation-montgomery",
    "name": "Ovation Fertility Montgomery",
    "description": "Ovation Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.ovationfertility.com/locations",
    "phone": "(513) 924-5550",
    "address": {
      "line1": "10506B Montgomery Rd, Suite 303",
      "city": "Montgomery",
      "state": "OH",
      "zip": "45242",
      "country": "US"
    },
    "location": {
      "lat": 39.2285,
      "lng": -84.3553
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ovationfertility.com/locations",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Pradeep Warikoo",
        "role": "Cincinnati Laboratory Director",
        "credentials": ["PhD", "HCLD", "ELD", "CC (ABB)"],
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/6661b708a35ef750e78b50d2/c7cfbdba-1aec-4d1a-b00a-df7abd7c55aa/Pradeep-Warikoo-SQ-450x430.jpg",
        "_source": {
          "url": "https://www.ovationfertility.com/newsroom/ovation-fertility-welcomes-pradeep-warikoo-phd-hcld-eld-cc-abb-as-cincinnati-lab-director",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-montgomery-pradeep-warikoo"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Ohio (OH) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-ovation-clarksville",
    "name": "Ovation Fertility Clarksville",
    "description": "Ovation Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.ovationfertility.com/locations",
    "phone": "(931) 920-2230",
    "address": {
      "line1": "787 Weatherly Dr, Suite 400",
      "city": "Clarksville",
      "state": "TN",
      "zip": "37043",
      "country": "US"
    },
    "location": {
      "lat": 36.58,
      "lng": -87.3162
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.nashvillefertility.com/about-us/find-a-tennessee-fertility-center/nashville-fertility-center-clarksville/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Kristin Van Heertum, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2021/06/Kristin-Van-Heertum-2021-SQ-768x722.jpg",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/fertility-specialists/kristin-van-heertum-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-clarksville-kristin-van-heertum-md"
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Tennessee (TN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-ovation-franklin",
    "name": "Ovation Fertility Franklin",
    "description": "Ovation Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.ovationfertility.com/locations",
    "phone": "(615) 321-4740",
    "address": {
      "line1": "4601 Carothers Pkwy, Suite 325",
      "city": "Franklin",
      "state": "TN",
      "zip": "37067",
      "country": "US"
    },
    "location": {
      "lat": 35.919,
      "lng": -86.8168
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.nashvillefertility.com/about-us/find-a-tennessee-fertility-center/nashville-fertility-center-franklin/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Abby C. Eblen",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2021/06/Abby-Eblen-2021-SQ--768x728.jpg",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/find-a-tennessee-fertility-center/nashville-fertility-center-franklin/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-franklin-abby-c-eblen"
      },
      {
        "name": "Kristin Van Heertum",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2021/06/Kristin-Van-Heertum-2021-SQ-768x722.jpg",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/find-a-tennessee-fertility-center/nashville-fertility-center-franklin/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-franklin-kristin-van-heertum"
      },
      {
        "name": "Meghan Smith",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2021/06/Meggie-Smith-2021-SQ-e1622567677634-768x753.jpg",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/find-a-tennessee-fertility-center/nashville-fertility-center-franklin/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-franklin-meghan-smith"
      },
      {
        "name": "Meredith Humphreys",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2024/01/NFCHumphreys_cropped-768x755.jpg",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/find-a-tennessee-fertility-center/nashville-fertility-center-franklin/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-franklin-meredith-humphreys"
      },
      {
        "name": "Colleen Miller",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2025/12/NFC_Colleen_Miller_600.png",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/find-a-tennessee-fertility-center/nashville-fertility-center-franklin/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-franklin-colleen-miller"
      }
    ],
    "images": [
      {
        "url": "https://www.nashvillefertility.com/wp-content/uploads/2024/10/franklin-tn-mast.webp",
        "type": "exterior",
        "caption": "Exterior of the building at 4601 Carothers Pkwy, Franklin, the location of Ovation Fertility Franklin and the Nashville Fertility Center Franklin office",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/find-a-tennessee-fertility-center/nashville-fertility-center-franklin/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Tennessee (TN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-ovation-murfreesboro",
    "name": "Ovation Fertility Murfreesboro",
    "description": "Ovation Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.ovationfertility.com/locations",
    "phone": "(615) 321-4740",
    "address": {
      "line1": "1725 Medical Center Pkwy, Suite 200",
      "city": "Murfreesboro",
      "state": "TN",
      "zip": "37129",
      "country": "US"
    },
    "location": {
      "lat": 35.8439,
      "lng": -86.3811
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.nashvillefertility.com/about-us/find-a-tennessee-fertility-center/nashville-fertility-center-murfreesboro/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Ovation+Fertility+Nashville+%E2%80%93+Andrology+Lab,+1725+Medical+Center+Pkwy+%23200,+Murfreesboro,+TN+37219/@35.8575669,-86.4242558,3234a,13.1y/data=!4m2!3m1!1s0x8863f7fc1b017e0d:0xf4cdf88582c62ddb",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Abby C. Eblen",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2021/06/Abby-Eblen-2021-SQ--768x728.jpg",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/fertility-specialists/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-murfreesboro-abby-c-eblen"
      },
      {
        "name": "Kristin Van Heertum",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2021/06/Kristin-Van-Heertum-2021-SQ-768x722.jpg",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/fertility-specialists/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-murfreesboro-kristin-van-heertum"
      },
      {
        "name": "Meghan Smith",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2021/06/Meggie-Smith-2021-SQ-e1622567677634-768x753.jpg",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/fertility-specialists/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-murfreesboro-meghan-smith"
      },
      {
        "name": "Meredith A. Humphreys",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2024/01/NFCHumphreys_cropped-768x755.jpg",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/fertility-specialists/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-murfreesboro-meredith-a-humphreys"
      },
      {
        "name": "Colleen Miller",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2025/12/NFC_Colleen_Miller_600.png",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/fertility-specialists/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-murfreesboro-colleen-miller"
      }
    ],
    "images": [
      {
        "url": "https://www.nashvillefertility.com/wp-content/uploads/2024/10/mast-int-murfreesboro-tn-location.webp",
        "type": "exterior",
        "caption": "Exterior of Gateway Medical Plaza at 1725 Medical Center Pkwy, the building housing the Murfreesboro fertility center location",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/find-a-tennessee-fertility-center/nashville-fertility-center-murfreesboro/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Tennessee (TN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "externalIds": {}
  },
  {
    "id": "org-ovation-nashville",
    "name": "Ovation Fertility Nashville",
    "description": "Ovation Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.ovationfertility.com/locations",
    "phone": "(615) 321-4740",
    "address": {
      "line1": "345 23rd Ave N, Suite 401",
      "city": "Nashville",
      "state": "TN",
      "zip": "37203",
      "country": "US"
    },
    "location": {
      "lat": 36.154,
      "lng": -86.807
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.nashvillefertility.com/about-us/ovation-nashville/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "team": [
      {
        "name": "Abby Eblen",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2021/06/Abby-Eblen-2021-SQ-.jpg",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/fertility-specialists/abby-eblen-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-nashville-abby-eblen"
      },
      {
        "name": "Kristin Van Heertum",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2021/06/Kristin-Van-Heertum-2021-SQ.jpg",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/fertility-specialists/kristin-van-heertum-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-nashville-kristin-van-heertum"
      },
      {
        "name": "Meghan (Meggie) Smith",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2021/06/Meggie-Smith-2021-SQ-e1622567677634.jpg",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/board-certified-fertility-specialists/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-nashville-meghan-meggie-smith"
      },
      {
        "name": "Meredith Humphreys",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2024/01/NFCHumphreys_cropped.jpg",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/board-certified-fertility-specialists/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-nashville-meredith-humphreys"
      },
      {
        "name": "Colleen Miller",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.nashvillefertility.com/wp-content/uploads/2025/12/NFC_Colleen_Miller.png",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/board-certified-fertility-specialists/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-ovation-nashville-colleen-miller"
      }
    ],
    "images": [
      {
        "url": "https://www.nashvillefertility.com/wp-content/uploads/2024/10/mast-int-nashville-fertility-center.webp",
        "type": "exterior",
        "caption": "Exterior of the TriStar Centennial Professional Plaza at 345 23rd Ave N, the building housing Ovation Fertility Nashville / Nashville Fertility Center (Suite 401).",
        "_source": {
          "url": "https://www.nashvillefertility.com/about-us/find-a-tennessee-fertility-center/nashville-fertility-center/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Tennessee (TN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-ovation-austin",
    "name": "Ovation Fertility Austin",
    "description": "Ovation Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.ovationfertility.com/locations",
    "phone": "(512) 451-0149",
    "address": {
      "line1": "6500 N Mopac, Bldg 3, Suite 3102",
      "city": "Austin",
      "state": "TX",
      "zip": "78731",
      "country": "US"
    },
    "location": {
      "lat": 30.3627,
      "lng": -97.7534
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Ovation+Fertility+Austin,+6500+N+Mopac+Expy+Bldg+3,+Suite+3102,+Austin,+TX+78731/@30.3458186,-97.7521074,3443a,13.1y/data=!4m2!3m1!1s0x8644cb02d907f651:0x9188792640d5892e",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [],
    "externalIds": {
      "googlePlaceId": "ChIJUfYH2QLLRIYRLonVQCZ5iJE"
    }
  },
  {
    "id": "org-ovation-south-austin",
    "name": "Ovation Fertility South Austin",
    "description": "Ovation Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.ovationfertility.com/locations",
    "phone": "(512) 451-0149",
    "address": {
      "line1": "5000 Davis Ln, Suite 100",
      "city": "Austin",
      "state": "TX",
      "zip": "78749",
      "country": "US"
    },
    "location": {
      "lat": 30.227,
      "lng": -97.854
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Ovation+Fertility+South+Austin+-+Andrology,+5000+Davis+Ln+%23100,+Austin,+TX+78749/@30.2071765,-97.859398,3448a,13.1y/data=!4m2!3m1!1s0x865b4bf0c36e80b3:0x9247890a693504f1",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [],
    "externalIds": {
      "googlePlaceId": "ChIJs4Buw_BLW4YR8QQ1aQqJR5I"
    }
  },
  {
    "id": "org-ovation-corpus-christi",
    "name": "Ovation Fertility Corpus Christi",
    "description": "Ovation Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.ovationfertility.com/locations",
    "phone": "(361) 993-2213",
    "address": {
      "line1": "6702 S Staples, Suite B",
      "city": "Corpus Christi",
      "state": "TX",
      "zip": "78413",
      "country": "US"
    },
    "location": {
      "lat": 27.7167,
      "lng": -97.383
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-ovation-fort-worth",
    "name": "Fort Worth Fertility",
    "description": "Ovation Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://fwivf.com",
    "phone": "(817) 348-8145",
    "address": {
      "line1": "1800 Mistletoe Blvd",
      "city": "Fort Worth",
      "state": "TX",
      "zip": "76104",
      "country": "US"
    },
    "location": {
      "lat": 32.7269,
      "lng": -97.3425
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "boutique",
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-ovation-new-braunfels",
    "name": "Ovation Fertility New Braunfels",
    "description": "Ovation Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.ovationfertility.com/locations",
    "phone": "(830) 620-5530",
    "address": {
      "line1": "705 Generations Dr, Suite 102",
      "city": "New Braunfels",
      "state": "TX",
      "zip": "78130",
      "country": "US"
    },
    "location": {
      "lat": 29.6938,
      "lng": -98.1118
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-ovation-round-rock",
    "name": "Ovation Fertility Round Rock",
    "description": "Ovation Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.ovationfertility.com/locations",
    "phone": "(512) 451-0149",
    "address": {
      "line1": "16040 Park Valley Dr, Bldg 1, Suite 201",
      "city": "Round Rock",
      "state": "TX",
      "zip": "78681",
      "country": "US"
    },
    "location": {
      "lat": 30.5481,
      "lng": -97.7025
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-ovation-san-antonio",
    "name": "Ovation Fertility San Antonio",
    "description": "Ovation Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.ovationfertility.com/locations",
    "phone": "(210) 692-0577",
    "address": {
      "line1": "18707 Hardy Oak Blvd, Suite 511",
      "city": "San Antonio",
      "state": "TX",
      "zip": "78258",
      "country": "US"
    },
    "location": {
      "lat": 29.5921,
      "lng": -98.5369
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Ovation+Fertility+San+Antonio,+18707+Hardy+Oak+Blvd+%23511,+San+Antonio,+TX+78258/@29.6163087,-98.4781457,3469a,13.1y/data=!4m2!3m1!1s0x865c620d56001165:0x3ee024428d047c3b",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "type": "fertility-clinic",
    "setting": "network-group",
    "_meta": {
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [],
    "externalIds": {
      "googlePlaceId": "ChIJZREAVg1iXIYRO3wEjUIk4D4"
    }
  },
  {
    "id": "org-ovation-colchester",
    "name": "Ovation Fertility Colchester",
    "description": "Ovation Fertility provides comprehensive fertility care including IVF, IUI, egg freezing, and genetic testing. Part of the US Fertility network.",
    "website": "https://www.ovationfertility.com/locations",
    "phone": "(802) 655-8888",
    "address": {
      "line1": "105 West View Rd, Suite 302",
      "city": "Colchester",
      "state": "VT",
      "zip": "05446",
      "country": "US"
    },
    "location": {
      "lat": 44.524,
      "lng": -73.1988
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana",
        "Oxford"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven", "WINFertility"]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "US Fertility"
    },
    "_enrichment": {
      "status": "partially-enriched",
      "source": "manual-us-fertility",
      "date": "2026-03-11",
      "sections": {
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.ovationfertility.com/locations",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://nrmvt.com/our-facilities",
            "fetchedAt": "2026-06-13"
          }
        },
        "team": {
          "status": "verified-none",
          "source": {
            "url": "https://www.ovationfertility.com/locations",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "type": "lab",
    "setting": "network-group",
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://nrmvt.com/client_media/crops/Default.5541c9a1.medical_bed_2.jpg",
        "type": "interior",
        "caption": "Shared NRM/Ovation Colchester clinical space.",
        "_source": {
          "url": "https://nrmvt.com/our-facilities",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Humana, Oxford",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Vermont (VT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-manual-wellnest-ogden",
    "externalIds": {
      "googlePlaceId": "ChIJcz4vJZwHU4cRzhmMyUj6Hc8"
    },
    "type": "fertility-clinic",
    "name": "Wellnest Fertility",
    "description": "Wellnest Fertility provides fertility diagnostics, IUI, IVF, egg freezing, embryo monitoring, outside monitoring, oncofertility, semen analysis, mental health support, and wellness resources in Ogden.",
    "website": "https://www.wellnestfertility.com/",
    "bookingUrl": "https://www.wellnestfertility.com",
    "address": {
      "line1": "1491 East Ridgeline Drive",
      "city": "South Ogden",
      "state": "UT",
      "zip": "84405",
      "country": "US"
    },
    "location": {
      "lat": 41.1541301,
      "lng": -111.9423849
    },
    "treatments": [
      {
        "name": "Fertility diagnostics",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.wellnestfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.wellnestfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.wellnestfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.wellnestfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Advanced embryo monitoring",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.wellnestfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Outside monitoring",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.wellnestfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Oncofertility",
        "category": "preservation",
        "_source": {
          "url": "https://www.wellnestfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Semen analysis",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.wellnestfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.wellnestfertility.com/insurance-coverage",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Select Health"
      ]
    },
    "pricing": {
      "packages": [
        {
          "name": "Welcome Call",
          "description": "15-minute conversation with a care team member to discuss fertility goals and learn about Wellnest's offerings",
          "price": 0,
          "currency": "USD"
        },
        {
          "name": "Fertility Clinician Consultation",
          "description": "For patients already diagnosed with infertility — book directly with our REI to get started",
          "price": 25000,
          "currency": "USD"
        },
        {
          "name": "Timed Intercourse",
          "price": 75000,
          "currency": "USD",
          "includes": [
            "Up to three ultrasounds",
            "Consultations with fertility specialists",
            "Oova hormone monitoring strips"
          ],
          "excludes": ["Medications"]
        },
        {
          "name": "IUI",
          "price": 125000,
          "currency": "USD",
          "includes": [
            "Up to three ultrasounds",
            "Bloodwork",
            "Oova hormone monitoring strips",
            "Sperm preparation",
            "Insemination"
          ],
          "excludes": ["Medications"]
        },
        {
          "name": "IVF",
          "price": 950000,
          "currency": "USD",
          "includes": [
            "Up to five ultrasounds",
            "Retrieval",
            "Sperm, egg, and embryo prep",
            "Insemination",
            "Three months of embryo cryopreservation"
          ],
          "excludes": [
            "Medications",
            "Egg and sperm freezing",
            "PGT",
            "Embryo transport",
            "Transfer"
          ]
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 350000,
          "currency": "USD",
          "includes": [
            "Up to three ultrasounds",
            "Consultations with fertility specialists",
            "Transfer of embryo",
            "Ultrasound guidance"
          ],
          "excludes": [
            "Medications",
            "Cryopreservation and biopsies of additional tissue"
          ]
        },
        {
          "name": "PGT",
          "description": "Preimplantation Genetic Testing",
          "price": 450000,
          "currency": "USD",
          "includes": [
            "Consultations with fertility specialists",
            "Biopsy of embryo blastomere"
          ],
          "excludes": ["Medications", "Anesthesia"]
        }
      ],
      "financingOptions": [
        {
          "name": "0% interest payment plans",
          "description": "0% interest payment plans"
        },
        {
          "name": "Military discount",
          "description": "15% discount on qualifying self-pay fertility treatments for active U.S. military and reservists",
          "details": ["Discounts apply to single-cycle fertility treatments"],
          "eligibility": "Active U.S. military or reservist status, verified with a U.S. military ID at the time of consultation. Must be uninsured, denied insurance coverage, or lacking benefits for treatment.",
          "exclusions": "Discounts do not cover consultations, diagnostic testing, external services, or medications.",
          "_source": {
            "url": "https://www.wellnestfertility.com/content/military-support-discounts",
            "fetchedAt": "2026-03-11"
          }
        },
        {
          "name": "Multiple insurance plans accepted",
          "description": "Multiple insurance plans accepted"
        }
      ],
      "_source": {
        "url": "https://www.wellnestfertility.com/pricing",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "isFirstConsultationFree": true,
    "_enrichment": {
      "status": "partially-enriched",
      "source": "manual-research",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.wellnestfertility.com/insurance-coverage",
            "fetchedAt": "2026-03-11"
          }
        },
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.wellnestfertility.com/locations",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.wellnestfertility.com/locations",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.wellnestfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.wellnestfertility.com/our-team",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://www.wellnestfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://www.wellnestfertility.com/locations",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Wellnest+Fertility,+1491+E+Ridgeline+Dr,+South+Ogden,+UT+84405/@41.1542015,-111.9403257,3004a,13.1y/data=!4m2!3m1!1s0x8753079c252f3e73:0xcf1dfa48c98c19ce",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "logoUrl": "https://cdn.prod.website-files.com/64ca0fdc63dd4e2f5e894c3d/64cb79fa95c17f53833c6570_wellnest_logolockup.svg",
    "images": [
      {
        "url": "https://cdn.prod.website-files.com/64ca0fdc63dd4e2f5e894c3d/67e331b8d6effe55a05dcd56_WellNest_2I5A5890_BLAKELY_D.webp",
        "type": "interior",
        "caption": "Wellnest Fertility clinic interior",
        "_source": {
          "url": "https://www.wellnestfertility.com/locations",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://cdn.prod.website-files.com/64ca0fdc63dd4e2f5e894c3d/67e16ea5f473ba599c2ca052_WellNest_2I5A5958_BLAKELY_D.webp",
        "type": "interior",
        "caption": "Wellnest Fertility treatment room",
        "_source": {
          "url": "https://www.wellnestfertility.com/locations",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://cdn.prod.website-files.com/64ca0fdc63dd4e2f5e894c3d/67e332be9c780c5b1eb1a225_Captura%20de%20tela%202025-03-25%20194757.png",
        "type": "interior",
        "caption": "Wellnest Fertility consultation area",
        "_source": {
          "url": "https://www.wellnestfertility.com/locations",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://cdn.prod.website-files.com/64ca0fdc63dd4e2f5e894c3d/67e33381254638686efc88e3_Captura%20de%20tela%202025-03-25%20195042.avif",
        "type": "interior",
        "caption": "Wellnest Fertility waiting area",
        "_source": {
          "url": "https://www.wellnestfertility.com/locations",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://cdn.prod.website-files.com/64ca0fdc63dd4e2f5e894c3d/67e336c017d3045a4ab2fbdd_Captura%20de%20tela%202025-03-25%20200506.avif",
        "type": "exterior",
        "caption": "Wellnest Fertility building exterior",
        "_source": {
          "url": "https://www.wellnestfertility.com/locations",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkoJpwy_k_M3SDXdjUG1nd_ceTIiSpkrwm0iX5PuL_0zese6_LXlsqUQgJHn7sp5pPjyvPR5-crfxdHl7s8j_PE60gUoamW3LXKtPEWVpdFluvxC46s8TRDTLa9a-h9wO5K7zGLt-IqvLjT=w530-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Wellnest+Fertility,+1491+E+Ridgeline+Dr,+South+Ogden,+UT+84405/@41.1542015,-111.9403257,3004a,13.1y/data=!4m2!3m1!1s0x8753079c252f3e73:0xcf1dfa48c98c19ce",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnyyU4FkUWs1pfisJmavdAdBOd3DHra8zwlWJUE1oVgITKPLLciJAbMXRyjszRbQ1v3JFPDhUo4G6M7ImHK0SjAnqaLMZym3NseSxSYzzB9gU4Rrm1OgJe-PQPI91U3kNEFAm6ew55wL_k=w224-h398-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Wellnest+Fertility,+1491+E+Ridgeline+Dr,+South+Ogden,+UT+84405/@41.1542015,-111.9403257,3004a,13.1y/data=!4m2!3m1!1s0x8753079c252f3e73:0xcf1dfa48c98c19ce",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "phone": "801-609-1442",
    "schedule": {
      "mon": {
        "open": "08:30",
        "close": "17:00"
      },
      "tue": {
        "open": "08:30",
        "close": "17:00"
      },
      "wed": {
        "open": "08:30",
        "close": "17:00"
      },
      "thu": {
        "open": "08:30",
        "close": "17:00"
      },
      "fri": {
        "open": "08:30",
        "close": "17:00"
      }
    },
    "setting": "boutique",
    "specialties": [
      "reproductive-endocrinology",
      "mental-health",
      "male-infertility"
    ],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "team": [
      {
        "practitionerId": "pr-org-manual-wellnest-ogden-sarah-bjorkman-md",
        "name": "Sarah Bjorkman, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn.prod.website-files.com/64ca0fdc63dd4e2f5e894c3d/689c8556109cf3fc526453de_1666560421998.jpg",
        "_source": {
          "url": "https://www.wellnestfertility.com/our-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-manual-wellnest-ogden-sarah-nelson-whnp-bc",
        "name": "Sarah Nelson, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["WHNP-BC"],
        "specialty": "Nurse Practitioner",
        "imageUrl": "https://cdn.prod.website-files.com/64ca0fdc63dd4e2f5e894c3d/66b3e02dccde70cabd6409d9_wellnest-fertility-clinic-sarah-nelson.avif",
        "_source": {
          "url": "https://www.wellnestfertility.com/our-team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-manual-wellnest-ogden-sunday-crider-phd-hcld-eld",
        "name": "Sunday Crider, PhD, HCLD/ELD",
        "role": "Laboratory Director",
        "credentials": ["PhD", "HCLD/ELD"],
        "specialty": "Laboratory Director",
        "imageUrl": "https://cdn.prod.website-files.com/64ca0fdc63dd4e2f5e894c3d/66ec31fb8b4fb08d1dcf3de6_wellnest-fertility-clinic-sunday-crider.avif",
        "_source": {
          "url": "https://www.wellnestfertility.com/our-team",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Select Health",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.wellnestfertility.com/insurance-coverage",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "7 public price package(s) and 3 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.wellnestfertility.com/pricing",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Utah (UT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-manual-oma-santa-barbara",
    "externalIds": {
      "googlePlaceId": "ChIJG794VJcV6YARjFMatToOKC8"
    },
    "type": "fertility-clinic",
    "name": "Empower Fertility - Santa Barbara",
    "description": "AI and robotics-powered fertility clinic using science-forward approach to reproductive care.",
    "website": "https://www.empowerfertilityclinic.com/",
    "bookingUrl": "https://omafertility.com",
    "address": {
      "line1": "427 W Pueblo St, Suite B",
      "city": "Santa Barbara",
      "state": "CA",
      "zip": "93105",
      "country": "US"
    },
    "location": {
      "lat": 34.4258,
      "lng": -119.7131
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://omafertility.com",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "source": "manual-research",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.empowerfertilityclinic.com/about-us-meet-the-team",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Empower+Fertility+Santa+Barbara,+427+W+Pueblo+St+2nd+Floor+Suite,+Ste+B%2FC,+Santa+Barbara,+CA+93105/@34.4284043,-119.7239159,3291a,13.1y/data=!4m2!3m1!1s0x80e915975478bf1b:0x2f280e3ab51a538c",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-manual-oma-santa-barbara-daniel-rychlik",
        "name": "Daniel Rychlik",
        "credentials": ["MD"],
        "role": "Medical Director & Leading Reproductive Endocrinologist",
        "specialty": "Reproductive Endocrinology & Infertility",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/6845f8ee670d6962aaf57fa2/4ba3e48c-4287-4f06-903b-12a2bb1c7c05/4357fave+.jpg",
        "_source": {
          "url": "https://www.empowerfertilityclinic.com/about-us-meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-manual-oma-santa-barbara-barry-behr",
        "name": "Barry Behr",
        "credentials": ["PhD"],
        "role": "Professor of Obstetrics and Gynecology",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/6845f8ee670d6962aaf57fa2/a9b8c7e3-3812-4b68-8f8f-a63a688103e3/Dr.+Barry+Behr.jpg",
        "_source": {
          "url": "https://www.empowerfertilityclinic.com/about-us-meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-manual-oma-santa-barbara-olesya-uzun",
        "name": "Olesya Uzun",
        "role": "IVF Coordinator & Sonographer, Empower Fertility",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/6845f8ee670d6962aaf57fa2/c0a033d8-390c-454a-9b2c-52057a6426dc/photo+4.jpg",
        "_source": {
          "url": "https://www.empowerfertilityclinic.com/about-us-meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-manual-oma-santa-barbara-alberto-buenrostro-lopez",
        "name": "Alberto Buenrostro Lopez",
        "role": "IVF Lab Supervisor & Senior Embryologist, Empower Fertility",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/6845f8ee670d6962aaf57fa2/7833a358-db8b-4f44-a99b-b18a36b491ce/photo+5.jpeg",
        "_source": {
          "url": "https://www.empowerfertilityclinic.com/about-us-meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-manual-oma-santa-barbara-elham-fazeli",
        "name": "Elham Fazeli",
        "role": "Embryologist, Empower Fertility",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/6845f8ee670d6962aaf57fa2/906603b5-5d6d-4e29-a054-9b2c0769b63d/photo+10.jpg",
        "_source": {
          "url": "https://www.empowerfertilityclinic.com/about-us-meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [
      {
        "url": "https://images.squarespace-cdn.com/content/v1/6845f8ee670d6962aaf57fa2/36dd7953-7a6a-4ca1-87f7-0b5e4ef3c79a/Lab.png",
        "type": "interior"
      },
      {
        "url": "https://images.squarespace-cdn.com/content/v1/6845f8ee670d6962aaf57fa2/1d980bc9-5e83-4f4c-89ac-b74551280760/lab+3.png",
        "type": "interior"
      },
      {
        "url": "https://images.squarespace-cdn.com/content/v1/6845f8ee670d6962aaf57fa2/a46dc3b0-afbe-468e-bdb7-d340744bcfee/IMG_0571-scaled.jpg",
        "type": "interior"
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmS50nOda6mwe6X9ci66ImOJNrQcWvC8slH3TIa5eEZIKQWkGeCKtmO0dlErrd076UHB_YJ7J1ArLAht8FHnN5aFqfdluZ31PaAaZLv5NSvrX73vSmRJFWk2urKaVxyP0Rp_-ZC_x4OoCGF=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Empower+Fertility+Santa+Barbara,+427+W+Pueblo+St+2nd+Floor+Suite,+Ste+B%2FC,+Santa+Barbara,+CA+93105/@34.4284043,-119.7239159,3291a,13.1y/data=!4m2!3m1!1s0x80e915975478bf1b:0x2f280e3ab51a538c",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkYU8ZMxBscxPUgujcq_SmZj9wgysM11LMFTfhBFYZbrrl7lj5dn7sGiJ4RUlVUbzW3pSMEKBfNJDCQc6rLL1t3Z_-45FBgGa3Vo8-6AhtqKjUCdYjf89707GOm795pk_lemNTa=w224-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Empower+Fertility+Santa+Barbara,+427+W+Pueblo+St+2nd+Floor+Suite,+Ste+B%2FC,+Santa+Barbara,+CA+93105/@34.4284043,-119.7239159,3291a,13.1y/data=!4m2!3m1!1s0x80e915975478bf1b:0x2f280e3ab51a538c",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://omafertility.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-manual-oma-nyc",
    "externalIds": {
      "googlePlaceId": "ChIJJ7QMyydZwokR5hpkkCE9XvM"
    },
    "type": "fertility-clinic",
    "name": "Pinnacle Fertility - Manhattan",
    "description": "AI and robotics-powered fertility clinic using science-forward approach to reproductive care.",
    "website": "https://omafertility.com",
    "bookingUrl": "https://omafertility.com",
    "address": {
      "line1": "551 Madison Ave, Suite 500",
      "city": "New York",
      "state": "NY",
      "zip": "10022",
      "country": "US"
    },
    "location": {
      "lat": 40.7614,
      "lng": -73.9725
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://omafertility.com",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "source": "manual-research",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/manhattan-ny/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Pinnacle+Fertility+New+York+-+Manhattan,+551+Madison+Ave+Ste+500,+New+York,+NY+10022/@40.7610454,-73.972956,3022a,13.1y/data=!4m2!3m1!1s0x89c25927cb0cb427:0xf35e3d2190641ae6",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "network": {
      "name": "Pinnacle Fertility"
    },
    "team": [
      {
        "name": "Guy Ringler, MD",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Guy-Ringler_CA-NY_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/manhattan-ny/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-manual-oma-nyc-guy-ringler-md"
      }
    ],
    "images": [
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/PIN_Manhattan4-1024x1024.jpg",
        "type": "interior",
        "caption": "Pinnacle Fertility Manhattan clinic",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/manhattan-ny/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlCL4ajnW7LVBPikCcATy8F7FoEpzViFnTg4ncFTmZAMB4y5NHtWs8ugWjHSOmNVJ0zYogn1HqrV-plcK6YXFxwJvm_ZDr_stB7fxMU4dXq4zMEBqCeOzYIPXhsqv7bLonyHmrFAnflKSYY=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Pinnacle+Fertility+New+York+-+Manhattan,+551+Madison+Ave+Ste+500,+New+York,+NY+10022/@40.7610454,-73.972956,3022a,13.1y/data=!4m2!3m1!1s0x89c25927cb0cb427:0xf35e3d2190641ae6",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm59rafntubti2C_TNrPDou_3HzE5BsvhEm0QvUU2Uf0wqWiuIy7ryIT-pFwwl-F-Xz0EDkb1_wYH9pwU5K5AW5WBuklqKvXbPLdPQdd-h8aGVq8vyquQz2QHvjCP0s0jA-R22YxN1LSss=w224-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Pinnacle+Fertility+New+York+-+Manhattan,+551+Madison+Ave+Ste+500,+New+York,+NY+10022/@40.7610454,-73.972956,3022a,13.1y/data=!4m2!3m1!1s0x89c25927cb0cb427:0xf35e3d2190641ae6",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://omafertility.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-manual-oma-atlanta",
    "externalIds": {
      "googlePlaceId": "ChIJsYBWz9cF9YgRVjlpjZ0lAds"
    },
    "type": "fertility-clinic",
    "name": "Pinnacle Fertility Georgia",
    "description": "AI and robotics-powered fertility clinic using science-forward approach to reproductive care.",
    "website": "https://www.pinnaclefertility.com/location/atlanta-ga/",
    "bookingUrl": "https://omafertility.com",
    "address": {
      "line1": "1801 Peachtree St NE",
      "city": "Atlanta",
      "state": "GA",
      "zip": "30309",
      "country": "US"
    },
    "location": {
      "lat": 33.8035139,
      "lng": -84.3932887
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://omafertility.com",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "source": "manual-research",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/atlanta-ga/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Pinnacle+Fertility+Georgia+-+Atlanta,+1801+Peachtree+Rd+NE+%23220,+Atlanta,+GA+30309/@33.8040156,-84.3929178,3315a,13.1y/data=!4m2!3m1!1s0x88f505d7cf5680b1:0xdb01259d8d693956",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "network": {
      "name": "Pinnacle Fertility"
    },
    "team": [
      {
        "name": "Paul Dudley, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Paul-Dudley_GA_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/atlanta-ga/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-manual-oma-atlanta-paul-dudley-md"
      }
    ],
    "images": [
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/2025-04-07-1024x576.jpg",
        "type": "interior",
        "caption": "Pinnacle Fertility Georgia laboratory interior",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/atlanta-ga/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/PIN-ATL2-1024x1024.jpg",
        "type": "interior",
        "caption": "Pinnacle Fertility Georgia clinic consultation space",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/atlanta-ga/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmdjII5FxoZwuY3GE42KaxGG3PSb5Kfgqu1qSlFrlDlvVjXMPaEPHAcLLXeq5GNJRyVVFkoWHvSq_pFl2W958VHS9xcEaFM-lBUFTrML9w9_zWZOgZ3tGtzgLD6PwFsD7xzZ7tbTtVCdoxK=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Pinnacle+Fertility+Georgia+-+Atlanta,+1801+Peachtree+Rd+NE+%23220,+Atlanta,+GA+30309/@33.8040156,-84.3929178,3315a,13.1y/data=!4m2!3m1!1s0x88f505d7cf5680b1:0xdb01259d8d693956",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://omafertility.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-kindbody-orlando",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Kindbody - Orlando",
    "description": "Kindbody's Orlando location offering comprehensive fertility services including IVF, egg freezing, and employer-sponsored fertility benefits.",
    "website": "https://kindbody.com",
    "bookingUrl": "https://kindbody.com",
    "address": {
      "line1": "Orlando",
      "city": "Orlando",
      "state": "FL",
      "zip": "32801",
      "country": "US"
    },
    "location": {
      "lat": 28.5383,
      "lng": -81.3792
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Anthem",
        "Blue Cross Blue Shield",
        "Cigna",
        "Emblem Health",
        "Empire Blue Cross Blue Shield",
        "First Health",
        "Health Net",
        "Horizon",
        "Humana",
        "Maven",
        "Medicare",
        "Medicaid",
        "MultiPlan",
        "Optum",
        "Oscar",
        "Oxford",
        "Progyny",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven"]
    },
    "pricing": {
      "packages": [
        {
          "name": "Pulse Assessment",
          "description": "Quick fertility check — not covered by insurance",
          "price": 9900,
          "currency": "USD",
          "includes": [
            "AMH blood test",
            "Transvaginal ultrasound for follicle count",
            "15-minute reproductive consultation"
          ],
          "notes": "Not covered by insurance"
        },
        {
          "name": "Fertility Consultation",
          "description": "Specialist consultation on fertility fundamentals",
          "price": 30000,
          "currency": "USD",
          "notes": "Billable to most insurance plans"
        },
        {
          "name": "Male Consultation + Semen Analysis",
          "price": 52500,
          "currency": "USD",
          "includes": ["Consultation", "Venipuncture", "Semen analysis"]
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Single egg freezing cycle",
          "price": 690000,
          "priceMax": 966000,
          "currency": "USD",
          "includes": [
            "Stimulation visits",
            "Ultrasounds",
            "Blood draws",
            "Retrieval",
            "Cryopreservation",
            "3 months storage",
            "Coordination"
          ],
          "excludes": ["Medications ($4,000 - $6,000)", "Anesthesia"]
        },
        {
          "name": "Annual Egg Storage",
          "price": 92000,
          "currency": "USD",
          "notes": "Per year"
        },
        {
          "name": "IVF Freeze All (Self Pay)",
          "description": "IVF cycle with all embryos frozen",
          "price": 1160000,
          "priceMax": 1850000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Cryopreservation",
            "3 months storage"
          ],
          "excludes": [
            "Medications (~$4,000 - $6,000)",
            "Embryo biopsy/genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Donor services",
            "Anesthesia"
          ]
        },
        {
          "name": "IVF Fresh Transfer (Self Pay)",
          "description": "IVF cycle with fresh embryo transfer",
          "price": 1380000,
          "priceMax": 1875000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$5,000 - $9,000)",
            "Genetic testing",
            "Surplus embryo storage",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Freeze All",
          "price": 910000,
          "priceMax": 1332000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Cryopreservation",
            "3-month storage"
          ],
          "excludes": [
            "Genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Fresh Transfer",
          "price": 990000,
          "priceMax": 1428000,
          "currency": "USD",
          "includes": [
            "Ultrasounds",
            "Thaw",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Surplus storage",
            "Frozen transfers",
            "Anesthesia"
          ]
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 400000,
          "priceMax": 550000,
          "currency": "USD",
          "includes": ["Ultrasounds", "Thaw", "Assisted hatching", "Transfer"],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "PGT Package",
          "description": "Preimplantation genetic testing",
          "price": 160000,
          "priceMax": 300000,
          "currency": "USD",
          "includes": ["Embryo biopsy", "Lab management"],
          "excludes": ["Storage", "Shipping", "Per-embryo testing costs"]
        },
        {
          "name": "Nutrition Coaching",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Counseling & Support",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Guided Meditation",
          "description": "Virtual wellness — 30-minute session",
          "price": 9000,
          "currency": "USD"
        }
      ],
      "financingOptions": [
        {
          "name": "PatientFi monthly payments",
          "description": "PatientFi monthly payments"
        }
      ],
      "disclaimer": "Prices vary by location. Medications and anesthesia are not included in procedure costs. 3 months of storage included with freeze procedures; annual storage is $920.",
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "source": "manual-research",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.kindbody.com/ivf-cost/",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "Kindbody"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Blue Cross Blue Shield, Cigna, Emblem Health, Empire Blue Cross Blue Shield, First Health, Health Net",
              "detail": "12 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "14 public price package(s) and 1 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-satellite-kindbody-princeton",
    "externalIds": {
      "googlePlaceId": "ChIJCbdWzm7nw4kRTfjh6szoNg4"
    },
    "type": "fertility-clinic",
    "name": "Kindbody - Princeton",
    "description": "Kindbody's Princeton location offering comprehensive fertility services including IVF, egg freezing, and employer-sponsored fertility benefits.",
    "website": "https://kindbody.com/location-princeton/",
    "phone": "(609) 632-1581",
    "bookingUrl": "https://kindbody.com/location-princeton/",
    "address": {
      "line1": "16 Chambers Street",
      "city": "Princeton",
      "state": "NJ",
      "zip": "08542",
      "country": "US"
    },
    "location": {
      "lat": 40.3491741,
      "lng": -74.6626208
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Anthem",
        "Blue Cross Blue Shield",
        "Cigna",
        "Emblem Health",
        "Empire Blue Cross Blue Shield",
        "First Health",
        "Health Net",
        "Horizon",
        "Humana",
        "Maven",
        "Medicare",
        "Medicaid",
        "MultiPlan",
        "Optum",
        "Oscar",
        "Oxford",
        "Progyny",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven"]
    },
    "pricing": {
      "packages": [
        {
          "name": "Pulse Assessment",
          "description": "Quick fertility check — not covered by insurance",
          "price": 9900,
          "currency": "USD",
          "includes": [
            "AMH blood test",
            "Transvaginal ultrasound for follicle count",
            "15-minute reproductive consultation"
          ],
          "notes": "Not covered by insurance"
        },
        {
          "name": "Fertility Consultation",
          "description": "Specialist consultation on fertility fundamentals",
          "price": 30000,
          "currency": "USD",
          "notes": "Billable to most insurance plans"
        },
        {
          "name": "Male Consultation + Semen Analysis",
          "price": 52500,
          "currency": "USD",
          "includes": ["Consultation", "Venipuncture", "Semen analysis"]
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Single egg freezing cycle",
          "price": 690000,
          "priceMax": 966000,
          "currency": "USD",
          "includes": [
            "Stimulation visits",
            "Ultrasounds",
            "Blood draws",
            "Retrieval",
            "Cryopreservation",
            "3 months storage",
            "Coordination"
          ],
          "excludes": ["Medications ($4,000 - $6,000)", "Anesthesia"]
        },
        {
          "name": "Annual Egg Storage",
          "price": 92000,
          "currency": "USD",
          "notes": "Per year"
        },
        {
          "name": "IVF Freeze All (Self Pay)",
          "description": "IVF cycle with all embryos frozen",
          "price": 1160000,
          "priceMax": 1850000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Cryopreservation",
            "3 months storage"
          ],
          "excludes": [
            "Medications (~$4,000 - $6,000)",
            "Embryo biopsy/genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Donor services",
            "Anesthesia"
          ]
        },
        {
          "name": "IVF Fresh Transfer (Self Pay)",
          "description": "IVF cycle with fresh embryo transfer",
          "price": 1380000,
          "priceMax": 1875000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$5,000 - $9,000)",
            "Genetic testing",
            "Surplus embryo storage",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Freeze All",
          "price": 910000,
          "priceMax": 1332000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Cryopreservation",
            "3-month storage"
          ],
          "excludes": [
            "Genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Fresh Transfer",
          "price": 990000,
          "priceMax": 1428000,
          "currency": "USD",
          "includes": [
            "Ultrasounds",
            "Thaw",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Surplus storage",
            "Frozen transfers",
            "Anesthesia"
          ]
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 400000,
          "priceMax": 550000,
          "currency": "USD",
          "includes": ["Ultrasounds", "Thaw", "Assisted hatching", "Transfer"],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "PGT Package",
          "description": "Preimplantation genetic testing",
          "price": 160000,
          "priceMax": 300000,
          "currency": "USD",
          "includes": ["Embryo biopsy", "Lab management"],
          "excludes": ["Storage", "Shipping", "Per-embryo testing costs"]
        },
        {
          "name": "Nutrition Coaching",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Counseling & Support",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Guided Meditation",
          "description": "Virtual wellness — 30-minute session",
          "price": 9000,
          "currency": "USD"
        }
      ],
      "financingOptions": [
        {
          "name": "PatientFi monthly payments",
          "description": "PatientFi monthly payments"
        }
      ],
      "disclaimer": "Prices vary by location. Medications and anesthesia are not included in procedure costs. 3 months of storage included with freeze procedures; annual storage is $920.",
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "source": "layer2-kindbody-current-address",
      "date": "2026-06-13",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.kindbody.com/ivf-cost/",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+Princeton,+16+Chambers+St,+Princeton,+NJ+08542/@40.3496337,-74.6630294,3041a,13.1y/data=!4m2!3m1!1s0x89c3e76ece56b709:0xe36e8cceae1f84d",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "Kindbody"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Blue Cross Blue Shield, Cigna, Emblem Health, Empire Blue Cross Blue Shield, First Health, Health Net",
              "detail": "12 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "14 public price package(s) and 1 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWllM9E1bj9VfaWNuwMTJCUNAKzlWIykOtje2B4MWFhdb-9sZBdbHA0Gm52crVzwzgcHLrUk2pk4foX0urEIWesNug6EEYFHe_K6MBpyt7zHe67-KEc4iDMsVMsVLl-_0yBatW0Yfw=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Princeton,+16+Chambers+St,+Princeton,+NJ+08542/@40.3496337,-74.6630294,3041a,13.1y/data=!4m2!3m1!1s0x89c3e76ece56b709:0xe36e8cceae1f84d",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnpl2iMw5sRfH0OxMTzPsMECr3_KcmfnrxYxlbN9y4EvryfS9p7YUvp78YRSNHqo4TAvn2PQPfeSYsGsu1m1BHYho4MyUxYK0SitzDURzxCcikBjYWXfR8FNy2v9paaMoZKi6k3=w224-h298-k-no-pi-20-ya7.0000157-ro-0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Princeton,+16+Chambers+St,+Princeton,+NJ+08542/@40.3496337,-74.6630294,3041a,13.1y/data=!4m2!3m1!1s0x89c3e76ece56b709:0xe36e8cceae1f84d",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-kindbody-glenview",
    "externalIds": {
      "googlePlaceId": "ChIJd_gw4AXHD4gRctk_6lP2Mk4"
    },
    "type": "fertility-clinic",
    "name": "Kindbody - Glenview",
    "description": "Kindbody's Glenview location offering comprehensive fertility services including IVF, egg freezing, and employer-sponsored fertility benefits.",
    "website": "https://kindbody.com/location/glenview-il/",
    "bookingUrl": "https://kindbody.com/location/glenview-il/",
    "address": {
      "line1": "2501 Compass Road, Suite 135",
      "city": "Glenview",
      "state": "IL",
      "zip": "60026",
      "country": "US"
    },
    "location": {
      "lat": 42.0987772,
      "lng": -87.8196312
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Anthem",
        "Blue Cross Blue Shield",
        "Cigna",
        "Emblem Health",
        "Empire Blue Cross Blue Shield",
        "First Health",
        "Health Net",
        "Horizon",
        "Humana",
        "Maven",
        "Medicare",
        "Medicaid",
        "MultiPlan",
        "Optum",
        "Oscar",
        "Oxford",
        "Progyny",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven"]
    },
    "pricing": {
      "packages": [
        {
          "name": "Pulse Assessment",
          "description": "Quick fertility check — not covered by insurance",
          "price": 9900,
          "currency": "USD",
          "includes": [
            "AMH blood test",
            "Transvaginal ultrasound for follicle count",
            "15-minute reproductive consultation"
          ],
          "notes": "Not covered by insurance"
        },
        {
          "name": "Fertility Consultation",
          "description": "Specialist consultation on fertility fundamentals",
          "price": 30000,
          "currency": "USD",
          "notes": "Billable to most insurance plans"
        },
        {
          "name": "Male Consultation + Semen Analysis",
          "price": 52500,
          "currency": "USD",
          "includes": ["Consultation", "Venipuncture", "Semen analysis"]
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Single egg freezing cycle",
          "price": 690000,
          "priceMax": 966000,
          "currency": "USD",
          "includes": [
            "Stimulation visits",
            "Ultrasounds",
            "Blood draws",
            "Retrieval",
            "Cryopreservation",
            "3 months storage",
            "Coordination"
          ],
          "excludes": ["Medications ($4,000 - $6,000)", "Anesthesia"]
        },
        {
          "name": "Annual Egg Storage",
          "price": 92000,
          "currency": "USD",
          "notes": "Per year"
        },
        {
          "name": "IVF Freeze All (Self Pay)",
          "description": "IVF cycle with all embryos frozen",
          "price": 1160000,
          "priceMax": 1850000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Cryopreservation",
            "3 months storage"
          ],
          "excludes": [
            "Medications (~$4,000 - $6,000)",
            "Embryo biopsy/genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Donor services",
            "Anesthesia"
          ]
        },
        {
          "name": "IVF Fresh Transfer (Self Pay)",
          "description": "IVF cycle with fresh embryo transfer",
          "price": 1380000,
          "priceMax": 1875000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$5,000 - $9,000)",
            "Genetic testing",
            "Surplus embryo storage",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Freeze All",
          "price": 910000,
          "priceMax": 1332000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Cryopreservation",
            "3-month storage"
          ],
          "excludes": [
            "Genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Fresh Transfer",
          "price": 990000,
          "priceMax": 1428000,
          "currency": "USD",
          "includes": [
            "Ultrasounds",
            "Thaw",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Surplus storage",
            "Frozen transfers",
            "Anesthesia"
          ]
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 400000,
          "priceMax": 550000,
          "currency": "USD",
          "includes": ["Ultrasounds", "Thaw", "Assisted hatching", "Transfer"],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "PGT Package",
          "description": "Preimplantation genetic testing",
          "price": 160000,
          "priceMax": 300000,
          "currency": "USD",
          "includes": ["Embryo biopsy", "Lab management"],
          "excludes": ["Storage", "Shipping", "Per-embryo testing costs"]
        },
        {
          "name": "Nutrition Coaching",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Counseling & Support",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Guided Meditation",
          "description": "Virtual wellness — 30-minute session",
          "price": 9000,
          "currency": "USD"
        }
      ],
      "financingOptions": [
        {
          "name": "PatientFi monthly payments",
          "description": "PatientFi monthly payments"
        }
      ],
      "disclaimer": "Prices vary by location. Medications and anesthesia are not included in procedure costs. 3 months of storage included with freeze procedures; annual storage is $920.",
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "source": "layer2-il-current-org-satellite-kindbody-glenview",
      "date": "2026-06-13",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.kindbody.com/ivf-cost/",
            "fetchedAt": "2026-03-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+Glenview,+2501+Compass+Rd+%23135,+Glenview,+IL+60026/@42.0981094,-87.8192976,2960a,13.1y/data=!4m2!3m1!1s0x880fc705e030f877:0x4e32f653ea3fd972",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "Kindbody"
    },
    "setting": "network-group",
    "phone": "(224) 404-2042",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Blue Cross Blue Shield, Cigna, Emblem Health, Empire Blue Cross Blue Shield, First Health, Health Net",
              "detail": "12 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "14 public price package(s) and 1 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-satellite-kindbody-milwaukee",
    "externalIds": {
      "googlePlaceId": "ChIJcTp_fIwEBYgRL0DBXCjTNz8"
    },
    "type": "fertility-clinic",
    "name": "Kindbody - Milwaukee",
    "description": "Kindbody's Milwaukee location offering comprehensive fertility services including IVF, egg freezing, and employer-sponsored fertility benefits.",
    "website": "https://kindbody.com/book-appointment-milwaukee/",
    "bookingUrl": "https://kindbody.com/scheduling/location-confirmed/service-type-select/milwaukee/",
    "address": {
      "line1": "787 N. Broadway",
      "city": "Milwaukee",
      "state": "WI",
      "zip": "53202",
      "country": "US"
    },
    "location": {
      "lat": 43.040991,
      "lng": -87.908274
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Anthem",
        "Blue Cross Blue Shield",
        "Cigna",
        "Emblem Health",
        "Empire Blue Cross Blue Shield",
        "First Health",
        "Health Net",
        "Horizon",
        "Humana",
        "Maven",
        "Medicare",
        "Medicaid",
        "MultiPlan",
        "Optum",
        "Oscar",
        "Oxford",
        "Progyny",
        "Tricare",
        "United Healthcare"
      ],
      "employeeBenefits": ["Progyny", "Carrot", "Maven"]
    },
    "pricing": {
      "packages": [
        {
          "name": "Pulse Assessment",
          "description": "Quick fertility check — not covered by insurance",
          "price": 9900,
          "currency": "USD",
          "includes": [
            "AMH blood test",
            "Transvaginal ultrasound for follicle count",
            "15-minute reproductive consultation"
          ],
          "notes": "Not covered by insurance"
        },
        {
          "name": "Fertility Consultation",
          "description": "Specialist consultation on fertility fundamentals",
          "price": 30000,
          "currency": "USD",
          "notes": "Billable to most insurance plans"
        },
        {
          "name": "Male Consultation + Semen Analysis",
          "price": 52500,
          "currency": "USD",
          "includes": ["Consultation", "Venipuncture", "Semen analysis"]
        },
        {
          "name": "Egg Freezing Cycle",
          "description": "Single egg freezing cycle",
          "price": 690000,
          "priceMax": 966000,
          "currency": "USD",
          "includes": [
            "Stimulation visits",
            "Ultrasounds",
            "Blood draws",
            "Retrieval",
            "Cryopreservation",
            "3 months storage",
            "Coordination"
          ],
          "excludes": ["Medications ($4,000 - $6,000)", "Anesthesia"]
        },
        {
          "name": "Annual Egg Storage",
          "price": 92000,
          "currency": "USD",
          "notes": "Per year"
        },
        {
          "name": "IVF Freeze All (Self Pay)",
          "description": "IVF cycle with all embryos frozen",
          "price": 1160000,
          "priceMax": 1850000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Cryopreservation",
            "3 months storage"
          ],
          "excludes": [
            "Medications (~$4,000 - $6,000)",
            "Embryo biopsy/genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Donor services",
            "Anesthesia"
          ]
        },
        {
          "name": "IVF Fresh Transfer (Self Pay)",
          "description": "IVF cycle with fresh embryo transfer",
          "price": 1380000,
          "priceMax": 1875000,
          "currency": "USD",
          "includes": [
            "Stimulation",
            "Ultrasounds",
            "Retrieval",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$5,000 - $9,000)",
            "Genetic testing",
            "Surplus embryo storage",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Freeze All",
          "price": 910000,
          "priceMax": 1332000,
          "currency": "USD",
          "includes": [
            "Thaw",
            "Fertilization",
            "Cryopreservation",
            "3-month storage"
          ],
          "excludes": [
            "Genetic testing",
            "Frozen transfers",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "Egg Thaw + Fertilization + Fresh Transfer",
          "price": 990000,
          "priceMax": 1428000,
          "currency": "USD",
          "includes": [
            "Ultrasounds",
            "Thaw",
            "Fertilization",
            "Assisted hatching",
            "Transfer"
          ],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Surplus storage",
            "Frozen transfers",
            "Anesthesia"
          ]
        },
        {
          "name": "Frozen Embryo Transfer",
          "price": 400000,
          "priceMax": 550000,
          "currency": "USD",
          "includes": ["Ultrasounds", "Thaw", "Assisted hatching", "Transfer"],
          "excludes": [
            "Medications (~$500 - $1,000)",
            "Genetic testing",
            "Diagnostics",
            "Anesthesia"
          ]
        },
        {
          "name": "PGT Package",
          "description": "Preimplantation genetic testing",
          "price": 160000,
          "priceMax": 300000,
          "currency": "USD",
          "includes": ["Embryo biopsy", "Lab management"],
          "excludes": ["Storage", "Shipping", "Per-embryo testing costs"]
        },
        {
          "name": "Nutrition Coaching",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Counseling & Support",
          "description": "Virtual wellness — 50-minute session",
          "price": 20000,
          "currency": "USD"
        },
        {
          "name": "Guided Meditation",
          "description": "Virtual wellness — 30-minute session",
          "price": 9000,
          "currency": "USD"
        }
      ],
      "financingOptions": [
        {
          "name": "PatientFi monthly payments",
          "description": "PatientFi monthly payments"
        }
      ],
      "disclaimer": "Prices vary by location. Medications and anesthesia are not included in procedure costs. 3 months of storage included with freeze procedures; annual storage is $920.",
      "_source": {
        "url": "https://www.kindbody.com/ivf-cost/",
        "fetchedAt": "2026-03-11"
      }
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "source": "manual-research",
      "date": "2026-03-11",
      "sections": {
        "insurance": {
          "status": "verified",
          "source": {
            "url": "https://www.kindbody.com/ivf-cost/",
            "fetchedAt": "2026-03-11"
          }
        },
        "identity": {
          "status": "missing"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/book-appointment-milwaukee/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/book-appointment-milwaukee/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+Milwaukee,+787+N+Broadway,+Milwaukee,+WI+53202/@43.0409915,-87.9082689,2916a,13.1y/data=!4m2!3m1!1s0x8805048c7c7f3a71:0x3f37d3285cc1402f",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "Kindbody"
    },
    "setting": "network-group",
    "phone": "(262) 518-7448",
    "team": [
      {
        "practitionerId": "pr-org-satellite-kindbody-milwaukee-ellen-hayes-md",
        "name": "Ellen Hayes, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://kindbody.com/wp-content/uploads/2022/05/Ellen-Hayes-Web-683x1024.jpg",
        "_source": {
          "url": "https://kindbody.com/book-appointment-milwaukee/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-kindbody-milwaukee-sonja-araoz-msn-aprn-fnp-bc",
        "name": "Sonja Araoz, MSN, APRN, FNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "APRN", "FNP-BC"],
        "specialty": "Fertility and Women's Health",
        "imageUrl": "https://kindbody.com/wp-content/uploads/2025/05/Sonja-Araoz-Web-683x1024.jpg",
        "_source": {
          "url": "https://kindbody.com/book-appointment-milwaukee/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-kindbody-milwaukee-cara-smarjesse-whnp",
        "name": "Cara Smarjesse, WHNP",
        "role": "Nurse Practitioner",
        "credentials": ["WHNP"],
        "specialty": "Fertility Preservation and Women's Health",
        "imageUrl": "https://kindbody.com/wp-content/uploads/2025/04/Cara-Smarjesse-web2-683x1024.jpg",
        "_source": {
          "url": "https://kindbody.com/book-appointment-milwaukee/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [
      {
        "url": "https://kindbody.com/wp-content/uploads/2024/07/KindbodyMKE-4232-scaled-e1720549529515-1031x1080.jpg",
        "type": "exterior",
        "caption": "Kindbody Milwaukee clinic exterior",
        "_source": {
          "url": "https://kindbody.com/book-appointment-milwaukee/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlhq_DMA6Y6_gsJHdxacSl2TnCeQqQC-zgLLrTYk_IHFdniTMj7xHNHUN_uoK7oGmmVy8aoL99fsaXSyHl5KnyqYgfutmzJpa5lleUoo2x-uLdulF1Z9_zlg52_502c6orxQpoJ=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Milwaukee,+787+N+Broadway,+Milwaukee,+WI+53202/@43.0409915,-87.9082689,2916a,13.1y/data=!4m2!3m1!1s0x8805048c7c7f3a71:0x3f37d3285cc1402f",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem, Blue Cross Blue Shield, Cigna, Emblem Health, Empire Blue Cross Blue Shield, First Health, Health Net",
              "detail": "12 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported pricing",
              "value": "14 public price package(s) and 1 financing option(s) are stored for this provider from public materials.",
              "_source": {
                "url": "https://www.kindbody.com/ivf-cost/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Wisconsin (WI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-mate-fresno",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Mate Fertility - Fresno",
    "description": "Mate Fertility's Fresno location offering modern fertility care in the Central Valley.",
    "website": "https://matefertility.com",
    "bookingUrl": "https://matefertility.com",
    "address": {
      "line1": "Fresno",
      "city": "Fresno",
      "state": "CA",
      "zip": "93721",
      "country": "US"
    },
    "location": {
      "lat": 36.7378,
      "lng": -119.7871
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://matefertility.com",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "source": "manual-research",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "Mate Fertility"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://matefertility.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-satellite-mate-slo",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Mate Fertility - San Luis Obispo",
    "description": "Mate Fertility's San Luis Obispo location offering modern fertility care on the Central Coast.",
    "website": "https://matefertility.com",
    "bookingUrl": "https://matefertility.com",
    "address": {
      "line1": "San Luis Obispo",
      "city": "San Luis Obispo",
      "state": "CA",
      "zip": "93401",
      "country": "US"
    },
    "location": {
      "lat": 35.2828,
      "lng": -120.6596
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://matefertility.com",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "source": "manual-research",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "Mate Fertility"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://matefertility.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-satellite-illume-stamford",
    "externalIds": {
      "googlePlaceId": "ChIJt_8qceyhwokRRe5V6CHtE2M"
    },
    "type": "fertility-clinic",
    "name": "Illume Fertility - Stamford",
    "description": "Illume Fertility's Stamford location offering comprehensive fertility and reproductive care in Fairfield County.",
    "website": "https://www.illumefertility.com/locations/stamford-ct",
    "bookingUrl": "https://www.illumefertility.com",
    "address": {
      "line1": "260 Long Ridge Road, Suite A, Entrance B",
      "city": "Stamford",
      "state": "CT",
      "zip": "06902",
      "country": "US"
    },
    "location": {
      "lat": 41.0534,
      "lng": -73.5387
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.illumefertility.com",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "source": "manual-research",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Illume+Fertility+-+Stamford,+CT,+260+Long+Ridge+Rd+Suite+A+(Entrance+B,+Stamford,+CT+06902/@41.0789833,-73.5549392,3008a,13.1y/data=!4m2!3m1!1s0x89c2a1ec712affb7:0x6313ed21e855ee45",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.illumefertility.com/locations/stamford-ct",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "Illume Fertility"
    },
    "setting": "network-group",
    "phone": "(203) 595-5455",
    "team": [
      {
        "practitionerId": "pr-org-satellite-illume-stamford-mark-p-leondires-md",
        "name": "Mark P. Leondires, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/Illume%20Fertility/In-House%20Image%20Library%20-%20Illume%20Fertility/Illume%20Team%20Headshots/Light%20Green%20Circle%20Headshots/MPL_circle_lightgreen.jpg?width=600&height=600&name=MPL_circle_lightgreen.jpg",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-illume-stamford-spencer-richlin-md",
        "name": "Spencer Richlin, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/Illume%20Fertility/In-House%20Image%20Library%20-%20Illume%20Fertility/Illume%20Team%20Headshots/Light%20Green%20Circle%20Headshots/SSR_circle_lightgreen.jpg?width=600&height=600&name=SSR_circle_lightgreen.jpg",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-illume-stamford-joshua-hurwitz-md",
        "name": "Joshua Hurwitz, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/Illume%20Fertility/In-House%20Image%20Library%20-%20Illume%20Fertility/Illume%20Team%20Headshots/Light%20Green%20Circle%20Headshots/JMH_circle_lightgreen.jpg?width=600&height=600&name=JMH_circle_lightgreen.jpg",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-illume-stamford-cynthia-murdock-md",
        "name": "Cynthia Murdock, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/Illume%20Fertility/In-House%20Image%20Library%20-%20Illume%20Fertility/Illume%20Team%20Headshots/Light%20Green%20Circle%20Headshots/CMM_circle_lightgreen.jpg?width=600&height=600&name=CMM_circle_lightgreen.jpg",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-illume-stamford-shaun-williams-md",
        "name": "Shaun Williams, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/Illume%20Fertility/In-House%20Image%20Library%20-%20Illume%20Fertility/Illume%20Team%20Headshots/Light%20Green%20Circle%20Headshots/SCW_circle_lightgreen.jpg?width=600&height=600&name=SCW_circle_lightgreen.jpg",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-illume-stamford-ilana-ressler-md",
        "name": "Ilana Ressler, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/Illume%20Fertility/In-House%20Image%20Library%20-%20Illume%20Fertility/Illume%20Team%20Headshots/Light%20Green%20Circle%20Headshots/IBR_circle_lightgreen.jpg?width=600&height=600&name=IBR_circle_lightgreen.jpg",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-illume-stamford-laura-meyer-md",
        "name": "Laura Meyer, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/Illume%20Fertility/In-House%20Image%20Library%20-%20Illume%20Fertility/Illume%20Team%20Headshots/Light%20Green%20Circle%20Headshots/LJM_circle_lightgreen.jpg?width=600&height=600&name=LJM_circle_lightgreen.jpg",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-illume-stamford-alexander-m-kucherov-md",
        "name": "Alexander M. Kucherov, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/Illume%20Fertility/In-House%20Image%20Library%20-%20Illume%20Fertility/Illume%20Team%20Headshots/Light%20Green%20Circle%20Headshots/AMK_circle_lightgreen.jpg?width=600&height=600&name=AMK_circle_lightgreen.jpg",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-illume-stamford-barry-r-witt-md",
        "name": "Barry R. Witt, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/DrWitt_whitebackground_circle.png?width=1200&height=1200&name=DrWitt_whitebackground_circle.png",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [
      {
        "url": "https://www.illumefertility.com/hs-fs/hubfs/Waiting%20Room_Stamford_JCG243.jpg?width=1200&height=846&name=Waiting%20Room_Stamford_JCG243.jpg",
        "type": "interior",
        "caption": "Illume Fertility Stamford waiting room",
        "_source": {
          "url": "https://www.illumefertility.com/locations/stamford-ct",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://www.illumefertility.com/hs-fs/hubfs/Waiting%20Room_Stamford_JCG240.jpg?width=6048&height=4024&name=Waiting%20Room_Stamford_JCG240.jpg",
        "type": "interior",
        "caption": "Illume Fertility Stamford reception area",
        "_source": {
          "url": "https://www.illumefertility.com/locations/stamford-ct",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlH2k0FAw1TV_WK0qL23FcfSMtLtBIKv69nq-NvhEXB9Md4g652ozixpiKb1qhK5uKRj72nbvAVL_pum7NgafocZG8T5BxUAjBtCqdq87ONguZ7Ge6kYIneQtcquhnx7hNO4A=w596-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Illume+Fertility+-+Stamford,+CT,+260+Long+Ridge+Rd+Suite+A+(Entrance+B,+Stamford,+CT+06902/@41.0789833,-73.5549392,3008a,13.1y/data=!4m2!3m1!1s0x89c2a1ec712affb7:0x6313ed21e855ee45",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.illumefertility.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Connecticut (CT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-illume-danbury",
    "externalIds": {
      "googlePlaceId": "ChIJdXucqjH_54kRoIDtKskXgw4"
    },
    "type": "fertility-clinic",
    "name": "Illume Fertility - Danbury",
    "description": "Illume Fertility's Danbury location offering comprehensive fertility and reproductive care in Western Connecticut.",
    "website": "https://www.illumefertility.com/locations/danbury-ct",
    "bookingUrl": "https://www.illumefertility.com",
    "address": {
      "line1": "103 Newtown Rd, Suite 1A",
      "city": "Danbury",
      "state": "CT",
      "zip": "06810",
      "country": "US"
    },
    "location": {
      "lat": 41.4015,
      "lng": -73.454
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.illumefertility.com",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "source": "manual-research",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Illume+Fertility+-+Danbury,+CT,+103+Newtown+Rd+%231a,+Danbury,+CT+06810/@41.4129541,-73.4077798,2992a,13.1y/data=!4m2!3m1!1s0x89e7ff31aa9c7b75:0xe8317c92aed80a0",
            "fetchedAt": "2026-08-16"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.illumefertility.com/locations/danbury-ct",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "Illume Fertility"
    },
    "setting": "network-group",
    "phone": "(203) 731-2520",
    "team": [
      {
        "practitionerId": "pr-org-satellite-illume-danbury-mark-p-leondires-md",
        "name": "Mark P. Leondires, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/Illume%20Fertility/In-House%20Image%20Library%20-%20Illume%20Fertility/Illume%20Team%20Headshots/Light%20Green%20Circle%20Headshots/MPL_circle_lightgreen.jpg?width=600&height=600&name=MPL_circle_lightgreen.jpg",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-illume-danbury-spencer-richlin-md",
        "name": "Spencer Richlin, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/Illume%20Fertility/In-House%20Image%20Library%20-%20Illume%20Fertility/Illume%20Team%20Headshots/Light%20Green%20Circle%20Headshots/SSR_circle_lightgreen.jpg?width=600&height=600&name=SSR_circle_lightgreen.jpg",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-illume-danbury-joshua-hurwitz-md",
        "name": "Joshua Hurwitz, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/Illume%20Fertility/In-House%20Image%20Library%20-%20Illume%20Fertility/Illume%20Team%20Headshots/Light%20Green%20Circle%20Headshots/JMH_circle_lightgreen.jpg?width=600&height=600&name=JMH_circle_lightgreen.jpg",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-illume-danbury-cynthia-murdock-md",
        "name": "Cynthia Murdock, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/Illume%20Fertility/In-House%20Image%20Library%20-%20Illume%20Fertility/Illume%20Team%20Headshots/Light%20Green%20Circle%20Headshots/CMM_circle_lightgreen.jpg?width=600&height=600&name=CMM_circle_lightgreen.jpg",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-illume-danbury-shaun-williams-md",
        "name": "Shaun Williams, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/Illume%20Fertility/In-House%20Image%20Library%20-%20Illume%20Fertility/Illume%20Team%20Headshots/Light%20Green%20Circle%20Headshots/SCW_circle_lightgreen.jpg?width=600&height=600&name=SCW_circle_lightgreen.jpg",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-illume-danbury-ilana-ressler-md",
        "name": "Ilana Ressler, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/Illume%20Fertility/In-House%20Image%20Library%20-%20Illume%20Fertility/Illume%20Team%20Headshots/Light%20Green%20Circle%20Headshots/IBR_circle_lightgreen.jpg?width=600&height=600&name=IBR_circle_lightgreen.jpg",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-illume-danbury-laura-meyer-md",
        "name": "Laura Meyer, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/Illume%20Fertility/In-House%20Image%20Library%20-%20Illume%20Fertility/Illume%20Team%20Headshots/Light%20Green%20Circle%20Headshots/LJM_circle_lightgreen.jpg?width=600&height=600&name=LJM_circle_lightgreen.jpg",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-illume-danbury-alexander-m-kucherov-md",
        "name": "Alexander M. Kucherov, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/Illume%20Fertility/In-House%20Image%20Library%20-%20Illume%20Fertility/Illume%20Team%20Headshots/Light%20Green%20Circle%20Headshots/AMK_circle_lightgreen.jpg?width=600&height=600&name=AMK_circle_lightgreen.jpg",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-illume-danbury-barry-r-witt-md",
        "name": "Barry R. Witt, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.illumefertility.com/hs-fs/hubfs/DrWitt_whitebackground_circle.png?width=1200&height=1200&name=DrWitt_whitebackground_circle.png",
        "_source": {
          "url": "https://www.illumefertility.com/fertility-blog/meet-our-doctors",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [
      {
        "url": "https://www.illumefertility.com/hs-fs/hubfs/Waiting%20Room_Danbury_JCG189.jpg?width=1600&height=1064&name=Waiting%20Room_Danbury_JCG189.jpg",
        "type": "interior",
        "caption": "Illume Fertility Danbury waiting room",
        "_source": {
          "url": "https://www.illumefertility.com/locations/danbury-ct",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://www.illumefertility.com/hs-fs/hubfs/Waiting%20Room_Danbury_JCG203.jpg?width=1200&height=1232&name=Waiting%20Room_Danbury_JCG203.jpg",
        "type": "interior",
        "caption": "Illume Fertility Danbury reception area",
        "_source": {
          "url": "https://www.illumefertility.com/locations/danbury-ct",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlS5YRxsOUBjiH4pTdK5OYKVB3fCi9fgUTTsurknuqCCjJmFbcqOQqm5CWWDPI_rHvi86AB32pj8dpJF-jQLyogEyrGTtu7Lqg3wrgvO299faI-lAcfEKYH2FoGV8SIAzPcQ-JW=w596-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Illume+Fertility+-+Danbury,+CT,+103+Newtown+Rd+%231a,+Danbury,+CT+06810/@41.4129541,-73.4077798,2992a,13.1y/data=!4m2!3m1!1s0x89e7ff31aa9c7b75:0xe8317c92aed80a0",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.illumefertility.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Connecticut (CT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-illume-harrison",
    "externalIds": {
      "googlePlaceId": "ChIJwWoDQXqRwokRyrQ9I6ovxGI"
    },
    "type": "fertility-clinic",
    "name": "Illume Fertility - Harrison",
    "description": "Illume Fertility's Harrison location offering comprehensive fertility and reproductive care in Westchester County.",
    "website": "https://www.illumefertility.com",
    "bookingUrl": "https://www.illumefertility.com",
    "address": {
      "line1": "Harrison",
      "city": "Harrison",
      "state": "NY",
      "zip": "10528",
      "country": "US"
    },
    "location": {
      "lat": 40.9712,
      "lng": -73.7126
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://www.illumefertility.com",
        "fetchedAt": "2026-03-11"
      },
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "consultationTypes": ["in-person", "telehealth"],
    "_enrichment": {
      "status": "enriched",
      "source": "manual-research",
      "date": "2026-03-11",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Illume+Fertility+-+Harrison,+NY,+440+Mamaroneck+Ave+Ste+501,+Harrison,+NY+10528/@40.9713444,-73.741442,3012a,13.1y/data=!4m2!3m1!1s0x89c2917a41036ac1:0x62c42faa233db4ca",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "Illume Fertility"
    },
    "setting": "network-group",
    "images": [
      {
        "url": "https://www.illumefertility.com/hs-fs/hubfs/Consultation_Harrison_JCG94-2.jpg?width=1200&height=798&name=Consultation_Harrison_JCG94-2.jpg",
        "type": "interior",
        "caption": "Illume Fertility Harrison consultation room",
        "_source": {
          "url": "https://www.illumefertility.com/locations/harrison-ny",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.illumefertility.com/hs-fs/hubfs/Waiting%20Room_Harrison_location.jpg?width=1200&height=798&name=Waiting%20Room_Harrison_location.jpg",
        "type": "interior",
        "caption": "Illume Fertility Harrison waiting room",
        "_source": {
          "url": "https://www.illumefertility.com/locations/harrison-ny",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWna4JcLfZHAjo0jdl914-goaHbMk6sfMg1qynBlwjkl0z_HnqJpP0Asasq7dwvQA56_WwHkGbrudGdmt2rte7rYpGOM5ijK0EKWSNH0CjKVAerXPzAeCQ7PMjMxNqVG1-Cxx4s=w596-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Illume+Fertility+-+Harrison,+NY,+440+Mamaroneck+Ave+Ste+501,+Harrison,+NY+10528/@40.9713444,-73.741442,3012a,13.1y/data=!4m2!3m1!1s0x89c2917a41036ac1:0x62c42faa233db4ca",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlteJmKlUWj65hFLxQ0XK2xKfocyaJ1VsMPL6ZBbWov_ZI3h5DVXf7uecWPE4jgdvQ-yCI38sAspMw0eVmUs3N9L3xcTO3J0Uw1JPdH4Nl6B6RwJ05Pe50j9WgSKGXQWfczSqlr8A=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Illume+Fertility+-+Harrison,+NY,+440+Mamaroneck+Ave+Ste+501,+Harrison,+NY+10528/@40.9713444,-73.741442,3012a,13.1y/data=!4m2!3m1!1s0x89c2917a41036ac1:0x62c42faa233db4ca",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.illumefertility.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-pozitivf-houston",
    "externalIds": {
      "googlePlaceId": "ChIJuZkTXaDBQIYR6JtPIQ_piVw"
    },
    "type": "fertility-clinic",
    "name": "Pozitivf Fertility - Houston",
    "website": "https://www.pozitivf.com",
    "phone": "(833) 723-2229",
    "logoUrl": "https://pozitivf.com/wp-content/uploads/2024/11/Header-Logo.png",
    "address": {
      "line1": "7400 Fannin Street, Suite 1000",
      "city": "Houston",
      "state": "TX",
      "zip": "77054",
      "country": "US"
    },
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "16:00"
      },
      "tue": {
        "open": "08:00",
        "close": "16:00"
      },
      "wed": {
        "open": "08:00",
        "close": "16:00"
      },
      "thu": {
        "open": "08:00",
        "close": "16:00"
      },
      "fri": {
        "open": "08:00",
        "close": "16:00"
      },
      "sat": null,
      "sun": null
    },
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "network": {
      "name": "Pozitivf Fertility"
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWndlkghsqKngl8WOpw56VhVyCMiboCzz4podzrCLCO2Kk0Cl2FUd96yd4uiHZwVsIdPAqBt4DQVnqTPp90I9i87mliAQ4j_H74rHcCKUb3jFIbk2DCB7LBSgBx0cPOE5UsiudkdaA=w408-h544-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Pozitivf+Fertility,+7400+Fannin+St+Ste+1000,+Houston,+TX+77054/@29.6944242,-95.4010315,3466a,13.1y/data=!4m2!3m1!1s0x8640c1a05d1399b9:0x5c89e90f214f9be8",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_enrichment": {
      "status": "enriched",
      "source": "manual-research",
      "date": "2026-03-11",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://pozitivf.com/dr-francisco-arredondo/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Pozitivf+Fertility,+7400+Fannin+St+Ste+1000,+Houston,+TX+77054/@29.6944242,-95.4010315,3466a,13.1y/data=!4m2!3m1!1s0x8640c1a05d1399b9:0x5c89e90f214f9be8",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "network-group",
    "team": [
      {
        "name": "Francisco Arredondo, MD",
        "imageUrl": "https://pozitivf.com/wp-content/uploads/2025/02/DrPaco.png",
        "_source": {
          "url": "https://pozitivf.com/dr-francisco-arredondo/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-satellite-pozitivf-houston-francisco-arredondo-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-hrc-beverly-hills",
    "externalIds": {
      "googlePlaceId": "ChIJWS3UYvu5woARnQKlXKNpRdo"
    },
    "type": "fertility-clinic",
    "name": "HRC Fertility - Beverly Hills",
    "website": "https://www.havingbabies.com/locations/beverly-hills/",
    "phone": "(310) 943-5820",
    "address": {
      "line1": "9777 Wilshire Blvd, Suite 600",
      "city": "Beverly Hills",
      "state": "CA",
      "zip": "90212",
      "country": "US"
    },
    "consultationTypes": ["in-person", "telehealth"],
    "languages": ["English", "Spanish"],
    "insurance": {
      "accepted": true,
      "financingOptions": [
        "Payment plans",
        "Loans",
        "Package pricing",
        "CapexMD",
        "Future Family",
        "PatientFi"
      ],
      "carriers": [
        "Aetna",
        "Anthem Blue Cross",
        "Blue Cross",
        "Blue Shield of California",
        "Cigna Healthcare",
        "United Healthcare",
        "Humana",
        "Health Net",
        "Kaiser Permanente",
        "Multiplan",
        "Tricare",
        "Optum"
      ],
      "employeeBenefits": [
        "Progyny",
        "Carrot",
        "Maven",
        "WINFertility",
        "Future Family"
      ],
      "_source": {
        "url": "https://www.havingbabies.com/locations/pasadena/",
        "fetchedAt": "2026-03-11"
      }
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "network": {
      "name": "HRC Fertility"
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/locations/beverly-hills/",
            "fetchedAt": "2026-03-11"
          }
        },
        "insurance": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/locations/beverly-hills/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/HRC+Fertility,+9777+Wilshire+Blvd+Ste+600,+Beverly+Hills,+CA+90212/@34.0675267,-118.4083233,3305a,13.1y/data=!4m2!3m1!1s0x80c2b9fb62d42d59:0xda4569a35ca5029d",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-satellite-hrc-beverly-hills-shahin-ghadir",
        "name": "Shahin Ghadir",
        "credentials": ["MD", "FACOG"],
        "role": "Board Certified Reproductive Endocrinologist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/07/Dr-Ghadir-2024-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/beverly-hills/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-hrc-beverly-hills-sahar-wertheimer",
        "name": "Sahar Wertheimer",
        "credentials": ["MD"],
        "role": "Board Certified Reproductive Endocrinologist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/07/Dr-Sahar-2024-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/beverly-hills/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-hrc-beverly-hills-robert-boostanfar",
        "name": "Robert Boostanfar",
        "credentials": ["MD", "FACOG"],
        "role": "Board Certified Reproductive Endocrinologist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/07/Dr-Boostanfar-2024-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/beverly-hills/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-hrc-beverly-hills-rachel-mandelbaum",
        "name": "Rachel Mandelbaum",
        "credentials": ["MD", "FACOG"],
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/07/Dr-Mandelbaum-2024-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/beverly-hills/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-hrc-beverly-hills-katherine-vanhise",
        "name": "Katherine VanHise",
        "credentials": ["MD"],
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2025/02/Dr-VanHise-Headshot-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/beverly-hills/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [
      {
        "url": "https://havingbabies.com/wp-content/uploads/2024/04/HRC-Beverly-Hills-9777-Wilshire-Blvd.jpg",
        "type": "exterior"
      }
    ],
    "description": "HRC Fertility's Beverly Hills clinic is located in the heart of Los Angeles County and offers comprehensive fertility testing, treatments, and monitoring. One of HRC Fertility's newest locations, it serves the greater Beverly Hills community with care from physicians Robert Boostanfar, Shahin Ghadir, Rachel Mandelbaum, Katherine VanHise, and Sahar Wertheimer.",
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross, Blue Cross, Blue Shield of California, Cigna Healthcare, United Healthcare, Humana, Health Net",
              "detail": "4 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.havingbabies.com/locations/pasadena/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-hrc-westlake-village",
    "externalIds": {
      "googlePlaceId": "ChIJ5SSv4_Ik6IARZxaLG-LQsqE"
    },
    "type": "fertility-clinic",
    "name": "HRC Fertility - Westlake Village",
    "website": "https://www.havingbabies.com/locations/westlake-village/",
    "phone": "(866) 472-4483",
    "address": {
      "line1": "1220 La Venta Dr, Suite 103",
      "city": "Westlake Village",
      "state": "CA",
      "zip": "91361",
      "country": "US"
    },
    "consultationTypes": ["in-person", "telehealth"],
    "languages": ["English", "Spanish"],
    "insurance": {
      "accepted": true,
      "financingOptions": [
        "Payment plans",
        "Loans",
        "Package pricing",
        "CapexMD",
        "Future Family",
        "PatientFi"
      ],
      "carriers": [
        "Aetna",
        "Anthem Blue Cross",
        "Blue Cross",
        "Blue Shield of California",
        "Cigna Healthcare",
        "United Healthcare",
        "Humana",
        "Health Net",
        "Kaiser Permanente",
        "Multiplan",
        "Tricare",
        "Optum"
      ],
      "employeeBenefits": [
        "Progyny",
        "Carrot",
        "Maven",
        "WINFertility",
        "Future Family"
      ],
      "_source": {
        "url": "https://www.havingbabies.com/locations/pasadena/",
        "fetchedAt": "2026-03-11"
      }
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      }
    ],
    "network": {
      "name": "HRC Fertility"
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/locations/westlake-village/",
            "fetchedAt": "2026-03-11"
          }
        },
        "insurance": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/locations/westlake-village/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/HRC+Fertility,+1220+La+Venta+Dr+%23103,+Westlake+Village,+CA+91361/@34.1489204,-118.8222601,3302a,13.1y/data=!4m2!3m1!1s0x80e824f2e3af24e5:0xa1b2d0e21b8b1667",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-satellite-hrc-westlake-village-roy-handelsman",
        "name": "Roy Handelsman",
        "credentials": ["MD", "FACOG"],
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/08/dr-roy-handelsman-2025-360X480c.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/westlake-village/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-hrc-westlake-village-robert-boostanfar",
        "name": "Robert Boostanfar",
        "credentials": ["MD", "FACOG"],
        "role": "Board Certified Reproductive Endocrinologist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/07/Dr-Boostanfar-2024-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/westlake-village/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-hrc-westlake-village-alison-c-peck",
        "name": "Alison C. Peck",
        "credentials": ["MD", "FACOG"],
        "role": "Board Certified Reproductive Endocrinologist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/07/Dr-Peck-2024-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/westlake-village/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [
      {
        "url": "https://havingbabies.com/wp-content/uploads/2019/04/hrc-westlake-village-exterior.jpg",
        "type": "exterior"
      }
    ],
    "description": "HRC Fertility's Westlake Village clinic provides infertility patients with a convenient location for infertility tests, fertility treatments, and monitoring. Patients are seen by three fertility doctors, Robert Boostanfar, Roy Handelsman, and Alison C. Peck. The clinic offers infertility consultations, diagnostic tests such as hysteroscopy and endometrial biopsy, basic treatments such as ovulation induction, and advanced assisted reproductive technologies.",
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross, Blue Cross, Blue Shield of California, Cigna Healthcare, United Healthcare, Humana, Health Net",
              "detail": "4 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.havingbabies.com/locations/pasadena/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-hrc-carlsbad",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "HRC Fertility - Carlsbad",
    "website": "https://www.havingbabies.com/locations/carlsbad/",
    "phone": "(760) 758-2034",
    "address": {
      "line1": "6183 Paseo Del Norte, Suite 270",
      "city": "Carlsbad",
      "state": "CA",
      "zip": "92011",
      "country": "US"
    },
    "consultationTypes": ["in-person", "telehealth"],
    "languages": ["English", "Spanish"],
    "insurance": {
      "accepted": true,
      "financingOptions": [
        "Payment plans",
        "Loans",
        "Package pricing",
        "CapexMD",
        "Future Family",
        "PatientFi"
      ],
      "carriers": [
        "Aetna",
        "Anthem Blue Cross",
        "Blue Cross",
        "Blue Shield of California",
        "Cigna Healthcare",
        "United Healthcare",
        "Humana",
        "Health Net",
        "Kaiser Permanente",
        "Multiplan",
        "Tricare",
        "Optum"
      ],
      "employeeBenefits": [
        "Progyny",
        "Carrot",
        "Maven",
        "WINFertility",
        "Future Family"
      ],
      "_source": {
        "url": "https://www.havingbabies.com/locations/pasadena/",
        "fetchedAt": "2026-03-11"
      }
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "network": {
      "name": "HRC Fertility"
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/locations/carlsbad/",
            "fetchedAt": "2026-03-11"
          }
        },
        "insurance": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/locations/carlsbad/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/locations/carlsbad/",
            "fetchedAt": "2026-06-10"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-satellite-hrc-carlsbad-mickey-s-coffler",
        "name": "Mickey S. Coffler",
        "credentials": ["MD", "FACOG"],
        "role": "Board Certified Reproductive Endocrinologist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/07/Dr-Coffler-2024-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/carlsbad/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-hrc-carlsbad-michael-d-wittenberger",
        "name": "Michael D. Wittenberger",
        "credentials": ["MD", "FACOG"],
        "role": "Board Certified Reproductive Endocrinologist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/07/Dr-Wittenberger-2024-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/carlsbad/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [],
    "description": "HRC Fertility's Carlsbad clinic serves patients in North San Diego County with fertility tests, treatment, and monitoring. Dr. Mickey S. Coffler diagnoses and treats a wide variety of fertility-related issues at this location, including endometriosis, ovulatory dysfunction, PCOS, polyps, and fibroids. The clinic offers assisted reproductive technologies such as IUI and IVF, along with third-party reproductive services including embryo adoption and surrogacy.",
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross, Blue Cross, Blue Shield of California, Cigna Healthcare, United Healthcare, Humana, Health Net",
              "detail": "4 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.havingbabies.com/locations/pasadena/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-hrc-san-diego",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "HRC Fertility - San Diego",
    "website": "https://www.havingbabies.com/locations/san-diego/",
    "phone": "(858) 935-6868",
    "address": {
      "line1": "9339 Genesee Ave, Suite 125",
      "city": "San Diego",
      "state": "CA",
      "zip": "92121",
      "country": "US"
    },
    "consultationTypes": ["in-person", "telehealth"],
    "languages": ["English", "Spanish"],
    "insurance": {
      "accepted": true,
      "financingOptions": [
        "Payment plans",
        "Loans",
        "Package pricing",
        "CapexMD",
        "Future Family",
        "PatientFi"
      ],
      "carriers": [
        "Aetna",
        "Anthem Blue Cross",
        "Blue Cross",
        "Blue Shield of California",
        "Cigna Healthcare",
        "United Healthcare",
        "Humana",
        "Health Net",
        "Kaiser Permanente",
        "Multiplan",
        "Tricare",
        "Optum"
      ],
      "employeeBenefits": [
        "Progyny",
        "Carrot",
        "Maven",
        "WINFertility",
        "Future Family"
      ],
      "_source": {
        "url": "https://www.havingbabies.com/locations/pasadena/",
        "fetchedAt": "2026-03-11"
      }
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "network": {
      "name": "HRC Fertility"
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/locations/san-diego/",
            "fetchedAt": "2026-03-11"
          }
        },
        "insurance": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/",
            "fetchedAt": "2026-03-11"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/locations/san-diego/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.havingbabies.com/locations/san-diego/",
            "fetchedAt": "2026-06-10"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-satellite-hrc-san-diego-mickey-s-coffler",
        "name": "Mickey S. Coffler",
        "credentials": ["MD", "FACOG"],
        "role": "Board Certified Reproductive Endocrinologist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/07/Dr-Coffler-2024-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/san-diego/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-satellite-hrc-san-diego-michael-d-wittenberger",
        "name": "Michael D. Wittenberger",
        "credentials": ["MD", "FACOG"],
        "role": "Board Certified Reproductive Endocrinologist",
        "imageUrl": "https://havingbabies.com/wp-content/uploads/2024/07/Dr-Wittenberger-2024-360X480.jpg",
        "_source": {
          "url": "https://www.havingbabies.com/locations/san-diego/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [
      {
        "url": "https://havingbabies.com/wp-content/uploads/2022/08/HRC-Fertility-San-Diego-med.jpg",
        "type": "exterior"
      }
    ],
    "description": "HRC Fertility's San Diego location serves the greater San Diego community with reproductive care from physicians Mickey S. Coffler and Michael Wittenberger. The clinic offers a range of fertility treatments, from egg and sperm freezing to embryo transfer and in vitro fertilization (IVF).",
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross, Blue Cross, Blue Shield of California, Cigna Healthcare, United Healthcare, Humana, Health Net",
              "detail": "4 more carrier names are stored on this record. Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.havingbabies.com/locations/pasadena/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-dr-aimee-eyvazzadeh",
    "externalIds": {},
    "type": "solo-practitioner",
    "name": "Dr. Aimee Eyvazzadeh, MD (Egg Whisperer)",
    "description": "Dr. Aimee is a board-certified OB-GYN and fellowship-trained reproductive endocrinologist known as the 'Egg Whisperer.' She provides personalized, hands-on fertility care including IVF, egg freezing, IUI, egg donation, and PGD from her independent practice.",
    "website": "https://draimee.org",
    "phone": "(925) 277-0600",
    "bookingUrl": "https://eggwhisperer.com",
    "socialLinks": [
      {
        "platform": "instagram",
        "url": "https://www.instagram.com/eggwhisperer/",
        "label": "Instagram",
        "_source": {
          "url": "https://eggwhisperer.com/show/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "youtube",
        "url": "https://www.youtube.com/channel/UC4w20dXVKYd9A81PTNkyzXQ",
        "label": "YouTube",
        "_source": {
          "url": "https://eggwhisperer.com/show/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "facebook",
        "url": "https://www.facebook.com/doctoraimee/",
        "label": "Facebook",
        "_source": {
          "url": "https://eggwhisperer.com/show/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "address": {
      "line1": "5401 Norris Canyon Rd, Ste 106",
      "city": "San Ramon",
      "state": "CA",
      "zip": "94583",
      "country": "US"
    },
    "location": {
      "lat": 37.7622,
      "lng": -121.9531
    },
    "specialties": [
      "reproductive-endocrinology",
      "egg-freezing",
      "IVF",
      "PCOS"
    ],
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "consultationTypes": ["in-person", "telehealth"],
    "languages": ["English"],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "scraped"
        },
        "contact": {
          "status": "scraped"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://draimee.org/",
            "fetchedAt": "2026-06-11"
          }
        },
        "socialLinks": {
          "status": "scraped",
          "source": {
            "url": "https://eggwhisperer.com/show/",
            "fetchedAt": "2026-06-15"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-turek-clinic-sf",
    "externalIds": {},
    "type": "solo-practitioner",
    "name": "The Turek Clinic — Dr. Paul Turek, MD",
    "description": "Dr. Paul Turek is an internationally renowned expert in male infertility and sexual health. A past president of the American Society of Andrology and NIH grant recipient, he invented sperm mapping and has published some of the highest vasectomy reversal success rates worldwide.",
    "website": "https://www.theturekclinic.com",
    "phone": "(415) 392-3200",
    "address": {
      "line1": "450 Sutter St, Ste 1708",
      "city": "San Francisco",
      "state": "CA",
      "zip": "94108",
      "country": "US"
    },
    "location": {
      "lat": 37.7891,
      "lng": -122.4079
    },
    "specialties": [
      "male-fertility",
      "microsurgery",
      "sperm-mapping",
      "vasectomy-reversal"
    ],
    "treatments": [
      {
        "name": "Sperm Mapping",
        "category": "diagnostic"
      },
      {
        "name": "Vasectomy Reversal",
        "category": "surgical"
      },
      {
        "name": "Microsurgical Varicocelectomy",
        "category": "surgical"
      },
      {
        "name": "Sperm Retrieval (TESE/microTESE)",
        "category": "surgical"
      }
    ],
    "consultationTypes": ["in-person", "telehealth"],
    "languages": ["English"],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "scraped"
        },
        "contact": {
          "status": "scraped"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.theturekclinic.com",
            "fetchedAt": "2026-06-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "The Turek Clinic"
    },
    "team": [
      {
        "name": "Paul Turek",
        "role": "Medical Director",
        "credentials": ["MD", "FACS", "FRSM"],
        "imageUrl": "https://d2uvynux30dg3.cloudfront.net/theturekclinic.com/wp-content/uploads/20200513194454/Dr._Photo.png",
        "practitionerId": "pr-org-turek-clinic-sf-paul-turek"
      }
    ],
    "images": [],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-turek-clinic-bh",
    "externalIds": {},
    "type": "solo-practitioner",
    "name": "The Turek Clinic — Dr. Paul Turek, MD (Beverly Hills)",
    "description": "Beverly Hills location of The Turek Clinic, led by Dr. Paul Turek, an internationally renowned expert in male infertility, sexual health, and microsurgery.",
    "website": "https://www.theturekclinic.com",
    "phone": "(310) 499-9299",
    "address": {
      "line1": "9033 Wilshire Blvd, Ste 408",
      "city": "Beverly Hills",
      "state": "CA",
      "zip": "90211",
      "country": "US"
    },
    "location": {
      "lat": 34.068,
      "lng": -118.3894
    },
    "specialties": [
      "male-fertility",
      "microsurgery",
      "sperm-mapping",
      "vasectomy-reversal"
    ],
    "treatments": [
      {
        "name": "Sperm Mapping",
        "category": "diagnostic"
      },
      {
        "name": "Vasectomy Reversal",
        "category": "surgical"
      },
      {
        "name": "Microsurgical Varicocelectomy",
        "category": "surgical"
      },
      {
        "name": "Sperm Retrieval (TESE/microTESE)",
        "category": "surgical"
      }
    ],
    "consultationTypes": ["in-person", "telehealth"],
    "languages": ["English"],
    "network": {
      "name": "The Turek Clinic"
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "scraped"
        },
        "contact": {
          "status": "scraped"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.theturekclinic.com",
            "fetchedAt": "2026-06-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Paul Turek",
        "role": "Medical Director",
        "credentials": ["MD", "FACS", "FRSM"],
        "imageUrl": "https://d2uvynux30dg3.cloudfront.net/theturekclinic.com/wp-content/uploads/20200513194454/Dr._Photo.png",
        "practitionerId": "pr-org-turek-clinic-bh-paul-turek"
      }
    ],
    "images": [],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-werthman-cmrm",
    "externalIds": {},
    "type": "solo-practitioner",
    "name": "Center for Male Reproductive Medicine — Dr. Philip Werthman, MD",
    "description": "Dr. Philip Werthman is a Fellow of the American College of Surgeons and one of the most recognized vasectomy reversal surgeons and male fertility doctors in the world. His practice is devoted exclusively to treating male infertility and performing vasectomy reversals, with over 20,000 microsurgical procedures performed.",
    "website": "https://www.malereproduction.com",
    "address": {
      "line1": "2080 Century Park East, Ste 907",
      "city": "Los Angeles",
      "state": "CA",
      "zip": "90067",
      "country": "US"
    },
    "location": {
      "lat": 34.0579,
      "lng": -118.4148
    },
    "specialties": ["male-fertility", "vasectomy-reversal", "microsurgery"],
    "treatments": [
      {
        "name": "Vasectomy Reversal",
        "category": "surgical"
      },
      {
        "name": "Sperm Retrieval (TESE/microTESE)",
        "category": "surgical"
      },
      {
        "name": "Microsurgical Varicocelectomy",
        "category": "surgical"
      },
      {
        "name": "No-Scalpel Vasectomy",
        "category": "surgical"
      }
    ],
    "consultationTypes": ["in-person"],
    "languages": ["English"],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "scraped"
        },
        "contact": {
          "status": "scraped"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.malereproduction.com",
            "fetchedAt": "2026-06-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-seaman-male-fertility",
    "externalIds": {},
    "type": "solo-practitioner",
    "name": "Male Fertility Doc — Dr. Eric Seaman, MD",
    "description": "Dr. Eric K. Seaman is a board-certified urologist and one of the leading experts in male reproductive health and microsurgery in the New York metropolitan area. He has performed thousands of vasectomies and vasectomy reversals using no-scalpel and no-needle techniques over nearly two decades.",
    "website": "https://www.malefertilitydoc.com",
    "phone": "(973) 253-4256",
    "address": {
      "line1": "225 Millburn Ave, Ste 304",
      "city": "Millburn",
      "state": "NJ",
      "zip": "07041",
      "country": "US"
    },
    "location": {
      "lat": 40.7252,
      "lng": -74.3073
    },
    "specialties": ["male-fertility", "microsurgery", "vasectomy-reversal"],
    "treatments": [
      {
        "name": "Vasectomy Reversal",
        "category": "surgical"
      },
      {
        "name": "No-Scalpel Vasectomy",
        "category": "surgical"
      },
      {
        "name": "Microsurgical Varicocelectomy",
        "category": "surgical"
      },
      {
        "name": "Sperm Retrieval (TESE/microTESE)",
        "category": "surgical"
      }
    ],
    "consultationTypes": ["in-person"],
    "languages": ["English"],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "scraped"
        },
        "contact": {
          "status": "scraped"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.malefertilitydoc.com",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "boutique",
    "team": [
      {
        "name": "Eric Seaman, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/assets/images/provider/photos/1902899.jpg",
        "_source": {
          "url": "https://www.malefertilitydoc.com",
          "fetchedAt": "2026-06-14"
        },
        "role": "Urologist",
        "credentials": ["MD"],
        "specialty": "Male Fertility",
        "practitionerId": "pr-org-seaman-male-fertility-eric-seaman-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-bastuba-mfs",
    "externalIds": {},
    "type": "solo-practitioner",
    "name": "Male Fertility & Sexual Medicine Specialists (MFS) — Dr. Martin Bastuba, MD",
    "description": "Dr. Martin Bastuba is an internationally leading vasectomy reversal surgeon and male infertility specialist. Board-certified and part of an elite group (2%) of urologists in the U.S. specializing in male fertility, he founded MFS in 1993 and has over 30 years of experience.",
    "website": "https://www.malefertility.com",
    "phone": "(858) 585-4766",
    "address": {
      "line1": "8851 Center Dr, Ste 505",
      "city": "San Diego",
      "state": "CA",
      "zip": "92122",
      "country": "US"
    },
    "location": {
      "lat": 32.8686,
      "lng": -117.2108
    },
    "specialties": ["male-fertility", "vasectomy-reversal", "microsurgery"],
    "treatments": [
      {
        "name": "Vasectomy Reversal",
        "category": "surgical"
      },
      {
        "name": "Sperm Retrieval (TESE/microTESE)",
        "category": "surgical"
      },
      {
        "name": "Microsurgical Varicocelectomy",
        "category": "surgical"
      }
    ],
    "consultationTypes": ["in-person"],
    "languages": ["English"],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "scraped"
        },
        "contact": {
          "status": "scraped"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.malefertility.com",
            "fetchedAt": "2026-06-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-rena-malik-md",
    "externalIds": {},
    "type": "solo-practitioner",
    "name": "Dr. Rena Malik, MD — Urology & Sexual Health",
    "description": "Dr. Rena Malik is a board-certified urologist, pelvic surgeon, and the world's most-followed urologist with 3M+ YouTube subscribers. She specializes in sexual medicine, urogynecology, hormone management, and pelvic health. Note: Not currently accepting new patients as of February 2026.",
    "website": "https://renamalikmd.com",
    "phone": "(949) 610-0866",
    "address": {
      "line1": "433 N Camden Dr, Ste 610",
      "city": "Beverly Hills",
      "state": "CA",
      "zip": "90210",
      "country": "US"
    },
    "location": {
      "lat": 34.0694,
      "lng": -118.3977
    },
    "specialties": [
      "urology",
      "sexual-health",
      "pelvic-medicine",
      "hormone-management"
    ],
    "treatments": [
      {
        "name": "Sexual Health Evaluation",
        "category": "diagnostic"
      },
      {
        "name": "Hormone Management",
        "category": "wellness"
      },
      {
        "name": "Pelvic Floor Treatment",
        "category": "wellness"
      }
    ],
    "consultationTypes": ["in-person", "telehealth"],
    "languages": ["English"],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "scraped"
        },
        "contact": {
          "status": "scraped"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://renamalikmd.com/about/",
            "fetchedAt": "2026-06-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-berkley-center",
    "externalIds": {},
    "type": "wellness-provider",
    "name": "The Berkley Center for Reproductive Wellness",
    "description": "Founded by Mike Berkley, LAc, FABORM — the first acupuncturist in the United States to specialize in fertility issues. Since 1998, the Berkley Center has been a premier fertility acupuncture clinic combining Eastern therapies with Western medical approaches, including acupuncture, herbal medicine, and low-level light therapy (LLLT).",
    "website": "https://www.berkleycenter.com",
    "phone": "(212) 685-0985",
    "address": {
      "line1": "16 E 40th St, 2nd Flr",
      "city": "New York",
      "state": "NY",
      "zip": "10016",
      "country": "US"
    },
    "location": {
      "lat": 40.7522,
      "lng": -73.981
    },
    "specialties": ["fertility-acupuncture", "herbal-medicine", "IVF-support"],
    "treatments": [
      {
        "name": "Fertility Acupuncture",
        "category": "wellness"
      },
      {
        "name": "Chinese Herbal Medicine",
        "category": "wellness"
      },
      {
        "name": "Low-Level Light Therapy (LLLT)",
        "category": "wellness"
      },
      {
        "name": "IVF/IUI Acupuncture Support",
        "category": "wellness"
      }
    ],
    "consultationTypes": ["in-person", "telehealth"],
    "languages": ["English"],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "scraped"
        },
        "contact": {
          "status": "scraped"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.berkleycenter.com/about-mike-berkley",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "boutique",
    "team": [
      {
        "name": "Mike Berkley",
        "imageUrl": "https://www.berkleycenter.com/wp-content/uploads/2024/05/WhatsApp-Image-2024-05-20-at-17-scaled.webp",
        "_source": {
          "url": "https://www.berkleycenter.com/about-mike-berkley",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "practitionerId": "pr-org-berkley-center-mike-berkley"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-natural-healing-acupuncture",
    "externalIds": {},
    "type": "wellness-provider",
    "name": "Natural Healing & Acupuncture — Denise Wiesner, DACM",
    "description": "Founded by Dr. Denise Wiesner, one of the foremost experts in fertility acupuncture, serving West Los Angeles and Santa Monica for over 30 years. Author of 'Conceiving with Love,' she specializes in natural fertility, IVF/IUI support, male fertility, and pain management using acupuncture and Chinese medicine.",
    "website": "https://naturalhealingacupuncture.com",
    "phone": "(310) 473-7474",
    "address": {
      "line1": "2001 S Barrington Ave, Ste 220",
      "city": "Los Angeles",
      "state": "CA",
      "zip": "90025",
      "country": "US"
    },
    "location": {
      "lat": 34.041,
      "lng": -118.4517
    },
    "specialties": [
      "fertility-acupuncture",
      "herbal-medicine",
      "IVF-support",
      "male-fertility"
    ],
    "treatments": [
      {
        "name": "Fertility Acupuncture",
        "category": "wellness"
      },
      {
        "name": "Chinese Herbal Medicine",
        "category": "wellness"
      },
      {
        "name": "IVF/IUI Acupuncture Support",
        "category": "wellness"
      },
      {
        "name": "Male Fertility Support",
        "category": "wellness"
      }
    ],
    "consultationTypes": ["in-person"],
    "languages": ["English"],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "scraped"
        },
        "contact": {
          "status": "scraped"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-nest-chicago",
    "externalIds": {},
    "type": "wellness-provider",
    "name": "The Nest Chicago — Fertility Acupuncture",
    "description": "Founded by Jen Paschen, The Nest Chicago has been providing fertility acupuncture in Chicago's Lincoln Square neighborhood for 19 years. Jen and her team have over 40 years of combined experience and work collaboratively with top fertility clinics and reproductive endocrinologists in the area.",
    "website": "https://www.thenestchicago.com",
    "phone": "(773) 267-0248",
    "address": {
      "line1": "4650 N Rockwell St",
      "city": "Chicago",
      "state": "IL",
      "zip": "60625",
      "country": "US"
    },
    "location": {
      "lat": 41.966,
      "lng": -87.693
    },
    "specialties": [
      "fertility-acupuncture",
      "IVF-support",
      "pregnancy-support"
    ],
    "treatments": [
      {
        "name": "Fertility Acupuncture",
        "category": "wellness"
      },
      {
        "name": "IVF/IUI Acupuncture Support",
        "category": "wellness"
      },
      {
        "name": "Pregnancy Acupuncture",
        "category": "wellness"
      }
    ],
    "consultationTypes": ["in-person"],
    "languages": ["English"],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "scraped"
        },
        "contact": {
          "status": "scraped"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-kenosha-gleaton-md",
    "externalIds": {},
    "type": "solo-practitioner",
    "name": "Dr. Kenosha Gleaton, MD — The EpiCentre",
    "description": "Dr. Kenosha Gleaton is a board-certified OB-GYN, Medical Director of Natalist, and a fertility and pregnancy educator. Having personally struggled with infertility, she is an advocate for those on their fertility journey, combining clinical practice with science-backed education through Natalist's platform.",
    "website": "https://www.epicentrecharleston.com",
    "address": {
      "line1": "2048 Charlie Hall Blvd.",
      "city": "Charleston",
      "state": "SC",
      "zip": "29414",
      "country": "US"
    },
    "location": {
      "lat": 32.7876,
      "lng": -79.7862
    },
    "specialties": ["ob-gyn", "fertility-education", "preconception"],
    "treatments": [
      {
        "name": "Preconception Counseling",
        "category": "diagnostic"
      },
      {
        "name": "Fertility Evaluation",
        "category": "diagnostic"
      },
      {
        "name": "OB-GYN Care",
        "category": "wellness"
      }
    ],
    "consultationTypes": ["in-person"],
    "languages": ["English"],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.epicentrecharleston.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.epicentrecharleston.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.epicentrecharleston.com/obstetrics-and-gynecology-practice-about-us/meet-our-team",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://www.epicentrecharleston.com/obstetrics-and-gynecology-practice-about-us/office-tour",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "boutique",
    "phone": "(843) 804-6010",
    "team": [
      {
        "practitionerId": "pr-org-kenosha-gleaton-md-kenosha-gleaton-md-facog",
        "name": "Kenosha Gleaton, MD, FACOG",
        "role": "EpiCentre Founder/CEO; Roper St. Francis OB/GYN",
        "credentials": ["MD", "FACOG"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://kyruus-app-static.kyruus.com/providermatch/roperstfrancis/photos/200/gleaton-kenosha-1235268210.jpg?1715001048941",
        "_source": {
          "url": "https://www.epicentrecharleston.com/obstetrics-and-gynecology-practice-about-us/meet-our-team",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check South Carolina (SC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-fertility-nutritionist",
    "externalIds": {},
    "type": "wellness-provider",
    "name": "Fertility Nutritionist — Anna Bohnengel, MS, RDN",
    "description": "Anna Bohnengel is a registered dietitian nutritionist trained at the National Institutes of Health who has dedicated her career to fertility nutrition. Since founding her practice in 2015, she provides evidence-based, personalized nutrition guidance for IVF support, PCOS management, and overall reproductive health.",
    "website": "https://fertility-nutritionist.com",
    "address": {
      "line1": "Virtual Practice",
      "city": "Nationwide",
      "state": "",
      "zip": "",
      "country": "US"
    },
    "location": null,
    "specialties": [
      "fertility-nutrition",
      "PCOS",
      "IVF-support",
      "dietary-counseling"
    ],
    "treatments": [
      {
        "name": "Fertility Nutrition Counseling",
        "category": "wellness"
      },
      {
        "name": "PCOS Diet Planning",
        "category": "wellness"
      },
      {
        "name": "IVF Nutrition Support",
        "category": "wellness"
      }
    ],
    "consultationTypes": ["telehealth"],
    "languages": ["English"],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "scraped"
        },
        "contact": {
          "status": "scraped"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.healthprofs.com/us/nutritionists-dietitians/fertility-nutritionist-ashland-or/563409",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://fertility-nutritionist.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "setting": "boutique",
    "team": [
      {
        "practitionerId": "pr-org-fertility-nutritionist-anna-bohnengel-ms-rdn-ld",
        "name": "Anna Bohnengel, MS, RDN, LD",
        "role": "Registered Dietitian Nutritionist",
        "credentials": ["MS", "RDN", "LD"],
        "specialty": "Fertility Nutrition",
        "imageUrl": "https://photos.healthprofs.com/59eff429-46cd-11ea-a6ad-06142c356176/1/320x400.jpeg",
        "_source": {
          "url": "https://www.healthprofs.com/us/nutritionists-dietitians/fertility-nutritionist-ashland-or/563409",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "This record does not have a state code, so state insurance and legal checks need manual review.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "brown-fertility-jacksonville-ivf-center",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Brown Fertility — Jacksonville IVF Center",
    "website": "https://www.brownfertility.com",
    "phone": "(877) 260-0352",
    "network": {
      "name": "Brown Fertility"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.brownfertility.com/about/doctors",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2025-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "address": {
      "line1": "8149 Point Meadows Way",
      "city": "Jacksonville",
      "state": "FL",
      "zip": "32256",
      "country": "US"
    },
    "location": {
      "lat": 30.2175,
      "lng": -81.5505
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility Surgery",
        "category": "surgical"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "languages": ["English", "Spanish"],
    "description": "Brown Fertility is a full-service fertility practice led by Dr. Samuel E. Brown, offering IVF, IUI, egg freezing, donor programs, and fertility preservation across Florida and Georgia.",
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "team": [
      {
        "name": "Erica Lobel, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2025/12/erica_lobel_1-1920x2965.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/erica-lobel",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-jacksonville-ivf-center-erica-lobel-md"
      },
      {
        "name": "Angeline N. Beltsos, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/04/20260319-KKphotography_Studio_114868_Z_8_1-Edit-1-1920x1280.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/angeline-n-beltsos-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-jacksonville-ivf-center-angeline-n-beltsos-md"
      },
      {
        "name": "Maria Crespo-Smith, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/02/crespo_lab_coat_2-1920x2965.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/maria-crespo-smith-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-jacksonville-ivf-center-maria-crespo-smith-md"
      },
      {
        "name": "Peter Casella, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/05/0050_PeterCasella_BrownFertility_26LauraEvans-002-1920x2878.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/peter-casella-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-jacksonville-ivf-center-peter-casella-md"
      },
      {
        "name": "Hannah Ballester, PA-C",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2025/10/Hannah-Ballester-PA-C-Employee-Headshot-1920x2880.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/hannah-ballester",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "practitionerId": "pr-brown-fertility-jacksonville-ivf-center-hannah-ballester-pa-c"
      },
      {
        "name": "Lauren Hilado",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/06/Brown-Fertility-Headshot.jpeg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/lauren-hilado",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "practitionerId": "pr-brown-fertility-jacksonville-ivf-center-lauren-hilado"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "brown-fertility-orlando",
    "externalIds": {
      "googlePlaceId": "ChIJWWjUiQZ754gRpeAs3zTQXcw"
    },
    "type": "fertility-clinic",
    "name": "Brown Fertility — Orlando",
    "website": "https://www.brownfertility.com",
    "phone": "(877) 260-0352",
    "network": {
      "name": "Brown Fertility"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.brownfertility.com/about/doctors",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Brown+Fertility,+70+W+Gore+St+%23202,+Orlando,+FL+32806/@28.5305827,-81.3793333,3505a,13.1y/data=!4m2!3m1!1s0x88e77b0689d46859:0xcc5dd034df2ce0a5",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2025-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "address": {
      "line1": "70 W Gore St, Ste 202",
      "city": "Orlando",
      "state": "FL",
      "zip": "32806",
      "country": "US"
    },
    "location": {
      "lat": 28.5367,
      "lng": -81.38
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility Surgery",
        "category": "surgical"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "languages": ["English", "Spanish"],
    "description": "Brown Fertility is a full-service fertility practice led by Dr. Samuel E. Brown, offering IVF, IUI, egg freezing, donor programs, and fertility preservation across Florida and Georgia.",
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "team": [
      {
        "name": "Erica Lobel, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2025/12/erica_lobel_1-1920x2965.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/erica-lobel",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-orlando-erica-lobel-md"
      },
      {
        "name": "Angeline N. Beltsos, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/04/20260319-KKphotography_Studio_114868_Z_8_1-Edit-1-1920x1280.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/angeline-n-beltsos-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-orlando-angeline-n-beltsos-md"
      },
      {
        "name": "Maria Crespo-Smith, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/02/crespo_lab_coat_2-1920x2965.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/maria-crespo-smith-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-orlando-maria-crespo-smith-md"
      },
      {
        "name": "Peter Casella, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/05/0050_PeterCasella_BrownFertility_26LauraEvans-002-1920x2878.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/peter-casella-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-orlando-peter-casella-md"
      },
      {
        "name": "Hannah Ballester, PA-C",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2025/10/Hannah-Ballester-PA-C-Employee-Headshot-1920x2880.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/hannah-ballester",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "practitionerId": "pr-brown-fertility-orlando-hannah-ballester-pa-c"
      },
      {
        "name": "Lauren Hilado",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/06/Brown-Fertility-Headshot.jpeg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/lauren-hilado",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "practitionerId": "pr-brown-fertility-orlando-lauren-hilado"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWneYc6DM3lr0mfdj2V1rZWthag8BcBI31sbMnnSgW90XYNZr8g5PZbvZlucFca-BkPFJpKnjsv-Jhkvo9OZm5IkcMuwcODSX3nAQ-TVcmstMEOOVGvu6pCqQIyr491q1_0dCV6p=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Brown+Fertility,+70+W+Gore+St+%23202,+Orlando,+FL+32806/@28.5305827,-81.3793333,3505a,13.1y/data=!4m2!3m1!1s0x88e77b0689d46859:0xcc5dd034df2ce0a5",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "brown-fertility-winter-garden-stoneybrook",
    "externalIds": {
      "googlePlaceId": "ChIJV0vQy16D54gRehaDhhQjmd0"
    },
    "type": "fertility-clinic",
    "name": "Brown Fertility — Winter Garden-Stoneybrook",
    "website": "https://www.brownfertility.com",
    "phone": "(877) 260-0352",
    "network": {
      "name": "Brown Fertility"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.brownfertility.com/about/doctors",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Brown+Fertility,+2200+Fowler+Grove+Blvd+Ste+260,+Winter+Garden,+FL+34787/@28.5247507,-81.589874,3505a,13.1y/data=!4m2!3m1!1s0x88e7835ecbd04b57:0xdd9923148683167a",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2025-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "address": {
      "line1": "2200 Fowler Grove Blvd, Ste 260",
      "city": "Winter Garden",
      "state": "FL",
      "zip": "34787",
      "country": "US"
    },
    "location": {
      "lat": 28.5227,
      "lng": -81.5629
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility Surgery",
        "category": "surgical"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "languages": ["English", "Spanish"],
    "description": "Brown Fertility is a full-service fertility practice led by Dr. Samuel E. Brown, offering IVF, IUI, egg freezing, donor programs, and fertility preservation across Florida and Georgia.",
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "team": [
      {
        "name": "Erica Lobel, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2025/12/erica_lobel_1-1920x2965.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/erica-lobel",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-winter-garden-stoneybrook-erica-lobel-md"
      },
      {
        "name": "Angeline N. Beltsos, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/04/20260319-KKphotography_Studio_114868_Z_8_1-Edit-1-1920x1280.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/angeline-n-beltsos-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-winter-garden-stoneybrook-angeline-n-beltsos-md"
      },
      {
        "name": "Maria Crespo-Smith, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/02/crespo_lab_coat_2-1920x2965.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/maria-crespo-smith-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-winter-garden-stoneybrook-maria-crespo-smith-md"
      },
      {
        "name": "Peter Casella, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/05/0050_PeterCasella_BrownFertility_26LauraEvans-002-1920x2878.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/peter-casella-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-winter-garden-stoneybrook-peter-casella-md"
      },
      {
        "name": "Hannah Ballester, PA-C",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2025/10/Hannah-Ballester-PA-C-Employee-Headshot-1920x2880.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/hannah-ballester",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "practitionerId": "pr-brown-fertility-winter-garden-stoneybrook-hannah-ballester-pa-c"
      },
      {
        "name": "Lauren Hilado",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/06/Brown-Fertility-Headshot.jpeg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/lauren-hilado",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "practitionerId": "pr-brown-fertility-winter-garden-stoneybrook-lauren-hilado"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "brown-fertility-tampa",
    "externalIds": {
      "googlePlaceId": "ChIJ650PmWDDwogRJFzl8VLQ5is"
    },
    "type": "fertility-clinic",
    "name": "Brown Fertility — Tampa",
    "website": "https://www.brownfertility.com",
    "phone": "(877) 260-0352",
    "network": {
      "name": "Brown Fertility"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.brownfertility.com/about/doctors",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Brown+Fertility,+4602+N+Armenia+Ave+Ste+200,+Tampa,+FL+33603/@27.9856426,-82.4849612,3523a,13.1y/data=!4m2!3m1!1s0x88c2c360990f9deb:0x2be6d052f1e55c24",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2025-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "address": {
      "line1": "4602 N Armenia Ave, Ste 200",
      "city": "Tampa",
      "state": "FL",
      "zip": "33603",
      "country": "US"
    },
    "location": {
      "lat": 27.9758,
      "lng": -82.4802
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility Surgery",
        "category": "surgical"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "languages": ["English", "Spanish"],
    "description": "Brown Fertility is a full-service fertility practice led by Dr. Samuel E. Brown, offering IVF, IUI, egg freezing, donor programs, and fertility preservation across Florida and Georgia.",
    "consultationTypes": ["in-person", "telehealth"],
    "setting": "network-group",
    "team": [
      {
        "name": "Erica Lobel, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2025/12/erica_lobel_1-1920x2965.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/erica-lobel",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-tampa-erica-lobel-md"
      },
      {
        "name": "Angeline N. Beltsos, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/04/20260319-KKphotography_Studio_114868_Z_8_1-Edit-1-1920x1280.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/angeline-n-beltsos-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-tampa-angeline-n-beltsos-md"
      },
      {
        "name": "Maria Crespo-Smith, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/02/crespo_lab_coat_2-1920x2965.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/maria-crespo-smith-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-tampa-maria-crespo-smith-md"
      },
      {
        "name": "Peter Casella, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/05/0050_PeterCasella_BrownFertility_26LauraEvans-002-1920x2878.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/peter-casella-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-tampa-peter-casella-md"
      },
      {
        "name": "Hannah Ballester, PA-C",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2025/10/Hannah-Ballester-PA-C-Employee-Headshot-1920x2880.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/hannah-ballester",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "practitionerId": "pr-brown-fertility-tampa-hannah-ballester-pa-c"
      },
      {
        "name": "Lauren Hilado",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/06/Brown-Fertility-Headshot.jpeg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/lauren-hilado",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "practitionerId": "pr-brown-fertility-tampa-lauren-hilado"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWli8MW01wOW4LQYSgEYhRWpbWuqj-tFKZ2Lwo8CnlG9QNJweEmt0iPc92epDhzCZw2lm2_rLqNOlPL0NsNU0nb_Gyd_p_Wndlk_klko-sCNVRUTy6PMa9ejAq0qp5OqF18mbQ-2=w408-h611-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Brown+Fertility,+4602+N+Armenia+Ave+Ste+200,+Tampa,+FL+33603/@27.9856426,-82.4849612,3523a,13.1y/data=!4m2!3m1!1s0x88c2c360990f9deb:0x2be6d052f1e55c24",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlrb9xYRhspS89SGA2IuBCY8xqECi17FwZdOebTWJaERhFtYjx1U9hLxNve5FXMnvtegTBRU0OXUF9E7hcQ9rRCBLxdCCuZXiN7NBq1qGH3rgQPnPfUJtE2LvH389z0EHv0iZHR=w224-h336-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Brown+Fertility,+4602+N+Armenia+Ave+Ste+200,+Tampa,+FL+33603/@27.9856426,-82.4849612,3523a,13.1y/data=!4m2!3m1!1s0x88c2c360990f9deb:0x2be6d052f1e55c24",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "brown-fertility-tampa-north",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Brown Fertility — Tampa North",
    "website": "https://www.brownfertility.com",
    "phone": "(877) 260-0352",
    "network": {
      "name": "Brown Fertility"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.brownfertility.com/about/doctors",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2025-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "address": {
      "line1": "5380 Primrose Lake Circle",
      "city": "Tampa",
      "state": "FL",
      "zip": "33647",
      "country": "US"
    },
    "location": {
      "lat": 28.0855,
      "lng": -82.3652
    },
    "treatments": [
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Fertility Consultation",
        "category": "diagnostic"
      },
      {
        "name": "Monitoring",
        "category": "diagnostic"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "languages": ["English", "Spanish"],
    "description": "Brown Fertility satellite office offering fertility consultations and monitoring. Patients may travel to a full-service Brown Fertility center for IVF procedures.",
    "consultationTypes": ["in-person"],
    "setting": "network-group",
    "team": [
      {
        "name": "Erica Lobel, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2025/12/erica_lobel_1-1920x2965.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/erica-lobel",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-tampa-north-erica-lobel-md"
      },
      {
        "name": "Angeline N. Beltsos, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/04/20260319-KKphotography_Studio_114868_Z_8_1-Edit-1-1920x1280.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/angeline-n-beltsos-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-tampa-north-angeline-n-beltsos-md"
      },
      {
        "name": "Maria Crespo-Smith, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/02/crespo_lab_coat_2-1920x2965.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/maria-crespo-smith-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-tampa-north-maria-crespo-smith-md"
      },
      {
        "name": "Peter Casella, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/05/0050_PeterCasella_BrownFertility_26LauraEvans-002-1920x2878.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/peter-casella-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-tampa-north-peter-casella-md"
      },
      {
        "name": "Hannah Ballester, PA-C",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2025/10/Hannah-Ballester-PA-C-Employee-Headshot-1920x2880.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/hannah-ballester",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "practitionerId": "pr-brown-fertility-tampa-north-hannah-ballester-pa-c"
      },
      {
        "name": "Lauren Hilado",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/06/Brown-Fertility-Headshot.jpeg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/lauren-hilado",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "practitionerId": "pr-brown-fertility-tampa-north-lauren-hilado"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "brown-fertility-daytona-beach",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Brown Fertility — Daytona Beach",
    "website": "https://www.brownfertility.com",
    "phone": "(877) 260-0352",
    "network": {
      "name": "Brown Fertility"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.brownfertility.com/about/doctors",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2025-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "address": {
      "line1": "Daytona Beach",
      "city": "Daytona Beach",
      "state": "FL",
      "zip": "32114",
      "country": "US"
    },
    "location": {
      "lat": 29.2108,
      "lng": -81.0228
    },
    "treatments": [
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Fertility Consultation",
        "category": "diagnostic"
      },
      {
        "name": "Monitoring",
        "category": "diagnostic"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "languages": ["English", "Spanish"],
    "description": "Brown Fertility satellite office offering fertility consultations and monitoring. Patients may travel to a full-service Brown Fertility center for IVF procedures.",
    "consultationTypes": ["in-person"],
    "setting": "network-group",
    "team": [
      {
        "name": "Erica Lobel, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2025/12/erica_lobel_1-1920x2965.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/erica-lobel",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-daytona-beach-erica-lobel-md"
      },
      {
        "name": "Angeline N. Beltsos, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/04/20260319-KKphotography_Studio_114868_Z_8_1-Edit-1-1920x1280.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/angeline-n-beltsos-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-daytona-beach-angeline-n-beltsos-md"
      },
      {
        "name": "Maria Crespo-Smith, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/02/crespo_lab_coat_2-1920x2965.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/maria-crespo-smith-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-daytona-beach-maria-crespo-smith-md"
      },
      {
        "name": "Peter Casella, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/05/0050_PeterCasella_BrownFertility_26LauraEvans-002-1920x2878.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/peter-casella-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-daytona-beach-peter-casella-md"
      },
      {
        "name": "Hannah Ballester, PA-C",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2025/10/Hannah-Ballester-PA-C-Employee-Headshot-1920x2880.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/hannah-ballester",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "practitionerId": "pr-brown-fertility-daytona-beach-hannah-ballester-pa-c"
      },
      {
        "name": "Lauren Hilado",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/06/Brown-Fertility-Headshot.jpeg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/lauren-hilado",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "practitionerId": "pr-brown-fertility-daytona-beach-lauren-hilado"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "brown-fertility-gainesville",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Brown Fertility — Gainesville",
    "website": "https://www.brownfertility.com",
    "phone": "(877) 260-0352",
    "network": {
      "name": "Brown Fertility"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.brownfertility.com/about/doctors",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2025-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "address": {
      "line1": "6440 W Newberry Rd, Ste 111",
      "city": "Gainesville",
      "state": "FL",
      "zip": "32605",
      "country": "US"
    },
    "location": {
      "lat": 29.652,
      "lng": -82.41
    },
    "treatments": [
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Fertility Consultation",
        "category": "diagnostic"
      },
      {
        "name": "Monitoring",
        "category": "diagnostic"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "languages": ["English", "Spanish"],
    "description": "Brown Fertility satellite office offering fertility consultations and monitoring. Patients may travel to a full-service Brown Fertility center for IVF procedures.",
    "consultationTypes": ["in-person"],
    "setting": "network-group",
    "team": [
      {
        "name": "Erica Lobel, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2025/12/erica_lobel_1-1920x2965.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/erica-lobel",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-gainesville-erica-lobel-md"
      },
      {
        "name": "Angeline N. Beltsos, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/04/20260319-KKphotography_Studio_114868_Z_8_1-Edit-1-1920x1280.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/angeline-n-beltsos-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-gainesville-angeline-n-beltsos-md"
      },
      {
        "name": "Maria Crespo-Smith, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/02/crespo_lab_coat_2-1920x2965.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/maria-crespo-smith-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-gainesville-maria-crespo-smith-md"
      },
      {
        "name": "Peter Casella, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/05/0050_PeterCasella_BrownFertility_26LauraEvans-002-1920x2878.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/peter-casella-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-gainesville-peter-casella-md"
      },
      {
        "name": "Hannah Ballester, PA-C",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2025/10/Hannah-Ballester-PA-C-Employee-Headshot-1920x2880.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/hannah-ballester",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "practitionerId": "pr-brown-fertility-gainesville-hannah-ballester-pa-c"
      },
      {
        "name": "Lauren Hilado",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/06/Brown-Fertility-Headshot.jpeg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/lauren-hilado",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "practitionerId": "pr-brown-fertility-gainesville-lauren-hilado"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "brown-fertility-melbourne",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Brown Fertility — Melbourne",
    "website": "https://www.brownfertility.com",
    "phone": "(877) 260-0352",
    "network": {
      "name": "Brown Fertility"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.brownfertility.com/about/doctors",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2025-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "address": {
      "line1": "129 W Hibiscus Blvd, Ste A",
      "city": "Melbourne",
      "state": "FL",
      "zip": "32901",
      "country": "US"
    },
    "location": {
      "lat": 28.0836,
      "lng": -80.6234
    },
    "treatments": [
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Fertility Consultation",
        "category": "diagnostic"
      },
      {
        "name": "Monitoring",
        "category": "diagnostic"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "languages": ["English", "Spanish"],
    "description": "Brown Fertility satellite office offering fertility consultations and monitoring. Patients may travel to a full-service Brown Fertility center for IVF procedures.",
    "consultationTypes": ["in-person"],
    "setting": "network-group",
    "team": [
      {
        "name": "Erica Lobel, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2025/12/erica_lobel_1-1920x2965.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/erica-lobel",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-melbourne-erica-lobel-md"
      },
      {
        "name": "Angeline N. Beltsos, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/04/20260319-KKphotography_Studio_114868_Z_8_1-Edit-1-1920x1280.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/angeline-n-beltsos-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-melbourne-angeline-n-beltsos-md"
      },
      {
        "name": "Maria Crespo-Smith, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/02/crespo_lab_coat_2-1920x2965.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/maria-crespo-smith-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-melbourne-maria-crespo-smith-md"
      },
      {
        "name": "Peter Casella, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/05/0050_PeterCasella_BrownFertility_26LauraEvans-002-1920x2878.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/peter-casella-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-melbourne-peter-casella-md"
      },
      {
        "name": "Hannah Ballester, PA-C",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2025/10/Hannah-Ballester-PA-C-Employee-Headshot-1920x2880.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/hannah-ballester",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "practitionerId": "pr-brown-fertility-melbourne-hannah-ballester-pa-c"
      },
      {
        "name": "Lauren Hilado",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/06/Brown-Fertility-Headshot.jpeg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/lauren-hilado",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "practitionerId": "pr-brown-fertility-melbourne-lauren-hilado"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "brown-fertility-ocala",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Brown Fertility — Ocala",
    "website": "https://www.brownfertility.com",
    "phone": "(877) 260-0352",
    "network": {
      "name": "Brown Fertility"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.brownfertility.com/about/doctors",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2025-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "address": {
      "line1": "1800 SE 17th St, Ste 300",
      "city": "Ocala",
      "state": "FL",
      "zip": "34471",
      "country": "US"
    },
    "location": {
      "lat": 29.1706,
      "lng": -82.1268
    },
    "treatments": [
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Fertility Consultation",
        "category": "diagnostic"
      },
      {
        "name": "Monitoring",
        "category": "diagnostic"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "languages": ["English", "Spanish"],
    "description": "Brown Fertility satellite office offering fertility consultations and monitoring. Patients may travel to a full-service Brown Fertility center for IVF procedures.",
    "consultationTypes": ["in-person"],
    "setting": "network-group",
    "team": [
      {
        "name": "Erica Lobel, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2025/12/erica_lobel_1-1920x2965.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/erica-lobel",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-ocala-erica-lobel-md"
      },
      {
        "name": "Angeline N. Beltsos, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/04/20260319-KKphotography_Studio_114868_Z_8_1-Edit-1-1920x1280.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/angeline-n-beltsos-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-ocala-angeline-n-beltsos-md"
      },
      {
        "name": "Maria Crespo-Smith, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/02/crespo_lab_coat_2-1920x2965.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/maria-crespo-smith-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-ocala-maria-crespo-smith-md"
      },
      {
        "name": "Peter Casella, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/05/0050_PeterCasella_BrownFertility_26LauraEvans-002-1920x2878.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/peter-casella-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-ocala-peter-casella-md"
      },
      {
        "name": "Hannah Ballester, PA-C",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2025/10/Hannah-Ballester-PA-C-Employee-Headshot-1920x2880.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/hannah-ballester",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "practitionerId": "pr-brown-fertility-ocala-hannah-ballester-pa-c"
      },
      {
        "name": "Lauren Hilado",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/06/Brown-Fertility-Headshot.jpeg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/lauren-hilado",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "practitionerId": "pr-brown-fertility-ocala-lauren-hilado"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "brown-fertility-tallahassee",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Brown Fertility — Tallahassee",
    "website": "https://www.brownfertility.com",
    "phone": "(877) 260-0352",
    "network": {
      "name": "Brown Fertility"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.brownfertility.com/about/doctors",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2025-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "address": {
      "line1": "1401 Centerville Rd, Ste 705",
      "city": "Tallahassee",
      "state": "FL",
      "zip": "32308",
      "country": "US"
    },
    "location": {
      "lat": 30.4613,
      "lng": -84.2486
    },
    "treatments": [
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Fertility Consultation",
        "category": "diagnostic"
      },
      {
        "name": "Monitoring",
        "category": "diagnostic"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Florida Blue"
      ]
    },
    "languages": ["English", "Spanish"],
    "description": "Brown Fertility satellite office offering fertility consultations and monitoring. Patients may travel to a full-service Brown Fertility center for IVF procedures.",
    "consultationTypes": ["in-person"],
    "setting": "network-group",
    "team": [
      {
        "name": "Erica Lobel, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2025/12/erica_lobel_1-1920x2965.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/erica-lobel",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-tallahassee-erica-lobel-md"
      },
      {
        "name": "Angeline N. Beltsos, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/04/20260319-KKphotography_Studio_114868_Z_8_1-Edit-1-1920x1280.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/angeline-n-beltsos-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-tallahassee-angeline-n-beltsos-md"
      },
      {
        "name": "Maria Crespo-Smith, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/02/crespo_lab_coat_2-1920x2965.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/maria-crespo-smith-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-tallahassee-maria-crespo-smith-md"
      },
      {
        "name": "Peter Casella, MD",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/05/0050_PeterCasella_BrownFertility_26LauraEvans-002-1920x2878.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/peter-casella-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-brown-fertility-tallahassee-peter-casella-md"
      },
      {
        "name": "Hannah Ballester, PA-C",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2025/10/Hannah-Ballester-PA-C-Employee-Headshot-1920x2880.jpg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/hannah-ballester",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "practitionerId": "pr-brown-fertility-tallahassee-hannah-ballester-pa-c"
      },
      {
        "name": "Lauren Hilado",
        "imageUrl": "https://www.brownfertility.com/wp-content/uploads/2026/06/Brown-Fertility-Headshot.jpeg",
        "_source": {
          "url": "https://www.brownfertility.com/doctors/lauren-hilado",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "practitionerId": "pr-brown-fertility-tallahassee-lauren-hilado"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Florida Blue",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "brown-fertility-albany-ga",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Brown Fertility — Albany, GA",
    "website": "https://www.brownfertility.com",
    "phone": "(877) 260-0352",
    "network": {
      "name": "Brown Fertility"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2025-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "address": {
      "line1": "2701 Meredyth Dr",
      "city": "Albany",
      "state": "GA",
      "zip": "31707",
      "country": "US"
    },
    "location": {
      "lat": 31.5505,
      "lng": -84.1226
    },
    "treatments": [
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Fertility Consultation",
        "category": "diagnostic"
      },
      {
        "name": "Monitoring",
        "category": "diagnostic"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "description": "Brown Fertility satellite office offering fertility consultations and monitoring. Patients may travel to a full-service Brown Fertility center for IVF procedures.",
    "consultationTypes": ["in-person"],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "brown-fertility-brunswick-ga",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Brown Fertility — Brunswick, GA",
    "website": "https://www.brownfertility.com",
    "phone": "(877) 260-0352",
    "network": {
      "name": "Brown Fertility"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2025-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "address": {
      "line1": "3025 Shrine Rd, Ste 190",
      "city": "Brunswick",
      "state": "GA",
      "zip": "31520",
      "country": "US"
    },
    "location": {
      "lat": 31.2028,
      "lng": -81.4997
    },
    "treatments": [
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Fertility Consultation",
        "category": "diagnostic"
      },
      {
        "name": "Monitoring",
        "category": "diagnostic"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "description": "Brown Fertility satellite office offering fertility consultations and monitoring. Patients may travel to a full-service Brown Fertility center for IVF procedures.",
    "consultationTypes": ["in-person"],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "brown-fertility-valdosta-ga",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Brown Fertility — Valdosta, GA",
    "website": "https://www.brownfertility.com",
    "phone": "(877) 260-0352",
    "network": {
      "name": "Brown Fertility"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2025-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "address": {
      "line1": "3312 N Oak Ext",
      "city": "Valdosta",
      "state": "GA",
      "zip": "31602",
      "country": "US"
    },
    "location": {
      "lat": 30.8577,
      "lng": -83.2785
    },
    "treatments": [
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Fertility Consultation",
        "category": "diagnostic"
      },
      {
        "name": "Monitoring",
        "category": "diagnostic"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "description": "Brown Fertility satellite office offering fertility consultations and monitoring. Patients may travel to a full-service Brown Fertility center for IVF procedures.",
    "consultationTypes": ["in-person"],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "brown-fertility-thomasville-ga",
    "externalIds": {
      "googlePlaceId": "ChIJr6s3-jK07YgREJW4-wUBCQc"
    },
    "type": "fertility-clinic",
    "name": "Brown Fertility — Thomasville, GA",
    "website": "https://www.brownfertility.com",
    "phone": "(877) 260-0352",
    "network": {
      "name": "Brown Fertility"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Thomasville,+GA/@30.8365815,-83.9787808,3426a,13.1y/data=!4m2!3m1!1s0x88edb432fa37abaf:0x7090105fbb89510",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2025-03-11",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "address": {
      "line1": "Thomasville",
      "city": "Thomasville",
      "state": "GA",
      "zip": "31792",
      "country": "US"
    },
    "location": {
      "lat": 30.8366,
      "lng": -83.9788
    },
    "treatments": [
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Fertility Consultation",
        "category": "diagnostic"
      },
      {
        "name": "Monitoring",
        "category": "diagnostic"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English", "Spanish"],
    "description": "Brown Fertility satellite office offering fertility consultations and monitoring. Patients may travel to a full-service Brown Fertility center for IVF procedures.",
    "consultationTypes": ["in-person"],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmX0q0cELyhLKxt_J48vNT5ydAF7ORJh37T1s__Ke-120FLCcP96YK6Fp6pGBmi2_qSgHQt0Nr4RDYNmGXBopt-wr9K4gsuWokXZPnEfXs-7zrwUiMUm_kXBjURfY6QlsFljEs=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Thomasville,+GA/@30.8365815,-83.9787808,3426a,13.1y/data=!4m2!3m1!1s0x88edb432fa37abaf:0x7090105fbb89510",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-pharmacy-alto",
    "externalIds": {},
    "type": "pharmacy",
    "name": "Alto Pharmacy",
    "description": "Alto is a full-service pharmacy with same-day delivery, in-app injection training videos, and 24/7 pharmacist chat. Specializes in fertility, oncology, and specialty medications. Alto was acquired by Fuze Health in 2025 (alongside Truepill and LetsGetChecked); fertility services are being consolidated under the Fuze Health brand.",
    "website": "https://alto.com",
    "phone": "(415) 941-4286",
    "address": {
      "line1": "645 Harrison St, Suite 200",
      "city": "San Francisco",
      "state": "CA",
      "zip": "94107",
      "country": "US"
    },
    "location": {
      "lat": 37.7815,
      "lng": -122.3965
    },
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://alto.com",
        "fetchedAt": "2026-03-18"
      },
      "carriers": [
        "Aetna",
        "Anthem Blue Cross",
        "Blue Shield",
        "Cigna",
        "United Healthcare",
        "Humana"
      ]
    },
    "specialties": [
      "fertility",
      "same-day-delivery",
      "injection-training",
      "cold-chain"
    ],
    "pharmacyDetails": {
      "delivery": {
        "sameDayCities": ["San Francisco", "San Jose"],
        "overnightNationwide": true
      }
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-research",
      "date": "2026-03-18",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-18",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross, Blue Shield, Cigna, United Healthcare, Humana",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://alto.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-pharmacy-mdr",
    "externalIds": {},
    "type": "pharmacy",
    "name": "MDR Pharmacy",
    "description": "MDR Pharmacy is an independent specialty pharmacy in Encino, CA known for competitive cash pricing on fertility medications. Offers free next-day nationwide shipping and nurse-led injection training.",
    "website": "https://mdrusa.com",
    "phone": "(800) 515-3784",
    "address": {
      "line1": "16311 Ventura Blvd, Suite 515",
      "city": "Encino",
      "state": "CA",
      "zip": "91436",
      "country": "US"
    },
    "location": {
      "lat": 34.1584,
      "lng": -118.4979
    },
    "insurance": {
      "accepted": false,
      "_source": {
        "url": "https://mdrusa.com",
        "fetchedAt": "2026-03-18"
      },
      "carriers": []
    },
    "specialties": [
      "fertility",
      "cash-pay",
      "price-match",
      "injection-training",
      "cold-chain"
    ],
    "pharmacyDetails": {
      "delivery": {
        "coldChain": true,
        "sameDayCities": [
          "Los Angeles",
          "Orange County",
          "San Diego",
          "San Francisco",
          "Oakland",
          "San Jose",
          "Sacramento"
        ],
        "overnightNationwide": true
      }
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-research",
      "date": "2026-03-18",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-18",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-pharmacy-freedom",
    "externalIds": {},
    "type": "pharmacy",
    "name": "Freedom Fertility Pharmacy",
    "description": "Freedom Fertility Pharmacy, part of Evernorth (Express Scripts), is one of the largest specialty fertility pharmacies in the US. Offers free overnight shipping, 24/7 fertility specialists, and is a participating TrumpRx pharmacy for EMD Serono medications.",
    "website": "https://freedomfertility.com",
    "phone": "(800) 660-4283",
    "address": {
      "line1": "12 Topsfield Rd",
      "city": "Byfield",
      "state": "MA",
      "zip": "01922",
      "country": "US"
    },
    "location": {
      "lat": 42.7551,
      "lng": -70.9481
    },
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://freedomfertility.com",
        "fetchedAt": "2026-03-18"
      },
      "carriers": [
        "Aetna",
        "Anthem Blue Cross",
        "Blue Cross Blue Shield",
        "Cigna",
        "Express Scripts",
        "United Healthcare"
      ]
    },
    "specialties": [
      "fertility",
      "trumprx-participating",
      "overnight-shipping",
      "cold-chain"
    ],
    "_enrichment": {
      "status": "enriched",
      "source": "manual-research",
      "date": "2026-03-18",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-18",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross, Blue Cross Blue Shield, Cigna, Express Scripts, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://freedomfertility.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-pharmacy-vfp",
    "externalIds": {},
    "type": "pharmacy",
    "name": "VFP Pharmacy Group",
    "description": "VFP Pharmacy Group (formerly Village Fertility Pharmacy) operates specialty fertility pharmacies in Waltham MA, Chicago, Phoenix, and Los Angeles. A participating TrumpRx pharmacy offering EMD Serono fertility medications at discounted prices.",
    "website": "https://vfppharmacygroup.com",
    "phone": "(866) 266-0868",
    "address": {
      "line1": "411 Waverley Oaks Rd, Suite 154",
      "city": "Waltham",
      "state": "MA",
      "zip": "02452",
      "country": "US"
    },
    "location": {
      "lat": 42.3884,
      "lng": -71.2369
    },
    "insurance": {
      "accepted": false,
      "_source": {
        "url": "https://vfppharmacygroup.com",
        "fetchedAt": "2026-03-18"
      },
      "carriers": []
    },
    "specialties": [
      "fertility",
      "trumprx-participating",
      "injection-training",
      "same-day-delivery",
      "cold-chain"
    ],
    "_enrichment": {
      "status": "enriched",
      "source": "manual-research",
      "date": "2026-03-18",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-18",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-pharmacy-mandells",
    "externalIds": {},
    "type": "pharmacy",
    "name": "Mandell's Pharmacy",
    "description": "Mandell's Pharmacy is an independent specialty pharmacy in Modesto, CA specializing in fertility medications. Known for automatic discount application and competitive pricing.",
    "website": "https://mymandellspharmacy.com",
    "phone": "(209) 524-2436",
    "address": {
      "line1": "1213 Coffee Rd",
      "city": "Modesto",
      "state": "CA",
      "zip": "95355",
      "country": "US"
    },
    "location": {
      "lat": 37.6583,
      "lng": -121.0088
    },
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://mymandellspharmacy.com",
        "fetchedAt": "2026-03-18"
      },
      "carriers": ["Aetna", "Anthem Blue Cross", "Cigna", "United Healthcare"]
    },
    "specialties": [
      "fertility",
      "injection-training",
      "automatic-discounts",
      "cold-chain"
    ],
    "pharmacyDetails": {
      "compoundingOnSite": true,
      "publishedPrices": {
        "sourceUrl": "https://www.mymandellspharmacy.com/drug-pricing/",
        "verifiedOn": "2026-08-25",
        "items": [
          {
            "medication": "Gonal-F 300 IU Pen",
            "price": 168
          },
          {
            "medication": "Gonal-F 450 IU Pen",
            "price": 252
          },
          {
            "medication": "Gonal-F 450 IU Vial",
            "price": 252
          },
          {
            "medication": "Gonal-F 900 IU Pen",
            "price": 504
          },
          {
            "medication": "Menopur 75 IU Vial",
            "price": 95
          },
          {
            "medication": "Ganirelix 250mcg PFS",
            "price": 49.9
          },
          {
            "medication": "Cetrotide 0.25mg Kit",
            "price": 22.5
          },
          {
            "medication": "Ovidrel 250mcg PFS",
            "price": 84
          },
          {
            "medication": "Chorionic Gonadotropin (HCG) 10,000 U Vial",
            "price": 149.9
          },
          {
            "medication": "Novarel 5,000 U Vial",
            "price": 109
          },
          {
            "medication": "Progesterone in Sesame Oil 50mg/ml Vial",
            "price": 49.5
          }
        ]
      }
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-research",
      "date": "2026-03-18",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-18",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://mymandellspharmacy.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-pharmacy-smp",
    "externalIds": {},
    "type": "pharmacy",
    "name": "SMP Pharmacy",
    "description": "SMP Pharmacy is a specialty pharmacy providing fertility, oncology, and other specialty medications. Offers 24/7 pharmacist access, injection training, and free 2-day shipping.",
    "website": "https://smppharmacy.com",
    "phone": "(800) 539-3411",
    "address": {
      "line1": "395 S. Main St",
      "city": "Fall River",
      "state": "MA",
      "zip": "02721",
      "country": "US"
    },
    "location": {
      "lat": 41.7015,
      "lng": -71.155
    },
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://smppharmacy.com",
        "fetchedAt": "2026-03-18"
      },
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "specialties": ["fertility", "injection-training", "cold-chain"],
    "pharmacyDetails": {
      "compoundingOnSite": true
    },
    "_enrichment": {
      "status": "enriched",
      "source": "manual-research",
      "date": "2026-03-18",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-18",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://smppharmacy.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-pharmacy-cvs-specialty",
    "externalIds": {},
    "type": "pharmacy",
    "name": "CVS Specialty",
    "description": "CVS Specialty handles specialty medications including fertility drugs. Offers in-store pickup at CVS locations or shipping. 24/7 pharmacist access and auto-refill.",
    "website": "https://cvs.com/specialty",
    "phone": "(800) 237-2767",
    "address": {
      "line1": "",
      "city": "Plainville",
      "state": "CT",
      "zip": "06062",
      "country": "US"
    },
    "location": {
      "lat": 41.6868,
      "lng": -72.8475
    },
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://cvs.com/specialty",
        "fetchedAt": "2026-03-18"
      },
      "carriers": [
        "Aetna",
        "Anthem Blue Cross",
        "Blue Cross Blue Shield",
        "Caremark",
        "Cigna",
        "Express Scripts",
        "Humana",
        "United Healthcare"
      ]
    },
    "specialties": ["fertility", "retail", "in-store-pickup", "cold-chain"],
    "_enrichment": {
      "status": "enriched",
      "source": "manual-research",
      "date": "2026-03-18",
      "sections": {
        "team": {
          "status": "verified-none",
          "source": {
            "url": "https://cvs.com/specialty",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://cvs.com/specialty",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://cvs.com/specialty",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-18",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [],
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross, Blue Cross Blue Shield, Caremark, Cigna, Express Scripts, Humana, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://cvs.com/specialty",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Connecticut (CT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-pharmacy-walgreens-specialty",
    "externalIds": {},
    "type": "pharmacy",
    "name": "Walgreens Specialty Pharmacy",
    "description": "Walgreens Specialty Pharmacy provides fertility medications with in-store pickup or overnight shipping. Features interactive injection training tools and 24/7 pharmacist access.",
    "website": "https://walgreens.com/specialty",
    "phone": "(888) 347-3416",
    "address": {
      "line1": "",
      "city": "Deerfield",
      "state": "IL",
      "zip": "60062",
      "country": "US"
    },
    "location": {
      "lat": 42.1487,
      "lng": -87.825
    },
    "insurance": {
      "accepted": true,
      "_source": {
        "url": "https://walgreens.com/specialty",
        "fetchedAt": "2026-03-18"
      },
      "carriers": [
        "Aetna",
        "Anthem Blue Cross",
        "Blue Cross Blue Shield",
        "Cigna",
        "Humana",
        "Optum",
        "United Healthcare"
      ]
    },
    "specialties": [
      "fertility",
      "retail",
      "injection-training",
      "overnight-delivery",
      "cold-chain"
    ],
    "_enrichment": {
      "status": "enriched",
      "source": "manual-research",
      "date": "2026-03-18",
      "sections": {
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-03-18",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Anthem Blue Cross, Blue Cross Blue Shield, Cigna, Humana, Optum, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://walgreens.com/specialty",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-ca-missing-acacio-fertility-center",
    "externalIds": {
      "cdcClinicId": "486",
      "googlePlaceId": "ChIJKweycfNp6oAR_ZwiR8ZGOUo"
    },
    "type": "fertility-clinic",
    "name": "Acacio Fertility Center",
    "phone": "(661) 326-8066",
    "address": {
      "line1": "2225 19th Street",
      "city": "Bakersfield",
      "state": "CA",
      "zip": "93301",
      "country": "US"
    },
    "location": {
      "lat": 35.3762,
      "lng": -119.0274
    },
    "website": "https://www.acaciofertility.com",
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Sperm Retrieval (TESE/microTESE)",
        "category": "surgical"
      }
    ],
    "_source": {
      "url": "https://www.acaciofertility.com",
      "fetchedAt": "2026-06-10"
    },
    "_enrichment": {
      "status": "draft",
      "notes": "CDC 2022 lists this clinic at 27882 Forbes Rd Suite 200, Laguna Niguel, CA 92677, phone (949) 249-9200 (CDC clinic id 486). The clinic website states the Laguna Niguel office 'has relocated to our Bakersfield location permanently'; address and phone above are the current Bakersfield location from the website. Treatments taken from website service list (IVF, ICSI, IUI, Pre-Implantation Genetic Testing, Egg Donation, Embryo Donation, Gestational Surrogacy, Oocyte Cryopreservation/Fertility Preservation, Testicular Sperm Extraction).",
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://www.acaciofertility.com/contact-us/laguna-niguel",
            "fetchedAt": "2026-06-10"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.acaciofertility.com",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.acaciofertility.com/meet-the-team/the-team",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Acacio+Fertility+Center,+2225+19th+St,+Bakersfield,+CA+93301/@35.3760733,-119.0277112,3253a,13.1y/data=!4m2!3m1!1s0x80ea69f371b2072b:0x4a3946c647229cfd",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-ca-missing-acacio-fertility-center-brian-acacio",
        "name": "Brian Acacio",
        "credentials": ["MD"],
        "role": "Clinic director",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.acaciofertility.com/images/dr-acacio.jpg",
        "_source": {
          "url": "https://www.acaciofertility.com/meet-the-team/dr-acacio",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ca-missing-acacio-fertility-center-dwight-hiscox",
        "name": "Dwight Hiscox",
        "credentials": ["MD"],
        "role": "Anesthesiologist",
        "_source": {
          "url": "https://www.acaciofertility.com/meet-the-team/the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ca-missing-acacio-fertility-center-terry-tennyson",
        "name": "Terry Tennyson",
        "role": "Practice Manager",
        "_source": {
          "url": "https://www.acaciofertility.com/meet-the-team/the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ca-missing-acacio-fertility-center-john-scodras",
        "name": "John Scodras",
        "credentials": ["PhD"],
        "role": "Embryologist",
        "_source": {
          "url": "https://www.acaciofertility.com/meet-the-team/the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ca-missing-acacio-fertility-center-lana-gangnes",
        "name": "Lana Gangnes",
        "credentials": ["R.N."],
        "role": "Clinic Director",
        "_source": {
          "url": "https://www.acaciofertility.com/meet-the-team/the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ca-missing-acacio-fertility-center-alyssa-tafoya",
        "name": "Alyssa Tafoya",
        "role": "Junior Embryologist",
        "_source": {
          "url": "https://www.acaciofertility.com/meet-the-team/the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ca-missing-acacio-fertility-center-karin-grisham",
        "name": "Karin Grisham",
        "credentials": ["R.N."],
        "role": "3rd Party Clinical Coordinator",
        "_source": {
          "url": "https://www.acaciofertility.com/meet-the-team/the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ca-missing-acacio-fertility-center-kasey-davis",
        "name": "Kasey Davis",
        "credentials": ["M.A."],
        "role": "IVF Coordinator",
        "_source": {
          "url": "https://www.acaciofertility.com/meet-the-team/the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ca-missing-acacio-fertility-center-lynn-martinez",
        "name": "Lynn Martinez",
        "credentials": ["M.A."],
        "_source": {
          "url": "https://www.acaciofertility.com/meet-the-team/the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ca-missing-acacio-fertility-center-viridiana-durazo",
        "name": "Viridiana Durazo",
        "role": "Licensed Vocational Nurse, Bakersfield",
        "_source": {
          "url": "https://www.acaciofertility.com/meet-the-team/the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ca-missing-acacio-fertility-center-ashley-hurtado",
        "name": "Ashley Hurtado",
        "role": "Licensed Vocational Nurse, Bakersfield",
        "_source": {
          "url": "https://www.acaciofertility.com/meet-the-team/the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ca-missing-acacio-fertility-center-mariana-solis",
        "name": "Mariana Solis",
        "role": "Financial Coordinator",
        "_source": {
          "url": "https://www.acaciofertility.com/meet-the-team/the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ca-missing-acacio-fertility-center-paula-mceachern",
        "name": "Paula McEachern",
        "role": "Billing Specialist",
        "_source": {
          "url": "https://www.acaciofertility.com/meet-the-team/the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ca-missing-acacio-fertility-center-pamela-ha",
        "name": "Pamela Ha",
        "role": "Administrative Assistant",
        "_source": {
          "url": "https://www.acaciofertility.com/meet-the-team/the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ca-missing-acacio-fertility-center-nicole-de-vos",
        "name": "Nicole De Vos",
        "role": "Licensed Vocational Nurse",
        "_source": {
          "url": "https://www.acaciofertility.com/meet-the-team/the-team",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "description": "Acacio Fertility Center is a Bakersfield fertility practice led by Brian Acacio, MD, offering evaluation and treatment for infertility with services that include IVF, IUI, fertility preservation, genetic testing, egg donation, sperm donation, and gestational carrier programs. The practice has permanently relocated from its prior Orange County address to 2225 19th Street in Bakersfield.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmVLiFlAPCivnLF94i7QgbnRCPTP-VD9HT9rkljojSX_HmLbJuPEqFLswTGgSRfs323AJd-Ijfb1f6iTQjotWo2RLDmhTmOhvJzUFXstEJExfoNljNfk7V3il4rEheBIJKHtELn=w298-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Acacio+Fertility+Center,+2225+19th+St,+Bakersfield,+CA+93301/@35.3760733,-119.0277112,3253a,13.1y/data=!4m2!3m1!1s0x80ea69f371b2072b:0x4a3946c647229cfd",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-ca-missing-ivf-fertility-center",
    "externalIds": {
      "cdcClinicId": "935"
    },
    "type": "fertility-clinic",
    "name": "IVF Fertility Center",
    "phone": "(310) 888-8448",
    "address": {
      "line1": "16055 Ventura Blvd, Suite 700",
      "city": "Encino",
      "state": "CA",
      "zip": "91436",
      "country": "US"
    },
    "location": {
      "lat": 34.1567,
      "lng": -118.4833
    },
    "website": "https://kuofertility.com",
    "languages": ["Mandarin Chinese"],
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "_source": {
      "url": "https://kuofertility.com",
      "fetchedAt": "2026-06-10"
    },
    "_enrichment": {
      "status": "draft",
      "notes": "Dr. John Kuo's clinic; part of the Ivy Fertility network. ivffertilitycenter.com 301-redirects to kuofertility.com. Address and phone on the website match the CDC 2022 listing (clinic id 935). Treatments from website treatment pages (IVF with ICSI described on /treatments/ivf, IUI, Egg Freezing, Genetic Testing, Egg Donor Services, Surrogacy, Fertility Preservation). Languages: website states Dr. Kuo is fluent in Mandarin Chinese.",
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://kuofertility.com",
            "fetchedAt": "2026-06-10"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://kuofertility.com/treatments",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://kuofertility.com/locations/encino-clinic",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://kuofertility.com/locations/encino-clinic",
            "fetchedAt": "2026-06-10"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-ca-missing-ivf-fertility-center-john-kuo",
        "name": "John Kuo",
        "credentials": ["MD", "PhD"],
        "role": "Physician and founder",
        "imageUrl": "https://a.storyblok.com/f/290132/466x698/22a2d4b0e6/dr-john-kuo.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://kuofertility.com/locations/encino-clinic",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ca-missing-ivf-fertility-center-yvonne-han",
        "name": "Yvonne Han",
        "credentials": ["HCLD"],
        "role": "Laboratory Director",
        "imageUrl": "https://kuofertility.com/_astro/filters_no_upscale()_Z1MbuqS.webp",
        "_source": {
          "url": "https://kuofertility.com/our-lab",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "images": [
      {
        "url": "https://kuofertility.com/_astro/filters_no_upscale()_1Eh4eU.webp",
        "type": "interior",
        "_source": {
          "url": "https://kuofertility.com/our-lab",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "url": "https://kuofertility.com/_astro/filters_no_upscale()_WhUFQ.webp",
        "type": "interior",
        "_source": {
          "url": "https://kuofertility.com/our-lab",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "url": "https://kuofertility.com/_astro/filters_no_upscale()_4zKEK.webp",
        "type": "interior",
        "_source": {
          "url": "https://kuofertility.com/our-lab",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "description": "IVF Fertility Center, now presented as Kuo Fertility on its official site, is an Encino fertility clinic founded by John Kuo, MD, PhD. The clinic offers fertility evaluation and treatment with an in-house laboratory led by certified High Complexity Laboratory Director Yvonne Han.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-ca-missing-la-jolla-ivf",
    "externalIds": {
      "cdcClinicId": "134"
    },
    "type": "fertility-clinic",
    "name": "La Jolla IVF",
    "phone": "(858) 558-2221",
    "address": {
      "line1": "9850 Genesee Ave, Suite 610",
      "city": "La Jolla",
      "state": "CA",
      "zip": "92037",
      "country": "US"
    },
    "location": {
      "lat": 32.8828,
      "lng": -117.2265
    },
    "website": "https://www.lajollaivf.com",
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "_source": {
      "url": "https://www.lajollaivf.com",
      "fetchedAt": "2026-06-10"
    },
    "_enrichment": {
      "status": "draft",
      "notes": "Dr. David Smotrich's clinic. Address and phone on the website match the CDC 2022 listing (clinic id 134). Treatments from website service pages (IVF with ICSI used routinely per /service/ivf, IUI, Egg Freezing & Banking, Genetic Testing, Egg Donation, Surrogacy). Site also mentions sperm retrieval and gender selection without procedure-level detail.",
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://www.lajollaivf.com/about",
            "fetchedAt": "2026-06-10"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.lajollaivf.com/services",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.lajollaivf.com/providers",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-ca-missing-la-jolla-ivf-david-b-smotrich",
        "name": "David B. Smotrich",
        "credentials": ["MD", "FACOG"],
        "role": "Founder, Medical Director, and Infertility and IVF Specialist",
        "specialty": "Infertility & IVF Specialist",
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/1d573e2a807d37b45d5442873954bd519f7ebbab/images/2686394.jpeg",
        "_source": {
          "url": "https://www.lajollaivf.com/provider/david-b-smotrich-md-facog",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "description": "La Jolla IVF is a La Jolla fertility practice led by founder and medical director David B. Smotrich, MD, FACOG. The clinic provides infertility and IVF care from its Genesee Avenue office.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-ca-missing-williams-obgyn-associates",
    "externalIds": {
      "cdcClinicId": "90"
    },
    "type": "fertility-clinic",
    "name": "Williams OB/GYN & Associates",
    "phone": "(909) 599-8677",
    "address": {
      "line1": "315 E. Route 66, Suite 201",
      "city": "Glendora",
      "state": "CA",
      "zip": "91740",
      "country": "US"
    },
    "location": {
      "lat": 34.1291,
      "lng": -117.8319
    },
    "website": "https://www.williamsobgyn.com",
    "treatments": [],
    "_source": {
      "url": "https://www.williamsobgyn.com",
      "fetchedAt": "2026-06-10"
    },
    "_enrichment": {
      "status": "draft",
      "notes": "CDC 2022 lists this practice at 1334 W. Covina Blvd, Suite 102, San Dimas, CA 91773 (clinic id 90). The practice website now lists only a Glendora office (315 E. Route 66 #201, Glendora, CA 91740) with the same phone number, so the address above is the current website address. The website names 'Infertility' among its services but does not list any specific fertility procedures (no IVF/IUI/etc.), so treatments are left empty. Geocode resolved at road level within Glendora (Nominatim returned no house-number match), so lat/lng is approximate.",
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://www.williamsobgyn.com/contact-us/",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.williamsobgyn.com/staff/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.williamsobgyn.com",
            "fetchedAt": "2026-06-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-ca-missing-williams-obgyn-associates-richard-anthony-williams",
        "name": "Richard Anthony Williams",
        "credentials": ["M.D.", "F.A.C.O.G."],
        "role": "OBGYN",
        "imageUrl": "https://cdcssl.ibsrv.net/ibimg/smb/498x738_80/webmgr/1k/u/w/drwilliams-11.jpg.webp?62e8c549eba8c4806a85ca3398065705",
        "_source": {
          "url": "https://www.williamsobgyn.com/staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ca-missing-williams-obgyn-associates-tina-l-moon",
        "name": "Tina L. Moon",
        "credentials": ["MS", "PAC"],
        "role": "Physicians Assistant",
        "imageUrl": "https://cdcssl.ibsrv.net/ibimg/smb/300x399_80/webmgr/1k/u/w/tina-moon-pa.jpg.webp?7ff277e40b66870dfa9052712af6a12c",
        "_source": {
          "url": "https://www.williamsobgyn.com/staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ca-missing-williams-obgyn-associates-megan-tolle",
        "name": "Megan Tolle",
        "role": "MA",
        "imageUrl": "https://cdcssl.ibsrv.net/ibimg/smb/330x439_80/webmgr/1k/u/w/nurse.jpg.webp?df7d979376621d727a78f59bb155e211",
        "_source": {
          "url": "https://www.williamsobgyn.com/staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ca-missing-williams-obgyn-associates-jackie-santisteban",
        "name": "Jackie Santisteban",
        "role": "Surgery Scheduling",
        "imageUrl": "https://cdcssl.ibsrv.net/ibimg/smb/324x432_80/webmgr/1k/u/w/IMG_7668.jpg.webp?ecbb17d3ac94ef081258b07912f53173",
        "_source": {
          "url": "https://www.williamsobgyn.com/staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ca-missing-williams-obgyn-associates-ellen-dempsey",
        "name": "Ellen Dempsey",
        "role": "Front Admin",
        "imageUrl": "https://cdcssl.ibsrv.net/ibimg/smb/310x465_80/webmgr/1k/u/w/Ellen%20Clean.png.webp?cef092c827d598782e5869c355d4f463",
        "_source": {
          "url": "https://www.williamsobgyn.com/staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ca-missing-williams-obgyn-associates-desiree-amiri",
        "name": "Desiree Amiri",
        "role": "Front Admin",
        "imageUrl": "https://cdcssl.ibsrv.net/ibimg/smb/340x453_80/webmgr/1k/u/w/Desiree.jpg.webp?8b887fdc3d4353bdbba7fe1ba89f354e",
        "_source": {
          "url": "https://www.williamsobgyn.com/staff/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ca-missing-williams-obgyn-associates-rosa-gomez",
        "name": "Rosa Gomez",
        "role": "Prior Authorization Medication",
        "imageUrl": "https://cdcssl.ibsrv.net/ibimg/smb/310x465_80/webmgr/1k/u/w/Rosa%20clean.png.webp?4f1bd4da6ad86e1a1bb702d4b101184c",
        "_source": {
          "url": "https://www.williamsobgyn.com/staff/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "description": "Williams OB/GYN & Associates is a Glendora obstetrics and gynecology practice led by Richard Anthony Williams, MD, FACOG. The practice includes fertility-related care within a broader women's health setting and currently lists its office at 315 E. Route 66, Suite 201 in Glendora.",
    "images": [
      {
        "url": "https://cdcssl.ibsrv.net/ibimg/smb/1798x1349_80/webmgr/1k/u/w/Lobby.jpeg.webp?1957ba033bb11e24647a6f31a33083f9",
        "type": "interior",
        "caption": "Williams OB/GYN lobby",
        "_source": {
          "url": "https://www.williamsobgyn.com",
          "fetchedAt": "2026-06-11"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-ca-missing-naval-medical-center-san-diego-infertility-clinic",
    "externalIds": {
      "cdcClinicId": "197"
    },
    "type": "fertility-clinic",
    "name": "Naval Medical Center San Diego Infertility Clinic",
    "phone": "(619) 532-5363",
    "address": {
      "line1": "34800 Bob Wilson Dr",
      "city": "San Diego",
      "state": "CA",
      "zip": "92134",
      "country": "US"
    },
    "location": {
      "lat": 32.726,
      "lng": -117.1451
    },
    "website": "https://sandiego.tricare.mil",
    "treatments": [
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      },
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "_source": {
      "url": "https://data.cdc.gov/resource/ix4g-rt8v.json",
      "fetchedAt": "2026-06-10"
    },
    "_enrichment": {
      "status": "draft",
      "notes": "Military treatment facility (TRICARE) serving military beneficiaries only; it is part of Naval Medical Center San Diego, whose official site is sandiego.tricare.mil. The site blocks automated access (HTTP 403 on 2026-06-10), so no treatments or contact details could be scraped from it; identity data is from the CDC 2022 ART Services & Profiles dataset (clinic id 197).",
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://data.cdc.gov/resource/ix4g-rt8v.json",
            "fetchedAt": "2026-06-10"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "description": "Naval Medical Center San Diego's official Women's Health & Pregnancy pages list Reproductive Endocrinology and Infertility as an OB/GYN subspecialty clinic, including evaluation and treatment of infertility and in vitro fertilization. The page for infertility services says services offered include ovulation induction, intrauterine insemination (IUI), in vitro fertilization (IVF) with a patient's own eggs or donor eggs, and fertility preservation for eligible beneficiaries.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-ca-missing-the-fertility-institutes",
    "externalIds": {
      "cdcClinicId": "28"
    },
    "type": "fertility-clinic",
    "name": "The Fertility Institutes",
    "phone": "(818) 728-4600",
    "address": {
      "line1": "16030 Ventura Blvd, Suite 404",
      "city": "Encino",
      "state": "CA",
      "zip": "91436",
      "country": "US"
    },
    "location": {
      "lat": 34.1561,
      "lng": -118.4822
    },
    "website": "https://www.fertility-docs.com",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Tubal / vasectomy reversal",
        "category": "surgical"
      },
      {
        "name": "PRP",
        "category": "wellness"
      }
    ],
    "_source": {
      "url": "https://www.fertility-docs.com",
      "fetchedAt": "2026-06-10"
    },
    "_enrichment": {
      "status": "draft",
      "notes": "Dr. Jeffrey Steinberg's clinic; CDC 2022 facility name is 'The Fertility Institutes-Los Angeles, New York, Guadalajara' (clinic id 28). Website lists the office as '16030 Ventura Boulevard Suite 404, Los Angeles, CA 91436'; city kept as Encino per CDC (Encino is the LA neighborhood for this address) and phone matches CDC. Treatments from website programs-and-services pages (IVF, Egg/Embryo/Oocyte Freezing and Preservation Options, PGD Genetic Screening, Egg Donors, Surrogacy, Vasectomy and Tubal Ligation Reversal, PRP). ICSI is mentioned only in a historical context, so plain 'IVF' is used. The site also prominently offers gender selection and eye color selection, which have no equivalent in the dataset taxonomy.",
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertility-docs.com",
            "fetchedAt": "2026-06-10"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertility-docs.com/programs-and-services/",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertility-docs.com/about-us/clinics-and-staff/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-ca-missing-the-fertility-institutes-jeffrey-steinberg",
        "name": "Jeffrey Steinberg",
        "role": "U.S. Institutes Director",
        "specialty": "reproductive endocrinologist",
        "imageUrl": "https://www.fertility-docs.com/wp-content/uploads/2026/03/1773428912_dr-jeffrey-steinberg-2-1.jpg",
        "_source": {
          "url": "https://www.fertility-docs.com/about-us/clinics-and-staff/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "description": "The Fertility Institutes is a fertility clinic network whose Los Angeles area center is directed by Jeffrey Steinberg. The Los Angeles location lists IVF and reproductive endocrinology services from its Ventura Boulevard office.",
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-kp-santa-clara-arques",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Kaiser Permanente Center for Reproductive Health - Santa Clara Arques",
    "description": "Kaiser Permanente's Santa Clara Arques Medical Offices include a Reproductive Endocrinology and Infertility clinic in Sunnyvale. The official Kaiser IVF locations page lists IVF and male infertility services at this location, with procedures supported through Kaiser Permanente Centers for Reproductive Health hubs.",
    "website": "https://www.kpivf.com/locations/",
    "phone": "(408) 530-6800",
    "address": {
      "line1": "1263 East Arques Avenue",
      "line2": "Arques Medical Offices",
      "city": "Sunnyvale",
      "state": "CA",
      "zip": "94085",
      "country": "US"
    },
    "location": {
      "lat": 37.3812919,
      "lng": -121.9896983
    },
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "16:30"
      },
      "tue": {
        "open": "08:00",
        "close": "16:30"
      },
      "wed": {
        "open": "08:00",
        "close": "16:30"
      },
      "thu": {
        "open": "08:00",
        "close": "16:30"
      },
      "fri": {
        "open": "08:00",
        "close": "17:00"
      },
      "sat": null,
      "sun": null
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": ["Kaiser Permanente"],
      "_source": {
        "url": "https://www.kpivf.com/locations/",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["English"],
    "consultationTypes": ["in-person"],
    "network": {
      "name": "Kaiser Permanente Centers for Reproductive Health"
    },
    "team": [
      {
        "practitionerId": "pr-org-kp-santa-clara-arques-nikhil-joshi",
        "name": "Nikhil Joshi",
        "credentials": ["MD"],
        "role": "Reproductive Endocrinology and In Vitro Fertilization Specialist",
        "specialty": "In Vitro Fertilization",
        "imageUrl": "https://www.kpivf.com/content/uploads/2019/11/Nikhil-Joshi-crop.jpg",
        "_source": {
          "url": "https://www.kpivf.com/locations/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-kp-santa-clara-arques-david-guo",
        "name": "David Guo",
        "credentials": ["MD"],
        "role": "Urologist, Male Infertility Specialist",
        "specialty": "Male Infertility Services",
        "imageUrl": "https://www.kpivf.com/content/uploads/2026/03/David-Guo.png",
        "_source": {
          "url": "https://www.kpivf.com/locations/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-kp-santa-clara-arques-james-stinson",
        "name": "James Stinson",
        "credentials": ["MD"],
        "role": "Urologist, Male Infertility Specialist",
        "specialty": "Male Infertility Services",
        "imageUrl": "https://www.kpivf.com/content/uploads/2026/03/james-Stinson.png",
        "_source": {
          "url": "https://www.kpivf.com/locations/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-kp-santa-clara-arques-vaishnavi-purusothaman",
        "name": "Vaishnavi Purusothaman",
        "credentials": ["MD"],
        "role": "Reproductive Endocrinology and In Vitro Fertilization Specialist",
        "specialty": "In Vitro Fertilization",
        "imageUrl": "https://www.kpivf.com/content/uploads/2023/01/0915871_Purusothaman_Vaishnavi_cpm_9-26-2022_IMG_0185-002-002.jpg",
        "_source": {
          "url": "https://www.kpivf.com/locations/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-kp-santa-clara-arques-lisa-farah-eways",
        "name": "Lisa Farah-Eways",
        "credentials": ["MD"],
        "role": "In Vitro Fertilization Program Director, Reproductive Endocrinology and In Vitro Fertilization Specialist",
        "specialty": "In Vitro Fertilization",
        "imageUrl": "https://www.kpivf.com/content/uploads/2019/11/lisa-farah.jpg",
        "_source": {
          "url": "https://www.kpivf.com/locations/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://www.kpivf.com/locations/",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.kpivf.com/locations/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Kaiser Permanente",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kpivf.com/locations/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-kp-san-ramon-bishop-ranch",
    "externalIds": {
      "googlePlaceId": "ChIJH4iglrvzj4AREdbB49NR8qs"
    },
    "type": "fertility-clinic",
    "name": "Kaiser Permanente San Ramon Bishop Ranch - Reproductive Endocrinology and Infertility Clinic",
    "description": "Kaiser Permanente lists a Reproductive Endocrinology and Infertility clinic at its San Ramon Bishop Ranch Medical Offices. The location page identifies two IVF specialists at this office and publishes weekday clinic hours.",
    "website": "https://www.kpivf.com/locations/",
    "phone": "(925) 244-7374",
    "address": {
      "line1": "2300 Camino Ramon",
      "line2": "1st Floor",
      "city": "San Ramon",
      "state": "CA",
      "zip": "94583",
      "country": "US"
    },
    "location": {
      "lat": 37.7753232,
      "lng": -121.9673071
    },
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "16:30"
      },
      "tue": {
        "open": "08:00",
        "close": "16:30"
      },
      "wed": {
        "open": "08:00",
        "close": "16:30"
      },
      "thu": {
        "open": "08:00",
        "close": "16:30"
      },
      "fri": {
        "open": "08:00",
        "close": "16:30"
      },
      "sat": null,
      "sun": null
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": ["Kaiser Permanente"],
      "_source": {
        "url": "https://www.kpivf.com/locations/",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["English"],
    "consultationTypes": ["in-person"],
    "network": {
      "name": "Kaiser Permanente Centers for Reproductive Health"
    },
    "team": [
      {
        "practitionerId": "pr-org-kp-san-ramon-bishop-ranch-rhea-chattopadhyay",
        "name": "Rhea Chattopadhyay",
        "credentials": ["MD"],
        "role": "Reproductive Endocrinology and In Vitro Fertilization Specialist",
        "specialty": "In Vitro Fertilization",
        "imageUrl": "https://www.kpivf.com/content/uploads/2023/01/Rhea-Chattopadhyay-Headshot-2022.jpg",
        "_source": {
          "url": "https://www.kpivf.com/locations/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-kp-san-ramon-bishop-ranch-tracey-telles",
        "name": "Tracey Telles",
        "credentials": ["MD"],
        "role": "Reproductive Endocrinology and In Vitro Fertilization Specialist",
        "specialty": "In Vitro Fertilization",
        "imageUrl": "https://www.kpivf.com/content/uploads/2019/11/tracey-telles.jpg",
        "_source": {
          "url": "https://www.kpivf.com/locations/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://www.kpivf.com/locations/",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.kpivf.com/locations/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Reproductive+Endocrinology+and+Infertility+Clinic+%7C+Kaiser+Permanente+San+Ramon+Bishop+Ranch+Medical+Offices,+2300+Camino+Ramon+%231st,+San+Ramon,+CA+94583/@37.7752884,-121.9669891,3154a,13.1y/data=!4m2!3m1!1s0x808ff3bb96a0881f:0xabf251d3e3c1d611",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Kaiser Permanente",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kpivf.com/locations/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk6TQ2MY5xoczSa5cY_M5F-bB12piPpZJCbcxFlL4zOwN_Cyh113UL0GuwCtA28qSA7-aHLTJ2RpT2VjMKcgBhWNhGJWcRl2Xxp3lub5QcfAMb4VCtvOlElB9N5Aowq_BRr1pH4vA=w661-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Reproductive+Endocrinology+and+Infertility+Clinic+%7C+Kaiser+Permanente+San+Ramon+Bishop+Ranch+Medical+Offices,+2300+Camino+Ramon+%231st,+San+Ramon,+CA+94583/@37.7752884,-121.9669891,3154a,13.1y/data=!4m2!3m1!1s0x808ff3bb96a0881f:0xabf251d3e3c1d611",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-kp-roseville-rei",
    "externalIds": {
      "googlePlaceId": "ChIJr7_0C3ofm4AR-7Nu4I_6ZGs"
    },
    "type": "fertility-clinic",
    "name": "Kaiser Permanente Roseville Medical Center - Reproductive Endocrinology and Infertility Clinic",
    "description": "Kaiser Permanente lists a Reproductive Endocrinology and Infertility clinic at Roseville Medical Center Medical Office Building 2, with weekday and weekend morning hours.",
    "website": "https://www.kpivf.com/locations/",
    "phone": "(916) 614-5005",
    "address": {
      "line1": "1600 Eureka Road",
      "line2": "3rd Floor",
      "city": "Roseville",
      "state": "CA",
      "zip": "95661",
      "country": "US"
    },
    "location": {
      "lat": 38.7474074,
      "lng": -121.2506572
    },
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "16:00"
      },
      "tue": {
        "open": "08:00",
        "close": "16:00"
      },
      "wed": {
        "open": "08:00",
        "close": "16:00"
      },
      "thu": {
        "open": "08:00",
        "close": "16:00"
      },
      "fri": {
        "open": "08:00",
        "close": "16:00"
      },
      "sat": {
        "open": "08:00",
        "close": "11:00"
      },
      "sun": {
        "open": "08:00",
        "close": "11:00"
      }
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": ["Kaiser Permanente"],
      "_source": {
        "url": "https://www.kpivf.com/locations/",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["English"],
    "consultationTypes": ["in-person"],
    "network": {
      "name": "Kaiser Permanente Centers for Reproductive Health"
    },
    "team": [],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://www.kpivf.com/locations/",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "verified-none",
          "source": {
            "url": "https://www.kpivf.com/locations/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kaiser+Permanente+Roseville+Medical+Ctr,+1600+Eureka+Rd,+Roseville,+CA+95661/@38.7464955,-121.2494897,3112a,13.1y/data=!4m2!3m1!1s0x809b1f7a0bf4bfaf:0x6b64fa8fe06eb3fb",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Kaiser Permanente",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kpivf.com/locations/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnWtp63vPbiOZIQU2jXwwWKvBHwnDQoBAXFTHXiKAqEKiVsx2dFVaWIOSxJexHonHs7WQjzcq2fAI1RYQcVyvM2zJTQN1gXdyTQbgFw7PRXy8x1zY1lskYS1Mg9pI0tod7W2B93fg=w408-h725-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kaiser+Permanente+Roseville+Medical+Ctr,+1600+Eureka+Rd,+Roseville,+CA+95661/@38.7464955,-121.2494897,3112a,13.1y/data=!4m2!3m1!1s0x809b1f7a0bf4bfaf:0x6b64fa8fe06eb3fb",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-kp-vacaville-rei",
    "externalIds": {
      "googlePlaceId": "ChIJp3G2XLkjhYARlG4UH5VX4Jk"
    },
    "type": "fertility-clinic",
    "name": "Kaiser Permanente Vacaville Medical Center - Reproductive Endocrinology and Infertility Clinic",
    "description": "Kaiser Permanente lists a Reproductive Endocrinology and Infertility clinic at Vacaville Medical Center, Building A, Suite A31, with weekday and weekend morning hours.",
    "website": "https://www.kpivf.com/locations/",
    "phone": "(707) 624-3215",
    "address": {
      "line1": "1 Quality Drive",
      "line2": "Building A, 3rd Floor, Suite A31",
      "city": "Vacaville",
      "state": "CA",
      "zip": "95688",
      "country": "US"
    },
    "location": {
      "lat": 38.3882169,
      "lng": -121.9387685
    },
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "16:00"
      },
      "tue": {
        "open": "08:00",
        "close": "16:00"
      },
      "wed": {
        "open": "08:00",
        "close": "16:00"
      },
      "thu": {
        "open": "08:00",
        "close": "16:00"
      },
      "fri": {
        "open": "08:00",
        "close": "16:00"
      },
      "sat": {
        "open": "08:00",
        "close": "11:00"
      },
      "sun": {
        "open": "08:00",
        "close": "11:00"
      }
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "Donor programs",
        "category": "art"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": ["Kaiser Permanente"],
      "_source": {
        "url": "https://www.kpivf.com/locations/",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["English"],
    "consultationTypes": ["in-person"],
    "network": {
      "name": "Kaiser Permanente Centers for Reproductive Health"
    },
    "team": [],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://www.kpivf.com/locations/",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "verified-none",
          "source": {
            "url": "https://www.kpivf.com/locations/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Reproductive+Endocrinology+and+Infertility+Clinic+%7C+Kaiser+Permanente+Vacaville+Medical+Center,+1+Quality+Dr,+Vacaville,+CA+95688/@38.3882169,-121.9387685,3127a,13.1y/data=!4m2!3m1!1s0x808523b95cb671a7:0x99e057951f146e94",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Kaiser Permanente",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kpivf.com/locations/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnj8rPSB5hPzfLyBvnd1xRkiztRsqh6Kv-twC0bf5qeZhR01TqJEOJ3Z0iN6CzHuY3cB-rkwlGGhiH8MCokMI3Wt_7JjzcM0xTw3OlZwFwehgB3Z5hdtkaWl9qfoV2_9OOkrMoM=w156-h156-n-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Reproductive+Endocrinology+and+Infertility+Clinic+%7C+Kaiser+Permanente+Vacaville+Medical+Center,+1+Quality+Dr,+Vacaville,+CA+95688/@38.3882169,-121.9387685,3127a,13.1y/data=!4m2!3m1!1s0x808523b95cb671a7:0x99e057951f146e94",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-kp-oakland-male-infertility",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Kaiser Permanente Oakland Medical Center - Male Infertility Program",
    "description": "Kaiser Permanente lists a Department of Urology Male Infertility Program at Oakland Medical Center, Specialty Medical Office Building, with Wayland Hsiao, MD as the named male infertility specialist.",
    "website": "https://www.kpivf.com/locations/",
    "phone": "(510) 752-6789",
    "address": {
      "line1": "3600 Broadway",
      "line2": "Suite 40, Specialty Medical Office Building",
      "city": "Oakland",
      "state": "CA",
      "zip": "94611",
      "country": "US"
    },
    "location": {
      "lat": 37.8234923,
      "lng": -122.2581218
    },
    "schedule": {
      "mon": {
        "open": "09:30",
        "close": "17:00"
      },
      "tue": {
        "open": "09:30",
        "close": "17:00"
      },
      "wed": {
        "open": "09:30",
        "close": "17:00"
      },
      "thu": {
        "open": "09:30",
        "close": "17:00"
      },
      "fri": {
        "open": "09:30",
        "close": "17:00"
      },
      "sat": null,
      "sun": null
    },
    "treatments": [
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": ["Kaiser Permanente"],
      "_source": {
        "url": "https://www.kpivf.com/locations/",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["English"],
    "consultationTypes": ["in-person"],
    "network": {
      "name": "Kaiser Permanente Centers for Reproductive Health"
    },
    "team": [
      {
        "practitionerId": "pr-org-kp-oakland-male-infertility-wayland-hsiao",
        "name": "Wayland Hsiao",
        "credentials": ["MD"],
        "role": "Urologist, Male Infertility Specialist",
        "specialty": "Male Infertility Services",
        "imageUrl": "https://www.kpivf.com/content/uploads/2019/11/wayland-hsiao.jpg",
        "_source": {
          "url": "https://www.kpivf.com/locations/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://www.kpivf.com/locations/",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.kpivf.com/locations/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "setting": "hospital-based",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Kaiser Permanente",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.kpivf.com/locations/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-life-ivf-arcadia",
    "externalIds": {
      "googlePlaceId": "ChIJCa3eXwfbwoAR0V6rda7Djzs"
    },
    "type": "fertility-clinic",
    "name": "Life IVF Center - Arcadia",
    "description": "Life IVF Center lists an Arcadia facility alongside its Irvine location, offering Precision IVF care through the same practice team and in-house lab model described on the official site.",
    "website": "https://lifeivfcenter.com/contact-us/",
    "phone": "626.777.1133",
    "address": {
      "line1": "289 W Huntington Dr",
      "line2": "Suite 400",
      "city": "Arcadia",
      "state": "CA",
      "zip": "91007",
      "country": "US"
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "miniIVF"
      }
    ],
    "insurance": {
      "accepted": true,
      "financingOptions": ["Package pricing", "Discount pricing"],
      "_source": {
        "url": "https://lifeivfcenter.com/contact-us/",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["English", "es", "zh", "ko", "ja", "vi"],
    "consultationTypes": ["in-person", "telehealth"],
    "team": [
      {
        "practitionerId": "pr-org-life-ivf-arcadia-frank-yelian",
        "name": "Frank Yelian",
        "role": "Medical Director",
        "imageUrl": "https://lifeivfcenter.com/wp-content/uploads/2023/01/Group-1261152299.png",
        "credentials": ["MD", "PhD"],
        "specialty": "Fertility Specialist",
        "_source": {
          "url": "https://lifeivfcenter.com/about-us/team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-life-ivf-arcadia-tsung-chieh-jackson-wu",
        "name": "Tsung-Chieh Jackson Wu",
        "credentials": ["MD"],
        "role": "Fertility Specialist",
        "imageUrl": "https://lifeivfcenter.com/wp-content/uploads/2023/07/Rectangle-26575.png",
        "_source": {
          "url": "https://lifeivfcenter.com/about-us/team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-life-ivf-arcadia-salman-okour",
        "name": "Salman Okour",
        "credentials": ["MD"],
        "role": "Fertility Specialist",
        "imageUrl": "https://lifeivfcenter.com/wp-content/uploads/2026/05/Dr.-Okour.png",
        "_source": {
          "url": "https://lifeivfcenter.com/about-us/team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-life-ivf-arcadia-vivian-duong",
        "name": "Vivian Duong",
        "credentials": ["MSN", "FNP-BC"],
        "role": "Nurse Practitioner",
        "imageUrl": "https://lifeivfcenter.com/wp-content/uploads/2026/05/Vivian.png",
        "_source": {
          "url": "https://lifeivfcenter.com/about-us/team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-life-ivf-arcadia-michelle-yu",
        "name": "Michelle Yu",
        "credentials": ["MD", "FACOG"],
        "role": "Fertility Specialist",
        "imageUrl": "https://lifeivfcenter.com/wp-content/uploads/2026/05/Dr.-Yu.png",
        "_source": {
          "url": "https://lifeivfcenter.com/about-us/team/dr-michelle-yu/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-life-ivf-arcadia-samira-shir",
        "name": "Samira Shir",
        "credentials": ["MSN", "FNP-BC"],
        "role": "Nurse Practitioner",
        "imageUrl": "https://lifeivfcenter.com/wp-content/uploads/2026/05/Samira.png",
        "_source": {
          "url": "https://lifeivfcenter.com/about-us/team/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://lifeivfcenter.com/contact-us/",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://lifeivfcenter.com/contact-us/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Life+IVF+Center+Los+Angeles,+289+W+Huntington+Dr+Ste+400,+Arcadia,+CA+91007/@34.1357603,-118.0423484,3302a,13.1y/data=!4m2!3m1!1s0x80c2db075fdead09:0x3b8fc3ae75ab5ed1",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnjVDmRlGIyf6TXAJOObCzVWkQOP26uDI4ifq5svUbW90N4RiEbzyE1mfUDTmvfprgIvLyIJzf9lxhVB6R8s29ooGsDkw9sA1J_6O2mpNQCfVl95wBISGtHceL2ukUWhgPRJd4k=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Life+IVF+Center+Los+Angeles,+289+W+Huntington+Dr+Ste+400,+Arcadia,+CA+91007/@34.1357603,-118.0423484,3302a,13.1y/data=!4m2!3m1!1s0x80c2db075fdead09:0x3b8fc3ae75ab5ed1",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnM55K-Rdd3G1gSZKRcHHDPvaUQYsGNqZhM_lAWVHvnD8w_scMja-ovcc2cjup-Dupw_zsT2RINwJVQ8kUrhXnCaBxtHo7W1sckasfZJBrzmrAunwPz2CqruAe719jqbIR0nlu_RFAzAeyi=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Life+IVF+Center+Los+Angeles,+289+W+Huntington+Dr+Ste+400,+Arcadia,+CA+91007/@34.1357603,-118.0423484,3302a,13.1y/data=!4m2!3m1!1s0x80c2db075fdead09:0x3b8fc3ae75ab5ed1",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-larc-bakersfield",
    "externalIds": {
      "googlePlaceId": "ChIJ69ZmectD6oAR7i-ALefeXUI"
    },
    "type": "fertility-clinic",
    "name": "Los Angeles Reproductive Center - Bakersfield",
    "description": "Los Angeles Reproductive Center lists a Bakersfield clinic on Brimhall Road for patients seeking the practice’s fertility services outside Encino.",
    "website": "https://www.losangelesreproductivecenter.com/locations/our-bakersfield-clinic",
    "phone": "(661) 889-5173",
    "address": {
      "line1": "8305 Brimhall Rd",
      "line2": "Building 1600, Suite 1602",
      "city": "Bakersfield",
      "state": "CA",
      "zip": "93312",
      "country": "US"
    },
    "location": {
      "lat": 35.36868,
      "lng": -119.09423
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ],
      "_source": {
        "url": "https://www.losangelesreproductivecenter.com/locations/our-bakersfield-clinic",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["Mandarin", "Italian", "Hebrew", "English"],
    "consultationTypes": ["in-person"],
    "network": {
      "name": "Ivy Fertility"
    },
    "team": [
      {
        "practitionerId": "pr-org-larc-bakersfield-nurit-winkler",
        "name": "Nurit Winkler",
        "role": "co-founder and co-owner",
        "imageUrl": "https://a.storyblok.com/f/290132/851x851/0d0c810719/nurit-winkler.jpg",
        "specialty": "Double Board-Certified Fertility Specialist & International Reproductive Expert",
        "_source": {
          "url": "https://www.losangelesreproductivecenter.com/doctors/dr-nurit-winkler",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-larc-bakersfield-marc-kalan",
        "name": "Marc Kalan",
        "role": "co-founder",
        "specialty": "Double Board-Certified Reproductive Endocrinologist & Fertility Specialist",
        "imageUrl": "https://a.storyblok.com/f/290132/918x918/2353df0280/marc-kalan.png",
        "_source": {
          "url": "https://www.losangelesreproductivecenter.com/doctors/dr-marc-kalan",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://www.losangelesreproductivecenter.com/locations/our-bakersfield-clinic",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.losangelesreproductivecenter.com/locations/our-bakersfield-clinic",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Los+Angeles+Reproductive+Center,+8305+Brimhall+Rd+Bldg+1600,+Ste+1602,+Bakersfield,+CA+93312/@35.3672988,-119.0949729,3254a,13.1y/data=!4m2!3m1!1s0x80ea43cb7966d6eb:0x425ddee72d802fee",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.losangelesreproductivecenter.com/locations/our-bakersfield-clinic",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm7veXpFerLYVBoECZG08ykp76_YfSanDNKqNVXw5Tb-k6Peymabn23k6hzbznmmdE1zScnkGBjEp3ss9Ev6FEkTSNbQmvkJ6rsZeOENZfwCCQlsE9oG4Cl-4Sq1JSB0Nb6o0Cm=w449-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Los+Angeles+Reproductive+Center,+8305+Brimhall+Rd+Bldg+1600,+Ste+1602,+Bakersfield,+CA+93312/@35.3672988,-119.0949729,3254a,13.1y/data=!4m2!3m1!1s0x80ea43cb7966d6eb:0x425ddee72d802fee",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkVb6n_n9DCNclH1Spx74-Aj5bAoUM2PHDz_OA0H8VuSVHdQadM7m1IK4rY0mGMuwBB7FYClI9ihtIlgc1AyYTldu6_t_rN3ebVZOJ0Xu3eSczsz01qknlZRkNBpiA4lT5pgll0=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Los+Angeles+Reproductive+Center,+8305+Brimhall+Rd+Bldg+1600,+Ste+1602,+Bakersfield,+CA+93312/@35.3672988,-119.0949729,3254a,13.1y/data=!4m2!3m1!1s0x80ea43cb7966d6eb:0x425ddee72d802fee",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-prc-glendale",
    "externalIds": {
      "googlePlaceId": "ChIJWVDgpQ_BwoARIDlYsXvKMHY"
    },
    "type": "fertility-clinic",
    "name": "Pacific Reproductive Center - Glendale",
    "description": "Pacific Reproductive Center lists a Glendale office as part of its Southern California fertility practice.",
    "website": "https://www.pacificreproductivecenter.com/locations/",
    "phone": "(818) 844-2690",
    "address": {
      "line1": "116 E. Broadway",
      "line2": "Suite 300",
      "city": "Glendale",
      "state": "CA",
      "zip": "91205",
      "country": "US"
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ],
      "_source": {
        "url": "https://www.pacificreproductivecenter.com/locations/",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["English"],
    "consultationTypes": ["in-person"],
    "team": [
      {
        "practitionerId": "pr-org-prc-glendale-rifaat-d-salem",
        "name": "Rifaat D. Salem",
        "role": "Medical Director",
        "imageUrl": "https://www.pacificreproductivecenter.com/wp-content/uploads/2023/04/RDS.jpg",
        "credentials": ["MD", "PhD"],
        "_source": {
          "url": "https://www.pacificreproductivecenter.com/meet-the-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-prc-glendale-shala-a-salem",
        "name": "Shala A. Salem",
        "credentials": ["MD"],
        "role": "Fertility Specialist",
        "imageUrl": "https://www.pacificreproductivecenter.com/wp-content/uploads/2023/04/ssalem-scaled-2.jpg",
        "_source": {
          "url": "https://www.pacificreproductivecenter.com/meet-the-team/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://www.pacificreproductivecenter.com/locations/",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pacificreproductivecenter.com/locations/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Pacific+Reproductive+Center,+116+E+Broadway+Ste+300,+Glendale,+CA+91205/@34.1461891,-118.2540996,3302a,13.1y/data=!4m2!3m1!1s0x80c2c10fa5e05059:0x7630ca7bb1583920",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.pacificreproductivecenter.com/locations/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmuOAoJ4epSypQNw0Hq1edeqeFZk0kUSaCahGdLyzPLsKhJoAWEOGvZvmWu6kCyw1ASOvAo4cg44Zs9H97AieyY9g-oNuekMv3106nZyvGGzQ6SKgVrrwRn2iR-4D0C9_GlSQ8l=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Pacific+Reproductive+Center,+116+E+Broadway+Ste+300,+Glendale,+CA+91205/@34.1461891,-118.2540996,3302a,13.1y/data=!4m2!3m1!1s0x80c2c10fa5e05059:0x7630ca7bb1583920",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-prc-irvine",
    "externalIds": {
      "googlePlaceId": "ChIJJUzcMW7d3IARrBOBKME9deo"
    },
    "type": "fertility-clinic",
    "name": "Pacific Reproductive Center - Irvine",
    "description": "Pacific Reproductive Center lists an Irvine office at 10 Post as part of its Southern California fertility practice.",
    "website": "https://www.pacificreproductivecenter.com/locations/",
    "phone": "(949) 341-0100",
    "address": {
      "line1": "10 Post",
      "city": "Irvine",
      "state": "CA",
      "zip": "92618",
      "country": "US"
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ],
      "_source": {
        "url": "https://www.pacificreproductivecenter.com/locations/",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["English"],
    "consultationTypes": ["in-person"],
    "team": [
      {
        "practitionerId": "pr-org-prc-irvine-rifaat-d-salem",
        "name": "Rifaat D. Salem",
        "role": "Medical Director",
        "imageUrl": "https://www.pacificreproductivecenter.com/wp-content/uploads/2023/04/RDS.jpg",
        "credentials": ["MD", "PhD"],
        "_source": {
          "url": "https://www.pacificreproductivecenter.com/meet-the-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-prc-irvine-shala-a-salem",
        "name": "Shala A. Salem",
        "credentials": ["MD"],
        "role": "Fertility Specialist",
        "imageUrl": "https://www.pacificreproductivecenter.com/wp-content/uploads/2023/04/ssalem-scaled-2.jpg",
        "_source": {
          "url": "https://www.pacificreproductivecenter.com/meet-the-team/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://www.pacificreproductivecenter.com/locations/",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pacificreproductivecenter.com/locations/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Pacific+Reproductive+Center+%7C+Irvine,+CA+%7C+IVF+Fertility,+10+Post,+Irvine,+CA+92618/@33.677764,-117.767507,3320a,13.1y/data=!4m2!3m1!1s0x80dcdd6e31dc4c25:0xea753dc1288113ac",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.pacificreproductivecenter.com/locations/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-prc-corona",
    "externalIds": {
      "googlePlaceId": "ChIJ94MEMu633IARHAhc-w-QT-s"
    },
    "type": "fertility-clinic",
    "name": "Pacific Reproductive Center - Corona",
    "description": "Pacific Reproductive Center lists a Corona office on Corporate Terrace as part of its Southern California fertility practice.",
    "website": "https://www.pacificreproductivecenter.com/locations/",
    "phone": "(951) 371-9200",
    "address": {
      "line1": "381 Corporate Terrace",
      "city": "Corona",
      "state": "CA",
      "zip": "92879",
      "country": "US"
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ],
      "_source": {
        "url": "https://www.pacificreproductivecenter.com/locations/",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["English"],
    "consultationTypes": ["in-person"],
    "team": [
      {
        "practitionerId": "pr-org-prc-corona-rifaat-d-salem",
        "name": "Rifaat D. Salem",
        "role": "Medical Director",
        "imageUrl": "https://www.pacificreproductivecenter.com/wp-content/uploads/2023/04/RDS.jpg",
        "credentials": ["MD", "PhD"],
        "_source": {
          "url": "https://www.pacificreproductivecenter.com/meet-the-team/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-prc-corona-shala-a-salem",
        "name": "Shala A. Salem",
        "credentials": ["MD"],
        "role": "Fertility Specialist",
        "imageUrl": "https://www.pacificreproductivecenter.com/wp-content/uploads/2023/04/ssalem-scaled-2.jpg",
        "_source": {
          "url": "https://www.pacificreproductivecenter.com/meet-the-team/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://www.pacificreproductivecenter.com/locations/",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pacificreproductivecenter.com/locations/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Pacific+Reproductive+Center+%7C+Corona,+CA+%7C+Fertility+Center,+381+Corporate+Terrace+Cir,+Corona,+CA+92879/@33.882845,-117.5345,3312a,13.1y/data=!4m2!3m1!1s0x80dcb7ee320483f7:0xeb4f900ffb5c081c",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.pacificreproductivecenter.com/locations/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlo206fMuCznILMVsvSgiaiNY533cKB0GA52-Ue2OPQcFRLP81cuJqtA1tBrh-gKFFQ_d2yTt3jSumldBtuc9bKeorspvOCXZoNkKDP0pR38KXJVakAyeWRViYoeFc90sdLiXzG=w408-h544-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Pacific+Reproductive+Center+%7C+Corona,+CA+%7C+Fertility+Center,+381+Corporate+Terrace+Cir,+Corona,+CA+92879/@33.882845,-117.5345,3312a,13.1y/data=!4m2!3m1!1s0x80dcb7ee320483f7:0xeb4f900ffb5c081c",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk6lbcOvDUxRy5kijaH7YmG37Zfum4r4vHz6dSr4Aw-3s3fr7Kk6j7tsNlaXQbosXAsIXs_R8ddN8CgQQlRSFMirJLUYWKjddmijyZ64GVY7bkds-E9LAkUE7OnCU_yHyh2MuY=w224-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Pacific+Reproductive+Center+%7C+Corona,+CA+%7C+Fertility+Center,+381+Corporate+Terrace+Cir,+Corona,+CA+92879/@33.882845,-117.5345,3312a,13.1y/data=!4m2!3m1!1s0x80dcb7ee320483f7:0xeb4f900ffb5c081c",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-arc-redlands",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "American Reproductive Centers - Redlands",
    "description": "American Reproductive Centers lists a Redlands office on Terracina Boulevard in addition to its Palm Springs location.",
    "website": "https://www.arcivf.com/contact/",
    "phone": "(760) 346-4334",
    "address": {
      "line1": "255 Terracina Blvd",
      "line2": "Suite 202",
      "city": "Redlands",
      "state": "CA",
      "zip": "92373",
      "country": "US"
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": ["Empire"],
      "_source": {
        "url": "https://www.arcivf.com/contact/",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["English", "Spanish", "Chinese", "Arabic"],
    "consultationTypes": ["in-person"],
    "team": [
      {
        "practitionerId": "pr-org-arc-redlands-maher-abdallah",
        "name": "Maher Abdallah",
        "role": "Medical Director",
        "imageUrl": "https://arcbabies.com/wp-content/uploads/2022/07/dr-maher-abdallah2.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://arcbabies.com/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://www.arcivf.com/contact/",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.arcivf.com/contact/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Empire",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.arcivf.com/contact/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-arc-el-cajon-affiliate",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "American Reproductive Centers - El Cajon Affiliate",
    "description": "American Reproductive Centers lists American Reproductive Centers-El Cajon APC as an ARC affiliate at the South Magnolia Avenue office.",
    "website": "https://www.arcivf.com/contact/",
    "phone": "(619) 768-1110",
    "address": {
      "line1": "330 S Magnolia Ave",
      "line2": "Suite 201",
      "city": "El Cajon",
      "state": "CA",
      "zip": "92020",
      "country": "US"
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": ["Empire"],
      "_source": {
        "url": "https://www.arcivf.com/contact/",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["English", "Spanish", "Chinese", "Arabic"],
    "consultationTypes": ["in-person"],
    "team": [
      {
        "practitionerId": "pr-org-arc-el-cajon-affiliate-maher-abdallah",
        "name": "Maher Abdallah",
        "role": "Medical Director",
        "imageUrl": "https://arcbabies.com/wp-content/uploads/2022/07/dr-maher-abdallah2.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://arcbabies.com/meet-our-team/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://www.arcivf.com/contact/",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.arcivf.com/contact/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Empire",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.arcivf.com/contact/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-pfcla-glendale",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Pacific Fertility Center Los Angeles - Glendale",
    "description": "PFCLA lists a Glendale clinic on Verdugo Boulevard in addition to its Westwood office.",
    "website": "https://www.pfcla.com/contact-us/",
    "phone": "(310) 209-7700",
    "address": {
      "line1": "1818 Verdugo Blvd",
      "line2": "Suite 402",
      "city": "Glendale",
      "state": "CA",
      "zip": "91208",
      "country": "US"
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ],
      "_source": {
        "url": "https://www.pfcla.com/contact-us/",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["Mandarin", "English"],
    "consultationTypes": ["in-person"],
    "network": {
      "name": "Prelude Network"
    },
    "team": [
      {
        "practitionerId": "pr-org-pfcla-glendale-vicken-sahakian-md",
        "name": "Vicken Sahakian, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.pfcla.com/hubfs/Style%20Assets/Doctors/Resized/Vicken-Sahakian-2.jpg",
        "_source": {
          "url": "https://www.pfcla.com/our-physicians",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-pfcla-glendale-vicken-sepilian",
        "name": "Vicken Sepilian",
        "role": "Infertility Specialist and Reproductive Endocrinologist",
        "imageUrl": "https://www.pfcla.com/hubfs/Style%20Assets/Doctors/Resized/Vicken%20Sepilian.jpg",
        "_source": {
          "url": "https://www.pfcla.com/our-physicians",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-pfcla-glendale-ingrid-rodi",
        "name": "Ingrid Rodi",
        "role": "Infertility Specialist and Reproductive Endocrinologist",
        "imageUrl": "https://www.pfcla.com/hubfs/Style%20Assets/Doctors/Resized/Ingrid%20Rodi.jpg",
        "_source": {
          "url": "https://www.pfcla.com/our-physicians",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-pfcla-glendale-catherine-deugarte",
        "name": "Catherine DeUgarte",
        "credentials": ["MD"],
        "role": "Infertility Specialist and Reproductive Endocrinologist",
        "imageUrl": "https://www.pfcla.com/hubfs/Style%20Assets/Doctors/Catherine-DeUgarte-1.jpg",
        "_source": {
          "url": "https://www.pfcla.com/our-physicians",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-pfcla-glendale-michele-evans",
        "name": "Michele Evans",
        "role": "Infertility Specialist and Reproductive Endocrinologist",
        "imageUrl": "https://www.pfcla.com/hubfs/Style%20Assets/Doctors/Michele%20Evans-desk.jpg",
        "_source": {
          "url": "https://www.pfcla.com/our-physicians",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-pfcla-glendale-gerard-celia",
        "name": "Gerard Celia",
        "credentials": ["MBA", "PhD", "HCLD", "CC"],
        "role": "Executive Lab Director",
        "imageUrl": "https://www.pfcla.com/hubfs/Style%20Assets/Doctors/Resized/Gerry%20Celia.jpg",
        "_source": {
          "url": "https://www.pfcla.com/our-physicians",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://www.pfcla.com/contact-us/",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pfcla.com/contact-us/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.pfcla.com/contact-us/",
            "fetchedAt": "2026-06-11"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "images": [
      {
        "url": "https://www.pfcla.com/hubfs/Images/Background%20Images/clinic-lobby-bg.jpg",
        "type": "interior",
        "caption": "PFCLA clinic lobby",
        "_source": {
          "url": "https://www.pfcla.com/contact-us/",
          "fetchedAt": "2026-06-11"
        }
      }
    ],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.pfcla.com/contact-us/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-ccrh-encino",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "California Center for Reproductive Health - Encino",
    "description": "California Center for Reproductive Health lists an Encino office on Ventura Boulevard for fertility treatment and reproductive endocrinology care.",
    "website": "https://center4reproduction.com/contact/",
    "phone": "(818) 907-1571",
    "address": {
      "line1": "16633 Ventura Boulevard",
      "line2": "Suite 1330",
      "city": "Encino",
      "state": "CA",
      "zip": "91436",
      "country": "US"
    },
    "location": {
      "lat": 34.1583,
      "lng": -118.4953
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ],
      "_source": {
        "url": "https://center4reproduction.com/contact/",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["English"],
    "consultationTypes": ["in-person"],
    "team": [
      {
        "practitionerId": "pr-org-ccrh-encino-peyman-saadat-md",
        "name": "Peyman Saadat, MD",
        "role": "Medical Director"
      },
      {
        "practitionerId": "pr-org-ccrh-encino-eliran-mor",
        "name": "Eliran Mor",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinologist",
        "imageUrl": "https://www.center4reproduction.com/wp-content/uploads/2023/05/2131307-1.png",
        "_source": {
          "url": "https://www.center4reproduction.com/doctors/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ccrh-encino-tina-koopersmith",
        "name": "Tina Koopersmith",
        "credentials": ["MD"],
        "specialty": "OB/GYN and Reproductive Endocrinologist",
        "imageUrl": "https://www.center4reproduction.com/wp-content/uploads/2023/09/Tina-Koopersmith-New.jpg",
        "_source": {
          "url": "https://www.center4reproduction.com/doctors/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ccrh-encino-maria-zapata",
        "name": "Maria Zapata",
        "credentials": ["NP"],
        "imageUrl": "https://www.center4reproduction.com/wp-content/uploads/2023/10/Maria.jpg",
        "_source": {
          "url": "https://www.center4reproduction.com/doctors/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://center4reproduction.com/contact/",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://center4reproduction.com/contact/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://center4reproduction.com/contact/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-ccrh-valencia",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "California Center for Reproductive Health - Valencia",
    "description": "California Center for Reproductive Health lists a Valencia office on Valencia Boulevard in addition to its Encino and West Hollywood offices.",
    "website": "https://center4reproduction.com/contact/",
    "phone": "(818) 907-1571",
    "address": {
      "line1": "23823 Valencia Boulevard",
      "line2": "Suite 150",
      "city": "Valencia",
      "state": "CA",
      "zip": "91355",
      "country": "US"
    },
    "location": {
      "lat": 34.4138,
      "lng": -118.5525
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ],
      "_source": {
        "url": "https://center4reproduction.com/contact/",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["English"],
    "consultationTypes": ["in-person"],
    "team": [
      {
        "practitionerId": "pr-org-ccrh-valencia-peyman-saadat-md",
        "name": "Peyman Saadat, MD",
        "role": "Medical Director"
      },
      {
        "practitionerId": "pr-org-ccrh-valencia-eliran-mor",
        "name": "Eliran Mor",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinologist",
        "imageUrl": "https://www.center4reproduction.com/wp-content/uploads/2023/05/2131307-1.png",
        "_source": {
          "url": "https://www.center4reproduction.com/doctors/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ccrh-valencia-tina-koopersmith",
        "name": "Tina Koopersmith",
        "credentials": ["MD"],
        "specialty": "OB/GYN and Reproductive Endocrinologist",
        "imageUrl": "https://www.center4reproduction.com/wp-content/uploads/2023/09/Tina-Koopersmith-New.jpg",
        "_source": {
          "url": "https://www.center4reproduction.com/doctors/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-ccrh-valencia-maria-zapata",
        "name": "Maria Zapata",
        "credentials": ["NP"],
        "imageUrl": "https://www.center4reproduction.com/wp-content/uploads/2023/10/Maria.jpg",
        "_source": {
          "url": "https://www.center4reproduction.com/doctors/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://center4reproduction.com/contact/",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://center4reproduction.com/contact/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://center4reproduction.com/contact/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-unity-fertility-san-gabriel",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Unity Fertility Center - San Gabriel",
    "description": "Unity Fertility Center lists a second location in San Gabriel on West Las Tunas Drive, in addition to its Pasadena office.",
    "website": "https://unity-fertility.com/contact/",
    "phone": "(626) 314-2500",
    "address": {
      "line1": "416 W. Las Tunas Dr",
      "line2": "Suite 306",
      "city": "San Gabriel",
      "state": "CA",
      "zip": "91776",
      "country": "US"
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ],
      "_source": {
        "url": "https://unity-fertility.com/contact/",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["English"],
    "consultationTypes": ["in-person"],
    "team": [
      {
        "practitionerId": "pr-org-unity-fertility-san-gabriel-chun-yeh-wang-md-phd",
        "name": "Chun-Yeh Wang, MD, PHD",
        "role": "Medical Director",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/6557beb789af580a3379af6a/64a274a9-ce56-4f9a-8103-d033e725275c/chun-yeh+wang+image+1.jpg",
        "_source": {
          "url": "https://www.unity-fertility.com/about",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://unity-fertility.com/contact/",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://unity-fertility.com/contact/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://unity-fertility.com/contact/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-western-fertility-arcadia",
    "externalIds": {
      "googlePlaceId": "ChIJwwHdZQLbwoARTICzpQ-DVxA"
    },
    "type": "fertility-clinic",
    "name": "Western Fertility Institute - Arcadia",
    "description": "Western Fertility Institute lists an Arcadia office on West Huntington Drive in addition to its Encino office.",
    "website": "https://www.westernfertility.com/contact-us/",
    "phone": "(626) 244-8224",
    "address": {
      "line1": "301 W. Huntington Dr",
      "line2": "Suite 210",
      "city": "Arcadia",
      "state": "CA",
      "zip": "91007",
      "country": "US"
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ],
      "_source": {
        "url": "https://www.westernfertility.com/contact-us/",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["Italian", "English"],
    "consultationTypes": ["in-person"],
    "team": [
      {
        "practitionerId": "pr-org-western-fertility-arcadia-ashim-kumar",
        "name": "Ashim Kumar",
        "role": "Medical Director",
        "imageUrl": "https://www.westernfertility.com/wp-content/uploads/2016/01/Dr_Kumar_photo-tight.jpg",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://www.westernfertility.com/our-physicians/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://www.westernfertility.com/contact-us/",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.westernfertility.com/contact-us/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Western+Fertility+Institute+%E2%80%93+Arcadia,+301+W+Huntington+Dr+Ste+210,+Arcadia,+CA+91007/@34.1349286,-118.0431213,3302a,13.1y/data=!4m2!3m1!1s0x80c2db0265dd01c3:0x1057830fa5b3804c",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.westernfertility.com/contact-us/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn9ecvjhiWzr1NH0ZMaXNFICqxZ0bXkq9oJ90ETnRYFQfzIic5taLKISHr7MiWG-LSO2fzJp-Upyz5vwMZG3dxB5LEiReoVlzrGZm6sNAqjjOu7MNeeFnlWDL4UVdMUFRkexaDr=w360-h553-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Western+Fertility+Institute+%E2%80%93+Arcadia,+301+W+Huntington+Dr+Ste+210,+Arcadia,+CA+91007/@34.1349286,-118.0431213,3302a,13.1y/data=!4m2!3m1!1s0x80c2db0265dd01c3:0x1057830fa5b3804c",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkHDaZ6PpYer3qzrIfxBqoCGSjNdr1E20PACgRy8wxrYeNNzs5vfTkPfAxMGb03MVUDl9QVwmabiHy0AJ3whhYVro1a5PTjgmClVBKYdGKALEeH0t9nNQ1pyoMkDel76ZeCI9zq=w448-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Western+Fertility+Institute+%E2%80%93+Arcadia,+301+W+Huntington+Dr+Ste+210,+Arcadia,+CA+91007/@34.1349286,-118.0431213,3302a,13.1y/data=!4m2!3m1!1s0x80c2db0265dd01c3:0x1057830fa5b3804c",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-care-fertility-upland",
    "externalIds": {
      "googlePlaceId": "ChIJ92JSt-A3w4ARS2igT-BkOlQ"
    },
    "type": "fertility-clinic",
    "name": "CARE Fertility - Upland",
    "description": "CARE Fertility lists an Upland office on North 13th Avenue in addition to its Glendale office.",
    "website": "https://carefertility.net",
    "phone": "(818) 230-7778",
    "address": {
      "line1": "510 N. 13th Avenue",
      "line2": "Suite 304",
      "city": "Upland",
      "state": "CA",
      "zip": "91786",
      "country": "US"
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ],
      "_source": {
        "url": "https://carefertility.net",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["English", "Spanish", "Mandarin", "Cantonese"],
    "consultationTypes": ["in-person"],
    "team": [
      {
        "practitionerId": "pr-org-care-fertility-upland-rudy-quintero",
        "name": "Rudy Quintero",
        "role": "Medical Director",
        "imageUrl": "https://carefertility.net/wp-content/uploads/2025/04/quintero-1-1-1.jpg",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://carefertility.net/dr-rudy-quintero/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-care-fertility-upland-antoine-la",
        "name": "Antoine La",
        "credentials": ["ELD"],
        "role": "Embryology Laboratory Director",
        "imageUrl": "https://carefertility.net/wp-content/uploads/2024/11/antoine-la.png",
        "_source": {
          "url": "https://carefertility.net/antoine-la/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://carefertility.net",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://carefertility.net",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CARE+Fertility,+510+N+13th+Ave+%23304,+Upland,+CA+91786/@34.099631,-117.6333306,3304a,13.1y/data=!4m2!3m1!1s0x80c337e0b75262f7:0x543a64e04fa0684b",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://carefertility.net",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkPASfqVPJU_LBCJdoxp-kiZI3TyPSPqcfc_fk1Nzx_GWhjwnXDjAUmMvjhPn_BFFtCvrrRmwPA_JqLYX0SkK4b_T1jvMyHNy_q6kt2Zk3O5NoBJmOo3INjb2GxfJ6HGNT026v8eGDc8Ed4=w408-h544-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CARE+Fertility,+510+N+13th+Ave+%23304,+Upland,+CA+91786/@34.099631,-117.6333306,3304a,13.1y/data=!4m2!3m1!1s0x80c337e0b75262f7:0x543a64e04fa0684b",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-rpmg-beverly-hills",
    "externalIds": {
      "googlePlaceId": "ChIJF2a9OD-5woAR1zqOZQQvABA"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Partners Medical Group - Beverly Hills",
    "description": "Reproductive Partners Medical Group lists a Beverly Hills clinic on Wilshire Boulevard as one of its four Southern California locations.",
    "website": "https://www.reproductivepartners.com/locations/our-beverly-hills-clinic",
    "phone": "(310) 855-2229",
    "address": {
      "line1": "8383 Wilshire Blvd.",
      "line2": "Suite 700",
      "city": "Beverly Hills",
      "state": "CA",
      "zip": "90211",
      "country": "US"
    },
    "schedule": {
      "mon": {
        "open": "07:30",
        "close": "16:00"
      },
      "tue": {
        "open": "07:30",
        "close": "16:00"
      },
      "wed": {
        "open": "07:30",
        "close": "16:00"
      },
      "thu": {
        "open": "07:30",
        "close": "16:00"
      },
      "fri": {
        "open": "07:30",
        "close": "16:00"
      },
      "sat": {
        "open": "07:30",
        "close": "12:00"
      },
      "sun": {
        "open": "07:30",
        "close": "12:00"
      }
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ],
      "_source": {
        "url": "https://www.reproductivepartners.com/locations/our-beverly-hills-clinic",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["English"],
    "consultationTypes": ["in-person"],
    "network": {
      "name": "Ivy Fertility"
    },
    "team": [
      {
        "practitionerId": "pr-org-rpmg-beverly-hills-gayane-ambartsumyan-md-phd",
        "name": "Gayane Ambartsumyan, MD, PHD",
        "role": "Medical Director",
        "imageUrl": "https://a.storyblok.com/f/290132/1080x1080/a820b624e5/dr-a-headshot.png",
        "credentials": ["MD", "PhD"],
        "_source": {
          "url": "https://www.reproductivepartners.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rpmg-beverly-hills-andy-huang",
        "name": "Andy Huang",
        "credentials": ["MD", "MBA"],
        "imageUrl": "https://a.storyblok.com/f/290132/400x500/66f07913bf/huang.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rpmg-beverly-hills-marli-amin",
        "name": "Marli Amin",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/400x500/844aa26871/amin.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rpmg-beverly-hills-carrie-wambach",
        "name": "Carrie Wambach",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/400x500/67d643b342/carrie-melissa-wambach-m-d.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rpmg-beverly-hills-jackie-ho",
        "name": "Jackie Ho",
        "credentials": ["MD", "MS"],
        "imageUrl": "https://a.storyblok.com/f/290132/400x500/e9e1cf1eae/jackie-ho-m-d.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rpmg-beverly-hills-wendy-chang",
        "name": "Wendy Chang",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/400x500/afd38fd276/dr-wendy-chang-m-d-facog.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rpmg-beverly-hills-meredith-brower",
        "name": "Meredith Brower",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/400x500/0ba4bb69c8/meredith-brower-m-d.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rpmg-beverly-hills-eric-han",
        "name": "Eric Han",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/400x500/42b09dc8a6/dr-eric-han-m-d.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rpmg-beverly-hills-amy-kaing",
        "name": "Amy Kaing",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/600x600/d77c1c3424/amy-kaing.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/doctors/dr-amy-kaing",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rpmg-beverly-hills-wayne-lin",
        "name": "Wayne Lin",
        "credentials": ["MD", "MPH"],
        "imageUrl": "https://a.storyblok.com/f/290132/600x600/188219d053/wayne-lin.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/doctors/dr-wayne-lin",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://www.reproductivepartners.com/locations/our-beverly-hills-clinic",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.reproductivepartners.com/locations/our-beverly-hills-clinic",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Reproductive+Partners+Medical+Group,+8383+Wilshire+Blvd+%23700,+Beverly+Hills,+CA+90211/@34.0650059,-118.3733892,3305a,13.1y/data=!4m2!3m1!1s0x80c2b93f38bd6617:0x10002f04658e3ad7",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlHyYtdJvXRcowjn1a9B5OQHwhcgjAMj_FcpLINpTSYxFCTvR7NO6_1kGfZeG_tXXfHZ43KyiibXpvxmeDDzreKFfa4Cqx3NVIG_WYsk0-3A02CEsoXZHvgVxuK_uylfWb3TPXslA=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Reproductive+Partners+Medical+Group,+8383+Wilshire+Blvd+%23700,+Beverly+Hills,+CA+90211/@34.0650059,-118.3733892,3305a,13.1y/data=!4m2!3m1!1s0x80c2b93f38bd6617:0x10002f04658e3ad7",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.reproductivepartners.com/locations/our-beverly-hills-clinic",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-rpmg-long-beach",
    "externalIds": {
      "googlePlaceId": "ChIJXSI6Q1Mv3YARQo1HG3Txi4E"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Partners Medical Group - Long Beach",
    "description": "Reproductive Partners Medical Group lists a Long Beach clinic on Worsham Avenue and notes that its former Westminster clinic moved to Long Beach.",
    "website": "https://www.reproductivepartners.com/locations/our-long-beach-clinic",
    "phone": "(714) 702-3000",
    "address": {
      "line1": "3833 Worsham Ave",
      "line2": "Suite 300",
      "city": "Long Beach",
      "state": "CA",
      "zip": "90808",
      "country": "US"
    },
    "schedule": {
      "mon": {
        "open": "07:30",
        "close": "16:00"
      },
      "tue": {
        "open": "07:30",
        "close": "16:00"
      },
      "wed": {
        "open": "07:30",
        "close": "16:00"
      },
      "thu": {
        "open": "07:30",
        "close": "16:00"
      },
      "fri": {
        "open": "07:30",
        "close": "16:00"
      },
      "sat": {
        "open": "07:30",
        "close": "12:00"
      },
      "sun": {
        "open": "07:30",
        "close": "12:00"
      }
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ],
      "_source": {
        "url": "https://www.reproductivepartners.com/locations/our-long-beach-clinic",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["English"],
    "consultationTypes": ["in-person"],
    "network": {
      "name": "Ivy Fertility"
    },
    "team": [
      {
        "practitionerId": "pr-org-rpmg-long-beach-gayane-ambartsumyan-md-phd",
        "name": "Gayane Ambartsumyan, MD, PHD",
        "role": "Medical Director",
        "imageUrl": "https://a.storyblok.com/f/290132/1080x1080/a820b624e5/dr-a-headshot.png",
        "credentials": ["MD", "PhD"],
        "_source": {
          "url": "https://www.reproductivepartners.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rpmg-long-beach-andy-huang",
        "name": "Andy Huang",
        "credentials": ["MD", "MBA"],
        "imageUrl": "https://a.storyblok.com/f/290132/400x500/66f07913bf/huang.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rpmg-long-beach-marli-amin",
        "name": "Marli Amin",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/400x500/844aa26871/amin.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rpmg-long-beach-carrie-wambach",
        "name": "Carrie Wambach",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/400x500/67d643b342/carrie-melissa-wambach-m-d.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rpmg-long-beach-jackie-ho",
        "name": "Jackie Ho",
        "credentials": ["MD", "MS"],
        "imageUrl": "https://a.storyblok.com/f/290132/400x500/e9e1cf1eae/jackie-ho-m-d.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rpmg-long-beach-wendy-chang",
        "name": "Wendy Chang",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/400x500/afd38fd276/dr-wendy-chang-m-d-facog.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rpmg-long-beach-meredith-brower",
        "name": "Meredith Brower",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/400x500/0ba4bb69c8/meredith-brower-m-d.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rpmg-long-beach-eric-han",
        "name": "Eric Han",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/400x500/42b09dc8a6/dr-eric-han-m-d.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/meet-the-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rpmg-long-beach-amy-kaing",
        "name": "Amy Kaing",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/600x600/d77c1c3424/amy-kaing.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/doctors/dr-amy-kaing",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rpmg-long-beach-wayne-lin",
        "name": "Wayne Lin",
        "credentials": ["MD", "MPH"],
        "imageUrl": "https://a.storyblok.com/f/290132/600x600/188219d053/wayne-lin.jpg",
        "_source": {
          "url": "https://www.reproductivepartners.com/doctors/dr-wayne-lin",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://www.reproductivepartners.com/locations/our-long-beach-clinic",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.reproductivepartners.com/locations/our-long-beach-clinic",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Reproductive+Partners+Medical+Group,+3833+Worsham+Ave+Suite+300,+Long+Beach,+CA+90808/@33.8285476,-118.146846,3314a,13.1y/data=!4m2!3m1!1s0x80dd2f53433a225d:0x818bf1741b478d42",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "images": [],
    "setting": "network-group",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.reproductivepartners.com/locations/our-long-beach-clinic",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-rfc-alhambra",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Reproductive Fertility Center - Alhambra",
    "description": "Reproductive Fertility Center lists an Alhambra clinic on South Garfield Avenue for consultations, testing, and monitoring.",
    "website": "https://rfcfamily.com/locations/alhambra/",
    "phone": "(626) 588-2885",
    "address": {
      "line1": "723 South Garfield Avenue",
      "line2": "Suite 203",
      "city": "Alhambra",
      "state": "CA",
      "zip": "91801",
      "country": "US"
    },
    "schedule": {
      "mon": {
        "open": "08:30",
        "close": "16:30"
      },
      "tue": {
        "open": "08:30",
        "close": "16:30"
      },
      "wed": {
        "open": "08:30",
        "close": "16:30"
      },
      "thu": {
        "open": "09:30",
        "close": "12:30"
      },
      "fri": {
        "open": "08:30",
        "close": "16:30"
      },
      "sat": null,
      "sun": null
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ],
      "_source": {
        "url": "https://rfcfamily.com/locations/alhambra/",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["English"],
    "consultationTypes": ["in-person"],
    "team": [
      {
        "practitionerId": "pr-org-rfc-alhambra-james-p-lin-md",
        "name": "James P. Lin, MD",
        "role": "Medical Director",
        "imageUrl": "https://rfcfamily.com/wp-content/uploads/2024/12/Doctor-Lin-Circle.png",
        "credentials": ["MD"],
        "_source": {
          "url": "https://rfcfamily.com/about/meet-our-experts/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rfc-alhambra-susan-nasab",
        "name": "Susan Nasab",
        "credentials": ["MD"],
        "imageUrl": "https://rfcfamily.com/wp-content/uploads/2025/06/Dr-Nasab-Gold-Circle.png",
        "_source": {
          "url": "https://rfcfamily.com/about/dr-susan-nasab/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://rfcfamily.com/locations/alhambra/",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rfcfamily.com/locations/alhambra/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rfcfamily.com/locations/alhambra/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-rfc-beverly-hills",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Reproductive Fertility Center - Beverly Hills",
    "description": "Reproductive Fertility Center lists a Beverly Hills-area clinic on West 3rd Street in Los Angeles with an on-site andrology lab.",
    "website": "https://rfcfamily.com/locations/beverly-hills/",
    "phone": "(213) 600-8088",
    "address": {
      "line1": "8635 West 3rd Street",
      "line2": "Suite 1170W",
      "city": "Los Angeles",
      "state": "CA",
      "zip": "90048",
      "country": "US"
    },
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "17:00"
      },
      "tue": {
        "open": "08:00",
        "close": "17:00"
      },
      "wed": {
        "open": "08:00",
        "close": "17:00"
      },
      "thu": {
        "open": "08:00",
        "close": "17:00"
      },
      "fri": {
        "open": "08:00",
        "close": "17:00"
      },
      "sat": null,
      "sun": null
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ],
      "_source": {
        "url": "https://rfcfamily.com/locations/beverly-hills/",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["English"],
    "consultationTypes": ["in-person"],
    "team": [
      {
        "practitionerId": "pr-org-rfc-beverly-hills-james-p-lin-md",
        "name": "James P. Lin, MD",
        "role": "Medical Director",
        "imageUrl": "https://rfcfamily.com/wp-content/uploads/2024/12/Doctor-Lin-Circle.png",
        "credentials": ["MD"],
        "_source": {
          "url": "https://rfcfamily.com/about/meet-our-experts/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rfc-beverly-hills-susan-nasab",
        "name": "Susan Nasab",
        "credentials": ["MD"],
        "imageUrl": "https://rfcfamily.com/wp-content/uploads/2025/06/Dr-Nasab-Gold-Circle.png",
        "_source": {
          "url": "https://rfcfamily.com/about/dr-susan-nasab/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://rfcfamily.com/locations/beverly-hills/",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rfcfamily.com/locations/beverly-hills/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rfcfamily.com/locations/beverly-hills/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-rfc-corona",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Reproductive Fertility Center - Corona",
    "description": "Reproductive Fertility Center lists a Corona facility with clinic, surgery center, and IVF laboratory services.",
    "website": "https://rfcfamily.com/locations/corona/",
    "phone": "(951) 272-2221",
    "address": {
      "line1": "400 E Rincon St",
      "line2": "1st Floor",
      "city": "Corona",
      "state": "CA",
      "zip": "92879",
      "country": "US"
    },
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "17:00"
      },
      "tue": {
        "open": "07:00",
        "close": "17:00"
      },
      "wed": {
        "open": "07:00",
        "close": "17:00"
      },
      "thu": {
        "open": "07:00",
        "close": "17:00"
      },
      "fri": {
        "open": "07:00",
        "close": "17:00"
      },
      "sat": {
        "open": "07:00",
        "close": "09:30"
      },
      "sun": null
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Ovulation Induction",
        "category": "art"
      },
      {
        "name": "Male infertility",
        "category": "surgical"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ],
      "_source": {
        "url": "https://rfcfamily.com/locations/corona/",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["English"],
    "consultationTypes": ["in-person"],
    "team": [
      {
        "practitionerId": "pr-org-rfc-corona-james-p-lin-md",
        "name": "James P. Lin, MD",
        "role": "Medical Director",
        "imageUrl": "https://rfcfamily.com/wp-content/uploads/2024/12/Doctor-Lin-Circle.png",
        "credentials": ["MD"],
        "_source": {
          "url": "https://rfcfamily.com/about/meet-our-experts/",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-rfc-corona-zitao-liu",
        "name": "Zitao Liu",
        "credentials": ["MD"],
        "role": "Associate Chief Medical Officer",
        "imageUrl": "https://rfcfamily.com/wp-content/uploads/2026/03/Dr.-Liu-Circle-1024x1024.png",
        "_source": {
          "url": "https://rfcfamily.com/about/meet-our-experts/",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://rfcfamily.com/locations/corona/",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rfcfamily.com/locations/corona/",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://rfcfamily.com/locations/corona/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-tlc-miracle-mile",
    "externalIds": {
      "googlePlaceId": "ChIJ51MWujq5woARq_bfygkcpnc"
    },
    "type": "fertility-clinic",
    "name": "Tree of Life Fertility Center - Miracle Mile / California Fertility Clinic",
    "description": "Tree of Life Fertility Center lists its Miracle Mile / California Fertility Clinic location on Wilshire Boulevard as one of its Los Angeles-area fertility clinic sites.",
    "website": "https://www.tlcfertility.com",
    "phone": "(818) 344-8522",
    "address": {
      "line1": "5455 Wilshire Blvd",
      "line2": "Suite 1904",
      "city": "Los Angeles",
      "state": "CA",
      "zip": "90036",
      "country": "US"
    },
    "location": {
      "lat": 34.0627505,
      "lng": -118.347615
    },
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "17:00"
      },
      "tue": {
        "open": "08:00",
        "close": "17:00"
      },
      "wed": {
        "open": "08:00",
        "close": "17:00"
      },
      "thu": {
        "open": "08:00",
        "close": "17:00"
      },
      "fri": {
        "open": "08:00",
        "close": "17:00"
      },
      "sat": {
        "open": "09:00",
        "close": "10:00"
      },
      "sun": {
        "open": "09:00",
        "close": "10:00"
      }
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "miniIVF",
        "category": "art"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ],
      "_source": {
        "url": "https://www.tlcfertility.com",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["English"],
    "consultationTypes": ["in-person"],
    "team": [
      {
        "practitionerId": "pr-org-tlc-miracle-mile-vuk-jovanovic-md",
        "name": "Vuk Jovanovic, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.tlcfertility.com/images/Vuk%20Jovanovic.webp",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-s-samuel-kim",
        "name": "S. Samuel Kim",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.tlcfertility.com/images/SSamuel%20Kim.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-snunit-ben-ozer",
        "name": "Snunit Ben-Ozer",
        "credentials": ["MD", "FACOG"],
        "role": "Tree of Life Center, Founder",
        "imageUrl": "https://www.tlcfertility.com/images/Snunit%20Ben-Ozer.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-caroline-kim",
        "name": "Caroline Kim",
        "credentials": ["PA-C"],
        "role": "Certified Physician Associate",
        "imageUrl": "https://www.tlcfertility.com/images/Caroline%20Kim.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-man-li",
        "name": "Man Li",
        "credentials": ["PHD", "HCLD (ABB)"],
        "role": "Tree of Life Center, IVF Lab director",
        "imageUrl": "https://www.tlcfertility.com/images/Man%20Li.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-honey-tavanasefat",
        "name": "Honey Tavanasefat",
        "role": "Embryologist",
        "imageUrl": "https://www.tlcfertility.com/images/Honey-Tavanasefat.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-maria-reica-magcaleng",
        "name": "Maria Reica Magcaleng",
        "role": "BS Endocrinology and Andrologist Technician",
        "imageUrl": "https://www.tlcfertility.com/images/Maria%20Reica%20Magcaleng.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-porscha-parker",
        "name": "Porscha Parker",
        "role": "Andrologist",
        "imageUrl": "https://www.tlcfertility.com/images/Porscha%20Parker.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-aja-pivaral",
        "name": "Aja Pivaral",
        "credentials": ["MA"],
        "role": "Third Party IVF Coordinator / Clinical Team Leader",
        "imageUrl": "https://www.tlcfertility.com/images/Aja%20Pivaral.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-suleima-hernandez",
        "name": "Suleima Hernandez",
        "credentials": ["MA"],
        "role": "Senior IVF Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/suleima%20hernandez.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-roshanda-james",
        "name": "Roshanda James",
        "credentials": ["MA"],
        "role": "Third Party IVF Coordinator / Egg Donor Manager-Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/Roshanda%20James.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-yang-jiao",
        "name": "Yang Jiao",
        "credentials": ["MPH"],
        "role": "Third-party Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/Yang%20Jiao.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-ercy-iglesias",
        "name": "Ercy Iglesias",
        "credentials": ["MA"],
        "role": "Senior Third-Party IVF Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/Ercy-Iglesias.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-julie-zhao",
        "name": "Julie Zhao",
        "role": "Third Party Coordinator & Chinese translator",
        "imageUrl": "https://www.tlcfertility.com/images/Julie%20Zhao.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-dulce-grajeda",
        "name": "Dulce Grajeda",
        "credentials": ["MA"],
        "role": "IVF Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/Dulce-Grajeda.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-kristina-leeds",
        "name": "Kristina Leeds",
        "credentials": ["BSHM"],
        "role": "Third Party IVF Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/Kristina%20Leeds.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-perla-villa",
        "name": "Perla Villa",
        "credentials": ["MA"],
        "role": "Medical Assistant, Assistant IVF Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/Perla%20Villa.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-valentina-mennesson",
        "name": "Valentina Mennesson",
        "credentials": ["MSM"],
        "role": "International Third Party Coordinator / Liaison",
        "imageUrl": "https://www.tlcfertility.com/images/Valentina%20Mennesson.webp",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-tetiana-kovalchuk",
        "name": "Tetiana Kovalchuk",
        "credentials": ["RN"],
        "role": "Registered Nurse",
        "imageUrl": "https://www.tlcfertility.com/images/Tetiana%20Kovalchuk.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-rachel-benavides",
        "name": "Rachel Benavides",
        "credentials": ["MA"],
        "role": "Medical Assistant and Front Desk Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/rachel%20benavides.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-john-genesi",
        "name": "John Genesi",
        "role": "Chief Financial Officer",
        "imageUrl": "https://www.tlcfertility.com/images/John-Genesi.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-jocelyn-hernandez",
        "name": "Jocelyn Hernandez",
        "role": "Financial Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/Jocelyn-Hernandez.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-eileen-jovanovic",
        "name": "Eileen Jovanovic",
        "role": "Billing and Accounting",
        "imageUrl": "https://www.tlcfertility.com/images/Eileen-Jovanovic.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-dave-petersen",
        "name": "Dave Petersen",
        "role": "Front Desk Administrator",
        "imageUrl": "https://www.tlcfertility.com/images/Dave-Petersen.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-dejan-stosic",
        "name": "Dejan Stosic",
        "role": "Digital Marketing and Brand Strategy Specialist",
        "imageUrl": "https://www.tlcfertility.com/images/Dejan-Stosic.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-miracle-mile-christian-bair",
        "name": "Christian Bair",
        "role": "German Representative",
        "imageUrl": "https://www.tlcfertility.com/images/Christian-Bair.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://www.tlcfertility.com",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.tlcfertility.com",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/California+Fertility+Clinic,+5455+Wilshire+Blvd+19th+Floor+Suite+1904,+Los+Angeles,+CA+90036/@34.0624927,-118.3473658,3305a,13.1y/data=!4m2!3m1!1s0x80c2b93aba1653e7:0x77a61c09cadff6ab",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmeR4WDLI2i-TAMcXr0YXwHsGv0lcMhG6xX1FMTyB0DMiNsvcucB5safq-1noBUSllOUkedMjHre-hWewDsOWjlTneLEq8Sw_ogRiV8yAqIt5pO3j6vMWtAI5rOfbnqt5YxxbyBuA=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/California+Fertility+Clinic,+5455+Wilshire+Blvd+19th+Floor+Suite+1904,+Los+Angeles,+CA+90036/@34.0624927,-118.3473658,3305a,13.1y/data=!4m2!3m1!1s0x80c2b93aba1653e7:0x77a61c09cadff6ab",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlf6FH_hFqMLzNjNDh0gL4nr1VpifalyNl04YrrXxKO-BnzCH7Kly1AcWhHkrJSoWn2zvOQE50HpGuu1S5kKN7zgM0ZpHEVl1PKtE5AgoNov_wZw4IZyCbnhjPtY8f-_L3vgda0=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/California+Fertility+Clinic,+5455+Wilshire+Blvd+19th+Floor+Suite+1904,+Los+Angeles,+CA+90036/@34.0624927,-118.3473658,3305a,13.1y/data=!4m2!3m1!1s0x80c2b93aba1653e7:0x77a61c09cadff6ab",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.tlcfertility.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-tlc-santa-clarita",
    "externalIds": {
      "googlePlaceId": "ChIJs4SVZnmHwoARpq4Lxg1VU5w"
    },
    "type": "fertility-clinic",
    "name": "Tree of Life Fertility Center - Santa Clarita",
    "description": "Tree of Life Fertility Center lists a Santa Clarita location on Bouquet Canyon Road in its current structured site data.",
    "website": "https://www.tlcfertility.com",
    "phone": "(818) 344-8522",
    "address": {
      "line1": "26615 Bouquet Canyon Rd",
      "line2": "Suite 1",
      "city": "Santa Clarita",
      "state": "CA",
      "zip": "91350",
      "country": "US"
    },
    "location": {
      "lat": 34.42870874182016,
      "lng": -118.53711252754732
    },
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "17:00"
      },
      "tue": {
        "open": "08:00",
        "close": "17:00"
      },
      "wed": {
        "open": "08:00",
        "close": "17:00"
      },
      "thu": {
        "open": "08:00",
        "close": "17:00"
      },
      "fri": {
        "open": "08:00",
        "close": "17:00"
      },
      "sat": {
        "open": "09:00",
        "close": "10:00"
      },
      "sun": {
        "open": "09:00",
        "close": "10:00"
      }
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "miniIVF",
        "category": "art"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare",
        "Kaiser Permanente",
        "Health Net"
      ],
      "_source": {
        "url": "https://www.tlcfertility.com",
        "fetchedAt": "2026-06-10"
      }
    },
    "languages": ["English"],
    "consultationTypes": ["in-person"],
    "team": [
      {
        "practitionerId": "pr-org-tlc-santa-clarita-vuk-jovanovic-md",
        "name": "Vuk Jovanovic, MD",
        "role": "Medical Director",
        "imageUrl": "https://www.tlcfertility.com/images/Vuk%20Jovanovic.webp",
        "credentials": ["MD", "FACOG"],
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-s-samuel-kim",
        "name": "S. Samuel Kim",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.tlcfertility.com/images/SSamuel%20Kim.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-snunit-ben-ozer",
        "name": "Snunit Ben-Ozer",
        "credentials": ["MD", "FACOG"],
        "role": "Tree of Life Center, Founder",
        "imageUrl": "https://www.tlcfertility.com/images/Snunit%20Ben-Ozer.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-caroline-kim",
        "name": "Caroline Kim",
        "credentials": ["PA-C"],
        "role": "Certified Physician Associate",
        "imageUrl": "https://www.tlcfertility.com/images/Caroline%20Kim.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-man-li",
        "name": "Man Li",
        "credentials": ["PHD", "HCLD (ABB)"],
        "role": "Tree of Life Center, IVF Lab director",
        "imageUrl": "https://www.tlcfertility.com/images/Man%20Li.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-honey-tavanasefat",
        "name": "Honey Tavanasefat",
        "role": "Embryologist",
        "imageUrl": "https://www.tlcfertility.com/images/Honey-Tavanasefat.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-maria-reica-magcaleng",
        "name": "Maria Reica Magcaleng",
        "role": "BS Endocrinology and Andrologist Technician",
        "imageUrl": "https://www.tlcfertility.com/images/Maria%20Reica%20Magcaleng.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-porscha-parker",
        "name": "Porscha Parker",
        "role": "Andrologist",
        "imageUrl": "https://www.tlcfertility.com/images/Porscha%20Parker.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-aja-pivaral",
        "name": "Aja Pivaral",
        "credentials": ["MA"],
        "role": "Third Party IVF Coordinator / Clinical Team Leader",
        "imageUrl": "https://www.tlcfertility.com/images/Aja%20Pivaral.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-suleima-hernandez",
        "name": "Suleima Hernandez",
        "credentials": ["MA"],
        "role": "Senior IVF Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/suleima%20hernandez.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-roshanda-james",
        "name": "Roshanda James",
        "credentials": ["MA"],
        "role": "Third Party IVF Coordinator / Egg Donor Manager-Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/Roshanda%20James.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-yang-jiao",
        "name": "Yang Jiao",
        "credentials": ["MPH"],
        "role": "Third-party Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/Yang%20Jiao.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-ercy-iglesias",
        "name": "Ercy Iglesias",
        "credentials": ["MA"],
        "role": "Senior Third-Party IVF Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/Ercy-Iglesias.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-julie-zhao",
        "name": "Julie Zhao",
        "role": "Third Party Coordinator & Chinese translator",
        "imageUrl": "https://www.tlcfertility.com/images/Julie%20Zhao.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-dulce-grajeda",
        "name": "Dulce Grajeda",
        "credentials": ["MA"],
        "role": "IVF Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/Dulce-Grajeda.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-kristina-leeds",
        "name": "Kristina Leeds",
        "credentials": ["BSHM"],
        "role": "Third Party IVF Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/Kristina%20Leeds.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-perla-villa",
        "name": "Perla Villa",
        "credentials": ["MA"],
        "role": "Medical Assistant, Assistant IVF Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/Perla%20Villa.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-valentina-mennesson",
        "name": "Valentina Mennesson",
        "credentials": ["MSM"],
        "role": "International Third Party Coordinator / Liaison",
        "imageUrl": "https://www.tlcfertility.com/images/Valentina%20Mennesson.webp",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-tetiana-kovalchuk",
        "name": "Tetiana Kovalchuk",
        "credentials": ["RN"],
        "role": "Registered Nurse",
        "imageUrl": "https://www.tlcfertility.com/images/Tetiana%20Kovalchuk.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-rachel-benavides",
        "name": "Rachel Benavides",
        "credentials": ["MA"],
        "role": "Medical Assistant and Front Desk Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/rachel%20benavides.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-john-genesi",
        "name": "John Genesi",
        "role": "Chief Financial Officer",
        "imageUrl": "https://www.tlcfertility.com/images/John-Genesi.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-jocelyn-hernandez",
        "name": "Jocelyn Hernandez",
        "role": "Financial Coordinator",
        "imageUrl": "https://www.tlcfertility.com/images/Jocelyn-Hernandez.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-eileen-jovanovic",
        "name": "Eileen Jovanovic",
        "role": "Billing and Accounting",
        "imageUrl": "https://www.tlcfertility.com/images/Eileen-Jovanovic.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-dave-petersen",
        "name": "Dave Petersen",
        "role": "Front Desk Administrator",
        "imageUrl": "https://www.tlcfertility.com/images/Dave-Petersen.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-dejan-stosic",
        "name": "Dejan Stosic",
        "role": "Digital Marketing and Brand Strategy Specialist",
        "imageUrl": "https://www.tlcfertility.com/images/Dejan-Stosic.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      },
      {
        "practitionerId": "pr-org-tlc-santa-clarita-christian-bair",
        "name": "Christian Bair",
        "role": "German Representative",
        "imageUrl": "https://www.tlcfertility.com/images/Christian-Bair.png",
        "_source": {
          "url": "https://www.tlcfertility.com/our-team",
          "fetchedAt": "2026-06-10"
        }
      }
    ],
    "_enrichment": {
      "sections": {
        "identity": {
          "status": "scraped",
          "source": {
            "url": "https://www.tlcfertility.com",
            "fetchedAt": "2026-06-10"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.tlcfertility.com",
            "fetchedAt": "2026-06-10"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Tree+of+Life+Center+-+Valencia+Fertility+Clinic,+27335+Tourney+Rd+G2,+Valencia,+CA+91355/@34.4190534,-118.5792966,3291a,13.1y/data=!4m2!3m1!1s0x80c28779669584b3:0x9c53550dc60baea6",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-10",
      "updatedAt": "2026-06-17T00:00:00.000Z",
      "source": "official-site"
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWke76gzyj80jQiei08K25fQD6D0QhVDKPaQtQdy2e05zFsruLFqKjSJvXiV1cy53UxtWOao1gVG-mv_EJoEMStkmMnt4Mfe6XSFYxK8OPi5zdDuchIwj72BPBaWRdnakBOliERX=w408-h544-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Tree+of+Life+Center+-+Valencia+Fertility+Clinic,+27335+Tourney+Rd+G2,+Valencia,+CA+91355/@34.4190534,-118.5792966,3291a,13.1y/data=!4m2!3m1!1s0x80c28779669584b3:0x9c53550dc60baea6",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "setting": "boutique",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare, Kaiser Permanente, Health Net",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.tlcfertility.com",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-new-hope-fertility-tx",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "New Hope Fertility Institute of Texas",
    "website": "https://subodhchauhanmd.com",
    "phone": "(832) 553-5483",
    "address": {
      "line1": "7900 Fannin St, Suite 2500",
      "city": "Houston",
      "state": "TX",
      "zip": "77054",
      "country": "US"
    },
    "location": {
      "lat": 29.690394,
      "lng": -95.4031254
    },
    "locations": [
      {
        "name": "Sugar Land",
        "address": {
          "line1": "16659 Southwest Fwy, Suite 225",
          "city": "Sugar Land",
          "state": "TX",
          "zip": "77479",
          "country": "US"
        }
      }
    ],
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://subodhchauhanmd.com/ivf-in-vitro-fertilization-houston/",
          "fetchedAt": "2026-06-12"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://subodhchauhanmd.com",
            "fetchedAt": "2026-06-12"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://subodhchauhanmd.com/services-and-procedures/",
            "fetchedAt": "2026-06-12"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://subodhchauhanmd.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-12",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Subodh Chauhan, MD",
        "imageUrl": "https://subodhchauhanmd.com/wp-content/uploads/2024/06/subodh-chauhan-md-profile.png",
        "_source": {
          "url": "https://subodhchauhanmd.com/about-us/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-new-hope-fertility-tx-subodh-chauhan-md"
      }
    ],
    "images": [
      {
        "url": "https://subodhchauhanmd.com/wp-content/uploads/elementor/thumbs/2026-01-30-2-rk9v7shizh1ool9xe5id7q4awulsfy1g188zm0mxkg.jpg",
        "type": "interior",
        "caption": "New Hope Fertility Institute of Texas office",
        "_source": {
          "url": "https://subodhchauhanmd.com/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-precision-ivf",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Precision IVF",
    "website": "https://www.precisionivf.com",
    "phone": "(972) 573-3200",
    "address": {
      "line1": "4401 Coit Rd, Suite 301",
      "city": "Frisco",
      "state": "TX",
      "zip": "75035",
      "country": "US"
    },
    "location": {
      "lat": 33.1136718,
      "lng": -96.7698218
    },
    "locations": [
      {
        "name": "Southlake",
        "address": {
          "line1": "470 E State Hwy 114",
          "city": "Southlake",
          "state": "TX",
          "zip": "76092",
          "country": "US"
        }
      },
      {
        "name": "El Paso",
        "address": {
          "line1": "7806 Gateway Blvd E, Suite 102",
          "city": "El Paso",
          "state": "TX",
          "zip": "79915",
          "country": "US"
        }
      }
    ],
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "patientGroups": ["LGBTQIA+"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.precisionivf.com/ivf",
          "fetchedAt": "2026-06-12"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.precisionivf.com",
          "fetchedAt": "2026-06-12"
        }
      },
      {
        "name": "PGT",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.precisionivf.com",
          "fetchedAt": "2026-06-12"
        }
      },
      {
        "name": "Fertility preservation",
        "category": "preservation",
        "_source": {
          "url": "https://www.precisionivf.com",
          "fetchedAt": "2026-06-12"
        }
      },
      {
        "name": "Tubal / vasectomy reversal",
        "category": "surgical",
        "_source": {
          "url": "https://www.precisionivf.com",
          "fetchedAt": "2026-06-12"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.precisionivf.com/contact",
            "fetchedAt": "2026-06-12"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.precisionivf.com",
            "fetchedAt": "2026-06-12"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.precisionivf.com/lp/topfertilityclinic",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-12",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Sushila Arya, MD",
        "imageUrl": "https://lirp.cdn-website.com/512f728a/dms3rep/multi/opt/shushila-arya-1920w.png",
        "_source": {
          "url": "https://www.precisionivf.com/lp/topfertilityclinic",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-precision-ivf-sushila-arya-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-caperton-fertility",
    "externalIds": {
      "googlePlaceId": "ChIJmQDQTq5Z54YRERs1fBjS9bU"
    },
    "type": "fertility-clinic",
    "name": "Caperton Fertility Institute",
    "website": "https://www.capertonfertility.com",
    "phone": "(915) 600-2220",
    "address": {
      "line1": "4171 N Mesa St, Building A, Suite 203",
      "city": "El Paso",
      "state": "TX",
      "zip": "79902",
      "country": "US"
    },
    "location": {
      "lat": 31.793829,
      "lng": -106.5103876
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.capertonfertility.com",
          "fetchedAt": "2026-06-12"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.capertonfertility.com/our-locations",
            "fetchedAt": "2026-06-12"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.capertonfertility.com",
            "fetchedAt": "2026-06-12"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Caperton+Fertility+Institute,+4171+N+Mesa+St+Bldg+A+Suite+203,+El+Paso,+TX+79902/@31.7938136,-106.5106729,3391a,13.1y/data=!4m2!3m1!1s0x86e759ae4ed00099:0xb5f5d2187c351b11",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-12",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmiv75IAMGfSKjQpzPkOcOK0arkXxyMCpYKoXnWdSmLIi7SkeiLz5QPs4l1p0XDKuoQ6BZ7QyOv58vuuicUlPZ8yaRcEq-WU8gqlFO124hh1BLTqcfgCHYOD4FNy-rqyCIvU4If0g=w408-h611-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Caperton+Fertility+Institute,+4171+N+Mesa+St+Bldg+A+Suite+203,+El+Paso,+TX+79902/@31.7938136,-106.5106729,3391a,13.1y/data=!4m2!3m1!1s0x86e759ae4ed00099:0xb5f5d2187c351b11",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk_S0W-7EsOJVZn9eeclVRiNqu_n70ZxuQhnAiZhVm34R2wU9WQC4Q0DZI8xJJV_Qm8nHVrdznA376YPrI30tTxeeLaLFK37JKvpl2nKFuoSHVWCtckyqQcSFMQVn_h6fsv2IT8=w348-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Caperton+Fertility+Institute,+4171+N+Mesa+St+Bldg+A+Suite+203,+El+Paso,+TX+79902/@31.7938136,-106.5106729,3391a,13.1y/data=!4m2!3m1!1s0x86e759ae4ed00099:0xb5f5d2187c351b11",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-sgf-davenport",
    "externalIds": {
      "googlePlaceId": "ChIJ27YNKqZx3YgRrsw58pI9kDY"
    },
    "type": "fertility-clinic",
    "name": "Shady Grove Fertility Davenport",
    "website": "https://www.shadygrovefertility.com/florida/",
    "phone": "(941) 203-6561",
    "address": {
      "line1": "130 Ridge Center Dr, Suite 208",
      "city": "Davenport",
      "state": "FL",
      "zip": "33837",
      "country": "US"
    },
    "location": {
      "lat": 28.1614046,
      "lng": -81.6017417
    },
    "network": {
      "name": "US Fertility"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.shadygrovefertility.com/newsroom/shady-grove-fertility-expands-in-central-florida-with-new-davenport-location/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Donor programs",
        "category": "art",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/newsroom/shady-grove-fertility-expands-in-central-florida-with-new-davenport-location/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/florida/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/florida/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Davenport,+130+Ridge+Center+Dr+suite+208,+Davenport,+FL+33837/@28.2151647,-81.6390627,3516a,13.1y/data=!4m2!3m1!1s0x88dd71a62a0db6db:0x36903d92f239ccae",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Anthony N. Imudia, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/11/Anthony-Imudia-profile-e1647611307797.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-sgf-davenport-anthony-n-imudia-md"
      },
      {
        "name": "L. Kendall Rauchfuss, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/09/L.-Kendall-Rauchfuss-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-sgf-davenport-l-kendall-rauchfuss-md"
      },
      {
        "name": "George Patounakis, MD, PhD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2024/12/G.-Patounakis-Website.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-sgf-davenport-george-patounakis-md-phd"
      },
      {
        "name": "Shayne Plosker, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/03/Shayne_Plosker-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-sgf-davenport-shayne-plosker-md"
      },
      {
        "name": "Papri Sarkar, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/08/Sarkar-850x850-1.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-sgf-davenport-papri-sarkar-md"
      },
      {
        "name": "Celso Silva, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/02/Celso-Silva-hero.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-sgf-davenport-celso-silva-md"
      },
      {
        "name": "Rachel Sprague",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2021/10/Rachel-Sprague-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": [],
        "practitionerId": "pr-org-web-sgf-davenport-rachel-sprague"
      },
      {
        "name": "Saioa Torrealday, MD",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/10/Torrealday-850x850-2.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-sgf-davenport-saioa-torrealday-md"
      },
      {
        "name": "Christine Kincaid, WHNP-BC",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/05/Christine-Kincaid-profile.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "credentials": ["WHNP-BC"],
        "practitionerId": "pr-org-web-sgf-davenport-christine-kincaid-whnp-bc"
      },
      {
        "name": "Susana Soto-Rodriguez, NP",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2025/01/Susie-Rodriguez.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "credentials": ["NP"],
        "practitionerId": "pr-org-web-sgf-davenport-susana-soto-rodriguez-np"
      },
      {
        "name": "Cortney White, MSN, CNM, WHNP-BC",
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2023/02/Cortney-White-profile.png",
        "_source": {
          "url": "https://www.shadygrovefertility.com/florida/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Provider",
        "credentials": ["MSN", "CNM", "WHNP-BC"],
        "practitionerId": "pr-org-web-sgf-davenport-cortney-white-msn-cnm-whnp-bc"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk3xgR4Y0JR4_6PjWTSh0tsOYN2FXDOrUPv6AS_Mnn_-wsxwDptDUXMsFdWjuf4nFA3e-kO_lnI6dQZABajgCDORHblet7Yp54CO0vlXhexwUoR5G14zZefSOJXIuF1YfPoBoNISA=w451-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Davenport,+130+Ridge+Center+Dr+suite+208,+Davenport,+FL+33837/@28.2151647,-81.6390627,3516a,13.1y/data=!4m2!3m1!1s0x88dd71a62a0db6db:0x36903d92f239ccae",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl3v7zkMcLbx0koslUv_WzGBQ8DX2LEZe6HC8u2nURbHaqt-pla_9t0PIO3nUqqqSLfuaFBIILglV3QfqAgMN71riQ8O_lOoh5SzB_x7y9yvywEYQkoxxP15ZElPf5d8i-BzYTjMDW6tHVv=w140-h248-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Davenport,+130+Ridge+Center+Dr+suite+208,+Davenport,+FL+33837/@28.2151647,-81.6390627,3516a,13.1y/data=!4m2!3m1!1s0x88dd71a62a0db6db:0x36903d92f239ccae",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-troche-fertility",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Troché Fertility Center",
    "phone": "(602) 993-8636",
    "address": {
      "line1": "17612 N 59th Ave, Suite 100",
      "city": "Glendale",
      "state": "AZ",
      "zip": "85308",
      "country": "US"
    },
    "location": {
      "lat": 33.6444272,
      "lng": -112.1867674
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.healthgrades.com/group-directory/az-arizona/glendale/troche-fertility-center-x8dc6n",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.healthgrades.com/group-directory/az-arizona/glendale/troche-fertility-center-x8dc6n",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.healthgrades.com/group-directory/az-arizona/glendale/troche-fertility-center-x8dc6n",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "missing"
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/glendale-az/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Nathaniel Zoneraich",
        "role": "Medical Director, Reproductive Endocrinology and Infertility Specialist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Nate-Zoneraich_AZ-NY_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-nathaniel-zoneraich/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-troche-fertility-nathaniel-zoneraich"
      },
      {
        "name": "Frederick Larsen",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/03/Dr.-Fred-Larsen_AZ-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-frederick-larsen/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-troche-fertility-frederick-larsen"
      },
      {
        "name": "Kurt Peterson",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["DO", "FACOOG"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/03/Dr.-Kurt-Peterson_AZ-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-kurt-peterson/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-troche-fertility-kurt-peterson"
      },
      {
        "name": "Kelly Soares",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/02/Kelly-Soares-AZ-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/kelly-soares-pa-c/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-troche-fertility-kelly-soares"
      },
      {
        "name": "Allison Abbey",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/02/Allison-Abbey-AZ-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/allison-abbey-pa-c/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-troche-fertility-allison-abbey"
      }
    ],
    "images": [
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/AFC_Glendale1-1.jpg",
        "type": "exterior",
        "caption": "Exterior of the Glendale, AZ clinic building (formerly Troché Fertility / Advanced Fertility Care) at 17612 N 59th Ave",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/glendale-az/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/AFC_Glendale2-1.jpg",
        "type": "interior",
        "caption": "Interior exam room with ultrasound equipment at the Glendale, AZ clinic",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/glendale-az/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/AFC_Glendale3-1.jpg",
        "type": "interior",
        "caption": "Interior exam/ultrasound room at the Glendale, AZ clinic",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/glendale-az/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Arizona (AZ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-vanderbilt-fertility",
    "externalIds": {
      "googlePlaceId": "ChIJRZTlSFV5ZIgRW9dc1Q4YGEM"
    },
    "type": "fertility-clinic",
    "name": "Vanderbilt Fertility Clinic",
    "website": "https://www.vanderbilthealth.com/locations/vanderbilt-fertility-clinic",
    "phone": "(615) 343-5700",
    "address": {
      "line1": "2009 Mallory Lane, Suite 250",
      "city": "Franklin",
      "state": "TN",
      "zip": "37067",
      "country": "US"
    },
    "location": {
      "lat": 35.9510851,
      "lng": -86.8181315
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.vanderbilthealth.com/program/reproductive-endocrinology-and-infertility",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.vanderbilthealth.com/program/reproductive-endocrinology-and-infertility",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.vanderbilthealth.com/locations/vanderbilt-fertility-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "missing"
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.vanderbilthealth.com/locations/vanderbilt-fertility-clinic",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Vanderbilt+Fertility+Clinic,+2009+Mallory+Ln+Suite+250,+Franklin,+TN+37067/@35.9507386,-86.8204695,3230a,13.1y/data=!4m2!3m1!1s0x8864795548e59445:0x4318180ed55cd75b",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Ryan Heitmann, DO",
        "role": "Reproductive Endocrinologist; Director, Division of Reproductive Endocrinology and Infertility; Associate Professor of Obstetrics & Gynecology",
        "credentials": ["DO"],
        "imageUrl": "https://www.vanderbilthealth.com/sites/default/files/uploads/provider_images/Heitmann-Ryan-278764.jpg",
        "_source": {
          "url": "https://www.vanderbilthealth.com/doctors/heitmann-ryan",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-vanderbilt-fertility-ryan-heitmann-do"
      },
      {
        "name": "Michelle K. Roach, MD",
        "role": "Reproductive Endocrinologist; Assistant Professor of Clinical Obstetrics and Gynecology",
        "credentials": ["MD"],
        "imageUrl": "https://www.vanderbilthealth.com/sites/default/files/uploads/provider_images/Roach-Michelle-Krystina-67263.jpg",
        "_source": {
          "url": "https://www.vanderbilthealth.com/doctors/roach-michelle",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-vanderbilt-fertility-michelle-k-roach-md"
      },
      {
        "name": "Karen A. Norfleet-McEwan, WHNP-BC",
        "role": "Women's Health Nurse Practitioner, Reproductive Endocrinology and Infertility",
        "credentials": ["WHNP-BC"],
        "imageUrl": "https://www.vanderbilthealth.com/sites/default/files/uploads/provider_images/Norfleet-McEwan-Karen-A-253452.jpg",
        "_source": {
          "url": "https://www.vanderbilthealth.com/doctors/norfleet-mcewan-karen",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-vanderbilt-fertility-karen-a-norfleet-mcewan-whnp-bc"
      }
    ],
    "images": [
      {
        "url": "https://www.vanderbilthealth.com/sites/default/files/uploads/2019-12/2009-Mallory-Lane_0.jpg",
        "type": "exterior",
        "caption": "Building exterior at 2009 Mallory Lane, Franklin, TN — the building housing Vanderbilt Fertility Clinic (address '2009' visible on facade)",
        "_source": {
          "url": "https://www.vanderbilthealth.com/locations/vanderbilt-fertility-clinic",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Tennessee (TN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-rei-georgia",
    "externalIds": {
      "googlePlaceId": "ChIJvYd4YKkF9YgRZnaALr74GJA"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Endocrinology and Fertility Group",
    "website": "https://www.reigeorgia.com",
    "address": {
      "line1": "1800 Peachtree Rd NW, Suite 640",
      "city": "Atlanta",
      "state": "GA",
      "zip": "30309",
      "country": "US"
    },
    "location": {
      "lat": 33.7957057,
      "lng": -84.3865291
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.reigeorgia.com",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.reigeorgia.com",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "missing"
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.reigeorgia.com/providers",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Reproductive+Endocrinology+and+Fertility+Group,+1800+Peachtree+Rd+Ste+640,+Atlanta,+GA+30309/@33.8035985,-84.3939958,3315a,13.1y/data=!4m2!3m1!1s0x88f505a9607887bd:0x9018f8be2e807666",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Carolyn Kaplan, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/d36631fca389416cca70048c3842e230a3d73339/images/2769657.jpg",
        "_source": {
          "url": "https://www.reigeorgia.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rei-georgia-carolyn-kaplan-md"
      },
      {
        "name": "Kaitlin McGrail, MD, FACOG",
        "role": "Physician",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/d36631fca389416cca70048c3842e230a3d73339/images/2769659.jpg",
        "_source": {
          "url": "https://www.reigeorgia.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rei-georgia-kaitlin-mcgrail-md-facog"
      },
      {
        "name": "Courtney Blue, NP",
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/d36631fca389416cca70048c3842e230a3d73339/images/2769661.jpg",
        "_source": {
          "url": "https://www.reigeorgia.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rei-georgia-courtney-blue-np"
      },
      {
        "name": "Sophia Touchstone, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/d36631fca389416cca70048c3842e230a3d73339/images/2818650.png",
        "_source": {
          "url": "https://www.reigeorgia.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rei-georgia-sophia-touchstone-pa-c"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnbR8BmNSpEZyFZdwdsPlq_LqWNfqK6389KwnAuXBQjAYRTywj7QIGaeipDCOpigWpzLMy9i1iIm0LNp-1DkjSRAOzu9bsBbQSP1xLR8y5qKird5AafMyOaUS7IO65aajEe82qF=w783-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Reproductive+Endocrinology+and+Fertility+Group,+1800+Peachtree+Rd+Ste+640,+Atlanta,+GA+30309/@33.8035985,-84.3939958,3315a,13.1y/data=!4m2!3m1!1s0x88f505a9607887bd:0x9018f8be2e807666",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-conceive-nj",
    "externalIds": {
      "googlePlaceId": "ChIJH4IC4b8pwokRcYZLeC73Phg"
    },
    "type": "fertility-clinic",
    "name": "Conceive NJ",
    "website": "https://conceivenj.com",
    "address": {
      "line1": "1599 NJ-34",
      "city": "Wall Township",
      "state": "NJ",
      "zip": "07727",
      "country": "US"
    },
    "location": {
      "lat": 40.1970613,
      "lng": -74.1195797
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "patientGroups": ["LGBTQIA+"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://conceivenj.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://conceivenj.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "PGT",
        "category": "diagnostic",
        "_source": {
          "url": "https://conceivenj.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://conceivenj.com",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://conceivenj.com/contact/fertility-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://conceivenj.com/fertility-treatments",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://conceivenj.com",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Conceive+NJ+%E2%80%93+IVF+%26+Fertility+Clinic,+1599+NJ-34+Ste+4,+Wall+Township,+NJ+07727/@40.2012027,-74.1226197,3047a,13.1y/data=!4m2!3m1!1s0x89c229bfe102821f:0x183ef72e784b8671",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Isaac Glatstein, MD, MSc",
        "imageUrl": "https://conceivenj.com/wp-content/uploads/Isaac-Z.-Glatstein-2025-Digital-300x377.jpg",
        "_source": {
          "url": "https://conceivenj.com/about/isaac-glatstein-md-msc",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD", "MSc"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-conceive-nj-isaac-glatstein-md-msc"
      },
      {
        "name": "Bryan Kloos, PhD, HCLD",
        "imageUrl": "https://conceivenj.com/wp-content/uploads/2023/07/IMG_2163-scaled-e1703807636721-300x300.jpg",
        "_source": {
          "url": "https://conceivenj.com/about",
          "fetchedAt": "2026-06-14"
        },
        "role": "Laboratory Director",
        "credentials": ["PhD", "HCLD"],
        "specialty": "Embryology",
        "practitionerId": "pr-org-web-conceive-nj-bryan-kloos-phd-hcld"
      },
      {
        "name": "Kelly Hynes, RN",
        "imageUrl": "https://conceivenj.com/wp-content/uploads/Kelly-e1764964615574-300x300.jpg",
        "_source": {
          "url": "https://conceivenj.com/about",
          "fetchedAt": "2026-06-14"
        },
        "role": "Registered Nurse",
        "credentials": ["RN"],
        "practitionerId": "pr-org-web-conceive-nj-kelly-hynes-rn"
      }
    ],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmn8P52MVVz4GQH6I3JC3pWWOXfb2d0LEuV1RtWextQo12HW9UMpnbgRqJRLux0YEGzv8ibQTOfCtG3xrF6tmEC8v8mze76eIoQvt0Bog7bMDJtYi6zcWDK1Nism3noTWsEkzJZnA=w360-h480-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Conceive+NJ+%E2%80%93+IVF+%26+Fertility+Clinic,+1599+NJ-34+Ste+4,+Wall+Township,+NJ+07727/@40.2012027,-74.1226197,3047a,13.1y/data=!4m2!3m1!1s0x89c229bfe102821f:0x183ef72e784b8671",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-ccrm-jersey-city",
    "externalIds": {
      "googlePlaceId": "ChIJfQxuLo9RwokR1tWO7PVz4Po"
    },
    "type": "fertility-clinic",
    "name": "CCRM Fertility of New Jersey - Jersey City",
    "website": "https://www.ccrmivf.com/location/us/new-jersey/jersey-city/",
    "phone": "(201) 275-0010",
    "address": {
      "line1": "66 York St., Suite 301",
      "city": "Jersey City",
      "state": "NJ",
      "zip": "07302",
      "country": "US"
    },
    "location": {
      "lat": 40.7160705,
      "lng": -74.0362439
    },
    "network": {
      "name": "CCRM Fertility"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.ccrmivf.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.ccrmivf.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.ccrmivf.com",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "missing"
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/new-jersey/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Jersey+City,+66+York+St+Ste+301,+Jersey+City,+NJ+07302/@40.7161185,-74.0362081,3024a,13.1y/data=!4m2!3m1!1s0x89c2518f2e6e0c7d:0xfae073f5ec8ed5d6",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Serena H. Chen, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Serena_Chen_600x600_2x-r9yq9umeokvb3bu9lt5qye91o216fi94nhurm0gv4w.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-jersey-city-serena-h-chen-md"
      },
      {
        "name": "Debbra A. Keegan, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Debbra_Keegan_600x600_2x-r9yq8xq21dm9sz61xwxt14jwvkjby3miuz0rtbtn6o.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-jersey-city-debbra-a-keegan-md"
      },
      {
        "name": "Jessica Salas Mann, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Jessica_Salas_Mann_600x600_2x-r9yq8c3ro6sody1gg5ldxs0b7phw128p400lrypp5s.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-jersey-city-jessica-salas-mann-md"
      },
      {
        "name": "Melissa C. Yih, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Melissa_C_Yih_600x600_2x-r9yq75t14n6rvhqwb5b6bkokhdadeokry6nr6igexs.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-jersey-city-melissa-c-yih-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-terra-fertility",
    "externalIds": {
      "googlePlaceId": "ChIJp7HbvdJ_44kR4VPNNxhfmJA"
    },
    "type": "fertility-clinic",
    "name": "Terra Fertility",
    "website": "https://www.terrafertility.com",
    "phone": "(781) 675-3192",
    "socialLinks": [
      {
        "platform": "instagram",
        "url": "https://www.instagram.com/terrafertility/",
        "label": "Instagram",
        "_source": {
          "url": "https://www.instagram.com/terrafertility/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "linkedin",
        "url": "https://www.linkedin.com/company/terra-fertility",
        "label": "LinkedIn",
        "_source": {
          "url": "https://www.linkedin.com/company/terra-fertility",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "address": {
      "line1": "45 Stergis Way",
      "city": "Dedham",
      "state": "MA",
      "zip": "02026",
      "country": "US"
    },
    "location": {
      "lat": 42.2342963,
      "lng": -71.1763829
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "patientGroups": ["LGBTQIA+"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.terrafertility.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.terrafertility.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.terrafertility.com",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.terrafertility.com/contact/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "missing"
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.terrafertility.com/about-terra-fertility-boston/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Terra+Fertility,+45+Stergis+Way,+Dedham,+MA+02026/@42.23429,-71.1763707,2954a,13.1y/data=!4m2!3m1!1s0x89e37fd2bddbb1a7:0x90985f1837cd53e1",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "socialLinks": {
          "status": "scraped",
          "source": {
            "url": "https://www.instagram.com/terrafertility/",
            "fetchedAt": "2026-06-15"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Emily Seidler",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.terrafertility.com/wp-content/uploads/2025/06/Emily-Seidler-MD-FACOG-terra-fertility.jpg.webp",
        "_source": {
          "url": "https://www.terrafertility.com/about-terra-fertility-boston/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-terra-fertility-emily-seidler"
      },
      {
        "name": "Pietro Bortoletto",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MSc", "FACOG"],
        "imageUrl": "https://www.terrafertility.com/wp-content/uploads/2025/06/Pietro-Bortoletto-MD-MSc-FACOG-terra-fertility.jpg.webp",
        "_source": {
          "url": "https://www.terrafertility.com/about-terra-fertility-boston/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-terra-fertility-pietro-bortoletto"
      },
      {
        "name": "Denis Vaughan",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.terrafertility.com/wp-content/uploads/2025/06/Denis-Vaughan-MD-FACOG-terra-fertility.jpg.webp",
        "_source": {
          "url": "https://www.terrafertility.com/about-terra-fertility-boston/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-terra-fertility-denis-vaughan"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnGJkGeg4e4HJxtFHTAfUfsB9-fJ1GAjCDpAV0Ww4w9MBiujlAxnSIbHYka2nhsEdzQlaTazKJWUXr0u_ChXgsXj5I9EfGSAFfko_A5vW8FhHfNlVtKuAa3SyN1Wb1C3q_N17e1pqDO6cUj=w224-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Terra+Fertility,+45+Stergis+Way,+Dedham,+MA+02026/@42.23429,-71.1763707,2954a,13.1y/data=!4m2!3m1!1s0x89e37fd2bddbb1a7:0x90985f1837cd53e1",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-kindbody-columbus",
    "externalIds": {
      "googlePlaceId": "ChIJJRDY6p31OIgREIJlzPECHwk"
    },
    "type": "fertility-clinic",
    "name": "Kindbody Columbus",
    "website": "https://kindbody.com",
    "address": {
      "line1": "8845 Lyra Dr",
      "city": "Columbus",
      "state": "OH",
      "zip": "43240",
      "country": "US"
    },
    "location": {
      "lat": 40.1446979,
      "lng": -82.9753346
    },
    "network": {
      "name": "Kindbody"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://kindbody.com/kindbody-opens-state-of-the-art-fertility-clinic-and-ivf-lab-in-columbus-oh/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://kindbody.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://kindbody.com",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/kindbody-opens-state-of-the-art-fertility-clinic-and-ivf-lab-in-columbus-oh/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "missing"
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/kindbody-opens-state-of-the-art-fertility-clinic-and-ivf-lab-in-columbus-oh/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+Columbus,+8845+Lyra+Dr,+Columbus,+OH+43240/@40.145726,-82.9759218,3050a,13.1y/data=!4m2!3m1!1s0x8838f59dead81025:0x91f02f1cc658210",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Kasey Reynolds Marelic",
        "role": "Reproductive Endocrinologist (Founding Medical Director)",
        "credentials": ["MD"],
        "imageUrl": "https://www.springcreekfertility.com/wp-content/uploads/2025/05/luxe-3d-cincinnati-real-estate-photographer-03-673x1024.jpg.webp",
        "_source": {
          "url": "https://www.springcreekfertility.com/dr-kasey-marelic/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-kindbody-columbus-kasey-reynolds-marelic"
      }
    ],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk_vmXGJ360pm1wrOEPi-gdKWP7w25eCO9UJnNBZLcgmgVbJH_PahkRN48Ln_d6IPTaiv2k0pJfzA9k-E4zaSsVp4D9xqb8JrYYmR21cT7rN98InfE8YatYXUAGezLFVO3ttbU3=w408-h544-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Columbus,+8845+Lyra+Dr,+Columbus,+OH+43240/@40.145726,-82.9759218,3050a,13.1y/data=!4m2!3m1!1s0x8838f59dead81025:0x91f02f1cc658210",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Ohio (OH) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-kindbody-bethesda",
    "externalIds": {
      "googlePlaceId": "ChIJFYXkCCHNt4kRdYn4FitgHPU"
    },
    "type": "fertility-clinic",
    "name": "Kindbody Bethesda",
    "website": "https://kindbody.com/bethesda/",
    "phone": "(301) 363-0226",
    "address": {
      "line1": "6000 Executive Blvd, Suite 500",
      "city": "North Bethesda",
      "state": "MD",
      "zip": "20852",
      "country": "US"
    },
    "location": {
      "lat": 39.0479274,
      "lng": -77.1205623
    },
    "network": {
      "name": "Kindbody"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://kindbody.com/location/bethesda-maryland/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://kindbody.com/location/bethesda-maryland/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://kindbody.com/location/bethesda-maryland/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/bethesda/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "missing"
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/bethesda/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody-+Bethesda,+6000+Executive+Blvd+Ste+500,+Rockville,+MD+20852/@39.0479733,-77.1205612,3099a,13.1y/data=!4m2!3m1!1s0x89b7cd2108e48515:0xf51c602b16f88975",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "bookingUrl": "https://kindbody.com/bethesda/",
    "team": [
      {
        "practitionerId": "pr-org-web-kindbody-bethesda-xiaohong-liu-md",
        "name": "Xiaohong Liu, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://kindbody.com/wp-content/uploads/2023/11/dr._qian_qian_720-150x150.jpg",
        "_source": {
          "url": "https://kindbody.com/team/dr-xiaohong-liu/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Maryland (MD) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlYYvDorz0_F6Xp8VScr_epxVbUiilRdg8k-OYh3IoftWIZh9a6KltCbeBrtHZZIR1rFd0FZpaj0aFx0AkKYXfWRPnm8oxoNBJb-qIxhANe2h1w6BQelBV03mTkzGGZ20ToRtHAh4xfUKkG=w360-h360-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody-+Bethesda,+6000+Executive+Blvd+Ste+500,+Rockville,+MD+20852/@39.0479733,-77.1205612,3099a,13.1y/data=!4m2!3m1!1s0x89b7cd2108e48515:0xf51c602b16f88975",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-iu-health-fertility",
    "externalIds": {
      "googlePlaceId": "ChIJ-cI-3hNXa4gRIOK-c2xB1-A"
    },
    "type": "fertility-clinic",
    "name": "IU Health Reproductive Endocrinology & Fertility",
    "website": "https://iuhealth.org/find-locations/iu-health-reproductive-endocrinology-fertility-550-n-university-blvd-indianapolis",
    "address": {
      "line1": "550 N. University Blvd",
      "city": "Indianapolis",
      "state": "IN",
      "zip": "46202",
      "country": "US"
    },
    "location": {
      "lat": 39.7809042,
      "lng": -86.1734598
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://iuhealth.org/find-locations/iu-health-reproductive-endocrinology-fertility-550-n-university-blvd-indianapolis",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://iuhealth.org",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://iuhealth.org",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://iuhealth.org/find-locations/iu-health-reproductive-endocrinology-fertility-550-n-university-blvd-indianapolis",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://iuhealth.org/find-providers/provider/michael-a-henry-md-11014",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "missing"
        },
        "pricing": {
          "status": "searched-absent",
          "source": {
            "url": "https://iuhealth.org/find-locations/iu-health-reproductive-endocrinology-fertility-550-n-university-blvd-indianapolis",
            "fetchedAt": "2026-06-13"
          }
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://medicine.iu.edu/faculty/24314/henry-michael",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/IU+Health+Reproductive+Endocrinology+%26+Fertility+-+Indianapolis,+550+University+Blvd+Suite+2403,+Indianapolis,+IN+46202/@39.7754993,-86.1763903,3066a,13.1y/data=!4m2!3m1!1s0x886b5713de3ec2f9:0xe0d7416c73bee220",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://iuhealth.org/find-locations/iu-health-reproductive-endocrinology-fertility-550-n-university-blvd-indianapolis",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "phone": "(317) 944-8231",
    "description": "IU Health Reproductive Endocrinology & Fertility - Indianapolis provides reproductive endocrinology and infertility services, including IVF, IUI and egg freezing, at 550 N. University Blvd.",
    "team": [
      {
        "practitionerId": "pr-org-web-iu-health-fertility-michael-a-henry-md",
        "name": "Michael A. Henry, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://mc-34647c8d-0ad3-4e6c-832a-7092-cdn.azureedge.net/-/media/project/facultyprofileimages/2021/02/06/22/13/24314-michael-henry.png?rev=7a0fde0a5ab846b286ca515b72a4ce06&la=en&h=600&w=400&hash=D7F5F08A7C5DB8E69E42E608B467CD4F",
        "_source": {
          "url": "https://medicine.iu.edu/faculty/24314/henry-michael",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Indiana (IN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-okc-fertility",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Oklahoma City Fertility",
    "website": "https://okcfertility.com",
    "phone": "(405) 724-7102",
    "address": {
      "line1": "3330 NW 56th St, Suite 600",
      "city": "Oklahoma City",
      "state": "OK",
      "zip": "73112",
      "country": "US"
    },
    "location": {
      "lat": 35.5274035,
      "lng": -97.5751136
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://okcfertility.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://okcfertility.com",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://okcfertility.com/about-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://okcfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://okcfertility.com/about-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://okcfertility.com/about-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://i0.wp.com/okcfertility.com/wp-content/uploads/2023/08/DSC00004.jpeg?fit=1200%2C739&ssl=1",
        "type": "interior",
        "caption": "Oklahoma City Fertility waiting room",
        "_source": {
          "url": "https://okcfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "team": [
      {
        "practitionerId": "pr-org-web-okc-fertility-sana-khan-md-facog",
        "name": "Sana Khan, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinologist",
        "imageUrl": "https://i0.wp.com/okcfertility.com/wp-content/uploads/2023/08/DSC00024-copy-e1693191524892.jpg?fit=1224%2C1617&ssl=1",
        "_source": {
          "url": "https://okcfertility.com/about-us/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-okc-fertility-kellie-williams-phd-hcld-eld",
        "name": "Kellie Williams, PhD, HCLD, ELD",
        "role": "Laboratory Director",
        "credentials": ["PhD", "HCLD", "ELD"],
        "specialty": "Laboratory Director",
        "imageUrl": "https://i0.wp.com/okcfertility.com/wp-content/uploads/2023/08/DSC00067-1-e1693192043211.jpg?fit=1167%2C1200&ssl=1",
        "_source": {
          "url": "https://okcfertility.com/about-us/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Oklahoma (OK) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-kindbody-rogers",
    "externalIds": {
      "googlePlaceId": "ChIJA7rP9rYRyYcRU4H3ntV_TfM"
    },
    "type": "fertility-clinic",
    "name": "Kindbody Rogers",
    "website": "https://kindbody.com/location/arkansas/",
    "address": {
      "line1": "2203 S Promenade Blvd, Suite 5185",
      "city": "Rogers",
      "state": "AR",
      "zip": "72758",
      "country": "US"
    },
    "location": {
      "lat": 36.308693,
      "lng": -94.17501
    },
    "network": {
      "name": "Kindbody"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://kindbody.com/location/arkansas/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://kindbody.com/location/arkansas/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://kindbody.com/location/arkansas/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://kindbody.com/location/arkansas/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "missing"
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://kindbody.com/book-appointment-arkansas/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+Arkansas,+2203+S+Promenade+Blvd+%235185,+Rogers,+AR+72758/@36.3050706,-94.1743816,3215a,13.1y/data=!4m2!3m1!1s0x87c911b6f6cfba03:0xf34d7fd59ef78153",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Dr. Fahimeh Sasan",
        "role": "Founding Physician & Chief Innovation Officer",
        "imageUrl": "https://kindbody.com/wp-content/uploads/2019/12/Fahimeh-Sasan-Web-KB-683x1024.jpg",
        "_source": {
          "url": "https://kindbody.com/book-appointment-arkansas/",
          "fetchedAt": "2026-06-13"
        },
        "practitionerId": "pr-org-web-kindbody-rogers-dr-fahimeh-sasan"
      },
      {
        "name": "Caitlin Bley",
        "role": "APP",
        "credentials": ["DNP", "APRN", "CNM", "IBCLC"],
        "imageUrl": "https://kindbody.com/wp-content/uploads/2025/05/Caitlin-Bley-Web2-683x1024.jpg",
        "_source": {
          "url": "https://kindbody.com/book-appointment-arkansas/",
          "fetchedAt": "2026-06-13"
        },
        "practitionerId": "pr-org-web-kindbody-rogers-caitlin-bley"
      },
      {
        "name": "McKenzie Stock",
        "role": "Nurse Practitioner",
        "credentials": ["DNP", "APRN", "FNP-BC"],
        "imageUrl": "https://kindbody.com/wp-content/uploads/2025/05/McKenzie-Stock-Web2-683x1024.jpg",
        "_source": {
          "url": "https://kindbody.com/book-appointment-arkansas/",
          "fetchedAt": "2026-06-13"
        },
        "practitionerId": "pr-org-web-kindbody-rogers-mckenzie-stock"
      },
      {
        "name": "Dr. Larry Barmat",
        "role": "Reproductive Endocrinologist",
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://kindbody.com/wp-content/uploads/2026/02/Larry-683x1024.jpg",
        "_source": {
          "url": "https://kindbody.com/book-appointment-arkansas/",
          "fetchedAt": "2026-06-13"
        },
        "practitionerId": "pr-org-web-kindbody-rogers-dr-larry-barmat"
      }
    ],
    "phone": "(479) 480-7200",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Arkansas (AR) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlEKys3gxJUDcAF6xHuHVe1pAmmz52Lpf6JPWM2Pl0IJGsVqSdVSNR98G_r7IQwUdYa9SXTqRz0gyw7E5anIo0erH82cngqI52HezcZhMDruSNkvL9asUQ1nMKmMZB8N7nXGoExEw=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Arkansas,+2203+S+Promenade+Blvd+%235185,+Rogers,+AR+72758/@36.3050706,-94.1743816,3215a,13.1y/data=!4m2!3m1!1s0x87c911b6f6cfba03:0xf34d7fd59ef78153",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-brandeis-fertility-ny",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Brandeis Fertility Center of New York",
    "website": "https://queensfertilityandivf.com",
    "address": {
      "line1": "110-15 71st Rd",
      "city": "Forest Hills",
      "state": "NY",
      "zip": "11375",
      "country": "US"
    },
    "location": {
      "lat": 40.7218095,
      "lng": -73.8410626
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://queensfertilityandivf.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://queensfertilityandivf.com",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://queensfertilityandivf.com",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "missing"
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://queensfertilityandivf.com/about-dr-vincent-brandeis/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Vincent Brandeis, MD",
        "imageUrl": "https://queensfertilityandivf.com/wp-content/uploads/2022/06/Dr-Vincent-Brandeis.jpg",
        "_source": {
          "url": "https://queensfertilityandivf.com/about-dr-vincent-brandeis/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-brandeis-fertility-ny-vincent-brandeis-md"
      }
    ],
    "images": [
      {
        "url": "https://queensfertilityandivf.com/wp-content/uploads/2025/08/Office_Vincent-Brandeis_2-1.jpg",
        "type": "interior",
        "caption": "Brandeis Fertility office",
        "_source": {
          "url": "https://queensfertilityandivf.com/about-dr-vincent-brandeis/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://queensfertilityandivf.com/wp-content/uploads/2025/08/Office_Vincent-Brandeis_1.jpg",
        "type": "interior",
        "caption": "Brandeis Fertility office",
        "_source": {
          "url": "https://queensfertilityandivf.com/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-montefiore-irmh-bronx",
    "externalIds": {
      "googlePlaceId": "ChIJ68ubsa30wokRu-WLZDj2awk"
    },
    "type": "fertility-clinic",
    "name": "Montefiore Einstein Institute for Reproductive Medicine and Health - Bronx",
    "website": "https://montefioreeinstein.org/patient-care/services/womens-health/specialties/reproductive-endocrinology-infertility",
    "address": {
      "line1": "1695 Eastchester Rd, Suite 302",
      "city": "Bronx",
      "state": "NY",
      "zip": "10461",
      "country": "US"
    },
    "location": {
      "lat": 40.8461873,
      "lng": -73.8449886
    },
    "network": {
      "name": "Montefiore Einstein"
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://montefioreeinstein.org/patient-care/services/womens-health/specialties/reproductive-endocrinology-infertility",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://montefioreeinstein.org/patient-care/services/womens-health/specialties/reproductive-endocrinology-infertility",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://montefioreeinstein.org/patient-care/services/womens-health/specialties/reproductive-endocrinology-infertility",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://montefioreeinstein.org/patient-care/services/womens-health/specialties/reproductive-endocrinology-infertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "missing"
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://doctors.montefioreeinstein.org/providers/1275613739/harry-j-lieman",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Montefiore+Medical+Park+at+Eastchester,+1695+Eastchester+Rd,+Bronx,+NY+10461/@40.8462736,-73.845166,3018a,13.1y/data=!4m2!3m1!1s0x89c2f4adb19bcbeb:0x96bf638648be5bb",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Harry J. Lieman, MD",
        "imageUrl": "https://documentapi-fargate-documentbucket-15qi4tpdvnhlz.s3.amazonaws.com/218/8e8cd210-c4aa-11eb-925b-439657343c68.jpg",
        "_source": {
          "url": "https://doctors.montefioreeinstein.org/providers/1275613739/harry-j-lieman",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-montefiore-irmh-bronx-harry-j-lieman-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlOdX_UhdHGNO_ZRiGmBztOERLUyt_3uUR8UhyzI38y57JKsOCKVfVnB8UYXWiFW1mPkLmuq46EuQyoANLtw3mjfg0sdkppOpkmoSIF5mQM82gz1K0FagP-pZfSmw6aQADomMxAxQ=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Montefiore+Medical+Park+at+Eastchester,+1695+Eastchester+Rd,+Bronx,+NY+10461/@40.8462736,-73.845166,3018a,13.1y/data=!4m2!3m1!1s0x89c2f4adb19bcbeb:0x96bf638648be5bb",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm0gyEfgTOTSOu-SSSsgQV4Ylbl7NF7R1lUiCrGWoJEEks7xmR5x_CGRFAA9-Oc7KKtp1L8Z5BlqTNZSinItPxoN4omsTdtM2auj6D6bIOicg9HiNdTl3E5LQQJ2bm0s-LH0K-N=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Montefiore+Medical+Park+at+Eastchester,+1695+Eastchester+Rd,+Bronx,+NY+10461/@40.8462736,-73.845166,3018a,13.1y/data=!4m2!3m1!1s0x89c2f4adb19bcbeb:0x96bf638648be5bb",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-mor-fertility",
    "externalIds": {
      "googlePlaceId": "ChIJf-P-mg9ZwokR3fdSm6Ckhew"
    },
    "type": "fertility-clinic",
    "name": "Mor Fertility",
    "website": "https://www.morfertility.com",
    "phone": "(646) 504-1672",
    "address": {
      "line1": "245 5th Avenue, 3rd Floor",
      "city": "New York",
      "state": "NY",
      "zip": "10016",
      "country": "US"
    },
    "location": {
      "lat": 40.7444471,
      "lng": -73.9872102
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.morfertility.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.morfertility.com",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.dramirmor.com/location",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "missing"
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Mor+Fertility+(Dr.+Amir+Mor,+MD+PhD),+245+5th+Ave+3rd+floor+Suite+308,+New+York,+NY+10016/@40.7443846,-73.9870662,3023a,13.1y/data=!4m2!3m1!1s0x89c2590f9afee37f:0xec85a4a09b52f7dd",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkEf_sLEJBYoejU5iP82aUTb0rA68XhIPP6Mj3qZRNSZZ-YgCjVzUAKBEwxEElafnMBPE1fIPuEb3KTftP2zDF-xQ3V0FB30IhQza5tN-a722JEvWUR5QYcimY4zcoDX4EkV2D7=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Mor+Fertility+(Dr.+Amir+Mor,+MD+PhD),+245+5th+Ave+3rd+floor+Suite+308,+New+York,+NY+10016/@40.7443846,-73.9870662,3023a,13.1y/data=!4m2!3m1!1s0x89c2590f9afee37f:0xec85a4a09b52f7dd",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmXIhS2EypGpE1kxGZYUKCN56DpPgcaZE03-RBwZhynxlvpDPt2CTrhahWupnNBq3G6crfXa0phfajHkGxQZzrrdV4B1pGEzPYddTsmCNTcYtAq7ggGa0zp6b35kNNWYjVi61LW=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Mor+Fertility+(Dr.+Amir+Mor,+MD+PhD),+245+5th+Ave+3rd+floor+Suite+308,+New+York,+NY+10016/@40.7443846,-73.9870662,3023a,13.1y/data=!4m2!3m1!1s0x89c2590f9afee37f:0xec85a4a09b52f7dd",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-nyu-rsny-brooklyn",
    "externalIds": {
      "googlePlaceId": "ChIJ78uGcEhawokR9T5DaHw5nmA"
    },
    "type": "fertility-clinic",
    "name": "NYU Langone Reproductive Specialists of New York - Brooklyn",
    "website": "https://www.fertilityrsny.org/brooklyn-fertility-clinic",
    "address": {
      "line1": "16 Court Street, 27th Floor",
      "city": "Brooklyn",
      "state": "NY",
      "zip": "11241",
      "country": "US"
    },
    "location": {
      "lat": 40.6936534,
      "lng": -73.9907124
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.fertilityrsny.org/brooklyn-fertility-clinic",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.fertilityrsny.org/brooklyn-fertility-clinic",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilityrsny.org/brooklyn-fertility-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "missing"
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/NYU+Langone+Reproductive+Specialists+of+New+York%E2%80%94Brooklyn,+16+Court+St+27th+floor,+Brooklyn,+NY+11241/@40.693632,-73.9908531,3025a,13.1y/data=!4m2!3m1!1s0x89c25a487086cbef:0x609e397c68433ef5",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWklUhfCieqe6IjyoYOWBKbNzhivYlSWgeBU_JE_9tITOhFmoO3DYYoppi9KTPp2vt2nBa3PRB3pZyqFjfU10uVztBjpAi3WSSnTSyBSdU-gFejdAGECN1fDhQD6_vZudUySO3gRphdt9_MT=w298-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/NYU+Langone+Reproductive+Specialists+of+New+York%E2%80%94Brooklyn,+16+Court+St+27th+floor,+Brooklyn,+NY+11241/@40.693632,-73.9908531,3025a,13.1y/data=!4m2!3m1!1s0x89c25a487086cbef:0x609e397c68433ef5",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-rma-ny-mount-sinai",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "RMA of New York - Mount Sinai",
    "website": "https://www.rmany.com/about-rmany/locations/manhattan/rma-mount-sinai",
    "address": {
      "line1": "5 East 98th Street",
      "city": "New York",
      "state": "NY",
      "zip": "10029",
      "country": "US"
    },
    "location": {
      "lat": 40.7890906,
      "lng": -73.9539001
    },
    "network": {
      "name": "US Fertility"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.rmany.com/about-rmany/locations/manhattan",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.rmany.com/about-rmany/locations/manhattan",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.rmany.com/about-rmany/locations/manhattan",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.rmany.com/about-rmany/locations/manhattan/rma-mount-sinai",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "missing"
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-rma-ny-westside",
    "externalIds": {
      "googlePlaceId": "ChIJYXF-mfdYwokRFqcd0lBW8C4"
    },
    "type": "fertility-clinic",
    "name": "RMA of New York - West Side",
    "website": "https://www.rmany.com/about-rmany/locations/manhattan/rma-westside",
    "address": {
      "line1": "200 W 57th St, Suite 900",
      "city": "New York",
      "state": "NY",
      "zip": "10019",
      "country": "US"
    },
    "location": {
      "lat": 40.7654312,
      "lng": -73.9804189
    },
    "network": {
      "name": "US Fertility"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.rmany.com/about-rmany/locations/manhattan",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.rmany.com/about-rmany/locations/manhattan",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.rmany.com/about-rmany/locations/manhattan/rma-westside",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "missing"
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+of+New+York:+Westside,+200+W+57th+St+Ste+900,+New+York,+NY+10019/@40.7654178,-73.9806094,3022a,13.1y/data=!4m2!3m1!1s0x89c258f7997e7161:0x2ef05650d21da716",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://www.rmany.com/media/pages/about-rmany/locations/manhattan/rma-westside/d79193e2e0-1729794593/westside-rma.jpg",
        "type": "interior",
        "caption": "RMA of New York Westside location",
        "_source": {
          "url": "https://www.rmany.com/about-rmany/locations/manhattan/rma-westside",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-rma-ny-downtown",
    "externalIds": {
      "googlePlaceId": "ChIJF-LnB49ZwokRRkUl0CYOEX4"
    },
    "type": "fertility-clinic",
    "name": "RMA of New York - Downtown",
    "website": "https://www.rmany.com/about-rmany/locations/manhattan/rma-downtown",
    "address": {
      "line1": "594 Broadway, Suite 1011",
      "city": "New York",
      "state": "NY",
      "zip": "10012",
      "country": "US"
    },
    "location": {
      "lat": 40.7249922,
      "lng": -73.9969625
    },
    "network": {
      "name": "US Fertility"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.rmany.com/about-rmany/locations/manhattan",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.rmany.com/about-rmany/locations/manhattan",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.rmany.com/about-rmany/locations/manhattan/rma-downtown",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "missing"
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/RMA+of+New+York:+Downtown+floor+11,+594+Broadway+%231101,+New+York,+NY+10012/@40.7249354,-73.9969647,3024a,13.1y/data=!4m2!3m1!1s0x89c2598f07e7e217:0x7e110e26d0254546",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://www.rmany.com/media/pages/about-rmany/locations/manhattan/rma-downtown/13352f5dec-1729794593/img_5115_edited-1.jpg",
        "type": "interior",
        "caption": "RMA of New York Downtown location",
        "_source": {
          "url": "https://www.rmany.com/about-rmany/locations/manhattan/rma-downtown",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmrDlHbLQojqxEcQ86JUx2i6HFcWcCPyGpyK0-fEC3xx3QDnfWCKoQDLJPAL91zQ3gKTi8n-n7f8Hi5TLfrFmmlMxCyF92qbM1cAChOy5XEzgeSDLybq-oK4-1g8X4lcW5TXeaLOw=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/RMA+of+New+York:+Downtown+floor+11,+594+Broadway+%231101,+New+York,+NY+10012/@40.7249354,-73.9969647,3024a,13.1y/data=!4m2!3m1!1s0x89c2598f07e7e217:0x7e110e26d0254546",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-cheyenne-womens-clinic",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Cheyenne Women's Clinic",
    "address": {
      "line1": "3952 Parkview Dr",
      "city": "Cheyenne",
      "state": "WY",
      "zip": "82001",
      "country": "US"
    },
    "location": {
      "lat": 41.1575589,
      "lng": -104.761738
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://cwcob.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://cwcob.com",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://cwcob.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://cwcob.com",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://cwcob.com/our-team/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://cwcob.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "website": "https://cwcob.com",
    "images": [],
    "phone": "(307) 637-7700",
    "team": [
      {
        "practitionerId": "pr-org-web-cheyenne-womens-clinic-rene-hinkle-md",
        "name": "Rene Hinkle, MD",
        "role": "OB/GYN",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://egte6nxuwyy.exactdn.com/wp-content/uploads/2024/10/Rhinkle-10.09.24-2.jpg?strip=all&quality=60",
        "_source": {
          "url": "https://cwcob.com/our-team/dr-rene-hinkle/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-cheyenne-womens-clinic-jacques-beveridge-md",
        "name": "Jacques Beveridge, MD",
        "role": "OB/GYN",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://egte6nxuwyy.exactdn.com/wp-content/uploads/2024/10/Jacques-Beveridge-MD-2.jpg?strip=all&quality=60",
        "_source": {
          "url": "https://cwcob.com/our-team/dr-jacques-beveridge/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-cheyenne-womens-clinic-megan-looby-do",
        "name": "Megan Looby, DO",
        "role": "OB/GYN",
        "credentials": ["DO"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://egte6nxuwyy.exactdn.com/wp-content/uploads/2024/10/Megan-Looby-DO-2.jpg?strip=all&quality=60",
        "_source": {
          "url": "https://cwcob.com/our-team/dr-megan-looby/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-cheyenne-womens-clinic-melissa-dozier-md",
        "name": "Melissa Dozier, MD",
        "role": "OB/GYN",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://egte6nxuwyy.exactdn.com/wp-content/uploads/2024/10/melissa-dozier-md-new.jpg?strip=all&quality=60",
        "_source": {
          "url": "https://cwcob.com/our-team/dr-melissa-dozier/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-cheyenne-womens-clinic-stormie-carter-md",
        "name": "Stormie Carter, MD",
        "role": "OB/GYN",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://egte6nxuwyy.exactdn.com/wp-content/uploads/2024/10/Dr.-Stormie-Carter-MD.jpg?strip=all&quality=60",
        "_source": {
          "url": "https://cwcob.com/our-team/dr-stormie-carter/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-cheyenne-womens-clinic-ryan-boone-md",
        "name": "Ryan Boone, MD",
        "role": "OB/GYN",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://egte6nxuwyy.exactdn.com/wp-content/uploads/2024/10/Dr.-Ryan-Boone-MD-2.jpg?strip=all&quality=60",
        "_source": {
          "url": "https://cwcob.com/dr-ryan-boone/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-cheyenne-womens-clinic-bailey-montgomery-pa-c",
        "name": "Bailey Montgomery, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "specialty": "Physician Assistant",
        "imageUrl": "https://egte6nxuwyy.exactdn.com/wp-content/uploads/2024/10/Bailey-Montgomery-PA-C.jpg?strip=all&quality=60",
        "_source": {
          "url": "https://cwcob.com/our-team/bailey-montgomery/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Wyoming (WY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-cheyenne-obgyn",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Cheyenne OBGYN",
    "address": {
      "line1": "2301 House Ave, Suite 400",
      "city": "Cheyenne",
      "state": "WY",
      "zip": "82001",
      "country": "US"
    },
    "location": {
      "lat": 41.1405788,
      "lng": -104.815424
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://cheyenneobgyn.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://cheyenneobgyn.com",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://cheyenneobgyn.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://cheyenneobgyn.com",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://cheyenneobgyn.com/providers/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://cheyenneobgyn.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "website": "https://cheyenneobgyn.com",
    "team": [
      {
        "practitionerId": "pr-org-web-cheyenne-obgyn-austin-l-barnes-md",
        "name": "Austin L. Barnes, MD",
        "role": "OB/GYN",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://cheyenneobgyn.com/austin-l-barnes-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-cheyenne-obgyn-colleen-c-foos-md",
        "name": "Colleen C. Foos, MD",
        "role": "OB/GYN",
        "credentials": ["MD", "FACOG"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://cheyenneobgyn.com/wp-content/uploads/elementor/thumbs/Colleen_Foos_MD-rd9i3nu6jbaqkldv6fcvwmwied5vmlm3s59kxo5kfw.jpg",
        "_source": {
          "url": "https://cheyenneobgyn.com/colleen-c-foos-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-cheyenne-obgyn-natalie-m-howard-md",
        "name": "Natalie M. Howard, MD",
        "role": "OB/GYN",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://cheyenneobgyn.com/wp-content/uploads/elementor/thumbs/Natalie_16F-r2ts6w0ps4emczmvilu4sf42bdxdu2h6784uw2ns8e.jpeg",
        "_source": {
          "url": "https://cheyenneobgyn.com/natalie-howard-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-cheyenne-obgyn-samantha-l-michelena-md",
        "name": "Samantha L. Michelena, MD",
        "role": "OB/GYN",
        "credentials": ["MD", "FACOG"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://cheyenneobgyn.com/wp-content/uploads/2023/06/Michelena-2023-Pic-updated.png",
        "_source": {
          "url": "https://cheyenneobgyn.com/samantha-l-michelena-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-cheyenne-obgyn-michael-r-nelson-do",
        "name": "Michael R. Nelson, DO",
        "role": "OB/GYN",
        "credentials": ["DO"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://cheyenneobgyn.com/michael-r-nelson-do/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-cheyenne-obgyn-wendy-g-avalos-rn-bsn-msn-fnp-c",
        "name": "Wendy G. Avalos, RN, BSN, MSN, FNP-C",
        "role": "Nurse Practitioner",
        "credentials": ["RN", "BSN", "MSN", "FNP-C"],
        "specialty": "Family Nurse Practitioner",
        "imageUrl": "https://cheyenneobgyn.com/wp-content/uploads/2025/01/Wendy_2-986x1024.jpg",
        "_source": {
          "url": "https://cheyenneobgyn.com/wendy-avalos-rn-bsn-msn-fnp-c/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-cheyenne-obgyn-lisa-e-meeker-rn-bsn-msn-fnp-c",
        "name": "Lisa E. Meeker, RN, BSN, MSN, FNP-C",
        "role": "Nurse Practitioner",
        "credentials": ["RN", "BSN", "MSN", "FNP-C"],
        "specialty": "Family Nurse Practitioner",
        "_source": {
          "url": "https://cheyenneobgyn.com/lisa-e-meeker-rn-bsn-msn-np-c/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "phone": "(307) 634-5216",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Wyoming (WY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-womens-health-assoc-casper",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Women's Health Associates",
    "address": {
      "line1": "1125 E 2nd St",
      "city": "Casper",
      "state": "WY",
      "zip": "82601",
      "country": "US"
    },
    "location": {
      "lat": 42.8486876,
      "lng": -106.3105741
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://doctor.webmd.com/practice/womens-health-associates-of-wyoming-70d768c8-4703-e211-a42b-001f29e3eb44",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "searched-absent"
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://doctor.webmd.com/practice/womens-health-associates-of-wyoming-70d768c8-4703-e211-a42b-001f29e3eb44",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://doctor.webmd.com/practice/womens-health-associates-of-wyoming-70d768c8-4703-e211-a42b-001f29e3eb44",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "phone": "(307) 577-4225",
    "team": [
      {
        "practitionerId": "pr-org-web-womens-health-assoc-casper-brittany-myers-md",
        "name": "Brittany Myers, MD",
        "role": "OB/GYN",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://a.mktgcdn.com/p/ghpjIP22mWZX_-u1vE4TC0leDiOnKpJvNkAY9uV-_8w/448x252.jpg",
        "_source": {
          "url": "https://doctor.webmd.com/doctor/brittany-myers-ecce27f4-45b2-4114-aed2-0cc117df96a6-overview",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-womens-health-assoc-casper-sam-t-scaling-md",
        "name": "Sam T. Scaling, MD",
        "role": "OB/GYN",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://mdxvitals-res.cloudinary.com/private_images/h_150%2Cw_150%2Cc_fill%2Cg_face%2Cf_auto%2Cdpr_auto/professionals/1962551/photo.jpg",
        "_source": {
          "url": "https://doctor.webmd.com/doctor/sam-scaling-cbc2a7ee-826c-4f39-bc23-824100e5d8c5-overview",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Wyoming (WY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-alaska-womens-health",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Alaska Women's Health",
    "address": {
      "line1": "3260 Providence Dr, Suite 322",
      "city": "Anchorage",
      "state": "AK",
      "zip": "99508",
      "country": "US"
    },
    "location": {
      "lat": 61.1897636,
      "lng": -149.8180688
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.akwomenshealth.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://www.akwomenshealth.com",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.akwomenshealth.com/contact-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.akwomenshealth.com/fertility/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.akwomenshealth.com/about-us-alaska-womens-health/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.akwomenshealth.com/about-us-alaska-womens-health/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "website": "https://www.akwomenshealth.com/",
    "phone": "(907) 563-5151",
    "images": [],
    "team": [
      {
        "practitionerId": "pr-org-web-alaska-womens-health-amanda-beery-md",
        "name": "Amanda Beery, MD",
        "role": "OB/GYN",
        "imageUrl": "https://www.akwomenshealth.com/wp-content/uploads/2024/03/amandabeery.jpg",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://www.akwomenshealth.com/about-us-alaska-womens-health/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-alaska-womens-health-ann-broz-md",
        "name": "Ann Broz, MD",
        "role": "OB/GYN",
        "imageUrl": "https://www.akwomenshealth.com/wp-content/uploads/2022/01/ann-broz.jpg",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://www.akwomenshealth.com/about-us-alaska-womens-health/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-alaska-womens-health-bella-barrows-fnp-c",
        "name": "Bella Barrows, FNP-C",
        "role": "Nurse Practitioner",
        "credentials": ["FNP-C"],
        "specialty": "Nurse Practitioner",
        "_source": {
          "url": "https://www.akwomenshealth.com/about-us-alaska-womens-health/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-alaska-womens-health-tania-hall-md",
        "name": "Tania Hall, MD",
        "role": "OB/GYN",
        "imageUrl": "https://www.akwomenshealth.com/wp-content/uploads/2020/06/AWH-8404.jpg",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://www.akwomenshealth.com/about-us-alaska-womens-health/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-alaska-womens-health-craig-hinkle-md",
        "name": "Craig Hinkle, MD",
        "role": "OB/GYN",
        "imageUrl": "https://www.akwomenshealth.com/wp-content/uploads/2020/06/AWH-8461.jpg",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://www.akwomenshealth.com/about-us-alaska-womens-health/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-alaska-womens-health-sylvia-moses-md",
        "name": "Sylvia Moses, MD",
        "role": "OB/GYN",
        "imageUrl": "https://www.akwomenshealth.com/wp-content/uploads/2020/06/AWH-8442.jpg",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://www.akwomenshealth.com/about-us-alaska-womens-health/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-alaska-womens-health-sherifat-ope-adenuga-md",
        "name": "Sherifat Ope-Adenuga, MD",
        "role": "OB/GYN",
        "imageUrl": "https://www.akwomenshealth.com/wp-content/uploads/2020/06/AWH-8423.jpg",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://www.akwomenshealth.com/about-us-alaska-womens-health/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-alaska-womens-health-alia-parker-anp-fnp-c",
        "name": "Alia Parker, ANP, FNP-C",
        "role": "Nurse Practitioner",
        "imageUrl": "https://www.akwomenshealth.com/wp-content/uploads/2020/06/AWH-8480.jpg",
        "credentials": ["ANP", "FNP-C"],
        "specialty": "Nurse Practitioner",
        "_source": {
          "url": "https://www.akwomenshealth.com/about-us-alaska-womens-health/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-alaska-womens-health-brittany-strickland-do",
        "name": "Brittany Strickland, DO",
        "role": "OB/GYN",
        "imageUrl": "https://www.akwomenshealth.com/wp-content/uploads/2025/09/Untitled-design-1.png",
        "credentials": ["DO"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://www.akwomenshealth.com/about-us-alaska-womens-health/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-alaska-womens-health-alyssa-wells-md",
        "name": "Alyssa Wells, MD",
        "role": "OB/GYN",
        "imageUrl": "https://www.akwomenshealth.com/wp-content/uploads/2020/06/AWH-8229.jpg",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://www.akwomenshealth.com/about-us-alaska-womens-health/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-alaska-womens-health-lisa-weston-cnm",
        "name": "Lisa Weston, CNM",
        "role": "Certified Nurse Midwife",
        "imageUrl": "https://www.akwomenshealth.com/wp-content/uploads/2022/01/Lisa-Weston_-CNM.jpg",
        "credentials": ["CNM"],
        "specialty": "Certified Nurse Midwife",
        "_source": {
          "url": "https://www.akwomenshealth.com/about-us-alaska-womens-health/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-alaska-womens-health-patricia-young-cnm-whnp-dnp",
        "name": "Patricia Young, CNM, WHNP, DNP",
        "role": "Certified Nurse Midwife",
        "imageUrl": "https://www.akwomenshealth.com/wp-content/uploads/2024/04/Trish-Young.png",
        "credentials": ["CNM", "WHNP", "DNP"],
        "specialty": "Certified Nurse Midwife",
        "_source": {
          "url": "https://www.akwomenshealth.com/about-us-alaska-womens-health/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-alaska-womens-health-louisa-chatroux-md",
        "name": "Louisa Chatroux, MD",
        "role": "OB/GYN",
        "imageUrl": "https://www.akwomenshealth.com/wp-content/uploads/2024/06/Dr.-Louisa-Chatroux.png",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://www.akwomenshealth.com/about-us-alaska-womens-health/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Alaska (AK) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-anchorage-womens-clinic",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Anchorage Women's Clinic",
    "address": {
      "line1": "3260 Providence Dr, Suite 425",
      "city": "Anchorage",
      "state": "AK",
      "zip": "99508",
      "country": "US"
    },
    "location": {
      "lat": 61.1897636,
      "lng": -149.8180688
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://anchoragewomensclinic.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://anchoragewomensclinic.com",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://anchoragewomensclinic.com",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://anchoragewomensclinic.com",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://anchoragewomensclinic.com/our-providers/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://anchoragewomensclinic.com/obstetrics/fertility/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "website": "https://anchoragewomensclinic.com/",
    "phone": "(907) 561-7111",
    "team": [
      {
        "practitionerId": "pr-org-web-anchorage-womens-clinic-allison-gibbs-md-facog",
        "name": "Allison Gibbs, MD, FACOG",
        "role": "OB/GYN",
        "imageUrl": "https://anchoragewomensclinic.com/wp-content/uploads/2021/02/Allison-Gibbs.jpg",
        "credentials": ["MD", "FACOG"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://anchoragewomensclinic.com/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-anchorage-womens-clinic-dana-espindola-md-facog",
        "name": "Dana Espindola, MD, FACOG",
        "role": "OB/GYN",
        "imageUrl": "https://anchoragewomensclinic.com/wp-content/uploads/2021/02/Dana-Espinola.jpg",
        "credentials": ["MD", "FACOG"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://anchoragewomensclinic.com/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-anchorage-womens-clinic-anne-gray-md-facog",
        "name": "Anne Gray, MD, FACOG",
        "role": "OB/GYN",
        "imageUrl": "https://anchoragewomensclinic.com/wp-content/uploads/2026/06/Dr-Anne-Gray-1.jpg",
        "credentials": ["MD", "FACOG"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://anchoragewomensclinic.com/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-anchorage-womens-clinic-leslie-cayco-travis-do-facog",
        "name": "Leslie Cayco-Travis, DO, FACOG",
        "role": "OB/GYN",
        "imageUrl": "https://anchoragewomensclinic.com/wp-content/uploads/2021/02/Leslie-Cayco.jpg",
        "credentials": ["DO", "FACOG"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://anchoragewomensclinic.com/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-anchorage-womens-clinic-megan-volkov-dnp-aprn-np-c",
        "name": "Megan Volkov, DNP, APRN, NP-C",
        "role": "Nurse Practitioner",
        "imageUrl": "https://anchoragewomensclinic.com/wp-content/uploads/2023/10/Megan-Short.jpg",
        "credentials": ["DNP", "APRN", "NP-C"],
        "specialty": "Nurse Practitioner",
        "_source": {
          "url": "https://anchoragewomensclinic.com/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-anchorage-womens-clinic-tanya-kirk-msn-aprn-cnm-fnp",
        "name": "Tanya Kirk, MSN, APRN, CNM, FNP",
        "role": "Certified Nurse Midwife",
        "imageUrl": "https://anchoragewomensclinic.com/wp-content/uploads/2021/02/Tonya-Kirk.jpg",
        "credentials": ["MSN", "APRN", "CNM", "FNP"],
        "specialty": "Certified Nurse Midwife",
        "_source": {
          "url": "https://anchoragewomensclinic.com/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-anchorage-womens-clinic-rosa-morrissett-msn-aprn-cnm",
        "name": "Rosa Morrissett, MSN, APRN, CNM",
        "role": "Certified Nurse Midwife",
        "imageUrl": "https://anchoragewomensclinic.com/wp-content/uploads/2023/10/Rosa-Short.jpg",
        "credentials": ["MSN", "APRN", "CNM"],
        "specialty": "Certified Nurse Midwife",
        "_source": {
          "url": "https://anchoragewomensclinic.com/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-anchorage-womens-clinic-molly-lunsford-msn-aprn-cnm-whnp",
        "name": "Molly Lunsford, MSN, APRN, CNM, WHNP",
        "role": "Certified Nurse Midwife",
        "imageUrl": "https://anchoragewomensclinic.com/wp-content/uploads/2025/08/IMG_2032-headshot.jpg",
        "credentials": ["MSN", "APRN", "CNM", "WHNP"],
        "specialty": "Certified Nurse Midwife",
        "_source": {
          "url": "https://anchoragewomensclinic.com/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-anchorage-womens-clinic-paula-phillips-lpc-e-ryt",
        "name": "Paula Phillips, LPC, E-RYT",
        "role": "Licensed Professional Counselor",
        "imageUrl": "https://anchoragewomensclinic.com/wp-content/uploads/2021/02/Paula-Phillips.jpg",
        "credentials": ["LPC", "E-RYT"],
        "specialty": "Mental Health Counseling",
        "_source": {
          "url": "https://anchoragewomensclinic.com/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Alaska (AK) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-womens-care-alaska",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Women's Care of Alaska",
    "address": {
      "line1": "2741 DeBarr Rd, Suite C205",
      "city": "Anchorage",
      "state": "AK",
      "zip": "99508",
      "country": "US"
    },
    "location": {
      "lat": 61.2097696,
      "lng": -149.8299766
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://wcakobgyn.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://wcakobgyn.com",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://wcakobgyn.com",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://wcakobgyn.com",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://wcakobgyn.com/providers/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://wcakobgyn.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "website": "https://wcakobgyn.com/",
    "phone": "(907) 279-2273",
    "images": [],
    "team": [
      {
        "practitionerId": "pr-org-web-womens-care-alaska-wynd-counts-md-facog",
        "name": "Wynd Counts, MD, FACOG",
        "role": "OB/GYN",
        "credentials": ["MD", "FACOG"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://wcakobgyn.com/providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-womens-care-alaska-wendy-cruz-md-facog",
        "name": "Wendy Cruz, MD, FACOG",
        "role": "OB/GYN",
        "credentials": ["MD", "FACOG"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://wcakobgyn.com/providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-womens-care-alaska-allison-van-haastert-md-facog",
        "name": "Allison van Haastert, MD, FACOG",
        "role": "OB/GYN",
        "credentials": ["MD", "FACOG"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://wcakobgyn.com/providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-womens-care-alaska-jessica-goldberger-md-facog",
        "name": "Jessica Goldberger, MD, FACOG",
        "role": "OB/GYN",
        "credentials": ["MD", "FACOG"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://wcakobgyn.com/providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-womens-care-alaska-meagan-byrne-do-facoog",
        "name": "Meagan Byrne, DO, FACOOG",
        "role": "OB/GYN",
        "credentials": ["DO", "FACOOG"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://wcakobgyn.com/providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-womens-care-alaska-migel-hadley-msn-fnp",
        "name": "Migel Hadley, MSN, FNP",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "FNP"],
        "specialty": "Nurse Practitioner",
        "_source": {
          "url": "https://wcakobgyn.com/providers/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Alaska (AK) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-chena-health",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Chena Health",
    "address": {
      "line1": "1919 Lathrop St, Suite 222",
      "city": "Fairbanks",
      "state": "AK",
      "zip": "99701",
      "country": "US"
    },
    "location": {
      "lat": 64.8300475,
      "lng": -147.7432822
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.chenahealth.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://www.chenahealth.com",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.chenahealth.com",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.chenahealth.com",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.chenahealth.com/team",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://www.chenahealth.com/gynecology",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "website": "https://www.chenahealth.com/",
    "phone": "(907) 456-8191",
    "team": [
      {
        "practitionerId": "pr-org-web-chena-health-ellie-hogenson-md-mph",
        "name": "Ellie Hogenson, MD, MPH",
        "role": "OB/GYN",
        "imageUrl": "https://static.wixstatic.com/media/bad4de_ad93fb842c3f4ab990a057642fe8d9bd~mv2.png",
        "credentials": ["MD", "MPH"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://www.chenahealth.com/team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-chena-health-courtney-amundson-cnm",
        "name": "Courtney Amundson, CNM",
        "role": "Certified Nurse Midwife",
        "imageUrl": "https://static.wixstatic.com/media/bad4de_bc17edb2bf5c4b1dacbba04301bb7990~mv2.jpg",
        "credentials": ["CNM"],
        "specialty": "Certified Nurse Midwife",
        "_source": {
          "url": "https://www.chenahealth.com/team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-chena-health-kinzea-jones-pa",
        "name": "Kinzea Jones, PA",
        "role": "Physician Assistant",
        "imageUrl": "https://static.wixstatic.com/media/bad4de_454430e8c2ef4a598a23b177e4288d5b~mv2.jpg",
        "credentials": ["PA"],
        "specialty": "Physician Assistant",
        "_source": {
          "url": "https://www.chenahealth.com/team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-chena-health-kimberly-schumacher-do",
        "name": "Kimberly Schumacher, DO",
        "role": "OB/GYN",
        "imageUrl": "https://static.wixstatic.com/media/bad4de_eb0b503f40244224a1487a2e184a3b5a~mv2.png",
        "credentials": ["DO"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://www.chenahealth.com/team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-chena-health-heidi-may-cnm",
        "name": "Heidi May, CNM",
        "role": "Certified Nurse Midwife",
        "imageUrl": "https://static.wixstatic.com/media/bad4de_ee0c0554b6e448e4878631ce67c327b8~mv2.jpg",
        "credentials": ["CNM"],
        "specialty": "Certified Nurse Midwife",
        "_source": {
          "url": "https://www.chenahealth.com/team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-chena-health-natalie-mayer-md",
        "name": "Natalie Mayer, MD",
        "role": "Family Medicine Physician",
        "imageUrl": "https://static.wixstatic.com/media/22beea_32d7758ff5c54514aaefa19910f4463c~mv2.jpg",
        "credentials": ["MD"],
        "specialty": "Family Medicine",
        "_source": {
          "url": "https://www.chenahealth.com/team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-chena-health-mishaela-whittier-do",
        "name": "Mishaela Whittier, DO",
        "role": "OB/GYN",
        "imageUrl": "https://static.wixstatic.com/media/bad4de_d669434faf2b477c9de6b86f23790aaa~mv2.png",
        "credentials": ["DO"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://www.chenahealth.com/team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-chena-health-delys-cooks-cnm",
        "name": "DeLys Cooks, CNM",
        "role": "Certified Nurse Midwife",
        "imageUrl": "https://static.wixstatic.com/media/22beea_60ffc57c0dbd4bcb9b9658681f909d7d~mv2.jpg",
        "credentials": ["CNM"],
        "specialty": "Certified Nurse Midwife",
        "_source": {
          "url": "https://www.chenahealth.com/team",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-chena-health-jackie-collins-fnp",
        "name": "Jackie Collins, FNP",
        "role": "Family Nurse Practitioner",
        "imageUrl": "https://static.wixstatic.com/media/bad4de_dc089e14a9fc4799bc11eace94a8fce8~mv2.png",
        "credentials": ["FNP"],
        "specialty": "Family Nurse Practitioner",
        "_source": {
          "url": "https://www.chenahealth.com/team",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Alaska (AK) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-interior-womens-health",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Interior Women's Health",
    "address": {
      "line1": "1626 30th Ave",
      "city": "Fairbanks",
      "state": "AK",
      "zip": "99701",
      "country": "US"
    },
    "location": {
      "lat": 64.8204002,
      "lng": -147.7429472
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.interiorwomenshealth.org",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://www.interiorwomenshealth.org",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.interiorwomenshealth.org/contactus",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.interiorwomenshealth.org/services/fertility-evaluation",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.interiorwomenshealth.org/provider",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.interiorwomenshealth.org/provider",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "website": "https://www.interiorwomenshealth.org/",
    "phone": "(907) 479-7701",
    "images": [],
    "team": [
      {
        "practitionerId": "pr-org-web-interior-womens-health-karl-baurick-md-facog",
        "name": "Karl Baurick, MD, FACOG",
        "role": "OB/GYN",
        "imageUrl": "https://sa1s3optim.patientpop.com/200x200/assets/production/practices/bbc377493cc6d87030ecafa62c9451514423149a/images/2224859.jpg",
        "credentials": ["MD", "FACOG"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://www.interiorwomenshealth.org/provider",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-interior-womens-health-doris-heilman-md-facog",
        "name": "Doris Heilman, MD, FACOG",
        "role": "OB/GYN",
        "imageUrl": "https://sa1s3optim.patientpop.com/200x200/assets/production/practices/bbc377493cc6d87030ecafa62c9451514423149a/images/2224864.jpg",
        "credentials": ["MD", "FACOG"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://www.interiorwomenshealth.org/provider",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-interior-womens-health-tanya-ignacio-cnm",
        "name": "Tanya Ignacio, CNM",
        "role": "Certified Nurse Midwife",
        "imageUrl": "https://sa1s3optim.patientpop.com/200x200/assets/production/practices/bbc377493cc6d87030ecafa62c9451514423149a/images/2224868.jpg",
        "credentials": ["CNM"],
        "specialty": "Certified Nurse Midwife",
        "_source": {
          "url": "https://www.interiorwomenshealth.org/provider",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-interior-womens-health-kristina-amundson-dnp-cnm",
        "name": "Kristina Amundson, DNP, CNM",
        "role": "Certified Nurse Midwife",
        "imageUrl": "https://sa1s3optim.patientpop.com/200x200/assets/production/practices/bbc377493cc6d87030ecafa62c9451514423149a/images/2224874.jpg",
        "credentials": ["DNP", "CNM"],
        "specialty": "Certified Nurse Midwife",
        "_source": {
          "url": "https://www.interiorwomenshealth.org/provider",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-interior-womens-health-misty-holacka-fnp",
        "name": "Misty Holacka, FNP",
        "role": "Nurse Practitioner",
        "imageUrl": "https://sa1s3optim.patientpop.com/200x200/assets/production/practices/bbc377493cc6d87030ecafa62c9451514423149a/images/2224879.jpg",
        "credentials": ["FNP"],
        "specialty": "Nurse Practitioner",
        "_source": {
          "url": "https://www.interiorwomenshealth.org/provider",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-interior-womens-health-alison-horner-cnm-anp",
        "name": "Alison Horner, CNM, ANP",
        "role": "Certified Nurse Midwife",
        "credentials": ["CNM", "ANP"],
        "specialty": "Certified Nurse Midwife",
        "_source": {
          "url": "https://www.interiorwomenshealth.org/provider",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Alaska (AK) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-billings-clinic-bozeman",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Billings Clinic Bozeman - Reproductive Medicine & Fertility Care",
    "address": {
      "line1": "925 Highland Blvd, Suite 1210/1220",
      "city": "Bozeman",
      "state": "MT",
      "zip": "59715",
      "country": "US"
    },
    "location": {
      "lat": 45.6690535,
      "lng": -111.0178458
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "specialties": ["iui", "ivf", "reproductive-endocrinology"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.billingsclinic.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.billingsclinic.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.billingsclinic.com",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://fertilitymontana.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://fertilitymontana.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.billingsclinic.com",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://providers.billingsclinic.com/provider/stacy-h-shomento/2052148",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://fertilitymontana.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "website": "https://fertilitymontana.com/",
    "network": {
      "name": "Billings Clinic"
    },
    "phone": "(406) 551-6008",
    "team": [
      {
        "practitionerId": "pr-org-web-billings-clinic-bozeman-stacy-h-shomento-md-facog",
        "name": "Stacy H. Shomento, MD, FACOG",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://framerusercontent.com/images/4MZk8mrbRVCBb6cF7JFI2YiGw.jpg",
        "_source": {
          "url": "https://providers.billingsclinic.com/provider/stacy-h-shomento/2052148",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Montana (MT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-community-med-missoula",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Community Medical Center - Fertility Services",
    "address": {
      "line1": "2835 Fort Missoula Road, Building 3, Suite 101",
      "city": "Missoula",
      "state": "MT",
      "zip": "59804",
      "country": "US"
    },
    "location": {
      "lat": 46.8469869,
      "lng": -114.0478243
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "specialties": [
      "fertility-services",
      "ob-gyn",
      "reproductive-endocrinology"
    ],
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.communitymed.org/womens-health/fertility-services",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://www.communitymed.org/womens-health/fertility-services",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.communitymed.org/womens-health/fertility-services",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.communitymed.org/provider-directory",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.communitymed.org/womens-health/fertility-services",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.communitymed.org/provider-directory",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://nbcmontana.com/news/local/missoulas-community-medical-center-expands-maternity-care-as-st-patrick-hospital-closes",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "website": "https://www.communitymed.org/womens-health/fertility-services",
    "phone": "(406) 327-4640",
    "images": [
      {
        "url": "https://nbcmontana.com/resources/media/b93881ab-2ad7-4a6c-99e8-3ac992df3635-jumbo16x9_cmc.jpg?1583276549748",
        "type": "exterior",
        "caption": "Community Medical Center exterior signage in Missoula.",
        "_source": {
          "url": "https://nbcmontana.com/news/local/missoulas-community-medical-center-expands-maternity-care-as-st-patrick-hospital-closes",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "team": [
      {
        "practitionerId": "pr-org-web-community-med-missoula-stacy-h-shomento-md-facog",
        "name": "Stacy H. Shomento, MD, FACOG",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "role": "Reproductive Endocrinologist",
        "imageUrl": "https://framerusercontent.com/images/4MZk8mrbRVCBb6cF7JFI2YiGw.jpg",
        "_source": {
          "url": "https://www.communitymed.org/provider-directory",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Montana (MT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-benefis-fertility",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Benefis Health System - Fertility Care",
    "address": {
      "line1": "1101 26th St S",
      "city": "Great Falls",
      "state": "MT",
      "zip": "59405",
      "country": "US"
    },
    "location": {
      "lat": 47.4906909,
      "lng": -111.2617623
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "specialties": ["infertility", "ob-gyn", "obstetrics-gynecology"],
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.benefis.org/medical-services/fertility-care/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://www.benefis.org/medical-services/fertility-care/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.benefis.org/medical-services/fertility-care/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.benefis.org/medical-services/fertility-care/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.benefis.org/find-a-provider/profile/kelly-timmer/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.benefis.org/locations/profile/womens-and-childrens-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "website": "https://www.benefis.org/medical-services/fertility-care/",
    "phone": "(406) 455-5000",
    "images": [
      {
        "url": "https://www.benefis.org/app/files/public/d77dcc1c-1366-460f-924d-867459249b47/WomensandChildrensCenter.jpg",
        "type": "exterior",
        "caption": "Benefis Women's and Children's Center at the East Campus.",
        "_source": {
          "url": "https://www.benefis.org/locations/profile/womens-and-childrens-center/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "team": [
      {
        "practitionerId": "pr-org-web-benefis-fertility-kelly-timmer-fnp-bc-whnp-bc",
        "name": "Kelly Timmer, FNP-BC, WHNP-BC",
        "credentials": ["FNP-BC", "WHNP-BC"],
        "specialty": "Obstetrics-Gynecology and Infertility Care",
        "role": "Fertility Care Provider",
        "imageUrl": "https://www.benefis.org/app/files/public/Timmer_1196.jpg",
        "_source": {
          "url": "https://www.benefis.org/find-a-provider/profile/kelly-timmer/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Montana (MT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-great-falls-obgyn",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Great Falls OBGYN Associates",
    "address": {
      "line1": "1400 29th St S, Suite 101",
      "city": "Great Falls",
      "state": "MT",
      "zip": "59405",
      "country": "US"
    },
    "location": {
      "lat": 47.490439,
      "lng": -111.257455
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["fertility-services", "ob-gyn", "obstetrics-gynecology"],
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://greatfallsobgyn.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://greatfallsobgyn.com",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://greatfallsobgyn.com/fertility-services/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://greatfallsobgyn.com/about-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://greatfallsobgyn.com",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://greatfallsobgyn.com/about-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://greatfallsobgyn.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "website": "https://greatfallsobgyn.com/fertility-services/",
    "phone": "(406) 761-7924",
    "email": "info@greatfallsobgyn.com",
    "images": [],
    "team": [
      {
        "practitionerId": "pr-org-web-great-falls-obgyn-daren-braget-md-facog",
        "name": "Daren Braget, MD, FACOG",
        "credentials": ["MD", "FACOG"],
        "specialty": "OB/GYN",
        "role": "OB/GYN",
        "imageUrl": "https://greatfallsobgyn.com/wp-content/uploads/2018/11/Braget_1.jpg",
        "_source": {
          "url": "https://greatfallsobgyn.com/about-us/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-great-falls-obgyn-stephanie-bryant-do-facog",
        "name": "Stephanie Bryant, DO, FACOG",
        "credentials": ["DO", "FACOG"],
        "specialty": "OB/GYN",
        "role": "OB/GYN",
        "imageUrl": "https://greatfallsobgyn.com/wp-content/uploads/2018/11/Bryant_1.jpg",
        "_source": {
          "url": "https://greatfallsobgyn.com/about-us/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-great-falls-obgyn-vicki-chapman-do-facog",
        "name": "Vicki Chapman, DO, FACOG",
        "credentials": ["DO", "FACOG"],
        "specialty": "OB/GYN",
        "role": "OB/GYN",
        "imageUrl": "https://greatfallsobgyn.com/wp-content/uploads/2018/11/Dr.-Chapman_1.jpg",
        "_source": {
          "url": "https://greatfallsobgyn.com/about-us/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-great-falls-obgyn-amanda-henzel-md-facog",
        "name": "Amanda Henzel, MD, FACOG",
        "credentials": ["MD", "FACOG"],
        "specialty": "OB/GYN",
        "role": "OB/GYN",
        "imageUrl": "https://greatfallsobgyn.com/wp-content/uploads/2018/11/Henzel_1.jpg",
        "_source": {
          "url": "https://greatfallsobgyn.com/about-us/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-great-falls-obgyn-alyson-miser-md-facog",
        "name": "Alyson Miser, MD, FACOG",
        "credentials": ["MD", "FACOG"],
        "specialty": "OB/GYN",
        "role": "OB/GYN",
        "imageUrl": "https://greatfallsobgyn.com/wp-content/uploads/2018/11/Dr.-Miser-copy_1.jpg",
        "_source": {
          "url": "https://greatfallsobgyn.com/about-us/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-great-falls-obgyn-tracy-richman-cnm",
        "name": "Tracy Richman, CNM",
        "credentials": ["CNM"],
        "specialty": "Certified Nurse Midwife",
        "role": "Certified Nurse Midwife",
        "imageUrl": "https://greatfallsobgyn.com/wp-content/uploads/2018/11/Midwife_1-1.jpg",
        "_source": {
          "url": "https://greatfallsobgyn.com/about-us/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-great-falls-obgyn-lori-durocher-whnp",
        "name": "Lori Durocher, WHNP",
        "credentials": ["WHNP"],
        "specialty": "Women's Health Nurse Practitioner",
        "role": "Women's Health Nurse Practitioner",
        "imageUrl": "https://greatfallsobgyn.com/wp-content/uploads/2018/11/Durocher_1.jpg",
        "_source": {
          "url": "https://greatfallsobgyn.com/about-us/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-great-falls-obgyn-gretchen-fowell-fnp-c",
        "name": "Gretchen Fowell, FNP-C",
        "credentials": ["FNP-C"],
        "specialty": "Family Nurse Practitioner",
        "role": "Family Nurse Practitioner",
        "imageUrl": "https://greatfallsobgyn.com/wp-content/uploads/2018/11/Fowel_1.jpg",
        "_source": {
          "url": "https://greatfallsobgyn.com/about-us/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-great-falls-obgyn-kyla-grymes-fnp-bc",
        "name": "Kyla Grymes, FNP-BC",
        "credentials": ["FNP-BC"],
        "specialty": "Family Nurse Practitioner",
        "role": "Family Nurse Practitioner",
        "imageUrl": "https://greatfallsobgyn.com/wp-content/uploads/2024/10/Kyla-Grymes-FNP-BC.jpg",
        "_source": {
          "url": "https://greatfallsobgyn.com/about-us/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-great-falls-obgyn-adrienne-dube-rn",
        "name": "Adrienne Dube, RN",
        "credentials": ["RN"],
        "specialty": "RN",
        "role": "RN",
        "imageUrl": "https://greatfallsobgyn.com/wp-content/uploads/2018/11/Dube_1.jpg",
        "_source": {
          "url": "https://greatfallsobgyn.com/about-us/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Montana (MT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-ccrm-fargo",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "CCRM Fertility - Fargo",
    "address": {
      "line1": "3000 32nd Ave S",
      "city": "Fargo",
      "state": "ND",
      "zip": "58103",
      "country": "US"
    },
    "location": {
      "lat": 46.8313421,
      "lng": -96.8280632
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.ccrmivf.com/clinic_location/fargo-nd/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.ccrmivf.com/clinic_location/fargo-nd/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.ccrmivf.com/clinic_location/fargo-nd/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/clinic_location/fargo-nd/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/clinic_location/fargo-nd/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/press/satellite-office-fargo/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-32nd-avenue-clinic-fargo",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "website": "https://www.ccrmivf.com/clinic_location/fargo-nd/",
    "network": {
      "name": "CCRM Fertility"
    },
    "images": [
      {
        "url": "https://www.essentiahealth.org/-/media/Project/Essentia/Essentia/Locations/facility-images/Essentia-Health-32nd-Avenue-Clinic-Fargo.jpg?rev=44fd7654e6aa4f168e0c79b989bd5e4c",
        "type": "exterior",
        "caption": "Essentia Health 32nd Avenue Clinic Fargo, the listed CCRM Fargo satellite location.",
        "_source": {
          "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-32nd-avenue-clinic-fargo",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "phone": "(952) 225-1630",
    "team": [
      {
        "practitionerId": "pr-org-web-ccrm-fargo-stephanie-k-dahl-md",
        "name": "Stephanie K. Dahl, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://framerusercontent.com/images/InV43MUwJYkO3O0phfv0rTJ7m8.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/press/satellite-office-fargo/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check North Dakota (ND) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-essentia-bismarck",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Essentia Health Mid Dakota Women's Center - Bismarck",
    "address": {
      "line1": "1000 E Rosser Ave",
      "city": "Bismarck",
      "state": "ND",
      "zip": "58501",
      "country": "US"
    },
    "location": {
      "lat": 46.808542,
      "lng": -100.776799
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-mid-dakota-womens-center-bismarck",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-mid-dakota-womens-center-bismarck",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-mid-dakota-womens-center-bismarck",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-mid-dakota-womens-center-bismarck",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-mid-dakota-womens-center-bismarck",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-mid-dakota-womens-center-bismarck",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "website": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-mid-dakota-womens-center-bismarck",
    "images": [
      {
        "url": "https://www.essentiahealth.org/-/media/Project/Essentia/Essentia/Locations/facility-images/mid-dakota-womens-center-bismarck-exterior.jpg?rev=ff53935c79d54851b70bde107d92303f",
        "type": "exterior",
        "caption": "Essentia Health Mid Dakota Women's Center exterior.",
        "_source": {
          "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-mid-dakota-womens-center-bismarck",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "phone": "(701) 712-4501",
    "network": {
      "name": "Essentia Health"
    },
    "team": [
      {
        "practitionerId": "pr-org-web-essentia-bismarck-heather-sandness-nelson-md",
        "name": "Heather Sandness Nelson, MD",
        "role": "OB/GYN Fertility Provider",
        "credentials": ["MD"],
        "specialty": "Obstetrics, Gynecology, and Fertility",
        "imageUrl": "https://www.essentiahealth.org/-/media/Project/Essentia/Essentia/Providers/profile-images/Heather-Sandness-Nelson.jpg?rev=45b30e932e6c4058bac2539f534c6007&sc_lang=en",
        "_source": {
          "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-mid-dakota-womens-center-bismarck",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-essentia-bismarck-marissa-wisdom-md",
        "name": "Marissa Wisdom, MD",
        "role": "OB/GYN Fertility Provider",
        "credentials": ["MD"],
        "specialty": "Obstetrics, Gynecology, and Fertility",
        "imageUrl": "https://www.essentiahealth.org/-/media/Project/Essentia/Essentia/Providers/profile-images/Marissa-Wisdom.jpg?rev=d7cbb2a909684f1bb3233ec7c5c84c64&sc_lang=en",
        "_source": {
          "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-mid-dakota-womens-center-bismarck",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-essentia-bismarck-anne-earsley-pa-c",
        "name": "Anne Earsley, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "specialty": "Obstetrics, Gynecology, and Fertility",
        "imageUrl": "https://www.essentiahealth.org/-/media/Project/Essentia/Essentia/Providers/profile-images/Anne-Earsley.jpg?rev=bdf15244ecbd46d39e8251eadb99ed21&sc_lang=en",
        "_source": {
          "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-mid-dakota-womens-center-bismarck",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-essentia-bismarck-stephanie-delvo-md",
        "name": "Stephanie Delvo, MD",
        "role": "OB/GYN Fertility Provider",
        "credentials": ["MD"],
        "specialty": "Obstetrics, Gynecology, and Fertility",
        "imageUrl": "https://www.essentiahealth.org/-/media/Project/Essentia/Essentia/Providers/profile-images/Stephanie-Delvo.jpg?rev=10e7792de8344e5a9c2250686a418b55&sc_lang=en",
        "_source": {
          "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-mid-dakota-womens-center-bismarck",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-essentia-bismarck-rachel-marohl-md",
        "name": "Rachel Marohl, MD",
        "role": "OB/GYN Fertility Provider",
        "credentials": ["MD"],
        "specialty": "Obstetrics, Gynecology, and Fertility",
        "imageUrl": "https://www.essentiahealth.org/-/media/Project/Essentia/Essentia/Providers/profile-images/rachel-marohl.jpg?rev=c0a813b87c7f4f4aa3f9a74d09de479b",
        "_source": {
          "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-mid-dakota-womens-center-bismarck",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-essentia-bismarck-april-kautzman-aprn-cnm",
        "name": "April Kautzman, APRN, CNM",
        "role": "Certified Nurse Midwife",
        "credentials": ["APRN", "CNM"],
        "specialty": "Fertility and Midwifery",
        "imageUrl": "https://www.essentiahealth.org/-/media/Project/Essentia/Essentia/Providers/profile-images/April-Kautzman.jpg?rev=2562873149e74a2687eeae28a02572cb&sc_lang=en",
        "_source": {
          "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-mid-dakota-womens-center-bismarck",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-essentia-bismarck-jill-steinle-md",
        "name": "Jill Steinle, MD",
        "role": "OB/GYN Fertility Provider",
        "credentials": ["MD"],
        "specialty": "Obstetrics, Gynecology, and Fertility",
        "imageUrl": "https://www.essentiahealth.org/-/media/Project/Essentia/Essentia/Providers/profile-images/jill-steinle.jpg?rev=5dc8230dfe6647a383bd07febf144e08",
        "_source": {
          "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-mid-dakota-womens-center-bismarck",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-essentia-bismarck-lee-hodny-md",
        "name": "Lee Hodny, MD",
        "role": "OB/GYN Fertility Provider",
        "credentials": ["MD"],
        "specialty": "Obstetrics, Gynecology, and Fertility",
        "imageUrl": "https://www.essentiahealth.org/-/media/Project/Essentia/Essentia/Providers/profile-images/lee-hodny.jpg?rev=95c5765ef02045db8ac252a5b360d564",
        "_source": {
          "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-mid-dakota-womens-center-bismarck",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check North Dakota (ND) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-rushmore-obgyn",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Rushmore OB/GYN - Sanford Reproductive Medicine outreach",
    "address": {
      "line1": "3006 Tower Rd",
      "city": "Rapid City",
      "state": "SD",
      "zip": "57701",
      "country": "US"
    },
    "location": {
      "lat": 44.054047,
      "lng": -103.2413117
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.sanfordhealth.org",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://www.sanfordhealth.org",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.rushmoreobgyn.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.sanfordhealth.org",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.rushmoreobgyn.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.rushmoreobgyn.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "website": "https://www.rushmoreobgyn.com/",
    "network": {
      "name": "Sanford Health"
    },
    "images": [
      {
        "url": "https://www.rushmoreobgyn.com/images/0RushmoreOBGYN2016-014.jpg",
        "type": "exterior",
        "caption": "Rushmore OB/GYN clinic exterior with on-site sign",
        "_source": {
          "url": "https://www.rushmoreobgyn.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "phone": "(605) 343-7295",
    "team": [
      {
        "practitionerId": "pr-org-web-rushmore-obgyn-keith-a-hansen-md",
        "name": "Keith A. Hansen, MD",
        "role": "Reproductive Endocrinology Outreach",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology",
        "imageUrl": "https://www.sanfordhealth.org/-/media/org/images/doctors/edith-providers/keith_hansen.jpg?sc_lang=en&hash=CBB50B6CFCB88E7FEFA42A1419FD7B30",
        "_source": {
          "url": "https://www.sanfordhealth.org/doctors/keith-hansen",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-rushmore-obgyn-pamela-a-schmagel-md",
        "name": "Pamela A. Schmagel, MD",
        "role": "OB/GYN Physician",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.rushmoreobgyn.com/images/RushmoreOBGYN061522-311.png",
        "_source": {
          "url": "https://www.rushmoreobgyn.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-rushmore-obgyn-elizabeth-a-sutton-md",
        "name": "Elizabeth A. Sutton, MD",
        "role": "OB/GYN Physician",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.rushmoreobgyn.com/images/RushmoreOBGYN061522-214.jpg",
        "_source": {
          "url": "https://www.rushmoreobgyn.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-rushmore-obgyn-katie-whaley-md",
        "name": "Katie Whaley, MD",
        "role": "OB/GYN Physician",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.rushmoreobgyn.com/images/Dr-Katie-Whaley-ee9ed78bbc04fbe5668bd14f023aa74f.jpg",
        "_source": {
          "url": "https://www.rushmoreobgyn.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-rushmore-obgyn-keirsta-ragels-cnm",
        "name": "Keirsta Ragels, CNM",
        "role": "Certified Nurse Midwife",
        "credentials": ["CNM"],
        "specialty": "Certified Nurse Midwife",
        "imageUrl": "https://www.rushmoreobgyn.com/templates/yootheme/cache/df/Ragels%201-df46f28d.jpeg",
        "_source": {
          "url": "https://www.rushmoreobgyn.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-rushmore-obgyn-meghan-epp-cnp",
        "name": "Meghan Epp, CNP",
        "role": "Nurse Practitioner",
        "credentials": ["CNP"],
        "specialty": "Nurse Practitioner",
        "imageUrl": "https://www.rushmoreobgyn.com/templates/yootheme/cache/85/Epp-Head%20shot-85217b28.jpeg",
        "_source": {
          "url": "https://www.rushmoreobgyn.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-rushmore-obgyn-megan-potter-cnp",
        "name": "Megan Potter, CNP",
        "role": "Nurse Practitioner",
        "credentials": ["CNP"],
        "specialty": "Nurse Practitioner",
        "imageUrl": "https://www.rushmoreobgyn.com/templates/yootheme/cache/64/Megan%20Potter-6490396b.jpeg",
        "_source": {
          "url": "https://www.rushmoreobgyn.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-rushmore-obgyn-sasha-mosset-cnp",
        "name": "Sasha Mosset, CNP",
        "role": "Nurse Practitioner",
        "credentials": ["CNP"],
        "specialty": "Nurse Practitioner",
        "imageUrl": "https://www.rushmoreobgyn.com/templates/yootheme/cache/07/Sasha.%20head%20shot-07e2fc12.jpeg",
        "_source": {
          "url": "https://www.rushmoreobgyn.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check South Dakota (SD) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-ui-arc-west-des-moines",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "University of Iowa Center for Reproductive Care - Urbandale",
    "address": {
      "line1": "2901 86th Street",
      "city": "Urbandale",
      "state": "IA",
      "zip": "50322",
      "country": "US"
    },
    "location": {
      "lat": 41.6209461,
      "lng": -93.7351394
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://uihc.org/services/fertility-and-reproductive-endocrinology",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://uihc.org/services/fertility-and-reproductive-endocrinology",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://uihc.org/services/fertility-and-reproductive-endocrinology",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://uihc.org/locations/urbandale-86th-street/center-reproductive-care-urbandale",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://uihc.org/locations/urbandale-86th-street/center-reproductive-care-urbandale",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://uihc.org/locations/urbandale-86th-street/center-reproductive-care-urbandale",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://uihealthcare.org/article/ui-health-care-welcomes-patients-new-urbandale-location-combined-services-convenient-care",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://uihc.org/locations/urbandale-86th-street/center-reproductive-care-urbandale",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "website": "https://uihc.org/locations/urbandale-86th-street/center-reproductive-care-urbandale",
    "phone": "1-515-336-6562",
    "network": {
      "name": "University of Iowa Health Care"
    },
    "team": [
      {
        "practitionerId": "pr-org-web-ui-arc-west-des-moines-abigail-mancuso-md",
        "name": "Abigail Mancuso, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://profiles.uiowa.edu/api/people/abigail-mancuso/image",
        "_source": {
          "url": "https://obgyn.medicine.uiowa.edu/faculty?cohort=421683",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [
      {
        "url": "https://uihc.org/sites/default/files/styles/scale_to_1200px/public/2025-09/Urbandale%20CRC_2025-09-08_02-edit.jpg.webp?itok=urII4ipW",
        "type": "interior",
        "caption": "Center for Reproductive Care - Urbandale interior.",
        "_source": {
          "url": "https://uihc.org/locations/urbandale-86th-street/center-reproductive-care-urbandale",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://uihc.org/sites/default/files/styles/scale_to_1200px/public/2025-09/2025-09-08_Urbandale_029-edit-edited.jpg.webp?itok=Ht5oh412",
        "type": "exterior",
        "caption": "UI Health Care Urbandale 86th Street exterior.",
        "_source": {
          "url": "https://uihc.org/locations/urbandale-86th-street",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Iowa (IA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-ui-repro-davenport",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "University of Iowa Reproductive Care - Davenport",
    "address": {
      "line1": "3385 Dexter Court, Pavilion 3, Suite 110",
      "city": "Davenport",
      "state": "IA",
      "zip": "52807",
      "country": "US"
    },
    "location": {
      "lat": 41.570565,
      "lng": -90.523803
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://uihc.org/locations/davenport-dexter-court",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://uihc.org/locations/davenport-dexter-court",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://uihc.org/locations/davenport-dexter-court",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://uihc.org/locations/davenport-dexter-court",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://uihc.org/locations/davenport-dexter-court",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://uihc.org/locations/davenport-dexter-court",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://obgyn.medicine.uiowa.edu/faculty?cohort=421683",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://uihc.org/locations/davenport-dexter-court",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "website": "https://uihc.org/locations/davenport-dexter-court",
    "phone": "1-563-355-2244",
    "network": {
      "name": "University of Iowa Health Care"
    },
    "team": [
      {
        "practitionerId": "pr-org-web-ui-repro-davenport-jessica-d-kresowik-md",
        "name": "Jessica D. Kresowik, MD",
        "role": "Director, In Vitro Fertilization Program",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://profiles.uiowa.edu/api/people/jessica-kresowik/image",
        "_source": {
          "url": "https://obgyn.medicine.uiowa.edu/faculty?cohort=421683",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [
      {
        "url": "https://uihc.org/sites/default/files/styles/scale_to_1200px/public/2022-08/Davenport_DexterCourt_5050_REV_2400x1400_0.png.webp?itok=qCzVjvDz",
        "type": "exterior",
        "caption": "UI Health Care Davenport Dexter Court exterior.",
        "_source": {
          "url": "https://uihc.org/locations/davenport-dexter-court",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Iowa (IA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-cedar-rapids-obgyn",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Cedar Rapids OB/GYN Specialists",
    "address": {
      "line1": "788 8th Ave SE, Suite 100",
      "city": "Cedar Rapids",
      "state": "IA",
      "zip": "52401",
      "country": "US"
    },
    "location": {
      "lat": 41.9765982,
      "lng": -91.6562799
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "treatments": [
      {
        "name": "Infertility evaluation",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.cr-obgyn.com/gynecology/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Infertility treatment",
        "category": "art",
        "_source": {
          "url": "https://www.cr-obgyn.com/obstetrics/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.cr-obgyn.com/cedar-rapids-office/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.cr-obgyn.com/cedar-rapids-office/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.cr-obgyn.com/obstetrics/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.cr-obgyn.com/about-us/physicians/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.cr-obgyn.com/cedar-rapids-office/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "website": "https://www.cr-obgyn.com/cedar-rapids-office/",
    "phone": "319-363-2682",
    "team": [
      {
        "practitionerId": "pr-org-web-cedar-rapids-obgyn-kristin-orr-md",
        "name": "Kristin Orr, MD",
        "role": "OB/GYN",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.cr-obgyn.com/wp-content/uploads/2019/07/xdrOrr.jpg.pagespeed.ic_.9Qdygw9ptw.jpeg",
        "_source": {
          "url": "https://www.cr-obgyn.com/about-us/physicians/dr-orr/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-cedar-rapids-obgyn-lindsy-alons-md",
        "name": "Lindsy Alons, MD",
        "role": "OB/GYN",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.cr-obgyn.com/wp-content/uploads/2022/07/Alons_Lindsy-001D.jpg",
        "_source": {
          "url": "https://www.cr-obgyn.com/about-us/physicians/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [
      {
        "url": "https://www.cr-obgyn.com/wp-content/uploads/2021/01/building-_1_-1.jpg",
        "type": "exterior",
        "caption": "Cedar Rapids OB/GYN Specialists building exterior.",
        "_source": {
          "url": "https://www.cr-obgyn.com/cedar-rapids-office/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://www.cr-obgyn.com/wp-content/uploads/2019/07/lobby-banner.jpg",
        "type": "interior",
        "caption": "Cedar Rapids OB/GYN Specialists lobby.",
        "_source": {
          "url": "https://www.cr-obgyn.com/cedar-rapids-office/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Iowa (IA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-utah-fertility-idaho-falls",
    "externalIds": {
      "googlePlaceId": "ChIJJzin9SZfVFMRrI8lIy8yYFg"
    },
    "type": "fertility-clinic",
    "name": "Utah Fertility Center - Idaho Falls",
    "address": {
      "line1": "535 W. Sunnyside Rd, Suite 1",
      "city": "Idaho Falls",
      "state": "ID",
      "zip": "83402",
      "country": "US"
    },
    "location": {
      "lat": 43.4682165,
      "lng": -112.044115
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://utahfertility.com/locations/idaho-falls-clinic",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://utahfertility.com/locations/idaho-falls-clinic",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://utahfertility.com/locations/idaho-falls-clinic",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://utahfertility.com/locations/idaho-falls-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://utahfertility.com/locations/idaho-falls-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://utahfertility.com/locations/idaho-falls-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://utahfertility.com/locations/idaho-falls-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Idaho+Fertility+Center,+535+W+Sunnyside+Rd+Ste+1,+Idaho+Falls,+ID+83402/@43.4679505,-112.0449354,2896a,13.1y/data=!4m2!3m1!1s0x53545f26f5a73827:0x5860322f23258fac",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "website": "https://utahfertility.com/locations/idaho-falls-clinic",
    "network": {
      "name": "Utah Fertility Center"
    },
    "phone": "(208) 529-2019",
    "team": [
      {
        "practitionerId": "pr-org-web-utah-fertility-idaho-falls-deirdre-a-conway-md",
        "name": "Deirdre A. Conway, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/1024x1536/b2bcf0b114/deirdre-a-conway-md.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/locations/idaho-falls-clinic",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-utah-fertility-idaho-falls-karson-sutton-whnp-bc",
        "name": "Karson Sutton, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["WHNP-BC"],
        "specialty": "Women's Health Nurse Practitioner",
        "imageUrl": "https://a.storyblok.com/f/290132/2176x3264/146f91c2a7/karson-sutton-whnp-bc.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/locations/idaho-falls-clinic",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-utah-fertility-idaho-falls-stephanie-morgan-pa-c",
        "name": "Stephanie Morgan, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "specialty": "Physician Assistant",
        "imageUrl": "https://a.storyblok.com/f/290132/2177x3264/0d5e87bdb2/stephanie-morgan-pa-c.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/locations/idaho-falls-clinic",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Idaho (ID) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnsxDw9d_T0ycgUQXkI_SnHTCxHZ5UtXst7wcD8_bCJFcwCeXqrrxoc3hoJV3Mm7JeHEol0hOywAENc8z-opL1HdPOfF8adC_oORv33GtmCggzcQwbw78W461ootvLetgHdMsbNZw=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Idaho+Fertility+Center,+535+W+Sunnyside+Rd+Ste+1,+Idaho+Falls,+ID+83402/@43.4679505,-112.0449354,2896a,13.1y/data=!4m2!3m1!1s0x53545f26f5a73827:0x5860322f23258fac",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-boston-ivf-bangor",
    "externalIds": {
      "googlePlaceId": "ChIJUenTtZy1r0wR9iD2nn5wB8M"
    },
    "type": "fertility-clinic",
    "name": "Boston IVF - The Bangor Center",
    "address": {
      "line1": "12 Stillwater Ave",
      "city": "Bangor",
      "state": "ME",
      "zip": "04401",
      "country": "US"
    },
    "location": {
      "lat": 44.8123031,
      "lng": -68.7708993
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.bostonivf.com/locations/the-bangor-me-fertility-center",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.bostonivf.com/locations/the-bangor-me-fertility-center",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.bostonivf.com/locations/the-bangor-me-fertility-center",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/locations/the-bangor-me-fertility-center",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/locations/the-bangor-me-fertility-center",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/locations/the-bangor-me-fertility-center",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Boston+IVF,+Downeast+Ob%2FGyn,+12+Stillwater+Ave,+Bangor,+ME+04401/@44.8131443,-68.7688733,2830a,13.1y/data=!4m2!3m1!1s0x4cafb59cb5d3e951:0xc307707e9ef620f6",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "website": "https://www.bostonivf.com/locations/the-bangor-me-fertility-center",
    "phone": "(207) 358-7600",
    "network": {
      "name": "Boston IVF"
    },
    "team": [
      {
        "practitionerId": "pr-org-web-boston-ivf-bangor-benjamin-m-lannon-md",
        "name": "Benjamin M. Lannon, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.bostonivf.com/thumbs/B-Lannon_thumb-physicians-list.png?v=00665",
        "_source": {
          "url": "https://www.bostonivf.com/locations/the-bangor-me-fertility-center",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-boston-ivf-bangor-kristen-adams-pa-c-cm",
        "name": "Kristen Adams, PA-C, CM",
        "role": "Physician Assistant",
        "credentials": ["PA-C", "CM"],
        "specialty": "Physician Assistant",
        "imageUrl": "https://www.bostonivf.com/thumbs/kristen-adams_thumb-physicians-list.png?v=0c677",
        "_source": {
          "url": "https://www.bostonivf.com/locations/the-bangor-me-fertility-center",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-boston-ivf-bangor-alexandra-huttler-md",
        "name": "Alexandra Huttler, MD",
        "role": "REI Fellow",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.bostonivf.com/thumbs/AHuttler_thumb-physicians-list.png?v=1f77d",
        "_source": {
          "url": "https://www.bostonivf.com/locations/the-bangor-me-fertility-center",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Maine (ME) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-womens-clinic-lincoln",
    "externalIds": {},
    "type": "medical-practice",
    "name": "The Women's Clinic of Lincoln",
    "address": {
      "line1": "220 Lyncrest Dr",
      "city": "Lincoln",
      "state": "NE",
      "zip": "68510",
      "country": "US"
    },
    "location": {
      "lat": 40.812159,
      "lng": -96.6377657
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://womensclinicoflincoln.com/infertility/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://womensclinicoflincoln.com/infertility/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://womensclinicoflincoln.com/our-office-mammograms-lincoln-ne/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://womensclinicoflincoln.com/infertility/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://womensclinicoflincoln.com/about-us-obgyn-lincoln-ne/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://womensclinicoflincoln.com/our-office-mammograms-lincoln-ne/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "website": "https://womensclinicoflincoln.com/infertility/",
    "team": [
      {
        "practitionerId": "pr-org-web-womens-clinic-lincoln-james-j-maly-md-facog",
        "name": "James J. Maly, MD, FACOG",
        "role": "OB/GYN Physician",
        "credentials": ["MD", "FACOG"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://womensclinicoflincoln.com/wp-content/uploads/2016/12/maly-james-md-5x7-1-400x284.jpg",
        "_source": {
          "url": "https://womensclinicoflincoln.com/about-us-obgyn-lincoln-ne/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-womens-clinic-lincoln-mary-molly-snow-bsn-aprn",
        "name": "Mary \"Molly\" Snow, BSN, APRN",
        "role": "OB/GYN Nurse Practitioner",
        "credentials": ["BSN", "APRN"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://womensclinicoflincoln.com/wp-content/uploads/2016/12/snow-molly-aprn-5x7-1-400x284.jpg",
        "_source": {
          "url": "https://womensclinicoflincoln.com/about-us-obgyn-lincoln-ne/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-womens-clinic-lincoln-jackie-oden-aprn",
        "name": "Jackie Oden, APRN",
        "role": "OB/GYN Nurse Practitioner",
        "credentials": ["APRN"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://womensclinicoflincoln.com/wp-content/uploads/2016/12/oden-jackie-aprn-5x7-1-400x284.jpg",
        "_source": {
          "url": "https://womensclinicoflincoln.com/about-us-obgyn-lincoln-ne/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-womens-clinic-lincoln-jodi-wegner-msn-aprn",
        "name": "Jodi Wegner, MSN, APRN",
        "role": "OB/GYN Nurse Practitioner",
        "credentials": ["MSN", "APRN"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://womensclinicoflincoln.com/wp-content/uploads/2016/12/wegner-jodi-aprn-5x7-1-400x284.jpg",
        "_source": {
          "url": "https://womensclinicoflincoln.com/about-us-obgyn-lincoln-ne/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-womens-clinic-lincoln-courtney-sams-msn-aprn",
        "name": "Courtney Sams, MSN, APRN",
        "role": "OB/GYN Nurse Practitioner",
        "credentials": ["MSN", "APRN"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://womensclinicoflincoln.com/wp-content/uploads/2016/12/sams-courtney-aprn-5x7-1-400x284.jpg",
        "_source": {
          "url": "https://womensclinicoflincoln.com/about-us-obgyn-lincoln-ne/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-womens-clinic-lincoln-andrea-roberts-msn-aprn",
        "name": "Andrea Roberts, MSN, APRN",
        "role": "OB/GYN Nurse Practitioner",
        "credentials": ["MSN", "APRN"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://womensclinicoflincoln.com/wp-content/uploads/2016/12/roberts-andrea-aprn-5x7-1-400x284.jpg",
        "_source": {
          "url": "https://womensclinicoflincoln.com/about-us-obgyn-lincoln-ne/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "phone": "(402) 434-3382",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Nebraska (NE) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-unm-reproductive-health",
    "externalIds": {},
    "type": "medical-practice",
    "name": "UNM Reproductive Endocrinology and Infertility Clinic",
    "address": {
      "line1": "2701 Frontier Street NE, Room 240",
      "city": "Albuquerque",
      "state": "NM",
      "zip": "87131",
      "country": "US"
    },
    "location": {
      "lat": 35.0898823,
      "lng": -106.6156605
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://unmhealth.org/stories/2020/11/low-cost-infertility-treatments.html",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://unmhealth.org/stories/2020/11/low-cost-infertility-treatments.html",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://directory.unm.edu/departments/department_phone_list.php?dept=298",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://directory.unm.edu/departments/department_phone_list.php?dept=298",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://unmhealth.org/stories/2020/11/low-cost-infertility-treatments.html",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "verified-none",
          "source": {
            "url": "https://directory.unm.edu/departments/department_phone_list.php?dept=10023",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://directory.unm.edu/departments/department_phone_list.php?dept=10023",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "website": "https://directory.unm.edu/departments/department_phone_list.php?dept=298",
    "phone": "(505) 272-3915",
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Mexico (NM) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-boston-ivf-providence",
    "externalIds": {
      "googlePlaceId": "ChIJm6CYTCxF5IkRLZdDzBkmN8o"
    },
    "type": "fertility-clinic",
    "name": "Boston IVF - The Providence Center",
    "address": {
      "line1": "148 W River St, Suite 6",
      "city": "Providence",
      "state": "RI",
      "zip": "02904",
      "country": "US"
    },
    "location": {
      "lat": 41.8454769,
      "lng": -71.4135293
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.bostonivf.com/locations/the-providence-ri-fertility-center",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.bostonivf.com/locations/the-providence-ri-fertility-center",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.bostonivf.com/locations/the-providence-ri-fertility-center",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/locations/the-providence-ri-fertility-center",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/locations/the-providence-ri-fertility-center",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/locations/the-providence-ri-fertility-center",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Boston+IVF,+148+W+River+St+%236,+Providence,+RI+02904/@41.8436971,-71.4146298,2972a,13.1y/data=!4m2!3m1!1s0x89e4452c4c98a09b:0xca372619cc43972d",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "website": "https://www.bostonivf.com/locations/the-providence-ri-fertility-center",
    "network": {
      "name": "Boston IVF"
    },
    "team": [
      {
        "practitionerId": "pr-org-web-boston-ivf-providence-kerri-luzzo-md",
        "name": "Kerri Luzzo, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.bostonivf.com/thumbs/K-Luzzo_thumb-physicians-list.png?v=5ae73",
        "_source": {
          "url": "https://www.bostonivf.com/locations/the-providence-ri-fertility-center",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-boston-ivf-providence-katherine-baker-md",
        "name": "Katherine Baker, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.bostonivf.com/thumbs/kbaker-1_thumb-physicians-list.png?v=e6fd2",
        "_source": {
          "url": "https://www.bostonivf.com/locations/the-providence-ri-fertility-center",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-boston-ivf-providence-jacalyn-finerty-ms-aprn-whnp-bc",
        "name": "Jacalyn Finerty, MS, APRN, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["MS", "APRN", "WHNP-BC"],
        "specialty": "Nurse Practitioner",
        "imageUrl": "https://www.bostonivf.com/thumbs/JFinerty_thumb-physicians-list.png?v=78cd6",
        "_source": {
          "url": "https://www.bostonivf.com/locations/the-providence-ri-fertility-center",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Rhode Island (RI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-wv-fertility-institute",
    "externalIds": {
      "googlePlaceId": "ChIJuf8LZfHTSIgRHgaVwPQ5Ee8"
    },
    "type": "fertility-clinic",
    "name": "West Virginia Fertility Institute",
    "address": {
      "line1": "108 Washington St W, Suite 102",
      "city": "Charleston",
      "state": "WV",
      "zip": "25302",
      "country": "US"
    },
    "location": {
      "lat": 38.3757357,
      "lng": -81.6666897
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://westvirginiafertility.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://westvirginiafertility.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "PGT",
        "category": "diagnostic",
        "_source": {
          "url": "https://westvirginiafertility.com",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://westvirginiafertility.com/our-team/dr-tamer-yalcinkaya/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://westvirginiafertility.com",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://westvirginiafertility.com",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://westvirginiafertility.com/our-team/brooke-bowman-fnp-bc/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/West+Virginia+Fertility+Institute,+108+Washington+St+W+Ste+102,+Charleston,+WV+25302/@38.3599985,-81.6405431,3129a,13.1y/data=!4m2!3m1!1s0x8848d3f1650bffb9:0xef1139f4c095061e",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "website": "https://westvirginiafertility.com",
    "phone": "(304) 345-9292",
    "team": [
      {
        "practitionerId": "pr-org-web-wv-fertility-institute-tamer-yalcinkaya-md",
        "name": "Tamer Yalcinkaya, MD",
        "role": "Practice Founder and Fertility Expert",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://westvirginiafertility.com/wp-content/uploads/2024/11/dr-y.jpg",
        "_source": {
          "url": "https://westvirginiafertility.com/our-team/dr-tamer-yalcinkaya/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-wv-fertility-institute-audrey-garneau-md",
        "name": "Audrey Garneau, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://westvirginiafertility.com/wp-content/uploads/2024/11/audrey-garneau.jpg",
        "_source": {
          "url": "https://westvirginiafertility.com/our-team/dr-audrey-garneau/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-wv-fertility-institute-hooman-sadri-md",
        "name": "Hooman Sadri, MD",
        "role": "Male Reproductive Medicine Specialist",
        "credentials": ["MD"],
        "specialty": "Male Reproductive Medicine",
        "imageUrl": "https://westvirginiafertility.com/wp-content/uploads/2025/05/download.jpg",
        "_source": {
          "url": "https://westvirginiafertility.com/our-team/dr-hooman-sadri/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-wv-fertility-institute-brooke-bowman-fnp-bc",
        "name": "Brooke Bowman, FNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["FNP-BC"],
        "specialty": "Nurse Practitioner",
        "imageUrl": "https://westvirginiafertility.com/wp-content/uploads/2025/05/brooke-bowman.jpg",
        "_source": {
          "url": "https://westvirginiafertility.com/our-team/brooke-bowman-fnp-bc/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check West Virginia (WV) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkjoRhuOgB6gXM_4ej5Opjvbe0ns13A6FQ6yY859r6xSOPjsFSkJGqU6VQlNKrI0avwGGpy1VkvDXHr38uneM-JWmHb8nog0Fdm16ecrZQLEQLUYATYxGAobtmb7t-TByBjokR8=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/West+Virginia+Fertility+Institute,+108+Washington+St+W+Ste+102,+Charleston,+WV+25302/@38.3599985,-81.6405431,3129a,13.1y/data=!4m2!3m1!1s0x8848d3f1650bffb9:0xef1139f4c095061e",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-hattiesburg-clinic",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Hattiesburg Clinic OB/GYN - Infertility",
    "address": {
      "line1": "421 S 28th Ave, Suite 200",
      "city": "Hattiesburg",
      "state": "MS",
      "zip": "39401",
      "country": "US"
    },
    "location": {
      "lat": 31.3180362,
      "lng": -89.3319734
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.hattiesburgclinic.com/obstetrics-gynecology/infertility/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://www.hattiesburgclinic.com/obstetrics-gynecology/infertility/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.hattiesburgclinic.com/obstetrics-gynecology/infertility/",
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.hattiesburgclinic.com/locations/obstetrics-gynecology/hattiesburg-421-s-28th-ave/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.hattiesburgclinic.com/locations/obstetrics-gynecology/hattiesburg-421-s-28th-ave/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.hattiesburgclinic.com/obstetrics-gynecology/infertility/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.hattiesburgclinic.com/locations/obstetrics-gynecology/hattiesburg-421-s-28th-ave/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.hattiesburgclinic.com/locations/obstetrics-gynecology/hattiesburg-421-s-28th-ave/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "phone": "(601) 268-5640",
    "images": [
      {
        "url": "https://www.hattiesburgclinic.com/wp-content/uploads/2023/01/28th-Place_DSC03911.webp",
        "type": "exterior",
        "caption": "Hattiesburg Clinic 28th Place building exterior.",
        "_source": {
          "url": "https://www.hattiesburgclinic.com/locations/obstetrics-gynecology/hattiesburg-421-s-28th-ave/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "team": [
      {
        "practitionerId": "pr-org-web-hattiesburg-clinic-jennifer-c-bailey-md",
        "name": "Jennifer C. Bailey, MD",
        "role": "OB/GYN",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.hattiesburgclinic.com/wp-content/uploads/2023/02/Bailey-Jennifer-C-MD_web-copy.jpg",
        "_source": {
          "url": "https://www.hattiesburgclinic.com/locations/obstetrics-gynecology/hattiesburg-421-s-28th-ave/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-hattiesburg-clinic-lauren-e-barry-md",
        "name": "Lauren E. Barry, MD",
        "role": "OB/GYN",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.hattiesburgclinic.com/wp-content/uploads/2023/12/Barry-Lauren_Web.jpg",
        "_source": {
          "url": "https://www.hattiesburgclinic.com/locations/obstetrics-gynecology/hattiesburg-421-s-28th-ave/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-hattiesburg-clinic-louis-w-benton-md",
        "name": "Louis W. Benton, MD",
        "role": "OB/GYN",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.hattiesburgclinic.com/wp-content/uploads/2023/02/Louis-W.-Benton-MD_Web.jpg",
        "_source": {
          "url": "https://www.hattiesburgclinic.com/locations/obstetrics-gynecology/hattiesburg-421-s-28th-ave/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-hattiesburg-clinic-lauren-a-bethea-md",
        "name": "Lauren A. Bethea, MD",
        "role": "OB/GYN",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.hattiesburgclinic.com/wp-content/uploads/2023/02/Bethea-Lauren-Web-NEW.jpg",
        "_source": {
          "url": "https://www.hattiesburgclinic.com/locations/obstetrics-gynecology/hattiesburg-421-s-28th-ave/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-hattiesburg-clinic-brittney-j-brown-do",
        "name": "Brittney J. Brown, DO",
        "role": "OB/GYN",
        "credentials": ["DO"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.hattiesburgclinic.com/wp-content/uploads/2023/02/Brown-Brittney-J-DO_web.webp",
        "_source": {
          "url": "https://www.hattiesburgclinic.com/locations/obstetrics-gynecology/hattiesburg-421-s-28th-ave/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-hattiesburg-clinic-john-g-holland-md",
        "name": "John G. Holland, MD",
        "role": "OB/GYN",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.hattiesburgclinic.com/wp-content/uploads/2023/02/Holland-John-G.-MD_Web.jpg",
        "_source": {
          "url": "https://www.hattiesburgclinic.com/locations/obstetrics-gynecology/hattiesburg-421-s-28th-ave/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-hattiesburg-clinic-jeffrey-l-hudson-md",
        "name": "Jeffrey L. Hudson, MD",
        "role": "OB/GYN",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.hattiesburgclinic.com/wp-content/uploads/2023/02/Hudson-Jeffrey-L-MD_web.webp",
        "_source": {
          "url": "https://www.hattiesburgclinic.com/locations/obstetrics-gynecology/hattiesburg-421-s-28th-ave/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-hattiesburg-clinic-libby-y-c-kot-md",
        "name": "Libby Y. C. Kot, MD",
        "role": "OB/GYN",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.hattiesburgclinic.com/wp-content/uploads/2023/02/Kot-Libby-MD_web-NEW.jpg",
        "_source": {
          "url": "https://www.hattiesburgclinic.com/locations/obstetrics-gynecology/hattiesburg-421-s-28th-ave/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-hattiesburg-clinic-anna-e-malcolm-do",
        "name": "Anna E. Malcolm, DO",
        "role": "OB/GYN",
        "credentials": ["DO"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.hattiesburgclinic.com/wp-content/uploads/2025/10/x-Malcolm-Anna-E.-DO_Web.jpg",
        "_source": {
          "url": "https://www.hattiesburgclinic.com/locations/obstetrics-gynecology/hattiesburg-421-s-28th-ave/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-hattiesburg-clinic-benjamin-c-moore-md",
        "name": "Benjamin C. Moore, MD",
        "role": "OB/GYN",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.hattiesburgclinic.com/wp-content/uploads/2023/02/Moore-Benjamin-MD_web.webp",
        "_source": {
          "url": "https://www.hattiesburgclinic.com/locations/obstetrics-gynecology/hattiesburg-421-s-28th-ave/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-hattiesburg-clinic-amanda-s-sellers-do",
        "name": "Amanda S. Sellers, DO",
        "role": "OB/GYN",
        "credentials": ["DO"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.hattiesburgclinic.com/wp-content/uploads/2023/02/Sellers-Amanda-S.-DO_Web.jpg",
        "_source": {
          "url": "https://www.hattiesburgclinic.com/locations/obstetrics-gynecology/hattiesburg-421-s-28th-ave/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-hattiesburg-clinic-deanna-k-stewart-md",
        "name": "Deanna K. Stewart, MD",
        "role": "OB/GYN",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.hattiesburgclinic.com/wp-content/uploads/2023/02/Stewart-Deanna-K-MD_web-1.webp",
        "_source": {
          "url": "https://www.hattiesburgclinic.com/locations/obstetrics-gynecology/hattiesburg-421-s-28th-ave/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-hattiesburg-clinic-kaylie-b-wilkerson-md",
        "name": "Kaylie B. Wilkerson, MD",
        "role": "OB/GYN",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.hattiesburgclinic.com/wp-content/uploads/2025/08/Wilkerson-Kaylie-B.-MD_Web.jpg",
        "_source": {
          "url": "https://www.hattiesburgclinic.com/locations/obstetrics-gynecology/hattiesburg-421-s-28th-ave/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-hattiesburg-clinic-marlena-b-mims-whnp",
        "name": "Marlena B. Mims, WHNP",
        "role": "Women's Health Nurse Practitioner",
        "credentials": ["WHNP"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.hattiesburgclinic.com/wp-content/uploads/2023/02/Mims-Marlena_web-NEW-1.jpg",
        "_source": {
          "url": "https://www.hattiesburgclinic.com/locations/obstetrics-gynecology/hattiesburg-421-s-28th-ave/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-hattiesburg-clinic-traci-d-suber-whnp",
        "name": "Traci D. Suber, WHNP",
        "role": "Women's Health Nurse Practitioner",
        "credentials": ["WHNP"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.hattiesburgclinic.com/wp-content/uploads/2023/02/TraciDSuberCNP.webp",
        "_source": {
          "url": "https://www.hattiesburgclinic.com/locations/obstetrics-gynecology/hattiesburg-421-s-28th-ave/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Mississippi (MS) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-positive-steps-gulfport",
    "externalIds": {
      "googlePlaceId": "ChIJyXBLSEAXnIgRO1oRQkWHcFg"
    },
    "type": "fertility-clinic",
    "name": "Positive Steps Fertility - Gulfport",
    "address": {
      "line1": "401 Cowan Rd, Suite A",
      "city": "Gulfport",
      "state": "MS",
      "zip": "39507",
      "country": "US"
    },
    "location": {
      "lat": 30.3906371,
      "lng": -89.0268493
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/gulfport-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/gulfport-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://positivestepsfertility.com/locations/gulfport-fertility-center/",
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://positivestepsfertility.com/locations/gulfport-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://positivestepsfertility.com/locations/gulfport-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://positivestepsfertility.com/locations/gulfport-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://positivestepsfertility.com/about/staff/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Positive+Steps+Fertility+-+Gulfport,+401+Cowan+Rd+Ste+a,+Gulfport,+MS+39507/@30.3901137,-89.0272675,3442a,13.1y/data=!4m2!3m1!1s0x889c1740484b70c9:0x5870874542115a3b",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "phone": "855-441-0226",
    "team": [
      {
        "practitionerId": "pr-org-web-positive-steps-gulfport-john-preston-parry-md",
        "name": "John Preston Parry, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://positivestepsfertility.com/wp-content/uploads/2025/04/photo-preston-parry-square-300x300-1.jpg",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/mississippi/madison-fertility-clinic",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-positive-steps-gulfport-amber-hutchison-nurse-practitioner",
        "name": "Amber Hutchison, Nurse Practitioner",
        "role": "Nurse Practitioner",
        "specialty": "Fertility Nursing",
        "imageUrl": "https://positivestepsfertility.com/wp-content/uploads/2026/05/5.png",
        "_source": {
          "url": "https://positivestepsfertility.com/about/staff/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-positive-steps-gulfport-nikki-flucke-rn",
        "name": "Nikki Flucke, RN",
        "role": "RN",
        "credentials": ["RN"],
        "specialty": "Fertility Nursing",
        "imageUrl": "https://positivestepsfertility.com/wp-content/uploads/2026/05/8.png",
        "_source": {
          "url": "https://positivestepsfertility.com/about/staff/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-positive-steps-gulfport-lauren-hava-rn",
        "name": "Lauren Hava, RN",
        "role": "RN",
        "credentials": ["RN"],
        "specialty": "Fertility Nursing",
        "imageUrl": "https://positivestepsfertility.com/wp-content/uploads/2026/05/Headshots-2.png",
        "_source": {
          "url": "https://positivestepsfertility.com/about/staff/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-positive-steps-gulfport-ashley-johnson-slidell-and-gulfport-office-manager",
        "name": "Ashley Johnson, Slidell and Gulfport Office Manager",
        "role": "Slidell and Gulfport Office Manager",
        "specialty": "Fertility Care",
        "imageUrl": "https://positivestepsfertility.com/wp-content/uploads/2026/05/7.png",
        "_source": {
          "url": "https://positivestepsfertility.com/about/staff/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Mississippi (MS) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlf6ikbu2WhdlmOq42dFix6FCFtMUtnRrd0kW650bsrr2i2OtxFQaNV_P3FF1xa-6stK8GOIQGZKzprFQpZQvoaWuaLxV71sm24vWYjCJ80aCXlNuK7fmX4vEwkuYKNIR6iB4gMYi2Uqppi=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Positive+Steps+Fertility+-+Gulfport,+401+Cowan+Rd+Ste+a,+Gulfport,+MS+39507/@30.3901137,-89.0272675,3442a,13.1y/data=!4m2!3m1!1s0x889c1740484b70c9:0x5870874542115a3b",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn0CbMDJVrX0zLcb7WpstoPFnxQTIC212KumVucj5uyJPsmYy6H1RMdnMA3rdLYEIg20T8WvvufvH7tuT0Rpy9n4UxpXBURQrYDsddX8AKmpT39YfrZvxL7_HU2LX5rcuTyZnGmsgBe3d2z=w440-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Positive+Steps+Fertility+-+Gulfport,+401+Cowan+Rd+Ste+a,+Gulfport,+MS+39507/@30.3901137,-89.0272675,3442a,13.1y/data=!4m2!3m1!1s0x889c1740484b70c9:0x5870874542115a3b",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-norman-regional-infertility",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Women’s Healthcare of Norman",
    "address": {
      "line1": "3440 RC Luttrell Dr, Suite 200",
      "city": "Norman",
      "state": "OK",
      "zip": "73072",
      "country": "US"
    },
    "location": {
      "lat": 35.2580469,
      "lng": -97.4925743
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.normanregional.com/services/womens-health/infertility/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://www.normanregional.com/services/womens-health/infertility/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.normanregional.com/locations/women-s-healthcare-of-norman/",
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.normanregional.com/locations/women-s-healthcare-of-norman/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.normanregional.com/locations/women-s-healthcare-of-norman/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.normanregional.com/locations/women-s-healthcare-of-norman/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.normanregional.com/locations/women-s-healthcare-of-norman/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.normanregional.com/locations/women-s-healthcare-of-norman/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "website": {
          "status": "scraped",
          "source": {
            "url": "https://www.normanregional.com/locations/women-s-healthcare-of-norman/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "phone": "(405) 360-1264",
    "images": [
      {
        "url": "https://www.normanregional.com/images/locations/Women_s-Healthcare-Plaza-Building[1].jpg",
        "type": "exterior",
        "caption": "Women’s Healthcare Plaza exterior for Women’s Healthcare of Norman",
        "_source": {
          "url": "https://www.normanregional.com/locations/women-s-healthcare-of-norman/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "team": [
      {
        "practitionerId": "pr-org-web-norman-regional-infertility-mary-dianne-chambers-md",
        "name": "Mary Dianne Chambers, MD",
        "role": "OB-GYN",
        "credentials": ["MD"],
        "specialty": "OB-GYN, Robotic Surgery, Women’s Health",
        "imageUrl": "https://www.normanregional.com/images/system/physicians/Chambers_Dianne_15565-066.jpg",
        "_source": {
          "url": "https://www.normanregional.com/locations/women-s-healthcare-of-norman/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-norman-regional-infertility-jessica-hinojosa-do",
        "name": "Jessica Hinojosa, DO",
        "role": "OB-GYN",
        "credentials": ["DO"],
        "specialty": "OB-GYN, Robotic Surgery, Women’s Health",
        "imageUrl": "https://www.normanregional.com/images/system/physicians/Jessica_Hinojosa.jpg",
        "_source": {
          "url": "https://www.normanregional.com/locations/women-s-healthcare-of-norman/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-norman-regional-infertility-daphne-l-lashbrook-md",
        "name": "Daphne L. Lashbrook, MD",
        "role": "OB-GYN",
        "credentials": ["MD"],
        "specialty": "OB-GYN, Robotic Surgery, Women’s Health",
        "imageUrl": "https://www.normanregional.com/images/system/physicians/Daphne_Lashbrook.jpg",
        "_source": {
          "url": "https://www.normanregional.com/locations/women-s-healthcare-of-norman/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-norman-regional-infertility-leslie-j-ollar-shoemake-do",
        "name": "Leslie J. Ollar-Shoemake, DO",
        "role": "OB-GYN",
        "credentials": ["DO"],
        "specialty": "OB-GYN, Robotic Surgery, Women’s Health",
        "imageUrl": "https://www.normanregional.com/images/system/physicians/Leslie-Ollar-Shoemake-DO-15565-108.jpg",
        "_source": {
          "url": "https://www.normanregional.com/locations/women-s-healthcare-of-norman/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-norman-regional-infertility-starla-givens-aprn-cnp",
        "name": "Starla Givens, APRN-CNP",
        "role": "Nurse Practitioner",
        "credentials": ["APRN-CNP"],
        "specialty": "Women’s Health, OB-GYN",
        "imageUrl": "https://www.normanregional.com/images/system/physicians/Starla_Givens.jpg",
        "_source": {
          "url": "https://www.normanregional.com/locations/women-s-healthcare-of-norman/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-norman-regional-infertility-heather-bulloch-aprn-cnp",
        "name": "Heather Bulloch, APRN-CNP",
        "role": "Nurse Practitioner",
        "credentials": ["APRN-CNP"],
        "specialty": "Women’s Health, OB-GYN",
        "imageUrl": "https://www.normanregional.com/images/system/physicians/Bulloch_Heather_15565-019.jpg",
        "_source": {
          "url": "https://www.normanregional.com/locations/women-s-healthcare-of-norman/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-norman-regional-infertility-allison-carter-md",
        "name": "Allison Carter, MD",
        "role": "OB-GYN",
        "credentials": ["MD"],
        "specialty": "OB-GYN, Robotic Surgery, Women’s Health",
        "imageUrl": "https://www.normanregional.com/images/system/physicians/Allison-Carter-MD-15565-046.jpg",
        "_source": {
          "url": "https://www.normanregional.com/locations/women-s-healthcare-of-norman/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-norman-regional-infertility-stacey-saunders-aprn",
        "name": "Stacey Saunders, APRN",
        "role": "Nurse Practitioner",
        "credentials": ["APRN"],
        "specialty": "Women’s Health, OB-GYN",
        "imageUrl": "https://www.normanregional.com/images/Stacey-Saunders-APRN-CNP-15565-141.jpg",
        "_source": {
          "url": "https://www.normanregional.com/locations/women-s-healthcare-of-norman/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-norman-regional-infertility-lilly-ferrell-aprn-cnp",
        "name": "Lilly Ferrell, APRN-CNP",
        "role": "Nurse Practitioner",
        "credentials": ["APRN-CNP"],
        "specialty": "Women’s Health, OB-GYN",
        "imageUrl": "https://www.normanregional.com/images/Ferrell_Lilly_15565-125.jpg",
        "_source": {
          "url": "https://www.normanregional.com/locations/women-s-healthcare-of-norman/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-norman-regional-infertility-amber-scroggins-aprn-cnp",
        "name": "Amber Scroggins, APRN-CNP",
        "role": "Nurse Practitioner",
        "credentials": ["APRN-CNP"],
        "specialty": "Women’s Health, OB-GYN",
        "imageUrl": "https://www.normanregional.com/images/physicians/Amber-Scroggins-APRN-CNP-15565-159.jpg",
        "_source": {
          "url": "https://www.normanregional.com/locations/women-s-healthcare-of-norman/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-norman-regional-infertility-robin-antosh-aprn-cnp",
        "name": "Robin Antosh, APRN-CNP",
        "role": "Nurse Practitioner",
        "credentials": ["APRN-CNP"],
        "specialty": "Women’s Health, OB-GYN",
        "imageUrl": "https://www.normanregional.com/images/Robin-Antosh-APRN-CNP-15565-014.jpg",
        "_source": {
          "url": "https://www.normanregional.com/locations/women-s-healthcare-of-norman/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-norman-regional-infertility-audra-stanfield-aprn-cnp",
        "name": "Audra Stanfield, APRN-CNP",
        "role": "Nurse Practitioner",
        "credentials": ["APRN-CNP"],
        "specialty": "Women’s Health, OB-GYN",
        "imageUrl": "https://www.normanregional.com/images/Audra-Stanfield-APRN-CNP-15565-173.jpg",
        "_source": {
          "url": "https://www.normanregional.com/locations/women-s-healthcare-of-norman/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-norman-regional-infertility-katie-nixon-md",
        "name": "Katie Nixon, MD",
        "role": "OB-GYN",
        "credentials": ["MD"],
        "specialty": "OB-GYN, Robotic Surgery, Women’s Health",
        "imageUrl": "https://www.normanregional.com/images/physicians/nixon_katie_white_coat.png",
        "_source": {
          "url": "https://www.normanregional.com/locations/women-s-healthcare-of-norman/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Oklahoma (OK) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-dartmouth-hitchcock-fertility",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Dartmouth Hitchcock Clinics Fertility Services",
    "address": {
      "line1": "25 South River Road",
      "city": "Bedford",
      "state": "NH",
      "zip": "03110",
      "country": "US"
    },
    "location": {
      "lat": 42.96,
      "lng": -71.48
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "specialties": ["fertility-evaluation", "intrauterine-insemination"],
    "treatments": [
      {
        "name": "Fertility evaluation",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.dartmouth-hitchcock.org/obgyn/fertility-services",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://www.dartmouth-hitchcock.org/obgyn/fertility-services",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.dartmouth-hitchcock.org/obgyn/fertility-services",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Semen analysis",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.dartmouth-hitchcock.org/obgyn/fertility-services",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Sperm banking",
        "category": "preservation",
        "_source": {
          "url": "https://www.dartmouth-hitchcock.org/obgyn/fertility-services",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Donor sperm insemination",
        "category": "art",
        "_source": {
          "url": "https://www.dartmouth-hitchcock.org/obgyn/fertility-services",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.dartmouth-hitchcock.org/obgyn/fertility-services",
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.dartmouth-hitchcock.org/obgyn/fertility-services",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.dartmouth-hitchcock.org/obgyn/fertility-services",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.dartmouth-hitchcock.org/obgyn/team",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://www.dartmouth-hitchcock.org/obgyn/fertility-services",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "phone": "(603) 695-2900",
    "team": [
      {
        "practitionerId": "pr-org-web-dartmouth-hitchcock-fertility-cathy-chung-hwa-yi-md",
        "name": "Cathy Chung Hwa Yi, MD",
        "role": "OB/GYN Provider",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://providers.dartmouth-health.org/sites/default/files/styles/max_width_247/public/2024-07/Yi-Cathy-1250.jpg?itok=ovu-kMwz",
        "_source": {
          "url": "https://providers.dartmouth-health.org/bedford-obstetrics-and-gynecology",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-dartmouth-hitchcock-fertility-cecilia-l-clemans-md",
        "name": "Cecilia L. Clemans, MD",
        "role": "OB/GYN Provider",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://providers.dartmouth-health.org/system/files/styles/max_width_247/private/providers/images/1013.jpg?itok=K8nDtltU",
        "_source": {
          "url": "https://providers.dartmouth-health.org/bedford-obstetrics-and-gynecology",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-dartmouth-hitchcock-fertility-kristen-a-dahlgren-msn-aprn-whnp-bc",
        "name": "Kristen A. Dahlgren, MSN, APRN, WHNP-BC",
        "role": "OB/GYN Provider",
        "credentials": ["MSN", "APRN", "WHNP-BC"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://providers.dartmouth-health.org/sites/default/files/styles/max_width_247/public/2024-07/Dahlgren-Kristen-1250.jpg?itok=YMOmXAkV",
        "_source": {
          "url": "https://providers.dartmouth-health.org/bedford-obstetrics-and-gynecology",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-dartmouth-hitchcock-fertility-kara-i-donati-mpas-pa-c",
        "name": "Kara I. Donati, MPAS, PA-C",
        "role": "OB/GYN Provider",
        "credentials": ["MPAS", "PA-C"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://providers.dartmouth-health.org/sites/default/files/styles/max_width_247/public/2026-02/Donati-Kara-1250.jpg?itok=VtGPj6tf",
        "_source": {
          "url": "https://providers.dartmouth-health.org/bedford-obstetrics-and-gynecology",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-dartmouth-hitchcock-fertility-lindsay-m-drew-md-ms",
        "name": "Lindsay M. Drew, MD, MS",
        "role": "OB/GYN Provider",
        "credentials": ["MD", "MS"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://providers.dartmouth-health.org/sites/default/files/styles/max_width_247/public/2024-07/Drew-Lindsay-1250.jpg?itok=MpYLl7Ma",
        "_source": {
          "url": "https://providers.dartmouth-health.org/bedford-obstetrics-and-gynecology",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-dartmouth-hitchcock-fertility-deborah-m-enegess-md",
        "name": "Deborah M. Enegess, MD",
        "role": "OB/GYN Provider",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://providers.dartmouth-health.org/sites/default/files/styles/max_width_247/public/2026-04/Enegess-Deborah-1250.jpg?itok=QuMVuQtW",
        "_source": {
          "url": "https://providers.dartmouth-health.org/bedford-obstetrics-and-gynecology",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-dartmouth-hitchcock-fertility-nicole-d-krygeris-aprn-whnp-bc-anp-bc",
        "name": "Nicole D. Krygeris, APRN, WHNP-BC, ANP-BC",
        "role": "OB/GYN Provider",
        "credentials": ["APRN", "WHNP-BC", "ANP-BC"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://providers.dartmouth-health.org/system/files/styles/max_width_247/private/providers/images/3261.jpg?itok=Yc5YUHQa",
        "_source": {
          "url": "https://providers.dartmouth-health.org/bedford-obstetrics-and-gynecology",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-dartmouth-hitchcock-fertility-rose-n-laignel-do",
        "name": "Rose N. Laignel, DO",
        "role": "OB/GYN Provider",
        "credentials": ["DO"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://providers.dartmouth-health.org/sites/default/files/styles/max_width_247/public/2024-07/Laignel-Rose-1250.jpg?itok=-YZtG0zh",
        "_source": {
          "url": "https://providers.dartmouth-health.org/bedford-obstetrics-and-gynecology",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-dartmouth-hitchcock-fertility-alexandria-m-margerison-ms-cnm",
        "name": "Alexandria M. Margerison, MS, CNM",
        "role": "OB/GYN Provider",
        "credentials": ["MS", "CNM"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://providers.dartmouth-health.org/sites/default/files/styles/max_width_247/public/2025-10/Margerison-Alexandria-1250.jpg?itok=LLSRk2vw",
        "_source": {
          "url": "https://providers.dartmouth-health.org/bedford-obstetrics-and-gynecology",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-dartmouth-hitchcock-fertility-katelyn-monroe-mspas-pa-c",
        "name": "Katelyn Monroe, MSPAS, PA-C",
        "role": "OB/GYN Provider",
        "credentials": ["MSPAS", "PA-C"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://providers.dartmouth-health.org/sites/default/files/styles/max_width_247/public/2024-07/Monroe-Katelyn-1250.jpg?itok=tZ7v1JW1",
        "_source": {
          "url": "https://providers.dartmouth-health.org/bedford-obstetrics-and-gynecology",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-dartmouth-hitchcock-fertility-cassandra-montminy-msn-aprn-cnm",
        "name": "Cassandra Montminy, MSN, APRN, CNM",
        "role": "OB/GYN Provider",
        "credentials": ["MSN", "APRN", "CNM"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://providers.dartmouth-health.org/sites/default/files/styles/max_width_247/public/2024-07/Montminy-Cassandra-1250.jpg?itok=JwZUSI3D",
        "_source": {
          "url": "https://providers.dartmouth-health.org/bedford-obstetrics-and-gynecology",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-dartmouth-hitchcock-fertility-maria-de-gracia-padin-md",
        "name": "Maria de Gracia Padin, MD",
        "role": "OB/GYN Provider",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://providers.dartmouth-health.org/sites/default/files/styles/max_width_247/public/2024-07/maria-padin-1250_0.jpg?itok=0WH1Yspd",
        "_source": {
          "url": "https://providers.dartmouth-health.org/bedford-obstetrics-and-gynecology",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-dartmouth-hitchcock-fertility-emily-principe-msn-aprn",
        "name": "Emily Principe, MSN, APRN",
        "role": "OB/GYN Provider",
        "credentials": ["MSN", "APRN"],
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://providers.dartmouth-health.org/system/files/styles/max_width_247/private/providers/images/1999.jpg?itok=0K7j8CDe",
        "_source": {
          "url": "https://providers.dartmouth-health.org/bedford-obstetrics-and-gynecology",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-dartmouth-hitchcock-fertility-rosemarie-c-keefe-mgc-lgc",
        "name": "Rosemarie C. Keefe, MGC, LGC",
        "role": "Reproductive Genetics Provider",
        "credentials": ["MGC", "LGC"],
        "specialty": "Reproductive Genetics",
        "imageUrl": "https://providers.dartmouth-health.org/sites/default/files/styles/max_width_247/public/2024-07/Keefe-Rosemarie-1250.jpg?itok=qTrwKzHg",
        "_source": {
          "url": "https://providers.dartmouth-health.org/bedford-reproductive-genetics",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-dartmouth-hitchcock-fertility-megan-m-wirth-ms-lgc",
        "name": "Megan M. Wirth, MS, LGC",
        "role": "Reproductive Genetics Provider",
        "credentials": ["MS", "LGC"],
        "specialty": "Reproductive Genetics",
        "imageUrl": "https://providers.dartmouth-health.org/sites/default/files/styles/max_width_247/public/2024-07/Wirth-Megan-1250.jpg?itok=7w0So4Fe",
        "_source": {
          "url": "https://providers.dartmouth-health.org/bedford-reproductive-genetics",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [
      {
        "url": "https://www.dartmouth-hitchcock.org/sites/default/files/styles/max_width_495/public/2020-05/bedford.jpg?itok=LrW0GAHL",
        "type": "exterior",
        "caption": "Dartmouth Hitchcock Clinics Bedford building exterior at 25 South River Road, Bedford, NH, with the Dartmouth-Hitchcock entrance sign visible",
        "_source": {
          "url": "https://www.dartmouth-hitchcock.org/locations-directions/dh-bedford",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Hampshire (NH) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-genes-fertility-pr",
    "externalIds": {
      "googlePlaceId": "ChIJiQtwP5JoA4wRgHvNYEoeM-4"
    },
    "type": "fertility-clinic",
    "name": "Genes Fertility Institute",
    "address": {
      "line1": "576 Ave Cesar Gonzalez, Adler Medical Plaza, Suite 505",
      "city": "San Juan",
      "state": "PR",
      "zip": "00918",
      "country": "US"
    },
    "location": {
      "lat": 18.411982,
      "lng": -66.0652515
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://genesfertility.com/en/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://genesfertility.com/en/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://genesfertility.com/en/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://genesfertility.com/en/",
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://genesfertility.com/en/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://genesfertility.com/en/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://genesfertility.com/en/team/dr-nabal-bracero-md-facog/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Genes+Fertility+Institute,+Adler+Medical+Plaza,+576+Av.+Tte.+C%C3%A9sar+Luis+Gonz%C3%A1lez+Ste+505,+Fifth+Floor,+San+Juan,+00918,+Puerto+Rico/@18.4106486,-66.0650812,3786a,13.1y/data=!4m2!3m1!1s0x8c0368923f700b89:0xee331e4a60cd7b80",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "phone": "787-767-2220",
    "team": [
      {
        "practitionerId": "pr-org-web-genes-fertility-pr-nabal-bracero-md-facog",
        "name": "Nabal Bracero, MD, FACOG",
        "role": "Medical Director",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "_source": {
          "url": "https://genesfertility.com/en/team/dr-nabal-bracero-md-facog/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Puerto Rico (PR) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-huntsville-reproductive",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Huntsville Reproductive Medicine",
    "address": {
      "line1": "185 Chateau Dr SW, Suite 301",
      "city": "Huntsville",
      "state": "AL",
      "zip": "35801",
      "country": "US"
    },
    "location": {
      "lat": 34.6921256,
      "lng": -86.5743737
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://huntsvilleivf.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://huntsvilleivf.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://huntsvilleivf.com",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://huntsvilleivf.com",
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.waff.com/2024/12/31/madison-ivf-clinic-closes-its-doors-new-opportunities/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "searched-absent",
          "source": {
            "url": "https://www.waff.com/2024/12/31/madison-ivf-clinic-closes-its-doors-new-opportunities/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://huntsvilleivf.com",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "verified-none",
          "source": {
            "url": "https://www.waff.com/2024/08/14/madison-ivf-clinic-closes-its-doors-new-opportunities/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://www.waff.com/2024/08/14/madison-ivf-clinic-closes-its-doors-new-opportunities/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [],
    "team": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Alabama (AL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-positive-steps-slidell",
    "externalIds": {
      "googlePlaceId": "ChIJ4-qoDgDnnYgRjRiMjv_7w7w"
    },
    "type": "fertility-clinic",
    "name": "Positive Steps Fertility - Slidell",
    "address": {
      "line1": "300 Gateway Dr",
      "city": "Slidell",
      "state": "LA",
      "zip": "70461",
      "country": "US"
    },
    "location": {
      "lat": 30.285365,
      "lng": -89.741898
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "treatments": [
      {
        "name": "Fertility testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "ICSI",
        "category": "art",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Embryo transfer",
        "category": "art",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Minimally invasive gynecologic surgery",
        "category": "surgical",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Tubal ligation reversal",
        "category": "surgical",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Third-party reproduction",
        "category": "art",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg freezing",
        "category": "preservation",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://positivestepsfertility.com/locations/louisiana/slidell-fertility-clinic",
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://positivestepsfertility.com/locations/louisiana/slidell-fertility-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://positivestepsfertility.com/locations/louisiana/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://positivestepsfertility.com/locations/louisiana/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://positivestepsfertility.com/locations/louisiana/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Positive+Steps+Fertility+-+Slidell,+300+Gateway+Dr,+Slidell,+LA+70461/@30.2875365,-89.7415704,3445a,13.1y/data=!4m2!3m1!1s0x889de7000ea8eae3:0xbcc3fbff8e8c188d",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://positivestepsfertility.com/locations/louisiana/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "phone": "(985) 265-7909",
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "description": "Positive Steps Fertility provides fertility testing, IUI, IVF, ICSI, embryo transfer, minimally invasive gynecologic surgery, LGBTQ+ fertility care, tubal ligation reversal, third-party reproduction, and egg freezing in Louisiana.",
    "team": [
      {
        "practitionerId": "pr-org-web-positive-steps-slidell-john-preston-parry-md",
        "name": "John Preston Parry, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://positivestepsfertility.com/wp-content/uploads/2025/04/photo-preston-parry-square-300x300-1.jpg",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Louisiana (LA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl1A2WE0AG5MJYxO8czQ84V2fpwPahA-lsF5smVNMKAN13Mu2vHJVFk0XaAhWY-MJoFpGhDK8WhE_G_htJ3LSl6xVTGnKuOmtGtyGZF7z-uZkdw3o7aqiDKmKBU4Ee5jsbeSAcw_JA03tU=w440-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Positive+Steps+Fertility+-+Slidell,+300+Gateway+Dr,+Slidell,+LA+70461/@30.2875365,-89.7415704,3445a,13.1y/data=!4m2!3m1!1s0x889de7000ea8eae3:0xbcc3fbff8e8c188d",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnKZugPfTeappsAaUeuj4YWtqDlkZlTUukikz7_knVlCKlFrV8YYK7UEbSAxJBABuQ6PeeamqWjIX9HncSgDIokiU9qIntEVv3chB-0fdF7kgDAwTJcDKzQHVE3aD3nfgcizK9fLMS58Y9-=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Positive+Steps+Fertility+-+Slidell,+300+Gateway+Dr,+Slidell,+LA+70461/@30.2875365,-89.7415704,3445a,13.1y/data=!4m2!3m1!1s0x889de7000ea8eae3:0xbcc3fbff8e8c188d",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-positive-steps-shreveport",
    "externalIds": {
      "googlePlaceId": "ChIJyXTPaIEtMYYRTvcS1C53jDA"
    },
    "type": "fertility-clinic",
    "name": "Positive Steps Fertility - Shreveport",
    "phone": "(833) 767-7837",
    "address": {
      "line1": "9391 Ellerbe Rd, Suite C",
      "city": "Shreveport",
      "state": "LA",
      "zip": "71106",
      "country": "US"
    },
    "location": {
      "lat": 32.4136387,
      "lng": -93.7384045
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "treatments": [
      {
        "name": "Fertility testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "ICSI",
        "category": "art",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Embryo transfer",
        "category": "art",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Minimally invasive gynecologic surgery",
        "category": "surgical",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Tubal ligation reversal",
        "category": "surgical",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Third-party reproduction",
        "category": "art",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg freezing",
        "category": "preservation",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://positivestepsfertility.com/clinics/louisiana/shreveport/",
    "description": "Positive Steps Fertility provides fertility testing, IUI, IVF, ICSI, embryo transfer, minimally invasive gynecologic surgery, LGBTQ+ fertility care, tubal ligation reversal, third-party reproduction, and egg freezing in Louisiana.",
    "team": [
      {
        "practitionerId": "pr-org-web-positive-steps-shreveport-john-preston-parry-md",
        "name": "John Preston Parry, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://positivestepsfertility.com/wp-content/uploads/2025/04/photo-preston-parry-square-300x300-1.jpg",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://positivestepsfertility.com/clinics/louisiana/shreveport/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://positivestepsfertility.com/locations/louisiana/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://positivestepsfertility.com/locations/louisiana/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://positivestepsfertility.com/locations/louisiana/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://positivestepsfertility.com/locations/louisiana/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Positive+Steps+Fertility+-+Shreveport,+9391+Ellerbe+Rd+Ste+C,+Shreveport,+LA+71106/@32.3985476,-93.7312044,3369a,13.1y/data=!4m2!3m1!1s0x86312d8168cf74c9:0x308c772ed412f74e",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Louisiana (LA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-positive-steps-monroe",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Positive Steps Fertility - Monroe",
    "phone": "(833) 767-7837",
    "address": {
      "line1": "1900 N 18th St, Suite 209",
      "city": "Monroe",
      "state": "LA",
      "zip": "71201",
      "country": "US"
    },
    "location": {
      "lat": 32.52716,
      "lng": -92.115942
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "treatments": [
      {
        "name": "Fertility testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "ICSI",
        "category": "art",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Embryo transfer",
        "category": "art",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Minimally invasive gynecologic surgery",
        "category": "surgical",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Tubal ligation reversal",
        "category": "surgical",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Third-party reproduction",
        "category": "art",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg freezing",
        "category": "preservation",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://positivestepsfertility.com/locations/louisiana/",
    "description": "Positive Steps Fertility provides fertility testing, IUI, IVF, ICSI, embryo transfer, minimally invasive gynecologic surgery, LGBTQ+ fertility care, tubal ligation reversal, third-party reproduction, and egg freezing in Louisiana.",
    "team": [
      {
        "practitionerId": "pr-org-web-positive-steps-monroe-john-preston-parry-md",
        "name": "John Preston Parry, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://positivestepsfertility.com/wp-content/uploads/2025/04/photo-preston-parry-square-300x300-1.jpg",
        "_source": {
          "url": "https://positivestepsfertility.com/locations/louisiana/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://positivestepsfertility.com/locations/louisiana/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://positivestepsfertility.com/locations/louisiana/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://positivestepsfertility.com/locations/louisiana/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://positivestepsfertility.com/locations/louisiana/",
            "fetchedAt": "2026-06-13"
          }
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://positivestepsfertility.com/locations/louisiana/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Positive+Steps+Fertility+-+Monroe,+1900+N+18th+St+%23209,+Monroe,+LA+71201/@32.5282418,-92.1144623,3364a,13.1y/data=!4m2!3m1!1s0x862e477b50054ded:0x8146de89db22b5b1",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Louisiana (LA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-utah-fertility-st-george",
    "externalIds": {
      "googlePlaceId": "ChIJSU9ZfydFyoAR1TVHA7hIT24"
    },
    "type": "fertility-clinic",
    "name": "Utah Fertility Center - St. George",
    "address": {
      "line1": "295 S 1470 E, Suite 100",
      "city": "St. George",
      "state": "UT",
      "zip": "84790",
      "country": "US"
    },
    "location": {
      "lat": 37.1000831,
      "lng": -113.5509377
    },
    "setting": "network-group",
    "consultationTypes": ["in-person", "telehealth"],
    "specialties": ["reproductive-endocrinology", "male-infertility"],
    "treatments": [
      {
        "name": "Gentle IVF",
        "category": "art",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Recurrent pregnancy loss care",
        "category": "diagnostic",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Genetic testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Male infertility care",
        "category": "diagnostic",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg freezing",
        "category": "preservation",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility preservation for cancer patients",
        "category": "preservation",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg donor services",
        "category": "art",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Surrogacy",
        "category": "art",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://utahfertility.com/locations/st-george-clinic",
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://utahfertility.com/locations/st-george-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://utahfertility.com/locations/st-george-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://utahfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://utahfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Utah+Fertility+Center,+St.+George,+295+S+1470+E+Ste+100,+St.+George,+UT+84790/@37.103247,-113.5512964,3182a,13.1y/data=!4m2!3m1!1s0x80ca45277f594f49:0x6e4f48b8034735d5",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "description": {
          "status": "scraped",
          "source": {
            "url": "https://utahfertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://utahfertility.com/locations/st-george-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "Utah Fertility Center"
    },
    "phone": "(435) 393-6620",
    "patientGroups": ["LGBTQIA+", "Single Parents", "Same sex couples"],
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "17:00"
      },
      "tue": {
        "open": "08:00",
        "close": "17:00"
      },
      "wed": {
        "open": "08:00",
        "close": "17:00"
      },
      "thu": {
        "open": "08:00",
        "close": "17:00"
      },
      "fri": {
        "open": "08:00",
        "close": "17:00"
      }
    },
    "description": "Utah Fertility Center provides gentle IVF, IVF, IUI, genetic testing, male infertility care, egg freezing, cancer fertility preservation, LGBTQ family-building, egg donor services, and surrogacy from clinics in Pleasant Grove, Midvale, Ogden, and St. George.",
    "team": [
      {
        "practitionerId": "pr-org-web-utah-fertility-st-george-shawn-e-gurtcheff-md-ms",
        "name": "Shawn E. Gurtcheff, MD, MS",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MS"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/1452x1932/9489a3d16c/dr-shawn-e-gurtcheff.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-utah-fertility-st-george-deirdre-a-conway-md",
        "name": "Deirdre A. Conway, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/1024x1536/b2bcf0b114/deirdre-a-conway-md.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-utah-fertility-st-george-yetunde-ibrahim-md",
        "name": "Yetunde Ibrahim, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/1452x1932/0b5feadcfe/dr-yetunde-ibrahim.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-utah-fertility-st-george-erica-louden-md-phd-facog",
        "name": "Erica Louden, MD, PhD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "PhD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/533x800/41547658de/erica-louden-md-ph-d-facog.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-utah-fertility-st-george-melinda-henne-md",
        "name": "Melinda Henne, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/3072x4080/79fa1d7c87/melinda-henne-md.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-utah-fertility-st-george-addison-alley-md-msci-facog",
        "name": "Addison Alley, MD, MSCI, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MSCI", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://a.storyblok.com/f/290132/2520x3149/7dac9de5f0/dr-addison-alley.jpg/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://utahfertility.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Utah (UT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk4YlM6H_UIlDicAp6eilHgVVF19K9wOrD-JbAENDU_N2-R_udkdlldjG8yTI3soSJ9L0cXcVHmAIISMja-AEOaCwsAdefLzbd-lQGkdilcgMWIjix6X_5xgtSjCAc0coJ-Vs2c2w=w241-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Utah+Fertility+Center,+St.+George,+295+S+1470+E+Ste+100,+St.+George,+UT+84790/@37.103247,-113.5512964,3182a,13.1y/data=!4m2!3m1!1s0x80ca45277f594f49:0x6e4f48b8034735d5",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-centracare-fertility",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "CentraCare Reproductive Medicine",
    "address": {
      "line1": "1900 CentraCare Circle, Suite 2300",
      "city": "St. Cloud",
      "state": "MN",
      "zip": "56303",
      "country": "US"
    },
    "location": {
      "lat": 45.5831721,
      "lng": -94.2068289
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "website": "https://www.centracare.com/services/reproductive-medicine/",
    "specialties": ["reproductive-endocrinology"],
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.centracare.com/services/reproductive-medicine/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://www.centracare.com/services/reproductive-medicine/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Testing",
        "category": "diagnostics",
        "_source": {
          "url": "https://www.centracare.com/services/reproductive-medicine/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.centracare.com/services/reproductive-medicine/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.centracare.com/services/reproductive-medicine/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.centracare.com/services/reproductive-medicine/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.centracare.com/locations/profile/plaza-clinic-obstetrics-womens-health/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "phone": "(320) 654-3630 ext. 70291",
    "team": [
      {
        "practitionerId": "pr-org-web-centracare-fertility-david-allen-kroska-md",
        "name": "David Allen Kroska, MD",
        "role": "Obstetrician/Gynecologist; Reproductive Medicine",
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.centracare.com/app/files/public/Provider-Headshots/Kroska-David.jpg",
        "_source": {
          "url": "https://www.centracare.com/doctors/profile/david-kroska/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-centracare-fertility-jacob-benjamin-dubay-do",
        "name": "Jacob Benjamin Dubay, DO",
        "role": "Obstetrician/Gynecologist; Reproductive Medicine",
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.centracare.com/app/files/public/Provider-Headshots/Dubay-Jacob.jpg?size=small",
        "_source": {
          "url": "https://www.centracare.com/services/reproductive-medicine/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-centracare-fertility-brett-ayn-pinkerton-md",
        "name": "Brett Ayn Pinkerton, MD",
        "role": "Obstetrician/Gynecologist; Reproductive Medicine",
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.centracare.com/app/files/public/Provider-Headshots/Pinkerton-Brett.jpg?size=small",
        "_source": {
          "url": "https://www.centracare.com/services/reproductive-medicine/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [
      {
        "url": "https://www.centracare.com/app/files/public/Locations/centracare-plaza-woodlands.jpg",
        "type": "exterior",
        "caption": "CentraCare Plaza Clinic Obstetrics & Women's Health exterior",
        "_source": {
          "url": "https://www.centracare.com/locations/profile/plaza-clinic-obstetrics-womens-health/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Minnesota (MN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-essentia-duluth-fertility",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Essentia Health - Duluth Fertility",
    "address": {
      "line1": "420 E 1st St",
      "city": "Duluth",
      "state": "MN",
      "zip": "55805",
      "country": "US"
    },
    "location": {
      "lat": 46.7922635,
      "lng": -92.0927226
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "website": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-duluth-clinic-1st-street-building-a",
    "specialties": ["ob-gyn"],
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-duluth-clinic-1st-street-building-a",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-duluth-clinic-1st-street-building-a",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-duluth-clinic-1st-street-building-a",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-duluth-clinic-1st-street-building-a",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-duluth-clinic-1st-street-building-a",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-duluth-clinic-1st-street-building-a",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "phone": "(218) 786-3800",
    "team": [
      {
        "practitionerId": "pr-org-web-essentia-duluth-fertility-heidi-thorson-md",
        "name": "Heidi Thorson, MD",
        "role": "Maternal-Fetal Medicine; Obstetrics/Gynecology; Fertility",
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-duluth-clinic-1st-street-building-a",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-essentia-duluth-fertility-terri-halverson-aprn-cnp",
        "name": "Terri Halverson, APRN, CNP",
        "role": "Obstetrics; Fertility",
        "specialty": "Obstetrics and Fertility",
        "imageUrl": "https://www.essentiahealth.org/-/media/Project/Essentia/Essentia/Providers/profile-images/terri-halverson.jpg?rev=c397d24355624f658a72138c8db3fbb7&sc_lang=en",
        "_source": {
          "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-duluth-clinic-1st-street-building-a",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-essentia-duluth-fertility-haley-meyer-md",
        "name": "Haley Meyer, MD",
        "role": "Obstetrics/Gynecology; Fertility",
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.essentiahealth.org/-/media/Project/Essentia/Essentia/Providers/profile-images/haley-meyer.jpg?rev=20933134f70c4c83bfbb16da257902fb&sc_lang=en",
        "_source": {
          "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-duluth-clinic-1st-street-building-a",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-essentia-duluth-fertility-claire-mallof-md",
        "name": "Claire Mallof, MD",
        "role": "Obstetrics/Gynecology; Fertility",
        "specialty": "Obstetrics and Gynecology",
        "imageUrl": "https://www.essentiahealth.org/-/media/Project/Essentia/Essentia/Providers/profile-images/claire-mallof.jpg?rev=e5a05095f4134d10b171f9ad857062fc",
        "_source": {
          "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-duluth-clinic-1st-street-building-a",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [
      {
        "url": "https://www.essentiahealth.org/-/media/Project/Essentia/Essentia/Locations/facility-images/Duluth-Clinic-1st-Street-Building.jpg?rev=430457e0327d49828dda79d1f4d53476",
        "type": "exterior",
        "caption": "Essentia Health Duluth Clinic 1st Street Building exterior",
        "_source": {
          "url": "https://www.essentiahealth.org/find-facility/fertility-essentia-health-duluth-clinic-1st-street-building-a",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Minnesota (MN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-kaldas-center",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Kaldas Center for Fertility, Surgery & Pregnancy",
    "address": {
      "line1": "701 S Nicolet Rd",
      "city": "Appleton",
      "state": "WI",
      "zip": "54914",
      "country": "US"
    },
    "location": {
      "lat": 44.259169,
      "lng": -88.4699841
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://kaldascenter.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://kaldascenter.com",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://kaldascenter.com",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://kaldascenter.com",
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://kaldascenter.com",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://kaldascenter.com",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://kaldascenter.com/about",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://kaldascenter.com/about",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "description": {
          "status": "missing"
        },
        "schedule": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-web-kaldas-center-rami-kaldas-md",
        "name": "Rami Kaldas, MD",
        "role": "Founder; Gynecological Surgeon",
        "credentials": ["MD"],
        "specialty": "Gynecological Surgery; Fertility",
        "imageUrl": "https://images.squarespace-cdn.com/content/v1/5fd8d2df8b953913d7c1aeb1/1ba51c48-138c-4f60-972e-926b837ff414/Dr-Rami-Portrait_About_2022.png",
        "_source": {
          "url": "https://kaldascenter.com/about",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Wisconsin (WI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-ccrm-greenville",
    "externalIds": {
      "googlePlaceId": "ChIJI7WUS3opWIgRZ5jkXxQf3x0"
    },
    "type": "fertility-clinic",
    "name": "CCRM Fertility of Greenville",
    "address": {
      "line1": "700 Executive Center Dr, Suite 300",
      "city": "Greenville",
      "state": "SC",
      "zip": "29615",
      "country": "US"
    },
    "location": {
      "lat": 34.8373054,
      "lng": -82.3032039
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/south-carolina/greenville/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/south-carolina/greenville/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/south-carolina/greenville/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.ccrmivf.com/location/us/south-carolina/greenville/",
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/south-carolina/greenville/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/south-carolina/greenville/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/south-carolina/greenville/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/south-carolina/greenville/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Greenville,+700+Executive+Center+Dr+Ste+300,+Greenville,+SC+29615/@34.8364082,-82.3015952,3275a,13.1y/data=!4m2!3m1!1s0x8858297a4b94b523:0x1ddf1f145fe49867",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "CCRM Fertility"
    },
    "phone": "(864) 412-1950",
    "team": [
      {
        "practitionerId": "pr-org-web-ccrm-greenville-rachel-beverley-md",
        "name": "Rachel Beverley, MD",
        "role": "Co-founding Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Rachel_Beverley_600x600_2x-r9ypwwegir534qnh87mslnwf0xv4dmu9je9xkro4v4.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/south-carolina/greenville/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-ccrm-greenville-creighton-e-likes-iii-md-ms",
        "name": "Creighton E. Likes, III, MD, MS",
        "role": "Co-founding Physician",
        "credentials": ["MD", "MS"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Creighton_Likes_600x600_2x-r9ypolhs5frwkqpnpmffkrbu4esedvvmeatiyrzbts.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/south-carolina/greenville/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkEbID_aOOGYwmCKr4oqwm0uSnb8ts1UpLehGJK11r8zUgVbFdUKuR6XU0W7txVKjBBk_zNinPcC2jO7QvavW9w0CGOLhRVeNLnDFeI6veGuY-vgNOr-bA993vuOTIjxalakr1Cx3QHofDI=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Greenville,+700+Executive+Center+Dr+Ste+300,+Greenville,+SC+29615/@34.8364082,-82.3015952,3275a,13.1y/data=!4m2!3m1!1s0x8858297a4b94b523:0x1ddf1f145fe49867",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check South Carolina (SC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-ccrm-arizona-gilbert",
    "externalIds": {
      "googlePlaceId": "ChIJnTgCvYSsK4cRODmcp8mrelw"
    },
    "type": "fertility-clinic",
    "name": "CCRM Fertility of Arizona",
    "address": {
      "line1": "3885 S Val Vista Dr, Suite 105",
      "city": "Gilbert",
      "state": "AZ",
      "zip": "85297",
      "country": "US"
    },
    "location": {
      "lat": 33.2798281,
      "lng": -111.7545782
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/arizona/gilbert/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/arizona/gilbert/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/arizona/gilbert/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.ccrmivf.com/location/us/arizona/gilbert/",
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/arizona/gilbert/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/arizona/gilbert/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/arizona/gilbert/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Gilbert,+3885+S+Val+Vista+Dr+Ste+105,+Gilbert,+AZ+85297/@33.2797061,-111.7545598,3335a,13.1y/data=!4m2!3m1!1s0x872bac84bd02389d:0x5c7aabc9a79c3938",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "CCRM Fertility"
    },
    "team": [
      {
        "name": "Ketan S. Patel, MD",
        "role": "Co-Medical Director, Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Ketan_Patel_600x600_2x.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/ketan-s-patel/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-ccrm-arizona-gilbert-ketan-s-patel-md"
      },
      {
        "name": "Evan Reshef, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Evan_Reshef_600x600_2x.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/evan-reshef/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-ccrm-arizona-gilbert-evan-reshef-md"
      },
      {
        "name": "Nicole Kummer, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Nicole_Kummer_600x600_2x.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/nicole-kummer/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-ccrm-arizona-gilbert-nicole-kummer-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Arizona (AZ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlAywfYySiwaMDEB9LAFHywFC0WAm91NduFz1oZ7pgw-4Vv6fPhMx2JXFTKSO58zfN4SVb1VRptYgk5c2E-P9TahXVRka-TQI1VQhLIlZu59G17JV4PJGfttt1uAb5188gPPox1Kg=w444-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Gilbert,+3885+S+Val+Vista+Dr+Ste+105,+Gilbert,+AZ+85297/@33.2797061,-111.7545598,3335a,13.1y/data=!4m2!3m1!1s0x872bac84bd02389d:0x5c7aabc9a79c3938",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnWlYFo4r7zMzvgG4IqwwVjZ0q84vloCkFlAw6oVhaC6RaK-Gh3_SRPYWC7WBpHprSEofhPXnRWZ8XDbdovu6865_aKZMDAkl8grOuFNaFr519SD6w09xuIseHB8rrJoqDmS-lYR1yzloRN=w286-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Gilbert,+3885+S+Val+Vista+Dr+Ste+105,+Gilbert,+AZ+85297/@33.2797061,-111.7545598,3335a,13.1y/data=!4m2!3m1!1s0x872bac84bd02389d:0x5c7aabc9a79c3938",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-umaryland-rei",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "University of Maryland Reproductive Endocrinology & Infertility",
    "address": {
      "line1": "419 W Redwood St, Suite 500",
      "city": "Baltimore",
      "state": "MD",
      "zip": "21201",
      "country": "US"
    },
    "location": {
      "lat": 39.2882315,
      "lng": -76.6219168
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.umms.org/ummc/health-services/womens-health/obstetrics-gynecology/fertility",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.umms.org/ummc/health-services/womens-health/obstetrics-gynecology/fertility",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.umms.org/ummc/health-services/womens-health/obstetrics-gynecology/fertility",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.umms.org/ummc/health-services/womens-health/obstetrics-gynecology/fertility",
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.umms.org/ummc/health-services/womens-health/obstetrics-gynecology/fertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.umms.org/ummc/health-services/womens-health/obstetrics-gynecology/fertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "verified-none",
          "source": {
            "url": "https://www.medschool.umaryland.edu/ob/divisions--centers/reproductive-endocrinology-and-infertility/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://www.umms.org/ummc/health-services/womens-health/obstetrics-gynecology/fertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "phone": "(667) 214-1300",
    "team": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Maryland (MD) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-pinnacle-toledo",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Pinnacle Fertility - Toledo",
    "address": {
      "line1": "6711 Monroe St, Bldg 3, Suite A",
      "city": "Sylvania",
      "state": "OH",
      "zip": "43560",
      "country": "US"
    },
    "location": {
      "lat": 41.7143416,
      "lng": -83.7059283
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/toledo-oh/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/toledo-oh/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/toledo-oh/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.pinnaclefertility.com/location/toledo-oh/",
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/toledo-oh/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/toledo-oh/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/toledo-oh/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "network": {
      "name": "Pinnacle Fertility"
    },
    "team": [
      {
        "name": "F. Nicholas Shamma",
        "role": "Medical Director, Reproductive Endocrinologist & Infertility Specialist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/03/Dr.-F.-Nicholas-Shamma_MI.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-f-nicholas-shamma/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pinnacle-toledo-f-nicholas-shamma"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Ohio (OH) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-fertility-center-knoxville",
    "externalIds": {
      "googlePlaceId": "ChIJn-h3bwkvXIgR4VCAXVZ-hEU"
    },
    "type": "fertility-clinic",
    "name": "The Fertility Center - Knoxville",
    "address": {
      "line1": "10408 Jackson Oaks Way",
      "city": "Knoxville",
      "state": "TN",
      "zip": "37922",
      "country": "US"
    },
    "location": {
      "lat": 35.8992797,
      "lng": -84.126099
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.myfertilitycenter.com/contact/knoxville/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.myfertilitycenter.com/contact/knoxville/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.myfertilitycenter.com/contact/knoxville/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "website": "https://www.myfertilitycenter.com/contact/knoxville/",
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.myfertilitycenter.com/contact/knoxville/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.myfertilitycenter.com/contact/knoxville/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.myfertilitycenter.com/contact/knoxville/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/The+Fertility+Center:+Knoxville,+10408+Jackson+Oaks+Way,+Knoxville,+TN+37922/@35.8987572,-84.1266213,3232a,13.1y/data=!4m2!3m1!1s0x885c2f096f77e89f:0x45847e565d8050e1",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Barry W. Donesky",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.myfertilitycenter.com/wp-content/uploads/2024/10/BarryDonesky.ChattandKnox-1-1.jpg",
        "_source": {
          "url": "https://www.myfertilitycenter.com/who-we-are/doctors/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-fertility-center-knoxville-barry-w-donesky"
      },
      {
        "name": "Joseph S. Bird III",
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "imageUrl": "https://www.myfertilitycenter.com/wp-content/uploads/2024/10/JosephSBirdIII.ChattandKnox-1.jpg",
        "_source": {
          "url": "https://www.myfertilitycenter.com/who-we-are/doctors/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-fertility-center-knoxville-joseph-s-bird-iii"
      },
      {
        "name": "Kristen Clouse",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "CNP"],
        "imageUrl": "https://www.myfertilitycenter.com/wp-content/uploads/2024/10/KristenClouse.jpg",
        "_source": {
          "url": "https://www.myfertilitycenter.com/team_members/kristen-clouse/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-fertility-center-knoxville-kristen-clouse"
      }
    ],
    "images": [
      {
        "url": "https://www.myfertilitycenter.com/wp-content/uploads/2020/10/contact-location2.jpg",
        "type": "exterior",
        "caption": "Exterior of The Fertility Center Knoxville office building, showing the 'Jackson Oaks Way' signage matching the clinic's address at 10408 Jackson Oaks Way.",
        "_source": {
          "url": "https://www.myfertilitycenter.com/contact/knoxville/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk82b5ZSaOZf9zg5WLu2UpJeBpiRczsvQXtqFEsl-VK0dvIU8qW6Z8IbNWv7LPatWJLWguZFGJFnPGxB5T09roU1bCe27MEoY9SQOyXrwh-vAUabOMuHEctlaat0qDoIj0DR3I=w408-h422-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/The+Fertility+Center:+Knoxville,+10408+Jackson+Oaks+Way,+Knoxville,+TN+37922/@35.8987572,-84.1266213,3232a,13.1y/data=!4m2!3m1!1s0x885c2f096f77e89f:0x45847e565d8050e1",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmGrxGkrBcjlmmLNODu_PvPKyH3Is_CRTkm39KjTCS1xuizfOKB0mjvJWIdHalqG63M280ByrPiP_7srpXrsfCAXrShZ96EnXOXnvR9t2FVwAx0K1FGBL_A4OTQacgjs2tIb44YZQ=w483-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/The+Fertility+Center:+Knoxville,+10408+Jackson+Oaks+Way,+Knoxville,+TN+37922/@35.8987572,-84.1266213,3232a,13.1y/data=!4m2!3m1!1s0x885c2f096f77e89f:0x45847e565d8050e1",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Tennessee (TN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-pinnacle-wa-bellevue",
    "externalIds": {
      "googlePlaceId": "ChIJBWxJqcNskFQRyHJlRKMKUIE"
    },
    "type": "fertility-clinic",
    "name": "Pinnacle Fertility - Bellevue",
    "address": {
      "line1": "3055 112th Ave NE, Suite 201",
      "city": "Bellevue",
      "state": "WA",
      "zip": "98004",
      "country": "US"
    },
    "location": {
      "lat": 47.63838,
      "lng": -122.1956614
    },
    "setting": "network-group",
    "network": {
      "name": "Pinnacle Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.pinnaclefertility.com/location/bellevue-wa/",
    "phone": "(206) 301-5000",
    "email": "info@seattlefertility.com",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/bellevue-wa/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/bellevue-wa/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/bellevue-wa/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/bellevue-wa/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/bellevue-wa/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/bellevue-wa/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Pinnacle+Fertility+Washington-+Bellevue,+3055+112th+Ave+NE+Ste+201,+Bellevue,+WA+98004/@47.6379933,-122.1965145,2688a,13.1y/data=!4m2!3m1!1s0x54906cc3a9496c05:0x81500aa3446572c8",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Amy Criniti",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Amy-Criniti_WA_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-amy-criniti/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pinnacle-wa-bellevue-amy-criniti"
      },
      {
        "name": "Paul C. Lin",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Paul-Lin_WA_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/bellevue-wa/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pinnacle-wa-bellevue-paul-c-lin"
      },
      {
        "name": "Amanda K. Hurliman",
        "role": "Reproductive Endocrinologist, Medical Director",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Amanda-Hurliman_WA_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/bellevue-wa/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pinnacle-wa-bellevue-amanda-k-hurliman"
      },
      {
        "name": "Teagen Tibbot",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/02/Teagan-Tibbot-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/teagen-tibbot-pa-c/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pinnacle-wa-bellevue-teagen-tibbot"
      }
    ],
    "images": [
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/Bellevue-Main-Wait-Area.jpg",
        "type": "interior",
        "caption": "Main waiting area at Pinnacle Fertility Bellevue (formerly Seattle Reproductive Medicine)",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/bellevue-wa/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/Bellevue-Second-Wait-Area-scaled.jpg",
        "type": "interior",
        "caption": "Second waiting area at the Bellevue clinic",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/bellevue-wa/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/Bellevue-Front-Desk-scaled.jpg",
        "type": "interior",
        "caption": "Front desk / reception at the Bellevue clinic",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/bellevue-wa/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnxeZ89nXjf2dZ3gbU_WCeIgLx13eQ30MHKQChaWoQ4TRUfdrNl2h4aXIE5fX44wEeutMqdZlU3sHVvr66l414hz1hOUKCyPMhjIKAKWWa2kHSO_wYBWlX0yA7UZT8AeoM_n07c=w224-h398-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Pinnacle+Fertility+Washington-+Bellevue,+3055+112th+Ave+NE+Ste+201,+Bellevue,+WA+98004/@47.6379933,-122.1965145,2688a,13.1y/data=!4m2!3m1!1s0x54906cc3a9496c05:0x81500aa3446572c8",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlfhXC1g5FuKsCdYqlwF1yaQ-L8S60jbvzoabvqL3DaOgsKSM3z1LSCRrmiORW0DObE8lPhlipTd6f2-L4uIHFVh43IKGSq-S4-XjOcx2fXigk1XElbQ0SnbXM8ZwacUh-WUVo5fw=w224-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Pinnacle+Fertility+Washington-+Bellevue,+3055+112th+Ave+NE+Ste+201,+Bellevue,+WA+98004/@47.6379933,-122.1965145,2688a,13.1y/data=!4m2!3m1!1s0x54906cc3a9496c05:0x81500aa3446572c8",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Washington (WA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-pinnacle-wa-everett",
    "externalIds": {
      "googlePlaceId": "ChIJ-3s6Y9gHkFQR8gXSjvKGLFU"
    },
    "type": "fertility-clinic",
    "name": "Pinnacle Fertility - Everett",
    "address": {
      "line1": "728 134th Street SW, Suite 207",
      "city": "Everett",
      "state": "WA",
      "zip": "98204",
      "country": "US"
    },
    "location": {
      "lat": 47.8761276,
      "lng": -122.2432427
    },
    "setting": "network-group",
    "network": {
      "name": "Pinnacle Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.pinnaclefertility.com/location/everett-wa/",
    "phone": "(206) 301-5000",
    "email": "info@seattlefertility.com",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/everett-wa/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/everett-wa/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/everett-wa/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/everett-wa/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/everett-wa/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/everett-wa/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Pinnacle+Fertility+Washington-+Everett,+728+134th+St+SW+Unit+207,+Everett,+WA+98204/@47.8761247,-122.2431786,2676a,13.1y/data=!4m2!3m1!1s0x549007d8633a7bfb:0x552c86f28ed205f2",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Kaitlyn Wald",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/03/Dr.-Kaitlyn-Wald_WA.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-kaitlyn-wald/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pinnacle-wa-everett-kaitlyn-wald"
      },
      {
        "name": "Meghan M. McKeever",
        "role": "Obstetrics and Gynecology (OB/GYN)",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Meg-McKeever_WA_Square-2048x2048.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-meghan-m-mckeever/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pinnacle-wa-everett-meghan-m-mckeever"
      }
    ],
    "images": [
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/Everett-Wait-Area-toward-FD.jpg",
        "type": "interior",
        "caption": "Waiting area looking toward the front desk at Pinnacle Fertility - Everett",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/everett-wa/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/Everett-Wait-Area-1.jpg",
        "type": "interior",
        "caption": "Patient waiting area at Pinnacle Fertility - Everett",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/everett-wa/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/Everett-Wait-Area-2.jpg",
        "type": "interior",
        "caption": "Patient waiting area (alternate view) at Pinnacle Fertility - Everett",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/everett-wa/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlb0np_xCe1qdqozSCgEze7Q23PX_klzVzaCx5Vav59HPb1ipyXPc94DxC_l9BogJjSVZ-W3_WlVjyviRN8LCqOygTwe16dO-Bi71KUaV3apwOHvDzw5jlB6t88xYTjwe2po72u=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Pinnacle+Fertility+Washington-+Everett,+728+134th+St+SW+Unit+207,+Everett,+WA+98204/@47.8761247,-122.2431786,2676a,13.1y/data=!4m2!3m1!1s0x549007d8633a7bfb:0x552c86f28ed205f2",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmT-nZhuwNGpipwZercl03V_SemW1qNtDOKFjRwXxZcgJKeuCu0s6B1IC4JrP8ZzWU9yoAY2T-DIokk8-F1jD7lL6hv8wuEDCcTiE9JeA4C4KeXomoB-566pigRi-W_VYBNwQa2=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Pinnacle+Fertility+Washington-+Everett,+728+134th+St+SW+Unit+207,+Everett,+WA+98204/@47.8761247,-122.2431786,2676a,13.1y/data=!4m2!3m1!1s0x549007d8633a7bfb:0x552c86f28ed205f2",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Washington (WA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-pinnacle-wa-kirkland",
    "externalIds": {
      "googlePlaceId": "ChIJk63bNYUNkFQRSedv5c0GEG0"
    },
    "type": "fertility-clinic",
    "name": "Pinnacle Fertility - Kirkland",
    "address": {
      "line1": "12333 NE 130th Lane, Suite 220",
      "city": "Kirkland",
      "state": "WA",
      "zip": "98034",
      "country": "US"
    },
    "location": {
      "lat": 47.7160356,
      "lng": -122.176432
    },
    "setting": "network-group",
    "network": {
      "name": "Pinnacle Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.pinnaclefertility.com/location/kirkland-wa/",
    "phone": "(206) 301-5000",
    "email": "info@seattlefertility.com",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/kirkland-wa/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/kirkland-wa/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/kirkland-wa/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/kirkland-wa/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/kirkland-wa/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/kirkland-wa/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Pinnacle+Fertility+Washington+-+Kirkland,+12333+NE+130th+Ln+Ste+220,+Kirkland,+WA+98034/@47.7161169,-122.1765109,2684a,13.1y/data=!4m2!3m1!1s0x54900d8535dbad93:0x6d1006cde56fe749",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Akhil B. Shah",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Akhil-Shah_WA_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-akhil-b-shah/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pinnacle-wa-kirkland-akhil-b-shah"
      },
      {
        "name": "Kevin A. Ostrowski",
        "role": "Urologist (Male Fertility Specialist)",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Kevin-Ostrowski_WA_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-kevin-a-ostrowski/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pinnacle-wa-kirkland-kevin-a-ostrowski"
      },
      {
        "name": "Michele J. Cho",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Michele-Cho_WA_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-michele-j-cho/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pinnacle-wa-kirkland-michele-j-cho"
      },
      {
        "name": "Teagen Tibbot",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/02/Teagan-Tibbot-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/teagen-tibbot-pa-c/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pinnacle-wa-kirkland-teagen-tibbot"
      }
    ],
    "images": [
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/Kirkland-Wait-Area-2-2048x1536.jpg",
        "type": "interior",
        "caption": "Waiting room at Pinnacle Fertility - Kirkland (Seattle Reproductive Medicine), with seating, artwork, and a Pinnacle Fertility branding banner.",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/kirkland-wa/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Washington (WA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-pinnacle-wa-tricities",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Pinnacle Fertility - Tri-Cities",
    "address": {
      "line1": "945 Goethals Drive, Suite 210",
      "city": "Richland",
      "state": "WA",
      "zip": "99352",
      "country": "US"
    },
    "location": {
      "lat": 46.2793494,
      "lng": -119.2798481
    },
    "setting": "network-group",
    "network": {
      "name": "Pinnacle Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.pinnaclefertility.com/location/tri-cities/",
    "phone": "(509) 940-2310",
    "email": "info@seattlefertility.com",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/tri-cities/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/tri-cities/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Preservation",
        "category": "preservation",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/tri-cities/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/tri-cities/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/tri-cities/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/tri-cities/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Brenda S. Houmard",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD", "PhD", "FACOG"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Brenda-Houmard_WA_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-brenda-s-houmard/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pinnacle-wa-tricities-brenda-s-houmard"
      },
      {
        "name": "Justine K. Fluharty",
        "role": "Physician Assistant",
        "credentials": ["PA-C", "MMSc"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/11/Justine.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/justine-k-fluharty-pa-c/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pinnacle-wa-tricities-justine-k-fluharty"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Washington (WA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-pinnacle-wa-tacoma",
    "externalIds": {
      "googlePlaceId": "ChIJZaDiZUhVkFQRcyJS3ixRwCo"
    },
    "type": "fertility-clinic",
    "name": "Pinnacle Fertility - Tacoma",
    "address": {
      "line1": "3209 S 23rd Street, Suite 350",
      "city": "Tacoma",
      "state": "WA",
      "zip": "98405",
      "country": "US"
    },
    "location": {
      "lat": 47.2380661,
      "lng": -122.4778246
    },
    "setting": "network-group",
    "network": {
      "name": "Pinnacle Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.pinnaclefertility.com/location/tacoma-wa/",
    "phone": "(206) 301-5000",
    "email": "info@seattlefertility.com",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/tacoma-wa/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/tacoma-wa/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/tacoma-wa/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/tacoma-wa/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/tacoma-wa/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/tacoma-wa/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Pinnacle+Fertility+Washington+-+Tacoma,+3209+S+23rd+St+Ste+350,+Tacoma,+WA+98405/@47.2380637,-122.4778507,2709a,13.1y/data=!4m2!3m1!1s0x5490554865e2a065:0x2ac0512cde522273",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Nichole M. Barker",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["DO", "FACOOG"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Nichole-Barker_WA_Square-2048x2048.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-nichole-m-barker/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pinnacle-wa-tacoma-nichole-m-barker"
      },
      {
        "name": "Erik Mazur",
        "role": "Reproductive Endocrinologist and Infertility Specialist",
        "credentials": ["MD", "MS"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Erik-Mazur_WA_Square-2048x2048.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/physicians/dr-erik-mazur/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pinnacle-wa-tacoma-erik-mazur"
      }
    ],
    "images": [
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/Tacoma-main-wait-area-2048x1536.jpeg",
        "type": "interior",
        "caption": "Main waiting area at Pinnacle Fertility - Tacoma (formerly Seattle Reproductive Medicine), 3209 S 23rd Street, Suite 350",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/tacoma-wa/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWknEFss-3AXFPmd2Yl1xt4-YKAEGdX8EDGERujj6ggO_XDEuhv-WEuoOK0C-hVhwVeGPJX0HEif53qh6PRinG79ogbLt9astX5T2zA3zVIW7BsurW37XC0ng_p5_iiILQyq5oN6=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Pinnacle+Fertility+Washington+-+Tacoma,+3209+S+23rd+St+Ste+350,+Tacoma,+WA+98405/@47.2380637,-122.4778507,2709a,13.1y/data=!4m2!3m1!1s0x5490554865e2a065:0x2ac0512cde522273",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Washington (WA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-pnwf-bellevue",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Pacific Northwest Fertility - Bellevue",
    "address": {
      "line1": "1231 116th Ave NE, Suite 750",
      "city": "Bellevue",
      "state": "WA",
      "zip": "98004",
      "country": "US"
    },
    "location": {
      "lat": 47.6209064,
      "lng": -122.1859767
    },
    "setting": "network-group",
    "network": {
      "name": "Ivy Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://pnwfertility.com/locations/our-bellevue-clinic",
    "phone": "(206) 515-0000",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://pnwfertility.com/locations/our-bellevue-clinic",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://pnwfertility.com/locations/our-bellevue-clinic",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://pnwfertility.com/locations/our-bellevue-clinic",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://pnwfertility.com/locations/our-bellevue-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://pnwfertility.com/locations/our-bellevue-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://pnwfertility.com/locations/our-bellevue-clinic",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Julie Lamb",
        "role": "Medical Director, Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://a.storyblok.com/f/290132/1600x2000/c5d6caa0d4/julie-lamb.png",
        "_source": {
          "url": "https://pnwfertility.com/locations/our-bellevue-clinic",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pnwf-bellevue-julie-lamb"
      },
      {
        "name": "Lora Shahine",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://a.storyblok.com/f/290132/1600x2000/ea1012b29b/lora-shahine.png",
        "_source": {
          "url": "https://pnwfertility.com/locations/our-bellevue-clinic",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pnwf-bellevue-lora-shahine"
      },
      {
        "name": "Darcy Broughton",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://a.storyblok.com/f/290132/1600x2000/9d0073819e/darcy-broughton.png",
        "_source": {
          "url": "https://pnwfertility.com/locations/our-bellevue-clinic",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pnwf-bellevue-darcy-broughton"
      },
      {
        "name": "Stephanie Rothenberg",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://a.storyblok.com/f/290132/1600x2000/f479bdbf10/stephanie-rothenberg.png",
        "_source": {
          "url": "https://pnwfertility.com/locations/our-bellevue-clinic",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pnwf-bellevue-stephanie-rothenberg"
      },
      {
        "name": "Diana Zhou",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://a.storyblok.com/f/290132/1600x2000/b5709cc4f1/diana-zhou.png",
        "_source": {
          "url": "https://pnwfertility.com/locations/our-bellevue-clinic",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pnwf-bellevue-diana-zhou"
      },
      {
        "name": "Jamie Massie",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://a.storyblok.com/f/290132/1600x2000/89c7ed5773/jamie-massie.png",
        "_source": {
          "url": "https://pnwfertility.com/locations/our-bellevue-clinic",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pnwf-bellevue-jamie-massie"
      },
      {
        "name": "Hanh Nguyen Cottrell",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://a.storyblok.com/f/290132/1600x2000/fc33f19e96/hanh-cottrell.png",
        "_source": {
          "url": "https://pnwfertility.com/locations/our-bellevue-clinic",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pnwf-bellevue-hanh-nguyen-cottrell"
      },
      {
        "name": "Shannel Adams",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://a.storyblok.com/f/290132/1600x2000/f7e4e19b5c/shannel-adams.png",
        "_source": {
          "url": "https://pnwfertility.com/locations/our-bellevue-clinic",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pnwf-bellevue-shannel-adams"
      },
      {
        "name": "Shelun Tsai",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://a.storyblok.com/f/290132/1600x2000/44dbb30537/shelun-tsai.png",
        "_source": {
          "url": "https://pnwfertility.com/locations/our-bellevue-clinic",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pnwf-bellevue-shelun-tsai"
      },
      {
        "name": "Lauren Verrilli",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://a.storyblok.com/f/290132/4476x3620/dc154e6edf/lauren-verrilli_003_hp_march-15-2022.jpg",
        "_source": {
          "url": "https://pnwfertility.com/locations/our-bellevue-clinic",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-pnwf-bellevue-lauren-verrilli"
      }
    ],
    "images": [
      {
        "url": "https://a.storyblok.com/f/290132/5913x3942/e950d66f04/pnwf_bellevue_007.jpg",
        "type": "interior",
        "caption": "Waiting and reception lounge inside Pacific Northwest Fertility's Bellevue clinic at the Overlake Medical Pavilion, Suite 750, with floor-to-ceiling windows overlooking the Bellevue skyline.",
        "_source": {
          "url": "https://pnwfertility.com/locations/our-bellevue-clinic",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Washington (WA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-poma-bellingham",
    "externalIds": {
      "googlePlaceId": "ChIJEdpg70yjhVQRsgE3-3ZHPYs"
    },
    "type": "fertility-clinic",
    "name": "POMA Fertility - Bellingham",
    "address": {
      "line1": "1050 Larrabee Ave, Suite 102",
      "city": "Bellingham",
      "state": "WA",
      "zip": "98225",
      "country": "US"
    },
    "location": {
      "lat": 48.718134,
      "lng": -122.503401
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.pomafertility.com/",
    "phone": "(425) 822-7662",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.pomafertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.pomafertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.pomafertility.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.pomafertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.pomafertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pomafertility.com/our-team",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/POMA+Fertility,+1050+Larrabee+Ave+STE+102,+Bellingham,+WA+98225/@48.7182155,-122.5036808,2632a,13.1y/data=!4m2!3m1!1s0x5485a34cef60da11:0x8b3d4776fb3701b2",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Dr. Michael Opsahl",
        "role": "Reproductive Endocrinologist (Co-Founder)",
        "credentials": ["MD", "Board Certified OBGYN", "Board Certified REI"],
        "imageUrl": "https://cdn.prod.website-files.com/6408c7175280297ba7c2e0a5/6424002bc7720b3324c84dd2_OPSAHL-large.webp",
        "_source": {
          "url": "https://www.pomafertility.com/team-members/dr-michael-opsahl-md",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-poma-bellingham-dr-michael-opsahl"
      },
      {
        "name": "Dr. Ronald Beesley",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.prod.website-files.com/6408c7175280297ba7c2e0a5/6424001dc7720b1690c84d9b_Ronald%20Beesley-large.webp",
        "_source": {
          "url": "https://www.pomafertility.com/team-members/dr-ronald-beesley-md",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-poma-bellingham-dr-ronald-beesley"
      },
      {
        "name": "Dr. Audrey Messelt",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.prod.website-files.com/6408c7175280297ba7c2e0a5/68f5d43622f4adba68c9be52_Audrey%20Messelt.webp",
        "_source": {
          "url": "https://www.pomafertility.com/team-members/audrey-messelt-md",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-poma-bellingham-dr-audrey-messelt"
      },
      {
        "name": "Anne Judge",
        "role": "Nurse Practitioner",
        "credentials": ["DNP", "WHNP-BC", "ARNP"],
        "imageUrl": "https://cdn.prod.website-files.com/6408c7175280297ba7c2e0a5/686e11ab160f761a66ad6a97_Anne%20Judge%20DNP%20WHNP-BC%20ARNP_POMA%20Fertility_Kirkland%20WA_Nurse%20Practitioner-removebg-preview.jpg",
        "_source": {
          "url": "https://www.pomafertility.com/team-members/anne-judge-dnp-whnp-bc-arnp",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-poma-bellingham-anne-judge"
      },
      {
        "name": "Megan Palazzola",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://cdn.prod.website-files.com/6408c7175280297ba7c2e0a5/642400053901ac692668edec_Megan%20Palazzola-large.webp",
        "_source": {
          "url": "https://www.pomafertility.com/team-members/megan-palazzola-pac",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-poma-bellingham-megan-palazzola"
      },
      {
        "name": "Dr. Carol Lynn Curchoe",
        "role": "Laboratory Director",
        "credentials": ["PhD", "HCLD (ABB)"],
        "imageUrl": "https://cdn.prod.website-files.com/6408c7175280297ba7c2e0a5/6880c750856775e245502066_Dr_Carol_Lynn_Curchoe_PhD_HCLD_POMA_Fertility_Kirkland_WA_Laboratory_Director-removebg-preview.png",
        "_source": {
          "url": "https://www.pomafertility.com/team-members/dr-carol-lynn-curchoe-phd-hcld-abb",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-poma-bellingham-dr-carol-lynn-curchoe"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Washington (WA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkjTblTaxKAZ2-SFpd823GhUNDnV0gtLFHDLL6lB4LKk_QAAB9lHqBBlTknk7iIel3yV5OtyON1txLGTA8Mhm2Ah33w6cF1xloBpaQBcLsTZj5FmKlsJtE_QvBOyM7kN9WqIEA6SQ=w224-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/POMA+Fertility,+1050+Larrabee+Ave+STE+102,+Bellingham,+WA+98225/@48.7182155,-122.5036808,2632a,13.1y/data=!4m2!3m1!1s0x5485a34cef60da11:0x8b3d4776fb3701b2",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-first-steps-edmonds",
    "externalIds": {},
    "type": "medical-practice",
    "name": "First Steps Fertility & Women's Health",
    "address": {
      "line1": "111 Sunset Avenue North, Suite 201",
      "city": "Edmonds",
      "state": "WA",
      "zip": "98020",
      "country": "US"
    },
    "location": {
      "lat": 47.8127034,
      "lng": -122.3819768
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "website": "https://firststepswhc.com/",
    "phone": "(206) 900-6220",
    "email": "eliza.martin@firststepswhc.com",
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://firststepswhc.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://firststepswhc.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF Monitoring",
        "category": "diagnostic",
        "_source": {
          "url": "https://firststepswhc.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://firststepswhc.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://firststepswhc.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://firststepswhc.com/about/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Eliza Martin",
        "role": "Nurse Practitioner & Owner",
        "credentials": ["ARNP"],
        "imageUrl": "https://firststepswhc.com/wp-content/uploads/2021/07/Headshot1_edited.jpg",
        "_source": {
          "url": "https://firststepswhc.com/about/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-first-steps-edmonds-eliza-martin"
      },
      {
        "name": "Rocky Mazzeo",
        "role": "Laboratory Director",
        "credentials": ["MD"],
        "imageUrl": "https://firststepswhc.com/wp-content/uploads/2021/06/final-951393_edited.jpg",
        "_source": {
          "url": "https://firststepswhc.com/about/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-first-steps-edmonds-rocky-mazzeo"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Washington (WA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-pinnacle-stockbridge",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Pinnacle Fertility - Stockbridge",
    "address": {
      "line1": "1060 Eagles Landing Parkway, Suite 240",
      "city": "Stockbridge",
      "state": "GA",
      "zip": "30281",
      "country": "US"
    },
    "location": {
      "lat": 33.5116206,
      "lng": -84.222364
    },
    "setting": "network-group",
    "network": {
      "name": "Pinnacle Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.pinnaclefertility.com/location/stockbridge-ga/",
    "phone": "(470) 592-5519",
    "email": "helloatl@pinnaclefertility.com",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/stockbridge-ga/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/stockbridge-ga/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/stockbridge-ga/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/stockbridge-ga/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/stockbridge-ga/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/stockbridge-ga/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Paul Dudley, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/01/1-Dr.-Paul-Dudley_GA_Square-1024x1024.png",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/stockbridge-ga/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-pinnacle-stockbridge-paul-dudley-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-coastal-fertility-savannah",
    "externalIds": {
      "googlePlaceId": "ChIJs1UHzEB1-4gRMuxLgkaiZnM"
    },
    "type": "fertility-clinic",
    "name": "Coastal Fertility Specialists - Savannah",
    "address": {
      "line1": "9100 White Bluff Road, Suite 201",
      "city": "Savannah",
      "state": "GA",
      "zip": "31406",
      "country": "US"
    },
    "location": {
      "lat": 31.9960396,
      "lng": -81.1247658
    },
    "setting": "network-group",
    "network": {
      "name": "Coastal Fertility Specialists"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.coastalfertilityspecialists.com/locations/savannah/",
    "phone": "(912) 421-1285",
    "treatments": [
      {
        "name": "IVF Monitoring",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.coastalfertilityspecialists.com/locations/savannah/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://www.coastalfertilityspecialists.com/locations/savannah/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Semen Analysis",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.coastalfertilityspecialists.com/locations/savannah/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.coastalfertilityspecialists.com/locations/savannah/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.coastalfertilityspecialists.com/locations/savannah/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Coastal+Fertility+Specialists,+9100+White+Bluff+Rd+Ste+201,+Savannah,+GA+31406/@31.9947478,-81.1260278,3384a,13.1y/data=!4m2!3m1!1s0x88fb7540cc0755b3:0x7366a246824bec32",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkGg9-niOIyC4pppthLkwSZK0Ch2bUs-crV80YKFWqKNtlFvHHTjYB1aJrfPFNvzG_BPmEriNDptuFESXaJU7-FGGc-CRp3Ltu0k1c7z5RqA9_kfIxIH4li5EA-RLzU7SN4PnMrbZ3Yv83m=w721-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Coastal+Fertility+Specialists,+9100+White+Bluff+Rd+Ste+201,+Savannah,+GA+31406/@31.9947478,-81.1260278,3384a,13.1y/data=!4m2!3m1!1s0x88fb7540cc0755b3:0x7366a246824bec32",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnRJ5EsFmF4Cy8eYIx1CDmPWnYp4e-lF0PLsWtnKhwbvBJ6KmdYJA4ZORLeN0jfimn9M5j_hFG6u3i3ApApQEQnGH3blKiQtcPFa16Vl-Uc9YPCgrWumJ-11JV_gCpHAH_aZwpSAMCn4C8=w449-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Coastal+Fertility+Specialists,+9100+White+Bluff+Rd+Ste+201,+Savannah,+GA+31406/@31.9947478,-81.1260278,3384a,13.1y/data=!4m2!3m1!1s0x88fb7540cc0755b3:0x7366a246824bec32",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-atrium-navicent-fertility-macon",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Atrium Health Navicent Women's Care Fertility and Reproductive Medicine",
    "address": {
      "line1": "4075 Elnora Drive",
      "city": "Macon",
      "state": "GA",
      "zip": "31210",
      "country": "US"
    },
    "location": {
      "lat": 32.8985935,
      "lng": -83.6932215
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "website": "https://navicenthealth.org/service-center/women-s-services-navicent-health/fertility-and-reproductive-medicine-macon",
    "phone": "(478) 757-7888",
    "treatments": [
      {
        "name": "Fertility Cycle Monitoring",
        "category": "diagnostic",
        "_source": {
          "url": "https://navicenthealth.org/service-center/women-s-services-navicent-health/fertility-and-reproductive-medicine-macon",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Semen Analysis",
        "category": "diagnostic",
        "_source": {
          "url": "https://navicenthealth.org/service-center/women-s-services-navicent-health/fertility-and-reproductive-medicine-macon",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://navicenthealth.org/service-center/women-s-services-navicent-health/fertility-and-reproductive-medicine-macon",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://navicenthealth.org/service-center/women-s-services-navicent-health/fertility-and-reproductive-medicine-macon",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://navicenthealth.org/service-center/women-s-services-navicent-health/fertility-and-reproductive-medicine-macon",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-athens-obgyn-fertility",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Athens ObGyn Fertility Management",
    "address": {
      "line1": "658 North Chase Street, Suite 301",
      "city": "Athens",
      "state": "GA",
      "zip": "30601",
      "country": "US"
    },
    "location": {
      "lat": 33.9630991,
      "lng": -83.3929375
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "website": "https://www.athensobgyn.com/services/fertility-management",
    "phone": "(706) 548-4272",
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.athensobgyn.com/services/fertility-management",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://www.athensobgyn.com/services/fertility-management",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Evaluation",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.athensobgyn.com/services/fertility-management",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.athensobgyn.com/services/fertility-management",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.athensobgyn.com/services/fertility-management",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.athensobgyn.com/providers",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Ruth Cline, MD, FACOG",
        "role": "Physician",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://storage.googleapis.com/treatspace-prod-media/thumb/u-61751/thumb_0.png",
        "_source": {
          "url": "https://www.athensobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-athens-obgyn-fertility-ruth-cline-md-facog"
      },
      {
        "name": "Meredith Bolton, MD, FACOG",
        "role": "Physician",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://storage.googleapis.com/treatspace-prod-media/thumb/u-61659/thumb_0.png",
        "_source": {
          "url": "https://www.athensobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-athens-obgyn-fertility-meredith-bolton-md-facog"
      },
      {
        "name": "Cristina Elstad, MD, FACOG",
        "role": "Physician",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://storage.googleapis.com/treatspace-prod-media/thumb/u-61752/thumb_0.png",
        "_source": {
          "url": "https://www.athensobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-athens-obgyn-fertility-cristina-elstad-md-facog"
      },
      {
        "name": "Andrew Herrin, MD, FACOG",
        "role": "Physician",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://storage.googleapis.com/treatspace-prod-media/thumb/u-61754/thumb_0.png",
        "_source": {
          "url": "https://www.athensobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-athens-obgyn-fertility-andrew-herrin-md-facog"
      },
      {
        "name": "Rachel Murthy, MD, FACOG",
        "role": "Physician",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://storage.googleapis.com/treatspace-prod-media/thumb/u-61755/thumb_0.png",
        "_source": {
          "url": "https://www.athensobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-athens-obgyn-fertility-rachel-murthy-md-facog"
      },
      {
        "name": "Katie Sells, NP",
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "imageUrl": "https://storage.googleapis.com/treatspace-prod-media/thumb/u-61756/thumb_0.png",
        "_source": {
          "url": "https://www.athensobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-athens-obgyn-fertility-katie-sells-np"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-womens-healthcare-associates-athens",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Women's Healthcare Associates - Athens",
    "address": {
      "line1": "355 Hawthorne Lane",
      "city": "Athens",
      "state": "GA",
      "zip": "30606",
      "country": "US"
    },
    "location": {
      "lat": 33.9686703,
      "lng": -83.4163411
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "website": "https://www.womenshealthcareassociates.com/patient/infertility",
    "phone": "(706) 369-0019",
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.womenshealthcareassociates.com/patient/infertility",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://www.womenshealthcareassociates.com/patient/infertility",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.womenshealthcareassociates.com/patient/infertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.womenshealthcareassociates.com/patient/infertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.womenshealthcareassociates.com/office/meet-our-providers",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Andrew Leach, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://www.womenshealthcareassociates.com/ResourceFiles/other/andrew-leach.png",
        "_source": {
          "url": "https://www.womenshealthcareassociates.com/office/meet-our-providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-healthcare-associates-athens-andrew-leach-md"
      },
      {
        "name": "Stephanie Allen, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://www.womenshealthcareassociates.com/ResourceFiles/other/stephanie-allen.jpg",
        "_source": {
          "url": "https://www.womenshealthcareassociates.com/office/meet-our-providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-healthcare-associates-athens-stephanie-allen-md"
      },
      {
        "name": "Leah D. Lowman, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://www.womenshealthcareassociates.com/ResourceFiles/other/leah-d-lowman.png",
        "_source": {
          "url": "https://www.womenshealthcareassociates.com/office/meet-our-providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-healthcare-associates-athens-leah-d-lowman-md"
      },
      {
        "name": "Lara Hart, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://www.womenshealthcareassociates.com/ResourceFiles/other/lara-hart.jpg",
        "_source": {
          "url": "https://www.womenshealthcareassociates.com/office/meet-our-providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-healthcare-associates-athens-lara-hart-md"
      },
      {
        "name": "Hannah Childs, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://www.womenshealthcareassociates.com/ResourceFiles/other/hannah-childs.jpg",
        "_source": {
          "url": "https://www.womenshealthcareassociates.com/office/meet-our-providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-healthcare-associates-athens-hannah-childs-md"
      },
      {
        "name": "Rebecca Keipper, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://www.womenshealthcareassociates.com/resourcefiles/other/rkeipper.jpg",
        "_source": {
          "url": "https://www.womenshealthcareassociates.com/office/meet-our-providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-healthcare-associates-athens-rebecca-keipper-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-womens-center-athens",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Women's Center of Athens",
    "address": {
      "line1": "1181 Langford Drive, Bldg 300, Suite 101",
      "city": "Watkinsville",
      "state": "GA",
      "zip": "30677",
      "country": "US"
    },
    "location": {
      "lat": 33.9162787,
      "lng": -83.4707424
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "website": "https://womenscenterofathens.com/infertility-evaluation-and-treatment/",
    "phone": "(706) 227-8999",
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://womenscenterofathens.com/infertility-evaluation-and-treatment/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Infertility Evaluation",
        "category": "diagnostic",
        "_source": {
          "url": "https://womenscenterofathens.com/infertility-evaluation-and-treatment/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://womenscenterofathens.com/infertility-evaluation-and-treatment/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://womenscenterofathens.com/infertility-evaluation-and-treatment/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://womenscenterofathens.com/our-providers/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Melissa Anderson, MD, FACOG",
        "role": "Physician",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://womenscenterofathens.com/wp-content/uploads/2024/07/WomensCenterOfAthens-9_websize.jpg",
        "_source": {
          "url": "https://womenscenterofathens.com/dr-melissa-anderson/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-center-athens-melissa-anderson-md-facog"
      },
      {
        "name": "Melissa Halbach, MD, FACOG",
        "role": "Physician",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://womenscenterofathens.com/wp-content/uploads/2024/07/WomensCenterOfAthens-65_websize.jpg",
        "_source": {
          "url": "https://womenscenterofathens.com/dr-melissa-halbach/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-center-athens-melissa-halbach-md-facog"
      },
      {
        "name": "Camille McPherson, MD, FACOG",
        "role": "Physician",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://womenscenterofathens.com/wp-content/uploads/2024/07/WomensCenterOfAthens-26_websize.jpg",
        "_source": {
          "url": "https://womenscenterofathens.com/dr-camille-mcpherson/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-center-athens-camille-mcpherson-md-facog"
      },
      {
        "name": "Natalie Romines, MSN, CNP",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "CNP"],
        "imageUrl": "https://womenscenterofathens.com/wp-content/uploads/2024/07/WomensCenter-8_websize-1.jpg",
        "_source": {
          "url": "https://womenscenterofathens.com/natalie-romines/",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Women's Health",
        "practitionerId": "pr-org-web-womens-center-athens-natalie-romines-msn-cnp"
      }
    ],
    "images": [
      {
        "url": "https://womenscenterofathens.com/wp-content/uploads/2024/05/WomensCenterOfAthens-100_websize.jpg",
        "type": "exterior",
        "caption": "Women's Center of Athens office exterior",
        "_source": {
          "url": "https://womenscenterofathens.com/contact-obgyn-athens/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://womenscenterofathens.com/wp-content/uploads/2024/05/WomensCenterOfAthens-99_websize.jpg",
        "type": "exterior",
        "caption": "Women's Center of Athens office entrance",
        "_source": {
          "url": "https://womenscenterofathens.com/contact-obgyn-athens/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-womens-specialists-fayette-fayetteville",
    "externalIds": {},
    "type": "medical-practice",
    "name": "The Women's Specialists of Fayette - Fayetteville",
    "address": {
      "line1": "1267 Highway 54 West, Suite 3200",
      "city": "Fayetteville",
      "state": "GA",
      "zip": "30214",
      "country": "US"
    },
    "location": {
      "lat": 33.4510508,
      "lng": -84.5071211
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "website": "https://www.wsfayette.com/services/infertility",
    "phone": "(770) 632-9900",
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.wsfayette.com/services/infertility",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://www.wsfayette.com/services/infertility",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.wsfayette.com/services/infertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.wsfayette.com/services/infertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.wsfayette.com/provider",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Marlo Carter, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/d28274fefd239aa543e99c81dbe355b62fd6f4d5/images/2583122.jpg",
        "_source": {
          "url": "https://www.wsfayette.com/provider",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-specialists-fayette-fayetteville-marlo-carter-md"
      },
      {
        "name": "Matthew Ralsten, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/d28274fefd239aa543e99c81dbe355b62fd6f4d5/images/2583124.jpg",
        "_source": {
          "url": "https://www.wsfayette.com/provider",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-specialists-fayette-fayetteville-matthew-ralsten-md"
      },
      {
        "name": "Nicole Quinn, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/d28274fefd239aa543e99c81dbe355b62fd6f4d5/images/2583126.jpg",
        "_source": {
          "url": "https://www.wsfayette.com/provider",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-specialists-fayette-fayetteville-nicole-quinn-md"
      },
      {
        "name": "Nykia Burke-Bray, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/d28274fefd239aa543e99c81dbe355b62fd6f4d5/images/2636404.jpg",
        "_source": {
          "url": "https://www.wsfayette.com/provider",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-specialists-fayette-fayetteville-nykia-burke-bray-md"
      },
      {
        "name": "Sarah Grace White, DO",
        "role": "Physician",
        "credentials": ["DO"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/d28274fefd239aa543e99c81dbe355b62fd6f4d5/images/2769520.jpg",
        "_source": {
          "url": "https://www.wsfayette.com/provider",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-specialists-fayette-fayetteville-sarah-grace-white-do"
      },
      {
        "name": "Deidra Printup, FNP-C",
        "role": "Nurse Practitioner",
        "credentials": ["FNP-C"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/d28274fefd239aa543e99c81dbe355b62fd6f4d5/images/2803783.jpg",
        "_source": {
          "url": "https://www.wsfayette.com/provider",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Women's Health",
        "practitionerId": "pr-org-web-womens-specialists-fayette-fayetteville-deidra-printup-fnp-c"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-womens-specialists-fayette-peachtree-city",
    "externalIds": {},
    "type": "medical-practice",
    "name": "The Women's Specialists of Fayette - Peachtree City",
    "address": {
      "line1": "403 Westpark Court, Suite 205",
      "city": "Peachtree City",
      "state": "GA",
      "zip": "30269",
      "country": "US"
    },
    "location": {
      "lat": 33.4009117,
      "lng": -84.589764
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "website": "https://www.wsfayette.com/services/infertility",
    "phone": "(770) 632-9900",
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.wsfayette.com/services/infertility",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://www.wsfayette.com/services/infertility",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.wsfayette.com/services/infertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.wsfayette.com/services/infertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.wsfayette.com/provider",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Marlo Carter, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/d28274fefd239aa543e99c81dbe355b62fd6f4d5/images/2583122.jpg",
        "_source": {
          "url": "https://www.wsfayette.com/provider",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-specialists-fayette-peachtree-city-marlo-carter-md"
      },
      {
        "name": "Matthew Ralsten, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/d28274fefd239aa543e99c81dbe355b62fd6f4d5/images/2583124.jpg",
        "_source": {
          "url": "https://www.wsfayette.com/provider",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-specialists-fayette-peachtree-city-matthew-ralsten-md"
      },
      {
        "name": "Nicole Quinn, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/d28274fefd239aa543e99c81dbe355b62fd6f4d5/images/2583126.jpg",
        "_source": {
          "url": "https://www.wsfayette.com/provider",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-specialists-fayette-peachtree-city-nicole-quinn-md"
      },
      {
        "name": "Nykia Burke-Bray, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/d28274fefd239aa543e99c81dbe355b62fd6f4d5/images/2636404.jpg",
        "_source": {
          "url": "https://www.wsfayette.com/provider",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-specialists-fayette-peachtree-city-nykia-burke-bray-md"
      },
      {
        "name": "Sarah Grace White, DO",
        "role": "Physician",
        "credentials": ["DO"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/d28274fefd239aa543e99c81dbe355b62fd6f4d5/images/2769520.jpg",
        "_source": {
          "url": "https://www.wsfayette.com/provider",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-specialists-fayette-peachtree-city-sarah-grace-white-do"
      },
      {
        "name": "Deidra Printup, FNP-C",
        "role": "Nurse Practitioner",
        "credentials": ["FNP-C"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/d28274fefd239aa543e99c81dbe355b62fd6f4d5/images/2803783.jpg",
        "_source": {
          "url": "https://www.wsfayette.com/provider",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Women's Health",
        "practitionerId": "pr-org-web-womens-specialists-fayette-peachtree-city-deidra-printup-fnp-c"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-womens-center-pc-stockbridge",
    "externalIds": {},
    "type": "medical-practice",
    "name": "The Women's Center, PC - Stockbridge",
    "address": {
      "line1": "140 Eagle Spring Court",
      "city": "Stockbridge",
      "state": "GA",
      "zip": "30281",
      "country": "US"
    },
    "location": {
      "lat": 33.5094295,
      "lng": -84.2277461
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "website": "https://www.womenscenterga.com/services/infertility",
    "phone": "(770) 302-0878",
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.womenscenterga.com/services/infertility",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Medication",
        "category": "art",
        "_source": {
          "url": "https://www.womenscenterga.com/services/infertility",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.womenscenterga.com/services/infertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.womenscenterga.com/services/infertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.womenscenterga.com/provider",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Stephanie Gordon, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/59d1490195710a2a052419de3324f1957f2573be/images/2276935.jpg",
        "_source": {
          "url": "https://www.womenscenterga.com/provider",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-center-pc-stockbridge-stephanie-gordon-md"
      },
      {
        "name": "Trent Rice, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/59d1490195710a2a052419de3324f1957f2573be/images/2724037.jpg",
        "_source": {
          "url": "https://www.womenscenterga.com/provider",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-center-pc-stockbridge-trent-rice-md"
      },
      {
        "name": "Sharon Hodges, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/59d1490195710a2a052419de3324f1957f2573be/images/2724048.jpg",
        "_source": {
          "url": "https://www.womenscenterga.com/provider",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-center-pc-stockbridge-sharon-hodges-md"
      },
      {
        "name": "Kia Burch, PA",
        "role": "Physician Assistant",
        "credentials": ["PA"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/59d1490195710a2a052419de3324f1957f2573be/images/2699480.png",
        "_source": {
          "url": "https://www.womenscenterga.com/provider",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Women's Health",
        "practitionerId": "pr-org-web-womens-center-pc-stockbridge-kia-burch-pa"
      },
      {
        "name": "Avery Elloway, PA",
        "role": "Physician Assistant",
        "credentials": ["PA"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/59d1490195710a2a052419de3324f1957f2573be/images/2769114.jpg",
        "_source": {
          "url": "https://www.womenscenterga.com/provider",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Women's Health",
        "practitionerId": "pr-org-web-womens-center-pc-stockbridge-avery-elloway-pa"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-womens-center-pc-conyers",
    "externalIds": {},
    "type": "medical-practice",
    "name": "The Women's Center, PC - Conyers",
    "address": {
      "line1": "2750 Owens Drive",
      "city": "Conyers",
      "state": "GA",
      "zip": "30094",
      "country": "US"
    },
    "location": {
      "lat": 33.6207285,
      "lng": -84.0763046
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "website": "https://www.womenscenterga.com/services/infertility",
    "phone": "(678) 413-4644",
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.womenscenterga.com/services/infertility",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Medication",
        "category": "art",
        "_source": {
          "url": "https://www.womenscenterga.com/services/infertility",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.womenscenterga.com/services/infertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.womenscenterga.com/services/infertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.womenscenterga.com/provider",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Stephanie Gordon, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/59d1490195710a2a052419de3324f1957f2573be/images/2276935.jpg",
        "_source": {
          "url": "https://www.womenscenterga.com/provider",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-center-pc-conyers-stephanie-gordon-md"
      },
      {
        "name": "Trent Rice, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/59d1490195710a2a052419de3324f1957f2573be/images/2724037.jpg",
        "_source": {
          "url": "https://www.womenscenterga.com/provider",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-center-pc-conyers-trent-rice-md"
      },
      {
        "name": "Sharon Hodges, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/59d1490195710a2a052419de3324f1957f2573be/images/2724048.jpg",
        "_source": {
          "url": "https://www.womenscenterga.com/provider",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-womens-center-pc-conyers-sharon-hodges-md"
      },
      {
        "name": "Kia Burch, PA",
        "role": "Physician Assistant",
        "credentials": ["PA"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/59d1490195710a2a052419de3324f1957f2573be/images/2699480.png",
        "_source": {
          "url": "https://www.womenscenterga.com/provider",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Women's Health",
        "practitionerId": "pr-org-web-womens-center-pc-conyers-kia-burch-pa"
      },
      {
        "name": "Avery Elloway, PA",
        "role": "Physician Assistant",
        "credentials": ["PA"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/59d1490195710a2a052419de3324f1957f2573be/images/2769114.jpg",
        "_source": {
          "url": "https://www.womenscenterga.com/provider",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Women's Health",
        "practitionerId": "pr-org-web-womens-center-pc-conyers-avery-elloway-pa"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-north-atlanta-obgyn-sandy-springs",
    "externalIds": {},
    "type": "medical-practice",
    "name": "North Atlanta Ob/Gyn - Sandy Springs",
    "address": {
      "line1": "5780 Peachtree-Dunwoody Road, Suite 295",
      "city": "Atlanta",
      "state": "GA",
      "zip": "30342",
      "country": "US"
    },
    "location": {
      "lat": 33.8773169,
      "lng": -84.3577628
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "website": "https://www.naobgyn.com/service/infertility",
    "phone": "(404) 255-0621",
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.naobgyn.com/service/infertility",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Medication",
        "category": "art",
        "_source": {
          "url": "https://www.naobgyn.com/service/infertility",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.naobgyn.com/service/infertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.naobgyn.com/service/infertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.naobgyn.com/providers",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Stephen A. Rosenberg, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/5a30fbb7829d3be2be72cdfb1bb35381a2c58d87/images/2760720.jpg",
        "_source": {
          "url": "https://www.naobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Gynecology",
        "practitionerId": "pr-org-web-north-atlanta-obgyn-sandy-springs-stephen-a-rosenberg-md"
      },
      {
        "name": "Michelle S. Dodder, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/5a30fbb7829d3be2be72cdfb1bb35381a2c58d87/images/2760721.jpg",
        "_source": {
          "url": "https://www.naobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Gynecology",
        "practitionerId": "pr-org-web-north-atlanta-obgyn-sandy-springs-michelle-s-dodder-md"
      },
      {
        "name": "Colleen E. Cherry, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/5a30fbb7829d3be2be72cdfb1bb35381a2c58d87/images/2760723.jpg",
        "_source": {
          "url": "https://www.naobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-north-atlanta-obgyn-sandy-springs-colleen-e-cherry-md"
      },
      {
        "name": "Jana D. Illston, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/5a30fbb7829d3be2be72cdfb1bb35381a2c58d87/images/2760724.jpg",
        "_source": {
          "url": "https://www.naobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Urogynecology",
        "practitionerId": "pr-org-web-north-atlanta-obgyn-sandy-springs-jana-d-illston-md"
      },
      {
        "name": "Sitra E. Mekonnen, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/5a30fbb7829d3be2be72cdfb1bb35381a2c58d87/images/2760725.jpg",
        "_source": {
          "url": "https://www.naobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-north-atlanta-obgyn-sandy-springs-sitra-e-mekonnen-md"
      },
      {
        "name": "Anamaria Uceda, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/5a30fbb7829d3be2be72cdfb1bb35381a2c58d87/images/2806655.png",
        "_source": {
          "url": "https://www.naobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-north-atlanta-obgyn-sandy-springs-anamaria-uceda-md"
      },
      {
        "name": "Erin M. Mabile, MSN, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "WHNP-BC"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/5a30fbb7829d3be2be72cdfb1bb35381a2c58d87/images/2760727.jpg",
        "_source": {
          "url": "https://www.naobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Women's Health",
        "practitionerId": "pr-org-web-north-atlanta-obgyn-sandy-springs-erin-m-mabile-msn-whnp-bc"
      },
      {
        "name": "Victoria Clark, MSN, APRN, FNP-C",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "APRN", "FNP-C"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/5a30fbb7829d3be2be72cdfb1bb35381a2c58d87/images/2823360.png",
        "_source": {
          "url": "https://www.naobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Women's Health",
        "practitionerId": "pr-org-web-north-atlanta-obgyn-sandy-springs-victoria-clark-msn-aprn-fnp-c"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-north-atlanta-obgyn-alpharetta",
    "externalIds": {},
    "type": "medical-practice",
    "name": "North Atlanta Ob/Gyn - Alpharetta",
    "address": {
      "line1": "3905 Brookside Parkway, Suite 104",
      "city": "Alpharetta",
      "state": "GA",
      "zip": "30022",
      "country": "US"
    },
    "location": {
      "lat": 34.0606253,
      "lng": -84.2470944
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "website": "https://www.naobgyn.com/service/infertility",
    "phone": "(770) 752-0824",
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.naobgyn.com/service/infertility",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Medication",
        "category": "art",
        "_source": {
          "url": "https://www.naobgyn.com/service/infertility",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.naobgyn.com/service/infertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.naobgyn.com/service/infertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.naobgyn.com/providers",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Stephen A. Rosenberg, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/5a30fbb7829d3be2be72cdfb1bb35381a2c58d87/images/2760720.jpg",
        "_source": {
          "url": "https://www.naobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Gynecology",
        "practitionerId": "pr-org-web-north-atlanta-obgyn-alpharetta-stephen-a-rosenberg-md"
      },
      {
        "name": "Michelle S. Dodder, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/5a30fbb7829d3be2be72cdfb1bb35381a2c58d87/images/2760721.jpg",
        "_source": {
          "url": "https://www.naobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Gynecology",
        "practitionerId": "pr-org-web-north-atlanta-obgyn-alpharetta-michelle-s-dodder-md"
      },
      {
        "name": "Colleen E. Cherry, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/5a30fbb7829d3be2be72cdfb1bb35381a2c58d87/images/2760723.jpg",
        "_source": {
          "url": "https://www.naobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-north-atlanta-obgyn-alpharetta-colleen-e-cherry-md"
      },
      {
        "name": "Jana D. Illston, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/5a30fbb7829d3be2be72cdfb1bb35381a2c58d87/images/2760724.jpg",
        "_source": {
          "url": "https://www.naobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Urogynecology",
        "practitionerId": "pr-org-web-north-atlanta-obgyn-alpharetta-jana-d-illston-md"
      },
      {
        "name": "Sitra E. Mekonnen, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/5a30fbb7829d3be2be72cdfb1bb35381a2c58d87/images/2760725.jpg",
        "_source": {
          "url": "https://www.naobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-north-atlanta-obgyn-alpharetta-sitra-e-mekonnen-md"
      },
      {
        "name": "Anamaria Uceda, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/5a30fbb7829d3be2be72cdfb1bb35381a2c58d87/images/2806655.png",
        "_source": {
          "url": "https://www.naobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-north-atlanta-obgyn-alpharetta-anamaria-uceda-md"
      },
      {
        "name": "Erin M. Mabile, MSN, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "WHNP-BC"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/5a30fbb7829d3be2be72cdfb1bb35381a2c58d87/images/2760727.jpg",
        "_source": {
          "url": "https://www.naobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Women's Health",
        "practitionerId": "pr-org-web-north-atlanta-obgyn-alpharetta-erin-m-mabile-msn-whnp-bc"
      },
      {
        "name": "Victoria Clark, MSN, APRN, FNP-C",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "APRN", "FNP-C"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/5a30fbb7829d3be2be72cdfb1bb35381a2c58d87/images/2823360.png",
        "_source": {
          "url": "https://www.naobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Women's Health",
        "practitionerId": "pr-org-web-north-atlanta-obgyn-alpharetta-victoria-clark-msn-aprn-fnp-c"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-north-atlanta-obgyn-marietta",
    "externalIds": {},
    "type": "medical-practice",
    "name": "North Atlanta Ob/Gyn - Marietta",
    "address": {
      "line1": "1523 Johnson Ferry Road, Suite 150",
      "city": "Marietta",
      "state": "GA",
      "zip": "30062",
      "country": "US"
    },
    "location": {
      "lat": 33.9866656,
      "lng": -84.4272448
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "website": "https://www.naobgyn.com/service/infertility",
    "phone": "(770) 977-3513",
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.naobgyn.com/service/infertility",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Medication",
        "category": "art",
        "_source": {
          "url": "https://www.naobgyn.com/service/infertility",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.naobgyn.com/service/infertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.naobgyn.com/service/infertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.naobgyn.com/providers",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Stephen A. Rosenberg, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/5a30fbb7829d3be2be72cdfb1bb35381a2c58d87/images/2760720.jpg",
        "_source": {
          "url": "https://www.naobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Gynecology",
        "practitionerId": "pr-org-web-north-atlanta-obgyn-marietta-stephen-a-rosenberg-md"
      },
      {
        "name": "Michelle S. Dodder, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/5a30fbb7829d3be2be72cdfb1bb35381a2c58d87/images/2760721.jpg",
        "_source": {
          "url": "https://www.naobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Gynecology",
        "practitionerId": "pr-org-web-north-atlanta-obgyn-marietta-michelle-s-dodder-md"
      },
      {
        "name": "Colleen E. Cherry, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/5a30fbb7829d3be2be72cdfb1bb35381a2c58d87/images/2760723.jpg",
        "_source": {
          "url": "https://www.naobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-north-atlanta-obgyn-marietta-colleen-e-cherry-md"
      },
      {
        "name": "Jana D. Illston, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/5a30fbb7829d3be2be72cdfb1bb35381a2c58d87/images/2760724.jpg",
        "_source": {
          "url": "https://www.naobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Urogynecology",
        "practitionerId": "pr-org-web-north-atlanta-obgyn-marietta-jana-d-illston-md"
      },
      {
        "name": "Sitra E. Mekonnen, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/5a30fbb7829d3be2be72cdfb1bb35381a2c58d87/images/2760725.jpg",
        "_source": {
          "url": "https://www.naobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-north-atlanta-obgyn-marietta-sitra-e-mekonnen-md"
      },
      {
        "name": "Anamaria Uceda, MD",
        "role": "Physician",
        "credentials": ["MD"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/5a30fbb7829d3be2be72cdfb1bb35381a2c58d87/images/2806655.png",
        "_source": {
          "url": "https://www.naobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Obstetrics and Gynecology",
        "practitionerId": "pr-org-web-north-atlanta-obgyn-marietta-anamaria-uceda-md"
      },
      {
        "name": "Erin M. Mabile, MSN, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "WHNP-BC"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/5a30fbb7829d3be2be72cdfb1bb35381a2c58d87/images/2760727.jpg",
        "_source": {
          "url": "https://www.naobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Women's Health",
        "practitionerId": "pr-org-web-north-atlanta-obgyn-marietta-erin-m-mabile-msn-whnp-bc"
      },
      {
        "name": "Victoria Clark, MSN, APRN, FNP-C",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "APRN", "FNP-C"],
        "imageUrl": "https://sa1s3optim.patientpop.com/filters:format(webp)/assets/production/practices/5a30fbb7829d3be2be72cdfb1bb35381a2c58d87/images/2823360.png",
        "_source": {
          "url": "https://www.naobgyn.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Women's Health",
        "practitionerId": "pr-org-web-north-atlanta-obgyn-marietta-victoria-clark-msn-aprn-fnp-c"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-fcne-cambridge",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Fertility Centers of New England - Cambridge",
    "address": {
      "line1": "330 Mount Auburn Street",
      "city": "Cambridge",
      "state": "MA",
      "zip": "02138",
      "country": "US"
    },
    "location": {
      "lat": 42.3748011,
      "lng": -71.1331402
    },
    "setting": "network-group",
    "network": {
      "name": "Fertility Centers of New England"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.fertilitycenter.com/locations/",
    "phone": "(877) 326-3483",
    "treatments": [
      {
        "name": "Fertility Consultations",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.fertilitycenter.com/locations/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Monitoring",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.fertilitycenter.com/locations/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitycenter.com/locations/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitycenter.com/locations/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-fcne-leominster",
    "externalIds": {
      "googlePlaceId": "ChIJX7nPAKvo44kRdikFGccyMps"
    },
    "type": "fertility-clinic",
    "name": "Fertility Centers of New England - Leominster",
    "address": {
      "line1": "80 Erdman Way, Suite 104",
      "city": "Leominster",
      "state": "MA",
      "zip": "01453",
      "country": "US"
    },
    "location": {
      "lat": 42.5474797,
      "lng": -71.7581428
    },
    "setting": "network-group",
    "network": {
      "name": "Fertility Centers of New England"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.fertilitycenter.com/locations/",
    "phone": "(877) 326-3483",
    "treatments": [
      {
        "name": "Fertility Consultations",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.fertilitycenter.com/locations/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Monitoring",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.fertilitycenter.com/locations/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitycenter.com/locations/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitycenter.com/locations/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+New+England,+80+Erdman+Way+Ste+104,+Leominster,+MA+01453/@42.5479609,-71.7589394,2939a,13.1y/data=!4m2!3m1!1s0x89e3e8ab00cfb95f:0x9b3232c719052976",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://www.fertilitycenter.com/wp-content/uploads/2019/06/location-leominster.jpg",
        "type": "exterior",
        "caption": "Exterior of The Leominster Center, located in the Longview Corporate Center at 80 Erdman Way, Suite 104, Leominster, MA.",
        "_source": {
          "url": "https://www.fertilitycenter.com/locations/the-leominster-center/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-fcne-peabody",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Fertility Centers of New England - Peabody",
    "address": {
      "line1": "1 Essex Center Drive",
      "city": "Peabody",
      "state": "MA",
      "zip": "01960",
      "country": "US"
    },
    "location": {
      "lat": 42.5365201,
      "lng": -70.9465054
    },
    "setting": "network-group",
    "network": {
      "name": "Fertility Centers of New England"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.fertilitycenter.com/locations/",
    "phone": "(877) 326-3483",
    "treatments": [
      {
        "name": "Fertility Consultations",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.fertilitycenter.com/locations/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Monitoring",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.fertilitycenter.com/locations/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitycenter.com/locations/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitycenter.com/locations/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://www.fertilitycenter.com/wp-content/uploads/2024/03/Peabody-Fertility-Center.jpeg",
        "type": "exterior",
        "caption": "Exterior of the Fertility Centers of New England - Peabody Center at 1 Essex Center Drive",
        "_source": {
          "url": "https://www.fertilitycenter.com/locations/the-peabody-center/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-fcne-plymouth",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Fertility Centers of New England - Plymouth",
    "address": {
      "line1": "101 Court Street, 4th Floor, Suite 8",
      "city": "Plymouth",
      "state": "MA",
      "zip": "02360",
      "country": "US"
    },
    "location": {
      "lat": 41.9599298,
      "lng": -70.6698153
    },
    "setting": "network-group",
    "network": {
      "name": "Fertility Centers of New England"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.fertilitycenter.com/locations/",
    "phone": "(877) 326-3483",
    "treatments": [
      {
        "name": "Fertility Consultations",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.fertilitycenter.com/locations/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Monitoring",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.fertilitycenter.com/locations/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitycenter.com/locations/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitycenter.com/locations/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://www.fertilitycenter.com/wp-content/uploads/2024/02/location-plymouth.jpeg",
        "type": "exterior",
        "caption": "Building exterior of the Fertility Centers of New England Plymouth location at 101 Court Street, Plymouth, MA",
        "_source": {
          "url": "https://www.fertilitycenter.com/locations/the-plymouth-center/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-fcne-westborough",
    "externalIds": {
      "googlePlaceId": "ChIJPaZEkZoK5IkR0n4idKEQTWk"
    },
    "type": "fertility-clinic",
    "name": "Fertility Centers of New England - Westborough",
    "address": {
      "line1": "33 Lyman Street, Suite 302",
      "city": "Westborough",
      "state": "MA",
      "zip": "01581",
      "country": "US"
    },
    "location": {
      "lat": 42.2830338,
      "lng": -71.6071355
    },
    "setting": "network-group",
    "network": {
      "name": "Fertility Centers of New England"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.fertilitycenter.com/locations/the-westborough-center/",
    "phone": "(877) 326-3483",
    "treatments": [
      {
        "name": "Physician Consultations",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.fertilitycenter.com/locations/the-westborough-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Bloodwork",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.fertilitycenter.com/locations/the-westborough-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ultrasounds",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.fertilitycenter.com/locations/the-westborough-center/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitycenter.com/locations/the-westborough-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitycenter.com/locations/the-westborough-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Centers+of+New+England+Westborough,+33+Lyman+St+Ste+302,+Westborough,+MA+01581/@42.2835017,-71.6061693,2952a,13.1y/data=!4m2!3m1!1s0x89e40a9a9144a63d:0x694d10a174227ed2",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://www.fertilitycenter.com/wp-content/uploads/2019/06/location-westborough.jpg",
        "type": "exterior",
        "caption": "Exterior of the Fertility Centers of New England Westborough office, a brick professional building in the Lyman Street Office Park with parking lot",
        "_source": {
          "url": "https://www.fertilitycenter.com/locations/the-westborough-center/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-boston-ivf-concord",
    "externalIds": {
      "googlePlaceId": "ChIJ00PtwTmR44kRWHd4pBt-1us"
    },
    "type": "fertility-clinic",
    "name": "Boston IVF - Concord",
    "address": {
      "line1": "150 Baker Avenue Extension, Suite 203",
      "city": "Concord",
      "state": "MA",
      "zip": "01742",
      "country": "US"
    },
    "location": {
      "lat": 42.4624943,
      "lng": -71.3883745
    },
    "setting": "network-group",
    "network": {
      "name": "Boston IVF"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.bostonivf.com/locations",
    "phone": "(888) 300-2483",
    "treatments": [
      {
        "name": "Consultations",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.bostonivf.com/locations",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "SIS",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.bostonivf.com/locations",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Blood/Ultrasound Monitoring",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.bostonivf.com/locations",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/locations",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/locations",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/locations/the-concord-ma-fertility-center",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Boston+IVF,+150+Baker+Avenue+Extension+%23203,+Concord,+MA+01742/@42.4627602,-71.3875014,2943a,13.1y/data=!4m2!3m1!1s0x89e39139c1ed43d3:0xebd67e1ba4787758",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Riwa Sabbagh",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.bostonivf.com/thumbs/R-Sabbagh_thumb-physicians-main.png?v=fb4a6",
        "_source": {
          "url": "https://www.bostonivf.com/physicians/riwa-sabbagh",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-boston-ivf-concord-riwa-sabbagh"
      },
      {
        "name": "Jill Attaman",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.bostonivf.com/thumbs/J-Attaman-min_thumb-physicians-main.jpg?v=e483d",
        "_source": {
          "url": "https://www.bostonivf.com/physicians/jill-attaman",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-boston-ivf-concord-jill-attaman"
      }
    ],
    "images": [
      {
        "url": "https://www.timberlineconstruction.com/wp-content/uploads/Boston-IVF_Lobby_1-1280x853.jpg",
        "type": "interior",
        "caption": "Waiting room and reception area with the Boston IVF wall logo at the Concord, MA fertility center",
        "_source": {
          "url": "https://www.timberlineconstruction.com/project/boston-ivf/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.timberlineconstruction.com/wp-content/uploads/Boston-IVF_Lobby_2-1280x853.jpg",
        "type": "interior",
        "caption": "Waiting lounge with fireplace and reception desk at the Boston IVF Concord, MA fertility center",
        "_source": {
          "url": "https://www.timberlineconstruction.com/project/boston-ivf/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.timberlineconstruction.com/wp-content/uploads/Boston-IVF_patient-room_1-1280x853.jpg",
        "type": "interior",
        "caption": "Exam and ultrasound room with GE ultrasound machine at the Boston IVF Concord, MA fertility center",
        "_source": {
          "url": "https://www.timberlineconstruction.com/project/boston-ivf/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://www.timberlineconstruction.com/wp-content/uploads/Boston-IVF_patient-room_2-1280x853.jpg",
        "type": "interior",
        "caption": "Patient exam room with exam table, sink, and scale at the Boston IVF Concord, MA fertility center",
        "_source": {
          "url": "https://www.timberlineconstruction.com/project/boston-ivf/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlDUoSvlW1Qqjxr-Ld4CHjIN2gGmP4Ln9matyjYEFuzyM0yfdFca6nTCEZyzwVnoRnCKJtrQDiZFTXJCDNkR2mhZguohwymq-YijdyaxCvpSWYCK2H1uliRPEQEOA832XQNf_ob=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Boston+IVF,+150+Baker+Avenue+Extension+%23203,+Concord,+MA+01742/@42.4627602,-71.3875014,2943a,13.1y/data=!4m2!3m1!1s0x89e39139c1ed43d3:0xebd67e1ba4787758",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-boston-ivf-springfield",
    "externalIds": {
      "googlePlaceId": "ChIJoWJAZ67n5okRposAoQHDedY"
    },
    "type": "fertility-clinic",
    "name": "Boston IVF - Springfield",
    "address": {
      "line1": "2 Medical Center Drive, Suite 301",
      "city": "Springfield",
      "state": "MA",
      "zip": "01107",
      "country": "US"
    },
    "location": {
      "lat": 42.1272903,
      "lng": -72.6005866
    },
    "setting": "network-group",
    "network": {
      "name": "Boston IVF"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.bostonivf.com/locations/the-springfield-ma-fertility-center",
    "phone": "(413) 707-0590",
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.bostonivf.com/locations/the-springfield-ma-fertility-center",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "SIS",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.bostonivf.com/locations/the-springfield-ma-fertility-center",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Semen Analysis",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.bostonivf.com/locations/the-springfield-ma-fertility-center",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/locations/the-springfield-ma-fertility-center",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/locations/the-springfield-ma-fertility-center",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.bostonivf.com/locations/the-springfield-ma-fertility-center",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Boston+IVF,+Medical+Office+Building,+2+Medical+Center+Dr+Ste+301,+Springfield,+MA+01107/@42.1213847,-72.6014717,2959a,13.1y/data=!4m2!3m1!1s0x89e6e7ae674062a1:0xd679c301a1008ba6",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Josette Dawkins, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "OB/GYN"],
        "imageUrl": "https://www.bostonivf.com/thumbs/Untitled-design-25-1_thumb-physicians-main.png?v=8f5d8",
        "_source": {
          "url": "https://www.bostonivf.com/physicians/josette-dawkins",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-boston-ivf-springfield-josette-dawkins-md"
      },
      {
        "name": "Meaghan Delaney, MD, MA",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "MA"],
        "imageUrl": "https://www.bostonivf.com/thumbs/MDelaney-new_thumb-physicians-main.png?v=cbe78",
        "_source": {
          "url": "https://www.bostonivf.com/physicians/meaghan-delaney",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-boston-ivf-springfield-meaghan-delaney-md-ma"
      },
      {
        "name": "Kerry Chenausky, MS, BSN",
        "role": "Nurse Practitioner",
        "credentials": ["MS", "BSN"],
        "imageUrl": "https://www.bostonivf.com/thumbs/Kerry_thumb-physicians-main.png?v=9fbb2",
        "_source": {
          "url": "https://www.bostonivf.com/physicians/kerry-chenausky",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-boston-ivf-springfield-kerry-chenausky-ms-bsn"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-mgb-reproductive-medicine-newton-wellesley",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Mass General Brigham Reproductive Medicine Center - Newton-Wellesley",
    "address": {
      "line1": "2014 Washington Street",
      "city": "Newton",
      "state": "MA",
      "zip": "02462",
      "country": "US"
    },
    "location": {
      "lat": 42.330668,
      "lng": -71.2479216
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.nwh.org/womens-health-center/reproductive-medicine/reproductive-medicine",
    "phone": "(617) 243-5200",
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.nwh.org/womens-health-center/reproductive-medicine/reproductive-medicine",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.nwh.org/womens-health-center/reproductive-medicine/reproductive-medicine",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.nwh.org/womens-health-center/reproductive-medicine/reproductive-medicine",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.nwh.org/womens-health-center/reproductive-medicine/reproductive-medicine",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.nwh.org/womens-health-center/reproductive-medicine/reproductive-medicine",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Jan L. Shifren, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.nwh.org/media/PhysicianPhotos/Shifren_Jan.jpg",
        "_source": {
          "url": "https://www.nwh.org/find-a-doctor/find-a-doctor-profile/jan-shifren-l-md",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-mgb-reproductive-medicine-newton-wellesley-jan-l-shifren-md"
      },
      {
        "name": "Mark D. Hornstein, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.nwh.org/media/PhysicianPhotos/Hornstein_1525.jpg",
        "_source": {
          "url": "https://www.nwh.org/find-a-doctor/find-a-doctor-profile/mark-hornstein-d-md",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-mgb-reproductive-medicine-newton-wellesley-mark-d-hornstein-md"
      },
      {
        "name": "Rachel K. Ashby, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.nwh.org/media/PhysicianPhotos/Ashby_Rachel.jpg",
        "_source": {
          "url": "https://www.nwh.org/find-a-doctor/find-a-doctor-profile/rachel-ashby-k-md",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-mgb-reproductive-medicine-newton-wellesley-rachel-k-ashby-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-bmc-rei",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Boston Medical Center Reproductive Endocrinology and Infertility",
    "address": {
      "line1": "725 Albany Street, 5th Floor",
      "city": "Boston",
      "state": "MA",
      "zip": "02118",
      "country": "US"
    },
    "location": {
      "lat": 42.3355233,
      "lng": -71.0707781
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.bmc.org/departments/obstetrics-and-gynecology/gynecology/reproductive-endocrinology-and-infertility",
    "phone": "(617) 414-2000",
    "treatments": [
      {
        "name": "Fertility Evaluation",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.bmc.org/departments/obstetrics-and-gynecology/gynecology/reproductive-endocrinology-and-infertility",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Assisted Reproductive Technology Coordination",
        "category": "art",
        "_source": {
          "url": "https://www.bmc.org/departments/obstetrics-and-gynecology/gynecology/reproductive-endocrinology-and-infertility",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.bmc.org/departments/obstetrics-and-gynecology/gynecology/reproductive-endocrinology-and-infertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.bmc.org/departments/obstetrics-and-gynecology/gynecology/reproductive-endocrinology-and-infertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.bmc.org/departments/obstetrics-and-gynecology/gynecology/reproductive-endocrinology-and-infertility",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Wendy Kuohung, MD",
        "role": "Reproductive Endocrinologist; Director, Division of Reproductive Endocrinology and Infertility",
        "credentials": ["MD"],
        "imageUrl": "https://assets.bmc.org/transform/c30b0fd4-de93-4146-a234-9c1c6bb37706/Kuohung-Wendy?io=transform:fill,width:600,height:900&format=jpg",
        "_source": {
          "url": "https://www.bmc.org/obstetrics-and-gynecology/gynecology/reproductive-endocrinology-and-infertility/our-team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-bmc-rei-wendy-kuohung-md"
      },
      {
        "name": "Jennifer A. Farraye, MSN, NP",
        "role": "Nurse Practitioner (OB/GYN and Reproductive Endocrinology)",
        "credentials": ["MSN", "NP"],
        "imageUrl": "https://assets.bmc.org/transform/8ef89d2c-e81a-49d0-956e-059f639c4112/Farraye_Jennifer-jpg?io=transform:fill,width:600,height:900&format=jpg",
        "_source": {
          "url": "https://www.bmc.org/obstetrics-and-gynecology/gynecology/reproductive-endocrinology-and-infertility/our-team",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-bmc-rei-jennifer-a-farraye-msn-np"
      }
    ],
    "images": [
      {
        "url": "https://assets.bmc.org/transform/bfc9329a-5a2c-47fb-a7a2-c64d0d17dfba/img_1611?io=transform:fill,width:600,height:400&format=jpg",
        "type": "exterior",
        "caption": "Entrance to the Boston Medical Center Ambulatory Care (Shapiro) Center at 725 Albany Street, the building housing the Reproductive Endocrinology and Infertility department on the 5th floor",
        "_source": {
          "url": "https://www.bmc.org/departments/obstetrics-and-gynecology/gynecology/reproductive-endocrinology-and-infertility",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-bidmc-reproductive-endocrinology",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Beth Israel Deaconess Reproductive Endocrinology",
    "address": {
      "line1": "330 Brookline Avenue",
      "city": "Boston",
      "state": "MA",
      "zip": "02215",
      "country": "US"
    },
    "location": {
      "lat": 42.3398227,
      "lng": -71.1062328
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://bidmc.org/services/endocrinology/reproductive-endocrinology",
    "phone": "(617) 434-6500",
    "treatments": [
      {
        "name": "Fertility Evaluation",
        "category": "diagnostic",
        "_source": {
          "url": "https://bidmc.org/services/endocrinology/reproductive-endocrinology",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "HSG",
        "category": "diagnostic",
        "_source": {
          "url": "https://bidmc.org/services/endocrinology/reproductive-endocrinology",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fallopian Tube Recanalization",
        "category": "surgical",
        "_source": {
          "url": "https://bidmc.org/services/endocrinology/reproductive-endocrinology",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://bidmc.org/services/endocrinology/reproductive-endocrinology",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://bidmc.org/services/endocrinology/reproductive-endocrinology",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://bidmc.org/services/endocrinology/reproductive-endocrinology",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Jessica A. Ryniec, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Jessica_Ryniec_600x600_2x.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/jessica-ryniec/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-bidmc-reproductive-endocrinology-jessica-a-ryniec-md"
      },
      {
        "name": "Aaron K. Styer, MD",
        "role": "Reproductive Endocrinologist; Associate Professor of Obstetrics, Gynecology & Reproductive Biology, Harvard Medical School",
        "credentials": ["MD"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Aaron_Styer_600x600_2x.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/aaron-styer/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-bidmc-reproductive-endocrinology-aaron-k-styer-md"
      },
      {
        "name": "Alison E. Zimon, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/2025/07/Alison_Zimon_600x600_2x.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/ccrm-fertility-doctors/alison-zimon/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-bidmc-reproductive-endocrinology-alison-e-zimon-md"
      }
    ],
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-bwh-cirs-foxborough",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Brigham and Women's CIRS - Foxborough",
    "address": {
      "line1": "22 Patriot Place, 3rd Floor",
      "city": "Foxborough",
      "state": "MA",
      "zip": "02035",
      "country": "US"
    },
    "location": {
      "lat": 42.0945617,
      "lng": -71.2522643
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.brighamandwomens.org/foxborough-health-care-center/foxborough-services/infertility-services",
    "phone": "(617) 732-4222",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.brighamandwomens.org/foxborough-health-care-center/foxborough-services/infertility-services",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.brighamandwomens.org/foxborough-health-care-center/foxborough-services/infertility-services",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.brighamandwomens.org/foxborough-health-care-center/foxborough-services/infertility-services",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.brighamandwomens.org/foxborough-health-care-center/foxborough-services/infertility-services",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.brighamandwomens.org/foxborough-health-care-center/foxborough-services/infertility-services",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.brighamandwomens.org/foxborough-health-care-center/foxborough-services/infertility-services",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Serene S. Srouji, MD",
        "role": "Reproductive Endocrinologist; Medical Director, Center for Infertility and Reproductive Surgery",
        "credentials": ["MD"],
        "imageUrl": "https://physiciandirectory.brighamandwomens.org/Custom/Photos/hires/1793.jpg",
        "_source": {
          "url": "https://doctors.massgeneralbrigham.org/provider/serene-samir-srouji/3001230",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-bwh-cirs-foxborough-serene-s-srouji-md"
      }
    ],
    "images": [
      {
        "url": "https://www.brighamandwomens.org/assets/BWH/about-bwh/images/fxb-brighamhealth-700x400.jpg",
        "type": "exterior",
        "caption": "Exterior of the Mass General Brigham Healthcare Center in Foxborough (Patriot Place campus), where the Brigham and Women's Center for Infertility and Reproductive Surgery clinic is located.",
        "_source": {
          "url": "https://www.brighamandwomens.org/about-bwh/locations/health-care-center-20-patriot-place-foxborough",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-bwh-cirs-braintree",
    "externalIds": {
      "googlePlaceId": "ChIJOaUpdwGD5IkRr3JCBDojq04"
    },
    "type": "fertility-clinic",
    "name": "Brigham and Women's CIRS - Braintree",
    "address": {
      "line1": "1681 Washington Street, 2nd Floor",
      "city": "Braintree",
      "state": "MA",
      "zip": "02184",
      "country": "US"
    },
    "location": {
      "lat": 42.1821811,
      "lng": -71.013172
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.brighamandwomens.org/obgyn/infertility-reproductive-surgery/locations-center-for-infertility-and-reproductive-surgery",
    "phone": "(781) 930-0653",
    "treatments": [
      {
        "name": "Infertility Services",
        "category": "art",
        "_source": {
          "url": "https://www.brighamandwomens.org/obgyn/infertility-reproductive-surgery/locations-center-for-infertility-and-reproductive-surgery",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Evaluation",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.brighamandwomens.org/obgyn/infertility-reproductive-surgery/locations-center-for-infertility-and-reproductive-surgery",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.brighamandwomens.org/obgyn/infertility-reproductive-surgery/locations-center-for-infertility-and-reproductive-surgery",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.brighamandwomens.org/obgyn/infertility-reproductive-surgery/locations-center-for-infertility-and-reproductive-surgery",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.brighamandwomens.org/obgyn/infertility-reproductive-surgery/locations-center-for-infertility-and-reproductive-surgery",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Brigham+and+Women's+Center+for+Infertility+and+Reproductive+Surgery,+1681+Washington+St,+Braintree,+MA+02184/@42.1821301,-71.0137131,2957a,13.1y/data=!4m2!3m1!1s0x89e483017729a539:0x4eab233a044272af",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Elizabeth S. Ginsburg",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://image-service-api.prd2.healthsparq.com/api/image?url=https%3A%2F%2Fcdn-images.kyruus.com%2Fprovidermatch%2Fmassgeneralbrigham%2Fphotos%2Forig%2Fginsburg-elizabeth-1164407938..jpg&w=200&h=200&f=jpeg&fp=auto&limit-resize=false",
        "_source": {
          "url": "https://doctors.massgeneralbrigham.org/provider/elizabeth-sarah-ginsburg/3002025",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-bwh-cirs-braintree-elizabeth-s-ginsburg"
      },
      {
        "name": "Rachel K. Ashby",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://image-service-api.prd2.healthsparq.com/api/image?url=https%3A%2F%2Fcdn-images.kyruus.com%2Fprovidermatch%2Fmassgeneralbrigham%2Fphotos%2Forig%2Fashby-rachel-1295792984..jpg&w=200&h=200&f=jpeg&fp=auto&limit-resize=false",
        "_source": {
          "url": "https://doctors.massgeneralbrigham.org/provider/rachel-kathleen-ashby/3005640",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-bwh-cirs-braintree-rachel-k-ashby"
      },
      {
        "name": "Mark D. Hornstein",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://image-service-api.prd2.healthsparq.com/api/image?url=https%3A%2F%2Fcdn-images.kyruus.com%2Fprovidermatch%2Fmassgeneralbrigham%2Fphotos%2Forig%2Fhornstein-mark-1720038276.jpg&w=200&h=200&f=jpeg&fp=auto&limit-resize=false",
        "_source": {
          "url": "https://doctors.massgeneralbrigham.org/provider/mark-d-hornstein/255013",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-bwh-cirs-braintree-mark-d-hornstein"
      },
      {
        "name": "Janis H. Fox",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://image-service-api.prd2.healthsparq.com/api/image?url=https%3A%2F%2Fcdn-images.kyruus.com%2Fprovidermatch%2Fmassgeneralbrigham%2Fphotos%2Forig%2Ffox-janis-1437100310..jpg&w=200&h=200&f=jpeg&fp=auto&limit-resize=false",
        "_source": {
          "url": "https://doctors.massgeneralbrigham.org/provider/janis-heidi-fox/3010641",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-bwh-cirs-braintree-janis-h-fox"
      },
      {
        "name": "Serene S. Srouji",
        "role": "Reproductive Endocrinologist / Medical Director, Center for Infertility and Reproductive Surgery",
        "credentials": ["MD"],
        "imageUrl": "https://image-service-api.prd2.healthsparq.com/api/image?url=https%3A%2F%2Fcdn-images.kyruus.com%2Fprovidermatch%2Fmassgeneralbrigham%2Fphotos%2Forig%2Fsrouji-serene-1639150394..jpg&w=200&h=200&f=jpeg&fp=auto&limit-resize=false",
        "_source": {
          "url": "https://doctors.massgeneralbrigham.org/provider/serene-samir-srouji/3001230",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-bwh-cirs-braintree-serene-s-srouji"
      },
      {
        "name": "Robert L. Barbieri",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://image-service-api.prd2.healthsparq.com/api/image?url=https%3A%2F%2Fcdn-images.kyruus.com%2Fprovidermatch%2Fmassgeneralbrigham%2Fphotos%2Forig%2Fbarbieri-robert-1548253958..jpg&w=200&h=200&f=jpeg&fp=auto&limit-resize=false",
        "_source": {
          "url": "https://doctors.massgeneralbrigham.org/provider/robert-l-barbieri/3001110",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-bwh-cirs-braintree-robert-l-barbieri"
      },
      {
        "name": "Marc R. Laufer",
        "role": "Obstetrician-Gynecologist (Reproductive Surgery)",
        "credentials": ["MD"],
        "imageUrl": "https://image-service-api.prd2.healthsparq.com/api/image?url=https%3A%2F%2Fcdn-images.kyruus.com%2Fprovidermatch%2Fmassgeneralbrigham%2Fphotos%2Forig%2Flaufer-marc-1679539969.jpg&w=200&h=200&f=jpeg&fp=auto&limit-resize=false",
        "_source": {
          "url": "https://doctors.massgeneralbrigham.org/provider/marc-r-laufer/3010678",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-bwh-cirs-braintree-marc-r-laufer"
      },
      {
        "name": "Kimberly W. Keefe Smith",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://image-service-api.prd2.healthsparq.com/api/image?url=https%3A%2F%2Fcdn-images.kyruus.com%2Fprovidermatch%2Fmassgeneralbrigham%2Fphotos%2Forig%2Fkeefesmith-kimberly-1891057584..jpg&w=200&h=200&f=jpeg&fp=auto&limit-resize=false",
        "_source": {
          "url": "https://doctors.massgeneralbrigham.org/provider/kimberly-keefe-smith/3009135",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-bwh-cirs-braintree-kimberly-w-keefe-smith"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-cooley-dickinson-fertility",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Cooley Dickinson Fertility Services",
    "address": {
      "line1": "22 Atwood Drive",
      "city": "Northampton",
      "state": "MA",
      "zip": "01060",
      "country": "US"
    },
    "location": {
      "lat": 42.3032936,
      "lng": -72.6230702
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "website": "https://www.cooleydickinson.org/programs-services/ob-gyn-midwifery/fertility-services/",
    "phone": "(413) 582-2000",
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.cooleydickinson.org/programs-services/ob-gyn-midwifery/fertility-services/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Monitoring",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.cooleydickinson.org/programs-services/ob-gyn-midwifery/fertility-services/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Semen Analysis",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.cooleydickinson.org/programs-services/ob-gyn-midwifery/fertility-services/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.cooleydickinson.org/programs-services/ob-gyn-midwifery/fertility-services/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.cooleydickinson.org/programs-services/ob-gyn-midwifery/fertility-services/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.cooleydickinson.org/programs-services/ob-gyn-midwifery/fertility-services/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Melanie Greenman",
        "role": "Obstetrician Gynecologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.cooleydickinson.org/wp-content/uploads/2020/12/Melanie-Greenman-51-web.jpg",
        "_source": {
          "url": "https://www.cooleydickinson.org/doctors-providers/melanie-greenman-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-cooley-dickinson-fertility-melanie-greenman"
      },
      {
        "name": "Edward Patton",
        "role": "Obstetrician Gynecologist, Chief of Obstetrics and Gynecology",
        "credentials": ["MD"],
        "imageUrl": "https://www.cooleydickinson.org/wp-content/uploads/2016/08/Patton-Edward-SIZED.jpg",
        "_source": {
          "url": "https://www.cooleydickinson.org/doctors-providers/edward-patton-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-cooley-dickinson-fertility-edward-patton"
      },
      {
        "name": "Kristen Kelly",
        "role": "Obstetrician Gynecologist, Medical Director, ObGyn & Midwifery",
        "credentials": ["MD"],
        "imageUrl": "https://www.cooleydickinson.org/wp-content/uploads/2016/08/Kelly-Kristen-SIZED-1.jpg",
        "_source": {
          "url": "https://www.cooleydickinson.org/doctors-providers/kristen-kelly-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-cooley-dickinson-fertility-kristen-kelly"
      },
      {
        "name": "Ruth Pryor",
        "role": "Obstetrician Gynecologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.cooleydickinson.org/wp-content/uploads/2016/11/Pryor-Ruth-512x512.jpg",
        "_source": {
          "url": "https://www.cooleydickinson.org/doctors-providers/ruth-pryor-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-cooley-dickinson-fertility-ruth-pryor"
      },
      {
        "name": "Tucker Kueny",
        "role": "Obstetrician Gynecologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.cooleydickinson.org/wp-content/uploads/2016/08/Kueny-Tucker-SIZED.jpg",
        "_source": {
          "url": "https://www.cooleydickinson.org/doctors-providers/tucker-kueny-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-cooley-dickinson-fertility-tucker-kueny"
      },
      {
        "name": "Jesse Eisenberg",
        "role": "Obstetrician Gynecologist (High Risk Obstetrics)",
        "credentials": ["MD"],
        "imageUrl": "https://www.cooleydickinson.org/wp-content/uploads/2024/10/jesse-eisenberg.jpg",
        "_source": {
          "url": "https://www.cooleydickinson.org/doctors-providers/jesse-eisenberg-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-cooley-dickinson-fertility-jesse-eisenberg"
      },
      {
        "name": "Nandi Chihombori-Quao",
        "role": "Obstetrician Gynecologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.cooleydickinson.org/wp-content/uploads/2023/05/nandi-chihombori-quao.jpeg",
        "_source": {
          "url": "https://www.cooleydickinson.org/doctors-providers/nandi-chihombori-quao-md/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-cooley-dickinson-fertility-nandi-chihombori-quao"
      }
    ],
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-cars-springfield",
    "externalIds": {
      "googlePlaceId": "ChIJ4UweJ7jn5okRo4IYH6BYN0U"
    },
    "type": "fertility-clinic",
    "name": "Center for Advanced Reproductive Services - Springfield",
    "address": {
      "line1": "3550 Main Street, Suite 203",
      "city": "Springfield",
      "state": "MA",
      "zip": "01107",
      "country": "US"
    },
    "location": {
      "lat": 42.1257755,
      "lng": -72.6108216
    },
    "setting": "network-group",
    "network": {
      "name": "First Fertility"
    },
    "consultationTypes": ["in-person", "telehealth"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://uconnfertility.com/the-center-for-advanced-reproductive-services-springfield/",
    "phone": "(413) 683-0014",
    "treatments": [
      {
        "name": "IUI/IVF Cycle Monitoring",
        "category": "diagnostic",
        "_source": {
          "url": "https://uconnfertility.com/the-center-for-advanced-reproductive-services-springfield/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Sonohysterogram",
        "category": "diagnostic",
        "_source": {
          "url": "https://uconnfertility.com/the-center-for-advanced-reproductive-services-springfield/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "HSG",
        "category": "diagnostic",
        "_source": {
          "url": "https://uconnfertility.com/the-center-for-advanced-reproductive-services-springfield/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://uconnfertility.com/the-center-for-advanced-reproductive-services-springfield/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://uconnfertility.com/the-center-for-advanced-reproductive-services-springfield/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://uconnfertility.com/the-center-for-advanced-reproductive-services-springfield/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Center+for+Advanced+Reproductive+Services+Springfield,+3550+Main+St+Ste+203,+Springfield,+MA+01107/@42.1259154,-72.6118936,2959a,13.1y/data=!4m2!3m1!1s0x89e6e7b8271e4ce1:0x453758a01f1882a3",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Kelly Lynch",
        "role": "Reproductive Endocrinologist (Lead Physician)",
        "credentials": ["MD"],
        "imageUrl": "https://uconnfertility.com/wp-content/uploads/2023/01/KellyLynch_5x7.jpg",
        "_source": {
          "url": "https://uconnfertility.com/provider/kelly-lynch-m-d/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-cars-springfield-kelly-lynch"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-wellesley-womens-care",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Wellesley Women's Care",
    "address": {
      "line1": "2000 Washington Street, Green Building, Suite 764",
      "city": "Newton",
      "state": "MA",
      "zip": "02462",
      "country": "US"
    },
    "location": {
      "lat": 42.3326974,
      "lng": -71.2460746
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "website": "https://www.careforwomen.com/intrauterine-inseminations.html",
    "phone": "(617) 965-7800",
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.careforwomen.com/intrauterine-inseminations.html",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://www.careforwomen.com/intrauterine-inseminations.html",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Monitored Cycles",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.careforwomen.com/intrauterine-inseminations.html",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.careforwomen.com/practice-locations.html",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.careforwomen.com/intrauterine-inseminations.html",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.careforwomen.com/our-doctors.html",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Thomas L. Beatty, Jr.",
        "role": "Obstetrician-Gynecologist; Chair, Department of Obstetrics & Gynecology, Newton-Wellesley Hospital",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.careforwomen.com/images/thomas-phot-bg.png",
        "_source": {
          "url": "https://www.careforwomen.com/our-doctors.html",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-wellesley-womens-care-thomas-l-beatty-jr"
      },
      {
        "name": "Karie Lin DeVries",
        "role": "Obstetrician-Gynecologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.careforwomen.com/images/karielin-phot-bg.png",
        "_source": {
          "url": "https://www.careforwomen.com/our-doctors.html",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-wellesley-womens-care-karie-lin-devries"
      },
      {
        "name": "Ann L. Dolloff",
        "role": "Obstetrician-Gynecologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.careforwomen.com/images/annldolloff-phot-bg.png",
        "_source": {
          "url": "https://www.careforwomen.com/our-doctors.html",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-wellesley-womens-care-ann-l-dolloff"
      },
      {
        "name": "Afarin Greiger",
        "role": "Obstetrician-Gynecologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.careforwomen.com/images/afarina-phot-bg.png",
        "_source": {
          "url": "https://www.careforwomen.com/our-doctors.html",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-wellesley-womens-care-afarin-greiger"
      },
      {
        "name": "Virginia Simmons",
        "role": "Obstetrician-Gynecologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.careforwomen.com/images/virginia-phot-bg.png",
        "_source": {
          "url": "https://www.careforwomen.com/our-doctors.html",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-wellesley-womens-care-virginia-simmons"
      },
      {
        "name": "Elizabeth Konig",
        "role": "Obstetrician-Gynecologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.careforwomen.com/images/elizabeth-konig-md-facog-profile.jpg",
        "_source": {
          "url": "https://www.careforwomen.com/our-doctors.html",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-wellesley-womens-care-elizabeth-konig"
      },
      {
        "name": "Sandra Reilly",
        "role": "Women's Health Nurse Practitioner",
        "credentials": ["MSN", "NP"],
        "imageUrl": "https://www.careforwomen.com/images/sandra-phot-bg.png",
        "_source": {
          "url": "https://www.careforwomen.com/our-doctors.html",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-wellesley-womens-care-sandra-reilly"
      },
      {
        "name": "Katherine Johnson",
        "role": "Obstetrician-Gynecologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.careforwomen.com/images/dr-katherine-johnson.jpg",
        "_source": {
          "url": "https://www.careforwomen.com/our-doctors.html",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-wellesley-womens-care-katherine-johnson"
      },
      {
        "name": "Thao Thieu",
        "role": "Obstetrician-Gynecologist (Pediatric & Adolescent Gynecology)",
        "credentials": ["MD", "FACOG", "PAG"],
        "imageUrl": "https://www.careforwomen.com/images/thao-thieu-h-small.jpg",
        "_source": {
          "url": "https://www.careforwomen.com/our-doctors.html",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-wellesley-womens-care-thao-thieu"
      },
      {
        "name": "Jinhee K. Oh",
        "role": "Obstetrician-Gynecologist",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://www.careforwomen.com/images/dr-jinhee-ho.jpg",
        "_source": {
          "url": "https://www.careforwomen.com/our-doctors.html",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-wellesley-womens-care-jinhee-k-oh"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Massachusetts (MA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-procreate-virginia-beach-cleveland",
    "externalIds": {
      "googlePlaceId": "ChIJL9KtWdiXuokR-5w63DQsWmw"
    },
    "type": "fertility-clinic",
    "name": "Procreate Fertility Center - Virginia Beach Cleveland",
    "address": {
      "line1": "5741 Cleveland Street, Suite 300",
      "city": "Virginia Beach",
      "state": "VA",
      "zip": "23462",
      "country": "US"
    },
    "location": {
      "lat": 36.8479535,
      "lng": -76.1780604
    },
    "setting": "network-group",
    "network": {
      "name": "Procreate Fertility Center of Virginia"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://procreatefertility.com/",
    "phone": "(757) 977-8500",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://procreatefertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://procreatefertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://procreatefertility.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://procreatefertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://procreatefertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://procreatefertility.com/virginia-beach/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Procreate+Fertility+Center+of+Virginia,+Virginia+Beach,+5741+Cleveland+St+Ste+300,+Virginia+Beach,+VA+23462/@36.8478472,-76.179355,3193a,13.1y/data=!4m2!3m1!1s0x89ba97d859add22f:0x6c5a2c34dc3a9cfb",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Silvina M. Bocca",
        "role": "Reproductive Endocrinologist / Laboratory Director (HCLD)",
        "credentials": ["MD", "PhD", "HCLD"],
        "imageUrl": "https://procreatefertility.com/wp-content/uploads/2026/02/Silvina-Bocca-370x365.png",
        "_source": {
          "url": "https://procreatefertility.com/our-team/silvina-bocca/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-procreate-virginia-beach-cleveland-silvina-m-bocca"
      },
      {
        "name": "Katherine Church",
        "role": "Women's Health Nurse Practitioner",
        "credentials": ["WHNP"],
        "imageUrl": "https://procreatefertility.com/wp-content/uploads/2026/02/Katherine-Duey-procreate-fertility-370x365.png",
        "_source": {
          "url": "https://procreatefertility.com/our-team/katherine-church/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-procreate-virginia-beach-cleveland-katherine-church"
      },
      {
        "name": "Mary Jo Dougherty",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://procreatefertility.com/wp-content/uploads/2026/02/Mary-Jo-Dougherty-370x365.png",
        "_source": {
          "url": "https://procreatefertility.com/our-team/mary-jo-dougherty/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-procreate-virginia-beach-cleveland-mary-jo-dougherty"
      },
      {
        "name": "Kierra Blount",
        "role": "Third Party Coordinator",
        "credentials": [],
        "imageUrl": "https://procreatefertility.com/wp-content/uploads/2026/02/Kierra-Blount-370x365.png",
        "_source": {
          "url": "https://procreatefertility.com/our-team/kierra-blount/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-procreate-virginia-beach-cleveland-kierra-blount"
      }
    ],
    "images": [
      {
        "url": "https://procreatefertility.com/wp-content/uploads/2026/01/fertility-doctor-virginia-beach.png",
        "type": "exterior",
        "caption": "Building exterior of Procreate Fertility Center at 5741 Cleveland Street, Virginia Beach (the '5741' street number is visible on the building, matching the clinic address).",
        "_source": {
          "url": "https://procreatefertility.com/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlc9W2jmqLOFXxRf1Vatv9TQwR0ZsFErsxpLzyd5p2nsU4g9Fa_H81TEqLJwF0AanxGLyuIcLHv3BwhOD2Wk-Vg0y5sQVzKw4C8D5aAJsajibI5NK2a5ymDW4-LokXhP0tPT-ag7gGRYh5i=w594-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Procreate+Fertility+Center+of+Virginia,+Virginia+Beach,+5741+Cleveland+St+Ste+300,+Virginia+Beach,+VA+23462/@36.8478472,-76.179355,3193a,13.1y/data=!4m2!3m1!1s0x89ba97d859add22f:0x6c5a2c34dc3a9cfb",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-procreate-first-colonial",
    "externalIds": {
      "googlePlaceId": "ChIJf033Xm_ruokRnl6DT2UFuLE"
    },
    "type": "fertility-clinic",
    "name": "Procreate Fertility Center - First Colonial",
    "address": {
      "line1": "968 First Colonial Road, Suite 101",
      "city": "Virginia Beach",
      "state": "VA",
      "zip": "23454",
      "country": "US"
    },
    "location": {
      "lat": 36.8590217,
      "lng": -76.026183
    },
    "setting": "network-group",
    "network": {
      "name": "Procreate Fertility Center of Virginia"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://procreatefertility.com/first-colonial/",
    "phone": "(757) 977-8500",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://procreatefertility.com/first-colonial/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://procreatefertility.com/first-colonial/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://procreatefertility.com/first-colonial/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://procreatefertility.com/first-colonial/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://procreatefertility.com/first-colonial/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Procreate+Fertility+Center+of+Virginia,+Virginia+Beach,+First+Colonial,+968+First+Colonial+Rd+Ste+101,+Virginia+Beach,+VA+23454/@36.8590797,-76.0257628,3192a,13.1y/data=!4m2!3m1!1s0x89baeb6f5ef74d7f:0xb1b805654f835e9e",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://procreatefertility.com/wp-content/uploads/2026/01/fertility-doctor-first-colonial.png",
        "type": "exterior",
        "caption": "Exterior of the Procreate Fertility Center - First Colonial office building at 968 First Colonial Road, Suite 101, Virginia Beach, VA",
        "_source": {
          "url": "https://procreatefertility.com/first-colonial/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-procreate-newport-news",
    "externalIds": {
      "googlePlaceId": "ChIJb2b7cnl5sIkR-o6c7zJrLFM"
    },
    "type": "fertility-clinic",
    "name": "Procreate Fertility Center - Newport News",
    "address": {
      "line1": "11848 Rock Landing Drive, Suite 101",
      "city": "Newport News",
      "state": "VA",
      "zip": "23606",
      "country": "US"
    },
    "location": {
      "lat": 37.0953347,
      "lng": -76.4675629
    },
    "setting": "network-group",
    "network": {
      "name": "Procreate Fertility Center of Virginia"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://procreatefertility.com/newport-news/",
    "phone": "(757) 977-8500",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://procreatefertility.com/newport-news/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://procreatefertility.com/newport-news/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://procreatefertility.com/newport-news/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://procreatefertility.com/newport-news/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://procreatefertility.com/newport-news/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://procreatefertility.com/newport-news/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Procreate+Fertility+Center+of+Virginia,+Newport+News,+11848+Rock+Landing+Dr+Ste+101,+Newport+News,+VA+23606/@37.0961899,-76.4673652,3182a,13.1y/data=!4m2!3m1!1s0x89b0797972fb666f:0x532c6b32ef9c8efa",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Christian Perez",
        "role": "Reproductive Endocrinologist (Founder, Board-Certified RE)",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://procreatefertility.com/wp-content/uploads/2021/12/Christian-Perez-370x365.jpg",
        "_source": {
          "url": "https://procreatefertility.com/our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-procreate-newport-news-christian-perez"
      },
      {
        "name": "Silvina M. Bocca",
        "role": "Reproductive Endocrinologist / Laboratory Director (HCLD)",
        "credentials": ["MD", "PhD", "HCLD"],
        "imageUrl": "https://procreatefertility.com/wp-content/uploads/2026/02/Silvina-Bocca-370x365.png",
        "_source": {
          "url": "https://procreatefertility.com/our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-procreate-newport-news-silvina-m-bocca"
      },
      {
        "name": "Christina Jackson",
        "role": "Physician (OB/GYN)",
        "credentials": ["DO", "FACOG"],
        "imageUrl": "https://procreatefertility.com/wp-content/uploads/2025/10/Christina-Jackson-DO-370x365.png",
        "_source": {
          "url": "https://procreatefertility.com/our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-procreate-newport-news-christina-jackson"
      },
      {
        "name": "Katherine Church",
        "role": "Women's Health Nurse Practitioner",
        "credentials": ["WHNP"],
        "imageUrl": "https://procreatefertility.com/wp-content/uploads/2026/02/Katherine-Duey-procreate-fertility-370x365.png",
        "_source": {
          "url": "https://procreatefertility.com/our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-procreate-newport-news-katherine-church"
      },
      {
        "name": "Stacey Seeley",
        "role": "Women's Health Nurse Practitioner",
        "credentials": ["MSN", "APRN", "WHNP-BC"],
        "imageUrl": "https://procreatefertility.com/wp-content/uploads/2026/02/Stacey-Seeley-370x365.png",
        "_source": {
          "url": "https://procreatefertility.com/our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-procreate-newport-news-stacey-seeley"
      },
      {
        "name": "Mary Jo Dougherty",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://procreatefertility.com/wp-content/uploads/2026/02/Mary-Jo-Dougherty-370x365.png",
        "_source": {
          "url": "https://procreatefertility.com/our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-procreate-newport-news-mary-jo-dougherty"
      },
      {
        "name": "Kristen Miller",
        "role": "Physician Assistant",
        "credentials": ["MPA", "PA-C"],
        "imageUrl": "https://procreatefertility.com/wp-content/uploads/2026/02/Procreate-Kristen-Miller-370x365.png",
        "_source": {
          "url": "https://procreatefertility.com/our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-procreate-newport-news-kristen-miller"
      },
      {
        "name": "Tricia Wahl",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "imageUrl": "https://procreatefertility.com/wp-content/uploads/2026/02/Tricia-Wahl-370x365.png",
        "_source": {
          "url": "https://procreatefertility.com/our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-procreate-newport-news-tricia-wahl"
      },
      {
        "name": "Jennifer Patrick",
        "role": "Laboratory Director",
        "credentials": [],
        "imageUrl": "https://procreatefertility.com/wp-content/uploads/2022/06/Patrick-Jennifer-370x365.png",
        "_source": {
          "url": "https://procreatefertility.com/our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-procreate-newport-news-jennifer-patrick"
      },
      {
        "name": "Lucy Lynch",
        "role": "Laboratory Manager",
        "credentials": [],
        "imageUrl": "https://procreatefertility.com/wp-content/uploads/2026/02/Lucy-Lynch-370x365.png",
        "_source": {
          "url": "https://procreatefertility.com/our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-procreate-newport-news-lucy-lynch"
      },
      {
        "name": "Kierra Blount",
        "role": "Third Party Coordinator",
        "credentials": [],
        "imageUrl": "https://procreatefertility.com/wp-content/uploads/2026/02/Kierra-Blount-370x365.png",
        "_source": {
          "url": "https://procreatefertility.com/our-team/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-procreate-newport-news-kierra-blount"
      }
    ],
    "images": [
      {
        "url": "https://procreatefertility.com/wp-content/uploads/2026/03/fertility-clinic-newport-news.png",
        "type": "exterior",
        "caption": "Exterior of the Procreate Fertility Center building at 11848 Rock Landing Drive, Newport News, VA - single-story brick and stucco office with arched entrance and parking lot.",
        "_source": {
          "url": "https://procreatefertility.com/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-sgf-virginia-beach",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Shady Grove Fertility Virginia Beach",
    "address": {
      "line1": "6161 Kempsville Circle, Suite 220",
      "city": "Norfolk",
      "state": "VA",
      "zip": "23502",
      "country": "US"
    },
    "location": {
      "lat": 36.8523661,
      "lng": -76.1932788
    },
    "setting": "network-group",
    "network": {
      "name": "US Fertility"
    },
    "consultationTypes": ["in-person", "telehealth"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.shadygrovefertility.com/locations/virginia/virginia-beach-fertility-center/",
    "phone": "(757) 807-6663",
    "treatments": [
      {
        "name": "Fertility Consultations",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/virginia/virginia-beach-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Monitoring",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/virginia/virginia-beach-fertility-center/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.shadygrovefertility.com/virginia/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.shadygrovefertility.com/virginia/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.shadygrovefertility.com/virginia/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/virginia/virginia-beach-fertility-center/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/virginia/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/virginia/virginia-beach-fertility-center/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Benjamin S. Harris",
        "role": "Reproductive Endocrinologist (Medical Director, Southern Virginia)",
        "credentials": ["MD", "MPH"],
        "imageUrl": "https://www.shadygrovefertility.com/wp-content/uploads/2022/09/Benjamin-Harris-profile1.jpg",
        "_source": {
          "url": "https://www.shadygrovefertility.com/our-care-team/doctors/benjamin-harris/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-sgf-virginia-beach-benjamin-s-harris"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-naval-medical-center-portsmouth-rei",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Naval Medical Center Portsmouth Reproductive Endocrinology and Infertility",
    "address": {
      "line1": "620 John Paul Jones Circle",
      "city": "Portsmouth",
      "state": "VA",
      "zip": "23708",
      "country": "US"
    },
    "location": {
      "lat": 36.8433891,
      "lng": -76.3050007
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://portsmouth.tricare.mil/Health-Services/Womens-Health/Reproductive-Endocrinology-Infertility-clinic",
    "phone": "(757) 953-2600",
    "treatments": [
      {
        "name": "Infertility Consultation",
        "category": "diagnostic",
        "_source": {
          "url": "https://portsmouth.tricare.mil/Health-Services/Womens-Health/Reproductive-Endocrinology-Infertility-clinic",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Pelvic Ultrasound",
        "category": "diagnostic",
        "_source": {
          "url": "https://portsmouth.tricare.mil/Health-Services/Womens-Health/Reproductive-Endocrinology-Infertility-clinic",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Saline Infusion Sonogram",
        "category": "diagnostic",
        "_source": {
          "url": "https://portsmouth.tricare.mil/Health-Services/Womens-Health/Reproductive-Endocrinology-Infertility-clinic",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://portsmouth.tricare.mil/Health-Services/Womens-Health/Reproductive-Endocrinology-Infertility-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://portsmouth.tricare.mil/Health-Services/Womens-Health/Reproductive-Endocrinology-Infertility-clinic",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://portsmouth.tricare.mil/Health-Services/Womens-Health/Reproductive-Endocrinology-Infertility-clinic",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Joshua C. Combs",
        "role": "Chief of Reproductive Medicine (Reproductive Endocrinologist), REI clinic provider",
        "credentials": ["MD", "FACOG", "Lt Col USAF MC"],
        "imageUrl": "https://cdn.shopify.com/s/files/1/0255/4237/files/JoshuaCombs125145.jpg?v=1749739001",
        "_source": {
          "url": "https://www.americasboardreview.com/pages/faculty-joshua-combs-md-facog",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-naval-medical-center-portsmouth-rei-joshua-c-combs"
      }
    ],
    "images": [
      {
        "url": "https://d1ldvf68ux039x.cloudfront.net/thumbs/photos/1812/4942345/1000w_q95.jpg",
        "type": "exterior",
        "caption": "Exterior view of the Naval Medical Center Portsmouth hospital complex across the Elizabeth River (official U.S. Navy / DVIDS photo).",
        "_source": {
          "url": "https://www.dvidshub.net/image/4942345/view-naval-medical-center-portsmouth",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-uva-reproductive-endocrinology",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "UVA Reproductive Endocrinology and Infertility",
    "address": {
      "line1": "1221 Lee Street, 3rd Floor",
      "city": "Charlottesville",
      "state": "VA",
      "zip": "22903",
      "country": "US"
    },
    "location": {
      "lat": 38.0324386,
      "lng": -78.4998302
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://med.virginia.edu/obgyn/divisions/reproductive-endocrinology-and-infertility/",
    "phone": "(434) 924-1955",
    "treatments": [
      {
        "name": "Infertility Evaluation",
        "category": "diagnostic",
        "_source": {
          "url": "https://med.virginia.edu/obgyn/divisions/reproductive-endocrinology-and-infertility/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Infertility Treatment",
        "category": "art",
        "_source": {
          "url": "https://med.virginia.edu/obgyn/divisions/reproductive-endocrinology-and-infertility/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://med.virginia.edu/obgyn/divisions/reproductive-endocrinology-and-infertility/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://med.virginia.edu/obgyn/divisions/reproductive-endocrinology-and-infertility/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://med.virginia.edu/obgyn/divisions/reproductive-endocrinology-and-infertility/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Linnea R. Goodman, MD",
        "role": "Reproductive Endocrinologist (Reproductive Endocrinology and Infertility)",
        "credentials": ["MD"],
        "imageUrl": "https://med.virginia.edu/obgyn/wp-content/uploads/sites/286/2023/06/Linnea-R-Goodman-MD-3-222x300.jpg",
        "_source": {
          "url": "https://med.virginia.edu/obgyn/faculty-and-staff/reproductive-endocrinology-and-infertility-staff/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-uva-reproductive-endocrinology-linnea-r-goodman-md"
      },
      {
        "name": "Laura P. Smith, MD",
        "role": "Reproductive Endocrinologist (Reproductive Endocrinology and Infertility)",
        "credentials": ["MD"],
        "imageUrl": "https://med.virginia.edu/obgyn/wp-content/uploads/sites/286/2017/08/SmithLaura-email-compressed-225x300.jpg",
        "_source": {
          "url": "https://med.virginia.edu/obgyn/faculty-and-staff/reproductive-endocrinology-and-infertility-staff/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-uva-reproductive-endocrinology-laura-p-smith-md"
      },
      {
        "name": "Chris D. Williams, MD",
        "role": "Reproductive Endocrinologist (Reproductive Endocrinology and Infertility)",
        "credentials": ["MD"],
        "imageUrl": "https://med.virginia.edu/obgyn/wp-content/uploads/sites/286/2017/08/WilliamsChristopher-email-compressed-225x300.jpg",
        "_source": {
          "url": "https://med.virginia.edu/obgyn/faculty-and-staff/reproductive-endocrinology-and-infertility-staff/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-uva-reproductive-endocrinology-chris-d-williams-md"
      }
    ],
    "images": [
      {
        "url": "https://discovercharlottesville.com/wp-content/uploads/2023/01/UVA-Primary-Care-Center-Entrance-800x450-1.jpg",
        "type": "exterior",
        "caption": "Exterior entrance of the UVA Health Primary Care Center at 1221 Lee Street, Charlottesville, where UVA Reproductive Endocrinology and Infertility is located on the 3rd floor (building signage reads 'Primary Care Center').",
        "_source": {
          "url": "https://discovercharlottesville.com/listings/primary-care-center-uva-health/",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://cdn-assets-us.frontify.com/s3/frontify-enterprise-files-us/eyJwYXRoIjoidXZhLWhlYWx0aFwvZmlsZVwvRktFOVZpTTRxMUVmYUp0c3IxZ3cuanBnIn0:uva-health:etZGxuuFj6bh2vAxwZ6ScjzZmRCF2fYLIQSjPNKhYFA?width=400",
        "type": "exterior",
        "caption": "UVA Health campus showing the University Hospital / Primary Care Center complex in Charlottesville (official UVA Health location image for the Primary Care Center).",
        "_source": {
          "url": "https://www.uvahealth.com/locations/Primary-Care-Center-LOC0000237704",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-valley-health-fertility",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Valley Health Fertility",
    "address": {
      "line1": "611 W Jubal Early Drive, Suite A1",
      "city": "Winchester",
      "state": "VA",
      "zip": "22601",
      "country": "US"
    },
    "location": {
      "lat": 39.1712823,
      "lng": -78.1841116
    },
    "setting": "hospital-based",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.valleyhealthlink.com/our-locations/profile/valley-health-fertility/",
    "phone": "(540) 536-7960",
    "treatments": [
      {
        "name": "Intrauterine Insemination (IUI)",
        "category": "art",
        "_source": {
          "url": "https://www.valleyhealthlink.com/our-locations/profile/valley-health-fertility/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF Monitoring",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.valleyhealthlink.com/our-locations/profile/valley-health-fertility/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://www.valleyhealthlink.com/our-locations/profile/valley-health-fertility/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Preservation",
        "category": "preservation",
        "_source": {
          "url": "https://www.valleyhealthlink.com/our-locations/profile/valley-health-fertility/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.valleyhealthlink.com/our-locations/profile/valley-health-fertility/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.valleyhealthlink.com/our-locations/profile/valley-health-fertility/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-river-city-obgyn-fertility",
    "externalIds": {},
    "type": "medical-practice",
    "name": "River City OB/GYN Fertility",
    "address": {
      "line1": "13710 St. Francis Boulevard, Suite 603",
      "city": "Midlothian",
      "state": "VA",
      "zip": "23114",
      "country": "US"
    },
    "location": {
      "lat": 37.4658976,
      "lng": -77.6614227
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "website": "https://rivercityobgyn.com/",
    "phone": "(804) 362-0808",
    "treatments": [
      {
        "name": "Fertility Care",
        "category": "diagnostic",
        "_source": {
          "url": "https://rivercityobgyn.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ultrasound-Guided Fertility",
        "category": "diagnostic",
        "_source": {
          "url": "https://rivercityobgyn.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://rivercityobgyn.com/contact/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://rivercityobgyn.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rivercityobgyn.com/meet-the-team/",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Christopher Paoloni",
        "role": "Board Certified Obstetrician-Gynecologist (Founder & Owner)",
        "credentials": ["MD", "FACOG"],
        "imageUrl": "https://rivercityobgyn.com/wp-content/uploads/2023/11/River-City-OBGYN-Headshot-Dr-Christopher-Paoloni-18-e1699542639969.jpg",
        "_source": {
          "url": "https://rivercityobgyn.com/about-dr-paoloni/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-river-city-obgyn-fertility-christopher-paoloni"
      },
      {
        "name": "Lindsey Brookmire",
        "role": "Women's Health Nurse Practitioner",
        "credentials": ["MSN", "WHNP-BC"],
        "imageUrl": "https://rivercityobgyn.com/wp-content/uploads/2023/11/River-City-OBGYN-Headshot-Lindsey-Brookmire-15-e1699542663618.jpg",
        "_source": {
          "url": "https://rivercityobgyn.com/about-lindsey-brookmire/",
          "fetchedAt": "2026-06-14"
        },
        "practitionerId": "pr-org-web-river-city-obgyn-fertility-lindsey-brookmire"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Virginia (VA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-geisinger-wilkes-barre-fertility",
    "externalIds": {
      "googlePlaceId": "ChIJhxYV1osbxYkRBWs-90FvfsU"
    },
    "type": "fertility-clinic",
    "name": "Geisinger Wilkes Barre - Fertility",
    "address": {
      "line1": "1155 East Mountain Boulevard",
      "city": "Wilkes-Barre",
      "state": "PA",
      "zip": "18702",
      "country": "US"
    },
    "location": {
      "lat": 41.2518034,
      "lng": -75.8124737
    },
    "setting": "hospital-based",
    "network": {
      "name": "Geisinger"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.geisinger.org/patient-care/conditions-treatments-specialty/fertility-treatments",
    "phone": "(800) 275-6401",
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.geisinger.org/patient-care/conditions-treatments-specialty/fertility-treatments",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.geisinger.org/patient-care/conditions-treatments-specialty/fertility-treatments",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.geisinger.org/patient-care/conditions-treatments-specialty/fertility-treatments",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://providers.geisinger.org/provider/jennifer-sue-gell/756921",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.geisinger.org/patient-care/conditions-treatments-specialty/fertility-treatments",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://providers.geisinger.org/provider/jennifer-sue-gell/756921",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Geisinger+East+Mountain+Specialty+Clinic,+1155+E+Mountain+Blvd,+Wilkes-Barre,+PA+18702/@41.2507747,-75.8097745,3000a,13.1y/data=!4m2!3m1!1s0x89c51b8bd6151687:0xc57e6f41f73e6b05",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Jennifer Sue Gell, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://www.geisinger.org/-/media/OneGeisinger/Images/providers/gell-j-1275501926.jpg?sc_lang=en&hash=E01388495B2D66A6BF5BF50E01EF1B47",
        "_source": {
          "url": "https://providers.geisinger.org/provider/jennifer-sue-gell/756921",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-geisinger-wilkes-barre-fertility-jennifer-sue-gell-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-geisinger-state-college-fertility",
    "externalIds": {
      "googlePlaceId": "ChIJL1V0SE4dzIkRkEORpsSHIdY"
    },
    "type": "fertility-clinic",
    "name": "Geisinger Healthplex State College Fertility",
    "address": {
      "line1": "132 Abigail Lane",
      "city": "Port Matilda",
      "state": "PA",
      "zip": "16870",
      "country": "US"
    },
    "location": {
      "lat": 40.8142539,
      "lng": -77.9420521
    },
    "setting": "hospital-based",
    "network": {
      "name": "Geisinger"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.geisinger.org/patient-care/conditions-treatments-specialty/fertility-treatments",
    "phone": "(814) 272-5011",
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.geisinger.org/patient-care/conditions-treatments-specialty/fertility-treatments",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.geisinger.org/patient-care/conditions-treatments-specialty/fertility-treatments",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.geisinger.org/patient-care/conditions-treatments-specialty/fertility-treatments",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://providers.geisinger.org/provider/lydia-singer/2440935",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.geisinger.org/patient-care/conditions-treatments-specialty/fertility-treatments",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Geisinger+Healthplex+State+College,+132+Abigail+Ln,+Port+Matilda,+PA+16870/@40.8145665,-77.9418283,3020a,13.1y/data=!4m2!3m1!1s0x89cc1d4e4874552f:0xd62187c4a6914390",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-main-line-fertility-philadelphia",
    "externalIds": {
      "googlePlaceId": "ChIJQTr23CbGxokREjMtxX6FjUM"
    },
    "type": "fertility-clinic",
    "name": "Main Line Fertility - Philadelphia",
    "address": {
      "line1": "1650 Arch Street, Suite 1907",
      "city": "Philadelphia",
      "state": "PA",
      "zip": "19103",
      "country": "US"
    },
    "location": {
      "lat": 39.9548565,
      "lng": -75.1672033
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.mainlinefertility.com/fertility-clinics/philadelphia",
    "phone": "(610) 527-0800",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-clinics/philadelphia",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-clinics/philadelphia",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-clinics/philadelphia",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.mainlinefertility.com/fertility-clinics/philadelphia",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.mainlinefertility.com/fertility-clinics/philadelphia",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.mainlinefertility.com/fertility-clinics/philadelphia",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Main+Line+Fertility,+1650+Arch+St+Ste+1907,+Philadelphia,+PA+19103/@39.9547002,-75.1675639,3058a,13.1y/data=!4m2!3m1!1s0x89c6c626dcf63a41:0x438d857ec52d3312",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Michael J. Glassner, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.buttercms.com/LJcH8BlKRCWDYk7WldTU",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-philadelphia-michael-j-glassner-md"
      },
      {
        "name": "Deanna R. Brasile, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "imageUrl": "https://cdn.buttercms.com/QNWDauTvRtmVmBffRYxC",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-philadelphia-deanna-r-brasile-do"
      },
      {
        "name": "Allison Bloom, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "imageUrl": "https://cdn.buttercms.com/pmwj4gofTfmgmKfw2Htt",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-philadelphia-allison-bloom-do"
      },
      {
        "name": "Shahab Minassian, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.buttercms.com/Sg6yiMuRGWI0J0hN2dkA",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-philadelphia-shahab-minassian-md"
      },
      {
        "name": "Jenna Kahn, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.buttercms.com/6lYzdfGTuEEA8tEmRLQg",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-philadelphia-jenna-kahn-md"
      },
      {
        "name": "Shannon Alexa, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "imageUrl": "https://cdn.buttercms.com/srYom1bNTDGa6byClbVY",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-philadelphia-shannon-alexa-do"
      },
      {
        "name": "Ben Gocial, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.buttercms.com/K1VJbgdqRaurRrTSYV1e",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-philadelphia-ben-gocial-md"
      },
      {
        "name": "Gina Menarde, MSN, CRNP",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "CRNP"],
        "imageUrl": "https://cdn.buttercms.com/AfBIbiPS6GFxuRgac9NR",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-philadelphia-gina-menarde-msn-crnp"
      },
      {
        "name": "Allison Tomack, PA-C, MPAS",
        "role": "Physician Assistant",
        "credentials": ["PA-C", "MPAS"],
        "imageUrl": "https://cdn.buttercms.com/c6tKozQPG8sgrstm28gw",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-philadelphia-allison-tomack-pa-c-mpas"
      },
      {
        "name": "Rachel Bruner, NP-C",
        "role": "Nurse Practitioner",
        "credentials": ["NP-C"],
        "imageUrl": "https://cdn.buttercms.com/Unu3HVnDQHO12BdSAcPn",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-philadelphia-rachel-bruner-np-c"
      },
      {
        "name": "Katie Gavern, MSN, CRNP, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "CRNP", "WHNP-BC"],
        "imageUrl": "https://cdn.buttercms.com/bMD6qLsRQjeoUzxc5068",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-philadelphia-katie-gavern-msn-crnp-whnp-bc"
      },
      {
        "name": "Sydney Gocial, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["WHNP-BC"],
        "imageUrl": "https://cdn.buttercms.com/7h9Ld17QQ6SvMxkfjHhw",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-philadelphia-sydney-gocial-whnp-bc"
      }
    ],
    "images": [
      {
        "url": "https://cdn.buttercms.com/vnMLppLRRoOYlkrlY4Ma",
        "type": "exterior",
        "caption": "Main Line Fertility Philadelphia clinic",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-clinics/philadelphia",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-main-line-fertility-west-chester",
    "externalIds": {
      "googlePlaceId": "ChIJe2APEtzzxokRzotEqS6Uet0"
    },
    "type": "fertility-clinic",
    "name": "Main Line Fertility - West Chester",
    "address": {
      "line1": "915 Old Fern Hill Road, Suite 101, Building B",
      "city": "West Chester",
      "state": "PA",
      "zip": "19380",
      "country": "US"
    },
    "location": {
      "lat": 39.9791316,
      "lng": -75.5915824
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.mainlinefertility.com/fertility-clinics/west-chester",
    "phone": "(610) 527-0800",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-clinics/west-chester",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-clinics/west-chester",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-clinics/west-chester",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.mainlinefertility.com/fertility-clinics/west-chester",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.mainlinefertility.com/fertility-clinics/west-chester",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.mainlinefertility.com/fertility-clinics/west-chester",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Main+Line+Fertility,+915+Old+Fern+Hill+Rd+Ste+101,+Building+B,+West+Chester,+PA+19380/@39.9800296,-75.592073,3057a,13.1y/data=!4m2!3m1!1s0x89c6f3dc120f607b:0xdd7a942ea9448bce",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Michael J. Glassner, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.buttercms.com/LJcH8BlKRCWDYk7WldTU",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-west-chester-michael-j-glassner-md"
      },
      {
        "name": "Deanna R. Brasile, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "imageUrl": "https://cdn.buttercms.com/QNWDauTvRtmVmBffRYxC",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-west-chester-deanna-r-brasile-do"
      },
      {
        "name": "Allison Bloom, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "imageUrl": "https://cdn.buttercms.com/pmwj4gofTfmgmKfw2Htt",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-west-chester-allison-bloom-do"
      },
      {
        "name": "Shahab Minassian, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.buttercms.com/Sg6yiMuRGWI0J0hN2dkA",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-west-chester-shahab-minassian-md"
      },
      {
        "name": "Jenna Kahn, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.buttercms.com/6lYzdfGTuEEA8tEmRLQg",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-west-chester-jenna-kahn-md"
      },
      {
        "name": "Shannon Alexa, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "imageUrl": "https://cdn.buttercms.com/srYom1bNTDGa6byClbVY",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-west-chester-shannon-alexa-do"
      },
      {
        "name": "Ben Gocial, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.buttercms.com/K1VJbgdqRaurRrTSYV1e",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-west-chester-ben-gocial-md"
      },
      {
        "name": "Gina Menarde, MSN, CRNP",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "CRNP"],
        "imageUrl": "https://cdn.buttercms.com/AfBIbiPS6GFxuRgac9NR",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-west-chester-gina-menarde-msn-crnp"
      },
      {
        "name": "Allison Tomack, PA-C, MPAS",
        "role": "Physician Assistant",
        "credentials": ["PA-C", "MPAS"],
        "imageUrl": "https://cdn.buttercms.com/c6tKozQPG8sgrstm28gw",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-west-chester-allison-tomack-pa-c-mpas"
      },
      {
        "name": "Rachel Bruner, NP-C",
        "role": "Nurse Practitioner",
        "credentials": ["NP-C"],
        "imageUrl": "https://cdn.buttercms.com/Unu3HVnDQHO12BdSAcPn",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-west-chester-rachel-bruner-np-c"
      },
      {
        "name": "Katie Gavern, MSN, CRNP, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "CRNP", "WHNP-BC"],
        "imageUrl": "https://cdn.buttercms.com/bMD6qLsRQjeoUzxc5068",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-west-chester-katie-gavern-msn-crnp-whnp-bc"
      },
      {
        "name": "Sydney Gocial, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["WHNP-BC"],
        "imageUrl": "https://cdn.buttercms.com/7h9Ld17QQ6SvMxkfjHhw",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-west-chester-sydney-gocial-whnp-bc"
      }
    ],
    "images": [
      {
        "url": "https://cdn.buttercms.com/f6n50XtRBuduyrucxZxt",
        "type": "exterior",
        "caption": "Main Line Fertility West Chester clinic",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-clinics/west-chester",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkH7OAfTOQTSgIJqbONxw282d2yuniHjTOJnipl9U0xuPxWsRk76noG7NaBNaYEQctJikhqc3xSZG6ezwvuXiRM28FfLd7Bv1m-yiSk-oWefMj3YdhBOfrBg8TBTed0m2SYBMvqqg=w530-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Main+Line+Fertility,+915+Old+Fern+Hill+Rd+Ste+101,+Building+B,+West+Chester,+PA+19380/@39.9800296,-75.592073,3057a,13.1y/data=!4m2!3m1!1s0x89c6f3dc120f607b:0xdd7a942ea9448bce",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnKU-Uud4nsDtKIgHxFWXMDKs8ya2v54aTJ93H7ap_88uJzklxZiOTmNbWfy7j7aakcx91ZEhBMAu1yzuc4lTIzAwIp-d1MMt6si9Ze1eUJBsxK3UwPpTvok4xe5EgXbLPGEpryxoP1LVY=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Main+Line+Fertility,+915+Old+Fern+Hill+Rd+Ste+101,+Building+B,+West+Chester,+PA+19380/@39.9800296,-75.592073,3057a,13.1y/data=!4m2!3m1!1s0x89c6f3dc120f607b:0xdd7a942ea9448bce",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-main-line-fertility-havertown",
    "externalIds": {
      "googlePlaceId": "ChIJ_5iDrQfBxokRuegXBKwmnkk"
    },
    "type": "fertility-clinic",
    "name": "Main Line Fertility - Havertown",
    "address": {
      "line1": "2010 West Chester Pike, Suite 350",
      "city": "Havertown",
      "state": "PA",
      "zip": "19083",
      "country": "US"
    },
    "location": {
      "lat": 39.976282,
      "lng": -75.3325913
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.mainlinefertility.com/fertility-clinics/havertown",
    "phone": "(610) 527-0800",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-clinics/havertown",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-clinics/havertown",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-clinics/havertown",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.mainlinefertility.com/fertility-clinics/havertown",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.mainlinefertility.com/fertility-clinics/havertown",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.mainlinefertility.com/fertility-clinics/havertown",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Main+Line+Fertility,+2010+West+Chester+Pike+Ste+350,+Havertown,+PA+19083/@39.9760253,-75.3336566,3057a,13.1y/data=!4m2!3m1!1s0x89c6c107ad8398ff:0x499e26ac0417e8b9",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Michael J. Glassner, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.buttercms.com/LJcH8BlKRCWDYk7WldTU",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-havertown-michael-j-glassner-md"
      },
      {
        "name": "Deanna R. Brasile, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "imageUrl": "https://cdn.buttercms.com/QNWDauTvRtmVmBffRYxC",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-havertown-deanna-r-brasile-do"
      },
      {
        "name": "Allison Bloom, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "imageUrl": "https://cdn.buttercms.com/pmwj4gofTfmgmKfw2Htt",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-havertown-allison-bloom-do"
      },
      {
        "name": "Shahab Minassian, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.buttercms.com/Sg6yiMuRGWI0J0hN2dkA",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-havertown-shahab-minassian-md"
      },
      {
        "name": "Jenna Kahn, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.buttercms.com/6lYzdfGTuEEA8tEmRLQg",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-havertown-jenna-kahn-md"
      },
      {
        "name": "Shannon Alexa, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "imageUrl": "https://cdn.buttercms.com/srYom1bNTDGa6byClbVY",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-havertown-shannon-alexa-do"
      },
      {
        "name": "Ben Gocial, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.buttercms.com/K1VJbgdqRaurRrTSYV1e",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-havertown-ben-gocial-md"
      },
      {
        "name": "Gina Menarde, MSN, CRNP",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "CRNP"],
        "imageUrl": "https://cdn.buttercms.com/AfBIbiPS6GFxuRgac9NR",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-havertown-gina-menarde-msn-crnp"
      },
      {
        "name": "Allison Tomack, PA-C, MPAS",
        "role": "Physician Assistant",
        "credentials": ["PA-C", "MPAS"],
        "imageUrl": "https://cdn.buttercms.com/c6tKozQPG8sgrstm28gw",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-havertown-allison-tomack-pa-c-mpas"
      },
      {
        "name": "Rachel Bruner, NP-C",
        "role": "Nurse Practitioner",
        "credentials": ["NP-C"],
        "imageUrl": "https://cdn.buttercms.com/Unu3HVnDQHO12BdSAcPn",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-havertown-rachel-bruner-np-c"
      },
      {
        "name": "Katie Gavern, MSN, CRNP, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "CRNP", "WHNP-BC"],
        "imageUrl": "https://cdn.buttercms.com/bMD6qLsRQjeoUzxc5068",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-havertown-katie-gavern-msn-crnp-whnp-bc"
      },
      {
        "name": "Sydney Gocial, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["WHNP-BC"],
        "imageUrl": "https://cdn.buttercms.com/7h9Ld17QQ6SvMxkfjHhw",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-havertown-sydney-gocial-whnp-bc"
      }
    ],
    "images": [
      {
        "url": "https://cdn.buttercms.com/LdcUaeUaRUi8Zv59KlVR",
        "type": "exterior",
        "caption": "Main Line Fertility Havertown clinic",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-clinics/havertown",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn8DvebDEUtO5N6oZwDlTuk-l_KqAHs9Uwiemf0XOQyGtkFHMyuWtZcBQlvn2qqsliU9UnoyiRq-zzl8l4KyANTV54tk4TSL77XRxnbzkz_p9LJ-cepcXv_eZIPvYKf4CxuYrW5=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Main+Line+Fertility,+2010+West+Chester+Pike+Ste+350,+Havertown,+PA+19083/@39.9760253,-75.3336566,3057a,13.1y/data=!4m2!3m1!1s0x89c6c107ad8398ff:0x499e26ac0417e8b9",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-main-line-fertility-wyomissing",
    "externalIds": {
      "googlePlaceId": "ChIJHeKGlK5xxokRQ3efIoeh2h0"
    },
    "type": "fertility-clinic",
    "name": "Main Line Fertility - Wyomissing",
    "address": {
      "line1": "2210 Ridgewood Road",
      "city": "Wyomissing",
      "state": "PA",
      "zip": "19610",
      "country": "US"
    },
    "location": {
      "lat": 40.3444337,
      "lng": -75.97782
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.mainlinefertility.com/fertility-clinics/reading",
    "phone": "(484) 258-2880",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-clinics/reading",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-clinics/reading",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-clinics/reading",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://towerhealth.org/locations/main-line-fertility-wyomissing",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.mainlinefertility.com/fertility-clinics/reading",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.mainlinefertility.com/fertility-clinics/reading",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Main+Line+Fertility,+2210+Ridgewood+Rd,+Wyomissing,+PA+19610/@40.344522,-75.976683,3041a,13.1y/data=!4m2!3m1!1s0x89c671ae9486e21d:0x1ddaa187229f7743",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Michael J. Glassner, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.buttercms.com/LJcH8BlKRCWDYk7WldTU",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-wyomissing-michael-j-glassner-md"
      },
      {
        "name": "Deanna R. Brasile, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "imageUrl": "https://cdn.buttercms.com/QNWDauTvRtmVmBffRYxC",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-wyomissing-deanna-r-brasile-do"
      },
      {
        "name": "Allison Bloom, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "imageUrl": "https://cdn.buttercms.com/pmwj4gofTfmgmKfw2Htt",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-wyomissing-allison-bloom-do"
      },
      {
        "name": "Shahab Minassian, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.buttercms.com/Sg6yiMuRGWI0J0hN2dkA",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-wyomissing-shahab-minassian-md"
      },
      {
        "name": "Jenna Kahn, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.buttercms.com/6lYzdfGTuEEA8tEmRLQg",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-wyomissing-jenna-kahn-md"
      },
      {
        "name": "Shannon Alexa, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "imageUrl": "https://cdn.buttercms.com/srYom1bNTDGa6byClbVY",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-wyomissing-shannon-alexa-do"
      },
      {
        "name": "Ben Gocial, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.buttercms.com/K1VJbgdqRaurRrTSYV1e",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-wyomissing-ben-gocial-md"
      },
      {
        "name": "Gina Menarde, MSN, CRNP",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "CRNP"],
        "imageUrl": "https://cdn.buttercms.com/AfBIbiPS6GFxuRgac9NR",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-wyomissing-gina-menarde-msn-crnp"
      },
      {
        "name": "Allison Tomack, PA-C, MPAS",
        "role": "Physician Assistant",
        "credentials": ["PA-C", "MPAS"],
        "imageUrl": "https://cdn.buttercms.com/c6tKozQPG8sgrstm28gw",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-wyomissing-allison-tomack-pa-c-mpas"
      },
      {
        "name": "Rachel Bruner, NP-C",
        "role": "Nurse Practitioner",
        "credentials": ["NP-C"],
        "imageUrl": "https://cdn.buttercms.com/Unu3HVnDQHO12BdSAcPn",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-wyomissing-rachel-bruner-np-c"
      },
      {
        "name": "Katie Gavern, MSN, CRNP, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "CRNP", "WHNP-BC"],
        "imageUrl": "https://cdn.buttercms.com/bMD6qLsRQjeoUzxc5068",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-wyomissing-katie-gavern-msn-crnp-whnp-bc"
      },
      {
        "name": "Sydney Gocial, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["WHNP-BC"],
        "imageUrl": "https://cdn.buttercms.com/7h9Ld17QQ6SvMxkfjHhw",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-wyomissing-sydney-gocial-whnp-bc"
      }
    ],
    "images": [
      {
        "url": "https://cdn.buttercms.com/7JfIstWnSI2Bh6b4CfQn",
        "type": "exterior",
        "caption": "Main Line Fertility Wyomissing clinic",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-clinics/reading",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkI7Q5BqucaYRPZwPmcViduqsukZQ_eBwQxqvM183x_wcuDQksiAHspSkop8fx8fE1Z1llX5boYxS46bdKXsjksk_aXIgPSrl7fn7EF5Yt1Tms8MxxKpYZc2ZxqvARQbv5acle9IQ=w530-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Main+Line+Fertility,+2210+Ridgewood+Rd,+Wyomissing,+PA+19610/@40.344522,-75.976683,3041a,13.1y/data=!4m2!3m1!1s0x89c671ae9486e21d:0x1ddaa187229f7743",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkMjh1iiA_w7yAC4GjD3CFm1z3LrsAEyxrHVHcRS_1Wke2-XPQR1n3bNWkiwSWZOFFo2WxMhvKStkhwz0Y2yK1H7U4UpwQmJzoWvQG7fqPhsujb9iPVyj14j5AGyDJTo50KVtkxKg=w224-h336-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Main+Line+Fertility,+2210+Ridgewood+Rd,+Wyomissing,+PA+19610/@40.344522,-75.976683,3041a,13.1y/data=!4m2!3m1!1s0x89c671ae9486e21d:0x1ddaa187229f7743",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-main-line-fertility-fort-washington",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Main Line Fertility - Fort Washington",
    "address": {
      "line1": "467 Pennsylvania Ave, Suite 202B",
      "city": "Fort Washington",
      "state": "PA",
      "zip": "19034",
      "country": "US"
    },
    "location": {
      "lat": 40.1353233,
      "lng": -75.2080272
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.mainlinefertility.com/fertility-clinics/fort-washington",
    "phone": "(610) 527-0800",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-clinics/fort-washington",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-clinics/fort-washington",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-clinics/fort-washington",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.mainlinefertility.com/fertility-clinics/fort-washington",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.mainlinefertility.com/fertility-clinics/fort-washington",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.mainlinefertility.com/fertility-clinics/fort-washington",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Michael J. Glassner, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.buttercms.com/LJcH8BlKRCWDYk7WldTU",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-fort-washington-michael-j-glassner-md"
      },
      {
        "name": "Deanna R. Brasile, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "imageUrl": "https://cdn.buttercms.com/QNWDauTvRtmVmBffRYxC",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-fort-washington-deanna-r-brasile-do"
      },
      {
        "name": "Allison Bloom, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "imageUrl": "https://cdn.buttercms.com/pmwj4gofTfmgmKfw2Htt",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-fort-washington-allison-bloom-do"
      },
      {
        "name": "Shahab Minassian, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.buttercms.com/Sg6yiMuRGWI0J0hN2dkA",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-fort-washington-shahab-minassian-md"
      },
      {
        "name": "Jenna Kahn, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.buttercms.com/6lYzdfGTuEEA8tEmRLQg",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-fort-washington-jenna-kahn-md"
      },
      {
        "name": "Shannon Alexa, DO",
        "role": "Reproductive Endocrinologist",
        "credentials": ["DO"],
        "imageUrl": "https://cdn.buttercms.com/srYom1bNTDGa6byClbVY",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-fort-washington-shannon-alexa-do"
      },
      {
        "name": "Ben Gocial, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "imageUrl": "https://cdn.buttercms.com/K1VJbgdqRaurRrTSYV1e",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-fort-washington-ben-gocial-md"
      },
      {
        "name": "Gina Menarde, MSN, CRNP",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "CRNP"],
        "imageUrl": "https://cdn.buttercms.com/AfBIbiPS6GFxuRgac9NR",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-fort-washington-gina-menarde-msn-crnp"
      },
      {
        "name": "Allison Tomack, PA-C, MPAS",
        "role": "Physician Assistant",
        "credentials": ["PA-C", "MPAS"],
        "imageUrl": "https://cdn.buttercms.com/c6tKozQPG8sgrstm28gw",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-fort-washington-allison-tomack-pa-c-mpas"
      },
      {
        "name": "Rachel Bruner, NP-C",
        "role": "Nurse Practitioner",
        "credentials": ["NP-C"],
        "imageUrl": "https://cdn.buttercms.com/Unu3HVnDQHO12BdSAcPn",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-fort-washington-rachel-bruner-np-c"
      },
      {
        "name": "Katie Gavern, MSN, CRNP, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "CRNP", "WHNP-BC"],
        "imageUrl": "https://cdn.buttercms.com/bMD6qLsRQjeoUzxc5068",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-fort-washington-katie-gavern-msn-crnp-whnp-bc"
      },
      {
        "name": "Sydney Gocial, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["WHNP-BC"],
        "imageUrl": "https://cdn.buttercms.com/7h9Ld17QQ6SvMxkfjHhw",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-main-line-fertility-fort-washington-sydney-gocial-whnp-bc"
      }
    ],
    "images": [
      {
        "url": "https://cdn.buttercms.com/ijpKOYi7TMWfHytg7PV9",
        "type": "exterior",
        "caption": "Main Line Fertility Fort Washington clinic",
        "_source": {
          "url": "https://www.mainlinefertility.com/fertility-clinics/fort-washington",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-radiance-fertility",
    "externalIds": {
      "googlePlaceId": "ChIJ92goVlqJNIgRnR_ofxuAOY4"
    },
    "type": "fertility-clinic",
    "name": "Radiance Fertility",
    "address": {
      "line1": "910 Sheraton Drive, Suite 400",
      "city": "Mars",
      "state": "PA",
      "zip": "16046",
      "country": "US"
    },
    "location": {
      "lat": 40.6694799,
      "lng": -80.0964995
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.radiancefertility.com/",
    "phone": "(412) 212-3025",
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.radiancefertility.com/resources/intrauterine-insemination-iui",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.radiancefertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.radiancefertility.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.radiancefertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.radiancefertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.radiancefertility.com/dr/sunita-katari",
            "fetchedAt": "2026-06-14"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Radiance+Fertility,+Professional+Building,+910+Sheraton+Dr+Ste+400,+Mars,+PA+16046/@40.6682658,-80.0952996,3026a,13.1y/data=!4m2!3m1!1s0x8834895a562868f7:0x8e39801b7fe81f9d",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Sunita Katari, MD",
        "role": "Medical Director",
        "credentials": ["MD"],
        "imageUrl": "https://storage.googleapis.com/treatspace-prod-media/thumb/u-59923/thumb_0.png",
        "_source": {
          "url": "https://www.radiancefertility.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-radiance-fertility-sunita-katari-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlYAq_J2OOyqC3O0Go7nC3CA87Ki_neLvCjUg4Bh3-miO3n-gVPex8XZVH8nxo_SaHmnXiBXZ-OEjwt0YdgxctOQkI9myY_4LSOBu281XNAWGrD-SPSKu7m-4MbYryJRWFf5KXSDg=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Radiance+Fertility,+Professional+Building,+910+Sheraton+Dr+Ste+400,+Mars,+PA+16046/@40.6682658,-80.0952996,3026a,13.1y/data=!4m2!3m1!1s0x8834895a562868f7:0x8e39801b7fe81f9d",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-upmc-fertility-penn-hills",
    "externalIds": {
      "googlePlaceId": "ChIJUyK0uI7rNIgRYfvDGiuoAzo"
    },
    "type": "fertility-clinic",
    "name": "UPMC Magee-Womens Center for Fertility and Reproductive Endocrinology - Penn Hills",
    "address": {
      "line1": "419 Rodi Road",
      "city": "Pittsburgh",
      "state": "PA",
      "zip": "15235",
      "country": "US"
    },
    "location": {
      "lat": 40.4554367,
      "lng": -79.8229232
    },
    "setting": "hospital-based",
    "network": {
      "name": "UPMC"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.upmc.com/services/womens-health/locations/southwest-pa/pittsburgh/penn-hills/419-rodi-rd",
    "phone": "(412) 731-8000",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.upmc.com/services/womens-health/services/obgyn/obstetrics/fertility",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Evaluation",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.upmc.com/services/womens-health/services/obgyn/obstetrics/fertility",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Preservation",
        "category": "preservation",
        "_source": {
          "url": "https://www.upmc.com/services/womens-health/services/obgyn/obstetrics/fertility",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.upmc.com/services/womens-health/locations/southwest-pa/pittsburgh/penn-hills/419-rodi-rd",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.upmc.com/services/womens-health/services/obgyn/obstetrics/fertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/UPMC+Magee-Womens+Center+for+Fertility+and+Reproductive+Endocrinology,+419+Rodi+Rd,+Pittsburgh,+PA+15235/@40.4554968,-79.8225594,3036a,13.1y/data=!4m2!3m1!1s0x8834eb8eb8b42253:0x3a03a82b1ac3fb61",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-upmc-fertility-hermitage",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "UPMC Magee-Womens Center for Fertility and Reproductive Endocrinology - Hermitage",
    "address": {
      "line1": "875 N. Hermitage Road, Suite 3",
      "city": "Hermitage",
      "state": "PA",
      "zip": "16148",
      "country": "US"
    },
    "location": {
      "lat": 41.2452402,
      "lng": -80.4498577
    },
    "setting": "hospital-based",
    "network": {
      "name": "UPMC"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.upmc.com/services/womens-health/locations/southwest-pa/hermitage/875-n-hermitage-rd-suite-3",
    "phone": "(724) 347-4851",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.upmc.com/services/womens-health/services/obgyn/obstetrics/fertility",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Evaluation",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.upmc.com/services/womens-health/services/obgyn/obstetrics/fertility",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Preservation",
        "category": "preservation",
        "_source": {
          "url": "https://www.upmc.com/services/womens-health/services/obgyn/obstetrics/fertility",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.upmc.com/services/womens-health/locations/southwest-pa/hermitage/875-n-hermitage-rd-suite-3",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.upmc.com/services/womens-health/services/obgyn/obstetrics/fertility",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://dam.upmc.com/-/media/upmc/callouts/contact-us/locations/outpatient/upmc-outpatient-center-in-hermitage.jpg?rev=3ba59fd3ac1249d98a6ca40797605483",
        "type": "exterior",
        "caption": "UPMC Outpatient Center in Hermitage exterior",
        "_source": {
          "url": "https://www.upmc.com/services/womens-health/locations/southwest-pa/hermitage/875-n-hermitage-rd-suite-3",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Pennsylvania (PA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-rscnj-toms-river",
    "externalIds": {
      "googlePlaceId": "ChIJc-_UkBZ2wYkRTS6ZHOOpcgg"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Science Center of New Jersey - Toms River",
    "address": {
      "line1": "780 Route 37 West, Suite 150",
      "city": "Toms River",
      "state": "NJ",
      "zip": "08755",
      "country": "US"
    },
    "location": {
      "lat": 39.9707665,
      "lng": -74.2348126
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.fertilitynj.com/our-fertility-clinics/toms-river",
    "phone": "(732) 918-2500",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.fertilitynj.com/our-fertility-clinics/toms-river",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.fertilitynj.com/our-fertility-clinics/toms-river",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.fertilitynj.com/our-fertility-clinics/toms-river",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.rscnj.com/fertility-specialists",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/The+Reproductive+Science+Center+of+New+Jersey,+780+NJ-37+Ste+150,+Toms+River,+NJ+08755/@39.9712042,-74.2343465,3058a,13.1y/data=!4m2!3m1!1s0x89c1761690d4ef73:0x872a9e31c992e4d",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "William Ziegler, DO",
        "imageUrl": "https://cdn.buttercms.com/KpIoPTmeTSe3qvUlO6qy",
        "_source": {
          "url": "https://www.rscnj.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rscnj-toms-river-william-ziegler-do"
      },
      {
        "name": "Alan Martinez, MD",
        "imageUrl": "https://cdn.buttercms.com/lRIffrAcTDy2zWbqeIEG",
        "_source": {
          "url": "https://www.rscnj.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rscnj-toms-river-alan-martinez-md"
      },
      {
        "name": "Ashley Ulker, MD",
        "imageUrl": "https://cdn.buttercms.com/vZRGpIzTTq3knvljZx56",
        "_source": {
          "url": "https://www.rscnj.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rscnj-toms-river-ashley-ulker-md"
      }
    ],
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-rscnj-lawrenceville",
    "externalIds": {
      "googlePlaceId": "ChIJM5_Wtv_iw4kRnxUM84_tnE4"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Science Center of New Jersey - Lawrenceville",
    "address": {
      "line1": "3131 Princeton Pike, Building 6, Suite 100",
      "city": "Lawrenceville",
      "state": "NJ",
      "zip": "08648",
      "country": "US"
    },
    "location": {
      "lat": 40.2837132,
      "lng": -74.7148182
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.fertilitynj.com/our-fertility-clinics/lawrenceville",
    "phone": "(732) 918-2500",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.fertilitynj.com/our-fertility-clinics/lawrenceville",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.fertilitynj.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.fertilitynj.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.rscnj.com/fertility-specialists",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/The+Reproductive+Science+Center+of+New+Jersey,+3131+Princeton+Pike+Building+6,+Suite+100,+Lawrence+Township,+NJ+08648/@40.2846632,-74.72,3044a,13.1y/data=!4m2!3m1!1s0x89c3e2ffb6d69f33:0x4e9ced8ff30c159f",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "William Ziegler, DO",
        "imageUrl": "https://cdn.buttercms.com/KpIoPTmeTSe3qvUlO6qy",
        "_source": {
          "url": "https://www.rscnj.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["DO"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rscnj-lawrenceville-william-ziegler-do"
      },
      {
        "name": "Alan Martinez, MD",
        "imageUrl": "https://cdn.buttercms.com/lRIffrAcTDy2zWbqeIEG",
        "_source": {
          "url": "https://www.rscnj.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rscnj-lawrenceville-alan-martinez-md"
      },
      {
        "name": "Ashley Ulker, MD",
        "imageUrl": "https://cdn.buttercms.com/vZRGpIzTTq3knvljZx56",
        "_source": {
          "url": "https://www.rscnj.com/fertility-specialists",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rscnj-lawrenceville-ashley-ulker-md"
      }
    ],
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-ccrm-nj-clark",
    "externalIds": {
      "googlePlaceId": "ChIJ6cp8V9qzw4kRyUxlCZiGhkk"
    },
    "type": "fertility-clinic",
    "name": "CCRM Fertility of New Jersey - Clark",
    "address": {
      "line1": "100 Walnut Ave., Suite 104",
      "city": "Clark",
      "state": "NJ",
      "zip": "07066",
      "country": "US"
    },
    "location": {
      "lat": 40.6299267,
      "lng": -74.3034542
    },
    "setting": "network-group",
    "network": {
      "name": "CCRM Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.ccrmivf.com/location/us/new-jersey/clark/",
    "phone": "(732) 943-7169",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/new-jersey/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Clark,+100+Walnut+Ave+%23104,+Clark,+NJ+07066/@40.6298782,-74.3036864,3028a,13.1y/data=!4m2!3m1!1s0x89c3b3da577ccae9:0x4986869809654cc9",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Serena H. Chen, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Serena_Chen_600x600_2x-r9yq9umeokvb3bu9lt5qye91o216fi94nhurm0gv4w.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-nj-clark-serena-h-chen-md"
      },
      {
        "name": "Debbra A. Keegan, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Debbra_Keegan_600x600_2x-r9yq8xq21dm9sz61xwxt14jwvkjby3miuz0rtbtn6o.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-nj-clark-debbra-a-keegan-md"
      },
      {
        "name": "Jessica Salas Mann, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Jessica_Salas_Mann_600x600_2x-r9yq8c3ro6sody1gg5ldxs0b7phw128p400lrypp5s.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-nj-clark-jessica-salas-mann-md"
      },
      {
        "name": "Melissa C. Yih, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Melissa_C_Yih_600x600_2x-r9yq75t14n6rvhqwb5b6bkokhdadeokry6nr6igexs.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-nj-clark-melissa-c-yih-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-ccrm-nj-old-bridge",
    "externalIds": {
      "googlePlaceId": "ChIJvynyLADPw4kRUb-ts2lxqN8"
    },
    "type": "fertility-clinic",
    "name": "CCRM Fertility of New Jersey - Old Bridge",
    "address": {
      "line1": "2 Hospital Plaza, Suite 330",
      "city": "Old Bridge",
      "state": "NJ",
      "zip": "08857",
      "country": "US"
    },
    "location": {
      "lat": 40.3822027,
      "lng": -74.3220558
    },
    "setting": "network-group",
    "network": {
      "name": "CCRM Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.ccrmivf.com/location/us/new-jersey/",
    "phone": "(732) 786-7900",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/new-jersey/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Old+Bridge,+2+Hospital+Plaza+Ste+330,+Old+Bridge,+NJ+08857/@40.3828242,-74.3243788,3039a,13.1y/data=!4m2!3m1!1s0x89c3cf002cf229bf:0xdfa87169b3adbf51",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Serena H. Chen, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Serena_Chen_600x600_2x-r9yq9umeokvb3bu9lt5qye91o216fi94nhurm0gv4w.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-nj-old-bridge-serena-h-chen-md"
      },
      {
        "name": "Debbra A. Keegan, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Debbra_Keegan_600x600_2x-r9yq8xq21dm9sz61xwxt14jwvkjby3miuz0rtbtn6o.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-nj-old-bridge-debbra-a-keegan-md"
      },
      {
        "name": "Jessica Salas Mann, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Jessica_Salas_Mann_600x600_2x-r9yq8c3ro6sody1gg5ldxs0b7phw128p400lrypp5s.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-nj-old-bridge-jessica-salas-mann-md"
      },
      {
        "name": "Melissa C. Yih, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Melissa_C_Yih_600x600_2x-r9yq75t14n6rvhqwb5b6bkokhdadeokry6nr6igexs.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-nj-old-bridge-melissa-c-yih-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-ccrm-nj-princeton",
    "externalIds": {
      "googlePlaceId": "ChIJBehC6bbnw4kRLgoVC1wBEgc"
    },
    "type": "fertility-clinic",
    "name": "CCRM Fertility of New Jersey - Princeton",
    "address": {
      "line1": "8 Forrestal Rd., Suite 204",
      "city": "Princeton",
      "state": "NJ",
      "zip": "08540",
      "country": "US"
    },
    "location": {
      "lat": 40.3440113,
      "lng": -74.6159528
    },
    "setting": "network-group",
    "network": {
      "name": "CCRM Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.ccrmivf.com/location/us/new-jersey/",
    "phone": "(609) 448-4300",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/new-jersey/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Princeton,+8+Forrestal+Rd+S+Ste+204,+Princeton,+NJ+08540/@40.3434704,-74.616702,3041a,13.1y/data=!4m2!3m1!1s0x89c3e7b6e942e805:0x712015c0b150a2e",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Serena H. Chen, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Serena_Chen_600x600_2x-r9yq9umeokvb3bu9lt5qye91o216fi94nhurm0gv4w.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-nj-princeton-serena-h-chen-md"
      },
      {
        "name": "Debbra A. Keegan, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Debbra_Keegan_600x600_2x-r9yq8xq21dm9sz61xwxt14jwvkjby3miuz0rtbtn6o.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-nj-princeton-debbra-a-keegan-md"
      },
      {
        "name": "Jessica Salas Mann, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Jessica_Salas_Mann_600x600_2x-r9yq8c3ro6sody1gg5ldxs0b7phw128p400lrypp5s.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-nj-princeton-jessica-salas-mann-md"
      },
      {
        "name": "Melissa C. Yih, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Melissa_C_Yih_600x600_2x-r9yq75t14n6rvhqwb5b6bkokhdadeokry6nr6igexs.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-nj-princeton-melissa-c-yih-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnxq32BayHUDmfO6SnMlz6j0AZDHMZ7hmtkk1tRkruRdNxPa7EFgjQZwPLl1usXFYoFwMf6Idb_9JGnQUbVhlbF_ArUXi2BCkf-3xWRfCeKmT_y1RYZC8wGWAHvLzYmGXDrhiE=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Princeton,+8+Forrestal+Rd+S+Ste+204,+Princeton,+NJ+08540/@40.3434704,-74.616702,3041a,13.1y/data=!4m2!3m1!1s0x89c3e7b6e942e805:0x712015c0b150a2e",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-ccrm-nj-teaneck",
    "externalIds": {
      "googlePlaceId": "ChIJcTllSnn3wokRsjL216ammzw"
    },
    "type": "fertility-clinic",
    "name": "CCRM Fertility of New Jersey - Teaneck",
    "address": {
      "line1": "400 Frank W. Burr Blvd., Glenpointe, Suite 145",
      "city": "Teaneck",
      "state": "NJ",
      "zip": "07666",
      "country": "US"
    },
    "location": {
      "lat": 40.8729251,
      "lng": -74.0068621
    },
    "setting": "network-group",
    "network": {
      "name": "CCRM Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.ccrmivf.com/location/us/new-jersey/",
    "phone": "(201) 645-1873",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/new-jersey/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Teaneck,+400+Frank+W+Burr+Blvd+Glenpointe,+Suite+145,+Teaneck,+NJ+07666/@40.8728273,-74.0059031,3017a,13.1y/data=!4m2!3m1!1s0x89c2f7794a653971:0x3c9ba6a6d7f632b2",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Serena H. Chen, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Serena_Chen_600x600_2x-r9yq9umeokvb3bu9lt5qye91o216fi94nhurm0gv4w.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-nj-teaneck-serena-h-chen-md"
      },
      {
        "name": "Debbra A. Keegan, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Debbra_Keegan_600x600_2x-r9yq8xq21dm9sz61xwxt14jwvkjby3miuz0rtbtn6o.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-nj-teaneck-debbra-a-keegan-md"
      },
      {
        "name": "Jessica Salas Mann, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Jessica_Salas_Mann_600x600_2x-r9yq8c3ro6sody1gg5ldxs0b7phw128p400lrypp5s.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-nj-teaneck-jessica-salas-mann-md"
      },
      {
        "name": "Melissa C. Yih, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Melissa_C_Yih_600x600_2x-r9yq75t14n6rvhqwb5b6bkokhdadeokry6nr6igexs.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-nj-teaneck-melissa-c-yih-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmiDVKHgeT8cB-fqO80lH5OoWleT2OF5Z26aOGtqn-j8eYbxdY89ReOYPfvyluha6D9tfRcGk4mxBxp0ezma2KsvDWU52lfeTXyFW080NXHwdd2HllueHejTKV7NvxA0Nhfxe6_=w286-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Teaneck,+400+Frank+W+Burr+Blvd+Glenpointe,+Suite+145,+Teaneck,+NJ+07666/@40.8728273,-74.0059031,3017a,13.1y/data=!4m2!3m1!1s0x89c2f7794a653971:0x3c9ba6a6d7f632b2",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-ccrm-nj-wall",
    "externalIds": {
      "googlePlaceId": "ChIJFdzRj_uHwYkRRbq4RnRBwIA"
    },
    "type": "fertility-clinic",
    "name": "CCRM Fertility of New Jersey - Wall",
    "address": {
      "line1": "3350 Highway 138, Suite 225",
      "city": "Wall",
      "state": "NJ",
      "zip": "07719",
      "country": "US"
    },
    "location": {
      "lat": 40.1707511,
      "lng": -74.0897942
    },
    "setting": "network-group",
    "network": {
      "name": "CCRM Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.ccrmivf.com/location/us/new-jersey/",
    "phone": "(732) 540-1444",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/new-jersey/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Wall,+3350+NJ-138+Ste+225,+Building+2,+Wall+Township,+NJ+07719/@40.1712526,-74.091254,3049a,13.1y/data=!4m2!3m1!1s0x89c187fb8fd1dc15:0x80c0417446b8ba45",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Serena H. Chen, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Serena_Chen_600x600_2x-r9yq9umeokvb3bu9lt5qye91o216fi94nhurm0gv4w.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-nj-wall-serena-h-chen-md"
      },
      {
        "name": "Debbra A. Keegan, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Debbra_Keegan_600x600_2x-r9yq8xq21dm9sz61xwxt14jwvkjby3miuz0rtbtn6o.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-nj-wall-debbra-a-keegan-md"
      },
      {
        "name": "Jessica Salas Mann, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Jessica_Salas_Mann_600x600_2x-r9yq8c3ro6sody1gg5ldxs0b7phw128p400lrypp5s.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-nj-wall-jessica-salas-mann-md"
      },
      {
        "name": "Melissa C. Yih, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Melissa_C_Yih_600x600_2x-r9yq75t14n6rvhqwb5b6bkokhdadeokry6nr6igexs.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/new-jersey/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-nj-wall-melissa-c-yih-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWljMAcBxXXQME3X2IuLycqHXACBMBDMKhh4NDVuu72ue0o0H37JEIZ4ieHdW9QDHc9mtg5SPDNOiBV0bhuyI5R-Ci0MWvqU3yf7zH4XN_JJkB1LJHDYrBpJDTX7CaNz25mRUjtEbJiprb6P=w286-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Wall,+3350+NJ-138+Ste+225,+Building+2,+Wall+Township,+NJ+07719/@40.1712526,-74.091254,3049a,13.1y/data=!4m2!3m1!1s0x89c187fb8fd1dc15:0x80c0417446b8ba45",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-ura-hoboken",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "University Reproductive Associates - Hoboken",
    "address": {
      "line1": "79 Hudson St, Suite 102 LL",
      "city": "Hoboken",
      "state": "NJ",
      "zip": "07030",
      "country": "US"
    },
    "location": {
      "lat": 40.7365755,
      "lng": -74.029938
    },
    "setting": "network-group",
    "network": {
      "name": "University Reproductive Associates"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.uranj.com/contact-us",
    "phone": "(201) 288-6330",
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.uranj.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.uranj.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.uranj.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.uranj.com/providers",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Michael Cho, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845361.png",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-hoboken-michael-cho-md"
      },
      {
        "name": "Adam Fechner, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845363.png",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-hoboken-adam-fechner-md"
      },
      {
        "name": "Rita Gulati, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845367.jpg",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-hoboken-rita-gulati-md"
      },
      {
        "name": "Peter G. McGovern, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845369.png",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-hoboken-peter-g-mcgovern-md"
      },
      {
        "name": "Sara Morelli, MD, PhD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845371.png",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-hoboken-sara-morelli-md-phd"
      },
      {
        "name": "Kavitha Persaud, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845373.jpg",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-hoboken-kavitha-persaud-md"
      },
      {
        "name": "Susan Wolf, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845375.png",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-hoboken-susan-wolf-md"
      },
      {
        "name": "Anat Chemerinski, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845377.jpg",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-hoboken-anat-chemerinski-md"
      },
      {
        "name": "Ndidiamaka Onwubalili, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845379.jpg",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-hoboken-ndidiamaka-onwubalili-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-ura-wayne",
    "externalIds": {
      "googlePlaceId": "ChIJIdFldXQBw4kRHeUiKuClrQM"
    },
    "type": "fertility-clinic",
    "name": "University Reproductive Associates - Wayne",
    "address": {
      "line1": "57 Willowbrook Blvd, #301",
      "city": "Wayne",
      "state": "NJ",
      "zip": "07470",
      "country": "US"
    },
    "location": {
      "lat": 40.8887941,
      "lng": -74.2506404
    },
    "setting": "network-group",
    "network": {
      "name": "University Reproductive Associates"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.uranj.com/contact-us",
    "phone": "(201) 288-6330",
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.uranj.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.uranj.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.uranj.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.uranj.com/providers",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/University+Reproductive+Associates,+57+Willowbrook+Blvd+%23301,+Wayne,+NJ+07470/@40.8890725,-74.2491831,3016a,13.1y/data=!4m2!3m1!1s0x89c301747565d121:0x3ada5e02a22e51d",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Michael Cho, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845361.png",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-wayne-michael-cho-md"
      },
      {
        "name": "Adam Fechner, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845363.png",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-wayne-adam-fechner-md"
      },
      {
        "name": "Rita Gulati, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845367.jpg",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-wayne-rita-gulati-md"
      },
      {
        "name": "Peter G. McGovern, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845369.png",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-wayne-peter-g-mcgovern-md"
      },
      {
        "name": "Sara Morelli, MD, PhD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845371.png",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-wayne-sara-morelli-md-phd"
      },
      {
        "name": "Kavitha Persaud, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845373.jpg",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-wayne-kavitha-persaud-md"
      },
      {
        "name": "Susan Wolf, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845375.png",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-wayne-susan-wolf-md"
      },
      {
        "name": "Anat Chemerinski, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845377.jpg",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-wayne-anat-chemerinski-md"
      },
      {
        "name": "Ndidiamaka Onwubalili, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845379.jpg",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-wayne-ndidiamaka-onwubalili-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWma5AUa7UwBjWXEUZBKRKWs8zU84wtsp6o6_3zdc8C3FVfMrZPH0S00hEUZVzoKsO_7Z-xG1XnHr3ClWWJcXPhZwdm5bShjMwnX8GgaO0fjn7X0ZziBF5LYHh5gutN9Y1dRcxg=w408-h544-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/University+Reproductive+Associates,+57+Willowbrook+Blvd+%23301,+Wayne,+NJ+07470/@40.8890725,-74.2491831,3016a,13.1y/data=!4m2!3m1!1s0x89c301747565d121:0x3ada5e02a22e51d",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-ura-denville",
    "externalIds": {
      "googlePlaceId": "ChIJ3WX9VAAJw4kRXG2HN2tjUlE"
    },
    "type": "fertility-clinic",
    "name": "University Reproductive Associates - Denville",
    "address": {
      "line1": "16 Pocono Rd, Suite 216",
      "city": "Denville",
      "state": "NJ",
      "zip": "07834",
      "country": "US"
    },
    "location": {
      "lat": 40.8942886,
      "lng": -74.4677294
    },
    "setting": "network-group",
    "network": {
      "name": "University Reproductive Associates"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.uranj.com/contact-us",
    "phone": "(973) 366-8600",
    "treatments": [
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.uranj.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.uranj.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.uranj.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.uranj.com/providers",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/University+Reproductive+Associates+(URA),+16+Pocono+Rd,+Denville,+NJ+07834/@40.8937469,-74.4722539,3016a,13.1y/data=!4m2!3m1!1s0x89c3090054fd65dd:0x5152636b37876d5c",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Michael Cho, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845361.png",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-denville-michael-cho-md"
      },
      {
        "name": "Adam Fechner, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845363.png",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-denville-adam-fechner-md"
      },
      {
        "name": "Rita Gulati, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845367.jpg",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-denville-rita-gulati-md"
      },
      {
        "name": "Peter G. McGovern, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845369.png",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-denville-peter-g-mcgovern-md"
      },
      {
        "name": "Sara Morelli, MD, PhD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845371.png",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD", "PhD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-denville-sara-morelli-md-phd"
      },
      {
        "name": "Kavitha Persaud, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845373.jpg",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-denville-kavitha-persaud-md"
      },
      {
        "name": "Susan Wolf, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845375.png",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-denville-susan-wolf-md"
      },
      {
        "name": "Anat Chemerinski, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845377.jpg",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-denville-anat-chemerinski-md"
      },
      {
        "name": "Ndidiamaka Onwubalili, MD",
        "imageUrl": "https://sa1s3optim.patientpop.com/1024x/filters:format(webp)/assets/production/practices/9428ee1ca5bc10e465b0f2e55a35e268a8490b0d/images/2845379.jpg",
        "_source": {
          "url": "https://www.uranj.com/providers",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ura-denville-ndidiamaka-onwubalili-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnnaYugXD8D3Anznr5DW5mRwz7a3BQpqlHeHKpgw2-EVvySWWlGY1BSifOLzNQzMT9z2QozcceGGzQuMPygbFJRXjd3-riwkR0EDR36PvEppSSIyJF_n1vvv_mY6vGE3FNQSccbR0QFrUwJ=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/University+Reproductive+Associates+(URA),+16+Pocono+Rd,+Denville,+NJ+07834/@40.8937469,-74.4722539,3016a,13.1y/data=!4m2!3m1!1s0x89c3090054fd65dd:0x5152636b37876d5c",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlbziemhrZa78oC0xhpmb1FeW2K_ABiIZ7ltGXAAM1Qbki3zTlDksgcC3flYnsSpjmLvJ2wZ7kDuMjtoxS5hfu8xDfU5IYuo59m7VifWl_pXjDTdrGiKyQmLiIVSDXvJsL8NnpOB8xlTy8=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/University+Reproductive+Associates+(URA),+16+Pocono+Rd,+Denville,+NJ+07834/@40.8937469,-74.4722539,3016a,13.1y/data=!4m2!3m1!1s0x89c3090054fd65dd:0x5152636b37876d5c",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-hudson-ivf",
    "externalIds": {
      "googlePlaceId": "ChIJaWs4TSxXwokRb4R0eoeh08Y"
    },
    "type": "fertility-clinic",
    "name": "Hudson IVF",
    "address": {
      "line1": "2777 Kennedy Blvd",
      "city": "Jersey City",
      "state": "NJ",
      "zip": "07306",
      "country": "US"
    },
    "location": {
      "lat": 40.7307305,
      "lng": -74.0683131
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology", "ob-gyn"],
    "website": "https://www.hudsonivf.com/",
    "phone": "(201) 963-4200",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.hudsonivf.com/services/in-vitro-fertilization/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Infertility Care",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.hudsonivf.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.hudsonivf.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Hudson+Ivf+Dr,+2777+John+F.+Kennedy+Blvd,+Jersey+City,+NJ+07306/@40.7309529,-74.0684986,3023a,13.1y/data=!4m2!3m1!1s0x89c2572c4d386b69:0xc6d3a1877a74846f",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Taonei Mushayandebvu, MD",
        "imageUrl": "https://www.hudsonivf.com/wp-content/uploads/2021/08/dr-musha-station.jpg",
        "_source": {
          "url": "https://www.hudsonivf.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-hudson-ivf-taonei-mushayandebvu-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl_OkPYIlEv1CI_0rFhlfY1I8E33Q51zdkVdiF2wBNw42UA__RJiwjBllxnG_o4oxs-_mwk39PKs4n0EAdjIBX2r0LuEsyFpk259PUpeKAjqsC0MNiMJq-KaRL2Ox9zDOlcB17Hog=w156-h156-n-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Hudson+Ivf+Dr,+2777+John+F.+Kennedy+Blvd,+Jersey+City,+NJ+07306/@40.7309529,-74.0684986,3023a,13.1y/data=!4m2!3m1!1s0x89c2572c4d386b69:0xc6d3a1877a74846f",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-clifton-obgyn-infertility",
    "externalIds": {},
    "type": "medical-practice",
    "name": "Clifton OB/GYN Infertility Services",
    "address": {
      "line1": "1033 U.S. Highway 46E, Suite 102",
      "city": "Clifton",
      "state": "NJ",
      "zip": "07013",
      "country": "US"
    },
    "location": {
      "lat": 40.8732782,
      "lng": -74.1749875
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "website": "https://www.cliftonobgyn.com/services-specialties/infertility/",
    "phone": "(973) 779-7979",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.cliftonobgyn.com/services-specialties/infertility/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.cliftonobgyn.com/services-specialties/infertility/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.cliftonobgyn.com/services-specialties/infertility/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-arm-fertility-princeton",
    "externalIds": {
      "googlePlaceId": "ChIJ53d9g3Lnw4kRr5pDdEQyxkQ"
    },
    "type": "fertility-clinic",
    "name": "Center for Advanced Reproductive Medicine & Fertility - Princeton",
    "address": {
      "line1": "114 Stanhope St",
      "city": "Princeton",
      "state": "NJ",
      "zip": "08540",
      "country": "US"
    },
    "location": {
      "lat": 40.3568823,
      "lng": -74.6120986
    },
    "setting": "network-group",
    "network": {
      "name": "Center for Advanced Reproductive Medicine & Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://infertilitydocs.com/",
    "phone": "(732) 339-9300",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://infertilitydocs.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://infertilitydocs.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://infertilitydocs.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.infertilitydocs.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Center+for+Advanced+Reproductive+Medicine+%26+Fertility,+114+Stanhope+St,+Princeton,+NJ+08540/@40.3560451,-74.6129056,3040a,13.1y/data=!4m2!3m1!1s0x89c3e772837d77e7:0x44c6324474439aaf",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Suna M. Qasim, MD",
        "imageUrl": "https://www.infertilitydocs.com/z-images/team/qasim.webp",
        "_source": {
          "url": "https://www.infertilitydocs.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-arm-fertility-princeton-suna-m-qasim-md"
      },
      {
        "name": "Rahul Sachdev, MD",
        "imageUrl": "https://www.infertilitydocs.com/z-images/team/rahul.webp",
        "_source": {
          "url": "https://www.infertilitydocs.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-arm-fertility-princeton-rahul-sachdev-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkJt42N2-ArJEqo3C5g5roTs4J2NuHmrZBq43Hm6NH7EgYksw3CXee1tcVJSHgvlf00wpP7psqM_2qb-HNMTooFNGu42nfZwZsTWGTSDZBn7C0y8LqccawG87N6TMVYrn5qoyUr=w421-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Center+for+Advanced+Reproductive+Medicine+%26+Fertility,+114+Stanhope+St,+Princeton,+NJ+08540/@40.3560451,-74.6129056,3040a,13.1y/data=!4m2!3m1!1s0x89c3e772837d77e7:0x44c6324474439aaf",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-arm-fertility-cranford",
    "externalIds": {
      "googlePlaceId": "ChIJpylsmSOyw4kRZ6npg93mUeg"
    },
    "type": "fertility-clinic",
    "name": "Center for Advanced Reproductive Medicine & Fertility - Cranford",
    "address": {
      "line1": "123 N Union Ave #102",
      "city": "Cranford",
      "state": "NJ",
      "zip": "07016",
      "country": "US"
    },
    "location": {
      "lat": 40.6568567,
      "lng": -74.303332
    },
    "setting": "network-group",
    "network": {
      "name": "Center for Advanced Reproductive Medicine & Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://infertilitydocs.com/",
    "phone": "(732) 339-9300",
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://infertilitydocs.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://infertilitydocs.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://infertilitydocs.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.infertilitydocs.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Center+for+Advanced+Reproductive+Medicine+%26+Fertility,+123+N+Union+Ave,+Cranford,+NJ+07016/@40.6578762,-74.3037101,3027a,13.1y/data=!4m2!3m1!1s0x89c3b223996c29a7:0xe851e6dd83e9a967",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Suna M. Qasim, MD",
        "imageUrl": "https://www.infertilitydocs.com/z-images/team/qasim.webp",
        "_source": {
          "url": "https://www.infertilitydocs.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-arm-fertility-cranford-suna-m-qasim-md"
      },
      {
        "name": "Rahul Sachdev, MD",
        "imageUrl": "https://www.infertilitydocs.com/z-images/team/rahul.webp",
        "_source": {
          "url": "https://www.infertilitydocs.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-arm-fertility-cranford-rahul-sachdev-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmwQ_GW1blduPdZkW68TuSfWUw2h1df865vIdnsToZx4Q2n_IIZIptWanWesvJBIsJlBEYOhKCrYPOdBAVm6yxLv_N1s7waxkLj-9Nt6mFca3krwVmz5PRfpMd11mjsQgbuI5A=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Center+for+Advanced+Reproductive+Medicine+%26+Fertility,+123+N+Union+Ave,+Cranford,+NJ+07016/@40.6578762,-74.3037101,3027a,13.1y/data=!4m2!3m1!1s0x89c3b223996c29a7:0xe851e6dd83e9a967",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-ccrm-il-chicago",
    "externalIds": {
      "googlePlaceId": "ChIJYXYC4PMtDogRpDj4XRBoQbA"
    },
    "type": "fertility-clinic",
    "name": "CCRM Fertility of Chicago",
    "address": {
      "line1": "225 W. Wacker Drive, Suite 800",
      "city": "Chicago",
      "state": "IL",
      "zip": "60606",
      "country": "US"
    },
    "location": {
      "lat": 41.8868168,
      "lng": -87.6340432
    },
    "setting": "network-group",
    "network": {
      "name": "CCRM Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.ccrmivf.com/location/us/illinois/chicago/",
    "phone": "(312) 253-3473",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/illinois/chicago/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Chicago,+225+W+Wacker+Dr+Ste+800,+Chicago,+IL+60606/@41.8863046,-87.6350769,2970a,13.1y/data=!4m2!3m1!1s0x880e2df3e0027661:0xb04168105df838a4",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Amanda Adeleye, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Amanda_Adeleye_600x600_2x-r9yqqsnnw22ee985nmumemb774ie72ixbd8w2lccyo.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/illinois/chicago/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-il-chicago-amanda-adeleye-md"
      },
      {
        "name": "Victoria Wesevich, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Victoria_Wesevich_600x600_2x-r9yppjbyzh286pci81202isfia5m2zlyiyb08ql5ls.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/illinois/chicago/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-il-chicago-victoria-wesevich-md"
      },
      {
        "name": "Laurence Jacobs, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Laurence-Jacobs-rmgnsl3mp3i99yyogmszufkzy3fs9bgc9o6riwd9k0.png",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/illinois/chicago/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-il-chicago-laurence-jacobs-md"
      },
      {
        "name": "Charles E. Miller, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Charles_E_Miller_600x600_2x-rdhmuwe9yylkjbdbvglys7cljz0u3ez8dpj44wkiao.png",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/illinois/chicago/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-il-chicago-charles-e-miller-md"
      },
      {
        "name": "Mary McKenna, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Mary_McKenna_600x600_2x-rbxsvvb7nmjiaywcsdesc94dnth0hfn7lrfppi0wbk.png",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/illinois/chicago/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-il-chicago-mary-mckenna-md"
      },
      {
        "name": "Kelly Ryan, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Kelly_Ryan_600x600_2x-rcv0ekz62pampwrlxlchj30z2r4umbcnvm2e1e3grk.png",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/illinois/chicago/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-il-chicago-kelly-ryan-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlEDtZbaJjwa-URUg6I5gNiZYL9ZdKCCMK9PdqjXDh1Rx73uVqJtX_mZwhNeZI1OVT4w9tvngI2biouhqt5ig-eh8QfaXg4RblKlL3f0JAYadMX_mNA8RMhnXJSoifIuWIBJr3VkS-H-kYC=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Chicago,+225+W+Wacker+Dr+Ste+800,+Chicago,+IL+60606/@41.8863046,-87.6350769,2970a,13.1y/data=!4m2!3m1!1s0x880e2df3e0027661:0xb04168105df838a4",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-ccrm-il-park-ridge",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "CCRM Fertility of Park Ridge",
    "address": {
      "line1": "350 S. Northwest Highway, Suite 112",
      "city": "Park Ridge",
      "state": "IL",
      "zip": "60068",
      "country": "US"
    },
    "location": {
      "lat": 42.0075256,
      "lng": -87.8237775
    },
    "setting": "network-group",
    "network": {
      "name": "CCRM Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.ccrmivf.com/location/us/illinois/park-ridge/",
    "phone": "(847) 641-2180",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/illinois/chicago/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Amanda Adeleye, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Amanda_Adeleye_600x600_2x-r9yqqsnnw22ee985nmumemb774ie72ixbd8w2lccyo.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/illinois/chicago/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-il-park-ridge-amanda-adeleye-md"
      },
      {
        "name": "Victoria Wesevich, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Victoria_Wesevich_600x600_2x-r9yppjbyzh286pci81202isfia5m2zlyiyb08ql5ls.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/illinois/chicago/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-il-park-ridge-victoria-wesevich-md"
      },
      {
        "name": "Laurence Jacobs, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Laurence-Jacobs-rmgnsl3mp3i99yyogmszufkzy3fs9bgc9o6riwd9k0.png",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/illinois/chicago/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-il-park-ridge-laurence-jacobs-md"
      },
      {
        "name": "Charles E. Miller, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Charles_E_Miller_600x600_2x-rdhmuwe9yylkjbdbvglys7cljz0u3ez8dpj44wkiao.png",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/illinois/chicago/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-il-park-ridge-charles-e-miller-md"
      },
      {
        "name": "Mary McKenna, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Mary_McKenna_600x600_2x-rbxsvvb7nmjiaywcsdesc94dnth0hfn7lrfppi0wbk.png",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/illinois/chicago/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-il-park-ridge-mary-mckenna-md"
      },
      {
        "name": "Kelly Ryan, MD",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Kelly_Ryan_600x600_2x-rcv0ekz62pampwrlxlchj30z2r4umbcnvm2e1e3grk.png",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/illinois/chicago/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-ccrm-il-park-ridge-kelly-ryan-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-kindbody-wicker-park",
    "externalIds": {
      "googlePlaceId": "ChIJ1_ICYcbSD4gR_74wu4gPN2I"
    },
    "type": "fertility-clinic",
    "name": "Kindbody - Wicker Park",
    "address": {
      "line1": "1455 N. Milwaukee Ave, 2nd Floor",
      "city": "Chicago",
      "state": "IL",
      "zip": "60622",
      "country": "US"
    },
    "location": {
      "lat": 41.9082211,
      "lng": -87.6739835
    },
    "setting": "network-group",
    "network": {
      "name": "Kindbody"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://kindbody.com/book-appointment-chicago/",
    "phone": "(773) 435-9036",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+Chicago+Wicker+Park,+1455+N+Milwaukee+Ave,+Chicago,+IL+60622/@41.9083711,-87.6739506,2969a,13.1y/data=!4m2!3m1!1s0x880fd2c66102f2d7:0x62370f88bb30beff",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-kindbody-aurora",
    "externalIds": {
      "googlePlaceId": "ChIJsxTBy0XxDogR4zzV40ORI4U"
    },
    "type": "fertility-clinic",
    "name": "Kindbody - Aurora",
    "address": {
      "line1": "2040 Ogden Ave, Suite 107",
      "city": "Aurora",
      "state": "IL",
      "zip": "60504",
      "country": "US"
    },
    "location": {
      "lat": 41.7287708,
      "lng": -88.267004
    },
    "setting": "network-group",
    "network": {
      "name": "Kindbody"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://kindbody.com/book-appointment-chicago/",
    "phone": "(630) 978-6254",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+Aurora,+2040+Ogden+Ave,+Aurora,+IL+60504/@41.7298414,-88.2687699,2978a,13.1y/data=!4m2!3m1!1s0x880ef145cbc114b3:0x85239143e3d53ce3",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkUhNH7EEei63duBbvP-zlgIj6ZFlA9uyX97htQwX4ikL9Y3Tg-uOXcNo8aX5Sg8BLJnP6X-hOeaA9FBEAFIZAcmaDqOq7vx4giiyB0m9JNfJeA_udzWQcoaX28nRYOalV_QKWWZw=w536-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Kindbody+-+Aurora,+2040+Ogden+Ave,+Aurora,+IL+60504/@41.7298414,-88.2687699,2978a,13.1y/data=!4m2!3m1!1s0x880ef145cbc114b3:0x85239143e3d53ce3",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-chicago-ivf-orland-park",
    "externalIds": {
      "googlePlaceId": "ChIJoQN7Q_BADogRac3PNnjFt6w"
    },
    "type": "fertility-clinic",
    "name": "Chicago IVF - Orland Park",
    "address": {
      "line1": "10811 West 143rd Street, Suite 120",
      "city": "Orland Park",
      "state": "IL",
      "zip": "60467",
      "country": "US"
    },
    "location": {
      "lat": 41.6298489,
      "lng": -87.8831893
    },
    "setting": "network-group",
    "network": {
      "name": "Chicago IVF"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.chicagoivf.com/locations/fertility-clinics/orland-park-southwest-chicago-suburbs",
    "phone": "(708) 633-1999",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.chicagoivf.com/about/fertility-specialists/dr-joel-brasch",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Chicago+IVF,+10811+W+143rd+St+%23120,+Orland+Park,+IL+60467/@41.6293934,-87.8832759,2982a,13.1y/data=!4m2!3m1!1s0x880e40f0437b03a1:0xacb7c57836cfcd69",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Joel G. Brasch, MD",
        "imageUrl": "https://www.chicagoivf.com/content/1-about/1-fertility-specialists/dr-joel-brasch/civf-joel-brasch.jpg",
        "_source": {
          "url": "https://www.chicagoivf.com/about/fertility-specialists/dr-joel-brasch",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-chicago-ivf-orland-park-joel-g-brasch-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-chicago-ivf-st-charles",
    "externalIds": {
      "googlePlaceId": "ChIJZ6a8Q0MdD4gRqNT3LdpwcCk"
    },
    "type": "fertility-clinic",
    "name": "Chicago IVF - St. Charles",
    "address": {
      "line1": "3310 West Main Street, Unit 175",
      "city": "St. Charles",
      "state": "IL",
      "zip": "60175",
      "country": "US"
    },
    "location": {
      "lat": 41.9181419,
      "lng": -88.3582398
    },
    "setting": "network-group",
    "network": {
      "name": "Chicago IVF"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.chicagoivf.com/locations/fertility-clinics/st-charles-northwest-chicago-suburbs",
    "phone": "(630) 513-9963",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.chicagoivf.com/about/fertility-specialists/dr-joel-brasch",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Chicago+IVF+-+St.+Charles+Fertility+Clinic,+3310+W+Main+St+Ste+175,+St.+Charles,+IL+60175/@41.9176928,-88.3560339,2969a,13.1y/data=!4m2!3m1!1s0x880f1d4343bca667:0x297070da2df7d4a8",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Joel G. Brasch, MD",
        "imageUrl": "https://www.chicagoivf.com/content/1-about/1-fertility-specialists/dr-joel-brasch/civf-joel-brasch.jpg",
        "_source": {
          "url": "https://www.chicagoivf.com/about/fertility-specialists/dr-joel-brasch",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-chicago-ivf-st-charles-joel-g-brasch-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-invia-arlington-heights",
    "externalIds": {
      "googlePlaceId": "ChIJxZ11zKO6D4gR6S6xyY2rvvw"
    },
    "type": "fertility-clinic",
    "name": "InVia Fertility Specialists - Arlington Heights",
    "address": {
      "line1": "1100 W. Central Road, Suite 404",
      "city": "Arlington Heights",
      "state": "IL",
      "zip": "60005",
      "country": "US"
    },
    "location": {
      "lat": 42.0666524,
      "lng": -87.9942053
    },
    "setting": "network-group",
    "network": {
      "name": "InVia Fertility Specialists"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.inviafertility.com/locations/arlington-heights",
    "phone": "(847) 884-8884",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.inviafertility.com/meet-the-staff",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/InVia+Fertility+Specialists+-+Arlington+Heights,+1100+Central+Rd+Ste+404,+Arlington+Heights,+IL+60005/@42.0674605,-87.9955577,2962a,13.1y/data=!4m2!3m1!1s0x880fbaa3cc759dc5:0xfcbeab8dc9b12ee9",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Vishvanath C. Karande, MD",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Dr.%20Karande%20Headshots-5.jpg?width=700&name=Dr.%20Karande%20Headshots-5.jpg",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-invia-arlington-heights-vishvanath-c-karande-md"
      },
      {
        "name": "Sigal Klipstein, MD",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Dr.%20Klipstein%20Headshots-5.jpg?width=295&height=443&name=Dr.%20Klipstein%20Headshots-5.jpg",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-invia-arlington-heights-sigal-klipstein-md"
      },
      {
        "name": "Elizabeth Puscheck, MD",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Dr.%20Puscheck%20Headshots-12.jpg?width=295&height=443&name=Dr.%20Puscheck%20Headshots-12.jpg",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-invia-arlington-heights-elizabeth-puscheck-md"
      },
      {
        "name": "Ha Luu, MD",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Dr.%20Luu%20Headshots-2.jpg?width=298&name=Dr.%20Luu%20Headshots-2.jpg",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-invia-arlington-heights-ha-luu-md"
      },
      {
        "name": "Lisa Shandley, MD",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Shandley.jpg?width=298&name=Shandley.jpg",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-invia-arlington-heights-lisa-shandley-md"
      }
    ],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkQza61R-UWPT4iJg1i3lgtLuGEGdLUcsVuzKosnXKXEEBXNEQ46pULXtoOOZ99ezg62H1zzrcKsShP6p9_fz1Lg_AisoByDdOt3bZkQsRpf312-KXgE-ztwlFlCcYitrQvwJMTcrmYKdma=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/InVia+Fertility+Specialists+-+Arlington+Heights,+1100+Central+Rd+Ste+404,+Arlington+Heights,+IL+60005/@42.0674605,-87.9955577,2962a,13.1y/data=!4m2!3m1!1s0x880fbaa3cc759dc5:0xfcbeab8dc9b12ee9",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm5DQN6AQNyXRw7Lw1N6LSTBN_iFofHW374HlFsy3lmO2b43SbjcKwmWRtZZ80oi0y9vVMXEQjEPb47ddsHfmKbztXxB7Ehk-g6C7Uc0f1aKAbN8YYgYztHuQOhx0XFVlLmRDTn90xBmSSV=w298-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/InVia+Fertility+Specialists+-+Arlington+Heights,+1100+Central+Rd+Ste+404,+Arlington+Heights,+IL+60005/@42.0674605,-87.9955577,2962a,13.1y/data=!4m2!3m1!1s0x880fbaa3cc759dc5:0xfcbeab8dc9b12ee9",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-invia-crystal-lake",
    "externalIds": {
      "googlePlaceId": "ChIJlen3xrdyD4gRUrGD17Bi0OI"
    },
    "type": "fertility-clinic",
    "name": "InVia Fertility Specialists - Crystal Lake",
    "address": {
      "line1": "407 Congress Parkway, Suite D",
      "city": "Crystal Lake",
      "state": "IL",
      "zip": "60014",
      "country": "US"
    },
    "location": {
      "lat": 42.2312241,
      "lng": -88.3062371
    },
    "setting": "network-group",
    "network": {
      "name": "InVia Fertility Specialists"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.inviafertility.com/locations/crystal-lake",
    "phone": "(815) 356-1818",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.inviafertility.com/meet-the-staff",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/InVia+Fertility+Specialists+-+Crystal+Lake,+407+Congress+Pkwy+Ste+D,+Crystal+Lake,+IL+60014/@42.2315027,-88.3043372,2954a,13.1y/data=!4m2!3m1!1s0x880f72b7c6f7e995:0xe2d062b0d783b152",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Vishvanath C. Karande, MD",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Dr.%20Karande%20Headshots-5.jpg?width=700&name=Dr.%20Karande%20Headshots-5.jpg",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-invia-crystal-lake-vishvanath-c-karande-md"
      },
      {
        "name": "Sigal Klipstein, MD",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Dr.%20Klipstein%20Headshots-5.jpg?width=295&height=443&name=Dr.%20Klipstein%20Headshots-5.jpg",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-invia-crystal-lake-sigal-klipstein-md"
      },
      {
        "name": "Elizabeth Puscheck, MD",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Dr.%20Puscheck%20Headshots-12.jpg?width=295&height=443&name=Dr.%20Puscheck%20Headshots-12.jpg",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-invia-crystal-lake-elizabeth-puscheck-md"
      },
      {
        "name": "Ha Luu, MD",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Dr.%20Luu%20Headshots-2.jpg?width=298&name=Dr.%20Luu%20Headshots-2.jpg",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-invia-crystal-lake-ha-luu-md"
      },
      {
        "name": "Lisa Shandley, MD",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Shandley.jpg?width=298&name=Shandley.jpg",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-invia-crystal-lake-lisa-shandley-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWn9Rybo0zwmq4p00VSVfLsXLAs01sZ9Ra8N3U-YIgYxqJzpJY9vszwaR5JqtAEsMtCoeJ_orecp2MC0M8oA33Lg6qEy7DmOlB_KDIHllws6O1sJidtu4X8D8T1OZpl-GrOluV7Xuw=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/InVia+Fertility+Specialists+-+Crystal+Lake,+407+Congress+Pkwy+Ste+D,+Crystal+Lake,+IL+60014/@42.2315027,-88.3043372,2954a,13.1y/data=!4m2!3m1!1s0x880f72b7c6f7e995:0xe2d062b0d783b152",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-invia-northbrook",
    "externalIds": {
      "googlePlaceId": "ChIJOTtlkdjAD4gRN2dksOhpvx0"
    },
    "type": "fertility-clinic",
    "name": "InVia Fertility Specialists - Northbrook",
    "address": {
      "line1": "1535 Lake Cook Road, Suite 612",
      "city": "Northbrook",
      "state": "IL",
      "zip": "60062",
      "country": "US"
    },
    "location": {
      "lat": 42.1475945,
      "lng": -87.8172064
    },
    "setting": "network-group",
    "network": {
      "name": "InVia Fertility Specialists"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.inviafertility.com/locations/northbrook",
    "phone": "(847) 884-8884",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.inviafertility.com/meet-the-staff",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/InVia+Fertility+Specialists+-+Northbrook,+1535+Lake+Cook+Rd+Suite+Suite+612,+Northbrook,+IL+60062/@42.1476674,-87.8180138,2958a,13.1y/data=!4m2!3m1!1s0x880fc0d891653b39:0x1dbf69e8b0646737",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Vishvanath C. Karande, MD",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Dr.%20Karande%20Headshots-5.jpg?width=700&name=Dr.%20Karande%20Headshots-5.jpg",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-invia-northbrook-vishvanath-c-karande-md"
      },
      {
        "name": "Sigal Klipstein, MD",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Dr.%20Klipstein%20Headshots-5.jpg?width=295&height=443&name=Dr.%20Klipstein%20Headshots-5.jpg",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-invia-northbrook-sigal-klipstein-md"
      },
      {
        "name": "Elizabeth Puscheck, MD",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Dr.%20Puscheck%20Headshots-12.jpg?width=295&height=443&name=Dr.%20Puscheck%20Headshots-12.jpg",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-invia-northbrook-elizabeth-puscheck-md"
      },
      {
        "name": "Ha Luu, MD",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Dr.%20Luu%20Headshots-2.jpg?width=298&name=Dr.%20Luu%20Headshots-2.jpg",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-invia-northbrook-ha-luu-md"
      },
      {
        "name": "Lisa Shandley, MD",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Shandley.jpg?width=298&name=Shandley.jpg",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-invia-northbrook-lisa-shandley-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmZ2TxzrsCo7fE4mEhYMTBL3Ajaqz3XckLluVYPkWxjxMuMFAfdpbcUN9nRXRzGVBJz1btZvoiS28Xp-p1G1vFP3WriwkpKhdAjz42PgycS5GJ34D57AtiHgSkbZqdzuRmmwFFJjg=w440-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/InVia+Fertility+Specialists+-+Northbrook,+1535+Lake+Cook+Rd+Suite+Suite+612,+Northbrook,+IL+60062/@42.1476674,-87.8180138,2958a,13.1y/data=!4m2!3m1!1s0x880fc0d891653b39:0x1dbf69e8b0646737",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-invia-rockford",
    "externalIds": {
      "googlePlaceId": "ChIJAxSaGiC5CIgRKFv8YGuBDG4"
    },
    "type": "fertility-clinic",
    "name": "InVia Fertility Specialists - Rockford",
    "address": {
      "line1": "2835 McFarland Road, Suite C",
      "city": "Rockford",
      "state": "IL",
      "zip": "61107",
      "country": "US"
    },
    "location": {
      "lat": 42.3019746,
      "lng": -88.9769347
    },
    "setting": "network-group",
    "network": {
      "name": "InVia Fertility Specialists"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.inviafertility.com/locations/rockford",
    "phone": "(815) 397-7077",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.inviafertility.com/meet-the-staff",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/InVia+Fertility+Specialists+-+Rockford,+2835+McFarland+Rd+%23+C,+Rockford,+IL+61107/@42.301898,-88.9761132,2951a,13.1y/data=!4m2!3m1!1s0x8808b9201a9a1403:0x6e0c816b60fc5b28",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Vishvanath C. Karande, MD",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Dr.%20Karande%20Headshots-5.jpg?width=700&name=Dr.%20Karande%20Headshots-5.jpg",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-invia-rockford-vishvanath-c-karande-md"
      },
      {
        "name": "Sigal Klipstein, MD",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Dr.%20Klipstein%20Headshots-5.jpg?width=295&height=443&name=Dr.%20Klipstein%20Headshots-5.jpg",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-invia-rockford-sigal-klipstein-md"
      },
      {
        "name": "Elizabeth Puscheck, MD",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Dr.%20Puscheck%20Headshots-12.jpg?width=295&height=443&name=Dr.%20Puscheck%20Headshots-12.jpg",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-invia-rockford-elizabeth-puscheck-md"
      },
      {
        "name": "Ha Luu, MD",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Dr.%20Luu%20Headshots-2.jpg?width=298&name=Dr.%20Luu%20Headshots-2.jpg",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-invia-rockford-ha-luu-md"
      },
      {
        "name": "Lisa Shandley, MD",
        "imageUrl": "https://www.inviafertility.com/hs-fs/hubfs/Shandley.jpg?width=298&name=Shandley.jpg",
        "_source": {
          "url": "https://www.inviafertility.com/meet-the-staff",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-invia-rockford-lisa-shandley-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-pinnacle-illinois-oak-brook",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Pinnacle Fertility - Oak Brook",
    "address": {
      "line1": "2425 W. 22nd Street, Suite 200",
      "city": "Oak Brook",
      "state": "IL",
      "zip": "60523",
      "country": "US"
    },
    "location": {
      "lat": 41.8460538,
      "lng": -87.9778582
    },
    "setting": "network-group",
    "network": {
      "name": "Pinnacle Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.pinnaclefertility.com/location/oak-brook-il/",
    "phone": "(312) 288-6420",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/oak-brook-il/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "David P. Cohen, MD",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/03/Dr.-David-Cohen_IL-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/chicago-il/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-pinnacle-illinois-oak-brook-david-p-cohen-md"
      }
    ],
    "images": [
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/Nurse-using-microscope-1-oakbrook-1024x683.jpg",
        "type": "lab",
        "caption": "Pinnacle Fertility Oak Brook lab",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/oak-brook-il/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-pinnacle-illinois-tinley-park",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Pinnacle Fertility - Tinley Park",
    "address": {
      "line1": "18210 South La Grange Road, Suite 210",
      "city": "Tinley Park",
      "state": "IL",
      "zip": "60487",
      "country": "US"
    },
    "location": {
      "lat": 41.559318,
      "lng": -87.8534233
    },
    "setting": "network-group",
    "network": {
      "name": "Pinnacle Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.pinnaclefertility.com/location/tinley-park-il/",
    "phone": "(312) 288-6420",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.pinnaclefertility.com/location/tinley-park-il/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "David P. Cohen, MD",
        "imageUrl": "https://cdn.pinnaclefertility.com/wp-content/uploads/2026/03/Dr.-David-Cohen_IL-1024x1024.jpg",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/chicago-il/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-pinnacle-illinois-tinley-park-david-p-cohen-md"
      }
    ],
    "images": [
      {
        "url": "https://cdn.pinnaclefertility.com/wp-content/uploads/2025/02/Front-Reception-talking-to-Patient-2-1024x683.jpg",
        "type": "interior",
        "caption": "Pinnacle Fertility Tinley Park front reception",
        "_source": {
          "url": "https://www.pinnaclefertility.com/location/tinley-park-il/",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-northwestern-fr-medicine-oakbrook",
    "externalIds": {
      "googlePlaceId": "ChIJI1O9gnFNDogRQ7ibMpAAB6g"
    },
    "type": "fertility-clinic",
    "name": "Northwestern Fertility and Reproductive Medicine - Oakbrook Terrace",
    "address": {
      "line1": "1S260 Summit Ave",
      "city": "Oakbrook Terrace",
      "state": "IL",
      "zip": "60181",
      "country": "US"
    },
    "location": {
      "lat": 41.8555207,
      "lng": -87.9728492
    },
    "setting": "hospital-based",
    "network": {
      "name": "Northwestern Medicine"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.nm.org/locations/fertility-and-reproductive-medicine-oakbrook-terrace",
    "phone": "(312) 695-7269",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Fertility Preservation",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.nm.org/conditions-and-care-areas/womens-health/fertility-and-reproductive-medicine/meet-the-fertility-and-reproductive-medicine-team",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Northwestern+Medicine+Center+for+Fertility+and+Reproductive+Medicine+Oakbrook+Terrace,+2+Trans+Am+Plaza+Dr+Ste+400,+Oakbrook+Terrace,+IL+60181/@41.8474877,-87.9867374,2972a,13.1y/data=!4m2!3m1!1s0x880e4d7182bd5323:0xa8070090329bb843",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Mary Ellen Pavone, MD",
        "imageUrl": "https://www.nm.org/image/doctor/NPI/1326192428.jpg",
        "_source": {
          "url": "https://www.nm.org/conditions-and-care-areas/womens-health/fertility-and-reproductive-medicine/meet-the-fertility-and-reproductive-medicine-team",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-northwestern-fr-medicine-oakbrook-mary-ellen-pavone-md"
      },
      {
        "name": "Elnur Babayev, MD",
        "imageUrl": "https://www.nm.org/image/doctor/NPI/1184012759.jpg",
        "_source": {
          "url": "https://www.nm.org/conditions-and-care-areas/womens-health/fertility-and-reproductive-medicine/meet-the-fertility-and-reproductive-medicine-team",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-northwestern-fr-medicine-oakbrook-elnur-babayev-md"
      },
      {
        "name": "Lia Bernardi, MD",
        "imageUrl": "https://www.nm.org/image/doctor/NPI/1467784579.jpg",
        "_source": {
          "url": "https://www.nm.org/conditions-and-care-areas/womens-health/fertility-and-reproductive-medicine/meet-the-fertility-and-reproductive-medicine-team",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-northwestern-fr-medicine-oakbrook-lia-bernardi-md"
      },
      {
        "name": "Christina Boots, MD",
        "imageUrl": "https://www.nm.org/image/doctor/NPI/1760712863.jpg",
        "_source": {
          "url": "https://www.nm.org/conditions-and-care-areas/womens-health/fertility-and-reproductive-medicine/meet-the-fertility-and-reproductive-medicine-team",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-northwestern-fr-medicine-oakbrook-christina-boots-md"
      },
      {
        "name": "Eve Feinberg, MD",
        "imageUrl": "https://www.nm.org/image/doctor/NPI/1306907423.jpg",
        "_source": {
          "url": "https://www.nm.org/conditions-and-care-areas/womens-health/fertility-and-reproductive-medicine/meet-the-fertility-and-reproductive-medicine-team",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-northwestern-fr-medicine-oakbrook-eve-feinberg-md"
      },
      {
        "name": "Kara Goldman, MD",
        "imageUrl": "https://www.nm.org/image/doctor/NPI/1184870818.jpg",
        "_source": {
          "url": "https://www.nm.org/conditions-and-care-areas/womens-health/fertility-and-reproductive-medicine/meet-the-fertility-and-reproductive-medicine-team",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-northwestern-fr-medicine-oakbrook-kara-goldman-md"
      },
      {
        "name": "Tarun Jain, MD",
        "imageUrl": "https://www.nm.org/image/doctor/NPI/1932156809.jpg",
        "_source": {
          "url": "https://www.nm.org/conditions-and-care-areas/womens-health/fertility-and-reproductive-medicine/meet-the-fertility-and-reproductive-medicine-team",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-northwestern-fr-medicine-oakbrook-tarun-jain-md"
      }
    ],
    "images": [
      {
        "url": "https://www.nm.org/-/media/Northwestern/Images/locations/northwestern-medicine-frm-oakbrook-terrace.jpg",
        "type": "exterior",
        "caption": "Northwestern Medicine Fertility and Reproductive Medicine Oakbrook Terrace",
        "_source": {
          "url": "https://www.nm.org/locations/fertility-and-reproductive-medicine-oakbrook-terrace",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkxE8jhkzyjqjItNEphKPhwK8vzi5swt3IzRwSJ6WmMYyl4r8LL1scgilMiL7hxavEztgcGQh2TgFGQ9Ho1Ng3i5P1GO4mYhLH9atArSbZNnurY95NZCJySQEysXXnaK7VeOFMW=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Northwestern+Medicine+Center+for+Fertility+and+Reproductive+Medicine+Oakbrook+Terrace,+2+Trans+Am+Plaza+Dr+Ste+400,+Oakbrook+Terrace,+IL+60181/@41.8474877,-87.9867374,2972a,13.1y/data=!4m2!3m1!1s0x880e4d7182bd5323:0xa8070090329bb843",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmprT3ujBohUaHDIh1mmHzcj-MbGxoNCP4IBikPTv5xura_-mxIv7mGmfyh0EjlI7bY1xi-Fv8PD10v4kIX8EsB6DTktAd2UoZt3sBaDZ0mIN7WvBFKWw69HLxt2bgV_vJP1SKQgBI62O8n=w224-h398-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Northwestern+Medicine+Center+for+Fertility+and+Reproductive+Medicine+Oakbrook+Terrace,+2+Trans+Am+Plaza+Dr+Ste+400,+Oakbrook+Terrace,+IL+60181/@41.8474877,-87.9867374,2972a,13.1y/data=!4m2!3m1!1s0x880e4d7182bd5323:0xa8070090329bb843",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-carle-reproductive-medicine-urbana",
    "externalIds": {
      "googlePlaceId": "ChIJ13DPpjbWDIgROBBKsWaqX1k"
    },
    "type": "fertility-clinic",
    "name": "Carle Reproductive Medicine",
    "address": {
      "line1": "1818 E. Windsor Road",
      "city": "Urbana",
      "state": "IL",
      "zip": "61802",
      "country": "US"
    },
    "location": {
      "lat": 40.0838737,
      "lng": -88.1849092
    },
    "setting": "hospital-based",
    "network": {
      "name": "Carle Health"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://carle.org/services/reproductive-medicine",
    "phone": "(217) 383-3140",
    "treatments": [
      {
        "name": "Fertility Evaluation",
        "category": "diagnostic"
      },
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://carle.org/services/reproductive-medicine",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Carle+Urbana+on+Windsor,+1818+E+Windsor+Rd,+Urbana,+IL+61802/@40.0849345,-88.1842504,3053a,13.1y/data=!4m2!3m1!1s0x880cd636a6cf70d7:0x595faa66b14a1038",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Teresa L. Majers, NP",
        "imageUrl": "https://fap-feed.carle.com/Media/Provider/403?notfound=Provider.jpg",
        "_source": {
          "url": "https://carle.org/services/reproductive-medicine",
          "fetchedAt": "2026-06-14"
        },
        "role": "Nurse Practitioner",
        "credentials": ["NP"],
        "practitionerId": "pr-org-web-carle-reproductive-medicine-urbana-teresa-l-majers-np"
      },
      {
        "name": "Nancy E. Fay, MD",
        "imageUrl": "https://fap-feed.carle.com/Media/Provider/222?notfound=Provider.jpg",
        "_source": {
          "url": "https://carle.org/services/reproductive-medicine",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Medicine",
        "practitionerId": "pr-org-web-carle-reproductive-medicine-urbana-nancy-e-fay-md"
      },
      {
        "name": "Michelle Bobinski, MSN, WHNP-BC",
        "imageUrl": "https://fap-feed.carle.com/Media/Provider/1755?notfound=Provider.jpg",
        "_source": {
          "url": "https://carle.org/services/reproductive-medicine",
          "fetchedAt": "2026-06-14"
        },
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "WHNP-BC"],
        "practitionerId": "pr-org-web-carle-reproductive-medicine-urbana-michelle-bobinski-msn-whnp-bc"
      },
      {
        "name": "Morgan Bolser, MS, FNP-C",
        "imageUrl": "https://fap-feed.carle.com/Media/Provider/3144?notfound=Provider.jpg",
        "_source": {
          "url": "https://carle.org/services/reproductive-medicine",
          "fetchedAt": "2026-06-14"
        },
        "role": "Nurse Practitioner",
        "credentials": ["MS", "FNP-C"],
        "practitionerId": "pr-org-web-carle-reproductive-medicine-urbana-morgan-bolser-ms-fnp-c"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmTijrsagCFmi__vhGoB1F3XYIxkFB9VmnFjQtzVoBpFu0vwGMg8H7k-wP9DzRHVv-sdRj7lkeLFSJACAF6uV1fD8PrQUrrQ7UmyC7fo_FvDpYGzXmuQ_YcJ2ZT43wEbQZggg4r=w426-h240-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Carle+Urbana+on+Windsor,+1818+E+Windsor+Rd,+Urbana,+IL+61802/@40.0849345,-88.1842504,3053a,13.1y/data=!4m2!3m1!1s0x880cd636a6cf70d7:0x595faa66b14a1038",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-rmi-naperville",
    "externalIds": {
      "googlePlaceId": "ChIJDSayIRVXDogRzL-7FUUnSQE"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Medicine Institute - Naperville",
    "address": {
      "line1": "387 Shuman Blvd, Suite 200E",
      "city": "Naperville",
      "state": "IL",
      "zip": "60563",
      "country": "US"
    },
    "location": {
      "lat": 41.803552,
      "lng": -88.1550238
    },
    "setting": "network-group",
    "network": {
      "name": "Reproductive Medicine Institute"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://teamrmi.com/locations/",
    "phone": "(630) 954-0054",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.reproductivemedicineinstitute.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Reproductive+Medicine+Institute,+387+Shuman+Blvd+%23200e,+Naperville,+IL+60563/@41.804534,-88.155454,2974a,13.1y/data=!4m2!3m1!1s0x880e571521b2260d:0x149274515bbbfcc",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Elena Trukhacheva, MD",
        "imageUrl": "https://www.reproductivemedicineinstitute.com/wp-content/uploads/2024/08/elena-trukhacheva.jpg",
        "_source": {
          "url": "https://www.reproductivemedicineinstitute.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rmi-naperville-elena-trukhacheva-md"
      },
      {
        "name": "Shweta Nayak, MD",
        "imageUrl": "https://www.reproductivemedicineinstitute.com/wp-content/uploads/2022/01/Shweta-Nayak-M.D.-FACOG-429x600.jpg",
        "_source": {
          "url": "https://www.reproductivemedicineinstitute.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rmi-naperville-shweta-nayak-md"
      },
      {
        "name": "Amanda Schwartz, MD",
        "imageUrl": "https://www.reproductivemedicineinstitute.com/wp-content/uploads/2025/04/dr-amanda-schwartz-428x600.jpg",
        "_source": {
          "url": "https://www.reproductivemedicineinstitute.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rmi-naperville-amanda-schwartz-md"
      },
      {
        "name": "Asima K. Ahmed, MD",
        "imageUrl": "https://www.reproductivemedicineinstitute.com/wp-content/uploads/2025/09/dr-asima-k-ahmed.png",
        "_source": {
          "url": "https://www.reproductivemedicineinstitute.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rmi-naperville-asima-k-ahmed-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmCOrY2_xoPOgyWZBxt-_JG8aWWJIUuVsq0yq1Dlyw0hHAhVJ9xd73GQTfyT4jf10YFuUH067j6WUK3NxrIW62M6PoSnzxjG7rduaeShNaV3J-lkzUOdjM9famsYXCkiqxsvJ0NXA=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Reproductive+Medicine+Institute,+387+Shuman+Blvd+%23200e,+Naperville,+IL+60563/@41.804534,-88.155454,2974a,13.1y/data=!4m2!3m1!1s0x880e571521b2260d:0x149274515bbbfcc",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlRhqwc2rBfo5w0TeGZWOqwHuxCq-KPI6VVzY6_TQjZhyo5Bb_pNvjmc9jCiTUDU8kEu5KtwiQhJsG0K_tlS7U4Eggs725KLA3bWxc4fjQLvors8MgDk4PXtNmjYuBgGF2RCf6T_w=w417-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Reproductive+Medicine+Institute,+387+Shuman+Blvd+%23200e,+Naperville,+IL+60563/@41.804534,-88.155454,2974a,13.1y/data=!4m2!3m1!1s0x880e571521b2260d:0x149274515bbbfcc",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-rmi-chicago",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Reproductive Medicine Institute - Chicago",
    "address": {
      "line1": "233 E. Erie St, Suite 307",
      "city": "Chicago",
      "state": "IL",
      "zip": "60611",
      "country": "US"
    },
    "location": {
      "lat": 41.894104,
      "lng": -87.6219075
    },
    "setting": "network-group",
    "network": {
      "name": "Reproductive Medicine Institute"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://teamrmi.com/locations/",
    "phone": "(312) 222-8200",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.reproductivemedicineinstitute.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Elena Trukhacheva, MD",
        "imageUrl": "https://www.reproductivemedicineinstitute.com/wp-content/uploads/2024/08/elena-trukhacheva.jpg",
        "_source": {
          "url": "https://www.reproductivemedicineinstitute.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rmi-chicago-elena-trukhacheva-md"
      },
      {
        "name": "Shweta Nayak, MD",
        "imageUrl": "https://www.reproductivemedicineinstitute.com/wp-content/uploads/2022/01/Shweta-Nayak-M.D.-FACOG-429x600.jpg",
        "_source": {
          "url": "https://www.reproductivemedicineinstitute.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rmi-chicago-shweta-nayak-md"
      },
      {
        "name": "Amanda Schwartz, MD",
        "imageUrl": "https://www.reproductivemedicineinstitute.com/wp-content/uploads/2025/04/dr-amanda-schwartz-428x600.jpg",
        "_source": {
          "url": "https://www.reproductivemedicineinstitute.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rmi-chicago-amanda-schwartz-md"
      },
      {
        "name": "Asima K. Ahmed, MD",
        "imageUrl": "https://www.reproductivemedicineinstitute.com/wp-content/uploads/2025/09/dr-asima-k-ahmed.png",
        "_source": {
          "url": "https://www.reproductivemedicineinstitute.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rmi-chicago-asima-k-ahmed-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-rmi-skokie",
    "externalIds": {
      "googlePlaceId": "ChIJ00Tr6KTaD4gREtVLawhIWUs"
    },
    "type": "fertility-clinic",
    "name": "Reproductive Medicine Institute - Skokie",
    "address": {
      "line1": "4709 Golf Rd, Suite 1000",
      "city": "Skokie",
      "state": "IL",
      "zip": "60076",
      "country": "US"
    },
    "location": {
      "lat": 42.0552023,
      "lng": -87.7435465
    },
    "setting": "network-group",
    "network": {
      "name": "Reproductive Medicine Institute"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://teamrmi.com/locations/",
    "phone": "(847) 675-1737",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.reproductivemedicineinstitute.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Reproductive+Medicine+Institute,+4709+Golf+Rd+Ste+1000,+Skokie,+IL+60076/@42.0542667,-87.7440317,2962a,13.1y/data=!4m2!3m1!1s0x880fdaa4e8eb44d3:0x4b5948086b4bd512",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Elena Trukhacheva, MD",
        "imageUrl": "https://www.reproductivemedicineinstitute.com/wp-content/uploads/2024/08/elena-trukhacheva.jpg",
        "_source": {
          "url": "https://www.reproductivemedicineinstitute.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rmi-skokie-elena-trukhacheva-md"
      },
      {
        "name": "Shweta Nayak, MD",
        "imageUrl": "https://www.reproductivemedicineinstitute.com/wp-content/uploads/2022/01/Shweta-Nayak-M.D.-FACOG-429x600.jpg",
        "_source": {
          "url": "https://www.reproductivemedicineinstitute.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rmi-skokie-shweta-nayak-md"
      },
      {
        "name": "Amanda Schwartz, MD",
        "imageUrl": "https://www.reproductivemedicineinstitute.com/wp-content/uploads/2025/04/dr-amanda-schwartz-428x600.jpg",
        "_source": {
          "url": "https://www.reproductivemedicineinstitute.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rmi-skokie-amanda-schwartz-md"
      },
      {
        "name": "Asima K. Ahmed, MD",
        "imageUrl": "https://www.reproductivemedicineinstitute.com/wp-content/uploads/2025/09/dr-asima-k-ahmed.png",
        "_source": {
          "url": "https://www.reproductivemedicineinstitute.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rmi-skokie-asima-k-ahmed-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmxj5cbZFl-n8acDaHq1T5elcUvFqkXAFHVR12DneqOvshRzTI33O1ZhWPjXKnRJVZL9bwu_3X0g_egjWDKfKD2ouqOaCGm5dNtH5-SOY7wosyuPyPaLnliy4WXT3_nJbMw3dMh=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Reproductive+Medicine+Institute,+4709+Golf+Rd+Ste+1000,+Skokie,+IL+60076/@42.0542667,-87.7440317,2962a,13.1y/data=!4m2!3m1!1s0x880fdaa4e8eb44d3:0x4b5948086b4bd512",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkKup5Xv6eyTu_aA-cLaR_HIeBXBboI0ep4ln_e31lkMQO26cErIhaIVwD4fi1Q7vqMsdDnKTt0ZvqUz6QjgnaHq_bfF5iKyHYza0OiJ2ymMs_jLHHGURmyx4kw-uzOoa0LRqrY5Q=w417-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Reproductive+Medicine+Institute,+4709+Golf+Rd+Ste+1000,+Skokie,+IL+60076/@42.0542667,-87.7440317,2962a,13.1y/data=!4m2!3m1!1s0x880fdaa4e8eb44d3:0x4b5948086b4bd512",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-afcc-arlington-heights",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Advanced Fertility Center of Chicago - Arlington Heights",
    "address": {
      "line1": "1626 W. Algonquin Rd",
      "city": "Arlington Heights",
      "state": "IL",
      "zip": "60005",
      "country": "US"
    },
    "location": {
      "lat": 42.0566617,
      "lng": -88.0020586
    },
    "setting": "network-group",
    "network": {
      "name": "Advanced Fertility Center of Chicago"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.advancedfertility.com/fertility-clinic-locations/",
    "phone": "(847) 662-1818",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.advancedfertility.com/fertility-clinics/arlington-heights",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Michelle Catenacci, MD",
        "imageUrl": "https://cdn.buttercms.com/6iBSp5QOTP21ZpHlyn1V",
        "_source": {
          "url": "https://www.advancedfertility.com/fertility-specialists/michelle-catenacci-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-afcc-arlington-heights-michelle-catenacci-md"
      }
    ],
    "images": [
      {
        "url": "https://cdn.buttercms.com/c5S6TWpCTRWdHHQfvTxB",
        "type": "exterior",
        "caption": "Advanced Fertility Center of Chicago Arlington Heights clinic",
        "_source": {
          "url": "https://www.advancedfertility.com/fertility-clinics/arlington-heights",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-afcc-river-north",
    "externalIds": {
      "googlePlaceId": "ChIJaf_-DXEzDogRigvfAMy54hk"
    },
    "type": "fertility-clinic",
    "name": "Advanced Fertility Center of Chicago - River North",
    "address": {
      "line1": "225 W. Illinois Street",
      "city": "Chicago",
      "state": "IL",
      "zip": "60654",
      "country": "US"
    },
    "location": {
      "lat": 41.8907204,
      "lng": -87.6347913
    },
    "setting": "network-group",
    "network": {
      "name": "Advanced Fertility Center of Chicago"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.advancedfertility.com/fertility-clinic-locations/",
    "phone": "(847) 662-1818",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.advancedfertility.com/fertility-clinics/chicago-river-north",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Advanced+Fertility+Center+of+Chicago,+20+W+Kinzie+St+%231130,+Chicago,+IL+60654/@41.8893453,-87.6289276,2970a,13.1y/data=!4m2!3m1!1s0x880e33710dfeff69:0x19e2b9cc00df0b8a",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Michelle Catenacci, MD",
        "imageUrl": "https://cdn.buttercms.com/6iBSp5QOTP21ZpHlyn1V",
        "_source": {
          "url": "https://www.advancedfertility.com/fertility-specialists/michelle-catenacci-md",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-afcc-river-north-michelle-catenacci-md"
      }
    ],
    "images": [
      {
        "url": "https://cdn.buttercms.com/jpsurfZeS5CyfEIuNpoR",
        "type": "exterior",
        "caption": "Advanced Fertility Center of Chicago River North clinic",
        "_source": {
          "url": "https://www.advancedfertility.com/fertility-clinics/chicago-river-north",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnuKCfUy5NUhtK-fQlSdqFZyXyC3y6RW5TnUD16g078QTBCtCxaDoIHnvQCN1m93wXJ_yXuDAEkKXZ4SxlP4tP1FSjb7K_3JsTDk2ZCMLOYE42QTbxHp9m4-Btj35_r86fjGzw5=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Advanced+Fertility+Center+of+Chicago,+20+W+Kinzie+St+%231130,+Chicago,+IL+60654/@41.8893453,-87.6289276,2970a,13.1y/data=!4m2!3m1!1s0x880e33710dfeff69:0x19e2b9cc00df0b8a",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl31gMZS1Zg33_NCsLpvFYfPJfbHvF9JD00x8BKD0Um-_XpMl-HtDOO3nWdKXbSUc3nAfmOgNRb5SBoHMGJKdGWPdTaUA-zPWQj3AOTIxzTQPBXMBABha9qPXrAd5eb33Jx4RU5=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Advanced+Fertility+Center+of+Chicago,+20+W+Kinzie+St+%231130,+Chicago,+IL+60654/@41.8893453,-87.6289276,2970a,13.1y/data=!4m2!3m1!1s0x880e33710dfeff69:0x19e2b9cc00df0b8a",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-kindbody-hoffman-estates",
    "externalIds": {
      "googlePlaceId": "ChIJ0ZNnM3CoD4gR4j9evLrLWN0"
    },
    "type": "fertility-clinic",
    "name": "Kindbody - Hoffman Estates",
    "address": {
      "line1": "1585 Barrington Rd., Suite 401",
      "city": "Hoffman Estates",
      "state": "IL",
      "zip": "60169",
      "country": "US"
    },
    "location": {
      "lat": 42.053566,
      "lng": -88.1443599
    },
    "setting": "network-group",
    "network": {
      "name": "Kindbody"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://kindbody.com/book-appointment-chicago/",
    "phone": "(847) 843-7090",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Kindbody+-+Hoffman+Estates,+1585+Barrington+Rd+%23401,+Hoffman+Estates,+IL+60169/@42.0541505,-88.1413357,2962a,13.1y/data=!4m2!3m1!1s0x880fa870336793d1:0xdd58cbbabc5e3fe2",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-aspire-hfi-loop-central",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Aspire HFI - Loop Central",
    "address": {
      "line1": "4828 Loop Central Dr, Suite 900",
      "city": "Houston",
      "state": "TX",
      "zip": "77081",
      "country": "US"
    },
    "location": {
      "lat": 29.7247315,
      "lng": -95.4553762
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.aspirehfi.com/fertility-clinics",
    "phone": "(713) 730-2229",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-aspire-hfi-beaumont",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Aspire HFI - Beaumont",
    "address": {
      "line1": "6025 Metropolitan Drive, Suite 250",
      "city": "Beaumont",
      "state": "TX",
      "zip": "77706",
      "country": "US"
    },
    "location": {
      "lat": 30.1108481,
      "lng": -94.1734045
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.aspirehfi.com/fertility-clinics",
    "phone": "(713) 730-2229",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-aspire-hfi-pearland",
    "externalIds": {
      "googlePlaceId": "ChIJh3lWKjSTQIYRE4i8xS-_lC0"
    },
    "type": "fertility-clinic",
    "name": "Aspire HFI - Pearland",
    "address": {
      "line1": "10907 Memorial Hermann Drive, Suite 330",
      "city": "Pearland",
      "state": "TX",
      "zip": "77584",
      "country": "US"
    },
    "location": {
      "lat": 29.560269,
      "lng": -95.3917063
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.aspirehfi.com/fertility-clinics/pearland",
    "phone": "(713) 730-2229",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+Pearland,+10907+Memorial+Hermann+Dr+Suite+330,+Pearland,+TX+77584/@29.5609719,-95.3888619,3470a,13.1y/data=!4m2!3m1!1s0x864093342a567987:0x2d94bf2fc5bc8813",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlC-Y0hJK5z4FHip6ilaF6Z7hFTvqYimPasHKIsRWKM4bv5vKhqJbTfDasrxgYwgKStI4TdQduM5B_x8z92dZTALDP-MD3vk9XKlBXvOJSE7-inTMG7ieUv3edvjLzrHyP4WdMG=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+Pearland,+10907+Memorial+Hermann+Dr+Suite+330,+Pearland,+TX+77584/@29.5609719,-95.3888619,3470a,13.1y/data=!4m2!3m1!1s0x864093342a567987:0x2d94bf2fc5bc8813",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlmnf-ekQq70tKmhE-hnBTei_tdvqlguEtZlmXK2wd8eq3yjs6S3iCG4XPN6lyz7NDRdClCEAy229hUOnC7_gVuxSDkcm7yV4YjsDHVIAzqsrMSd_P70X8G15kOhWenwRrYcFkp-0U6Zi7y=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+Pearland,+10907+Memorial+Hermann+Dr+Suite+330,+Pearland,+TX+77584/@29.5609719,-95.3888619,3470a,13.1y/data=!4m2!3m1!1s0x864093342a567987:0x2d94bf2fc5bc8813",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-aspire-hfi-katy",
    "externalIds": {
      "googlePlaceId": "ChIJE7bcvO4mQYYR1w80oTCT4Vg"
    },
    "type": "fertility-clinic",
    "name": "Aspire HFI - Katy",
    "address": {
      "line1": "23920 Katy Freeway, Suite 340",
      "city": "Katy",
      "state": "TX",
      "zip": "77494",
      "country": "US"
    },
    "location": {
      "lat": 29.7773099,
      "lng": -95.8567187
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.aspirehfi.com/fertility-clinics/katy",
    "phone": "(713) 730-2229",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+Katy,+23920+Katy+Fwy+Suite+340,+Katy,+TX+77494/@29.786989,-95.7872328,3463a,13.1y/data=!4m2!3m1!1s0x864126eebcdcb613:0x58e19330a1340fd7",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-aspire-hfi-kingwood",
    "externalIds": {
      "googlePlaceId": "ChIJyZIt8dGyQIYReg6yAc08WTA"
    },
    "type": "fertility-clinic",
    "name": "Aspire HFI - Kingwood",
    "address": {
      "line1": "350 Kingwood Medical Drive, Suite 210",
      "city": "Kingwood",
      "state": "TX",
      "zip": "77339",
      "country": "US"
    },
    "location": {
      "lat": 30.0472584,
      "lng": -95.2590342
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.aspirehfi.com/fertility-clinics/kingwood",
    "phone": "(713) 730-2229",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+Kingwood,+350+Kingwood+Medical+Dr+Suite+210,+Kingwood,+TX+77339/@30.0478678,-95.2589108,3454a,13.1y/data=!4m2!3m1!1s0x8640b2d1f12d92c9:0x30593ccd01b20e7a",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlvlJ20e0sY58h4ImeXp9MBiZ_D1kUMyCNf5DJXPz6_dC4NNg1Q_oVotEWdGYIDQRCQ0pvnc-B_gLTcPo_YNyWcb8iz10d_SQkag3xx4eOyb6Dz3CspqVq6NFYxbfKK6QinFXw_=w408-h544-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+Kingwood,+350+Kingwood+Medical+Dr+Suite+210,+Kingwood,+TX+77339/@30.0478678,-95.2589108,3454a,13.1y/data=!4m2!3m1!1s0x8640b2d1f12d92c9:0x30593ccd01b20e7a",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnYSYMSEgz_omTNJImfK89xkfTEYq7WPNruBQJKVaodRU0rXDBO--qfGiOr6sdH-8nkP76ycu7865wAiY6m8IAl_UIZVsuuOQsFuQzJ0-l8tZG9Fjcwjgvr5VgksP3KX1Km8pBv=w530-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+Kingwood,+350+Kingwood+Medical+Dr+Suite+210,+Kingwood,+TX+77339/@30.0478678,-95.2589108,3454a,13.1y/data=!4m2!3m1!1s0x8640b2d1f12d92c9:0x30593ccd01b20e7a",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-aspire-hfi-cypress",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Aspire HFI - Cypress",
    "address": {
      "line1": "27700 Northwest Freeway, Suite 430",
      "city": "Cypress",
      "state": "TX",
      "zip": "77433",
      "country": "US"
    },
    "location": {
      "lat": 29.9822203,
      "lng": -95.7253396
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.aspirehfi.com/fertility-clinics/cypress",
    "phone": "(713) 730-2229",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-aspire-hfi-woodlands",
    "externalIds": {
      "googlePlaceId": "ChIJQxbDrOc2R4YRFCOXd3vAXR4"
    },
    "type": "fertility-clinic",
    "name": "Aspire HFI - The Woodlands",
    "address": {
      "line1": "8850 Six Pines Drive, Suite 100",
      "city": "The Woodlands",
      "state": "TX",
      "zip": "77380",
      "country": "US"
    },
    "location": {
      "lat": 30.1763075,
      "lng": -95.4597511
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.aspirehfi.com/fertility-clinics/the-woodlands",
    "phone": "(713) 730-2229",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+The+Woodlands,+8850+Six+Pines+Dr+Suite+100,+The+Woodlands,+TX+77380/@30.1758312,-95.4586031,3449a,13.1y/data=!4m2!3m1!1s0x864736e7acc31643:0x1e5dc07b77972314",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkH-0vLO7JuZcIlgNaQmHKZS22e8uM8YyiL94FrDw2U8HRxWjPrqh26nRR5l68UHzSK9ncUKHlA3tYzZ8-TJPYb_v8X5P9qSiAea_R02285oBmcniPs9u-FGmq2jIkqVZMbW6apxXQ2RUs6=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+The+Woodlands,+8850+Six+Pines+Dr+Suite+100,+The+Woodlands,+TX+77380/@30.1758312,-95.4586031,3449a,13.1y/data=!4m2!3m1!1s0x864736e7acc31643:0x1e5dc07b77972314",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-aspire-hfi-clear-lake",
    "externalIds": {
      "googlePlaceId": "ChIJmwFuGo2cQIYRJ5W3_Q3eQzw"
    },
    "type": "fertility-clinic",
    "name": "Aspire HFI - Clear Lake",
    "address": {
      "line1": "400 Medical Center Boulevard, Suite 225",
      "city": "Webster",
      "state": "TX",
      "zip": "77598",
      "country": "US"
    },
    "location": {
      "lat": 29.5449392,
      "lng": -95.1213809
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.aspirehfi.com/fertility-clinics/clear-lake",
    "phone": "(713) 730-2229",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+Clear+Lake,+400+W+Medical+Ctr+Blvd+Suite+225,+Webster,+TX+77598/@29.5423035,-95.1260761,3471a,13.1y/data=!4m2!3m1!1s0x86409c8d1a6e019b:0x3c43de0dfdb79527",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkwb1NFlL3vw3_sEjz6e3b2D1Mr0y5nhYAdU9tTqtOI5BCp50uQmRIP0zOYDwkov1-BsNg9-grLmu5jeW5TAJYKqoqPeb539U4Ut91kF8e-VC2BMG7XtE-VX4k-ccctZWj23BfZpJ-7ges=w457-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+Clear+Lake,+400+W+Medical+Ctr+Blvd+Suite+225,+Webster,+TX+77598/@29.5423035,-95.1260761,3471a,13.1y/data=!4m2!3m1!1s0x86409c8d1a6e019b:0x3c43de0dfdb79527",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-aspire-hfi-sugar-land",
    "externalIds": {
      "googlePlaceId": "ChIJTcHFZbzmQIYRFtNckE2rC1U"
    },
    "type": "fertility-clinic",
    "name": "Aspire HFI - Sugar Land",
    "address": {
      "line1": "16651 Southwest Freeway, Suite 400",
      "city": "Sugar Land",
      "state": "TX",
      "zip": "77479",
      "country": "US"
    },
    "location": {
      "lat": 29.5783132,
      "lng": -95.6518329
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.aspirehfi.com/fertility-clinics/sugar-land",
    "phone": "(713) 730-2229",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+Sugar+Land,+16651+Southwest+Fwy+Ste+400,+Sugar+Land,+TX+77479/@29.5892786,-95.6301876,3469a,13.1y/data=!4m2!3m1!1s0x8640e6bc65c5c14d:0x550bab4d905cd316",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnUVZBMnk_JJTIB-lLrDYdO8pv9vIAzaDWbv63hbehblVhqHm4aIMMUO8M1zu_xyvzbgyCeFASOysOsuO6WwHfcBxVhEPbUHOW0ySUz5qthpkaxYHf5MC6RUoU9fWVRYZ71mGz9H5fQeVA=w457-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+Sugar+Land,+16651+Southwest+Fwy+Ste+400,+Sugar+Land,+TX+77479/@29.5892786,-95.6301876,3469a,13.1y/data=!4m2!3m1!1s0x8640e6bc65c5c14d:0x550bab4d905cd316",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-aspire-hfi-memorial-city",
    "externalIds": {
      "googlePlaceId": "ChIJicje4n3FQIYRc432MIQHky8"
    },
    "type": "fertility-clinic",
    "name": "Aspire HFI - Memorial City",
    "address": {
      "line1": "929 Gessner Road, Suite 1320",
      "city": "Houston",
      "state": "TX",
      "zip": "77024",
      "country": "US"
    },
    "location": {
      "lat": 29.7805049,
      "lng": -95.544515
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.aspirehfi.com/fertility-clinics/memorial-city",
    "phone": "(713) 730-2229",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+Memorial+City,+929+Gessner+Rd+%231320,+Houston,+TX+77024/@29.7825887,-95.5455686,3463a,13.1y/data=!4m2!3m1!1s0x8640c57de2dec889:0x2f93078430f68d73",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlwsO7flz_HEvMgl4_mXG1b9EDrvpGOU9aLa-dQIKJGqZontLQaFD83E_2ZCM5WRzynwFD8zVUCNXp1l0EZFLITGVp0bt9LPMpKtdgC_xHS2ChHPPnolepvHpzZYmqjblFdi27t=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+Memorial+City,+929+Gessner+Rd+%231320,+Houston,+TX+77024/@29.7825887,-95.5455686,3463a,13.1y/data=!4m2!3m1!1s0x8640c57de2dec889:0x2f93078430f68d73",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkWM9CHpFPdIm7UflVca_oyOaxG3d9aJ6RxZjL3B2uDqhG6M3gHAUOyLu10ov611LcaPmDXHsuLGQEScWRFN7voS3axIZWYpLw9U94Va3ywU8T_gvGqcHhmYv76WGPj2Bm7ge-n=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+Memorial+City,+929+Gessner+Rd+%231320,+Houston,+TX+77024/@29.7825887,-95.5455686,3463a,13.1y/data=!4m2!3m1!1s0x8640c57de2dec889:0x2f93078430f68d73",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-aspire-hfi-main-street",
    "externalIds": {
      "googlePlaceId": "ChIJhaREjxTAQIYRvSuZGTGaUzI"
    },
    "type": "fertility-clinic",
    "name": "Aspire HFI - Medical Center Main Street",
    "address": {
      "line1": "7515 S Main Street, Suite 500",
      "city": "Houston",
      "state": "TX",
      "zip": "77030",
      "country": "US"
    },
    "location": {
      "lat": 29.6995363,
      "lng": -95.4102755
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.aspirehfi.com/fertility-clinics/main-street",
    "phone": "(713) 730-2229",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+Medical+Center+-+Main+Street,+7515+Main+St+Ste+500,+Houston,+TX+77030/@29.698698,-95.410275,3466a,13.1y/data=!4m2!3m1!1s0x8640c0148f44a485:0x32539a3119992bbd",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmQLpahRuvQxe9wTHpJb8Z3_HT0l0M3a8N2BwliTEcKD7Ro8bf0a_f3QKb9hyQTJFtFU40sMAcknCvRSQ0CIOysyzJPXhHSrDN4fYPaJRr5zGlqXaPYbHgI7IU-pEDj737gYmLq=w530-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+Medical+Center+-+Main+Street,+7515+Main+St+Ste+500,+Houston,+TX+77030/@29.698698,-95.410275,3466a,13.1y/data=!4m2!3m1!1s0x8640c0148f44a485:0x32539a3119992bbd",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-aspire-hfi-memorial-hermann",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Aspire HFI - Memorial Hermann",
    "address": {
      "line1": "6400 Fannin Street, Suite 2000",
      "city": "Houston",
      "state": "TX",
      "zip": "77030",
      "country": "US"
    },
    "location": {
      "lat": 29.7152985,
      "lng": -95.3965253
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.aspirehfi.com/fertility-clinics/memorial-hermann",
    "phone": "(713) 730-2229",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-aspire-hfi-willowbrook",
    "externalIds": {
      "googlePlaceId": "ChIJ9yk4zfPNQIYRA-BLDFBy0YE"
    },
    "type": "fertility-clinic",
    "name": "Aspire HFI - Willowbrook",
    "address": {
      "line1": "13325 Hargrave Road, Suite 250",
      "city": "Houston",
      "state": "TX",
      "zip": "77070",
      "country": "US"
    },
    "location": {
      "lat": 29.9689965,
      "lng": -95.5518603
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.aspirehfi.com/fertility-clinics/willowbrook",
    "phone": "(713) 730-2229",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Aspire+Fertility+%E2%80%93+Willowbrook,+13325+Hargrave+Rd+Ste+250,+Houston,+TX+77070/@29.9694753,-95.5525663,3456a,13.1y/data=!4m2!3m1!1s0x8640cdf3cd3829f7:0x81d172500c4be003",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-dallas-ivf-dallas",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Dallas IVF - Dallas",
    "address": {
      "line1": "3600 Gaston Avenue, Suite 1001",
      "city": "Dallas",
      "state": "TX",
      "zip": "75246",
      "country": "US"
    },
    "location": {
      "lat": 32.7909346,
      "lng": -96.7803452
    },
    "setting": "network-group",
    "network": {
      "name": "Ivy Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://dallasivf.com/locations/dallas-fertility-clinic",
    "phone": "(214) 225-2057",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://dallasivf.com/locations/dallas-fertility-clinic",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Brian D. Barnett, MD",
        "imageUrl": "https://a.storyblok.com/f/290132/266x400/eb7205627d/doctor-photo-4-dallas.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://dallasivf.com/doctors/dr-brian-barnett",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-dallas-ivf-dallas-brian-d-barnett-md"
      }
    ],
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-dallas-ivf-mckinney",
    "externalIds": {
      "googlePlaceId": "ChIJdYrxF4sUTIYRwk05PpeGnG0"
    },
    "type": "fertility-clinic",
    "name": "Dallas IVF - McKinney",
    "address": {
      "line1": "5301 W University Drive",
      "city": "McKinney",
      "state": "TX",
      "zip": "75071",
      "country": "US"
    },
    "location": {
      "lat": 33.2181413,
      "lng": -96.6831048
    },
    "setting": "network-group",
    "network": {
      "name": "Ivy Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://dallasivf.com/locations/mckinney-fertility-clinic",
    "phone": "(214) 225-2057",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://dallasivf.com/locations/mckinney-fertility-clinic",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Dallas+IVF+-+McKinney,+5301+W+University+Dr,+McKinney,+TX+75071/@33.2177183,-96.6837987,3338a,13.1y/data=!4m2!3m1!1s0x864c148b17f18a75:0x6d9c86973e394dc2",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Brian D. Barnett, MD",
        "imageUrl": "https://a.storyblok.com/f/290132/266x400/eb7205627d/doctor-photo-4-dallas.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://dallasivf.com/doctors/dr-brian-barnett",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-dallas-ivf-mckinney-brian-d-barnett-md"
      }
    ],
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-dallas-ivf-tyler",
    "externalIds": {
      "googlePlaceId": "ChIJm4-Kh-rPSYYRC6Pe8VG2Zj0"
    },
    "type": "fertility-clinic",
    "name": "Dallas IVF - Tyler",
    "address": {
      "line1": "641 South Broadway Avenue, Suite 1",
      "city": "Tyler",
      "state": "TX",
      "zip": "75701",
      "country": "US"
    },
    "location": {
      "lat": 32.3424904,
      "lng": -95.3007552
    },
    "setting": "network-group",
    "network": {
      "name": "Ivy Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://dallasivf.com/locations/tyler-fertility-clinic",
    "phone": "(214) 225-2057",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://dallasivf.com/locations/tyler-fertility-clinic",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Dallas+IVF-+Tyler+Clinic,+641+S+Broadway+Ave+%231%2F2,+Tyler,+TX+75701/@32.3423987,-95.3014494,3371a,13.1y/data=!4m2!3m1!1s0x8649cfea878a8f9b:0x3d66b651f1dea30b",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Brian D. Barnett, MD",
        "imageUrl": "https://a.storyblok.com/f/290132/266x400/eb7205627d/doctor-photo-4-dallas.png/m/0x2000/filters:no_upscale()",
        "_source": {
          "url": "https://dallasivf.com/doctors/dr-brian-barnett",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-dallas-ivf-tyler-brian-d-barnett-md"
      }
    ],
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkfto0VZBXJ1ktfKKRMSjVjO4l18CgcVSwN9QumeyniJAMhfOHF5LohRKSPpFDn_N4xJ44WHaauxJ-ccDfVVYcwEG6eCnIdKDzJgJFI7o0pb5ajkyyg3tlctYATprzMhtKrYnnz=w851-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Dallas+IVF-+Tyler+Clinic,+641+S+Broadway+Ave+%231%2F2,+Tyler,+TX+75701/@32.3423987,-95.3014494,3371a,13.1y/data=!4m2!3m1!1s0x8649cfea878a8f9b:0x3d66b651f1dea30b",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-fst-dallas",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Fertility Specialists of Texas - Dallas",
    "address": {
      "line1": "8160 Walnut Hill Lane, Suite 211",
      "city": "Dallas",
      "state": "TX",
      "zip": "75231",
      "country": "US"
    },
    "location": {
      "lat": 32.8827358,
      "lng": -96.7644255
    },
    "setting": "network-group",
    "network": {
      "name": "Fertility Specialists of Texas"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.fertilitytexas.com/",
    "phone": "(214) 618-2044",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitytexas.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Jerald S. Goldstein, MD",
        "imageUrl": "https://www.fertilitytexas.com/wp-content/uploads/2025/01/FST-Jerald-Goldstein-MD.png",
        "_source": {
          "url": "https://www.fertilitytexas.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-fst-dallas-jerald-s-goldstein-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-fst-southlake",
    "externalIds": {
      "googlePlaceId": "ChIJD2b3kDIrTIYRvxFFkh1ayb4"
    },
    "type": "fertility-clinic",
    "name": "Fertility Specialists of Texas - Southlake",
    "address": {
      "line1": "540 East Southlake Boulevard, Suite 100",
      "city": "Southlake",
      "state": "TX",
      "zip": "76092",
      "country": "US"
    },
    "location": {
      "lat": 32.9411048,
      "lng": -97.1439984
    },
    "setting": "network-group",
    "network": {
      "name": "Fertility Specialists of Texas"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.fertilitytexas.com/",
    "phone": "(214) 618-2044",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitytexas.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Specialists+of+Texas+-+Southlake,+540+E+Southlake+Blvd+%23100,+Southlake,+TX+76092/@32.9413748,-97.1450875,3348a,13.1y/data=!4m2!3m1!1s0x864c2b3290f7660f:0xbec95a1d924511bf",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Jerald S. Goldstein, MD",
        "imageUrl": "https://www.fertilitytexas.com/wp-content/uploads/2025/01/FST-Jerald-Goldstein-MD.png",
        "_source": {
          "url": "https://www.fertilitytexas.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-fst-southlake-jerald-s-goldstein-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-fst-rockwall",
    "externalIds": {
      "googlePlaceId": "ChIJaZ2psdyrToYRfg7LdyPD8gs"
    },
    "type": "fertility-clinic",
    "name": "Fertility Specialists of Texas - Rockwall",
    "address": {
      "line1": "1005 W Ralph Hall Parkway, Suite 237",
      "city": "Rockwall",
      "state": "TX",
      "zip": "75032",
      "country": "US"
    },
    "location": {
      "lat": 32.8882669,
      "lng": -96.4695559
    },
    "setting": "network-group",
    "network": {
      "name": "Fertility Specialists of Texas"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.fertilitytexas.com/",
    "phone": "(214) 618-2044",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.fertilitytexas.com/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Fertility+Specialists+of+Texas+-+Rockwall,+1005+W+Ralph+Hall+Pkwy+%23237,+Rockwall,+TX+75032/@32.8868042,-96.4697455,3350a,13.1y/data=!4m2!3m1!1s0x864eabdcb1a99d69:0xbf2c32377cb0e7e",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Jerald S. Goldstein, MD",
        "imageUrl": "https://www.fertilitytexas.com/wp-content/uploads/2025/01/FST-Jerald-Goldstein-MD.png",
        "_source": {
          "url": "https://www.fertilitytexas.com/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-fst-rockwall-jerald-s-goldstein-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnflbdo7XuqfrkfTgcmIxXgVPG7_O7NjUpo63zn6m_zDTu5VlBiOvcXHu6fTJhGhAJkXmbV6HI0HEJKYnfkVP_xw0efRqNeMQ0DJ9kdi3SlTNS-lCr5wO1nwRJdL4vvZPCJKBNAv4XoOFU=w408-h544-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Fertility+Specialists+of+Texas+-+Rockwall,+1005+W+Ralph+Hall+Pkwy+%23237,+Rockwall,+TX+75032/@32.8868042,-96.4697455,3350a,13.1y/data=!4m2!3m1!1s0x864eabdcb1a99d69:0xbf2c32377cb0e7e",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-web-tfc-cedar-park",
    "externalIds": {
      "googlePlaceId": "ChIJpXethGktW4YRD2FL7SYEvqY"
    },
    "type": "fertility-clinic",
    "name": "Texas Fertility Center - Cedar Park",
    "address": {
      "line1": "13625 Ronald W Reagan Boulevard, Building 7, Suite 200",
      "city": "Cedar Park",
      "state": "TX",
      "zip": "78613",
      "country": "US"
    },
    "location": {
      "lat": 30.537155,
      "lng": -97.7847217
    },
    "setting": "network-group",
    "network": {
      "name": "Texas Fertility Center"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.cedarparkfertility.com/",
    "phone": "(512) 451-0149",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://txfertility.com/fertility-specialists/kaylen-silverberg-md/",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Texas+Fertility+-+Cedar+Park+Fertility,+13625+Ronald+Reagan+Blvd+%237-200,+Cedar+Park,+TX+78613/@30.537185,-97.786301,3436a,13.1y/data=!4m2!3m1!1s0x865b2d6984ad77a5:0xa6be0426ed4b610f",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Kaylen Silverberg, MD",
        "imageUrl": "https://txfertility.com/wp-content/uploads/2023/03/TFC-Kaylen-Silverberg-Headshot-optimized-819x1024.jpg",
        "_source": {
          "url": "https://txfertility.com/fertility-specialists/kaylen-silverberg-md/",
          "fetchedAt": "2026-06-14"
        },
        "role": "Physician",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-tfc-cedar-park-kaylen-silverberg-md"
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-ivfmd-cooper-city",
    "externalIds": {
      "googlePlaceId": "ChIJIyj4w32m2YgR--PUQNgq8Pw"
    },
    "type": "fertility-clinic",
    "name": "IVFMD - Cooper City",
    "address": {
      "line1": "9900 Stirling Road, Suite 222",
      "city": "Hollywood",
      "state": "FL",
      "zip": "33024",
      "country": "US"
    },
    "location": {
      "lat": 26.044457,
      "lng": -80.277755
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.ivfmd.com/fertility-clinics/cooper-city",
    "phone": "(954) 433-7060",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/IVFMD,+9900+Stirling+Rd+Suite+222,+Hollywood,+FL+33024/@26.0440965,-80.2779955,3585a,13.1y/data=!4m2!3m1!1s0x88d9a67dc3f82823:0xfcf02ad840d4e3fb",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://cdn.buttercms.com/maemv8FbTnO7f1lBaJKO",
        "type": "exterior",
        "caption": "IVFMD Cooper City fertility clinic exterior",
        "_source": {
          "url": "https://www.ivfmd.com/fertility-clinics/cooper-city",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-ivfmd-boca-raton",
    "externalIds": {
      "googlePlaceId": "ChIJmRoqTeQb2YgRIK-_VqUrLbA"
    },
    "type": "fertility-clinic",
    "name": "IVFMD - Boca Raton",
    "address": {
      "line1": "9960 Central Park Boulevard, Suite 275",
      "city": "Boca Raton",
      "state": "FL",
      "zip": "33428",
      "country": "US"
    },
    "location": {
      "lat": 26.3572007,
      "lng": -80.2016276
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.ivfmd.com/fertility-clinics/boca-raton",
    "phone": "(561) 549-9010",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/IVFMD,+9960+N+Central+Park+Blvd+%23275,+Boca+Raton,+FL+33428/@26.3552548,-80.2009418,3575a,13.1y/data=!4m2!3m1!1s0x88d91be44d2a1a99:0xb02d2ba556bfaf20",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkQCKyNQtMBduGbPgoSCCCWd8BZjzjYV_Gp1fAR5ZlxxvYkUAaPRIUoPR_FkanNJANCeXcbZc6CptQgKKmRFXyngHxVowLzAIXIPfc0nT5RU0iRcOZcPGDFLy_jrH_2Xt6mjs6PSQ=w360-h360-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/IVFMD,+9960+N+Central+Park+Blvd+%23275,+Boca+Raton,+FL+33428/@26.3552548,-80.2009418,3575a,13.1y/data=!4m2!3m1!1s0x88d91be44d2a1a99:0xb02d2ba556bfaf20",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-ivfmd-jupiter",
    "externalIds": {
      "googlePlaceId": "ChIJMWL4KnPX3ogRE2ZJ20YD_x4"
    },
    "type": "fertility-clinic",
    "name": "IVFMD - Jupiter",
    "address": {
      "line1": "345 Jupiter Lakes Boulevard, Suite 102",
      "city": "Jupiter",
      "state": "FL",
      "zip": "33458",
      "country": "US"
    },
    "location": {
      "lat": 26.9212228,
      "lng": -80.0987362
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.ivfmd.com/fertility-clinics/jupiter",
    "phone": "(561) 972-6900",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/IVFMD,+345+Jupiter+Lakes+Blvd+Ste+102,+Jupiter,+FL+33458/@26.9216942,-80.0989287,3557a,13.1y/data=!4m2!3m1!1s0x88ded7732af86231:0x1eff0346db496613",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://cdn.buttercms.com/6CikWj1VQKhQhBO8KHH6",
        "type": "exterior",
        "caption": "IVFMD Jupiter fertility clinic exterior",
        "_source": {
          "url": "https://www.ivfmd.com/fertility-clinics/jupiter",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmKRMqwsjnK7t_-z9ZI6PrjxjdXz6NGnPP_CSvRDApscnQ7O8Xl53G6wpI_l035Y9DrufJV9qLhv1H_dCWT8h5lAel0OONutqc7FMstBXqYm8P83-BUZaJtlaBWm7ubcyJZdrDc=w298-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/IVFMD,+345+Jupiter+Lakes+Blvd+Ste+102,+Jupiter,+FL+33458/@26.9216942,-80.0989287,3557a,13.1y/data=!4m2!3m1!1s0x88ded7732af86231:0x1eff0346db496613",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-ivfmd-naples",
    "externalIds": {
      "googlePlaceId": "ChIJn_J8z7Ee24gR3bOX8Sy9ylQ"
    },
    "type": "fertility-clinic",
    "name": "IVFMD - Naples",
    "address": {
      "line1": "1265 Creekside Parkway, Suite 202",
      "city": "Naples",
      "state": "FL",
      "zip": "34108",
      "country": "US"
    },
    "location": {
      "lat": 26.2718628,
      "lng": -81.7928615
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.ivfmd.com/fertility-clinics/naples",
    "phone": "(239) 687-5600",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/IVFMD,+1265+Creekside+Pkwy+Suite+202,+Naples,+FL+34108/@26.271751,-81.7909348,3578a,13.1y/data=!4m2!3m1!1s0x88db1eb1cf7cf29f:0x54cabd2cf197b3dd",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://cdn.buttercms.com/NR1G0iMQTWPkgefhd3Mj",
        "type": "exterior",
        "caption": "IVFMD Naples fertility clinic exterior",
        "_source": {
          "url": "https://www.ivfmd.com/fertility-clinics/naples",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkpaZOG6AHruR7Q2wgoLlo2eEsXEJvbxTBNIzHdvdzoV24I3G2xX29NzZOv5zyjhnt9ZIMWlqaqQ_6_pbpxcbzLetH_GWtIvX9BbCVJrErRnO4TO-5-MidU6owbCKnrBM29XI0=w238-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/IVFMD,+1265+Creekside+Pkwy+Suite+202,+Naples,+FL+34108/@26.271751,-81.7909348,3578a,13.1y/data=!4m2!3m1!1s0x88db1eb1cf7cf29f:0x54cabd2cf197b3dd",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkx0sgmVVSfZClZt7HdZxTimWnAM5ar4lksQmckLtV5xlCPLjzUi8p10PHCdTFSvDuRQfFRY1uKi6wtEzIaLCBmeHImzErxN9dPzZIs-9WTo0kSi6cHCrgAvJ4PWjZnpzR0ATSHVcVfqp3U=w224-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/IVFMD,+1265+Creekside+Pkwy+Suite+202,+Naples,+FL+34108/@26.271751,-81.7909348,3578a,13.1y/data=!4m2!3m1!1s0x88db1eb1cf7cf29f:0x54cabd2cf197b3dd",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-ivfmd-viera",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "IVFMD - Viera",
    "address": {
      "line1": "8059 Spyglass Hill Road, Suite 102",
      "city": "Viera",
      "state": "FL",
      "zip": "32940",
      "country": "US"
    },
    "location": {
      "lat": 28.2377088,
      "lng": -80.7097628
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.ivfmd.com/fertility-clinics/viera",
    "phone": "(321) 752-0111",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://cdn.buttercms.com/NOxl3DdnQ8vJLs62nB3q",
        "type": "exterior",
        "caption": "IVFMD Viera fertility clinic",
        "_source": {
          "url": "https://www.ivfmd.com/fertility-clinics/viera",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-rmg-south-tampa",
    "externalIds": {
      "googlePlaceId": "ChIJa1oou27DwogRKV9mCrf1UCE"
    },
    "type": "fertility-clinic",
    "name": "The Reproductive Medicine Group - South Tampa",
    "address": {
      "line1": "2919 Swann Avenue, Suite 305",
      "city": "Tampa",
      "state": "FL",
      "zip": "33609",
      "country": "US"
    },
    "location": {
      "lat": 27.937494,
      "lng": -82.4896302
    },
    "setting": "network-group",
    "network": {
      "name": "The Reproductive Medicine Group"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.floridafertility.com/our-fertility-clinics/south-tampa",
    "phone": "(813) 870-3553",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.floridafertility.com/fertility-specialists/dr-timothy-yeko",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/The+Reproductive+Medicine+Group,+2919+W+Swann+Ave+%23305,+Tampa,+FL+33609/@27.9377741,-82.4907279,3525a,13.1y/data=!4m2!3m1!1s0x88c2c36ebb285a6b:0x2150f5b70a665f29",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Timothy R. Yeko, MD",
        "imageUrl": "https://cdn.buttercms.com/oS9smygHRDmnOFXdGEyj",
        "_source": {
          "url": "https://www.floridafertility.com/fertility-specialists/dr-timothy-yeko",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rmg-south-tampa-timothy-r-yeko-md"
      }
    ],
    "images": [
      {
        "url": "https://cdn.buttercms.com/rfU8LgFIQ8aczctGH5qG",
        "type": "exterior",
        "caption": "The Reproductive Medicine Group South Tampa clinic",
        "_source": {
          "url": "https://www.floridafertility.com/our-fertility-clinics/south-tampa",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-rmg-clearwater",
    "externalIds": {
      "googlePlaceId": "ChIJ9-NTTL_twogRRtOfs91IVHI"
    },
    "type": "fertility-clinic",
    "name": "The Reproductive Medicine Group - Clearwater",
    "address": {
      "line1": "3165 McMullen Booth Road, Bldg. F, Suite 2",
      "city": "Clearwater",
      "state": "FL",
      "zip": "33761",
      "country": "US"
    },
    "location": {
      "lat": 28.0367024,
      "lng": -82.7089229
    },
    "setting": "network-group",
    "network": {
      "name": "The Reproductive Medicine Group"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.floridafertility.com/our-fertility-clinics/clearwater",
    "phone": "(727) 724-0702",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.floridafertility.com/our-fertility-clinics/clearwater",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/The+Reproductive+Medicine+Group,+3165+McMullen+Booth+Rd+Bldg.+F,+Suite+2,+Clearwater,+FL+33761/@28.0370525,-82.7080766,3522a,13.1y/data=!4m2!3m1!1s0x88c2edbf4c53e3f7:0x725448ddb39fd346",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Timothy R. Yeko, MD",
        "imageUrl": "https://cdn.buttercms.com/oS9smygHRDmnOFXdGEyj",
        "_source": {
          "url": "https://www.floridafertility.com/fertility-specialists/dr-timothy-yeko",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rmg-clearwater-timothy-r-yeko-md"
      }
    ],
    "images": [
      {
        "url": "https://cdn.buttercms.com/xMWP4NsJQOWXSbxudumr",
        "type": "exterior",
        "caption": "The Reproductive Medicine Group Clearwater clinic",
        "_source": {
          "url": "https://www.floridafertility.com/our-fertility-clinics/clearwater",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkQMgdFZ1mSkW8Ef3rS5fgUj_FtRrxXtrjvKSPtuzTlKtFq1mYjHL-03xMdyuDzOARoyt6P2ZZMaYi_H3ix8LcVwRWKq8-nU6QduoRpXc0scc9Y37SuaPGG6iSFcBCtsIuH4pYV=w529-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/The+Reproductive+Medicine+Group,+3165+McMullen+Booth+Rd+Bldg.+F,+Suite+2,+Clearwater,+FL+33761/@28.0370525,-82.7080766,3522a,13.1y/data=!4m2!3m1!1s0x88c2edbf4c53e3f7:0x725448ddb39fd346",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWndNMKvDAgWNVOvfc_q7iZThPi372nZM_w9Fajh2Re-2wdmyNjlb4myZ9mW4fsis5bRIXamFS1TuQ0WQlm3LP7vbbpJlKW3BUa2aHUTovksF7ZXo4nxEZw2c6ZYFjH6m0TwHXrMUEcZ2_Kw=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/The+Reproductive+Medicine+Group,+3165+McMullen+Booth+Rd+Bldg.+F,+Suite+2,+Clearwater,+FL+33761/@28.0370525,-82.7080766,3522a,13.1y/data=!4m2!3m1!1s0x88c2edbf4c53e3f7:0x725448ddb39fd346",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-rmg-brandon",
    "externalIds": {
      "googlePlaceId": "ChIJ59KZE9DNwogRQRn5u5EKvgk"
    },
    "type": "fertility-clinic",
    "name": "The Reproductive Medicine Group - Brandon",
    "address": {
      "line1": "612 Medical Care Drive",
      "city": "Brandon",
      "state": "FL",
      "zip": "33511",
      "country": "US"
    },
    "location": {
      "lat": 27.9325895,
      "lng": -82.2919331
    },
    "setting": "network-group",
    "network": {
      "name": "The Reproductive Medicine Group"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.floridafertility.com/our-fertility-clinics/brandon",
    "phone": "(813) 661-9114",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.floridafertility.com/fertility-specialists/dr-timothy-yeko",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/The+Reproductive+Medicine+Group,+612+Medical+Care+Dr,+Brandon,+FL+33511/@27.9327639,-82.2928706,3525a,13.1y/data=!4m2!3m1!1s0x88c2cdd01399d2e7:0x9be0a91bbf91941",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Timothy R. Yeko, MD",
        "imageUrl": "https://cdn.buttercms.com/oS9smygHRDmnOFXdGEyj",
        "_source": {
          "url": "https://www.floridafertility.com/fertility-specialists/dr-timothy-yeko",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rmg-brandon-timothy-r-yeko-md"
      }
    ],
    "images": [
      {
        "url": "https://cdn.buttercms.com/XekB3cmoQMmNGKkO38is",
        "type": "exterior",
        "caption": "The Reproductive Medicine Group Brandon clinic",
        "_source": {
          "url": "https://www.floridafertility.com/our-fertility-clinics/brandon",
          "fetchedAt": "2026-06-14"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWllXRaoXFeT2f1D5M-6HG2D23c0W6p4l83_5citDZtJS4Zh3-zG1Rmx6tWebkjNbNmR1zaEqcpQA2r3azJX_uIo2vzXRjp6Yw_I0VljRgPTEGmE1-RjlTy4Dda1ZsZyyea7PI1Ij0SUuDg=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/The+Reproductive+Medicine+Group,+612+Medical+Care+Dr,+Brandon,+FL+33511/@27.9327639,-82.2928706,3525a,13.1y/data=!4m2!3m1!1s0x88c2cdd01399d2e7:0x9be0a91bbf91941",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-rmg-wesley-chapel",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "The Reproductive Medicine Group - Wesley Chapel",
    "address": {
      "line1": "3743 Maryweather Lane, Suite 101",
      "city": "Wesley Chapel",
      "state": "FL",
      "zip": "33544",
      "country": "US"
    },
    "location": {
      "lat": 28.2116694,
      "lng": -82.3561703
    },
    "setting": "network-group",
    "network": {
      "name": "The Reproductive Medicine Group"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.floridafertility.com/our-fertility-clinics/wesley-chapel",
    "phone": "(813) 914-7304",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.floridafertility.com/our-fertility-clinics/wesley-chapel",
            "fetchedAt": "2026-06-14"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "name": "Timothy R. Yeko, MD",
        "imageUrl": "https://cdn.buttercms.com/oS9smygHRDmnOFXdGEyj",
        "_source": {
          "url": "https://www.floridafertility.com/fertility-specialists/dr-timothy-yeko",
          "fetchedAt": "2026-06-14"
        },
        "role": "Medical Director",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "practitionerId": "pr-org-web-rmg-wesley-chapel-timothy-r-yeko-md"
      }
    ],
    "images": [
      {
        "url": "https://cdn.buttercms.com/VoneDO9UQN6CVOC1xX1z",
        "type": "exterior",
        "caption": "The Reproductive Medicine Group Wesley Chapel clinic",
        "_source": {
          "url": "https://www.floridafertility.com/our-fertility-clinics/wesley-chapel",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-ivf-center-lake-nona",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "The IVF Center - Lake Nona",
    "address": {
      "line1": "6718 Lake Nona Boulevard, Suite 100",
      "city": "Orlando",
      "state": "FL",
      "zip": "32827",
      "country": "US"
    },
    "location": {
      "lat": 28.3691981,
      "lng": -81.2855997
    },
    "setting": "network-group",
    "network": {
      "name": "The IVF Center"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://theivfcenter.com/contact-us/",
    "phone": "(407) 672-1106",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-crm-orlando-celebration",
    "externalIds": {
      "googlePlaceId": "ChIJgVraoTd_3YgRhzZGnJ9cGas"
    },
    "type": "fertility-clinic",
    "name": "Center for Reproductive Medicine - Celebration",
    "address": {
      "line1": "410 Celebration Place, Suite 205",
      "city": "Celebration",
      "state": "FL",
      "zip": "34747",
      "country": "US"
    },
    "location": {
      "lat": 28.3298856,
      "lng": -81.5396429
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.ivforlando.com/our-fertility-clinics/celebration-fl",
    "phone": "(407) 740-0909",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Center+for+Reproductive+Medicine,+410+Celebration+Pl+Suite+205,+Kissimmee,+FL+34747/@28.3274657,-81.5401221,3512a,13.1y/data=!4m2!3m1!1s0x88dd7f37a1da5a81:0xab195c9f9c463687",
            "fetchedAt": "2026-08-16"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "images": [
      {
        "url": "https://cdn.buttercms.com/ID348FAFR1CUS6Eh0jiV",
        "type": "exterior",
        "caption": "Center for Reproductive Medicine Celebration clinic building",
        "_source": {
          "url": "https://www.ivforlando.com/our-fertility-clinics/celebration-fl",
          "fetchedAt": "2026-06-14"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-crm-orlando-lake-nona",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "Center for Reproductive Medicine - Lake Nona",
    "address": {
      "line1": "6424 Alexandra Louise Drive, Suite 450",
      "city": "Orlando",
      "state": "FL",
      "zip": "32827",
      "country": "US"
    },
    "location": {
      "lat": 28.3718987,
      "lng": -81.2824201
    },
    "setting": "network-group",
    "network": {
      "name": "Prelude Fertility"
    },
    "consultationTypes": ["in-person"],
    "specialties": ["reproductive-endocrinology"],
    "website": "https://www.ivforlando.com/",
    "phone": "(407) 740-0909",
    "treatments": [
      {
        "name": "IVF",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      }
    ],
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "_enrichment": {
      "status": "seed-only",
      "sections": {
        "identity": {
          "status": "verified"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "images": [],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-ccrm-dover-de",
    "externalIds": {
      "googlePlaceId": "ChIJn58HG6l8x4kRZVnF2JM4y2w"
    },
    "type": "fertility-clinic",
    "name": "CCRM Fertility of Delaware - Dover",
    "description": "CCRM Fertility clinic in Dover, DE, formerly RADfertility, offering fertility services including IUI, IVF, ICSI, PGT, egg freezing, donor options, and gestational carrier support.",
    "website": "https://www.ccrmivf.com/location/us/delaware/dover/",
    "phone": "(302) 602-8822",
    "bookingUrl": "https://www.ccrmivf.com/location/us/delaware/dover/",
    "address": {
      "line1": "Eden Hill Medical Center, 200 Banning Street, Suite 240",
      "city": "Dover",
      "state": "DE",
      "zip": "19904",
      "country": "US"
    },
    "location": {
      "lat": 39.1541,
      "lng": -75.5333
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "LGBTQIA+ family building",
        "category": "art"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "United Healthcare"
      ]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "CCRM Fertility"
    },
    "setting": "network-group",
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/delaware/dover/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/delaware/dover/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/delaware/dover/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Dover,+200+Banning+St+Suite+240,+Dover,+DE+19904/@39.1535778,-75.5358931,3094a,13.1y/data=!4m2!3m1!1s0x89c77ca91b079f9f:0x6ccb3893d8c55965",
            "fetchedAt": "2026-08-16"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ccrmivf.com/location/us/delaware/dover/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-satellite-ccrm-dover-de-wendy-schillings-md",
        "name": "Wendy Schillings, MD",
        "role": "Fertility Specialist",
        "credentials": ["MD"],
        "specialty": "Fertility Specialist",
        "imageUrl": "https://www.ccrmivf.com/wp-content/uploads/elementor/thumbs/Wendy_Schillings_600x600_2x-r9yqj74mn9nyjq9h0um6r1c2bzykz5d19relf2lx9c.jpg",
        "_source": {
          "url": "https://www.ccrmivf.com/location/us/delaware/dover/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Delaware (DE) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlpRNYS5vvkdthiBozYhWwyjhGIhnkPuJizwiL96pCgcwdvVQTl_AQO2KjPS1s0c0PkBOM4vg3EX-woSthNxo-sKHEsxD_OFuExO5sJrY0D-iwEdGHxCKHjr7BIDF_cGF766LhDXA=w448-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Dover,+200+Banning+St+Suite+240,+Dover,+DE+19904/@39.1535778,-75.5358931,3094a,13.1y/data=!4m2!3m1!1s0x89c77ca91b079f9f:0x6ccb3893d8c55965",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkYb7pzpOAGkypZVMfIBmvGh9XL5pZaBaVgrRRgVThx9jXNrGMG9jm5wdEz9d0ILR9m1RcwdAeYQ-szhMz1Pmb1CmyUlG_mjabIJOfjkUj0l-ZiwD8VtC8yryLju5EWT-3B2MW0Aw=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/CCRM+Fertility+of+Dover,+200+Banning+St+Suite+240,+Dover,+DE+19904/@39.1535778,-75.5358931,3094a,13.1y/data=!4m2!3m1!1s0x89c77ca91b079f9f:0x6ccb3893d8c55965",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-fih-hilo",
    "externalIds": {
      "googlePlaceId": "ChIJRbvBc620U3kRAkWM4W0YS94"
    },
    "type": "fertility-clinic",
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "name": "Fertility Institute of Hawaii - Hilo",
    "description": "Fertility Institute of Hawaii satellite office in Hilo for neighbor-island fertility consultations and monitoring.",
    "website": "https://www.ivfcenterhawaii.com/contact-us/",
    "bookingUrl": "https://www.ivfcenterhawaii.com/contact-us/",
    "phone": "(808) 545-2800",
    "address": {
      "line1": "82 Puuhonu Place, Suite 208",
      "city": "Hilo",
      "state": "HI",
      "zip": "96720",
      "country": "US"
    },
    "location": {
      "lat": 19.716,
      "lng": -155.0975
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "HMSA",
        "Kaiser Permanente Hawaii",
        "United Healthcare"
      ]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "Fertility Institute of Hawaii"
    },
    "parentClinicId": "org-cdc-219",
    "setting": "network-group",
    "team": [
      {
        "practitionerId": "pr-org-satellite-fih-hilo-john-l-frattarelli-md-hcld",
        "name": "John L. Frattarelli, MD, HCLD",
        "role": "Medical, Practice and Laboratory Director",
        "credentials": ["MD", "HCLD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2021/01/John-Frattarelli-MD.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/john-frattarelli-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fih-hilo-anatte-karmon-md-facog",
        "name": "Anatte Karmon, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2021/01/Anatte-Karmon-MD.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/anatte-karmon-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fih-hilo-emily-goulet-md-facog",
        "name": "Emily Goulet, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2021/01/EG_web.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/emily-goulet-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fih-hilo-kaitlin-corbett-pa-c",
        "name": "Kaitlin Corbett, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "specialty": "Physician Assistant",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2022/10/PXL_20220922_001157193.PORTRAIT-scaled-e1665018923419-300x223.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/kaitlin-corbett-pa-c/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fih-hilo-chandra-marsh-pa-c",
        "name": "Chandra Marsh, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "specialty": "Physician Assistant",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2023/01/Chandra-PA_C-300x200.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/chandra-marsh-pa-c/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fih-hilo-lyndsey-smith-aprn",
        "name": "Lyndsey Smith, APRN",
        "role": "Nurse Practitioner",
        "credentials": ["APRN"],
        "specialty": "Nurse Practitioner",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2022/02/Lyndsey-Smith-APRN-300x200.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/lyndsey-smith-aprn/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.ivfcenterhawaii.com/contact-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.ivfcenterhawaii.com/contact-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfcenterhawaii.com/contact-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/The+Fertility+Institute+of+Hawaii,+82+Puuhonu+Pl+Ste+208,+Hilo,+HI+96720/@19.7170747,-155.0981942,3756a,13.1y/data=!4m2!3m1!1s0x7953b4ad73c1bb45:0xde4b186de18c4502",
            "fetchedAt": "2026-08-16"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/john-frattarelli-md/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, HMSA, Kaiser Permanente Hawaii, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Hawaii (HI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-satellite-fih-maui",
    "externalIds": {
      "googlePlaceId": "ChIJIbZjgKDTVHkRDmaKiycwua0"
    },
    "type": "fertility-clinic",
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "name": "Fertility Institute of Hawaii - Maui",
    "description": "Fertility Institute of Hawaii satellite office in Kahului for neighbor-island fertility consultations and monitoring.",
    "website": "https://www.ivfcenterhawaii.com/contact-us/",
    "bookingUrl": "https://www.ivfcenterhawaii.com/contact-us/",
    "phone": "(808) 466-7120",
    "address": {
      "line1": "165 Ma'a Street",
      "city": "Kahului",
      "state": "HI",
      "zip": "96732",
      "country": "US"
    },
    "location": {
      "lat": 20.889,
      "lng": -156.47
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "HMSA",
        "Kaiser Permanente Hawaii",
        "United Healthcare"
      ]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "Fertility Institute of Hawaii"
    },
    "parentClinicId": "org-cdc-219",
    "setting": "network-group",
    "team": [
      {
        "practitionerId": "pr-org-satellite-fih-maui-john-l-frattarelli-md-hcld",
        "name": "John L. Frattarelli, MD, HCLD",
        "role": "Medical, Practice and Laboratory Director",
        "credentials": ["MD", "HCLD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2021/01/John-Frattarelli-MD.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/john-frattarelli-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fih-maui-anatte-karmon-md-facog",
        "name": "Anatte Karmon, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2021/01/Anatte-Karmon-MD.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/anatte-karmon-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fih-maui-emily-goulet-md-facog",
        "name": "Emily Goulet, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2021/01/EG_web.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/emily-goulet-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fih-maui-kaitlin-corbett-pa-c",
        "name": "Kaitlin Corbett, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "specialty": "Physician Assistant",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2022/10/PXL_20220922_001157193.PORTRAIT-scaled-e1665018923419-300x223.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/kaitlin-corbett-pa-c/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fih-maui-chandra-marsh-pa-c",
        "name": "Chandra Marsh, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "specialty": "Physician Assistant",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2023/01/Chandra-PA_C-300x200.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/chandra-marsh-pa-c/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fih-maui-lyndsey-smith-aprn",
        "name": "Lyndsey Smith, APRN",
        "role": "Nurse Practitioner",
        "credentials": ["APRN"],
        "specialty": "Nurse Practitioner",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2022/02/Lyndsey-Smith-APRN-300x200.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/lyndsey-smith-aprn/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.ivfcenterhawaii.com/contact-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.ivfcenterhawaii.com/contact-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfcenterhawaii.com/contact-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/The+Fertility+Institute+of+Hawaii,+165+Ma'a+Street,+Kahului,+HI+96732/@20.866707,-156.4954861,3728a,13.1y/data=!4m2!3m1!1s0x7954d3a08063b621:0xadb930278b8a660e",
            "fetchedAt": "2026-08-16"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/john-frattarelli-md/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, HMSA, Kaiser Permanente Hawaii, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Hawaii (HI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl7cfS0PzxT7bBmpCeLKZ2utnYXkY6Exi65bj6CtwCc0lV3wFGtcIbotprg4wEXEJqlEHGZnknrIBdiWusIMFw6f2QcY6xbJVTgTJ--oGnaLgTU1Y7AOTevwraOFUszL66JI_yG=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/The+Fertility+Institute+of+Hawaii,+165+Ma'a+Street,+Kahului,+HI+96732/@20.866707,-156.4954861,3728a,13.1y/data=!4m2!3m1!1s0x7954d3a08063b621:0xadb930278b8a660e",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkU_9XdviePXyWzspenugmHlgFhP7luxYZwbVBqBN7zd1VqKzt9LAVJZ2wSOwCaRuCrMwJZsh-PK0XAyTsP6tPolRWPp6Z_9rWjWPLz26gjfGbYYMkWveOXMXGaaqv1WhCP5w0=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/The+Fertility+Institute+of+Hawaii,+165+Ma'a+Street,+Kahului,+HI+96732/@20.866707,-156.4954861,3728a,13.1y/data=!4m2!3m1!1s0x7954d3a08063b621:0xadb930278b8a660e",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-satellite-fih-kona",
    "externalIds": {},
    "type": "fertility-clinic",
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "name": "Fertility Institute of Hawaii - Kona",
    "description": "Fertility Institute of Hawaii satellite office in Kailua-Kona for neighbor-island fertility consultations and monitoring.",
    "website": "https://www.ivfcenterhawaii.com/contact-us/",
    "bookingUrl": "https://www.ivfcenterhawaii.com/contact-us/",
    "phone": "(808) 545-2800",
    "address": {
      "line1": "Ali'i Health Center, 78-6831 Alii Drive, Suite 411",
      "city": "Kailua-Kona",
      "state": "HI",
      "zip": "96740",
      "country": "US"
    },
    "location": {
      "lat": 19.5701,
      "lng": -155.9618
    },
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art"
      },
      {
        "name": "IUI",
        "category": "art"
      },
      {
        "name": "Egg Freezing",
        "category": "preservation"
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation"
      },
      {
        "name": "PGT",
        "category": "diagnostic"
      },
      {
        "name": "Donor programs",
        "category": "art"
      },
      {
        "name": "Surrogacy",
        "category": "art"
      },
      {
        "name": "Fertility preservation",
        "category": "preservation"
      }
    ],
    "insurance": {
      "accepted": true,
      "carriers": [
        "Aetna",
        "Blue Cross Blue Shield",
        "Cigna",
        "HMSA",
        "Kaiser Permanente Hawaii",
        "United Healthcare"
      ]
    },
    "languages": ["English"],
    "consultationTypes": ["in-person", "telehealth"],
    "network": {
      "name": "Fertility Institute of Hawaii"
    },
    "parentClinicId": "org-cdc-219",
    "setting": "network-group",
    "team": [
      {
        "practitionerId": "pr-org-satellite-fih-kona-john-l-frattarelli-md-hcld",
        "name": "John L. Frattarelli, MD, HCLD",
        "role": "Medical, Practice and Laboratory Director",
        "credentials": ["MD", "HCLD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2021/01/John-Frattarelli-MD.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/john-frattarelli-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fih-kona-anatte-karmon-md-facog",
        "name": "Anatte Karmon, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2021/01/Anatte-Karmon-MD.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/anatte-karmon-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fih-kona-emily-goulet-md-facog",
        "name": "Emily Goulet, MD, FACOG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2021/01/EG_web.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/emily-goulet-md/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fih-kona-kaitlin-corbett-pa-c",
        "name": "Kaitlin Corbett, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "specialty": "Physician Assistant",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2022/10/PXL_20220922_001157193.PORTRAIT-scaled-e1665018923419-300x223.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/kaitlin-corbett-pa-c/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fih-kona-chandra-marsh-pa-c",
        "name": "Chandra Marsh, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "specialty": "Physician Assistant",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2023/01/Chandra-PA_C-300x200.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/chandra-marsh-pa-c/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-fih-kona-lyndsey-smith-aprn",
        "name": "Lyndsey Smith, APRN",
        "role": "Nurse Practitioner",
        "credentials": ["APRN"],
        "specialty": "Nurse Practitioner",
        "imageUrl": "https://www.ivfcenterhawaii.com/wp-content/uploads/2022/02/Lyndsey-Smith-APRN-300x200.jpg",
        "_source": {
          "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/lyndsey-smith-aprn/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.ivfcenterhawaii.com/contact-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "verified",
          "source": {
            "url": "https://www.ivfcenterhawaii.com/contact-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfcenterhawaii.com/contact-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://www.ivfcenterhawaii.com/contact-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.ivfcenterhawaii.com/about/meet-our-team/john-frattarelli-md/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported accepted carriers",
              "value": "Aetna, Blue Cross Blue Shield, Cigna, HMSA, Kaiser Permanente Hawaii, United Healthcare",
              "detail": "Network status, pharmacy benefits, and fertility authorizations still need plan-specific confirmation.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Hawaii (HI) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-web-first-choice-obgyn",
    "externalIds": {},
    "type": "medical-practice",
    "name": "First Choice OBGYN",
    "phone": "(907) 308-6488",
    "address": {
      "line1": "3750 E Country Field Cir, Suite E",
      "city": "Wasilla",
      "state": "AK",
      "zip": "99654",
      "country": "US"
    },
    "location": {
      "lat": 61.5894281,
      "lng": -149.3565368
    },
    "website": "https://firstchoiceobgynak.com/",
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "specialties": ["ob-gyn"],
    "treatments": [
      {
        "name": "Fertility Evaluation",
        "category": "diagnostic",
        "_source": {
          "url": "https://firstchoiceobgynak.com/services/fertility/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Ovulation Induction",
        "category": "art",
        "_source": {
          "url": "https://firstchoiceobgynak.com/services/fertility/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://firstchoiceobgynak.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://firstchoiceobgynak.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://firstchoiceobgynak.com/contact/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://firstchoiceobgynak.com/services/fertility/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://firstchoiceobgynak.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://firstchoiceobgynak.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "team": [
      {
        "practitionerId": "pr-org-web-first-choice-obgyn-christy-south-md",
        "name": "Christy South, MD",
        "role": "OB/GYN",
        "credentials": ["MD"],
        "specialty": "Obstetrics and Gynecology",
        "_source": {
          "url": "https://firstchoiceobgynak.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-first-choice-obgyn-margaret-awadalla-pa-c",
        "name": "Margaret Awadalla, PA-C",
        "role": "Physician Assistant",
        "credentials": ["PA-C"],
        "specialty": "Physician Assistant",
        "_source": {
          "url": "https://firstchoiceobgynak.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Alaska (AK) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-mcrm-fertility-tulsa",
    "externalIds": {
      "googlePlaceId": "ChIJn7rRk3uRtocRmBcFdRaDrFk"
    },
    "type": "fertility-clinic",
    "name": "MCRM Fertility - Tulsa",
    "website": "https://www.mcrmfertility.com/our-practice/locations/tulsa-fertility-clinic/",
    "phone": "(918) 615-8484",
    "address": {
      "line1": "4809 E 89th St South, Suite 100",
      "city": "Tulsa",
      "state": "OK",
      "zip": "74137",
      "country": "US"
    },
    "location": {
      "lat": 36.0339709,
      "lng": -95.922783
    },
    "setting": "network-group",
    "network": {
      "name": "MCRM Fertility"
    },
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.mcrmfertility.com/our-practice/locations/tulsa-fertility-clinic/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.mcrmfertility.com/our-practice/locations/tulsa-fertility-clinic/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Third-party reproduction",
        "category": "art",
        "_source": {
          "url": "https://www.mcrmfertility.com/caregivers/mira-aubuchon-md-facog/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [
      {
        "url": "https://www.mcrmfertility.com/wp-content/uploads/2023/09/4809-East-89th-Street-South-Suite-100-Tulsa-OK-74137.jpg",
        "type": "exterior",
        "caption": "MCRM Fertility Tulsa office exterior",
        "_source": {
          "url": "https://www.mcrmfertility.com/our-practice/locations/tulsa-fertility-clinic/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk86QE3k43nSUFfmnM5DrOlY-kIzdtcHbNT0lhhvW7m9mCNhjby6WHvFm_zJP1B-BxUtPzlFYuikqUoAvi2xxkhqQMC39TQSwtZdTf0KDfVQ-CQeMrTIAjIwmRiP324loN5RIv_=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/MCRM+Fertility,+4809+E+89th+St+Ste+100,+Tulsa,+OK+74137/@36.0339566,-95.9227289,3226a,13.1y/data=!4m2!3m1!1s0x87b6917b93d1ba9f:0x59ac831675051798",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnyBLH7ox9cX14n2x0MEUNVinYfw42eUC1ZRXrIgwnI-YNhIEILBsBusOVEgkgQ-9TPe6sasWrf66vr-AZurP3HiAvoPXYeGptPaBk4AHE9ke74NPKuvtB_oE3T5sNy60Rtghs=w224-h298-k-no-pi-0-ya208-ro-0-fo100",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/MCRM+Fertility,+4809+E+89th+St+Ste+100,+Tulsa,+OK+74137/@36.0339566,-95.9227289,3226a,13.1y/data=!4m2!3m1!1s0x87b6917b93d1ba9f:0x59ac831675051798",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "team": [
      {
        "practitionerId": "pr-org-web-mcrm-fertility-tulsa-mira-aubuchon-md-facog",
        "name": "Mira Aubuchon, MD, FACOG",
        "role": "Medical Director",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://www.mcrmfertility.com/wp-content/uploads/2023/05/mira-aubuchon-1024x1024.jpg",
        "_source": {
          "url": "https://www.mcrmfertility.com/caregivers/mira-aubuchon-md-facog/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-mcrm-fertility-tulsa-randy-fink-md-facog",
        "name": "Randy Fink, MD, FACOG",
        "role": "Reproductive Specialist",
        "credentials": ["MD", "FACOG"],
        "specialty": "Reproductive Specialist",
        "imageUrl": "https://www.mcrmfertility.com/wp-content/uploads/2025/09/Dr.-Randy-Fink-cropped-sq-1024x1024.jpg",
        "_source": {
          "url": "https://www.mcrmfertility.com/our-practice/locations/tulsa-fertility-clinic/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-mcrm-fertility-tulsa-lauren-rackovan-msn-aprn-whnp-bc",
        "name": "Lauren Rackovan, MSN, APRN, WHNP-BC",
        "role": "Nurse Practitioner",
        "credentials": ["MSN", "APRN", "WHNP-BC"],
        "specialty": "Women’s Health Nurse Practitioner",
        "imageUrl": "https://www.mcrmfertility.com/wp-content/uploads/2025/10/Lauren_Rackovan_1024x1024.png",
        "_source": {
          "url": "https://www.mcrmfertility.com/caregivers/lauren-rackovan-msn-aprn-whnp-bc/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.mcrmfertility.com/our-practice/locations/tulsa-fertility-clinic/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.mcrmfertility.com/our-practice/locations/tulsa-fertility-clinic/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.mcrmfertility.com/our-practice/locations/tulsa-fertility-clinic/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://www.mcrmfertility.com/our-practice/locations/tulsa-fertility-clinic/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/MCRM+Fertility,+4809+E+89th+St+Ste+100,+Tulsa,+OK+74137/@36.0339566,-95.9227289,3226a,13.1y/data=!4m2!3m1!1s0x87b6917b93d1ba9f:0x59ac831675051798",
            "fetchedAt": "2026-08-16"
          }
        },
        "insurance": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Oklahoma (OK) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-alabama-fertility-huntsville",
    "externalIds": {},
    "type": "fertility-clinic",
    "website": "https://alabamafertility.com/",
    "setting": "boutique",
    "consultationTypes": ["in-person", "telehealth"],
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art",
        "_source": {
          "url": "https://alabamafertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Donor programs",
        "category": "art",
        "_source": {
          "url": "https://alabamafertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://alabamafertility.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "languages": ["English"],
    "team": [
      {
        "practitionerId": "pr-org-satellite-alabama-fertility-huntsville-beth-a-malizia-md",
        "name": "Beth A. Malizia, MD",
        "role": "Fertility Physician",
        "credentials": ["MD"],
        "specialty": "Fertility Physician",
        "imageUrl": "https://alabamafertility.com/wp-content/uploads/2024/09/AFS_DrMalizia_web-400x400.jpg",
        "_source": {
          "url": "https://alabamafertility.com/our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-alabama-fertility-huntsville-janet-mclaren-bouknight-md-msce",
        "name": "Janet McLaren Bouknight, MD, MSCE",
        "role": "Fertility Physician",
        "credentials": ["MD", "MSCE"],
        "specialty": "Fertility Physician",
        "imageUrl": "https://alabamafertility.com/wp-content/uploads/2024/09/AFS_DrBouknight_web-400x400.jpg",
        "_source": {
          "url": "https://alabamafertility.com/our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-alabama-fertility-huntsville-mamie-mclean-md",
        "name": "Mamie McLean, MD",
        "role": "Fertility Physician",
        "credentials": ["MD"],
        "specialty": "Fertility Physician",
        "imageUrl": "https://alabamafertility.com/wp-content/uploads/2024/09/AFS_DrMcLean_web_v2-400x400.jpg",
        "_source": {
          "url": "https://alabamafertility.com/our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-alabama-fertility-huntsville-michael-c-allemand-md",
        "name": "Michael C. Allemand, MD",
        "role": "Fertility Physician",
        "credentials": ["MD"],
        "specialty": "Fertility Physician",
        "imageUrl": "https://alabamafertility.com/wp-content/uploads/2024/09/AFS_DrAllemand_web_v2-400x400.jpg",
        "_source": {
          "url": "https://alabamafertility.com/our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-alabama-fertility-huntsville-emily-spurlin-md",
        "name": "Emily Spurlin, MD",
        "role": "Fertility Physician",
        "credentials": ["MD"],
        "specialty": "Fertility Physician",
        "imageUrl": "https://alabamafertility.com/wp-content/uploads/2024/09/AFS_DrSpurlin_web-400x400.jpg",
        "_source": {
          "url": "https://alabamafertility.com/our-team/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [],
    "network": {
      "name": "Alabama Fertility Specialists"
    },
    "name": "Alabama Fertility Specialists - Huntsville",
    "phone": "(256) 533-1010",
    "address": {
      "line1": "500 Whitesport Drive, Unit 4",
      "city": "Huntsville",
      "state": "AL",
      "zip": "35801",
      "country": "US"
    },
    "location": {
      "lat": 34.692351,
      "lng": -86.571487
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://alabamafertility.com/contact/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://alabamafertility.com/contact/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://alabamafertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://alabamafertility.com/our-team/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://alabamafertility.com/contact/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Alabama (AL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-alabama-fertility-montgomery",
    "externalIds": {},
    "type": "fertility-clinic",
    "website": "https://alabamafertility.com/",
    "setting": "boutique",
    "consultationTypes": ["in-person", "telehealth"],
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art",
        "_source": {
          "url": "https://alabamafertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Donor programs",
        "category": "art",
        "_source": {
          "url": "https://alabamafertility.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://alabamafertility.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "languages": ["English"],
    "team": [
      {
        "practitionerId": "pr-org-satellite-alabama-fertility-montgomery-beth-a-malizia-md",
        "name": "Beth A. Malizia, MD",
        "role": "Fertility Physician",
        "credentials": ["MD"],
        "specialty": "Fertility Physician",
        "imageUrl": "https://alabamafertility.com/wp-content/uploads/2024/09/AFS_DrMalizia_web-400x400.jpg",
        "_source": {
          "url": "https://alabamafertility.com/our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-alabama-fertility-montgomery-janet-mclaren-bouknight-md-msce",
        "name": "Janet McLaren Bouknight, MD, MSCE",
        "role": "Fertility Physician",
        "credentials": ["MD", "MSCE"],
        "specialty": "Fertility Physician",
        "imageUrl": "https://alabamafertility.com/wp-content/uploads/2024/09/AFS_DrBouknight_web-400x400.jpg",
        "_source": {
          "url": "https://alabamafertility.com/our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-alabama-fertility-montgomery-mamie-mclean-md",
        "name": "Mamie McLean, MD",
        "role": "Fertility Physician",
        "credentials": ["MD"],
        "specialty": "Fertility Physician",
        "imageUrl": "https://alabamafertility.com/wp-content/uploads/2024/09/AFS_DrMcLean_web_v2-400x400.jpg",
        "_source": {
          "url": "https://alabamafertility.com/our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-alabama-fertility-montgomery-michael-c-allemand-md",
        "name": "Michael C. Allemand, MD",
        "role": "Fertility Physician",
        "credentials": ["MD"],
        "specialty": "Fertility Physician",
        "imageUrl": "https://alabamafertility.com/wp-content/uploads/2024/09/AFS_DrAllemand_web_v2-400x400.jpg",
        "_source": {
          "url": "https://alabamafertility.com/our-team/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-alabama-fertility-montgomery-emily-spurlin-md",
        "name": "Emily Spurlin, MD",
        "role": "Fertility Physician",
        "credentials": ["MD"],
        "specialty": "Fertility Physician",
        "imageUrl": "https://alabamafertility.com/wp-content/uploads/2024/09/AFS_DrSpurlin_web-400x400.jpg",
        "_source": {
          "url": "https://alabamafertility.com/our-team/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [],
    "network": {
      "name": "Alabama Fertility Specialists"
    },
    "name": "Alabama Fertility Specialists - Montgomery",
    "phone": "(334) 396-9916",
    "address": {
      "line1": "356 St. Luke’s Drive",
      "city": "Montgomery",
      "state": "AL",
      "zip": "36117",
      "country": "US"
    },
    "location": {
      "lat": 32.3765658,
      "lng": -86.1700695
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://alabamafertility.com/contact/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://alabamafertility.com/contact/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://alabamafertility.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://alabamafertility.com/our-team/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "searched-absent",
          "source": {
            "url": "https://alabamafertility.com/contact/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Alabama (AL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-uab-hoover-rei",
    "externalIds": {},
    "type": "fertility-clinic",
    "name": "UAB Reproductive Endocrinology & Infertility Clinic - Hoover",
    "website": "https://www.uabmedicine.org/locations/hoover-primary-specialty-care/",
    "phone": "(205) 996-3130",
    "address": {
      "line1": "501 Emery Drive West, Floor 2",
      "city": "Hoover",
      "state": "AL",
      "zip": "35244",
      "country": "US"
    },
    "location": {
      "lat": 33.352194,
      "lng": -86.84614
    },
    "setting": "hospital-based",
    "network": {
      "name": "UAB Medicine"
    },
    "consultationTypes": ["in-person", "telehealth"],
    "languages": ["English"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.uabmedicine.org/specialties/women-and-infants/reproductive-endocrinology-infertility-services/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.uabmedicine.org/specialties/women-and-infants/reproductive-endocrinology-infertility-services/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Preservation",
        "category": "preservation",
        "_source": {
          "url": "https://www.uabmedicine.org/specialties/women-and-infants/reproductive-endocrinology-infertility-services/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Male Infertility",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.uabmedicine.org/specialties/women-and-infants/reproductive-endocrinology-infertility-services/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "team": [
      {
        "practitionerId": "pr-org-satellite-uab-hoover-rei-richard-burney-md",
        "name": "Richard Burney, MD",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/uab/photos/200/burney-richard-1003958083.jpg",
        "_source": {
          "url": "https://providerdirectory.uabmedicine.org/specialty/Reproductive%20Endocrinology%20and%20Infertility/near/Hoover%2C%20AL?page=1",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-uab-hoover-rei-courtney-gregory-crnp",
        "name": "Courtney Gregory, CRNP",
        "role": "Nurse Practitioner",
        "credentials": ["CRNP"],
        "specialty": "Reproductive Endocrinology and Infertility",
        "imageUrl": "https://cdn-images.kyruus.com/providermatch/uab/photos/200/gregory-courtney-1356659262.jpg",
        "_source": {
          "url": "https://providerdirectory.uabmedicine.org/specialty/Reproductive%20Endocrinology%20and%20Infertility/near/Hoover%2C%20AL?page=1",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [
      {
        "url": "https://www.uabmedicine.org/wp-content/uploads/sites/3/2023/02/RS37683_UAB-med-Hoover-02.jpg",
        "type": "exterior",
        "caption": "UAB Medicine Hoover Primary & Specialty Care exterior",
        "_source": {
          "url": "https://www.uabmedicine.org/locations/hoover-primary-specialty-care/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://providerdirectory.uabmedicine.org/specialty/Reproductive%20Endocrinology%20and%20Infertility/near/Hoover%2C%20AL?page=1",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://providerdirectory.uabmedicine.org/specialty/Reproductive%20Endocrinology%20and%20Infertility/near/Hoover%2C%20AL?page=1",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.uabmedicine.org/specialties/women-and-infants/reproductive-endocrinology-infertility-services/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://providerdirectory.uabmedicine.org/specialty/Reproductive%20Endocrinology%20and%20Infertility/near/Hoover%2C%20AL?page=1",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.uabmedicine.org/locations/hoover-primary-specialty-care/",
            "fetchedAt": "2026-06-13"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Alabama (AL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-web-acrm-homewood",
    "externalIds": {
      "googlePlaceId": "ChIJhyUB7HsZiYgRv7bGxIFXX30"
    },
    "type": "fertility-clinic",
    "website": "https://alabamareproductive.com/",
    "phone": "(205) 307-0484",
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "languages": ["English"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://alabamareproductive.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://alabamareproductive.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://alabamareproductive.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://alabamareproductive.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Reproductive Surgery",
        "category": "surgical",
        "_source": {
          "url": "https://alabamareproductive.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "team": [
      {
        "practitionerId": "pr-org-web-acrm-homewood-cecil-a-long-md-facog-hcld",
        "name": "Cecil A. Long, MD, FACOG, HCLD",
        "role": "Founder, Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG", "HCLD"],
        "specialty": "Reproductive Endocrinologist",
        "imageUrl": "https://alabamareproductive.com/wp-content/uploads/2025/08/ACRM-Cecil-1-2.jpg",
        "_source": {
          "url": "https://alabamareproductive.com/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-acrm-homewood-merry-lynn-mann-md-facog-facmg",
        "name": "Merry Lynn Mann, MD, FACOG, FACMG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG", "FACMG"],
        "specialty": "Reproductive Endocrinologist",
        "imageUrl": "https://alabamareproductive.com/wp-content/uploads/2025/08/ACRM-Merry-1.jpg",
        "_source": {
          "url": "https://alabamareproductive.com/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-acrm-homewood-lori-rosenthal-md",
        "name": "Lori Rosenthal, MD",
        "role": "Fertility Provider",
        "credentials": ["MD"],
        "specialty": "Fertility Provider",
        "imageUrl": "https://alabamareproductive.com/wp-content/uploads/2025/05/LoriRosenthal.jpg",
        "_source": {
          "url": "https://alabamareproductive.com/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-acrm-homewood-gail-beth-hide-msn-crnp-rdms",
        "name": "Gail Beth Hide, MSN, CRNP, RDMS",
        "role": "Nurse Practitioner, Ultrasonographer",
        "credentials": ["MSN", "CRNP", "RDMS"],
        "specialty": "Nurse Practitioner, Ultrasonographer",
        "imageUrl": "https://alabamareproductive.com/wp-content/uploads/2025/08/GailBethHide.jpg",
        "_source": {
          "url": "https://alabamareproductive.com/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-acrm-homewood-tracey-mendelsohn-crnp",
        "name": "Tracey Mendelsohn, CRNP",
        "role": "Nurse Practitioner",
        "credentials": ["CRNP"],
        "specialty": "Nurse Practitioner, Women’s Health",
        "imageUrl": "https://alabamareproductive.com/wp-content/uploads/2025/08/TraceyMendelsohn.jpg",
        "_source": {
          "url": "https://alabamareproductive.com/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-web-acrm-homewood-cecily-metzler-crnp",
        "name": "Cecily Metzler, CRNP",
        "role": "Nurse Practitioner",
        "credentials": ["CRNP"],
        "specialty": "Nurse Practitioner, Reproductive Medicine",
        "imageUrl": "https://alabamareproductive.com/wp-content/uploads/2025/08/CecilyMetzler.jpg",
        "_source": {
          "url": "https://alabamareproductive.com/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [
      {
        "url": "https://alabamareproductive.com/wp-content/uploads/2025/07/ACRM-Home-2.jpg",
        "type": "interior",
        "caption": "ACRM waiting room",
        "_source": {
          "url": "https://alabamareproductive.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://alabamareproductive.com/wp-content/uploads/2025/07/ACRM-Home-3.jpg",
        "type": "lab",
        "caption": "ACRM laboratory microscope",
        "_source": {
          "url": "https://alabamareproductive.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnQGyLgoyfh0GFOvJSye0rjornYJmPck8-X2U4gLNPR4wsyWpG_2BKwHp5xVbGmFtevZGhzuEYX33Hj03FCrIHfX6rZn1HPwJzs3Sn7d4FPUpWy-PSyMpY0B3IMYkbHbb8bsDymr5joVp12=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Alabama+Center+for+Reproductive+Medicine+(ACRM)+-+Birmingham,+2006+Brookwood+Medical+Center+Dr+Suite+302,+Homewood,+AL+35209/@33.4633655,-86.7774131,3328a,13.1y/data=!4m2!3m1!1s0x8889197bec012587:0x7d5f5781c4c6b6bf",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "network": {
      "name": "Alabama Center for Reproductive Medicine"
    },
    "name": "Alabama Center for Reproductive Medicine - Homewood",
    "address": {
      "line1": "2006 Brookwood Medical Center Drive, Suite 302",
      "city": "Homewood",
      "state": "AL",
      "zip": "35209",
      "country": "US"
    },
    "location": {
      "lat": 33.4646556,
      "lng": -86.7724139
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://alabamareproductive.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://alabamareproductive.com/contact-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://alabamareproductive.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://alabamareproductive.com/our-providers/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Alabama+Center+for+Reproductive+Medicine+(ACRM)+-+Birmingham,+2006+Brookwood+Medical+Center+Dr+Suite+302,+Homewood,+AL+35209/@33.4633655,-86.7774131,3328a,13.1y/data=!4m2!3m1!1s0x8889197bec012587:0x7d5f5781c4c6b6bf",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Alabama (AL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-satellite-acrm-montgomery",
    "externalIds": {
      "googlePlaceId": "ChIJtycAPFctjIgR41z-aLMDAFU"
    },
    "type": "fertility-clinic",
    "website": "https://alabamareproductive.com/",
    "phone": "(205) 307-0484",
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "languages": ["English"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://alabamareproductive.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://alabamareproductive.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://alabamareproductive.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Fertility Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://alabamareproductive.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "name": "Reproductive Surgery",
        "category": "surgical",
        "_source": {
          "url": "https://alabamareproductive.com/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "team": [
      {
        "practitionerId": "pr-org-satellite-acrm-montgomery-cecil-a-long-md-facog-hcld",
        "name": "Cecil A. Long, MD, FACOG, HCLD",
        "role": "Founder, Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG", "HCLD"],
        "specialty": "Reproductive Endocrinologist",
        "imageUrl": "https://alabamareproductive.com/wp-content/uploads/2025/08/ACRM-Cecil-1-2.jpg",
        "_source": {
          "url": "https://alabamareproductive.com/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-acrm-montgomery-merry-lynn-mann-md-facog-facmg",
        "name": "Merry Lynn Mann, MD, FACOG, FACMG",
        "role": "Reproductive Endocrinologist",
        "credentials": ["MD", "FACOG", "FACMG"],
        "specialty": "Reproductive Endocrinologist",
        "imageUrl": "https://alabamareproductive.com/wp-content/uploads/2025/08/ACRM-Merry-1.jpg",
        "_source": {
          "url": "https://alabamareproductive.com/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-acrm-montgomery-lori-rosenthal-md",
        "name": "Lori Rosenthal, MD",
        "role": "Fertility Provider",
        "credentials": ["MD"],
        "specialty": "Fertility Provider",
        "imageUrl": "https://alabamareproductive.com/wp-content/uploads/2025/05/LoriRosenthal.jpg",
        "_source": {
          "url": "https://alabamareproductive.com/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-acrm-montgomery-gail-beth-hide-msn-crnp-rdms",
        "name": "Gail Beth Hide, MSN, CRNP, RDMS",
        "role": "Nurse Practitioner, Ultrasonographer",
        "credentials": ["MSN", "CRNP", "RDMS"],
        "specialty": "Nurse Practitioner, Ultrasonographer",
        "imageUrl": "https://alabamareproductive.com/wp-content/uploads/2025/08/GailBethHide.jpg",
        "_source": {
          "url": "https://alabamareproductive.com/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-acrm-montgomery-tracey-mendelsohn-crnp",
        "name": "Tracey Mendelsohn, CRNP",
        "role": "Nurse Practitioner",
        "credentials": ["CRNP"],
        "specialty": "Nurse Practitioner, Women’s Health",
        "imageUrl": "https://alabamareproductive.com/wp-content/uploads/2025/08/TraceyMendelsohn.jpg",
        "_source": {
          "url": "https://alabamareproductive.com/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "practitionerId": "pr-org-satellite-acrm-montgomery-cecily-metzler-crnp",
        "name": "Cecily Metzler, CRNP",
        "role": "Nurse Practitioner",
        "credentials": ["CRNP"],
        "specialty": "Nurse Practitioner, Reproductive Medicine",
        "imageUrl": "https://alabamareproductive.com/wp-content/uploads/2025/08/CecilyMetzler.jpg",
        "_source": {
          "url": "https://alabamareproductive.com/our-providers/",
          "fetchedAt": "2026-06-13"
        }
      }
    ],
    "images": [
      {
        "url": "https://alabamareproductive.com/wp-content/uploads/2025/07/ACRM-Home-2.jpg",
        "type": "interior",
        "caption": "ACRM waiting room",
        "_source": {
          "url": "https://alabamareproductive.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://alabamareproductive.com/wp-content/uploads/2025/07/ACRM-Home-3.jpg",
        "type": "lab",
        "caption": "ACRM laboratory microscope",
        "_source": {
          "url": "https://alabamareproductive.com/",
          "fetchedAt": "2026-06-13"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlwrA6AbWJjNeNNJM_fKyqT7kdbyVhuzc02QoG2_lR0gXO0mBRGwZ_CFhYmfaA89oreqLOndv_V8o-eA1EdeE-NUEIbryD0WRA0fVMM8j9GaQhvdbzGnORkw5j6gUuLQSyQEvRZlqIWAmQ=w408-h509-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Alabama+Center+for+Reproductive+Medicine+(ACRM)+-+Montgomery,+7209+Copperfield+Dr,+Montgomery,+AL+36117/@32.376314,-86.170483,3370a,13.1y/data=!4m2!3m1!1s0x888c2d573c0027b7:0x550003b368fe5ce3",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnlFepdxKHBA2w40cuzy6LUdIngZmiXG77zdOfHoVTfIz5Gy65YFveOxpVJta_dY-3jtecPDeohr2JUSoCUtnUHWJJwmP6xleRhgljDu8sQnq3GYCqzZnvknQiVFzLoGg6v54eAergnjGI2=w386-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Alabama+Center+for+Reproductive+Medicine+(ACRM)+-+Montgomery,+7209+Copperfield+Dr,+Montgomery,+AL+36117/@32.376314,-86.170483,3370a,13.1y/data=!4m2!3m1!1s0x888c2d573c0027b7:0x550003b368fe5ce3",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "network": {
      "name": "Alabama Center for Reproductive Medicine"
    },
    "name": "Alabama Center for Reproductive Medicine - Montgomery",
    "address": {
      "line1": "7209 Copperfield Drive",
      "city": "Montgomery",
      "state": "AL",
      "zip": "36117",
      "country": "US"
    },
    "location": {
      "lat": 32.3761142,
      "lng": -86.1707273
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://alabamareproductive.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://alabamareproductive.com/contact-us/",
            "fetchedAt": "2026-06-13"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://alabamareproductive.com/",
            "fetchedAt": "2026-06-13"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://alabamareproductive.com/our-providers/",
            "fetchedAt": "2026-06-13"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Alabama+Center+for+Reproductive+Medicine+(ACRM)+-+Montgomery,+7209+Copperfield+Dr,+Montgomery,+AL+36117/@32.376314,-86.170483,3370a,13.1y/data=!4m2!3m1!1s0x888c2d573c0027b7:0x550003b368fe5ce3",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-13",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Alabama (AL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-fiq-ceibo-fertility-center",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/ceibo-fertility-center",
      "googlePlaceId": "ChIJNRQv3D4D2YgRxZvM9Kx072c"
    },
    "type": "fertility-clinic",
    "name": "Ceibo Fertility Center",
    "website": "https://www.ceibofertilitycenter.com/",
    "phone": "+1 954-715-7232",
    "email": "hello@ceibofertilitycenter.com",
    "address": {
      "line1": "4801 N Federal Highway",
      "line2": "Suite 300",
      "city": "Fort Lauderdale",
      "state": "FL",
      "zip": "33308",
      "country": "US"
    },
    "location": {
      "lat": 26.18686,
      "lng": -80.11706
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.ceibofertilitycenter.com/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.ceibofertilitycenter.com/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.ceibofertilitycenter.com/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.ceibofertilitycenter.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.ceibofertilitycenter.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.ceibofertilitycenter.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Ceibo+Fertility+Center,+4801+N+Federal+Hwy+%23300,+Fort+Lauderdale,+FL+33308/@26.186929,-80.117145,3580a,13.1y/data=!4m2!3m1!1s0x88d9033edc2f1435:0x67ef74acf4cc9bc5",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWm7Ti9rUENuRk16p1I20pcAl0qsglnzm6v8HfLMupUfauOYDkq5kZ8PkayD1TvavUxPtdOLnaXP9PNQJL61b76MfeAV7OY1RKqR6CXysZlh0aYBY3hzBd8_xZPtcHEI3pVls_J0=w408-h408-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Ceibo+Fertility+Center,+4801+N+Federal+Hwy+%23300,+Fort+Lauderdale,+FL+33308/@26.186929,-80.117145,3580a,13.1y/data=!4m2!3m1!1s0x88d9033edc2f1435:0x67ef74acf4cc9bc5",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkHOZYik9JoZn2jnizp6lROixMl-8JQcGw2s1C-MzjSx9yaBwCGw45_MjM4OE1CzJq0CZfgIkdgJzI1Y4xABZp5JxXYJAtyT49awRcx8tmnreeunHxP1XRYaalrwsUcqIrPoOWJ=w397-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Ceibo+Fertility+Center,+4801+N+Federal+Hwy+%23300,+Fort+Lauderdale,+FL+33308/@26.186929,-80.117145,3580a,13.1y/data=!4m2!3m1!1s0x88d9033edc2f1435:0x67ef74acf4cc9bc5",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-fiq-open-fertility-astoria",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/open-fertility"
    },
    "type": "fertility-clinic",
    "name": "Open Fertility - Astoria",
    "website": "https://openfertility.com/astoria/",
    "phone": "+1 718-450-9440",
    "address": {
      "line1": "3613 30th Ave",
      "city": "Astoria",
      "state": "NY",
      "zip": "11103",
      "country": "US"
    },
    "network": {
      "name": "Open Fertility"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://openfertility.com/astoria/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://openfertility.com/astoria/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "LGBTQ+ Family Planning",
        "category": "art",
        "_source": {
          "url": "https://openfertility.com/astoria/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://openfertility.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://openfertility.com/astoria/",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://openfertility.com/astoria/",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://openfertility.com/astoria/",
            "fetchedAt": "2026-06-15"
          }
        },
        "images": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-fiq-open-fertility-roseville",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/open-fertility"
    },
    "type": "fertility-clinic",
    "name": "Open Fertility - Roseville",
    "website": "https://openfertility.com/roseville/",
    "phone": "+1 916-907-0050",
    "address": {
      "line1": "2550 Douglas Blvd",
      "line2": "Suite 160",
      "city": "Roseville",
      "state": "CA",
      "zip": "95661",
      "country": "US"
    },
    "network": {
      "name": "Open Fertility"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://openfertility.com/roseville/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://openfertility.com/roseville/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "LGBTQ+ Family Planning",
        "category": "art",
        "_source": {
          "url": "https://openfertility.com/roseville/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://openfertility.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://openfertility.com/roseville/",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://openfertility.com/roseville/",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://openfertility.com/roseville/",
            "fetchedAt": "2026-06-15"
          }
        },
        "images": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-fiq-peak-fertility-plano",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/peak-fertility",
      "googlePlaceId": "ChIJWcwdHcI9TIYR9yXdqV38Lx4"
    },
    "type": "fertility-clinic",
    "name": "Peak Fertility - Plano",
    "website": "https://peakfertility.com/contact-us/",
    "phone": "+1 469-443-4329",
    "email": "frontdesk@peakfertility.com",
    "address": {
      "line1": "5288 Towne Square Drive",
      "city": "Plano",
      "state": "TX",
      "zip": "75024",
      "country": "US"
    },
    "network": {
      "name": "Peak Fertility"
    },
    "setting": "boutique",
    "consultationTypes": ["in-person", "telehealth"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://peakfertility.com/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://peakfertility.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://peakfertility.com/contact-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://peakfertility.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://peakfertility.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Peak+Fertility,+5288+Towne+Square+Dr,+Plano,+TX+75024/@33.0907441,-96.8035241,3343a,13.1y/data=!4m2!3m1!1s0x864c3dc21d1dcc59:0x1e2ffc5da9dd25f7",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnl4HYMG6DFhTCeuwinRDiJgoqfMhVby1dIxVhNGCEOPjt0VfIxGmuiyqT-IDO9G7SJE-rG5SO4rAf_bsnbc3s9w6x7ZWA8CSQrZcVoto8rH-PsmSYjWMpFkISSmIPQrstyu0ka=w408-h612-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Peak+Fertility,+5288+Towne+Square+Dr,+Plano,+TX+75024/@33.0907441,-96.8035241,3343a,13.1y/data=!4m2!3m1!1s0x864c3dc21d1dcc59:0x1e2ffc5da9dd25f7",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-fiq-peak-fertility-dallas",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/peak-fertility",
      "googlePlaceId": "ChIJZR6dOrafToYRi3S2sIHvskk"
    },
    "type": "fertility-clinic",
    "name": "Peak Fertility - Dallas",
    "website": "https://peakfertility.com/contact-us/",
    "phone": "+1 469-443-4329",
    "email": "frontdesk@peakfertility.com",
    "address": {
      "line1": "7557 Rambler Rd",
      "line2": "Suite 265",
      "city": "Dallas",
      "state": "TX",
      "zip": "75231",
      "country": "US"
    },
    "network": {
      "name": "Peak Fertility"
    },
    "setting": "boutique",
    "consultationTypes": ["in-person", "telehealth"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://peakfertility.com/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://peakfertility.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://peakfertility.com/contact-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://peakfertility.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://peakfertility.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Peak+Fertility,+7557+Rambler+Rd+Ste+265,+Dallas,+TX+75231/@32.8851798,-96.7631601,3350a,13.1y/data=!4m2!3m1!1s0x864e9fb63a9d1e65:0x49b2ef81b0b6748b",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Texas (TX) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-fiq-perch-fertility",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/perch-fertility",
      "googlePlaceId": "ChIJBwu0_vrxwokRuO7zfnKF2LE"
    },
    "type": "fertility-clinic",
    "name": "Perch Fertility",
    "website": "https://perchfertility.com/",
    "phone": "+1 201-775-0003",
    "address": {
      "line1": "385 Sylvan Ave",
      "line2": "#12",
      "city": "Englewood Cliffs",
      "state": "NJ",
      "zip": "07632",
      "country": "US"
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://perchfertility.com/about-us/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://perchfertility.com/about-us/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://perchfertility.com/about-us/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://perchfertility.com/about-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://perchfertility.com/about-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://perchfertility.com/about-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://perchfertility.com/about-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Perch+Fertility,+385+Sylvan+Ave+%2312,+Englewood+Cliffs,+NJ+07632/@40.8747068,-73.952162,3017a,13.1y/data=!4m2!3m1!1s0x89c2f1fafeb40b07:0xb1d885727ef3eeb8",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New Jersey (NJ) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-fiq-muna-fertility",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/muna-fertility",
      "googlePlaceId": "ChIJtYf0JFwP9YgR17lBPjEC0Ds"
    },
    "type": "fertility-clinic",
    "name": "Muna Fertility",
    "website": "https://www.munafertility.com/",
    "phone": "+1 404-937-7844",
    "email": "info@munafertility.com",
    "address": {
      "line1": "5887 Glenridge Drive",
      "line2": "Suite 300",
      "city": "Sandy Springs",
      "state": "GA",
      "zip": "30328",
      "country": "US"
    },
    "setting": "boutique",
    "consultationTypes": ["in-person", "telehealth"],
    "treatments": [
      {
        "name": "IVF & ICSI",
        "category": "art",
        "_source": {
          "url": "https://www.munafertility.com/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.munafertility.com/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.munafertility.com/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Frozen Embryo Transfer",
        "category": "art",
        "_source": {
          "url": "https://www.munafertility.com/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.munafertility.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.munafertility.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.munafertility.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Muna+Fertility,+5887+Glenridge+Dr+Ste+300,+Sandy+Springs,+GA+30328/@33.9158773,-84.3600377,3311a,13.1y/data=!4m2!3m1!1s0x88f50f5c24f487b5:0x3bd002313e41b9d7",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Georgia (GA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmIxKHLsBo74zVw878-NQZEtpcoq1tOUUVmiNWOk8lXEEPck1Z5Jqqrv_dtokY0X6AE02sN2KUucKfA3fNmvu-KICjVSUCqcVPFYA0-fayi14MqdFKN9VCbJJRxfb0-EtNZbwZwZhOU9iP0=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Muna+Fertility,+5887+Glenridge+Dr+Ste+300,+Sandy+Springs,+GA+30328/@33.9158773,-84.3600377,3311a,13.1y/data=!4m2!3m1!1s0x88f50f5c24f487b5:0x3bd002313e41b9d7",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-fiq-rejoice-fertility-knoxville",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/southeastern-fertility-center",
      "googlePlaceId": "ChIJjaM_6-YuXIgRNWz32qhD9EI"
    },
    "type": "fertility-clinic",
    "name": "Rejoice Fertility - Knoxville",
    "website": "https://rejoicefertility.com/contact-us/",
    "phone": "+1 865-777-0088",
    "address": {
      "line1": "11132 Kingston Pike",
      "city": "Knoxville",
      "state": "TN",
      "zip": "37934",
      "country": "US"
    },
    "network": {
      "name": "Rejoice Fertility"
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://rejoicefertility.com/contact-us/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Embryo Donation",
        "category": "art",
        "_source": {
          "url": "https://rejoicefertility.com/contact-us/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://rejoicefertility.com/contact-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://rejoicefertility.com/contact-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://rejoicefertility.com/contact-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rejoicefertility.com/contact-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Rejoice+Fertility,+11132+Kingston+Pike,+Knoxville,+TN+37934/@35.8858317,-84.1494209,3232a,13.1y/data=!4m2!3m1!1s0x885c2ee6eb3fa38d:0x42f443a8daf76c35",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Tennessee (TN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkMa9HLbZATBn8oOp4vhJuV_6g6AzFXbWrxgLB5vBqKTvYyd4Z9WlxQRzWnStCmxruOpNfrmcxqUqZ7DH0cWPjfEf1XeZZCDueWQFh0040n-C_CBNw8jUQoeNPFTLyxsCSzVOF1=w446-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Rejoice+Fertility,+11132+Kingston+Pike,+Knoxville,+TN+37934/@35.8858317,-84.1494209,3232a,13.1y/data=!4m2!3m1!1s0x885c2ee6eb3fa38d:0x42f443a8daf76c35",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkBxW_rMnWtXNGbXfhj5pEGppPeD6hmj2zjLIJwu8C8bPZdGSe9uJy2QazgNRimKBVjub97uuRZf8NZ_39IWiA0UPFQ4N7g4Mugxfr-17SISP0pVQsObKyZQHu2d-fuTev0LH_gnKXMRldV=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Rejoice+Fertility,+11132+Kingston+Pike,+Knoxville,+TN+37934/@35.8858317,-84.1494209,3232a,13.1y/data=!4m2!3m1!1s0x885c2ee6eb3fa38d:0x42f443a8daf76c35",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-fiq-rejoice-fertility-mt-juliet",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/southeastern-fertility-center"
    },
    "type": "fertility-clinic",
    "name": "Rejoice Fertility - Mt Juliet",
    "website": "https://rejoicefertility.com/contact-us/",
    "phone": "+1 865-777-0088",
    "address": {
      "line1": "660 S Mt Juliet Road",
      "city": "Mt Juliet",
      "state": "TN",
      "zip": "37122",
      "country": "US"
    },
    "network": {
      "name": "Rejoice Fertility"
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://rejoicefertility.com/contact-us/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Embryo Donation",
        "category": "art",
        "_source": {
          "url": "https://rejoicefertility.com/contact-us/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://rejoicefertility.com/contact-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://rejoicefertility.com/contact-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://rejoicefertility.com/contact-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "scraped",
          "source": {
            "url": "https://rejoicefertility.com/contact-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "images": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Tennessee (TN) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-fiq-noble-fertility-center",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/noble-fertility-ctr"
    },
    "type": "fertility-clinic",
    "name": "Noble Fertility Center",
    "website": "https://www.noblefertilitycenter.com/",
    "phone": "+1 212-804-6666",
    "email": "info@noblefertility.com",
    "address": {
      "line1": "137 East 36th Street",
      "line2": "Ground Floor",
      "city": "New York",
      "state": "NY",
      "zip": "10016",
      "country": "US"
    },
    "setting": "boutique",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.noblefertilitycenter.com/index.php/contact-us-clinic",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Donation",
        "category": "art",
        "_source": {
          "url": "https://www.noblefertilitycenter.com/index.php/our-services/egg-donation",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.noblefertilitycenter.com/index.php/contact-us-clinic",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.noblefertilitycenter.com/index.php/contact-us-clinic",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.noblefertilitycenter.com/index.php/our-services/egg-donation",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-fiq-arbor-fertility-fenton",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/arbor-fertility",
      "googlePlaceId": "ChIJCdW0PPvR2IcRHZNkM02b_xs"
    },
    "type": "fertility-clinic",
    "name": "Arbor Fertility - Fenton",
    "website": "https://www.arbor-fertility.com/",
    "phone": "+1 314-806-2229",
    "email": "care@arborfertility.one",
    "logoUrl": "https://images.squarespace-cdn.com/content/v1/651f0b9d43cc8848d2dc9dd8/284c269e-1195-4bec-83cc-24306a4ec8a5/Arbor+Fertility+Logo_color.jpg?format=1500w",
    "socialLinks": [
      {
        "platform": "facebook",
        "url": "http://facebook.com/profile.php?id=61552989937016",
        "label": "Facebook",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "instagram",
        "url": "http://instagram.com/arborfertility/",
        "label": "Instagram",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "linkedin",
        "url": "https://www.linkedin.com/company/arbor-fertility%E2%84%A2%EF%B8%8F/",
        "label": "LinkedIn",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "youtube",
        "url": "https://www.youtube.com/channel/UCFa0BIczpkqBvPEmMYP7N4Q",
        "label": "YouTube",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "address": {
      "line1": "794 Gravois Bluffs Blvd C",
      "city": "Fenton",
      "state": "MO",
      "zip": "63026",
      "country": "US"
    },
    "location": {
      "lat": 38.5024493,
      "lng": -90.4528908
    },
    "network": {
      "name": "Arbor Fertility"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person", "telehealth"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "LGBTQ+ Family Building",
        "category": "art",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Fertility Preservation",
        "category": "preservation",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.arbor-fertility.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/treatment-options",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Arbor+Fertility,+794+Gravois+Bluffs+Blvd,+Fenton,+MO+63026/@38.5023533,-90.4529054,3122a,13.1y/data=!4m2!3m1!1s0x87d8d1fb3cb4d509:0x1bff9b4d3364931d",
            "fetchedAt": "2026-08-16"
          }
        },
        "socialLinks": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "logo": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Missouri (MO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-fiq-arbor-fertility-creve-coeur",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/arbor-fertility",
      "googlePlaceId": "ChIJNVmK3ugz34cRzzOsu8SfRIQ"
    },
    "type": "fertility-clinic",
    "name": "Arbor Fertility - Creve Coeur",
    "website": "https://www.arbor-fertility.com/",
    "phone": "+1 314-806-2229",
    "email": "care@arborfertility.one",
    "logoUrl": "https://images.squarespace-cdn.com/content/v1/651f0b9d43cc8848d2dc9dd8/284c269e-1195-4bec-83cc-24306a4ec8a5/Arbor+Fertility+Logo_color.jpg?format=1500w",
    "socialLinks": [
      {
        "platform": "facebook",
        "url": "http://facebook.com/profile.php?id=61552989937016",
        "label": "Facebook",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "instagram",
        "url": "http://instagram.com/arborfertility/",
        "label": "Instagram",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "linkedin",
        "url": "https://www.linkedin.com/company/arbor-fertility%E2%84%A2%EF%B8%8F/",
        "label": "LinkedIn",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "youtube",
        "url": "https://www.youtube.com/channel/UCFa0BIczpkqBvPEmMYP7N4Q",
        "label": "YouTube",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "address": {
      "line1": "10420 Old Olive Street Road",
      "line2": "Suite 100",
      "city": "Creve Coeur",
      "state": "MO",
      "zip": "63141",
      "country": "US"
    },
    "location": {
      "lat": 38.6744564,
      "lng": -90.4127976
    },
    "network": {
      "name": "Arbor Fertility"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person", "telehealth"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "LGBTQ+ Family Building",
        "category": "art",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Fertility Preservation",
        "category": "preservation",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.arbor-fertility.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/treatment-options",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Arbor+Fertility,+10420+Old+Olive+Street+Rd+Suite+100,+Creve+Coeur,+MO+63141/@38.6744148,-90.4093416,3115a,13.1y/data=!4m2!3m1!1s0x87df33e8de8a5935:0x84449fc4bbac33cf",
            "fetchedAt": "2026-08-16"
          }
        },
        "socialLinks": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "logo": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Missouri (MO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-fiq-arbor-fertility-st-peters",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/arbor-fertility"
    },
    "type": "fertility-clinic",
    "name": "Arbor Fertility - St. Peters",
    "website": "https://www.arbor-fertility.com/",
    "phone": "+1 314-806-2229",
    "email": "care@arborfertility.one",
    "logoUrl": "https://images.squarespace-cdn.com/content/v1/651f0b9d43cc8848d2dc9dd8/284c269e-1195-4bec-83cc-24306a4ec8a5/Arbor+Fertility+Logo_color.jpg?format=1500w",
    "socialLinks": [
      {
        "platform": "facebook",
        "url": "http://facebook.com/profile.php?id=61552989937016",
        "label": "Facebook",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "instagram",
        "url": "http://instagram.com/arborfertility/",
        "label": "Instagram",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "linkedin",
        "url": "https://www.linkedin.com/company/arbor-fertility%E2%84%A2%EF%B8%8F/",
        "label": "LinkedIn",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "youtube",
        "url": "https://www.youtube.com/channel/UCFa0BIczpkqBvPEmMYP7N4Q",
        "label": "YouTube",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "address": {
      "line1": "5401 Veterans Memorial",
      "line2": "Suite 201",
      "city": "St. Peters",
      "state": "MO",
      "zip": "63376",
      "country": "US"
    },
    "location": {
      "lat": 38.7968916,
      "lng": -90.5950192
    },
    "network": {
      "name": "Arbor Fertility"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person", "telehealth"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "LGBTQ+ Family Building",
        "category": "art",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Fertility Preservation",
        "category": "preservation",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.arbor-fertility.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/treatment-options",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "searched-absent"
        },
        "socialLinks": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "logo": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Missouri (MO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-fiq-arbor-fertility-ofallon-il",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/arbor-fertility",
      "googlePlaceId": "ChIJZWwRW7gHdogRnEhpLxQ8lJ0"
    },
    "type": "fertility-clinic",
    "name": "Arbor Fertility - O'Fallon",
    "website": "https://www.arbor-fertility.com/",
    "phone": "+1 314-806-2229",
    "email": "care@arborfertility.one",
    "logoUrl": "https://images.squarespace-cdn.com/content/v1/651f0b9d43cc8848d2dc9dd8/284c269e-1195-4bec-83cc-24306a4ec8a5/Arbor+Fertility+Logo_color.jpg?format=1500w",
    "socialLinks": [
      {
        "platform": "facebook",
        "url": "http://facebook.com/profile.php?id=61552989937016",
        "label": "Facebook",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "instagram",
        "url": "http://instagram.com/arborfertility/",
        "label": "Instagram",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "linkedin",
        "url": "https://www.linkedin.com/company/arbor-fertility%E2%84%A2%EF%B8%8F/",
        "label": "LinkedIn",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "youtube",
        "url": "https://www.youtube.com/channel/UCFa0BIczpkqBvPEmMYP7N4Q",
        "label": "YouTube",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "address": {
      "line1": "701 S Lincoln Ave",
      "city": "O'Fallon",
      "state": "IL",
      "zip": "62269",
      "country": "US"
    },
    "location": {
      "lat": 38.586413,
      "lng": -89.911154
    },
    "network": {
      "name": "Arbor Fertility"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person", "telehealth"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "LGBTQ+ Family Building",
        "category": "art",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Fertility Preservation",
        "category": "preservation",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.arbor-fertility.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/treatment-options",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Arbor+Fertility,+701+S+Lincoln+Ave,+O'Fallon,+IL+62269/@38.5863978,-89.9113256,3119a,13.1y/data=!4m2!3m1!1s0x887607b85b116c65:0x9d943c142f69489c",
            "fetchedAt": "2026-08-16"
          }
        },
        "socialLinks": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "logo": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Illinois (IL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWknkXB8Di_Y0pHFw8SSQkMO-MYTm4RsBVLeAfEJClBnsAe8BTSctPEL-LoR0C1-yom6cCsYv1-_pOcKH950ionWgsdppWmrcV5sCpa0ln8_fEMvKxsvuEKikyY9AaxM7cM2gXE4Nkl0QyA=w447-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Arbor+Fertility,+701+S+Lincoln+Ave,+O'Fallon,+IL+62269/@38.5863978,-89.9113256,3119a,13.1y/data=!4m2!3m1!1s0x887607b85b116c65:0x9d943c142f69489c",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-fiq-arbor-fertility-columbia",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/arbor-fertility",
      "googlePlaceId": "ChIJGSMqU6253IcR_XdxpvRkxyA"
    },
    "type": "fertility-clinic",
    "name": "Arbor Fertility - Columbia",
    "website": "https://www.arbor-fertility.com/",
    "phone": "+1 314-806-2229",
    "email": "care@arborfertility.one",
    "logoUrl": "https://images.squarespace-cdn.com/content/v1/651f0b9d43cc8848d2dc9dd8/284c269e-1195-4bec-83cc-24306a4ec8a5/Arbor+Fertility+Logo_color.jpg?format=1500w",
    "socialLinks": [
      {
        "platform": "facebook",
        "url": "http://facebook.com/profile.php?id=61552989937016",
        "label": "Facebook",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "instagram",
        "url": "http://instagram.com/arborfertility/",
        "label": "Instagram",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "linkedin",
        "url": "https://www.linkedin.com/company/arbor-fertility%E2%84%A2%EF%B8%8F/",
        "label": "LinkedIn",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "youtube",
        "url": "https://www.youtube.com/channel/UCFa0BIczpkqBvPEmMYP7N4Q",
        "label": "YouTube",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "address": {
      "line1": "3301 Berrywood Drive",
      "line2": "Suite 206",
      "city": "Columbia",
      "state": "MO",
      "zip": "65201",
      "country": "US"
    },
    "location": {
      "lat": 38.959368,
      "lng": -92.2888
    },
    "network": {
      "name": "Arbor Fertility"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person", "telehealth"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "LGBTQ+ Family Building",
        "category": "art",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Fertility Preservation",
        "category": "preservation",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.arbor-fertility.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/treatment-options",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Arbor+Fertility,+3301+Berrywood+Dr+%23206,+Columbia,+MO+65201/@38.9595822,-92.2885792,3102a,13.1y/data=!4m2!3m1!1s0x87dcb9ad532a2319:0x20c764f4a67177fd",
            "fetchedAt": "2026-08-16"
          }
        },
        "socialLinks": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "logo": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Missouri (MO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWnpVZQgf3bHrcUZ1IfkgQJrX_RLFHXmN34dZFo61eGAjoPS_lHcChnWT4gAf3z6T2VpYwc6jZLLuPj9tVTtKT98lFF2aVbCZkpGN__c2s7NgtaV6U4fthCudFN2ikRPtBCMUe0nYwa1bwFc=w224-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Arbor+Fertility,+3301+Berrywood+Dr+%23206,+Columbia,+MO+65201/@38.9595822,-92.2885792,3102a,13.1y/data=!4m2!3m1!1s0x87dcb9ad532a2319:0x20c764f4a67177fd",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-fiq-arbor-fertility-chesterfield",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/arbor-fertility",
      "googlePlaceId": "ChIJgaxFfNLV2IcRhLeCNWNkuB4"
    },
    "type": "fertility-clinic",
    "name": "Arbor Fertility - Chesterfield",
    "website": "https://www.arbor-fertility.com/",
    "phone": "+1 314-806-2229",
    "email": "care@arborfertility.one",
    "logoUrl": "https://images.squarespace-cdn.com/content/v1/651f0b9d43cc8848d2dc9dd8/284c269e-1195-4bec-83cc-24306a4ec8a5/Arbor+Fertility+Logo_color.jpg?format=1500w",
    "socialLinks": [
      {
        "platform": "facebook",
        "url": "http://facebook.com/profile.php?id=61552989937016",
        "label": "Facebook",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "instagram",
        "url": "http://instagram.com/arborfertility/",
        "label": "Instagram",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "linkedin",
        "url": "https://www.linkedin.com/company/arbor-fertility%E2%84%A2%EF%B8%8F/",
        "label": "LinkedIn",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "youtube",
        "url": "https://www.youtube.com/channel/UCFa0BIczpkqBvPEmMYP7N4Q",
        "label": "YouTube",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "address": {
      "line1": "15320 Conway Road",
      "line2": "Suite B",
      "city": "Chesterfield",
      "state": "MO",
      "zip": "63017",
      "country": "US"
    },
    "location": {
      "lat": 38.6515204,
      "lng": -90.5517108
    },
    "network": {
      "name": "Arbor Fertility"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person", "telehealth"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "LGBTQ+ Family Building",
        "category": "art",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Fertility Preservation",
        "category": "preservation",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.arbor-fertility.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/treatment-options",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Arbor+Fertility,+15320+Conway+Rd+Ste+B,+Chesterfield,+MO+63017/@38.651597,-90.551943,3116a,13.1y/data=!4m2!3m1!1s0x87d8d5d27c45ac81:0x1eb864633582b784",
            "fetchedAt": "2026-08-16"
          }
        },
        "socialLinks": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "logo": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Missouri (MO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": [
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl9z9waIVGm2zZT4IlLPhnxg2toC84mq8OEo6uW3B773I4g3EInGo1AurGvBRel2AcqcMk5IwI8cJxNNnWr0n42Ep-vKEEDEQMj6qlDWV6EQHYUfkfH1ZyEMVjoZEM57QEpztHS=w224-h398-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/Arbor+Fertility,+15320+Conway+Rd+Ste+B,+Chesterfield,+MO+63017/@38.651597,-90.551943,3116a,13.1y/data=!4m2!3m1!1s0x87d8d5d27c45ac81:0x1eb864633582b784",
          "fetchedAt": "2026-08-16"
        }
      }
    ]
  },
  {
    "id": "org-fiq-arbor-fertility-st-charles",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/arbor-fertility",
      "googlePlaceId": "ChIJreF08NQv34cRKopLBHL6PZw"
    },
    "type": "fertility-clinic",
    "name": "Arbor Fertility - St. Charles",
    "website": "https://www.arbor-fertility.com/",
    "phone": "+1 314-806-2229",
    "email": "care@arborfertility.one",
    "logoUrl": "https://images.squarespace-cdn.com/content/v1/651f0b9d43cc8848d2dc9dd8/284c269e-1195-4bec-83cc-24306a4ec8a5/Arbor+Fertility+Logo_color.jpg?format=1500w",
    "socialLinks": [
      {
        "platform": "facebook",
        "url": "http://facebook.com/profile.php?id=61552989937016",
        "label": "Facebook",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "instagram",
        "url": "http://instagram.com/arborfertility/",
        "label": "Instagram",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "linkedin",
        "url": "https://www.linkedin.com/company/arbor-fertility%E2%84%A2%EF%B8%8F/",
        "label": "LinkedIn",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "youtube",
        "url": "https://www.youtube.com/channel/UCFa0BIczpkqBvPEmMYP7N4Q",
        "label": "YouTube",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "address": {
      "line1": "1360 S 5th St",
      "line2": "Suite 104",
      "city": "St. Charles",
      "state": "MO",
      "zip": "63301",
      "country": "US"
    },
    "location": {
      "lat": 38.7701058,
      "lng": -90.4924335
    },
    "network": {
      "name": "Arbor Fertility"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person", "telehealth"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "LGBTQ+ Family Building",
        "category": "art",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Fertility Preservation",
        "category": "preservation",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.arbor-fertility.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/treatment-options",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Arbor+Fertility,+1360+S+5th+St+Suit+104,+St+Charles,+MO+63301/@38.7700056,-90.4924921,3111a,13.1y/data=!4m2!3m1!1s0x87df2fd4f074e1ad:0x9c3dfa72044b8a2a",
            "fetchedAt": "2026-08-16"
          }
        },
        "socialLinks": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "logo": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Missouri (MO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-fiq-arbor-fertility-parints",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/parints",
      "googlePlaceId": "ChIJ6eJ3kl3N2IcRPC9ShAJH6MU"
    },
    "type": "fertility-clinic",
    "name": "P.A.R.I.N.T.S - A Branch of Arbor Fertility",
    "website": "https://www.arbor-fertility.com/",
    "phone": "+1 314-806-2229",
    "email": "care@arborfertility.one",
    "logoUrl": "https://images.squarespace-cdn.com/content/v1/651f0b9d43cc8848d2dc9dd8/284c269e-1195-4bec-83cc-24306a4ec8a5/Arbor+Fertility+Logo_color.jpg?format=1500w",
    "socialLinks": [
      {
        "platform": "facebook",
        "url": "http://facebook.com/profile.php?id=61552989937016",
        "label": "Facebook",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "instagram",
        "url": "http://instagram.com/arborfertility/",
        "label": "Instagram",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "linkedin",
        "url": "https://www.linkedin.com/company/arbor-fertility%E2%84%A2%EF%B8%8F/",
        "label": "LinkedIn",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "youtube",
        "url": "https://www.youtube.com/channel/UCFa0BIczpkqBvPEmMYP7N4Q",
        "label": "YouTube",
        "_source": {
          "url": "https://www.arbor-fertility.com/contact",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "address": {
      "line1": "2821 N Ballas Rd",
      "line2": "Suite 227",
      "city": "St. Louis",
      "state": "MO",
      "zip": "63131",
      "country": "US"
    },
    "location": {
      "lat": 38.6317129,
      "lng": -90.4442422
    },
    "network": {
      "name": "Arbor Fertility"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person", "telehealth"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "LGBTQ+ Family Building",
        "category": "art",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Fertility Preservation",
        "category": "preservation",
        "_source": {
          "url": "https://www.arbor-fertility.com/treatment-options",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.arbor-fertility.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/treatment-options",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/PARINTS+Infertility+Management:+A+Branch+of+Arbor+Fertility%E2%84%A2,+2821+N+Ballas+Rd+Ste+227,+St.+Louis,+MO+63131/@38.6319163,-90.4442725,3117a,13.1y/data=!4m2!3m1!1s0x87d8cd5d9277e2e9:0xc5e8470284522f3c",
            "fetchedAt": "2026-08-16"
          }
        },
        "socialLinks": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "logo": {
          "status": "scraped",
          "source": {
            "url": "https://www.arbor-fertility.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Missouri (MO) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-fiq-newlife-fertility-pensacola",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/new-leaders-in-fertility-and-endocrinology-llc",
      "googlePlaceId": "ChIJy77XUGjAkIgRLBa460kVxZc"
    },
    "type": "fertility-clinic",
    "name": "NewLIFE Fertility - Pensacola",
    "website": "https://fertilityleaders.com/new-life-pensacola",
    "phone": "+1 850-262-1008",
    "logoUrl": "https://fertilityleaders.com/wp-content/uploads/2024/06/NewLIFE_PrimaryLogo_Tagline.png",
    "socialLinks": [
      {
        "platform": "facebook",
        "url": "https://www.facebook.com/NewLeadersinFertility/",
        "label": "Facebook",
        "_source": {
          "url": "https://fertilityleaders.com/our-locations",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "instagram",
        "url": "https://www.instagram.com/newlife_fertility/",
        "label": "Instagram",
        "_source": {
          "url": "https://fertilityleaders.com/our-locations",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "youtube",
        "url": "https://www.youtube.com/channel/UC0BV_D__sZj88qFKzUyWMpQ",
        "label": "YouTube",
        "_source": {
          "url": "https://fertilityleaders.com/our-locations",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "address": {
      "line1": "4400 Bayou Blvd",
      "line2": "Suite 36",
      "city": "Pensacola",
      "state": "FL",
      "zip": "32503",
      "country": "US"
    },
    "location": {
      "lat": 30.4675864,
      "lng": -87.2049956
    },
    "network": {
      "name": "NewLIFE Fertility"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person", "telehealth"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://fertilityleaders.com/fertility-services",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://fertilityleaders.com/fertility-services",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://fertilityleaders.com/fertility-services",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Preimplantation Genetic Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://fertilityleaders.com/fertility-services",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Semen Analysis",
        "category": "diagnostic",
        "_source": {
          "url": "https://fertilityleaders.com/fertility-services",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "LGBTQ+ Family Building",
        "category": "art",
        "_source": {
          "url": "https://fertilityleaders.com/fertility-services",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "images": [
      {
        "url": "https://fertilityleaders.com/wp-content/uploads/elementor/thumbs/Pensacola-e1611332473997-qp9wyo2pz70jhmwqosh3kqzl92t8hrqj7ea291mg3k.jpg",
        "type": "exterior",
        "caption": "NewLIFE Fertility - Pensacola",
        "_source": {
          "url": "https://fertilityleaders.com/our-locations",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWlkmWuOkRxvuSG56l5bqNKsgj-rKPSLvyNhWUCW2jqQHQqbVA687LFcYfIh3edm1i7RgwqKSu-rVQfH3zNDgdfiqmTcvr7nKXFvgZ-IYnWAEB87vsEsFwQuTwufZHSEB_yiZ8GWWg=w638-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/NewLIFE+Fertility%2FNew+Leaders+In+Fertility+%26+Endocrinology+LLC,+4400+Bayou+Blvd+Ste+36,+Pensacola,+FL+32503/@30.4674727,-87.2040908,3439a,13.1y/data=!4m2!3m1!1s0x8890c06850d7becb:0x97c51549ebb8162c",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmD8AM9HGmigAudZxY4aU9caWFTbq46aJ05LQGkGi_B6jH46shNYlvvhWDEm9Czd7bp9NBmyvorFMkLASQUBqqW2_GeyVfKJbMooEP6hgy8kVLhwnj8CzHy_au9g7L6Fnsj6CVV=w514-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/NewLIFE+Fertility%2FNew+Leaders+In+Fertility+%26+Endocrinology+LLC,+4400+Bayou+Blvd+Ste+36,+Pensacola,+FL+32503/@30.4674727,-87.2040908,3439a,13.1y/data=!4m2!3m1!1s0x8890c06850d7becb:0x97c51549ebb8162c",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://fertilityleaders.com/our-locations",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://fertilityleaders.com/our-locations",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://fertilityleaders.com/fertility-services",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/NewLIFE+Fertility%2FNew+Leaders+In+Fertility+%26+Endocrinology+LLC,+4400+Bayou+Blvd+Ste+36,+Pensacola,+FL+32503/@30.4674727,-87.2040908,3439a,13.1y/data=!4m2!3m1!1s0x8890c06850d7becb:0x97c51549ebb8162c",
            "fetchedAt": "2026-08-16"
          }
        },
        "socialLinks": {
          "status": "scraped",
          "source": {
            "url": "https://fertilityleaders.com/our-locations",
            "fetchedAt": "2026-06-15"
          }
        },
        "logo": {
          "status": "scraped",
          "source": {
            "url": "https://fertilityleaders.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-fiq-newlife-fertility-mobile",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/new-leaders-in-fertility-and-endocrinology-llc",
      "googlePlaceId": "ChIJGwvyXY2ym4gRhfsvuQlfxYc"
    },
    "type": "fertility-clinic",
    "name": "NewLIFE Fertility - Mobile",
    "website": "https://fertilityleaders.com/new-life-mobile",
    "phone": "+1 850-262-1008",
    "logoUrl": "https://fertilityleaders.com/wp-content/uploads/2024/06/NewLIFE_PrimaryLogo_Tagline.png",
    "socialLinks": [
      {
        "platform": "facebook",
        "url": "https://www.facebook.com/NewLeadersinFertility/",
        "label": "Facebook",
        "_source": {
          "url": "https://fertilityleaders.com/our-locations",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "instagram",
        "url": "https://www.instagram.com/newlife_fertility/",
        "label": "Instagram",
        "_source": {
          "url": "https://fertilityleaders.com/our-locations",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "youtube",
        "url": "https://www.youtube.com/channel/UC0BV_D__sZj88qFKzUyWMpQ",
        "label": "YouTube",
        "_source": {
          "url": "https://fertilityleaders.com/our-locations",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "address": {
      "line1": "3715 Dauphin St",
      "line2": "Bldg. 2 Suite 5A",
      "city": "Mobile",
      "state": "AL",
      "zip": "36608",
      "country": "US"
    },
    "location": {
      "lat": 30.6853899,
      "lng": -88.1359397
    },
    "network": {
      "name": "NewLIFE Fertility"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person", "telehealth"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://fertilityleaders.com/fertility-services",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://fertilityleaders.com/fertility-services",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://fertilityleaders.com/fertility-services",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Preimplantation Genetic Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://fertilityleaders.com/fertility-services",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Semen Analysis",
        "category": "diagnostic",
        "_source": {
          "url": "https://fertilityleaders.com/fertility-services",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "LGBTQ+ Family Building",
        "category": "art",
        "_source": {
          "url": "https://fertilityleaders.com/fertility-services",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "images": [
      {
        "url": "https://fertilityleaders.com/wp-content/uploads/elementor/thumbs/Mobile-combined-e1611333099583-qp9wyn4vscz960y3ua2h0984noxva2msv9mkrrnu9s.jpg",
        "type": "exterior",
        "caption": "NewLIFE Fertility - Mobile",
        "_source": {
          "url": "https://fertilityleaders.com/our-locations",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkWNpUo23VwFwH9kyR8pTsy-fDn2CpLWVGJ3-BQdpj9lITgmdua6l9oI8nDRdJXuvw5PQp386O1bnjMimTENPTYH8GC5jCkEceHZYLTDW5oqL_UgzYNEEN2-5fm78Xg6HHmaaLp0w=w408-h408-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/NewLIFE+Fertility%2FNew+Leaders+In+Fertility+%26+Endocrinology+LLC,+3715+Dauphin+St+Bldg+2+%235a,+Mobile,+AL+36608/@30.684624,-88.1306062,3431a,13.1y/data=!4m2!3m1!1s0x889bb28d5df20b1b:0x87c55f09b92ffb85",
          "fetchedAt": "2026-08-16"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWkne5RG4clsqLuYhMkNUX9ugxAmIVB9LgjmyfhwDCJMPUekeowJz6SU3ZC7RqD0wpvu7OpnvqhS9zJbkP3kgBmmu9z2z-v6SSiFE-Q8fiwTTDW_ptHmh-hWziHq_H8FVmEw2AGY=w224-h298-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/NewLIFE+Fertility%2FNew+Leaders+In+Fertility+%26+Endocrinology+LLC,+3715+Dauphin+St+Bldg+2+%235a,+Mobile,+AL+36608/@30.684624,-88.1306062,3431a,13.1y/data=!4m2!3m1!1s0x889bb28d5df20b1b:0x87c55f09b92ffb85",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://fertilityleaders.com/our-locations",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://fertilityleaders.com/our-locations",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://fertilityleaders.com/fertility-services",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/NewLIFE+Fertility%2FNew+Leaders+In+Fertility+%26+Endocrinology+LLC,+3715+Dauphin+St+Bldg+2+%235a,+Mobile,+AL+36608/@30.684624,-88.1306062,3431a,13.1y/data=!4m2!3m1!1s0x889bb28d5df20b1b:0x87c55f09b92ffb85",
            "fetchedAt": "2026-08-16"
          }
        },
        "socialLinks": {
          "status": "scraped",
          "source": {
            "url": "https://fertilityleaders.com/our-locations",
            "fetchedAt": "2026-06-15"
          }
        },
        "logo": {
          "status": "scraped",
          "source": {
            "url": "https://fertilityleaders.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Alabama (AL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-fiq-newlife-fertility-panama-city",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/new-leaders-in-fertility-and-endocrinology-llc",
      "googlePlaceId": "ChIJTz6-CfuDk4gRNVuyMuTsQuk"
    },
    "type": "fertility-clinic",
    "name": "NewLIFE Fertility - Panama City",
    "website": "https://fertilityleaders.com/new-life-panama-city",
    "phone": "+1 850-262-1008",
    "logoUrl": "https://fertilityleaders.com/wp-content/uploads/2024/06/NewLIFE_PrimaryLogo_Tagline.png",
    "socialLinks": [
      {
        "platform": "facebook",
        "url": "https://www.facebook.com/NewLeadersinFertility/",
        "label": "Facebook",
        "_source": {
          "url": "https://fertilityleaders.com/our-locations",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "instagram",
        "url": "https://www.instagram.com/newlife_fertility/",
        "label": "Instagram",
        "_source": {
          "url": "https://fertilityleaders.com/our-locations",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "youtube",
        "url": "https://www.youtube.com/channel/UC0BV_D__sZj88qFKzUyWMpQ",
        "label": "YouTube",
        "_source": {
          "url": "https://fertilityleaders.com/our-locations",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "address": {
      "line1": "2101 Northside Drive",
      "line2": "Suite 301",
      "city": "Panama City",
      "state": "FL",
      "zip": "32405",
      "country": "US"
    },
    "location": {
      "lat": 30.187003,
      "lng": -85.6766355
    },
    "network": {
      "name": "NewLIFE Fertility"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person", "telehealth"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://fertilityleaders.com/fertility-services",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://fertilityleaders.com/fertility-services",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://fertilityleaders.com/fertility-services",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Preimplantation Genetic Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://fertilityleaders.com/fertility-services",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Semen Analysis",
        "category": "diagnostic",
        "_source": {
          "url": "https://fertilityleaders.com/fertility-services",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "LGBTQ+ Family Building",
        "category": "art",
        "_source": {
          "url": "https://fertilityleaders.com/fertility-services",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "images": [
      {
        "url": "https://fertilityleaders.com/wp-content/uploads/elementor/thumbs/Panama-City-qp9wyn4vsczslsf6gjtb409n0uguzo0fc2uip2v1mo.jpg",
        "type": "exterior",
        "caption": "NewLIFE Fertility - Panama City",
        "_source": {
          "url": "https://fertilityleaders.com/our-locations",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "url": "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWk18EX98vM3SGi4H8FMGFqWfanNssZ5SOvYS5e-07Atxcoax0-Zc95ebQes-mM3i4VA4N28vtQt2_JZjvjAim4M3Tb3Q5SDJFJsa01-O8bTOCsC6Tmiy3vmnCxOBLOqEPJNzA=w408-h306-k-no",
        "type": "interior",
        "caption": "Facility photo from the clinic's Google Business profile",
        "_source": {
          "url": "https://www.google.com/maps/preview/place/NewLIFE+Fertility%2FNew+Leaders+In+Fertility+%26+Endocrinology+LLC,+2101+Northside+Dr+Ste+301,+Panama+City,+FL+32405/@30.1869895,-85.676643,3449a,13.1y/data=!4m2!3m1!1s0x889383fb09be3e4f:0xe942ece432b25b35",
          "fetchedAt": "2026-08-16"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://fertilityleaders.com/our-locations",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://fertilityleaders.com/our-locations",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://fertilityleaders.com/fertility-services",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/NewLIFE+Fertility%2FNew+Leaders+In+Fertility+%26+Endocrinology+LLC,+2101+Northside+Dr+Ste+301,+Panama+City,+FL+32405/@30.1869895,-85.676643,3449a,13.1y/data=!4m2!3m1!1s0x889383fb09be3e4f:0xe942ece432b25b35",
            "fetchedAt": "2026-08-16"
          }
        },
        "socialLinks": {
          "status": "scraped",
          "source": {
            "url": "https://fertilityleaders.com/our-locations",
            "fetchedAt": "2026-06-15"
          }
        },
        "logo": {
          "status": "scraped",
          "source": {
            "url": "https://fertilityleaders.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Florida (FL) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "type": "fertility-clinic",
    "website": "https://www.reproductiveamerica.com/",
    "phone": "+1 203-221-3424",
    "email": "info@reproductiveamerica.com",
    "logoUrl": "https://cdn.prod.website-files.com/67dcb1ef1677360596dfc20b/682a94e3d320006671b631db_REPRODUCTIVE%20AMERICA%20WHITE%20LETTERING%20TRANS%20BG.png",
    "network": {
      "name": "Reproductive America"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.reproductiveamerica.com/treatments",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.reproductiveamerica.com/treatments",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Preimplantation Genetic Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.reproductiveamerica.com/treatments",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.reproductiveamerica.com/treatments",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Donation",
        "category": "art",
        "_source": {
          "url": "https://www.reproductiveamerica.com/treatments",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Gestational Carrier Support",
        "category": "art",
        "_source": {
          "url": "https://www.reproductiveamerica.com/treatments",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Male Fertility Support",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.reproductiveamerica.com/treatments",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "17:00"
      },
      "tue": {
        "open": "08:00",
        "close": "17:00"
      },
      "wed": {
        "open": "08:00",
        "close": "17:00"
      },
      "thu": {
        "open": "08:00",
        "close": "17:00"
      },
      "fri": {
        "open": "08:00",
        "close": "17:00"
      },
      "sat": null,
      "sun": null
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.reproductiveamerica.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.reproductiveamerica.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.reproductiveamerica.com/treatments",
            "fetchedAt": "2026-06-15"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://www.reproductiveamerica.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "logo": {
          "status": "scraped",
          "source": {
            "url": "https://www.reproductiveamerica.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Reproductive+Centers+of+America,+Connecticut,+4+Corporate+Dr+%23488,+Shelton,+CT+06484/@41.276249,-73.1308241,2998a,13.1y/data=!4m2!3m1!1s0x89e81b0a258d0541:0x242cb5e40d314011",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "id": "org-fiq-reproductive-america-shelton",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/reproductive-america",
      "googlePlaceId": "ChIJQQWNJQob6IkREUAxDeS1LCQ"
    },
    "name": "Reproductive America - Shelton",
    "address": {
      "line1": "4 Corporate Dr",
      "line2": "Suite 488",
      "city": "Shelton",
      "state": "CT",
      "zip": "06484",
      "country": "US"
    },
    "location": {
      "lat": 41.2761383,
      "lng": -73.13087
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check Connecticut (CT) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "type": "fertility-clinic",
    "website": "https://www.reproductiveamerica.com/",
    "phone": "+1 203-221-3424",
    "email": "info@reproductiveamerica.com",
    "logoUrl": "https://cdn.prod.website-files.com/67dcb1ef1677360596dfc20b/682a94e3d320006671b631db_REPRODUCTIVE%20AMERICA%20WHITE%20LETTERING%20TRANS%20BG.png",
    "network": {
      "name": "Reproductive America"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.reproductiveamerica.com/treatments",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.reproductiveamerica.com/treatments",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Preimplantation Genetic Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.reproductiveamerica.com/treatments",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.reproductiveamerica.com/treatments",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Donation",
        "category": "art",
        "_source": {
          "url": "https://www.reproductiveamerica.com/treatments",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Gestational Carrier Support",
        "category": "art",
        "_source": {
          "url": "https://www.reproductiveamerica.com/treatments",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Male Fertility Support",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.reproductiveamerica.com/treatments",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "17:00"
      },
      "tue": {
        "open": "08:00",
        "close": "17:00"
      },
      "wed": {
        "open": "08:00",
        "close": "17:00"
      },
      "thu": {
        "open": "08:00",
        "close": "17:00"
      },
      "fri": {
        "open": "08:00",
        "close": "17:00"
      },
      "sat": null,
      "sun": null
    },
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.reproductiveamerica.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.reproductiveamerica.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.reproductiveamerica.com/treatments",
            "fetchedAt": "2026-06-15"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://www.reproductiveamerica.com/contact",
            "fetchedAt": "2026-06-15"
          }
        },
        "logo": {
          "status": "scraped",
          "source": {
            "url": "https://www.reproductiveamerica.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "id": "org-fiq-reproductive-america-new-york",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/reproductive-america"
    },
    "name": "Reproductive America - New York",
    "address": {
      "line1": "425 Fifth Ave",
      "line2": "3rd Floor",
      "city": "New York",
      "state": "NY",
      "zip": "10016",
      "country": "US"
    },
    "location": {
      "lat": 40.7510773,
      "lng": -73.9825145
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-fiq-genprime-fertility-los-angeles",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/genprime-fertility-los-angeles",
      "googlePlaceId": "ChIJFcTHJFgp3YAR9Eo54V5IDQY"
    },
    "type": "fertility-clinic",
    "name": "GenPrime Fertility Los Angeles",
    "website": "https://la.genprime.com/locations/fertility-centre-los-angeles",
    "phone": "+1 833-988-9898",
    "address": {
      "line1": "1808 W Lincoln Ave",
      "city": "Anaheim",
      "state": "CA",
      "zip": "92801",
      "country": "US"
    },
    "location": {
      "lat": 33.8326121,
      "lng": -117.9463259
    },
    "network": {
      "name": "GenPrime Fertility"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "schedule": {
      "mon": {
        "open": "09:00",
        "close": "17:00"
      },
      "tue": {
        "open": "09:00",
        "close": "17:00"
      },
      "wed": {
        "open": "09:00",
        "close": "17:00"
      },
      "thu": {
        "open": "09:00",
        "close": "17:00"
      },
      "fri": {
        "open": "09:00",
        "close": "17:00"
      },
      "sat": null,
      "sun": null
    },
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://la.genprime.com/locations/fertility-centre-los-angeles",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Preimplantation Genetic Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://la.genprime.com/locations/fertility-centre-los-angeles",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://la.genprime.com/locations/fertility-centre-los-angeles",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://la.genprime.com/locations/fertility-centre-los-angeles",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Embryo Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://la.genprime.com/locations/fertility-centre-los-angeles",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Gestational Carrier Support",
        "category": "art",
        "_source": {
          "url": "https://la.genprime.com/locations/fertility-centre-los-angeles",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "images": [],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://la.genprime.com/locations/fertility-centre-los-angeles",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://la.genprime.com/locations/fertility-centre-los-angeles",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://la.genprime.com/locations/fertility-centre-los-angeles",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/GenPrime+Fertility+Los+Angeles+%2F+%E7%8F%8D%E7%9B%BC%E6%B4%9B%E6%9D%89%E7%9F%B6%E8%AF%95%E7%AE%A1%E7%94%9F%E6%AE%96%E4%B8%AD%E5%BF%83,+1808+W+Lincoln+Ave,+Anaheim,+CA+92801/@33.8321677,-117.9460209,3314a,13.1y/data=!4m2!3m1!1s0x80dd295824c7c415:0x60d485ee1394af4",
            "fetchedAt": "2026-08-16"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://la.genprime.com/locations/fertility-centre-los-angeles",
            "fetchedAt": "2026-06-15"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-fiq-ferny-madison",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/ferny"
    },
    "type": "fertility-clinic",
    "name": "Ferny - Madison",
    "website": "https://ferny.com/locations/",
    "email": "info@ferny.com",
    "bookingUrl": "https://healow.com/apps/practice/radjabi-medical-pc-new-york-ny-19024",
    "logoUrl": "https://ferny.com/wp-content/uploads/2026/05/Ferny_Logo_Hor_Midnight.png",
    "socialLinks": [
      {
        "platform": "facebook",
        "url": "https://www.facebook.com/FernyFertility",
        "label": "Facebook",
        "_source": {
          "url": "https://ferny.com/contact-us/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "instagram",
        "url": "https://www.instagram.com/fernyfertility/",
        "label": "Instagram",
        "_source": {
          "url": "https://ferny.com/contact-us/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "address": {
      "line1": "290 Madison Avenue",
      "line2": "6th Floor",
      "city": "New York",
      "state": "NY",
      "zip": "10017",
      "country": "US"
    },
    "location": {
      "lat": 40.7518874,
      "lng": -73.9803019
    },
    "network": {
      "name": "Ferny"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "Fertility Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Fertility Surgery",
        "category": "surgical",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Genetic Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Male Infertility",
        "category": "diagnostic",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "LGBTQ+ Family Building",
        "category": "art",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "images": [
      {
        "url": "https://ferny.com/wp-content/uploads/2026/06/Ferny-NYC-Fertility-contact-hero-image-scaled.jpg",
        "type": "interior",
        "caption": "Ferny fertility care",
        "_source": {
          "url": "https://ferny.com/contact-us/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://ferny.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://ferny.com/contact-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://ferny.com/fertility-treatment/",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://ferny.com/contact-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "socialLinks": {
          "status": "scraped",
          "source": {
            "url": "https://ferny.com/contact-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "logo": {
          "status": "scraped",
          "source": {
            "url": "https://ferny.com/contact-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    }
  },
  {
    "id": "org-fiq-ferny-midtown",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/ferny",
      "googlePlaceId": "ChIJZyhpawxZwokRsr5Tv3hk3Ng"
    },
    "type": "fertility-clinic",
    "name": "Ferny - Midtown",
    "website": "https://ferny.com/locations/",
    "email": "info@ferny.com",
    "bookingUrl": "https://healow.com/apps/practice/radjabi-medical-pc-new-york-ny-19024",
    "logoUrl": "https://ferny.com/wp-content/uploads/2026/05/Ferny_Logo_Hor_Midnight.png",
    "socialLinks": [
      {
        "platform": "facebook",
        "url": "https://www.facebook.com/FernyFertility",
        "label": "Facebook",
        "_source": {
          "url": "https://ferny.com/contact-us/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "instagram",
        "url": "https://www.instagram.com/fernyfertility/",
        "label": "Instagram",
        "_source": {
          "url": "https://ferny.com/contact-us/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "address": {
      "line1": "157 E 57th St",
      "city": "New York",
      "state": "NY",
      "zip": "10022",
      "country": "US"
    },
    "location": {
      "lat": 40.7606007,
      "lng": -73.9679502
    },
    "network": {
      "name": "Ferny"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "Fertility Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Fertility Surgery",
        "category": "surgical",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Genetic Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Male Infertility",
        "category": "diagnostic",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "LGBTQ+ Family Building",
        "category": "art",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://ferny.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://ferny.com/contact-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://ferny.com/fertility-treatment/",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Ferny+Fertility+%2B+Gynecology+%E2%80%93+Midtown+East,+157+E+57th+St,+New+York,+NY+10022/@40.7606201,-73.9679985,3022a,13.1y/data=!4m2!3m1!1s0x89c2590c6b692867:0xd8dc6478bf53beb2",
            "fetchedAt": "2026-08-16"
          }
        },
        "socialLinks": {
          "status": "scraped",
          "source": {
            "url": "https://ferny.com/contact-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "logo": {
          "status": "scraped",
          "source": {
            "url": "https://ferny.com/contact-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-fiq-ferny-central-park",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/ferny",
      "googlePlaceId": "ChIJiW05F-xYwokRx5fJ3iYU9yk"
    },
    "type": "fertility-clinic",
    "name": "Ferny - Central Park",
    "website": "https://ferny.com/locations/",
    "email": "info@ferny.com",
    "bookingUrl": "https://healow.com/apps/practice/radjabi-medical-pc-new-york-ny-19024",
    "logoUrl": "https://ferny.com/wp-content/uploads/2026/05/Ferny_Logo_Hor_Midnight.png",
    "socialLinks": [
      {
        "platform": "facebook",
        "url": "https://www.facebook.com/FernyFertility",
        "label": "Facebook",
        "_source": {
          "url": "https://ferny.com/contact-us/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "instagram",
        "url": "https://www.instagram.com/fernyfertility/",
        "label": "Instagram",
        "_source": {
          "url": "https://ferny.com/contact-us/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "address": {
      "line1": "240 Central Park S",
      "line2": "Suite 1P",
      "city": "New York",
      "state": "NY",
      "zip": "10019",
      "country": "US"
    },
    "location": {
      "lat": 40.7673344,
      "lng": -73.9811711
    },
    "network": {
      "name": "Ferny"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "Fertility Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Fertility Surgery",
        "category": "surgical",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Genetic Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Male Infertility",
        "category": "diagnostic",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "LGBTQ+ Family Building",
        "category": "art",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://ferny.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://ferny.com/contact-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://ferny.com/fertility-treatment/",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Ferny+Fertility+%2B+Gynecology+%E2%80%93+Central+Park+South,+240+Central+Park+S+%231P,+New+York,+NY+10019/@40.7674484,-73.9811332,3022a,13.1y/data=!4m2!3m1!1s0x89c258ec17396d89:0x29f71426dec997c7",
            "fetchedAt": "2026-08-16"
          }
        },
        "socialLinks": {
          "status": "scraped",
          "source": {
            "url": "https://ferny.com/contact-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "logo": {
          "status": "scraped",
          "source": {
            "url": "https://ferny.com/contact-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-fiq-ferny-tribeca",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/ferny"
    },
    "type": "fertility-clinic",
    "name": "Ferny - Tribeca",
    "website": "https://ferny.com/locations/",
    "email": "info@ferny.com",
    "bookingUrl": "https://healow.com/apps/practice/radjabi-medical-pc-new-york-ny-19024",
    "logoUrl": "https://ferny.com/wp-content/uploads/2026/05/Ferny_Logo_Hor_Midnight.png",
    "socialLinks": [
      {
        "platform": "facebook",
        "url": "https://www.facebook.com/FernyFertility",
        "label": "Facebook",
        "_source": {
          "url": "https://ferny.com/contact-us/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "platform": "instagram",
        "url": "https://www.instagram.com/fernyfertility/",
        "label": "Instagram",
        "_source": {
          "url": "https://ferny.com/contact-us/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "address": {
      "line1": "95 Chambers St",
      "city": "New York",
      "state": "NY",
      "zip": "10007",
      "country": "US"
    },
    "location": {
      "lat": 40.7147716,
      "lng": -74.0073107
    },
    "network": {
      "name": "Ferny"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "treatments": [
      {
        "name": "Fertility Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Fertility Surgery",
        "category": "surgical",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Genetic Testing",
        "category": "diagnostic",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Male Infertility",
        "category": "diagnostic",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "LGBTQ+ Family Building",
        "category": "art",
        "_source": {
          "url": "https://ferny.com/fertility-treatment/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://ferny.com/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://ferny.com/contact-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://ferny.com/fertility-treatment/",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "missing"
        },
        "socialLinks": {
          "status": "scraped",
          "source": {
            "url": "https://ferny.com/contact-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "logo": {
          "status": "scraped",
          "source": {
            "url": "https://ferny.com/contact-us/",
            "fetchedAt": "2026-06-15"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-06-17T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check New York (NY) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-fiq-sgf-solana-beach",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/shady-grove-fertility-california",
      "googlePlaceId": "ChIJUxDAuncJ3IARI-_EIU1CMj8"
    },
    "type": "fertility-clinic",
    "name": "Shady Grove Fertility - Solana Beach",
    "website": "https://www.shadygrovefertility.com/locations/california/solana-beach-fertility-center/",
    "phone": "+1 619-685-0649",
    "address": {
      "line1": "420 Stevens Avenue",
      "line2": "Suite 300",
      "city": "Solana Beach",
      "state": "CA",
      "zip": "92075",
      "country": "US"
    },
    "location": {
      "lat": 32.9920287,
      "lng": -117.2615818
    },
    "network": {
      "name": "Shady Grove Fertility"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person"],
    "schedule": {
      "mon": {
        "open": "07:00",
        "close": "16:00"
      },
      "tue": {
        "open": "07:00",
        "close": "16:00"
      },
      "wed": {
        "open": "07:00",
        "close": "16:00"
      },
      "thu": {
        "open": "07:00",
        "close": "16:00"
      },
      "fri": {
        "open": "07:00",
        "close": "16:00"
      },
      "sat": null,
      "sun": null
    },
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/california/solana-beach-fertility-center/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/california/solana-beach-fertility-center/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/california/solana-beach-fertility-center/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Donor Eggs",
        "category": "art",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/california/solana-beach-fertility-center/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Donor Sperm",
        "category": "art",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/california/solana-beach-fertility-center/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Embryo Donation",
        "category": "art",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/california/solana-beach-fertility-center/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/california/solana-beach-fertility-center/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/california/solana-beach-fertility-center/",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/california/solana-beach-fertility-center/",
            "fetchedAt": "2026-06-15"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/california/solana-beach-fertility-center/",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+in+Solana+Beach,+420+Stevens+Ave+Ste+300,+Solana+Beach,+CA+92075/@32.9927723,-117.2610093,3346a,13.1y/data=!4m2!3m1!1s0x80dc0977bac01053:0x3f32424d21c4ef23",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check California (CA) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-fiq-sgf-raleigh",
    "externalIds": {
      "fertilityIqUrl": "https://www.fertilityiq.com/fertilityiq/clinics/shady-grove-fertility-north-carolina",
      "googlePlaceId": "ChIJCTrS3ujzrIkR5Orx6wer6pE"
    },
    "type": "fertility-clinic",
    "name": "Shady Grove Fertility - Raleigh",
    "website": "https://www.shadygrovefertility.com/locations/north-carolina/raleigh-fertility-center/",
    "phone": "+1 984-464-2244",
    "address": {
      "line1": "6730 McCrimmon Pkwy",
      "city": "Cary",
      "state": "NC",
      "zip": "27519",
      "country": "US"
    },
    "location": {
      "lat": 35.8302824,
      "lng": -78.8785906
    },
    "network": {
      "name": "Shady Grove Fertility"
    },
    "setting": "network-group",
    "consultationTypes": ["in-person", "telehealth"],
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "16:00"
      },
      "tue": {
        "open": "08:00",
        "close": "16:00"
      },
      "wed": {
        "open": "08:00",
        "close": "16:00"
      },
      "thu": {
        "open": "08:00",
        "close": "16:00"
      },
      "fri": {
        "open": "08:00",
        "close": "16:00"
      },
      "sat": null,
      "sun": null
    },
    "treatments": [
      {
        "name": "IVF",
        "category": "art",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/north-carolina/raleigh-fertility-center/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "IUI",
        "category": "art",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/north-carolina/raleigh-fertility-center/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Egg Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/north-carolina/raleigh-fertility-center/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Donor Eggs",
        "category": "art",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/north-carolina/raleigh-fertility-center/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Donor Sperm",
        "category": "art",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/north-carolina/raleigh-fertility-center/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Embryo Donation",
        "category": "art",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/north-carolina/raleigh-fertility-center/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Semen Analysis",
        "category": "diagnostic",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/north-carolina/raleigh-fertility-center/",
          "fetchedAt": "2026-06-15"
        }
      },
      {
        "name": "Sperm Freezing",
        "category": "preservation",
        "_source": {
          "url": "https://www.shadygrovefertility.com/locations/north-carolina/raleigh-fertility-center/",
          "fetchedAt": "2026-06-15"
        }
      }
    ],
    "_enrichment": {
      "status": "partially-enriched",
      "sections": {
        "identity": {
          "status": "verified",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/north-carolina/raleigh-fertility-center/",
            "fetchedAt": "2026-06-15"
          }
        },
        "contact": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/north-carolina/raleigh-fertility-center/",
            "fetchedAt": "2026-06-15"
          }
        },
        "treatments": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/north-carolina/raleigh-fertility-center/",
            "fetchedAt": "2026-06-15"
          }
        },
        "schedule": {
          "status": "scraped",
          "source": {
            "url": "https://www.shadygrovefertility.com/locations/north-carolina/raleigh-fertility-center/",
            "fetchedAt": "2026-06-15"
          }
        },
        "pricing": {
          "status": "missing"
        },
        "outcomes": {
          "status": "missing"
        },
        "insurance": {
          "status": "missing"
        },
        "team": {
          "status": "missing"
        },
        "images": {
          "status": "scraped",
          "source": {
            "url": "https://www.google.com/maps/preview/place/Shady+Grove+Fertility+Cary,+6730+McCrimmon+Pkwy,+Cary,+NC+27519/@35.829927,-78.880544,3235a,13.1y/data=!4m2!3m1!1s0x89acf3e8ded23a09:0x91eaab07ebf1eae4",
            "fetchedAt": "2026-08-16"
          }
        },
        "marketProfile": {
          "status": "scraped",
          "source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        }
      },
      "lastEnrichmentRun": "2026-08-16T00:00:00.000Z"
    },
    "_meta": {
      "createdAt": "2026-06-15",
      "updatedAt": "2026-06-17T00:00:00.000Z"
    },
    "marketProfile": {
      "country": "US",
      "regulatory": {
        "regulator": "CDC National ART Surveillance System",
        "notes": "CDC/NASS and SART outcome reporting are separate from insurance coverage, clinic pricing, financing, and state legal requirements.",
        "_source": {
          "url": "https://www.cdc.gov/art/php/nass/index.html",
          "fetchedAt": "2026-06-17"
        }
      },
      "payment": {
        "publicCoverage": "There is no single national IVF coverage rule for all patients in this record; coverage depends on plan, employer, state mandates, and treatment details.",
        "privatePay": "Private-pay pricing and financing vary by clinic and should be captured from clinic fee pages where available.",
        "notes": "State infertility mandates, Marketplace benefits, employer benefits, and self-funded ERISA plans can produce very different patient costs.",
        "_source": {
          "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
          "fetchedAt": "2026-06-17"
        }
      },
      "legal": {
        "embryoDisposition": "Check state law and clinic consent documents before creating, freezing, transferring, donating, or discarding embryos.",
        "surrogacy": "Gestational-carrier law and parentage processes are state-specific and require legal review.",
        "pgt": "PGT availability, insurance coverage, and consent requirements vary by clinic, state, and plan.",
        "_source": {
          "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
          "fetchedAt": "2026-06-17"
        }
      },
      "displaySections": [
        {
          "title": "U.S. ART reporting context",
          "items": [
            {
              "label": "CDC/NASS reporting",
              "value": "CDC collects ART data through NASS and calculates standardized success rates for each reporting U.S. ART clinic.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Reporting law",
              "value": "The Fertility Clinic Success Rate and Certification Act requires ART clinics to provide annual ART procedure data to CDC; CDC publishes clinic-specific success rates and lists nonreporters.",
              "_source": {
                "url": "https://www.cdc.gov/art/php/nass/index.html",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Imported outcome source",
              "value": "No CDC/SART success-rate value is attached to this record yet.",
              "_source": {
                "url": "https://www.cdc.gov/art/success-rates/index.html",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.cdc.gov/art/php/nass/index.html",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. insurance and payment context",
          "items": [
            {
              "label": "Plan-specific coverage",
              "value": "U.S. fertility coverage depends on the exact plan, employer, state rules, benefit administrator, prior authorization, diagnosis rules, and treatment type.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Marketplace plan check",
              "value": "HealthCare.gov says specific services can vary by state requirements and plan, and patients should compare plan details or call the plan for a specific treatment.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Self-funded employer plans",
              "value": "HealthCare.gov says large employers that self-insure may not have to provide essential health benefits; patients should check whether their employer plan is self-insured and what services are covered.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "ERISA mandate caveat",
              "value": "GAO ERISA materials explain that self-funded plans are not deemed insurance and ERISA preempts them from state regulation.",
              "detail": "This is why a state infertility mandate may not apply to an employer plan even when the clinic is in a mandate state.",
              "_source": {
                "url": "https://www.govinfo.gov/content/pkg/GAOREPORTS-HEHS-95-167/html/GAOREPORTS-HEHS-95-167.htm",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Accepted insurance",
              "value": "No accepted-carrier list is imported for this record yet.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Public pricing",
              "value": "No public treatment pricing or financing package is imported for this record yet; verify IVF, IUI, medication, lab, anesthesia, genetic testing, storage, and refund-program costs directly with the clinic.",
              "_source": {
                "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.healthcare.gov/coverage/what-marketplace-plans-cover/",
            "fetchedAt": "2026-06-17"
          }
        },
        {
          "title": "U.S. state and legal checkpoints",
          "items": [
            {
              "label": "State insurance check",
              "value": "Check North Carolina (NC) infertility insurance rules and your exact plan type. State mandates vary widely and often exclude self-funded employer plans.",
              "_source": {
                "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "State law source",
              "value": "ReproductiveFacts/ASRM maintains state and territory infertility insurance law pages and recommends contacting the state or territory insurance commissioner for questions.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            },
            {
              "label": "Consent and embryo checkpoint",
              "value": "Embryo disposition, donor gametes, PGT, storage, and gestational-carrier arrangements depend on state law, clinic consent forms, and patient agreements. This record is a checkpoint, not legal advice.",
              "_source": {
                "url": "https://www.reproductivefacts.org/patient-advocacy/state-and-territory-infertility-insurance-laws/",
                "fetchedAt": "2026-06-17"
              }
            }
          ],
          "_source": {
            "url": "https://www.kff.org/state-health-policy-data/state-indicator/infertility-coverage/",
            "fetchedAt": "2026-06-17"
          }
        }
      ]
    },
    "images": []
  },
  {
    "id": "org-pharmacy-apri",
    "externalIds": {},
    "type": "pharmacy",
    "name": "Apri Fertility Pharmacy",
    "description": "APRI Fertility Pharmacy provides fertility-focused medication support, price quotes, and injection training for patients and care teams.",
    "website": "https://www.aprinow.com",
    "phone": "(858) 771-7791",
    "address": {
      "line1": "4122 Sorrento Valley Blvd, Suite 102",
      "city": "San Diego",
      "state": "CA",
      "zip": "92121",
      "country": "US"
    },
    "location": {
      "lat": 32.904322,
      "lng": -117.2160229
    },
    "specialties": ["fertility", "injection-training"],
    "pharmacyDetails": {
      "compoundingOnSite": true
    },
    "_enrichment": {
      "status": "enriched",
      "source": "official-site",
      "date": "2026-07-27"
    },
    "_meta": {
      "createdAt": "2026-07-27",
      "updatedAt": "2026-07-27T00:00:00.000Z"
    },
    "images": []
  },
  {
    "id": "org-pharmacy-prima",
    "externalIds": {},
    "type": "pharmacy",
    "name": "Prima Pharmacy",
    "description": "Prima is a fertility-focused pharmacy providing IVF and egg-freezing medication, specialty support, in-home infusion, and delivery services.",
    "website": "https://www.forprima.com",
    "phone": "(718) 230-3535",
    "address": {
      "line1": "8 East 41st Street",
      "city": "New York",
      "state": "NY",
      "zip": "10017",
      "country": "US"
    },
    "location": {
      "lat": 40.7523419,
      "lng": -73.9808681
    },
    "specialties": ["fertility", "same-day-delivery", "next-day-delivery"],
    "_enrichment": {
      "status": "enriched",
      "source": "official-site",
      "date": "2026-07-27"
    },
    "_meta": {
      "createdAt": "2026-07-27",
      "updatedAt": "2026-07-27T00:00:00.000Z"
    },
    "images": []
  },
  {
    "id": "org-pharmacy-metro-drugs",
    "externalIds": {},
    "type": "pharmacy",
    "name": "Metro Drugs",
    "description": "Metro Drugs is a family-owned New York specialty pharmacy with more than 35 years of fertility experience. Services include IVF and egg-freezing medications, injection training, an in-house compounding lab, exclusive manufacturer discounts, and 24/7 nursing support. Same-day delivery across NYC and Long Island; overnight shipping nationwide.",
    "website": "https://metrodrugs.com",
    "phone": "(212) 794-7200",
    "address": {
      "line1": "243 East 60th Street",
      "city": "New York",
      "state": "NY",
      "zip": "10022",
      "country": "US"
    },
    "location": {
      "lat": 40.762,
      "lng": -73.9648
    },
    "specialties": [
      "fertility",
      "injection-training",
      "same-day-delivery",
      "next-day-delivery"
    ],
    "pharmacyDetails": {
      "compoundingOnSite": true,
      "delivery": {
        "coldChain": true,
        "sameDayCities": [
          "Manhattan",
          "Brooklyn",
          "Bronx",
          "Queens",
          "Staten Island",
          "Long Island"
        ],
        "overnightNationwide": true
      }
    },
    "_enrichment": {
      "status": "enriched",
      "source": "official-site",
      "date": "2026-08-24"
    },
    "_meta": {
      "createdAt": "2026-08-24",
      "updatedAt": "2026-08-24T00:00:00.000Z"
    },
    "images": []
  },
  {
    "id": "org-pharmacy-apthorp",
    "externalIds": {},
    "type": "pharmacy",
    "name": "Apthorp Pharmacy",
    "description": "Apthorp Pharmacy, established 1910 on Manhattan's Upper West Side, is a fertility-focused neighborhood pharmacy offering price quotes, insurance benefit screening, direct insurance billing, and access to manufacturer savings programs (including up to 75% off Follistim, Ganirelix, and Pregnyl for qualifying patients). Same-day messenger service in Manhattan; overnight priority shipping nationwide.",
    "website": "https://apthorprx.com",
    "phone": "(212) 877-3480",
    "address": {
      "line1": "2191 Broadway",
      "city": "New York",
      "state": "NY",
      "zip": "10024",
      "country": "US"
    },
    "location": {
      "lat": 40.7815,
      "lng": -73.9799
    },
    "specialties": ["fertility", "same-day-delivery", "overnight-delivery"],
    "pharmacyDetails": {
      "delivery": {
        "sameDayCities": ["Manhattan"],
        "overnightNationwide": true
      }
    },
    "_enrichment": {
      "status": "enriched",
      "source": "official-site",
      "date": "2026-08-24"
    },
    "_meta": {
      "createdAt": "2026-08-24",
      "updatedAt": "2026-08-24T00:00:00.000Z"
    },
    "images": []
  },
  {
    "id": "org-pharmacy-rosemont",
    "externalIds": {},
    "type": "pharmacy",
    "name": "Rosemont Pharmacy",
    "description": "Rosemont Pharmacy is a Philadelphia Main Line specialty pharmacy that has dispensed fertility medications since 1989 — one of the longest-standing fertility-only pharmacies in the country. Dedicated fertility coordinators (ext. 300/302), on-site injection administration by certified pharmacists, and free same-day or next-day shipping nationwide. Also offers bioidentical hormone replacement (BHRT) compounding.",
    "website": "https://rosemontpharmacy.com",
    "phone": "(610) 525-3570",
    "address": {
      "line1": "1149 Lancaster Avenue",
      "city": "Rosemont",
      "state": "PA",
      "zip": "19010",
      "country": "US"
    },
    "location": {
      "lat": 40.0154,
      "lng": -75.3216
    },
    "specialties": ["fertility", "injection-training", "next-day-delivery"],
    "pharmacyDetails": {
      "compoundingOnSite": true,
      "delivery": {
        "overnightNationwide": true
      }
    },
    "_enrichment": {
      "status": "enriched",
      "source": "official-site",
      "date": "2026-08-24"
    },
    "_meta": {
      "createdAt": "2026-08-24",
      "updatedAt": "2026-08-24T00:00:00.000Z"
    },
    "images": []
  },
  {
    "id": "org-pharmacy-fuze",
    "externalIds": {},
    "type": "pharmacy",
    "name": "Fuze Health (FuzeRx)",
    "description": "FuzeRx is the specialty and mail pharmacy arm of Fuze Health (formed in 2025 by uniting Truepill, LetsGetChecked, and Alto Pharmacy). URAC-accredited for mail service and specialty pharmacy. Draws on Alto's fertility book — the team previously led one of the largest specialty fertility pharmacies in the country — and now dispenses fertility medications previously handled by Optum Specialty Pharmacy (which exited fertility on Feb 19, 2026). 50-state licensing, nationwide shipping.",
    "website": "https://rx.fuzehealth.com",
    "phone": "(833) 860-1057",
    "address": {
      "line1": "3121 Diablo Ave",
      "city": "Hayward",
      "state": "CA",
      "zip": "94545",
      "country": "US"
    },
    "location": {
      "lat": 37.6323,
      "lng": -122.0764
    },
    "specialties": ["fertility", "mail-order", "cold-chain"],
    "pharmacyDetails": {
      "delivery": {
        "overnightNationwide": true
      }
    },
    "_enrichment": {
      "status": "enriched",
      "source": "official-site",
      "date": "2026-08-25"
    },
    "_meta": {
      "createdAt": "2026-08-25",
      "updatedAt": "2026-08-25T00:00:00.000Z"
    },
    "images": []
  }
]
